webpackJsonp([7],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_format__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_chartTipFormat__ = __webpack_require__(149);





var SERVER_URL = 'api';

/* harmony default export */ __webpack_exports__["a"] = ({
  data: {
    authenticated: false,
    normalSuggest: 0
  },
  RouteByUserType: function RouteByUserType(context, data) {
    var USERTYPE = data.user_type;
    var FLAG = data.flag;
    if ('admin_login' == FLAG) {
      context.$router.push('CreateHCP');
      return;
    }
    if ('clinic_login' == FLAG) {
      context.$router.push('ClinicPatientList');
      return;
    }
    var unread = data.unread_message;
    context.$store.commit('updateUnRead', unread);
    if (USERTYPE === 'D') {
      if ('hcp_group' == data.created_by) {
        context.$router.push('/PatientList');
      } else {
        context.$router.push('/HcpMenu');
      }
    }
    if (USERTYPE === 'P') {
      context.$router.push('monitor');
      var _unread = data.connection_request;
      context.$store.commit('updateUnRead', _unread);
    }
    if (USERTYPE === 'M') {
      context.$router.push('carerConnection');
      var _unread2 = data.unread_message;
      context.$store.commit('updateUnRead', _unread2);
    }
  },
  login: function login(context, info) {
    var that = this;
    context.$http.post(SERVER_URL + '/v2.0/login', info).then(function (res) {
      var err = res.body.error;

      if (err === 0) {
        sessionStorage.setItem('token', 'Header:' + res.bodyText);
        sessionStorage.setItem('uid', res.data.uid);
        sessionStorage.setItem('userType', res.data.user_type);
        sessionStorage.setItem('username', res.data.username);
        localStorage.setItem('userCreatedBy', res.data.created_by);
        sessionStorage.setItem('MFA', res.data.mfa);
        var country = res.data.country;
        var unitmgCountryList = ['TH', 'ID', 'IN', 'FR', 'DE', 'IT', 'PT', 'ES', 'TR', 'SA', 'AE', 'AT', 'CL', 'BE', 'PL'];
        if (unitmgCountryList.includes(country)) {
          localStorage.setItem('unit', 'mg');
        } else {
          localStorage.setItem('unit', 'mmol');
        }
        sessionStorage.setItem('country', res.data.country);
        that.RouteByUserType(context, res.data);
      } else if (52 === err) {
        context.$message.error('Your account is not approved.');
      }
      if (err === 2) {
        var tip = context.$t('userNotExist');
        context.$message.error(tip);
      }
      if (err === 9) {
        var _tip = context.$t('t1103_Incorrect_Password').replace('$1', res.body.left_try_num);
        context.$message.error(_tip);
      }
      if (err === 10) {
        var _tip2 = context.$t('UserType incorrect');
        context.$message.error(_tip2);
      }
      if (err === 62) {
        var _tip3 = context.$t('t1103_Incorrect_locked').replace('$1', res.body.unlock_time_left);
        context.$message.error(_tip3);
      }

      if (err === 63) {
        sessionStorage.setItem('loginInfo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(info));
        context.$router.push('/verificationCode');
      }
      if (err === 64) {
        var _tip4 = context.$t('t1215_Verification_code_incorrect');
        context.$message.error(_tip4);
        context.isErrorCode = true;
      }
    }, function (err) {
      console.log(err + "," + err.body.message);
      context.error = err.body.message;
    });
  },
  getPortrait: function getPortrait(context, uid) {
    context.$http.get(SERVER_URL + '/v2.0/person/' + uid + '/portrait').then(function (res) {
      var err = res.body.error;

      if (err === 0) {}
    });
  },
  getProfile: function getProfile(context) {
    var that = this;
    context.$http.get(SERVER_URL + '/v2.0/person/profile').then(function (res) {
      var err = res.body.error;

      if (err === 0) {
        var profile = res.data.profile;
        that.initProfile2(context, profile);
        context.profile = profile;
      }
    });
  },
  modifyPersonProfile: function modifyPersonProfile(context, profile) {
    var that = this;
    var user = sessionStorage.getItem('userType');
    context.$http.post(SERVER_URL + '/v2.0/person/profile', { profile: profile }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var tip = context.$t('saveTip');
        context.$message({
          type: 'success',
          message: tip
        });
        var unitmgCountryList = ['TH', 'ID', 'IN', 'FR', 'DE', 'IT', 'PT', 'ES', 'TR', 'SA', 'AE', 'AT', 'CL', 'BE', 'PL'];
        if (unitmgCountryList.includes(profile.country)) {
          localStorage.setItem('unit', 'mg');
        } else {
          localStorage.setItem('unit', 'mmol');
        }
        if (user === 'P') {
          context.$router.push('/monitor');
        }
        if (user === 'D') {
          context.$router.push('/PatientList');
        }
        if (user === 'M') {
          context.$router.push('/carerConnection');
        }
      } else {
        var _tip5 = context.$t('Input error');
        context.$message.error(_tip5);
      }
    });
  },
  getMessages: function getMessages(context, uid) {
    var that = this;
    context.$http.get(SERVER_URL + '/v2.0/messages').then(function (res) {
      var err = res.body.error;

      if (err === 0) {
        context.messages = res.data.data.map(function (e, i) {
          if (e[1].message_type === 'RELATION_AUTH_PERMIT') {
            e[1] = e[1].username + context.accept;
          } else if (e[1].message_type === 'RELATION_AUTH_CANCEL') {
            e[1] = e[1].username + context.cancel;
          } else {
            e[1] = e[1].username + context.reject;
          }
          if (context.isZh) {
            e[2] = __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formateDate(new Date(e[2] * 1000));
          } else {
            var time = new Date(e[2] * 1000 + 8 * 3600000).toUTCString();
            var sp1 = time.split(',');
            var sp2 = sp1[1].split(' ');
            var sp3 = sp2[4].split(':');
            e[2] = sp2[2] + ' ' + sp2[1] + ' ' + sp2[3] + ', at ' + sp3[0] + ':' + sp3[1];
          }
          e[4] = '/api/v2.0/person/' + parseInt(e[4]) + '/portrait';
          return e;
        });
        if (context.messages.length === 0) {
          context.noMes = true;
        }
      }
    });
  },
  getUnread: function getUnread(context) {
    context.$http.get('api/v2.0/messages/unread').then(function (res) {
      var err = res.body.error;

      if (err === 0) {
        var count = res.data.count;
        context.$store.commit('updateUnRead', count);
      }
    });
  },
  getUnread1: function getUnread1(context) {
    context.$http.get('api/v2.0/relations/auth/todo').then(function (res) {
      var err = res.body.error;

      if (err === 0) {
        var count = res.data.count;
        context.$store.commit('updateUnRead', count);
      }
    });
  },
  goPatientProfile: function goPatientProfile(context, uid) {
    context.$http.get(SERVER_URL + '/v2.0/patients/' + uid + '/profile').then(function (res) {
      var err = res.body.error;

      if (err === 0) {
        var profile = res.data.profile;
        if (profile.created_by === 'register') {
          this.$router.push('/patientProfile2');
        } else {
          this.$router.push('/patientProfile');
        }
      }
    });
  },
  goClinicPatientProfile: function goClinicPatientProfile(context, uid) {
    context.$http.get(SERVER_URL + '/v2.0/patients/' + uid + '/profile').then(function (res) {
      var err = res.body.error;

      if (err === 0) {
        var profile = res.data.profile;
        if (profile.created_by === 'register') {
          this.$router.push('/clinic_patientProfile2');
        } else {
          this.$router.push('/clinic_patientProfile');
        }
      }
    });
  },
  getPatientProfile2: function getPatientProfile2(context, uid) {
    var that = this;
    context.$http.get(SERVER_URL + '/v2.0/patients/' + uid + '/profile').then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var profile = res.data.profile;
        if (profile.created_by === 'register') {
          that.initProfile(context, profile);
        } else {
          that.initProfile2(context, profile);
        }
        context.profile = profile;
        context.birthday = profile.birthday;
        context.alias = profile.alias ? profile.alias : profile.realname;
      }
    });
  },
  getPatientProfile3: function getPatientProfile3(context, uid) {
    var that = this;
    context.$http.get(SERVER_URL + '/v2.0/monitor/' + uid + '/profile').then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var profile = res.data.profile;
        that.initProfile(context, profile);
        context.alias = profile.alias ? profile.alias : profile.realname;
        context.profile = profile;
      }
    });
  },
  initProfile: function initProfile(context, val) {
    val.username = val.username ? val.username : '--';
    val.realname = val.realname ? val.realname : '--';
    val.gender = val.gender ? context.$t(val.gender) : '--';
    val.height = val.height ? val.height + 'cm' : '--';
    val.weight = val.weight ? val.weight + 'kg' : '--';
    val.diabetes_type = val.diabetes_type ? context.$t(val.diabetes_type) : '--';
    val.address = val.address ? val.address : '--';
    val.zipcode = val.zipcode ? val.zipcode : '--';
    val.mobile = val.mobile ? val.mobile : '--';
    val.telephone = val.telephone ? val.telephone : '--';
    val.email = val.email ? val.email : '--';
    val.date = val.date ? val.date : '--';
    val.birthday = val.birthday ? val.birthday : '--';
    val.diabetes_diagnosis_date = val.diabetes_diagnosis_date ? val.diabetes_diagnosis_date : '--';
  },
  initProfile2: function initProfile2(context, val) {
    console.log('initProfile2:', val);
    val.username = val.username ? val.username : ' ';
    val.realname = val.realname ? val.realname : '';
    val.gender = val.gender ? val.gender : '';
    val.height = val.height ? val.height : '';
    val.weight = val.weight ? val.weight : '';
    val.diabetes_type = val.diabetes_type ? val.diabetes_type : '';
    val.address = val.address ? val.address : '';
    val.zipcode = val.zipcode ? val.zipcode : '';
    val.mobile = val.mobile ? val.mobile : '';
    val.telephone = val.telephone ? val.telephone : '';
    val.email = val.email ? val.email : '';
    val.date = val.date ? val.date : '';
    val.serve_for = val.serve_for ? val.serve_for : '';
    val.major = val.major ? val.major : '';
    val.birthday = val.birthday ? val.birthday : '';
    context.birthdayShow = val.birthday;
    val.diabetes_diagonosis_date = val.diabetes_diagonosis_date ? val.diabetes_diagonosis_date : '';
    context.disDateShow = val.diabetes_diagonosis_date;
  },
  modifyPatientProfile: function modifyPatientProfile(context, pid, profile) {
    context.$http.post(SERVER_URL + '/v2.0/patients/' + pid + '/profile', { profile: profile }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var tip = context.$t('saveTip');
        context.$message({
          type: 'success',
          message: tip
        });
        if (profile.alias) {
          sessionStorage.setItem('patientName', profile.alias);
          this.$store.commit('updatePatientName', profile.alias);
        } else {
          sessionStorage.setItem('patientName', profile.realname);
          this.$store.commit('updatePatientName', profile.realname);
        }
        context.$router.push('monitor');
      }
    });
  },
  modifyPatientProfile2: function modifyPatientProfile2(context, pid, profile) {
    context.$http.post('api/v2.0/monitor/' + pid + '/settings', profile).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var tip = context.$t('saveTip');
        context.$message({
          type: 'success',
          message: tip
        });
        context.$router.push('/carerConnection');
      } else {
        var _tip6 = context.$t('modifyFailed');
        context.$message.error(_tip6);
      }
    });
  },
  getUserList: function getUserList(context, info) {
    var that = this;
    context.$http.get(SERVER_URL + '/v2.0/patients', { params: info }).then(function (data) {
      var err = data.body.error;

      if (err === 0) {
        var isZh = sessionStorage.getItem('language') === 'zh' ? true : false;
        var dataObj = data.body.patients;
        var users = dataObj.items.map(function (e, i) {
          e.gender = context.$t(e.gender);
          e.diabetes_type = context.$t(e.diabetes_type);
          if (e.upload_time) {
            var upload_time = new Date(e.upload_time * 1000);
            e.upload_time = isZh ? __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formateDate(upload_time) : __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate1(upload_time);
          }
          if (e.created_by) {
            e.created_by = context.$t(e.created_by);
          }
          if (e.created_by === context.$t('register') && e.alias) {
            e.name = e.alias;
          }
          if (e.diabetes_diagnosis_date) {
            e.diabetes_diagnosis_date = that.getDuration(context, e.diabetes_diagnosis_date);
          }

          return e;
        });
        context.$store.commit('updateUsers', users);
        this.pages = dataObj.pages !== 0 ? dataObj.pages : 1;
        this.has_next = dataObj.has_next;
        this.has_prev = dataObj.has_prev;
      }
      if (err === 12) {
        context.$router.push('/hcpLogin');
      }
    });
  },
  getUserListAll: function getUserListAll(context, info) {
    var that = this;
    sessionStorage.setItem('ListLoad', '');
    context.$http.get(SERVER_URL + '/v2.0/patients', { params: info }).then(function (data) {
      var err = data.body.error;

      sessionStorage.setItem('ListLoad', 'true');
      if (err === 0) {
        var isZh = sessionStorage.getItem('language') === 'zh' ? true : false;
        var dataObj = data.body.patients;
        var users = dataObj.items.map(function (e, i) {
          e.gender = context.$t(e.gender);
          e.diabetes_type = context.$t(e.diabetes_type);
          if (e.upload_time) {
            var upload_time = new Date(e.upload_time * 1000);
            e.upload_time = isZh ? __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formateDate(upload_time) : __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate1(upload_time);
          }
          if (e.created_by) {
            e.created_by = context.$t(e.created_by);
          }
          if (e.created_by === context.$t('register') && e.alias) {
            e.name = e.alias;
          }
          if (e.diabetes_diagnosis_date) {
            e.diabetes_diagnosis_date = that.getDuration(context, e.diabetes_diagnosis_date);
          }

          return e;
        });
        context.$store.commit('updateUsers', users);
        this.pages = dataObj.pages !== 0 ? dataObj.pages : 1;
        this.has_next = dataObj.has_next;
        this.has_prev = dataObj.has_prev;
      }
      if (err === 12) {
        context.$router.push('/hcpLogin');
      }
    });
  },
  getDuration: function getDuration(context, val) {
    var now = new Date().setHours(0, 0, 0, 0) / 1000;
    var time = new Date(val).getTime() / 1000;
    var st = now - time;
    var y = parseInt(st / (3600 * 24 * 365));
    var m = parseInt(st % (3600 * 24 * 365) / (3600 * 24 * 30));
    var lang = localStorage.getItem('language');
    var year = y > 1 ? context.$t('Years') : context.$t('Year');
    var month = m > 1 ? context.$t('Months') : context.$t('Month');
    return lang === 'zh' || lang === 'hk' ? y + ' 年 ' + m + ' 月' : y + ' ' + year + ' ' + m + ' ' + month;
  },
  sendSeccode: function sendSeccode(context, info) {
    context.$http.post(SERVER_URL + '/v2.0/seccode/send', info).then(function (res) {
      var err = res.body.error;

      if (err === 0) {
        context.token = res.data.token;
      } else if (err === 1) {
        var tip = context.$t('userNotExist');
        context.$message.error(tip);
      } else {
        var _tip7 = context.$t('tryAgain');
        context.$message.error(_tip7);
      }
    }, function (err) {
      console.log(err + "," + err.body.message);
      context.error = err.body.message;
    });
  },
  setTime: function setTime(context) {
    var count = 60;
    var t = setInterval(function () {
      if (count === 0) {
        clearInterval(t);
        context.send = context.$t('Getcode');
        context.canClick = false;
        context.showTime = false;
        count = 10;
        if (context.tryAgain) {
          context.tryAgain = false;
        }
      } else {
        context.canClick = true;
        context.showTime = true;
        context.time = count;
        context.send = 'S';
        if (context.tryAgain) {
          context.tryAgain = true;
        }
        count--;
      }
    }, 1000);
  },
  register: function register(context, info) {
    context.$http.post(SERVER_URL + '/v2.0/regist', info).then(function (res) {
      var err = res.body.error;

      if (err === 0) {
        if ('yes' == info.test) {
          context.tabA = false;
          context.tabB = true;

          if ('CN' == info.country || 'HKF' == info.country || 'AE' == info.country) {
            context.isEU = false;
          }
        } else {
          var tip = context.$t('registSuccess');
          context.$message({
            type: 'success',
            message: tip
          });
          this.$router.push('login');
        }
      } else if (err === 26) {
        var _tip8 = context.$t('errtip3');
        context.$message.error(_tip8);
      } else {

        if ('yes' == info.test) {
          var _tip9 = context.$t('infoWrongTip');
          context.$message.error(_tip9);
        } else {
          var _tip10 = context.$t('registFailed');
          context.$message.error(_tip10);
        }
      }
    }, function (err) {
      if ('yes' == info.test) {
        var tip = context.$t('infoWrongTip');
        context.$message.error(tip);
      } else {
        var _tip11 = context.$t('registFailed');
        context.$message.error(_tip11);
      }
    });
  },
  HcpRegister: function HcpRegister(context, info) {
    context.$http.post(SERVER_URL + '/v2.0/hcp/apply', { 'info': info }).then(function (res) {
      var err = res.body.error;

      if ('yes' == info.test) {
        var user_type = res.body.user_type;
        console.log('hcp apply:', err, user_type);

        if (0 == err) {
          context.tabA = false;
          context.tabB = true;
          if ('CN' == info.country || 'HKF' == info.country || 'AE' == info.country) {
            context.isEU = false;
          } else {
            context.isEU = true;
          }
        } else if (3 == err) {
          if ('D' == user_type) {
            this.$message.error("User exist");
          } else if ('P' == user_type || 'M' == user_type) {
            context.tabA = false;
            context.tabA1 = true;
          }
        }
      } else {

        var tip = context.$t('sentSuccess');
        context.$message({
          type: 'success',
          message: tip
        });
        this.$router.push('/hcpLogin');
      }
    }, function (err) {
      var tip = context.$t('sentFailed');
      context.$message.error('Sent failed!');
    });
  },
  adjustBasalRecord: function adjustBasalRecord(basalRecord, pumpStatus) {
    var AutoModeEnableNew = pumpStatus && pumpStatus['AutoModeEnabledNew'];

    if (1) {
      var cur_day = new Date().setHours(0, 0, 0);
      var newBasalRecord = basalRecord.filter(function (record) {
        var recordId = record[0];
        var recordTime = record[1];
        var recordType = record[2];
        var recordIdSplit = recordId.split('-');
        var filterFlag = false;
        if (recordIdSplit[3] == '9999' && index === basalRecord.length - 1) {
          if (recordIdSplit[2] == pumpStatus.pumpId) {
            if (AutoModeEnableNew) {
              filterFlag = true;
            } else {
              filterFlag = false;
            }
          } else {
            filterFlag = false;
          }

          return filterFlag;
        }

        filterFlag = 'BAAMS' != recordType && 'BAAME' != recordType && 'BAAMTarget100' != recordType && 'BAAMTarget110' != recordType && 'BAAMTarget120' != recordType && 'BAAMBreakfast' != recordType && 'BAAMLunch' != recordType && 'BAAMDinner' != recordType && 'BAAMExerciseStart' != recordType && 'BAAMSnack' != recordType && 'BAAMExerciseExit' != recordType;

        return filterFlag;
      });

      basalRecord = newBasalRecord;
    }

    var i = 0;
    for (; i < basalRecord.length - 1; i++) {
      var curEnd = basalRecord[i][1] + basalRecord[i][3];
      var nextStart = basalRecord[i + 1][1];

      if (curEnd > nextStart) {
        basalRecord[i][3] = nextStart - basalRecord[i][1];
      }
    }

    var isSuspend = false;
    var inj_status = pumpStatus.status;
    if (0x40 <= inj_status && inj_status <= 0x4F) {
      isSuspend = true;
    }

    if (pumpStatus.basalDeliveriedTime && !isSuspend) {
      var size = basalRecord.length;
    }
    return basalRecord;
  },
  getMonData: function getMonData(context, param, Pid) {
    var that = this;
    var now = new Date() / 1000;
    context.$http.get('/api/v2.1/monitor/' + Pid + '/status', { params: { param: param } }).then(function (res) {
      var err = res.body.error;

      if (err === 0) {
        var data = res.body.data;

        sessionStorage.setItem('data_source', data.data_source);

        if (data.pump_status) {
          if (0x40 <= data.pump_status.state && data.pump_status.state <= 0x4F) {
            if (data.chart.basal && data.chart.basal.length > 0) {
              var last_basal = data.chart.basal[data.chart.basal.length - 1];
              if (last_basal[2].indexOf('SUS') == 0) {
                data.chart.basal.splice(data.chart.basal.length - 1, 1);
              }
            }
          } else {
            if (data.chart.basal && data.chart.basal.length > 0) {
              if (data.pump_status.AutoModeEnabledNew) {} else {
                var _last_basal = data.chart.basal[data.chart.basal.length - 1];

                var recordIdSplit = _last_basal[0].split('-');
                data.pump_status.pumpId = recordIdSplit[2];

                console.log('last_basal:', _last_basal, data.chart.basal);
                if (_last_basal[1] == data.pump_status.basalDeliveriedTime) {
                  data.chart.basal.splice(data.chart.basal.length - 1, 1);
                }
              }
            }
          }
        }

        if (res.body.data.chart.transmtr) {
          context.transmtr = that.getTransmtr(context, res.body.data.chart.transmtr);
        } else {
          context.transmtr = [];
        }

        context.$store.commit('updateDataS', res.body.data.chart);

        if (false) {
          console.log('monitor sg:', res.body.data.chart.sg);

          var sgData = res.body.data.chart.sg;
          var dataNum = sgData.length;
          var start = 0;
          var end = dataNum;
          if (dataNum > 50) {
            start = dataNum - 50;
            end = 50;
          }
          for (var i = start; i < dataNum; i++) {}

          for (var _i = 0; _i < end; _i++) {
            if (sgData[_i][1] > 5) {
              sgData[_i][1] += 18;
            }
          }
        }

        if (false) {
          var pump_status = { "wizardGlucose": 0, "updateTime": 1583292987.951734, "basalDuration": 150, "serial": 1256630150,
            "extendBolusSet": 0, "extendBolusDuration": 0, "basalType": 6, "extendBolusDeliveried": 0, "state": 32,
            "bolusSet": 6.2, "basalRate": 0.55, "wizardType": 0, "bolusType": 1, "lastBolusType": 0,
            "remainingTime": 4230.33433000048, "bolusDeliveried": 1.2, "wizardCorrSet": 0,
            "anotherBolusType": 0, "iob": 0, "basalDeliveriedTime": 1583288321, "wizardCarbSet": 0,
            "wizardIob": 0, "basalPercent": 90, "wizardCarb": 0, "bolusDeliveriedTime": 1583292938,
            "rssi": -50, "remainingDose": 120.95 };
          var pump_status2 = { "updateTime": 1583826009.216325, "wizardGlucose": 160.1999931335449, "basalDuration": 150,
            "serial": 1256630150, "extendBolusSet": 0.55, "suspendRemainingTime": 0, "extendBolusDuration": 30,
            "basalType": 1, "extendBolusDeliveried": 0, "state": 32, "basalDeliveried": 0.15, "bolusSet": 0.85,
            "basalRate": 0.9, "wizardType": 3, "bolusType": 3, "suspendTime": 1583825463, "lastBolusType": 0,
            "remainingTime": 4310.39661141634, "bolusDeliveried": 0.7000000000000001, "wizardCorrSet": 0.4,
            "anotherBolusType": 0, "iob": 0, "basalDeliveriedTime": 1583825463 + 3600, "wizardCarbSet": 1,
            "pumpId": 74, "wizardIob": 0, "basalPercent": 90, "wizardCarb": 15, "bolusDeliveriedTime": 1583825981,
            "rssi": -58, "remainingDose": 190.65 };

          pump_status['updateTime'] = new Date().getTime() / 1000;
          data.pump_status = pump_status2;
        }

        context.DataSG = that.getMoSG(context, res.body.data.chart.sg);


        context.st = res.body.data.chart.st;
        context.et = res.body.data.chart.et;

        console.log('chart.basal:', data.chart.basal);
        var basalTotal = 0;
        var bolusTotal = 0;
        if (res.body.data.chart.basal.length > 0) {
          var originBasal = res.body.data.chart.basal;
          context.basal = that.adjustBasalRecord(originBasal, data.pump_status);
        }
        if (res.body.data.chart.bolus.length > 0) {
          var originBolus = res.body.data.chart.bolus;
          context.bolus = originBolus;
        }

        var t1 = now - data.sensor_status.updateTime;
        context.sensorTime = data.sensor_status.updateTime ? __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate1(new Date()) : '--';
        data.sensor_status.updateTime = data.sensor_status.updateTime ? __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate1(new Date(data.sensor_status.updateTime * 1000)) : '--';
        that.getSensor(context, data.sensor_status);

        var t2 = now - data.pump_status.updateTime;
        context.pumpTime = data.pump_status.updateTime ? __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate1(new Date()) : '--';
        data.pump_status.updateTime = data.pump_status.updateTime ? __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate1(new Date(data.pump_status.updateTime * 1000)) : '--';
        data.pump_status.bolusSum = bolusTotal;
        data.pump_status.basalSum = basalTotal;
        that.getPump(context, data.pump_status);

        if (1) {
          context.$store.commit('updateBasal', that.getBasal(context, context.st, context.basal));
          var bs = that.getBasal2(context.basal, context.st);
          context.newBasal = bs[0];
          context.stopBasal = bs[1];
          context.autoModeBasal = bs[2];
          context.autoModeCorrBolus = bs[3];
          if (bs[4] > context.basalMax) {
            context.basalMax = bs[4];
          }
          var bs1 = that.getBasalSus4(context, context.st, context.basal);
          context.basal_suspend = bs1[0];
          context.tempBasal = bs1[1];
          context.basal_suspend2 = bs1[2];

          var normalBasal = context.DataBasal;
          var basalValue = normalBasal.map(function (e, i) {
            return e[1];
          });
          var autoBasalValue = context.autoModeBasal.map(function (e, i) {
            return e[2];
          });

          var basalValueAll = basalValue.concat(autoBasalValue);
          context.basalMax = that.getBasalYMax(basalValueAll);
        }

        if (1) {
          var bolus = that.getBolus(context, context.st, context.bolus);
          context.DataBolus = bolus[0];
          context.extend_bolus = bolus[1][0] ? bolus[1] : context.extend_bolus;
          context.bolusMax = bolus[2];
        }

        var alarm_display = data.chart.alarm_display;
        if (alarm_display === 'On') {
          context.sensor_alarm = that.getAlarm2(context, res.body.data.chart.sensor_alarm, 0);
          context.pump_alarm = that.getAlarm2(context, res.body.data.chart.pump_alarm, 1);
        }
        context.calib = that.getCalib2(res.body.data.chart.calibRecord);
        that.getSleepTime2(context, res.body.data.chart.st, res.body.data.chart.et, res.body.data.chart.sleeptime);

        if (t1 > 3600) {
          context.sensorTime = '--';
          that.clearSensor(context, data.sensor_status);
          context.showCGMStatus = false;
        } else {
          context.showCGMStatus = true;
        }
        if (t2 > 3600) {
          context.pumpTime = '--';
          that.clearPump(context, data.pump_status);
        }

        that.checkSgIcon(context);
        var sensor_serial = data.sensor_status.serial;
        console.log('sensor serial:', sensor_serial, typeof sensor_serial === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(sensor_serial));
        if (102000000 <= sensor_serial && sensor_serial <= 103999999) {} else {}
        context.$store.commit('updateSensor', data.sensor_status);
        context.$store.commit('updatePump', data.pump_status);
        if (context.chart1) {
          context.chart1.dispose();
          context.chart2.dispose();
        }
        context.drawCharts();
      }
    }, function (err) {
      console.log(err + "," + err.body.message);
    });
  },
  getAlarm2: function getAlarm2(context, val, flag) {
    var alarm = [];
    for (var i = 0; i < val.length; i++) {
      alarm[i] = new Array(3);
      alarm[i][0] = new Date(val[i][0] * 1000);
      if (flag === 1) {
        alarm[i][1] = 0.2;
      } else {
        alarm[i][1] = localStorage.getItem('unit') === 'mg' ? Math.round(1.2 * 18) : 1.2;
      }
      alarm[i][2] = context.$t(val[i][1]);
    }
    return alarm;
  },
  getCalib2: function getCalib2(val) {
    var exe = [],
        j = 0;
    for (var i = 0; i < val.length; i++) {
      if (val[i].length > 0) {
        exe[j] = new Array(2);
        exe[j][0] = new Date(val[i][1] * 1000);
        exe[j][1] = localStorage.getItem('unit') === 'mg' ? Math.round(val[i][3] * 18) : val[i][3].toFixed(1);
        j++;
      }
    }
    return exe;
  },
  getMoSG: function getMoSG(context, val) {
    var sg = [],
        time = [],
        type = [],
        SG = [],
        max = context.isMg ? 400 : 22.2;
    for (var i = 0; i < val.length; i++) {
      sg[i] = val[i][1];
      sg[i] = sg[i] > 22.2 ? 22.2 : sg[i];
      if (sg[i] < 2.2 && (val[i][4] === 'C' || val[i][4] === 'CX' || val[i][4] === 'NC' && val[i][1] > 0)) {
        sg[i] = 2.2;
      }
      sg[i] = context.isMg ? Math.round(sg[i] * 18) : sg[i].toFixed(1);
      if (val[i][4] === 'DE') {
        sg[i] = 0;
      }
      time[i] = val[i][0];
      type[i] = val[i][4];
    }
    max = sg.length > 1 ? Math.max.apply(null, sg) : max;

    for (var m = 0; m < sg.length; m++) {
      SG[m] = new Array(3);
      time[m] = new Date(time[m] * 1000);
      SG[m][0] = time[m];
      SG[m][1] = sg[m];
      SG[m][2] = type[m];
    }
    return SG;
  },
  getSensor: function getSensor(context, val) {
    var cgm_status = val.status;
    var originVal = {};
    for (var p in val) {
      originVal[p] = val[p];
    }

    console.log('cgm_status:', cgm_status, originVal);
    if (13 == cgm_status || 14 == cgm_status) {
      delete val.sensorLifetimeTotalCount;
      delete val.glucose;
      delete val.glucoseRate;
      console.log('val:', val);
    }

    val.serial = val.serial ? this.deviceSNFormat(val.serial, 'TRANS', val.deviceType) : '--';
    var status = val.status;
    if (val.status === -1) {
      val.status = '--';
    } else {
      val.status = val.status ? context.status[val.status] : '--';
    }
    if (val.updateTime !== '--') {
      var sp = val.updateTime.split(' ');
      var sp1 = sp[0].split('-');
      var d = new Date().getDate();
      if (d === parseInt(sp1[0])) {
        context.updateTime1 = context.$t('Today') + ' ' + sp[1];
      } else if (d - 1 === parseInt(sp1[0])) {
        context.updateTime1 = context.$t('Yesterday') + ' ' + sp[1];
      } else {
        sp1 = sp1[0] + '/' + sp1[1] + '/' + sp1[2];
        context.updateTime1 = sp1 + ' ' + sp[1];
      }
    } else {
      context.updateTime1 = '--';
    }

    if (true) {
      val.sensorLifetimeTotalCount = val.sensorLifetimeTotalCount ? this.getTime(val.sensorLifetimeTotalCount - val.sequence) : '--';
    }

    if (val.batteryPercent) {
      var b = val.batteryPercent;

      if (b >= 0.8) {
        context.batteryIcon = '/static/battery/Battery_full.png';
      } else if (b >= 0.4) {
        context.batteryIcon = '/static/battery/Battery_three_quarters.png';
      } else if (b >= 0.2) {
        if ('TY012' == context.deviceType) {
          context.batteryIcon = '/static/battery/Battery_half.png';
        } else {
          context.batteryIcon = '/static/battery/Battery_half_2.png';
        }
      } else if (b >= 0.1) {
        context.batteryIcon = '/static/battery/Battery_quarter.png';
      } else {
        context.batteryIcon = '/static/battery/Battery_zero.png';
      }
    } else {
      context.batteryIcon = '/static/battery/Battery_nodata.png';
    }

    val.batteryPercent = val.batteryPercent ? (val.batteryPercent * 100).toFixed(1) + '%' : '--';
    var ratestatus = val.glucoseRate;
    if (ratestatus === 0 || ratestatus === 8) {
      context.sgIcon = '/static/SG ICON/Trend_smooth.png';
    }
    if (ratestatus === 1 || ratestatus === 2 || ratestatus === 3) {
      context.sgIcon = '/static/SG ICON/Trend_up ' + ratestatus + '.png';
    }
    if (ratestatus === 4 || ratestatus === 5 || ratestatus === 6) {
      context.sgIcon = '/static/SG ICON/Trend_down ' + (ratestatus - 3) + '.png';
    }
    if (ratestatus === 7) {
      context.sgIcon = '';
    }

    if (val.glucose) {
      if (!context.isMg) {
        val.glucose = val.glucose.toFixed(1) + 'mmol/L';
      } else {
        val.glucose = Math.round(val.glucose * 18) + 'mg/dL';
      }
    } else {
      val.glucose = '--';
    }

    if (status === 1 || status === 2 || status == 6 || 13 == status || 14 == status) {
      val.glucose = '--';
      context.updateTime1 = '--';
      context.sgIcon = '';
      context.sensorTime = '--';
    }
  },
  clearSensor: function clearSensor(context, val) {
    val.serial = '--';
    val.status = '--';

    val.sensorLifetimeTotalCount = '--';
    val.batteryPercent = '--';
    context.updateTime1 = '--';
    context.sgIcon = '';
    val.glucose = '--';
  },
  getPumpCurrentBolus: function getPumpCurrentBolus(context, pumpStatus) {
    var currentBolus = [];
    var record_id = context.uid + '-' + pumpStatus.serial;
    var bolusType = '';
    if (1 == pumpStatus.bolusType) {
      bolusType = 'NB';
      record_id += '-bolus-current-N';
    } else if (2 == pumpStatus.bolusType) {
      bolusType = 'EB';
      record_id += '-bolus-current-E';
    } else if (3 == pumpStatus.bolusType) {
      bolusType = 'CB';
      record_id += '-bolus-current-C';
    }
    var wizardInfo = {};
    if (0 == pumpStatus.wizardType) {
      bolusType += 'M';
    } else if (1 == pumpStatus.wizardType) {
      bolusType += 'CRW';
      wizardInfo = {
        'bg': pumpStatus.wizardGlucose / 18.0,
        'corr_bolus': pumpStatus.wizardCorrSet,
        'iob': pumpStatus.wizardIob
      };
    } else if (2 == pumpStatus.wizardType) {
      bolusType += 'CAW';
      wizardInfo = {
        'carb': pumpStatus.wizardCarb,
        'carb_bolus': pumpStatus.wizardCarbSet,
        'iob': pumpStatus.wizardIob
      };
    } else if (3 == pumpStatus.wizardType) {
      bolusType += 'CCW';
      wizardInfo = {
        'bg': pumpStatus.wizardGlucose / 18.0,
        'corr_bolus': pumpStatus.wizardCorrSet,
        'carb': pumpStatus.wizardCarb,
        'carb_bolus': pumpStatus.wizardCarbSet,
        'iob': pumpStatus.wizardIob
      };
    }
    if (pumpStatus.wizardType > 0) {
      if (pumpStatus.adjustmentType) {
        wizardInfo['adjustmentType'] = 1;
      } else {
        wizardInfo['adjustmentType'] = 0;
      }
    }

    currentBolus.push(record_id);
    currentBolus.push(pumpStatus.bolusDeliveriedTime);
    currentBolus.push(bolusType);
    currentBolus.push(pumpStatus.bolusSet);
    currentBolus.push(pumpStatus.bolusDeliveried);
    currentBolus.push(pumpStatus.extendBolusSet);
    currentBolus.push(pumpStatus.extendBolusDeliveried);
    currentBolus.push(pumpStatus.extendBolusDuration);
    currentBolus.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(wizardInfo));
    currentBolus.push(0);

    console.log('currentBolus:', currentBolus);
    return currentBolus;
  },
  randomString: function randomString(len) {
    len = len || 32;
    var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    var maxPos = $chars.length;
    var pwd = '';
    for (var i = 0; i < len; i++) {
      pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
  },
  removePumpCurrentBolus: function removePumpCurrentBolus(context, pumpStatus) {
    var i = 0;
    for (; i < context.bolus.length; i++) {
      var record_id = context.bolus[i][0];
      if (record_id.indexOf('bolus-current') > 0) {
        if (record_id.indexOf('-fix-') < 0) {
          context.bolus[i][0] = record_id + '-fix-' + this.randomString(6);
        }
      }
    }
    console.log('removePumpCurrentBolus:', i, context.bolus.length);
    if (i < context.bolus.length) {}
  },
  removePumpCurrentBasal: function removePumpCurrentBasal(context, record_id_key) {
    var i = 0;
    for (; i < context.basal.length; i++) {
      var record_id = context.basal[i][0];
      if (record_id.indexOf(record_id_key) > 0) {
        context.basal[i] = undefined;
      }
    }
    context.basal = context.basal.filter(function (e, i) {
      return e !== undefined;
    });
    console.log('removePumpCurrentBasal:', record_id_key, i, context.basal.length);
    if (i < context.basal.length) {}
  },
  getPumpCurrentBasal: function getPumpCurrentBasal(context, pumpStatus) {
    var currentBasal = [];

    var basalTypeMap = {
      0: 'BAS',
      1: 'BAE',
      2: 'BAH',
      3: 'BAPA',
      4: 'BAPB',
      27: 'BAPC',
      28: 'BAPD',
      29: 'BASK',
      30: 'BAAM'
    };
    var tempBasalTypeMap = {
      5: 'BART',
      6: 'BAAT'
    };
    var record_id = context.uid + '-' + pumpStatus.serial;
    var basalType = '';
    var tempBasalType = '';
    var basalDuration = 0;
    var curTime = new Date().getTime() / 1000;
    var basalRate = 0;
    var basalDeliveried = 0;
    var basalDeliveriedTime = pumpStatus.basalDeliveriedTime;

    if (!pumpStatus.basalDeliveriedTime) {
      return false;
    }

    console.log('basalType:', pumpStatus.state, pumpStatus.basalType, pumpStatus.basalRate, pumpStatus.basalDeliveried);
    if (0x20 <= pumpStatus.state && pumpStatus.state < 0x2F) {
      basalType = basalTypeMap[pumpStatus.basalType];
      tempBasalType = tempBasalTypeMap[pumpStatus.basalType];

      if (pumpStatus.AutoModeEnabledNew) {
        return false;
      }

      basalRate = pumpStatus.basalRate;


      basalDeliveried = pumpStatus.basalDeliveried || pumpStatus.basalDelivery;

      if (basalRate > 0) {
        basalDuration = basalDeliveried / basalRate * 3600;
      } else {
        basalDuration = 0;
      }

      if (basalType) {
        record_id += '-basal-current';
        this.removePumpCurrentBasal(context, 'suspend-current');
        this.removePumpCurrentBasal(context, 'basal-temp-current');
      } else if (tempBasalType) {
        basalType = tempBasalType;
        record_id += '-basal-temp-current';
        this.removePumpCurrentBasal(context, 'suspend-current');
        this.removePumpCurrentBasal(context, 'basal-current');
      }
    } else if (0x40 <= pumpStatus.state && pumpStatus.state < 0x4F) {
      record_id += '-suspend-current';

      if (0x40 == pumpStatus.state) {
        basalType = 'SUSLSG';
      } else if (0x41 == pumpStatus.state) {
        basalType = 'SUSPLSG';
      } else if (0x42 == pumpStatus.state) {
        basalType = 'SUSA';
      } else if (0x43 == pumpStatus.state) {
        basalType = 'SUSHM';
      } else if (0x44 == pumpStatus.state) {
        basalType = 'SUSDM';
      } else if (0x45 == pumpStatus.state) {
        basalType = 'SUSM';
      } else {
        basalType = 'SUSM';
      }
      basalDeliveriedTime = pumpStatus.suspendTime;

      if (curTime > basalDeliveriedTime) {
        basalDuration = curTime - basalDeliveriedTime;
      } else {
        basalDuration = 0;
      }

      this.removePumpCurrentBasal(context, 'basal-current');
      this.removePumpCurrentBasal(context, 'basal-temp-current');
      return false;
    }

    currentBasal.push(record_id);
    currentBasal.push(basalDeliveriedTime);
    currentBasal.push(basalType);
    currentBasal.push(basalDuration);
    currentBasal.push(basalRate);
    currentBasal.push(basalDeliveried);
    currentBasal.push(0);

    console.log('curBasal:', currentBasal);
    return currentBasal;
  },
  getPump: function getPump(context, val) {
    var originVal = {};
    for (var k in val) {
      originVal[k] = val[k];
    }
    console.log('getPump:', originVal);

    if (val.state < 0x20) {
      delete val.remainingDose;
      delete val.remainingTime;
    } else if (128 == val.state) {
      delete val.remainingDose;
      delete val.remainingTime;
    }

    var ins_unit2 = 'U';
    try {
      ins_unit2 = context.$t('ins_unit2');
    } catch (e) {
      console.log("ins_unit2 error:", e);
    }
    val.serial = val.serial ? this.deviceSNFormat(val.serial, 'PUMP') : '--';
    var basal_active = false;
    if (val.state < 7) {
      val.state = val.state ? context.state1[val.state] : '--';
    } else if (val.state < 40) {
      val.state = val.state ? context.state2[val.state - 32] : '--';
      if (30 == val.basalType || val.AutoModeEnabledNew) {
        val.state = context.$t('t1222_Auto_Mode');
      }
      basal_active = true;

      if (val.bolusType && val.bolusType > 0) {
        val.state = context.injState['Bolus'];

        var currentBolusRecord = this.getPumpCurrentBolus(context, originVal);
        context.addBolusRecord(currentBolusRecord);
      } else if (6 == val.basalType) {
        val.state = context.injState['BART'];
      }
      var currentBasalRecord = this.getPumpCurrentBasal(context, originVal);
      if (currentBasalRecord) {
        context.addBasalRecord(currentBasalRecord);
      }
    } else if (val.state < 70) {
      val.state = val.state ? context.state3[val.state - 64] : '--';

      var _currentBasalRecord = this.getPumpCurrentBasal(context, originVal);
      if (_currentBasalRecord) {
        context.addBasalRecord(_currentBasalRecord);
      }
    } else if (val.state < 104) {
      val.state = val.state ? context.state4[val.state - 96] : '--';
    } else if (val.state === 128) {
      val.state = 'Delivery stopped';
    } else {
      val.state = '--';
    }

    if (!basal_active || !val.bolusType || 0 == val.bolusType) {
      this.removePumpCurrentBolus(context, originVal);
    }

    console.log('AutoModeEnableNew:', val.AutoModeEnabledNew);
    if (30 == val.basalType || val.AutoModeEnabledNew) {
      val.basalRate = context.$t('t1222_Auto_Mode');
    } else if (val.basalRate && basal_active) {
      val.basalRate = val.basalRate.toFixed(2) + context.$t('basal_unit2');
    } else {
      val.basalRate = '--';
    }

    val.remainingDose = val.remainingDose ? val.remainingDose.toFixed(2) + ins_unit2 : '--';
    val.iob = val.iob ? val.iob.toFixed(2) + ins_unit2 : '--';

    val.basalSum = context.calDayBasalTotal();
    val.bolusSum = context.calDayBolusTotal();
    var autoSum = context.calDayAutoModeTotal();
    console.log('autoSum:', val.basalSum, val.bolusSum, autoSum);
    val.basalSum += autoSum[0];
    val.bolusSum += autoSum[1];
    console.log('calDayBasalTotal:', context.basal, val.basalSum);

    val.bolusSum = val.bolusSum ? val.bolusSum.toFixed(2) + ins_unit2 : '--';
    val.basalSum = val.basalSum ? val.basalSum.toFixed(2) + ins_unit2 : '--';

    var type = val.bolusType;
    if (0 == type) {
      type = val.lastBolusType;
    }
    if (type === 1) {
      context.lastBolus = 'N' + val.bolusDeliveried.toFixed(2) + ins_unit2 + '  ' + __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate7(context, val.bolusDeliveriedTime);
    } else if (type === 2) {
      context.lastBolus = 'E' + val.extendBolusDeliveried.toFixed(2) + ins_unit2 + '  ' + __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate7(context, val.bolusDeliveriedTime);
    } else if (type === 3) {
      context.lastBolus = 'C' + (val.extendBolusDeliveried + val.bolusDeliveried).toFixed(2) + ins_unit2 + '  ' + __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate7(context, val.bolusDeliveriedTime);
    } else {
      context.lastBolus = '--';
    }
    val.remainingTime = val.remainingTime ? this.getTime3(val.remainingTime) : '--';
  },
  clearPump: function clearPump(context, val) {
    val.state = '--';
    val.serial = '--';
    val.remainingTime = '--';

    val.remainingDose = '--';
    val.basalRate = '--';
    val.basalSum = '--';
    context.lastBolus = '--';
    val.iob = '--';
    val.bolusSum = '--';
  },
  getSleepTime2: function getSleepTime2(context, st, et, Stime) {
    var time1 = new Array(2),
        time2 = new Array(2);
    time1[0] = new Array(3);
    time1[0][0] = new Date((st + Stime[0] * 60) * 1000);
    time1[0][1] = new Date(et * 1000);
    time1[0][2] = context.sgMax ? context.sgMax : 20;
    time1[1] = new Array(3);
    time1[1][0] = new Date(st * 1000);
    time1[1][1] = new Date((st + Stime[1] * 60) * 1000);
    time1[1][2] = time1[0][2];

    time2[0] = new Array(3);
    time2[0][0] = new Date((st + Stime[0] * 60) * 1000);
    time2[0][1] = new Date(et * 1000);
    time2[0][2] = context.basalMax ? context.basalMax : 5;
    time2[1] = new Array(3);
    time2[1][0] = new Date(st * 1000);
    time2[1][1] = new Date((st + Stime[1] * 60) * 1000);
    time2[1][2] = time2[0][2];

    context.sleepTime1 = time1;
    context.sleepTime2 = time2;
  },
  updateBolusChart: function updateBolusChart(context) {
    var bolus_proc = this.getBolus(context, context.st, context.bolus);

    context.DataBolus = bolus_proc[0];
    context.extend_bolus = bolus_proc[1][0] ? bolus_proc[1] : context.extend_bolus;

    console.log('updateBolusChart:', context.DataBolus.length, context.extend_bolus.length);
    var chartOption = context.chart2.getOption();
    chartOption.series[4].data = context.DataBolus;
    chartOption.series[5].data = context.extend_bolus;
    context.chart2.setOption(chartOption);
  },
  updateBasalChart: function updateBasalChart(context) {
    var bolus_proc = this.getBolus(context, context.st, context.bolus);

    context.DataBolus = bolus_proc[0];
    context.extend_bolus = bolus_proc[1][0] ? bolus_proc[1] : context.extend_bolus;

    console.log('updateBolusChart:', context.bolus, context.DataBolus, context.extend_bolus);

    context.basal.sort(function (x, y) {
      return x[1] - y[1];
    });
    console.log('updateBasalChart after sort:', context.basal);
    context.$store.commit('updateBasal', this.getBasal(context, context.st, context.basal));
    var bs = this.getBasal2(context.basal, context.st);
    context.newBasal = bs[0];
    context.stopBasal = bs[1];
    context.autoModeBasal = bs[2];
    context.autoModeCorrBolus = bs[3];
    if (bs[4] > context.basalMax) {
      context.basalMax = bs[4];
    }

    var bs1 = this.getBasalSus4(context, context.st, context.basal);
    context.basal_suspend = bs1[0];
    context.tempBasal = bs1[1];
    context.basal_suspend2 = bs1[2];

    var chartOption = context.chart2.getOption();

    chartOption.series[4].data = context.DataBolus;
    chartOption.series[5].data = context.extend_bolus;

    chartOption.series[0].data = context.DataBasal;
    chartOption.series[1].data = context.basal_suspend;
    chartOption.series[2].data = context.tempBasal;
    chartOption.series[3].data = context.basal_suspend2;
    chartOption.series[6].data = context.newBasal;
    chartOption.series[7].data = context.stopBasal;
    chartOption.series[10].data = context.autoModeBasal;
    chartOption.series[11].data = context.autoModeCorrBolus;

    chartOption.yAxis[0].max = context.basalMax;
    context.chart2.setOption(chartOption);
  },
  getMonData1: function getMonData1(context, info) {
    var that = this;
    var flag = parseInt(sessionStorage.getItem('monitor'));
    var uid = parseInt(context.uid);
    var now = new Date() / 1000;
    if (flag === 1) {
      context.$http.post('api/v2.0/monitor/data', info, { _timeout: 118000, onTimeout: function onTimeout(request) {
          console.log('超时');
        },
        before: function before(request) {
          if (this.previousRequest) {
            this.previousRequest.abort();
          }
          this.previousRequest = request;
        }
      }).then(function (res) {
        console.log(res);
        var err = res.body.error;
        if (err === 0) {
          var data = res.body.data[uid];
          console.log('monitor:', data);

          if (false) {
            data.pump = { "updateTime": 1583826009.216325, "wizardGlucose": 160.1999931335449, "basalDuration": 150,
              "serial": 1256630150, "extendBolusSet": 0.55, "suspendRemainingTime": 0, "extendBolusDuration": 30,
              "basalType": 1, "extendBolusDeliveried": 0.30000000001, "state": 32, "basalDeliveried": 0.15, "bolusSet": 0.85,
              "basalRate": 0.9, "wizardType": 3, "bolusType": 3, "suspendTime": 1583825463, "lastBolusType": 0,
              "remainingTime": 4310.39661141634, "bolusDeliveried": 0.7000000000000001, "wizardCorrSet": 0.4,
              "anotherBolusType": 0, "iob": 0, "basalDeliveriedTime": 1583825463, "wizardCarbSet": 1,
              "pumpId": 74, "wizardIob": 0, "basalPercent": 90, "wizardCarb": 15, "bolusDeliveriedTime": 1583825981 + 3600,
              "rssi": -58, "remainingDose": 190.65 };
          }

          if (data.sg) {
            var newSG = that.updateSg(context, data.sg);
            for (var i = 0; i < newSG.length; i++) {
              context.DataSG.push(newSG[i]);
            }
          }
          if (data.sg && context.chart1) {
            var option = context.chart1.getOption();
            option.series[0].data = context.DataSG;
            context.chart1.setOption(option);
          }
          if (data.sensor) {
            var t1 = now - data.sensor.update_time;
            context.sensorTime = data.sensor.update_time ? __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate1(new Date()) : '--';
            data.sensor.updateTime = data.sensor.update_time ? __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate1(new Date(data.sensor.update_time * 1000)) : '--';

            var sensor_serial = data.sensor.serial;

            if (102000000 <= sensor_serial && sensor_serial <= 103999999) {} else {}

            that.getSensor(context, data.sensor);
            if (t1 > 3600) {
              context.sensorTime = '--';
              that.clearSensor(context, data.sensor);
              context.showCGMStatus = false;
            } else {
              context.showCGMStatus = true;
            }
            that.checkSgIcon(context);
            context.$store.commit('updateSensor', data.sensor);
          }
          var basalChartUpdate = false;
          var bolusChartUpdate = false;
          var suspendFlag = false;
          if (data.pump) {
            var originStatus = {};
            for (var k in data.pump) {
              originStatus[k] = data.pump[k];
            }
            context.pumpTime = data.pump.update_time ? __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate1(new Date()) : '--';
            data.pump.update_time = data.pump.update_time ? __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate1(new Date(data.pump.update_time * 1000)) : '--';

            that.getPump(context, data.pump);
            var t2 = now - data.pump.update_time;
            if (t2 > 3600) {
              context.pumpTime = '--';
              that.clearPump(context, data.pump);
            }
            context.$store.commit('updatePump', data.pump);

            if (data.pump && data.pump.bolusType > 0) {
              bolusChartUpdate = true;
            }

            if (0x20 <= originStatus.state && originStatus.state <= 0x2F || 0x40 <= originStatus.state && originStatus.state <= 0x4F) {
                basalChartUpdate = true;
              }

            if (0x40 <= originStatus.state && originStatus.state <= 0x4F) {
              suspendFlag = true;
            }
          }

          if (data.bolus && false) {
            console.log('data.bolus.1:', data.bolus, context.bolus.length);
            var needRefresh = false;
            for (var _i2 = 0; _i2 < data.bolus.length; _i2++) {
              var newBolusRecord = data.bolus[_i2];

              var flag = context.addBolusRecord(newBolusRecord);
              needRefresh = needRefresh || flag;
            }

            if (needRefresh) {
              console.log('data.bolus.2:', context.bolus.length);
              context.calDayBolusTotal();

              context.basal = that.adjustBasalRecord(context.basal, data.pump || context.pump);

              bolusChartUpdate = true;
            }
          }

          if (data.basal && true) {
            console.log('data.basal.1:', data.basal, context.basal.length);
            var _needRefresh = false;
            for (var _i3 = 0; _i3 < data.basal.length; _i3++) {
              var newBasalRecord = data.basal[_i3];

              var flag = context.addBasalRecord(newBasalRecord);
              _needRefresh = _needRefresh || flag;
            }

            if (_needRefresh) {
              context.basal = that.adjustBasalRecord(context.basal, data.pump || context.pump);
              console.log('data.basal.2:', context.basal.length);
              context.calDayBasalTotal();

              basalChartUpdate = true;
            }
          }
          var chartUpdateTime = new Date().getTime() / 1000;

          if (basalChartUpdate || bolusChartUpdate) {
            if (chartUpdateTime - context.basalChartUpdateTime > 1) {
              console.log({ chartUpdateTime: chartUpdateTime, time: context.basalChartUpdateTime });
              context.basalChartUpdateTime = chartUpdateTime;
              that.updateBasalChart(context);
            }
          }


          info.eventNo = res.body.eventNo;
          that.getMonData1(context, info);
        } else {
          that.getMonData1(context, info);
        }
      }, function (err) {
        if (context.$route.path === '/monitor') {
          context.timeout1 = setTimeout(that._getMonData1(context, info), 5000);
        } else {
          context.timeout1 = '';
        }
      });
    }
  },
  updateSg: function updateSg(context, val) {
    var SG = [];
    for (var m = 0; m < val.length; m++) {
      SG[m] = new Array(3);
      SG[m][0] = new Date(val[m][1] * 1000);
      SG[m][1] = context.isMg ? Math.round(val[m][3] * 18) : val[m][3].toFixed(1);
      SG[m][2] = val[m][4];
    }
    return SG;
  },
  checkSgIcon: function checkSgIcon(context) {
    var obj = document.getElementById('sgIcon');

    if (!context.sgIcon) {
      obj.style.display = 'none';
      console.log('checkSgIcon.1:', context.sgIcon);
    } else {
      obj.style.display = 'auto';
    }
  },
  getDataMap: function getDataMap(context, uid, cb) {
    context.updateXhr = context.$http.get(SERVER_URL + '/v2.0/chart/' + uid + '/datamap').then(function (res) {
      cb(res.data);
    }, function (err) {
      console.log(err + "," + err.body.message);
      context.error = err.body.message;
    });
  },
  getDs: function getDs(context, uid, param, i) {
    var that = this;

    context.updateXhr = context.$http.get(SERVER_URL + '/v2.1/chart/' + uid + '/data/ds', { params: { param: param } }).then(function (res) {
      var err = res.body.error;

      if (err === 0) {
        console.log('ds.data:', res.body.data);
        var data_source = res.body.data.data_source;
        if (data_source) {
          sessionStorage.setItem('data_source', data_source);
        }
        context.$store.commit('updateDataS', res.body.data);
        context.timeSection = res.body.data.time_section[0];
        var st = context.timeSection[0];
        if (false) {
          console.log('ds sg:', res.body.data.sensor_glucose);
          var sgData = res.body.data.sensor_glucose[0];

          var dataNum = sgData.length;
          var start = 0;
          var end = dataNum;
          if (dataNum > 50) {
            start = dataNum - 50;
            end = 50;
          }
          for (var _i4 = start; _i4 < dataNum; _i4++) {}

          for (var _i5 = 0; _i5 < end; _i5++) {
            if (sgData[_i5][1] > 5) {
              sgData[_i5][1] += 18;
            }
          }
        }

        var SG = that.getSG(context, res.body.data);
        context.$store.commit('updateDataSG', SG[0]);

        if (res.body.data.transmtr) {
          context.transmtr = that.getTransmtr(context, res.body.data.transmtr[0]);
        } else {
          context.transmtr = [];
        }

        var alarm_display = res.body.data.alarm_display;
        if (alarm_display === 'On') {
          context.sensor_alarm = that.getAlarm(context, res.body.data.sensor_alarm, 0);
          context.pump_alarm = that.getAlarm(context, res.body.data.pump_alarm, 1);
        }

        context.calib = that.getCalib(res.body.data.calibRecord);
        var bg1 = that.getBg1(res.body.data.bg);
        context.bg = bg1[0];
        var bgMax = bg1[1];
        context.sgMax = context.sgMax > bgMax ? context.sgMax : bgMax;

        context.$store.commit('updateBasal', that.getBasal(context, st, res.body.data.basal[0]));

        console.log(res.body.data.basal[0], st);
        var bs = that.getBasal2(res.body.data.basal[0], st);
        context.newBasal = bs[0];

        context.stopBasal = bs[1];

        context.autoModeBasal = bs[2];
        console.log('autoModeBasal: ', context.autoModeBasal);
        context.autoModeCorrBolus = bs[3];
        if (bs[4] > context.basalMax) {
          context.basalMax = bs[4];
        }

        var normalBasal = context.DataBasal;
        var basalValue = normalBasal.map(function (e, i) {
          return e[1];
        });
        var autoBasalValue = context.autoModeBasal.map(function (e, i) {
          return e[2];
        });

        var basalValueAll = basalValue.concat(autoBasalValue);
        context.basalMax = that.getBasalYMax(basalValueAll);

        var bs1 = that.getBasalSus4(context, st, res.body.data.basal[0]);
        context.basal_suspend = bs1[0];
        context.tempBasal = bs1[1];
        context.basal_suspend2 = bs1[2];

        that.getDailySummaryAutoModeStatistics(context, res.body.data, i);
        var bolus_data = res.body.data.bolus[0];

        bolus_data = bolus_data.filter(function (e, i) {
          var recordId = e[0];
          var recordIdSplit = recordId.split('-');
          var recordSeq = recordIdSplit[3];
          try {
            if (recordSeq >= 8888) {
              return false;
            }
          } catch (e) {}
          return true;
        });

        var bolus = that.getBolus(context, st, bolus_data);

        context.$store.commit('updateBolus', bolus[0]);

        context.extend_bolus = bolus[1][0] ? bolus[1] : context.extend_bolus;


        context.bolusMax = bolus[2];

        var Carb = that.getCarb(res.body.data.carb_event);
        context.carb = Carb[0];
        context.carbMax = Carb[1];

        var exe = that.getExercise(context, res.body.data.exercise_event);
        context.exercise = exe ? exe : context.exercise;

        var autoMeal = that.getAutoMeal(context, res.body.data.auto_mode_event[0], context.carbMax);
        context.autoBreakfast = autoMeal[0];
        context.autoLunch = autoMeal[1];
        context.autoDinner = autoMeal[2];
        context.autoSnack = autoMeal[3];
        context.autoExercise = autoMeal[4];

        var sleep = that.getSleepTime(context, res.body.data.sleeptime, context.timeSection);
        context.sleepTime1 = sleep[0];
        context.sleepTime2 = sleep[1];
        context.sleepTime3 = sleep[2];

        if (context.chart1_2) {
          context.chartsDispose();
        }

        context.drawCharts(i);

        if (context.getStatistics) {
          context.getStatistics(res.data.report_data);
        } else if (context.getStatisticsQuick) {
          context.getStatisticsQuick(res.data.report_data, i);
        }
      }
    }, function (err) {
      console.log(err + "," + err.body.message);
      context.error = err.body.message;
    });
  },
  getSG: function getSG(context, val) {
    var sg = [],
        time = [],
        type = [],
        SG = [],
        max = context.isMg ? 400 : 22.2;
    for (var i = 0; i < val.sensor_glucose.length; i++) {
      for (var j = 0; j < val.sensor_glucose[i].length; j++) {
        sg[j] = val.sensor_glucose[i][j][1].toFixed(1);
        sg[j] = sg[j] > 22.2 ? 22.2 : sg[j];
        if (sg[j] < 2.2 && (val.sensor_glucose[i][j][4] === 'C' || val.sensor_glucose[i][j][4] === 'CX')) {
          sg[j] = 2.2;
        }
        sg[j] = context.isMg ? Math.round(sg[j] * 18) : sg[j];
        if (val.sensor_glucose[i][j][4] === 'DE') {
          sg[j] = 0;
        }
        time[j] = val.sensor_glucose[i][j][0];
        type[j] = val.sensor_glucose[i][j][4];
      }
    }
    max = sg.length > 1 ? Math.max.apply(null, sg) : max;
    max = this.getsgMax1(max);
    for (var m = 0; m < sg.length; m++) {
      SG[m] = new Array(3);
      time[m] = new Date(time[m] * 1000);
      SG[m][0] = time[m];
      SG[m][1] = sg[m];
      SG[m][2] = type[m];
    }

    return [SG, max];
  },
  getBasal: function getBasal(context, st, val) {
    var basal = [],
        j = 0,
        m1 = [],
        max = 0;
    var TODAY = new Date().setHours(0, 0, 0, 0);
    function isToday(date, TODAY) {
      date = new Date(date * 1000).setHours(0, 0, 0, 0);
      return date === TODAY;
    }
    var allowType = ['BAS', 'BAE', 'BAH', 'BAPB', 'BAPA', 'BAPC', 'BAPD', 'BASK'];
    var tempVal = [];
    for (var i = 0; i < val.length; i++) {
      if (val[i][0].split('-')[3] == '9999') {
        continue;
      }
      tempVal.push(val[i]);
    }
    val = tempVal;
    for (var _i6 = 0; _i6 < val.length; _i6++) {
      if (val[_i6][0].split('-').pop() !== '9999' || isToday(val[_i6][1], TODAY)) {
        if (allowType.includes(val[_i6][2])) {
          if (val[_i6][3] || val[_i6][3] === 0) {
            basal[j] = new Array(2);
            basal[j][0] = st <= val[_i6][1] ? new Date(val[_i6][1] * 1000) : new Date(st * 1000);
            basal[j][1] = val[_i6][4] ? val[_i6][4].toFixed(2) : 0;
            j++;
            basal[j] = new Array(2);
            basal[j][0] = st + 86400 <= val[_i6][1] + val[_i6][3] ? new Date((st + 86400) * 1000) : new Date((val[_i6][1] + val[_i6][3]) * 1000);
            basal[j][1] = val[_i6][4] ? val[_i6][4].toFixed(2) : 0;
            var tmpIndex = _i6;

            if (_i6 < val.length - 1) {
              var nextBasalType = val[_i6 + 1][2];

              while (true) {
                if (val[_i6 + 1][0].split('-').pop() !== '9999' || _i6 + 1 >= val.length - 1 || isToday(val[_i6 + 1][1], TODAY)) {
                  break;
                }
                _i6 += 1;
                nextBasalType = val[_i6 + 1][2];
              }

              if (!allowType.includes(nextBasalType) || val[_i6 + 1][1] - val[_i6][1] - val[_i6][3] > 60) {
                j++;
                basal[j] = new Array(2);
                basal[j][0] = st + 86400 <= val[tmpIndex][1] + val[tmpIndex][3] ? new Date((st + 86400) * 1000) : new Date((val[tmpIndex][1] + val[tmpIndex][3]) * 1000);
                basal[j][1] = null;
              }
            }
            j++;
          }
        }
        m1.push(val[_i6][4]);
      }
    }
    max = m1.length > 0 ? Math.max.apply(null, m1) : 1;
    if (max < 1) {
      max = 1;
    } else if (max < 2) {
      max = 2;
    } else if (max < 5) {
      max = 5;
    } else if (max < 10) {
      max = 10;
    } else if (max < 15) {
      max = 15;
    } else if (max < 20) {
      max = 20;
    } else if (max < 25) {
      max = 25;
    }
    context.basalMax = max;
    return basal;
  },
  getBasalYMax: function getBasalYMax(val) {
    var m1 = val;
    var max = m1.length > 1 ? Math.max.apply(null, m1) : 3;
    if (max < 1) {
      max = 1;
    } else if (max < 2) {
      max = 2;
    } else if (max < 5) {
      max = 5;
    } else if (max < 10) {
      max = 10;
    } else if (max < 15) {
      max = 15;
    } else if (max < 20) {
      max = 20;
    } else if (max < 25) {
      max = 25;
    }

    return max;
  },
  getBasal2: function getBasal2(val, st) {
    console.log('getBasal2:');
    var basalMax = 0;
    var newBasal = [],
        stopBasal = [];
    var autoModeBasal = [];
    var autoModeCorrBolus = [];
    var j = 0,
        k = 0;

    var today = new Date(st * 1000).getDate();
    for (var i = 0; i < val.length; i++) {
      if (val[i][2] === 'NEW') {
        newBasal[j] = new Array(2);
        newBasal[j][0] = new Date(val[i][1] * 1000);
        newBasal[j][1] = 0.2;
        j++;
      }
      if (val[i][2] === 'ENDM' || val[i][2] === 'ENDEM' || val[i][2] === 'ENDPE' || val[i][2] === 'ENDEP' || val[i][2] === 'ENDPB' || val[i][2] === 'ENDCE' || val[i][2] === 'ENDPBE' || val[i][2] === 'ENDD' || val[i][2] === 'ENDPE2') {
        stopBasal[j] = new Array(2);
        stopBasal[j][0] = new Date(val[i][1] * 1000);
        stopBasal[j][1] = 0.1;
        j++;
      }

      var basal_type = val[i][2];
      if (basal_type == 'BAAM') {
        var duration = val[i][3];
        var microBolusNum = Math.round(duration / 360);

        var microBolus = val[i][7];
        var microBolusJson = [];
        try {
          microBolus = JSON.parse(microBolus);

          microBolusJson = microBolus['autoModeJSON'];
          microBolusJson = microBolusJson.slice(0, microBolusNum);
        } catch (e) {
          console.log('microBolus error:', e);
        }
        if (Array.isArray(microBolusJson) && microBolusJson.length > 0) {
          var _index = 0;

          while (_index < microBolusJson.length) {

            var subRecord = microBolusJson.slice(_index, _index + 5);
            var startTime = new Date(val[i][1] * 1000 + _index * 6 * 60 * 1000);

            var endTime = new Date(val[i][1] * 1000 + (_index + subRecord.length) * 6 * 60 * 1000);

            if (startTime.getDate() !== today && endTime.getDate() === today) {
              startTime.setDate(startTime.getDate() + 1);
              startTime.setHours(0, 0, 0, 0);
            } else if (endTime.getDate() !== today) {
              endTime.setHours(0, 0, 0, 0);
            }
            var totalInject = 0;
            var totalCorrBolus = 0;
            var totalFoodBolus = 0;
            subRecord.map(function (e, i) {
              totalInject += e['auto_basal_delivery'];
              totalCorrBolus += e['auto_corr_delivery'];
              totalFoodBolus += e['auto_food_delivery'];
            });
            var basalRate = totalInject * 0.05 / (subRecord.length * 6.0 / 60);

            var basal_record = [startTime, endTime, basalRate];

            if (basalRate > 0 && startTime.getDate() === today) {
              autoModeBasal.push(basal_record);
              if (basalRate > basalMax) {
                basalMax = basalRate;
              }
            }

            if ((totalCorrBolus > 0 || totalFoodBolus > 0) && startTime.getDate() === today) {
              autoModeCorrBolus.push([new Date((startTime.getTime() + endTime.getTime()) / 2), totalCorrBolus * 0.05, totalFoodBolus * 0.05]);
            }

            _index += 5;
          }
        }
      }
    }

    var max = basalMax;
    if (max < 1) {
      max = 1;
    } else if (max < 2) {
      max = 2;
    } else if (max < 5) {
      max = 5;
    } else if (max < 10) {
      max = 10;
    } else if (max < 15) {
      max = 15;
    } else if (max < 20) {
      max = 20;
    } else if (max < 25) {
      max = 25;
    }
    basalMax = max;
    return [newBasal, stopBasal, autoModeBasal, autoModeCorrBolus, basalMax];
  },
  getDailySummaryAutoModeStatistics: function getDailySummaryAutoModeStatistics(context, data, index) {
    var basal = data.basal[0];
    var sg = data.sensor_glucose[0];
    var autoModeTime = 0;
    var autoModeTimeSection = [];
    var autoModeExits = 0;
    var autoModeStat = {};

    var today = data.time_section[0][0];
    var tomorrow = data.time_section[0][1];

    for (var i = 0; i < basal.length; i++) {
      var basalRecord = basal[i];
      var basalType = basalRecord[2];
      if ('BAAM' === basalType) {
        if (basalRecord[1] < today) {
          var datac = basalRecord[3] + basalRecord[1] - today;
          autoModeTime += datac;
        } else if (basalRecord[1] + basalRecord[3] > tomorrow) {
          var _datac = tomorrow - basalRecord[1];
          autoModeTime = autoModeTime + _datac;
        } else {
          autoModeTime += basalRecord[3];
        }
        if (autoModeTimeSection.length > 0) {
          var lastRecord = autoModeTimeSection[autoModeTimeSection.length - 1];

          if (basalRecord[1] > lastRecord[1]) {
            autoModeTimeSection.push([basalRecord[1], basalRecord[1] + basalRecord[3]]);
          } else if (basalRecord[1] == lastRecord[1]) {
            lastRecord[1] = basalRecord[1] + basalRecord[3];
          }
        } else {
          autoModeTimeSection.push([basalRecord[1], basalRecord[1] + basalRecord[3]]);
        }
      } else if ('BAAME' == basalType) {
        autoModeExits += 1;
      }
    }

    context.autoModeExits = autoModeExits;
    autoModeStat.autoModeExits = autoModeExits;

    var autoModeSG = [];
    var autoModeSGInTarget = [];
    var autoModeSGAboveTarget = [];
    var autoModeSGBelowTarget = [];

    var autoModeSGTargetHigh = 180 / 18.0;
    var autoModeSGTargetLow = 70 / 18.0;

    for (var _i7 = 0; _i7 < sg.length; _i7++) {
      var sgRecord = sg[_i7];
      var sgState = sgRecord[4];
      var sgValue = sgRecord[1];
      var sgTime = sgRecord[0];
      if ('CX' == sgState || 'C' == sgState || 'NC' == sgState) {
        if (sgValue > 0.000001) {
          var sgInAutoMode = false;
          for (var s = 0; s < autoModeTimeSection.length; s++) {
            if (sgTime >= autoModeTimeSection[s][0] && sgTime <= autoModeTimeSection[s][1]) {
              sgInAutoMode = true;
              break;
            }
          }
          if (sgInAutoMode) {
            autoModeSG.push(sgValue);
            if (sgValue >= autoModeSGTargetHigh) {
              autoModeSGAboveTarget.push(sgValue);
            } else if (sgValue < autoModeSGTargetLow) {
              autoModeSGBelowTarget.push(sgValue);
            } else {
              autoModeSGInTarget.push(sgValue);
            }
          } else {}
        }
      }
    }

    var statResult = this.getAvgSD(autoModeSG);
    if (statResult.num) {
      context.autoModeSGAvgSD = this.getGlucoseValText2(context.isMg, statResult.avg) + ' ± ' + this.getGlucoseSDValText(context.isMg, statResult.sd);
      var highPercent = parseInt((autoModeSGAboveTarget.length * 100.0 / autoModeSG.length).toFixed());
      var lowPercent = parseInt((autoModeSGBelowTarget.length * 100.0 / autoModeSG.length).toFixed());
      var inRangePercent = 100 - highPercent - lowPercent;
      context.autoModeSGInTargetRange = inRangePercent + '%';
      context.autoModeSGAboveRange = highPercent + '%';
      context.autoModeSGBelowRange = lowPercent + '%';

      autoModeStat.autoModeSGAvgSD = context.autoModeSGAvgSD;
      autoModeStat.autoModeSGInTargetRange = inRangePercent + '%';
      autoModeStat.autoModeSGAboveRange = highPercent + '%';
      autoModeStat.autoModeSGBelowRange = lowPercent + '%';
    } else {
      autoModeStat.autoModeSGAvgSD = '--';
      autoModeStat.autoModeSGInTargetRange = '--';
      autoModeStat.autoModeSGAboveRange = '--';
      autoModeStat.autoModeSGBelowRange = '--';
    }

    context.timeInAutoMode = parseInt((autoModeTime * 100.0 / (3600 * 24)).toFixed()) + '%';

    autoModeStat.timeInAutoMode = parseInt((autoModeTime * 100.0 / (3600 * 24)).toFixed()) + '%';
    context.autoModeStat[index] = autoModeStat;
  },
  getBolus: function getBolus(context, st, val) {
    var bolus = [],
        extend_bolus = [],
        m1 = [],
        max = 10,
        j = 0,
        k = 0;
    for (var i = 0; i < val.length; i++) {
      if (val[i][2] === 'EBCCW' || val[i][2] === 'EBM' || val[i][2] === 'EBCAW') {
        var partion_factor = val[i][5] ? 1.0 * val[i][6] / val[i][5] : 0;

        extend_bolus[j] = new Array(8);
        extend_bolus[j][0] = st < val[i][1] ? new Date(val[i][1] * 1000) : new Date(st * 1000);
        extend_bolus[j][1] = st + 86400 > val[i][1] + val[i][7] * 60 ? new Date((val[i][1] + val[i][7] * 60 * partion_factor) * 1000) : new Date((st + 86400) * 1000);
        extend_bolus[j][2] = val[i][6];
        extend_bolus[j][3] = Math.round(val[i][5] ? val[i][7] * 1.0 * val[i][6] / val[i][5] : 0);
        extend_bolus[j][4] = context.$t('E');
        extend_bolus[j][5] = val[i][8];
        extend_bolus[j][6] = val[i][5];
        extend_bolus[j][7] = val[i][5] == 0 ? 0 : Math.floor(val[i][6] / val[i][5] * val[i][7]);
        j++;
      } else if (val[i][2] === 'CBCCW' || val[i][2] === 'CBM' || val[i][2] === 'CBCAW') {
        extend_bolus[j] = new Array(8);
        extend_bolus[j][0] = st < val[i][1] ? new Date(val[i][1] * 1000) : new Date(st * 1000);
        extend_bolus[j][1] = st + 86400 > val[i][1] + val[i][7] * 60 ? new Date((val[i][1] + val[i][7] * 60) * 1000) : new Date((st + 86400) * 1000);
        extend_bolus[j][2] = val[i][6];
        extend_bolus[j][3] = val[i][7];
        extend_bolus[j][4] = context.$t('CE');
        extend_bolus[j][5] = val[i][8];
        extend_bolus[j][6] = val[i][5];
        extend_bolus[j][7] = val[i][5] == 0 ? 0 : Math.floor(val[i][6] / val[i][5] * val[i][7]);

        j++;
        bolus[k] = new Array(3);
        bolus[k][0] = new Date(val[i][1] * 1000);
        bolus[k][1] = val[i][4];
        bolus[k][2] = context.$t('CN1');
        k++;
      } else {
        bolus[k] = new Array(4);
        bolus[k][0] = new Date(val[i][1] * 1000);
        bolus[k][1] = val[i][4];
        bolus[k][2] = context.$t('N');
        bolus[k][3] = val[i][8];

        k++;
      }
      m1.push(val[i][4]);
      m1.push(val[i][6]);
    }
    max = Math.max.apply(null, m1);
    if (max < 5) {
      max = 5;
    } else if (max < 10) {
      max = 10;
    } else if (max < 15) {
      max = 15;
    } else if (max < 20) {
      max = 20;
    } else if (max < 25) {
      max = 25;
    }
    return [bolus, extend_bolus, max];
  },
  getExercise: function getExercise(context, val) {
    var exe = [],
        type = ['Light', 'Medium', 'Heavy'],
        j = 0,
        Num = [20, 60, 100];
    for (var i = 0; i < val[0].length; i++) {
      exe[j] = new Array(5);
      exe[j][0] = new Date(val[0][i][0] * 1000);
      exe[j][1] = new Date((val[0][i][0] + val[0][i][1] * 60) * 1000);
      exe[j][2] = Num[val[0][i][2]] * (context.carbMax / 100);
      exe[j][3] = val[0][i][1];
      exe[j][4] = type[val[0][i][2]];
      j++;
    }
    return exe;
  },
  getAutoMeal: function getAutoMeal(context, autoMeal, carbMax) {
    var autoBreakfast = autoMeal[0];
    var autoLunch = autoMeal[1];
    var autoDinner = autoMeal[2];
    var autoSnack = autoMeal[3];
    var autoExercise = autoMeal[4];
    if (1) {
      if (autoSnack.length) {
        autoSnack[0][1] = 50;
      }
    }

    autoBreakfast = autoBreakfast.map(function (e, i) {
      return [new Date(e[0] * 1000), carbMax - 0.1];
    });
    autoLunch = autoLunch.map(function (e, i) {
      return [new Date(e[0] * 1000), carbMax - 0.1];
    });
    autoDinner = autoDinner.map(function (e, i) {
      return [new Date(e[0] * 1000), carbMax - 0.1];
    });
    autoSnack = autoSnack.map(function (e, i) {
      return [new Date(e[0] * 1000), carbMax - 0.1];
    });
    autoExercise = autoExercise.map(function (e, i) {
      return [new Date(e[0] * 1000), carbMax - 0.1];
    });

    return [autoBreakfast, autoLunch, autoDinner, autoSnack, autoExercise];
  },
  getCalib: function getCalib(val) {
    var exe = [];
    for (var i = 0; i < val[0].length; i++) {
      exe[i] = new Array(2);
      exe[i][0] = new Date(val[0][i][1] * 1000);
      exe[i][1] = localStorage.getItem('unit') === 'mg' ? Math.round(val[0][i][3] * 18) : val[0][i][3].toFixed(1);
    }
    return exe;
  },
  getBg1: function getBg1(val) {
    var bg = [],
        max1 = [],
        max = 0;
    for (var i = 0; i < val[0].length; i++) {
      bg[i] = new Array(2);
      bg[i][0] = new Date(val[0][i][0] * 1000);
      bg[i][1] = localStorage.getItem('unit') === 'mg' ? Math.round(val[0][i][1] * 18) : val[0][i][1].toFixed(1);
      max1[i] = bg[i][1];
    }
    max = max1.length > 1 ? Math.max.apply(null, max1) : 0;
    max = this.getsgMax1(max);
    return [bg, max];
  },
  getCarb: function getCarb(val) {
    var carb = [],
        max = [],
        j = 0;
    for (var i = 0; i < val[0].length; i++) {
      if (val[0][i][1] !== 0) {
        carb[j] = new Array(2);
        carb[j][0] = new Date(val[0][i][0] * 1000);
        carb[j][1] = val[0][i][1];
        max[j] = val[0][i][1];
        j++;
      }
    }
    var max1 = Math.max.apply(null, max);
    if (max1 < 100) {
      max1 = 100;
    } else if (max1 < 200) {
      max1 = 200;
    } else if (max1 < 300) {
      max1 = 300;
    } else {
      max1 = 500;
    }
    return [carb, max1];
  },
  getAlarm: function getAlarm(context, val, flag) {
    var alarm = [];
    for (var i = 0; i < val[0].length; i++) {
      alarm[i] = new Array(3);
      alarm[i][0] = new Date(val[0][i][0] * 1000);
      if (flag === 1) {
        alarm[i][1] = 0.2;
      } else {
        alarm[i][1] = localStorage.getItem('unit') === 'mg' ? Math.round(1.2 * 18) : 1.2;
      }
      alarm[i][2] = context.$t(val[0][i][1]);
    }
    return alarm;
  },
  getsgMax1: function getsgMax1(max) {
    if (localStorage.getItem('unit') === 'mg') {
      if (max < 200) {
        max = 200;
      } else if (max < 300) {
        max = 300;
      } else if (max < 400) {
        max = 400;
      }
    } else {
      if (max < 15) {
        max = 15;
      } else if (max < 20) {
        max = 20;
      } else if (max < 25) {
        max = 25;
      }
    }
    return max;
  },
  getSleepTime: function getSleepTime(context, Stime, Dtime) {
    var time1 = new Array(2),
        time2 = new Array(2),
        time3 = new Array(2);
    time1[0] = new Array(3);
    time1[0][0] = new Date((Dtime[0] + Stime[0] * 60) * 1000);
    time1[0][1] = new Date(Dtime[1] * 1000);
    time1[0][2] = context.sgMax ? context.sgMax : 20;
    time1[1] = new Array(3);
    time1[1][0] = new Date(Dtime[0] * 1000);
    time1[1][1] = new Date((Dtime[0] + Stime[1] * 60) * 1000);
    time1[1][2] = time1[0][2];

    time2[0] = new Array(3);
    time2[0][0] = new Date((Dtime[0] + Stime[0] * 60) * 1000);
    time2[0][1] = new Date(Dtime[1] * 1000);
    time2[0][2] = context.basalMax ? context.basalMax : 5;
    time2[1] = new Array(3);
    time2[1][0] = new Date(Dtime[0] * 1000);
    time2[1][1] = new Date((Dtime[0] + Stime[1] * 60) * 1000);
    time2[1][2] = time2[0][2];

    time3[0] = new Array(3);
    time3[0][0] = new Date((Dtime[0] + Stime[0] * 60) * 1000);
    time3[0][1] = new Date(Dtime[1] * 1000);
    time3[0][2] = context.carbMax;
    time3[1] = new Array(3);
    time3[1][0] = new Date(Dtime[0] * 1000);
    time3[1][1] = new Date((Dtime[0] + Stime[1] * 60) * 1000);
    time3[1][2] = context.carbMax;

    return [time1, time2, time3];
  },
  getTransmtr: function getTransmtr(context, val) {
    var trans = [],
        j = 0;
    for (var i = 0; i < val.length; i++) {
      if (val[i].length > 0) {
        trans[j] = new Array(2);
        trans[j][0] = new Date(val[i][1] * 1000);
        trans[j][1] = 0.2;
        j++;
      }
    }
    return trans;
  },
  parseDeviceSN: function parseDeviceSN(context, basal_data) {
    var pump_sn = {};
    var transmitter_sn = {};
    basal_data.map(function (e, i) {
      var record_id = e[0];
      pump_sn[record_id.split('-')[1]] = 1;
    });
    var pump_sn_arr = [];
    for (var p in pump_sn) {
      pump_sn_arr.push(p);
    }

    if (pump_sn_arr.length > 0) {
      context.pump_device = 'MD-JN ' + this.deviceSNFormat(pump_sn_arr[0], 'PUMP');
    } else {
      context.pump_device = '--';
    }
  },
  getDd: function getDd(context, uid, param) {
    var that = this;
    context.$http.get('/api/v2.1/chart/' + uid + '/data/dd', { params: { param: param } }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        if (context.sgChart1 || context.chartColumn11) {
          context.chartsDispose2();
          this.sg = [];
          this.basal = [];
        }

        if (1) {
          var basal_data = [];

          for (var i in res.body.data.basal) {
            basal_data = basal_data.concat(res.body.data.basal[i]);
          }

          that.parseDeviceSN(context, basal_data);
        }

        context.$store.commit('updateDataD', res.body.data);
        if (false) {
          var dayNum = res.body.data.sg.length;
          var sgData = res.body.data.sg[dayNum - 1];
          var dataNum = sgData.length;
          var start = 0;
          var end = dataNum;
          if (dataNum > 50) {
            start = dataNum - 50;
            end = 50;
          }
          for (var _i8 = start; _i8 < dataNum; _i8++) {}

          for (var _i9 = 0; _i9 < end; _i9++) {
            if (sgData[_i9][1] > 5) {
              sgData[_i9][1] += 18;
            }
          }
        }
        context.sg = that.getDdSG(res.body.data.sg);
        context.calib = that.getCalib3(res.body.data.calib);
        context.bg = that.getBg3(res.body.data.bg);
        context.timeSection = res.body.data.time_sec;
        that.getBasal3(context, res.body.data.basal);

        that.getBasalSus3(context, res.body.data.basal);
        var mealTime = that.getMealTime(res.body.data.meal_time, res.body.data.time_sec);
        context.mealTime1 = mealTime[0];
        context.mealTime2 = mealTime[1];
        context.mealTime3 = mealTime[2];
        if (res.data.data.transmtr) {
          that.getTransmtr2(context, res.data.data.transmtr);
        }
        that.getBolus3(context, res.body.data.bolus);

        sessionStorage.setItem('dd_report_data', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(res.body.report_data));
        if (context.getDdReportInfo) {
          context.getDdReportInfo(res.body.report_data);
        }
        context.carb = res.body.data.carb;

        context.autoBreakfast = res.body.data.auto_mode_event[0];
        context.autoLunch = res.body.data.auto_mode_event[1];
        context.autoDinner = res.body.data.auto_mode_event[2];
        context.autoSnack = res.body.data.auto_mode_event[3];

        context.drawCharts2();
      }
      context.loading = false;
    }, function (err) {
      context.error = err.body.message;
    });
  },
  getDdSG: function getDdSG(val) {
    var SG = new Array(7);
    for (var i = 0; i < val.length; i++) {
      SG[i] = [];
      for (var j = 0; j < val[i].length; j++) {
        SG[i][j] = new Array(2);
        SG[i][j][0] = new Date(val[i][j][0] * 1000);
        SG[i][j][1] = val[i][j][1] > 22.2 ? 22.2 : val[i][j][1].toFixed(1);
        if (SG[i][j][1] < 2.2 && (val[i][j][4] === 'C' || val[i][j][4] === 'CX')) {
          SG[i][j][1] = 2.2;
        }
        SG[i][j][1] = localStorage.getItem('unit') === 'mg' ? Math.round(SG[i][j][1] * 18) : SG[i][j][1];
        if (val[i][j][4] === 'DE') {
          SG[i][j][1] = 0;
        }
        SG[i][j][2] = val[i][j][4];
      }
    }
    return SG;
  },
  getBasal3: function getBasal3(context, val) {
    var basal = new Array(7);
    var max_basal = 0;
    var allowType = ['BAS', 'BAE', 'BAH', 'BAPB', 'BAPA', 'BAPC', 'BAPD', 'BASK'];
    for (var i = 0; i < val.length; i++) {
      var st = context.timeSection[i][0];
      basal[i] = [];
      var j = 0;
      for (var k = 0; k < val[i].length; k++) {
        var recordSeq = val[i][k][0].split('-')[3];
        if ('9999' === recordSeq || '65535' == recordSeq) {
          continue;
        }
        if (allowType.includes(val[i][k][2])) {
          if (val[i][k][4] && val[i][k][4] > max_basal) {
            max_basal = val[i][k][4];
          }
          basal[i][j] = new Array(2);
          basal[i][j][0] = st <= val[i][k][1] ? new Date(val[i][k][1] * 1000) : new Date(st * 1000);
          basal[i][j][1] = val[i][k][4] ? val[i][k][4].toFixed(2) : 0;
          j++;
          basal[i][j] = new Array(2);
          basal[i][j][0] = st + 86400 <= val[i][k][1] + val[i][k][3] ? new Date((st + 86400) * 1000) : new Date((val[i][k][1] + val[i][k][3]) * 1000);
          basal[i][j][1] = val[i][k][4] ? val[i][k][4].toFixed(2) : 0;
          var tmpIndex = k;

          if (k < val[i].length - 1) {
            var nextBasalType = val[i][k + 1][2];

            while (true) {
              if (val[i][k + 1][0].split('-').pop() !== '9999' || k + 1 >= val[i].length - 1) {
                break;
              }
              k += 1;
              nextBasalType = val[i][k + 1][2];
            }

            if (!allowType.includes(nextBasalType) || val[i][k + 1][1] - val[i][k][1] - val[i][k][3] > 60) {
              j++;
              basal[i][j] = new Array(2);
              basal[i][j][0] = st + 86400 <= val[i][tmpIndex][1] + val[i][tmpIndex][3] ? new Date((st + 86400) * 1000) : new Date((val[i][tmpIndex][1] + val[i][tmpIndex][3]) * 1000);
              basal[i][j][1] = null;
            }
          }
          j++;
        }
      }
    }
    context.basal = basal;

    var autoModeBasalList = [];
    var autoModeCorrBolusList = [];

    for (var _i10 = 0; _i10 < val.length; _i10++) {
      var _st = context.timeSection[_i10][0];
      var autoModeBasal = [];
      var autoModeCorrBolus = [];
      for (var _k = 0; _k < val[_i10].length; _k++) {
        var basalType = val[_i10][_k][2];
        if ('BAAM' == basalType) {
          var duration = val[_i10][_k][3];
          var microBolusNum = Math.round(duration / 360);
          var microBolus = val[_i10][_k][7];

          var microBolusJson = [];
          try {
            microBolus = JSON.parse(microBolus);
            microBolusJson = microBolus['autoModeJSON'];
            microBolusJson = microBolusJson.slice(0, microBolusNum);
          } catch (e) {
            console.log('microBolus error:', e);
          }
          if (microBolusJson.length > 0) {

            var _index2 = 0;
            while (_index2 < microBolusJson.length) {
              var subRecord = microBolusJson.slice(_index2, _index2 + 5);
              var startTime = new Date(val[_i10][_k][1] * 1000 + _index2 * 6 * 60 * 1000);
              var endTime = new Date(val[_i10][_k][1] * 1000 + (_index2 + subRecord.length) * 6 * 60 * 1000);
              var totalInject = 0;
              var totalCorrBolus = 0;
              var totalFoodBolus = 0;
              subRecord.map(function (e, i) {
                totalInject += e['auto_basal_delivery'];
                totalCorrBolus += e['auto_corr_delivery'];
                totalFoodBolus += e['auto_food_delivery'];
              });
              var basalRate = totalInject * 0.05 / (subRecord.length * 6.0 / 60);

              var basal_record = [startTime, endTime, basalRate];
              autoModeBasal.push(basal_record);

              if (basalRate && basalRate > max_basal) {
                max_basal = basalRate;
              }

              if (totalCorrBolus > 0 || totalFoodBolus > 0) {
                autoModeCorrBolus.push([new Date((startTime.getTime() + endTime.getTime()) / 2), totalCorrBolus * 0.05, totalFoodBolus * 0.05]);
              }

              _index2 += 5;
            }
          }
        }
      }
      autoModeBasalList.push(autoModeBasal);
      autoModeCorrBolusList.push(autoModeCorrBolus);
    }
    context.autoModeBasal = autoModeBasalList;
    context.autoModeCorrBolus = autoModeCorrBolusList;

    var max = max_basal;
    if (max < 1) {
      max = 1;
    } else if (max < 2) {
      max = 2;
    } else if (max < 5) {
      max = 5;
    } else if (max < 10) {
      max = 10;
    } else if (max < 15) {
      max = 15;
    } else if (max < 20) {
      max = 20;
    } else if (max < 25) {
      max = 25;
    }
    context.basalMax = max;
  },
  getBasalSus3: function getBasalSus3(context, val) {
    var basal = new Array(7);
    var NewBasal = new Array(7);
    var stopBasal = new Array(7);
    var manualStop = new Array(7);
    var tempBasal = new Array(7);
    for (var i = 0; i < val.length; i++) {
      var data = this.getBasalSus4(context, context.timeSection[i][0], val[i]);
      basal[i] = data[0];
      tempBasal[i] = data[1];
      manualStop[i] = data[2];
      var data1 = this.getBasal2(val[i], context.timeSection[i][0]);
      NewBasal[i] = data1[0];
      stopBasal[i] = data1[1];
    }
    context.basal_suspend = basal;
    context.manualStop = manualStop;
    context.tempBasal = tempBasal;
    context.NewBasal = NewBasal;
    context.stopBasal = stopBasal;
  },
  getBasalSus4: function getBasalSus4(context, st, val) {
    var TextFunc = context.$t;

    var basal = [],
        tempBasal = [],
        basa2 = [];
    var j = 0,
        k = 0,
        p = 0,
        et = st + 86400;
    for (var i = 0; i < val.length; i++) {
      if (val[i][2] === 'SUSHM' || val[i][2] === 'SUSDM' || val[i][2] === 'SUSLSG' || val[i][2] === 'SUSPLSG' || val[i][2] === 'SUSA') {
        basal[j] = [];
        basal[j][0] = st <= val[i][1] ? new Date(val[i][1] * 1000) : new Date(st * 1000);
        basal[j][1] = val[i - 1] ? val[i - 1][4] : 0;
        basal[j][2] = context.$t(val[i][2]);
        j++;
        basal[j] = [];
        basal[j][0] = st <= val[i][1] ? new Date(val[i][1] * 1000) : new Date(st * 1000);
        basal[j][1] = 0;
        basal[j][2] = context.$t(val[i][2]);
        j++;
        basal[j] = [];
        basal[j][0] = et <= val[i][1] + val[i][3] ? new Date(et * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
        basal[j][1] = 0;
        basal[j][2] = context.$t(val[i][2]);
        j++;
        basal[j] = [];
        basal[j][0] = et <= val[i][1] + val[i][3] ? new Date(et * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
        basal[j][1] = val[i + 1] ? val[i + 1][4] : 0;
        basal[j][2] = context.$t(val[i][2]);

        if (i < val.length - 1) {
          if (val[i + 1][2] !== 'SUSHM' && val[i + 1][2] !== 'SUSDM' && val[i + 1][2] !== 'SUSLSG' && val[i + 1][2] !== 'SUSPLSG' && val[i + 1][2] !== 'SUSA') {
            j++;
            basal[j] = new Array(2);
            basal[j][0] = et <= val[i][1] + val[i][3] ? new Date(et * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
            basal[j][1] = null;
            basal[j][2] = context.$t(val[i][2]);
          }
        }
        j++;
      }
      if (val[i][2] === 'BART' || val[i][2] === 'BAAT') {
        tempBasal[k] = new Array(2);
        tempBasal[k][0] = st <= val[i][1] ? new Date(val[i][1] * 1000) : new Date(st * 1000);
        if (val[i - 1]) {
          if (val[i - 1][2] !== 'SUSM' && val[i - 1][2] !== 'SUSEB') {
            tempBasal[k][1] = val[i - 1][4];
          } else {
            if (val[i - 2]) {
              tempBasal[k][1] = val[i - 2][4];
            } else {
              tempBasal[k][1] = val[i][4];
            }
          }
        }
        k++;
        tempBasal[k] = new Array(2);
        tempBasal[k][0] = st <= val[i][1] ? new Date(val[i][1] * 1000) : new Date(st * 1000);
        tempBasal[k][1] = val[i][4];
        k++;
        tempBasal[k] = new Array(2);
        tempBasal[k][0] = et <= val[i][1] + val[i][3] ? new Date(et * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
        tempBasal[k][1] = val[i][4];
        k++;
        tempBasal[k] = new Array(2);
        tempBasal[k][0] = et <= val[i][1] + val[i][3] ? new Date(et * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
        if (val[i + 1]) {
          if (val[i + 1][2] !== 'SUSM' && val[i + 1][2] !== 'SUSEB' && val[i + 1][2] !== 'SUSHM' && val[i + 1][2] !== 'SUSDM' && val[i + 1][2] !== 'SUSLSG' && val[i + 1][2] !== 'SUSPLSG' && val[i + 1][2] !== 'SUSA') {
            tempBasal[k][1] = val[i + 1][4];
          } else {
            if (val[i + 2]) {
              tempBasal[k][1] = val[i + 2][4];
            } else {
              tempBasal[k][1] = val[i][4];
            }
          }
        }

        if (i < val.length - 1) {
          if (val[i + 1][2] !== 'BART' && val[i + 1][2] !== 'BAAT') {
            k++;
            tempBasal[k] = new Array(2);
            tempBasal[k][0] = et <= val[i][1] + val[i][3] ? new Date(et * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
            tempBasal[k][1] = null;
          }
        }
        k++;
      }
      if (val[i][2] === 'SUSM' || val[i][2] === 'SUSEB') {
        basa2[p] = new Array(2);
        basa2[p][0] = st <= val[i][1] ? new Date(val[i][1] * 1000) : new Date(st * 1000);

        if (val[i - 1]) {
          if (val[i - 1][2] === 'BAS' || val[i - 1][2] === 'BAE' || val[i - 1][2] === 'BAH') {
            basa2[p][1] = val[i - 1][4];
          } else {
            if (val[i - 2]) {
              basa2[p][1] = val[i - 2][4];
            } else {
              basa2[p][1] = val[i][4];
            }
          }
        }
        p++;
        basa2[p] = new Array(2);
        basa2[p][0] = st <= val[i][1] ? new Date(val[i][1] * 1000) : new Date(st * 1000);
        basa2[p][1] = 0;
        p++;
        basa2[p] = new Array(2);
        basa2[p][0] = et <= val[i][1] + val[i][3] ? new Date(et * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
        basa2[p][1] = 0;
        p++;
        basa2[p] = new Array(2);
        basa2[p][0] = et <= val[i][1] + val[i][3] ? new Date(et * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
        basa2[p][1] = val[i + 1] ? val[i + 1][4] : 0;

        if (i < val.length - 1) {
          if (val[i + 1][2] !== 'SUSM' && val[i + 1][2] !== 'SUEB') {
            p++;
            basa2[p] = new Array(2);
            basa2[p][0] = et <= val[i][1] + val[i][3] ? new Date(et * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
            basa2[p][1] = null;
          }
        }
        p++;
      }
    }


    return [basal, tempBasal, basa2];
  },
  getBolus3: function getBolus3(context, val) {
    var bolus = new Array(7);
    var extend_bolus = new Array(7);
    var max = new Array();
    for (var i = 0; i < val.length; i++) {
      var info = this.getBolus(context, context.timeSection[i][0], val[i]);
      bolus[i] = info[0];
      extend_bolus[i] = info[1];
      max[i] = info[2];
    }
    context.bolus = bolus;
    context.extend_bolus = extend_bolus;
    context.bolusMax = max.length > 0 ? Math.max.apply(null, max) : 5;
  },
  getCalib3: function getCalib3(val) {
    var calib = new Array(7);
    for (var i = 0; i < val.length; i++) {
      calib[i] = [];
      for (var j = 0; j < val[i].length; j++) {
        calib[i][j] = new Array(2);
        calib[i][j][0] = new Date(val[i][j][1] * 1000);
        calib[i][j][1] = localStorage.getItem('unit') === 'mg' ? Math.round(val[i][j][3] * 18) : val[i][j][3].toFixed(1);
      }
    }
    return calib;
  },
  getBg3: function getBg3(val) {
    var bg = new Array(7);
    for (var i = 0; i < val.length; i++) {
      bg[i] = [];
      for (var j = 0; j < val[i].length; j++) {
        bg[i][j] = new Array(2);
        bg[i][j][0] = new Date(val[i][j][0] * 1000);
        bg[i][j][1] = localStorage.getItem('unit') === 'mg' ? Math.round(val[i][j][1] * 18) : val[i][j][1].toFixed(1);
      }
    }
    return bg;
  },
  getMealTime: function getMealTime(Mtime, Dtime) {
    var timeb = [],
        timel = [],
        times = [],
        num = localStorage.getItem('unit') === 'mg' ? 400 : 25;
    for (var i = 0; i < Dtime.length; i++) {
      timeb[i] = new Array(3);
      timeb[i][0] = new Date((Dtime[i][0] + Mtime[0][0] * 60) * 1000);
      timeb[i][1] = new Date((Dtime[i][0] + Mtime[0][1] * 60) * 1000);
      timeb[i][2] = num;

      timel[i] = new Array(3);
      timel[i][0] = new Date((Dtime[i][0] + Mtime[1][0] * 60) * 1000);
      timel[i][1] = new Date((Dtime[i][0] + Mtime[1][1] * 60) * 1000);
      timel[i][2] = num;

      times[i] = new Array(3);
      times[i][0] = new Date((Dtime[i][0] + Mtime[2][0] * 60) * 1000);
      times[i][1] = new Date((Dtime[i][0] + Mtime[2][1] * 60) * 1000);
      times[i][2] = num;
    }
    return [timeb, timel, times];
  },
  getTransmtr2: function getTransmtr2(context, val) {
    var trans = [];
    for (var i = 0; i < val.length; i++) {
      trans[i] = this.getTransmtr(context, val[i]);
    }
    context.trans = trans;
  },
  getOl: function getOl(context, uid, param) {
    var that = this;
    var t1 = new Date();
    context.$http.get('/api/v2.1/chart/' + uid + '/data/ol', { params: { param: param } }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        if (context.chart3_1) {
          context.chart3_1.dispose();
          context.chart3_1 = null;
          context.DataSG = [];
        }
        context.$store.commit('updateDataS', res.body.data);

        if (false) {
          var dayNum = res.body.data.sg.length;
          var sgData = res.body.data.sg[dayNum - 1];
          var dataNum = sgData.length;
          var start = 0;
          var end = dataNum;
          if (dataNum > 50) {
            start = dataNum - 50;
            end = 50;
          }
          for (var i = start; i < dataNum; i++) {}

          for (var _i11 = 0; _i11 < end; _i11++) {
            if (sgData[_i11][1] > 5) {
              sgData[_i11][1] += 18;
            }
          }
        }
        context.DataSG = that.getSG2(context, res.body.data);
        context.calib = that.getCalib5(context, res.body.data.calib);
        context.bg = that.getBg5(context, res.body.data.bg);
        var t2 = new Date();

        context.drawChart3_1();

        context.checkLegend();

        if (context.getOlReportInfo) {
          context.getOlReportInfo(res.body.report_data);
        }
      }
    }, function (err) {
      var tip = context.$t('tryAgain');
      context.$message.error(tip);
    });
  },
  getSG2: function getSG2(context, val) {
    var time = [],
        SG = [],
        k = 0,
        kday = [],
        flag = 0,
        f1 = 0,
        p = 0,
        isEn = localStorage.getItem('unit') === 'mg';
    var length = val.sg.length;

    for (var i = 0; i < length; i++) {
      if (val.sg[i].length > 0 && flag === 0) {
        f1 = i;
        flag = 1;
        break;
      }
    }
    for (var _i12 = 0; _i12 < length; _i12++) {
      if (val.sg[_i12].length > 0) {
        if (false) {
          var t0 = format.formatterDate3(val.sg[f1][0][0]).split('-');
          var t1 = format.formatterDate3(val.sg[_i12][0][0]).split('-');
          var m = parseInt(t0[1]);
          if (m === 1 || m === 3 || m === 5 || m === 7 || m === 8 || m === 10 || m === 12) {
            k = (parseInt(t1[1]) - m) * 31 + parseInt(t1[2]) - parseInt(t0[2]);
          } else if (m === 2) {
            k = (parseInt(t1[1]) - m) * 28 + parseInt(t1[2]) - parseInt(t0[2]);
          } else {
            k = (parseInt(t1[1]) - m) * 30 + parseInt(t1[2]) - parseInt(t0[2]);
          }
        } else {
          var _t = val.sg[f1][0][0];
          var _t2 = val.sg[_i12][0][0];
          var d0 = new Date(_t * 1000);
          var d1 = new Date(_t2 * 1000);
          d0 = new Date(d0.getFullYear(), d0.getMonth(), d0.getDate());
          d1 = new Date(d1.getFullYear(), d1.getMonth(), d1.getDate());
          _t = d0.getTime() / 1000;
          _t2 = d1.getTime() / 1000;
          k = (_t2 - _t) / 86400;
        }

        kday.push(k);
        SG[p] = new Array(720);
        var length1 = val.sg[_i12].length;
        for (var j = 0; j < length1; j++) {
          time[j] = new Date((val.sg[_i12][j][0] - k * 3600 * 24) * 1000);
          SG[p][j] = new Array(3);
          SG[p][j][0] = time[j];
          SG[p][j][1] = val.sg[_i12][j][1] > 22.2 ? 22.2 : val.sg[_i12][j][1].toFixed(1);
          if (SG[p][j][1] < 2.2 && (val.sg[_i12][j][4] === 'C' || val.sg[_i12][j][4] === 'CX')) {
            SG[p][j][1] = 2.2;
          }
          SG[p][j][1] = isEn ? Math.round(SG[p][j][1] * 18) : parseFloat(SG[p][j][1]);
          if (val.sg[_i12][j][4] === 'DE') {
            SG[p][j][1] = 0;
          }
          SG[p][j][2] = val.sg[_i12][j][4];
        }
        p++;
      }
    }
    var st = 0;
    if (val.sg[f1].length > 1) {
      st = __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate3(val.sg[f1][0][0]) + ' 00:00:00';
      st = Date.parse(st.replace(/-/g, "/"));
    } else {
      st = val.time_sec[0][0] * 1000;
    }
    context.startTime = st;
    context.Kday = kday;

    if (length > 1) {
      context.getAverage(SG);
    }
    return SG;
  },
  getCalib5: function getCalib5(context, val) {
    var startDate = __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate9(context.startTime / 1000);
    var calib = [];
    var p = 0;
    for (var i = 0; i < val.length; i++) {
      if (val[i].length > 0) {
        for (var j = 0; j < val[i].length; j++) {
          var nt = __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate10(val[i][j][1]);
          calib[p] = new Array(3);
          calib[p][0] = new Date(startDate[0], startDate[1], startDate[2], nt[0], nt[1], nt[2]);
          calib[p][1] = localStorage.getItem('unit') === 'mg' ? Math.round(val[i][j][3] * 18) : val[i][j][3].toFixed(1);
          calib[p][2] = __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate2(val[i][j][1]);
          p++;
        }
      }
    }
    return calib;
  },
  getBg5: function getBg5(context, val) {
    var startDate = __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate9(context.startTime / 1000);
    var bg = [];
    var p = 0;
    for (var i = 0; i < val.length; i++) {
      if (val[i].length > 0) {
        for (var j = 0; j < val[i].length; j++) {
          bg[p] = new Array(3);

          var nt = __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate10(val[i][j][0]);
          bg[p][0] = new Date(startDate[0], startDate[1], startDate[2], nt[0], nt[1], nt[2]);
          bg[p][1] = localStorage.getItem('unit') === 'mg' ? Math.round(val[i][j][1] * 18) : val[i][j][1].toFixed(1);
          bg[p][2] = __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate2(val[i][j][0]);
          p++;
        }
      }
    }
    return bg;
  },
  getTa: function getTa(context, uid, param) {
    var that = this;
    context.$http.get('/api/v2.1/chart/' + uid + '/data/ta', { params: { param: param } }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        context.$store.commit('updateDataS', res.body.data);
        var ba0 = that.getTaData1(res.body.data.glucose_analysis);
        context.TaData1 = ba0[0];
        context.bgMax = ba0[1];
        var ba = that.getTaData2(res.body.data.inject_summary);
        context.TaData2 = ba[0];
        context.basalMax = ba[1];
        context.TaData3 = that.getTaData3(res.body.data.glucose_analysis);
        if (context.chart4_1) {
          context.chartsDispose();
        }
        context.drwCharts();

        if (context.getTaReportInfo) {
          context.getTaReportInfo(res.body.report_data);
        }
      }
    }, function (err) {
      this.error = err.body.message;
    });
  },
  getTaData1: function getTaData1(val) {
    var length = val.length,
        max = [];
    var TaData1 = [];
    var bg = new Array(3);bg[0] = new Array(length);bg[1] = new Array(length);bg[2] = new Array(length);
    var sg = new Array(3);sg[0] = new Array(length);sg[1] = new Array(length);sg[2] = new Array(length);
    for (var i = 0; i < length; i++) {
      bg[0][i] = val[i].bgdist[0];
      bg[1][i] = val[i].bgdist[1];
      bg[2][i] = val[i].bgdist[2];
      sg[0][i] = (val[i].sgdist[0] * 100).toFixed(1);
      sg[1][i] = (val[i].sgdist[1] * 100).toFixed(1);
      sg[2][i] = (val[i].sgdist[2] * 100).toFixed(1);
    }
    TaData1[0] = bg;TaData1[1] = sg;
    max[0] = bg[0].length > 1 ? Math.max.apply(null, bg[0]) : 5;
    max[1] = bg[1].length > 1 ? Math.max.apply(null, bg[1]) : 5;
    max[2] = bg[2].length > 1 ? Math.max.apply(null, bg[2]) : 5;
    var max1 = Math.max.apply(null, max);
    if (max1 < 10) {
      max1 = 10;
    } else if (max1 < 20) {
      max1 = 20;
    } else if (max1 < 30) {
      max1 = 30;
    } else if (max1 < 40) {
      max1 = 40;
    }
    return [TaData1, max1];
  },
  getTaData2: function getTaData2(val) {
    var length = val.length,
        max = 25,
        max2 = 0,
        max1 = 0;
    var data2 = new Array(2);data2[0] = new Array(length);data2[1] = new Array(length);
    for (var i = 0; i < length; i++) {
      data2[0][i] = val[i][1];
      data2[1][i] = val[i][2];
    }
    max1 = data2[0].length > 1 ? Math.max.apply(null, data2[0]) : 25;
    max2 = data2[1].length > 1 ? Math.max.apply(null, data2[1]) : 25;
    max = max1 > max2 ? max1 : max2;

    if (max < 20) {
      max = 20;
    } else if (max < 30) {
      max = 30;
    } else if (max < 40) {
      max = 40;
    } else if (max < 50) {
      max = 50;
    } else if (max < 100) {
      max = 100;
    } else if (max < 150) {
      max = 150;
    } else if (max < 200) {
      max = 200;
    } else {
      max = 250;
    }
    return [data2, max];
  },
  getTaData3: function getTaData3(val) {
    var length = val.length,
        j = 0,
        k = 0,
        data3 = [],
        flag = localStorage.getItem('unit') === 'mg';
    data3[0] = new Array(length);
    data3[1] = new Array(length);
    for (var i = 0; i < length; i++) {
      if (val[i].sgbs.length > 0) {
        data3[0][i] = flag ? Math.round(val[i].sgbs[0] * 18) : val[i].sgbs[0].toFixed(1);
        data3[1][i] = new Array(5);
        data3[1][i][0] = flag ? Math.round(val[i].sgbs[4] * 18) : val[i].sgbs[4].toFixed(1);
        data3[1][i][1] = flag ? Math.round(val[i].sgbs[2] * 18) : val[i].sgbs[2].toFixed(1);
        data3[1][i][2] = flag ? Math.round(val[i].sgbs[1] * 18) : val[i].sgbs[1].toFixed(1);
        data3[1][i][3] = flag ? Math.round(val[i].sgbs[3] * 18) : val[i].sgbs[3].toFixed(1);
        data3[1][i][4] = flag ? Math.round(val[i].sgbs[5] * 18) : val[i].sgbs[5].toFixed(1);
      } else {
        data3[0][i] = null;
        data3[1][i] = new Array(5);
      }
    }
    return data3;
  },
  getBg: function getBg(val) {
    var bg = [];
    for (var i = 0; i < val.length; i++) {
      bg[i] = [];
      var k = 0;
      for (var j = 0; j < val[i].length; j++) {
        if (val[i][j].disp !== '') {
          bg[i][k] = new Array(3);
          bg[i][k][0] = j;
          bg[i][k][1] = val[i][j].disp;
          bg[i][k][2] = val[i][j].color;
          k++;
        }
      }
    }
    return bg;
  },
  getIns: function getIns(context, val) {
    var bg = [],
        autoStop = [],
        manualStop = [],
        stop = [],
        Newer = [];
    for (var i = 0; i < val.length; i++) {
      bg[i] = [];autoStop[i] = [];manualStop[i] = [];stop[i] = [];Newer[i] = [];
      var k = 0,
          p = 0,
          q = 0,
          o = 0,
          s = 0;
      for (var j = 0; j < val[i].length; j++) {
        if (val[i][j].disp !== 0) {
          bg[i][k] = new Array(2);
          bg[i][k][0] = j;
          bg[i][k][1] = val[i][j].disp;
          k++;
        }
        if (val[i][j].basal) {
          for (var w = 0; w < val[i][j].basal.length; w++) {
            var va = val[i][j].basal[w];
            if (va[2] === 'SUSHM' || va[2] === 'SUSDM' || va[2] === 'SUSLSG' || va[2] === 'SUSPLSG' || va[2] === 'SUSA') {
              autoStop[i][p] = j;
              p++;
            }
            if (va[2] === 'SUSM' || va[2] === 'SUSEB') {
              manualStop[i][q] = j;
              q++;
            }
            if (va[2] === 'ENDM' || va[2] === 'ENDEM' || va[2] === 'ENDPE' || va[2] === 'ENDEP' || va[2] === 'ENDPB' || va[2] === 'ENDCE' || va[2] === 'ENDPBE') {
              stop[i][o] = j;
              o++;
            }
            if (va[2] === 'NEW') {
              Newer[i][s] = j;
              s++;
            }
          }
        }
      }
    }
    context.autoStop = autoStop;
    context.manualStop = manualStop;
    context.stop = stop;
    context.Newer = Newer;
    return bg;
  },
  getNoMeal: function getNoMeal(context, mt, val) {
    var noMeal = [];
    for (var i = 0; i < val.length; i++) {
      noMeal[i] = [0, 0, 0];
      if (val[i].length !== 0) {
        for (var j = 0; j < val[i].length; j++) {
          for (var k = 0; k < 3; k++) {
            if (val[i][j][0] >= mt[k][0] && val[i][j][0] <= mt[k][1]) {
              noMeal[i][k] = 1;
            }
          }
        }
      }
    }
    context.mt = mt;
    context.noMeal = noMeal;
  },
  getLgb1: function getLgb1(context, uid, param) {
    var that = this;
    context.$http.get('/api/v2.1/chart/' + uid + '/data/lgb', { params: { param: param } }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        context.initTable();
        var data = res.data.data;

        if (1) {
          var basal_data = [];

          for (var i in res.body.data.basal) {
            basal_data = basal_data.concat(res.body.data.basal[i]);
          }
          that.parseDeviceSN(context, basal_data);
        }

        var mt1 = [];
        var mt = data.meal_time.map(function (e, i) {
          mt1[i] = [];
          mt1[i][0] = (e[0] / 60).toFixed(1);
          mt1[i][1] = (e[1] / 60).toFixed(1);
          e[0] = Math.round(e[0] / 60);
          e[1] = Math.round(e[1] / 60);
          return e;
        });
        context.mt1 = mt1;
        that.getLbg(context, data.bg_event, data.calib, data.bolus, data.target_high, data.target_low);
        var carb = that.getLcarb(context, data.carb_event, data.bolus);
        that.getLnoMeal(context, mt, carb);
        that.getLexer(context, data.exr_event);
        that.getLother(context, data.other_event);

        that.getAutoModeEvent(context, data.auto_mode_event, data.basal);
        var autoModeInject = that.getAutoModeInject(context, data.basal);
        var bolusTotal = that.getLbolus(context, data.bolus, data.ins_event);
        var basalTotal = that.getLbasal(context, data.basal);
        for (var _i13 = 0; _i13 < basalTotal.length; _i13++) {
          basalTotal[_i13] += autoModeInject[_i13][0];
          bolusTotal[_i13] += autoModeInject[_i13][1];

          var total = basalTotal[_i13] + bolusTotal[_i13];
          var percent = bolusTotal[_i13] / total * 100;
          if (total !== 0) {
            context.ins[_i13].total = parseFloat(total).toFixed(2);
            context.ins[_i13].percent = parseFloat(percent).toFixed(1);
          }
        }
        that.getLbolus2(context, data.ins_event);
        if (context.getLgbReportInfo) {
          context.getLgbReportInfo(res.data.report_data);
        }
      }
    }, function (err) {
      this.error = err.body.message;
    });
  },
  getLbg: function getLbg(context, val, val2, val3, high, low) {
    var _this = this;

    var length = val.length,
        bg = [],
        bgNew = [];
    var middle = (high + low) / 2;
    high = context.isMg ? parseInt(high * 18) : parseFloat(high.toFixed(1));
    low = context.isMg ? parseInt(low * 18) : parseFloat(low.toFixed(1));
    middle = context.isMg ? parseInt(middle * 18) : parseFloat(middle.toFixed(1));

    var _loop = function _loop(i) {
      var length1 = val[i].length,
          length2 = val2[i].length,
          length3 = val3[i].length,
          sum = 0,
          num = 0,
          m = 0,
          st = context.ts[i][0];
      bg[i] = [];
      bgNew[i] = new Array(24);
      if (length1 !== 0) {
        val[i].map(function (e, j) {
          var k = parseInt((e[0] - st) / 3600);
          if (k >= 0) {
            bg[i][m] = [];
            bg[i][m][0] = k;
            bg[i][m][1] = e[1];
            m++;
          }
        });
      }
      if (length2 !== 0) {
        val2[i].map(function (e, j) {
          var k = parseInt((e[0] - st) / 3600);
          if (k >= 0) {
            bg[i][m] = [];
            bg[i][m][0] = k;
            bg[i][m][1] = e[1];
            m++;
          }
        });
      }
      if (length3 !== 0) {
        val3[i].map(function (e, j) {
          if (e[8].bg) {
            var k = parseInt((e[1] - st) / 3600);
            if (k >= 0) {
              bg[i][m] = [];
              bg[i][m][0] = k;
              bg[i][m][1] = e[8].bg;
              m++;
            }
          }
        });
      }

      for (var p = 0; p < 24; p++) {
        bgNew[i][p] = [];
      }
      bg[i].map(function (e) {
        e[1] = context.isMg ? parseInt(e[1] * 18) : parseFloat(e[1].toFixed(1));
        bgNew[i][e[0]].push(e[1]);
        sum += e[1];
        num++;
      });

      bgNew[i] = _this.getShowBg(bgNew[i], high, low, middle);
      if (sum > 0) {
        context.bgAvg[i].avg = context.isMg ? parseInt(sum / num) + 'mg/dL' : parseFloat(sum / num).toFixed(1) + 'mmol/L';
      } else {
        context.bgAvg[i].avg = context.isMg ? '--mg/dL' : '--mmol/L';
      }
    };

    for (var i = 0; i < length; i++) {
      _loop(i);
    }
    context.makebg1(bgNew, high, low);
  },
  getShowBg: function getShowBg(bgNew, high, low, middle) {
    for (var q = 0; q < 24; q++) {
      var leng = bgNew[q].length;
      if (leng > 1) {
        var _ret2 = function () {
          var v1 = [],
              v2 = [],
              v3 = [];
          bgNew[q].map(function (e, i) {
            if (e < low) {
              v1.push(e);
            } else if (e > high) {
              v2.push(e);
            } else {
              v3.push(e);
            }
          });
          if (v1.length > 0) {
            var min = Math.min.apply(null, v1);
            bgNew[q] = [];
            bgNew[q][0] = min;
            bgNew[q][1] = 2;
            return 'continue';
          } else if (v2.length > 0) {
            var max = Math.max.apply(null, v2);
            bgNew[q] = [];
            bgNew[q][0] = max;
            bgNew[q][1] = 2;
            return 'continue';
          } else if (v3.length > 0) {
            var diff = [],
                k = 0;
            v3.map(function (e, i) {
              diff[i] = Math.abs(e - middle);
            });
            k = diff.indexOf(Math.max.apply(null, diff));
            bgNew[q] = [];
            bgNew[q][0] = v3[k];
            bgNew[q][1] = 2;
          }
        }();

        if (_ret2 === 'continue') continue;
      }
    }
    return bgNew;
  },
  getLcarb: function getLcarb(context, val, val2) {
    var length = val.length,
        carb = [],
        newCarb = [];

    var _loop2 = function _loop2(i) {
      var length1 = val[i].length,
          length2 = val2[i].length,
          m = 0;
      var st = context.ts[i][0],
          sum = 0;
      carb[i] = [];newCarb[i] = [];
      if (length1 !== 0) {
        val[i].map(function (e, j) {
          sum += e[1];
          var k = parseInt((e[0] - st) / 3600);
          if (k >= 0) {
            carb[i][m] = [];
            carb[i][m][0] = k;
            carb[i][m][1] = e[1];
            m++;
          }
        });
      }
      if (length2 !== 0) {
        val2[i].map(function (e, j) {
          if (e[8].carb) {
            var k = parseInt((e[1] - st) / 3600);
            if (k >= 0) {
              carb[i][m] = [];
              carb[i][m][0] = k;
              carb[i][m][1] = e[8].carb;
              sum += e[8].carb;
              m++;
            }
          }
        });
      }
      context.carb[i].total = sum ? parseInt(sum) + 'g' : '--g';
      for (var p = 0; p < 24; p++) {
        newCarb[i][p] = 0;
      }
      carb[i].map(function (e) {
        if (e[0] < 24) {
          newCarb[i][e[0]] = newCarb[i][e[0]] + e[1];
        }
      });
    };

    for (var i = 0; i < length; i++) {
      _loop2(i);
    }
    if (carb.length > 0) {
      context.makecarb(newCarb);
    }
    return carb;
  },
  getLnoMeal: function getLnoMeal(context, mt, val) {
    var noMeal = [];
    for (var i = 0; i < val.length; i++) {
      noMeal[i] = [0, 0, 0];
      var leng = val[i].length;
      if (leng > 0) {
        for (var j = 0; j < leng; j++) {
          for (var k = 0; k < 3; k++) {
            if (val[i][j][0] >= mt[k][0] && val[i][j][0] <= mt[k][1]) {
              noMeal[i][k] = 1;
            }
          }
        }
      }
    }
    context.mt = mt;
    context.noMeal = noMeal;
    context.makeNoMeal();
  },
  getLbasal: function getLbasal(context, val) {
    var autoStop = [],
        manualStop = [],
        stop = [],
        Newer = [],
        basalTotal = [],
        noPump = [],
        tempBasal = [];
    for (var i = 0; i < val.length; i++) {
      autoStop[i] = [];manualStop[i] = [];stop[i] = [];Newer[i] = [];basalTotal[i] = [];noPump[i] = 0;tempBasal[i] = [];
      var p = 0,
          q = 0,
          o = 0,
          s = 0,
          _sum = 0,
          t = 0;
      var _st2 = context.ts[i][0],
          et = context.ts[i][1];
      for (var j = 0; j < val[i].length; j++) {
        var va = val[i][j];
        if ('BAAM' === va[2] || 'BAAMS' === va[2] || 'BAAME' === va[2] || 'BAAMTarget100' === va[2] || 'BAAMTarget110' === va[2] || 'BAAMTarget120' === va[2] || 'BAAMBreakfast' === va[2] || 'BAAMLunch' === va[2] || 'BAAMDinner' === va[2] || 'BAAMExerciseStart' === va[2] || 'BAAMSnack' === va[2] || 'BAAMExerciseExit' === va[2]) {
          continue;
        }
        if (va[2] === 'SUSHM' || va[2] === 'SUSDM' || va[2] === 'SUSLSG' || va[2] === 'SUSPLSG' || va[2] === 'SUSA') {
          var k1 = 0,
              k2 = 0;
          if (va[1] < _st2) {
            k1 = 0;
            k2 = parseInt((va[1] + va[3] - _st2) / 3600);
          } else if (va[1] + va[3] > et) {
            k1 = parseInt((va[1] - _st2) / 3600);
            k2 = 23;
          } else {
            k1 = parseInt((va[1] - _st2) / 3600);
            k2 = parseInt((va[1] + va[3] - _st2) / 3600);
          }
          for (var k = k1; k < k2 + 1; k++) {
            autoStop[i][p] = k;
            p++;
          }
        } else if (va[2] === 'SUSM' || va[2] === 'SUSEB') {
          var _k2 = 0,
              _k3 = 0;
          if (va[1] < _st2) {
            _k2 = 0;
            _k3 = parseInt((va[1] + va[3] - _st2) / 3600);
          } else if (va[1] + va[3] > et) {
            _k2 = parseInt((va[1] - _st2) / 3600);
            _k3 = 23;
          } else {
            _k2 = parseInt((va[1] - _st2) / 3600);
            _k3 = parseInt((va[1] + va[3] - _st2) / 3600);
          }
          for (var _k4 = _k2; _k4 < _k3 + 1; _k4++) {
            manualStop[i][q] = _k4;
            q++;
          }
        } else if (va[2] === 'BART' || va[2] === 'BAAT') {
          var _k5 = 0,
              _k6 = 0;
          if (va[1] < _st2) {
            _k5 = 0;
            _k6 = parseInt((va[1] + va[3] - _st2) / 3600);
          } else if (va[1] + va[3] > et) {
            _k5 = parseInt((va[1] - _st2) / 3600);
            _k6 = 23;
          } else {
            _k5 = parseInt((va[1] - _st2) / 3600);
            _k6 = parseInt((va[1] + va[3] - _st2) / 3600);
          }
          for (var _k7 = _k5; _k7 < _k6 + 1; _k7++) {
            tempBasal[i][t] = _k7;
            t++;
          }
        } else if (va[2] === 'ENDM' || va[2] === 'ENDEM' || va[2] === 'ENDPE' || va[2] === 'ENDEP' || va[2] === 'ENDPB' || va[2] === 'ENDCE' || va[2] === 'ENDPBE' || va[2] === 'ENDD' || va[2] === 'ENDPE2') {
          var _k8 = parseInt((va[1] - _st2) / 3600);
          if (_k8 >= 0) {
            stop[i][o] = _k8;
            o++;
          }
        } else if (va[2] === 'NEW') {
          var _k9 = parseInt((va[1] - _st2) / 3600);
          if (_k9 >= 0) {
            Newer[i][s] = _k9;
            s++;
          }
        }
        if (va[1] < _st2) {
          var value = (va[1] + va[3] - _st2) / va[3] * parseFloat(va[5]);
          _sum = _sum + value;
        } else if (va[1] + va[3] > _st2 + 86400) {
          var _value = (_st2 + 86400 - va[1]) / va[3] * parseFloat(va[5]);
          _sum = _sum + _value;
        } else {
          _sum = _sum + va[5];
        }
      }
      basalTotal[i] = _sum;
      if (val[i].length === 0) {
        noPump[i] = 1;
      }
    }
    context.makeNoPump(noPump);
    context.makeOth1(this.getLnewBasal(autoStop), 0);
    context.makeOth1(this.getLnewBasal(manualStop), 1);
    context.makeOth1(this.getLnewBasal(stop), 2);
    context.makeOth1(this.getLnewBasal(Newer), 3);
    context.makeOth1(this.getLnewBasal(tempBasal), 6);
    return basalTotal;
  },
  getLnewBasal: function getLnewBasal(val) {
    var length = val.length,
        newBasal = [];

    var _loop3 = function _loop3(i) {
      newBasal[i] = new Array(24);
      for (var p = 0; p < 24; p++) {
        newBasal[i][p] = 0;
      }
      if (val[i].length > 0) {
        val[i].map(function (e) {
          if (e < 24) {
            newBasal[i][e] = 1;
          }
        });
      }
    };

    for (var i = 0; i < length; i++) {
      _loop3(i);
    }
    return newBasal;
  },
  getLbolus: function getLbolus(context, val, val2) {
    var bolus = [],
        newBolus = [],
        bolusTotal = [];
    var bolusMarkFlag = [];
    var bolusNoMark = [];

    var _loop4 = function _loop4(i) {
      var length1 = val[i].length,
          st = context.ts[i][0],
          length2 = val2[i].length,
          sum = 0;
      bolus[i] = [];newBolus[i] = new Array(24);bolusTotal[i] = [];
      if (length1 > 0) {
        val[i].map(function (e, j) {
          var k = parseInt((e[1] - st) / 3600);
          if (k >= 0) {
            bolus[i][j] = [];
            bolus[i][j][0] = k;
            if (e[2] === 'EBCCW' || e[2] === 'EBM' || e[2] === 'EBCAW') {
              bolus[i][j][1] = e[6];
            } else if (e[2] === 'CBCCW' || e[2] === 'CBM' || e[2] === 'CBCAW') {
              bolus[i][j][1] = e[4] + e[6];
            } else {
              bolus[i][j][1] = e[4];
            }

            bolus[i][j][2] = true;

            if (e[2].substr(-1) === 'W') {
              var wizzard_info = e[8];

              var carb_bolus = __WEBPACK_IMPORTED_MODULE_3__lib_chartTipFormat__["a" /* default */].getSuggest(wizzard_info);
              var iob = wizzard_info['iob'];

              var set_total = 0;
              if (e[3]) {
                set_total += e[3];
              }
              if (e[5]) {
                set_total += e[5];
              }
              if (set_total == carb_bolus) {
                bolus[i][j][2] = false;
              }
            }

            sum += bolus[i][j][1];
          }
        });
      }
      bolusMarkFlag[i] = new Array(24);
      bolusNoMark[i] = new Array(24);
      for (var p = 0; p < 24; p++) {
        newBolus[i][p] = 0;
        bolusMarkFlag[i][p] = false;
        bolusNoMark[i][p] = 0;
      }

      bolus[i].map(function (e) {
        var hour = e[0];
        bolusMarkFlag[i][hour] = bolusMarkFlag[i][hour] || e[2];
        newBolus[i][e[0]] = newBolus[i][e[0]] + parseFloat(e[1]);
        bolusNoMark[i][hour] = newBolus[i][hour];
      });

      bolusMarkFlag[i].map(function (e, h) {
        if (e) {} else {}
      });

      if (length2 > 0) {
        val2[i].map(function (e) {
          sum += e[1];
        });
      }
      bolusTotal[i] = sum;
    };

    for (var i = 0; i < val.length; i++) {
      _loop4(i);
    }

    context.makeBolus(newBolus, bolusMarkFlag);
    return bolusTotal;
  },
  getLbolus2: function getLbolus2(context, val) {
    var length = val.length,
        bolus2 = [];

    var _loop5 = function _loop5(i) {
      var length1 = val[i].length,
          st = context.ts[i][0];
      bolus2[i] = [];
      if (length1 !== 0) {
        val[i].map(function (e, j) {
          var k = parseInt((e[0] - st) / 3600);
          if (k >= 0) {
            bolus2[i][j] = [];
            bolus2[i][j][0] = k;
            bolus2[i][j][1] = e[1];
          }
        });
      }
    };

    for (var i = 0; i < length; i++) {
      _loop5(i);
    }
    context.makeBolus2(bolus2);
  },
  getLexer: function getLexer(context, val) {
    var exe = [];
    for (var i = 0; i < val.length; i++) {
      exe[i] = [];
      var _st3 = context.ts[i][0],
          et = context.ts[i][1],
          length = val[i].length,
          p = 0;
      if (length > 0) {
        for (var j = 0; j < length; j++) {
          var k1 = 0,
              k2 = 0;
          var va = val[i][j];
          if (va[0] < _st3) {
            k1 = 0;
            k2 = parseInt(va[1] / 60);
          } else if (va[0] + va[1] * 60 > et) {
            k1 = parseInt((va[0] - _st3) / 3600);
            k2 = 23;
          } else {
            k1 = parseInt((va[0] - _st3) / 3600);
            k2 = parseInt((va[0] + va[1] * 60 - _st3) / 3600);
          }
          for (var k = k1; k < k2 + 1; k++) {
            exe[i][p] = k;
            p++;
          }
        }
      }
    }
    context.makeOth1(this.getLnewBasal(exe), 4);
  },
  getLother: function getLother(context, val) {
    var oth = [];
    for (var i = 0; i < val.length; i++) {
      oth[i] = [];
      var _st4 = context.ts[i][0],
          length = val[i].length,
          p = 0;
      if (length > 0) {
        var k = 0;
        for (var j = 0; j < length; j++) {
          k = parseInt((val[i][j][0] - _st4) / 3600);
          oth[i][p] = k;
          p++;
        }
      }
    }
    context.makeOth1(this.getLnewBasal(oth), 5);
  },
  getAutoModeInject: function getAutoModeInject(context, basal_data) {
    var injectResult = [];
    for (var d = 0; d < basal_data.length; d++) {
      var autoBasalTotal = 0;
      var autoBolusTotal = 0;
      for (var i = 0; i < basal_data[d].length; i++) {
        var basalRecord = basal_data[d][i];
        var basalType = basalRecord[2];
        if ('BAAM' == basalType) {
          var autoModeData = basalRecord[7];
          try {
            autoModeData = JSON.parse(autoModeData);
            var autoModeJson = autoModeData['autoModeJSON'];
            autoModeJson.map(function (e, i) {
              autoBasalTotal += e['auto_basal_delivery'] * 0.05;
              autoBolusTotal += (e['auto_food_delivery'] + e['auto_corr_delivery']) * 0.05;
            });
          } catch (e) {}
        }
      }
      injectResult.push([autoBasalTotal, autoBolusTotal]);
    }
    return injectResult;
  },
  getAutoModeEvent: function getAutoModeEvent(context, auto_mode_event, basal_record) {
    for (var _m = 0; _m < 5; _m++) {

      var autoMeal = auto_mode_event[_m];
      var autoMealFlag = [];

      for (var i = 0; i < autoMeal.length; i++) {
        var tmp = [];
        for (var j = 0; j < 24; j++) {
          tmp.push(0);
        }

        var _st5 = context.ts[i][0];
        for (var _j = 0; _j < autoMeal[i].length; _j++) {
          var hour = parseInt((autoMeal[i][_j][0] - _st5) / 3600);
          tmp[hour] = 1;
        }

        autoMealFlag.push(tmp);
      }
      context.makeOth1(autoMealFlag, 7 + _m);
    }

    var autoModeStartFlag = [];
    var autoModeExitFlag = [];
    for (var _i14 = 0; _i14 < basal_record.length; _i14++) {
      var startFlag = [];
      var exitFlag = [];
      for (var _j2 = 0; _j2 < 24; _j2++) {
        startFlag.push(0);
        exitFlag.push(0);
      }

      var _st6 = context.ts[_i14][0];
      for (var _j3 = 0; _j3 < basal_record[_i14].length; _j3++) {
        var basalType = basal_record[_i14][_j3][2];
        var _hour = parseInt((basal_record[_i14][_j3][1] - _st6) / 3600);

        if ('BAAMS' == basalType) {
          startFlag[_hour] = 1;
        } else if ('BAAME' == basalType) {
          exitFlag[_hour] = 1;
        }
      }

      autoModeStartFlag.push(startFlag);
      autoModeExitFlag.push(exitFlag);
    }
    context.makeOth1(autoModeStartFlag, 12);
    context.makeOth1(autoModeExitFlag, 13);
  },
  getPdm1: function getPdm1(context, uid, param) {
    var that = this;
    function addPreZero(pdm_sn_hex, num) {
      var pre = '';
      for (var i = 0; i < num; i++) {
        pre += '0';
      }
      return pre + pdm_sn_hex;
    }

    context.$http.get(SERVER_URL + '/v2.0/pdm/' + uid + '/settings', { params: param }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var data = res.data.settings;
        context.PDM = data.items.map(function (e, i) {
          e[1] = new Date(e[1] * 1000);
          e[1] = __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate1(e[1]);
          e[2] = that.deviceSNFormat(e[2], 'PDM');

          return e;
        });
        context.pages = data.pages;
        context.has_next = data.has_next;
        context.has_prev = data.has_prev;
        if (context.PDM.length > 0 && context.first) {
          context.index = '0';
          context.selectId = sessionStorage.getItem('rid');
          if (!context.selectId) {
            context.selectId = context.PDM[0][0];
          }
          context.tempSelectId = context.selectId;
          context.index = context.PDM.length - 1;
          context.apply();
          context.first = false;
        }
      }
    }, function (err) {
      alert(err + "," + err.body.message);
    });
  },
  getPdmSG: function getPdmSG(basalPattern) {
    var time = new Date();
    var timeBase = time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate() + ' ';
    var zero = new Date(timeBase).getTime();
    var endOfDay = new Date(timeBase + '24:00').getTime();
    var data = [];
    var len = basalPattern.length;
    if (len === 0) {
      data = [[zero, 0], [endOfDay, 0]];
    } else {
      if (basalPattern[0][0] !== "00:00") {
        data.push([zero, basalPattern[0][1]]);
      }
      for (var item in basalPattern) {
        var _time = new Date(timeBase + basalPattern[item][0]);
        data.push([_time.getTime(), basalPattern[item][1]]);
      }
      if (basalPattern[len - 1][0] !== "24:00") {
        data.push([endOfDay, basalPattern[len - 1][1]]);
      }
    }
    return data;
  },
  getRatio: function getRatio(context, val, flag) {
    var length = val.length;
    var Ratio = new Array(length),
        sumCol = 0;
    for (var i = 0; i < length - 1; i++) {
      var _st7 = val[i][0].split(':');
      var et = val[i + 1][0].split(':');
      var h = et[0] - _st7[0],
          _m2 = et[1] - _st7[1];
      var col = h * 2 + _m2 / 30;
      sumCol = sumCol + col;
      Ratio[i] = new Array(2);
      Ratio[i][0] = col;
      Ratio[i][1] = val[i][1];
    }
    Ratio[length - 1] = new Array(2);
    Ratio[length - 1][0] = 48 - sumCol;
    Ratio[length - 1][1] = val[length - 1][1];
    return Ratio;
  },
  getMaxBolus: function getMaxBolus(val) {
    var length = val.length,
        j = 0;
    var Ratio = [],
        sumCol = 0;
    if (length === 0) {
      Ratio[0] = 0;
    }
    if (length === 1) {
      var _st8 = val[0][0].split(':');
      var et = val[0][1].split(':');
      var h = et[0] - _st8[0],
          _m3 = et[1] - _st8[1];
      var col = h * 2 + _m3 / 30;
      var staCol = _st8[0] * 2 + _st8[1] / 30;
      sumCol = sumCol + col + staCol;

      Ratio[0] = [];
      Ratio[0][1] = col;
      Ratio[0][0] = _st8[0] * 2 + _st8[1] / 30;
    } else {
      for (var i = 0; i < length; i++) {
        if (i > 0 && i < length - 1 && val[i][0] === val[i + 1][0] && val[i][1] === val[i + 1][1]) {
          continue;
        }
        var _st9 = val[i][0].split(':');
        var _et = val[i][1].split(':');
        var _h = _et[0] - _st9[0],
            _m4 = _et[1] - _st9[1];
        var _col = _h * 2 + _m4 / 30;
        sumCol = sumCol + _col;
        Ratio[j] = [];
        Ratio[j][1] = _col;
        Ratio[j][0] = _st9[0] * 2 + _st9[1] / 30;
        j++;
      }
    }
    return Ratio;
  },
  getGlucoseLimit: function getGlucoseLimit(context, val) {
    var length = val.length;
    var Ratio = new Array(length),
        sumCol = 0;
    for (var i = 0; i < length - 1; i++) {
      var _st10 = val[i][0].split(':');
      var et = val[i + 1][0].split(':');
      var h = et[0] - _st10[0],
          _m5 = et[1] - _st10[1];
      var col = h * 2 + _m5 / 30;
      sumCol = sumCol + col;
      Ratio[i] = new Array(3);
      Ratio[i][0] = col;
      Ratio[i][1] = val[i][1];
      Ratio[i][2] = val[i][2];
    }
    Ratio[length - 1] = new Array(3);
    Ratio[length - 1][0] = 48 - sumCol;
    Ratio[length - 1][1] = val[length - 1][1];
    Ratio[length - 1][2] = val[length - 1][2];
    return Ratio;
  },
  getDashboard: function getDashboard(context, uid, param) {
    var that = this;
    context.$http.post('/api/v2.1/data/' + uid, param).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var data = res.data.data;
        if (data.devices) {
          context.devices = data.devices;
        }

        if (data.sg) {
          context.sg = data.sg;
          that.getDashboardSg(context, data.sg);
          that.getDashboardSgStat(context, data);
        }

        that.getDashboardBG(context, data);

        that.getDashboardMiscInfo(context, data);

        var bolus_stat_result = {};
        if (data.bolus) {
          bolus_stat_result = that.getDashboardInsulinStat(context, data);
        }
        var ins_use_duration_day = bolus_stat_result['use_duration_day'];
        var ins_use_duration_day_pre = bolus_stat_result['use_duration_day_pre'];

        that.getDashboardCarbStat(context, data, ins_use_duration_day);
        that.getDashboardExerciseStat(context, data, ins_use_duration_day);

        if (data.device_setting) {}
        if (data.device_setting) {
          var t = __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate1(new Date(data.device_setting.update_time * 1000));
          context.update_time = t + ', ' + data.device_setting.pdm_sn;
        }
        context.target_high = context.isMg ? parseInt(data.target_high * 18) : data.target_high.toFixed(1);
        context.target_low = context.isMg ? parseInt(data.target_low * 18) : data.target_low.toFixed(1);
        if (this.chart1_2) {
          this.chartsDispose();
        }
        this.drawCharts();
      }
    }, function (err) {
      this.error = err.body.message;
    });
  },
  getAvgSD: function getAvgSD(data) {
    if (!(data instanceof Array) || data.length == 0) {
      return { 'sd': 0, 'avg': 0, 'num': 0 };
    }
    var size = data.length;
    var total = 0;
    var avg = 0;

    var diffTotal = 0;
    data.map(function (e, i) {
      total += e;
    });
    avg = total / size;
    data.map(function (e, i) {
      diffTotal += Math.pow(e - avg, 2);
    });
    var sd = Math.sqrt(diffTotal / size);
    return {
      'sd': sd,
      'avg': avg,
      'num': size
    };
  },
  getInsulinVal: function getInsulinVal(ins) {
    var num = Math.round(ins / 0.05);
    return (0.05 * num).toFixed(2);
  },
  getInsulinValText: function getInsulinValText(ins) {
    if (ins < 0.00001) return '0';

    var txt = Math.round(ins * 100) / 100;
    txt = txt.toFixed(2);
    return txt;
  },
  getGlucoseValText: function getGlucoseValText(isMg, mmol_val) {
    var txt = isMg ? Math.round(mmol_val * 18) + ' mg/dL' : parseFloat(mmol_val.toFixed(1)) + ' mmol/L';
    return txt;
  },
  getGlucoseValText2: function getGlucoseValText2(isMg, mmol_val) {
    var txt = isMg ? Math.round(mmol_val * 18) + '' : parseFloat(mmol_val.toFixed(1)) + '';
    return txt;
  },
  getGlucoseSDValText: function getGlucoseSDValText(isMg, mmol_val) {
    var txt = isMg ? (mmol_val * 18).toFixed(1) + '' : parseFloat(mmol_val.toFixed(2)) + '';
    return txt;
  },
  getNumText: function getNumText(num, use_days) {
    if (num * 1.0 / use_days < 0.00001) {
      return 0 + '';
    }

    if (num % use_days) {
      return (num * 1.0 / use_days).toFixed(1);
    } else {
      return Math.round(num * 1.0 / use_days);
    }
  },
  getNumText3: function getNumText3(num, use_days, digit) {
    if (num % use_days) {
      return (num * 1.0 / use_days).toFixed(digit);
    } else {
      return Math.round(num * 1.0 / use_days);
    }
  },
  getMinuteText: function getMinuteText(minutes, use_days, digit) {
    var avg_minute = Math.round(minutes / use_days);
    if (avg_minute < 60) {
      return {
        'minute': avg_minute,
        'hour': 0
      };
    } else {
      var h = Math.floor(avg_minute / 60);
      var _m6 = avg_minute % 60;
      return {
        'minute': _m6,
        'hour': h
      };
    }
  },
  getNumText2: function getNumText2(num, use_days) {
    return Math.round(num * 1.0 / use_days);
  },
  getDashboardMiscInfo: function getDashboardMiscInfo(context, data) {
    context.highLevelText = this.getGlucoseValText(context.isMg, data.target_high);
    context.lowLevelText = this.getGlucoseValText(context.isMg, data.target_low);
  },
  getDashboardBG: function getDashboardBG(context, data) {
    var bg_day_data = [];
    var bg_data = [];
    var calib = data.calib;
    var bolus = data.bolus;
    var event = data.event;
    var use_days = 0;
    var calib_day_data = [];
    var calib_use_days = 0;
    var calib_data = [];

    if (calib) {
      calib.map(function (d, n) {
        bg_day_data.push([]);
        calib_day_data.push([]);
      });
      calib.map(function (d, n) {
        if (d.length > 0) {
          d.map(function (e, i) {
            bg_day_data[n].push(e[1]);
            bg_data.push(e[1]);

            calib_day_data[n].push(e[1]);
            calib_data.push(e[1]);
          });
        }
      });
    } else {
      return;
    }

    if (bolus) {
      bolus.map(function (d, n) {
        if (d.length > 0) {
          d.map(function (e, i) {
            if (e[8] && e[8].length > 0) {
              var w = JSON.parse(e[8]);
              if (w.bg) {
                bg_day_data[n].push(w.bg);
                bg_data.push(w.bg);
              }
            }
          });
        }
      });
    }

    if (event) {
      event.map(function (d, n) {
        if (d.length > 0) {
          d.map(function (e, i) {
            if ('BG' == e[2]) {
              var content = e[3];
              if (content.value) {
                var bg_value = content.value;

                bg_value = bg_value / 18.0;

                bg_day_data[n].push(bg_value);
                bg_data.push(bg_value);
              }
            }
          });
        }
      });
    }

    bg_day_data.map(function (d, n) {
      if (d.length > 0) {
        use_days += 1;
      }
    });

    calib_day_data.map(function (d, n) {
      if (d.length > 0) {
        calib_use_days += 1;
      }
    });

    var result = this.getAvgSD(bg_data);
    result.use_days = use_days;
    if (result.num && result.use_days) {
      context.bgAvg = this.getGlucoseValText2(context.isMg, result.avg);
      context.bgSD = this.getGlucoseSDValText(context.isMg, result.sd);
      context.bgPerDay = this.getNumText(result.num, result.use_days);
      context.bgNum = result.num;

      context.calibPerDay = this.getNumText(calib_data.length, calib_use_days);
    } else {
      context.bgAvg = '--';
      context.bgSD = '--';
      context.bgPerDay = '--';
      context.bgNum = '--';
      context.calibPerDay = '--';
    }
  },
  truncateBasal: function truncateBasal(basal, ts) {
    basal.map(function (d, n) {
      var size = d.length;
      if (size > 0) {
        var first = d[0];
        var last = d[size - 1];

        var t = first[1];
        var duration = first[3];
        var inject = first[5];
        if (t < ts[n][0]) {
          first[1] = ts[n][0];
          first[3] = duration - (ts[n][0] - t);
          first[5] = inject * 1.0 * first[3] / duration;
        }

        t = last[1];
        duration = last[3];
        inject = last[5];

        if (t + duration > ts[n][1]) {
          last[3] = ts[n][1] - t;
          last[5] = inject * 1.0 * first[3] / duration;
        }
      }
    });
    return basal;
  },
  getDashboardCarbStat: function getDashboardCarbStat(context, data, ins_use_duration_day) {
    var carb_day_data = [];
    var carb_data = [];
    var carb_total = 0;
    var use_days = 0;
    var event = data.event;
    var bolus = data.bolus;


    event.map(function (e, i) {
      carb_day_data.push([]);
    });

    if (event) {
      event.map(function (d, n) {
        if (d.length > 0) {
          d.map(function (e, i) {
            if ('CARB' == e[2]) {
              var content = e[3];
              if (content.value) {
                carb_day_data[n].push(content.value);
                carb_data.push(content.value);
              }
            }
          });
        }
      });
    } else {
      return;
    }

    if (bolus) {
      bolus.map(function (d, n) {
        if (d.length > 0) {
          d.map(function (e, i) {
            var recordId = e[0];
            var recordIdSplit = recordId.split('-');
            var recordSeq = recordIdSplit[3];
            try {
              if (recordSeq >= 8888) {
                return;
              }
            } catch (e) {}
            if (e[8] && e[8].length > 0) {
              var w = JSON.parse(e[8]);
              if (w.carb) {
                carb_day_data[n].push(w.carb);
                carb_data.push(w.carb);
              }
            }
          });
        }
      });
    }

    carb_data = [];
    ins_use_duration_day.map(function (ins_day_use, n) {
      if (ins_day_use > 23.5 * 3600) {
        use_days += 1;

        carb_data = carb_data.concat(carb_day_data[n]);
      } else {}
    });

    carb_data.map(function (d, n) {
      carb_total += d;
    });

    if (carb_data.length) {
      var result = this.getAvgSD(carb_data);
      if (result.num) {
        context.carbSD = result.sd.toFixed(1);

        context.carbNum = result.num;
        context.carbAvg = this.getNumText3(carb_total, use_days, 1);
      }
    }
  },
  getDashboardExerciseStat: function getDashboardExerciseStat(context, data, ins_use_duration_day) {
    var exercise_day_data = [];
    var exercise_data = [];
    var exercise_total = 0;
    var use_days = 0;
    var event = data.event;


    event.map(function (e, i) {
      exercise_day_data.push([]);
    });

    if (event) {
      event.map(function (d, n) {
        if (d.length > 0) {
          d.map(function (e, i) {
            if ('EXR' == e[2] || 'AutoExercise' == e[2]) {
              var content = e[3];
              if (content.value) {
                exercise_day_data[n].push(content.value);
                exercise_data.push(content.value);
              } else if (content.duration) {
                exercise_day_data[n].push(content.duration);
                exercise_data.push(content.duration);
              }
            }
          });
        }
      });
    } else {
      return;
    }

    exercise_data = [];
    ins_use_duration_day.map(function (ins_day_use, n) {
      if (ins_day_use > 0) {
        use_days += 1;
        exercise_data = exercise_data.concat(exercise_day_data[n]);
      }
    });

    exercise_data.map(function (d, n) {
      exercise_total += d;
    });

    if (exercise_data.length) {
      var result = this.getAvgSD(exercise_data);
      if (result.num) {
        context.exerSD = result.sd.toFixed(1);

        context.exerNum = result.num;
        var exerAvgRes = this.getMinuteText(exercise_total, use_days, 1);
        context.exerAvg = exerAvgRes['minute'];
        context.exerAvgHour = exerAvgRes['hour'];
      }
    }
  },
  getDashboardInsulinStat: function getDashboardInsulinStat(context, data) {
    var basal = this.truncateBasal(data.basal, context.ts);
    var ins_unit2 = context.$t('ins_unit2');
    var insulin_data = [];
    var insulinUsage = [];
    var use_days = 0;
    var use_duration_day = [];
    var use_duration_day_pre = [];
    var use_duration = 0;
    var basal_total = 0;
    var auto_basal_total = 0;
    var auto_bolus_total = 0;
    var bolus_total = 0;
    var basalUsage = [];
    var bolusUsage = [];

    var usePatchInfo = {};
    var usePatchNum = 0;

    var inject_total = 0;
    var bolus_num = 0;
    var suspend_duration = 0;
    var manual_bolus = 0;
    var manual_bolus_num = 0;
    var manual_normal_bolus = 0;
    var manual_normal_bolus_num = 0;
    var manual_extend_bolus = 0;
    var manual_extend_bolus_num = 0;
    var manual_combo_bolus = 0;
    var manual_combo_bolus_num = 0;
    var wizzard_bolus = 0;
    var wizzard_bolus_num = 0;
    var food_wizzard_bolus = 0;
    var food_wizzard_bolus_num = 0;
    var corr_wizzard_bolus = 0;
    var corr_wizzard_bolus_num = 0;
    var wizzard_override_add = 0;
    var wizzard_override_add_num = 0;
    var wizzard_override_sub = 0;
    var wizzard_override_sub_num = 0;

    function getBolusWizzardSuggest(wizzard, fromPDM) {
      var iob = wizzard.iob;
      var carb_bolus = 0;
      var bg_bolus = 0;

      if (false) {
        carb_bolus = wizzard.carb_bolus;
        bg_bolus = wizzard.bg_bolus;
      } else {
        carb_bolus = wizzard.bg_bolus;
        bg_bolus = wizzard.carb_bolus;
      }
      if (bg_bolus > 400) {
        bg_bolus = -(655.36 - bg_bolus);
      }

      if (bg_bolus > 0) {
        if (bg_bolus < iob) {
          return carb_bolus;
        } else {
          return carb_bolus + bg_bolus - iob;
        }
      } else if (bg_bolus < 0) {
        return carb_bolus + bg_bolus;
      } else {
        return carb_bolus;
      }

      return carb_bolus + bg_bolus - iob;
    }

    data.basal.map(function (d, n) {
      insulinUsage.push(0);
      insulin_data.push([]);
      basalUsage.push(0);
      bolusUsage.push(0);
      use_duration_day.push(0);
      use_duration_day_pre.push(0);
    });

    data.basal.map(function (d, n) {
      if (d.length) {
        d.map(function (e, i) {
          use_duration_day_pre[n] += e[3];
        });
      }
    });

    var notAllowType = ['BAAMS', 'BAAME', 'BAAMBreakfast', 'BAAMLunch', 'BAAMDinner', 'BAAMSnack', 'BAAMExerciseStart', 'BAAMExerciseExit'];
    data.basal.map(function (d, n) {
      if (d.length) {
        use_days += 1;
        d.map(function (e, i) {
          var recordId = e[0];
          var basalType = e[2];
          var recordIdPart = recordId.split('-');
          if ('9999' == recordIdPart[3] || '65535' == recordIdPart[3]) {
            return;
          }
          if ('BAAM' === basalType) {
            var autoModeData = e[7];
            use_duration_day[n] += e[3];
            use_duration += e[3];
            try {
              if (autoModeData) {
                autoModeData = JSON.parse(autoModeData);
                var microBolusJson = autoModeData['autoModeJSON'];
                var cur_auto_basal_total = 0;
                var cur_auto_bolus_total = 0;

                microBolusJson.map(function (e, i) {
                  cur_auto_basal_total += e['auto_basal_delivery'];
                  cur_auto_bolus_total += e['auto_food_delivery'] + e['auto_corr_delivery'];
                });

                insulin_data[n].push(cur_auto_basal_total * 0.05 + cur_auto_bolus_total * 0.05);
                insulinUsage[n] += cur_auto_basal_total * 0.05 + cur_auto_bolus_total * 0.05;
                auto_basal_total += cur_auto_basal_total * 0.05;
                auto_bolus_total += cur_auto_bolus_total * 0.05;
                basalUsage[n] += cur_auto_basal_total * 0.05;
                bolusUsage[n] += cur_auto_bolus_total * 0.05;
              }
            } catch (e) {
              console.log('auto mode json error:', e);
            }
          } else if (!notAllowType.includes(basalType)) {
            insulin_data[n].push(e[5]);
            insulinUsage[n] += e[5];
            basal_total += e[5];
            basalUsage[n] += e[5];
            use_duration_day[n] += e[3];
            use_duration += e[3];
          }
          var patchId = recordIdPart[1] + '-' + recordIdPart[2];
          if (usePatchInfo[patchId]) {} else {
            usePatchInfo[patchId] = 1;
            usePatchNum += 1;
          }

          if (0 == e[2].indexOf('SUS')) {
            suspend_duration += e[3];
          }
        });
      }
    });
    data.bolus.map(function (d, n) {
      if (d.length && use_duration_day[n] > 23.5 * 86400 / 24.0) {
        d.map(function (e, i) {
          var recordId = e[0];
          var recordIdSplit = recordId.split('-');
          if (recordIdSplit[3] >= 8888) {
            return;
          }

          insulin_data[n].push(e[4] + e[6]);
          insulinUsage[n] += e[4] + e[6];
          bolus_total += e[4] + e[6];
          bolusUsage[n] += e[4] + e[6];

          bolus_num += 1;

          var bolusType = e[2];
          var bolusInject = e[4] + e[6];
          var bolusSet = e[3] + e[5];
          var wizzard = e[8];

          if (bolusType.indexOf('M') >= 0) {
            manual_bolus += bolusInject;
            manual_bolus_num += 1;
            if (0 == bolusType.indexOf('NB')) {
              manual_normal_bolus += bolusInject;
              manual_normal_bolus_num += 1;
            } else if (0 == bolusType.indexOf('EB')) {
              manual_extend_bolus += bolusInject;
              manual_extend_bolus_num += 1;
            } else if (0 == bolusType.indexOf('CB')) {
              manual_combo_bolus += bolusInject;
              manual_combo_bolus_num += 1;
            }
          }

          if (bolusType.indexOf('W') >= 0) {
            wizzard_bolus += bolusInject;
            wizzard_bolus_num += 1;

            if (bolusType.indexOf('CCW') >= 0 || bolusType.indexOf('CAW') >= 0) {
              food_wizzard_bolus += bolusInject;
              food_wizzard_bolus_num += 1;
            } else if (bolusType.indexOf('CRW') >= 0) {
              corr_wizzard_bolus += bolusInject;
              corr_wizzard_bolus_num += 1;
            }

            if (wizzard && wizzard.length > 0) {
              wizzard = JSON.parse(wizzard);
              var suggest_bolus = getBolusWizzardSuggest(wizzard);
              if (bolusSet > suggest_bolus) {
                wizzard_override_add += bolusSet - suggest_bolus;
                wizzard_override_add_num += 1;
              } else if (bolusSet < suggest_bolus) {
                wizzard_override_sub += suggest_bolus - bolusSet;
                wizzard_override_sub_num += 1;
              }
            }
          }
        });
      }
    });

    if (data.event) {
      data.event.map(function (d, n) {
        if (d.length > 0) {
          d.map(function (e, i) {
            if ('INS' == e[2]) {
              var content = e[3];
              if (content.value) {
                insulin_data[n].push(content.value);
              }
            }
          });
        }
      });
    }

    var insulinUsage2 = [];

    basal_total = 0;
    bolus_total = 0;

    insulin_data.map(function (d, n) {
      if (use_duration_day[n] > 23.5 * 86400 / 24.0) {
        var dayTotal = 0;
        d.map(function (e, i) {
          dayTotal += e;
        });
        insulinUsage2.push(dayTotal);

        basal_total += basalUsage[n];
        bolus_total += bolusUsage[n];
      }
    });
    use_days = insulinUsage2.length;
    basal_total = Math.round(basal_total * 1000000) / 1000000;

    var result = this.getAvgSD(insulinUsage2);
    result.use_days = use_days;
    if (result.num && result.use_days) {
      context.insAvg = this.getInsulinValText(result.avg);
      context.insSD = this.getInsulinValText(result.sd);

      context.insNum = use_days.toFixed(1);
      context.patchAvgLife = (use_duration / 86400.0 / usePatchNum).toFixed(2);
      context.avgBolusNum = this.getNumText3(bolus_num, result.use_days, 1);

      inject_total = basal_total + bolus_total;
      if (inject_total) {
        var basalPercent = (basal_total * 100 / inject_total).toFixed(1);
        context.basalPercent = this.getInsulinValText(basal_total / use_days) + 'U/' + basalPercent + ' %';
        context.bolusPercent = this.getInsulinValText(bolus_total / use_days) + 'U/' + (100 - basalPercent).toFixed(1) + ' %';
      }
      context.insPieData = [{ value: Math.round(bolus_total / use_days * 100) / 100, name: context.$t('t1103_Bolus') }, { value: Math.round(basal_total / use_days * 100) / 100, name: context.$t('t1103_Basal') }];

      if (bolus_total + basal_total) {
        context.chart6NoData = false;
        context.chart7NoData = false;
      } else {
        context.chart6NoData = true;
        context.chart7NoData = true;
      }
      var avgSuspendTime = suspend_duration / result.use_days;
      if (avgSuspendTime < 3600) {
        context.avgSuspendTime = Math.round(avgSuspendTime % 3600 / 60) + ' min';
      } else {
        context.avgSuspendTime = Math.floor(avgSuspendTime / 3600) + ' h ' + Math.round(avgSuspendTime % 3600 / 60) + ' min';
      }

      context.avgManualBolus = this.getInsulinValText(manual_bolus / use_days) + ins_unit2 + '/' + this.getNumText(manual_bolus_num, use_days);
      context.avgManualNormalBolus = this.getInsulinValText(manual_normal_bolus / use_days) + ins_unit2 + '/' + this.getNumText(manual_normal_bolus_num, use_days);
      context.avgManualExtendBolus = this.getInsulinValText(manual_extend_bolus / use_days) + ins_unit2 + '/' + this.getNumText(manual_extend_bolus_num, use_days);
      context.avgManualComboBolus = this.getInsulinValText(manual_combo_bolus / use_days) + ins_unit2 + '/' + this.getNumText(manual_combo_bolus_num, use_days);

      context.avgWizzardBolus = this.getInsulinValText(wizzard_bolus / use_days) + ins_unit2 + '/' + this.getNumText3(wizzard_bolus_num, use_days, 1);
      context.avgFoodWizzardBolus = this.getInsulinValText(food_wizzard_bolus / use_days) + ins_unit2 + '/' + this.getNumText3(food_wizzard_bolus_num, use_days, 1);
      context.avgCorrWizzardBolus = this.getInsulinValText(corr_wizzard_bolus / use_days) + ins_unit2 + '/' + this.getNumText3(corr_wizzard_bolus_num, use_days, 1);
      context.avgWizzardOverrideAdd = this.getInsulinValText(wizzard_override_add / use_days) + ins_unit2 + '/' + this.getNumText3(wizzard_override_add_num, use_days, 2);
      context.avgWizzardOverrideSub = this.getInsulinValText(wizzard_override_sub / use_days) + ins_unit2 + '/' + this.getNumText3(wizzard_override_sub_num, use_days, 2);
    } else {
      context.chart6NoData = true;
    }

    var autoModeTime = 0;
    var autoModeTimeSection = [];
    var dayNum = use_days;
    var autoModeInject = [];
    var autoModeBasalInject = 0;
    var autoModeBolusInject = 0;

    for (var d = 0; d < data.basal.length; d++) {
      var autoModeBasalTotal = 0;
      var autoModeBolusTotal = 0;
      var time = 0;
      var time2 = 0;

      for (var j = 0; j < data.basal[d].length; j++) {
        var basalRecord = data.basal[d][j];
        var recordIdPart = basalRecord[0].split('-');
        if ('9999' != recordIdPart[3] && '65535' != recordIdPart[3] && !notAllowType.includes(data.basal[d][j][2])) {
          time += data.basal[d][j][3];
        }
      }
      for (var i = 0; i < data.basal[d].length; i++) {
        var basalType = data.basal[d][i][2];
        var _basalRecord = data.basal[d][i];
        var _recordIdPart = _basalRecord[0].split('-');

        if ('BAAM' === basalType && time > 23.5 * 86400 / 24.0 && '9999' != _recordIdPart[3] && '65535' != _recordIdPart[3]) {
          autoModeTime += _basalRecord[3];
          if (autoModeTimeSection.length > 0) {
            var lastRecord = autoModeTimeSection[autoModeTimeSection.length - 1];

            if (_basalRecord[1] > lastRecord[1]) {
              autoModeTimeSection.push([_basalRecord[1], _basalRecord[1] + _basalRecord[3]]);
            } else if (_basalRecord[1] == lastRecord[1]) {
              lastRecord[1] = _basalRecord[1] + _basalRecord[3];
            }
          } else {
            autoModeTimeSection.push([_basalRecord[1], _basalRecord[1] + _basalRecord[3]]);
          }

          var autoModeData = _basalRecord[7];
          try {
            if (autoModeData) {
              autoModeData = JSON.parse(autoModeData);
              var microBolusJson = autoModeData['autoModeJSON'];
              microBolusJson.map(function (e, i) {
                autoModeBasalTotal += e['auto_basal_delivery'];
                autoModeBolusTotal += e['auto_food_delivery'] + e['auto_corr_delivery'];
              });
            }
          } catch (e) {
            console.log('autoModeData error:', e, _basalRecord[7]);
          }
        }
      }
      autoModeInject.push([autoModeBasalTotal * 0.05, autoModeBolusTotal * 0.05]);
      autoModeBasalInject += autoModeBasalTotal * 0.05;
      autoModeBolusInject += autoModeBolusTotal * 0.05;
    }

    if (dayNum) {
      context.autoModeBasalPerDay = this.getInsulinValText(autoModeBasalInject / dayNum) + context.$t('ins_unit2');
      context.autoModeBolusPerDay = this.getInsulinValText(autoModeBolusInject / dayNum) + context.$t('ins_unit2');
    } else {
      context.autoModeBasalPerDay = '--';
      context.autoModeBolusPerDay = '--';
    }

    var autoModeSGTargetHigh = 180 / 18.0;
    var autoModeSGTargetLow = 70 / 18.0;
    var autoModeSG = [];
    var notAutoModeSG = [];
    var autoModeSGInTarget = [];
    var autoModeSGAboveTarget = [];
    var autoModeSGBelowTarget = [];
    for (var _d = 0; _d < data.sg.length; _d++) {
      for (var _i15 = 0; _i15 < data.sg[_d].length; _i15++) {
        var sgRecord = data.sg[_d][_i15];
        var sgState = sgRecord[4];
        var sgValue = sgRecord[3];
        var sgTime = sgRecord[1];
        if ('CX' == sgState || 'C' == sgState || 'NC' == sgState) {
          if (sgValue > 0.000001) {
            var sgInAutoMode = false;
            for (var s = 0; s < autoModeTimeSection.length; s++) {
              if (sgTime >= autoModeTimeSection[s][0] && sgTime <= autoModeTimeSection[s][1]) {
                sgInAutoMode = true;
                break;
              }
            }
            if (sgInAutoMode) {
              autoModeSG.push(sgValue);
              if (sgValue >= autoModeSGTargetHigh) {
                autoModeSGAboveTarget.push(sgValue);
              } else if (sgValue < autoModeSGTargetLow) {
                autoModeSGBelowTarget.push(sgValue);
              } else {
                autoModeSGInTarget.push(sgValue);
              }
            } else {
              notAutoModeSG.push(sgValue);
            }
          }
        }
      }
    }
    var statResult = this.getAvgSD(autoModeSG);
    if (statResult.num) {
      context.autoModeSGAvgSD = this.getGlucoseValText2(context.isMg, statResult.avg) + ' ± ' + this.getGlucoseSDValText(context.isMg, statResult.sd);
      var highPercent = parseInt((autoModeSGAboveTarget.length * 100.0 / autoModeSG.length).toFixed());
      var lowPercent = parseInt((autoModeSGBelowTarget.length * 100.0 / autoModeSG.length).toFixed());
      var inRangePercent = 100 - highPercent - lowPercent;
      context.autoModeSGInTargetRange = inRangePercent + '%';
      context.autoModeSGAboveRange = highPercent + '%';
      context.autoModeSGBelowRange = lowPercent + '%';

      context.autoModeSGDistPie = {
        'legendData': ['high', 'target', 'low'],
        'selected': { 'low': true, 'target': true, 'high': true },
        'seriesData': [{ name: 'high', value: autoModeSGAboveTarget.length }, { name: 'target', value: autoModeSGInTarget.length }, { name: 'low', value: autoModeSGBelowTarget.length }],
        'dataNum': autoModeSGAboveTarget.length + autoModeSGInTarget.length + autoModeSGBelowTarget.length
      };
    }

    if (dayNum) {
      context.timeInAutoMode = (autoModeTime * 100.0 / (dayNum * 3600 * 24)).toFixed() + '%';
    } else {
      context.timeInAutoMode = '--';
    }

    return {
      'use_duration_day': use_duration_day,
      'use_duration_day_pre': use_duration_day_pre
    };
  },
  getDashboardSgStat: function getDashboardSgStat(context, data) {
    var sg_day_data = [];
    var sg_data = [];
    var use_days = 0;
    var sg_day = data.sg;
    var sgMax = 0;
    var sgMin = 100;
    var hypoNum = 0;
    var lowNum = 0;
    var targetNum = 0;
    var highNum = 0;
    var target_low = data.target_low;
    var target_high = data.target_high;

    var daySelectSpan = sg_day.length;

    sg_day.map(function (d, n) {
      sg_day_data.push([]);
    });

    sg_day.map(function (d, n) {
      if (d.length > 0) {
        use_days += 1;
        d.map(function (e, i) {
          if (e[4] == 'C' || (e[4] == 'NC' || e[4] == 'CX') && e[3] > 0.00001) {
            var val = e[3];
            val = val > 22.2 ? 22.2 : val;
            val = val < 2.2 ? 2.2 : val;
            sg_day_data[n].push(val);
            sg_data.push(val);
            if (val > sgMax) {
              sgMax = val;
            }
            if (val < sgMin) {
              sgMin = val;
            }
            if (val <= 3.1) {
              hypoNum += 1;
            } else if (val > 3.1 && val < target_low) {
              lowNum += 1;
            } else if (val >= target_low && val <= target_high) {
              targetNum += 1;
            } else if (val > target_high) {
              highNum += 1;
            }
          }
        });
      }
    });

    var result = this.getAvgSD(sg_data);
    result.use_days = use_days;
    if (result.num && result.use_days) {
      context.sgAvg = this.getGlucoseValText2(context.isMg, result.avg);
      context.sgSD = this.getGlucoseSDValText(context.isMg, result.sd);
      context.sgNum = this.getNumText2(result.num, 1);

      context.est_a1c = ((result.avg * 18 + 46.7) / 28.7).toFixed(1) + '%';
      if (result.num > daySelectSpan * 720 * 0.8) {
        context.a1c_available = true;
      }

      var aucu = 0;
      var aucl = 0;
      sg_data.map(function (e, i) {
        if (e > data.target_high) {
          aucu += e - data.target_high;
        }
        if (e < data.target_low) {
          aucl += data.target_low - e;
        }
      });
      context.aucu = this.getGlucoseValText2(context.isMg, aucu / (720 * use_days));
      context.aucl = this.getGlucoseValText2(context.isMg, aucl / (720 * use_days));
      context.sgHighest = this.getGlucoseValText(context.isMg, sgMax);
      context.sgLowest = this.getGlucoseValText(context.isMg, sgMin);

      context.sgDistPie = {
        'legendData': ['high', 'target', 'low', 'hypo'],
        'selected': { 'hypo': true, 'low': true, 'target': true, 'high': true },
        'seriesData': [{ name: 'high', value: highNum }, { name: 'target', value: targetNum }, { name: 'low', value: lowNum }, { name: 'hypo', value: hypoNum }],
        'dataNum': highNum + targetNum + lowNum + hypoNum
      };

      var hypoRangeLabel = '< ' + this.getGlucoseValText(context.isMg, 3.1);
      var lowRangeLabel = this.getGlucoseValText2(context.isMg, 3.1) + ' - ' + this.getGlucoseValText(context.isMg, target_low);
      var targetRangeLabel = this.getGlucoseValText2(context.isMg, target_low) + ' - ' + this.getGlucoseValText(context.isMg, target_high);
      var highRangeLabel = '> ' + this.getGlucoseValText(context.isMg, target_high);

      context.sgDistPieLabels = [hypoRangeLabel, lowRangeLabel, targetRangeLabel, highRangeLabel];
    } else {
      context.sgAvg = '--';
      context.sgSD = '--';
      context.sgNum = '--';
    }
  },
  getDashboardSg: function getDashboardSg(context, val) {

    var that = this;
    var sg1 = new Array(144),
        sg2 = new Array(144),
        length1 = val.length,
        sgHalf = new Array(144);
    for (var i = 0; i < 144; i++) {
      sg1[i] = [];
      sg2[i] = [];
    }

    var _loop6 = function _loop6(_i16) {
      var length2 = val[_i16].length,
          st = context.ts[_i16][0];
      if (length2 > 0) {
        val[_i16].map(function (e, i) {
          if ((e[4] === 'C' || e[4] === 'CX' || e[4] === 'NC') && e[3] > 0.0001 && e[1] >= st) {
            var count = Math.floor(parseInt(e[1] - st) / 600);
            if (count >= 144 || count < 0) return;
            e[3] = e[3] > 22.2 ? 22.2 : e[3];
            e[3] = e[3] < 2.2 ? 2.2 : e[3];
            sg1[count].push(e[3]);
          }
        });
      }
    };

    for (var _i16 = 0; _i16 < length1; _i16++) {
      _loop6(_i16);
    }

    sg1.map(function (e, i) {
      if (e.length > 0) {
        e.sort(that.compare);
        var length3 = e.length;
        var d1 = Math.floor(0.1 * length3);
        var d2 = Math.floor(0.25 * length3);
        var d3 = Math.floor(0.5 * length3);
        var d4 = Math.floor(0.75 * length3);
        var d5 = Math.floor(0.9 * length3);
        sg2[i].push(e[0]);
        sg2[i].push(e[d1]);
        sg2[i].push(e[d2]);
        sg2[i].push(e[d3]);
        sg2[i].push(e[d4]);
        sg2[i].push(e[d5]);
        sg2[i].push(e[length3 - 1]);
        sgHalf[i] = context.isMg ? Math.round(e[d3] * 18) : parseFloat(e[d3].toFixed(1));
      }
    });

    var YDataMin = new Array(144);
    var YData10P = new Array(144);
    var YDataQ1 = new Array(144);
    var YDataMed = new Array(144);
    var YDataQ3 = new Array(144);
    var YData90P = new Array(144);
    var YDataMax = new Array(144);
    var sel_time = new Date(2019, 0, 1).getTime();

    var sg3 = sg2.map(function (e, i) {
      if (e && e.length > 0) {
        var d0 = context.isMg ? Math.round(e[0] * 18) : parseFloat(e[0].toFixed(1));
        var d1 = context.isMg ? Math.round((e[1] - e[0]) * 18) : parseFloat((e[1] - e[0]).toFixed(1));
        var d2 = context.isMg ? Math.round((e[2] - e[1]) * 18) : parseFloat((e[2] - e[1]).toFixed(1));
        var d3 = context.isMg ? Math.round((e[3] - e[2]) * 18) : parseFloat((e[3] - e[2]).toFixed(1));
        var d4 = context.isMg ? Math.round((e[4] - e[3]) * 18) : parseFloat((e[4] - e[3]).toFixed(1));
        var d5 = context.isMg ? Math.round((e[5] - e[4]) * 18) : parseFloat((e[5] - e[4]).toFixed(1));
        var d6 = context.isMg ? Math.round((e[6] - e[5]) * 18) : parseFloat((e[6] - e[5]).toFixed(1));

        var v0 = context.isMg ? Math.round(e[0] * 18) : parseFloat(e[0].toFixed(1));
        var v1 = context.isMg ? Math.round(e[1] * 18) : parseFloat(e[1].toFixed(1));
        var v2 = context.isMg ? Math.round(e[2] * 18) : parseFloat(e[2].toFixed(1));
        var v3 = context.isMg ? Math.round(e[3] * 18) : parseFloat(e[3].toFixed(1));
        var v4 = context.isMg ? Math.round(e[4] * 18) : parseFloat(e[4].toFixed(1));
        var v5 = context.isMg ? Math.round(e[5] * 18) : parseFloat(e[5].toFixed(1));
        var v6 = context.isMg ? Math.round(e[6] * 18) : parseFloat(e[6].toFixed(1));

        YDataMin[i] = [sel_time + i * 10 * 60 * 1000 + 5 * 60 * 1000, d0, v0];
        YData10P[i] = [sel_time + i * 10 * 60 * 1000 + 5 * 60 * 1000, d1, v1];
        YDataQ1[i] = [sel_time + i * 10 * 60 * 1000 + 5 * 60 * 1000, d2, v2];
        YDataMed[i] = [sel_time + i * 10 * 60 * 1000 + 5 * 60 * 1000, d3, v3];
        YDataQ3[i] = [sel_time + i * 10 * 60 * 1000 + 5 * 60 * 1000, d4, v4];
        YData90P[i] = [sel_time + i * 10 * 60 * 1000 + 5 * 60 * 1000, d5, v5];
        YDataMax[i] = [sel_time + i * 10 * 60 * 1000 + 5 * 60 * 1000, d6, v6];

        return [d0, d1, d2, d3, d4, d5, d6];
      }
    });

    context.YDataMin = YDataMin;
    context.YData10P = YData10P;
    context.YDataQ1 = YDataQ1;
    context.YDataMed = YDataMed;
    context.YDataQ3 = YDataQ3;
    context.YData90P = YData90P;
    context.YDataMax = YDataMax;
  },
  getSegment: function getSegment(context, uid, param) {
    var that = this;
    context.$http.post('/api/v2.1/data/' + uid, param).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var data = res.data.data;
        if (data.sg) {
          context.sg = data.sg;
          that.getSegmentSg(context, data.sg);
        }
        if (data.bolus) {
          that.getSegmentBolus(context, data.bolus, data.event);
        }
        if (data.device_setting) {
          that.getSegmentBasal(context, data.device_setting.basal_pattern.seg);
        }
        if (data.device_setting) {
          var t = __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate1(new Date(data.device_setting.update_time * 1000));
          context.update_time = t + ', ' + data.device_setting.pdm_sn;
        }
        context.target_high = context.isMg ? parseInt(data.target_high * 18) : data.target_high.toFixed(1);
        context.target_low = context.isMg ? parseInt(data.target_low * 18) : data.target_low.toFixed(1);
        if (this.chart1_2) {
          this.chartsDispose();
        }
        this.drawCharts();
      }
    }, function (err) {
      this.error = err.body.message;
    });
  },
  getSegmentSg: function getSegmentSg(context, val) {
    var that = this;
    var sg1 = new Array(48),
        sg2 = new Array(48),
        length1 = val.length,
        sgHalf = new Array(48);
    for (var i = 0; i < 48; i++) {
      sg1[i] = [];
      sg2[i] = [];
    }

    var _loop7 = function _loop7(_i17) {
      var length2 = val[_i17].length,
          st = context.ts[_i17][0];
      if (length2 > 0) {
        val[_i17].map(function (e, i) {
          if (e[4] === 'C' && e[1] >= st) {
            var count = Math.floor(parseInt(e[1] - st) / 1800);
            e[3] = e[3] > 22.2 ? 22.2 : e[3];
            e[3] = e[3] < 2.2 ? 2.2 : e[3];
            sg1[count].push(e[3]);
          }
        });
      }
    };

    for (var _i17 = 0; _i17 < length1; _i17++) {
      _loop7(_i17);
    }

    sg1.map(function (e, i) {
      if (e.length > 0) {
        e.sort(that.compare);
        var length3 = e.length;
        var d1 = Math.floor(0.1 * length3);
        var d2 = Math.floor(0.25 * length3);
        var d3 = Math.floor(0.5 * length3);
        var d4 = Math.floor(0.75 * length3);
        var d5 = Math.floor(0.9 * length3);
        sg2[i].push(e[d1]);
        sg2[i].push(e[d2]);
        sg2[i].push(e[d3]);
        sg2[i].push(e[d4]);
        sg2[i].push(e[d5]);
        sgHalf[i] = context.isMg ? Math.round(e[d3] * 18) : parseFloat(e[d3].toFixed(1));
      }
    });

    var newSg1 = new Array(4);
    for (var _i18 = 0; _i18 < 4; _i18++) {
      newSg1[_i18] = [];
    }
    sg2.map(function (e, i) {
      if (e.length > 0) {
        var d0 = context.isMg ? Math.round(e[0] * 18) : parseFloat(e[0].toFixed(1));
        var d1 = context.isMg ? Math.round((e[1] - e[0]) * 18) : parseFloat((e[1] - e[0]).toFixed(1));
        var d2 = context.isMg ? Math.round((e[3] - e[1]) * 18) : parseFloat((e[3] - e[1]).toFixed(1));
        var d3 = context.isMg ? Math.round((e[4] - e[3]) * 18) : parseFloat((e[4] - e[3]).toFixed(1));
        newSg1[0][i] = d0;
        newSg1[1][i] = d1;
        newSg1[2][i] = d2;
        newSg1[3][i] = d3;
      }
    });
    context.sg1 = newSg1;
    context.sgHalf = sgHalf;
  },
  getSegmentBolus: function getSegmentBolus(context, val, val2) {
    var that = this;
    var bolus1 = new Array(48),
        bolus2 = new Array(48),
        length1 = val.length,
        length3 = val2.length,
        countArray = new Array(48),
        maxGroup = [];
    for (var i = 0; i < 48; i++) {
      bolus1[i] = [];
      bolus2[i] = new Array(5);
      countArray[i] = 0;
    }

    var _loop8 = function _loop8(_i19) {
      var length2 = val[_i19].length,
          st = context.ts[_i19][0];
      if (length2 > 0) {
        val[_i19].map(function (e, i) {
          if (e[2] === 'EBCCW' || e[2] === 'EBM' || e[2] === 'EBCAW') {
            if (e[1] >= st) {
              var _k10 = Math.floor(parseInt(e[1] - st) / 1800);
              var end = e[1] + e[7] * 60;
              var half = st + (_k10 + 1) * 1800;
              var value = e[6];

              if (end > half) {
                value = (half - e[1]) / (e[7] * 60) * e[6];
                if (_k10 + 1 < 48) {
                  bolus1[_k10 + 1].push(e[6] - value);
                }
              }
              bolus1[_k10].push(value);
              countArray[_k10]++;
            }
          } else if (e[2] === 'CBCCW' || e[2] === 'CBM' || e[2] === 'CBCAW') {
            if (e[1] >= st) {
              var _k11 = Math.floor(parseInt(e[1] - st) / 1800);
              var _end = e[1] + e[7] * 60;
              var _half = st + (_k11 + 1) * 1800;
              var _value2 = e[6];
              if (_end > _half) {
                _value2 = (_half - e[1]) / (e[7] * 60) * e[6];
                if (_k11 + 1 < 48) {
                  bolus1[_k11 + 1].push(e[6] - _value2);
                }
              }
              bolus1[_k11].push(_value2 + e[4]);
              countArray[_k11]++;
            }
          } else {
            if (e[1] >= st) {
              var _k12 = Math.floor(parseInt(e[1] - st) / 1800);
              bolus1[_k12].push(e[4]);
              countArray[_k12]++;
            }
          }
        });
      }
    };

    for (var _i19 = 0; _i19 < length1; _i19++) {
      _loop8(_i19);
    }

    var _loop9 = function _loop9(_i20) {
      var length2 = val2[_i20].length,
          st = context.ts[_i20][0];
      if (length2 > 0) {
        val2[_i20].map(function (e, i) {
          if (e[2] === 'INS' && e[1] >= st && e[3].value) {
            var _k13 = Math.floor(parseInt(e[1] - st) / 1800);
            bolus1[_k13].push(e[3].value);
            countArray[_k13]++;
          }
        });
      }
    };

    for (var _i20 = 0; _i20 < length3; _i20++) {
      _loop9(_i20);
    }

    bolus1.map(function (e, i) {
      if (e.length > 0) {
        e.sort(that.compare);
        var _length = e.length;
        var d1 = Math.floor(0.1 * _length);
        var d2 = Math.floor(0.25 * _length);
        var d3 = Math.floor(0.5 * _length);
        var d4 = Math.floor(0.75 * _length);
        var d5 = Math.floor(0.9 * _length);
        bolus2[i][0] = e[d1].toFixed(1);
        bolus2[i][1] = e[d2].toFixed(1);
        bolus2[i][2] = e[d3].toFixed(1);
        bolus2[i][3] = e[d4].toFixed(1);
        bolus2[i][4] = e[d5].toFixed(1);
        maxGroup.push(parseFloat(e[d5].toFixed(1)));
      }
    });
    context.bolus1 = bolus2;

    var max = maxGroup.length > 2 ? Math.max.apply(null, maxGroup) : 10;
    if (max < 10) {
      max = 10;
    } else if (max < 15) {
      max = 15;
    } else if (max < 20) {
      max = 20;
    } else if (max < 30) {
      max = 30;
    } else if (max < 50) {
      max = 50;
    }
    context.bolusMax = max;

    var bolCount = [],
        k = 0;
    countArray.map(function (e, i) {
      if (e !== 0) {
        bolCount[k] = [];
        bolCount[k][0] = i;
        bolCount[k][1] = e;
        k++;
      }
    });
    context.bolCount = bolCount;
  },
  compare: function compare(value1, value2) {
    return value1 - value2;
  },
  getSegmentBasal: function getSegmentBasal(context, val) {
    var st = context.ts[0][0],
        et = context.ts[0][1],
        basal = [],
        p = 0,
        length = val.length,
        value = [];
    for (var i = 0; i < length; i++) {
      var t1 = val[i][0].split(':');
      var t = st + parseInt(t1[0]) * 3600 + parseInt(t1[1]) * 60;
      basal[p] = [];
      basal[p][0] = new Date(t * 1000);
      basal[p][1] = val[i][1];
      if (i < length - 1) {
        basal[p][2] = val[i][0] + ' - ' + val[i + 1][0];
      } else {
        basal[p][2] = val[i][0] + ' - ' + '24:00';
      }

      value.push(val[i][1]);
      p++;
      if (i < length - 1) {
        t1 = val[i + 1][0].split(':');
        t = st + parseInt(t1[0]) * 3600 + parseInt(t1[1]) * 60;
      } else {
        t = et;
      }
      basal[p] = [];
      basal[p][0] = new Date(t * 1000);
      basal[p][1] = val[i][1];
      if (i < length - 1) {
        basal[p][2] = val[i][0] + ' - ' + val[i + 1][0];
      } else {
        basal[p][2] = val[i][0] + ' - ' + '24:00';
      }
      p++;
    }
    var max = value.length > 0 ? Math.max.apply(null, value) : 5;
    if (max <= 2) {
      max = 2.5;
    } else if (max <= 4) {
      max = 4;
    } else if (max <= 5) {
      max = 5;
    } else {
      max = 10;
    }
    context.basal = basal;
    context.basalMax = max;
  },
  getSettingData: function getSettingData(context, uid) {
    context.$http.get(SERVER_URL + '/v2.0/settings/' + uid).then(function (res) {
      var err = res.body.error;
      context.En = localStorage.getItem('unit') === 'mg' ? true : false;
      if (err === 0) {
        var settings = res.data.settings;

        if (context.En) {
          settings.glucose_unit = 'mg/dL';
          settings.blos_low_before_b = Math.round(settings.blos_low_before_b * 18);
          settings.blos_low_before_b = settings.blos_low_before_b < 60 ? 60 : settings.blos_low_before_b;
          settings.blos_low_before_b = settings.blos_low_before_b > 100 ? 100 : settings.blos_low_before_b;

          settings.blos_high_before_b = Math.round(settings.blos_high_before_b * 18);
          settings.blos_low_after_b = Math.round(settings.blos_low_after_b * 18);
          settings.blos_low_after_b = settings.blos_low_after_b < 60 ? 60 : settings.blos_low_after_b;
          settings.blos_low_after_b = settings.blos_low_after_b > 100 ? 100 : settings.blos_low_after_b;

          settings.blos_high_after_b = Math.round(settings.blos_high_after_b * 18);
          settings.blos_low_before_l = Math.round(settings.blos_low_before_l * 18);
          settings.blos_low_before_l = settings.blos_low_before_l < 60 ? 60 : settings.blos_low_before_l;
          settings.blos_low_before_l = settings.blos_low_before_l > 100 ? 100 : settings.blos_low_before_l;

          settings.blos_high_before_l = Math.round(settings.blos_high_before_l * 18);
          settings.blos_low_after_l = Math.round(settings.blos_low_after_l * 18);
          settings.blos_low_after_l = settings.blos_low_after_l < 60 ? 60 : settings.blos_low_after_l;
          settings.blos_low_after_l = settings.blos_low_after_l > 100 ? 100 : settings.blos_low_after_l;

          settings.blos_high_after_l = Math.round(settings.blos_high_after_l * 18);
          settings.blos_low_before_s = Math.round(settings.blos_low_before_s * 18);
          settings.blos_low_before_s = settings.blos_low_before_s < 60 ? 60 : settings.blos_low_before_s;
          settings.blos_low_before_s = settings.blos_low_before_s > 100 ? 100 : settings.blos_low_before_s;

          settings.blos_high_before_s = Math.round(settings.blos_high_before_s * 18);
          settings.blos_low_after_s = Math.round(settings.blos_low_after_s * 18);
          settings.blos_low_after_s = settings.blos_low_after_s < 60 ? 60 : settings.blos_low_after_s;
          settings.blos_low_after_s = settings.blos_low_after_s > 100 ? 100 : settings.blos_low_after_s;

          settings.blos_high_after_s = Math.round(settings.blos_high_after_s * 18);
          settings.blos_low_night = Math.round(settings.blos_low_night * 18);
          settings.blos_low_night = settings.blos_low_night < 60 ? 60 : settings.blos_low_night;
          settings.blos_low_night = settings.blos_low_night > 100 ? 100 : settings.blos_low_night;

          settings.blos_high_night = Math.round(settings.blos_high_night * 18);
          settings.blos_low = Math.round(settings.blos_low * 18);
          settings.blos_low = settings.blos_low < 60 ? 60 : settings.blos_low;

          settings.blos_high = Math.round(settings.blos_high * 18);
          settings.hypo = Math.round(settings.hypo * 18);
        } else {
          settings.glucose_unit = 'mmol/L';
          settings.blos_low_before_b = settings.blos_low_before_b.toFixed(1);
          settings.blos_high_before_b = settings.blos_high_before_b.toFixed(1);
          settings.blos_low_after_b = settings.blos_low_after_b.toFixed(1);
          settings.blos_high_after_b = settings.blos_high_after_b.toFixed(1);
          settings.blos_low_before_l = settings.blos_low_before_l.toFixed(1);
          settings.blos_high_before_l = settings.blos_high_before_l.toFixed(1);
          settings.blos_low_after_l = settings.blos_low_after_l.toFixed(1);
          settings.blos_high_after_l = settings.blos_high_after_l.toFixed(1);
          settings.blos_low_before_s = settings.blos_low_before_s.toFixed(1);
          settings.blos_high_before_s = settings.blos_high_before_s.toFixed(1);
          settings.blos_low_after_s = settings.blos_low_after_s.toFixed(1);
          settings.blos_high_after_s = settings.blos_high_after_s.toFixed(1);
          settings.blos_low_night = settings.blos_low_night.toFixed(1);
          settings.blos_high_night = settings.blos_high_night.toFixed(1);
          settings.blos_low = settings.blos_low.toFixed(1);
          settings.blos_high = settings.blos_high.toFixed(1);
          settings.hypo = settings.hypo.toFixed(1);
        }
        context.$store.commit('updateSettingData', settings);
        context.$store.commit('updateAlarm', settings.alarm_display);
      }
    }, function (err) {
      alert(err + "," + err.body.message);
    });
  },
  getSessions: function getSessions(context, uid) {
    var that = this;
    function addPreZero(pdm_sn_hex, num) {
      var pre = '';
      for (var i = 0; i < num; i++) {
        pre += '0';
      }
      return pre + pdm_sn_hex;
    }
    var authRef = this;

    context.$http.get(SERVER_URL + '/v2.0/pdm/' + uid + '/sessions').then(function (res) {
      var err = res.body.error;

      if (err === 0) {

        var sessions = res.body.sessions;
        for (var i = 0; i < sessions.length; i++) {
          for (var j = 0; j < sessions[i].length; j++) {
            for (var k = 0; k < 8; k++) {
              if (k === 3 || k === 4 || k === 5) {
                var time = new Date(sessions[i][j][k] * 1000);
                sessions[i][j][k] = context.isZh ? __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formateDate(time) : __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate1(time);
              } else if (k === 6) {
                sessions[i][j][k] = authRef.deviceSNFormat(sessions[i][j][k], 'PDM');
              } else if (k === 1) {
                if (0 == i) {
                  sessions[i][j][k] = authRef.deviceSNFormat(sessions[i][j][k], 'TRANS');
                } else if (1 == i) {
                  sessions[i][j][k] = authRef.deviceSNFormat(sessions[i][j][k], 'PUMP');
                }
              }
            }
          }
        }
        context.Sessions = sessions;

        var data = res.data.options;
        context.cgms = data.cgms ? data.cgms : [];
        context.pump = data.pump ? data.pump : [];

        if (context.Sessions[0].length) {
          context.haveSensorData = true;
        } else {
          context.haveSensorData = false;
        }
        if (context.Sessions[1].length) {
          context.havePumpData = true;
        } else {
          context.havePumpData = false;
        }
        console.log('havePumpData:', context.havePumpData, context.haveSensorData);

        if (data.option === 'daopapp') {
          context.isA = true;
          context.isB = false;
          sessionStorage.setItem('dateViewA', 1);
          sessionStorage.setItem('dateViewB', 0);
        } else {
          context.isB = true;
          context.isA = false;
          sessionStorage.setItem('dateViewA', 0);
          sessionStorage.setItem('dateViewB', 1);
        }

        if (context.isB) {
          setTimeout(context.checkSet, 50);
        }
      }
    }, function (err) {
      alert(err + "," + err.body.message);
    });
  },
  setData: function setData(context, uid, param) {
    var that = this;
    context.$http.post(SERVER_URL + '/v2.0/options/' + uid + '/data', param).then(function (res) {
      var err = res.body.error;
      console.log('save options:', err);
      if (err === 0) {
        var tip = context.$t('saveTip');
        context.$message({
          type: 'success',
          message: tip
        });
        sessionStorage.setItem('data_source', param.data['option']);
      }
      if (err === 34) {
        var _tip12 = context.$t('Time overlapped');
        context.$message.error(_tip12);
      }
    });
  },
  getSet: function getSet(context, uid) {
    context.$http.get(SERVER_URL + '/v2.0/options/' + uid + '/data').then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var data = res.data.data;
        context.cgms = data.cgms ? data.cgms : [];
        context.pump = data.pump ? data.pump : [];

        if (data.option === 'daopapp') {
          context.isA = true;
          context.isB = false;
          sessionStorage.setItem('dateViewA', 1);
          sessionStorage.setItem('dateViewB', 0);
          context.isRealtime = true;
          context.isPDM = false;
        } else {
          context.isB = true;
          context.isA = false;
          sessionStorage.setItem('dateViewA', 0);
          sessionStorage.setItem('dateViewB', 1);
          context.isRealtime = false;
          context.isPDM = true;
        }
      }
    });
  },
  getEvents: function getEvents(context, uid, param) {
    var that = this;
    var ins_unit2 = context.$t('ins_unit2');
    context.$http.get(SERVER_URL + '/v2.0/events/' + uid, { params: param }).then(function (res) {
      var err = res.data.error;

      if (err === 0) {
        var dataObj = res.data.data;
        context.defaultDate2 = dataObj.st ? __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate4(dataObj.st) : __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate4(new Date().setHours(0, 0, 0, 0) / 1000 - 86400 * 6);
        console.log('event:', dataObj.items);
        var isEn = sessionStorage.getItem('language') !== 'zh' ? true : false;
        var events = dataObj.items.map(function (e, i) {
          e[1] = isEn ? __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate1(new Date(e[1] * 1000)) : __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formateDate(new Date(e[1] * 1000));
          if (e[3]) {
            if (e[2] === 'BG') {
              e[3].value = context.isMg ? e[3].value : (e[3].value / 18).toFixed(1);
              e[3].value = e[3].value + ' ' + context.unit;
            }
            if (e[2] === 'CARB') {
              e[3].value = e[3].value + ' g';
            }
            if (e[2] === 'INS') {
              e[3].value = e[3].value + ' ' + ins_unit2;
            }
            if (e[2] === 'EXR') {
              e[3].value = e[3].value + ' min';
              var exercise = ["Light", "Medium", "Heavy"];
              e[3].value = e[3].value + ' ' + exercise[e[3].exerciseIntensity];
            }
            if (e[2] === 'AutoExercise') {
              if (e[3].value) {
                e[3].value = e[3].value + ' min';
              } else {
                e[3].value = e[3].duration + ' min';
              }
            }
            if (e[2] === 'HBA1C') {
              e[3].value = e[3].value + ' %';
            }
            if (e[2] === 'URINEK') {
              var urinekType = ['Negative', 'Macro', '+', '++', '+++', '++++'];
              e[3].value = urinekType[e[3].value - 1];
            }
            if (e[2] === 'OTR') {
              e[3].value = '...';
            }
          }
          e[2] = context.$t(e[2]);
          e[4] = e[4] === 'pdm' ? context.$t('pdm') : e[4];

          var event_type_map = {
            'AutoBreakfast': 't1222_autoBreakfast',
            'AutoLunch': 't1222_autoLunch',
            'AutoDinner': 't1222_autoDinner',
            'AutoSnack': 't1222_Snack',
            'AutoExercise': 't1222_autoExercise'
          };
          if (event_type_map[e[2]]) {
            e[2] = context.$t(event_type_map[e[2]]);
          }
          return e;
        });
        context.$store.commit('updateEvents', events);
        this.pages = dataObj.pages;
        this.has_next = dataObj.has_next;
        this.has_prev = dataObj.has_prev;
      }
    });
  },
  newEvents: function newEvents(context, uid, param) {
    context.$http.post(SERVER_URL + '/v2.0/events/' + uid + '/data/new', { data: [param] }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var tip = context.$t('saveTip');
        context.$message({
          type: 'success',
          message: tip
        });
        context.getEvents();
        context.isA = false;
      } else {
        var _tip13 = context.$t('createFailed');
        context.$message.error(_tip13);
      }
    });
  },
  deleteEvents: function deleteEvents(context, uid, param) {
    context.$http.post(SERVER_URL + '/v2.0/events/' + uid + '/data/delete', { eids: param }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var tip = context.$t('deleteSuccess');
        context.$message({
          type: 'success',
          message: tip
        });
        context.eids = [];
        context.getEvents();
      } else {
        var _tip14 = context.$t('deleteFailed');
        context.$message.error(_tip14);
      }
    });
  },
  deleteData: function deleteData(context) {
    context.$http.post(SERVER_URL + '/v2.0/data/delete').then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var tip = context.$t('deleteSuccess');
        context.$message({
          type: 'success',
          message: tip
        });

        context.Sessions = [];
      } else {
        var _tip15 = context.$t('deleteFailed');
        context.$message.error(_tip15);
      }
    });
  },
  editEvents: function editEvents(context, uid, eid, param) {
    context.$http.post(SERVER_URL + '/v2.0/events/' + uid + '/data/' + eid, { event: param }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var tip = context.$t('editSuccess');
        context.$message({
          type: 'success',
          message: tip
        });
        context.isB = false;
        context.getEvents();
      } else {
        var _tip16 = context.$t('editFailed');
        context.$message.error(_tip16);
      }
    });
  },
  getRecords: function getRecords(context, uid) {
    var that = this;
    context.$http.get(SERVER_URL + '/v2.0/records/' + uid).then(function (res) {
      var err = res.data.error;
      if (err === 0) {
        var dataObj = res.data.data;

        dataObj.profile.diabetes_type = context.$t(dataObj.profile.diabetes_type);
        if (dataObj.profile.height) {
          dataObj.profile.height = dataObj.profile.height + ' cm';
        }
        if (dataObj.profile.weight) {
          dataObj.profile.weight = dataObj.profile.weight + ' kg';
        }
        if (dataObj.profile.birthday) {
          var y = parseInt(dataObj.profile.birthday.split('-')[0]);
          var y1 = new Date().getFullYear();
          dataObj.profile.birthday = y1 - y;
        }
        if (dataObj.profile.diabetes_diagnosis_date) {
          var t = dataObj.profile.diabetes_diagnosis_date.split('-');
          var _y = new Date().getFullYear();
          var m1 = new Date().getMonth() + 1;
          var _y2 = _y - parseInt(t[0]);
          var _m7 = m1 - parseInt(t[1]);
          if (_m7 < 0) {
            _y2--;
            _m7 += 12;
          }
          var year = _y2 > 1 ? context.$t('Years') : context.$t('Year');
          var month = _m7 > 1 ? context.$t('Months') : context.$t('Month');
          var lang = localStorage.getItem('language');
          dataObj.profile.diabetes_diagnosis_date = lang === 'zh' || lang === 'hk' ? _y2 + ' 年 ' + _m7 + ' 月' : _y2 + ' ' + year + ' ' + _m7 + ' ' + month;
        }
        context.profile = dataObj.profile;
        var isEn = sessionStorage.getItem('language') !== 'zh' ? true : false;
        context.complications = dataObj.complications.map(function (e, i) {
          e[2] = isEn ? __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate4(e[2]) : __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate3(e[2]);
          return e;
        });
        context.prescription = dataObj.prescription;
        context.suggestions = dataObj.suggestions.map(function (e, i) {
          e[1] = isEn ? __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate4(e[1]) : __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate3(e[1]);
          return e;
        });

        sessionStorage.setItem('Rpro', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(context.profile));
        sessionStorage.setItem('Rcop', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(context.complications));
        sessionStorage.setItem('Rpre', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(context.prescription));
        sessionStorage.setItem('Rsug', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(context.suggestions));
      }
    });
  },
  newRecords: function newRecords(context, uid, param) {
    var that = this;

    context.$http.post(SERVER_URL + '/v2.0/records/' + uid + '/data/new', { data: param }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var tip = context.$t('createSuccess');
        context.$message({
          type: 'success',
          message: tip
        });
        this.CreateVisible = false;
        that.getRecords(context, uid);
      } else {
        var _tip17 = context.$t('createFailed');
        context.$message.error(_tip17);
      }
    }, function (err) {
      var tip = context.$t('createFailed');
      context.$message.error(tip);
    });
  },
  deleteRecords: function deleteRecords(context, uid, param) {
    var that = this;
    context.$http.post(SERVER_URL + '/v2.0/records/' + uid + '/data/delete', { rids: param }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var tip = context.$t('deleteSuccess');
        context.$message({
          type: 'success',
          message: tip
        });
        that.getRecords(context, uid);
      } else {
        var _tip18 = context.$t('deleteFailed');
        context.$message.error(_tip18);
      }
    });
  },
  editRecords: function editRecords(context, uid, param) {
    var that = this;
    context.$http.post(SERVER_URL + '/v2.0/records/' + uid + '/data/edit', { data: param }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        context.EditVisible = false;
        var tip = context.$t('editSuccess');
        context.$message({
          type: 'success',
          message: tip
        });
        that.getRecords(context, uid);
      } else {
        var _tip19 = context.$t('editFailed');
        context.$message.error(_tip19);
      }
    });
  },
  getConnections: function getConnections(context, info) {
    var that = this;
    var now = new Date() / 1000;
    context.$http.get(SERVER_URL + '/v2.1/monitor/connections', { params: info }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var data = res.body.data;

        var dataObj = data.items;
        context.connections = dataObj.map(function (e, i) {
          var t1 = now - e.sensor_status.updateTime;
          var t2 = now - e.pump_status.updateTime;
          if (e.sensor_status.glucose) {
            console.log('connection.glucose:', e.alias, e.sensor_status.glucose);
            if (context.unit === 'mg/dL') {
              var glucoseMg = (e.sensor_status.glucose * 18).toFixed(1);
              if (glucoseMg >= 400) {
                e.sensor_status.glucose = 'High';
              } else if (glucoseMg <= 40) {
                e.sensor_status.glucose = 'Low';
              } else {
                e.sensor_status.glucose = glucoseMg;
              }
            } else {
              var glucoseMml = e.sensor_status.glucose.toFixed(1);
              if (glucoseMml >= 22.2) {
                e.sensor_status.glucose = 'High';
              } else if (glucoseMml <= 2.2) {
                e.sensor_status.glucose = 'Low';
              } else {
                e.sensor_status.glucose = glucoseMml;
              }
            }
          } else {
            e.sensor_status.glucose = '--';
          }
          if (e.pump_status.basalRate) {
            e.pump_status.basalRate = e.pump_status.basalRate.toFixed(1);
          }
          if (e.pump_status.iob) {
            e.pump_status.iob = e.pump_status.iob.toFixed(2);
          }
          if (t1 > 3600) {
            e.sensor_status.glucose = '--';
          }
          if (t2 > 3600) {
            e.pump_status.basalRate = '--';
            e.pump_status.iob = '--';
          }
          e.alias = e.alias ? e.alias : e.real_name;
          return e;
        });
        this.pages = data.pages !== 0 ? data.pages : 1;
        this.has_next = data.has_next;
        this.has_prev = data.has_prev;
      }
      if (err === 14) {
        context.$router.push('/login');
      }
    });
  },
  getPatientConnections: function getPatientConnections(context) {
    context.$http.get(SERVER_URL + '/v2.0/relations/auth').then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var data = res.data.data;
        context.hcp = [];context.carer = [];context.hcpApply = [];context.carerApply = [];
        context.oauth2 = data.oauth2;
        data.hcp.map(function (e, i) {
          if (e.state === 'ACCEPT') {
            context.hcp.push(e);
          } else {
            context.hcpApply.push(e);
          }
        });
        data.carer.map(function (e, i) {
          if (e.state === 'ACCEPT') {
            context.carer.push(e);
          } else {
            context.carerApply.push(e);
          }
        });
        console.log('connection.data:', data);
        if (data.hcp.length === 0 && data.carer.length === 0) {
          context.noMes = true;
        }
      }
      if (err === 14) {
        context.$router.push('/login');
      }
    });
  },
  deleteConnection: function deleteConnection(context, id) {
    var that = this;
    context.$http.post(SERVER_URL + '/v2.0/relations/auth/cancel', { uid: id }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var tip = context.$t('deleteSuccess');
        context.$message({
          type: 'success',
          message: tip
        });
      } else {
        var _tip20 = context.$t('deleteFailed');
        context.$message.error(_tip20);
      }
      that.getPatientConnections(context);
    });
  },
  addConnection: function addConnection(context, id) {
    var that = this;
    context.$http.post(SERVER_URL + '/v2.0/relations/auth/permit', { uid: id }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var tip = context.$t('acceSu');
        context.$message({
          type: 'success',
          message: tip
        });
      } else {
        var _tip21 = context.$t('acceEr');
        context.$message.error(_tip21);
      }
      that.getPatientConnections(context);
      that.getUnread1(context);
    });
  },
  rejectConnection: function rejectConnection(context, id) {
    var that = this;
    context.$http.post(SERVER_URL + '/v2.0/relations/auth/reject', { uid: id }).then(function (res) {
      var err = res.body.error;
      if (err === 0) {
        var tip = context.$t('rejeSu');
        context.$message({
          type: 'success',
          message: tip
        });
      } else {
        var _tip22 = context.$t('rejeEr');
        context.$message.error(_tip22);
      }
      that.getPatientConnections(context);
      that.getUnread1(context);
    });
  },
  getTime: function getTime(val) {
    var isEn = localStorage.getItem('language') === 'zh' || localStorage.getItem('language') === 'hk' ? true : false;

    if (val < 0) {
      return '--';
    } else {
      var d = parseInt(val * 2 / 1440);
      var h = parseInt(val * 2 % 1440 / 60);
      var mi = parseInt(val * 2 % 60);
      if (d === 0) {
        return isEn ? h + ' 小时 ' + mi + ' 分钟' : h + ' h ' + mi + ' min';
      } else {
        return isEn ? d + ' 天 ' + h + ' 小时 ' + mi + ' 分钟' : d + ' day ' + h + ' h ' + mi + ' min';
      }
    }
  },
  getTime2: function getTime2(val) {
    var h = parseInt(val / 60);
    var mi = val % 60;
    h = h < 10 ? '0' + h : h;
    mi = mi < 10 ? '0' + mi : mi;
    return [h, mi];
  },
  getTime3: function getTime3(val) {
    var isEn = localStorage.getItem('language') === 'zh' || localStorage.getItem('language') === 'hk' ? true : false;
    if (val < 0) {
      return '--';
    } else {
      var d = parseInt(val / 1440);
      var h = parseInt(val % 1440 / 60);
      var mi = parseInt(val % 60);
      if (d === 0) {
        return isEn ? h + ' 小时 ' + mi + ' 分钟' : h + ' h ' + mi + ' min';
      } else {
        return isEn ? d + ' 天 ' + h + ' 小时 ' + mi + ' 分钟' : d + ' day ' + h + ' h ' + mi + ' min';
      }
    }
  },
  modifyPassword: function modifyPassword(context, param) {
    context.$http.post(SERVER_URL + '/v2.0/password/modify', param).then(function (res) {
      var err = res.body.error;

      if (err === 0) {
        var tip = context.$t('saveTip');
        context.$message({
          type: 'success',
          message: tip
        });
        var user = sessionStorage.getItem('userType');
        if (user === 'P') {
          context.$router.push('/monitor');
        }
        if (user === 'D') {
          context.$router.push('/PatientList');
        }
        if (user === 'M') {
          context.$router.push('/carerConnection');
        }
      } else {
        var _tip23 = context.$t('oldErr');
        context.$message.error(_tip23);
      }
    });
  },
  getToken: function getToken(context, param) {
    context.$http.get(SERVER_URL + '/v2.0/password/reset/token', { params: { param: param } }).then(function (res) {
      var err = res.body.error;

      if (err === 0) {
        context.passwordToken = res.data.token;
        context.isB = false;
        context.isC = true;
        sessionStorage.setItem('B', 0);
        sessionStorage.setItem('C', 1);
      } else {
        var tip = context.$t('verErrTip');
        context.$message.error(tip);
      }
    });
  },
  resetPassword: function resetPassword(context, param) {
    context.$http.post(SERVER_URL + '/v2.0/password/reset', param).then(function (res) {
      var err = res.body.error;

      if (err === 0) {
        this.isC = false;
        this.isD = true;
        sessionStorage.setItem('C', 0);
        sessionStorage.setItem('D', 1);
      } else {
        var tip = context.$t('modifyFailed');
        context.$message.error(tip);
      }
    });
  },
  init: function init() {
    var height = window.innerHeight;
    var width = window.innerWidth;
    var body = document.getElementsByTagName('body')[0];
    body.style.height = height + 'px';
    body.style.width = width + 'px';
    console.log(body.style.width + 'X' + body.style.height);
  },
  getAuthHeader: function getAuthHeader() {
    return {
      'Authorization': 'Bearer ' + sessionStorage.getItem('token')
    };
  },
  checkAuth: function checkAuth() {
    var token = sessionStorage.getItem('token');
    if (token) {
      this.authenticated = true;
    } else {
      this.authenticated = false;
    }
  },
  clearSession: function clearSession() {
    var tz = parseInt(sessionStorage.getItem('tz'));
    var uid = parseInt(sessionStorage.getItem('uid'));
    var userType = sessionStorage.getItem('userType');
    var username = sessionStorage.getItem('username');
    var token = sessionStorage.getItem('token');
    var lang = sessionStorage.getItem('language');
    var num = sessionStorage.getItem('patientPages');
    sessionStorage.clear();
    sessionStorage.setItem('patientPages', num || 1);
    sessionStorage.setItem('tz', tz);
    sessionStorage.setItem('uid', uid);
    sessionStorage.setItem('userType', userType);
    sessionStorage.setItem('username', username);
    sessionStorage.setItem('token', token);
    sessionStorage.setItem('language', lang);
  },
  getTs: function getTs(st, et) {
    var ts = [],
        k = 0;
    var days = parseInt((et - st) / 86400) + 1;
    for (var i = 0; i < days; i++) {
      ts[k] = [];
      ts[k][0] = st + i * 86400;
      ts[k][1] = st + (i + 1) * 86400;
      k++;
    }
    return ts;
  },
  getTs2: function getTs2(context, st, et) {
    var ts = [],
        days = (et - st) / 86400 + 1,
        k = 0;
    var No = this.chekcNoDate(context.weekmode);
    for (var i = 0; i < days; i++) {
      var day = new Date((st + i * 86400) * 1000).getDay();
      if (No.indexOf(day) === -1) {
        ts[k] = [];
        ts[k][0] = st + i * 86400;
        ts[k][1] = st + (i + 1) * 86400;
        k++;
      }
    }
    return ts;
  },
  chekcNoDate: function chekcNoDate(weekmode) {
    var No = [],
        no = weekmode.split('');
    no.map(function (e, i) {
      if (e === 'n') {
        var d = i + 1;
        if (d > 6) {
          d = 0;
        }
        No.push(d);
      }
    });
    return No;
  },
  checkWeekMode: function checkWeekMode(context) {
    context.weekModeSp = [];
    context.weekM1 = false;
    context.weekM2 = false;
    var week = context.weekmode.split('');

    week.map(function (e, i) {
      if (e === 'n') {
        context.weekModeSp[i] = true;
        if (i < 5) {
          context.weekM1 = true;
        } else {
          context.weekM2 = true;
        }
      } else {
        context.weekModeSp[i] = false;
      }
    });
  },
  open: function open(url) {
    window.open(url, '_blank');
  },
  _open: function _open(url) {
    return function () {
      this.open(url);
    };
  },
  checkPrint: function checkPrint(context, start, now) {
    var that = this;
    var report = JSON.parse(sessionStorage.getItem('Reports'));
    var length = report.length;
    document.onreadystatechange = function () {
      if (document.readyState === 'complete') {
        for (var i = start; i < length; i++) {
          if (report[i] === 1) {
            var key = 'qFirst' + now;
            sessionStorage.setItem(key, 0);
            var path = '/#/quickPrint' + i;
            var open = window.open(path, '_blank');
            if (open === null) {
              console.log('open: ', open);
              context.$message.error('popup window intercepted auth');
            }
            break;
          }
        }
      }
    };
  },
  _printPdf: function _printPdf() {
    var that = this;
    return function () {
      that.print_page();
    };
  },
  print_page: function print_page() {
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
      console.log('print_page.1');
      var hkey_root = void 0,
          hkey_path = void 0,
          hkey_key = void 0;
      hkey_path = "HKEY_CURRENT_USER\\Software\\Microsoft\\Internet Explorer\\PageSetup\\";
      try {
        var RegWsh = new ActiveXObject("WScript.Shell");
        RegWsh.RegWrite(hkey_path + "header", "");
        RegWsh.RegWrite(hkey_path + "footer", "");
      } catch (e) {}
    }
    console.log('print_page.2');
    window.print();
  },
  _getMonData1: function _getMonData1(context, info) {
    var that = this;
    return function () {
      that.getMonData1(context, info);
    };
  },
  initLanguages: function initLanguages(context) {
    context.hostname = window.location.hostname.split('.')[2];
    var href = window.location.href;
    var search = href.split('=')[1],
        info = [];

    if (!search) {
      if (context.hostname === 'cn') {
        info = [1, 1];
      } else if (context.hostname === 'eu') {
        var countryIndex = localStorage.getItem('index');
        if (!countryIndex) {
          info = [0, 0];
        } else {
          var _index3 = parseInt(countryIndex);
          var index2 = parseInt(localStorage.getItem('languageIndex'));
          info = [_index3, index2];
        }
      } else {
        info = [0, 0];
      }
    } else {
      var _index4 = 0;
      context.country.map(function (e, i) {
        if (e === search) {
          _index4 = i;
        }
      });
      if (search === 'DE') {
        _index4 = 3;
      }
      info = [_index4, _index4];
    }

    var country = context.country[info[0]];
    console.log('loc_code:', info[0], country);
    localStorage.setItem('loc_code', country);
    context.$store.commit('updateLocCode', country);

    info.push(1);
    context.$store.commit('changLanguage', info);
  },
  xx_initLanguages: function xx_initLanguages(context) {
    context.hostname = window.location.hostname.split('.')[2];
    var href = window.location.href;
    var search = href.split('=')[1],
        info = [];
    var countryIndex = localStorage.getItem('index');
    if (!countryIndex) {
      if (!search) {
        if (context.hostname === 'cn') {
          info = [1, 1];
        } else if (context.hostname === 'eu') {
          info = [0, 0];
        } else {
          info = [0, 0];
        }
      } else {
        var _index5 = 0;
        context.country.map(function (e, i) {
          if (e === search) {
            _index5 = i;
          }
        });
        if (search === 'DE') {
          _index5 = 3;
        }
        info = [_index5, _index5];
      }
    } else {
      var _index6 = parseInt(countryIndex);
      var index2 = parseInt(localStorage.getItem('languageIndex'));
      info = [_index6, index2];
    }

    var country = context.country[info[0]];
    console.log('loc_code:', info[0], country);
    localStorage.setItem('loc_code', country);
    context.$store.commit('updateLocCode', country);

    info.push(1);
    context.$store.commit('changLanguage', info);
  },
  changeServer: function changeServer(context, country, route) {
    var index = 0;
    if (country !== 'DE') {
      context.country.map(function (e, i) {
        if (e === country) {
          index = i;
        }
      });
    } else {
      index = 3;
    }
    var hostname = window.location.hostname.split('.')[2];
    var flag = 1;
    if (index === 1 && hostname !== 'cn') {
      window.location = 'https://easyview.medtrum.cn/#/' + route + '?country=' + country;
      flag = 0;
    } else {
        window.location = 'https://easyview.medtrum.eu/#/' + route + '?country=' + country;
      }
    context.$store.commit('changLanguage', [index, index, flag]);
  },
  getOuterHost: function getOuterHost() {
    var host = 'https://www.medtrum.com';
    var loc = localStorage.getItem('loc_code');
    console.log('getOuterHost:', loc);

    var eu_loc = ['GB', 'BE', 'PL', 'xx', 'xx', 'AT', 'Ro', 'PT', 'BG', 'RH', 'xx', 'xx', 'HU', 'xx', 'LV', 'Nor', 'xx', 'EE', 'CH', 'LT', 'FI', 'SK', 'SI', 'BA', 'xx', 'xx'];
    var host_map = {
      'FR': 'https://www.medtrum.fr',
      'DE': 'https://de.medtrum.com',
      'DD': 'https://de.medtrum.com',
      'IT': 'https://www.medtrum.it',
      'TR': 'https://tr.medtrum.com',
      'NL': 'https://www.medtrum.nl',
      'DK': 'https://www.medtrum.dk',
      'ES': 'https://www.medtrum.es',
      'CN': 'https://www.medtrum.com.cn',
      'SE': 'https://www.medtrum.se',
      'HKF': 'https://www.medtrum.com.hk',
      'CZ': 'https://cz.medtrum.com'

    };
    if (eu_loc.indexOf(loc) >= 0) {
      host = 'https://www.medtrum.co.uk';
    } else if (host_map[loc]) {
      host = host_map[loc];
    }
    return host;
  },
  getBrowserInfo: function getBrowserInfo() {
    var agent = navigator.userAgent.toLowerCase();
    console.log(agent);
    var regStr_ie = /msie [\d.]+;/gi;
    var regStr_ff = /firefox\/[\d.]+/gi;
    var regStr_chrome = /chrome\/[\d.]+/gi;
    var regStr_saf = /safari\/[\d.]+/gi;
    var regStr_safVersion = /version\/[\d.]+/gi;
    var regStr_edge = /edge\/[\d.]+/gi;

    if (agent.indexOf("msie") > 0) {
      return agent.match(regStr_ie);
    }

    if (agent.indexOf("edge") > 0) {
      return agent.match(regStr_edge);
    }

    if (agent.indexOf("firefox") > 0) {
      return agent.match(regStr_ff);
    }

    if (agent.indexOf("chrome") > 0) {
      return agent.match(regStr_chrome);
    }

    if (agent.indexOf("safari") > 0 && agent.indexOf("chrome") < 0) {
      var bro = agent.match(regStr_saf)[0].split('/')[0];
      var ver = agent.match(regStr_safVersion)[0].split('/')[1];
      var user = bro + '/' + ver;
      return [user];
    }
  },
  checkBrowser: function checkBrowser(context) {
    var info = this.getBrowserInfo()[0].split('/');
    var browser = info[0];
    var version = info[1];
    console.log(info);
    sessionStorage.setItem('Browser', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(info));
    if (browser === 'chrome') {
      var flag = this.compareBrowser(version, '61.0');
      if (!flag) {
        context.$router.push('/error');
      }
    } else if (browser === 'edge') {
      var _flag = this.compareBrowser(version, '16.0');
      if (!_flag) {
        context.$router.push('/error');
      }
    } else if (browser === 'firefox') {
      var _flag2 = this.compareBrowser(version, '55.0');
      if (!_flag2) {
        context.$router.push('/error');
      }
    } else if (browser === 'safari') {
      var _flag3 = this.compareBrowser(version, '8.08');
      if (!_flag3) {
        context.$router.push('/error');
      }
    } else {
      context.$router.push('/error');
    }
  },
  compareBrowser: function compareBrowser(ver1, ver2) {
    var version1pre = parseFloat(ver1);
    var version2pre = parseFloat(ver2);
    var version1next = ver1.replace(version1pre + ".", "");
    var version2next = ver2.replace(version2pre + ".", "");
    if (version1pre > version2pre) {
      return true;
    } else if (version1pre < version2pre) {
      return false;
    } else {
      if (version1next >= version2next) {
        return true;
      } else {
        return false;
      }
    }
  },
  detectOS: function detectOS() {
    var sUserAgent = navigator.userAgent;
    var isWin = navigator.platform == "Win32" || navigator.platform == "Windows";
    var isMac = navigator.platform == "Mac68K" || navigator.platform == "MacPPC" || navigator.platform == "Macintosh" || navigator.platform == "MacIntel";
    if (isMac) return "Mac";
    if (isWin) {
      var isWin2K = sUserAgent.indexOf("Windows NT 5.0") > -1 || sUserAgent.indexOf("Windows 2000") > -1;
      if (isWin2K) return "Win2000";
      var isWinXP = sUserAgent.indexOf("Windows NT 5.1") > -1 || sUserAgent.indexOf("Windows XP") > -1;
      if (isWinXP) return "WinXP";
      var isWin2003 = sUserAgent.indexOf("Windows NT 5.2") > -1 || sUserAgent.indexOf("Windows 2003") > -1;
      if (isWin2003) return "Win2003";
      var isWinVista = sUserAgent.indexOf("Windows NT 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1;
      if (isWinVista) return "WinVista";
      var isWin7 = sUserAgent.indexOf("Windows NT 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1;
      if (isWin7) return "Windows 7";
      var isWin8 = sUserAgent.indexOf("Windows NT 6.2") > -1 || sUserAgent.indexOf("Windows 8") > -1;
      if (isWin8) return "Windows 8";
      var isWin8_1 = sUserAgent.indexOf("Windows NT 6.3") > -1 || sUserAgent.indexOf("Windows 8.1") > -1;
      if (isWin8_1) return "Windows 8.1";
      var isWin10 = sUserAgent.indexOf("Windows NT 10") > -1 || sUserAgent.indexOf("Windows 10") > -1;
      if (isWin10) return "Windows 10";
    }
    return "other";
  },
  deviceSNFormat: function deviceSNFormat(device_sn, deviceKind, deviceType) {

    function addPreZero(pdm_sn_hex, num) {
      var pre = '';
      for (var i = 0; i < num; i++) {
        pre += '0';
      }
      return pre + pdm_sn_hex;
    }

    var pdm_sn = parseInt(device_sn);
    console.log('deviceSNFormat:', device_sn, pdm_sn);

    if (isNaN(pdm_sn)) {
      return device_sn;
    }
    var sn_val = pdm_sn;

    var decimal_list = [['TY012', 102], ['TY015', 103], ['TY026', 123], ['TY027', 103], ['TY025', 115], ['TY026', 118], ['TY027', 119], ['TG158', 120], ['TG159', 121], ['TG160', 150]];
    var trans_device = {
      'TY012': [102],
      'TY015': [103],
      'TY025': [115],
      'TY026': [123, 118],
      'TY027': [103, 119],
      'TG158': [120],
      'TG159': [121],
      'TG160': [150]
    };
    var pump_device = {
      'JN012': [106],
      'JN022': [114],
      'JN026': [125],
      'KR201': [126, 127],
      'KR202': [130, 131],
      'KR401': [135],
      'KR8201': [128],
      'KR402': [145, 146]
    };
    var pdm_device = {
      'all': [100, 101, 108, 109]
    };
    var sn_pre_list = [];
    if ('TRANS' == deviceKind) {
      sn_pre_list = trans_device[deviceType] || [];

      for (var p in trans_device) {
        sn_pre_list = sn_pre_list.concat(trans_device[p]);
      }
    } else if ('PUMP' == deviceKind) {
      sn_pre_list = pump_device[deviceType] || [];

      for (var _p in pump_device) {
        sn_pre_list = sn_pre_list.concat(pump_device[_p]);
      }
    } else if ('PDM' == deviceKind) {
      sn_pre_list = pdm_device[deviceType] || [];

      for (var _p2 in pdm_device) {
        sn_pre_list = sn_pre_list.concat(pdm_device[_p2]);
      }
    } else {
      for (var _p3 in trans_device) {
        sn_pre_list = sn_pre_list.concat(trans_device[_p3]);
      }
      for (var _p4 in pump_device) {
        sn_pre_list = sn_pre_list.concat(pump_device[_p4]);
      }
      for (var _p5 in pdm_device) {
        sn_pre_list = sn_pre_list.concat(pdm_device[_p5]);
      }
    }

    var sn_pre = parseInt(sn_val / 1000000);
    var is_decimal = false;
    if (sn_pre_list.indexOf(sn_pre) >= 0) {
      is_decimal = true;
    }
    console.log('is_decimal:', is_decimal, sn_pre, sn_pre_list, sn_val);

    if (is_decimal) {
      return pdm_sn;
    } else {
      var pdm_sn_hex = pdm_sn.toString(16);
      var lackZeroDigit = 8 - pdm_sn_hex.length;
      pdm_sn_hex = addPreZero(pdm_sn_hex, lackZeroDigit);

      return pdm_sn_hex.toUpperCase();
    }
  }
});

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chartTipFormat__ = __webpack_require__(149);






/* harmony default export */ __webpack_exports__["a"] = ({
  formatterTip: function formatterTip(params, context) {
    function notEmpty(num) {
      if (num === 0) {
        return true;
      } else {
        return new Boolean(num).valueOf();
      }
    }

    var tipArray = [],
        tip = '',
        timeDetail = '',
        basalValue = '',
        tempList = {};

    var cleanParam = params.filter(function (item) {
      if (notEmpty(item.value[1]) || notEmpty(item.value[2])) {
        if (item.seriesName === context.$t('basal')) {
          basalValue = item.value[1];
          return true;
        } else if (item.seriesName === context.$t('tempBasal')) {
          tempList['' + item.value[1]] = item;
        } else {
          return true;
        }
      }
    });
    if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(tempList).length === 1) {
      cleanParam.push(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(tempList)[0]);
    } else if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(tempList).length > 1) {
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(tempList).map(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        if (+key !== +basalValue) {
          cleanParam.push(value);
        }
      });
    }
    cleanParam.map(function (e) {
      if (e.value[0] !== 10) {
        var name = e.seriesName;
        var value = e.value;
        timeDetail = __WEBPACK_IMPORTED_MODULE_5__chartTipFormat__["a" /* default */].getFormatterTip1TimeDetail(e.value[0]);

        var chartFormatMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a([[context.$t('basal'), __WEBPACK_IMPORTED_MODULE_5__chartTipFormat__["a" /* default */].basalFormat], [context.$t('auto suspend'), __WEBPACK_IMPORTED_MODULE_5__chartTipFormat__["a" /* default */].autosuspendFormat], [context.$t('tempBasal'), __WEBPACK_IMPORTED_MODULE_5__chartTipFormat__["a" /* default */].basalFormat], [context.$t('manualStop'), __WEBPACK_IMPORTED_MODULE_5__chartTipFormat__["a" /* default */].manualStopFormat], [context.$t('normalBolus'), __WEBPACK_IMPORTED_MODULE_5__chartTipFormat__["a" /* default */].normalBolusFormat], [context.$t('extendBolus'), __WEBPACK_IMPORTED_MODULE_5__chartTipFormat__["a" /* default */].extendBolusFormat], [context.$t('newPatch'), __WEBPACK_IMPORTED_MODULE_5__chartTipFormat__["a" /* default */].newPatchFormat], [context.$t('stop'), __WEBPACK_IMPORTED_MODULE_5__chartTipFormat__["a" /* default */].stopFormat], [context.$t('alert'), __WEBPACK_IMPORTED_MODULE_5__chartTipFormat__["a" /* default */].alertFormat], [context.$t('t1222_autoModeBasal'), __WEBPACK_IMPORTED_MODULE_5__chartTipFormat__["a" /* default */].autoModeBasalFormat], [context.$t('t1222_autoModeCorrBolus'), __WEBPACK_IMPORTED_MODULE_5__chartTipFormat__["a" /* default */].autoModeCorrBolusFormat]]);
        tipArray.push(chartFormatMap.get(name).call(__WEBPACK_IMPORTED_MODULE_5__chartTipFormat__["a" /* default */], value, name, context));
      }
    });
    tip = tip + timeDetail;

    var resMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
    tipArray.map(function (e, i) {
      if (e) {
        resMap.set(e, resMap.get(e) || 1);
      }
    });
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(resMap.keys()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var item = _step.value;

        tip = tip + item + '<br>';
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return tip;
  },
  formatterTip1: function formatterTip1(params, context) {
    var tipArray = [],
        tip = '',
        timeDetail = '';
    params.map(function (e) {
      if (e.value[0] !== 10) {
        var name = e.seriesName;
        timeDetail = __WEBPACK_IMPORTED_MODULE_5__chartTipFormat__["a" /* default */].getFormatterTip1TimeDetail(e.value[0]);
        var chartFormatMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a([['SG', __WEBPACK_IMPORTED_MODULE_5__chartTipFormat__["a" /* default */].SGFormat], ['calib', __WEBPACK_IMPORTED_MODULE_5__chartTipFormat__["a" /* default */].calibFormat], ['bg', __WEBPACK_IMPORTED_MODULE_5__chartTipFormat__["a" /* default */].bgFormat], ['transmtr', __WEBPACK_IMPORTED_MODULE_5__chartTipFormat__["a" /* default */].transmtrFormat], ['alarm', __WEBPACK_IMPORTED_MODULE_5__chartTipFormat__["a" /* default */].alarmFormat]]);
        tipArray.push(chartFormatMap.get(name)(e, context));
      }
    });
    tip = tip + timeDetail;
    tipArray.map(function (e, i) {
      if (e) {
        tip = tip + e + '<br>';
      }
    });

    return tip;
  },
  formatterTip3: function formatterTip3(params, context) {
    var that = this;
    var tipArray = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        tip = '',
        timeDetail = '',
        unit = context.isMg ? 'mg/dL' : 'mmol/L ';
    var icon0 = " <div style='background: #3ce8dc;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    var icon1 = " <div style='background: #2842d2;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    var icon2 = " <div style='background: #79bd39;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    var icon3 = " <div style='background: #dce573;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    var icon4 = " <div style='background: #e61795;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    var icon5 = " <div style='background: #c9711e;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    var icon6 = " <div style='background: #a922d9;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    var icon7 = " <div style='background: #464646;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    params.map(function (e, i) {
      var index = e.seriesIndex;
      var value = e.value[1];
      var date = e.value[0];
      var time = that.formatterDate5(date);
      var t1 = '';
      timeDetail = context.$t('SG') + ' ' + time[0] + ':' + time[1] + '<br>';
      if (index < 8) {
        var type = e.value[2],
            tip0 = '',
            ico = icon0;
        if (index < 7) {
          var t2 = context.legendDate[index].split('-');
          t1 = t2[0] + '/' + t2[1];
        } else {
          t1 = context.$t('Avg');
        }
        ico = index === 1 ? icon1 : ico;ico = index === 2 ? icon2 : ico;ico = index === 3 ? icon3 : ico;
        ico = index === 4 ? icon4 : ico;ico = index === 5 ? icon5 : ico;ico = index === 6 ? icon6 : ico;ico = index === 7 ? icon7 : ico;
        if (value > 0) {
          var value1 = '';

          var isHighLow = true;

          try {
            var sg_val = parseFloat(value);
            if (context.isMg) {
              if (sg_val >= 400) {
                value = 'High';
              } else if (sg_val <= 40) {
                value = 'Low';
              } else {
                isHighLow = false;
              }
            } else {
              if (sg_val >= 22.2) {
                value = 'High';
              } else if (sg_val <= 2.2) {
                value = 'Low';
              } else {
                isHighLow = false;
              }
            }
          } catch (e) {
            console.log('sg tip:', e);
          }

          if (type === 'CX' || type === 'NC') {
            var top1 = 45 * (index + 1) + 'px';
            var hr1 = '<hr style="width: 25px;background:#FFF;height:1px;border:none;left:65px;;position: absolute;top:"' + top1 + '>';
            var hr2 = '<hr style="width: 25px;background:#FFF;height:1px;border:none;left:90px;;position: absolute;top:"' + top1 + '>';
            value1 = context.isEn ? value + hr1 : value + hr1;
          } else {
            value1 = value;
          }
          if (isHighLow) {
            tip0 = ico + t1 + ' : ' + value1;
          } else {
            tip0 = ico + t1 + ' : ' + value1 + unit;
          }
        } else {
          var text = '';
          if (type === 'NC') {
            text = context.$t('Not Calibrated');
          }
          if (type === 'DE') {
            text = context.$t('noReadings');
          }
          if (type === 'CE0' || type === 'CE1') {
            text = context.$t('Calibration Error');
          }
          if (type === 'H') {
            text = context.$t('warm');
          }
          tip0 = ico + t1 + ' : ' + text;
        }
        tipArray[index] = tip0;
      }
      if (index === 8) {
        var icon8 = " <div style='background: #f00;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
        tipArray[8] = icon8 + context.$t('calib') + ' : ' + value + unit;
      }
      if (index === 9) {
        var _icon = " <div style='background: #f00;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
        tipArray[9] = _icon + context.$t('BG') + ' : ' + value + unit;
      }
    });
    tip = tip + timeDetail;
    tipArray.map(function (e, i) {
      if (e) {
        tip = tip + e + '<br>';
      }
    });
    return tip;
  },
  formateDate: function formateDate(date) {
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    var d = date.getDate();
    var h = date.getHours();
    var mi = date.getMinutes();
    var s = date.getSeconds();
    m = m < 10 ? '0' + m : m;
    d = d < 10 ? '0' + d : d;
    mi = mi < 10 ? '0' + mi : mi;
    return y + '-' + m + '-' + d + ' ' + h + ':' + mi + ':' + s;
  },
  formatterDate1: function formatterDate1(date) {
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    var d = date.getDate();
    var h = date.getHours();
    var mi = date.getMinutes();
    var s = date.getSeconds();
    m = m < 10 ? '0' + m : m;
    d = d < 10 ? '0' + d : d;
    h = h < 10 ? '0' + h : h;
    mi = mi < 10 ? '0' + mi : mi;
    s = s < 10 ? '0' + s : s;
    return d + '-' + m + '-' + y + ' ' + h + ':' + mi + ':' + s;
  },
  formatterDate1a: function formatterDate1a(date) {
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    var d = date.getDate();
    var h = date.getHours();
    var mi = date.getMinutes();
    var s = date.getSeconds();
    m = m < 10 ? '0' + m : m;
    d = d < 10 ? '0' + d : d;
    h = h < 10 ? '0' + h : h;
    mi = mi < 10 ? '0' + mi : mi;
    s = s < 10 ? '0' + s : s;
    return y + '-' + m + '-' + d + ' ' + h + ':' + mi + ':' + s;
  },
  formatterDate2: function formatterDate2(val) {
    var time = new Date(val * 1000);
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    m = m < 10 ? '0' + m : m;
    d = d < 10 ? '0' + d : d;
    return d + '/' + m + '/' + y;
  },
  formatterDate3: function formatterDate3(val) {
    var time = new Date(val * 1000);
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    m = m < 10 ? '0' + m : m;
    d = d < 10 ? '0' + d : d;
    return y + '-' + m + '-' + d;
  },
  formatterDate4: function formatterDate4(val) {
    var time = new Date(val * 1000);
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    m = m < 10 ? '0' + m : m;
    d = d < 10 ? '0' + d : d;
    return d + '-' + m + '-' + y;
  },
  formatterDate4_1: function formatterDate4_1(val) {
    var time = new Date(val * 1000);
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();

    return d + '-' + m;
  },
  formatterDate5: function formatterDate5(val) {
    var h = val.getHours();
    var mi = val.getMinutes();
    h = h < 10 ? '0' + h : h;
    mi = mi < 10 ? '0' + mi : mi;
    return [h, mi];
  },
  formatterDate6: function formatterDate6(val) {
    var date = new Date(val * 1000);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    var d = date.getDate();
    var h = date.getHours();
    var mi = date.getMinutes();
    m = m < 10 ? '0' + m : m;
    d = d < 10 ? '0' + d : d;
    h = h < 10 ? '0' + h : h;
    mi = mi < 10 ? '0' + mi : mi;
    return d + '/' + m + '/' + y + ' ' + h + ':' + mi;
  },
  formatterDate7: function formatterDate7(context, val) {
    if (!val) {
      return '--';
    }
    var date = new Date(val * 1000);
    var now = new Date().getDate();
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    var d = date.getDate();
    var h = date.getHours();
    var mi = date.getMinutes();
    m = m < 10 ? '0' + m : m;
    d = d < 10 ? '0' + d : d;
    h = h < 10 ? '0' + h : h;
    mi = mi < 10 ? '0' + mi : mi;
    if (now === parseInt(d)) {
      return context.$t('Today') + ' ' + h + ':' + mi;
    } else if (now - 1 === parseInt(d)) {
      return context.$t('Yesterday') + ' ' + h + ':' + mi;
    } else {
      return d + '/' + m + '/' + y + ' ' + h + ':' + mi;
    }
  },
  formatterDate8: function formatterDate8(val) {
    var time = new Date(val * 1000);
    var m = time.getMonth() + 1;
    var d = time.getDate();
    m = m < 10 ? '0' + m : m;
    d = d < 10 ? '0' + d : d;
    return d + '/' + m;
  },
  formatterDate9: function formatterDate9(val) {
    var time = new Date(val * 1000);
    var y = time.getFullYear();
    var m = time.getMonth();
    var d = time.getDate();
    return [parseInt(y), parseInt(m), parseInt(d)];
  },
  formatterDate10: function formatterDate10(val) {
    var time = new Date(val * 1000);
    var h = time.getHours();
    var m = time.getMinutes();
    var s = time.getSeconds();
    return [parseInt(h), parseInt(m), parseInt(s)];
  },
  formatterDay: function formatterDay(context, val) {
    var time = new Date(val * 1000);
    var week = new Array(context.$t('Sun'), context.$t('Mon'), context.$t('Tue'), context.$t('Wed'), context.$t('Thur'), context.$t('Fri'), context.$t('Sat'));
    var day = time.getDay();
    return week[day];
  },
  formatterDateHCL: function formatterDateHCL(val) {
    var time = new Date(val * 1000);
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    m = m < 10 ? '0' + m : m;
    d = d < 10 ? '0' + d : d;
    return y + '/' + m + '/' + d;
  },
  convertTimeZone: function convertTimeZone(unconvertTime, Zone) {
    var offset = Zone.match(/[\d]+$/g);
    if (offset && Zone[0] === '-') {
      offset = -offset;
    }
    return new Date(unconvertTime.getTime() + unconvertTime.getTimezoneOffset() * 60000 + offset * 3600000);
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


function utf16to8(str) {
  var out, i, len, c;
  out = "";
  len = str.length;
  for (i = 0; i < len; i++) {
    c = str.charCodeAt(i);
    if (c >= 0x0001 && c <= 0x007F) {
      out += str.charAt(i);
    } else if (c > 0x07FF) {
      out += String.fromCharCode(0xE0 | c >> 12 & 0x0F);
      out += String.fromCharCode(0x80 | c >> 6 & 0x3F);
      out += String.fromCharCode(0x80 | c >> 0 & 0x3F);
    } else {
      out += String.fromCharCode(0xC0 | c >> 6 & 0x1F);
      out += String.fromCharCode(0x80 | c >> 0 & 0x3F);
    }
  }
  return out;
}

function utf8to16(str) {
  var out, i, len, c;
  var char2, char3;
  out = "";
  len = str.length;
  i = 0;
  while (i < len) {
    c = str.charCodeAt(i++);
    switch (c >> 4) {
      case 0:case 1:case 2:case 3:case 4:case 5:case 6:case 7:
        out += str.charAt(i - 1);
        break;
      case 12:case 13:
        char2 = str.charCodeAt(i++);
        out += String.fromCharCode((c & 0x1F) << 6 | char2 & 0x3F);
        break;
      case 14:
        char2 = str.charCodeAt(i++);
        char3 = str.charCodeAt(i++);
        out += String.fromCharCode((c & 0x0F) << 12 | (char2 & 0x3F) << 6 | (char3 & 0x3F) << 0);
        break;
    }
  }
  return out;
}

var base64EncodeChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var base64DecodeChars = new Array(-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 62, -1, -1, -1, 63, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1, -1, -1, -1, -1, -1, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, -1, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, -1, -1, -1, -1, -1);

function base64encode(str) {
  var out, i, len;
  var c1, c2, c3;
  len = str.length;
  i = 0;
  out = "";
  while (i < len) {
    c1 = str.charCodeAt(i++) & 0xff;
    if (i == len) {
      out += base64EncodeChars.charAt(c1 >> 2);
      out += base64EncodeChars.charAt((c1 & 0x3) << 4);
      out += "==";
      break;
    }
    c2 = str.charCodeAt(i++);
    if (i == len) {
      out += base64EncodeChars.charAt(c1 >> 2);
      out += base64EncodeChars.charAt((c1 & 0x3) << 4 | (c2 & 0xF0) >> 4);
      out += base64EncodeChars.charAt((c2 & 0xF) << 2);
      out += "=";
      break;
    }
    c3 = str.charCodeAt(i++);
    out += base64EncodeChars.charAt(c1 >> 2);
    out += base64EncodeChars.charAt((c1 & 0x3) << 4 | (c2 & 0xF0) >> 4);
    out += base64EncodeChars.charAt((c2 & 0xF) << 2 | (c3 & 0xC0) >> 6);
    out += base64EncodeChars.charAt(c3 & 0x3F);
  }
  return out;
}

function base64decode(str) {
  var c1, c2, c3, c4;
  var i, len, out;
  len = str.length;
  i = 0;
  out = "";
  while (i < len) {
    do {
      c1 = base64DecodeChars[str.charCodeAt(i++) & 0xff];
    } while (i < len && c1 == -1);
    if (c1 == -1) break;

    do {
      c2 = base64DecodeChars[str.charCodeAt(i++) & 0xff];
    } while (i < len && c2 == -1);
    if (c2 == -1) break;
    out += String.fromCharCode(c1 << 2 | (c2 & 0x30) >> 4);

    do {
      c3 = str.charCodeAt(i++) & 0xff;
      if (c3 == 61) return out;
      c3 = base64DecodeChars[c3];
    } while (i < len && c3 == -1);
    if (c3 == -1) break;
    out += String.fromCharCode((c2 & 0XF) << 4 | (c3 & 0x3C) >> 2);

    do {
      c4 = str.charCodeAt(i++) & 0xff;
      if (c4 == 61) return out;
      c4 = base64DecodeChars[c4];
    } while (i < len && c4 == -1);
    if (c4 == -1) break;
    out += String.fromCharCode((c3 & 0x03) << 6 | c4);
  }

  return out;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  base64decode: base64decode,
  base64encode: base64encode
});

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAICAYAAADA+m62AAAAAXNSR0IArs4c6QAAAKZJREFUGBltkDEOwjAMRW16Fw7Q9AhdmNlBQoKNKyA4AgIViY2dqzTiNEyl5rmQCAGRHH/7fzt2xKpqZmVpFsJGvg65BrujmQ7UO9FRcEhax9gj5TQTVINXYnYS1Ro/Jm40xrVrstADOp8RLB0jjtq2YcBcowR+vNntM5eFPifEAjvSzZ+fp/lywd9lXht3cHsXqn+P9P0FvGXwXa4G0PFK54kURf0EV5FIt5rVulsAAAAASUVORK5CYII="

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAICAYAAADA+m62AAAAAXNSR0IArs4c6QAAAK5JREFUGBllkE0KwjAQhTvxLl7AK3TTEyQbxY2Kglfw7wYitCC40E2ysFcRbxS/iaYEHJjMm3mvL9NICGEWY7yLyN45d6qKgGtp53BTA/kAdAx2EJesU4zBiv5mre2lIPTrJdkhqKljDFqMtqoZhNp476+UhWJEL0QTxRrmW/5PXN/ldHD8LZ6uRjAiE85XJ8dSpAS5QahrrFnnTK0EUXoeY8yBvzvqMAfcE9zA1R9b3EXkt12arQAAAABJRU5ErkJggg=="

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGsAAAAsCAYAAABi4kbYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFHGlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDUgNzkuMTYzNDk5LCAyMDE4LzA4LzEzLTE2OjQwOjIyICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxOSAoV2luZG93cykiIHhtcDpDcmVhdGVEYXRlPSIyMDIxLTEwLTI4VDE2OjM3OjA3KzA4OjAwIiB4bXA6TW9kaWZ5RGF0ZT0iMjAyMS0xMC0yOFQxNjozODoyOSswODowMCIgeG1wOk1ldGFkYXRhRGF0ZT0iMjAyMS0xMC0yOFQxNjozODoyOSswODowMCIgZGM6Zm9ybWF0PSJpbWFnZS9wbmciIHBob3Rvc2hvcDpDb2xvck1vZGU9IjMiIHBob3Rvc2hvcDpJQ0NQcm9maWxlPSJzUkdCIElFQzYxOTY2LTIuMSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDowNzlkM2YzMy03YjdiLWYwNGEtOGY3Yy00Y2VhMTFjNWVmMDEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MDc5ZDNmMzMtN2I3Yi1mMDRhLThmN2MtNGNlYTExYzVlZjAxIiB4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ9InhtcC5kaWQ6MDc5ZDNmMzMtN2I3Yi1mMDRhLThmN2MtNGNlYTExYzVlZjAxIj4gPHhtcE1NOkhpc3Rvcnk+IDxyZGY6U2VxPiA8cmRmOmxpIHN0RXZ0OmFjdGlvbj0iY3JlYXRlZCIgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDowNzlkM2YzMy03YjdiLWYwNGEtOGY3Yy00Y2VhMTFjNWVmMDEiIHN0RXZ0OndoZW49IjIwMjEtMTAtMjhUMTY6Mzc6MDcrMDg6MDAiIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE5IChXaW5kb3dzKSIvPiA8L3JkZjpTZXE+IDwveG1wTU06SGlzdG9yeT4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5gLakNAAAGWUlEQVR4nO2baYwURRSAv52sKIiy4kUBKhIFEeMVokFEV6OQ5y0qxKDRiBoxiuuBikYjHqsJGhXRCNF4BQ1iPJDwFH6IUX5IIiiCghLjBcWhAiKHLIc/XjXbzM4MvWxvtLP9JZ3qqap+82pe1auqVz1VO3bsICcbFP5rBXKSkxsrQ+TGyhC5sTJEbqwMkRsrQ+TGyhC5sTJEVaVCJ1IAzgCGAAOAXkDHUPwHsAiYDUzxqt+2npo5UMFYTuQy4BGgT0JZHwNjvOr8NBTLaUoTYzmRA4CXgUtj2auAN4GZwGJgDbAvNtLOBIYDRwHbgMeBh7zqtlbVvA2yi7GcSHfMINFo2gyMBZ71qpvKCQnucjjwJHAI8C5wpVfd0hpKt1V2GiuMqM+BY0PWMkC86jdJhTmRLsAHwCnAW8Bwr5pHilMivhqcRKOhVgG1zTEUgFddAQwC5gNXArekoWSOUQXgRC7CRkTEIK86a0+FOpGewNdB/jFe9bcWaZkDQJUTqcJGwgkhb6pXHdpSwU7kPuAxYIJXvTXhM7Xhdq5X3VimzolADbA0rU7gREYD3YBxwHrgOmC1V52chvy0KACn0WgogCdSkj0B2ARc60Q6JHzmk3C9FjrRLjiRQcCXoc7lKekJtji6DTgY6Aw8DYxOUX4qFNh1if6jV52XhmCv+heg2CZ6UDMfvxy4P57hRI4GptCGoy7VwMDY5zmlKjmRI4EjgGVe9YdmyJ9DY/Tj/WY8twV4xIks8KrTnMj+2JxaAzQAexXpdzK2mOkH7A38DEwFXvGqW2P1ugJ12Gq1W0xO1xI6HOVEZof7r7xqnROZTmMEJ+J64MTw/a961VeLdHsJ24NeD6wApgMbQ3oJ0AP4Hft9ngHOAW7Etk8NmCcZ51UXVgO9Y7J/KvqiPtgGuX8sbz4wImGk4ueQ9q5Yqyk3AK8Ak51If6A+KD89lF8Q02cEtpItYI37Ezg3XEOdyAVe9R8ncjwWGjsA2A4sxzbxzeF0oBPwaVF+dyw4MLvEM/2waaYjNjjODPmC7WPXAUdjv3Ed4EK5Bw4E+gLDnEhtIXx5REN0E1Z0c4gZKnAS8JkT6ZugcdGmuCZB3TjTgHuxBs4FLgQWYNuBnT+wE+kGPI8Z6i5gP6/aBfMCn2G99K5QfRJmqA+BLl71MK/aw6v2AErFNZd61dpw1cULYvm1XnVpM9sG1lluAjoFfc8GNmCG+g7o41W7YgGGaZi3qC/2/11i9/WhcaXYF3gqgVI1SbUvxquOw0Z1e2AlcKFX/buommAN2Yi58ylO5H1gPNaLwXrlQcCpwFbgGq+6ek/1Son1XnViFOHxqp8AE0PZTK+6OOSvA0aG/AEFbBhGxN3VxSFdBAzFVkebY+XnJljlHRfStc1oSJybgY+Ai73qLyXK9w5pNTZvxK+umBveBuwT6jUAf+2hLknYvwXPljy18KrLMRu1qwaWYBMuwEAnEvnWqIFXeNXvAJzIgZh7AnM9nbFeXY7BIV2yJ9qHnicVqkQLoh3ASK+q8UIn0t6rbgqxS4+5mbuxYHNU53hssdESVoT0fCfyYOQBnMhh7OqtKrHb+bMa8+2RsdoBV2NxPQAiQwXWxu43YO6pJE4kmlihzCqzpXjVr5zIeGAUMMOJfAssxNrRF1gNDPCq253IPcDrQL0TGRrq9cTm5IrnegmYgZ3v9QJ+cCKfYlNALY2jv8UUgPeK8sYAO92bE6lxIp2dyGDgjli9yV61gfLUh/RvLJLfWtQB1wLzgGMwl30J1qOXO5F9ALzqG9j+bSHmJq8K6dtAKRebmLCnHAx8ARwKDAPOAmZhAfFUKBVuAtt8Dqvw3CJgoFddU6rQiYwEXggfE4ebWooTaY8tdxuAVeUi/k6kE7bSXBnfhyWQfzhQ8Ko/VajTARtVK7zq9uTa755ygdxy/Ir1xIdDb2pCkPUOtuHcQB7ITY34edZUmsbbXgTuLBdUjRMm8dux2GK0bB7lVZ9LSdc2T6XDx4hfsflnslddXyzAiVQD5wEPYLv1iPzwMWV2d6wfpwFb1X2PHU52wGJeA2m6ec6P9VuBpC/MJGUbNgrH5i/MpE+lV9GGAI+Sv4r2v6GlL3kuxCLNb+cvebY+VfnfVLNDmz11zSK5sTJEbqwMkRsrQ+TGyhC5sTJEbqwMkRsrQ/wLBPkE7ewTSkMAAAAASUVORK5CYII="

/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAYAAAC5tzfZAAAAAXNSR0IArs4c6QAAAMdJREFUKBV9kDsKwkAURWcUEiFYCKkkvVvQLEFsra1cgXuwcQ3uQlRwEdmClVhYB6zG8wLKy3y8cEje52Yy1zjn1iA6Q2YSYraXJbTtVngRQwNXyH0fvQM84Q7DrymjuEFgpKcN094HGea+MWWw2ilG6hOUUMAY3lBbax8848Iov9rCBkRVfFN1WZI7aF0ognB+Fob60hV1NJyUoUsJUzJV453Qi5WZn+pkQPPIcZJiC0FKpCbpreAFc1jIKSUsYUTjr9jZwewDQ4cWj2f/EY4AAAAASUVORK5CYII="

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/User-1.1d2a753.png";

/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAS9JREFUKBVjYMAFmi9dYWi6PJXh/38mbEqwCoIV/mc8zMDwP4uh5cpChlX/mdE149ZYq5PFwMg4HWhjDMPNy8sZ9v9nQdbMiMzBym6+1Mfwn6EQKLeRQYM5jCFM+xdIHW4bYabU6hUBbW4Hcv0Zbv7dyDD/PgdIirCNMANaLtUx/GNoBOrYxyAm4ssIDLnpDIz/DWDy+GlGQ6Cf2YEuOAD0MDC4/xNpM8x9QPUwJn6LQLLNl2qBFjSBncoh5ocSxDh1N11uBTqxCqhpBwO3YBBDkcR3whrB0fG/EKhpE4M6cyhDmCw4OjBSBNzW//8ZGVhCpgGdlwvUtIZBTDecIV7sN0wet0aWkBlA52UAg2Epg7puDEM84x+YJhCN26n/GWyBmqYz1OjkAOl/yJpAbABlrVItY2gXqwAAAABJRU5ErkJggg=="

/***/ }),
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAASCAYAAACq26WdAAAABHNCSVQICAgIfAhkiAAAARJJREFUOE/N0rFRw0AQheF/ZUyKSzAVYAUcIVACKYONXIIrgQ64sTyk0AGORWDTASUo91jLoIBBkn13QsPApbe33+y+E354VgmDzZY7IDcps5A2ElJUr1klDDcFTyCj8k7VmpSpr1dr7PWGC41KaFBpHgC2wrIxCSIPeyfwgMFYNsGC3PpWpYVenS143lXnxcqPUPDylY9PQ/N+xHFsyeulTiy7ZsRBCVXz8YGqU5N+bqJ69mLefJygrs2cOAgLzcflmbk2BvFm5ttYm/sGVubU46hNk121/R5v9U/SxMYsETnvikmhl6cLlt/7/DmWqDDsOtlhhI0t787JuiKu9801TrhHOemMbpmZR9b/KrNf+40fKRFgE/4jTiwAAAAASUVORK5CYII="

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAASCAYAAACq26WdAAAABHNCSVQICAgIfAhkiAAAAY5JREFUOE+9lf1RwkAQxX9XgdeBWoFSgcQGtAOHCoQKlArEDkIFYgOEErACoQLPCtZ5x8HgmWiCM+yfud19+/bjxXFEc4dgWeUfgXvAA0tg4oow/StXI5hVXok+UoIALICpK8IsvhkLHBd7AKUrwsAqPwTMFeE5B/8GZpW/xDh11+FVjlb5ErjLgsRilHwFeLL3PgJKjBWOd2DgiiDm0SJYYvEC9NP3bZVnEINyU5IytfMhe+wBYqci1ZGRfPfBZsBNFrQFrGMn156qtrkPGTu1e511JBbnrPJiUzUMV0DjBnZLV4ReQ6vr0p0LbJI2q2mZBsBtDXP5qxC1Op9rXa6ps7nXkK9+WVv1XZuVz0YhetPWtrGVwPKe1wWuEoM2SRt91Eb7V4a2wcb6eGAwVhuXmRK0rbW9n/GGoy9mOsCn9pEdPbdARQhbBWk63I6Zf7iPXREk2tF22hilxxhmatAdbMNEiiQN1WnsLBdi3YwOuI/FY/WN8zQ+0+9FJUuiJLhSFZ1JrR30P+tOdxPxBdm+lML3OsH3AAAAAElFTkSuQmCC"

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAASCAYAAACq26WdAAAABHNCSVQICAgIfAhkiAAAAXtJREFUOE+1lTtWwlAQhr9JIaWwAnEFZgeGHaTx0aklUKhlKmMhlGgBlNpaCTuIKzBLwA2IpdCM5yaCvBIDkTknTZI735355yFsau07G7FegDJoj9H4gmv/M82dbMoihgXAbuRDeaDuXf0PrNssA2eo2iDFGKA2IsUIZHFP1Rvkg3WbDsoN4KRmQfCperebw9rNc4THzKlWDRmPK0naJWu2LmhyoxTgalgs/lvmiJZ/DKh5lcXXq2GdRgBymAMGQoWqZ6p1asuw/FHFzpU+dc9Nh3UaLogPHOSKzByueXPBJBdIyy9S2DHl7qI4iOytDRf2Z3sv+wQxTa3qouIgUc/FkyO9seZ0S4UNj3FVuFQltISAEa+lHvH8M9piuYg6icW0UCSpsI8TzPiZT58SKgRLcKP1b9Sx3llhwyNstfi712bgpWf6EcTovVNwqXtP6dU483V4atZH9GSzL8JpmlecmKTRCG6G7TbMSGEG9GACM3uotQ0S8P6zMQbf5s1/Eyucr/YAAAAASUVORK5CYII="

/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAASCAYAAACq26WdAAAABHNCSVQICAgIfAhkiAAAAaFJREFUOE/llc1RwmAQhp9NwKswKh7FCsAKjA04lEAF4tmBMQwZr9KBODaADShWYKxAPIoH4xnCOh8CQvgxjHIytyS777PfvruJELk6ZQIR3J0a9ei7397LpMBbGUeFe1Wqux7ub8Wj+f8MhnKd8SiutY2dMnWEEoqf8ThYG+zdJdsNeR4Bkjb7aZf2XwLHA/JW4VThciRuJnIjQQMI0i7BKlAz1X0oSZ9q5gJ/lDuGvZZxRTifEA3ocUyCGvBoCS3b4mEe+N0l1QvJoTgKBYS80VG43a1RiAMz0T4hJ2pzI8LeuBDzHIKhaGrRqUU52vFozcBGCz2TqPhJpdC1uAYOV2jnQ6aGMxk/tdSdyqDi3BzBgD6nIryoDL4sP0GfkjZOtOXTsDPy2Dwuql6hbSkNDbmzbLZCvrwRyCJkVWmJ0E7aNOd5OwUziZ3KYJmvYrVLv/2YiE8ZL6PDMSxqVnYl4OKqlns28weAJsJmrFNOB/3sWVTU7E+3NxiIYiyo8qFQ30hQj+XZvFMMl7bYBwclP9455QPBN/toQWvbo7msC59BYaQThvzxRwAAAABJRU5ErkJggg=="

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loading; });

var loading = {
    data: function data() {
        return {
            loadingText: this.$t('Loading'),
            loading: false
        };
    },

    methods: {
        registLoading: function registLoading(key, chart) {
            var _this = this;

            this.loading = true;
            chart.on('finished', function () {
                _this.loading = false;
            });
        }
    },
    created: function created() {
        this.loading = true;
    }
};

/***/ }),
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAYAAADdRIy+AAAAAXNSR0IArs4c6QAAAaBJREFUOBGllLtOgkEQhZdLCD/hVhAqpNEWCQmxAqSHkhfAzmdAW3gBHwBqiL2+AgmJQkNPBQkmIkhAOJ75ucgKiuAmG2Znz/lm8u8EpfYsKGXnxnLb98iVdZ9AWa3XKpF4M7fE/1nsyg+n8xXNJswtMXNHM+Fy3SGfH2G1JGbuKCA7OYVhvKPbBRoNoNWCGRvGiHdnB0Ph9T6gWJxixAbdbiAQAGYzoFSa8u7xICA7uEQwOMR4DPR6qxcGplOYObmj5k9QCi3weNqo1RZfbjJZAF2u1ZcEqlWwy7Zo90IpukIsNvhyM/L5gHBYS5kaan8FEubmK76gXtfN0SiQSuk50YiWnk2oPtiGcaMyGYeKxzc1ikOtVDKp50STzTqUYdzqF8sTK51wiEfodPRO5NTvAwP9K5gi0YqH3i0oH+IehQJfYMfK5YB0GpjPty/FQ68GZIUL+P1DDIfbBslEIkAotBib7wrxiJeMNZQVmqhUdpRfumUefyomknJ5TsazAC0kn/P3SdlsH+sKxwSzmfy1Rc3BJNTBg/7ih0PnhE0+AfsI0E6dPreFAAAAAElFTkSuQmCC"

/***/ }),
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAYAAABiS3YzAAAAAXNSR0IArs4c6QAAAFNJREFUOBFj+M/AoAXEVxmoAGBmMVHBLAwjho6hGE4fYQKwZEANb8PMGjqxTxOXUiMoh7IZsGRADT/AzKJJRA0dQ6kRlNjNgAbwfyANw/DqhRw5ACO5LOZrGZ7OAAAAAElFTkSuQmCC"

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAACCAYAAACpDacGAAAAAXNSR0IArs4c6QAAABxJREFUCB1jZPjvaM/A8N+BgeaA8QATze1AsgAAnrEDg9H2nR0AAAAASUVORK5CYII="

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAYAAABiS3YzAAAAAXNSR0IArs4c6QAAAEVJREFUOBFj+M/AEArEqxioAGBmMVHBLAwjRg3FCBKKBUbDlOIgxDBgNEwxgoRigdEwpTgIMQygSZiyQK0BVSlARBWwGgDqOgkhWi5bvAAAAABJRU5ErkJggg=="

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAPCAIAAAC9X6JnAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFFmlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNi4wLWMwMDIgNzkuMTY0MzYwLCAyMDIwLzAyLzEzLTAxOjA3OjIyICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgMjEuMSAoV2luZG93cykiIHhtcDpDcmVhdGVEYXRlPSIyMDIxLTAxLTExVDEwOjUzOjM3KzA4OjAwIiB4bXA6TW9kaWZ5RGF0ZT0iMjAyMS0wMS0xMVQxMDo1NjoxNyswODowMCIgeG1wOk1ldGFkYXRhRGF0ZT0iMjAyMS0wMS0xMVQxMDo1NjoxNyswODowMCIgZGM6Zm9ybWF0PSJpbWFnZS9wbmciIHBob3Rvc2hvcDpDb2xvck1vZGU9IjMiIHBob3Rvc2hvcDpJQ0NQcm9maWxlPSJzUkdCIElFQzYxOTY2LTIuMSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDozOTFmYjkyYS05OGE0LWM3NDYtYTZhMy02NDgxZjM0YTg0YzMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MzkxZmI5MmEtOThhNC1jNzQ2LWE2YTMtNjQ4MWYzNGE4NGMzIiB4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ9InhtcC5kaWQ6MzkxZmI5MmEtOThhNC1jNzQ2LWE2YTMtNjQ4MWYzNGE4NGMzIj4gPHhtcE1NOkhpc3Rvcnk+IDxyZGY6U2VxPiA8cmRmOmxpIHN0RXZ0OmFjdGlvbj0iY3JlYXRlZCIgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDozOTFmYjkyYS05OGE0LWM3NDYtYTZhMy02NDgxZjM0YTg0YzMiIHN0RXZ0OndoZW49IjIwMjEtMDEtMTFUMTA6NTM6MzcrMDg6MDAiIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkFkb2JlIFBob3Rvc2hvcCAyMS4xIChXaW5kb3dzKSIvPiA8L3JkZjpTZXE+IDwveG1wTU06SGlzdG9yeT4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz72VBKrAAAAF0lEQVQYlWNkWPCfAS9gwi89qmIIqwAAVpIBvbY7CWEAAAAASUVORK5CYII="

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAABHNCSVQICAgIfAhkiAAAAERJREFUOE9jZKAyYMRlXupDl//IcrPl9+BUi6xu8BiIywdku3AEGEgodcFSAdFhSLKB6IFMyAB0eQwXjhpIahAy0CwMAaNpSBA/fTUrAAAAAElFTkSuQmCC"

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAPCAYAAADzun+cAAAAAXNSR0IArs4c6QAAALZJREFUOBFjZCAAUh+6uDAw/LcloAxNmvHwbPk9e9AEUbhMKDw0Tu5/T/b/DP93/2di/EcSBupp+J/AgWYcCpcFhYeVw/hrjuyeRqxSOASBoVSJQwoujNfHcFU0YIxaTINAxW7kaFBjDxcaiI4GNQ0CFbuRLKkPnXEWhz8e/WYHVhBs2LXiFgWW7+xPHz+pBpr9D5cqFlDhj0sSKP6dhYnJBo88VikWFiabP//+uzAwMmKVBwkCAHeUQIsY1i3ZAAAAAElFTkSuQmCC"

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAASCAYAAACNdSR1AAAAAXNSR0IArs4c6QAAAXdJREFUKBWFkT1LA0EQht+NFyWihelUbBTEwkIIMYWFoiiCjYofoIIgxKCNhQiSKrGwSJUqhZ2l+B/sbLTWHxALmxARxezuJRln93IhHycOzM7czvO+c8cBAUGpQpZOb2Y6R6HOCzoqjEO5l6jIfOesC4b6yUCrXig5Twe51VZBG0y715MM7kO7sKnc7J8wKjoNpUIsYJhT6VnayC77gqYzbaaHoeWe56oZNsmCijzvgvGpkgyEPdcGrKxghRYvJozAOtNCxoFUKetmAd/ZVsEbTwwszEGJ1BaI7k0fGAJlREZGHTuU+pAlgVzjMgpdXBMUO+6H/C4xG7G82RWoE7cOvj6mUatHrINgkpg01YTfezXuQFejqFW9Ydfpr+EqxBDD9RfU+I/9G+LV7qPoUpFXjrWtNeIWY+6vPHhgboc/6q59yrD/zsA7+ganLGxMKBzPs+Cs6WYurbMow8G2kE8PTdgKEFsH6kmmEvxc4nwEejICz29m/gt6j6YxZWz1KwAAAABJRU5ErkJggg=="

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAPCAYAAAAceBSiAAAAAXNSR0IArs4c6QAAAD9JREFUOBFj/L31f/2//wwNDHQGTIwMDUx0thPFulHLUYKDXpzRYKdXSKPYMxrsKMFBL85osNMrpFHsGdBgBwBlAwZMQ/V/HQAAAABJRU5ErkJggg=="

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAACCAYAAACpDacGAAAAAXNSR0IArs4c6QAAABtJREFUCB1j/M/AYM/AwOAAxLQGB5hobQOy+QCWbgJCJpGLywAAAABJRU5ErkJggg=="

/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAADJJREFUGBlj3PXU/j8DEYCJCDVgJSwwhW7SBxlhbGQaZiPRJg4FhYwwXyH7FBubaM8AADf8Cc9wVjeoAAAAAElFTkSuQmCC"

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAPCAYAAAAyPTUwAAAAAXNSR0IArs4c6QAAAChJREFUKBVjlDBoXsXw/38oAyHAyBTGREgNsvyo4tHQQA4BZDZJaQMA6j0EPxb2FcUAAAAASUVORK5CYII="

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAH9JREFUGBl9kNENgCAMRBu3YBgcxTVIdCvmcA528EPxnikfGpDkgPZeWqiZr2oWpSwVF/fY/OdUYpUuqX504jVodujQmaTg4k4OOJo2WlApvdooIOdeJuBNgKEDUh2vTF9zFAPubi4dqOV2WjMWHvz/GaoI2hwej6e1E0jl4cBvBJZmoWzTPLQAAAAASUVORK5CYII="

/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAPCAYAAADzun+cAAAAAXNSR0IArs4c6QAAAC5JREFUOBFjXPpixX+GAQBMA2An2MpRi+kW8qNBPRrUNAuB0cRFs6BFN3jkBTUAIAwDUuAPn7QAAAAASUVORK5CYII="

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAPCAYAAAD3T6+hAAAAAXNSR0IArs4c6QAAAQhJREFUOBFjZCAAMh976P359zsYpoyDjW3KZMntr0H8lEeu2Yz//4lhk4OJodNM6ALo/L//f6cxMDIy/Wdi/AfCP/+z/IepYWL4DxZDl0t77JKT88hVCqaO5nTqQ+ezKQ/djLFZRNCH2DRRIkbQwtRHLiWFj92FKLEEWS9BCxkY/mf8ZGAgzUJGpsncHBxPkC2CsVlgDGrSs+V2L8BlHhE+xKWVPHGCFjL+Z+pm4+F8Q4rx+LIFwSCdJb97JimWgdQCc2fiDwam40DmM3S9BH2IroFSPkELh362wFcAg+T+//+nzMBIWkDCsgU2s1lABfA/YKEMMxK9cGZgZA6cJrvzDkyeFBqb2QA6TnFjOW20iQAAAABJRU5ErkJggg=="

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAKCAYAAABi8KSDAAAAAXNSR0IArs4c6QAAACFJREFUGBljZFjEsYrh//9QBkKAkSmMiZAaZPlRxfQJDQD4yQQU6WQ0pQAAAABJRU5ErkJggg=="

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAPCAYAAADzun+cAAAAAXNSR0IArs4c6QAAAC5JREFUOBFjXLJkyX+GAQBMA2An2MpRi+kW8qNBPRrUNAuB0cRFs6BFN3jkBTUAGvQDCcqlF08AAAAASUVORK5CYII="

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAASCAYAAACNdSR1AAAAAXNSR0IArs4c6QAAAKRJREFUKBVjYAACZ2fnLE9PT1EQGx9gAin89+/f1J8/f+4npIGJjY1tNSMj49X///9rE9LACLIWZCJIIUgDSCM7O7vj9u3bX6M7CayYWA1wxcRoQFFMSAOGYnwasCrGpYEJJEEswGoyrqDEUIxLIch2FMX4FKIoJqQQrpgYhWDFwFQnDEwTBwmlC5BiJiEhoc9A+j6+BARSCAehoaFsIBvgAjgYAOoMqgKq8UXyAAAAAElFTkSuQmCC"

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAASCAYAAACNdSR1AAAAAXNSR0IArs4c6QAAAJZJREFUKBWN0rENgCAQBVChkB7jFA5hDBUDsIQOSOkU1g5gaUWFHAWRcMBdQfX+hVz+MHRGaz0rpXZgrGUBOudO7/3COT+q+A8ZY5cQYkMxBq21T4FrsPhzC2a4BxOmwIipEDCHhzrxGtTt6XSUQMLwlV4gw71AgVsBFGOBUKa1ejooTmxaaFwI31LKF5Y0JxR/MsaMgD6Mj6hciWiinwAAAABJRU5ErkJggg=="

/***/ }),
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAASCAYAAACNdSR1AAAAAXNSR0IArs4c6QAAAdRJREFUKBVtkk9IVFEUxr/7TCZcJChuXFkZgUiQbVwozVIXMhSMEwglCP6DdCGBIMqTKGEUCsFFUSsjRA2GWojVIhQ3QYjMooSC2Ua2MJzwvXvuPZ558uY54zx43Hu+73e/d9+5Fyh7ePBFLfc9WymTg9I5Jx7+c0GU4nvzA+WeOitwKn0V1n4H23dg3EZN9TW1/CgfMqXJvv9YUj+irv4+jM0j742HYGEswpxwW0B+r0DT6uWQhqVZ+DTBfe6lcEERhqYpSf2g3s/sBmYb3sLoP/irR0tg7ppsgta9kjYXGsp1LcgswOpx7l6MFfTTZI8egvSO2kx/DeFgvNC4DG2A41wqgDnuXpTP9cOapRJQCrUx5oH1a/GGAxje7x75McL1lkw5fFo7r+D77RwfbXZk1V3pQCboQAVafXmegzHf8J/uOLLXdhj/UwUukgx9LnACm3oQH0ROhZnVB9KpOkdSs/K2VkAiiUwrDGUdOYxt6fEDTiarIjea8c1kA7TfI6e5Jcmxp9K6RuzRE2YuvVi3BmtwJK0jyqr9tfXA5MuJTrBZhVL7kvkGjvoFgxtQPCK1h1hVQv3I5IpJ3NzdIPKMXM0OOdcrAmWhsIlqpNXPDa+wsRNoh9OHaWwsBgAAAABJRU5ErkJggg=="

/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAB1JREFUGBljZPjv85+BCMBEhBqwklGFeEOK6OABALVxAl7H/c2oAAAAAElFTkSuQmCC"

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAB1JREFUGBljZJj9/z8DEYCJCDVgJaMK8YYU0cEDADK1Aq12ptwdAAAAAElFTkSuQmCC"

/***/ }),
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__format__ = __webpack_require__(8);


/* harmony default export */ __webpack_exports__["a"] = ({
  getFormatterTip1TimeDetail: function getFormatterTip1TimeDetail(date) {
    var time = __WEBPACK_IMPORTED_MODULE_1__format__["a" /* default */].formatterDate5(date);
    var day = __WEBPACK_IMPORTED_MODULE_1__format__["a" /* default */].formatterDate4(date.getTime() / 1000);
    return day + '  ' + time[0] + ':' + time[1] + '<br>';
  },
  SGFormat: function SGFormat(e, context) {
    var icon = " <div style='background: #2cd200;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    var icon1 = " <div style='background: #e6be00;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    var icon2 = " <div style='background: #ff5c5c;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    var icon3 = " <div style='background: #a4a4a4;height: 8px;width: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    var icon4 = " <div style='background: #ff5c5c;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    var unit = context.isMg ? 'mg/dL' : 'mmol/L ';
    var type = e.value[2],
        tip0 = '';
    var value = e.value[1];
    if (value > 0) {
      var value1 = '',
          ico = icon;
      var isHighLow = true;
      try {
        var sg_val = parseFloat(value);
        if (context.isMg) {
          if (sg_val >= 400) {
            value = 'High';
          } else if (sg_val <= 40) {
            value = 'Low';
          } else {
            isHighLow = false;
          }
        } else {
          if (sg_val >= 22.2) {
            value = 'High';
          } else if (sg_val <= 2.2) {
            value = 'Low';
          } else {
            isHighLow = false;
          }
        }
      } catch (e) {
        console.log('sg tip:', e);
      }

      if (type === 'CX' || type === 'NC') {
        var hr1 = '<hr style="width: 25px;background:#FFF;height:1px;border:none;left:45px;top: 45px;position: absolute">';
        var hr2 = '<hr style="width: 25px;background:#FFF;height:1px;border:none;left:70px;top: 45px;position: absolute">';
        var hr3 = '<hr style="width: 25px;background:#FFF;height:1px;border:none;left:140px;top: 45px;position: absolute">';
        value1 = context.isEn ? value + hr1 : value + hr2;
        if (context.isFr) {
          value1 = value + hr3;
        }
      } else {
        value1 = value;
      }

      var selectData = context.DataS ? context.DataS : context.DataD;
      if (context.isMg) {
        ico = value > selectData.blos_high * 18 ? icon1 : ico;
        ico = value < selectData.blos_low * 18 ? icon2 : ico;
      } else {
        ico = value > selectData.blos_high ? icon1 : ico;
        ico = value < selectData.blos_low ? icon2 : ico;
      }

      if (isHighLow) {
        tip0 = ico + context.$t('SG') + ' : ' + value1;
      } else {
        tip0 = ico + context.$t('SG') + ' : ' + value1 + unit;
      }
    } else {
      var _ico = icon4,
          text = '';
      if (type === 'NC') {
        text = context.$t('Not Calibrated');
      }
      if (type === 'DE') {
        text = context.$t('noReadings');
      }
      if (type === 'CE0' || type === 'CE1') {
        text = context.$t('Calibration Error');
      }
      if (type === 'H') {
        _ico = icon3;text = context.$t('warm');
      }
      tip0 = _ico + text;
    }
    return tip0;
  },
  calibFormat: function calibFormat(e, context) {
    var unit = context.isMg ? 'mg/dL' : 'mmol/L ';
    var value = e.value[1];
    var icon5 = " <div style='background: #f00;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    return icon5 + context.$t('calib') + ' : ' + value + unit;
  },
  bgFormat: function bgFormat(e, context) {
    var unit = context.isMg ? 'mg/dL' : 'mmol/L ';
    var value = e.value[1];
    var icon5 = " <div style='background: #f00;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    return icon5 + context.$t('BG Reading') + ' : ' + value + unit;
  },
  transmtrFormat: function transmtrFormat(e, context) {
    var icon5 = " <div style='background: #00a107;height: 8px;width: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    return icon5 + context.$t('newSen');
  },
  alarmFormat: function alarmFormat(e, context) {
    var icon5 = " <div style='height:0;width:0;margin-right:1px;border-width:6px;border-style:solid;border-color:transparent transparent #f00 transparent ;float:left;display: inline-block'></div>";
    return icon5 + context.$t('alert') + ' : ' + e.value[2];
  },
  basalFormat: function basalFormat(value, name, context) {
    var basal_unit = 'U/H';
    try {
      basal_unit = context.$t('basal_unit2');
    } catch (e) {}
    var transValue = Math.round(value[1] * 100) / 100;
    if (!transValue && transValue !== 0) {
      return 0;
    } else {
      var icon = " <div style='background: #00ff4c;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
      return icon + name + ' :  ' + transValue + basal_unit;
    }
  },
  autosuspendFormat: function autosuspendFormat(value) {
    var icon = " <div style='background: #ff0000;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    return icon + value[2];
  },
  manualStopFormat: function manualStopFormat(value, name) {
    var icon = " <div style='background: #ff0000;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    return icon + name;
  },
  normalBolusFormat: function normalBolusFormat(value, name, context) {
    var ins_unit2 = 'U';
    var t_suggest = 'Suggested';
    var t_adjustment = 'Adjustment';
    var t_N = 'N';
    var t_CN = 'CN';
    var t_Carb = 'Carb';
    var t_BG = 'BG';
    var t_Glucose = 'Glucose';
    var t_Active_Insulin = 'Active Insulin';

    try {
      ins_unit2 = context.$t('ins_unit2');
      t_suggest = context.$t('t1102_Suggested');
      t_adjustment = context.$t('t1102_Adjustment');
      t_N = context.$t('N');
      t_CN = context.$t('CN1');
      t_Carb = context.$t('t1112_Carbs');
      t_BG = context.$t('t1112_BG');
      t_Glucose = context.$t('t1112_Glucose');
      t_Active_Insulin = context.$t('Active Insulin');
    } catch (e) {}
    var normalSuggest = this.getSuggest(value[3]);
    var icon = " <div style='background: #182f82;height: 8px;width: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    var tmpTip = icon + name + ' :  ' + value[2] + ', ' + parseFloat(value[1]).toFixed(2) + ins_unit2;

    if ((value[2] === t_N || value[2] === t_CN) && normalSuggest) {
      try {
        var wizzard_info = value[3];
        wizzard_info = JSON.parse(wizzard_info);
        var wizzard_carb = wizzard_info['carb'];
        var wizzard_bg = wizzard_info['bg'];
        var wizzard_iob = wizzard_info['iob'];
        var adjustmentType = wizzard_info['adjustmentType'];

        var iobName = t_Active_Insulin + ':';
        var BGName = t_BG + ':';
        if (wizzard_bg) {
          if (context.isMg) {
            wizzard_bg = Math.round(wizzard_bg * 18) + ' mg/dL';
          } else {
            wizzard_bg = parseFloat(wizzard_bg).toFixed(1) + ' mmol/L';
          }
        }
        if (adjustmentType) {
          iobName = t_adjustment + ':';
          BGName = t_Glucose + ':';
        } else {
          if (wizzard_iob > 100) {
            iobName = t_adjustment + ':';
            BGName = t_Glucose + ':';
          }
          wizzard_iob = this.changeIob(wizzard_iob);
        }

        if (wizzard_carb && wizzard_bg) {
          tmpTip += '<br/>&nbsp;&nbsp;&nbsp;' + t_Carb + ':' + wizzard_carb + ' g, ' + BGName + wizzard_bg + '<br/>&nbsp;&nbsp;&nbsp;' + iobName + parseFloat(wizzard_iob).toFixed(2) + ' ' + ins_unit2;
        } else if (wizzard_carb) {
          tmpTip += '<br/>&nbsp;&nbsp;&nbsp;' + t_Carb + ':' + wizzard_carb + ' g' + '<br/>&nbsp;&nbsp;&nbsp;' + iobName + parseFloat(wizzard_iob).toFixed(2) + ' ' + ins_unit2;
        } else if (wizzard_bg) {
          tmpTip += '<br/>&nbsp;&nbsp;&nbsp;' + BGName + wizzard_bg + '<br/>&nbsp;&nbsp;&nbsp;' + iobName + parseFloat(wizzard_iob).toFixed(2) + ' ' + ins_unit2;
        }
        if (normalSuggest) {
          tmpTip += '<br/>&nbsp;&nbsp;&nbsp;' + t_suggest + ':' + normalSuggest + ' ' + ins_unit2;
        }
      } catch (e) {
        console.log('出错啦： ', { value: value }, e);
      }
    }
    return tmpTip;
  },
  extendBolusFormat: function extendBolusFormat(value, name, context) {
    var ins_unit2 = 'U';
    var t_suggest = 'Suggested';
    var t_adjustment = 'Adjustment';

    var t_Carb = 'Carb';
    var t_BG = 'BG';
    var t_Glucose = 'Glucose';
    var t_Active_Insulin = 'Active Insulin';

    try {
      ins_unit2 = context.$t('ins_unit2');
      t_suggest = context.$t('t1102_Suggested');
      t_adjustment = context.$t('t1102_Adjustment');
      t_Carb = context.$t('t1112_Carbs');
      t_BG = context.$t('t1112_BG');
      t_Glucose = context.$t('t1112_Glucose');
      t_Active_Insulin = context.$t('Active Insulin');
    } catch (e) {}
    var icon = " <div style='background: #f9b4ff;height: 8px;width: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    var tmpTip = icon + name + ' :  ' + value[4] + ', ' + parseFloat(value[2]).toFixed(2) + ins_unit2 + '/' + value[7] + 'min';
    try {
      var wizzard_info = value[5];
      wizzard_info = JSON.parse(wizzard_info);
      var wizzard_carb = wizzard_info['carb'];
      var wizzard_bg = wizzard_info['bg'];
      var wizzard_iob = wizzard_info['iob'];
      var adjustmentType = wizzard_info['adjustmentType'];

      var iobName = t_Active_Insulin + ':';
      var BGName = t_BG + ':';
      if (wizzard_bg) {
        if (context.isMg) {
          wizzard_bg = Math.round(wizzard_bg * 18) + ' mg/dL';
        } else {
          wizzard_bg = parseFloat(wizzard_bg).toFixed(1) + ' mmol/L';
        }
      }

      if (adjustmentType) {
        iobName = t_adjustment + ':';
        BGName = t_Glucose + ':';
      } else {
        if (wizzard_iob > 100) {
          iobName = t_adjustment + ':';
          BGName = t_Glucose + ':';
        }
        wizzard_iob = this.changeIob(wizzard_iob);
      }

      if (wizzard_carb && wizzard_bg) {
        tmpTip += '<br/>&nbsp;&nbsp;&nbsp;' + t_Carb + ':' + wizzard_carb + ' g, ' + BGName + wizzard_bg + '<br/>&nbsp;&nbsp;&nbsp;' + iobName + parseFloat(wizzard_iob).toFixed(2) + ' ' + ins_unit2;
      } else if (wizzard_carb) {
        tmpTip += '<br/>&nbsp;&nbsp;&nbsp;' + t_Carb + ':' + wizzard_carb + ' g' + '<br/>&nbsp;&nbsp;&nbsp;' + iobName + parseFloat(wizzard_iob).toFixed(2) + ' ' + ins_unit2;
      } else if (wizzard_bg) {
        tmpTip += '<br/>&nbsp;&nbsp;&nbsp;' + BGName + wizzard_bg + '<br/>&nbsp;&nbsp;&nbsp;' + iobName + parseFloat(wizzard_iob).toFixed(2) + ' ' + ins_unit2;
      }
      var extendSuggest = this.getSuggest(wizzard_info);
      if (extendSuggest) {
        tmpTip += '<br/>&nbsp;&nbsp;&nbsp;' + t_suggest + ':' + extendSuggest + ' ' + ins_unit2;
      }
    } catch (e) {
      console.log('extend bolus tip:', e);
    }
    return tmpTip;
  },
  newPatchFormat: function newPatchFormat(value, name) {
    var icon = " <div style='background:yellowgreen;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    return icon + name;
  },
  stopFormat: function stopFormat(value, name) {
    var icon = " <div style='background: #ff0000;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    return icon + name;
  },
  alertFormat: function alertFormat(value, name) {
    var icon = " <div style='height:0;width:0;margin-right:1px;border-width:6px;border-style:solid;border-color:transparent transparent #f00 transparent ;float:left;display: inline-block'></div>";
    return icon + name + ' :  ' + value[2];
  },
  autoModeBasalFormat: function autoModeBasalFormat(value, name, context) {
    var basal_unit = 'U/H';
    try {
      basal_unit = context.$t('basal_unit2');
    } catch (e) {}
    value = Math.round(value[2] * 100) / 100;
    return name + ':' + value + basal_unit;
  },
  autoModeCorrBolusFormat: function autoModeCorrBolusFormat(value, name, context) {
    var t_auto_correction = 'Auto mode correction bolus';
    var t_auto_meal = 'Auto meal bolus';
    var ins_unit2 = 'U';
    try {
      t_auto_correction = context.$t('t1029_Auto_mode_correction_bolus');
      t_auto_meal = context.$t('t1029_Auto_meal_bolus');
      ins_unit2 = context.$t('ins_unit2');
    } catch (e) {
      console.log('t_auto_meal:', e);
    }
    var tmpTip = '';
    if (value[2]) {
      tmpTip += t_auto_meal + ':' + parseFloat(value[2]).toFixed(2) + ins_unit2;
    }
    if (value[1] && value[2]) {
      tmpTip += '<br/>' + t_auto_correction + ':' + parseFloat(value[1]).toFixed(2) + ins_unit2;
    } else if (value[1]) {
      tmpTip += t_auto_correction + ':' + parseFloat(value[1]).toFixed(2) + ins_unit2;
    }
    return tmpTip;
  },
  getSuggest: function getSuggest(bolusInfo) {
    if (!bolusInfo || bolusInfo === '{}') return 0;
    var bolusInfoJSON = undefined;
    if (bolusInfo instanceof Object) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(bolusInfo) === '{}') return 0;
      bolusInfoJSON = bolusInfo;
    } else {
      try {
        bolusInfoJSON = JSON.parse(bolusInfo);
      } catch (e) {
        console.log('错误json： ', bolusInfo);
        return 0;
      }
    }

    var suggest = 0;
    var data_source = sessionStorage.getItem('data_source');
    if (!data_source) return 0;

    if (data_source === 'daoppdm') {
      if (undefined == bolusInfoJSON.carb_bolus) {
        bolusInfoJSON.carb_bolus = 0;
      } else if (undefined == bolusInfoJSON.bg_bolus) {
        bolusInfoJSON.bg_bolus = 0;
      } else {
        var _ref = [bolusInfoJSON.carb_bolus, bolusInfoJSON.bg_bolus];
        bolusInfoJSON.bg_bolus = _ref[0];
        bolusInfoJSON.carb_bolus = _ref[1];
      }

      bolusInfoJSON['corr_bolus'] = this.change2SignedNumber(bolusInfoJSON.bg_bolus);
    } else {
      if (undefined == bolusInfoJSON.carb_bolus) {
        bolusInfoJSON.carb_bolus = 0;
      } else if (undefined == bolusInfoJSON.corr_bolus) {
        bolusInfoJSON.corr_bolus = 0;
      }
    }

    if (bolusInfoJSON['adjustmentType']) {
      suggest = bolusInfoJSON.corr_bolus + bolusInfoJSON.carb_bolus + bolusInfoJSON.iob;
    } else if (bolusInfoJSON.iob > 100) {
      bolusInfoJSON.iob = this.changeIob(bolusInfoJSON.iob);
      suggest = bolusInfoJSON.corr_bolus + bolusInfoJSON.carb_bolus + bolusInfoJSON.iob;
    } else if (bolusInfoJSON.corr_bolus < 0) {
        suggest = bolusInfoJSON.carb_bolus + bolusInfoJSON.corr_bolus;
      } else if (bolusInfoJSON.corr_bolus <= bolusInfoJSON.iob) {
        suggest = bolusInfoJSON.carb_bolus;
      } else {
        suggest = bolusInfoJSON.carb_bolus + bolusInfoJSON.corr_bolus - bolusInfoJSON.iob;
      }

    return suggest.toFixed(2);
  },
  changeIob: function changeIob(UnSignedNumber) {
    if (UnSignedNumber > 100) {
      if (UnSignedNumber > 500) {
        var val = Math.round(UnSignedNumber / 0.05) & 0x3fff;
        if (val > 0x1fff) {
          UnSignedNumber = (val - 0x4000) * 0.05;
        } else if (val >= 0) {
          UnSignedNumber = val * 0.05;
        }
      } else {
        var _val = Math.round(UnSignedNumber / 0.01) & 0x3fff;
        if (_val > 0x1fff) {
          UnSignedNumber = (_val - 0x4000) * 0.01;
        } else if (_val >= 0) {
          UnSignedNumber = _val * 0.01;
        }
      }
    }
    return UnSignedNumber;
  },
  change2SignedNumber: function change2SignedNumber(UnSignedNumber) {
    if (UnSignedNumber > 327.67) {
      var strNum = new Number(UnSignedNumber).toString();

      var val = Math.round(UnSignedNumber * 100);
      var max = 655.36;
      if (val % 5 == 0) {
        max = 655.35;
      }
      return UnSignedNumber - max;
    }
    return UnSignedNumber;
  }
});

/***/ }),
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAYCAYAAAAYl8YPAAAAAXNSR0IArs4c6QAAAq5JREFUOBGdlF9IU3EUx8/53bvprCSKrJxzPURJy/6A4EMPUiBCUZlDiJAe+kME9pQPYQg9SRAFIda7vkj5pxBW9CQEQUEIc4sehFxDEmmIqZvO3d/p/LSN7XJ/d9CFsXu/53w/93fP75wfguYKjf5sA6Bu/jUTQjUCzhPBB2Ga/bF2f9LJhnaxOZKqXs2sPSOSN1WMIRYgpRhUs/0My4h4LxYODtu9wi6sZlaHFQgRvgtDtFXXil3x8KH96Ks6iCDuM94riYZCY8lrdm/Jyo5PJLqkRfxG/Bisqm99dx437IbGN8lGmZOfWc+AzxeKX6hZyOeUrIwk9PNnZdAjbjiBlGmmPTADAh8S0B5cT/fkQeq/ADvxdv4oEQUI4FP8cmC2OMl+vwPEkNK4jq3FsQIMZK5uO4DTxQlO91866lK8Mwkuxz/PdlYBRiC8SkKUy04Au4YEKq+iWC/AisX/vd/azcbxZIsl5S2uQhf30LAgMVIOaKE1yKvzo4BeD3lfT4drExganevmog+UM7vGEVY8aDaZXKUHiPTS8MATV4MmKLKGuQnyfY6suyb3ix9JzEYv1f/Q5JeVj43NLfKi/Lwy/XU68mvfZibbx+NzmIsb6QwHXzzi7dY5XGEb6Y1Jnoi9vClTQPD41XhStcJTHUzbGicnk342NQsDrsbDwdvcpINAslMHUroWZoKxxJ+W5RE7e2piaTfnNnFdCkPtBNXCvl6sTRNijxr+rPUnxeYjhin6nCB5TQtTCd/CwQEQ4joC5YydFQ1bJ0be6fDvClP5XPwFXuFKtO3AmoO/RCoLi10JTPm8noYSl+ZB8JvTCNLQxLdkrt9vtzi3j8FzmlazOcbbfoY/KOpmcIkZ3IMtfPp2mZUV3jvr2exzPjbPMbTSxaQJoTooe+Md9SN/AV9J3Idqlb+fAAAAAElFTkSuQmCC"

/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAXCAYAAAALHW+jAAAAAXNSR0IArs4c6QAAAytJREFUOBGVVF1IVEEUPmfuupJIFJahubtUROVd+8GgKAnqqQQR3TCsx4jINymUHvp5iQokipCglwILEdyVsDJK8KlSSEpzfclid819EMoyc03bO32zci+ztos1MMw353zz3TPnnDtMGUbZ4+hq+YvPSClriGmTJFoF2hfMPrdwN72rKYpkOJYy8VLH9lDMn5RWr5S0jol/EsmPkmmWiAtIys3MPIUzz4mNq+HakqGl59MEy7vjeYn5hTGWVCiZm1e4XXcGq4ohtjhKQ5ETJOkKpg8fmyFhVGQStflkBqNNpZ0RqVbHmAGYofHDpcGoBW4/0pIWlND5yNUx7OdWFonbun0pDtd6nuH692Df4++K7df9juBlKQWuugNX+fB6nyehkzJhFvQwZbfokO53BHt6vuZLkgai/KQTsmHB/D3lE9KtcxzBgcqCabTID0yPTsiGLYs2LPqEaidnOIIpi6Qx5KZUXd9hZANM5cplsBzWKc5BVS3kz4c+m7iE5tNJmTDyParsVpL8ut8RhJBqAAtOriNy7DpZx+CmOMh7UrenHYRkGyLdGA6OX9NJS/GuYNyHP6kFN0q4c0RI96cJUkHeRXTpMLE86w/Ft+lEHc/TwnXkeg0xN7yt9sZ1X5pg+GDhjCDjPMgsrYVGnWhjszvuBQ4gujfhgPe+bbfXNEFlHA6U9CCNYVTlJH7BozZRrUeeylw5P9+BtLiQ8xbdZ+O/BFVxDJeoR8nnUOxWm6jWWOJzAPXfi7S0jwS8HbrPxi4bqNXsm8znb4lKmbQq1F+Da0V0PxvJiPytLOw3Q9FmwdT7vsY3mMZRG9WD/uB4I7F1AdVTjynyTZMGuaqRgn61t4cZjLSC02Dv8dFXhuDTw7XeEWVLPT1mZ/QuIjqF/TSzuGUY9CKnxNM/uJsX7IP6Wh6MFCUYj4Kk45iVSNOsEHRARctmZySAAnTiwEBOrhEYqvJM6IeXw2ZXrJ6Ssg33HFtb4Nsp0PHnEHaSc911/yumPhau8bajjjcR1JbJqVgV3kAug300XFUcWy6abH5JrifKp7TwrNEDVOBGNvI/2beufwm5R3gC+v4ATcMgL+ZeiG0AAAAASUVORK5CYII="

/***/ }),
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAATCAYAAABhh3Y4AAAABHNCSVQICAgIfAhkiAAAAg5JREFUSEulVD1y02AQffsZzVDKNlEKGtcMM4gT4NQ0oaZAMk264BPEuYE5ALIYUtHEFS3mBIRhqBNKK8hRaGXtMmtbGY2xkZBVWt739H52CTUf27vuNkhOBHABSUA0Ybb6SdhMtkFSHS7bu+k0THopwC0EYxBcAp5AMIlHzsHOZO3Xvw6zTJIk3Ju0etMBgU4yxtMkdC4UvOVHIRFeZWw1t6mrpGxhmZHPCirAUFjuG0NHceDczbd7kQdglDEd6AdtUldKZns3tqH0EoSfahMRjkWgudgsfysrfsA6YSnZumWq0hCfAfRQCHOIfCTQIyK4AjmdBfuD2pmpMiDt5NkoULN3/dJAzmSJOhfGDzIUzoK9oWYrws9mgdP/b2XrA0VbmeEZg1CbqFkyW28NpV8J+BaPnO7OZC1/+h1Ej+cpnv/+4HxaNHHVzlWBbpktNwmbVzuRrSw6z4MWIGS2ThXY9iK3QTIA0TgOnLBWG/Oh3D61KBPLM5QOdK/KSlEk3dhGtQUwwnzvfW5H25+OhahbtKjdi2R3Mj8a6j4tMhBcgDAh4I2A+to4/f1u0cm8iN89GFc5e1v3TO+fMfNDQLzV3ftSbJjmB+Hz4skqIyxd6qWKyAWsq+LNyxv4r4uxUxuLw8sM4c6C/U6Zovx9JWWbwNp+tDi2m5a39rnaNrhUZiZ5Yaqoq62sCvj6f/4A13gKIzfD04UAAAAASUVORK5CYII="

/***/ }),
/* 220 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Verfication Code.3fbda9d.png";

/***/ }),
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(exports)) && "object" == ( false ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(module)) ? module.exports = t(__webpack_require__(11)) : "function" == typeof define && __webpack_require__(508) ? define(["echarts"], t) : "object" == (typeof exports === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(exports)) ? exports.dataTool = t(__webpack_require__(11)) : (e.echarts = e.echarts || {}, e.echarts.dataTool = t(e.echarts));
}(this, function (e) {
  return function (e) {
    function t(o) {
      if (r[o]) return r[o].exports;var n = r[o] = { exports: {}, id: o, loaded: !1 };return e[o].call(n.exports, n, n.exports, t), n.loaded = !0, n.exports;
    }var r = {};return t.m = e, t.c = r, t.p = "", t(0);
  }([function (e, t, r) {
    var o;o = function (e) {
      var t = r(1);return t.dataTool = { version: "1.0.0", gexf: r(5), prepareBoxplotData: r(6) }, t.dataTool;
    }.call(t, r, t, e), !(void 0 !== o && (e.exports = o));
  }, function (t, r) {
    t.exports = e;
  },,,, function (e, t, r) {
    var o;o = function (e) {
      "use strict";
      function t(e) {
        var t;if ("string" == typeof e) {
          var r = new DOMParser();t = r.parseFromString(e, "text/xml");
        } else t = e;if (!t || t.getElementsByTagName("parsererror").length) return null;var i = l(t, "gexf");if (!i) return null;for (var u = l(i, "graph"), s = o(l(u, "attributes")), c = {}, f = 0; f < s.length; f++) {
          c[s[f].id] = s[f];
        }return { nodes: n(l(u, "nodes"), c), links: a(l(u, "edges")) };
      }function o(e) {
        return e ? s.map(u(e, "attribute"), function (e) {
          return { id: i(e, "id"), title: i(e, "title"), type: i(e, "type") };
        }) : [];
      }function n(e, t) {
        return e ? s.map(u(e, "node"), function (e) {
          var r = i(e, "id"),
              o = i(e, "label"),
              n = { id: r, name: o, itemStyle: { normal: {} } },
              a = l(e, "viz:size"),
              s = l(e, "viz:position"),
              c = l(e, "viz:color"),
              f = l(e, "attvalues");if (a && (n.symbolSize = parseFloat(i(a, "value"))), s && (n.x = parseFloat(i(s, "x")), n.y = parseFloat(i(s, "y"))), c && (n.itemStyle.normal.color = "rgb(" + [0 | i(c, "r"), 0 | i(c, "g"), 0 | i(c, "b")].join(",") + ")"), f) {
            var p = u(f, "attvalue");n.attributes = {};for (var v = 0; v < p.length; v++) {
              var d = p[v],
                  g = i(d, "for"),
                  h = i(d, "value"),
                  b = t[g];if (b) {
                switch (b.type) {case "integer":case "long":
                    h = parseInt(h, 10);break;case "float":case "double":
                    h = parseFloat(h);break;case "boolean":
                    h = "true" == h.toLowerCase();}n.attributes[g] = h;
              }
            }
          }return n;
        }) : [];
      }function a(e) {
        return e ? s.map(u(e, "edge"), function (e) {
          var t = i(e, "id"),
              r = i(e, "label"),
              o = i(e, "source"),
              n = i(e, "target"),
              a = { id: t, name: r, source: o, target: n, lineStyle: { normal: {} } },
              u = a.lineStyle.normal,
              s = l(e, "viz:thickness"),
              c = l(e, "viz:color");return s && (u.width = parseFloat(s.getAttribute("value"))), c && (u.color = "rgb(" + [0 | i(c, "r"), 0 | i(c, "g"), 0 | i(c, "b")].join(",") + ")"), a;
        }) : [];
      }function i(e, t) {
        return e.getAttribute(t);
      }function l(e, t) {
        for (var r = e.firstChild; r;) {
          if (1 == r.nodeType && r.nodeName.toLowerCase() == t.toLowerCase()) return r;r = r.nextSibling;
        }return null;
      }function u(e, t) {
        for (var r = e.firstChild, o = []; r;) {
          r.nodeName.toLowerCase() == t.toLowerCase() && o.push(r), r = r.nextSibling;
        }return o;
      }var s = r(1).util;return { parse: t };
    }.call(t, r, t, e), !(void 0 !== o && (e.exports = o));
  }, function (e, t, r) {
    var o;o = function (e) {
      var t = r(7),
          o = r(1).number;return function (e, r) {
        r = r || [];for (var n = [], a = [], i = [], l = r.boundIQR, u = 0; u < e.length; u++) {
          i.push(u + "");var s = o.asc(e[u].slice()),
              c = t(s, .25),
              f = t(s, .5),
              p = t(s, .75),
              v = p - c,
              d = "none" === l ? s[0] : c - (null == l ? 1.5 : l) * v,
              g = "none" === l ? s[s.length - 1] : p + (null == l ? 1.5 : l) * v;n.push([d, c, f, p, g]);for (var h = 0; h < s.length; h++) {
            var b = s[h];if (b < d || b > g) {
              var x = [u, b];"vertical" === r.layout && x.reverse(), a.push(x);
            }
          }
        }return { boxData: n, outliers: a, axisData: i };
      };
    }.call(t, r, t, e), !(void 0 !== o && (e.exports = o));
  }, function (e, t, r) {
    var o;o = function (e) {
      return function (e, t) {
        var r = (e.length - 1) * t + 1,
            o = Math.floor(r),
            n = +e[o - 1],
            a = r - o;return a ? n + a * (e[o] - n) : n;
      };
    }.call(t, r, t, e), !(void 0 !== o && (e.exports = o));
  }]);
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1510)(module)))

/***/ }),
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAACCAYAAACpDacGAAAAAXNSR0IArs4c6QAAAB5JREFUCB1jdHNz+8+AA+zatYsRJkUNdUwww+hBAwCZqgnVq0+DEQAAAABJRU5ErkJggg=="

/***/ }),
/* 295 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABHNCSVQICAgIfAhkiAAAARBJREFUKFOlksFVg1AURO+wcSkbDUusQEpICSlBK5BgAaEBCXaAHWAFpgO1gyzBlTbA83wEDyRKFvzNP+f/NzNv3hsx4+gQG8QszeMOI5SIzPiUKGl4qnJ2w/oROFhTmAOI9OOBsi+8vGclIxW8Vhm3/fsveLEmF/jVlpv/nDhyhPUELfgiJvI8ijojOjWCRcKbGmJnoQUHMaG7q5x9D+5UdlVGMSR0FryGlevwaGB9oR/jn3ktez4k6N73dYb/o5xgk+02XI26SlrfmlYWLxKP08pzPM+atvPb7lmcD0NwlD63Z7eVLgsjz44AscTY1FueRwlr2AjehyH6K9shInUxFVwbfMkoMYrJbJ9K1+H/N3ohcxClNV46AAAAAElFTkSuQmCC"

/***/ }),
/* 296 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABHNCSVQICAgIfAhkiAAAAPNJREFUKFOlk4ERwUAQRd9WQAk6oANK0AE60IGUEB0oITqgAnSQEnRw5uc25xDCuJnMZHL7d///+2P8cewZG2AGLIA5MATO/mwtvqfzAA6wAyZAYVC1VSE2KoCTwar9nsAOxGD5TonXXA3WqmnATrW0OPXtCVHGAVhKQgsW3Sqn2uHFyLWLmYB1CxYVdf14QpRUArN8cjCX4DJkzuZDp6PFBo3mXybLLAGFacDfatb6RF3ApFnB6HXbBykod7ez6dKeQtDhuBg+7jlLki7HnrC9N9UWpp4wGdUEJIUkn+CBkS5FcgBcfL+KbJ3XvvwYfbvO729PpEgQtpEQIQAAAABJRU5ErkJggg=="

/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAACCAYAAACpDacGAAAAAXNSR0IArs4c6QAAABZJREFUCB1jtHlx5z8DnQATnewBWwMAhzYDAw07Af4AAAAASUVORK5CYII="

/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAACCAYAAABL0bx/AAAAAXNSR0IArs4c6QAAABxJREFUCB1j1HS6tOo/A0MoAx0AEwNDGBDTFwAA9qIDl0HBhFcAAAAASUVORK5CYII="

/***/ }),
/* 299 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAACCAYAAABL0bx/AAAAAXNSR0IArs4c6QAAAB5JREFUCB1jrN5rGfqPgWEVAx0AIwPDaiY62INiBQBIUAQenrzH7gAAAABJRU5ErkJggg=="

/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAACCAYAAACpDacGAAAAAXNSR0IArs4c6QAAABZJREFUCB1jvPO0+D8DnQATnewBWwMAtB8DNzdr+tQAAAAASUVORK5CYII="

/***/ }),
/* 301 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAACCAYAAABL0bx/AAAAAXNSR0IArs4c6QAAAB5JREFUCB1jfC4xbdX///9DGegAGBkZw5joYA+KFQD6dQXukhihWwAAAABJRU5ErkJggg=="

/***/ }),
/* 302 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAACCAYAAABL0bx/AAAAAXNSR0IArs4c6QAAAB1JREFUCB1jPFkkF8rwn2EVAz0AI8NqJnrYg2wHADOWBAcT9sXzAAAAAElFTkSuQmCC"

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAACCAYAAACpDacGAAAAAXNSR0IArs4c6QAAABZJREFUCB1jXKl08z8DnQATnewBWwMAOgYCpwopLxwAAAAASUVORK5CYII="

/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAQCAYAAAD52jQlAAAAAXNSR0IArs4c6QAAAJlJREFUOBFj+G9n5wXEGxmoAGBmsTAwMTEx/PvHTAUzGRgPHdoGNGcbEzUMw2rG/4YGqhkOMosRqy1kCv53cPABBmUG1VyI7A4mWIwhC5LN/vfvH1Dv39HYJzsEMTSOxj4477NAA0YUFkD/7e1TgblCBsxnZZ3FuG/fUxCbFHEmxgMHtjBwc/vADGX4//8fAyMjBDMz/ydHHACQpGDGfgU9sgAAAABJRU5ErkJggg=="

/***/ }),
/* 305 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAUCAYAAADlep81AAAAAXNSR0IArs4c6QAAANdJREFUSA3tlkEKwjAQRU3wEsVDuOleL6LbkJ2C4h1EcJl2qwuvUfcFTyG5ReL/kq5n1aaLDJSZZkL+YzKQUQuYc24Fd1NKbWKMFdemMmh6aL6hd7LWflWC6bFw11o/jTF+KhjqtG1bhRB2CI/4agK9EHxAd4XPZk3TXCC+1rwmViYbSRIGxwPhlv0Tc8MM+mTRw89cfAGSbqJUqFRIqoCULz1UKiRVQMrzcfUcAaSNY+fJQBY2dYcBaT+2oHR+YuiWCM7Y3P9f2owDGjgO4KgVyQEzmxH2Bz14VUBqeLIvAAAAAElFTkSuQmCC"

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAOCAYAAAD0f5bSAAAAAXNSR0IArs4c6QAAAWpJREFUKBWFUsFKw0AQ3dnsbE22SWnMQXrwqpKLEPwCv8KTiEfBkyDegh8gCh5E8CCKevcLvAjFD/Ai9FZBQdBDqU2adTZ2IwXbBpZ5u/Pe7JvZMDblq0u54gp8dh3seIhrU6h/Kc/BU9cR+nfhnc1wC2xstVqeL+VyGIYBcNa254xwkiTo+/58dRbHsVQCT6hqf1T9m246V1JuKDG3HgRBSFYfPUe8ViLyfWXIRLxUiFuEByPxwBPYJvxFa0i9bVf2AKADHHZ6w2yzYKxO1bCsCPDEmH4HBjecQ9LLsovqJguiKPLJwpu5heKHsWVzE6Mn5OHIllZC7P1H5H6ttqSUWkjTlJtetC4OLLEAyC0ei+bhTIO0TKPGUrccBE2q3Atxb8Y/JiLCKo36mMS3ZGe/0Wg0DUFrDS7iLglzyl2PiWZt6AnOSFiYX2oWt8o3XXeRRANyc2QPHQsmxX6ef9ZQvGjGHrKi6BreD1QnVFPqMDXpAAAAAElFTkSuQmCC"

/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAUCAYAAADlep81AAAAAXNSR0IArs4c6QAAAEJJREFUSA3t0rENADAIA0HCatm/yEREYoFvXTytG+vwmXengq6DumwVC9FHFFKIBCh3QwqRAOVuSCESoNwNKUQClH+wcwM6aq3eqQAAAABJRU5ErkJggg=="

/***/ }),
/* 308 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAQCAYAAAD52jQlAAAAAXNSR0IArs4c6QAAAGZJREFUOBFj/O/gIMHw799pxkOHZBkoBP9tbSUZGBnPMTH8/csINIuFQvNQtDOh8KjEGTWUSgGJZMxomCIFBpWYIzxMIQXJ//8SwBKmkQpBKskANAtUQjEADfQGFlkmVDAUaNj/zQDetBVsprARrAAAAABJRU5ErkJggg=="

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAFCAYAAABIHbx0AAAAAXNSR0IArs4c6QAAAHNJREFUGBlj1NDQ2MHIyGjLgAMwMTFpcnBwfAOChziUgITPsgCJaiAWBPGwAVFR0VefP3/+C5TzxyYPEgNa9gmXHMnijECvTQJ6zRCXTqBtoaysrD9+/vy5GZcaoPgNFqAhx4CMJ7gU8fDwfAMa9puAQc8BJSodfT4xFtMAAAAASUVORK5CYII="

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAPCAYAAAD3T6+hAAAAAXNSR0IArs4c6QAAAmBJREFUOBG1lD1s01AQx7HjpInIB0lqRZQIipShdEPJgJiydCgLLAgJiY+pYmFhYSQoCztioGKksMFCF9SNrQtdEBsDjRoJaAgIycaKbX5n5UWvttONJ53u7n/3v3t+vveME/95dTqd9TAMN6WNYRgbpt6PgJHL5VZs2y7q+HF2s9kswFnt9XpHaimONEOaU9mcJWUymauWZX3zff/zaDT6if+y3W5nFTGupQE5z4bD4RjOp36/f5jNZu/E81J9Ei9B9pCnhULhLPoKMkZepBIA2dwT4i5fdwPOGfzH+D6yrnPkSNn4vojYUYyk1xB25UhVMpu4C+4Vi0VbYUo3Go2TxH7Beagw0fjbyHsdS9itVmsBskviAz1Yq9XK4H9pfE/HxQa/joRyGnqM3FvgQalUWtRx3TYHg8FpgAXkox7gP/5mqr7w1ed1XGzwZdSh4zhf0bMFvodjuK57bgbGDHMymSwJZprm91hM3B80lA3F1xLFE/l8YYQFQRDVjJPElym1pgF/qnUlWE4HxGYTwknkswmFzZ1uGe0DKcKu0s59kSJRXHLUEoymiXzP8yKM+FDlxrVZr9elYEDSBT0ow0TRZbCBjovN8e+jbIajrse4jyvic7QSn7+Y0HfIjp7Bl1+Ticvn84mhKZfLNWIOhTdinFfU2dWxVJukNSmOflSpVKroy/gH6LeKgP0G+aB84s+RMdhatVqt0Pw+fshDcFPlHKsh3IbwR0giFNqWC65I+DvIHsccPQ7y7JG3hcjrIhyH+JG7rLhzdbfbtWh8Me3iSqO0B/oUC05b/vncwlrgH1yYscb6hTstAAAAAElFTkSuQmCC"

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAAAXNSR0IArs4c6QAAADdJREFUKBVjDHvM/Z+BRMBEonqwchaYplWyXxlhbFw0zFVk2TSqCRqs9AsIRliE4YpQbOJkOQ8AxOYIobik/7kAAAAASUVORK5CYII="

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAUCAYAAAAKuPQLAAAAAXNSR0IArs4c6QAAAE9JREFUSA3t0LENACAMxEBgWHaCOTJfROnuawqnsvRNdLOqdnef8c/d9c8vfOJTWORSKvuwKoVFLqWyD6tSWORSKvuwKoVFLqWyD6tSWOR6UKYG12+ERvEAAAAASUVORK5CYII="

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAYAAAC5tzfZAAAAAXNSR0IArs4c6QAAAONJREFUKBVj+M/Ac/g/A28VAxoAiusAxW2BtBiaFAMDUHDlfwbuf0B6NhCHAnEWkH8KiP9DMVCOe+F/BikuuGagokwkBTCF2OgYmCYmIOMAjIOfZvSGyTMxMny5zsDA+BImgId2/8/gwAKSB9kEAgchFD7yvyADwxkrkAqYpgOYyhlvAV2wHIiPAuX+Q+T/w50ICkFNSGDwvADST4D8Wf8ZVNhhBgGDXg0ovgUofgUmBqaBAiANnSiCaBygmpz/DCJScGGgADC+ePbABfAwYH4CKTkAxMYgBtEAaAvUX/zKhDQBAPHdWlV92VU+AAAAAElFTkSuQmCC"

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAALCAYAAABLcGxfAAAAAXNSR0IArs4c6QAAASVJREFUKBWVkb1OAkEQx2f2gFARbaxsCVaE2JmYy4EVNL6ED6CQUF8tiV9P4CtYURgIuZhY2FGdobahMlTEwK2/XY9IqHSSmf98/GeyO6OSi42igqzXV4QdUW2ItXPwTYrFax2NphueOgfyoWTZE6TjTWELv2jsa5Lcu5yx1iqTHz1ZNRVjOhIE+1Iq1fAHkANqtzYMQ9dQkGbzHDyj8AHhRCeTT1dAHPYhzsEBTQ9gw/CUUxwnd1vkn4yzrdYNdoHWbbtdMXTWXJ7pqccdo3GckZqhKstl1fCUd8/JsqMdrg9tHBucKmqlXJ4ZJr/kxEu2tZf7vzAedwkq6FSHw4X6LYXhMwn38RTtoq9s6kBWqwv+2KOm5CJWm/z7Dr6BCe54f7r0N+dsceevV+r5AAAAAElFTkSuQmCC"

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAUCAYAAAAKuPQLAAAAAXNSR0IArs4c6QAAAFFJREFUSA3t0KENwDAQxdC0K3WC7N9uFCmFZsYBPmTpk9O79pzPWOsd59x3n/MLn/QUFl5JuQ9rUlh4JeU+rElh4ZWU+7AmhYVXUu7DmhQWXj/CewVtt3IokwAAAABJRU5ErkJggg=="

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wAARCAAUACQDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD7booor5Q8cKKKKACiiigAooooAKKKKACiiigD/9k="

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAABHNCSVQICAgIfAhkiAAAAKNJREFUGFeF0LttQkEQheFvUkQjRBYNoBvRBtABboBHAQjoAMdOyF2EjUQXIMhIFy13hS4IiyNNsDv/ztkz4UmJPXrBqdmKF+ABneD4ACZW+A2+ciNxBxMVBsEoymFWM+b4Rh8TdDEOtnfrxBBrtHDBMsgDbnoG8zfaBVxE7VCDxXpaHo3xU6zz3Qc+b9YlzF+w+SfMMMj1qGbqd3vcoQrOTfAKGOMvC+DD90gAAAAASUVORK5CYII="

/***/ }),
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_format_js__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["a"] = ({
  formatterDate: function formatterDate(date, index) {
    var gmt = date.split('GMT')[1];
    var time = __WEBPACK_IMPORTED_MODULE_3__lib_format_js__["a" /* default */].convertTimeZone(new Date(date), gmt);
    var utcTime = new Date(time.getTime() + index * 86400000).getTime() / 1000;
    return __WEBPACK_IMPORTED_MODULE_3__lib_format_js__["a" /* default */].formatterDateHCL(utcTime);
  },
  addProps: function addProps(object, addProp) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(addProp)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _ref = _step.value;

        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        if (!object[key]) {
          object[key] = value;
        } else {
          object[key] = this.addNumFixed(value, object[key]);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  },
  addNumFixed: function addNumFixed(num1, num2) {
    return Math.round(num1 * 100 + num2 * 100) / 100;
  },
  invalidAccountMSG: function invalidAccountMSG(invalidAccount, ctx) {
    if (invalidAccount.length) {
      var h = ctx.$createElement;
      ctx.$msgbox({
        confirmButtonText: '确定',
        message: h('div', [h('span', '提示: 导入设置中存在无效账号，无效账号将不会显示结果!'), h('div', {
          style: {
            border: "1px solid black",
            margin: "30px 0 0 10%",
            width: "80%",
            height: "100px",
            overflow: "auto"
          } }, invalidAccount.map(function (item) {
          return h('p', item.accountName);
        }))])
      });
    }
  }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return format; });

function format(fmt) {
    if (fmt == null) {
        return '';
    } else {
        var date = new Date(fmt * 1000);
        var y = date.getFullYear();
        var MM = date.getMonth() + 1;
        MM = MM < 10 ? '0' + MM : MM;
        var d = date.getDate();
        d = d < 10 ? '0' + d : d;
        var h = date.getHours();
        h = h < 10 ? '0' + h : h;
        var m = date.getMinutes();
        m = m < 10 ? '0' + m : m;
        var s = date.getSeconds();
        s = s < 10 ? '0' + s : s;
        var timer = y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
        return timer;
    }
}


/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export export_table_to_excel */
/* unused harmony export export_json_to_excel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_file_saver__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_xlsx__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_xlsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_xlsx_populate__ = __webpack_require__(1524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_xlsx_populate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_xlsx_populate__);








__webpack_require__(737);



function generateArray(table) {
  var out = [];
  var rows = table.querySelectorAll('tr');
  var ranges = [];
  for (var R = 0; R < rows.length; ++R) {
    var outRow = [];
    var row = rows[R];
    var columns = row.querySelectorAll('td');
    for (var C = 0; C < columns.length; ++C) {
      var cell = columns[C];
      var colspan = cell.getAttribute('colspan');
      var rowspan = cell.getAttribute('rowspan');
      var cellValue = cell.innerText;
      if (cellValue !== "" && cellValue == +cellValue) cellValue = +cellValue;

      ranges.forEach(function (range) {
        if (R >= range.s.r && R <= range.e.r && outRow.length >= range.s.c && outRow.length <= range.e.c) {
          for (var i = 0; i <= range.e.c - range.s.c; ++i) {
            outRow.push(null);
          }
        }
      });

      if (rowspan || colspan) {
        rowspan = rowspan || 1;
        colspan = colspan || 1;
        ranges.push({ s: { r: R, c: outRow.length }, e: { r: R + rowspan - 1, c: outRow.length + colspan - 1 } });
      };

      outRow.push(cellValue !== "" ? cellValue : null);

      if (colspan) for (var k = 0; k < colspan - 1; ++k) {
        outRow.push(null);
      }
    }
    out.push(outRow);
  }
  return [out, ranges];
};

function datenum(v, date1904) {
  if (date1904) v += 1462;
  var epoch = Date.parse(v);
  return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
}

function sheet_from_array_of_arrays(data, opts) {
  var ws = {};
  var range = { s: { c: 10000000, r: 10000000 }, e: { c: 0, r: 0 } };
  for (var R = 0; R != data.length; ++R) {
    for (var C = 0; C != data[R].length; ++C) {
      if (range.s.r > R) range.s.r = R;
      if (range.s.c > C) range.s.c = C;
      if (range.e.r < R) range.e.r = R;
      if (range.e.c < C) range.e.c = C;
      var cell = { v: data[R][C] };
      if (cell.v == null) continue;
      var value = cell.v;
      var cell_ref = __WEBPACK_IMPORTED_MODULE_6_xlsx___default.a.utils.encode_cell({ c: C, r: R });

      if (typeof value === 'number') cell.t = 'n';else if (typeof value === 'boolean') cell.t = 'b';else if (value instanceof Date) {
        cell.t = 'n';
        cell.z = __WEBPACK_IMPORTED_MODULE_6_xlsx___default.a.SSF._table[14];
        cell.v = datenum(value);
      } else if (typeof value === 'string') {
        if (value.match(/^[0-9]+[\.]?[0-9]*%$/)) {
          cell.z = '0.0%';
          cell.t = 'n';
          cell.v = Number(cell.v.substring(0, cell.v.length - 1)) / 100;
        } else {
          cell.t = 's';
        }
      } else {
        console.log("err: ", typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(value), value);
      }

      ws[cell_ref] = cell;
    }
  }
  if (range.s.c < 10000000) ws['!ref'] = __WEBPACK_IMPORTED_MODULE_6_xlsx___default.a.utils.encode_range(range);
  return ws;
}

function Workbook() {
  if (!(this instanceof Workbook)) return new Workbook();
  this.SheetNames = [];
  this.Sheets = {};
}

function s2ab(s) {
  var buf = new ArrayBuffer(s.length);
  var view = new Uint8Array(buf);
  for (var i = 0; i != s.length; ++i) {
    view[i] = s.charCodeAt(i) & 0xFF;
  }return buf;
}

function pushRowSpanPlaceHolder(arr, count) {
  for (var i = 0; i < count; i++) {
    arr.push(null);
  }
}

function pushColSpanPlaceHolder(arr, count) {
  for (var i = 0; i < count; i++) {
    arr.push('!$COL_SPAN_PLACEHOLDER');
  }
}

function getHeader(headers, excelHeader, deep, perOffset) {
  var offset = 0;
  var cur = excelHeader[deep];
  if (!cur) {
    cur = excelHeader[deep] = [];
  }

  pushRowSpanPlaceHolder(cur, perOffset - cur.length);
  for (var i = 0; i < headers.length; i++) {
    var head = headers[i];
    cur.push(head.label);
    if (head.hasOwnProperty('child') && Array.isArray(head.child) && head.child.length > 0) {
      var childOffset = getHeader(head.child, excelHeader, deep + 1, cur.length - 1);

      pushColSpanPlaceHolder(cur, childOffset - 1);
      offset += childOffset;
    } else {
      offset++;
    }
  }
  return offset;
}

function buildHeader(revealList) {
  var excelHeader = [];

  getHeader(revealList, excelHeader, 0, 0);

  var max = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(excelHeader.map(function (a) {
    return a.length;
  })));
  excelHeader.filter(function (e) {
    return e.length < max;
  }).forEach(function (e) {
    return pushRowSpanPlaceHolder(e, max - e.length);
  });
  return excelHeader;
}

function getMaxChildLength(map) {
  var length = 0;
  if (map['child'] && Array.isArray(map['child'])) {
    length = length > map['child'].length ? length : map['child'].length;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(map['child']), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var child = _step.value;

        var tmpLength = getMaxChildLength(child);
        length = length > tmpLength ? length : tmpLength;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
  return length;
}
function getMaxChildDeep(map) {
  var deep = 0;
  if (map['child'] && Array.isArray(map['child'])) {
    deep += 1;
    var maxDeep = 0;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(map['child']), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var child = _step2.value;

        var tmpdeep = getMaxChildDeep(child);
        maxDeep = maxDeep > tmpdeep ? maxDeep : tmpdeep;
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    deep += maxDeep;
  }
  return deep;
}

function doMerges(deep, revealList) {
  var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var preColEnd = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  var mergeTitle = [],
      rowStart = 0,
      rowEnd = 0,
      colStart = 0,
      colEnd = 0;
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(revealList), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var line = _step3.value;

      rowStart = index;
      colStart = preColEnd;
      if (line['child'] && Array.isArray(line['child'])) {
        rowEnd = rowStart;
      } else {
        rowEnd = deep - getMaxChildDeep(line) - 1;
      }
      colEnd = colStart + (getMaxChildLength(line) || 1) - 1;
      mergeTitle.push({
        s: {
          r: rowStart,
          c: colStart
        },
        e: {
          r: rowEnd,
          c: colEnd
        }
      });
      preColEnd = colEnd + 1;
      if (line['child'] && Array.isArray(line['child'])) {
        mergeTitle.push.apply(mergeTitle, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(doMerges(deep, line['child'], index + 1, colStart)));
      }
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  return mergeTitle;
}
function export_table_to_excel(id) {
  var theTable = document.getElementById(id);
  var oo = generateArray(theTable);
  var ranges = oo[1];

  var data = oo[0];
  var ws_name = "SheetJS";

  var wb = new Workbook(),
      ws = sheet_from_array_of_arrays(data);

  ws['!merges'] = ranges;

  wb.SheetNames.push(ws_name);
  wb.Sheets[ws_name] = ws;

  var wbout = __WEBPACK_IMPORTED_MODULE_6_xlsx___default.a.write(wb, { bookType: 'xls', bookSST: false, type: 'binary' });

  saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), "test.xls");
}

function export_json_to_excel(th, jsonData, defaultTitle) {

  var data = jsonData;
  data.unshift(th);
  var ws_name = "SheetJS";

  var wb = new Workbook(),
      ws = sheet_from_array_of_arrays(data);

  wb.SheetNames.push(ws_name);
  wb.Sheets[ws_name] = ws;

  var wbout = __WEBPACK_IMPORTED_MODULE_6_xlsx___default.a.write(wb, { bookType: 'xls', bookSST: false, type: 'binary' });
  var title = defaultTitle || '列表';
  __WEBPACK_IMPORTED_MODULE_5_file_saver___default.a.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), title + ".xls");
}
function formatJson(filterVal, jsonData) {
  return jsonData.map(function (v) {
    return filterVal.map(function (j) {
      return v[j];
    });
  });
}

function getfilterVal(revealList) {
  var filterVal = [],
      queue = [];
  queue.push({ "child": revealList });
  while (queue.length) {
    var line = queue.shift();
    if (line['child'] && Array.isArray(line['child'])) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(line['child']), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var item = _step4.value;

          queue.push(item);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    } else {
      filterVal.push(line['prop']);
    }
  }
  return filterVal;
}

function addStyle(workbookBlob, outlierList) {
  return __WEBPACK_IMPORTED_MODULE_7_xlsx_populate___default.a.fromDataAsync(workbookBlob).then(function (workbook) {
    workbook.sheets().forEach(function (sheet) {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(outlierList)), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _ref = _step5.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
              info = _ref2[0],
              infoData = _ref2[1];

          if (sheet.name() === info) {
            infoData.map(function (item) {
              if (item[1] === 'bg') {
                sheet.cell(item[0]).style({
                  fill: "FF0000"
                });
              } else if (item[1] === 'font') {
                sheet.cell(item[0]).style({
                  fontColor: 'FF0000'
                });
              }
            });
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    });
    return workbook.outputAsync();
  });
}

function exportToExcel(writeData, excelName) {
  var outlier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var wb = __WEBPACK_IMPORTED_MODULE_6_xlsx___default.a.utils.book_new(),
      wbout;
  var outlierList = {};
  writeData.map(function (tabelInfo) {
    var tmpOutlierList = [];
    var tHeader = buildHeader(tabelInfo.tableType);
    var mergeTitle = doMerges(tHeader.length, tabelInfo.tableType).sort(function (x, y) {
      if (x.s.r !== y.s.r) {
        return x.s.r - y.s.r;
      } else {
        return x.s.c - y.s.c;
      }
    });
    var filterVal = getfilterVal(tabelInfo.tableType);
    var list = tabelInfo.tableData;
    var data = formatJson(filterVal, list);
    data.unshift.apply(data, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(tHeader));

    var worksheet = sheet_from_array_of_arrays(data);
    worksheet['!merges'] = mergeTitle;
    if (outlier && outlier[tabelInfo.sheetName]) {
      var dateIndex = filterVal.findIndex(function (x) {
        return x === 'date';
      });
      var dataSourceIndex = filterVal.findIndex(function (x) {
        return x === 'data_source';
      });
      var accountIndex = filterVal.findIndex(function (x) {
        return x === 'account';
      });
      var isOpenIndex = filterVal.findIndex(function (x) {
        return x === 'isOpen';
      });
      outlier[tabelInfo.sheetName].map(function (item) {
        data.map(function (row, rowIndex) {
          if (row[dateIndex] === item.date && row[dataSourceIndex] === item.data_source && row[accountIndex] === item.account && row[isOpenIndex] === item.isOpen) {
            tmpOutlierList.push([__WEBPACK_IMPORTED_MODULE_6_xlsx___default.a.utils.encode_cell({ c: accountIndex, r: rowIndex }), 'bg']);
            item.props.map(function (prop) {
              tmpOutlierList.push([__WEBPACK_IMPORTED_MODULE_6_xlsx___default.a.utils.encode_cell({ c: filterVal.findIndex(function (x) {
                  return x === prop;
                }), r: rowIndex }), 'font']);
            });
          }
        });
      });
      if (tmpOutlierList[0]) {
        outlierList[tabelInfo.sheetName] = tmpOutlierList;
      }
    }

    wb.SheetNames.push(tabelInfo.sheetName);
    wb.Sheets[tabelInfo.sheetName] = worksheet;
  });
  wbout = __WEBPACK_IMPORTED_MODULE_6_xlsx___default.a.write(wb, { bookType: 'xlsx', bookSST: false, type: 'binary' });
  var workbookBlob = new Blob([s2ab(wbout)], { type: "application/octet-stream" });
  addStyle(workbookBlob, outlierList).then(function (workbookBlob) {
    return __WEBPACK_IMPORTED_MODULE_5_file_saver___default.a.saveAs(workbookBlob, excelName + ".xlsx");
  });
}

/* harmony default export */ __webpack_exports__["a"] = (exportToExcel);

/***/ }),
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */
/***/ (function(module, exports) {

module.exports = {
	"sha224WithRSAEncryption": {
		"sign": "rsa",
		"hash": "sha224",
		"id": "302d300d06096086480165030402040500041c"
	},
	"RSA-SHA224": {
		"sign": "ecdsa/rsa",
		"hash": "sha224",
		"id": "302d300d06096086480165030402040500041c"
	},
	"sha256WithRSAEncryption": {
		"sign": "rsa",
		"hash": "sha256",
		"id": "3031300d060960864801650304020105000420"
	},
	"RSA-SHA256": {
		"sign": "ecdsa/rsa",
		"hash": "sha256",
		"id": "3031300d060960864801650304020105000420"
	},
	"sha384WithRSAEncryption": {
		"sign": "rsa",
		"hash": "sha384",
		"id": "3041300d060960864801650304020205000430"
	},
	"RSA-SHA384": {
		"sign": "ecdsa/rsa",
		"hash": "sha384",
		"id": "3041300d060960864801650304020205000430"
	},
	"sha512WithRSAEncryption": {
		"sign": "rsa",
		"hash": "sha512",
		"id": "3051300d060960864801650304020305000440"
	},
	"RSA-SHA512": {
		"sign": "ecdsa/rsa",
		"hash": "sha512",
		"id": "3051300d060960864801650304020305000440"
	},
	"RSA-SHA1": {
		"sign": "rsa",
		"hash": "sha1",
		"id": "3021300906052b0e03021a05000414"
	},
	"ecdsa-with-SHA1": {
		"sign": "ecdsa",
		"hash": "sha1",
		"id": ""
	},
	"sha256": {
		"sign": "ecdsa",
		"hash": "sha256",
		"id": ""
	},
	"sha224": {
		"sign": "ecdsa",
		"hash": "sha224",
		"id": ""
	},
	"sha384": {
		"sign": "ecdsa",
		"hash": "sha384",
		"id": ""
	},
	"sha512": {
		"sign": "ecdsa",
		"hash": "sha512",
		"id": ""
	},
	"DSA-SHA": {
		"sign": "dsa",
		"hash": "sha1",
		"id": ""
	},
	"DSA-SHA1": {
		"sign": "dsa",
		"hash": "sha1",
		"id": ""
	},
	"DSA": {
		"sign": "dsa",
		"hash": "sha1",
		"id": ""
	},
	"DSA-WITH-SHA224": {
		"sign": "dsa",
		"hash": "sha224",
		"id": ""
	},
	"DSA-SHA224": {
		"sign": "dsa",
		"hash": "sha224",
		"id": ""
	},
	"DSA-WITH-SHA256": {
		"sign": "dsa",
		"hash": "sha256",
		"id": ""
	},
	"DSA-SHA256": {
		"sign": "dsa",
		"hash": "sha256",
		"id": ""
	},
	"DSA-WITH-SHA384": {
		"sign": "dsa",
		"hash": "sha384",
		"id": ""
	},
	"DSA-SHA384": {
		"sign": "dsa",
		"hash": "sha384",
		"id": ""
	},
	"DSA-WITH-SHA512": {
		"sign": "dsa",
		"hash": "sha512",
		"id": ""
	},
	"DSA-SHA512": {
		"sign": "dsa",
		"hash": "sha512",
		"id": ""
	},
	"DSA-RIPEMD160": {
		"sign": "dsa",
		"hash": "rmd160",
		"id": ""
	},
	"ripemd160WithRSA": {
		"sign": "rsa",
		"hash": "rmd160",
		"id": "3021300906052b2403020105000414"
	},
	"RSA-RIPEMD160": {
		"sign": "rsa",
		"hash": "rmd160",
		"id": "3021300906052b2403020105000414"
	},
	"md5WithRSAEncryption": {
		"sign": "rsa",
		"hash": "md5",
		"id": "3020300c06082a864886f70d020505000410"
	},
	"RSA-MD5": {
		"sign": "rsa",
		"hash": "md5",
		"id": "3020300c06082a864886f70d020505000410"
	}
};

/***/ }),
/* 356 */
/***/ (function(module, exports) {

module.exports = {
	"1.3.132.0.10": "secp256k1",
	"1.3.132.0.33": "p224",
	"1.2.840.10045.3.1.1": "p192",
	"1.2.840.10045.3.1.7": "p256",
	"1.3.132.0.34": "p384",
	"1.3.132.0.35": "p521"
};

/***/ }),
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAYCAYAAAB5j+RNAAAAAXNSR0IArs4c6QAABPRJREFUSA3NVglQVHUY/73dtwfLoUscQiGYnCKXGCQLFkOD0ChWTCI5mdhoClpZNpUzNs0U09SQYBQdFkhhhwrVgAmYNBQEZMYSp4FC6rIcu8geXMvC9t4u+4Rld2EaafrPvP3u3/977/99338J2Z6MKYedqazR4HXIz/8FRV/WY3x8EsZFEAQas2OhfHovSB8flDxxBFnHKoxmPfX3d8PRGAfcW3senGgRcuWuKCwWz/H5NwLrG89Ylbr8AljPHsDBB11Q/sMhpG6PAIdkL4jn5eWEE3sDUcBtgO+oFPYf56HpvgRUX765YOxiHMi8002qkwLusozHHsbWoq9ho1bh1UPPIe2paLyfV4Wyc3/Ow3FbsQwvb/FCpLgS7P5bEGRnoblvAjmHS9DQcG2ev6nC3p4P79Uu6Lo6AJVq3NTMyETanoJ+AjoXWmNnx0NymBPCmi6CuyESvEcfQW+fEs4djcyxDn9UAOfai9C1tcImfR+kbDt8+90faBRfZ0B7umXo61cysimzIzUSLx1OxBuZpSguuWxqZmRC/m6u1mZaY/UMp3p6MHHuPFiOjuCnpjDBlphTN7nIruq3ZEbQ2ruRkR5H1W45uroGLPoR8gjRtG6A+nh3cNVEJeNIM8ciIt1kOp0ORmrJkdSFr9dxR1VWk5uWy6FtaQVhawvO+nBLWIxezRNSvJqRTRk6MXoZqdFON+Gkdsoogvx01SYFSbJoNP0KoMZC1AZv2A/2QlNaBiIhAew+qb7m2O7uQO4HoAt6WtKL8dNnIPEMQPUwHwrFmBECdfVXKd5ycozjLCYxIQgx0T44llMJmcwQy/qiqG4kv6AG3T0yJG0ORcJaIThvvg519nGUszwQn/H9LAjgbPHveGZ/IToUAH97CtwvVePxuq8QQChRWtYEGqu9XcrECARc+PutAJdLMjpThv5iG2N89Y9QaMuYSZHIm5exLxZBbnyM5uZBLZGgITQeb5f2QFoj1tcF4z3D1NR2gX42xQfiYMbz8MQINua8B9EaHSpWxSCnpAMKpeFLZr2zDSEhHticdBwajdYUSi/TR3mysBZnqBfv7LzdSGTmiw8JBWdPQdXcgpb7E5EpXo6eE01mQUyVFZWtuPBjG7YmhSH9ldfgOixFIpWkds1KZNYDPB6JlhYJ5HI12CyWafgc+cpffXNkWiD2b8kcYOumnK9oBZBIhuc50IpQH0e4TCigYZFoHeFicFA1z4/DYWM1NVjpNSQdwoBiQs9T9aynWu20ns7+oY8zLi4Av9Z1QamcP4zJn/8enzB0jWZ23Bxe3Dk0I9OdZNh0jgMlTE5OoaPjdq0Z7eaSMtro4wxf56VPzqibTYnA4KM3qOTuma00xzs52TFdZM6+FDrrhUDt6Oho6J60XdGgExTYcPW1tBTJmGJa7u8Zz5Uejvjkw51wdnFASLAHVRtjSD9QZIqzJPKCX66busT5fA6c7rJDWOhK/Hape0kSMQdqNTkbGw52747G2Jjhzyc9p+hLWxTlbQ5r0TpnZ3tEi7xBU2uL7eL6wAuUg4M5J7rT6uuv6etMRs0q4XJbPLnrM1y/Yexec1EL61K2ReCtzGRqdN1CMzUHLa0Fa44ObG3rxedFdfDzdaXuVZ7ZmWRpA3P6qp/a4UddaTS1thY9SqyBLJXNas0t1aaLxf1fJ0eydOwdOhb4i32b/9LvH9OQvfWiFd5bAAAAAElFTkSuQmCC"

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAACWTY9zAAAAAXNSR0IArs4c6QAAAZBJREFUSA3tlL9KA0EQxmf2jKfGpLMPCAb1IcRGO0st7CztBEE78xSCWGgXLCytjaCIbxBQxNokiAoxl+QyfmsV95aDJRsQua1u/tx8P76dO26UykJ/8ChHpg4xvTLTu+N7zu0pYNy2TQtDXkK+Zqv5zFnBmLkPZ46SQhxHEV2S0Eay5jdjBYPEdRjS2Q/gLz3Jk8gKlhIlfsCVHjMBcwxnGAz7w/uKeT2ngt1ivd5SHKzqGO5dJLXlEbVbUHWStdEzbHyVXzBjb+6lfqJHN8rlAnXpFJ5smVJwKgZUD/kps+YjHnZMz5smlm39IJWKmlFqloU2dWweQAWAy5l5X7EJBi511SwtHjTPq09RpObh4L1VjPlGmA+xa5/W+ojJCfN9YdnBgi/o/GDQr0H82bbecOsDfV04VzBn+IjNHUufyRSR8BuaAIMvdIwncZWpWsLxZD5Yxm/iLrXPQ9EJjFn6vXZcFZE1D9qpIxI7ltYtQkVc4dihNIOTY2nQvmsZmKujmWOZY64OuPZnO/ZvHPsGnrlmUn8JyCkAAAAASUVORK5CYII="

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAAHhSr/lAAAAAXNSR0IArs4c6QAAArRJREFUSA1jSGxY9u/fz18omFHcrfY/AxC82NkEosCABca4rqgBYzIwgrTCeVAGbu3eH+8xoGiHWXRjTSWDAC8nuklwPtxIuAiQsev2GgbW/6jWw125/9YqZLUYbKwuR1cFtpaZmYnh6bYGdDk4nwnE+vv3H4OEex1D39IDcAlkBoYHOP/9Ydh2Zx2yGga440GiuDwAVrTw/nYGud+fUXSjcEABC8IbD175TynAcDvIJi0lCYZ907NQLCWGg9UwdI0HZ+UyqMuLogtj8FECDEMWKDDhyX6Gfw6rGK5jk0QTwzBM6O8PhrV3N6EpI44LNizp7RWG2LfXiNOBRxXjw0ev/smKC+BRQrwUOAKkxfgZzi4uJl4XDpXgtP/01Udw2q+cshWHMuKEwYbBlM7ffBJs6PHLD2BCJNE40xknOyvDjbWVDOysGBGO0wIUlyGr+v7zN4O8TxNDaPkCZGG8bJwuQ9aV8uYyQ/Q7wskWrx+Ufn5kmPtwJ7K5eNlYDWMEall/dwMD/99feDWjS2IYVvniFIPbpwfo6ojiww0z+fqCofvpIaI04VLEwvH/L8PGO+sZ2NAqD1wa8ImDY5ODjZUhO8yGIQeIQelrMACsycxKT5GhNcuLQVNRfMDciNVhyK4R5ONiKI93YojzMmVgYgKlP/oAgg5Dd4a/vQ5DXao7g7QoP7oUVfkkOwzZdjkJQYZ6oCO9bbSQhanCpshhyC5gZmJiiPcwYCiLsGXg5WJHliKLTRWHOX1+zJDx+gKD6J/vZDkCmyZ4QYZNEpcY779fDIlvrjD4f7jLwMQAbpnjUkq2ONEO0/rxlqHg5TkG1Z/vybaMFI04HcYCLL2DP9xmiAe2sDj//SbFTKqoRXGY5O+vDFmvLjDYfH1KFcMpMYTF7suTv1mvL/6W+P2VNomFTNcBAEEZJGQgdpRvAAAAAElFTkSuQmCC"

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAAHhSr/lAAAAAXNSR0IArs4c6QAAAVNJREFUSA1jfK2g/p8BDTCh8cFcrIKMIO0i928wvFHUgGvCqhKrIFg7TB+6MTBxEM34HwiQBXCxiTcR5nGQte9snBn+PX2KYShWR6OrIkoRUR6AO55iN8FNQnYsyFQQwOVbZLXIbKI8iKwBH5uogMBnALIc44fYJIxkwb9oLljN56Iyhn9v3iKrx8tm+X34KE4Fv0+dxZpCcGmgbpjB0irMNu6mOgbO2CgwFznnweTx0VR12QgxjKqJlqphhpEDOOKiGdhdnMAp4GNcMr6UgCGHkQPYXJ3hivDlDrgiJAZVvTl4DcNa0iIFA5iJnF9hcqSWwjB9xNJUDTJiLSVG3ajDiAklZDUsnNkZyHysbBYdbQxxjvhohv8fP2GIU0uAquUitRwFMmfQprHR4oLUaB60UTloHcbCyMhwmmAwf/ok8ffWbUFkdYwM/+4A9f5GFqMmGwAW2H00DRMqtgAAAABJRU5ErkJggg=="

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAACWTY9zAAAAAXNSR0IArs4c6QAAAJhJREFUSA1jtPea8puBBGBrqfSjucbzPQlaGL7Utgn+OXqSgxQ9LK/efGEhRcPXb794gOpBmHjw9RvD31dviFcPVMlEkmo6Kh51GKmBPRpioyFGagiQqn40jY2GGKkhQKr60TQ2GmKkhgCp6kfT2GiIkRoCpKofTWOkhhiLubH8I1I0SUvyvwWqv0WKHiZpKTVWM2NhUvQAACwIGYlfssiKAAAAAElFTkSuQmCC"

/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAACWTY9zAAAAAXNSR0IArs4c6QAAAGxJREFUSA1jZGBg+A/Egw4wDToXQR006jBSY2Y0xIZNiLFIMLOQ6hm6qGe8Ja82Wo6REtSjuZKU0AKpHQ2xYRNiLBzqP0n1DF3UM/49yzFajpES1KO5kpTQAqkdDbFhE2IsP65yPCLVN/RQDwB0YAogVYwtOQAAAABJRU5ErkJggg=="

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAaCAYAAACkVDyJAAAAAXNSR0IArs4c6QAAAtRJREFUSA3tVctu00AUxY6dhkWyItDybmlp4ryUP7DDY8uCRX6FBft+AhJ/EFUUiR1S1XoBYhklaR4tjw2BhppNIhYhT861ZqKp49gOlVgx0ujO3Mc59965TqRLS658Pn+93++/mk6nk1Ao9LRer3eWgZCWcWZkhyC7z+KOJUkyms3maVCcwIS5XO7GYDAgsi2AW9gUewV7KVIZAb7LSYaqCoqiPEDgT+xtbDOZTK75AsHBl5CRmayyM1mWqYVHWFVVVQvAsFiLTWq5H6lnS7PZ7M3hcEht3AQQkRUajUZdBEVladgPoIuj8pNIJGKUy+Xvoo94XkjIyKiyewD6QWSYyIYYzM+apqUmkwmRXoXvx3A4bFQqlW/cLkrXljrJMP7GIjICo6opIRzPkOAWDRc9hUjEz3MVptPpW+Px+JBV1gFZAe/V5AFeMpVKaVQpYq+h0k+oVHdWeo6QyEajkQnQDQR0MIlGrVZreZE4bcBIsoRtUgyWUa1W29xv1lJkd1sgO4WjviwZgVI3kKhOCaPSTQydSU/ECe0KiQxZmVCuw5HIKKtj7qTrumJZ1kMArHCdKBHzOx6P75umOeL6TCaTQAHU3jXYP9McIJmvkkgGZxpno9VqnfBAkolE4jHEWwQORT0/A1SF7RG+z32uI4nKttlnRT8KX6hyGY/8Gpd1bJsMmWRA8Az32QKYShcAhp27WCxGmGN4FoADYYBMQzI6roS9gYr3ZCjaAGxi61QZEngJ4w49PuRfLWonAnewX7BuGYyjrUDxRERFApfpjje1pWgLeuaxHIuRahQ/m9KgYBf1+0940Q7Oxf/zlipzKbgrpqTGf98Hp7lUKtm/Vhh728dpd94DEcZisXe9Xu85QM993BwM+jfRaPQ9v3tJL8I7+LX4RcHdbpfELr4rkq4LPqvwXyUj/O66OkG5kBBBe4uC/PReibkNTckPMKgdrd51+v4BVGdty9Oc1SQAAAAASUVORK5CYII="

/***/ }),
/* 472 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAaCAYAAADbhS54AAAAAXNSR0IArs4c6QAAAoZJREFUSA3tlX9ojHEcx1+Pu90Pv0KMRER+lHRoZe1mK0usxeSSH0nxhykl+RV1SYoaKSz58Yfyj/DHmtrk1FFD2dof0hg3SWwTZrIZc93tfL59W7urdT3Ps6td2qeeu+/zPN/7fF/3/vwyEoW+BNlmLndiTLYxDfCMgg0oYfb7P1fM4YQtO+DWPajYb1aUtPvEYwbsSBDKNmpHLc0ZcAjDD+X8BRoqHIJfPVC0eoTAxo1PPXh5HvT3w+w58jcd0CNwylxumDBRr218WlPMKZE/WQl5+ZBfCB4P5Ljg2xdYuBiaX8DDOjh3GUJP4X493JH7tWWW0azl2KQpAuTXlzrqw3s4ewoCW6E+DOfPQNUNcAvsjy548hjKN0PwtAYLCaRJs6ZY51fo/qmvm9dh7jyYmgt1NfD8GZSsg9Y30NsL06ZrVRMS5revYYkPHBJqk2ZYnpVKnQPHJJe6IRaDru+iyCEJaQ54vTBzFnS0w9JlUFwCr17C1UsQl71mTWaldTDlfJPA7d6rYZSCHW1w5aLknICtKYWVBfAuAieOQvSvWZzBfbbBlAvVVBdJwqtKbPsIuyrgz28BaoWDx/UhqhAuVA4eaHYlYNaSP9mxQ9Jz5x7wF+mn7Z8g0iJtwgOqpXyWcK4PwLUqDZz8WxNra8mf7NBfDAWrpC3U6gqcLBXb1Ai5kvSq0TZIMbikOlXO2TB7YN6xULoBDENXpmqkEanG2mqouauBVB7G41IcnTaw7I4k3wpQCkWjotAMqL4Nh/fpCdDUANvKdUE8kjGl+pkNs1eVZg5SQz38APr6zOxO3TOsqkx1ldk7AbOXY5nFGNLbKNiQsqR5mLWKOQlsD6YBH5lXBrF/YAOsPcmLTIMAAAAASUVORK5CYII="

/***/ }),
/* 473 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAXCAYAAABnGz2mAAAAAXNSR0IArs4c6QAAAGdJREFUSA1jPKtp959hEAKmQegmsJNGHUZqzIyG2LAJMcY367YNyuKC8T8QkBrM9FA/mvhJDeXREBsNMVJDgFT1jFk9RYOyuGC59fgOqZ6hi/rRXElqMI+G2LAJMRZ5CbmvpPqGHuoB0PQP92tFhfcAAAAASUVORK5CYII="

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAXCAYAAABnGz2mAAAAAXNSR0IArs4c6QAAATtJREFUSA1j/D7D4j/DIARMg9BNYCeNOozUmBkNsWETYox/zswZlMUF438gIDWYkdWDtK9YcZLh9ZvPDP///WfQ1JJicHPVQVZCFptih02btpfB1k6N4d/f/wx8fJwMr159YXj8+A1DSIgpWQ6CaWKBMcihv3//zcDHz8nw5fNPhmvXnzJwcrIxaGhIMrx4+ZEc41D0UFRcvHr1iUFCgo/h48fvDI8ev2d49vwDw/dvvxl4edlRLCGHQ5HDZGWFGO7ff8sAotVUxBnUVCUYRMX4GN6//06OW1D0UBSVTEyMYEddv/6Mwd5eg4GJmYlh966LDI4OGiiWkMOhOPGDLL177xXDoUO3GFhZmBjc3HQYxIChRilg7DuyiKLiglIH4NLPKNPhPCgdRlHix+VbaoiPOozUUBwNsWETYgDU61zTWBfG+wAAAABJRU5ErkJggg=="

/***/ }),
/* 475 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAACWTY9zAAAAAXNSR0IArs4c6QAAAGFJREFUSA1jPKug8Z9hEAKmQegmsJNGHUZqzIyG2GiIkRoCpKofTWPDJsRYxJMTjpHqG3qoZ/wPBPSwiFQ7RhP/aIiRGgKkqh9NY6MhRmoIkKp+NI2RGmIsQA3+pGqih3oAkB8IMjLbp24AAAAASUVORK5CYII="

/***/ }),
/* 476 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAACWTY9zAAAAAXNSR0IArs4c6QAAAHtJREFUSA1jZJzo/p+BBBCqasew0rOKBB0MDPeLqhne79xLkh4mklTTUfGow0gN7NEQGw0xUkOAVPWjaWw0xEgNAVLVj6ax0RAjNQRIVT+axkZDjNQQIFX9aBobNiHGEqBidZoU32gIyb4Cqr9Oih4OJXlNAWc7MVL0AABrkg0JXZrPtgAAAABJRU5ErkJggg=="

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAACWTY9zAAAAAXNSR0IArs4c6QAAAVRJREFUSA3tl8tKw0AUhv9JO814Sc2YVGKr1Np6ARFXKoigi4Kg4lrciStx51JKnycPpxvdVuJMZcBSWzKRzATpgXDgXJhvfk7CCcFumOBiC2SxgiIZETAJWBnotkEOosKwfYMpnBYHLrdBfKYi1vwomMSgDnDeAg4bIESm7dg4mOJoeMDVDkhtQUWM+slgEsMR6dMmcLIOUhJKGrTpYApEqnYtZq9eVZHcfTowiSErj9aAsw0QWsodTB6Q6DxxHCcmzOzgaOg8A9MQa1g6U+zfKCbWCj37fP/A4PVNrylDdeoPrBzGu+oyHv0QzMl/NFMp1qEu+mGEPXcuw92ztUwFk8kHodD9UgBqeAWaCLbvMvSDVWxW3GxX/mPXGBgTyjzxGm49LrYeOYJ2bATsmM2jF0SoU/s/JkMwT7xlz3wFN55vR55fTi13eYCXZhthAVT6yfcFPpWQGUP9WzAAAAAASUVORK5CYII="

/***/ }),
/* 478 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAAHhSr/lAAAAAXNSR0IArs4c6QAAAKtJREFUSA3tlbsNgDAMRBNEwRh0jMHytGzCCgionafIQQdyEboc/tydg8nnPl3JPOO4rQZKKR/zUkTmD9KLzg+AjCgQWWIgMbeBgwXo7OLmquQi76vkUUdiCHN1pETCXG5RImFSZi73iQVhWmZhpymVKS0W955JZUqLxf0CpDKlxfAPSBvhb0yqUkm+E2t1U7rLWpvX4vsoa+7Qu7COSXc/KX+LhXWsE2sd6Q2qLCqhQaj4MgAAAABJRU5ErkJggg=="

/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAACWTY9zAAAAAXNSR0IArs4c6QAAArJJREFUSA3NlV1IU2EYx//n7ItNN8XNTWyGim6GugoroaHQZRddhVQ3QlEX3QgRUhJ0EXjVRVeRl4O+L7pJxKIwWBi1hmVRorhNV6udtc2lq7mzr95zoCMndTJ7kb0X5+N5n/d5fuf5v897mKa9ZwugNO4uT0JZyFOJptwsitWURKNlGaFYBQLhqs3cZHbr0CBULCOzbfdlHVhvRwjD/a+RJ3V8NNkCnSaLKl0G0wETCsSmVWeR4tctE/PXne6HSqnYLotsnSzDcec8rp+ZxOM3TRhyHZYBtNQnsJJSo6c9hHe+WvxaVSO8pJMF8w1chIpOwSCBmat/4+opD/ycAZdcTqT5tS8/aOOQy7O4csJLqpfG0a4gRsY7YNSn8ClolOAST5/R32OChHptBjfHHDIoATiTVeBynxf7myNEqgL4HEtsLG6Nd6K6Mo1EUiPCdc1+oC/lnoYlMfhMsEaqgPAQSehg35VAU92yCCXY1Io82oi/gi1IUII9PvYEKgUrPP73kKT8FqsUg9XXJGVBhYq1ErBQtAK1hpQ09yVaifbdcfjDBgnOf2GQvpSeOYuY9IgjhIcvbRKAULGpeTMqNBkYSHfqdTyiP7V47zfh1YxFghIWONzP6Uv5ccGIB24bTvbO4Vh3AKOkM/+Oz0TelZQSUz4zDrRyWIzoMTHdgNXMWoMIvmqLmT6YEPja/UPCDTfOubGv+QfuTLQhQLqUJXvpa0wP3/dqLBCoEJFRo86B/wfMa3dQk5LZ6JfU2RhDty0snvx+rgovpq0ioEhd5OIe6KF28m8IViR30alZ7wg1KRlX33lqP3FnjXzPFf2KLSaZt3YHNbAtcpU0zRTIKGnFDjkr46NjO5SqtDSMp9FelhVj0hxXnmB5ni9PsLKVkrt9rzwrVrbHBWni4dIaeWe8/wBkZ/DlGv8j0gAAAABJRU5ErkJggg=="

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAXCAYAAABnGz2mAAAAAXNSR0IArs4c6QAAAGpJREFUSA1jXCev/p9hEAKmQegmsJNGHUZqzIyG2LAJMRbFqHBSPUMX9Yz/gYAuNpFoyWjiJzHAGEZDbDTESA0BUtUz+uYsHpTFBcvl2y9I9Qxd1I/mSlKDeTTEhk2IsajKiXwl1Tf0UA8AcxENMAxaRKYAAAAASUVORK5CYII="

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAACWTY9zAAAAAXNSR0IArs4c6QAAAShJREFUSA1jvKal8Z+BABCvrmHYyavHUNO3h4GHi43h4tZshjuuzgy/nz0joJN8aSbytdJW56jDSA3f0RAbDTFSQ4BU9YM2jbGI19QS9AyXiQkDw42fKOpEc/MY/n79iiJGTQ7LDh4dwubd+MFw+tJTsLrff/4yLNt8iYGBUZGBgYewVnJVMCo59BGsksg1nBJ9LKC6jxgACqmfv/4yMAIVcxOphxhzcalh/A8EuCSRxZdvvoxSiSPL0YLNAmolEAKghM7AqISi7EFsNMOfFy9QxKjJYSGm6fL3yxcGBl5Ua0GOIkYvqi7ieYO2HBt1GPGRCFE5GmKjIUZqCJCqnoWBkbGbkKY/z56riAvyqoUYCgmxsTD9+7x371NglXECqBe1yUHIIBLkAafcTuTKLouIAAAAAElFTkSuQmCC"

/***/ }),
/* 482 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAaCAYAAADbhS54AAAAAXNSR0IArs4c6QAAAv5JREFUSA3tll1Ik1EYx39rLp3b1M2pE2tTujAvzHIiDiohkJKICLoohfBCyosguouuJKKgq7KbvOkyIQlvsotYRWElSaX0IZrSIj+2KVORzTn30TPDXe7DVyHCB172wnmec37v/znnv6PiEt1sMt73sdjgpWCT5UnLsohxMWlGksE1NaMyXJUkZdNDuzZduc2FO2CZCvwfKRYDVRgqdLBUh34xB0KZypFGflYaOYkUjUB11ML+UvAHwdKIecoOYdG94iHkuQQ6ka3sJW2wci1cq7cxPlbIyIya4rwYQS0x4w8I+qN8OxdD8+Uz9n7Yiv2RFpgjDtUkyjwtYGbiE7ec8KYSBizkXn0NT0TFhYiOo+KIL/ZC0wNlasWrU4NJ+y7UiIsKyOpbIwd8EOjqokK1SB7ThFpqqeu5I4NhQhN+og3SZvkv0UmdkkitekT2TT70f5CvWNViGgZtaytekafbdx5dezulxmrMHgNl16FsAJbrlCD9rU2pmFlOXaE8C7kwGpymR1rqGJ5Gozdx8oiV+4+/UpI7jM/mwXFWhCuUieWxDCmDS6mYXjKiYg/zXjl1MSNtP2FuMUIgGMbrW2HW66chUsGJZQuqFWmzeMcv+RClkRLMFRCoNeh8BZM5aizj0KydpcikxTW1xI0OO/oRN3l6GyaBMkvLD75UigVq7HQmnUaMqcYEx2xgKF9hcCHAzI9e7NZGrKUGJm630WcYorC2EkPrJPPFYL0L2dGks6YcTLnH4o45MAk3T8Ogy03sUDWHnR5Mp5rXL2IhtRp/Sw3Lxc9xjwmQtNMgCisNldzG0jrYdWY4sw8+eqRd2UUcD1VTFdGEQ7PuLOPcCGEHrLhErXsCppRK6tMGi69l3g2XxQqyxXB/z0N7Cf7c7+iC0mrrIzkc7+J7Y2siI7D1JcXXTNlQuweuuJmrf0aRbkIMdWt4ErOkPJWJzI0XkcQn9uF0QX6v7PVtgIovlTnYBuA2/+6AZSrwP6tY3GCdmX7NRr46iria3H22If4ADvnZDVhbzxgAAAAASUVORK5CYII="

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAAHhSr/lAAAAAXNSR0IArs4c6QAAAJFJREFUSA3tlEEKgDAMBI0v8eb/3+UjVIRCiTnMYUsjphcbWLPJpK2d91rcWl38hHZs+0tpA37H5pEwLD0ShpV7IcqGRCG9gXbRXLwdjVGDU5IhqlMqkzJDZ/X7bUqZ5U32k0ObdwDSyqR3k95hopN2SQyppgqjpJquiDUS9Ct9Y6kp0dUoCaVeU8R6GmSfltgFESwriJQ5jh8AAAAASUVORK5CYII="

/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 485 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAACWTY9zAAAAAXNSR0IArs4c6QAAAZ1JREFUSA3NVzFIAmEYfUZRgmlQpIION7W1Ck0GTS2NITQkEQQtJQUVlSAELU3WEERrkIQUbQ1aYCBC4BJBiSUOhaVpat55V/k3OP/fDz/4T8fx3r3H+z7e3Zl+WweEU8rmcR06QOYqQWDRoSaqMSZRKxQRnV3DW/qBrsjJ6ObEtWHZeBKXC0Fo1Xr7noyLLupDFa8HE7sr6HcOU6kkPNkYW0lD1WDoOkmICiaP8uUmhXhoH2q5StUi4YWW/7tUxtnMamct/8fjM2LBsFRTLFryjvWY+9BrtZDGIgImG7O6HPBuL8I+OiKix80hL382lsTF/Cb0hsotIgIkJ6aMezAZ3oLV7RTR4+aQjf0Yxv8rSfuqcYuIAMnGcok73O4do/FZEdHj5gj1mFqpIuILSK0McmKF+wyi/nWpplisZGPmQRtsbgf3SESBZGMW+xDGAv7O7LHzuQ0YWlM0DC4eOTHWY1NHOxhQXFwCoiCyMaOpo/iUQ/29JKrJxSMbyyfTSB2eQHbBCvUY+94/nV6SWhnkxF5bf0YR37JUU2zWf0NmmkxY4aAYAAAAAElFTkSuQmCC"

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAAHhSr/lAAAAAXNSR0IArs4c6QAAANJJREFUSA1j1DTr+M8ABFemN4AohvdxRgxMYBYagVWQAaS9ICP2/9+zHP/faFuBMVaVWAUZYbaD7HI3usrQm7oabi3IJTCAVTdMEpkmWiGK1TDPg0wi2VqirKSzIhTfIYcPeiAjyyH7HFmcKLcja8DHHjUMX+hgl8MZm8jpFlnr18mKDL9OCyILwdmjEQAPCqIZo2FGdFDBFY6QMMOZN+EBgcbAVwKjKYVz8eVnuCI0BlXDH81sirijDiM1+EZDbDTESA0BUtWPprHRECM1BEhVDwDYaTK+XEBdcwAAAABJRU5ErkJggg=="

/***/ }),
/* 487 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAACWTY9zAAAAAXNSR0IArs4c6QAAA35JREFUSA3tldlLVFEcx78zc8dxHEcdHcd9QSsVl7IxFTOyRdGWlyJEgoII6iXoD5CIXoweip56iBYkKiraaAFJiXDBFs0SrTQtZabScRmdcWacrd85cXuJmesEgg8ewTPn3HvP+Zzv7/v7HZlwotyPFdjkK5CJI62ChRoZYSkfZOlTYHc5kK5LhMk6CZtrAT6/H2k6AzxeL2QyGXQRWqiV4dCo1Pjy6zvsi064PItQyOX0rRN5iZk058DE/AzClWEwzU4G3VoSLFypgk6txam6oxieHEd5ZgFaP79B+9c+7C3agg7qq3PLME+wiVFxiCSw0ox8HLvVhP0btnPg47fP4sbhMxidMsPqsPGDNFxrpMP5AsJJgmXFJaMiqwhrDWkQ5AqMz07A6rSjLr+CQ9Ubq+F0L6IwORtzNN8y2E3whUjQxmLCNg23zwOlQsDd3lYOObMwT0onBIVitAp5WerpgNj0wEYhLE7Nwc7cUpgpjJ0jHxCnical9vuICtfwkFnsM+gZ/4zphTl4fV70mb7A7fUQSBT8FHJBoUC/+StOVNXjh3UKDrcTHSN9WPS4A24tCeahjbLj07gn1BTWA8U7UJNXjsrs9bDYrdw7TJEhCnODsYYgBHz69Q0HN9XysJlIYTbeumYjZh3zMGh13BKjUz/A1AvUJEPJjP1quIeMn4AHfS+5IiwBnnxs50nAVNu2zog9BZWI1URx/4QJAq50PUZj7RFcaLvJE2Xg5yiiIyKRRD6spoPd620LxMTnJcFSouORGmPgJ65aa+SZ9nZsEDkJGThWuQ9NLddxqGw3rnY9QhK9y5KBJUC/eRjPBzqhVUVgV/5mFJAHp0jh5tfPSO0N8NNfsCZZYJlR9ZExfCG28HvTEMIUSuRS+rPFmVIl5w5RqVBheGKcl4d3Y59wuHwPhmjMspX57OS987jT8wJ6TQziab0RizkYF2TLdVeqhDCuLtud2YHBscYOOW2fk8xKyVDy1f7jHyuuYhOh2NhimxWng/aSoQz69TI+XAULVdyQPMbuzViq5k63C6zwsouc3Xd/e9+f3yxbRV/lGDIwNvOTqr0rJLaQwNgVwiq/MT2Xlwy2k1iPRBCxOonjpGg9h2RZ2tz9FJc7Hy4JMCQwps7Fl7eXtLD4UjIV3ZL0PH5fjlhM4rRkv2x1THJniRdWs1JCoH8er1jFfgO4FnkQc/Gg7wAAAABJRU5ErkJggg=="

/***/ }),
/* 488 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAAHhSr/lAAAAAXNSR0IArs4c6QAAAvFJREFUSA3NVl9IE3Ec/9x5+9N0czrbChVXIQmZjIqgeskNIqFIfaqIoj1EYBTLSijS0UNQD/Uk+GQkSS9BSvSYqA9SliRUkplCGatmuulUUG933d3c7e52jptu4MHx+/75fD/7/L73+30ZwXIPFA9hqW1nJ4YfCOGdriZhJf45dycj1ywPtdeiwNslMgvlu1y3MD78MBFUKxezEkNQxPu8qv6GZlS/fooy62kJJGaqqkxCcQFCy0+TapXKmKht5lE1VoY+wtEZVmJAxSNh9/GYudrWeJxfRfEjlxrhXJyC6VmHNC/YIigpIwlo2p0En9JM6sL0jgrwLz32XVhnyitTEkiTVH7dE6mPCc6zDvSCtJhR+OkDZvYegBIjK5A4YuvjsTaPDZffTMddNLjL0NrzQ/RTGZoam4pAmkvqmTSZrp3dr5muGik+o9uUkS13vxLO1uzZC8LKn7d0Htk5++qmYbBYYLp2BbjagLkz5/G4YwD+l6OaOMXby6N1NA3TTR/IIhvYaBSUqwomMJqIeJCM7IvNicq7PgTtpSgK/gIJFn0HlzSTyW4AQXDqmCiWiRyBoJKdxWciXzuZcsQTdjtObq+Hywrc62vTTMQDN+91kp2ztPakAs7o3VThX3coo7tctwqVQtn5V+aZP39Bvx1UhuU+RUF/okYey4CXUthKTy/m77QAeh10hw8BJAnTDR/mG5tA5OWCfj8kSLAd83AYfQbkJChksywRjlljR5fAX3eypATR0W+A0Qg2HAIzOQmyuBiE2Qw2EkHr80Hc7hpTlm/IT9mxRUMuzBw983MS4GYm6bBzDgt2fiEmlOsgwb1T0di02pASRXGOoeKUXxET3cDWUhwJj+O+0YUQtQVeRw2a30UQpPIwlFuKcUMBqrz1uNi3ADqa9J9X5FmPIZvXagSFZgP8LgOu94dAr85xHlfOzOFc3X60dGf2E8Y1pDWuKY8bgT37sO1FJ5jA7zhHVta0hGVFwRqkm3bAblph/wGvufBXFm1CMgAAAABJRU5ErkJggg=="

/***/ }),
/* 489 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAaCAYAAADbhS54AAAAAXNSR0IArs4c6QAAAgBJREFUSA3tlj1v00AYx3/n2E7S4uAG0ZSX0gZBSmGgCi8DVZkQAxMDsDEg8QG6wCdAYmdi4RuwFwkBC+oGiNclVEqBpE3TGlWBYCdxjL10QbVzVVpZKLfY1v3vnt/zdmexaEzcI4ZDLA4f82LIhRJHqIBpACabmdhGTNVHO7LO7IleeK/5P7pyqZ7ak4ipvVp5V4JKXVBah0vjAlf1OD0pMI3dCXiPYII3CyrlLwI92+XVM51MEjq3HS4Xe3VNThcJNv8QLk55FOfaWCakWuBlNMxhODcNd+7D4weQ1OUMR6kjj4vrN04ydT5H+UmW5y8gX82z2Z1n4dM1fifOcuvuLLoWZUZ+PhTM88tnqDaJ83aEDbXFkjKO3XJZW1lldvoCqx9V0t/yNC0hbzliRSiYbYPjJmimVNpplZsFh0fKGXJug7azzJ+OjTJ2nOpyhJUdTIfXmI/dXLE5MWdQryp+9Bqs/7KYMEvkNltktKN8r1i42cA/dwfmt18SCpb2O+/QVc1PXw0hFHRVcOXwT8wjbZ/Yw1M66DMuhYP9hQpwQ8ECwcvPDYa0JIX8Pn50R/m6v8iMu8aIYWFlanwov2eMA5zKbQTyvg2pK8n1A9P1GyIo9UTCf/a/5rccUytPja2POL0Mfq1lsxF6jslu1k/9AEw2mv45JnbhQpHF+Ff/FwDbjLfGIKC0AAAAAElFTkSuQmCC"

/***/ }),
/* 490 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAAHhSr/lAAAAAXNSR0IArs4c6QAAAUVJREFUSA1j+A8FFn7tMOZ/lgvXnjCAwJ8//xhgbBYDLRmwIAsLEwOMzQDSo2JTDdcKYsC1w7SCtYFk0FWCtYMkQAAkiewKiCiEZARJgo0hRCDrwmci3Ool605iuAtmCBMh20DycO8+ef4erB7F21ATiPMAzF6K3cQIMglqNZxauv4UQ0PfJjBfRIiH4fjGCrgcPgZRoYDPAGQ54gICWQceNnVdNnjDDJvLVG1r4CFz+3ALnE2IQdUwG7yGwXMlrvDAlktxqR28iZaqEYC11BhNZ7hSBVgca5hh04Fc+iLLk1ISI+sjxKZqyiBkGSnyow4jJbRAaqla/JBqOT71o1GJL3SwyTGev/IIo2GGTeHOg9cY5iw/jCElwMfFMLsrFkOcUgEWA21Zosy4eus5VnXgbgGRZmA1AIfgaBrDETA4hQdtiAEAtHIcYRJAlwcAAAAASUVORK5CYII="

/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAXCAYAAABnGz2mAAAAAXNSR0IArs4c6QAAALtJREFUSA1jZAie9J+BAJjitp4h0+g4iirl6ZUMDz4KoohRk8NETcOoadaow0gNzdEQGw0xUkOAVPWDNo0xPtgrSbCAFeL4ysDN9gvF08+/8DH8+ceMIkZNDuPf0xwEHUZNC4k1a9BG5aB1GMuGWzoEQ1df7BmDosA7FHW77qsxfPvNhiJGTQ7jaOuCxOActGls1GEkxiTDaIgNmxBjYWBkOEvIN59+copffyuO0iUCVrB3gXp/E9JLrjwAS7Eqzpqibq8AAAAASUVORK5CYII="

/***/ }),
/* 492 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAACWTY9zAAAAAXNSR0IArs4c6QAAARNJREFUSA1jfK2g/p9hEAKmQegmsJNGHUZqzLCQqgFdPZuvNwO7qzOK8M/dexl+bd6KIkYqh2KHsWhqMLD7eqHY+/fJU4odNprGUIKUCM6gDTGS0hi7nw8Di6kxin9ZjQxQ+CAOm501AyMvD4r4n9NnGX5u2oIiho9DksNYzU0ZOKLC8ZkHlmPR1mIAYWTwg4mJJIcN2qgcdRhytBLDJimN/dy1h+Hv02co5rLZ2TCA0h4y+H3yNMOvQ0eQhRj+XL2GwifEIclhvw8eZgBhZMDIw4PpsHMXGL5Pm4msjGT2aBojNcgGbYiRlMaw+fr3qdMM35hR/QcSoxQwjrb5SQxC1DggUTMtlbMwMjI8pqUF5JoNAON7PBhH3aG6AAAAAElFTkSuQmCC"

/***/ }),
/* 493 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAACWTY9zAAAAAXNSR0IArs4c6QAAAH1JREFUSA1jfK2g/p9hEAKmQegmsJMGrcNYmKWlBmWgMf4HgsHoskEblYPWYSxnT18fjDHJwKgi4zeaxkiJmkGbxkYdRko0gtSOhhipIcaSmhlIqh66qB+tK0kN5kGb+Fm+1jeT6hm6qGccbfOTGM6DN43ddvddRaJn6KIcACv1FfNjRLK2AAAAAElFTkSuQmCC"

/***/ }),
/* 494 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAXCAYAAABnGz2mAAAAAXNSR0IArs4c6QAAAklJREFUSA3tVj1oFEEUft/MaUyiFkICJi5n4nlcozZanIKksvAQVKystBKEgIW2EhAJopWVYGdnYSH41+tpIcFGiRfC/UXxVCRqEX9yO8+3C3ewyU52Tk65IgvLzrz3vW+/eW/e7KKWzjL14KV6UFMoaV1Yp5Xp2YylnFcCekTQdzXTHLTRTR8ZYnMKREele7q+wGRCoKFIn0xX5wrpyuydvn6q+b7yAN4N4KEsbJIIFecFOgLXzBgISxo0MVqdLQV8C2O5yR9LZpqJByl6yBQJNCK2Psf3JsISMsaXRiulUFQ9nT1vjLkZilpFy4faooDqKvdfGOzCQB+9s6dvBZyNXXuHpVzXXfilxDekxC8l2025X7vExGHswhjPMDVlgqDf/s+DkqmBOIKIDfQVhsobUgMF3rpxWGJqEX8HE7swosU2D1SmPbYNgBcprQo7qqUn2+dffdbfl3MCLdjgSXa7MPBIKxjGvGmNrU/mfLNpitIgZ+rj2QO+HCmCvW3FJziswsA4vJDP9wfxg3rLc9kvXxK4Qreca0Ns6AH59BSg4y4xcRirMNkfm/nD4tUgaFt55hs0zsURrLQx02XpUGkWIhkPrfS7zq3CQgI2F+pjuSPB2Cu/vae1OiYZeR8hB5alY4tiD0+2+OMkEuE0QdL/WND28sG55unxK5h//It3Tmx6R5/2iXkPoBq+of1gvtgtQS3VicLaQKDOzPehqARSyjBnQHxCyuW1MN18Ogvr5ktduNbeYy4M/wizLqzTxMpvD2Y6Dfof+D9s1a58PddnSAAAAABJRU5ErkJggg=="

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAACWTY9zAAAAAXNSR0IArs4c6QAAAHZJREFUSA1jfKOg8p+BCPCHjeWpjK+wNBFKqaKEiSqm0MCQUYeRGqijITYaYqSGAKnqWYjVwMrA+Od3zxFilVOsbjTxkxqEoyE2GmKkhgCp6gdtGiO6HPv97x8LIyMjqR4nW/2gDbFRh5Eap6MhNhpipIYAqeoBLe4LMF9r2yUAAAAASUVORK5CYII="

/***/ }),
/* 496 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAAXNSR0IArs4c6QAAAUlJREFUKBWVUT1LA0EQ3bnTQkuJreBPsRERTgQbFRI5EuNHoU0aTYorkkgQC02IRMTPInJEiURUBPE/iFhrKxZamuzOc9dwQaKiDuzHzHvz9rFD89eYhhK9m4OUFf8MJ99IAvRkASKkV2bmAgXoyl90DG+kKAsKnBZA6KNn9gq5+DkjdobSb0IGHy3JklOsYzj/ljMCrZfjl0izRJKZdvscEfOIuN2VB1i3O2pbNdhlUKY215kyHCsgbg1RShB5YHYfqrznA3aAmdP3Yd/tqn0wXNK8QMBgLScmMRE9xZJUnBUQR/09VtgbIOndoOP+UR0qhXFtZvkkZq802c39i4gpu1UkZINXBdNxVzdFXl/UAbMYg6REJWqvfRYw929FDDBVwYJ2tK7H/6wd6AnSoh+xNwzWHj+KGGK4AkfWeUJ/Xbk8SbX25iB/B9XbpbImFOK8AAAAAElFTkSuQmCC"

/***/ }),
/* 497 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAAHhSr/lAAAAAXNSR0IArs4c6QAAAK9JREFUSA3tVLsRgDAINZ6FY9g5jneOYuHSlg4QtSUQwHueFEnH//EIpGOac0deyvcjui6d214qPwinhR+ZRcQ6coBeO/ZcJNWZsNkycRQX5SwdJosTzSzJJuxSMNWb2KJBkoxFFpezsMigA4Ami/vPoG1Ck7EnXto9TR/3BGE5Q+6mxqnHDu3SU1jzDQtsGNdFA/+LHXrLkB2EHWUD5h0z9Fx7i9f82yhr7HC2sIxdleJCh1YUNl4AAAAASUVORK5CYII="

/***/ }),
/* 498 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAAHhSr/lAAAAAXNSR0IArs4c6QAABK5JREFUSA2tV3tMU1cY/yHQB4hBHA+pQwEZMnDgWp0SK9sfm4AoCJMJiTMBMTomm5NQYVMyFR8wGgEF0c3EZcnmXFQw021ZtigRNrAwUBlGzEQeQeAPJ4+2UOjuuebc3Nvb1sI8yeF7/b7f+b5z2nMKfHyrzLExeWazDuwMCtSaZ4EZzR2BSM7/mKjscCJIarz9RhsabofA6ebNXnO0TEH98I2vwqyNybW48OAe5yQKy/nhrt8Qmn6WC3CcHh4ShAW040pJKRckSvC7WoyMyZ9lE8fw8Dga7y5Go6kPqZ/tIi7BcBFYjLF+Qw3z91W0Og/g+Of7uDC39OOrOzknX2E7IQ5S28mGFn5MoLOdkboOHPwDOnO/IEgNFkSN+HWX2I2iNpUCEHF6ekpRVqejcVaKQE+eGHH4SCPO3bnDAbnuiOfYMTVeX+aD/JwS/Kgt4UD2FLrxBCPYU42mjs2rubyb6SEIKyPuo6ZYa49LEBOVT6KJSTWYM0eC9kfhOFHfjE0FOYIkW4ZVMgJ++nScnQcP/QlNUQG+7+xA2v5sWzysX9CmLeQ65ujIuHZ1H9N+BGJXtuLc/lMiuM3KREjGERd/CV5eMrT8swrf/N2ObUe2C2DsaapUvkhICIJWq0Pz2Wx4uBkEIHsG+SzTwbZ569ZjtLYOoqd7O5QqCa6XbcNsuZFiHJZcmxMTU/D1O4WenhEEpxzHqEHqMAkFcmTUsUatgEazHJFbKxlCCXU7JEWneaOuF41N/eh6mIXIKFc0VGbCTTbhEJmoMpJlMEyyLff3jyIwuRx6o+vMyWhmTs4yrH1nISK2VMEwLmqCwjhptTIaLS9vQWvbEB50ZiJ0cyWME/YJ7ZIRUtIqOWXSekBiBcZNznQtkXwuGc3Iy1uO1av9sSStGhMm62nWvZSBJ4uLm9DVNcy0nIHAlCqYJsWpYg+PwFLt7h6G3/xq9hUIea9aRCi4ab1fkmNwSA9vbzmGGHn0qBqFhfUIX3Qf5w9VTOs7a1mILZt/U/Mxgi5JUWQMDuqxRr0AXnNl2POJCrqOICzdUoGE3NwZfWX5Czqq2/wMXr/RAzKlUmeUlsYgbXMompsHoN4RiQVzW/DtgRNwl407us60cYIds5ZtNE4yj2kT/BWnkZH5C3p7R5DyfgZz4ZVh497dGDM4dgNY47bne25hJHlgYIzlIDJ27SLM85IzR6xEfdsrCEs/iZSCjxy+ouwVw4/ZPEo+iK//9PNDkOnj44YfLqxHdPR8XLzYyRQYgRVLbuPrwkrIJCZ+yoz0aRdGVyG7R36lkpvOz88der0JcalZWJgUhreUd9m3Xuo68wIdOkpajKUkRZFBZO4eJXMvubNH/bsuHCGplUgvzLZ7JVvy8e0Z7xifhOhflD77verv746ay4lQKn3w3fl7WLwpEjFRLfjq09OQuExaptm0X1hhdIW+vlHs/OBXEEmKNJmmoE7YgZc3vIa4VX/hTP4ZuLpMUbhN+b+O0hYrKYoMIvP3rkBwkCf7OF5riMLSrV8ioyhL9ARZcrk4OTk9snS+SLvocCNLp1DMdr5SmzQvIMDDpbZWNRqQpPo3+c16N2Z9PTO5/xbp2v8BafWMeWbbXXMAAAAASUVORK5CYII="

/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAWCAYAAAHftQ6oAAAAAXNSR0IArs4c6QAAAMFJREFUSA3tk0EKAjEMRX860LN4C/fCnMlDeArB07jyJLNQoTJCM7FJoDDFRelA4fdPkqavBDHGtK73AykhfFeA8ZkmcmpOV1HKoDUl11/uzywxHbbYTfFvLaqC/nxcVU/tgn5uJwlJsNKXkKVf1ZJM8HTHhUzYp2PC7fJSOOhKCGdSPkBzx4zG1YwXL6yOGZkjUlyft97ocEAh/JEqAnnbcNS45k7R7PF39sHpoyFG4YhByAHD9iDEKBwxCDlg2P4ACVEqlErjRdQAAAAASUVORK5CYII="

/***/ }),
/* 500 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAAHhSr/lAAAAAXNSR0IArs4c6QAAAMxJREFUSA3tlDEOg0AMBM8JP+EvUX6SV1HlLVDQpOAPeUYCKWhsCw3SRlDcNejM3t7uGmzfZRW3mv79cqVSbHjcAtL+cDzcvBSs7e7h8hQ4tVcGzJR7xosvZPs0LQ9EBprn+PEHw96Iw7QvgQoWUAqQi3eSEGqVkWCJqh9Gq4x8q4cok9qUkqG/kmaG/l5KJrUpJUPzh9pEc4qSSW1KyaSTlsZBcFKX5EKKqcJoUitOOn5WUsWztnJviqdNTDqu96ayhT9tYlXYVtuydzO7WkPVz9jVMgAAAABJRU5ErkJggg=="

/***/ }),
/* 501 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAXCAYAAAEQHA0wAAAAAXNSR0IArs4c6QAAAYJJREFUSA1jlHea9Z8BCB7sTQVRYMAEYyDTjJd11cEqkQUZQNrRARMfNxuKIhAHq3ZGmO0gFcguAPGRAVbdyApgbKxOh0ki03CrFaT5GQ4sCkOWg7PBpsX4asIFsDHAipZsvo5NDi5GlAeIcjxRiuC+gzsAyMDnU2R16Gy4jQYaonhjCV0jNj7csAs3XjMoOM/GpoZoMaJClVjT4C4jVgM+dSwMjIzf8CkgRQ5rbOLLLvgMp6o34YZlRujjs5QoObhh5almDCpyAkRpwqWIBSYBSmPYCiSYPDE03GUgxZ++/iJGD041gzfRongTp/uJlBi8htE+b2ILInJLX2xmESOGNfwVpPkYRIU4idFPMzXwnAmyQUdVhKGjyJZBSZafAdS6uPXgPUN5zyEwTTMX4DAYxWFXbr9hWLn9BgMXJysDJzsLw8NnnwbEUSC3ojgMJLB4E/7WBkgNPQBLpiZxZSEf6yuGl5P66eEmsB1ULWOp6WqsuZKaFpBr1qjDSA25QRtiABCrZi5ZAfrSAAAAAElFTkSuQmCC"

/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAXCAYAAAEQHA0wAAAAAXNSR0IArs4c6QAAA5pJREFUSA3NVl1IFFEU/kZnV3PFSivCftcsIU1NUzejoB76eykqTSuIwBLroXzRhAiUIk0JqR76ISkiiqQIElIfrIcCba1AitAs08xMXdfdWnV33bk5o7szO3+NWdB9uPec73znzJk795y5FElODoFoUJ7eXsJiZc12bNJZkJJgBLVqdSkHNh2ZjbRrVs6HUnV/3T2KpIXBHJNO3HaTE8wnIpF4uGfCfWBpNBeT09QmIhqe1g9kuPIicTW/8rP4slQLxtpkMxc70RaLzSEGxbpvt1jDu58URiw/YLYBefGhPFeYpaezizgKThL38xdCmEiSby6MAmOzIfWKxReJ9kmTwpqyT2IIlOaNlbhKAckThZTi01WIr36IN2tmwe5g0N+9GOHpHlyqLBfSeNnvjUUKuzGDqenEWVdPRq5eJ7aMLOJqeili8WoAH1YqUbNmInj7VsBqBRUcBDo1FQFhYVLiJCLZfTlmTKgLIeMb8mZIL2f2YTSogFyfpiC0OiZqA5QCYRLWdFbVQ/BWTWeap6tLqh9A3VVqVQ5GUcg4ko9HQStxbG8C8qKjkHX8HJgQgzTKJOJXlWJWZoMFu8fsiDEZ8dH8Ge8DAnFq4yIxjdf5IyeVrOs2cCBbcuzwrpwiM0EG80HMgIUMpq0jTF/fxPr9u88mJ1AsyOfpLzlKzoCOjcVYYyNok4lbDeVl/iSBRscnKRu3LtbhTCIN4h4DpaNx1zoXF1X4msrpYLQbt9tpML8pAdUW5H2DW+06r6i6aqpN1QgC41/ttIK40xaVq2naoacXQNO3lHuEO3wOaOcI+pasxFPjBqwd+4Sq9dnY97oGbaNhiBnqwApzPVwR86Dv/SoXQhX7409ZWHIPr/pt2NXeisiGWrzdmYVB+g6I/jji3HmYbygA09aCHtMO5F7IB5xO1UTERtUiF5OFOvOtF8NXrgKjTgRl7oGnqwvuhmfQpSQjcLwxuJ7UYbzjYEbOIdBxsUJXTfKfJ9b1BWAYkKEh/Cwsgt6UBv2B/XDX1cP5uAaGogJQCxaCsduhS07SlIwfSa5XasHYGwjb0NlbCDvYmwjb0NnbCDtsmdmcrnYr4YgKE52Te88v0akolRUVMCxbCotxOYK2bEZExwcMl57n9Jn37wKRkTha/AzMjY9TCctx6Zfmzik7eR3Sx30zjB7kV1dDP9jPJWQoKkRofS2qzj7A5RbFf5Q3hOKq6T+i6P0PDf9tg/0Fx/ewxZOV1xAAAAAASUVORK5CYII="

/***/ }),
/* 503 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAAHhSr/lAAAAAXNSR0IArs4c6QAAALlJREFUSA3NlsENgCAQBMVQmhZBKdbl1ypswjKQ+IR5XC5LPH9suHX2TohpO866dE9q60HMtQ7akiaUdzDfEoloI1LSRiTvN669QGsTm8nJBG9yMqWjMKSZ3kiFpJm6RYWkSclM3ScK0qRkcacpjSk1i/udSWNKzeKeAGlMqZn0bNJN4tWkKb0QVBcWLD/3RcC/a9K7TJkm7CjDguVSinICMq/Ufu/H/3uZvd8o7CjDguXW7N3f8HmVL7ojMg8W9uiVAAAAAElFTkSuQmCC"

/***/ }),
/* 504 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAAHhSr/lAAAAAXNSR0IArs4c6QAAALpJREFUSA1jXMcr+J8BDTCh8cFcrIKMNNCOzXLGnz9/YjgTq0JsDiJbIVY/o5tGlCKiPIA1NMmzjthgQDcdG58oD2LTiE2MqIDAphGbGONucyuikgU2zehiLJ+vXUcXI5tP3TAbtLFJVW8OXsOommip6s0RkgOoGmZUNYyoMpvsYoQCjVT1JQXuwNA66jCMICEgwCITFUFAycBIU7VcpKYXBm0aGy0uSI3mQRuVg9ZhLHx6uqSGMl3UAwAWOTCfbQZkIQAAAABJRU5ErkJggg=="

/***/ }),
/* 505 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAXCAYAAAEQHA0wAAAAAXNSR0IArs4c6QAAAfRJREFUSA1j/A8EDGiAkSFuCVjQ8+8Lhu3MEmBpxtcK6pgqcWrfUujA4NN/AG4yVu0MIO0wALJULmIqjItCw10ENw8HA7s1WBQzgszHIo4ixITM402dg8yFs1kY45fCOacbgxiQ+TAJojxAlONR3AQzHp0mynfomnDxcdooX7ieoWjZWQb7yF5cejHEcQYEz99fDDZMnxh2MIpgaMIlwIJL4gszG8MOBuINAplDVOjjshBdnIWJiakIXZBcPn1ikxzXYY0Am8h+hqt83AxffnEwPG9yZxCRFSfKbKyGyQpwMMjpaTGcf/ieaINAtqHkSpj1tt++MPR5ajF8//UHay6FqUOncSZax18vGC4x8jO8ZeVE14OTj9WbINX72SAlLU6dWCRw5k0sagkKUTUHUNVlVDVs8OZNgjFEggKcyQybGe+//WLYdeU5w8M37xn+/mNgkBHiY3DVlmKQ4OfAppwiMZJKM6+EiQzb/4swsDH/YeBm/c3w/gcng/6X5wynl+UzsLKzUuQQdM0soLqMWMDJysxwsdaLQVdWAKzl2fvvDLnl8xjK114i1gii1eEsfrCZwPnvD0M0z2eGkOwgBg4WFoZVC7czrH7wk+E1Gzc25RSJkeQwimwiUTNVywsS7carnKpFLF6bSJQctCE26jASY5IBAOr8tfUHAP1CAAAAAElFTkSuQmCC"

/***/ }),
/* 506 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAhhJREFUOBGNkztoU2EUx3s/ghaxZEimliYgrgVfS8Ek5CFEMDilbgoVpHWxii51aIZCwT4cFUWItFvEXZpHby5aoXTo1HZxVMFk0CbgoLn+/tfeEtpqe+Dcc75z/uf1fedaPV2Uz+dPNJvNUUwjrusOWZbVh/yMtOEXlUpltQvuqZZvyGQy5zudzhvOA/Bb+ANBO9gi6Nfhi/DraDQ6ViwWf6J75CXYDXawbFPxZiKR2C4UCr92MT3YrHQ6PcZ5Fn0V/1Xfb9S2KuPYCoVCw1S9Ztv2ih8sic2tVqvPkFfgpOM4k77fMPNtDmr7VqPRuEeiM+FwOOEDuqXuAP88BR/RdVA+A+fhd2qb7DmC75ZKpd9yHkbBYHAGey+Jsp4/mUx+S6VSU4eB99s0rmzgN+Bp6YaqeqovOhxFjFsWBvwO3CfdKJgkQzr8j3K53CmwGlkUIcYrqg5WcFz+a//3t9VqTRljFhlZ+zBInC20Mr6EzzGT3vkAqTI78ISAs7FY7BWA5+hr5XL5o8CG99XGLdHFLMBhP4MujKT1dru9jO9TPB6/Ua/XlegC53GkK2xAHxboDhfUj8MhaI5WZ3jK77ji8mtTCX6PegkMbqM9WZdv719gNQOAHgN4iP0kFTbRfyAjSF3aGnJcwSzSPJgHtVrt6V4CZRNpwwBmYb3MafgrwbZmRnptc5H3sS+QbOJAAhzHIkadADj6BzLU+MGM6JTtAAAAAElFTkSuQmCC"

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1205)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(648),
  /* template */
  __webpack_require__(1470),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5d220fb1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */
/***/ (function(module, exports) {

module.exports = {
	"dailyData": [
		{
			"width": "120",
			"label": "日期",
			"prop": "date"
		},
		{
			"width": "",
			"label": "开闭环",
			"prop": "isOpen"
		},
		{
			"width": "",
			"label": "来源",
			"prop": "data_source"
		},
		{
			"width": "180",
			"label": "账号",
			"prop": "account"
		},
		{
			"width": "",
			"label": "用户名",
			"prop": "userName"
		},
		{
			"width": "100",
			"label": "Avg.SG",
			"prop": "avgSG"
		},
		{
			"width": "100",
			"label": "SGnum",
			"prop": "SGnum"
		},
		{
			"width": "100",
			"label": "< 3.0",
			"prop": "below30Percent"
		},
		{
			"width": "",
			"label": "TBR",
			"prop": "TBRPercent"
		},
		{
			"width": "",
			"label": "TIR",
			"prop": "TirPercent"
		},
		{
			"width": "",
			"label": "TAR",
			"prop": "tarPercent"
		},
		{
			"width": "100",
			"label": "> 13.9",
			"prop": "beyond13Percent"
		},
		{
			"width": "100",
			"label": "Auto%",
			"prop": "AutoPercent"
		},
		{
			"width": "",
			"label": "Basal",
			"prop": "avgBasal"
		},
		{
			"width": "100",
			"label": "Basal%",
			"prop": "basalPercent"
		},
		{
			"width": "",
			"label": "Bolus",
			"prop": "avgBolus"
		},
		{
			"width": "100",
			"label": "Bolus%",
			"prop": "bolusPercent"
		},
		{
			"width": "",
			"label": "TDD",
			"prop": "TDD"
		},
		{
			"width": "",
			"label": "(TDD/Avg.TDD)%",
			"prop": "TDDPercent"
		},
		{
			"width": "",
			"label": "Umax",
			"prop": "umax"
		},
		{
			"width": "120",
			"label": "Newbasal",
			"prop": "newbasal"
		}
	],
	"accountData": [
		{
			"width": "70",
			"label": "组别",
			"prop": "groupName"
		},
		{
			"width": "",
			"label": "开闭环",
			"prop": "isOpen"
		},
		{
			"width": "180",
			"label": "账号",
			"prop": "account"
		},
		{
			"width": "",
			"label": "来源",
			"prop": "data_source"
		},
		{
			"width": "",
			"label": "用户名",
			"prop": "userName"
		},
		{
			"width": "100",
			"label": "Avg.SG",
			"prop": "avgSG"
		},
		{
			"width": "100",
			"label": "SGnum",
			"prop": "SGnum"
		},
		{
			"width": "",
			"label": "< 3.0",
			"prop": "below30Percent"
		},
		{
			"width": "",
			"label": "TBR",
			"prop": "TBRPercent"
		},
		{
			"width": "",
			"label": "TIR",
			"prop": "TirPercent"
		},
		{
			"width": "",
			"label": "TAR",
			"prop": "tarPercent"
		},
		{
			"width": "100",
			"label": "> 13.9",
			"prop": "beyond13Percent"
		},
		{
			"width": "100",
			"label": "Auto%",
			"prop": "AutoPercent"
		},
		{
			"width": "",
			"label": "Basal",
			"prop": "avgBasal"
		},
		{
			"width": "100",
			"label": "Basal%",
			"prop": "basalPercent"
		},
		{
			"width": "",
			"label": "Bolus",
			"prop": "avgBolus"
		},
		{
			"width": "100",
			"label": "Bolus%",
			"prop": "bolusPercent"
		},
		{
			"width": "",
			"label": "TDD",
			"prop": "TDD"
		},
		{
			"width": "",
			"label": "Umax",
			"prop": "umax"
		},
		{
			"width": "120",
			"label": "Newbasal",
			"prop": "newbasal"
		}
	],
	"invalidAccountData": [
		{
			"label": "账号",
			"prop": "accountName"
		},
		{
			"width": "",
			"label": "用户名",
			"prop": "userName"
		}
	],
	"groupData": [
		{
			"width": "70",
			"label": "组别",
			"prop": "groupName"
		},
		{
			"width": "",
			"label": "Avg.SG",
			"prop": "avgSG"
		},
		{
			"width": "",
			"label": "SGnum",
			"prop": "SGnum"
		},
		{
			"width": "",
			"label": "< 3.0",
			"prop": "below30Percent"
		},
		{
			"width": "",
			"label": "TBR",
			"prop": "TBRPercent"
		},
		{
			"width": "",
			"label": "TIR",
			"prop": "TirPercent"
		},
		{
			"width": "",
			"label": "TAR",
			"prop": "tarPercent"
		},
		{
			"width": "",
			"label": "> 13.9",
			"prop": "beyond13Percent"
		},
		{
			"width": "",
			"label": "Auto%",
			"prop": "AutoPercent"
		},
		{
			"width": "",
			"label": "Basal",
			"prop": "avgBasal"
		},
		{
			"width": "",
			"label": "Basal%",
			"prop": "basalPercent"
		},
		{
			"width": "",
			"label": "Bolus",
			"prop": "avgBolus"
		},
		{
			"width": "",
			"label": "Bolus%",
			"prop": "bolusPercent"
		}
	],
	"insulinData": [
		{
			"width": "120",
			"label": "日期",
			"prop": "date"
		},
		{
			"width": "180",
			"label": "账号",
			"prop": "account"
		},
		{
			"width": "",
			"label": "用户名",
			"prop": "userName"
		},
		{
			"width": "",
			"label": "来源",
			"prop": "data_source"
		},
		{
			"width": "",
			"label": "Basal",
			"prop": "totalBasal"
		},
		{
			"width": "",
			"label": "Bolus",
			"prop": "totalBolus"
		},
		{
			"width": "",
			"label": "0:00-1:00",
			"prop": "basalDate1",
			"child": [
				{
					"width": "",
					"label": "Basal1",
					"prop": "Basal1"
				}
			]
		},
		{
			"width": "",
			"label": "1:00-2:00",
			"prop": "basalDate2",
			"child": [
				{
					"width": "",
					"label": "Basal2",
					"prop": "Basal2"
				}
			]
		},
		{
			"width": "",
			"label": "2:00-3:00",
			"prop": "basalDate3",
			"child": [
				{
					"width": "",
					"label": "Basal3",
					"prop": "Basal3"
				}
			]
		},
		{
			"width": "",
			"label": "3:00-4:00",
			"prop": "basalDate4",
			"child": [
				{
					"width": "",
					"label": "Basal4",
					"prop": "Basal4"
				}
			]
		},
		{
			"width": "",
			"label": "4:00-5:00",
			"prop": "basalDate5",
			"child": [
				{
					"width": "",
					"label": "Basal5",
					"prop": "Basal5"
				}
			]
		},
		{
			"width": "",
			"label": "5:00-6:00",
			"prop": "basalDate6",
			"child": [
				{
					"width": "",
					"label": "Basal6",
					"prop": "Basal6"
				}
			]
		},
		{
			"width": "",
			"label": "6:00-7:00",
			"prop": "basalDate7",
			"child": [
				{
					"width": "",
					"label": "Basal7",
					"prop": "Basal7"
				}
			]
		},
		{
			"width": "",
			"label": "7:00-8:00",
			"prop": "basalDate8",
			"child": [
				{
					"width": "",
					"label": "Basal8",
					"prop": "Basal8"
				}
			]
		},
		{
			"width": "",
			"label": "8:00-9:00",
			"prop": "basalDate9",
			"child": [
				{
					"width": "",
					"label": "Basal9",
					"prop": "Basal9"
				}
			]
		},
		{
			"width": "",
			"label": "9:00-10:00",
			"prop": "basalDate10",
			"child": [
				{
					"width": "",
					"label": "Basal10",
					"prop": "Basal10"
				}
			]
		},
		{
			"width": "",
			"label": "10:00-11:00",
			"prop": "basalDate11",
			"child": [
				{
					"width": "",
					"label": "Basal11",
					"prop": "Basal11"
				}
			]
		},
		{
			"width": "",
			"label": "11:00-12:00",
			"prop": "basalDate12",
			"child": [
				{
					"width": "",
					"label": "Basal12",
					"prop": "Basal12"
				}
			]
		},
		{
			"width": "",
			"label": "12:00-13:00",
			"prop": "basalDate13",
			"child": [
				{
					"width": "",
					"label": "Basal13",
					"prop": "Basal13"
				}
			]
		},
		{
			"width": "",
			"label": "13:00-14:00",
			"prop": "basalDate14",
			"child": [
				{
					"width": "",
					"label": "Basal14",
					"prop": "Basal14"
				}
			]
		},
		{
			"width": "",
			"label": "14:00-15:00",
			"prop": "basalDate15",
			"child": [
				{
					"width": "",
					"label": "Basal15",
					"prop": "Basal15"
				}
			]
		},
		{
			"width": "",
			"label": "15:00-16:00",
			"prop": "basalDate16",
			"child": [
				{
					"width": "",
					"label": "Basal16",
					"prop": "Basal16"
				}
			]
		},
		{
			"width": "",
			"label": "16:00-17:00",
			"prop": "basalDate17",
			"child": [
				{
					"width": "",
					"label": "Basal17",
					"prop": "Basal17"
				}
			]
		},
		{
			"width": "",
			"label": "17:00-18:00",
			"prop": "basalDate18",
			"child": [
				{
					"width": "",
					"label": "Basal18",
					"prop": "Basal18"
				}
			]
		},
		{
			"width": "",
			"label": "18:00-19:00",
			"prop": "basalDate19",
			"child": [
				{
					"width": "",
					"label": "Basal19",
					"prop": "Basal19"
				}
			]
		},
		{
			"width": "",
			"label": "19:00-20:00",
			"prop": "basalDate20",
			"child": [
				{
					"width": "",
					"label": "Basal20",
					"prop": "Basal20"
				}
			]
		},
		{
			"width": "",
			"label": "20:00-21:00",
			"prop": "basalDate21",
			"child": [
				{
					"width": "",
					"label": "Basal21",
					"prop": "Basal21"
				}
			]
		},
		{
			"width": "",
			"label": "21:00-22:00",
			"prop": "basalDate22",
			"child": [
				{
					"width": "",
					"label": "Basal22",
					"prop": "Basal22"
				}
			]
		},
		{
			"width": "",
			"label": "22:00-23:00",
			"prop": "basalDate23",
			"child": [
				{
					"width": "",
					"label": "Basal23",
					"prop": "Basal23"
				}
			]
		},
		{
			"width": "",
			"label": "23:00-24:00",
			"prop": "basalDate24",
			"child": [
				{
					"width": "",
					"label": "Basal24",
					"prop": "Basal24"
				}
			]
		},
		{
			"width": "",
			"label": "0:00-1:00",
			"prop": "bolusDate1",
			"child": [
				{
					"width": "",
					"label": "Bolus1",
					"prop": "Bolus1"
				}
			]
		},
		{
			"width": "",
			"label": "1:00-2:00",
			"prop": "bolusDate2",
			"child": [
				{
					"width": "",
					"label": "Bolus2",
					"prop": "Bolus2"
				}
			]
		},
		{
			"width": "",
			"label": "2:00-3:00",
			"prop": "bolusDate3",
			"child": [
				{
					"width": "",
					"label": "Bolus3",
					"prop": "Bolus3"
				}
			]
		},
		{
			"width": "",
			"label": "3:00-4:00",
			"prop": "bolusDate4",
			"child": [
				{
					"width": "",
					"label": "Bolus4",
					"prop": "Bolus4"
				}
			]
		},
		{
			"width": "",
			"label": "4:00-5:00",
			"prop": "bolusDate5",
			"child": [
				{
					"width": "",
					"label": "Bolus5",
					"prop": "Bolus5"
				}
			]
		},
		{
			"width": "",
			"label": "5:00-6:00",
			"prop": "bolusDate6",
			"child": [
				{
					"width": "",
					"label": "Bolus6",
					"prop": "Bolus6"
				}
			]
		},
		{
			"width": "",
			"label": "6:00-7:00",
			"prop": "bolusDate7",
			"child": [
				{
					"width": "",
					"label": "Bolus7",
					"prop": "Bolus7"
				}
			]
		},
		{
			"width": "",
			"label": "7:00-8:00",
			"prop": "bolusDate8",
			"child": [
				{
					"width": "",
					"label": "Bolus8",
					"prop": "Bolus8"
				}
			]
		},
		{
			"width": "",
			"label": "8:00-9:00",
			"prop": "bolusDate9",
			"child": [
				{
					"width": "",
					"label": "Bolus9",
					"prop": "Bolus9"
				}
			]
		},
		{
			"width": "",
			"label": "9:00-10:00",
			"prop": "bolusDate10",
			"child": [
				{
					"width": "",
					"label": "Bolus10",
					"prop": "Bolus10"
				}
			]
		},
		{
			"width": "",
			"label": "10:00-11:00",
			"prop": "bolusDate11",
			"child": [
				{
					"width": "",
					"label": "Bolus11",
					"prop": "Bolus11"
				}
			]
		},
		{
			"width": "",
			"label": "11:00-12:00",
			"prop": "bolusDate12",
			"child": [
				{
					"width": "",
					"label": "Bolus12",
					"prop": "Bolus12"
				}
			]
		},
		{
			"width": "",
			"label": "12:00-13:00",
			"prop": "bolusDate13",
			"child": [
				{
					"width": "",
					"label": "Bolus13",
					"prop": "Bolus13"
				}
			]
		},
		{
			"width": "",
			"label": "13:00-14:00",
			"prop": "bolusDate14",
			"child": [
				{
					"width": "",
					"label": "Bolus14",
					"prop": "Bolus14"
				}
			]
		},
		{
			"width": "",
			"label": "14:00-15:00",
			"prop": "bolusDate15",
			"child": [
				{
					"width": "",
					"label": "Bolus15",
					"prop": "Bolus15"
				}
			]
		},
		{
			"width": "",
			"label": "15:00-16:00",
			"prop": "bolusDate16",
			"child": [
				{
					"width": "",
					"label": "Bolus16",
					"prop": "Bolus16"
				}
			]
		},
		{
			"width": "",
			"label": "16:00-17:00",
			"prop": "bolusDate17",
			"child": [
				{
					"width": "",
					"label": "Bolus17",
					"prop": "Bolus17"
				}
			]
		},
		{
			"width": "",
			"label": "17:00-18:00",
			"prop": "bolusDate18",
			"child": [
				{
					"width": "",
					"label": "Bolus18",
					"prop": "Bolus18"
				}
			]
		},
		{
			"width": "",
			"label": "18:00-19:00",
			"prop": "bolusDate19",
			"child": [
				{
					"width": "",
					"label": "Bolus19",
					"prop": "Bolus19"
				}
			]
		},
		{
			"width": "",
			"label": "19:00-20:00",
			"prop": "bolusDate20",
			"child": [
				{
					"width": "",
					"label": "Bolus20",
					"prop": "Bolus20"
				}
			]
		},
		{
			"width": "",
			"label": "20:00-21:00",
			"prop": "bolusDate21",
			"child": [
				{
					"width": "",
					"label": "Bolus21",
					"prop": "Bolus21"
				}
			]
		},
		{
			"width": "",
			"label": "21:00-22:00",
			"prop": "bolusDate22",
			"child": [
				{
					"width": "",
					"label": "Bolus22",
					"prop": "Bolus22"
				}
			]
		},
		{
			"width": "",
			"label": "22:00-23:00",
			"prop": "bolusDate23",
			"child": [
				{
					"width": "",
					"label": "Bolus23",
					"prop": "Bolus23"
				}
			]
		},
		{
			"width": "",
			"label": "23:00-24:00",
			"prop": "bolusDate24",
			"child": [
				{
					"width": "",
					"label": "Bolus24",
					"prop": "Bolus24"
				}
			]
		}
	]
};

/***/ }),
/* 544 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(326);




__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var state = {
  count: 10,
  language: 'en',
  langs: [{ lang: true, ab: 'en' }, { lang: false, ab: 'zh' }, { lang: false, ab: 'fr' }, { lang: false, ab: 'de' }, { lang: false, ab: 'sw' }, { lang: false, ab: 'en' }, { lang: false, ab: 'hk' }, { lang: false, ab: 'en' }, { lang: false, ab: 'it' }, { lang: false, ab: 'du' }, { lang: false, ab: 'en' }, { lang: false, ab: 'po' }, { lang: false, ab: 'es' }, { lang: false, ab: 'tr' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'cz' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'pl' }, { lang: false, ab: 'dk' }, { lang: false, ab: 'fi' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }, { lang: false, ab: 'en' }],
  country: [true, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],
  users: [],
  header: false,
  patientName: '',

  DataS: [],
  DataSG: [],
  DataBasal: [],
  DataBolus: [],

  DataD: [],
  olDataSG: [],

  settingData: {},
  sessions: [],

  sensor: {},
  pump: {},
  compileTimeout1: '',

  events: [],
  Request: [],

  alarm_display: 'Off',
  glucose_display: 'Off',
  unRead: 0,

  loc_code: ''

};

var mutations = {
  changLanguage: function changLanguage(context, info) {
    context.langs.map(function (e, i) {
      if (i === info[1]) {
        e.lang = true;
        context.language = e.ab;
        if (info[2] === 1) {
          localStorage.setItem('language', e.ab);
        }
        sessionStorage.setItem('language', e.ab);
      } else {
        e.lang = false;
      }
      return e;
    });
    for (var i = 0; i < context.country.length; i++) {
      context.country[i] = i === info[0] ? true : false;
    }

    console.log('info:', info);
    if (info[2] === 1) {
      localStorage.setItem('index', info[0]);
      localStorage.setItem('languageIndex', info[1]);
    }

    var loc_code = localStorage.getItem('loc_code');
    console.log('save loc_code:', loc_code);
    context.loc_code = loc_code;
  },
  updateLocCode: function updateLocCode(context, loc_code) {
    context.loc_code = loc_code;
  },
  updateUsers: function updateUsers(context, data) {
    context.users = data;
    sessionStorage.setItem('users', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
  },
  updateDataS: function updateDataS(context, data) {
    context.DataS = data;
  },
  updateDataSG: function updateDataSG(context, data) {
    context.DataSG = data;
  },
  updateOlDataSG: function updateOlDataSG(context, data) {
    context.olDataSG = data;
  },
  updateBasal: function updateBasal(context, data) {
    context.DataBasal = data;
  },
  updateBolus: function updateBolus(context, data) {
    context.DataBolus = data;
  },
  updateDataD: function updateDataD(context, data) {
    context.DataD = data;
  },
  updatePatientName: function updatePatientName(context, data) {
    context.patientName = data;
  },
  updateUnRead: function updateUnRead(context, data) {
    context.unRead = data;
  },
  updateAlarm: function updateAlarm(context, data) {
    context.alarm_display = data;
  },
  updateGlucose: function updateGlucose(context, data) {
    context.glucose_display = data;
  },
  updateRequest: function updateRequest(context, data) {
    if (!data) {
      context.Request = [];
    } else {
      context.Request.push(data);
    }
  },
  updateEvents: function updateEvents(context, data) {
    context.events = data;
  },
  updateSensor: function updateSensor(context, data) {
    context.sensor = data;
  },
  updatePump: function updatePump(context, data) {
    context.pump = data;
  },
  updateSettingData: function updateSettingData(context, data) {
    context.settingData = data;
  },
  updateSessions: function updateSessions(context, data) {
    context.sessions = data;
    sessionStorage.setItem('sessions', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
  }
};

var actions = {
  add: function add(_add) {
    _add.commit('add');
  },
  oddAdd: function oddAdd(_ref) {
    var commit = _ref.commit,
        state = _ref.state;

    if (state.count % 2 === 0) {
      commit('add');
    }
  }
};

var getters = {
  count: function count(context) {
    return context.count;
  },
  getOdd: function getOdd(context) {
    return context.count % 2 === 0 ? '偶数' : '奇数';
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}));

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return czMessages; });

var czMessages = {

  "privacy_policy_and_terms_of_use": "Privacy Policy and Terms of Use ",
  "privacy_confirm_text": "We've updated our <a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>Privacy Policy</a> and <a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>Terms of Use</a>. To continue using EasyView, you need to read and agree to all the terms.",
  "privacy_confirm_disagree": "Disagree",
  "privacy_confirm_accept": "Accept",

  "title": "EasyView Personal",
  "title1": "EasyView Pro",
  "user": "Email",
  "password": "Heslo",
  "remember": "Zapamatuj si mě",
  "forget": "Zapomenuté heslo?",
  "sign in": "Přihlásit se",
  "login": "Login",
  "sign up now": "Zaregistrovat se nyní",
  "apply": "Založit si účet",
  "contact us": "Kontaktujte nás",
  "Privacy Policy": "Zásady ochrany osobních údajů",
  "Terms of Use": "Podmínky užití",
  "copyright": "Autorská práva © 2021 Medtrum Technologies Inc. Všechna práva vyhrazena.",

  "chooseLang": "Zvolte Vaši zemi a jazyk",
  "asia": "Asie",
  "europe": "Evropa",

  "applyHcp": "Založit si účet poskytovatele zdr. péče",
  "sign up": "Zaregistrovat se",
  "Patient": "Pacient",
  "Caregiver": "Poskytovatel zdr. Péče",
  "Email": "Email",
  "Mobile": "Mobil",
  "Enter email": "Zadejte email adresu",
  "Enter mobile": "Zadejte mob. číslo",
  "Verification": "Verifikační kód",
  "Invitation": "Invitation code",
  "full name": "Zadejte své celé jméno",
  "Enter pass": "Zadejte heslo",
  "org": "Společnost/Organizace",
  "Register": "Register",
  "send": "Zaslat",
  "agree": "Přečetl jsem si a souhlasím se Zásadami ochrany ",
  "privacy": " ochrany osobních údajů ",
  "and": "a ",
  "use": "Podmínkami užití.",
  "errtip1-1": "Musíte zadat platnou email adresu, která se ",
  "errtip1-2": "stane Vaším Medtrum uživ. jménem.",
  "errtip2": "Please enter a valid mobile number.",
  "errtip3": "Nesprávný verifikační kód",
  "errtip4": "Incorrect invitation code.",
  "errtip5": "Nesprávné uživ. Jméno",
  "errtip6": "Your password must have 8 or more characters.",
  "errtip7": "Please enter your organization.",

  "errp1": "Heslo musí obsahovat alespoň 3 typy následujících znaků: ",
  "errp2": "velká, malá písmena, čísla a zvláštní znaky.",
  "errp3": "Heslo musí mít délku mezi 6-20 znaky.",
  "errp4": "Heslo musí být jiné než uživatelské jméno.",
  "errp5": "Heslo s 3 po sobě jdoucími čísly je neplatné. (Např.: 123,321).",
  "errp6": "Heslo s 3 po sobě jdoucími písmeny je neplatné. (Např.: abc,cba).",
  "errp7": "Heslo nesmí obsahovat mezeru.",

  "Find account": "Znovu získat heslo",
  "Enter username": "Prosím zadejte Vaše uživ. jméno",
  "Next": "Dále",
  "Cancel": "Zrušit",
  "Back": "Zpět",
  "Enter veri": "Verifikační kód",
  "Verify notice": "Prosím vyhledejte verifikační kód zaslaný v emailu. ",
  "Create new": "Zadat nové heslo",
  "Create new notice": "Prosím zadejte nové heslo obsahující 6 nebo více znaků.",
  "New pass": "Nové heslo",
  "Completed": "Hotovo",
  "Created": "Nové heslo zadáno",
  "Login Now": "Přihlásit se nyní",

  "Delete": "Vymazat",
  "New Patient": "Nový pacient",
  "Add Patient": "Přidat pacienta",
  "Filter": "Filtr",
  "Name": "Jméno",
  "Gender": "Pohlaví",
  "Age": "Věk",
  "Type": "Typ cukrovky",
  "Duration": "Doba trvání",
  "Connections": "Tvůrce účtu",
  "UploadTime": "Čas nahrání",
  "Year": "roky",
  "Years": "roky",
  "Month": "měsíců",
  "Month2": "Měsíc",
  "Months": "měsíců",
  "Invite": "Pozvat",
  "Invited": "Pozván/a",
  "All": "Vše",
  "Female": "Žena",
  "Male": "Muž",
  "Not Set": "Neurčeno",
  "Type 1": "Cukrovka typu 1",
  "Type 2": "Cukrovka typu 2",
  "Gestational": "Gestacionální cukrovka",
  "Prediabetes": "Prediabetes",
  "LADA": "Typ 1.5 LADA",
  "Apply": "Použít",
  "disUn": "Neupřesněná nemoc",
  "ageUn": "Neupřesněný věk",
  "genUn": "Neupřesněné pohlaví",
  "addP": "Přidat pacienta",
  "newP": "Nový pacient",
  "findP": "Najít pacienta",

  "GDRNF": "Neurčeno",
  "GDRF": "Žena",
  "GDRM": "Muž",
  "女": "Muž",

  "DBTNF": "Neurčeno",
  "DBT1": "Cukrovka typu 1",
  "DBT2": "Cukrovka typu 2",
  "DBTLADA": "Type 1.5 LADA",
  "DBTPRE": "Prediabetes",
  "DBTGEST": "Gestacionální cukrovka",
  "前期": "beFore",
  "beFore": "beFore",
  "MODY": "Mody",

  "No selection": "Neurčeno",
  "unspecif": "Neurčeno",
  "register": "Pacient",
  "hcp": "Doktor",

  "BG": "Krevní glukóza",
  "CARB": "Sacharidy",
  "INS": "Injekce",
  "EXR": "Cvičení",
  "OTR": "Další",
  "HBA1C": "HbA1c",
  "DOSE": "DOSE",
  "URINEK": "Ketony v moči",
  "HEL": "HEL",
  "OTR1": "Další",
  "Loading": "Nahrávám",

  "home": "Domov ",
  "pID": "ID Pacienta",
  "fullName": "Celé jméno",
  "gender": "Pohlaví",
  "height": "Výška",
  "weight": "Váha",
  "cm": "cm",
  "kg": "kg",
  "birthday": "Datum narození",
  "disType": "Typ cukrovky",
  "disDate": "Datum diagnózy",
  "Address": "Adresa",
  "Postcode": "PSČ",
  "Inpatient": "Hospitalizovaný pacient",
  "Yes": "Ano",
  "No": "Ne",
  "Pno": "Číslo hosp. pacienta",
  "Bno": "Číslo pac. postele",
  "create": "Vytvořit",
  "Telephone": "Tel.",

  "enterU": "Zadat uživ. Jméno (email)",
  "search": "Vyhledat",
  "noU": "Je vyžadováno uživ. jméno",
  "searchR": "Výsledky vyhledávání",
  "uername": "Uživ. jméno",
  "alias": "Přezdívka",
  "remove": "Odstranit",
  "viewG": "Zobrazit grafy",
  "sendR": "Zaslat žádost",
  "rSent": "Vaše žádost byla zaslána.",
  "cancelR": "Zrušit žádost",

  "VcodeTip1": "Nedoručeno? Prosím počkejte jednu minutu a ",
  "VcodeTip2": "zkuste to znovu.",
  "VcodeTip3": "Právě jsme zaslali verifikační kód na ",
  "Entercode": "Zadat kód",
  "Getcode": "Získat kód",

  "messages": "Zprávy",
  "profile": "Profil",
  "sign out": "Odhlásit se",
  "changeP": "Změnit heslo",
  "connection": "Spojení",

  "myP": "Můj profil",
  "Portrait": "Profil. foto",
  "Profession": "Povolání",
  "DPRONF": "Neurčeno",
  "DPROENDOCRIN": "Endokrinolog",
  "DPRODIABTRA": "Diabetolog",
  "DPRONURSE": "Zdr. sestra/bratr",
  "DPRODIATIT": "Dietetik",
  "DPROOTR": "Další Poskyt. zdrav. péče",
  "Organization": "Společnost",
  "Bio": "Životopis",
  "save": "Uložit",
  "oldPa": "Staré heslo",
  "newPa": "Nové heslo",
  "RePa": "Znovu zadat heslo",
  "forgetY": "Zapomenuté heslo?",
  "applyM": "Použít",
  "oldErr": "Staré heslo je nesprávné.",
  "EntTheSame": "Zadejte nové heslo znovu.",
  "EnterOld": "Zadejte straré heslo.",

  "pList": "Pacientův seznam",
  "connections": "Spojení",
  "settings": "Nastavení",
  "monitor": "Monitorace",
  "graphs": "Hlášení",
  "events": "Události",
  "records": "Záznamy",
  "qPrint": "Rychlý tisk",

  "sensorIn": "Senzor Info ",
  "timeOfLaRead": "Čas posledního senzor. měření hod",
  "tranSn": "SČ Vysílače",
  "status": "Stav",
  "sensorLife": "Zbývající životnost senzoru",
  "lastSenorRead": "Poslední senzorová hodnota",
  "TranBattery": "Baterie Vysílače",
  "sg": "SG",
  "alert": "Upozornění",
  "target": "Cíl",
  "hypo": "Hypo",
  "sensorGlucose": "Senzor. Glukóza",
  "calib": "Kalibrace",
  "newSen": "Nový senzor",
  "warm": "Příprava senzoru",
  "InsulinPump": "Inzulinová pumpa",
  "timeOfLaPump": "Čas posledních dat z pumpy",
  "pumpSN": "SČ Podstavy pumpy",
  "ReserviorLife": "Zbývající životnost zásob. náplasti",
  "InsulinLeft": "Zbývající inzulin",
  "basal": "Bazál",
  "bolus": "Bolus",
  "totalBasal": "Celodenní bazál",
  "lastBolus": "Poslední bolus",
  "activeInsulin": "Aktivní inzulin",
  "totalBolus": "Celodenní bolus",
  "tampBasal": "Dočasný bazál",
  "normalBolus": "Běžný bolus",
  "extendBolus": "Rozšířený bolus",
  "manualStop": "Manuální přerušení",
  "autoStop": "Auto přerušení",
  "auto suspend": "Auto přerušení",
  "stop": "Zastavení dávky",
  "newPatch": "Nová náplast",
  "tempBasal": "Dočasný bazál",
  "N": "B",
  "E": "R",
  "CN1": "KB",
  "CE": "KR",

  "staticSettings": "Nastavení hlášení",
  "dataSource": "Data k zobrazení",
  "unit": "Jednotka",
  "glucoseTarget": "Cílové rozmezí glukózy",
  "overall": "Celkem",
  "Hypoglycemia": "Hypoglykemie",
  "timePeriod": "Časové období",
  "postMeal": "Pojídelní analýza",
  "Breakfast": "Snídaně",
  "Lunch": "Oběd",
  "Dinner": "Večeře",
  "night": "Noc",
  "Before": "Předtím",
  "After": "Poté",
  "Low": "Nízká",
  "High": "Vysoká",
  "From": "Od",
  "To": "Do",
  "Hours": "Hodin",
  "Reset": "Obnovit výchozí nastavení",
  "RealTime": "Reálný čas",
  "uploaded": "Nahráno",
  "sensor": "Senzor",
  "pdmSN": "SČ ODM",
  "startTime": "Startovací čas",
  "endTime": "Konečný čas",
  "uploadTime": "Čas nahrání",
  "pdm": "ODM",
  "Uploaded": "Nahráno",
  "Patch Pump": "Patch pumpa",
  "overLapp": "Sessions overlapped",
  "showAlert": "Zobrazit upozornění",

  "dashboard": "Přístrojová deska",
  "dboard_glucose_statistics": "Glucose Statistics",
  "dboard_glucose": "Glucose",
  "dboard_cgm": "CGM",
  "dboard_insulin": "Insulin",
  "dboard_carbs": "Carbs",
  "dboard_exercise": "Exercise",
  "dboard_glucose_avg": "Average",
  "dboard_cgm_avg": "Průměrný",
  "dboard_insulin_avg": "Average Daily Dose",
  "dboard_carbs_avg": "Průměrná denní dávka sacharidů",
  "dboard_exercise_avg": "Průměrná doba / Den",
  "dboard_sd": "SD",
  "dboard_num": "Mřížka",
  "dboard_num_days": "# days",
  "dboard_statistics": "Statistics",
  "dboard_BG": "BG",
  "dboard_BG_calibration": "BG / calibration (per day)",
  "dboard_SG": "SG",
  "dboard_AUC_high": "AUC high >",
  "dboard_AUC_low": "AUC low <",
  "dboard_highest_value": "Nejvyšší hodnota",
  "dboard_lowest_value": "Nejnižší hodnota",

  "dboard_pump": "Pump",
  "dboard_avg_daily_dose": "Průměrná denní dávka",
  "dboard_SD": "Směrodatná odchylka",
  "dboard_daily_basal": "Denní basal",
  "dboard_daily_bolus": "Denní bolus",
  "dboard_avg_bolus_num": "Průměrná hodnota bolusu za den",
  "dboard_avg_suspend_time": "Průměrná doba odstavení",
  "dboard_avg_reservoir_usage": "Průměrná spotřeba rezervy",
  "dboard_days": "days",

  "dboard_manual_bolus": "Manuální bolus (Objem/za den)",
  "dboard_normal": "-Normální",
  "dboard_extend": "-Rozšířený",
  "dboard_combo": "-Kombinace",

  "dboard_bolus_calculator": "Kalkulačka Bolusu (Objem/ za den)",
  "dboard_food_bolus": "-Kalkulačka bolusu z jídla",
  "dboard_corr_bolus": "-Kalkulačka správného množství bolusu",
  "dboard_override_add": "-Přepsání (+)",
  "dboard_override_sub": "-Přepsání (-)",

  "dboard_report": "Přístrojová deska zprávu",

  "daily": "Denní souhrn",
  "date": "Datum",
  "print": "Tisk",
  "carbs": "Sacharidy",
  "exercise": "Cvičení",
  "heavy": "Těžké cvičení",
  "Medium": "Střední cvíčení",
  "Light": "Lehké cvičení",
  "dailyReport": "Denní souhrnné hlášení",
  "devices": "Zařízení",
  "tran": "Vysílač",
  "pumpBase": "Pods. pumpy",
  "HbA1c": "HbA1c",
  "statics": "Statistiky",
  "glucose": "Glukóza",
  "item": "Položka",
  "BG1": "GK",
  "SG1": "SG",
  "avgSD": "Průměr.(mmol/L)± Směr.odchylka",
  "avgSD1": "Průměr. ± Směr. odchylka",
  "min": "Minimum",
  "max": "Maximum",
  "ofRead": "# měření",
  "ofHypo": "# hypo. epizod/doba trvání(min)",
  "ofAlert": "# upozornění",
  "insulin": "Inzulin",
  "insulin2": "Inzulín",
  "totalDose": "CDD",
  "foodBolus": "Bolus k jídlu ",
  "Food+coor": "Food+corr",
  "calibBolus": "Opravný bolus",
  "durationStop": "Délka přerušení (min)",
  "ofPumpAlert": "# upozornění pumpy",
  "ofMeal": "# jídel ",
  "totalExerTime": "Celkový čas cvičení",
  "exerNum": "# cvičení",
  "avgInten": "Prům. intenzita",
  "target1": "Cíl",
  "high1": "Vysoká",
  "low1": "Nízká",
  "BG Reading": "měření GK",

  "dayByday": "Přehled den za dnem",
  "dayBydayRe": "Přehledové hlášení den za dnem",
  "period": "Časové období",

  "sensorOverlay": "Pokrytí senzoru",
  "set": "Nastavit",
  "setPeriod": "Nastavit čas. období",
  "Weekdays": "Pracovní dny",
  "Weekends": "Víkendy",
  "Mon": "Po",
  "Tue": "Út",
  "Wed": "St",
  "Thur": "Čt",
  "Thu": "Čt",
  "Fri": "Pá",
  "Sat": "So",
  "Sun": "Ne",
  "Average": "Průměr",
  "sensorOlRe": "Hlášení pokrytí senzoru",
  "Avg": "Průměr",
  "±SD": "±SD",
  "ofhypo": "# hypo epizod",
  "Everyday": "Každý den",

  "TrendAna": "Analýza vývoje",
  "TrendRe": "Hlášení analýzy vývoje",
  "sensorGlu": "Sensor Glucose ",
  "ofBGtest": "# GK testů",
  "Basics": "Základní",
  "static": "Statistiky",
  "Med": "Medián",
  "med": "median",
  "Q1": "Q1",
  "Q3": "Q3",
  "Q11": "Q1",
  "Q31": "Q3",
  "IQR": "Interkvartilové rozmezí (IQR)",
  "SD": "SD",
  "CV": "Variační koeficient",
  "SE1": "Směrodatná chyba průměru",
  "distri": "Distribuce",
  "stab": "Stabilita",
  "#high": "# měření vysoké GK",
  "#low": "# měření nízké GK",
  "aucBelow": "PPK pod limitem",
  "aucAbove": "PPK nad limitem",
  "bgRead": "měření GK",
  "total": "Celkem",
  "ofBolus": "# bolusů",
  "avgBolus": "Prům. bolus",
  "Dura1": "Doba trvání（min）",
  "Avg/Total": "Průměr/Celkem",
  "high": "Vysoká",
  "low": "Nízká",
  "#hypo": "# hypo epizod",
  "ofExer": "# cvičení",

  "logbook": "Záznamník",
  "dailyTotal": "Celkem za den",
  "High Glucose": "Vysoká glukóza",
  "Low Glucose": "Nízká glukóza",
  "No Active Patch": "Žádná aktivní náplast",
  "Missed Meal": "Zmeškané jídlo",
  "Multiple BG Readings": "Někólikanásobné měření GK",
  "Stop Patch": "Zastavit náplast",
  "Others": "Ostatní",
  "Other Events": "Další události",
  "logRe": "Hlášení záznamníku",

  "DeviceSetting": "Přehled nast. zařízení",
  "Insulin Pump": "Inzulinová pumpa",
  "MaxBasalRate": "Max. Baz. Dávka",
  "BasalPatterns": "Bazální schémata",
  "Selected Basal Pattern": "Vybraná bazální schémata",
  "Maximum Bolus": "Maximum Bolus",
  "Combo/Extended Bolus": "Kombi/Rozšířený Bolus",
  "BG Reminder": "Připomenutí GK",
  "Bolus Increment": "Bolusové zvýšení",
  "Bolus Calculator": "Bolus Kalkulátor ",
  "Active Insulin Time": "Čas akt. Inzulinu",
  "IC Ratios": "ISP Poměr ",
  "Insulin Sensitivity": "Inzulinová citlivost",
  "BG Target": "Cíl GK",
  "Bolus Reminder": "Připomenutí bolusu",
  "CGM": "Kontinuální monitorace glukózy",
  "CGM System": "Systém CGM",
  "Glucose Unit": "Glukózová jednotka",
  "Glucose Limits": "Glukózové limity",
  "Predicitive Alerts": "Plánovaná upozornění",
  "Rate Alerts": "Dávková upozornění",
  "type": "Typ ",
  "time": "Čas",
  "data": "Data",
  "Rate": "Rate",
  "Calibration Reminder": "Připomenutí kalibrace",
  "Calibration Repeat": "Opakovaná kalibrace",
  "Snooze": "Přestávka",
  "Audio Options": "Zvukové možnosti",
  "Confidence Reminder": "Potvrzení přijetí",
  "Backlight": "Podsvícení",
  "Sec": "sek",
  "Alarm Clock": "Budík",
  "Patch Expiration": "Expirace náplasti",
  "Sensor Expiration": "Expirace senzoru",
  "Hourly Max": "Hodinový Max",
  "Daily Max": "Denní Max",
  "Low Reservoir": "Nízký objem zásobníku",
  "Low Suspend": "Spo. Lim. Přerušení",
  "Predictive Low Suspend": "Plán. S.L. Přerušení",
  "Rise": "Vzestup",
  "Fall": "Sestup",
  "Auto Off": "Auto vyp",
  "Standard": "Standard",
  "Exercise": "Cvičení",
  "Holiday": "Prázdniny",
  "ProgramA": "Schéma A",
  "ProgramB": "Schéma B",
  "--": "--",
  "Insulin": "Inzulin",

  "SUSA": "Auto vyp",
  "SUSHM": "Překročena Max Hod. Dáv",
  "SUSDM": "Alarm: Překročena Max CDD",
  "SUSLSG": "Spo. Lim. Přerušení",
  "SUSPLSG": "Plán. S.L. Přerušení",
  "Pump Restarted": "Pumpa restartována",
  "Meter BG Now": "Nyní zadejte GK",
  "Sensor Exp in 2 Hours": "Senzor. Exp. za 2 hod.",
  "Sensor Exp in 6 Hours": "Senzor. Exp. za 6 hod.",
  "Sensor Exp in 30 Min": "Senzor. Exp. za 30 min.",
  "Sensor Calibration Error": "Chyba kalibrace senzoru",
  "Sensor Error": "Chyba senzoru",

  "Device Settings Report": "Hlášení nast. Zařízení",
  "24h Total": "24h/Celkem",
  "Device Settings at": "Device Settings at",
  "Start": "Start",
  "Combo/Ext Bolus": "Kombi/Rozš. Bolus",
  "Time Format": "Časový formát",
  "Device Options（CGM System)": "Nastavení zařízení (Systém CGM)",
  "Device Options（Insulin Pump)": "Nastavení zařízení (Inzulinová pumpa)",
  "Dispay Settings (Screen)": "Nastavení displeje (Obrazovka)",
  "Dispay Settings (Backlight)": "Nastavení displeje (Podsvícení)",
  "Graph Range": "Grafická škála",
  "Range": "škála",
  "Repeat": "Opakovat",
  "Glucose Alerts": "Glukózová upozornění",
  "Alert Silence": "Ztlumit upozornění ",

  "Create": "Vytvořit",
  "Event Filter": "Filtr událostí",
  "HbA1c1": "HbA1c",
  "Urine Ketone": "Ketony v moči",
  "Injection": "Injekce",
  "Other": "Další",
  "Event Type": "Typ události",
  "Details": "Detaily",
  "Notes": "Poznámky",
  "Source": "Zdroj",
  "edit": "Upravit",
  "Action": "Akce",
  "EventReport": "Přehledové hlášení událostí",
  "By Date": "Podle data",
  "By Category": "Podle kategorie",
  "Event Summary": "Přehled událostí",
  "No data": "Žádná data",
  "No1": "Žádná",
  "data1": "data",
  "#": "#",
  "BG Summary": "Přehled GK",
  "Carbs Summary": "Přehled Sacharidů",
  "Injection Summary": "Přehled injekcí",
  "Exercise Summary": "Přehled cvíčení",
  "Input Notes": "Vložit poznámku",

  "Profile": "Profil",
  "Complications": "Komplikace",
  "Concomitant diseases": "Průvodní nemoci",
  "Suggestion": "Návrh",
  "Coronary heart disease": "Ischemická choroba srdeční",
  "High blood lipids": "Vysoké krevní tuky",
  "High blood pressure": "Vysoký krevní tlak",
  "Kidney disease": "Ledvinová nemoc",
  "Neuropathy": "Neuropatie",
  "Obesity": "Obezita",
  "Peripheral arterial disease": "Periférní cévní onemocnění",
  "Retinopathy": "Retinopatie",
  "Smoking addiction": "Závislost na kouření",
  "Enter date": "Zadejte datum",
  "Enter suggestion": "Zadejte návrh",
  "Enter Notes": "Zadat poznámku.",
  "Select": "Vybrat",
  "Prescription": "Recept",
  "Medicine": "Lék",
  "Dose": "Dávka",
  "Enter medicine": "Zadat lék",
  "Enter dose": "Zadat dávku",
  "Enterdis": "Enter concomitant diseases",
  "Add note": "Zadat poznámku",
  "Add Content": "Max. délka je 1000 znaků.",
  "Other suggestions": "Další návrhy",
  "OK": "OK",
  "HCP": "Posk. Zdr. Péče",
  "Content": "Obsah",
  "Records Report": "Hlášení o záznamech",

  "Quick Print": "Rychlý tisk",
  "Quick Print Settings": "Nastavení rychlého tisku",
  "Select duration": "Vyberte délku trvání",
  "One Week": "Jeden týden",
  "One Month": "Jeden měsíc",
  "One Quarter": "Jeden kvartál",
  "End date": "Konečné datum",
  "Yesterday": "Včera",
  "Last Sunday": "Minulá neděle",
  "Last Saturday": "Minulá sobota",
  "Last Day of Last Month": "Last Day of Last Month",
  "Last Day of Last Quarter": "Last Day of Last Quarter",
  "Customized": "Přizpůsobit",
  "Week Filter": "Týdenní filtr",
  "Select reports to print": "Vyberte hlášení k tisku",
  "Daily Summary": "Denní souhrn",
  "Day By Day Overview": "Přehled den za dnem",
  "Sensor Overlay": "Pokrytí senzotru",
  "Trend Analysis": "Analýza vývoje",
  "Logbook": "Záznamník",
  "Device Settings Review": "Přehled nastavení zařízení",
  "createReport": "Vytvořit zprávu",

  "Segment Analysis": "Analýza segmentu",
  "Sensor Glucose Profile": "Profil Senzor. Glukózy",
  "# of Boluses": "#  bolusů",
  "Bolus Insulin": "Bolus Inzulin",
  "Basal Pattern": "Bazál Schéma",
  "Segment Analysis Report": "Hlášení analýzy segmentů",
  "Avg Glucose": "Průměr. glukóza",
  "Below": "Pod",
  "In Target Range": "V cílovém rozmezí ",
  "Coefficient of variation": "variační koeficient",
  "% Time CGM Active": "% času aktivního CGM ",
  "est_a1c_t1": "Estimated A1C:",
  "est_a1c_t2": "calculated from SG values",
  "est_a1c_t3": "Poznámka: Odhadovaná hladina A1C nenahrazuje laboratorní měření",

  "acceptTip": " Vám povolil dálkové sledování jeho/jejích zdr. údajů.",
  "cancelTip": " Vám pozastavil povolení k dálkovému sledování jeho/jejích zdr. údajů. V případě potřeby můžete požádat znovu.",
  "rejectTip": " Vám zamítl žádost o dálkové sledování.",
  "Read": "Přečíst",

  "Connection": "Spojení",
  "connections1": "Spojení",
  "Add Connection": "Přidat spojení",
  "SG": "SG",
  "Active Insulin": "Aktivní inzulin",
  "Stop following": "Přestat sledovat",
  "Enter username (email)": "Zadat uživ. Jméno (email)",
  "Search results": "Výsledky vyhledávání",
  "Send request": "Zaslat žádost",
  "View graphs": "Zobrazit grafy",
  "Agree": "Souhlasím",
  "Deny": "Zamítnout",
  "Remove": "Odstranit",
  "Cancel Requset": "Zrušit žádost ",
  "Remark": "Poznámka",

  "Warm up": "Příprava senzoru",
  "Monitoring": "Monitorace",
  "Transmitter Error": "Chyba vysílače",
  "Sensor Failure": "Selhání senzoru",
  "Sensor Expired": "Senzor expiroval",
  "Lost Sensor": "Senzor ztracen",
  "Not Calibrated": "Nekalibrováno",
  "Calibrating": "Kalibruji",
  "Calibration Needed": "Je zapotřebí kalibrace",
  "Calibration Error": "Chyba kalibrace",
  "Charging Battery": "Dobíjím baterii",
  "Battery Charged": "Baterie dobita",

  "To be filled": "K naplnění",
  "Filled with insulin": "Naplněn inzulinem",
  "Priming": "Priming",
  "Priming completed": "Priming dokončen",
  "Inserting needle": "Vkládám jehlu",
  "Patch activated": "Náplast aktivována",
  "Delivering Basal": "Doručuji bazál",
  "Exceeds Max 1 Hour Delivery": "Překročena Max Hod. Dáv",
  "Exceeds Max TDD": "Alarm: Překročena Max CDD",
  "Suspend": "Přerušit",
  "Occlusion Detected": "Zjištěna okluze",
  "Patch Expired": "Náplast expirovala",
  "Empty Reservoir": "Prázdný zásobník",
  "Patch Error": "Chyba náplasti",
  "Pump Base Error": "Chyba Podst. Pumpy",
  "Patch Battery Depleted": "Baterie náplasti prázdná",
  "Magnetic sensor not calibrated": "Magentický senzor nezkalibrován",

  "Patient Profile": "Profil pacienta",

  "On": "Zap",
  "on": "Zap",
  "Off": "Vyp",
  "off": "Vyp",

  "CORONARY_HEART_DISEASE": "Ischemická choroba srdeční",
  "HIGH_BLOOD_LIPIDS": "Vysoké krevní tuky",
  "HIGH_BLOOD_PRESSURE": "Vysoký krevní tlak",
  "KIDNEY_DISEASE": "Ledvinová nemoc",
  "NEUROPATHY": "Neuropatie",
  "OBESITY": "Obezita",
  "PERIPHERAL_ARTERIAL_DISEASE": "Periférní cévní onemocnění",
  "RETINOPATHY": "Retinopatie",
  "SMOKING_ADDICTION": "Závislost na kouření",

  "saveTip": "Uloženo úspěšně ",
  "changePaTip": "Vaše heslo bylo změněno",
  "enterEmTip": "Zadejte svou email adresu.",
  "verErrTip": "Nesprávný verifikační kód ",
  "chooseEventTip": "Zvolte události k tisku",
  "chooseDataTip": "Vybrat data k tisku",
  "dateWrongTip": "TKonečné datum nemůže být dřív než startovací datum",
  "infoWrongTip": "Prosím vyplňte všechna požadovaná pole.",
  "createdSuccssTip": "Vytvořeno úspěšně",
  "selectData": "Vybrat data k uložení",

  "acceSu": "Žádost o spojení přijata",
  "acceEr": "Přidání nového spojení selhalo",
  "rejeSu": "Zamítnutá žádost o spojení",
  "rejeEr": "Zamítnutí žádosti o spojení zamítnut",

  "userNotExist": "Toto uživ. jméno neexistuje",
  "Password incorrect": "Nesprávné heslo",
  "UserType incorrect": "Nesprávný typ uživatele",

  "registSuccess": "Váš účet byl úspěšně vytvořen.",
  "registFailed": "Registrace nového účtu selhala.",
  "sentSuccess": "Úspěšně zasláno",
  "sentFailed": "Zaslání selhalo",
  "Input error": "Špatné zadání",

  "deletePtip": "Jste si jisti vymazáním těchto pacientů?",
  "deleteEvents": "Jste si jisti vymazáním těchto událostí?",
  "deleteData": "Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",
  "deleteThis": "Jste si jisti tímto vymazáním?",
  "confirm": "Potvrdit",
  "deleteSuccess": "Úspěšné vymazání",
  "deleteFailed": "Smazání selhalo",
  "modifySuccess": "Úspěšně upraveno",
  "modifyFailed": "Úprava selhala",
  "createSuccess": "Úspěšné vytvoření",
  "createFailed": "Vytvoření selhalo",
  "editSuccess": "Úspěšně upraveno",
  "editFailed": "Úprava selhala",
  "Time overlapped": "Vámi vybraná vysílání se překrývají",

  "stopFollow": "Jste si jistí, že chcete přestat sledovat tohoto pacienta?",
  "CancelTip1": "Jste si jisti tímto spojením?",

  "Warning": "Připomenutí",
  "agreeConnect": "Pokud kliknete 'Souhlasím', přijímáte tak žádost o spojení. Vaše zdr. údaje  budou dostupné novému spojení.",
  "denyConnect": "Jste si jistí zamítnutím tohoto spojení? ",
  "deleteConnect": "Jste si jisti vymazáním tohoto spojení? Pokud jej vymažete, dané spojení si již nebude moci zobrazit Vaše data o zdr. stavu .",

  "Choose the events to print": "Zvolte události k tisku",
  "tryAgain": "Zkusit znovu",
  "username and password is required": "Je vyžadováno uživ. jméno",
  "A name is required": "Je vyžadováno jméno",
  "username is required": "Je vyžadováno uživ. jméno",
  "The date choose wrong": "Špatný výběr data",
  "Date no more than 14 days": "Nelze vybrat více než 14 dní",

  "CancelTip": "Jste si jistí zamítnutím tohoto spojení? ",
  "removeConnect": "Úspěšné vymazání",

  "dateErr1": "Nelze vybrat více než 90 dní",
  "dateErr2": "Konečné datum nemůže být dřív než startovací datum",

  "Not Filled": "Neurčeno",
  "Today": "Dnes",
  "duration": "Doba trvání",
  "interval": "Interval",
  "7 days": "7 dní",
  "14 days": "14 dní",
  "30 days": "30 dní",
  "90 days": "90 dní",
  "g": "g",

  "Sound+Vibrate": "Zvuk+Vibrace",
  "Sound": "Zvuk",
  "Vibrate": "Vibrace",
  "Silent": "Nerušit",
  "1": "Jednou",
  "2": "Denně",
  "noMes": "Žádné zprávy",
  "noConnect": "Žádná spojení",
  "Customize": "Přizpůsobit",
  "GB": "United Kingdom",
  "CN": "China",
  "FR": "France",
  "DD": "Germany",
  "DE": "Germany",
  "SE": "Sweden",
  "AU": "Australia",
  "HKF": "Hongkong",
  "HU": "Hungary",
  "IT": "Italy",
  "NL": "Netherlands",
  "Nor": "Norway",
  "PT": "Portugal",
  "ES": "Spain",
  "TR": "Turkey",

  "Jan": "Led",
  "Feb": "Úno",
  "Mar": "Bře",
  "Apr": "Dub",
  "May": "Kvě",
  "Jun": "Čer",
  "Jul": "Čvc",
  "Aug": "Aug",
  "Sep": "Zář",
  "Oct": "Říj",
  "Nov": "Lis",
  "Dec": "Pro",
  "ApplyTip": " žádost o zobrazení vašich dat.",
  "noReadings": "Chyba senzoru",

  "daop_A6_system": "A6 Touchcare System",
  "daop_easytouch_easyview": "EasyTouch / EasyView iPad",
  "daop_TY012_TY015": "TY012/TY015",
  "daop_easysense": "EasySense",
  "daop_delete_data": "Delete Data",
  "daop_uploaded_data": "Nahraná data",
  "daop_uploaded_data_text": "Data pochází z aplikace EasyTouch nebo EasyView iPad.",
  "daop_realtime_data": "Data v reálném čase",
  "daop_realtime_data_text": "The data is from EasySense App or EasyPatch App.",

  "ins_unit": "(J)",
  "ins_unit2": "J",
  "basal_unit": "(J/H)",
  "basal_unit2": "J/H",

  "Alerts_Patch_Battery_Low": "Slabá bat. náplasti",
  "Alerts_Patch_Battery_Depleted": "Prázdná bat. náplasti",
  "Alerts_Lost_Pump": "Lost Pump",
  "Alerts_Low_Reservoir": "Nízký objem zásobníku",
  "Alerts_Empty_Reservoir": "Prázdný zásobník",
  "Alerts_Patch_Expiration_Advisory": "Výstraha. Exp. Náplasti",
  "Alerts_Patch_Exp_In_1_Hour": "Patch Exp In 1 Hour",
  "Alerts_Patch_Expired": "Náplast expirovala",
  "Alerts_Patch_Error": "Chyba náplasti",
  "Alerts_Pump_Base_Error": "Chyba Podst. Pumpy",
  "Alerts_Basal_Rate_Key_Error": "Basal Rate Key Error",
  "Alerts_Occlusion_Detected": "Zjištěna okluze",
  "Alerts_End_Of_Suspend": "End Of Suspend",
  "Alerts_Exceeds_Max_TDD": "Alarm: Překročena Max CDD",
  "Alerts_Exceeds_Max_1Hr_Delivery": "Překročena Max Hod. Dáv",

  "Alerts_Predictive_Low_Suspend": "Plán. S.L. Přerušení",
  "Alerts_Low_Suspend": "Spo. Lim. Přerušení",
  "Alerts_Auto_Off": "Auto vyp",

  "Alerts_Pump_Restart": "Pump Restart",
  "Alerts_Auto_Off_Warning": "Auto Off Warning",
  "Alerts_Pump_Out_Of_Range": "Pump Out Of Range",

  "Alerts_Lost_Sensor": "Senzor ztracen",
  "Alerts_Transmitter_Battery_Low": "Slabá baterie vysílače",
  "Alerts_Charge_Transmitter": "Nabijte vysílač",
  "Alerts_Sensor_Error": "Chyba senzoru",
  "Alerts_Transmitter_Error": "Chyba vysílače",
  "Alerts_Sensor_Calibration_Error": "Sensor Calibration Error",

  "Alerts_Sensor_Failure": "Selhání senzoru",
  "Alerts_Sensor_Calibration_Reminder": "Sensor Calibration Reminder",
  "Alerts_Meter_BG_Now": "Nyní zadejte GK",
  "Alerts_Sensor_Exp_in_6_Hours": "Senzor. Exp. za 6 hod.",
  "Alerts_Sensor_Exp_in_2_Hours": "Senzor. Exp. za 2 hod.",
  "Alerts_Sensor_Exp_in_30_Min": "Senzor. Exp. za 30 min.",
  "Alerts_Sensor_Expired": "Senzor expiroval",
  "Alerts_Rapid_Rise": "Prudký vzestup",
  "Alerts_Rapid_Fall": "Prudký sestup",
  "Alerts_High_Predicted": "Hor. Lim. Přer.",
  "Alerts_Low_Predicted": "Níz. Lim. Přer.",
  "Alerts_High_Glucose": "Vysoká glukóza",
  "Alerts_Low_Glucose": "Nízká glukóza",
  "Alerts_Below_3.1_mmol/L": "Pod 3.1 mmol/L",
  "Alerts_Transmitter_Battery_Low_2": "Slabá baterie vysílače",

  "Alerts_PDM_Battery_Low": "Nízká baterie ODM",
  "Alerts_Replace_Battery": "Charge PDM Now",
  "Alert": "Alert",
  "Alerts": "Upozornění",
  "Alert Filter": "Alert Filter",
  "PDM": "PDM",
  "Pump": "Pumpa",

  "alert_Time": "Time",
  "alert_Type": "Type",

  "Out Of Range": "Out Of Range",
  "t1221_Time_in_Auto_Mode": "Doba v auto režimu",
  "t1221_Average_SG_SD": "Průměrná GS±SD",
  "t1221_Time_in_Target_Range": "Doba v cílovém rozmezí",
  "t1221_Time_above_Range": "Doba nad rozmezím",
  "t1221_Time_below_Range": "Doba pod rozmezím",
  "t1221_Auto_Basal_per_day": "Auto bazál (za den)",
  "t1221_Auto_Bolus_per_day": "Auto bolus (za den)",
  "t1221_Auto_Mode_Exits": "Ukončení auto režimu",
  "t1221_No_Sensor_readings": "Žádné údaje senzoru",
  "t1221_Max_Delivery": "Maximální podání",
  "t1221_Min_Delivery": "Minimální podání",
  "t1222_autoModeBasal": "Auto režim bazálu",
  "t1222_autoModeCorrBolus": "Auto režim korekčního bolusu",
  "t1222_autoSnack": "Auto svačina",
  "t1222_autoBreakfast": "Auto snídaně",
  "t1222_autoLunch": "Auto oběd",
  "t1222_autoDinner": "Auto večeře",
  "t1222_autoExercise": "Auto pohybová aktivita",
  "t1222_Snack": "Svačina",
  "t1222_Auto_Mode": "Auto režim",
  "t1222_Time_in_Auto_Mode": "Doba v auto režimu (%)",
  "t1222_Avg_SD": "Průměr (mmol/l)±SD",
  "t1222_Target_Range": "Cílové rozmezí(%)",
  "t1222_Above_Range": "Nad rozmezí(%)",
  "t1222_Below_Range": "Pod rozmezí(%)",
  "t1222_Auto_Mode_Exits": "# ukončení auto režimu",
  "t1221_Auto_Mode": "Auto režim",
  "t1222_auto_basal": "Auto bazál",
  "t1222_auto_bolus": "Auto bolus",
  "t0805_User_Management": "správa uživatelů",
  "t0805_Patient_Management": "Správa pacientů",
  "t0805_Operation_History": "Historie provozu",
  "t0805_User_List": "Seznam uživatelů",
  "t0805_User": "Uživatel",
  "t0805_Time": "Čas",
  "t0805_Operation_Type": "Typ operace",
  "t0805_Back": "Zpět",
  "t0805_Add": "Přidat",
  "t0805_Delete": "Vymazat",
  "t0809_Add_User": "Přidat uživatele",
  "t1028_Pattern_C": "Schéma C",
  "t1028_Pattern_D": "Schéma D",
  "t1029_Auto_meal_bolus": "Auto meal bolus",
  "t1029_Auto_mode_correction_bolus": "Auto mode correction bolus",
  "t1029_Sick": "Nemoc",
  "t1029_Auto_Mode_Feature": "Funkce auto režimu",
  "t1029_Target_SG": "Cíl GS",
  "t1029_Auto_Meal_Handling": "Auto řízení jídla",
  "t1029_Total_Daily_Dose": "Celk. denní dávku",
  "t1029_Pump_Light": "Kontrolka pumpy",
  "t1029_Alerts_for_Hypo": "Výstrahy pro Hypo",
  "t1102_Out_of_Range": "Mimo dosah",
  "t1102_Command_Reminder": "Připomenutí příkazu",
  "t1102_Alarms_Alerts_on_APP": "Alarmy a upozornění na čerpadlo",
  "t1102_Alarms_on_App": "Alarmy na aplikaci",
  "t1102_Alerts_on_App": "Upozornění na aplikaci",
  "t1102_Factory_Calibration": "Tovární kalibrace",
  "t1102_Alerts_for_Low": "Upozornění pro nízké",
  "t1102_Alerts_for_High": "Upozornění pro vysoké",
  "t1102_Alerts_for_Others": "Upozornění pro ostatní",
  "t1102_Adjustment": "Nastavení",
  "t1102_Suggested": "Doporučeno",
  "t1103_Glucose": "Glukóza",
  "t1103_CGM": "CGM",
  "t1103_Insulin": "Inzulin",
  "t1103_Carbs": "Sacharidy",
  "t1103_Exercise": "Cvičení ",
  "t1103_Min_Max": "Min/Max",
  "t1103_Target_Range": "Cílový rozsah",
  "t1103_Overall_Tine_In_Range": "Přehled: čas v rozsahu",
  "t1103_Basal": "Bazál",
  "t1103_Bolus": "Bolus",
  "t1103_Basal_Bolus": "Bazál & Bolus",
  "t1103_Auto_Mode_Time_In_Range": "Auto režim",
  "t1103_Time_below_range": "Čas pod cílovým rozsahem",
  "t1103_Time_above_range": "Čas nad cílovým rozsahem",
  "t1103_Time_in_target_range": "Čas v cílovém rozsahu",
  "t1103_Incorrect_Password": "Nesprávné heslo, zbývá $1 pokus, zadejte prosím správné heslo.",
  "t1103_Incorrect_locked": "Neúspěšné pokusy překračují limit, účet byl uzamčen. Zkuste to prosím znovu za $1 minut.",
  "t1104_The_data_is_from": "Data pochází z aplikace EasySense nebo EasyPatch.",
  "t1104_Privacy_Policy": "Ochrana osobních dat a podmínky pro užívání",
  "t1104_updated_privacy_policy": "Aktualizovali jsme vaši ochranu osobních dat a podmínky pro uživatele. Před použitím EasyPatch si, prosím, pečlivě přečtěte nové podmínky a potvrďte souhlas.",
  "t1104_Disagree": "Nesouhlas",
  "t1104_Agree": "Souhlasím",
  "t1105_Upload_History": "Historie nahrávání",
  "t1105_Delete_Data": "Smazat data",
  "t1105_Target_Range": "Cílový rozsah",
  "t1105_request_to_view_your_data": "$1 požadavek na zobrazení vašich dat.",
  "t1105_Recent_Updates": "Nedávné aktualizace",
  "t1108_No_data": "Žádná data",
  "t1108_Pump_Bash_SN": "SČ Pods. pumpy",
  "t1108_Transmitter_SN": "SČ Vysílače",
  "t1112_Normal_Glucose": "Normální Glukóza",
  "t1112_Manual_Bolus_or_Modified_Bolus": "Manuální bolus nebo Modifikovaný bolus",
  "t1112_Auto_Mode_Started": "Auto režim začal",
  "t1112_Auto_Mode_Exit": "Ukončení auto režimu",
  "t1112_Normal_Bolus": "Běžný bolus",
  "t1112_Extended_Bolus": "Rozšířený bolus",
  "t1112_Combo_Bolus": "Kombinovaný bolus",
  "t1112_Carbs": "Sacharidy",
  "t1112_Glucose": "Glukóza",
  "t1112_BG": "GK",
  "t1112_Audio": "Zvuk",
  "t1112_Tone": "Tón",
  "t1112_Audio_Options": "Zvukové možnosti",
  "t1112_Weight_Unit": "Hmotnostní Jednotka",
  "t1112_Height_Unit": "Jednotka Výšky",
  "t1112_Not_available": "Není Dostupný",
  "t1112_Number": "Číslo",
  "t1112_days": "# dny",
  "t1112_min": "min",
  "t1113_days": "dny",
  "t1215_Security": "Bezpečnostní",
  "t1215_MFA": "Vícefaktorové ověřování (MFA)",
  "t1215_Enter_verification_code": "Vložte ověřovací kód",
  "t1215_Multi_factor_ON": "Vícefaktorové ověřování je ZAPNUTO. Ověřovací kód byl odeslán na adresu $1 Odešlete prosím ověřovací kód.",
  "t1215_Verification_code_incorrect": "Nesprávný verifikační kód",
  "t1215_Show_Glucose_Value": "Zobrazit hodnotu glukózy",
  "t1221_enter_verification_code": "Zadejte 6místný ověřovací kód odeslaný na číslo $1.",
  "t1221_Verification_Success": "Úspěšně ověřeno",
  "t1222_We_will_only_process": "Vaše zdravotnická data zpracováváme pouze prostřednictvím aplikace Medtrum/webu s vaším souhlasem. ",
  "t1222_If_you_are_under_years": "Pokud máte méně než 16 let, budete potřebovat souhlas svého rodiče nebo zákonného zástupce k registraci v této aplikaci. .",
  "t1221_register_cn": "Máte právo nenahrávat do aplikace žádná data zařízení. V takovém případě nebudou data přístupná ostatním. Pokud se rozhodnete neregistrovat se v aplikaci Medtrum nebo na webových stránkách, jediný záznam vašich zdravotních údajů je na samotném zařízení. ",
  "t1221_register_eu": "Pokud se rozhodnete zaregistrovat svůj účet Medtrum a přistupovat k naší aplikaci pomocí účtu, budou zdravotní údaje zaznamenané v aplikaci nahrány na náš server v Evropě a budou uchovávány po dobu 2 let. Máte právo nenahrávat do aplikace žádná data zařízení. V takovém případě nebudou data přístupná ostatním. Pokud se rozhodnete neregistrovat se v aplikaci Medtrum nebo na webových stránkách, jediný záznam vašich zdravotních údajů je na samotném zařízení.",
  "t1221_register_follow": "Vaše zdravotnická data zpracováváme pouze prostřednictvím aplikace Medtrum/webu s vaším souhlasem.",
  "t1222_Terms_of_Use": "s podmínkami užití společnosti Medtrum",
  "t1222_Privacy_Policy": "se zásadami ochrany o osobních údajích společnosti Medtrum",
  "t1222_Create_Account": "Vytvořit účet",
  "t1222_Back": "Zpět",
  "t1222_Verify_your_account": "Ověřte svůj účet",
  "t1222_please_check_your_account": "Ověřovací kód zašleme na adresu $1, zkontrolujte prosím svůj účet.",
  "t1222_I_Agree_to": "Souhlasím $1",
  "t1223_Invalid_Verification_Code": "Neplatný ověřovací kód. Prosím zkuste to znovu."
};

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deMessages; });
var deMessages = {
  "privacy_policy_and_terms_of_use": "Privacy Policy and Terms of Use ",
  "privacy_confirm_text": "We've updated our <a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>Privacy Policy</a> and <a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>Terms of Use</a>. To continue using EasyView, you need to read and agree to all the terms.",
  "privacy_confirm_disagree": "Disagree",
  "privacy_confirm_accept": "Accept",

  "title": "EasyView Personal",
  "title1": "EasyView Pro",
  "user": "E-Mail",
  "password": "Passwort",
  "remember": "Mich speichern",
  "forget": "Passwort vergessen?",
  "sign in": "Einloggen",
  "login": "Login",
  "sign up now": "Jetzt anmelden",
  "apply": "Jetzt beantragen",
  "contact us": "Uns kontaktieren",
  "Privacy Policy": "Datenschutzrichtlinien",
  "Terms of Use": "Nutzungsbedigungen",
  "copyright": "Copyright © 2021 Medtrum Technologies Inc. Alle Rechte vorbehalten.",

  "chooseLang": "Wählen Sie Ihr Land oder Ihre Sprache",
  "asia": "Asien",
  "europe": "Europa",

  "applyHcp": "Ein HCP-Konto beantragen",
  "sign up": "Anmelden",
  "Patient": "Patient",
  "Caregiver": "Pfleger",
  "Email": "E-Mail",
  "Mobile": "Mobilnummer",
  "Enter email": "E-Mail-Adresse eingeben",
  "Enter mobile": "Mobilnummer eingeben",
  "Verification": "Bestätigungscode",
  "Invitation": "Invitation code",
  "full name": "Geben Sie Ihren vollständigen Namen ein",
  "Enter pass": "Passwort eingeben",
  "org": "Organisation",
  "Register": "Anmelden",
  "send": "Senden",
  "agree": "Ich habe die  ",
  "privacy": " Medtrum Datenschutzrichtlinien  ",
  "and": "und die ",
  "use": "allgemeinen Nutzungsbedingungen gelesen und akzeptiere sie.",
  "errtip1-1": "Sie müssen eine gültige E-Mail-Adresse eingeben, welche",
  "errtip1-2": " zu Ihrem Medtrum-Benutzernamen wird.",
  "errtip2": "Please enter a valid mobile number.",
  "errtip3": "Bestätigungscode ",
  "errtip4": "Incorrect invitation code.",
  "errtip5": "Benutzername ungültig.",
  "errtip6": "Your password must have 8 or more characters.",
  "errtip7": "Bitte geben Sie ihre Qrganisation ein",

  "errp1": "Das Passwort muss mindestens 3 der folgenden Zeichen enthalten: ",
  "errp2": "Großbuchstaben Kleinbuchstaben, Ziffern und Sonderzeichen.",
  "errp3": "Das Passwort muss zwischen 6 und 20 Zeichen lang sein.",
  "errp4": "Das Passwort muss sich vom Benutzernamen unterscheiden.",
  "errp5": "Passwörter mit 3 aufeinanderfolgenden Ziffern sind ungültig (z.B.: 123, 321).",
  "errp6": "Passwörter mit 3 aufeinanderfolgenden Buchstaben sind ungültig (zB: abc, cba).",
  "errp7": "Das Passwort darf keine Leerzeichen enthalten.",

  "Find account": "Passwort anfordern.",
  "Enter username": "Bitte geben Sie Ihren Benutzernamen ein.",
  "Next": "Weiter",
  "Cancel": "Abbrechen",
  "Back": "Zurück",
  "Enter veri": "Bestätigungscode",
  "Verify notice": "Der Bestätigungscode wurde Ihnen in einer E-Mail zugesendet.",
  "Create new": "Neues Passwort erstellen",
  "Create new notice": "Bitte erstellen Sie ein neues Passwort. Ihr Passwort muss mindestens 6 Zeichen lang sein.",
  "New pass": "Neues Passwort",
  "Completed": "Abgeschlossen",
  "Created": "Neues Passwort erstellt.",
  "Login Now": "Jetzt einloggen",

  "Delete": "Löschen",
  "New Patient": "New Patient",
  "Add Patient": "Patient hinzufügen",
  "Filter": "Filter",
  "Name": "Name",
  "Gender": "Geschlecht",
  "Age": "Alter",
  "Type": "Typ",
  "Duration": "Dauer",
  "Connections": "Kontoersteller",
  "UploadTime": "Zeitpunkt des Uploads",
  "Year": "jahr",
  "Years": "jahre",
  "Month": "mois",
  "Month2": "Monat",
  "Months": "mois",
  "Invite": "Einladen",
  "Invited": "Eingeladen",
  "All": "Alle",
  "Female": "Weiblich",
  "Male": "Männlich",
  "Not Set": "Not Set",
  "Type 1": "Typ 1",
  "Type 2": "Typ 2",
  "Gestational": "Schwangerschäftsdiabetes",
  "Prediabetes": "Prädiabetes",
  "LADA": "Typ 1.5 LADA",
  "Apply": "Anwenden",
  "disUn": "Diabetes-Typ nicht angegeben",
  "ageUn": "Alter nicht angegeben",
  "genUn": "Geschlecht nicht angegeben",
  "addP": "Patienten hinzufügen",
  "newP": "Neuer Patient",
  "findP": "Patienten finden",

  "GDRNF": "Nicht spezifiziert",
  "GDRF": "Weiblich",
  "GDRM": "Männlich",
  "女": "Männlich",

  "DBTNF": "Nicht spezifiziert",
  "DBT1": "Typ 1",
  "DBT2": "Typ 2",
  "DBTLADA": "Typ 1.5 LADA",
  "DBTPRE": "Prädiabetes",
  "DBTGEST": "Schwangerschäftsdiabetes",
  "前期": "beFore",
  "beFore": "beFore",
  "MODY": "Mody",

  "No selection": "No selection",
  "unspecif": "Nicht spezifiziert",
  "register": "Patient",
  "hcp": "Kliniker/in",

  "BG": "BG",
  "CARB": "Kohlenhydrate",
  "INS": "Injektion",
  "EXR": "Übung",
  "OTR": "Other",
  "HBA1C": "HbA1c",
  "DOSE": "DOSE",
  "URINEK": "Urinketon",
  "HEL": "HEL",
  "OTR1": "Andere",
  "Loading": "Lädt",

  "home": "Zuhause",
  "pID": "Patienten-ID",
  "fullName": "Vollständiger Name",
  "gender": "Geschlecht",
  "height": "Größe",
  "weight": "Gewicht",
  "cm": "cm",
  "kg": "kg",
  "birthday": "Geburtstag",
  "disType": "Diabetes-Typ",
  "disDate": "Zeitpunkt der Diagnose",
  "Address": "Adresse",
  "Postcode": "Postleitzahl",
  "Inpatient": "Stationärer Patient",
  "Yes": "Ja",
  "No": "Nein",
  "Pno": "Patienten-Nr.",
  "Bno": "Betten-Nr.",
  "create": "Erstellen",
  "Telephone": "Festnetznummer",

  "enterU": "Benutzernamen eingeben (E-Mail)",
  "search": "Suchen",
  "noU": "Ein Benutzername ist erforderlich.",
  "searchR": "Ergebnisse durchsuchen",
  "uername": "Benutzername",
  "alias": "Alias",
  "remove": "Entfernen",
  "viewG": "Diagramme anzeigen",
  "sendR": "Anfrage senden",
  "rSent": "Ihre Anfrage wurde gesendet.",
  "cancelR": "Anrage abbrechen",

  "VcodeTip1": "Nicht erhalten? Bitte warten Sie eine Minute und ",
  "VcodeTip2": " versuchen Sie es erneut.",
  "VcodeTip3": "Wir haben gerade einen Bestätigungscode gesendet an ",
  "Entercode": "Code eingeben",
  "Getcode": "Code erhalten",

  "messages": "Nachrichten",
  "profile": "Profil",
  "sign out": "Abmelden",
  "changeP": "Passwort ändern",
  "connection": "Verbindungen",

  "myP": "Mein Profil",
  "Portrait": "Profilfoto",
  "Profession": "Beruf",
  "DPRONF": "Nicht spezifiziert",
  "DPROENDOCRIN": "Endokrinologe",
  "DPRODIABTRA": "Diabetes-Berater",
  "DPRONURSE": "Krankenpfleger",
  "DPRODIATIT": "Ernährungsberater",
  "DPROOTR": "Sonstiger HCP",
  "Organization": "Organisation",
  "Bio": "Bio",
  "save": "Speichern",
  "oldPa": "Altes Passwort",
  "newPa": "Neues Passwort",
  "RePa": "Passwort erneut eingeben",
  "forgetY": "Passwort vergessen?",
  "applyM": "Anwenden",
  "oldErr": "Das alte Passwort ist nicht korrekt",
  "EntTheSame": "Geben Sie das neue Passwort erneut",
  "EnterOld": "Geben Sie das alte Passwort ein",

  "pList": "Patientenliste",
  "connections": "Verbindungen",
  "settings": "Einstellungen",
  "monitor": "Überwachen",
  "graphs": "Berichte",
  "events": "Ereignisse",
  "records": "Protokolle",
  "qPrint": "Schnelldruck",

  "sensorIn": "Sensorinformationen",
  "timeOfLaRead": "Zeitpunkt des letzten Sensor-Messwertes",
  "tranSn": "Sendeanlage-SN",
  "status": "Status",
  "sensorLife": "Verbleibende Sensorlaufzeit ",
  "lastSenorRead": "Letzter Sensor-Messwert",
  "TranBattery": "Sender-Batterie",
  "sg": "SZ",
  "alert": "Warnmeldung",
  "target": "Ziel",
  "hypo": "Hypo",
  "sensorGlucose": "Sensor-Glukose",
  "calib": "Kalibrierung",
  "newSen": "Neuer Sensor",
  "warm": "Aufwärmen",
  "InsulinPump": "Aufwärmen",
  "timeOfLaPump": "Zeitpunkt der letzten Pumpendaten",
  "pumpSN": "Pumpenbasis-SN",
  "ReserviorLife": "Verbleibende Patch-Behälter-Lebensdauer",
  "InsulinLeft": "Verbleibendes Insulin",
  "basal": "Basal",
  "bolus": "Bolus",
  "totalBasal": "Gesamte Tagesdosis Basal",
  "lastBolus": "Letzter Bolus",
  "activeInsulin": "Aktives Insulin",
  "totalBolus": "Gesamte Tagesdosis Bolus",
  "tampBasal": "Temp-Basal",
  "normalBolus": "Normaler Bolus",
  "extendBolus": "Verzögerter Bolus",
  "manualStop": "Manuelle Unterbrechung",
  "autoStop": "Automatische Unterbrechung",
  "auto suspend": "Automatische Unterbrechung",
  "stop": "Abgabestopp",
  "newPatch": "Neuer Patch",
  "tempBasal": "Tempbasal",
  "N": "N",
  "E": "V",
  "CN1": "CN",
  "CE": "CV",

  "staticSettings": "Berichte-Einstellungen",
  "dataSource": "Datenquelle",
  "unit": "Einheit",
  "glucoseTarget": "Grenzwerte der Glukose-Zielwerte",
  "overall": "Insgesamt",
  "Hypoglycemia": "Hypoglykämie",
  "timePeriod": "Zeitraum",
  "postMeal": "Post-Mahlzeit-Analyse",
  "Breakfast": "Frühstück",
  "Lunch": "Mittagessen",
  "Dinner": "Abendessen",
  "night": "Nacht",
  "Before": "Vor",
  "After": "Nach",
  "Low": "Niedrig",
  "High": "Hoch",
  "From": "Von ",
  "To": "Bis",
  "Hours": "stunden",
  "Reset": "Standardeinstellungen wiederherstellen",
  "RealTime": "Echtzeit",
  "uploaded": "Hochgeladen",
  "sensor": "Sensor",
  "pdmSN": "PDM-SN",
  "startTime": "Startzeit",
  "endTime": "Endzeit",
  "uploadTime": "Upload-Zeit",
  "pdm": "PDM",
  "Uploaded": "Hochgeladen",
  "Patch Pump": "PDM ",
  "overLapp": "Sitzungen überlappen sich",
  "showAlert": "Warnungen zeigen",

  "dashboard": "Dashboard",
  "dboard_glucose_statistics": "Statistiken",
  "dboard_glucose": "Glucose",
  "dboard_glucose_avg": "Durchschnittlich",

  "dboard_cgm": "CGM",
  "dboard_cgm_avg": "Durchschnittlich",

  "dboard_insulin": "Insulin",
  "dboard_insulin_avg": "Durchschnittliche tägliche Dosis",

  "dboard_num_days": "# days",
  "dboard_carbs": "Kohlenhydrate",
  "dboard_carbs_avg": "Durchschnittliche Kohlenhydrate / Tag",

  "dboard_exercise": "Übung",
  "dboard_exercise_avg": "Durchschnittliche Zeit / Tag",
  "dboard_sd": "SD",
  "dboard_num": "#",
  "est_a1c_t1": "Geschätzte A1C:",
  "est_a1c_t2": " aus SG-Werten berechnet",
  "est_a1c_t3": "Hinweis: Geschätzter A1C-Wert ersetzt keine Labormessung",

  "dboard_statistics": "Statistiken",
  "dboard_BG": "BG",
  "dboard_SG": "SG",
  "dboard_BG_calibration": "BG / Kalibrierung (pro Tag)",
  "dboard_AUC_high": "AUC hoch> 11,0 mmol / l",
  "dboard_AUC_low": "AUC niedrig <5,2 mmol / l",
  "dboard_highest_value": "Höchster Wert",
  "dboard_lowest_value": "Niedrigster Wert",
  "dboard_pump": "Pumpe",
  "dboard_avg_daily_dose": "Durchschnittliche tägliche Dosis",
  "dboard_SD": "SD",
  "dboard_daily_basal": "Täglicher Basal",
  "dboard_daily_bolus": "Täglicher Bolus",
  "dboard_avg_bolus_num": "Durchschnittliche Boluszahl pro Tag",
  "dboard_avg_suspend_time": "Durchschnittliche Suspend-Zeit",
  "dboard_avg_reservoir_usage": "Durchschnittliche Reservoirnutzung",
  "dboard_days": "days",
  "dboard_manual_bolus": "Manueller Bolus (Volumen / Nr. Pro Tag)",
  "dboard_normal": "-Normal",
  "dboard_extend": "-Verzögert",
  "dboard_combo": "-Combo",
  "dboard_bolus_calculator": "Bolusrechner (Volumen / Nr. Pro Tag)",
  "dboard_food_bolus": "-Mahlzeitbolus-Rechner",
  "dboard_corr_bolus": "-Korrekturbolus-Rechner",
  "dboard_override_add": "-Überreiten (+)",
  "dboard_override_sub": "-Überreiten (-)",

  "dboard_report": "Dashboard erstellen",

  "daily": "Tägliche Zusammenfassung",
  "date": "Datum",
  "print": "Drucken",
  "carbs": "Kohlenhydrate",
  "exercise": "Bewegung",
  "heavy": "Viel",
  "Medium": "Mittlere",
  "Light": "Wenig",
  "dailyReport": "Täglicher Zusammenfassungsbericht",
  "devices": "Geräte",
  "tran": "Sendeanlage",
  "pumpBase": "Pumpenbasis",
  "HbA1c": "HbA1c",
  "statics": "Statistiken",
  "glucose": "Glukose",
  "item": "Artikel",
  "BG1": "BZ",
  "SG1": "SG",
  "avgSD": "Durchschn (mmol/L)±SD",
  "avgSD1": "Avg±SD",
  "min": "Mindest",
  "max": "Max",
  "ofRead": "# an Messungen",
  "ofHypo": "# an Hypo/Dauer(min)",
  "ofAlert": "# an Warnmeldungen",
  "insulin": "Insulin",
  "insulin2": "Insulin",
  "totalDose": "Gesamt-Tagesdosis",
  "foodBolus": "Mahlzeitbolus",
  "Food+coor": "Food+corr",
  "calibBolus": "Korrekturbolus",
  "durationStop": "Dauer der Unterbrechung (min)",
  "ofPumpAlert": "# an Pumpenalarmen",
  "ofMeal": "# an Mahlzeiten",
  "totalExerTime": "Gesamte Bewegungsdauer",
  "exerNum": "# an Bewegungsübungen",
  "avgInten": "Durschnittliche Intensität",
  "target1": "Ziel",
  "high1": "Hoch ",
  "low1": "Niedrig ",
  "BG Reading": "BZ-Messwerte",

  "dayByday": "Tägliche Übersicht",
  "dayBydayRe": "Tägliche Übersicht",
  "period": "Zeitraum",

  "sensorOverlay": "Sensor-Overlay",
  "set": "Einstellen",
  "setPeriod": "Zeitraum einstellen",
  "Weekdays": "Wochentags",
  "Weekends": "Wochenenden",
  "Mon": "Mo",
  "Tue": "Di",
  "Wed": "Mi ",
  "Thur": "Do",
  "Thu": "Do",
  "Sat": "Sa",
  "Fri": "Fr ",
  "Sun": "So",
  "Average": "Durschnittlich",
  "sensorOlRe": "Sensor-Overlay-Bericht",
  "Avg": "Avg",
  "±SD": "±SD",
  "ofhypo": "# an Hypo",
  "Everyday": "jeden Tag",

  "TrendAna": "Trendanalyse",
  "TrendRe": "Trendanalyse-Bericht",
  "sensorGlu": "Sensor-Glukosewert ",
  "ofBGtest": "# an BZ-Tests",
  "Basics": "Grundlagen",
  "static": "Statistiken",
  "Med": "Med",
  "med": "median",
  "Q1": "Q1",
  "Q3": "Q3",
  "Q11": "Q1",
  "Q31": "Q3",
  "IQR": "IQR",
  "SD": "SD",
  "CV": "CV",
  "SE1": "SE Mittelewert",
  "distri": "Verteilung",
  "stab": "Stabilität",
  "#high": "# an Hoch",
  "#low": "# an Niedrig",
  "aucBelow": "AUC unter dem unteren Grenzwert",
  "aucAbove": "AUC über dem oberen Grenzwert",
  "bgRead": "BZ-Messwerte",
  "bgRead1": "BZ-Messwerte",
  "total": "Gesamt",
  "avg_daily_basal": "Basal",
  "avg_daily_bolus": "Bolus",
  "ofBolus": "# an Bolus",
  "avgBolus": "Ø Bolus",
  "Dura1": "Dauer (min)",
  "Avg/Total": "Avg/Total",
  "high": "Hoch",
  "low": "Niedrig",
  "#hypo": "# an Hypo",
  "ofExer": "# an Bewegungsübungen",

  "logbook": "Logbuch",
  "dailyTotal": "Tagessumme",
  "High Glucose": "Hohe Glukosewerte",
  "Low Glucose": "Niedrige Glukosewerte",
  "No Active Patch": "Kein aktiver Patch",
  "Missed Meal": "Verpasste Mahlzeit",
  "Multiple BG Readings": "Mehrere BZ-Messwerte",
  "Stop Patch": "Patch-Stopp",
  "Others": "Andere",
  "Other Events": "Andere Ereignisse",
  "logRe": "Logbuch-Bericht",

  "DeviceSetting": "Geräte-Einstellungsübersicht",
  "Insulin Pump": "Insulinpumpe",
  "MaxBasalRate": "Maximale Basalrate",
  "BasalPatterns": "Basalvorlagen",
  "Selected Basal Pattern": "Ausgewählte Basalvorlage",
  "Maximum Bolus": "Maximaler Bolus",
  "Combo/Extended Bolus": "Combo/Verzögerter Bolus",
  "BG Reminder": "BZ-Erinnerung",
  "Bolus Increment": "Bolusschritt",
  "Bolus Calculator": "Bolus-Rechner",
  "Active Insulin Time": "Aktive Insulinzeit",
  "IC Ratios": "KI-Verhältnisse",
  "Insulin Sensitivity": "Insulinempfindlichkeit",
  "BG Target": "BZ-Zielwert",
  "Bolus Reminder": "Bolus-Erinnerung",
  "CGM": "CGM",
  "CGM System": "CGM-System",
  "Glucose Unit": "Glukose-Einheit",
  "Glucose Limits": "Glukose-Grenzwerte",
  "Predicitive Alerts": "Vorwarnungen",
  "Rate Alerts": "Änderungsrate-Warnungen ",
  "type": "Typ",
  "time": "Zeit",
  "data": "Daten",
  "Rate": "Rate",
  "Calibration Reminder": "Kalibrierungs-Erinnerung",
  "Calibration Repeat": "Kalibrierungs-Wiederholung",
  "Snooze": "Erinnerungsintervall",
  "Audio Options": "Ton-Optionen",
  "Confidence Reminder": "Eingabe-Erinnerung",
  "Backlight": "Hintergrundbeleuchtung",
  "Sec": "sek",
  "Alarm Clock": "Wecker",
  "Patch Expiration": "Patch-Verfall",
  "Sensor Expiration": "Sensor-Verfall",
  "Hourly Max": "Maximale Stundenabgabe",
  "Daily Max": "Maximale Tagesabgabe",
  "Low Reservoir": "Behälterstand niedrig",
  "Low Suspend": "Niedrige Unterbrechung",
  "Predictive Low Suspend": "Vorwarnung Niedrige Unterbrechung",
  "Rise": "Zunahme",
  "Fall": "Abnahme",
  "Auto Off": "Automatische Unterbrechung",
  "Standard": "Standard",
  "Exercise": "Bewegung",
  "Holiday": "Urlaub",
  "ProgramA": "Vorlage A",
  "ProgramB": "Vorlage B",
  "--": "--",
  "Insulin": "Insulin",

  "SUSA": "Automatische Unterbrechung",
  "SUSHM": "Überschreitet max. stündliche Abgabe",
  "SUSDM": "Überschreitet max. GTD",
  "SUSLSG": "Niedrige Unterbrechung",
  "SUSPLSG": "Vorwarnung Niedrige Unterbrechung",
  "Pump Restarted": "Pumpe neu gestartet",
  "Meter BG Now": "BZ jetzt messen",
  "Sensor Exp in 2 Hours": "S-Verfall in 2 Std.",
  "Sensor Exp in 6 Hours": "S-Verfall in 6 Std",
  "Sensor Exp in 30 Min": "S-Verfall in 30 Min.",
  "Sensor Calibration Error": "Sensor-Kal.-Error",
  "Sensor Error": "Keine Lesungen",

  "Device Settings Report": "Geräte-Einstellungsbericht",
  "24h Total": "24h-Gesamt",
  "Device Settings at": "Geräte-Einstellungen am",
  "Start": "Start",
  "Combo/Ext Bolus": "Combo/Verzögerter Bolus",
  "Time Format": "Zeitformat",
  "Device Options（CGM System)": "Geräte-Optionen (CGM-System)",
  "Device Options（Insulin Pump)": "Geräte-Optionen (Insulinpumpe)",
  "Dispay Settings (Screen)": "Anzeige-Einstellungen (Bildschirm)",
  "Dispay Settings (Backlight)": "Anzeige-Einstellungen (Hintergrundbeleuchtung)",
  "Graph Range": "Diagramm-Bereich",
  "Range": "Bereich",
  "Repeat": "Wiederholung",
  "Glucose Alerts": "Glukose-Warnmeldungen",
  "Alert Silence": "Warnmeldung stummschalten",

  "Create": "Erstellen",
  "Event Filter": "Ereignis-Filter",
  "HbA1c1": "HbA1c",
  "Urine Ketone": "Urinketon",
  "Injection": "Injektion",
  "Other": "Andere",
  "Event Type": "Ereignis-Typ",
  "Details": "Details",
  "Notes": "Notizen",
  "Source": "Quelle",
  "edit": "Bearbeiten",
  "Action": "Aktion",
  "EventReport": "Ereignis-Zusammenfassungsbericht",
  "By Date": "Nach Datum",
  "By Category": "Nach Kategorie",
  "Event Summary": "Ereignis-Zusammenfassung ",
  "No data": "Keine Daten",
  "No1": "Keine",
  "data1": "Daten",
  "#": "#",
  "BG Summary": "BZ-Zusammenfassung",
  "Carbs Summary": "Kohlenhydrate-Zusammenfassung",
  "Injection Summary": "Injektions-Zusammenfassung",
  "Exercise Summary": "Bewegungs-Zusammenfassung",
  "Input Notes": "Geben Sie eine Notiz ein",

  "Profile": "Profil",
  "Complications": "Komplikationen",
  "Concomitant diseases": "Begleiterkrankungen",
  "Suggestion": "Empfehlung",
  "Coronary heart disease": "koronare Herzkrankheit",
  "High blood lipids": "hohe Blutfettwerte",
  "High blood pressure": "Bluthochdruck",
  "Kidney disease": "Nierenerkrankung",
  "Neuropathy": "Neuropathie",
  "Obesity": "Adipositas",
  "Peripheral arterial disease": "periphere Arterienerkrankung",
  "Retinopathy": "Retinopathie",
  "Smoking addiction": "Rauchsucht",
  "Enter date": "Datum eingeben",
  "Enter suggestion": "Empfehlung eingeben",
  "Enter Notes": "Eine Notiz eingeben.",
  "Select": "Auswählen",
  "Prescription": "Verschreibung",
  "Medicine": "Medizin",
  "Dose": "Dosis",
  "Enter medicine": "Medizin eingeben",
  "Enter dose": "Dosis eingeben",
  "Enterdis": "Enter concomitant diseases",
  "Add note": "Notiz hinzufügen",
  "Add Content": "Die maximale Länge beträgt 1000 Zeichenstellen",
  "Other suggestions": "Andere Empfehlungen",
  "OK": "OK",
  "HCP": "HCP",
  "Content": "Inhalt",
  "Records Report": "Protokoll-Bericht",

  "Quick Print": "Schnelldruck",
  "Quick Print Settings": "Schnelldruck-Einstellungen",
  "Select duration": "Dauer auswählen:",
  "One Week": "Eine Woche",
  "One Month": "Ein Monat",
  "One Quarter": "Ein Quartal",
  "End date": "Enddatum ",
  "Yesterday": "Gestern",
  "Last Sunday": "Letzten Sonntag",
  "Last Saturday": "Letzten Samstag",
  "Last Day of Last Month": "Last Day of Last Month",
  "Last Day of Last Quarter": "Last Day of Last Quarter",
  "Customized": "Anpassen",
  "Week Filter": "Filter nach Wochen",
  "Select reports to print": "Berichte zum Drucken auswählen",
  "Daily Summary": "Tägliche Zusammenfassung",
  "Day By Day Overview": "Tägliche Übersicht",
  "Sensor Overlay": "Sensor-Overlay",
  "Trend Analysis": "Trendanalyse",
  "Logbook": "Logbuch",
  "Device Settings Review": "Geräte-Einstellungsübersicht",
  "createReport": "Bericht erstellen",

  "Segment Analysis": "Segmentanalyse",
  "Sensor Glucose Profile": " Sensor-Glukoseprofil",
  "# of Boluses": " # von Bolus",
  "Bolus Insulin": "Bolus-Insulin",
  "Basal Pattern": "Basalvorlage",
  "Segment Analysis Report": "Segmentanalysebericht",
  "Avg Glucose": "Durchschn Glucose ",
  "Below": "Unter",
  "In Target Range": " Im Zielbereich",
  "Coefficient of variation": "Variationskoeffizient",
  "% Time CGM Active": "  % der Zeit für aktives CGM",


  "acceptTip": " hat Ihre Anfrage zugelassen, seine/ihre Gesundheits-Informationen per Remote-Ansicht zu betrachten.",
  "cancelTip": " hat Ihre Zugriffsberechtigung auf seine/ihre Gesundheits-Informationen per Remote-Ansicht beendet. Sie können die Berechtigung erneut anfragen, falls nötig.",
  "rejectTip": " hat Ihre Anfrage auf Remote-Ansicht abgelehnt.",
  "Read": "Lesen",

  "Connection": "Verbindung",
  "connections1": "Verbindungen",
  "Add Connection": "Verbindung hinzufügen",
  "SG": "SZ",
  "Active Insulin": "Aktives Insulin",
  "Stop following": "Nicht mehr folgen",
  "Enter username (email)": "Benutzernamen eingeben (E-Mail)",
  "Search results": "Ergebnisse durchsuchen",
  "Send request": "Anfrage senden",
  "View graphs": "Diagramme ansehen",
  "Agree": "Zustimmen",
  "Deny": "Ablehnen",
  "Remove": "Entfernen",
  "Cancel Requset": "Requset abbrechen",
  "Remark": "Anmerkung",

  "Warm up": "Aufwärmen",
  "Monitoring": "Überwachung",
  "Transmitter Error": "Transmitter-Error",
  "Sensor Failure": "Sensor-Fehler ",
  "Sensor Expired": "Sensor verfallen",
  "Lost Sensor": "Sensorsignal verloren",
  "Not Calibrated": "Nicht kalibriert",
  "Calibrating": "Kalibriert",
  "Calibration Needed": "Kalibrierung erforderlich",
  "Calibration Error": "Kalibrierungs-Error",
  "Charging Battery": "Batterie läd auf",
  "Battery Charged": "Batterie aufgeladen",

  "To be filled": "Befüllen erforderlich",
  "Filled with insulin": "Mit Insulin befüllt",
  "Priming": "Vorpumpen",
  "Priming completed": "Vorpumpen abgeschlossen",
  "Inserting needle": "Nadel wird eingeführt",
  "Patch activated": "Patch aktiviert",
  "Delivering Basal": "Gibt Basal ab",
  "Exceeds Max 1 Hour Delivery": "Überschritten max. stündliche Abgabe",
  "Exceeds Max TDD": "Überschritten max. GTD",
  "Suspend": "Unterbrechen",
  "Occlusion Detected": "Verschluss entdeckt",
  "Patch Expired": "Patch verfallen",
  "Empty Reservoir": "Reservoir Leer",
  "Patch Error": "Patch-Error",
  "Pump Base Error": "Pumpenbasis-Error",
  "Patch Battery Depleted": "Patch-Batterie leer",
  "Magnetic sensor not calibrated": "Magnetsensor nicht kalibriert",

  "Patient Profile": "Patientenprofil",

  "On": "An",
  "on": "An",
  "Off": "Aus",
  "off": "Aus",

  "CORONARY_HEART_DISEASE": "koronare Herzkrankheit",
  "HIGH_BLOOD_LIPIDS": "hohe Blutfettwerte",
  "HIGH_BLOOD_PRESSURE": "Bluthochdruck",
  "KIDNEY_DISEASE": "Nierenerkrankung",
  "NEUROPATHY": "Neuropathie",
  "OBESITY": "Adipositas",
  "PERIPHERAL_ARTERIAL_DISEASE": "periphere Arterienerkrankung",
  "RETINOPATHY": "Retinopathie",
  "SMOKING_ADDICTION": "Rauchsucht",

  "saveTip": "Erfolgreich gespeichert.",
  "changePaTip": "Ihr Passwort wurde geändert.",
  "enterEmTip": "Geben Sie Ihre E-Mail-Adresse an.",
  "verErrTip": "Bestätigungscode ungültig.",

  "chooseEventTip": "Wählen Sie die zu druckenden Ereignisse aus",
  "chooseDataTip": "Wählen Sie Daten zum Drucken",
  "dateWrongTip": "Die Endzeit sollte nicht früher als die Startzeit sein",
  "infoWrongTip": "Bitte füllen Sie alle erforderlichen Felder aus.",
  "createdSuccssTip": "Erfolgreich erstellt",
  "selectData": "Wählen Sie Daten zum Speichern",

  "acceSu": "Verbindungsanfrage akzeptiert  ",
  "acceEr": "Fehler: neue Verbindung  nicht hinzugefügt",
  "rejeSu": "Verbindungsanfrage abgelehnt",
  "rejeEr": "Fehler bei Anforderung-Ablehnen",

  "userNotExist": "Der Benutzername existiert nicht.",
  "Password incorrect": "Ungültiges Passwort.",
  "UserType incorrect": "Falschner Benutzertyp",

  "registSuccess": "Ihr Konto wird erfolgreich erstellt",
  "registFailed": "Fehler: neues Konto nicht registriert",
  "sentSuccess": "Nachtricht erfolgreich gesendet",
  "sentFailed": "Nachricht-Senden fehlgeschlagen",
  "Input error": "Eingabe Fehler",

  "deletePtip": "Sind Sie sicher, dass Sie diese Patienten löschen möchten?",
  "deleteEvents": "Möchten Sie diese Ereignisse wirklich löschen?",
  "deleteData": "Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",
  "deleteThis": "Sind Sie sicher, dass Sie löschen möchten ?",
  "confirm": "Bestätigen",
  "deleteSuccess": "Löschen erfolgreich",
  "deleteFailed": " Inhalt-Löschen fehlgeschlagen",
  "modifySuccess": "Änderung erfolgreich ",
  "modifyFailed": "Änderung fehlgeschlagen",
  "createSuccess": "Erfolgreich erstellt",
  "createFailed": "Erstellen fehlgeschlagen",
  "editSuccess": "Erfolgreich bearbeiten",
  "editFailed": "Bearbeiten fehlgeschlagen",
  "Time overlapped": "Die Sitzungen, die Sie ausgewählten, überlappen sich",

  "stopFollow": "Sind Sie sicher, dass Sie diesen Patienten nicht mehr folgen möchten?",
  "CancelTip1": "Sind Sie sicher,  diese Verbindung zu löschen?",

  "Warning": "Warnung",
  "agreeConnect": "Wenn Sie auf ,Akzeptieren“ klicken und die Verbindungsanfrage akzeptieren, werden Ihre Gesundheitsdaten für die neue Verbindung zugänglich.",
  "denyConnect": "Sind Sie sicher, die Verbindungsanfrage abzulehnen?",
  "deleteConnect": "Sind Sie sicher,  diese Verbindung zu löschen? Wenn Sie ihn / sie löschen, wird die Verbindung nicht in der Lage sein, Ihre Gesundheitsdaten zu sehen.",

  "Choose the events to print": "Choisissez les événements à imprimer",
  "tryAgain": "Versuchen Sie es nochmal",
  "username and password is required": "username and password is required",
  "A name is required": "Ein Name ist erforderlich.",
  "username is required": "Ein Benutzername ist erforderlich.",
  "The date choose wrong": "falsches Datum gewählt",
  "Date no more than 14 days": "Sie können nicht mehr als 14 Tage wählen",

  "CancelTip": "Sind Sie sicher,  die Verbindung zu löschen?",
  "removeConnect": "Erfolgreich gelöscht",

  "dateErr1": "Sie können nicht mehr als 90 Tagen wählen",
  "dateErr2": "Das Enddatum darf nicht vor dem Startdatum liegen.",

  "Not Filled": "Nicht spezifiziert",
  "Today": "Heute",
  "duration": "Dauer",
  "interval": "Interval",
  "7 days": "7 Tage",
  "14 days": "14 Tage",
  "30 days": "30 Tage",
  "90 days": "90 Tage",
  "g": "g",

  "Sound+Vibrate": "Audio + Vibration",
  "Sound": "Audio",
  "Vibrate": "Vibrieren",
  "Silent": "Bitte nicht stören",
  "1": "Einmal",
  "2": "Täglich",
  "noMes": "Es gibt keine Nachrichten.",
  "noConnect": "Es gibt keine Verbindungen.",
  "Customize": "Anpassen",
  "GB": "United Kingdom",
  "CN": "China",
  "FR": "France",
  "DD": "Germany",
  "DE": "Germany",
  "SE": "Sweden",
  "AU": "Australia",
  "HKF": "Hongkong",
  "HU": "Hungary",
  "IT": "Italy",
  "NL": "Netherlands",
  "Nor": "Norway",
  "PT": "Portugal",
  "ES": "Spain",
  "TR": "Turkey",

  "Jan": "Jan",
  "Feb": "Feb",
  "Mar": "Mär",
  "Apr": "Apr",
  "May": "Mai",
  "Jun": "Jun",
  "Jul": "Jul",
  "Aug": "Aug",
  "Sep": "Sep",
  "Oct": "Okt",
  "Nov": "Nov",
  "Dec": "Dez",
  "ApplyTip": " Anfrage um Ihre Daten zu sehen.",
  "noReadings": "Keine Lesungen",

  "daop_A6_system": "A6 Touchcare System",
  "daop_easytouch_easyview": "EasyTouch / EasyView iPad",
  "daop_TY012_TY015": "TY012/TY015",
  "daop_easysense": "EasySense",
  "daop_delete_data": "Delete Data",
  "daop_uploaded_data": "daten hochgeladen",
  "daop_uploaded_data_text": "Die Daten stammen von der EasyTouch App oder der EasyView iPad App.",
  "daop_realtime_data": " Echtzeitdaten",
  "daop_realtime_data_text": "The data is from EasySense App or EasyPatch App.",

  "ins_unit": "(IE)",
  "ins_unit2": "IE ",
  "basal_unit": "(IE/H)",
  "basal_unit2": "IE/H",

  "Alerts_Patch_Battery_Low": "Patch-Batterie schwach",
  "Alerts_Patch_Battery_Depleted": "Patch-Batterie leer",
  "Alerts_Lost_Pump": "Lost Pump",
  "Alerts_Low_Reservoir": "Behälterstand niedrig",
  "Alerts_Empty_Reservoir": "Leerer Behälter",
  "Alerts_Patch_Expiration_Advisory": "Patch-Verfall-Erinnerung",
  "Alerts_Patch_Exp_In_1_Hour": "Patch Exp In 1 Hour",
  "Alerts_Patch_Expired": "Patch verfallen",
  "Alerts_Patch_Error": "Patch-Error",
  "Alerts_Pump_Base_Error": "Pumpenbasis-Error",
  "Alerts_Basal_Rate_Key_Error": "Basal Rate Key Error",
  "Alerts_Occlusion_Detected": "Verschluss entdeckt",
  "Alerts_End_Of_Suspend": "End Of Suspend",
  "Alerts_Exceeds_Max_TDD": "Überschreitet max. GTD",
  "Alerts_Exceeds_Max_1Hr_Delivery": "Überschreitet max. stündl. Abgabe",

  "Alerts_Predictive_Low_Suspend": "Vorwarnung Niedrige Unterbrechung",
  "Alerts_Low_Suspend": "Niedrige Unterbrechung",
  "Alerts_Auto_Off": "Automatische Unterbrechung",

  "Alerts_Pump_Restart": "Pump Restart",
  "Alerts_Auto_Off_Warning": "Auto Off Warning",
  "Alerts_Pump_Out_Of_Range": "Pump Out Of Range",

  "Alerts_Lost_Sensor": "Sensorsignal verloren",
  "Alerts_Transmitter_Battery_Low": "Sender-Batterie schwach",
  "Alerts_Charge_Transmitter": "Sendeanlage aufladen",
  "Alerts_Sensor_Error": "Keine Lesungen",
  "Alerts_Transmitter_Error": "Sender-Error",
  "Alerts_Sensor_Calibration_Error": "Sensor Calibration Error",

  "Alerts_Sensor_Failure": "Sensor-Fehler ",
  "Alerts_Sensor_Calibration_Reminder": "Sensor Calibration Reminder",
  "Alerts_Meter_BG_Now": "BZ jetzt messen",
  "Alerts_Sensor_Exp_in_6_Hours": "S-Verfall in 6 Std.",
  "Alerts_Sensor_Exp_in_2_Hours": "S-Verfall in 2 Std.",
  "Alerts_Sensor_Exp_in_30_Min": "S-Verfall in 30 Min.",
  "Alerts_Sensor_Expired": "Sensor verfallen",
  "Alerts_Rapid_Rise": "Schnelle Zunahme",
  "Alerts_Rapid_Fall": "Schnelle Abnahme",
  "Alerts_High_Predicted": "Hoch Vorwarnung",
  "Alerts_Low_Predicted": "Niedrig Vorwarnung",
  "Alerts_High_Glucose": "Hohe Glukosewerte",
  "Alerts_Low_Glucose": "Niedrige Glukosewerte",
  "Alerts_Below_3.1_mmol/L": " Unter 3.1 mmol/L  ",
  "Alerts_Transmitter_Battery_Low_2": "Sender-Batterie schwach",

  "Alerts_PDM_Battery_Low": "PDM-Batterie schwach",
  "Alerts_Replace_Battery": "Laden Sie den PDM auf",

  "Alert": "Alert",
  "Alerts": "Warnmeldungen",
  "Alert Filter": "Alert Filter",
  "PDM": "PDM",
  "Pump": "Pumpe",

  "alert_Time": "Time",
  "alert_Type": "Type",

  "Out Of Range": "Out Of Range",
  "t1221_Time_in_Auto_Mode": "Zeit im Auto-Modus",
  "t1221_Average_SG_SD": "Durchschnittlicher SG ± SD",
  "t1221_Time_in_Target_Range": "Zeit im Zielbereich",
  "t1221_Time_above_Range": "Zeit über Bereich",
  "t1221_Time_below_Range": "Zeit unter Bereich",
  "t1221_Auto_Basal_per_day": "Auto Basal (pro Tag)",
  "t1221_Auto_Bolus_per_day": "Auto Bolus (pro Tag)",
  "t1221_Auto_Mode_Exits": "Auto-Modus beendet",
  "t1221_No_Sensor_readings": "Keine Sensormessungen",
  "t1221_Max_Delivery": "Max. Lieferung",
  "t1221_Min_Delivery": "Min. Lieferung",
  "t1222_autoModeBasal": "Auto-Modus Basal",
  "t1222_autoModeCorrBolus": "Auto-Modus Korrekter Bolus ",
  "t1222_autoSnack": "Auto Snack",
  "t1222_autoBreakfast": "Auto Frühstück",
  "t1222_autoLunch": "Auto Mittagessen",
  "t1222_autoDinner": "Auto Abendessen",
  "t1222_autoExercise": "Auto Übung",
  "t1222_Snack": "Snack",
  "t1222_Auto_Mode": "Auto-Modus",
  "t1222_Time_in_Auto_Mode": "Zeit im Auto-Modus(%)",
  "t1222_Avg_SD": "Durchschnitt (mmol/L)±SD",
  "t1222_Target_Range": "Zielbereich(%)",
  "t1222_Above_Range": "Über Bereich(%)",
  "t1222_Below_Range": "Unter Bereich(%)",
  "t1222_Auto_Mode_Exits": "# von Auto-Modus  beendet",
  "t1221_Auto_Mode": "Auto-Modus",
  "t1222_auto_basal": "Auto Basal",
  "t1222_auto_bolus": "Auto Bolus",
  "t0805_User_Management": "Benutzerverwaltung",
  "t0805_Patient_Management": "Patienten Management",
  "t0805_Operation_History": "Betriebsverlauf",
  "t0805_User_List": "Benutzerliste",
  "t0805_User": "Nutzer",
  "t0805_Time": "Zeit",
  "t0805_Operation_Type": "Operationstyp",
  "t0805_Back": "Zurück",
  "t0805_Add": "Hinzufügen",
  "t0805_Delete": "Löschen",
  "t0809_Add_User": "Benutzer hinzufügen",
  "t1028_Pattern_C": "Vorlage C",
  "t1028_Pattern_D": "Vorlage D",
  "t1029_Auto_meal_bolus": "Auto meal bolus",
  "t1029_Auto_mode_correction_bolus": "Auto mode correction bolus",
  "t1029_Sick": "Krank",
  "t1029_Auto_Mode_Feature": "Automatik-Modus",
  "t1029_Target_SG": "Target SG",
  "t1029_Auto_Meal_Handling": "Auto Malzeit Bolus",
  "t1029_Total_Daily_Dose": "Ges. täglicher Dosis ",
  "t1029_Pump_Light": "Pumpenlicht",
  "t1029_Alerts_for_Hypo": "Warnmeldungen für Unter",
  "t1102_Out_of_Range": "Außer Bereichs",
  "t1102_Command_Reminder": "Befehlserinnerung",
  "t1102_Alarms_Alerts_on_APP": "Alarme und Warnungen an der Pumpe",
  "t1102_Alarms_on_App": "Alarme auf App",
  "t1102_Alerts_on_App": "Alerts On App",
  "t1102_Factory_Calibration": "Werks Kalibrierung",
  "t1102_Alerts_for_Low": "Warnungen für niedrigen BZ",
  "t1102_Alerts_for_High": "Warnungen für hohen BZ",
  "t1102_Alerts_for_Others": "andere Warnungen ",
  "t1102_Adjustment": "Anpassung",
  "t1102_Suggested": "Empfohlen",
  "t1103_Glucose": "Glukose",
  "t1103_CGM": "CGM",
  "t1103_Insulin": "Insulin",
  "t1103_Carbs": "Kohlenhydrate",
  "t1103_Exercise": "Bewegung",
  "t1103_Min_Max": "Min/Max",
  "t1103_Target_Range": "Zielbereich",
  "t1103_Overall_Tine_In_Range": "Übersicht: Zeit im Zielbereich",
  "t1103_Basal": "Basal",
  "t1103_Bolus": "Bolus",
  "t1103_Basal_Bolus": "Basal & Bolus",
  "t1103_Auto_Mode_Time_In_Range": "Auto-Modus: Zeit im Zielbereich",
  "t1103_Time_below_range": "Zeit unterhalb des Zielbereichs",
  "t1103_Time_above_range": "Zeit oberhalb des Zielbereichs",
  "t1103_Time_in_target_range": "Zeit im Zielbereich",
  "t1103_Incorrect_Password": "Falsches Passwort, $1 Versuch links, bitte geben Sie das richtige Passwort ein.",
  "t1103_Incorrect_locked": "Fehlgeschlagene Versuche überschreiten das Limit, das Konto wurde gesperrt. Bitte versuchen Sie es in $1 Minuten erneut.",
  "t1104_The_data_is_from": "Die Daten stammen von der EasySense App oder der EasyPatch App.",
  "t1104_Privacy_Policy": "Datenschutzerklärung und Nutzungsbedingung",
  "t1104_updated_privacy_policy": "Wir haben unsere Datenschutzbestimmungen und Nutzungsbedingungen aktualisiert. Bitte lesen Sie   die neuen Bedingungen sorgfältig durch und stimmen Sie ihnen zu, bevor Sie das Easy-Patch System verwenden.",
  "t1104_Disagree": "Nicht einverstanden",
  "t1104_Agree": "Zustimmen",
  "t1105_Upload_History": "Upload-Verlauf",
  "t1105_Delete_Data": "Daten löschen",
  "t1105_Target_Range": "Zielbereich",
  "t1105_request_to_view_your_data": "$1 Anfrage, um Ihre Daten anzuzeigen.",
  "t1105_Recent_Updates": "Neueste Updates",
  "t1108_No_data": "Keine Daten",
  "t1108_Pump_Bash_SN": "Pumpenbasis-SN",
  "t1108_Transmitter_SN": "Sendeanlage-SN",
  "t1112_Normal_Glucose": "Normale Glukose",
  "t1112_Manual_Bolus_or_Modified_Bolus": "Manueller Bolus oder modifizierter Bolus",
  "t1112_Auto_Mode_Started": "Automodus hat begonnen",
  "t1112_Auto_Mode_Exit": "Automodus Abbruch",
  "t1112_Normal_Bolus": "Normaler Bolus",
  "t1112_Extended_Bolus": "Verzög. Bolus",
  "t1112_Combo_Bolus": "Combo-Bolus",
  "t1112_Carbs": "Kohlenhydrate",
  "t1112_Glucose": "Glukose",
  "t1112_BG": "BZ",
  "t1112_Audio": "Audio",
  "t1112_Tone": "Ton",
  "t1112_Audio_Options": "Ton-Optionen",
  "t1112_Weight_Unit": "Gewichtseinheit",
  "t1112_Height_Unit": "Höheneinheit",
  "t1112_Not_available": "Nicht Verfügbar",
  "t1112_Number": "Nummer",
  "t1112_days": "# tage",
  "t1112_min": "min",
  "t1113_days": "tage",
  "t1215_Security": "Sicherheit",
  "t1215_MFA": "Multi-Faktor-Authentifizierung (MFA)",
  "t1215_Enter_verification_code": "Bestätigungscode eingeben",
  "t1215_Multi_factor_ON": "Die Multi-Faktor-Authentifizierung ist aktiviert. Der Bestätigungscode wurde an $1 gesendet Bitte senden Sie den Bestätigungscode.",
  "t1215_Verification_code_incorrect": "Bestätigungscode ",
  "t1215_Show_Glucose_Value": "Glukosewert anzeigen",
  "t1221_enter_verification_code": "Bitte geben Sie den 6-stelligen Bestätigungscode ein, der an $1 gesendet wurde.",
  "t1221_Verification_Success": "Erfolgreich bestätigt",
  "t1222_We_will_only_process": "Wir werden Ihre Gesundheitsdaten nur mit Ihrer Zustimmung über die Medtrum App/Website verarbeiten. ",
  "t1222_If_you_are_under_years": "Wenn Sie unter 16 Jahre alt sind, benötigen Sie die Zustimmung Ihres Elternteils oder Erziehungsberechtigten, um sich in dieser App zu registrieren .",
  "t1221_register_cn": "Sie haben das Recht, keine Gerätedaten in die App hochzuladen. In diesem Fall sind die Daten anderen nicht zugänglich. Wenn Sie sich nicht für die Medtrum App/Webseiten registrieren, werden nur Ihre Gesundheitsdaten auf dem Gerät selbst gespeichert. ",
  "t1221_register_eu": "Wenn Sie sich für die Registrierung Ihres Medtrum-Kontos entscheiden und über das Konto auf unsere App zugreifen, werden die in der App aufgezeichneten Gesundheitsdaten auf unseren Server in Europa hochgeladen und 2 Jahre lang aufbewahrt. Sie haben das Recht, keine Gerätedaten in die App hochzuladen. In diesem Fall sind die Daten anderen nicht zugänglich. Wenn Sie sich nicht für die Medtrum App/Webseiten registrieren, werden nur Ihre Gesundheitsdaten auf dem Gerät selbst gespeichert.",
  "t1221_register_follow": "Wir werden Ihre Gesundheitsdaten nur mit Ihrer Zustimmung über die Medtrum App/Webseiten verarbeiten.",
  "t1222_Terms_of_Use": "den Nutzungsbedingungen von Medtrum zu",
  "t1222_Privacy_Policy": "der Datenschutz-Erklärung von Medtrum zu",
  "t1222_Create_Account": "Benutzerkonto anlegen",
  "t1222_Back": "Zurück",
  "t1222_Verify_your_account": "Bestätige dein Konto",
  "t1222_please_check_your_account": "Wir senden einen Verifizierungscode an $1, bitte überprüfen Sie Ihr Konto.",
  "t1222_I_Agree_to": "Ich stimme $1",
  "t1223_Invalid_Verification_Code": "Ungültiger Bestätigungscode. Bitte versuche es erneut."
};

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dkMessages; });
var dkMessages = {
  "privacy_policy_and_terms_of_use": "Politik om databeskyttelse og vilkår for brug",
  "privacy_confirm_text": "Vi har opdateret vores politik om databeskyttelse og vilkår for brug . For at kunne fortsætte med at bruge Easyview, bedes du læse og acceptere alle vilkårene.",
  "privacy_confirm_disagree": "Uenig",
  "privacy_confirm_accept": "Accepter",

  "title": "EasyView Personal",
  "title1": "EasyView Pro",
  "user": "E-mail",
  "password": "Adgangskode",
  "remember": "Husk mig",
  "forget": "Glemt adgangskode?",
  "sign in": "Log på",
  "login": "Login",
  "sign up now": "Tilmeld dig nu",
  "apply": "Ansøg om en konto",
  "contact us": "Kontakt os",
  "Privacy Policy": "Politik om databeskyttelse",
  "Terms of Use": "Vilkår for brug",
  "copyright": "Copyright © 2021 Medtrum Technologies Inc. Alle rettigheder forbeholdes.",

  "chooseLang": "Vælg dit land eller sprog",
  "asia": "Asia Pacific",
  "europe": "Europa",
  "middleEast": "Middle East",

  "applyHcp": "Ansøg om en HCP-konto ",
  "sign up": "Tilmeld dig",
  "Patient": "Patient",
  "Caregiver": "pårørende",
  "Email": "E-mail",
  "Mobile": "Mobil",
  "Enter email": "Indtast e-mailadresse",
  "Enter mobile": "Indtast mobilnummer",
  "Verification": "Bekræftelseskode",
  "Invitation": "Invitation code",
  "full name": "Indtast dit fulde navn",
  "Enter pass": "Enter password",
  "org": "Organisation",
  "Register": "Register",
  "send": "Send",
  "createAccount": "Create Account",
  "agree": "I have read and agree to the ",
  "privacy": " Medtrum privacy policy  ",
  "and": "and ",
  "use": "terms of service.",
  "errtip1-1": "Du skal indtaste en gyldig e-mailadresse, ",
  "errtip1-2": "som bliver dit Medtrum-brugernavn.",
  "errtip2": "Please enter a valid mobile number.",
  "errtip3": "Bekræftelseskode er forkert",
  "errtip4": "Incorrect invitation code.",
  "errtip5": "Brugernavn er forkert",
  "errtip6": "Your password must have 8 or more characters.",
  "errtip7": "Indtast venligst din organisation",

  "errp1": "Adgangskoden skal indeholde mindst 3 typer af følgende tegn:",
  "errp2": "store bogstaver, små bogstaver, tal og specialtegn.",
  "errp3": "Adgangskoden skal være på mellem 6 og 20 tegn.",
  "errp4": "Adgangskoden skal være anderledes end brugernavnet.",
  "errp5": "En adgangskode med 3 tal efter hinanden er ugyldig (f.eks.: 123, 321).",
  "errp6": "En adgangskode med 3 bogstaver efter hinanden er ugyldig (f.eks.: abc, cba).",
  "errp7": "Adgangskoden må ikke indeholde mellemrum.",

  "Find account": "Hent din adgangskode.",
  "Enter username": "Indtast dit brugernavn.",
  "Next": "Næste",
  "Cancel": "Annuller",
  "Back": "Tilbage",
  "Enter veri": "Enter verification code",
  "Verify notice": "Find den bekræftelseskode, der blev sendt i en e-mail.",
  "Create new": "Opret en ny adgangskode",
  "Create new notice": "Opret en ny adgangskode. Adgangskoden skal indeholde 6 eller flere tegn.",
  "New pass": "Ny adgangskode",
  "Completed": "Fuldført",
  "Created": "Ny adgangskode er oprettet.",
  "Login Now": "Log på nu",

  "Delete": "Slet",
  "New Patient": "Ny patient",
  "Add Patient": "Tilføj patient",
  "Filter": "Filter",
  "Name": "Navn",
  "Gender": "Køn",
  "Age": "Alder",
  "Type": "Type",
  "Duration": "Varighed",
  "Connections": "Kontoopretter",
  "UploadTime": "Overførselstid",
  "Year": "år",
  "Years": "år",
  "Month": "måneder",
  "Month2": "Måned",
  "Months": "måneder",
  "Invite": "Inviter",
  "Invited": "Inviteret",
  "All": "Alle",
  "Female": "Kvinde",
  "Male": "Mand",
  "Not Set": "Not Set",
  "Type 1": "Type 1",
  "Type 2": "Type 2",
  "Gestational": "Graviditet",
  "Prediabetes": "Prædiabetes",
  "LADA": "Type 1.5 LADA",
  "Apply": "Anvend",
  "disUn": "Diabetes type ikke angivet",
  "ageUn": "Alder ikke angivet",
  "genUn": "Køn ikke angivet",
  "addP": "Tilføj patient",
  "newP": "Ny patient",
  "findP": "Find patient",

  "GDRNF": "Ikke angivet",
  "GDRF": "Kvinde",
  "GDRM": "Mand",
  "女": "Mand",

  "DBTNF": "Ikke angivet",
  "DBT1": "Type 1",
  "DBT2": "Type 2",
  "DBTLADA": "Type 1.5 LADA",
  "DBTPRE": "Prædiabetes",
  "DBTGEST": "Graviditet",
  "前期": "beFore",
  "beFore": "beFore",
  "MODY": "Mody",

  "No selection": "No selection",
  "unspecif": "unspecified",
  "register": "Patient",
  "hcp": "Kliniker",

  "BG": "BS",
  "CARB": "Kulhydrater",
  "INS": "Injektion",
  "EXR": "Motion",
  "OTR": "Andet",
  "HBA1C": "HbA1c",
  "DOSE": "DOSE",
  "URINEK": "Urinketon",
  "HEL": "HEL",
  "OTR1": "Andet",
  "Loading": "Indlæser",

  "home": "Hjem",
  "pID": "Patient-ID",
  "fullName": "Fulde navn",
  "gender": "Køn",
  "height": "Højde",
  "weight": "Vægt",
  "cm": "cm",
  "kg": "kg",
  "birthday": "Fødselsdato",
  "disType": "Type af diabetes",
  "disDate": "Dato for diagnose",
  "Address": "Adresse",
  "Postcode": "Postnummer",
  "Inpatient": "Indlagt patient",
  "Yes": "Ja",
  "No": "Nej",
  "Pno": "Patientnr.",
  "Bno": "Sengenr.",
  "create": "Opret",
  "Telephone": "Telefon",

  "enterU": "Indtast brugernavn (e-mail)",
  "search": "Søg",
  "noU": "Brugernavn skal angives.",
  "searchR": "Søgeresultater",
  "uername": "Brugernavn",
  "alias": "Alias",
  "remove": "Fjern",
  "viewG": "Vis grafer",
  "sendR": "Send anmodning",
  "rSent": "Din anmodning er afsendt.",
  "cancelR": "Slet anmodning",

  "VcodeTip1": "Didn’t receive it? Please wait for a few minutes and",
  "VcodeTip2": "try again.",
  "VcodeTip3": "We just sent a code to ",
  "Entercode": "Indtast kode",
  "Getcode": "Få kode",

  "messages": "Meddelelser",
  "profile": "Profil",
  "sign out": "Log af",
  "changeP": "Skift adgangskode",
  "connection": "Forbindelser",

  "myP": "Min profil",
  "Portrait": "Profilbillede",
  "Profession": "Erhverv",
  "DPRONF": "Ikke angivet",
  "DPROENDOCRIN": "Endokrinolog",
  "DPRODIABTRA": "Diabetesunderviser",
  "DPRONURSE": "Sygeplejerske",
  "DPRODIATIT": "Diætist",
  "DPROOTR": "Andre sundhedspersoner",
  "Organization": "Organisation",
  "Bio": "Bio",
  "save": "Gem",
  "oldPa": "Gammel adgangskode ",
  "newPa": "Ny adgangskode",
  "RePa": "Indtast adgangskode igen",
  "forgetY": "Glemt din adgangskode?",
  "applyM": "Anvend",
  "oldErr": "Det gamle Adgangskode er ikke korrekt.",
  "EntTheSame": "Indtast den nye Adgangskode igen.",
  "EnterOld": "Enter the old Password!",

  "pList": "Patientliste",
  "connections": "Forbindelser",
  "settings": "Indstillinger",
  "monitor": "Overvåg",
  "graphs": "Rapporter",
  "events": "Hændelser",
  "records": "Overblik",
  "qPrint": "Hurtig udskrivning",

  "sensorIn": "Sensoroplysninger",
  "timeOfLaRead": "Tidspunkt for den sidste sensormåling",
  "tranSn": "Transmitters SN",
  "status": "Status",
  "sensorLife": "Resterende sensorlevetid",
  "lastSenorRead": "Seneste sensormåling",
  "TranBattery": "Transmitterbatteri",
  "sg": "SG",
  "alert": "Advarsel",
  "target": "Mål",
  "hypo": "Hypo",
  "sensorGlucose": "Sensorglukose",
  "calib": "Kalibrering",
  "newSen": "Ny sensor",
  "warm": "Opvarmning",
  "InsulinPump": "Insulinpumpe",
  "timeOfLaPump": "Tidspunkt for de sidste pumpedata",
  "pumpSN": "Pumpebases SN",
  "ReserviorLife": "Resterende levetid for reservoir-patch",
  "InsulinLeft": "Insulin tilbage",
  "basal": "Basal",
  "bolus": "Bolus",
  "totalBasal": "Total daglig basal",
  "lastBolus": "Sidste bolus",
  "activeInsulin": "Aktivt insulin",
  "totalBolus": "Total daglig bolus",
  "tampBasal": "Midl. basal",
  "normalBolus": "Normal Bolus",
  "extendBolus": "Forlænget Bolus",
  "manualStop": "Manuelt Stop",
  "autoStop": "Automatisk Stop",
  "auto suspend": "Automatisk Stop",
  "stop": "Tilførselsstop",
  "newPatch": "Ny patch",
  "tempBasal": "Midl. Basal",
  "N": "N",
  "E": " F",
  "CN1": "KN",
  "CE": " KF",

  "staticSettings": "Rapport Indstillinger",
  "dataSource": "Data, der skal vises",
  "unit": "Enhed:",
  "glucoseTarget": "Glukose Måleområde",
  "overall": "Samlet",
  "Hypoglycemia": "Hypoglykæmi",
  "timePeriod": "Tidsperiode",
  "postMeal": "Analyse efter måltid",
  "Breakfast": "Morgen",
  "Lunch": "Frokost",
  "Dinner": "Middag",
  "night": "Nat",
  "Before": "Før",
  "After": "Efter",
  "Low": "Lav",
  "High": "Høj",
  "From": "Fra",
  "To": "Til",
  "Hours": "Timer",
  "Reset": "Gendan standarder",
  "RealTime": "Realtid",
  "uploaded": "Overført",
  "sensor": "Sensor",
  "pdmSN": "PDM SN",
  "startTime": "Starttidspunkt",
  "endTime": "Sluttidspunkt",
  "uploadTime": "Time of upload",
  "pdm": "PDM",
  "Uploaded": "Overført",
  "Patch Pump": "Patch Pumpe",
  "overLapp": "Sessioner overlapper hinanden",
  "showAlert": "Vis advarsler",

  "dashboard": "Dashboard ",
  "dboard_glucose_statistics": "Glucose Statistics",
  "dboard_glucose": "BS",
  "dboard_cgm": "CGM",
  "dboard_insulin": "Insulin",
  "dboard_carbs": "Kulhydrater",
  "dboard_exercise": "Motion",
  "dboard_glucose_avg": "Gennemsnit",
  "dboard_cgm_avg": "Gennemsnit",
  "dboard_insulin_avg": "Gennemsnitlig daglig dosis",
  "dboard_carbs_avg": "Gennemsnitlige kulhydrater/dag",
  "dboard_exercise_avg": "Gennemsnitlig tid/dag",
  "dboard_sd": "SD",
  "dboard_num": "#",
  "dboard_num_days": "# dage",
  "dboard_statistics": "Statistik",
  "dboard_BG": "BS",
  "dboard_BG_calibration": "BS/kalibrering (pr. dag)",
  "dboard_SG": "SG",
  "dboard_AUC_high": "AUC høj >",
  "dboard_AUC_low": "AUC lav <",
  "dboard_highest_value": "Højeste værdi",
  "dboard_lowest_value": "Laveste værdi",

  "dboard_pump": "Pumpe",
  "dboard_avg_daily_dose": "Gennemsnitlig daglig dosis",
  "dboard_SD": "SD",
  "dboard_daily_basal": "Daglig basal",
  "dboard_daily_bolus": "Daglig bolus",
  "dboard_avg_bolus_num": "Gennemsnitligt antal boli pr. dag",
  "dboard_avg_suspend_time": "Gennemsnitlig stoppet tid",
  "dboard_avg_reservoir_usage": "Gennemsnitlig reservoirbrug",
  "dboard_days": "dage",

  "dboard_manual_bolus": "Manuel bolus (mængde/antal pr. dag)",
  "dboard_normal": "-Normal",
  "dboard_extend": "-Forlænget",
  "dboard_combo": "-Kombi",

  "dboard_bolus_calculator": "Bolusguide (mængde/antal pr. dag)",
  "dboard_food_bolus": "-Måltidsbolus",
  "dboard_corr_bolus": "-Korr.bolus",
  "dboard_override_add": "-Forøg (+)",
  "dboard_override_sub": "-Formindsk (-)",

  "dboard_report": "Dashboard Rapport ",

  "daily": "Daglig oversigt",
  "date": "Dato",
  "print": "Udskriv",
  "carbs": "Kulhydrater",
  "exercise": "Motion",
  "heavy": "Hård",
  "Medium": "Mellem",
  "Light": "Let",
  "dailyReport": "Daglig Oversigts Rapport",
  "devices": "Enheder",
  "tran": "Transmitter",
  "pumpBase": "Pumpebase",
  "HbA1c": "HbA1c",
  "statics": "Statistik",
  "glucose": "Glukose",
  "item": "Element",
  "BG1": "BS",
  "SG1": "SG",
  "avgSD": "Gns. (mmol/l)±SD",
  "avgSD1": "Gns±SD ",
  "min": "Min.",
  "max": "Maks.",
  "ofRead": "Antal aflæsninger",
  "ofHypo": "Antal hypo/varighed",
  "ofAlert": "Antal advarsler",
  "insulin": "Insulin",
  "insulin2": "Insulin",
  "totalDose": "Samlet daglig dosis",
  "foodBolus": "Kulhydratbolus",
  "Food+coor": "Food+corr",
  "calibBolus": "Korrektionsbolus",
  "durationStop": "Varighed af stop (min.)",
  "ofPumpAlert": "Antal pumpealarmer",
  "ofMeal": "Antal måltider",
  "totalExerTime": "Samlet motionstid",
  "exerNum": "Antal øvelser",
  "avgInten": "Gns. intensitet",
  "target1": "Mål",
  "high1": "Høj",
  "low1": "Lav",
  "BG Reading": "BS-aflæsninger",

  "dayByday": "Oversigt dag for dag",
  "dayBydayRe": "Oversigtsrapport dag for dag",
  "period": "Periode",

  "sensorOverlay": "Sensor Overblik",
  "set": "Indstil",
  "setPeriod": "Indstil periode",
  "Weekdays": "Hverdage",
  "Weekends": "Weekender",
  "Mon": "Man",
  "Tue": "Tir",
  "Wed": "Ons",
  "Thur": "Tor",
  "Thu": "Tor",
  "Fri": "Fre",
  "Sat": "Lør",
  "Sun": "Søn",
  "Average": "Gennemsnit",
  "sensorOlRe": "Sensor Overbliks Rapport ",
  "Avg": "Gns.",
  "±SD": "±SD",
  "ofhypo": "Antal hypo",
  "Everyday": "hver dag",

  "TrendAna": "Tendensanalyse",
  "TrendRe": "Tendens Analyse Rapport",
  "sensorGlu": "Sensorglukose ",
  "ofBGtest": "Antal BS-tests",
  "Basics": "Grundlæggende",
  "static": "Statistik",
  "Med": "Med",
  "med": "median",
  "Q1": "Q1",
  "Q3": "Q3",
  "Q11": "Q1",
  "Q31": "Q3",
  "IQR": "IQR",
  "SD": "SD",
  "CV": "CV",
  "SE1": "SE middel",
  "distri": "Distribution",
  "stab": "Stabilitet",
  "#high": "Antal høje",
  "#low": "Antal lave",
  "aucBelow": "AUC Below limit",
  "aucAbove": "AUC Above limit",
  "bgRead": "BS-aflæsninger",
  "total": "Avg Daily Total",
  "avg_daily_basal": "Avg Daily Basal",
  "avg_daily_bolus": "Avg Daily Bolus",
  "ofBolus": "Avg # of bolus/Day",
  "avgBolus": "Avg bolus(U)/Each",
  "Dura1": "Varighed (min.)",
  "Avg/Total": "Gns./samlet",
  "high": "Høj",
  "low": "Lav",
  "#hypo": "Antal hypo",
  "ofExer": "Antal øvelser",

  "logbook": "Logbog",
  "dailyTotal": "Daglig Total",
  "High Glucose": "Høj Glukose",
  "Low Glucose": "Lav Glukose",
  "No Active Patch": "Ingen aktiv Patch",
  "Missed Meal": "Mistet måltid",
  "Multiple BG Readings": "Flere BS-aflæsninger",
  "Stop Patch": "Stop Patch",
  "Others": "Andre",
  "Other Events": "Andre Begivenheder",
  "logRe": "Logbogs Rapport",

  "DeviceSetting": "Gennemgang af PDM Indstillinger",
  "Insulin Pump": "Insulinpumpe",
  "MaxBasalRate": "Maksimal basaldosis",
  "BasalPatterns": "Basalmønstre",
  "Selected Basal Pattern": "Valgt basalmønster",
  "Maximum Bolus": "Maks. bolus",
  "Combo/Extended Bolus": "Kombi/Forlænget bolus",
  "BG Reminder": "BS-påmindelse:",
  "Bolus Increment": "Bolusforøgelse",
  "Bolus Calculator": "Bolusguide",
  "Active Insulin Time": "Aktiv insulintid",
  "IC Ratios": "Kulhydrat-forhold ",
  "Insulin Sensitivity": "Insulinfølsomhed",
  "BG Target": "BS-mål",
  "Bolus Reminder": "Boluspåmindelse",
  "CGM": "CGM",
  "CGM System": "CGM-system",
  "Glucose Unit": "Glukoseenhed",
  "Glucose Limits": "Glukosegrænser",
  "Predicitive Alerts": "Forventede advarsler",
  "Rate Alerts": "Hastighedsadvarsler",
  "type": "Type",
  "time": "Tid",
  "data": "Data",
  "Rate": "Rate",
  "Calibration Reminder": "Påmindelse om kalibrering",
  "Calibration Repeat": "Gentagelse af kalibrering",
  "Snooze": "Snooze",
  "Audio Options": "Lydindstillinger",
  "Confidence Reminder": "Anvendelsesfeedback",
  "Backlight": "Baggrundslys:",
  "Sec": "sek.",
  "Alarm Clock": "Alarmur",
  "Patch Expiration": "Patch-udløb",
  "Sensor Expiration": "Sensorudløb",
  "Hourly Max": "Maks. pr. time",
  "Daily Max": "Dagligt maks.",
  "Low Reservoir": "Reservoir lavt",
  "Low Suspend": "Stop ved lav",
  "Predictive Low Suspend": "Stop før Lav",
  "Rise": "Stigning",
  "Fall": "Fald",
  "Auto Off": "Auto-sluk",
  "Standard": "Standard",
  "Exercise": "Motion",
  "Holiday": "Ferie",
  "ProgramA": "Mønster A",
  "ProgramB": "Mønster B",
  "--": "--",
  "Insulin": "Insulin",

  "SUSA": "Auto fra",
  "SUSHM": "Overstiger maks. tilførsel pr. 1 time",
  "SUSDM": "Overstiger maks. TDD",
  "SUSLSG": "Stop ved lav",
  "SUSPLSG": "Stop før Lav",
  "Pump Restarted": "Pumpe genstartet",
  "Meter BG Now": "Mål BS nu",
  "Sensor Exp in 2 Hours": "Sensorudløb om 2 timer",
  "Sensor Exp in 6 Hours": "Sensorudløb om 6 timer",
  "Sensor Exp in 30 Min": "Sensorudløb om 30 min.",
  "Sensor Calibration Error": "Fejl i sensorkal.",
  "Sensor Error": "Ingen målinger",

  "Device Settings Report": "Rapport med Enheds Indstillinger",
  "24h Total": "Døgntotal",
  "Device Settings at": "Enheds Indstillinger",
  "Start": "Start",
  "Combo/Ext Bolus": "Kombi/Forlænget bolus",
  "Time Format": "Tidsformat",
  "Device Options（CGM System)": "Enhedsindstillinger (CGM-system)",
  "Device Options（Insulin Pump)": "Enhedsindstillinger (insulinpumpe)",
  "Dispay Settings (Screen)": "Visningsindstillinger (skærm)",
  "Dispay Settings (Backlight)": "Visningsindstillinger (baggrundslys)",
  "Graph Range": "Grafområde",
  "Range": "Range",
  "Repeat": "Gentag",
  "Glucose Alerts": "Glukoseadvarsler ",
  "Alert Silence": "Advarsel Lydløs",

  "Create": "Opret",
  "Event Filter": "Begivenhedsfilter",
  "HbA1c1": "HbA1c",
  "Urine Ketone": "Urinketon",
  "Injection": "Injektion",
  "Other": "Andet",
  "Event Type": "Begivenhedstype",
  "Details": "Info",
  "Notes": "Bemærkninger",
  "Source": "Kilde",
  "edit": "Rediger",
  "Action": "Handling",
  "EventReport": "Begivenheds Oversigts Rapport",
  "By Date": "Efter dato",
  "By Category": "Efter kategori",
  "Event Summary": "Begivenheds Oversigt",
  "No data": "Ingen data",
  "No1": "Nej",
  "data1": "data",
  "#": "#",
  "BG Summary": "BS-oversigt",
  "Carbs Summary": "Kulhydratoversigt",
  "Injection Summary": "Injektionsoversigt",
  "Exercise Summary": "Motionsoversigt",
  "Input Notes": "Indtast en bemærkning",

  "Profile": "Profil",
  "Complications": "Komplikationer",
  "Concomitant diseases": "Samtidige sygdomme",
  "Suggestion": "Suggestions",
  "Coronary heart disease": "Koronar hjertesygdom",
  "High blood lipids": "Forhøjede lipider i blodet",
  "High blood pressure": "Højt blodtryk",
  "Kidney disease": "Nyresygdom",
  "Neuropathy": "Neuropati",
  "Obesity": "Overvægt",
  "Peripheral arterial disease": "Perifer arteriesygdom",
  "Retinopathy": "Retinopati",
  "Smoking addiction": "Tobaksafhængighed",
  "Enter date": "Indtast dato",
  "Enter suggestion": "Indtast forslag",
  "Enter Notes": "Enter Notes",
  "Select": "Vælg",
  "Prescription": "Recept",
  "Medicine": "Medicin",
  "Dose": "Dosis",
  "Enter medicine": "Indtast medicin",
  "Enter dose": "Indtast dosis",
  "Enterdis": "Enter concomitant diseases",
  "Add note": "Tilføj bemærkning",
  "Add Content": "Maximum 1000 tegn.",
  "Other suggestions": "Andre forslag",
  "OK": "OK",
  "HCP": "Sundhedsperson",
  "Content": "Indhold",
  "Records Report": "Overbliks Rapport ",

  "Quick Print": "Hurtig udskrivning",
  "Quick Print Settings": "Indstillinger for hurtig udskrivning",
  "Select duration": "Vælg varighed: ",
  "One Week": "En uge",
  "One Month": "En måned",
  "One Quarter": "Et kvartal",
  "End date": "Slutdato:",
  "Yesterday": "I går",
  "Last Sunday": "Sidste søndag",
  "Last Saturday": "Sidste lørdag",
  "Last Day of Last Month": "Last Day of Last Month",
  "Last Day of Last Quarter": "Last Day of Last Quarter",
  "Customized": "Tilpas",
  "Week Filter": "Ugefilter",
  "Select reports to print": "Vælg rapporter, der skal udskrives",
  "Daily Summary": "Daglig Oversigt",
  "Day By Day Overview": "Oversigt dag for dag",
  "Sensor Overlay": "Sensoroverblik",
  "Trend Analysis": "Tendens Analyse",
  "Logbook": "Logbog",
  "Device Settings Review": "Gennemgang af Enheds indstillinger",
  "createReport": "Opret rapport",

  "Segment Analysis": "Segment Analyse",
  "Sensor Glucose Profile": "Sensorglucose Profil",
  "# of Boluses": "Antal bolusser",
  "Bolus Insulin": "Bolusinsulin ",
  "Basal Pattern": "Basalmønster ",
  "Segment Analysis Report": "Segment Analyse",
  "Avg Glucose": "Gns. glukose",
  "Below": "Under",
  "In Target Range": "Inden for målområde",
  "Coefficient of variation": "Variationskoefficient ",
  "% Time CGM Active": "% tid med aktiv CGM",
  "est_a1c_t1": "Anslået A1C",
  "est_a1c_t2": "beregnet ud fra SG-værdier",
  "est_a1c_t3": "Bemærk: Anslået A1C erstatter Ikke tilgængelig",

  "acceptTip": " har tilladt, at du følger vedkommendes sundhedsoplysninger. ",
  "cancelTip": " tillader ikke længere at du følger vedkommendes sundhedsoplysninger. Du kan om nødvendigt ansøge igen.",
  "rejectTip": " har afvist din ansøgning om at følge data.",
  "Read": "Læs",

  "Connection": "Forbindelse",
  "connections1": "Forbindelser",
  "Add Connection": "Tilføj forbindelse",
  "SG": "SG",
  "Active Insulin": "Aktivt insulin",
  "Stop following": "Stop med at følge",
  "Enter username (email)": "Indtast brugernavn (e-mail)",
  "Search results": "Søgeresultater",
  "Send request": "Send anmodning",
  "View graphs": "Vis grafer",
  "Agree": "Acceptér",
  "Deny": "Afvis",
  "Remove": "Fjern",
  "Cancel Requset": "Annuller anmodning",
  "Remark": "Bemærkning",

  "Warm up": "Opvarmning",
  "Monitoring": "Overvågning",
  "Transmitter Error": "Transmitterfejl",
  "Sensor Failure": "Sensorfejl",
  "Sensor Expired": "Sensor udløbet",
  "Lost Sensor": "Tabt sensor",
  "Not Calibrated": "Ikke kalibreret",
  "Calibrating": "Kalibrerer",
  "Calibration Needed": "Kalibrering nødvendig",
  "Calibration Error": "Kalibreringsfejl",
  "Charging Battery": "Oplader batteri",
  "Battery Charged": "Batteri opladet",

  "To be filled": "Skal fyldes",
  "Filled with insulin": "Fyldt med insulin",
  "Priming": "Priming",
  "Priming completed": "Priming er fuldført",
  "Inserting needle": "Isæt nål",
  "Patch activated": "Patch aktiveret",
  "Delivering Basal": "Tilfører basal",
  "Exceeds Max 1 Hour Delivery": "Overstiger maks. tilførsel pr. 1 time",
  "Exceeds Max TDD": "Overstiger maks. TDD",
  "Suspend": "Stop af tilførsel",
  "Occlusion Detected": "Okklusion registreret",
  "Patch Expired": "Patch udløbet",
  "Empty Reservoir": "Tomt reservoir",
  "Patch Error": "Patch-fejl",
  "Pump Base Error": "Pumpebase Fejl",
  "Patch Battery Depleted": "Patch-batteri afladet",
  "Magnetic sensor not calibrated": "Magnetisk sensor ikke kalibreret",

  "Patient Profile": "Patient Profil",

  "On": "Til",
  "on": "Start",
  "Off": "Fra",
  "off": "Til",

  "CORONARY_HEART_DISEASE": "Koronar hjertesygdom",
  "HIGH_BLOOD_LIPIDS": "Forhøjede lipider i blodet",
  "HIGH_BLOOD_PRESSURE": "Højt blodtryk",
  "KIDNEY_DISEASE": "Nyresygdom",
  "NEUROPATHY": "Neuropati",
  "OBESITY": "Overvægt",
  "PERIPHERAL_ARTERIAL_DISEASE": "Perifer arteriesygdom",
  "RETINOPATHY": "Retinopati",
  "SMOKING_ADDICTION": "Tobaksafhængighed",

  "saveTip": "Gemt korrekt.",
  "changePaTip": "Din adgangskode er blevet ændret.",
  "enterEmTip": "Indtast din e-mailadresse.",
  "verErrTip": "Bekræftelseskode er forkert.",
  "chooseEventTip": "Vælg begivenheder, der skal udskrives",
  "chooseDataTip": "Vælg data til print",
  "dateWrongTip": "Slutdatoen kan ikke ligge tidligere end startdatoen.",
  "infoWrongTip": "Udfyld alle obligatoriske felter.",
  "createdSuccssTip": "Oprettet med succes",
  "selectData": "Vælg data der skal gemmes",

  "acceSu": "Accpter anmodning",
  "acceEr": "Kunne ikke tilføje ny forbindelse",
  "rejeSu": "Afvist anmodning",
  "rejeEr": "Kunne ikke afvise anmodning",

  "userNotExist": "Brugernavn findes ikke.",
  "Password incorrect": "Forkert adgangskode.",
  "UserType incorrect": "Forkert Brugertype",

  "registSuccess": "Din Konto er oprettet med succes.",
  "registFailed": "Kunne ikke registrere en ny Konto.",
  "sentSuccess": "Meddelelse er sendt",
  "sentFailed": "Meddelelse blev ikke sendt",
  "Input error": "Input Fejl ",

  "deletePtip": "Er du sikker på, at du vil slette disse patienter?",
  "deleteEvents": "Er du sikker på, at du vil slette disse hændelser?",
  "deleteData": "Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",
  "deleteThis": "Er du sikker på, at du vil slette?",
  "confirm": "Bekræft",
  "deleteSuccess": "Slettet",
  "deleteFailed": "Element blev ikke slettet",
  "modifySuccess": "Ændret med succes",
  "modifyFailed": "Ændring mislykkedes",
  "createSuccess": "Oprettet med succes",
  "createFailed": "Kunne ikke oprette",
  "editSuccess": "Redigering gennemført",
  "editFailed": "Kunne ikke redigere",
  "Time overlapped": "Sessionerne du har valgt, overlapper hinanden.",

  "stopFollow": "Er du sikker på, at du ikke længere vil følge denne patient?",
  "CancelTip1": "Er du sikker på, at du vil slette denne forbindelse?",

  "Warning": "Advarsel",
  "agreeConnect": "Hvis du trykker \"enig\" accepteres anmodningen, og dine data bliver tilgængelige for den nye forbindelse.",
  "denyConnect": "Er du sikker på, at du vil afvise denne anmodning?",
  "deleteConnect": "Er du sikker på, at du vil slette denne forbindelse? Hvis den slettes, vil forbindelsen ikke kunne følge dine data mere.",

  "Choose the events to print": "Choose the events to print",
  "tryAgain": "Prøv igen",
  "username and password is required": "username and password is required",
  "A name is required": "A name is required",
  "username is required": "Username is required",
  "The date choose wrong": "Fejl i datovalg",
  "Date no more than 14 days": "Du kan ikke vælge mere end 14 dage.",

  "CancelTip": "Er du sikker på at du vil slette denne forbindelse?",
  "removeConnect": "Slettet",

  "dateErr1": "Du kan ikke vælge mere end 90 dage.",
  "dateErr2": "Slutdatoen kan ikke ligge tidligere end startdatoen.",

  "Not Filled": "Ikke angivet",
  "Today": "I dag",
  "duration": "Varighed",
  "interval": "Interval",
  "7 days": "7 dage",
  "14 days": "14 dage",
  "30 days": "30 dage",
  "90 days": "90 dage",
  "g": "g",

  "Sound+Vibrate": "Lyd + vibration",
  "Sound": "Lyd ",
  "Vibrate": "Vibration",
  "Silent": "Må ikke forstyrres",
  "1": "En enkelt gang",
  "2": "Dagligt",
  "noMes": "Der er ingen meddelelser.",
  "noConnect": "Der er ingen forbindelser.",
  "Customize": "Tilpas",
  "GB": "United Kingdom",
  "CN": "China",
  "FR": "France",
  "DD": "Germany",
  "DE": "Germany",
  "SE": "Sweden",
  "AU": "Australia",
  "HKF": "Hongkong",
  "HU": "Hungary",
  "IT": "Italy",
  "NL": "Netherlands",
  "Nor": "Norway",
  "PT": "Portugal",
  "ES": "Spain",
  "TR": "Turkey",

  "Jan": "Jan",
  "Feb": "Feb",
  "Mar": "Mar",
  "Apr": "Apr",
  "May": "May",
  "Jun": "Jun",
  "Jul": "Jul",
  "Aug": "Aug",
  "Sep": "Sep",
  "Oct": "Oct",
  "Nov": "Nov",
  "Dec": "Dec",
  "ApplyTip": " request to view your data.",
  "noReadings": "Ingen målinger",

  "daop_A6_system": "A6 Touchcare System",
  "daop_easytouch_easyview": "EasyTouch / EasyView iPad",
  "daop_TY012_TY015": "TY012/TY015",
  "daop_easysense": "EasySense",
  "daop_delete_data": "Slet Data",
  "daop_uploaded_data": "Overførte data",
  "daop_uploaded_data_text": "Dataene er fra EasyTouch-appen eller EasyView-appen til iPad.",
  "daop_realtime_data": "Realtidsdata",
  "daop_realtime_data_text": "The data is from EasySense App or EasyPatch App.",

  "ins_unit": "(IE) ",
  "ins_unit2": "IE",
  "basal_unit": "(IE/T) ",
  "basal_unit2": "IE/T",
  "dump_last": "Dump End",

  "Alerts_Patch_Battery_Low": "Patch-batteri lavt",
  "Alerts_Patch_Battery_Depleted": "Patch-batteri afladet",
  "Alerts_Lost_Pump": "Lost Pump",
  "Alerts_Low_Reservoir": "Reservoir lavt",
  "Alerts_Empty_Reservoir": "Tomt reservoir",
  "Alerts_Patch_Expiration_Advisory": "Meddelelse om udløb af patch",
  "Alerts_Patch_Exp_In_1_Hour": "Patch Exp In 1 Hour",
  "Alerts_Patch_Expired": "Patch udløbet",
  "Alerts_Patch_Error": "Patch-fejl",
  "Alerts_Pump_Base_Error": "Pumpebase Fejl",
  "Alerts_Basal_Rate_Key_Error": "Basal Rate Key Error",
  "Alerts_Occlusion_Detected": "Okklusion registreret",
  "Alerts_End_Of_Suspend": "End Of Suspend",
  "Alerts_Exceeds_Max_TDD": "Overstiger maks. TDD",
  "Alerts_Exceeds_Max_1Hr_Delivery": "Overstiger maks. tilførsel pr. 1 time",

  "Alerts_Predictive_Low_Suspend": "Stop før Lav",
  "Alerts_Low_Suspend": "Stop ved Lav",
  "Alerts_Auto_Off": "Auto-sluk",

  "Alerts_Pump_Restart": "Pump Restart",
  "Alerts_Auto_Off_Warning": "Auto Off Warning",
  "Alerts_Pump_Out_Of_Range": "Udenfor rækkevidde",

  "Alerts_Lost_Sensor": "Tabt sensor",
  "Alerts_Transmitter_Battery_Low": "Transmitterbatteri lavt",
  "Alerts_Charge_Transmitter": "Oplad transmitter",
  "Alerts_Sensor_Error": "Ingen målinger",
  "Alerts_Transmitter_Error": "Transmitterfejl",
  "Alerts_Sensor_Calibration_Error": "Sensor Calibration Error",

  "Alerts_Sensor_Failure": "Sensorfejl",
  "Alerts_Sensor_Calibration_Reminder": "Sensor Calibration Reminder",
  "Alerts_Meter_BG_Now": "Mål BS nu",
  "Alerts_Sensor_Exp_in_6_Hours": "Sensorudløb om 6 timer",
  "Alerts_Sensor_Exp_in_2_Hours": "Sensorudløb om 2 timer",
  "Alerts_Sensor_Exp_in_30_Min": "Sensorudløb om 30 min.",
  "Alerts_Sensor_Expired": "Sensor udløbet",
  "Alerts_Rapid_Rise": "Hurt. stig",
  "Alerts_Rapid_Fall": "Hurt. fald",
  "Alerts_High_Predicted": "Høj forventet",
  "Alerts_Low_Predicted": "Lav forventet",
  "Alerts_High_Glucose": "Høj glukose",
  "Alerts_Low_Glucose": "Lav glukose",
  "Alerts_Below_3.1_mmol/L": "Under 3,1 mmol/l",
  "Alerts_Transmitter_Battery_Low_2": "Transmitterbatteri lavt",

  "Alerts_PDM_Battery_Low": "PDM-batteri lavt",
  "Alerts_Replace_Battery": "Oplad PDM Nu",

  "Alert": "Alert",
  "Alerts": "Advarsler",
  "Alert Filter": "Alert Filter",
  "PDM": "PDM",
  "Pump": "Pumpe",

  "Out Of Range": "Out Of Range",
  "t1221_Time_in_Auto_Mode": "Tid i Auto Tilstand",
  "t1221_Average_SG_SD": "Gennemsnit SG ± SD",
  "t1221_Time_in_Target_Range": "Tid i Målområde",
  "t1221_Time_above_Range": "Tid over Målområde",
  "t1221_Time_below_Range": "Tid under Målområde",
  "t1221_Auto_Basal_per_day": "Auto Basal (pr dag)",
  "t1221_Auto_Bolus_per_day": "Auto Bolus (pr dag)",
  "t1221_Auto_Mode_Exits": "Auto Tilstand Afsluttet",
  "t1221_No_Sensor_readings": "Ingen Sensoraflæsninger",
  "t1221_Max_Delivery": "Max. Tilførsel",
  "t1221_Min_Delivery": "Min. Tilførsel",
  "t1222_autoModeBasal": "Auto Tilstand Basal",
  "t1222_autoModeCorrBolus": "Auto Tilstand Korrek. Bolus",
  "t1222_autoSnack": "Auto Snack",
  "t1222_autoBreakfast": "Auto Morgen",
  "t1222_autoLunch": "Auto Frokost",
  "t1222_autoDinner": "Auto Middag",
  "t1222_autoExercise": "Auto Træning",
  "t1222_Snack": "Snack",
  "t1222_Auto_Mode": "Auto Tilstand",
  "t1222_Time_in_Auto_Mode": "Tid i Auto Tilstand (%)",
  "t1222_Avg_SD": "Gns(mmol/L)±SD",
  "t1222_Target_Range": "Målområde (%)",
  "t1222_Above_Range": "Over Målområde (%)",
  "t1222_Below_Range": "Under Målområde (%)",
  "t1222_Auto_Mode_Exits": "# af Auto Tilstand Afsluttet",
  "t1221_Auto_Mode": "Auto Tilstand",
  "t1222_auto_basal": "Auto Basal",
  "t1222_auto_bolus": "Auto Bolus",
  "t0805_User_Management": "Bruger Liste",
  "t0805_Patient_Management": "Patient Liste",
  "t0805_Operation_History": "Hændelses Historik",
  "t0805_User_List": "Brugerliste",
  "t0805_User": "Bruger",
  "t0805_Time": "Tid",
  "t0805_Operation_Type": "Operation Type",
  "t0805_Back": "Tilbage",
  "t0805_Add": "Tilføje",
  "t0805_Delete": "Slet",
  "t0809_Add_User": "Tilføj bruger",
  "t1028_Pattern_C": "Mønster C",
  "t1028_Pattern_D": "Mønster D",
  "t1029_Auto_meal_bolus": "Auto Måltid Bolus",
  "t1029_Auto_mode_correction_bolus": "Auto Tilstand Korrektions Bolus",
  "t1029_Sick": "Syg",
  "t1029_Auto_Mode_Feature": "Auto tilstand funkt.",
  "t1029_Target_SG": "SG Mål",
  "t1029_Auto_Meal_Handling": "Auto Måltid Behandling",
  "t1029_Total_Daily_Dose": "Total Daglig Dosis",
  "t1029_Pump_Light": "Pumpe Lys",
  "t1029_Alerts_for_Hypo": "Advarsel for Hypo",
  "t1102_Out_of_Range": "Udenfor rækkevidde",
  "t1102_Command_Reminder": "Kommando Påmindelse",
  "t1102_Alarms_Alerts_on_APP": "Alarmer & Advarsler på App",
  "t1102_Alarms_on_App": "Alarmer på App",
  "t1102_Alerts_on_App": "Advarsler på App",
  "t1102_Factory_Calibration": "Fabrik Kalibrering",
  "t1102_Alerts_for_Low": "Advarsler for Lav",
  "t1102_Alerts_for_High": "Advarsler for Høj",
  "t1102_Alerts_for_Others": "Advarsler for Andet",
  "t1102_Adjustment": "Justering",
  "t1102_Suggested": "Foreslag",
  "t1103_Glucose": "Glukose",
  "t1103_CGM": "CGM",
  "t1103_Insulin": "Insulin",
  "t1103_Carbs": "Kulhydrater",
  "t1103_Exercise": "Motion",
  "t1103_Min_Max": "Min/Max",
  "t1103_Target_Range": "Målområde",
  "t1103_Overall_Tine_In_Range": "Samlet: Tid i målområde",
  "t1103_Basal": "Basal",
  "t1103_Bolus": "Bolus",
  "t1103_Basal_Bolus": "Basal & Bolus",
  "t1103_Auto_Mode_Time_In_Range": "Auto Tilstand: Tid i målområde",
  "t1103_Time_below_range": "Tid under målområde",
  "t1103_Time_above_range": "Tid over målområde",
  "t1103_Time_in_target_range": "Tid i målområde",
  "t1103_Incorrect_Password": "Forkert adgangskode, $1 Forsøg tilbage, indtast venligst den korrekte adgangskode.",
  "t1103_Incorrect_locked": "Mislykkede forsøg overskrider grænsen, kontoen er blevet låst. Prøv venligst igen om $1 minutter.",
  "t1104_The_data_is_from": "Dataene er fra EasySense App eller EasyPatch App.",
  "t1104_Privacy_Policy": "Politik om databeskyttelse og vilkår for brug",
  "t1104_updated_privacy_policy": "Vi har opdateret vores politik om databeskyttelse og vilkår for brug . For at kunne fortsætte med at bruge Easyview, bedes du læse og acceptere alle vilkårene.",
  "t1104_Disagree": "Uenig",
  "t1104_Agree": "Acceptér",
  "t1105_Upload_History": "Overførsels Historik",
  "t1105_Delete_Data": "Slet data",
  "t1105_Target_Range": "Måleområde",
  "t1105_request_to_view_your_data": "$1 anmodning om at se dine data.",
  "t1105_Recent_Updates": "Seneste opdateringer",
  "t1108_No_data": "Ingen data",
  "t1108_Pump_Bash_SN": "Pumpebases SN",
  "t1108_Transmitter_SN": "Transmitters SN",
  "t1112_Normal_Glucose": "Normal Glukose",
  "t1112_Manual_Bolus_or_Modified_Bolus": "Manuel bolus eller ændret bolus",
  "t1112_Auto_Mode_Started": "Auto Tilstand Startet",
  "t1112_Auto_Mode_Exit": "Afslut Auto Tilstand",
  "t1112_Normal_Bolus": "Normal Bolus",
  "t1112_Extended_Bolus": "Forlænget Bolus",
  "t1112_Combo_Bolus": "Kombi. bolus",
  "t1112_Carbs": "Kulhydrater",
  "t1112_Glucose": "Glukose",
  "t1112_BG": "BS",
  "t1112_Audio": "Lyd",
  "t1112_Tone": "Tone",
  "t1112_Audio_Options": "Lyd Indstillinger",
  "t1112_Weight_Unit": "Vægtenhed",
  "t1112_Height_Unit": "Højdeenhed",
  "t1112_Not_available": "Ikke Tilgængelig",
  "t1112_Number": "Nummer",
  "t1112_days": "# dage",
  "t1112_min": "min.",
  "t1113_days": "dage",
  "t1215_Security": "Sikkerhed",
  "t1215_MFA": "Multi-faktor autentificering (MFA)",
  "t1215_Enter_verification_code": "Indsæt verifikations kode",
  "t1215_Multi_factor_ON": "Multifaktorgodkendelse er TIL. Bekræftelseskoden er blevet sendt til $1 Indsend venligst bekræftelseskode.",
  "t1215_Verification_code_incorrect": "Bekræftelseskode er forkert",
  "t1215_Show_Glucose_Value": "Vis glukoseværdi",
  "t1221_enter_verification_code": "Indtast venligst den 6-cifrede bekræftelseskode sendt til $1.",
  "t1221_Verification_Success": "Bekræftet med succes",
  "t1222_We_will_only_process": "Vi behandler kun dine Sundhedsdata via Medtrums app/websted med dit samtykke. ",
  "t1222_If_you_are_under_years": "Hvis du er under 16 år, skal du have tilladelse fra en forælder eller værge til at registrere dig i denne app.",
  "t1221_register_cn": "Du har ret til ikke at overføre nogen enhedsdata til appen, og i så fald vil dataene ikke være tilgængelige for andre. Hvis du vælger ikke at registrere dig i Medtrums app/websted, er den eneste fortegnelse over dine sundhedsdata på selve enheden. ",
  "t1221_register_eu": "Hvis du vælger at registrere din Medtrum-konto og få adgang til vores app ved hjælp af kontoen, vil de sundhedsdata, der er registreret i appen, blive overført til vores server i Europa og opbevaret i 2 år. Du har ret til ikke at overføre nogen enhedsdata til appen, og i så fald vil dataene ikke være tilgængelige for andre. Hvis du vælger ikke at registrere dig i Medtrums app/websted, er den eneste fortegnelse over dine sundhedsdata på selve enheden.",
  "t1221_register_follow": "Vi behandler kun dine sundhedsdata via Medtrums app/websted med dit samtykke.",
  "t1222_Terms_of_Use": "Medtrums vilkår for brug",
  "t1222_Privacy_Policy": "Medtrums politik om databeskyttelse",
  "t1222_Create_Account": "Opret konto",
  "t1222_Back": "Tilbage",
  "t1222_Verify_your_account": "Bekræft din konto",
  "t1222_please_check_your_account": "Vi sender en bekræftelseskode til $1, Tjek venligst din konto.",
  "t1222_I_Agree_to": "Jeg accepterer $1",
  "t1223_Invalid_Verification_Code": "Ugyldig bekræftelseskode. Prøv igen."
};

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return duMessages; });
var duMessages = {
  "privacy_policy_and_terms_of_use": "Privacy Policy and Terms of Use ",
  "privacy_confirm_text": "We've updated our <a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>Privacy Policy</a> and <a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>Terms of Use</a>. To continue using EasyView, you need to read and agree to all the terms.",
  "privacy_confirm_disagree": "Disagree",
  "privacy_confirm_accept": "Accept",

  "title": "EasyView Personal",
  "title1": "EasyView Pro",
  "user": "E-mail",
  "password": "Wachtwoord",
  "remember": "Onthoud mij",
  "forget": "Wachtwoord vergeten?",
  "sign in": "Inloggen",
  "login": "Login",
  "sign up now": "Nu registreren",
  "apply": "Nu aanvragen",
  "contact us": "Neem contact met ons op",
  "Privacy Policy": "Privacybeleid",
  "Terms of Use": "Gebruiksvoorwaarden",
  "copyright": "Copyright © 2021 Medtrum Technologies Inc. Alle rechten voorbehouden.",

  "chooseLang": "Kies uw land of taal",
  "asia": "Azië",
  "europe": "Europa",

  "applyHcp": "Vraag een zorgverlenersaccount aan",
  "sign up": "Registreren",
  "Patient": "Patiënt",
  "Caregiver": "Zorgverlener",
  "Email": "E-mail",
  "Mobile": "Mobiel",
  "Enter email": "Vul e-mailadres in",
  "Enter mobile": "Vul mobiel nummer in",
  "Verification": "Verificatiecode",
  "Invitation": "Invitation code",
  "full name": "Vul uw volledige naam in",
  "Enter pass": "Vul wachtwoord in",
  "org": "Organisatie",
  "Register": "Register",
  "send": "Verzenden",
  "agree": "Ik heb het privacybeleid en de ",
  "privacy": " servicevoor waarden van Medtrum gelezen  ",
  "and": "en ga ",
  "use": "hiermee akkoord.",
  "errtip1-1": "U dient een geldig e-mailadres in te vullen,",
  "errtip1-2": "dit wordt uw gebruikersnaam voor Medtrum.",
  "errtip2": "Please enter a valid mobile number.",
  "errtip3": "Verificatiecode onjuist",
  "errtip4": "Incorrect invitation code.",
  "errtip5": "Gebruikersnaam onjuist",
  "errtip6": "Your password must have 8 or more characters.",
  "errtip7": "Vul uw organisatie in a.u.b.",

  "errp1": "Wachtwoord moet tenminste 3 van de volgende soorten tekens bevatten:",
  "errp2": "hoofdletter, kleine letter, nummer en speciaal teken. ",
  "errp3": "Wachtwoord moet tussen de 6 en 20 tekens lang zijn.",
  "errp4": "Wachtwoord moet anders zijn dan gebruikersnaam.",
  "errp5": "Wachtwoord met 3 opeenvolgende nummers is ongeldig (bv. 123, 321). ",
  "errp6": "Wachtwoord met 3 opeenvolgende letters is ongeldig (bv. abc, cba).",
  "errp7": "Wachtwoord mag geen spaties bevatten.",

  "Find account": "Herstel uw wachtwoord.",
  "Enter username": "Vul uw gebruikersnaam in a.u.b.",
  "Next": "Volgende",
  "Cancel": "Annuleren",
  "Back": "Terug",
  "Enter veri": "Verificatiecode",
  "Verify notice": "Zoek de verificatiecode op die is verzonden in een e-mail.",
  "Create new": "Een nieuwe wachtwoord aanmaken",
  "Create new notice": "Maak een nieuw wachtwoord aan a.u.b., deze dient te bestaan uit 6 of meer tekens.",
  "New pass": "Nieuw wachtwoord",
  "Completed": "Voltooid",
  "Created": "Nieuw wachtwoord aangemaakt.",
  "Login Now": "Nu aanmelden",

  "Delete": "Verwijderen",
  "New Patient": "Nieuwe patiënt",
  "Add Patient": "Patiënt toevoegen",
  "Filter": "Filter",
  "Name": "Naam",
  "Gender": "Geslacht",
  "Age": "Leeftijd",
  "Type": "Type",
  "Duration": "Duur",
  "Connections": "Aanmaker van account",
  "UploadTime": "Uploadtijd",
  "Year": "jaar ",
  "Years": "Jaar",
  "Month": "maand",
  "Month2": "Maand",
  "Months": "maand",
  "Invite": "Uitnodigen",
  "Invited": "Uitgenodigd",
  "All": "Alle",
  "Female": "Vrouw",
  "Male": "Man",
  "Not Set": "Ongespecificeerd",
  "Type 1": "Type 1",
  "Type 2": "Type 2",
  "Gestational": "Zwangerschaps-",
  "Prediabetes": "Prediabetes",
  "LADA": "Type 1.5 LADA",
  "Apply": "Toepassen",
  "disUn": "Diabetestype ongespecificeerd",
  "ageUn": "Leeftijd ongespecificeerd",
  "genUn": "Geslacht ongespecificeerd",
  "addP": "Patiënt toevoegen",
  "newP": "Nieuwe patiënt",
  "findP": "Patiënt zoeken",

  "GDRNF": "Ongespecificeerd",
  "GDRF": "Vrouw",
  "GDRM": "Man",
  "女": "Man",

  "DBTNF": "Ongespecificeerd",
  "DBT1": "Type 1",
  "DBT2": "Type 2",
  "DBTLADA": "Type 1.5 LADA",
  "DBTPRE": "Prediabetes",
  "DBTGEST": "Zwangerschaps-",
  "前期": "beFore",
  "beFore": "beFore",
  "MODY": "Mody",

  "No selection": "Ongespecificeerd",
  "unspecif": "Ongespecificeerd",
  "register": "Patiënt",
  "hcp": "Arts",

  "BG": "BG",
  "CARB": "Koolhydraten",
  "INS": "Injectie",
  "EXR": "Inspanning",
  "OTR": "Anders",
  "HBA1C": "HbA1c",
  "DOSE": "Dosis",
  "URINEK": "Ketonen in urine",
  "HEL": "HEL",
  "OTR1": "Anders",
  "Loading": "Aan het laden",

  "home": "Start",
  "pID": "Patiënt-ID",
  "fullName": "Volledige naam",
  "gender": "Geslacht",
  "height": "Lengte",
  "weight": "Gewicht",
  "cm": "cm",
  "kg": "kg",
  "birthday": "Geboortedatum",
  "disType": "Diabetestype",
  "disDate": "Diagnosedatum",
  "Address": "Adres",
  "Postcode": "Postcode",
  "Inpatient": "Intramuraal",
  "Yes": "Ja",
  "No": "Nee",
  "Pno": "Patiëntnr.",
  "Bno": "Bednr.",
  "create": "Aanmaken",
  "Telephone": "Telefoon",

  "enterU": "Vul gebruikersnaam in (e-mail)",
  "search": "Zoeken",
  "noU": "Gebruikersnaam is verplicht.",
  "searchR": "Zoekresultaten",
  "uername": "Gebruikersnaam",
  "alias": "Bijnaam",
  "remove": "Verwijderen",
  "viewG": "Grafieken bekijken",
  "sendR": "Verzend verzoek",
  "rSent": "Uw verzoek is verzonden.",
  "cancelR": "Verzoek annuleren",

  "VcodeTip1": "Niet ontvangen? Wacht a.u.b. een minuut en ",
  "VcodeTip2": "probeer het opnieuw.",
  "VcodeTip3": "We hebben net een verificatiecode verstuurd naar ",
  "Entercode": "Vul code in",
  "Getcode": "Verstuur code",

  "messages": "Berichten",
  "profile": "Profiel",
  "sign out": "Afmelden",
  "changeP": "Wachtwoord wijzigen",
  "connection": "Connections",

  "myP": "Mijn profiel",
  "Portrait": "Profielfoto",
  "Profession": "Beroep",
  "DPRONF": "Ongespecificeerd",
  "DPROENDOCRIN": "Endocrinoloog",
  "DPRODIABTRA": "Diabetesverpleegkundige",
  "DPRONURSE": "Verpleegkundige",
  "DPRODIATIT": "Diëtist",
  "DPROOTR": "Andere zorgverleners",
  "Organization": "Organisatie",
  "Bio": "Bio",
  "save": "Opslaan",
  "oldPa": "Oude wachtwoord",
  "newPa": "Nieuwe wachtwoord",
  "RePa": "Vul wachtwoord opnieuw in",
  "forgetY": "Uw wachtwoord vergeten?",
  "applyM": "Toepassen",
  "oldErr": "Het oude wachtwoord is onjuist.",
  "EntTheSame": "Vul het nieuwe wachtwoord opnieuw in.",
  "EnterOld": "Vul het oude wachtwoord in.",

  "pList": "Patiëntenlijst",
  "connections": "Connecties",
  "settings": "Instellingen",
  "monitor": "Controleren",
  "graphs": "Verslagen",
  "events": "Gebeurtenissen",
  "records": "Archief",
  "qPrint": "Snel afdrukken",

  "sensorIn": "Sensorinfo",
  "timeOfLaRead": "Tijd van laatste sensorlezing ",
  "tranSn": "SN van de zender ",
  "status": "Status ",
  "sensorLife": "Resterende levensduur van de sensor ",
  "lastSenorRead": "Laatste sensorlezing",
  "TranBattery": "Zenderbatterij",
  "sg": "SG",
  "alert": "Waarschuwing",
  "target": "Doel",
  "hypo": "Hypo",
  "sensorGlucose": "Sensorglucose",
  "calib": "Kalibratie",
  "newSen": "Nieuwe Sensor",
  "warm": "Opwarmen",
  "InsulinPump": "Insulinepomp",
  "timeOfLaPump": "Tijdstip van laatste pompgegevens ",
  "pumpSN": "SN van de pomp",
  "ReserviorLife": "Resterende levensduur van het reservoir ",
  "InsulinLeft": "Resterende insuline ",
  "basal": "Basaal",
  "bolus": "Bolus",
  "totalBasal": "Totale dagelijkse basaal",
  "lastBolus": "Laatste bolus",
  "activeInsulin": "Actieve insuline",
  "totalBolus": "Totale dagelijkse bolus ",
  "tampBasal": "Tijd. Basaal",
  "normalBolus": "Normale Bolus",
  "extendBolus": "Verlengde Bolus",
  "manualStop": "Handmatige Onderbreking",
  "autoStop": "Automatische Onderbreking",
  "auto suspend": "Automatische Onderbreking",
  "stop": "Toedieningsstop",
  "newPatch": "Nieuw Reservoir",
  "tempBasal": "Tijd. Basaal",
  "N": "N",
  "E": "V",
  "CN1": "GN",
  "CE": "GV",

  "staticSettings": "Verslaginstellingen",
  "dataSource": "Gegevensbron",
  "unit": "Eenheid ",
  "glucoseTarget": "Glucosestreefniveau",
  "overall": "Algemeen",
  "Hypoglycemia": "Hypoglykemie",
  "timePeriod": "Tijdsperiode",
  "postMeal": "Post-maaltijdanalyse",
  "Breakfast": "Ontbijt",
  "Lunch": "Lunch",
  "Dinner": "Diner",
  "night": " 's Nachts",
  "Before": "Voor",
  "After": "Na",
  "Low": "Laag",
  "High": "Hoog",
  "From": "Van",
  "To": "Tot",
  "Hours": "uren",
  "Reset": "Herstel fabrieksinstellingen",
  "RealTime": "Real-time",
  "uploaded": "Bijgewerkt",
  "sensor": "Sensor",
  "pdmSN": "SN van de PDM",
  "startTime": "Begintijd",
  "endTime": "Eindtijd",
  "uploadTime": "Uploadtijd",
  "pdm": "PDM",
  "Uploaded": "Bijgewerkt",
  "Patch Pump": "PDM",
  "overLapp": "Sessies overlapten",
  "showAlert": "Toon meldingen",

  "dashboard": "Dashboard",
  "dboard_glucose_statistics": "Statistieken",
  "dboard_glucose": "Glucose",
  "dboard_cgm": "CGM",
  "dboard_insulin": "Insuline",
  "dboard_carbs": "Koolhydraten",
  "dboard_exercise": "Inspanning",
  "dboard_glucose_avg": "Gemiddelde",
  "dboard_cgm_avg": "Gemiddelde",
  "dboard_insulin_avg": "Gemiddelde dagelijkse dosis",
  "dboard_carbs_avg": "Gemiddelde koolhydraten/dag",
  "dboard_exercise_avg": "Gemiddelde tijd/dag",
  "dboard_sd": "SD",
  "dboard_num": "#",
  "dboard_num_days": "# days",
  "dboard_statistics": "Statistieken",
  "dboard_BG": "BG",
  "dboard_BG_calibration": "BG/kalibratie (per dag)",
  "dboard_SG": "SG",
  "dboard_AUC_high": "AUC hoog >",
  "dboard_AUC_low": "AUC laag <",
  "dboard_highest_value": "Hoogste waarde",
  "dboard_lowest_value": "Laagste waarde",

  "dboard_pump": "Pomp",
  "dboard_avg_daily_dose": "Gemiddelde dagelijkse dosis",
  "dboard_SD": "SD",
  "dboard_daily_basal": "Dagelijkse basaal",
  "dboard_daily_bolus": "Dagelijkse bolus",
  "dboard_avg_bolus_num": "Gemiddeld aantal bolussen per dag",
  "dboard_avg_suspend_time": "Gemiddelde onderbrekingstijd",
  "dboard_avg_reservoir_usage": "Gemiddeld reservoirgebruik",
  "dboard_days": "days",

  "dboard_manual_bolus": "Handmatige bolus (volume/aantal per dag)",
  "dboard_normal": " -Normaal",
  "dboard_extend": " -Verlengd",
  "dboard_combo": " -Gecombineerd",

  "dboard_bolus_calculator": "Boluscalculator (volume/aantal per dag)",
  "dboard_food_bolus": " -Maaltijdboluscalc.",
  "dboard_corr_bolus": " -Correctieboluscalc.",
  "dboard_override_add": " -Overschrijding(+)",
  "dboard_override_sub": " -Overschrijding(-)",

  "dboard_report": "Dashboard aanmaken",

  "daily": "Dagelijks Overzicht",
  "date": "Datum",
  "print": "Afdrukken",
  "carbs": "Koolhydraten",
  "exercise": "Inspanning",
  "heavy": "Zwaar",
  "Medium": "Medium",
  "Light": "Licht",
  "dailyReport": "Dagelijks Overzichtsverslag",
  "devices": "Apparaten",
  "tran": "Zender",
  "pumpBase": "Pomp",
  "HbA1c": "HbA1c",
  "statics": "Statistieken",
  "glucose": "Glucose",
  "item": "Item",
  "BG1": "BG",
  "SG1": "SG",
  "avgSD": "Gem (mmol/L)±SD",
  "avgSD1": "Gem±SD",
  "min": "Min",
  "max": "Max",
  "ofRead": "Aantal lezingen",
  "ofHypo": "Aantal hypo's/duur(min)",
  "ofAlert": "Aantal waarschuwingen",
  "insulin": "Insuline",
  "insulin2": "Insuline",
  "totalDose": "Totale dagelijkse dosis",
  "foodBolus": "Maaltijdbolus",
  "Food+coor": "Food+corr",
  "calibBolus": "Correctiebolus",
  "durationStop": "Duur van onderbreking (min)",
  "ofPumpAlert": "Aantal pompalarmen",
  "ofMeal": "Aantal maaltijden",
  "totalExerTime": "Totale inspanningstijd",
  "exerNum": "Aantal inspanningen",
  "avgInten": "Gem Intensiteit",
  "target1": "Doel",
  "high1": "Hoog ",
  "low1": "Laag",
  "BG Reading": "BG-lezingen",

  "dayByday": "Overzicht per dag",
  "dayBydayRe": "Dagelijks Overzichtsverslag",
  "period": "Periode",

  "sensorOverlay": "Sensor Overzicht",
  "set": "Instellen",
  "setPeriod": "Stel periode in",
  "Weekdays": "Doordeweeks",
  "Weekends": "Weekends",
  "Mon": "Ma",
  "Tue": "Di ",
  "Wed": "Wo",
  "Thur": "Do",
  "Thu": "Do",
  "Fri": "Vr",
  "Sat": "Za",
  "Sun": "Zo",
  "Average": "Gemiddeld",
  "sensorOlRe": "Overzichtsverslag Sensor",
  "Avg": "Gem",
  "±SD": "±SD",
  "ofhypo": "Aantal Hypo's",
  "Everyday": "dagelijks",

  "TrendAna": "Trendanalyse",
  "TrendRe": "Trendanalyse-verslag",
  "sensorGlu": "Sensorglucose ",
  "ofBGtest": "Aantal BG-testen",
  "Basics": "Basis",
  "static": "Statistieken",
  "Med": "Med",
  "med": "Med",
  "Q1": "Q1",
  "Q3": "Q3",
  "Q11": "Q1",
  "Q31": "Q3",
  "IQR": "IQR",
  "SD": "SD",
  "CV": "CV",
  "SE1": "SEM",
  "distri": "Spreiding",
  "stab": "Stabiliteit",
  "#high": "Aantal hoge",
  "#low": "Aantal lage",
  "aucBelow": "AUC onder de grens",
  "aucAbove": "AUC boven de grens",
  "bgRead": "BG-lezingen",
  "total": "Totaal",
  "ofBolus": "Aantal bolussen",
  "avgBolus": "Gem. bolu",
  "Dura1": "Duur (min)",
  "Avg/Total": "Gem/Totaal",
  "high": "Hoog",
  "low": "Laag",
  "#hypo": "Aantal Hypo's",
  "ofExer": "Aantal inspanningen",

  "logbook": "Logboek",
  "dailyTotal": "Dagelijks Totaal",
  "High Glucose": "Hoge Glucose",
  "Low Glucose": "Lage Glucose",
  "No Active Patch": "Geen Actief Reservoir",
  "Missed Meal": "Gemiste Maaltijd",
  "Multiple BG Readings": "Meerdere BG-lezingen",
  "Stop Patch": "Reservoir Stoppen",
  "Others": "Anders",
  "Other Events": "Andere gebeurtenissen",
  "logRe": "Logboekverslag",

  "DeviceSetting": "Inspectie Apparaatinstellingen",
  "Insulin Pump": "Insulinepomp",
  "MaxBasalRate": "Maximale Basaalsnelheid",
  "BasalPatterns": "Basaalschema's",
  "Selected Basal Pattern": "Geselecteerde Basaalschema",
  "Maximum Bolus": "Maximale Bolus",
  "Combo/Extended Bolus": "Gecombineerde/Verlengde Bolus",
  "BG Reminder": "BG-herinnering",
  "Bolus Increment": "Stapgrootte van de Bolus",
  "Bolus Calculator": "Boluscalculator",
  "Active Insulin Time": "Actieve Insulinetijd",
  "IC Ratios": "I:KH Ratio's",
  "Insulin Sensitivity": "Insulinegevoeligheid",
  "BG Target": "BG-doel",
  "Bolus Reminder": "Bolusherinnering",
  "CGM": "CGM",
  "CGM System": "CGM-systeem",
  "Glucose Unit": "Glucose-eenheid",
  "Glucose Limits": "Glucoselimieten",
  "Predicitive Alerts": "Voorspelde Waarschuwingen",
  "Rate Alerts": "Snelheidswaarschuwingen",
  "type": "Type",
  "time": "Tijd",
  "data": "Gegevens",
  "Rate": "Rate",
  "Calibration Reminder": "Kalibratieherinnering",
  "Calibration Repeat": "Kalibratieherhaling",
  "Snooze": "Sluimerfunctie",
  "Audio Options": "Geluidsopties",
  "Confidence Reminder": "Herinnering",
  "Backlight": "Schermverlichting",
  "Sec": "sec",
  "Alarm Clock": "Wekker",
  "Patch Expiration": "Vervaldatum Reservoir",
  "Sensor Expiration": "Vervaldatum Sensor",
  "Hourly Max": "Max per Uur",
  "Daily Max": "Dagelijkse Max",
  "Low Reservoir": "Reservoir bijna leeg",
  "Low Suspend": "Lage Stopwaarde",
  "Predictive Low Suspend": "Voorspelde Lage Stopwaarde",
  "Rise": "Stijgen",
  "Fall": "Dalen",
  "Auto Off": "Auto Uit",
  "Standard": "Standaard",
  "Exercise": "Exercise",
  "Holiday": "Vakantie",
  "ProgramA": "Schema A",
  "ProgramB": "Schema B",
  "--": "--",
  "Insulin": "Insulin",

  "SUSA": "Auto Uit",
  "SUSHM": "Max. dosis per uur overschreden",
  "SUSDM": "Max. dagelijkse dosis overschreden",
  "SUSLSG": "Lage Stopwaarde",
  "SUSPLSG": "Voorspelde Lage Stopwaarde",
  "Pump Restarted": "Pomp herstart",
  "Meter BG Now": "BG direct meten",
  "Sensor Exp in 2 Hours": "Sensor vervalt binnen 2 uur",
  "Sensor Exp in 6 Hours": "Sensor vervalt binnen 6 uur",
  "Sensor Exp in 30 Min": "Sensor vervalt binnen 30 min",
  "Sensor Calibration Error": "Sensor-kal. Fout",
  "Sensor Error": "Geen metingen",

  "Device Settings Report": "Apparaatinstellingen Verslag",
  "24h Total": "24-uurs Totaal",
  "Device Settings at": "Apparaatinstellingen op",
  "Start": "Begin",
  "Combo/Ext Bolus": "Gecom./Verl. Bolus ",
  "Time Format": "Tijdnotatie",
  "Device Options（CGM System)": "Apparaatopties (CGM-systeem)",
  "Device Options（Insulin Pump)": "Apparaatopties (Insulinepomp)",
  "Dispay Settings (Screen)": "Weergave-instellingen (scherm) ",
  "Dispay Settings (Backlight)": "Weergave-instellingen (schermverlichting)",
  "Graph Range": "Grafiekbereik",
  "Range": "Range",
  "Repeat": "Herhalen",
  "Glucose Alerts": "Glucose-waarschuwingen",
  "Alert Silence": "Waarschuwingen dempen",

  "Create": "Aanmaken",
  "Event Filter": "Gebeurtenissenfilter",
  "HbA1c1": "HbA1c",
  "Urine Ketone": "Ketonen in urine",
  "Injection": "Injectie",
  "Other": "Anders",
  "Event Type": "Gebeurtenistype",
  "Details": "Details",
  "Notes": "Opmerkingen",
  "Source": "Bron",
  "edit": "Bewerken",
  "Action": "Actie",
  "EventReport": "Overzichtsverslag Gebeurtenissen",
  "By Date": "Op Datum",
  "By Category": "Op Categorie",
  "Event Summary": "Samenvatting Gebeurtenissen",
  "No data": "Geen gegevens",
  "No1": "Geen",
  "data1": "gegevens",
  "#": "#",
  "BG Summary": "Samenvatting BG",
  "Carbs Summary": "Samenvatting Koolhydraten",
  "Injection Summary": "Samenvatting Injecties",
  "Exercise Summary": "Samenvatting Inspanning",
  "Input Notes": "Opmerking invoeren",

  "Profile": "Profiel",
  "Complications": "Complicaties",
  "Concomitant diseases": "Bijkomende aandoeningen",
  "Suggestion": "Suggestie",
  "Coronary heart disease": "Coronaire hartziekte",
  "High blood lipids": "Hyperlipidemie",
  "High blood pressure": "Verhoogde bloeddruk",
  "Kidney disease": "Nierziekte",
  "Neuropathy": "Neuropathie",
  "Obesity": "Overgewicht",
  "Peripheral arterial disease": "Perifeer arterieel vaatlijden",
  "Retinopathy": "Retinopathie",
  "Smoking addiction": "Rookverslaving",
  "Enter date": "Vul datum in",
  "Enter suggestion": "Vul suggestie in",
  "Enter Notes": "Voeg opmerking toe",
  "Select": "Selecteren",
  "Prescription": "Recept",
  "Medicine": "Medicijn",
  "Dose": "Dosis",
  "Enter medicine": "Vul medicatie in",
  "Enter dose": "Vul dosis in",
  "Enterdis": "Enter concomitant diseases",
  "Add note": "Voeg opmerking toe",
  "Add Content": "Maximale lengte is 1000 tekens.",
  "Other suggestions": "Andere suggesties",
  "OK": "OK",
  "HCP": "Zorgverleners",
  "Content": "Inhoud",
  "Records Report": "Archiefverslag",

  "Quick Print": "Snel afdrukken",
  "Quick Print Settings": "Instellingen Snel Afdrukken",
  "Select duration": "Selecteer duur",
  "One Week": "Een week",
  "One Month": "Een maand",
  "One Quarter": "Een kwartaal",
  "End date": "Einddatum",
  "Yesterday": "Gisteren",
  "Last Sunday": "Afgelopen zondag",
  "Last Saturday": "Afgelopen zaterdag",
  "Last Day of Last Month": "Last Day of Last Month",
  "Last Day of Last Quarter": "Last Day of Last Quarter",
  "Customized": "Aanpassen",
  "Week Filter": "Weekfilter",
  "Select reports to print": "Selecteer verslagen om af te drukken",
  "Daily Summary": "Dagelijks Overzicht",
  "Day By Day Overview": "Overzicht per dag",
  "Sensor Overlay": "Sensor Overzicht",
  "Trend Analysis": "Trendanalyse",
  "Logbook": "Logboek",
  "Device Settings Review": "Inspectie Apparaatinstellingen",
  "createReport": "Verslag aanmaken",

  "Segment Analysis": "Segmentanalyse",
  "Sensor Glucose Profile": "Sensorglucoseprofiel",
  "# of Boluses": "Aantal bolussen",
  "Bolus Insulin": "Bolusinsuline ",
  "Basal Pattern": "Basaalschema ",
  "Segment Analysis Report": "Verslag van segmentanalyse",
  "Avg Glucose": "Gem. glucose",
  "Below": "Onder",
  "In Target Range": "Binnen streefniveau",
  "Coefficient of variation": "Variatiecoëfficiënt",
  "% Time CGM Active": "% tijd CGM actief",
  "est_a1c_t1": "Geschatte A1C:",
  "est_a1c_t2": "berekend op basis van SG-waarden",
  "est_a1c_t3": "Opmerking: Geschatte A1C is geen vervanging voor laboratoriummeting",

  "acceptTip": " staat u toe zijn/haar gezondheidsinformatie van op afstand te bekijken.",
  "cancelTip": " staat niet langer toe dat u zijn/haar gezondheidsinformatie van op afstand bekijkt. U kunt indien nodig opnieuw een verzoek doen.",
  "rejectTip": " heeft uw verzoek geweigerd om zijn/haar gezondheidsinformatie van op afstand te bekijken.",
  "Read": "Lees",

  "Connection": "Connectie",
  "connections1": "Connecties",
  "Add Connection": "Voeg connectie toe",
  "SG": "SG",
  "Active Insulin": "Actieve Insuline",
  "Stop following": "Stop met volgen",
  "Enter username (email)": "Vul gebruikersnaam in (e-mail)",
  "Search results": "Zoekresultaten",
  "Send request": "Verzend verzoek",
  "View graphs": "Bekijk grafieken",
  "Agree": "Accepteer",
  "Deny": "Weiger",
  "Remove": "Verwijderen",
  "Cancel Requset": "Verzoek annuleren",
  "Remark": "Opmerking",

  "Warm up": "Opwarmen",
  "Monitoring": "Aan het controleren",
  "Transmitter Error": "Zenderfout",
  "Sensor Failure": "Sensorstoring",
  "Sensor Expired": "Sensor vervallen",
  "Lost Sensor": "Sensor verloren",
  "Not Calibrated": "Niet gekalibreerd",
  "Calibrating": "Aan het kalibreren",
  "Calibration Needed": "Kalibratie benodigd",
  "Calibration Error": "Kalibratiefout",
  "Charging Battery": "Batterij wordt opgeladen",
  "Battery Charged": "Batterij opgeladen",

  "To be filled": "Moet worden gevuld",
  "Filled with insulin": "Gevuld met insuline",
  "Priming": "Aan het voorbereiden",
  "Priming completed": "Voorbereiden voltooid",
  "Inserting needle": "Naald wordt ingebracht",
  "Patch activated": "Reservoir geactiveerd",
  "Delivering Basal": "Basaal wordt toegediend",
  "Exceeds Max 1 Hour Delivery": "Max. dosis per uur overschreden",
  "Exceeds Max TDD": "Max. dagelijkse dosis overschreden",
  "Suspend": "Stoppen",
  "Occlusion Detected": "Verstopping gedetecteerd",
  "Patch Expired": "Reservoir Vervallen",
  "Empty Reservoir": "Leeg Reservoir",
  "Patch Error": "Reservoirfout",
  "Pump Base Error": "Pompfout",
  "Patch Battery Depleted": "Reservoirbatterij Leeg",
  "Magnetic sensor not calibrated": "Magnetische sensor niet gekalibreerd",

  "Patient Profile": "Patiëntenprofiel",

  "On": "Aan",
  "on": "Aan",
  "Off": "Uit",
  "off": "Uit",

  "CORONARY_HEART_DISEASE": "Coronaire hartziekte",
  "HIGH_BLOOD_LIPIDS": "Hyperlipidemie",
  "HIGH_BLOOD_PRESSURE": "Verhoogde bloeddruk",
  "KIDNEY_DISEASE": "Nierziekte",
  "NEUROPATHY": "Neuropathie",
  "OBESITY": "Overgewicht",
  "PERIPHERAL_ARTERIAL_DISEASE": "Perifeer arterieel vaatlijden",
  "RETINOPATHY": "Retinopathie",
  "SMOKING_ADDICTION": "Rookverslaving",

  "saveTip": "Succesvol opgeslagen.",
  "changePaTip": "Uw wachtwoord is gewijzigd.",
  "enterEmTip": "Vul uw e-mailadres in.",
  "verErrTip": "Verificatiecode onjuist.",
  "chooseEventTip": "Kies gebeurtenissen om af te drukken",
  "chooseDataTip": "Selecteer gegevens om af te drukken",
  "dateWrongTip": "De einddatum mag niet eerder zijn dan de begindatum.",
  "infoWrongTip": "Vul alle verplichte velden in a.u.b.",
  "createdSuccssTip": "Succesvol aangemaakt",
  "selectData": "Selecteer gegevens om op te slaan",

  "acceSu": "Connectieverzoek geaccepteerd",
  "acceEr": "Nieuwe connectie toevoegen mislukt",
  "rejeSu": "Connectieverzoek afgewezen",
  "rejeEr": "Verzoek afwijzen mislukt",

  "userNotExist": "De gebruikersnaam bestaat niet.",
  "Password incorrect": "Wachtwoord onjuist.",
  "UserType incorrect": "Onjuist gebruikerstype",

  "registSuccess": "Uw account is succesvol aangemaakt.",
  "registFailed": "Nieuw account aanmaken mislukt.",
  "sentSuccess": "Bericht succesvol verzonden",
  "sentFailed": "Bericht versturen mislukt",
  "Input error": "Invoerfout",

  "deletePtip": "Weet u zeker dat u deze patiënten wilt verwijderen?",
  "deleteEvents": "Weet u zeker dat u deze gebeurtenissen wilt verwijderen?",
  "deleteData": "Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",
  "deleteThis": "Weet u zeker dat u dit wilt verwijderen?",
  "confirm": "Bevestigen",
  "deleteSuccess": "Succesvol verwijderd",
  "deleteFailed": "Item verwijderen mislukt",
  "modifySuccess": "Succesvol veranderd",
  "modifyFailed": "Veranderen mislukt",
  "createSuccess": "Succesvol aangemaakt",
  "createFailed": "Aanmaken mislukt",
  "editSuccess": "Bewerking succesvol",
  "editFailed": "Bewerken mislukt",
  "Time overlapped": "De door u geselecteerde sessies overlapten elkaar.",

  "stopFollow": "Weet u zeker dat u deze patiënt niet meer wilt volgen?",
  "CancelTip1": "Weet u zeker dat u deze connectie wilt verwijderen?",

  "Warning": "Waarschuwing",
  "agreeConnect": "Als u op 'Accepteren' klikt om het connectieverzoek te accepteren, wordt uw gezondheidsinformatie zichtbaar voor de nieuwe connectie.",
  "denyConnect": "Weet u zeker dat u het connectieverzoek wilt afwijzen?",
  "deleteConnect": "Weet u zeker dat u deze connectie wilt verwijderen? Als u hem/haar verwijderd, kan de connectie uw gezondheidsinformatie niet meer zien.",

  "Choose the events to print": "Kies gebeurtenissen om af te drukken",
  "tryAgain": "Probeer opnieuw",
  "username and password is required": "username and password is required",
  "A name is required": "Een naam is verplicht.",
  "username is required": "Gebruikersnaam is verplicht.",
  "The date choose wrong": "Onjuiste datumselectie",
  "Date no more than 14 days": "U kunt niet meer dan 14 dagen selecteren.",

  "CancelTip": "Weet u zeker dat u de connectie wilt verwijderen?",
  "removeConnect": "Succesvol verwijderd",

  "dateErr1": "U kunt niet meer dan 90 dagen selecteren.",
  "dateErr2": "De einddatum mag niet eerder zijn dan de begindatum.",

  "Not Filled": "Ongespecificeerd",
  "Today": "Vandaag",
  "duration": "Duur",
  "interval": "Interval",
  "7 days": "7 dagen",
  "14 days": "14 dagen",
  "30 days": "30 dagen",
  "90 days": "90 dagen",
  "g": "g",

  "Sound+Vibrate": "Geluid+Trillen",
  "Sound": "Geluid",
  "Vibrate": "Trillen",
  "Silent": "Niet storen",
  "1": "Eenmalig",
  "2": "Dagelijks",
  "noMes": "Er zijn geen berichten.",
  "noConnect": "Er zijn geen connecties.",
  "Customize": "Aanpassen",
  "GB": "United Kingdom",
  "CN": "China",
  "FR": "France",
  "DD": "Germany",
  "DE": "Germany",
  "SE": "Sweden",
  "AU": "Australia",
  "HKF": "Hongkong",
  "HU": "Hungary",
  "IT": "Italy",
  "NL": "Netherlands",
  "Nor": "Norway",
  "PT": "Portugal",
  "ES": "Spain",
  "TR": "Turkey",

  "Jan": "jan",
  "Feb": "feb",
  "Mar": "maa",
  "Apr": "apr",
  "May": "mei",
  "Jun": "jun",
  "Jul": "jul",
  "Aug": "aug",
  "Sep": "sep",
  "Oct": "okt",
  "Nov": "nov",
  "Dec": "dec",
  "ApplyTip": " verzoek om uw gegevens te bekijken.",
  "noReadings": "Geen metingen",

  "daop_A6_system": "A6 Touchcare System",
  "daop_easytouch_easyview": "EasyTouch / EasyView iPad",
  "daop_TY012_TY015": "TY012/TY015",
  "daop_easysense": "EasySense",
  "daop_delete_data": "Delete Data",
  "daop_uploaded_data": "Geüploade gegevens",
  "daop_uploaded_data_text": "De gegevens zijn afkomstig van de EasyTouch-app of de EasyView iPad-app.",
  "daop_realtime_data": "Real-time gegevens",
  "daop_realtime_data_text": "The data is from EasySense App or EasyPatch App.",

  "ins_unit": "( E ) ",
  "ins_unit2": "E",
  "basal_unit": "(E/u)",
  "basal_unit2": "E/u",

  "Alerts_Patch_Battery_Low": "Reservoirbatterij bijna leeg",
  "Alerts_Patch_Battery_Depleted": "Reservoirbatterij leeg",
  "Alerts_Lost_Pump": "Lost Pump",
  "Alerts_Low_Reservoir": "Reservoir bijna leeg",
  "Alerts_Empty_Reservoir": "Leeg Reservoir",
  "Alerts_Patch_Expiration_Advisory": "Reservoir-verval Herinnering",
  "Alerts_Patch_Exp_In_1_Hour": "Patch Exp In 1 Hour",
  "Alerts_Patch_Expired": "Reservoir Vervallen",
  "Alerts_Patch_Error": "Reservoirfout",
  "Alerts_Pump_Base_Error": "Pompfout",
  "Alerts_Basal_Rate_Key_Error": "Basal Rate Key Error",
  "Alerts_Occlusion_Detected": "Verstopping Gedetecteerd",
  "Alerts_End_Of_Suspend": "End Of Suspend",
  "Alerts_Exceeds_Max_TDD": "Max. dagelijkse dosis overschreden",
  "Alerts_Exceeds_Max_1Hr_Delivery": "Max. toediening per uur overschreden",

  "Alerts_Predictive_Low_Suspend": "Voorspelde Lage Stopwaarde",
  "Alerts_Low_Suspend": "Lage Stopwaarde",
  "Alerts_Auto_Off": "Auto Uit  ",

  "Alerts_Pump_Restart": "Pump Restart",
  "Alerts_Auto_Off_Warning": "Auto Off Warning",
  "Alerts_Pump_Out_Of_Range": "Pump Out Of Range",

  "Alerts_Lost_Sensor": "Sensor Verloren",
  "Alerts_Transmitter_Battery_Low": "Zenderbatterij bijna leeg",
  "Alerts_Charge_Transmitter": "Laad Zender Op",
  "Alerts_Sensor_Error": "Geen metingen",
  "Alerts_Transmitter_Error": "Zenderfout",
  "Alerts_Sensor_Calibration_Error": "Sensor Calibration Error",

  "Alerts_Sensor_Failure": "Sensorstoring",
  "Alerts_Sensor_Calibration_Reminder": "Sensor Calibration Reminder",
  "Alerts_Meter_BG_Now": "BG direct meten",
  "Alerts_Sensor_Exp_in_6_Hours": "Sensor vervalt binnen 6 uur",
  "Alerts_Sensor_Exp_in_2_Hours": "Sensor vervalt binnen 2 uur",
  "Alerts_Sensor_Exp_in_30_Min": "Sensor vervalt binnen 30 min",
  "Alerts_Sensor_Expired": "Sensor vervallen",
  "Alerts_Rapid_Rise": "Snelle Stijging",
  "Alerts_Rapid_Fall": "Snelle Daling",
  "Alerts_High_Predicted": "Hoog Verwacht",
  "Alerts_Low_Predicted": "Laag Verwacht",
  "Alerts_High_Glucose": "Hoge Glucose",
  "Alerts_Low_Glucose": "Lage Glucose",
  "Alerts_Below_3.1_mmol/L": "Onder 3,1 mmol/L",
  "Alerts_Transmitter_Battery_Low_2": "Zenderbatterij bijna leeg",

  "Alerts_PDM_Battery_Low": "PDM-batterij bijna leeg",
  "Alerts_Replace_Battery": "Laad de PDM nu op ",

  "Alert": "Alert",
  "Alerts": "Waarschuwingen",
  "Alert Filter": "Alert Filter",
  "PDM": "PDM",
  "Pump": "Pomp",

  "Out Of Range": "Out Of Range",
  "t1221_Time_in_Auto_Mode": "Tijd in Auto Modus",
  "t1221_Average_SG_SD": "Gemiddelde  SG ± SD",
  "t1221_Time_in_Target_Range": "Tijd binnen Streefbereik",
  "t1221_Time_above_Range": "Tijd boven Streefbereik",
  "t1221_Time_below_Range": "Tijd onder Streefbereik",
  "t1221_Auto_Basal_per_day": "Auto Basaal (per dag)",
  "t1221_Auto_Bolus_per_day": "Auto Bolus (per dag)",
  "t1221_Auto_Mode_Exits": "Auto Modus Exit",
  "t1221_No_Sensor_readings": "Geen Sensor waardes",
  "t1221_Max_Delivery": "Max. Toediening",
  "t1221_Min_Delivery": "Min. Toediening",
  "t1222_autoModeBasal": "Auto Modus Basaal",
  "t1222_autoModeCorrBolus": "Auto Modus Correctie Bolus",
  "t1222_autoSnack": "Auto Snack",
  "t1222_autoBreakfast": "Auto Ontbijt",
  "t1222_autoLunch": "Auto Lunch",
  "t1222_autoDinner": "Auto Diner",
  "t1222_autoExercise": "Auto Inspanning",
  "t1222_Snack": "Snack",
  "t1222_Auto_Mode": "Auto Modus",
  "t1222_Time_in_Auto_Mode": "Tijd in Auto Modus(%)",
  "t1222_Avg_SD": "Gemid.(mmol/L)±SD",
  "t1222_Target_Range": "Streefbereik (%)",
  "t1222_Above_Range": "Boven Streefbereik (%)",
  "t1222_Below_Range": "Onder Streefbereik(%)",
  "t1222_Auto_Mode_Exits": "# van Auto Modus Exit",
  "t1221_Auto_Mode": "Auto Modus",
  "t1222_auto_basal": "Auto Basaal",
  "t1222_auto_bolus": "Auto Bolus",
  "t0805_User_Management": "Gebruikersbeheer",
  "t0805_Patient_Management": "Patiëntbeheer",
  "t0805_Operation_History": "Operatie geschiedenis",
  "t0805_User_List": "gebruikers lijst",
  "t0805_User": "Gebruiker",
  "t0805_Time": "Tijd",
  "t0805_Operation_Type": "Bewerkingstype",
  "t0805_Back": "Terug",
  "t0805_Add": "Toevoegen",
  "t0805_Delete": "Verwijderen",
  "t0809_Add_User": "Voeg gebruiker toe",
  "t1028_Pattern_C": "Schema C",
  "t1028_Pattern_D": "Schema D",
  "t1029_Auto_meal_bolus": "Auto Maaltijd Bolus",
  "t1029_Auto_mode_correction_bolus": "Auto Mode Maaltijd Correctie Bolus",
  "t1029_Sick": "Ziek",
  "t1029_Auto_Mode_Feature": "Automatische modus",
  "t1029_Target_SG": "Doel SG",
  "t1029_Auto_Meal_Handling": "Auto. maaltijdverwerking",
  "t1029_Total_Daily_Dose": "Totale dag. Dosis",
  "t1029_Pump_Light": "Pomp Licht",
  "t1029_Alerts_for_Hypo": "Waarschuwingen voor Hypo",
  "t1102_Out_of_Range": "Buiten Bereik",
  "t1102_Command_Reminder": "Opdracht",
  "t1102_Alarms_Alerts_on_APP": "Pomp Alarmen & Waarschuwingen ",
  "t1102_Alarms_on_App": "App Alarmen",
  "t1102_Alerts_on_App": "App Waarschuwingen ",
  "t1102_Factory_Calibration": "Fabrieks Kalibratie",
  "t1102_Alerts_for_Low": "Hypo-waarschuwingen",
  "t1102_Alerts_for_High": "Hyper-waarschuwingen",
  "t1102_Alerts_for_Others": "Overige waarschuwingen",
  "t1102_Adjustment": "Aanpassing",
  "t1102_Suggested": "Voorgesteld",
  "t1103_Glucose": "Glucose",
  "t1103_CGM": "CGM",
  "t1103_Insulin": "Insuline",
  "t1103_Carbs": "Koolhydraten",
  "t1103_Exercise": "Inspanning",
  "t1103_Min_Max": "Min/Max",
  "t1103_Target_Range": "Doel bereik",
  "t1103_Overall_Tine_In_Range": "Algemeen: Time in Range",
  "t1103_Basal": "Basaal",
  "t1103_Bolus": "Bolus",
  "t1103_Basal_Bolus": "Basaal & Bolus",
  "t1103_Auto_Mode_Time_In_Range": "Auto Modus: Time In Range",
  "t1103_Time_below_range": "Tijd beneden Doelbereik",
  "t1103_Time_above_range": "Tijd boven Doelbereik",
  "t1103_Time_in_target_range": "Tijd binnen Doelbereik",
  "t1103_Incorrect_Password": "Onjuist wachtwoord, $1 Poging over, voer het juiste wachtwoord in.",
  "t1103_Incorrect_locked": "Mislukte pogingen overschrijden de limiet, het account is vergrendeld. Probeer het over $1 minuten opnieuw.",
  "t1104_The_data_is_from": "De gegevens zijn afkomstig van de EasySense-app of de EasyPatch-app.",
  "t1104_Privacy_Policy": "Privacybeleid en gebruiksvoorwaarden",
  "t1104_updated_privacy_policy": "We hebben onze privacybeleid en gebruiksvoorwaarden bijgewerkt. Lees deze aandachtig en ga akkoord met de nieuwe voorwaarden voordat u de EasyPatch gebruikt.",
  "t1104_Disagree": "Niet akkoord",
  "t1104_Agree": "Accepteer",
  "t1105_Upload_History": "Geschiedenis uploaden",
  "t1105_Delete_Data": "Verwijder data",
  "t1105_Target_Range": "Doel bereik",
  "t1105_request_to_view_your_data": "$1 verzoek om uw gegevens te bekijken.",
  "t1105_Recent_Updates": "Recente updates",
  "t1108_No_data": "Geen gegevens",
  "t1108_Pump_Bash_SN": "SN van de Pomp",
  "t1108_Transmitter_SN": "SN van de Zender",
  "t1112_Normal_Glucose": "Normale Glucose",
  "t1112_Manual_Bolus_or_Modified_Bolus": "Handmatige bolus of aangepaste bolus",
  "t1112_Auto_Mode_Started": "Auto Mode gestart",
  "t1112_Auto_Mode_Exit": "Auto Mode Exit",
  "t1112_Normal_Bolus": "Normale Bolus",
  "t1112_Extended_Bolus": "Verlengde Bolus",
  "t1112_Combo_Bolus": "Gecombineerde Bolus",
  "t1112_Carbs": "Koolhydraten",
  "t1112_Glucose": "Glucose",
  "t1112_BG": "BG",
  "t1112_Audio": "Geluid",
  "t1112_Tone": "Geluid",
  "t1112_Audio_Options": "Geluidsopties",
  "t1112_Weight_Unit": "Gewichtseenheid",
  "t1112_Height_Unit": "Hoogte-Eenheid",
  "t1112_Not_available": "Niet Beschikbaar",
  "t1112_Number": "Nummer",
  "t1112_days": "# dagen",
  "t1112_min": "min",
  "t1113_days": "dagen",
  "t1215_Security": "Veiligheid",
  "t1215_MFA": "Multi-factor authenticatie (MFA)",
  "t1215_Enter_verification_code": "Voer verificatiecode in",
  "t1215_Multi_factor_ON": "Multi-factor authenticatie is AAN. Verificatiecode is verzonden naar $1 Dien een verificatiecode in.",
  "t1215_Verification_code_incorrect": "Verificatiecode onjuist",
  "t1215_Show_Glucose_Value": "Glucosewaarde weergeven",
  "t1221_enter_verification_code": "Voer de 6-cijferige verificatiecode in die naar $1 is verzonden.",
  "t1221_Verification_Success": "Succesvol geverifieerd",
  "t1222_We_will_only_process": "We zullen uw gezondheidsinformatie alleen verwerken via de app/website van Medtrum met uw toestemming. ",
  "t1222_If_you_are_under_years": "Indien u jonger bent dan 16 jaar, heeft u toestemming van uw ouder of wettelijke voogd nodig voor registratie in de app.",
  "t1221_register_cn": "U heeft het recht om geen apparaatgegevens naar de app te uploaden, in welk geval de gegevens niet voor anderen toegankelijk zullen zijn. Als u ervoor kiest om u niet te registeren via de app/website van Medtrum, staat uw gezondheidsinformatie alleen op het apparaat zelf opgeslagen. ",
  "t1221_register_eu": "Als u ervoor kiest om uw Medtrum-account te registreren en gebruik te maken van de app via uw account, zal uw gezondheidsinformatie die staat opgeslagen in de app naar onze server in Europa worden geüpload en daar gedurende 2 jaar worden bewaard. U heeft het recht om geen apparaatgegevens naar de app te uploaden, in welk geval de gegevens niet voor anderen toegankelijk zullen zijn. Als u ervoor kiest om u niet te registeren via de app/website van Medtrum, staat uw gezondheidsinformatie alleen op het apparaat zelf opgeslagen.",
  "t1221_register_follow": "We zullen uw gezondheidsinformatie alleen verwerken via de app/website van Medtrum met uw toestemming. ",
  "t1222_Terms_of_Use": "de gebruiksvoorwaarden van Medtrum",
  "t1222_Privacy_Policy": "het privacybeleid van Medtrum",
  "t1222_Create_Account": "Account aanmaken",
  "t1222_Back": "Terug",
  "t1222_Verify_your_account": "Verifieer uw account",
  "t1222_please_check_your_account": "We sturen een verificatiecode naar $1, controleer uw account.",
  "t1222_I_Agree_to": "Ik ga akkoord met $1",
  "t1223_Invalid_Verification_Code": "Ongeldige verificatie code. Probeer het opnieuw."
};

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return enMessages; });


var enMessages = {
  "BG Export": "BG",

  "Pump_Alarm_Alerts_On_Pump": "Pump Alarms & Alerts On Pump",
  "EasyLoop": "EasyLoop",
  "Time": "Time",
  "Title": "Title",
  "Reminders": "Reminders",
  "Height Unit": "Height Unit",
  "Weight Unit": "Weight Unit",
  "Audio Option": "Audio Option",
  "APP": "APP",
  "Tone": "Tone",
  "Alerts for Others": "Alerts for Others",
  "Alerts for High": "Alerts for High",
  "Alerts for Low": "Alerts for Low",
  "Factory Calibration": "Factory Calibration",
  "Transmitter SN": "Transmitter SN",
  "Pump Alerts on App": "Pump Alerts on App",
  "Pump Alarms on App": "Pump Alarms on App",
  "Command Reminder": "Command Reminder",
  "Pump Base SN": "Pump Base SN",
  "Audio": "Audio",
  "Once": "Once",

  "country_region": "Country/region",
  "hcp_apply_user_exist": "This email address has been used by a patient/caregiver account. If you want to switch to an HCP account, choose Next.<br/><br/>" + "Please note that once the account type is changed, any account data will be lost, and you can’t log in anymore to your patient/caregiver account on EasyTouch/EasySense/EasyFollow.",
  "check_email_for_code": "Please check your email XXX@XXX.com for the verification code. ",
  "try_again": "Try again.",
  "account_type_changed": "Account type changed.",
  "application_has_been_submitted": "Your application has been submitted. Once your application status changes, an email will be sent informing you. ",

  "privacy_policy_and_terms_of_use": "Privacy Policy and Terms of Use ",

  "privacy_confirm_text": "We have updated our <a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>privacy policy</a> and <a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>terms of use</a>. Please read and agree to all terms to continue using EasyView.",
  "privacy_confirm_disagree": "Disagree",
  "privacy_confirm_accept": "Accept",

  "title": "EasyView Personal",
  "title1": "EasyView Pro",
  "user": "Email",
  "password": "Password",
  "remember": "Remember Me",
  "forget": "Forgot Password?",
  "sign in": "Sign in",
  "login": "Login",
  "sign up now": "Sign up now",
  "apply": "Apply for an account",
  "contact us": "Contact Us",
  "Privacy Policy": "Privacy Policy",
  "Terms of Use": "Terms of Use",
  "copyright": "Copyright © 2021 Medtrum Technologies Inc. All rights reserved.",

  "chooseLang": "Choose your country/region or language",
  "asia": "Asia Pacific",
  "europe": "Europe",
  "middleEast": "Middle East",

  "applyHcp": "Apply for an HCP account",
  "sign up": "Sign up",
  "Patient": "Patient",
  "Caregiver": "Caregiver",
  "Email": "Email",
  "Mobile": "Mobile",
  "Enter email": "Enter email address",
  "Enter mobile": "Enter mobile number",
  "Verification": "Verification code",
  "Invitation": "Invitation code",
  "full name": "Enter your full name",
  "Enter pass": "Enter password",
  "org": "Organization",
  "Register": "Register",
  "send": "Send",
  "createAccount": "Create Account",
  "agree": "I have read and agree to the ",
  "privacy": " Medtrum privacy policy  ",
  "and": "and ",
  "use": "terms of service.",
  "errtip1-1": "You must enter a valid email address,which",
  "errtip1-2": "will become your Medtrum username.",
  "errtip2": "Please enter a valid mobile number.",
  "errtip3": "Verification code incorrect",
  "errtip4": "Incorrect invitation code.",
  "errtip5": "Username incorrect",
  "errtip6": "Your password must have 8 or more characters.",
  "errtip7": "Please enter your organization.",

  "errp1": "Password must contain at least 3 types of the following characters:",
  "errp2": "capital letter,lowercase letter, number and special character.",
  "errp3": "Password must be between 6 and 20 characters long.",
  "errp4": "Password must be different from username.",
  "errp5": "Password with 3 consecutive numbers is invalid (e.g.: 123, 321).",
  "errp6": "Password with 3 consecutive letters is invalid (e.g.: abc, cba).",
  "errp7": "Password cannot contain spaces.",

  "Find account": "Retrieve your password.",
  "Enter username": "Please enter your username.",
  "Next": "Next",
  "Cancel": "Cancel",
  "Back": "Back",
  "Enter veri": "Enter verification code",
  "Verify notice": "Please find the verification code sent in an email.",
  "Create new": "Create a new password",
  "Create new notice": "Please create a new password，and your password must have 6 or more characters.",
  "New pass": "New password",
  "Completed": "Completed",
  "Created": "New password created.",
  "Login Now": "Sign in now",

  "Delete": "Delete",
  "New Patient": "New Patient",
  "Add Patient": "Add Patient",
  "Filter": "Filter",
  "Name": "Name",
  "Gender": "Gender",
  "Age": "Age",
  "Type": "Type",
  "Duration": "Duration",
  "Connections": "Account creator",
  "UploadTime": "Upload time",
  "Year": "year",
  "Years": "years",
  "Month": "month",
  "Month2": "Month",
  "Months": "months",
  "Invite": "Invite",
  "Invited": "Invited",
  "All": "All",
  "Female": "Female",
  "Male": "Male",
  "Not Set": "Not Set",
  "Type 1": "Type 1",
  "Type 2": "Type 2",
  "Gestational": "Gestational",
  "Prediabetes": "Prediabetes",
  "LADA": "Type 1.5 LADA",
  "Apply": "Apply",
  "disUn": "Diabetes type unspecified",
  "ageUn": "Age unspecified",
  "genUn": "Gender unspecified",
  "addP": "Add Patient",
  "newP": "New Patient",
  "findP": "Find Patient",

  "GDRNF": "Unspecified",
  "GDRF": "Female",
  "GDRM": "Male",
  "女": "Male",

  "DBTNF": "Unspecified",
  "DBT1": "Type 1",
  "DBT2": "Type 2",
  "DBTLADA": "Type 1.5 LADA",
  "DBTPRE": "Prediabetes",
  "DBTGEST": "Gestational",
  "前期": "beFore",
  "beFore": "beFore",
  "MODY": "Mody",

  "No selection": "No selection",
  "unspecif": "unspecified",
  "register": "Patient",
  "hcp": "Clinician",

  "BG": "BG",
  "CARB": "Carbs",
  "INS": "Injection",
  "EXR": "Exercise",
  "OTR": "Other",
  "HBA1C": "HbA1c",
  "DOSE": "DOSE",
  "URINEK": "Urine Ketone",
  "HEL": "HEL",
  "OTR1": "Other",
  "Loading": "Loading",

  "home": "Home",
  "pID": "Patient ID",
  "fullName": "Full name",
  "gender": "Gender",
  "height": "Height",
  "weight": "Weight",
  "cm": "cm",
  "kg": "kg",
  "birthday": "Date of birth",
  "disType": "Type of diabetes",
  "disDate": "Date of diagnosis",
  "Address": "Address",
  "Postcode": "Postcode",
  "Inpatient": "Inpatient",
  "Yes": "Yes",
  "No": "No",
  "Pno": "Patient no.",
  "Bno": "Bed no.",
  "create": "Create",
  "Telephone": "Telephone",

  "enterU": "Enter username (email)",
  "search": "Search",
  "noU": "Username is required.",
  "searchR": "Search results",
  "uername": "Username",
  "alias": "Alias",
  "remove": "Remove",
  "viewG": "View graphs",
  "sendR": "Send request",
  "rSent": "Your request has been sent.",
  "cancelR": "Cancel request",

  "VcodeTip1": "Didn’t receive it? Please wait for a few minutes and",
  "VcodeTip2": "try again.",
  "VcodeTip3": "We just sent a code to ",
  "Entercode": "Enter code",
  "Getcode": "Get code",

  "messages": "Messages",
  "profile": "Profile",
  "sign out": "Sign out",
  "changeP": "Change Password",
  "connection": "Connections",

  "myP": "My profile",
  "Portrait": "Profile photo",
  "Profession": "Profession",
  "DPRONF": "Unspecified",
  "DPROENDOCRIN": "Endocrinologist",
  "DPRODIABTRA": "Diabetes Educator",
  "DPRONURSE": "Nurse",
  "DPRODIATIT": "Dietitian",
  "DPROOTR": "Other HCPs",
  "Organization": "Organization",
  "Bio": "Bio",
  "save": "Save",
  "oldPa": "Old password ",
  "newPa": "New password",
  "RePa": "Re-enter password",
  "forgetY": "Forgot your password?",
  "applyM": "Apply",
  "oldErr": "The old password is incorrect.",
  "EntTheSame": "Enter the new password again.",
  "EnterOld": "Enter the old Password!",

  "pList": "Patient List",
  "connections": "Connections",
  "settings": "Settings",
  "monitor": "Monitor",
  "graphs": "Reports",
  "events": "Events",
  "records": "Records",
  "qPrint": "Quick Print",

  "sensorIn": "Sensor Info",
  "timeOfLaRead": "Time of the last sensor reading",
  "tranSn": "Transmitter SN",
  "status": "Status",
  "sensorLife": "Sensor life left",
  "lastSenorRead": "Last sensor reading",
  "TranBattery": "Transmitter battery",
  "sg": "SG",
  "alert": "Alert",
  "target": "Target",
  "hypo": "Hypo",
  "sensorGlucose": "Sensor Glucose",
  "calib": "Calibration",
  "newSen": "New Sensor",
  "warm": "Warm up",
  "InsulinPump": "Insulin Pump",
  "timeOfLaPump": "Time of the last pump data",
  "pumpSN": "Pump Base SN",
  "ReserviorLife": "Reservoir patch life left",
  "InsulinLeft": "Insulin left",
  "basal": "Basal",
  "bolus": "Bolus",
  "totalBasal": "Total daily basal",
  "lastBolus": "Last bolus",
  "activeInsulin": "Active insulin",
  "totalBolus": "Total daily bolus",
  "tampBasal": "Temp Basal",
  "normalBolus": "Normal Bolus",
  "extendBolus": "Extended Bolus",
  "manualStop": "Manual Suspend",
  "autoStop": "Auto Suspend",
  "auto suspend": "Auto Suspend",
  "stop": "Delivery Stop",
  "newPatch": "New Patch",
  "tempBasal": "Temp Basal",
  "N": "N",
  "E": "E",
  "CN1": "CN",
  "CE": "CE",

  "staticSettings": "Report Settings",
  "dataSource": "Data to view",
  "unit": "Unit",
  "glucoseTarget": "Glucose Target Range",
  "overall": "Overall",
  "Hypoglycemia": "Hypoglycaemia",
  "timePeriod": "Time Period",
  "postMeal": "Post Meal Analysis",
  "Breakfast": "Breakfast",
  "Lunch": "Lunch",
  "Dinner": "Dinner",
  "night": "Night-time",
  "Before": "Before",
  "After": "After",
  "Low": "Low",
  "High": "High",
  "From": "From",
  "To": "To",
  "Hours": "hours",
  "Reset": "Restore defaults",
  "RealTime": "Real-time",
  "uploaded": "Uploaded",
  "sensor": "Sensor",
  "pdmSN": "PDM SN",
  "startTime": "Start time",
  "endTime": "End time",
  "uploadTime": "Time of upload",
  "pdm": "PDM",
  "Uploaded": "Uploaded",
  "Patch Pump": "Patch Pump",
  "overLapp": "Sessions overlapped",
  "showAlert": "Show alerts",

  "dashboard": "Dashboard",
  "dboard_glucose_statistics": "Glucose Statistics",
  "dboard_glucose": "BG",
  "dboard_cgm": "CGM",
  "dboard_insulin": "Insulin",
  "dboard_carbs": "Carbs",
  "dboard_exercise": "Exercise",
  "dboard_glucose_avg": "Average",
  "dboard_cgm_avg": "Average",
  "dboard_insulin_avg": "Average Daily Dose",
  "dboard_carbs_avg": "Average Carbs/Day",
  "dboard_exercise_avg": "Average time/Day",
  "dboard_sd": "SD",
  "dboard_num": "#",
  "dboard_num_days": "# days",
  "dboard_statistics": "Statistics",
  "dboard_BG": "BG",
  "dboard_BG_calibration": "BG / calibration (per day)",
  "dboard_SG": "SG",
  "dboard_AUC_high": "AUC high >",
  "dboard_AUC_low": "AUC low <",
  "dboard_highest_value": "Highest value",
  "dboard_lowest_value": "Lowest value",

  "dboard_pump": "Pump",
  "dboard_avg_daily_dose": "Average Daily Dose",
  "dboard_SD": "SD",
  "dboard_daily_basal": "Daily Basal",
  "dboard_daily_bolus": "Daily Bolus",
  "dboard_avg_bolus_num": "Average Bolus No. (per day)",
  "dboard_avg_suspend_time": "Average Suspend time (per day)",
  "dboard_avg_reservoir_usage": "Average Reservoir usage (per day)",
  "dboard_days": "days",

  "dboard_manual_bolus": "Manual Bolus (Volume/No. per day)",
  "dboard_normal": "-Normal",
  "dboard_extend": "-Extended",
  "dboard_combo": "-Combo",

  "dboard_bolus_calculator": "Bolus Calculator (Volume/No. per day)",
  "dboard_food_bolus": "-Food Bolus calc.",
  "dboard_corr_bolus": "-Corr Bolus calc.",
  "dboard_override_add": "-Override(+)",
  "dboard_override_sub": "-Override(-)",

  "dboard_report": "Dashboard Report",

  "daily": "Daily Summary",
  "date": "Date",
  "print": "Print",
  "carbs": "Carbs",
  "exercise": "Exercise",
  "heavy": "Heavy",
  "Medium": "Medium",
  "Light": "Light",
  "dailyReport": "Daily Summary Report",
  "devices": "Devices",
  "tran": "Transmitter",
  "pumpBase": "Pump Base",
  "HbA1c": "HbA1c",
  "statics": "Statistics",
  "glucose": "Glucose",
  "item": "Item",
  "BG1": "BG",
  "SG1": "SG",
  "avgSD": "Avg. (mmol/L)±SD",
  "avgSD1": "Avg±SD",
  "min": "Min",
  "max": "Max",
  "ofRead": "# of readings",
  "ofHypo": "# of hypo/duration(min)",
  "ofAlert": "# of alerts",
  "insulin": "Insulin",
  "insulin2": "Insulin",
  "totalDose": "Total daily dose",
  "foodBolus": "Food Bolus",
  "Food+coor": "Food+corr",
  "calibBolus": "Correction Bolus",
  "durationStop": "Duration of suspension(min)",
  "ofPumpAlert": "# of pump alarms",
  "ofMeal": "# of meals",
  "totalExerTime": "Total exercise time",
  "exerNum": "# of exercises",
  "avgInten": "Avg. Intensity",
  "target1": "Target",
  "high1": "High",
  "low1": "Low",
  "BG Reading": "BG Reading",

  "dayByday": "Day by Day Overview",
  "dayBydayRe": "Day by Day Overview Report",
  "period": "Period",

  "sensorOverlay": "Sensor Overlay",
  "set": "Set",
  "setPeriod": "Set period",
  "Weekdays": "Weekdays",
  "Weekends": "Weekends",
  "Mon": "Mon",
  "Tue": "Tue",
  "Wed": "Wed",
  "Thur": "Thu",
  "Thu": "Thu",
  "Fri": "Fri",
  "Sat": "Sat",
  "Sun": "Sun",
  "Average": "Average",
  "sensorOlRe": "Sensor Overlay Report",
  "Avg": "Avg.",
  "±SD": "±SD",
  "ofhypo": "# of Hypo",
  "Everyday": "every day",

  "TrendAna": "Trend Analysis",
  "TrendRe": "Trend Analysis Report",
  "sensorGlu": "Sensor Glucose ",
  "ofBGtest": "# of BG tests",
  "Basics": "Basics",
  "static": "Statistics",
  "Med": "Med",
  "med": "median",
  "Q1": "Q1",
  "Q3": "Q3",
  "Q11": "Q1",
  "Q31": "Q3",
  "IQR": "IQR",
  "SD": "SD",
  "CV": "CV",
  "SE1": "SE Mean",
  "distri": "Distribution",
  "stab": "Stability",
  "#high": "# of high",
  "#low": "# of low",
  "aucBelow": "AUC Below limit",
  "aucAbove": "AUC Above limit",
  "bgRead": "BG readings",
  "total": "Avg. Daily Total",
  "avg_daily_basal": "Avg. Daily Basal",
  "avg_daily_bolus": "Avg. Daily Bolus",
  "ofBolus": "Avg. # of bolus/Day",
  "avgBolus": "Avg. bolus(U)/Each",
  "Dura1": "Duration (min)",
  "Avg/Total": "Avg/Total",
  "high": "High",
  "low": "Low",
  "#hypo": "# of Hypo",
  "ofExer": "# of Exercises",

  "logbook": "Logbook",
  "dailyTotal": "Daily Total",
  "High Glucose": "High Glucose",
  "Low Glucose": "Low Glucose",
  "No Active Patch": "No Active Patch",
  "Missed Meal": "Missed Meal",
  "Multiple BG Readings": "Multiple BG Readings",
  "Stop Patch": "Stop Patch",
  "Others": "Others",
  "Other Events": "Other Events",
  "logRe": "Logbook Report",

  "DeviceSetting": "Device Settings Review",
  "Insulin Pump": "Insulin Pump",
  "MaxBasalRate": "Maximum Basal Rate",
  "BasalPatterns": "Basal Patterns",
  "Selected Basal Pattern": "Selected Basal Pattern",
  "Maximum Bolus": "Maximum Bolus",
  "Combo/Extended Bolus": "Combo/Extended Bolus",
  "BG Reminder": "BG Reminder",
  "Bolus Increment": "Bolus Increment",
  "Bolus Calculator": "Bolus Calculator",
  "Active Insulin Time": "Active Insulin Time",
  "IC Ratios": "IC Ratios",
  "Insulin Sensitivity": "Insulin Sensitivity",
  "BG Target": "BG Target",
  "Bolus Reminder": "Bolus Reminder",
  "CGM": "CGM",
  "CGM System": "CGM System",
  "Glucose Unit": "Glucose Unit",
  "Glucose Limits": "Glucose Limits",
  "Predicitive Alerts": "Predictive Alerts",
  "Rate Alerts": "Rate Alerts",
  "type": "Type",
  "time": "Time",
  "data": "Data",
  "Rate": "Rate",
  "Calibration Reminder": "Calibration Reminder",
  "Calibration Repeat": "Calibration Repeat",
  "Snooze": "Snooze",
  "Audio Options": "Audio Options",
  "Confidence Reminder": "Confidence Reminder",
  "Backlight": "Backlight",
  "Sec": "sec",
  "Alarm Clock": "Alarm Clock",
  "Patch Expiration": "Patch Expiration",
  "Sensor Expiration": "Sensor Expiration",
  "Hourly Max": "Hourly Max",
  "Daily Max": "Daily Max",
  "Low Reservoir": "Low Reservoir",
  "Low Suspend": "Low Suspend",
  "Predictive Low Suspend": "Predictive Low Suspend",
  "Rise": "Rise",
  "Fall": "Fall",
  "Auto Off": "Auto Off",
  "Standard": "Standard",
  "Exercise": "Exercise",
  "Holiday": "Holiday",
  "ProgramA": "Pattern A",
  "ProgramB": "Pattern B",
  "--": "--",
  "Insulin": "Insulin",

  "SUSA": "Auto Off",
  "SUSHM": "Exceeds Max 1 Hour Delivery",
  "SUSDM": "Exceeds Max TDD",
  "SUSLSG": "Low Suspend",
  "SUSPLSG": "Predictive Low Suspend",
  "Pump Restarted": "Pump Restarted",
  "Meter BG Now": "Meter BG Now",
  "Sensor Exp in 2 Hours": "Sensor Exp in 2 Hours",
  "Sensor Exp in 6 Hours": "Sensor Exp in 6 Hours",
  "Sensor Exp in 30 Min": "Sensor Exp in 30 Min",
  "Sensor Calibration Error": "Sensor Calibration Error",
  "Sensor Error": "No Readings",

  "Device Settings Report": "Device Settings Report",
  "24h Total": "24h Total",
  "Device Settings at": "Device Settings at",
  "Start": "Start",
  "Combo/Ext Bolus": "Combo/Ext Bolus",
  "Time Format": "Time Format",
  "Device Options（CGM System)": "Device Options (CGM System)",
  "Device Options（Insulin Pump)": "Device Options (Insulin Pump)",
  "Dispay Settings (Screen)": "Dispay Settings (Screen)",
  "Dispay Settings (Backlight)": "Dispay Settings (Backlight)",
  "Graph Range": "Graph Range",
  "Range": "Range",
  "Repeat": "Repeat",
  "Glucose Alerts": "Glucose Alerts",
  "Alert Silence": "Alert Silence",

  "Create": "Create",
  "Event Filter": "Event Filter",
  "HbA1c1": "HbA1c",
  "Urine Ketone": "Ketone",
  "Injection": "Injection",
  "Other": "Other",
  "Event Type": "Event Type",
  "Details": "Details",
  "Notes": "Notes",
  "Source": "Source",
  "edit": "Edit",
  "Action": "Action",
  "EventReport": "Event Summary Report",
  "By Date": "By Date",
  "By Category": "By Category",
  "Event Summary": "Event Summary",
  "No data": "No data",
  "No1": "No",
  "data1": "data",
  "#": "#",
  "BG Summary": "BG Summary",
  "Carbs Summary": "Carbs Summary",
  "Injection Summary": "Injection Summary",
  "Exercise Summary": "Exercise Summary",
  "Input Notes": "Enter a note",

  "Profile": "Profile",
  "Complications": "Complications",
  "Concomitant diseases": "Concomitant diseases",
  "Suggestion": "Suggestions",
  "Coronary heart disease": "Coronary heart disease",
  "High blood lipids": "High blood lipids",
  "High blood pressure": "High blood pressure",
  "Kidney disease": "Kidney disease",
  "Neuropathy": "Neuropathy",
  "Obesity": "Obesity",
  "Peripheral arterial disease": "Peripheral arterial disease",
  "Retinopathy": "Retinopathy",
  "Smoking addiction": "Smoking addiction",
  "Enter date": "Enter date",
  "Enter suggestion": "Enter suggestion",
  "Enter Notes": "Enter Notes",
  "Select": "Select",
  "Prescription": "Prescription",
  "Medicine": "Medicine",
  "Dose": "Dose",
  "Enter medicine": "Enter medicine",
  "Enter dose": "Enter dose",
  "Enterdis": "Enter concomitant diseases",
  "Add note": "Add note",
  "Add Content": "Maximum length is 1000 characters.",
  "Other suggestions": "Other suggestions",
  "OK": "OK",
  "HCP": "HCP",
  "Content": "Content",
  "Records Report": "Records Report",

  "Quick Print": "Quick Print",
  "Quick Print Settings": "Quick Print Settings",
  "Select duration": "Select duration",
  "One Week": "One Week",
  "One Month": "One Month",
  "One Quarter": "One Quarter",
  "End date": "End date",
  "Yesterday": "Yesterday",
  "Last Sunday": "Last Sunday",
  "Last Saturday": "Last Saturday",
  "Last Day of Last Month": "Last Day of Last Month",
  "Last Day of Last Quarter": "Last Day of Last Quarter",
  "Customized": "Customize",
  "Week Filter": "Week Filter",
  "Select reports to print": "Select reports to print",
  "Daily Summary": "Daily Summary",
  "Day By Day Overview": "Day by Day Overview",
  "Sensor Overlay": "Sensor Overlay",
  "Trend Analysis": "Trend Analysis",
  "Logbook": "Logbook",
  "Device Settings Review": "Device Settings Review",
  "createReport": "Create Report",

  "Segment Analysis": "Segment Analysis",
  "Sensor Glucose Profile": "Sensor Glucose Percentile",
  "# of Boluses": "# of Boluses",
  "Bolus Insulin": "Bolus Insulin",
  "Basal Pattern": "Basal Pattern",
  "Segment Analysis Report": "Segment Analysis Report",
  "Avg Glucose": "Avg. Glucose",
  "Below": "Below",
  "In Target Range": "In Target Range",
  "Coefficient of variation": "Coefficient of variation",
  "% Time CGM Active": "% Time CGM Active",
  "est_a1c_t1": "Estimated A1C:",
  "est_a1c_t2": "calculated from SG values",
  "est_a1c_t3": "Note: Estimated A1C does not replace lab measurement",

  "acceptTip": " has permitted you to remotely view his/her health information.",
  "cancelTip": " has stopped permitting you to remotely view his/her health information. You can apply again if necessary.",
  "rejectTip": " has rejected your remote view application.",
  "Read": "Read",

  "Connection": "Connection",
  "connections1": "Connections",
  "Add Connection": "Add Connection",
  "SG": "SG",
  "Active Insulin": "Active Insulin",
  "Stop following": "Stop following",
  "Enter username (email)": "Enter username (email)",
  "Search results": "Search results",
  "Send request": "Send request",
  "View graphs": "View graphs",
  "Agree": "Agree",
  "Deny": "Deny",
  "Remove": "Remove",
  "Cancel Requset": "Cancel Requset",
  "Remark": "Remark",

  "Warm up": "Warm up",
  "Monitoring": "Monitoring",
  "Transmitter Error": "Transmitter Error",
  "Sensor Failure": "Sensor Failure",
  "Sensor Expired": "Sensor Expired",
  "Lost Sensor": "Lost Sensor",
  "Not Calibrated": "Not Calibrated",
  "Calibrating": "Calibrating",
  "Calibration Needed": "Calibration Needed",
  "Calibration Error": "Calibration Error",
  "Charging Battery": "Charging Battery",
  "Battery Charged": "Battery Charged",

  "To be filled": "To be filled",
  "Filled with insulin": "Filled with insulin",
  "Priming": "Priming",
  "Priming completed": "Priming completed",
  "Inserting needle": "Inserting needle",
  "Patch activated": "Patch activated",
  "Delivering Basal": "Delivering Basal",
  "Exceeds Max 1 Hour Delivery": "Exceeds Max 1 Hour Delivery",
  "Exceeds Max TDD": "Exceeds Max TDD",
  "Suspend": "Suspend",
  "Occlusion Detected": "Occlusion Detected",
  "Patch Expired": "Patch Expired",
  "Empty Reservoir": "Empty Reservoir",
  "Patch Error": "Patch Error",
  "Pump Base Error": "Pump Base Error",
  "Patch Battery Depleted": "Patch Battery Depleted",
  "Magnetic sensor not calibrated": "Magnetic sensor not calibrated",

  "Patient Profile": "Patient Profile",

  "On": "On",
  "on": "On",
  "Off": "Off",
  "off": "Off",

  "CORONARY_HEART_DISEASE": "Coronary heart disease",
  "HIGH_BLOOD_LIPIDS": "High blood lipids",
  "HIGH_BLOOD_PRESSURE": "High blood pressure",
  "KIDNEY_DISEASE": "Kidney disease",
  "NEUROPATHY": "Neuropathy",
  "OBESITY": "Obesity",
  "PERIPHERAL_ARTERIAL_DISEASE": "Peripheral arterial disease",
  "RETINOPATHY": "Retinopathy",
  "SMOKING_ADDICTION": "Smoking addiction",

  "saveTip": "Saved successfully.",
  "changePaTip": "Your password has been changed.",
  "enterEmTip": "Enter your email address.",
  "verErrTip": "Verification code incorrect.",
  "chooseEventTip": "Choose events to print",
  "chooseDataTip": "Select data to print",
  "dateWrongTip": "The end date cannot be earlier than the start date.",
  "infoWrongTip": "Please fill in all required fields.",
  "createdSuccssTip": "Created successfully",
  "selectData": "Select data to save",

  "acceSu": "Accepted connection request",
  "acceEr": "Failed to add new connection",
  "rejeSu": "Rejected connection request",
  "rejeEr": "Failed to reject request",

  "userNotExist": "The username does not exist.",
  "Password incorrect": "Password incorrect.",
  "UserType incorrect": "Incorrect user type",

  "registSuccess": "Your account has been successfully created.",
  "registFailed": "Failed to register a new account.",
  "sentSuccess": "Message sent successfully",
  "sentFailed": "Failed to send message",
  "Input error": "Input error",

  "deletePtip": "Are you sure you want to delete these patients?",
  "deleteEvents": "Are you sure you want to delete these events?",
  "deleteData": "Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",
  "deleteThis": "Are you sure you want to delete ?",
  "confirm": "Confirm",
  "deleteSuccess": "Deleted successfully",
  "deleteFailed": "Failed to delete item",
  "modifySuccess": "Changed successfully",
  "modifyFailed": "Failed to change",
  "createSuccess": "Created successfully",
  "createFailed": "Create failed",
  "editSuccess": "Edit successfully",
  "editFailed": "Edit failed",
  "Time overlapped": "The sessions you selected overlapped each other.",

  "stopFollow": "Are you sure you want to stop following this patient?",
  "CancelTip1": "Are you sure to you want to delete this connection?",

  "Warning": "Warning",
  "agreeConnect": "If you click “Agree” to accept the connection request, your health data will become available to the new connection.",
  "denyConnect": "Are you sure you want to reject the connection request?",
  "deleteConnect": "Are you sure you want to delete this connection? If you delete him/her, the connection will not be able to view your health data any more.",

  "Choose the events to print": "Choose the events to print",
  "tryAgain": "Try again",
  "username and password is required": "username and password is required",
  "A name is required": "A name is required",
  "username is required": "Username is required",
  "The date choose wrong": "The date choose wrong",
  "Date no more than 14 days": "You cannot select more than 14 days.",

  "CancelTip": "Are you sure you want to delete the connection?",
  "removeConnect": "Deleted successfully",

  "dateErr1": "You cannot select more than 90 days.",
  "dateErr2": "The end date cannot be earlier than the start date.",

  "Not Filled": "Unspecified",
  "Today": "Today",
  "duration": "Duration",
  "interval": "Interval",
  "7 days": "7 days",
  "14 days": "14 days",
  "30 days": "30 days",
  "90 days": "90 days",
  "g": "g",

  "Sound+Vibrate": "Audio+Vibrate",
  "Sound": "Audio",
  "Vibrate": "Vibrate",
  "Silent": "Do not disturb",
  "1": "Once",
  "2": "Daily",
  "noMes": "There is no message.",
  "noConnect": "There is no connection.",
  "Customize": "Customize",
  "GB": "United Kingdom",
  "CN": "China",
  "FR": "France",
  "DD": "Germany",
  "DE": "Germany",
  "SE": "Sweden",
  "AU": "Australia",
  "HKF": "Hongkong",
  "HU": "Hungary",
  "IT": "Italy",
  "NL": "Netherlands",
  "Nor": "Norway",
  "PT": "Portugal",
  "ES": "Spain",
  "TR": "Turkey",

  "Jan": "Jan",
  "Feb": "Feb",
  "Mar": "Mar",
  "Apr": "Apr",
  "May": "May",
  "Jun": "Jun",
  "Jul": "Jul",
  "Aug": "Aug",
  "Sep": "Sep",
  "Oct": "Oct",
  "Nov": "Nov",
  "Dec": "Dec",
  "ApplyTip": " request to view your data.",
  "noReadings": "No Readings",

  "daop_A6_system": "A6 Touchcare System",
  "daop_easytouch_easyview": "EasyTouch / EasyView iPad",
  "daop_TY012_TY015": "TY012/TY015",
  "daop_easysense": "EasySense",
  "daop_delete_data": "Delete Data",
  "daop_uploaded_data": "Uploaded Data",
  "daop_uploaded_data_text": "The data is from EasyTouch App or EasyView iPad App.",
  "daop_realtime_data": "Real-time Data",
  "daop_realtime_data_text": "The data is from EasySense App or EasyPatch App.",

  "ins_unit": "(U)",
  "ins_unit2": "U",
  "basal_unit": "(U/H)",
  "basal_unit2": "U/H",
  "dump_last": "Dump End",

  "Alerts_Patch_Battery_Low": "Patch Battery Low",
  "Alerts_Patch_Battery_Depleted": "Patch Battery Depleted",
  "Alerts_Lost_Pump": "Lost Pump",
  "Alerts_Low_Reservoir": "Low Reservoir",
  "Alerts_Empty_Reservoir": "Empty Reservoir",
  "Alerts_Patch_Expiration_Advisory": "Patch Expiration Advisory",
  "Alerts_Patch_Exp_In_1_Hour": "Patch Exp In 1 Hour",
  "Alerts_Patch_Expired": "Patch Expired",
  "Alerts_Patch_Error": "Patch Error",
  "Alerts_Pump_Base_Error": "Pump Base Error",
  "Alerts_Basal_Rate_Key_Error": "Basal Rate Key Error",
  "Alerts_Occlusion_Detected": "Occlusion Detected",
  "Alerts_End_Of_Suspend": "End Of Suspend",
  "Alerts_Exceeds_Max_TDD": "Exceeds Max TDD",

  "Alerts_Exceeds_Max_1Hr_Delivery": "Exceeds Max 1Hr Delivery",

  "Alerts_Predictive_Low_Suspend": "Predictive Low Suspend",
  "Alerts_Low_Suspend": "Low Suspend",
  "Alerts_Auto_Off": "Auto Off",

  "Alerts_Pump_Restart": "Pump Restart",
  "Alerts_Auto_Off_Warning": "Auto Off Warning",
  "Alerts_Pump_Out_Of_Range": "Pump Out Of Range",

  "Alerts_Lost_Sensor": "Lost Sensor",
  "Alerts_Transmitter_Battery_Low": "Transmitter Battery Low",
  "Alerts_Charge_Transmitter": "Charge Transmitter",
  "Alerts_Sensor_Error": "No Readings",
  "Alerts_Transmitter_Error": "Transmitter Error",
  "Alerts_Sensor_Calibration_Error": "Sensor Calibration Error",

  "Alerts_Sensor_Failure": "Sensor Failure",
  "Alerts_Sensor_Calibration_Reminder": "Sensor Calibration Reminder",
  "Alerts_Meter_BG_Now": "Meter BG Now",
  "Alerts_Sensor_Exp_in_6_Hours": "Sensor Exp in 6 Hours",
  "Alerts_Sensor_Exp_in_2_Hours": "Sensor Exp in 2 Hours",
  "Alerts_Sensor_Exp_in_30_Min": "Sensor Exp in 30 Min",
  "Alerts_Sensor_Expired": "Sensor Expired",
  "Alerts_Rapid_Rise": "Rapid Rise",
  "Alerts_Rapid_Fall": "Rapid Fall",
  "Alerts_High_Predicted": "High Predicted",
  "Alerts_Low_Predicted": "Low Predicted",
  "Alerts_High_Glucose": "High Glucose",
  "Alerts_Low_Glucose": "Low Glucose",
  "Alerts_Below_3.1_mmol/L": "Below 3.1 mmol/L",
  "Alerts_Transmitter_Battery_Low_2": "Transmitter Battery Low",

  "Alerts_PDM_Battery_Low": "PDM Battery Low",
  "Alerts_Replace_Battery": "Charge PDM Now",

  "Alerts_Auto_Mode_Exit": "Auto Mode Exit",
  "Alerts_PDM_Error": "PDM Restart",

  "Alert": "Alert",
  "Alerts": "Alerts",
  "Alert Filter": "Alert Filter",
  "PDM": "PDM",
  "Pump": "Pump",

  "alert_Time": "Time",
  "alert_Type": "Type",

  "Out Of Range": "Out Of Range",

  "Charge Transmitter": "Charge Transmitter",
  "High Predicted": "High Predicted",
  "Low Predicted": "Low Predicted",

  "t1221_Auto_Mode": "Auto Mode",
  "t1221_Time_in_Auto_Mode": "Time in Auto Mode",
  "t1221_Average_SG_SD": "Average SG ± SD",
  "t1221_Time_in_Target_Range": "Time in Target Range",
  "t1221_Time_above_Range": "Time above Range",
  "t1221_Time_below_Range": "Time below Range",
  "t1221_Auto_Basal_per_day": "Auto Basal (per day)",
  "t1221_Auto_Bolus_per_day": "Auto Bolus (per day)",
  "t1221_Auto_Mode_Exits": "Auto Mode Exits",
  "t1221_No_Sensor_readings": "No Sensor readings",
  "t1221_Max_Delivery": "Max Delivery",
  "t1221_Min_Delivery": "Min Delivery",

  "t1222_autoModeBasal": "Auto Mode Basal",
  "t1222_autoModeCorrBolus": "Auto Mode Correct Bolus",
  "t1222_autoSnack": "Auto Snack",
  "t1222_autoBreakfast": "Auto Breakfast",
  "t1222_autoLunch": "Auto Lunch",
  "t1222_autoDinner": "Auto Dinner",
  "t1222_autoExercise": "Auto Exercise",
  "t1222_Snack": "Snack",
  "t1222_auto_basal": "Auto Basal",
  "t1222_auto_bolus": "Auto Bolus",
  "t1222_Auto_Mode": "Auto Mode",
  "t1222_Time_in_Auto_Mode": "Time in Auto Mode(%)",
  "t1222_Avg_SD": "Avg.(mmol/L)±SD",
  "t1222_Target_Range": "Target Range(%)",
  "t1222_Above_Range": "Above Range(%)",
  "t1222_Below_Range": "Below Range(%)",
  "t1222_Auto_Mode_Exits": "# of Auto Mode Exits",

  "t0805_User_Management": "User Management",
  "t0805_Patient_Management": "Patient Management",
  "t0805_Operation_History": "Operation History",
  "t0805_User_List": "User List",
  "t0805_User": "User",
  "t0805_Time": "Time",
  "t0805_Operation_Type": "Operation Type",
  "t0805_Back": "Back",
  "t0805_Add": "Add",
  "t0805_Delete": "Delete",
  "t0809_Add_User": "Add User",
  "t1028_Pattern_C": "Pattern C",
  "t1028_Pattern_D": "Pattern D",
  "t1029_Auto_meal_bolus": "Auto meal bolus",
  "t1029_Auto_mode_correction_bolus": "Auto mode correction bolus",
  "t1029_Sick": "Sick",
  "t1029_Auto_Mode_Feature": "Auto Mode Feature",
  "t1029_Target_SG": "Target SG",
  "t1029_Auto_Meal_Handling": "Auto Meal Handling",
  "t1029_Total_Daily_Dose": "Total Daily Dose",
  "t1029_Pump_Light": "Pump Light",
  "t1029_Alerts_for_Hypo": "Alerts for Hypo",
  "t1102_Out_of_Range": "Out of Range",
  "t1102_Command_Reminder": "Command Reminder",
  "t1102_Alarms_Alerts_on_APP": "Alarms & Alerts on APP",
  "t1102_Alarms_on_App": "Alarms on App",
  "t1102_Alerts_on_App": "Alerts on App",
  "t1102_Factory_Calibration": "Factory Calibration",
  "t1102_Alerts_for_Low": "Alerts for Low",
  "t1102_Alerts_for_High": "Alerts for High",
  "t1102_Alerts_for_Others": "Alerts for Others",
  "t1102_Adjustment": "Adjustment",
  "t1102_Suggested": "Suggested",
  "t1103_Glucose": "Glucose",
  "t1103_CGM": "CGM",
  "t1103_Insulin": "Insulin",
  "t1103_Carbs": "Carbs",
  "t1103_Exercise": "Exercise",
  "t1103_Min_Max": "Min/Max",
  "t1103_Target_Range": "Target Range",
  "t1103_Overall_Tine_In_Range": "Overall: Time In Range",
  "t1103_Basal": "Basal",
  "t1103_Bolus": "Bolus",
  "t1103_Basal_Bolus": "Basal & Bolus",
  "t1103_Auto_Mode_Time_In_Range": "Auto Mode: Time In Range",
  "t1103_Time_below_range": "Time below range",
  "t1103_Time_above_range": "Time above range",
  "t1103_Time_in_target_range": "Time in target range",
  "t1103_Incorrect_Password": "Incorrect Password, $1 Attempt left, please enter the correct Password.",
  "t1103_Incorrect_locked": "Failed Attempts exceed the limit, the account has been locked. Please try again in $1 minutes.",
  "t1104_The_data_is_from": "The data is from EasySense App or EasyPatch App.",
  "t1104_Privacy_Policy": "Privacy Policy and Terms of Use",
  "t1104_updated_privacy_policy": "We have updated our privacy policy and terms of use. Please read and agree to all terms to continue using EasyView.",
  "t1104_Disagree": "Disagree",
  "t1104_Agree": "Agree",
  "t1105_Upload_History": "Upload History",
  "t1105_Delete_Data": "Delete Data",
  "t1105_Target_Range": "Target Range",
  "t1105_request_to_view_your_data": "$1 request to view your data.",
  "t1105_Recent_Updates": "Recent Updates",
  "t1108_No_data": "No data",
  "t1108_Pump_Bash_SN": "Pump Base SN",
  "t1108_Transmitter_SN": "Transmitter SN",
  "t1112_Normal_Glucose": "Normal Glucose",
  "t1112_Manual_Bolus_or_Modified_Bolus": "Manual Bolus or Modified Bolus",
  "t1112_Auto_Mode_Started": "Auto Mode Started",
  "t1112_Auto_Mode_Exit": "Auto Mode Exit",
  "t1112_Normal_Bolus": "Normal Bolus",
  "t1112_Extended_Bolus": "Extended Bolus",
  "t1112_Combo_Bolus": "Combo Bolus",
  "t1112_Carbs": "Carbs",
  "t1112_Glucose": "Glucose",
  "t1112_BG": "BG",
  "t1112_Audio": "Audio",
  "t1112_Tone": "Tone",
  "t1112_Audio_Options": "Audio Options",
  "t1112_Weight_Unit": "Weight Unit",
  "t1112_Height_Unit": "Height Unit",
  "t1112_Not_available": "Not available",
  "t1112_Number": "Number",
  "t1112_days": "# days",
  "t1112_min": "min",
  "t1113_days": "days",
  "t1215_Security": "Security",
  "t1215_MFA": "Multi-factor authentication (MFA)",
  "t1215_Enter_verification_code": "Enter verification code",
  "t1215_Multi_factor_ON": "Multi-factor authentication is ON. Verification code has been sent to $1 Please submit verification code.",
  "t1215_Verification_code_incorrect": "Verification code incorrect",
  "t1215_Show_Glucose_Value": "Show Glucose Value",
  "t1221_enter_verification_code": "Please enter the 6-digit verification code sent to $1.",
  "t1221_Verification_Success": "Verification Success",
  "t1222_We_will_only_process": "We will only process your Healthcare data through Medtrum App/website with your consent.",
  "t1222_If_you_are_under_years": "If you are under 16 years of age, you will need the consent of your parent or legal guardian to register in this App.",
  "t1221_register_cn": "You have the right not to upload any device data to the App, in which case the data will not be accessible to others. If you choose not to register in Medtrum App/website, the only record of your Healthcare data is on the device itself. ",
  "t1221_register_eu": "If you choose to register your Medtrum account and access our App using the account, the healthcare data recorded on the App will be uploaded to our server in Europe and be held for 2 years. You have the right not to upload any device data to the App, in which case the data will not be accessible to others. If you choose not to register in Medtrum App/website, the only record of your Healthcare data is on the device itself.",
  "t1221_register_follow": "We will only process your Healthcare data through Medtrum App/website with your consent.",
  "t1222_Terms_of_Use": "the Terms of Use of Medtrum",
  "t1222_Privacy_Policy": "the Privacy Policy of Medtrum",
  "t1222_Create_Account": "Create Account",
  "t1222_Back": "Back",
  "t1222_Verify_your_account": "Verify your account",
  "t1222_please_check_your_account": "We will send a Verification Code to $1, please check your account.",
  "t1222_I_Agree_to": "I Agree to $1",
  "t1223_Invalid_Verification_Code": "Invalid Verification Code. Please try again."
};

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return esMessages; });

var esMessages = {

  "privacy_policy_and_terms_of_use": "Privacy Policy and Terms of Use ",
  "privacy_confirm_text": "We've updated our <a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>Privacy Policy</a> and <a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>Terms of Use</a>. To continue using EasyView, you need to read and agree to all the terms.",
  "privacy_confirm_disagree": "Disagree",
  "privacy_confirm_accept": "Accept",

  "title": "EasyView Personal",
  "title1": "EasyView Pro",
  "user": "Email",
  "password": "Contraseña",
  "remember": "Recordarme",
  "forget": "¿Ha olvidado la contraseña?",
  "sign in": "Iniciar sesión",
  "login": "Login",
  "sign up now": "Registrarse ahora",
  "apply": "Solicitar ahora",
  "contact us": "Contacte con nosotros",
  "Privacy Policy": "Política de privacidad",
  "Terms of Use": "Términos de uso",
  "copyright": "Copyright ©2017, Medtrum Technologies Inc. Todos los derechos reservados.",

  "chooseLang": "Seleccione su país o idioma",
  "asia": "Asia",
  "europe": "Europa",

  "applyHcp": "Solicitar una cuenta PCM",
  "sign up": "Registrarse",
  "Patient": "Paciente",
  "Caregiver": "Cuidador",
  "Email": "Email",
  "Mobile": "Móvil",
  "Enter email": "Introduzca su email.",
  "Enter mobile": "Introduzca su número de móvil.",
  "Verification": "Código de verificación",
  "Invitation": "Invitation code",
  "full name": "Introduzca su nombre completo",
  "Enter pass": "Vuelva a introducir la contraseña.",
  "org": "Organización",
  "Register": "Registrarse",
  "send": "Enviar",
  "agree": "He leído y estoy de acuerdo ",
  "privacy": "con la política de privacidad  ",
  "and": "y ",
  "use": "los términos de servicio.",
  "errtip1-1": "Debe introducir un email correcto,que se ",
  "errtip1-2": "convertirá en su nombre de usuario Medtrum.",
  "errtip2": "Please enter a valid mobile number.",
  "errtip3": "Código de verificación incorrecto",
  "errtip4": "Incorrect invitation code.",
  "errtip5": "Nombre de usuario incorrecto",
  "errtip6": "Your password must have 8 or more characters.",
  "errtip7": "Introduzca su organización.",

  "errp1": "La contraseña debe contener al menos 3 tipos de los siguientes caracteres: ",
  "errp2": "mayúsculas, minúsculas, número y caracteres especiales.",
  "errp3": "La contraseña debe tener entre 6 y 20 caracteres.",
  "errp4": "La contraseña debe ser diferente del nombre de usuario.",
  "errp5": "La contraseña será inválida si tiene 3 números consecutivos (p.e.: 123 321).",
  "errp6": "La contraseña será inválida si tiene 3 letras consecutivas (p.e.: abc, cba).",
  "errp7": "La contraseña no puede contener espacios.",

  "Find account": "Recuperar su contraseña.",
  "Enter username": "Introduzca su nombre de usuario.",
  "Next": "Siguiente",
  "Cancel": "Cancelar",
  "Back": "Volver atrás",
  "Enter veri": "Enter verification code",
  "Verify notice": "Encuentre el código de verificación enviado por email.",
  "Create new": "Crear una contraseña nueva",
  "Create new notice": "Cree una contraseña nueva. Su contraseña debe tener 6 o más caracteres.",
  "New pass": "Contraseña nueva",
  "Completed": "Completado",
  "Created": "Contraseña nueva creada.",
  "Login Now": "Iniciar sesión ahora",

  "Delete": "Eliminar",
  "New Patient": "Nuevo paciente",
  "Add Patient": "Añadir paciente",
  "Filter": "Filtro",
  "Name": "Nombre",
  "Gender": "Sexo",
  "Age": "Edad",
  "Type": "Tipo",
  "Duration": "Duración",
  "Connections": "Creador de la cuenta",
  "UploadTime": "Tiempo de carga",
  "Year": "años",
  "Years": "años",
  "Month": "mes",
  "Month2": "Mes",
  "Months": "mes",
  "Invite": "Invitar",
  "Invited": "Invitado/a",
  "All": "Todo",
  "Female": "Mujer",
  "Male": "Hombre",
  "Not Set": "Not Set",
  "Type 1": "Tipo 1",
  "Type 2": "Tipo 2",
  "Gestational": "Gestacional",
  "Prediabetes": "Prediabetes",
  "LADA": "Tipo 1.5 LADA",
  "Apply": "Aplicar",
  "disUn": "Tipo de diabetes no especificado",
  "ageUn": "Edad no especificada",
  "genUn": "Sexo no especificado",
  "addP": "Añadir paciente",
  "newP": "Nuevo paciente",
  "findP": "Encontrar paciente",

  "GDRNF": "No especificado",
  "GDRF": "Mujer",
  "GDRM": "Hombre",
  "女": "Hombre",

  "DBTNF": "No especificado",
  "DBT1": "Tipo 1",
  "DBT2": "Tipo 2",
  "DBTLADA": "Tipo 1.5 LADA",
  "DBTPRE": "Prediabetes",
  "DBTGEST": "Gestacional",
  "前期": "beFore",
  "beFore": "beFore",
  "MODY": "Mody",

  "No selection": "No especificado",
  "unspecif": "No especificado",
  "register": "Paciente",
  "hcp": "Médico clínico",

  "BG": "GS",
  "CARB": "Carbs",
  "INS": "Inyección",
  "EXR": "Ejercicio",
  "OTR": "Otro",
  "HBA1C": "HbA1c",
  "DOSE": "DOSE",
  "URINEK": "Cetona en orina",
  "HEL": "HEL",
  "OTR1": "Otro",
  "Loading": "Cargando",

  "home": "Hogar",
  "pID": "ID del paciente",
  "fullName": "Nombre completo",
  "gender": "Sexo",
  "height": "Altura",
  "weight": "Peso",
  "cm": "cm",
  "kg": "kg",
  "birthday": "Fecha de nacimiento",
  "disType": "Tipo de diabetes",
  "disDate": "Fecha de diagnóstico",
  "Address": "Dirección",
  "Postcode": "Código Postal",
  "Inpatient": "Paciente hospitalizado",
  "Yes": "Sí",
  "No": "No",
  "Pno": "Nº de paciente",
  "Bno": "Nº de cama",
  "create": "Crear",
  "Telephone": "Teléfono",

  "enterU": "Introduzca el nombre de usuario (email)",
  "search": "Búsqueda",
  "noU": "Se requiere el nombre de usuario.",
  "searchR": "Resultados de la búsqueda",
  "uername": "Nombre de usuario",
  "alias": "Alias",
  "remove": "Eliminar",
  "viewG": "Visualizar gráficas",
  "sendR": "Enviar solicitud",
  "rSent": "Su solicitud ha sido enviada.",
  "cancelR": "Cancelar petición",

  "VcodeTip1": "¿No lo ha recibido? Espere un minuto e",
  "VcodeTip2": "Inténtelo de nuevo.",
  "VcodeTip3": "Le acabamos de enviar un código de verificación a",
  "Entercode": "Introducir código",
  "Getcode": "Obtener código",

  "messages": "Mensajes",
  "profile": "Perfil",
  "sign out": "Cerrar sesión",
  "changeP": "Cambiar contraseña",
  "connection": "Conexiones",

  "myP": "Mi perfil",
  "Portrait": "Foto de perfil",
  "Profession": "Profesión",
  "DPRONF": "No especificado",
  "DPROENDOCRIN": "Endocrino",
  "DPRODIABTRA": "Educador de diabetes",
  "DPRONURSE": "Enfermero/a",
  "DPRODIATIT": "Dietista",
  "DPROOTR": "Otros PCM",
  "Organization": "Organización",
  "Bio": "Bio",
  "save": "Guardar",
  "oldPa": "Contraseña antigua ",
  "newPa": "Contraseña nueva",
  "RePa": "Vuelva a introducir la contraseña.",
  "forgetY": "¿Ha olvidado su contraseña?",
  "applyM": "Aplicar",
  "oldErr": "La contraseña antigua es incorrecta.",
  "EntTheSame": "Introduzca la nueva contraseña de nuevo.",
  "EnterOld": "Introduzca la contraña antigua.",

  "pList": "Lista de pacientes",
  "connections": "Conexiones",
  "settings": "Configuración",
  "monitor": "Monitorización",
  "graphs": "Informes",
  "events": "Eventos",
  "records": "Historial",
  "qPrint": "Impresión rápida",

  "sensorIn": "Info. del sensor",
  "timeOfLaRead": "Hora de la última lectura del sensor",
  "tranSn": "NS del transmisor:",
  "status": "Estado",
  "sensorLife": "Vida útil restante del sensor",
  "lastSenorRead": "Última lectura del sensor",
  "TranBattery": "Batería del transmisor",
  "sg": "GSe",
  "alert": "Alerta",
  "target": "Objetivo",
  "hypo": "Hipo",
  "sensorGlucose": "Glucosa del sensor (GSe)",
  "calib": "Calibrado",
  "newSen": "Nuevo sensor",
  "warm": "Calentamiento",
  "InsulinPump": "Bomba de insulina",
  "timeOfLaPump": "Hora de los últimos datos de la bomba",
  "pumpSN": "NS de la base de la bomba",
  "ReserviorLife": "Vida útil restante del parche de depósito",
  "InsulinLeft": "Insulina restante",
  "basal": "Basal",
  "bolus": "Bolus",
  "totalBasal": "Basal diaria total",
  "lastBolus": "Último bolus",
  "activeInsulin": "Insulina activa",
  "totalBolus": "Bolus diario total",
  "tampBasal": "Basal Temp",
  "normalBolus": "Bolus Normal",
  "extendBolus": "Bolus Extendido",
  "manualStop": "Manual Suspendido",
  "autoStop": "Auto. Suspendido",
  "auto suspend": "Auto. Suspendido",
  "stop": "Suministro Detenido",
  "newPatch": "Nuevo parche",
  "tempBasal": "Basal Temp",
  "N": "N",
  "E": "E",
  "CN1": "CN",
  "CE": "CE",

  "staticSettings": "Configuración de Informes",
  "dataSource": "Fuente de datos",
  "unit": "Unidad",
  "glucoseTarget": "Rango Objetivo de Glucosa",
  "overall": "General",
  "Hypoglycemia": "Hipoglucemia",
  "timePeriod": "Periodo de tiempo",
  "postMeal": "Análisis después de comida",
  "Breakfast": "Desayuno",
  "Lunch": "Almuerzo",
  "Dinner": "Cena",
  "night": "Hora de noche",
  "Before": "Antes",
  "After": "Después",
  "Low": "Baja",
  "High": "Alta",
  "From": "Desde",
  "To": "Hasta",
  "Hours": "horas",
  "Reset": "Restaurar predeterminados",
  "RealTime": "Tiempo real",
  "uploaded": "Descargado",
  "sensor": "Sensor",
  "pdmSN": "NS del PDM",
  "startTime": "Hora de inicio",
  "endTime": "Hora de finalización",
  "uploadTime": "Tiempo de carga",
  "pdm": "PDM",
  "Uploaded": "Descargado",
  "Patch Pump": "Patch Pump",
  "overLapp": "Sessions overlapped",

  "daily": "Resumen diario",
  "date": "Fecha",
  "print": "Imprimir",
  "carbs": "Carbohidratos",
  "exercise": "Ejercicio",
  "heavy": "Pesado",
  "Medium": "Medio",
  "Light": "Ligero",
  "dailyReport": "Informe Resumen Diario",
  "devices": "Dispositivos",
  "tran": "Transmisor",
  "pumpBase": "Base de bomba",
  "HbA1c": "HbA1c",
  "statics": "Estadísticas",
  "glucose": "Glucosa",
  "item": "Elemento",
  "BG1": "GS",
  "SG1": "GSe",
  "avgSD": "Media (mmol/L)±SD",
  "avgSD1": "Media±SD",
  "min": "Mín",
  "max": "Máx",
  "ofRead": "# de lecturas",
  "ofHypo": "# de hipo/duración(min)",
  "ofAlert": "# de alertas",
  "insulin": "Insulina",
  "insulin2": "Insulina",
  "totalDose": "Dosis diaria total",
  "foodBolus": "Bolus de comida",
  "Food+coor": "comida+corr",
  "calibBolus": "Bolus correctivo",
  "durationStop": "Duración de la suspensión (min)",
  "ofPumpAlert": "# de alarmas de bomba",
  "ofMeal": "# de comidas",
  "totalExerTime": "Tiempo total de ejercicio",
  "exerNum": "# de ejercicios",
  "avgInten": "Intensidad media",
  "target1": "Objetivo",
  "high1": "ALTA",
  "low1": "BAJA",
  "BG Reading": "Lecturas GS",

  "dayByday": "Vista general del día a día",
  "dayBydayRe": "Informe de vista general del día a día",
  "period": "Periodo",

  "sensorOverlay": "Superposición del sensor",
  "set": "Configurar",
  "setPeriod": "Configurar periodo",
  "Weekdays": "Días entre semana",
  "Weekends": "Fines de semana",
  "Mon": "Lun",
  "Tue": "Mar",
  "Wed": "Mie",
  "Thur": "Jue",
  "Thu": "Jue",
  "Fri": "Vie",
  "Sat": "Sáb",
  "Sun": "Dom",
  "Average": "Media",
  "sensorOlRe": "Informe de superposición del sensor",
  "Avg": "Media",
  "±SD": "±SD",
  "ofhypo": "# de Hipo",
  "Everyday": "Cada día",

  "TrendAna": "Análisis de tendencia",
  "TrendRe": "Informe de análisis de tendencia",
  "sensorGlu": "Glucosa del sensor ",
  "ofBGtest": "# de pruebas de GS",
  "Basics": "Básicas",
  "static": "Estadísticas",
  "Med": "Med",
  "med": "median",
  "Q1": "C1",
  "Q3": "C3",
  "Q11": "C1",
  "Q31": "C3",
  "IQR": "RIC",
  "SD": "SD",
  "CV": "CV",
  "SE1": "EE de la Media",
  "distri": "Distribución",
  "stab": "Estabilidad",
  "#high": "# de alta",
  "#low": "# de baja",
  "aucBelow": "ABC bajo el límite",
  "aucAbove": "ABC encima del límite",
  "bgRead": "Lecturas GS",
  "total": "Total",
  "ofBolus": "# de bolus",
  "avgBolus": "Bolus de media",
  "Dura1": "Duración (min)",
  "Avg/Total": "Media/Total",
  "high": "Alta",
  "low": "Baja",
  "#hypo": "# de Hipo",
  "ofExer": "# de ejercicios",

  "logbook": "Registro",
  "dailyTotal": "Total Diario",
  "High Glucose": "Glucosa Alta",
  "Low Glucose": "Glucosa Baja",
  "No Active Patch": "No parche activo",
  "Missed Meal": "Comida perdida",
  "Multiple BG Readings": "Lecturas GS múltiples",
  "Stop Patch": "Detener parche",
  "Others": "Otros",
  "Other Events": "Otros Eventos",
  "logRe": "Informe de registro",

  "DeviceSetting": "Revisión de configuración del dispositivo",
  "Insulin Pump": "Bomba de insulina",
  "MaxBasalRate": "Tasa Basal Máxima",
  "BasalPatterns": "Patrones Basales",
  "Selected Basal Pattern": "Seleccione un patrón basal",
  "Maximum Bolus": "Bolus Máximo",
  "Combo/Extended Bolus": "Bolus Combo/Extendido",
  "BG Reminder": "Recordatorio GS",
  "Bolus Increment": "Incremento de Bolus",
  "Bolus Calculator": "Calculadora Bolus",
  "Active Insulin Time": "Tiempo de insulina activa",
  "IC Ratios": "Ratios IC ",
  "Insulin Sensitivity": "Sensibilidad de insulina",
  "BG Target": "Objetivo GS",
  "Bolus Reminder": "Recordatorio de bolus",
  "CGM": "CGM",
  "CGM System": "Sistema CGM",
  "Glucose Unit": "Unidades de Glucosa",
  "Glucose Limits": "Límites de glucosa",
  "Predicitive Alerts": "Alertas predictivas",
  "Rate Alerts": "Alertas de ratio",
  "type": "Tipo",
  "time": "Hora",
  "data": "Fecha",
  "Rate": "Ratio",
  "Calibration Reminder": "Recordatorio de calibrado",
  "Calibration Repeat": "Repetir calibrado",
  "Snooze": "Silenciar",
  "Audio Options": "Opciones de audio",
  "Confidence Reminder": "Recordatorio de confianza",
  "Backlight": "Retroiluminación",
  "Sec": "Seg",
  "Alarm Clock": "Despertador",
  "Patch Expiration": "Caducidad del parche",
  "Sensor Expiration": "Caducidad del sensor",
  "Hourly Max": "Máx por hora",
  "Daily Max": "Máx diario",
  "Low Reservoir": "Depósito bajo",
  "Low Suspend": "Suspender Bajo",
  "Predictive Low Suspend": "Suspender Bajo Predictivo",
  "Rise": "Subida",
  "Fall": "Bajada",
  "Auto Off": "Auto Desact",
  "Standard": "Estándar",
  "Exercise": "Ejercicio",
  "Holiday": "Vacaciones",
  "ProgramA": "Patrón A",
  "ProgramB": "Patrón B",
  "--": "--",
  "Insulin": "insulina",

  "SUSA": "Auto Desact.",
  "SUSHM": "Sobrepasa el máx. suministro de 1 hora",
  "SUSDM": "Sobrepasa la DDT Máx",
  "SUSLSG": "Suspender Bajo",
  "SUSPLSG": "Suspender Bajo Predictivo",
  "Pump Restarted": "Bomba restaurada",
  "Meter BG Now": "Medir GS Ahora",
  "Sensor Exp in 2 Hours": "Sensor caduca en 2 Horas",
  "Sensor Exp in 6 Hours": "Sensor caduca en 6 Horas",
  "Sensor Exp in 30 Min": "Sensor caduca en 30 Min",
  "Sensor Calibration Error": "Error Calib Sensor",
  "Sensor Error": "Sin lecturas",

  "Device Settings Report": "Informe de configuración de dispositivo",
  "24h Total": "24H totales",
  "Device Settings at": "Configuración del dispositivo alas",
  "Start": "Inicio",
  "Combo/Ext Bolus": "Bolus Combo/Extendido",
  "Time Format": "Formato de hora",
  "Device Options（CGM System)": "Opciones de dispositivo (Sistema CGM)",
  "Device Options（Insulin Pump)": "Opciones de dispositivo (Bomba de insulina)",
  "Dispay Settings (Screen)": "Configuración de pantalla (pantalla)",
  "Dispay Settings (Backlight)": "Configuración de pantalla (retroiluminación)",
  "Graph Range": "Rango de gráfica",
  "Range": "Rango",
  "Repeat": "Repetir",
  "Glucose Alerts": "Alertas de glucosa",
  "Alert Silence": "Silenciar Alerta",

  "Create": "Crear",
  "Event Filter": "Filtro de evento",
  "HbA1c1": "HbA1c",
  "Urine Ketone": "Cetona en orina",
  "Injection": "Inyección",
  "Other": "Otro",
  "Event Type": "Tipo de evento",
  "Details": "Detalles",
  "Notes": "Notas",
  "Source": "Fuente",
  "edit": "Editar",
  "Action": "Acción",
  "EventReport": "Informe Resumen Evento",
  "By Date": "Por Fecha",
  "By Category": "Por Categoría",
  "Event Summary": "Resumen de evento",
  "No data": "No hay datos",
  "No1": "Sin",
  "data1": "datos",
  "#": "#",
  "BG Summary": "Resumen GS",
  "Carbs Summary": "Resumen Carbs",
  "Injection Summary": "Resumen Inyección",
  "Exercise Summary": "Resumen Ejercicio",
  "Input Notes": "Introducir una nota",

  "Profile": "Perfil",
  "Complications": "Complicaciones",
  "Concomitant diseases": "Enfermedades concurrentes",
  "Suggestion": "Sugerencia",
  "Coronary heart disease": "Cardiopatía coronaria",
  "High blood lipids": "Lípidos de hipertensión",
  "High blood pressure": "Hipertensión arterial",
  "Kidney disease": "Enfermedad del riñón",
  "Neuropathy": "Neuropatía",
  "Obesity": "Obesidad",
  "Peripheral arterial disease": "Enfermedad arterial periférica",
  "Retinopathy": "Retinopatía",
  "Smoking addiction": "Adicción al tabaco",
  "Enter date": "Introduzca la fecha",
  "Enter suggestion": "Introduzca la sugerencia",
  "Enter Notes": "Introduzca la nota",
  "Select": "Seleccionar",
  "Prescription": "Prescripción",
  "Medicine": "Medicina",
  "Dose": "Dosis",
  "Enter medicine": "Introduzca la medicina",
  "Enter dose": "Introduzca la dosis",
  "Enterdis": "Enter concomitant diseases",
  "Add note": "Añadir nota",
  "Add Content": "La longitud máxima es de 1000 caracteres.",
  "Other suggestions": "Otras sugerencias",
  "OK": "Aceptar",
  "HCP": "PCM",
  "Content": "Contenido",
  "Records Report": "Informe de registros",

  "Quick Print": "Impresión rápida",
  "Quick Print Settings": "Configuración de la impresión rápida",
  "Select duration": "Seleccionar duración",
  "One Week": "Una semana",
  "One Month": "Un mes",
  "One Quarter": "Un trimestre",
  "End date": "Fecha de finalización",
  "Yesterday": "Ayer",
  "Last Sunday": "Último domingo",
  "Last Saturday": "Último Sábado",
  "Last Day of Last Month": "Last Day of Last Month",
  "Last Day of Last Quarter": "Last Day of Last Quarter",
  "Customized": "Personalizar",
  "Week Filter": "Filtro de semana",
  "Select reports to print": "Seleccione los informes a imprimir",
  "Daily Summary": "Resumen diario",
  "Day By Day Overview": "Vista general del día a día",
  "Sensor Overlay": "Superposición del sensor",
  "Trend Analysis": "Análisis de tendencia",
  "Logbook": "Registro",
  "Device Settings Review": "Revisión de configuración del dispositivo",
  "createReport": "Crear informe",

  "Segment Analysis": "Análisis de segmento",
  "Sensor Glucose Profile": "Perfil de glucosa del sensor",
  "# of Boluses": "# de bolus",
  "Bolus Insulin": "Insulina de bolus",
  "Basal Pattern": "Patrón basal",
  "Segment Analysis Report": "Informe de análisis de segmento",
  "Avg Glucose": "Glucosa de media",
  "Below": "Inferior a",
  "In Target Range": "En rango objetivo",
  "Coefficient of variation": "Coeficiente de variación",
  "% Time CGM Active": "& tiempo de CGM activo",
  "est_a1c_t1": "A1C estimado: ",
  "est_a1c_t2": "calculado a partir de valores de GS",
  "est_a1c_t3": "Nota: A1C estimado no sustituye la medición de laboratorio",

  "acceptTip": " ha permitido que visualice de forma remota su información de salud. ",
  "cancelTip": " ha dejado de permitir que visualice de forma remota su información de salud. Puede solicitarlo de nuevo si es necesario.",
  "rejectTip": " ha rechazado su solicitud de visualización remota.",
  "Read": "Lectura",

  "Connection": "Conexión",
  "connections1": "Connections",
  "Add Connection": "Añadir conexión",
  "SG": "GSe",
  "Active Insulin": "Insulina Activa",
  "Stop following": "Detener seguimiento",
  "Enter username (email)": "Introduzca el nombre de usuario (email)",
  "Search results": "Resultados de la búsqueda",
  "Send request": "Enviar solicitud",
  "View graphs": "Visualizar gráficas",
  "Agree": "Estoy de acuerdo",
  "Deny": "Denegar",
  "Remove": "Eliminar",
  "Cancel Requset": "Cancelar solicitud",
  "Remark": "Nota",

  "Warm up": "Calentamiento",
  "Monitoring": "Monitorizando",
  "Transmitter Error": "Error del transmisor",
  "Sensor Failure": "Fallo del sensor",
  "Sensor Expired": "Sensor Caducado",
  "Lost Sensor": "Sensor Perdido",
  "Not Calibrated": "No calibrado",
  "Calibrating": "Calibrando",
  "Calibration Needed": "Calibrado necesario",
  "Calibration Error": "Error de calibrado",
  "Charging Battery": "Batería cargándose",
  "Battery Charged": "Batería cargada",

  "To be filled": "Debe rellenarse",
  "Filled with insulin": "Rellenado con insulina",
  "Priming": "Cebando",
  "Priming completed": "Cebado completado",
  "Inserting needle": "Insertando aguja",
  "Patch activated": "Parche desactivado.",
  "Delivering Basal": "Suministrando Basal",
  "Exceeds Max 1 Hour Delivery": "Sobrepasa el máx. suministro de 1 hora",
  "Exceeds Max TDD": "Sobrepasa la DDT Máx",
  "Suspend": "Suspender",
  "Occlusion Detected": "Oclusión detectada",
  "Patch Expired": "Parche caducado",
  "Empty Reservoir": "Depósito vacío",
  "Patch Error": "Error de parche",
  "Pump Base Error": "Error de base de bomba",
  "Patch Battery Depleted": "Batería de parche agotada",
  "Magnetic sensor not calibrated": "Sensor magnético no calibrado",

  "Patient Profile": "Perfil del peciente",
  "On": "Activar",
  "on": "Activar",
  "Off": "Desactivar",
  "off": "Desactivar",

  "CORONARY_HEART_DISEASE": "Cardiopatía coronaria",
  "HIGH_BLOOD_LIPIDS": "Lípidos de hipertensión",
  "HIGH_BLOOD_PRESSURE": "Hipertensión arterial",
  "KIDNEY_DISEASE": "Enfermedad del riñón",
  "NEUROPATHY": "Neuropatía",
  "OBESITY": "Obesidad",
  "PERIPHERAL_ARTERIAL_DISEASE": "Enfermedad arterial periférica",
  "RETINOPATHY": "Retinopatía",
  "SMOKING_ADDICTION": "Adicción al tabaco",

  "saveTip": "Guardado correctamente.",
  "changePaTip": "Su contraseña ha sido modificada.",
  "enterEmTip": "Introduzca su email.",
  "verErrTip": "Código de verificación incorrecto.",
  "chooseEventTip": "Seleccione los eventos a imprimir",
  "chooseDataTip": "Seleccionar datos a imprimir",
  "dateWrongTip": "La fecha de finalización no puede ser anterior a la fecha de inicio.",
  "infoWrongTip": "Rellene todos los campos requeridos.",
  "createdSuccssTip": "Creado correctamente",
  "selectData": "Seleccionar datos a guardar",

  "acceSu": "Petición de conexión aceptada",
  "acceEr": "No se pudo añadir una nueva conexión",
  "rejeSu": "Petición de conexión rechazada",
  "rejeEr": "No se pudo rechazar la petición",

  "userNotExist": "El nombre de usuario no existe.",
  "Password incorrect": "Contraseña incorrecta.",
  "UserType incorrect": "Tipo de usuario incorrecto",

  "registSuccess": "Su cuenta se ha creado correctamente.",
  "registFailed": "No se pudo registrar una nueva cuenta.",
  "sentSuccess": "Mensaje enviado correctamente",
  "sentFailed": "No se pudo enviar el mensaje",
  "Input error": "Error de entrada",

  "deletePtip": "¿Está seguro/a que desea eliminar estos pacientes?",
  "deleteEvents": "¿Está seguro/a que desea eliminar estos eventos?",
  "deleteData": "Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",
  "deleteThis": "¿Está seguro/a que desea eliminarlos?",
  "confirm": "Confirmar",
  "deleteSuccess": "Eliminado correctamente",
  "deleteFailed": "No se pudo eliminar el elemento",
  "modifySuccess": "Modificado correctamente",
  "modifyFailed": "No se pudo modificar",
  "createSuccess": "Creado correctamente",
  "createFailed": "Fallo en la creación",
  "editSuccess": "Editado correctamente",
  "editFailed": "Fallo en la edición",
  "Time overlapped": "Las sesiones que ha seleccionado se solapan entre sí.",
  "showAlert": "Mostrar alertas",

  "dashboard": "Panel de mandos",
  "dboard_glucose_statistics": "Estadísticas",
  "dboard_glucose": "Glucosa",
  "dboard_cgm": "CGM",
  "dboard_insulin": "Insulina",
  "dboard_carbs": "Carbohidratos",
  "dboard_exercise": "Ejercicio",
  "dboard_glucose_avg": "Media",
  "dboard_cgm_avg": "Media",
  "dboard_insulin_avg": "Dosis Diaria Media",
  "dboard_carbs_avg": "Carbohidratos medios/Diario",
  "dboard_exercise_avg": "Tiempo medio/Diario",
  "dboard_sd": "SD",
  "dboard_num": "#",
  "dboard_num_days": "# days",
  "dboard_statistics": "Estadísticas",
  "dboard_BG": "GS",
  "dboard_BG_calibration": "GS/Calibrado (por día)",
  "dboard_SG": "GSe",
  "dboard_AUC_high": "AUC alta >",
  "dboard_AUC_low": "AUC baja <",
  "dboard_highest_value": "Valor más alto",
  "dboard_lowest_value": "Valor más bajo",

  "dboard_pump": "Bomba",
  "dboard_avg_daily_dose": "Dosis Diaria Media",
  "dboard_SD": "SD",
  "dboard_daily_basal": "Basal diario",
  "dboard_daily_bolus": "Bolus diario",
  "dboard_avg_bolus_num": "Nº de bolus medio por día",
  "dboard_avg_suspend_time": "Tiempo de suspensión medio",
  "dboard_avg_reservoir_usage": "Uso de reserva medio",
  "dboard_days": "days",

  "dboard_manual_bolus": "Bolus manual (volumen/nº por día)",
  "dboard_normal": "-Normal",
  "dboard_extend": "-Extendido",
  "dboard_combo": "-Combo",

  "dboard_bolus_calculator": "Calculadora de bolus (volumen/nº por día)",
  "dboard_food_bolus": "-Calc. de bolus de comida",
  "dboard_corr_bolus": "-Calc. de bolus de corrección",
  "dboard_override_add": "-Anulación(+)",
  "dboard_override_sub": "-Anulación(-)",

  "dboard_report": "Panel de mandos informe",

  "stopFollow": "¿Está seguro/a de que desea dejar de seguir a este/a paciente?",
  "CancelTip1": "¿Está seguro/a de que desea eliminar esta conexión?",

  "Warning": "Advertencia",
  "agreeConnect": "Si hace clic en 'Aceptar' para aceptar la petición de conexión, sus datos de salud estarán disponibles para la nueva conexión.",
  "denyConnect": "¿Está seguro/a de que desea rechazar la petición de conexión?",
  "deleteConnect": "¿Está seguro/a de que desea eliminar esta conexión? Si lo/la eliminar, la conexión no será capaz de visualizar sus datos de salud.",

  "Choose the events to print": "Seleccione los eventos a imprimir",
  "tryAgain": "Inténtelo de nuevo",
  "username and password is required": "username and password is required",
  "A name is required": "Se requiere un nombre.",
  "username is required": "Se requiere el nombre de usuario.",
  "The date choose wrong": "La fecha elegida es incorrecta",
  "Date no more than 14 days": "No puede seleccionar más de 14 días.",

  "CancelTip": "¿Está seguro/a de que desea eliminar la conexión?",
  "removeConnect": "Eliminado correctamente",

  "dateErr1": "You cannot select more than 90 days.",
  "dateErr2": "La fecha de finalización no puede ser anterior a la fecha de inicio.",

  "Not Filled": "No especificado",
  "Today": "Hoy",
  "duration": "Duración",
  "interval": "Interval",
  "7 days": "7 días",
  "14 days": "14 días",
  "30 days": "30 días",
  "90 days": "90 días",
  "g": "g",

  "Sound+Vibrate": "Audio+Vibración",
  "Sound": "Audio",
  "Vibrate": "Vibración",
  "Silent": "No molestar",

  "1": "Una vez",
  "2": "Diariamente",
  "noMes": "No hay ningún mensaje.",
  "noConnect": "No hay ninguna conexión.",
  "Customize": "Personalizar",

  "GB": "United Kingdom",
  "CN": "China",
  "FR": "France",
  "DD": "Germany",
  "DE": "Germany",
  "SE": "Sweden",
  "AU": "Australia",
  "HKF": "Hongkong",
  "HU": "Hungary",
  "IT": "Italy",
  "NL": "Netherlands",
  "Nor": "Norway",
  "PT": "Portugal",
  "ES": "Spain",
  "TR": "Turkey",

  "Jan": "Ene",
  "Feb": "Feb",
  "Mar": "Mar",
  "Apr": "Abr",
  "May": "May",
  "Jun": "Jun",
  "Jul": "Jul",
  "Aug": "Ago",
  "Sep": "Sep",
  "Oct": "Oct",
  "Nov": "Nov",
  "Dec": "Dic",
  "ApplyTip": " solicitud para ver sus datos.",
  "noReadings": "Sin lecturas",

  "daop_A6_system": "A6 Touchcare System",
  "daop_easytouch_easyview": "EasyTouch / EasyView iPad",
  "daop_TY012_TY015": "TY012/TY015",
  "daop_easysense": "EasySense",
  "daop_delete_data": "Delete Data",
  "daop_uploaded_data": "Datos cargados",
  "daop_uploaded_data_text": "Los datos provienen de la App EasyTouch o la App EasyView para iPad.",
  "daop_realtime_data": "Datos en tiempo real",
  "daop_realtime_data_text": "The data is from EasySense App or EasyPatch App.",

  "ins_unit": "(U)",
  "ins_unit2": "U",
  "basal_unit": "(U/H)",
  "basal_unit2": "U/H",

  "Alerts_Patch_Battery_Low": "Batería de parche baja",
  "Alerts_Patch_Battery_Depleted": "Batería de parche agotada",
  "Alerts_Lost_Pump": "Lost Pump",
  "Alerts_Low_Reservoir": "Depósito bajo",
  "Alerts_Empty_Reservoir": "Depósito vacío",
  "Alerts_Patch_Expiration_Advisory": "Caducidad recomendada del parche",
  "Alerts_Patch_Exp_In_1_Hour": "Patch Exp In 1 Hour",
  "Alerts_Patch_Expired": "Parche caducado",
  "Alerts_Patch_Error": "Error de parche",
  "Alerts_Pump_Base_Error": "Error de base de bomba",
  "Alerts_Basal_Rate_Key_Error": "Basal Rate Key Error",
  "Alerts_Occlusion_Detected": "Oclusión detectada",
  "Alerts_End_Of_Suspend": "End Of Suspend",
  "Alerts_Exceeds_Max_TDD": "Sobrepasa la DDT Máx",
  "Alerts_Exceeds_Max_1Hr_Delivery": "Sobrepasa el suministro máx de 1 H",

  "Alerts_Predictive_Low_Suspend": "Suspender Bajo Predictivo",
  "Alerts_Low_Suspend": "Suspender Bajo",
  "Alerts_Auto_Off": "Auto Desact.",

  "Alerts_Pump_Restart": "Pump Restart",
  "Alerts_Auto_Off_Warning": "Auto Off Warning",
  "Alerts_Pump_Out_Of_Range": "Pump Out Of Range",

  "Alerts_Lost_Sensor": "Sensor Perdido",
  "Alerts_Transmitter_Battery_Low": "Batería baja del transmisor",
  "Alerts_Charge_Transmitter": "Cargar Transmisor",
  "Alerts_Sensor_Error": "Sin lecturas",
  "Alerts_Transmitter_Error": "Error del transmisor",
  "Alerts_Sensor_Calibration_Error": "Sensor Calibration Error",

  "Alerts_Sensor_Failure": "Fallo del sensor",
  "Alerts_Sensor_Calibration_Reminder": "Sensor Calibration Reminder",
  "Alerts_Meter_BG_Now": "Medir GS Ahora",
  "Alerts_Sensor_Exp_in_6_Hours": "Sensor caduca en 6 Horas",
  "Alerts_Sensor_Exp_in_2_Hours": "Sensor caduca en 2 Horas",
  "Alerts_Sensor_Exp_in_30_Min": "Sensor caduca en 30 Min",
  "Alerts_Sensor_Expired": "Sensor Caducado",
  "Alerts_Rapid_Rise": "Subida rápida",
  "Alerts_Rapid_Fall": "Caída Rápida",
  "Alerts_High_Predicted": "Alta predictiva",
  "Alerts_Low_Predicted": "Baja Predictiva",
  "Alerts_High_Glucose": "Glucosa Alta",
  "Alerts_Low_Glucose": "Glucosa Baja",
  "Alerts_Below_3.1_mmol/L": "Inferior a 3,1 mmol/L",
  "Alerts_Transmitter_Battery_Low_2": "Batería baja del transmisor",

  "Alerts_PDM_Battery_Low": "Pila baja del PDM",
  "Alerts_Replace_Battery": "Cargar PDM ya",

  "Alert": "Alert",
  "Alerts": "Alertas",
  "Alert Filter": "Alert Filter",
  "PDM": "PDM",
  "Pump": "Bomba",


  "Out Of Range": "Out Of Range",
  "t1221_Time_in_Auto_Mode": "Tiempo en el Modo Automático",
  "t1221_Average_SG_SD": "Promedio GS ± DE",
  "t1221_Time_in_Target_Range": "Tiempo en Rango Objetivo",
  "t1221_Time_above_Range": "Tiempo por encima del Rango",
  "t1221_Time_below_Range": "Tiempo por debajo del Rango",
  "t1221_Auto_Basal_per_day": "Auto Basal (por día)",
  "t1221_Auto_Bolus_per_day": "Auto Bolo (por día)",
  "t1221_Auto_Mode_Exits": "Salidas del Modo Automático",
  "t1221_No_Sensor_readings": "No hay lecturas de sensor",
  "t1221_Max_Delivery": "Administración Máxima",
  "t1221_Min_Delivery": "Administración Mínima",
  "t1222_autoModeBasal": "Basal del Modo automático",
  "t1222_autoModeCorrBolus": "Bolo de Corrección del Modo Automático",
  "t1222_autoSnack": "Automático Merienda",
  "t1222_autoBreakfast": "Automático Desayuno",
  "t1222_autoLunch": "Automático Almuerzo",
  "t1222_autoDinner": "Automático Cena",
  "t1222_autoExercise": "Automático Ejercicio",
  "t1222_Snack": "Merienda",
  "t1222_Auto_Mode": "Modo Automático",
  "t1222_Time_in_Auto_Mode": "Tiempo en Modo Automático(%)",
  "t1222_Avg_SD": "Promedio (mg/dL)±DE",
  "t1222_Target_Range": "Rango objetivo(%)",
  "t1222_Above_Range": "Por encima del rango(%)",
  "t1222_Below_Range": "Por debajo del rango(%)",
  "t1222_Auto_Mode_Exits": "# de salidas del modo automático",
  "t1221_Auto_Mode": "Modo Automático",
  "t1222_auto_basal": "Basal Auto",
  "t1222_auto_bolus": "Bolus Auto",
  "t0805_User_Management": "Gestión de usuarios",
  "t0805_Patient_Management": "El manejo del paciente",
  "t0805_Operation_History": "Historial de operaciones",
  "t0805_User_List": "Lista de usuarios",
  "t0805_User": "Usuario",
  "t0805_Time": "Tiempo",
  "t0805_Operation_Type": "Tipo de operación",
  "t0805_Back": "Volver atrás",
  "t0805_Add": "Añadir",
  "t0805_Delete": "Eliminar",
  "t0809_Add_User": "Agregar usuario",
  "t1028_Pattern_C": "Patrón C",
  "t1028_Pattern_D": "Patrón D",
  "t1029_Auto_meal_bolus": "Bolo de comida automático",
  "t1029_Auto_mode_correction_bolus": "Bolo de corrección del modo automático",
  "t1029_Sick": "Enfermo/a",
  "t1029_Auto_Mode_Feature": "Modo Auto Feator",
  "t1029_Target_SG": "GSe Objetivo",
  "t1029_Auto_Meal_Handling": "Gestión Comida Auto",
  "t1029_Total_Daily_Dose": "Dosis Diario Total",
  "t1029_Pump_Light": "Luz de bomba",
  "t1029_Alerts_for_Hypo": "Alertas para Hipo.",
  "t1102_Out_of_Range": "Fuera de rango",
  "t1102_Command_Reminder": "Recordatorio de Mando",
  "t1102_Alarms_Alerts_on_APP": "Alarmas y Alertas de la Bomba",
  "t1102_Alarms_on_App": "Alarmas Act. en la App",
  "t1102_Alerts_on_App": "Alarmas Act. en la App",
  "t1102_Factory_Calibration": "Calibrado de fábrica",
  "t1102_Alerts_for_Low": "Alertas para Baja",
  "t1102_Alerts_for_High": "Alertas para Alta",
  "t1102_Alerts_for_Others": "Alertas para Otros",
  "t1102_Adjustment": "Ajuste",
  "t1102_Suggested": "Sugerido",
  "t1103_Glucose": "Glucosa",
  "t1103_CGM": "CGM",
  "t1103_Insulin": "Insulina",
  "t1103_Carbs": "Carbs",
  "t1103_Exercise": "Ejercicio",
  "t1103_Min_Max": "Mín./Máx.",
  "t1103_Target_Range": "Rango objetivo",
  "t1103_Overall_Tine_In_Range": "Total: Tiempo En Rango",
  "t1103_Basal": "Basal",
  "t1103_Bolus": "Bolus",
  "t1103_Basal_Bolus": "Basal & Bolus",
  "t1103_Auto_Mode_Time_In_Range": "Modo automático: Tiempo En Rango",
  "t1103_Time_below_range": "Tiempo por debajo del rango",
  "t1103_Time_above_range": "Tiempo por encima del rango",
  "t1103_Time_in_target_range": "Tiempo en rango objetivo",
  "t1103_Incorrect_Password": "Contraseña incorrecta, $1 Intento restante, ingrese la contraseña correcta.",
  "t1103_Incorrect_locked": "Los intentos fallidos superan el límite, la cuenta se ha bloqueado. Vuelva a intentarlo en $1 minutos.",
  "t1104_The_data_is_from": "Los datos provienen de la App EasySense o la App EasyPatch.",
  "t1104_Privacy_Policy": "Política de privacidad y Condiciones de uso",
  "t1104_updated_privacy_policy": "Hemos actualizado nuestra política de privacidad y condiciones de uso. Léalas cuidadosamente y acepte las nuevas condiciones antes de usar EasyPatch.",
  "t1104_Disagree": "No acepto",
  "t1104_Agree": "Estoy de acuerdo",
  "t1105_Upload_History": "Historial de carga",
  "t1105_Delete_Data": "Borrar datos",
  "t1105_Target_Range": "Rango objetivo",
  "t1105_request_to_view_your_data": "Solicitud de $1 para ver sus datos.",
  "t1105_Recent_Updates": "Actualizaciones recientes",
  "t1108_No_data": "No hay datos",
  "t1108_Pump_Bash_SN": "NS de la base de la bomba",
  "t1108_Transmitter_SN": "NS del transmisor",
  "t1112_Normal_Glucose": "Glucosa Normal",
  "t1112_Manual_Bolus_or_Modified_Bolus": "Bolus manual o bolus modificado",
  "t1112_Auto_Mode_Started": "Suministro suspendido",
  "t1112_Auto_Mode_Exit": "Modo Auto Iniciado",
  "t1112_Normal_Bolus": "Bolus normal",
  "t1112_Extended_Bolus": "Bolus extendido",
  "t1112_Combo_Bolus": "Bolus Combo",
  "t1112_Carbs": "Carbohidratos",
  "t1112_Glucose": "Glucosa",
  "t1112_BG": "GS",
  "t1112_Audio": "Audio",
  "t1112_Tone": "Tono",
  "t1112_Audio_Options": "Opciones de audio",
  "t1112_Weight_Unit": "Unidad De Peso",
  "t1112_Height_Unit": "Unidad De Altura",
  "t1112_Not_available": "No Disponible",
  "t1112_Number": "Número",
  "t1112_days": "# días",
  "t1112_min": "min",
  "t1113_days": "días",
  "t1215_Security": "Seguridad",
  "t1215_MFA": "Autenticación multifactor (MFA)",
  "t1215_Enter_verification_code": "Ingrese el código de verificación",
  "t1215_Multi_factor_ON": "La autenticación multifactor está activada. Se ha enviado el código de verificación a $1 Envíe el código de verificación.",
  "t1215_Verification_code_incorrect": "Código de verificación incorrecto",
  "t1215_Show_Glucose_Value": "Mostrar valor de glucosa",
  "t1221_enter_verification_code": "Ingrese el código de verificación de 6 dígitos enviado a $1.",
  "t1221_Verification_Success": "Verificado con éxito",
  "t1222_We_will_only_process": "Solo procesaremos sus datos de cuidado de salud a través de la página web/App de Medtrum con su consentimiento. ",
  "t1222_If_you_are_under_years": "Si es menor de 16 años, necesitará el consentimiento de sus padres o representante legal para registrarse en esta App.",
  "t1221_register_cn": "Tiene el derecho de no cargar datos de dispositivos a la App, en cuyo caso los datos no serán accesibles por otras personas. Si elige no registrarse en la página web/App de Medtrum, el único registro de sus datos de cuidado de salud estará en el mismo dispositivo. ",
  "t1221_register_eu": "Si elige registrarse en su cuenta de Medtrum y acceder a nuestra App usando dicha cuenta, los datos de cuidado de salud registrados en la App serán cargados en nuestras servidores de Europa y se conservarán durante 2 años. Tiene el derecho de no cargar datos de dispositivos a la App, en cuyo caso los datos no serán accesibles por otras personas. Si elige no registrarse en la página web/App de Medtrum, el único registro de sus datos de cuidado de salud estará en el mismo dispositivo.",
  "t1221_register_follow": "Solo procesaremos sus datos de cuidado de salud a través de la página web/App de Medtrum con su consentimiento.",
  "t1222_Terms_of_Use": "las Condiciones de Uso de Medtrum",
  "t1222_Privacy_Policy": "la Política de Privacidad de Medtrum",
  "t1222_Create_Account": "Crear Cuenta",
  "t1222_Back": "Volver atrás",
  "t1222_Verify_your_account": "Verifica tu cuenta",
  "t1222_please_check_your_account": "Enviaremos un código de verificación a $1, verifique su cuenta.",
  "t1222_I_Agree_to": "Estoy de acuerdo con $1",
  "t1223_Invalid_Verification_Code": "Código de verificación invalido. Inténtalo de nuevo."
};

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fiMessages; });

var fiMessages = {

  "privacy_policy_and_terms_of_use": "Privacy Policy and Terms of Use ",
  "privacy_confirm_text": "We've updated our <a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>Privacy Policy</a> and <a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>Terms of Use</a>. To continue using EasyView, you need to read and agree to all the terms.",
  "privacy_confirm_disagree": "Disagree",
  "privacy_confirm_accept": "Accept",

  "title": "EasyView Personal",
  "title1": "EasyView Pro",
  "user": "Sähköposti",
  "password": "Salasana",
  "remember": "Muista minut",
  "forget": "Unohtuiko salasana?",
  "sign in": "Kirjaudu sisään",
  "login": "Login",
  "sign up now": "Rekisteröidy nyt",
  "apply": "Pyydä avaamaan tili",
  "contact us": "Yhteystiedot",
  "Privacy Policy": "Tietosuojaseloste",
  "Terms of Use": "Käyttöehdot",
  "copyright": "Copyright © 2017, Medtrum Technologies Inc. Kaikki oikeudet pidätetään.",

  "chooseLang": "Valitse maa tai kieli",
  "asia": "Aasia",
  "europe": "Eurooppa",
  "middleEast": "Middle East",

  "applyHcp": "Pyydä avaamaan terveydenhuollon ammattilaisen tili",
  "sign up": "Rekisteröidy",
  "Patient": "Potilas",
  "Caregiver": "Hoitaja",
  "Email": "Sähköposti",
  "Mobile": "Matkapuhelin",
  "Enter email": "Anna sähköpostiosoite",
  "Enter mobile": "Enter mobile number",
  "Verification": "Vahvistuskoodi",
  "Invitation": "Invitation code",
  "full name": "Anna koko nimi",
  "Enter pass": "Anna salasana",
  "org": "Laitos",
  "Register": "Register",
  "send": "Lähetä",
  "createAccount": "Create Account",
  "agree": "Olen lukenut Medtrumin tietosuojaselosteen ja käyttöehdot ja hyväksyn ne.",
  "privacy": "",
  "and": "",
  "use": "",
  "errtip1-1": "Sinun on annettava kelvollinen sähköpostiosoite. Sitä käytetään Medtrum-käyttäjänimenäsi.",
  "errtip1-2": "",
  "errtip2": "Please enter a valid mobile number.",
  "errtip3": "Väärä vahvistuskoodi",
  "errtip4": "Incorrect invitation code.",
  "errtip5": "Väärä käyttäjänimi",
  "errtip6": "Your password must have 8 or more characters.",
  "errtip7": "Anna laitoksesi.",

  "errp1": "Salasanassa täytyy olla vähintään kolmea seuraavista merkkityypeistä:isot kirjaimet, pienet kirjaimet, numerot ja erikoismerkit.",
  "errp2": "",
  "errp3": "Salasanan on oltava 6–20 merkkiä pitkä.",
  "errp4": "Salasana ei saa olla sama kuin käyttäjänimi.",
  "errp5": "Kolme peräkkäistä numeroa sisältävä salasana ei kelpaa (esim: 123, 321).",
  "errp6": "Kolme peräkkäistä kirjainta sisältävä salasana ei kelpaa (esim: abc, cba).",
  "errp7": "Salasanassa ei voi olla välilyöntejä.",

  "Find account": "Nouda salasana.",
  "Enter username": "Anna käyttäjänimesi.",
  "Next": "Seuraava",
  "Cancel": "Peruuta",
  "Back": "Takaisin",
  "Enter veri": "Enter verification code",
  "Verify notice": "Etsi sähköpostitse lähetetty vahvistuskoodi.",
  "Create new": "Luo uusi salasana",
  "Create new notice": "Luo uusi salasana. Salasanassa on oltava vähintään 6 merkkiä.",
  "New pass": "Uusi salasana",
  "Completed": "Valmis",
  "Created": "Uusi salasana on luotu.",
  "Login Now": "Kirjaudu sisään",

  "Delete": "Poista",
  "New Patient": "New Patient",
  "Add Patient": "Lisää potilas",
  "Filter": "Suodatin",
  "Name": "Nimi",
  "Gender": "Sukupuoli",
  "Age": "Ikä",
  "Type": "Tyyppi",
  "Duration": "Kesto",
  "Connections": "Tilin luoja",
  "UploadTime": "Latausaika",
  "Year": "Vuosi",
  "Years": "Vuotta",
  "Month": "Kuukausi",
  "Month2": "Kuukausi",
  "Months": "months",
  "Invite": "Kutsu",
  "Invited": "Kutsuttu",
  "All": "Kaikki",
  "Female": "Nainen",
  "Male": "Mies",
  "Not Set": "Not Set",
  "Type 1": "Tyyppi 1",
  "Type 2": "Tyyppi 2",
  "Gestational": "Raskausdiabetes",
  "Prediabetes": "Esidiabetes",
  "LADA": "Tyyppi 1.5 LADA",
  "Apply": "Käytä",
  "disUn": "Diabetestyyppiä ei määritetty",
  "ageUn": "Ikää ei määritetty",
  "genUn": "Sukupuolta ei määritetty",
  "addP": "Lisää potilas",
  "newP": "Uusi potilas",
  "findP": "Etsi potilas",

  "GDRNF": "Määrittämätön",
  "GDRF": "Nainen",
  "GDRM": "Mies",
  "女": "Male",

  "DBTNF": "Määrittämätön",
  "DBT1": "Tyyppi 1",
  "DBT2": "Tyyppi 2",
  "DBTLADA": "Tyyppi 1.5 LADA",
  "DBTPRE": "Esidiabetes",
  "DBTGEST": "Raskausdiabetes",
  "前期": "beFore",
  "beFore": "beFore",
  "MODY": "Mody",

  "No selection": "No selection",
  "unspecif": "Määrittämätön",
  "register": "Potilas",
  "hcp": "Vahvista",

  "BG": "VS",
  "CARB": "Hiilihydr.",
  "INS": "Pistos",
  "EXR": "Liikunta",
  "OTR": "Muu",
  "HBA1C": "HbA1c",
  "DOSE": "Annos",
  "URINEK": "Virtsan ketonipitoisuus",
  "HEL": "HEL",
  "OTR1": "Muu",
  "Loading": "Ladataan",

  "home": "Etusivu",
  "pID": "Potilastunnus",
  "fullName": "Koko nimi",
  "gender": "Sukupuoli",
  "height": "Pituus",
  "weight": "Paino",
  "cm": "cm",
  "kg": "kg",
  "birthday": "Syntymäaika",
  "disType": "Diabetestyyppi",
  "disDate": "Taudin toteamispäivä",
  "Address": "Osoite",
  "Postcode": "Postinumero",
  "Inpatient": "Sairaalapotilas",
  "Yes": "Kyllä",
  "No": "Ei",
  "Pno": "Potilasnro",
  "Bno": "Vuodenro",
  "create": "Luo",
  "Telephone": "Puhelin",

  "enterU": "Anna käyttäjänimi (sähköposti)",
  "search": "Etsi",
  "noU": "Käyttäjänimi on pakollinen.",
  "searchR": "Hakutulokset",
  "uername": "Käyttäjänimi",
  "alias": "Alias",
  "remove": "Poista",
  "viewG": "Näytä käyrät",
  "sendR": "Lähetä pyyntö",
  "rSent": "Pyyntösi on lähetetty.",
  "cancelR": "Peruuta pyyntö",

  "VcodeTip1": "Etkö saanut sitä? Odota minuutin ajan ja yritä uudestaan.",
  "VcodeTip2": "Yritä uudestaan",
  "VcodeTip3": "Lähetimme juuri vahvistuskoodin ",
  "Entercode": "Anna koodi",
  "Getcode": "Tilaa koodi",

  "messages": "Viestit",
  "profile": "Profiili",
  "sign out": "Kirjaudu ulos",
  "changeP": "Vaihda salasana",
  "connection": "Yhteydet",

  "myP": "Oma profiili",
  "Portrait": "Profiilikuva",
  "Profession": "Ammatti",
  "DPRONF": "Määrittämätön",
  "DPROENDOCRIN": "Endokrinologi",
  "DPRODIABTRA": "Diabeteshoitaja",
  "DPRONURSE": "Sairaanhoitaja",
  "DPRODIATIT": "Ravitsemusterapeutti",
  "DPROOTR": "Muu terveydenhuollon ammattilainen",
  "Organization": "Laitos",
  "Bio": "Esittely",
  "save": "Tallenna",
  "oldPa": "Vanha salasana ",
  "newPa": "Uusi salasana",
  "RePa": "Anna salasana uudelleen",
  "forgetY": "Unohtuiko salasana?",
  "applyM": "Käytä",
  "oldErr": "Vanha salasana on väärä.",
  "EntTheSame": "Anna uusi salasana uudelleen.",
  "EnterOld": "Anna vanha salasana.",

  "pList": "Potilasluettelo",
  "connections": "Connections",
  "settings": "Asetukset",
  "monitor": "Seuranta",
  "graphs": "Raportit",
  "events": "Tapahtumat",
  "records": "Tallenteet",
  "qPrint": "Pikatulostus",

  "sensorIn": "Sensorin tiedot",
  "timeOfLaRead": "Sensorin viimeisimmän lukeman aika",
  "tranSn": "Lähettimen sarjanro",
  "status": "Tila",
  "sensorLife": "Sensorilla käyttöaikaa",
  "lastSenorRead": "Sensorin viimeisin lukema",
  "TranBattery": "Lähettimen akku",
  "sg": "SG",
  "alert": "Varoitus",
  "target": "Tavoite",
  "hypo": "Hypo",
  "sensorGlucose": "Sensorin glukoosi",
  "calib": "Kalibrointi",
  "newSen": "Uusi sensori",
  "warm": "Lämpenee",
  "InsulinPump": "Insuliinipumppu",
  "timeOfLaPump": "Pumpun viimeisimpien tietojen aika",
  "pumpSN": "Pumppuosan sarjanro",
  "ReserviorLife": "Säiliölaastarilla käyttöaikaa",
  "InsulinLeft": "Insuliinia jäljellä",
  "basal": "Perusinsuliini",
  "bolus": "Bolus",
  "totalBasal": "Perusinsuliinia vrk yhteensä",
  "lastBolus": "Viimeisin bolus",
  "activeInsulin": "Aktiivinen insuliini",
  "totalBolus": "Bolusinsuliinia vrk:ssa",
  "tampBasal": "Väliaik. perusannos",
  "normalBolus": "Normaali bolus",
  "extendBolus": "Pitkä bolus",
  "manualStop": "Manuaal. pys.",
  "autoStop": "Auto Suspend",
  "auto suspend": "Automaattinen pysäytys",
  "stop": "Annon pysäytys",
  "newPatch": "Uusi laastari",
  "tempBasal": "Väliaik. perusannos",
  "N": "N",
  "E": "E",
  "CN1": "CN",
  "CE": "CE",

  "staticSettings": "Raporttiasetukset",
  "dataSource": "Tarkasteltavat tiedot",
  "unit": "Yksikkö",
  "glucoseTarget": "Glukoositavoitteen vaihteluväli",
  "overall": "Yht.",
  "Hypoglycemia": "Hypoglykemia",
  "timePeriod": "Ajanjakso",
  "postMeal": "Aterianjälkeinen analyysi",
  "Breakfast": "Aamiainen",
  "Lunch": "Lounas",
  "Dinner": "Päivällinen",
  "night": "Yöllä",
  "Before": "Ennen",
  "After": "Jälkeen",
  "Low": "Matala",
  "High": "Korkea",
  "From": "Alku",
  "To": "Loppu",
  "Hours": "Tuntia",
  "Reset": "Palauta oletusarvot",
  "RealTime": "Reaaliaikainen",
  "uploaded": "Ladattu",
  "sensor": "Sensori",
  "pdmSN": "PDM:n sarjanro",
  "startTime": "Aloitusaika",
  "endTime": "Lopetusaika",
  "uploadTime": "Latausaika",
  "pdm": "PDM",
  "Uploaded": "Ladattu",
  "Patch Pump": "Laastaripumppu",
  "overLapp": "Päällekkäiset käyttöajat",
  "showAlert": "Näytä varoitukset",

  "dashboard": "Dashboard",
  "dboard_glucose_statistics": "Glucose Statistics",
  "dboard_glucose": "Glucose",
  "dboard_cgm": "CGM",
  "dboard_insulin": "Insulin",
  "dboard_carbs": "Carbs",
  "dboard_exercise": "Exercise",
  "dboard_glucose_avg": "Average",
  "dboard_cgm_avg": "Average",
  "dboard_insulin_avg": "Average Daily Dose",
  "dboard_carbs_avg": "Average Carbs/Day",
  "dboard_exercise_avg": "Average time/Day",
  "dboard_sd": "SD",
  "dboard_num": "#",
  "dboard_num_days": "# days",
  "dboard_statistics": "Statistics",
  "dboard_BG": "BG",
  "dboard_BG_calibration": "BG / calibration (per day)",
  "dboard_SG": "SG",
  "dboard_AUC_high": "AUC high >",
  "dboard_AUC_low": "AUC low <",
  "dboard_highest_value": "Highest value",
  "dboard_lowest_value": "Lowest value",

  "dboard_pump": "Pump",
  "dboard_avg_daily_dose": "Average Daily Dose",
  "dboard_SD": "SD",
  "dboard_daily_basal": "Daily Basal",
  "dboard_daily_bolus": "Daily Bolus",
  "dboard_avg_bolus_num": "Average bolus no. per day",
  "dboard_avg_suspend_time": "Average Suspend time",
  "dboard_avg_reservoir_usage": "Average reservoir usage",
  "dboard_days": "days",

  "dboard_manual_bolus": "Manual bolus (volume/no. per day)",
  "dboard_normal": "-Normal",
  "dboard_extend": "-Extended",
  "dboard_combo": "-Combo",

  "dboard_bolus_calculator": "Bolus Calculator (volume/no. per day)",
  "dboard_food_bolus": "-Food bolus calc.",
  "dboard_corr_bolus": "-Corr bolus calc.",
  "dboard_override_add": "-Override(+)",
  "dboard_override_sub": "-Override(-)",

  "dboard_report": "Dashboard Report",

  "daily": "Päivittäinen yhteenveto",
  "date": "Pvm",
  "print": "Tulosta",
  "carbs": "Hiilihydr.",
  "exercise": "Liikunta",
  "heavy": "Rasitt.",
  "Medium": "Kohtal.",
  "Light": "Kevyt",
  "dailyReport": "Päivittäinen yhteenvetoraportti",
  "devices": "Laitteet",
  "tran": "Lähetin",
  "pumpBase": "Pumppuosa",
  "HbA1c": "HbA1c",
  "statics": "Tilastotiedot",
  "glucose": "Glukoosi",
  "item": "Kohde",
  "BG1": "VS",
  "SG1": "SG",
  "avgSD": "Keskiarvo (mmol/L)±SD",
  "avgSD1": "Keskiarvo±SD",
  "min": "Minimi",
  "max": "Maksimi",
  "ofRead": "Lukemien määrä",
  "ofHypo": "Hypogl. määrä/kesto",
  "ofAlert": "Varoitusten määrä",
  "insulin": "Insuliini",
  "insulin2": "Insuliini",
  "totalDose": "Vuorokauden kokonaisannos",
  "foodBolus": "Ateriabolus",
  "Food+coor": "Food+corr",
  "calibBolus": "Korjausbolus",
  "durationStop": "Keskeytyksen kesto (min)",
  "ofPumpAlert": "Pumpun hälytysten määrä",
  "ofMeal": "Aterioiden määrä",
  "totalExerTime": "Kokonaisliikunta-aika",
  "exerNum": "Liikuntaharjoitusten määrä",
  "avgInten": "Keskimääräinen rasittavuus",
  "target1": "Tavoite",
  "high1": "Korkea",
  "low1": "Matala",
  "BG Reading": "VS-lukemat",

  "dayByday": "Päiväkohtaiset yleistiedot",
  "dayBydayRe": "Päiväkohtaiset yleistiedot",
  "period": "Ajanjakso",

  "sensorOverlay": "Sensoripeittokuva",
  "set": "Aseta",
  "setPeriod": "Aseta ajanjakso",
  "Weekdays": "Arkipäivät",
  "Weekends": "Viikonloput",
  "Mon": "Ma",
  "Tue": "Ti",
  "Wed": "Ke",
  "Thur": "To",
  "Thu": "To",
  "Fri": "Pe",
  "Sat": "La",
  "Sun": "Su",
  "Average": "Keskiarvo",
  "sensorOlRe": "Sensorin peittokuvaraportti",
  "Avg": "Keskiarvo",
  "±SD": "±SD",
  "ofhypo": "Hypogl. määrä",
  "Everyday": "joka päivä",

  "TrendAna": "Trendianalyysi",
  "TrendRe": "Trendianalyysiraportti",
  "sensorGlu": "Sensorin glukoosi ",
  "ofBGtest": "# of BG tests",
  "Basics": "Perustiedot",
  "static": "Tilastotiedot",
  "Med": "Mediaani",
  "med": "median",
  "Q1": "Alakvartiili",
  "Q3": "Yläkvartiili",
  "Q11": "Alakvartiili",
  "Q31": "Yläkvartiili",
  "IQR": "Kvartiiliväli",
  "SD": "Keskihajonta",
  "CV": "Variaatiokerroin",
  "SE1": "Keskiarvon keskivirhe",
  "distri": "Jakauma",
  "stab": "Stabiilius",
  "#high": "Korkeiden määrä",
  "#low": "Matalien määrä",
  "aucBelow": "AUC-arvo alarajan alapuolella",
  "aucAbove": "AUC-arvo ylärajan yläpuolella",
  "bgRead": "VS-lukemat",
  "total": "Avg Daily Total",
  "avg_daily_basal": "Avg Daily Basal",
  "avg_daily_bolus": "Avg Daily Bolus",
  "ofBolus": "Boluksien määrä",
  "avgBolus": "Keskimääräinen bolus",
  "Dura1": "Kesto (min)",
  "Avg/Total": "Keskiarvo/yhteensä",
  "high": "Korkea",
  "low": "Matala",
  "#hypo": "Hypogl. määrä",
  "ofExer": "Liikuntaharjoitusten määrä",

  "logbook": "Lokikirja",
  "dailyTotal": "Vrk yhteensä",
  "High Glucose": "Korkea glukoosi",
  "Low Glucose": "Matala glukoosi",
  "No Active Patch": "Ei laastaria käytössä",
  "Missed Meal": "Ateria unohtui",
  "Multiple BG Readings": "Useat VS-lukemat",
  "Stop Patch": "Pysäytä laastari",
  "Others": "Others",
  "Other Events": "Muut tapahtumat",
  "logRe": "Lokikirjaraportti",

  "DeviceSetting": "Näytä laiteasetukset",
  "Insulin Pump": "Insuliinipumppu",
  "MaxBasalRate": "Maksimiperusannos",
  "BasalPatterns": "Perusannostelumallit",
  "Selected Basal Pattern": "Valittu perusannostelumalli",
  "Maximum Bolus": "Maksimibolus",
  "Combo/Extended Bolus": "Yhdistelmäbolus / pitkä bolus",
  "BG Reminder": "VS-muistutus",
  "Bolus Increment": "Boluksen erä",
  "Bolus Calculator": "Boluslaskuri",
  "Active Insulin Time": "Aktiivisen insuliinin aika",
  "IC Ratios": "IH-suhteet",
  "Insulin Sensitivity": "Insuliiniherkkyyskerroin",
  "BG Target": "VS-tavoite",
  "Bolus Reminder": "Bolusmuistutus",
  "CGM": "CGM",
  "CGM System": "CGM-järjestelmä",
  "Glucose Unit": "Glukoosin yksikkö",
  "Glucose Limits": "Glukoosirajat",
  "Predicitive Alerts": "Ennakoivat varoitukset",
  "Rate Alerts": "Nopeushälytykset",
  "type": "Tyyppi",
  "time": "Aika",
  "data": "Pvm",
  "Rate": "Rate",
  "Calibration Reminder": "Kalibrointimuistutus",
  "Calibration Repeat": "Kalibroinnin toisto",
  "Snooze": "Torkku",
  "Audio Options": "Ääniasetukset",
  "Confidence Reminder": "Kuittausmuistutus",
  "Backlight": "Taustavalo",
  "Sec": "s",
  "Alarm Clock": "Herätyskello",
  "Patch Expiration": "Laastarin vanhent.",
  "Sensor Expiration": "Sensorin vanhent.",
  "Hourly Max": "Tunnin maks.",
  "Daily Max": "Vrk:n maks.",
  "Low Reservoir": "Säiliö lähes tyhjä",
  "Low Suspend": "Alarajapysäytys",
  "Predictive Low Suspend": "Ennakoiva alarajapysäytys",
  "Rise": "Nousu",
  "Fall": "Lasku",
  "Auto Off": "Autom pys",
  "Standard": "Vakio",
  "Exercise": "Liikunta",
  "Holiday": "Loma",
  "ProgramA": "Malli A",
  "ProgramB": "Malli B",
  "--": "--",
  "Insulin": "Insuliini",

  "SUSA": "Autom pys",
  "SUSHM": "Yli 1 tunnin maksimin",
  "SUSDM": "Ylittää vuorokauden maksimin",
  "SUSLSG": "Alarajapysäytys",
  "SUSPLSG": "Ennakoiva alarajapysäytys",
  "Pump Restarted": "Pumppu käynnistetty uudelleen",
  "Meter BG Now": "Mittaa VS nyt",
  "Sensor Exp in 2 Hours": "Sensori vanhenee: 2 h",
  "Sensor Exp in 6 Hours": "Sensori vanhenee: 6 h",
  "Sensor Exp in 30 Min": "Sensori vanh.: 30 min",
  "Sensor Calibration Error": "Sensorin kalibr.virhe",
  "Sensor Error": "Sensorin virhe",

  "Device Settings Report": "Laiteasetusten raportti",
  "24h Total": "24 h yhteensä",
  "Device Settings at": "Laiteasetukset",
  "Start": "Alku",
  "Combo/Ext Bolus": "Yhd./pitkä bolus",
  "Time Format": "Kellonajan muoto",
  "Device Options（CGM System)": "Laiteasetukset (CGM-järjestelmä)",
  "Device Options（Insulin Pump)": "Laiteasetukset (insuliinipumppu)",
  "Dispay Settings (Screen)": "Näytön asetukset (näyttöruutu)",
  "Dispay Settings (Backlight)": "Näytön asetukset (taustavalo)",
  "Graph Range": "Käyräalue",
  "Range": "Range",
  "Repeat": "Toista",
  "Glucose Alerts": "Glukoosivaroit.",
  "Alert Silence": "Var. vaiennus",

  "Create": "Luo",
  "Event Filter": "Tapahtumasuodatin",
  "HbA1c1": "HbA1c",
  "Urine Ketone": "Virtsan ketonipitoisuus",
  "Injection": "Pistos",
  "Other": "Muu",
  "Event Type": "Tap.tyyppi",
  "Details": "Tiedot",
  "Notes": "Huomautukset",
  "Source": "Lähde",
  "edit": "Muokkaa",
  "Action": "Toimi",
  "EventReport": "Tapahtumien yhteenvetoraportti",
  "By Date": "Päivämäärän mukaan",
  "By Category": "Luokan mukaan",
  "Event Summary": "Tapahtumien yhteenveto",
  "No data": "Ei tietoja",
  "No1": "No",
  "data1": "data",
  "#": "Määrä",
  "BG Summary": "VS: yhteenveto",
  "Carbs Summary": "Hiilihydr.: yhteenveto",
  "Injection Summary": "Pistokset: yhteenveto",
  "Exercise Summary": "Liikunta: yhteenveto",
  "Input Notes": "Lisää huomautus",

  "Profile": "Profiili",
  "Complications": "Komplikaatiot",
  "Concomitant diseases": "Samanaikaiset sairaudet",
  "Suggestion": "Ehdotus",
  "Coronary heart disease": "Sepelvaltimotauti",
  "High blood lipids": "Veren suuri lipidipitoisuus",
  "High blood pressure": "Korkea verenpaine",
  "Kidney disease": "Munuaissairaus",
  "Neuropathy": "Neuropatia",
  "Obesity": "Lihavuus",
  "Peripheral arterial disease": "Perifeerinen valtimotauti",
  "Retinopathy": "Retinopatia",
  "Smoking addiction": "Tupakkariippuvuus",
  "Enter date": "Anna päivämäärä",
  "Enter suggestion": "Anna ehdotus",
  "Enter Notes": "Enter Notes",
  "Select": "Valitse",
  "Prescription": "Resepti",
  "Medicine": "Lääke",
  "Dose": "Annos",
  "Enter medicine": "Ilmoita lääke",
  "Enter dose": "Ilmoita annos",
  "Enterdis": "Enter concomitant diseases",
  "Add note": "Lisää huomautus",
  "Add Content": "Maksimipituus on 1 000 merkkiä.",
  "Other suggestions": "Muut ehdotukset",
  "OK": "OK",
  "HCP": "Terveydenhuollon ammattilainen",
  "Content": "Sisältö",
  "Records Report": "Tallenneraportti",

  "Quick Print": "Pikatulostus",
  "Quick Print Settings": "Pikatulostuksen asetukset",
  "Select duration": "Valitse kesto",
  "One Week": "Viikko",
  "One Month": "Kuukausi",
  "One Quarter": "Vuosineljännes",
  "End date": "Lopetuspäivä",
  "Yesterday": "Eilen",
  "Last Sunday": "Viime sunnuntai",
  "Last Saturday": "Viime lauantai",
  "Last Day of Last Month": "Last Day of Last Month",
  "Last Day of Last Quarter": "Last Day of Last Quarter",
  "Customized": "Mukauta",
  "Week Filter": "Viikkosuodatin",
  "Select reports to print": "Valitse tulostettavat raportit",
  "Daily Summary": "Päivittäinen yhteenveto",
  "Day By Day Overview": "Päiväkohtaiset yleistiedot",
  "Sensor Overlay": "Sensoripeittokuva",
  "Trend Analysis": "Trendianalyysi",
  "Logbook": "Lokikirja",
  "Device Settings Review": "Näytä laiteasetukset",
  "createReport": "Luo raportti",

  "Segment Analysis": "Segmenttianalyysi",
  "Sensor Glucose Profile": "Sensorin glukoosiprofiili",
  "# of Boluses": "Boluksien määrä",
  "Bolus Insulin": "Bolusinsuliini",
  "Basal Pattern": "Perusannostelumalli",
  "Segment Analysis Report": "Segmenttianalyysiraportti",
  "Avg Glucose": "Keskimääräinen glukoosi",
  "Below": "Alle",
  "In Target Range": "Tavoitearvoalueella",
  "Coefficient of variation": "Variaatiokerroin",
  "% Time CGM Active": "Aika (%), kun CGM aktiivinen",
  "est_a1c_t1": "Estimated A1C:",
  "est_a1c_t2": "calculated from SG values",
  "est_a1c_t3": "Note: Estimated A1C does not replace lab measurement",

  "acceptTip": " on antanut sinulle luvan terveystietojensa etäkatseluun. ",
  "cancelTip": " on peruuttanut sinulle antamansa luvan terveystietojensa etäkatseluun. Voit pyytää lupaa tarvittaessa uudelleen.",
  "rejectTip": " on evännyt pyyntösi tietojen etäkatseluun.",
  "Read": "Lue",

  "Connection": "Yhteys",
  "connections1": "Yhteydet",
  "Add Connection": "Lisää yhteys",
  "SG": "SG",
  "Active Insulin": "Akt. insuliini",
  "Stop following": "Pysäytä seuranta",
  "Enter username (email)": "Anna käyttäjänimi (sähköposti)",
  "Search results": "Hakutulokset",
  "Send request": "Lähetä pyyntö",
  "View graphs": "Näytä käyrät",
  "Agree": "Hyväksy",
  "Deny": "Älä hyväksy",
  "Remove": "Poista",
  "Cancel Requset": "Peruuta pyyntö",
  "Remark": "Huomautus",

  "Warm up": "Lämpenee",
  "Monitoring": "Monitoring",
  "Transmitter Error": "Lähettimen virhe",
  "Sensor Failure": "Sensorin vika",
  "Sensor Expired": "Sensori vanhentunut",
  "Lost Sensor": "Sensori puuttuu",
  "Not Calibrated": "Ei kalibroitu",
  "Calibrating": "Kalibroidaan",
  "Calibration Needed": "Täytyy kalibroida",
  "Calibration Error": "Kalibrointivirhe",
  "Charging Battery": "Akkua ladataan",
  "Battery Charged": "Akku ladattu",

  "To be filled": "Pitää täyttää",
  "Filled with insulin": "Täytetty insuliinilla",
  "Priming": "Esitäyttö",
  "Priming completed": "Esitäyttö valmis",
  "Inserting needle": "Neulaa asetetaan paikalleen",
  "Patch activated": "Laastari otettu käyttöön",
  "Delivering Basal": "Annetaan perusinsuliinia",
  "Exceeds Max 1 Hour Delivery": "Yli 1 tunnin maksimin",
  "Exceeds Max TDD": "Ylittää vuorokauden maksimin",
  "Suspend": "Pysäytys",
  "Occlusion Detected": "Tukkeuma havaittu",
  "Patch Expired": "Laastari vanhentunut",
  "Empty Reservoir": "Tyhjä säiliö",
  "Patch Error": "Laastarin virhe",
  "Pump Base Error": "Pumppuosan virhe",
  "Patch Battery Depleted": "Laastarin paristo tyhjä",
  "Magnetic sensor not calibrated": "Magnetic sensor not calibrated",

  "Patient Profile": "Potilasprofiili",

  "On": "Kyllä",
  "on": "Kyllä",
  "Off": "Ei",
  "off": "Ei",

  "CORONARY_HEART_DISEASE": "Sepelvaltimotauti",
  "HIGH_BLOOD_LIPIDS": "Veren suuri lipidipitoisuus",
  "HIGH_BLOOD_PRESSURE": "Korkea verenpaine",
  "KIDNEY_DISEASE": "Munuaissairaus",
  "NEUROPATHY": "Neuropatia",
  "OBESITY": "Lihavuus",
  "PERIPHERAL_ARTERIAL_DISEASE": "Perifeerinen valtimotauti",
  "RETINOPATHY": "Retinopatia",
  "SMOKING_ADDICTION": "Tupakkariippuvuus",

  "saveTip": "Tallennus onnistui.",
  "changePaTip": "Salasana on vaihdettu.",
  "enterEmTip": "Anna sähköpostiosoitteesi.",
  "verErrTip": "Väärä vahvistuskoodi.",
  "chooseEventTip": "Valitse tulostettavat tapahtumat",
  "chooseDataTip": "Valitse tulostettavat tiedot",
  "dateWrongTip": "Lopetuspäivä ei saa olla ennen aloituspäivää.",
  "infoWrongTip": "Täytä kaikki pakolliset kentät.",
  "createdSuccssTip": "Luonti onnistui",
  "selectData": "Valitse tallennettavat tiedot",

  "acceSu": "Yhteyspyyntö hyväksytty",
  "acceEr": "Uuden yhteyden lisäys epäonnistui",
  "rejeSu": "Yhteyspyyntö evätty",
  "rejeEr": "Pyynnön epäys epäonnistui",

  "userNotExist": "Käyttäjänimeä ei ole.",
  "Password incorrect": "Väärä salasana.",
  "UserType incorrect": "Väärä käyttäjätyyppi",

  "registSuccess": "Tilin luonti onnistui.",
  "registFailed": "Uuden tilin rekisteröinti epäonnistui.",
  "sentSuccess": "Viestin lähetys onnistui",
  "sentFailed": "Viestin lähetys epäonnistui",
  "Input error": "Syöttövirhe",

  "deletePtip": "Haluatko varmasti poistaa nämä potilaat?",
  "deleteEvents": "Haluatko varmasti poistaa nämä tapahtumat?",
  "deleteData": "Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",
  "deleteThis": "Haluatko varmasti poistaa?",
  "confirm": "Vahvista",
  "deleteSuccess": "Poisto onnistui",
  "deleteFailed": "Kohteen poisto epäonnistui",
  "modifySuccess": "Vaihto onnistui",
  "modifyFailed": "Vaihto epäonnistui",
  "createSuccess": "Created successfully",
  "createFailed": "Create failed",
  "editSuccess": "Muokkaus onnistui",
  "editFailed": "Muokkaus epäonnistui",
  "Time overlapped": "Valitsemasi käyttöajat olivat päällekkäisiä.",

  "stopFollow": "Haluatko varmasti lopettaa tämän potilaan seuraamisen?",
  "CancelTip1": "Haluatko varmasti poistaa tämän yhteyden?",

  "Warning": "Varoitus",
  "agreeConnect": "Jos hyväksyt yhdistämispyynnön klikkaamalla ”Hyväksy”, terveystietosi ovat luettavissa uuden yhteyden kautta.",
  "denyConnect": "Haluatko varmasti evätä tämän yhteyspyynnön?",
  "deleteConnect": "Haluatko varmasti poistaa tämän yhteyden? Jos poistat sen, terveystietojasi ei voi enää lukea yhteyden kautta.",

  "Choose the events to print": "Valitse tulostettavat tapahtumat",
  "tryAgain": "Yritä uudestaan",
  "username and password is required": "username and password is required",
  "A name is required": "Nimi on pakollinen.",
  "username is required": "Käyttäjänimi on pakollinen.",
  "The date choose wrong": "Valittu päivä on väärä",
  "Date no more than 14 days": "Valinta ei saa ylittää 14 vuorokautta.",

  "CancelTip": "Haluatko varmasti poistaa tämän yhteyden?",
  "removeConnect": "Poisto onnistui",

  "dateErr1": "Valinta ei saa ylittää 90 vuorokautta.",
  "dateErr2": "Lopetuspäivä ei saa olla ennen aloituspäivää.",

  "Not Filled": "Määrittämätön",
  "Today": "Tänään",
  "duration": "Kesto",
  "interval": "Interval",
  "7 days": "7 päivää",
  "14 days": "14 päivää",
  "30 days": "30 days",
  "90 days": "90 days",
  "g": "g",

  "Sound+Vibrate": "Ääni ja värinä",
  "Sound": "Ääni",
  "Vibrate": "Värinä",
  "Silent": "Ei saa häiritä",
  "1": "Kerran",
  "2": "Päivittäin",
  "noMes": "Viestejä ei ole.",
  "noConnect": "Yhteyksiä ei ole.",
  "Customize": "Mukauta",
  "GB": "United Kingdom",
  "CN": "China",
  "FR": "France",
  "DD": "Germany",
  "DE": "Germany",
  "SE": "Sweden",
  "AU": "Australia",
  "HKF": "Hongkong",
  "HU": "Hungary",
  "IT": "Italy",
  "NL": "Netherlands",
  "Nor": "Norway",
  "PT": "Portugal",
  "ES": "Spain",
  "TR": "Turkey",

  "Jan": "Jan",
  "Feb": "Feb",
  "Mar": "Mar",
  "Apr": "Apr",
  "May": "May",
  "Jun": "Jun",
  "Jul": "Jul",
  "Aug": "Aug",
  "Sep": "Sep",
  "Oct": "Oct",
  "Nov": "Nov",
  "Dec": "Dec",
  "ApplyTip": " request to view your data.",
  "noReadings": "Ei lukemia",

  "daop_A6_system": "A6 Touchcare System",
  "daop_easytouch_easyview": "EasyTouch / EasyView iPad",
  "daop_TY012_TY015": "TY012/TY015",
  "daop_easysense": "EasySense",
  "daop_delete_data": "Delete Data",
  "daop_uploaded_data": "Uploaded Data",
  "daop_uploaded_data_text": "The data is from EasyTouch App or EasyView iPad App.",
  "daop_realtime_data": "Real-time Data",
  "daop_realtime_data_text": "The data is from EasySense App or EasyPatch App.",

  "ins_unit": "(U)",
  "ins_unit2": "U",
  "basal_unit": "(U/H)",
  "basal_unit2": "U/H",

  "Alerts_Patch_Battery_Low": "Patch Battery Low",
  "Alerts_Patch_Battery_Depleted": "Patch Battery Depleted",
  "Alerts_Lost_Pump": "Lost Pump",
  "Alerts_Low_Reservoir": "Low Reservoir",
  "Alerts_Empty_Reservoir": "Empty Reservoir",
  "Alerts_Patch_Expiration_Advisory": "Patch Expiration Advisory",
  "Alerts_Patch_Exp_In_1_Hour": "Patch Exp In 1 Hour",
  "Alerts_Patch_Expired": "Patch Expired",
  "Alerts_Patch_Error": "Patch Error",
  "Alerts_Pump_Base_Error": "Pump Base Error",
  "Alerts_Basal_Rate_Key_Error": "Basal Rate Key Error",
  "Alerts_Occlusion_Detected": "Occlusion Detected",
  "Alerts_End_Of_Suspend": "End Of Suspend",
  "Alerts_Exceeds_Max_TDD": "Exceeds Max TDD",

  "Alerts_Exceeds_Max_1Hr_Delivery": "Exceeds Max 1Hr Delivery",

  "Alerts_Predictive_Low_Suspend": "Predictive Low Suspend",
  "Alerts_Low_Suspend": "Low Suspend",
  "Alerts_Auto_Off": "Auto Off",

  "Alerts_Pump_Restart": "Pump Restart",
  "Alerts_Auto_Off_Warning": "Auto Off Warning",
  "Alerts_Pump_Out_Of_Range": "Pump Out Of Range",

  "Alerts_Lost_Sensor": "Lost Sensor",
  "Alerts_Transmitter_Battery_Low": "Transmitter Battery Low",
  "Alerts_Charge_Transmitter": "Charge Transmitter",
  "Alerts_Sensor_Error": "Sensor Error",
  "Alerts_Transmitter_Error": "Transmitter Error",
  "Alerts_Sensor_Calibration_Error": "Sensor Calibration Error",

  "Alerts_Sensor_Failure": "Sensor Failure",
  "Alerts_Sensor_Calibration_Reminder": "Sensor Calibration Reminder",
  "Alerts_Meter_BG_Now": "Meter BG Now",
  "Alerts_Sensor_Exp_in_6_Hours": "Sensor Exp in 6 Hours",
  "Alerts_Sensor_Exp_in_2_Hours": "Sensor Exp in 2 Hours",
  "Alerts_Sensor_Exp_in_30_Min": "Sensor Exp in 30 Min",
  "Alerts_Sensor_Expired": "Sensor Expired",
  "Alerts_Rapid_Rise": "Rapid Rise",
  "Alerts_Rapid_Fall": "Rapid Fall",
  "Alerts_High_Predicted": "High Predicted",
  "Alerts_Low_Predicted": "Low Predicted",
  "Alerts_High_Glucose": "High Glucose",
  "Alerts_Low_Glucose": "Low Glucose",
  "Alerts_Below_3.1_mmol/L": "Below 3.1 mmol/L",
  "Alerts_Transmitter_Battery_Low_2": "Transmitter Battery Low",

  "Alerts_PDM_Battery_Low": "PDM Battery Low",
  "Alerts_Replace_Battery": "Replace Battery",

  "Alert": "Alert",
  "Alerts": "Alerts",
  "Alert Filter": "Alert Filter",
  "PDM": "PDM",
  "Pump": "Pump",


  "Out Of Range": "Out Of Range"
};

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return frMessages; });

var frMessages = {

  "privacy_policy_and_terms_of_use": "Privacy Policy and Terms of Use ",
  "privacy_confirm_text": "We've updated our <a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>Privacy Policy</a> and <a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>Terms of Use</a>. To continue using EasyView, you need to read and agree to all the terms.",
  "privacy_confirm_disagree": "Disagree",
  "privacy_confirm_accept": "Accept",

  "title": "EasyView Personal",
  "title1": "EasyView Pro",
  "user": "Email",
  "password": "Mot de pass",
  "remember": "Souvenez de moi",
  "forget": "Mot de passe oublié?",
  "sign in": "se connecter",
  "login": "Login",
  "sign up now": "S'inscrire maintenant",
  "apply": "Appliquer maintenant",
  "contact us": "Contactez nous",
  "Privacy Policy": "Politique de confidentialité",
  "Terms of Use": "Conditions d'utilisation",
  "copyright": "Copyright © 2021 Medtrum Technologies Inc. All rights reserved.",

  "chooseLang": "Choisissez votre pays ou votre langue",
  "asia": "Asie",
  "europe": "L'Europe ",

  "applyHcp": "Demander un compte HCP",
  "sign up": "S'inscrire",
  "Patient": "Patient",
  "Caregiver": "Soignant",
  "Email": "Email",
  "Mobile": "Mobile",
  "Enter email": "Entrer l'adresse e-mail",
  "Enter mobile": "Entrez le numéro de mobile",
  "Verification": "Code de vérification",
  "Invitation": "Invitation code",
  "full name": "Entrez votre nom complet",
  "Enter pass": "Entrer le mot de passe",
  "org": "Organisation",
  "Register": "Register",
  "send": "Envoyer",
  "agree": "J'ai lu et j'accepte la ",
  "privacy": "politique de confidentialité ",
  "and": "et ",
  "use": "les conditions d'utilisation.",
  "errtip1-1": "Vous devez entrer une adresse email valide, qui",
  "errtip1-2": "deviendra votre nom d'utilisateur Medtrum.",
  "errtip2": "Please enter a valid mobile number.",
  "errtip3": "Code de vérification incorrect",
  "errtip4": "Incorrect invitation code.",
  "errtip5": "Nom d'utilisateur incorrect",
  "errtip6": "Your password must have 8 or more characters.",
  "errtip7": "Veuillez entrer votre organisation",

  "errp1": "Le mot de passe doit contenir au moins 3 types des caractères suivants:",
  "errp2": "lettre majuscule, lettre minuscule, numéro et caractère spécial.",
  "errp3": "Le mot de passe doit comporter entre 6 et 20 caractères.",
  "errp4": "Le mot de passe doit être différent du nom d'utilisateur.",
  "errp5": "Le mot de passe avec 3 numéros consécutifs est invalide (ex: 123, 321).",
  "errp6": "Le mot de passe avec 3 lettres consécutives est invalide (ex: abc, cba).",
  "errp7": "Le mot de passe ne peut pas contenir d'espaces.",

  "Find account": "Récupérez votre mot de passe.",
  "Enter username": "S'il vous plaît entrez votre nom d'utilisateur.",
  "Next": "Prochain",
  "Cancel": "Annuler",
  "Back": "retour",
  "Enter veri": "Entrer Code de vérification",
  "Verify notice": "Veuillez trouver le code de vérification dans un e-mail.",
  "Create new": "Crée un nouveau mot de passe",
  "Create new notice": "Veuillez créer un nouveau mot de passe, et votre mot de passe doit avoir 6 caractères ou plus.",
  "New pass": "Nouveau mot de passe",
  "Completed": "Terminé",
  "Created": "Nouveau mot de passe créé.",
  "Login Now": "Connectez vous maintenant",

  "Delete": "Supprimer",
  "New Patient": "New Patient",
  "Add Patient": "Ajouter un patient",
  "Filter": "Sellectionner",
  "Name": "Nom",
  "Gender": "Sex",
  "Age": "Age",
  "Type": "Type",
  "Duration": "Durée",
  "Connections": "Créateur de compte",
  "UploadTime": "Temps de téléchargement",
  "Year": "année",
  "Years": "année",
  "Month": "month",
  "Month2": "Mois",
  "Months": "months",
  "Invite": "Inviter",
  "Invited": "Invité",
  "All": "Tout",
  "Female": "Femelle",
  "Male": "Mâle",
  "Not Set": "Non spécifié",
  "Type 1": "Type 1",
  "Type 2": "Type 2",
  "Gestational": "Gestationnel",
  "Prediabetes": "Prédiabète",
  "LADA": "Type 1.5 LADA",
  "Apply": "Appliquer",
  "disUn": "Type de diabète non spécifié",
  "ageUn": "Âge n'est pas renseigné",
  "genUn": "Sexe non renseigné",
  "addP": "Ajouter un patient",
  "newP": "Nouveau patient",
  "findP": "Trouver un patient",

  "GDRNF": "Non spécifié",
  "GDRF": "Femelle",
  "GDRM": "Mâle",
  "女": "Mâle",

  "DBTNF": "Non spécifié",
  "DBT1": "Type 1",
  "DBT2": "Type 2",
  "DBTLADA": "Type 1.5 LADA",
  "DBTPRE": "Prédiabète",
  "DBTGEST": "Gestationnel",
  "前期": "beFore",
  "beFore": "beFore",
  "MODY": "Mody",

  "No selection": "Non spécifié",
  "unspecif": "Non spécifié",
  "register": "Patient",
  "hcp": "Clinicien",

  "BG": "Glyc. Cap.",
  "CARB": "Glucides",
  "INS": "Injection",
  "EXR": "Exercice",
  "OTR": "Autres",
  "HBA1C": "HbA1c",
  "DOSE": "DOSE",
  "URINEK": "Cétone d'urine",
  "HEL": "HEL",
  "OTR1": "Autre",
  "Loading": "En cours de chargement",

  "home": "Accueil ",
  "pID": "ID du patient",
  "fullName": "Nom complet",
  "gender": "Sex",
  "height": "la taille",
  "weight": "Poids",
  "cm": "cm",
  "kg": "kg",
  "birthday": "Date de naissance",
  "disType": "Type de diabète",
  "disDate": "Date du diagnostic",
  "Address": "Adresse",
  "Postcode": "Code postal",
  "Inpatient": "Hospitalisé",
  "Yes": "Oui",
  "No": "no",
  "Pno": "No.Patient",
  "Bno": "No.Lit",
  "create": "Créer",
  "Telephone": "Telephone",

  "enterU": "Entrez le nom d'utilisateur (email)",
  "search": "Chercher",
  "noU": "Nom d'utilisateur est nécessaire.",
  "searchR": "Résultats de la recherche",
  "uername": "Nom d'utilisateur",
  "alias": "Alias",
  "remove": "Enlever",
  "viewG": "Voir les graphiques",
  "sendR": "Envoyer une demande",
  "rSent": "Votre demande à été envoyé.",
  "cancelR": "Demande d'annulation",

  "VcodeTip1": "Je ne l'ai pas reçu? Veuillez patienter une minute et ",
  "VcodeTip2": "réessayer.",
  "VcodeTip3": "Nous venons d'envoyer un code de vérification à ",
  "Entercode": "Entrez le code",
  "Getcode": "Obtenir le code",

  "messages": "Messages",
  "profile": "Profil",
  "sign out": "Déconnexion",
  "changeP": "Changer le mot de passe",
  "connection": "Connections",

  "myP": "Mon profil",
  "Portrait": "Photo de profil",
  "Profession": "Métier",
  "DPRONF": "Non spécifié",
  "DPROENDOCRIN": "Endocrinologue",
  "DPRODIABTRA": "Éducateur en diabète",
  "DPRONURSE": "Infirmière",
  "DPRODIATIT": "Nutritionniste",
  "DPROOTR": "Professionnelle de santé",
  "Organization": "Organization",
  "Bio": "bio",
  "save": "sauvegarder",
  "oldPa": "Ancien mot de passe",
  "newPa": "Nouveau mot de passe",
  "RePa": "Retaper le mot de passe",
  "forgetY": "Mot de passe oublié?",
  "applyM": "Appliquer",
  "oldErr": "L'ancien mot de passe est incorrect.",
  "EntTheSame": "Entrez le nouveau mot de passe à nouveau.",
  "EnterOld": "Entrez l'ancien mot de passe.",

  "pList": "Liste des patients",
  "connections": "Connexions",
  "settings": "Réglages",
  "monitor": "Moniteur",
  "graphs": "Rapports",
  "events": "Événements",
  "records": "Enregistrements",
  "qPrint": "Imprimé rapide",

  "sensorIn": "Infos sur le capteur",
  "timeOfLaRead": "Heure de la dernière lecture du capteur",
  "tranSn": "Transmetteur de NS",
  "status": "Statut",
  "sensorLife": "Durée de vie restante du capteur",
  "lastSenorRead": "Dernière lecture du capteur",
  "TranBattery": "Pile de l'émetteur",
  "sg": "capteur de glucose",
  "alert": "Alerte",
  "target": "Cible",
  "hypo": "hypoglycémie",
  "sensorGlucose": "Valeur de glucose",
  "calib": "Calibrage",
  "newSen": "Nouveau capteur",
  "warm": "Réchauffer",
  "InsulinPump": "Pompe à insuline",
  "timeOfLaPump": "Heure des dernières données de la pompe",
  "pumpSN": "Base de pompe deNS",
  "ReserviorLife": "Durée de vie du réservoir restante",
  "InsulinLeft": "Insuline restante",
  "basal": "Basal",
  "bolus": "Bolus",
  "totalBasal": "Total quotidien basal",
  "lastBolus": "Dernier bolus",
  "activeInsulin": "Insuline active",
  "totalBolus": "Bolus total quotidien",
  "tampBasal": "Basal Temporaire",
  "normalBolus": "Bolus normal",
  "extendBolus": "Bolus étendu",
  "manualStop": "Suspension manuelle",
  "autoStop": "Suspension automatique",
  "auto suspend": "Suspension automatique",
  "stop": "Arrêt d'administration",
  "newPatch": "Nouvelle pompe",
  "tempBasal": "Basal Temporaire",
  "N": "N",
  "E": "C",
  "CN1": "Duo-N",
  "CE": "Duo-C",

  "staticSettings": "Réglages de rapport",
  "dataSource": "La source de données",
  "unit": "Unité",
  "glucoseTarget": "Plage de cible de glucose",
  "overall": "Global",
  "Hypoglycemia": "Hypoglycémie",
  "timePeriod": "Période de temps",
  "postMeal": "Analyse post-repas",
  "Breakfast": "Petit Déjeuner",
  "Lunch": "Le déjeuner",
  "Dinner": "Dîner",
  "night": "La nuit",
  "Before": "Avant",
  "After": "Après",
  "Low": "Bas",
  "High": "Haute",
  "From": "De",
  "To": "À",
  "Hours": "heures",
  "Reset": "Réinitialiser",
  "RealTime": "Temps réél",
  "uploaded": "Téléchargé",
  "sensor": "Capteur",
  "pdmSN": "NS de PDM",
  "startTime": "Heure de début",
  "endTime": "Heure de fin",
  "uploadTime": "Temps de téléchargement",
  "pdm": "PDM",
  "Uploaded": "Téléchargé",
  "Patch Pump": "PDM",
  "overLapp": "Les sessions se chevauchaient",
  "showAlert": "Afficher les alertes",

  "dashboard": "Tableau de bord",
  "dboard_glucose_statistics": "Glucose Statistics",
  "dboard_glucose": "Glucose",
  "dboard_cgm": "CGM",
  "dboard_insulin": "Insulin",
  "dboard_carbs": "Carbs",
  "dboard_exercise": "Exercise",
  "dboard_glucose_avg": "Average",
  "dboard_cgm_avg": "Moyenne",
  "dboard_insulin_avg": "Average Daily Dose",
  "dboard_carbs_avg": "Moyenne glucides/jour",
  "dboard_exercise_avg": "Temps moyen/jour",
  "dboard_sd": "SD",
  "dboard_num": "#",
  "dboard_num_days": "# days",
  "dboard_statistics": "Statistics",
  "dboard_BG": "BG",
  "dboard_BG_calibration": "BG / calibration (per day)",
  "dboard_SG": "SG",
  "dboard_AUC_high": "AUC high >",
  "dboard_AUC_low": "AUC low <",
  "dboard_highest_value": "Valeur la plus élevée",
  "dboard_lowest_value": "Valeur la plus basse",

  "dboard_pump": "Pump",
  "dboard_avg_daily_dose": "Dose quotidienne moyenne",
  "dboard_SD": "ÉCART-TYPE",
  "dboard_daily_basal": "Basale Quotidienne",
  "dboard_daily_bolus": "Bolus Quotidien",
  "dboard_avg_bolus_num": "Nombre moyen de bolus quotidien",
  "dboard_avg_suspend_time": "Temps moyen d'arrêt de la pompe",
  "dboard_avg_reservoir_usage": "Utilisation moyenne du réservoir",
  "dboard_days": "days",

  "dboard_manual_bolus": "Bolus manuel (Volume/nombre par jour)",
  "dboard_normal": "-Normal",
  "dboard_extend": "-Carré",
  "dboard_combo": "-Duo",

  "dboard_bolus_calculator": "Calculateur de bolus (volume/nombre par jour)",
  "dboard_food_bolus": "-Calculateur Bolus alimentaire",
  "dboard_corr_bolus": "-Calculateur Bolus de Correction",
  "dboard_override_add": "- Ignorer (+)",
  "dboard_override_sub": "- Ignorer (-)",

  "dboard_report": "Tableau de bord Rapport",

  "daily": "Résumé quotidien",
  "date": "Date",
  "print": "Imprimer",
  "carbs": "Glucides",
  "exercise": "Exercise",
  "heavy": "Exercice lourd",
  "Medium": "Exercice moyen",
  "Light": "Exercice léger",
  "dailyReport": "Rapport récapitulatif quotidien",
  "devices": "Dispositifs",
  "tran": "Transmetteur ",
  "pumpBase": "Base de Pump ",
  "HbA1c": "HbA1c",
  "statics": "Statistiques",
  "glucose": "Glucose",
  "item": "élément",
  "BG1": "glucose sanguin",
  "SG1": "capteur de glucose",
  "avgSD": "moyenne déviation standard",
  "avgSD1": "Moyenne±SD",
  "min": "Min",
  "max": "Max",
  "ofRead": "nombre de lectures",
  "ofHypo": "nombre d'épisodes d'hypoglycémie/durée(min)",
  "ofAlert": "Nombre d'alertes",
  "insulin": "Insulin",
  "insulin2": "Insuline",
  "totalDose": "Dose quotidienne totale",
  "foodBolus": "Bolus alimentaire",
  "Food+coor": "Food+corr",
  "calibBolus": "Bolus de correction",
  "durationStop": "Durée de la suspension(min)",
  "ofPumpAlert": "Nombre d'alarmes de pompe",
  "ofMeal": "# de repas",
  "totalExerTime": "Temps d'exercice total",
  "exerNum": "# d'exercices",
  "avgInten": "Intensité moyenne",
  "target1": "Cible",
  "high1": "Haute",
  "low1": "Bas",
  "BG Reading": "BG Reading",

  "dayByday": "Jour après jour",
  "dayBydayRe": "Rapport d'aperçu au jour le jour",
  "period": "Période",

  "sensorOverlay": "Superposition de capteur",
  "set": "Réglages",
  "setPeriod": "regler periode",
  "Weekdays": "Jours de la semaine",
  "Weekends": "Weekends",
  "Mon": "Lun",
  "Tue": "Mar",
  "Wed": "Mer",
  "Thur": "Jeu",
  "Thu": "Jeu",
  "Fri": "Ven",
  "Sat": "Sam",
  "Sun": "Dim",
  "Average": "Moyen",
  "sensorOlRe": "Rapport de superposition de capteurs",
  "Avg": "Moyen",
  "±SD": "±SD",
  "ofhypo": "nombre d'épisodes d'hypoglycémie",
  "Everyday": "tous les jours",

  "TrendAna": "Analyse de tendance",
  "TrendRe": "Rapport d'analyse des tendances",
  "sensorGlu": "Glucose du capteur ",
  "ofBGtest": "nombre de tests de glycémie",
  "Basics": "Base",
  "static": "Statistiques",
  "Med": "Moyen",
  "med": "median",
  "Q1": "Q1",
  "Q3": "Q3",
  "Q11": "Q1",
  "Q31": "Q3",
  "IQR": "gamme interquartile",
  "SD": "SD",
  "CV": "Coefficient de variation",
  "SE1": "Erreur standard de la moyenne",
  "distri": "Distribution",
  "stab": "La stabilité",
  "#high": "nombre de lectures de glucose élevées",
  "#low": "nombre de lectures de glucose faibles",
  "aucBelow": "Surface sous la courbe en dessous de la limite basse",
  "aucAbove": "Surface sous la courbe au-dessus de la limite haute",
  "bgRead": "lectures de glucose sanguin",
  "total": "Totale",
  "ofBolus": "Nombre de bolus",
  "avgBolus": "Bolus moyen",
  "Dura1": "Durée (min)",
  "Avg/Total": "Moy / Total",
  "high": "Haute",
  "low": "Bas",
  "#hypo": "nombre d'épisodes d'hypoglycémie",
  "ofExer": "# d'exercices",

  "logbook": "Registre",
  "dailyTotal": "Total quotidien",
  "High Glucose": "Glucose élevée",
  "Low Glucose": "Glucose bas",
  "No Active Patch": "Pas de réservoir actif",
  "Missed Meal": "Repas manqué",
  "Multiple BG Readings": "Lectures multiples de glycémie",
  "Stop Patch": "Arrêter le réservoir ",
  "Others": "Autres",
  "Other Events": "Autres événements",
  "logRe": "Rapport de journal de bord",

  "DeviceSetting": "Examen des réglages de dispositif",
  "Insulin Pump": "Pompe à insuline",
  "MaxBasalRate": "Taux basal maximum",
  "BasalPatterns": "Modèle basal",
  "Selected Basal Pattern": "sellectionner modèle basal",
  "Maximum Bolus": "Bolus maximum",
  "Combo/Extended Bolus": "bolus combo/extendu",
  "BG Reminder": "Rappelde glucose sanguin",
  "Bolus Increment": "Incrément de bolus",
  "Bolus Calculator": "Calculatrice de bolus",
  "Active Insulin Time": "Temps d'insuline active",
  "IC Ratios": "Rapports insuline-glucides ",
  "Insulin Sensitivity": "Sensibilité à l'insuline",
  "BG Target": "Cible de glycémie",
  "Bolus Reminder": "Rappel de Bolus",
  "CGM": "MCG",
  "CGM System": "Système CGM",
  "Glucose Unit": "Unité de glucose",
  "Glucose Limits": "Limites de glucose",
  "Predicitive Alerts": "Alertes prédictives",
  "Rate Alerts": "taux de Alertes ",
  "type": "Type",
  "time": "L'heure",
  "data": "Data",
  "Rate": "Rate",
  "Calibration Reminder": "Rappel de calibrage",
  "Calibration Repeat": "Répétition de calibrage",
  "Snooze": "Répetition",
  "Audio Options": "Options audio",
  "Confidence Reminder": "Rappel de confiance",
  "Backlight": "Rétro-éclairage",
  "Sec": "secondes",
  "Alarm Clock": "Réveil",
  "Patch Expiration": "Expiration du réservoir",
  "Sensor Expiration": "Expiration du capteur",
  "Hourly Max": "Max horaire",
  "Daily Max": "Max quotidien",
  "Low Reservoir": "Réservoir bas",
  "Low Suspend": "suspension bas",
  "Predictive Low Suspend": "suspension bas projeté",
  "Rise": "Augmenter",
  "Fall": "Chute",
  "Auto Off": "Arrêt automatique",
  "Standard": "Standard",
  "Exercise": "Exercise",
  "Holiday": "Vacances",
  "ProgramA": "Modèle A",
  "ProgramB": "Modèle B",
  "--": "--",
  "Insulin": "Insulin",

  "SUSA": "Auto Off",
  "SUSHM": "Dépasse la livraison maximale de 1 heure",
  "SUSDM": "Dépasse Max TDD",
  "SUSLSG": "Faible suspension",
  "SUSPLSG": "Prédictive faible suspension",
  "Pump Restarted": "Pompe redémarrée",
  "Meter BG Now": "entrer une valeur de glycémie mètre maintenant",
  "Sensor Exp in 2 Hours": "Sensor Exp en 2 heures",
  "Sensor Exp in 6 Hours": "Sensor Exp en 6 heures",
  "Sensor Exp in 30 Min": "Capteur Exp dans 30 Min",
  "Sensor Calibration Error": "Erreur d'étalonnage du capteur",
  "Sensor Error": "Pas de lectures",

  "Device Settings Report": "Rapport des réglages de l'appareil",
  "24h Total": "Total de 24h",
  "Device Settings at": "dispositif réglé à",
  "Start": "Démarrer",
  "Combo/Ext Bolus": "Bolus Duo/Carré",
  "Time Format": "Format de l'heure",
  "Device Options（CGM System)": "Options de dispositf (système CGM)",
  "Device Options（Insulin Pump)": "Options de dispositf (Pompe à insuline)",
  "Dispay Settings (Screen)": "réglages d'affichage (écran)",
  "Dispay Settings (Backlight)": "réglages d'affichage (Rétro-éclairage)",
  "Graph Range": "Plage de graphes",
  "Range": "Plage",
  "Repeat": "Répéter",
  "Glucose Alerts": "Alertes au glucose",
  "Alert Silence": "Silence d'alerte",

  "Create": "Créer",
  "Event Filter": "Filtre d'événement",
  "HbA1c1": "HbA1c",
  "Urine Ketone": "Cétone d'urine",
  "Injection": "Injection",
  "Other": "Autre",
  "Event Type": "Type d'événement",
  "Details": "Détails",
  "Notes": "Remarques",
  "Source": "La source",
  "edit": "Modifier",
  "Action": "Action",
  "EventReport": "Rapport de synthèse de l'événement",
  "By Date": "Par date",
  "By Category": "Par catégorie",
  "Event Summary": "Résumé des événements",
  "No data": "Pas de données",
  "No1": "Pas de",
  "data1": "données",
  "#": "#",
  "BG Summary": "Résumé de glucose sanguin",
  "Carbs Summary": "Résumé des glucides",
  "Injection Summary": "Résumé de l'injection",
  "Exercise Summary": "Résumé de l'exercice",
  "Input Notes": "Saisir un commentaire",

  "Profile": "Profil",
  "Complications": "Complications",
  "Concomitant diseases": "Maladies concomitantes",
  "Suggestion": "Suggestion",
  "Coronary heart disease": "Maladie coronarienne",
  "High blood lipids": "Lipides sanguins élevés",
  "High blood pressure": "Hypertension",
  "Kidney disease": "Maladie rénale",
  "Neuropathy": "Neuropathie",
  "Obesity": "Obésité",
  "Peripheral arterial disease": "Maladie artérielle périphérique",
  "Retinopathy": "Rétinopathie",
  "Smoking addiction": "Dépendance au tabac",
  "Enter date": "Entrez la date",
  "Enter suggestion": "Entrez une suggestion",
  "Enter Notes": "Ajouter une note",
  "Select": "Sélectionner",
  "Prescription": "Prescription",
  "Medicine": "Médicament",
  "Dose": "Dose",
  "Enter medicine": "Entrez la médecine",
  "Enter dose": "Entrer la dose",
  "Enterdis": "Entrez la maladies concomitantes",
  "Add note": "Ajouter une note",
  "Add Content": "La longueur maximale est de 1000 caractères.",
  "Other suggestions": "Autres suggestions",
  "OK": "OK",
  "HCP": "HCP",
  "Content": "Contenu",
  "Records Report": "Rapport sur les documents",

  "Quick Print": "Impression rapide",
  "Quick Print Settings": "Réglages d'impression rapide",
  "Select duration": "Sélectionnez la durée",
  "One Week": "Une semaine",
  "One Month": "Un mois",
  "One Quarter": "Un quart",
  "End date": "Date de fin",
  "Yesterday": "Hier",
  "Last Sunday": "Dimanche dernier",
  "Last Saturday": "Samedi dernier",
  "Last Day of Last Month": "Last Day of Last Month",
  "Last Day of Last Quarter": "Last Day of Last Quarter",
  "Customized": "Personnaliser",
  "Week Filter": "Filtre de la semaine",
  "Select reports to print": "Sélectionnez les rapports à imprimer",
  "Daily Summary": "Résumé quotidien",
  "Day By Day Overview": "Jour après jour",
  "Sensor Overlay": "Superposition de capteur",
  "Trend Analysis": "Analyse de tendance",
  "Logbook": "Registre",
  "Device Settings Review": "Examen des réglages du dispositif",
  "createReport": "Créer un Rapport",

  "Segment Analysis": "Analyse des segments",
  "Sensor Glucose Profile": "Profile du capteur de glucose",
  "# of Boluses": "Nombre de bolus",
  "Bolus Insulin": "Bolus insuline",
  "Basal Pattern": "Modèle basal",
  "Segment Analysis Report": "Rapport d'analyse sectorielle",
  "Avg Glucose": "Glucose moyen",
  "Below": "En dessous",
  "In Target Range": "Dans la cible",
  "Coefficient of variation": "Coefficient de variation",
  "% Time CGM Active": "% temps MCG active",
  "est_a1c_t1": "Estimated A1C:",
  "est_a1c_t2": "calculated from SG values",
  "est_a1c_t3": "Note : hbA1C estimée ne remplace pas un dosage au laboratoire.",

  "acceptTip": " vous a permis de visualiser à distance ses informations de santé.",
  "cancelTip": " a cessé de vous permettre de visualiser à distance ses informations de santé. Vous pouvez postuler à nouveau si nécessaire.",
  "rejectTip": " a rejeté votre application de visualisation à distance.",
  "Read": "lire",

  "Connection": "Connexion",
  "connections1": "Connexion",
  "Add Connection": "Ajouter une connexion",
  "SG": "Valeur de glucose",
  "Active Insulin": "Insuline active",
  "Stop following": "Arrête de suivre",
  "Enter username (email)": "Entrez le nom d'utilisateur (email)",
  "Search results": "Résultats de la recherche",
  "Send request": "Envoyer une demande",
  "View graphs": "Voir les graphiques",
  "Agree": "Se mettre d'accord",
  "Deny": "Refuse",
  "Remove": "Enlever",
  "Cancel Requset": "Annuler la demande",
  "Remark": "Remarque",

  "Warm up": "Réchauffer",
  "Monitoring": "suivi",
  "Transmitter Error": "Erreur de transmetteur",
  "Sensor Failure": "Défaillance du capteur",
  "Sensor Expired": "Capteur expiré",
  "Lost Sensor": "Capteur perdu",
  "Not Calibrated": "Non calibré",
  "Calibrating": "Calibration",
  "Calibration Needed": "Calibration nécessaire",
  "Calibration Error": "Erreur de calibrage",
  "Charging Battery": "Charge de la batterie",
  "Battery Charged": "Batterie chargée",

  "To be filled": "Être rempli",
  "Filled with insulin": "Rempli d'insuline",
  "Priming": "Amorçage",
  "Priming completed": "Apprêt terminé",
  "Inserting needle": "Insérer une aiguille",
  "Patch activated": "réservoir activé",
  "Delivering Basal": "administrer Basal",
  "Exceeds Max 1 Hour Delivery": "Dépasse la livraison maximale de 1 heure",
  "Exceeds Max TDD": "Dépasse Max TDD",
  "Suspend": "Suspendre",
  "Occlusion Detected": "Occlusion détectée",
  "Patch Expired": "Réservoir expiré",
  "Empty Reservoir": "Réservoir vide",
  "Patch Error": "Erreur de pompe",
  "Pump Base Error": "Erreur de base de pompe",
  "Patch Battery Depleted": "Patch batterie appauvri",
  "Magnetic sensor not calibrated": "Capteur magnétique non calibré",

  "Patient Profile": "Profil du patient",

  "On": "démarer",
  "on": "démarer",
  "Off": "éteindre",
  "off": "éteindre",

  "CORONARY_HEART_DISEASE": "Maladie coronarienne",
  "HIGH_BLOOD_LIPIDS": "Lipides sanguins élevés",
  "HIGH_BLOOD_PRESSURE": "Hypertension",
  "KIDNEY_DISEASE": "Maladie rénale",
  "NEUROPATHY": "Neuropathie",
  "OBESITY": "Obésité",
  "PERIPHERAL_ARTERIAL_DISEASE": "Maladie artérielle périphérique",
  "RETINOPATHY": "Rétinopathie",
  "SMOKING_ADDICTION": "Dépendance au tabac",

  "saveTip": "Enregistré avec succès.",
  "changePaTip": "Votre mot de passe a été changé.",
  "enterEmTip": "Entrez votre adresse email.",
  "verErrTip": "Code de vérification incorrect.",
  "chooseEventTip": "Choisissez les événements à imprimer",
  "chooseDataTip": "Sélectionnez les données à imprimer",
  "dateWrongTip": "La date de fin ne peut pas être antérieure à la date de début",
  "infoWrongTip": "Veuillez remplir tous les champs requis.",
  "createdSuccssTip": "Créé avec succès",
  "selectData": "Sélectionnez les données à sauvegarder",

  "acceSu": "Demande de connexion acceptée",
  "acceEr": "mpossible d'ajouter une nouvelle connexion",
  "rejeSu": "Demande de connexion rejetée",
  "rejeEr": "Échec de la demande de rejet",

  "userNotExist": "Le nom d'utilisateur n'existe pas.",
  "Password incorrect": "Mot de passe incorrect.",
  "UserType incorrect": "Type d'utilisateur incorrect",

  "registSuccess": "Votre compte à été créé avec succès.",
  "registFailed": "Impossible d'enregistrer un nouveau compte",
  "sentSuccess": "message envoyé avec succès",
  "sentFailed": "Échec de l'envoi du message",
  "Input error": "Erreur de saisie",

  "deletePtip": "Êtes-vous sûr de vouloir supprimer ces patients?",
  "deleteEvents": "Etes-vous sur de vouloir supprimer ces évènements?",
  "deleteData": "Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",
  "deleteThis": "Etes-vous sur de vouloir supprimer?",
  "confirm": "Confirmer",
  "deleteSuccess": "Supprimé avec succès",
  "deleteFailed": "Échec de changement",
  "modifySuccess": "Changé avec succès",
  "modifyFailed": "Échec de changement",
  "createSuccess": "Créé avec succès",
  "createFailed": "La création a échoué",
  "editSuccess": "Modifié avec succès",
  "editFailed": "Echec de modification",
  "Time overlapped": "Les sessions que vous avez sélectionnées se chevauchaient.",

  "stopFollow": "Souhaitez-vous arrêter le suivi de ce patient?",
  "CancelTip1": "Êtes-vous sûr de vouloir supprimer cette connexion?",

  "Warning": "Attention",
  "agreeConnect": "Si vous cliquez sur 'Accepter' pour accepter la demande de connexion, vos données de santé deviendront disponibles pour la nouvelle connexion.",
  "denyConnect": "Êtes-vous sûr de vouloir rejeter la demande de connexion?",
  "deleteConnect": "Êtes-vous sûr de vouloir supprimer cette connexion? Si vous le supprimez, la connexion ne pourra plus afficher vos données de santé.",

  "Choose the events to print": "Choisissez les événements à imprimer",
  "tryAgain": "Réessayer",
  "username and password is required": "username and password is required",
  "A name is required": "Un nom est requis",
  "username is required": "Nom d'utilisateur est nécessaire.",
  "The date choose wrong": "Date incorrecte",
  "Date no more than 14 days": "Vous ne pouvez pas sélectionner plus de 14 jours.",

  "CancelTip": "Êtes-vous sûr de vouloir supprimer la connexion?",
  "removeConnect": "Supprimé avec succès",

  "dateErr1": "Vous ne pouvez pas sélectionner plus de 90 jours.",
  "dateErr2": "La date de fin ne peut pas être antérieure à la date de début.",

  "Not Filled": "Non spécifié",
  "Today": "Aujourd'hui",
  "duration": "Durée",
  "interval": "Interval",
  "7 days": "7 jours",
  "14 days": "14 jours",
  "30 days": "30 jours",
  "90 days": "90 jours",
  "g": "g",

  "Sound+Vibrate": "Audio+Vibration",
  "Sound": "Audio",
  "Vibrate": "Vibration",
  "Silent": "Ne pas déranger",
  "1": "Une fois ",
  "2": "Quotidien",
  "noMes": "Il n'y a pas de messages.",
  "noConnect": "Il n'y a pas de connexions..",
  "Customize": "Personnaliser",
  "GB": "United Kingdom",
  "CN": "China",
  "FR": "France",
  "DD": "Germany",
  "DE": "Germany",
  "SE": "Sweden",
  "AU": "Australia",
  "HKF": "Hongkong",
  "HU": "Hungary",
  "IT": "Italy",
  "NL": "Netherlands",
  "Nor": "Norway",
  "PT": "Portugal",
  "ES": "Spain",
  "TR": "Turkey",

  "Jan": "Jan",
  "Feb": "Fév",
  "Mar": "Mar",
  "Apr": "Avr",
  "May": "Mai",
  "Jun": "Jun",
  "Jul": "Jul",
  "Aug": "Aoû",
  "Sep": "Sep",
  "Oct": "Oct",
  "Nov": "Nov",
  "Dec": "Déc",
  "ApplyTip": "  demande d'afficher vos données.",
  "noReadings": "Pas de lectures",

  "daop_A6_system": "A6 Touchcare System",
  "daop_easytouch_easyview": "EasyTouch / EasyView iPad",
  "daop_TY012_TY015": "TY012/TY015",
  "daop_easysense": "EasySense",
  "daop_delete_data": "Delete Data",
  "daop_uploaded_data": "Données transmises",
  "daop_uploaded_data_text": "Donnée de l'app EasyTouch ou EasyView (pour IPAD)",
  "daop_realtime_data": "Donnée en Temps Réel",
  "daop_realtime_data_text": "The data is from EasySense App or EasyPatch App.",

  "ins_unit": "(U)",
  "ins_unit2": "U",
  "basal_unit": "Unités / heure",
  "basal_unit2": "U/H",

  "Alerts_Patch_Battery_Low": "batterie de reservoir faible",
  "Alerts_Patch_Battery_Depleted": "batterie de reservoir appauvri",
  "Alerts_Lost_Pump": "Lost Pump",
  "Alerts_Low_Reservoir": "Réservoir bas",
  "Alerts_Empty_Reservoir": "Réservoir vide",
  "Alerts_Patch_Expiration_Advisory": "Avis d'expiration de  reservoir",
  "Alerts_Patch_Exp_In_1_Hour": "Patch Exp In 1 Hour",
  "Alerts_Patch_Expired": "reservoir expiré",
  "Alerts_Patch_Error": "Erreur de pompe",
  "Alerts_Pump_Base_Error": "Erreur de base de pompe",
  "Alerts_Basal_Rate_Key_Error": "Basal Rate Key Error",
  "Alerts_Occlusion_Detected": "Occlusion détectée",
  "Alerts_End_Of_Suspend": "End Of Suspend",
  "Alerts_Exceeds_Max_TDD": "Dépasse Max TDD",
  "Alerts_Exceeds_Max_1Hr_Delivery": "Dépasse la livraison maximale de 1 heure",

  "Alerts_Predictive_Low_Suspend": "Prédictive faible suspension",
  "Alerts_Low_Suspend": "suspension bas",
  "Alerts_Auto_Off": "Arrêt automatique",

  "Alerts_Pump_Restart": "Pump Restart",
  "Alerts_Auto_Off_Warning": "Auto Off Warning",
  "Alerts_Pump_Out_Of_Range": "Pump Out Of Range",

  "Alerts_Lost_Sensor": "Capteur perdu",
  "Alerts_Transmitter_Battery_Low": "Batterie de l'émetteur faible",
  "Alerts_Charge_Transmitter": "Transmetteur de charge",
  "Alerts_Sensor_Error": "Pas de lectures",
  "Alerts_Transmitter_Error": "Erreur de transmetteur",
  "Alerts_Sensor_Calibration_Error": "Sensor Calibration Error",

  "Alerts_Sensor_Failure": "Défaillance du capteur",
  "Alerts_Sensor_Calibration_Reminder": "Sensor Calibration Reminder",
  "Alerts_Meter_BG_Now": "entrer une valeur de glycémie mètre maintenant",
  "Alerts_Sensor_Exp_in_6_Hours": "Sensor Exp en 6 heures",
  "Alerts_Sensor_Exp_in_2_Hours": "Sensor Exp en 2 heures",
  "Alerts_Sensor_Exp_in_30_Min": "Capteur Exp dans 30 Min",
  "Alerts_Sensor_Expired": "Capteur expiré",
  "Alerts_Rapid_Rise": "Hausse rapide",
  "Alerts_Rapid_Fall": "Chute rapide",
  "Alerts_High_Predicted": "Haute prédite",
  "Alerts_Low_Predicted": "Faible",
  "Alerts_High_Glucose": "Glucose élevée",
  "Alerts_Low_Glucose": "Glucose faible",
  "Alerts_Below_3.1_mmol/L": "En dessous de 3.1 mmol/L",
  "Alerts_Transmitter_Battery_Low_2": "Batterie de l'émetteur faible",

  "Alerts_PDM_Battery_Low": "Batterie PDM faible",
  "Alerts_Replace_Battery": "Charger PDM ",

  "Alert": "Alert",
  "Alerts": "Alertes",
  "Alert Filter": "Alert Filter",
  "PDM": "PDM",
  "Pump": "Pompe",


  "Out Of Range": "Out Of Range",
  "t1221_Time_in_Auto_Mode": "Temps en Mode Auto",
  "t1221_Average_SG_SD": "Moyenne GC ± DS",
  "t1221_Time_in_Target_Range": "Temps dans la cible",
  "t1221_Time_above_Range": "Temps au-dessus de la cible",
  "t1221_Time_below_Range": "Temps en dessous de la cible",
  "t1221_Auto_Basal_per_day": "Basal Auto (par jour)",
  "t1221_Auto_Bolus_per_day": "Bolus Auto (par jour)",
  "t1221_Auto_Mode_Exits": "Sorties du Mode Auto",
  "t1221_No_Sensor_readings": "Pas le lecture du capteur",
  "t1221_Max_Delivery": "Administration max",
  "t1221_Min_Delivery": "Administration min",
  "t1222_autoModeBasal": "Mode Auto - Basal",
  "t1222_autoModeCorrBolus": "Mode Auto - Bolus de correction",
  "t1222_autoSnack": "Auto Collation",
  "t1222_autoBreakfast": "Auto Petit-Déjeuner",
  "t1222_autoLunch": "Auto Déjeuner",
  "t1222_autoDinner": "Auto Diner ",
  "t1222_autoExercise": "Auto Exercice",
  "t1222_Snack": "Collation",
  "t1222_Auto_Mode": "Mode Auto ",
  "t1222_Time_in_Auto_Mode": "Temps en Mode Auto(%)",
  "t1222_Avg_SD": "Moy.(mg/dl)±GC",
  "t1222_Target_Range": "Dans la cible (%)",
  "t1222_Above_Range": "Au-dessus de la cible(%)",
  "t1222_Below_Range": "En dessous de la cible(%)",
  "t1222_Auto_Mode_Exits": "# de sorties du Mode Auto",
  "t1221_Auto_Mode": "Mode Auto",
  "t1222_auto_basal": "Basal Auto",
  "t1222_auto_bolus": "Bolus Auto",
  "t0805_User_Management": "Gestion des utilisateurs",
  "t0805_Patient_Management": "Gestion des patients",
  "t0805_Operation_History": "Historique des opérations",
  "t0805_User_List": "liste d'utilisateur",
  "t0805_User": "Utilisateur",
  "t0805_Time": "Temps",
  "t0805_Operation_Type": "Type d'opération",
  "t0805_Back": "Retour",
  "t0805_Add": "Ajouter",
  "t0805_Delete": "Supprimer",
  "t0809_Add_User": "Ajouter un utilisateur",
  "t1028_Pattern_C": "Modèle C",
  "t1028_Pattern_D": "Modèle D",
  "t1029_Auto_meal_bolus": "Auto meal bolus",
  "t1029_Auto_mode_correction_bolus": "Auto mode correction bolus",
  "t1029_Sick": "Malade",
  "t1029_Auto_Mode_Feature": "Fonction Mode Auto",
  "t1029_Target_SG": "Glucose cible",
  "t1029_Auto_Meal_Handling": "Gestion auto repas",
  "t1029_Total_Daily_Dose": "Total quotidien",
  "t1029_Pump_Light": "Témoin lumineux",
  "t1029_Alerts_for_Hypo": "Alertes Hypo",
  "t1102_Out_of_Range": "Hors de portée",
  "t1102_Command_Reminder": "Rappel commande",
  "t1102_Alarms_Alerts_on_APP": "Alarmes & Alertes sur System",
  "t1102_Alarms_on_App": "Alarmes sur l'APP",
  "t1102_Alerts_on_App": "Alertes sur l'APP",
  "t1102_Factory_Calibration": "Calibration usine",
  "t1102_Alerts_for_Low": "Alertes pour basse ",
  "t1102_Alerts_for_High": "Alertes pour Haute ",
  "t1102_Alerts_for_Others": "Alertes pour les autres ",
  "t1102_Adjustment": "Ajustement",
  "t1102_Suggested": "Suggéré",
  "t1103_Glucose": "Glucose",
  "t1103_CGM": "CGM",
  "t1103_Insulin": "Insuline",
  "t1103_Carbs": "Glucides",
  "t1103_Exercise": "Exercice",
  "t1103_Min_Max": "Min/Max",
  "t1103_Target_Range": "Intervalle cible",
  "t1103_Overall_Tine_In_Range": "Général : Temps dans la cible",
  "t1103_Basal": "Basal",
  "t1103_Bolus": "Bolus",
  "t1103_Basal_Bolus": "Basal et Bolus",
  "t1103_Auto_Mode_Time_In_Range": "Mode Auto : Temps dans la cible",
  "t1103_Time_below_range": "Temps en dessous de la cible",
  "t1103_Time_above_range": "Temps au-dessus de la cible",
  "t1103_Time_in_target_range": "Temps dans la cible",
  "t1103_Incorrect_Password": "Mot de passe incorrect, $1 Tentative laissée, veuillez saisir le mot de passe correct.",
  "t1103_Incorrect_locked": "Les tentatives infructueuses dépassent la limite, le compte a été verrouillé. Veuillez réessayer dans $1 minutes.",
  "t1104_The_data_is_from": "Donnée de l'app EasySense ou EasyPatch.",
  "t1104_Privacy_Policy": "Politique de confidentialité et conditions d'utilisation",
  "t1104_updated_privacy_policy": "Nous avons mis à jour notre politique de confidentialité et conditions d'utilisation.Veuillez lire attentivement et accepter les modifications avant de utiliser EasyPatch",
  "t1104_Disagree": "Non",
  "t1104_Agree": "Se mettre d'accord",
  "t1105_Upload_History": "Télécharger l'historique",
  "t1105_Delete_Data": "Suprimmer les données",
  "t1105_Target_Range": "Intervalle cible",
  "t1105_request_to_view_your_data": "$1 de demande pour afficher vos données.",
  "t1105_Recent_Updates": "Mises à jour récentes",
  "t1108_No_data": "Pas de données",
  "t1108_Pump_Bash_SN": "NS Base de Pump ",
  "t1108_Transmitter_SN": "Transmetteur NS",
  "t1112_Normal_Glucose": "Glycémie Normale",
  "t1112_Manual_Bolus_or_Modified_Bolus": "Bolus manuel ou bolus modifié",
  "t1112_Auto_Mode_Started": "Début du Mode Auto",
  "t1112_Auto_Mode_Exit": "Fin du Mode Auto",
  "t1112_Normal_Bolus": "Bolus Normal",
  "t1112_Extended_Bolus": "Bolus Carré ",
  "t1112_Combo_Bolus": "Bolus Combo",
  "t1112_Carbs": "Glucides",
  "t1112_Glucose": "Glucose",
  "t1112_BG": "Glycémie",
  "t1112_Audio": "Son ",
  "t1112_Tone": "Tonalité",
  "t1112_Audio_Options": "Options audio",
  "t1112_Weight_Unit": "Unité De Poids",
  "t1112_Height_Unit": "Unité De Hauteur",
  "t1112_Not_available": "Pas Disponible",
  "t1112_Number": "Numéro",
  "t1112_days": "# jours",
  "t1112_min": "Min",
  "t1113_days": "jours",
  "t1215_Security": "Sécurité",
  "t1215_MFA": "Authentification multifacteur (MFA)",
  "t1215_Enter_verification_code": "Entrez le code de vérification",
  "t1215_Multi_factor_ON": "L'authentification multifacteur est activée. Le code de vérification a été envoyé à $1 Veuillez soumettre le code de vérification.",
  "t1215_Verification_code_incorrect": "Code de vérification incorrect",
  "t1215_Show_Glucose_Value": "Afficher la valeur de glucose",
  "t1221_enter_verification_code": "Veuillez saisir le code de vérification à 6 chiffres envoyé à $1.",
  "t1221_Verification_Success": "Vérifié avec succès",
  "t1222_We_will_only_process": "Vos données de santé seront traitées à partir de l'app/du Portail Medtrum uniquement avec votre consentement.  ",
  "t1222_If_you_are_under_years": "L'ouverture d'un compte pour un mineur de moins de 16 ans requiert l'autorisation de vos parents ou tuteur légal.",
  "t1221_register_cn": "Vous disposez du droit de ne pas télécharger les données de vos dispositif sur l'App. Dans ce cas, vos données ne pourront pas être consultées par un tiers. Si vous n'ouvrez pas de compte Medtrum sur le portail web ou notre App., vos données seront uniquement enregistrées sur le dispositif que vous utilisez. ",
  "t1221_register_eu": "Si vous créez un compte Medtrum pour accéder à notre application, vos donnés de santé enregistrées sur l'App. seront téléchargées sur notre serveur européen et conservées pendant 2 ans. Vous êtes libre de ne pas téléchargées vos données sur l'App. Dans ce cas, vos données ne pourront être consultées par aucun tiers à distance. Si vous n'ouvrez pas de compte Medtrum sur le portail web ou notre App., vos données seront uniquement enregistrées sur le dispositif que vous utilisez.",
  "t1221_register_follow": "Le traitement de vos données de santé sera effectué à partir de l'app/du Portail Medtrum, uniquement avec votre consentement",
  "t1222_Terms_of_Use": "les conditions d'utilisation de Medtrum",
  "t1222_Privacy_Policy": "la politique de confidentialité de Medtrum",
  "t1222_Create_Account": "Créer un compte",
  "t1222_Back": "retour",
  "t1222_Verify_your_account": "Vérifiez votre compte",
  "t1222_please_check_your_account": "Nous enverrons un code de vérification à $1, veuillez vérifier votre compte.",
  "t1222_I_Agree_to": "J'accepte $1",
  "t1223_Invalid_Verification_Code": "Code de vérification invalide. Veuillez réessayer."
};

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hkMessages; });
var hkMessages = {
  "privacy_policy_and_terms_of_use": "Privacy Policy and Terms of Use ",
  "privacy_confirm_text": "We've updated our <a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>Privacy Policy</a> and <a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>Terms of Use</a>. To continue using EasyView, you need to read and agree to all the terms.",
  "privacy_confirm_disagree": "Disagree",
  "privacy_confirm_accept": "Accept",

  "title": "EasyView Personal",
  "title1": "EasyView Pro",
  "user": "郵箱/手機號",
  "password": "密碼",
  "remember": "記住密碼",
  "forget": "忘記密碼？",
  "sign in": "登錄",
  "login": "登錄",
  "sign up now": "立即註冊",
  "apply": "立即申請帳號",
  "contact us": "聯繫我們",
  "Privacy Policy": "隱私政策",
  "Terms of Use": "服務協定",
  "copyright": "2017，上海移宇科技有限公司，保留所有權利。",

  "chooseLang": "選擇國家/地區和語言",
  "asia": "亞洲",
  "europe": "歐洲",

  "applyHcp": "申請HCP帳號",
  "sign up": "註冊",
  "Patient": "患者",
  "Caregiver": "監護人",
  "Email": "郵箱/用戶名",
  "Mobile": "手機",
  "Enter email": "輸入郵箱位址",
  "Enter mobile": "輸入手機號",
  "Verification": "驗證碼",
  "Invitation": "邀请码",
  "full name": "輸入真實姓名",
  "Enter pass": "輸入密碼",
  "org": "組織機構",
  "Register": "註冊",
  "send": "發送",
  "agree": "我已閱讀並同意Medtrum的",
  "privacy": "隱私政策",
  "and": "及 ",
  "use": "服務協定",
  "errtip1-1": "您的郵箱位址將會成為您的用戶名,",
  "errtip1-2": " 請輸入有效的郵箱位址",
  "errtip2": "請輸入正确的手機號",
  "errtip3": "驗證碼輸入錯誤",
  "errtip4": "邀请码错误",
  "errtip5": "未輸入姓名",
  "errtip6": "你的密码必须不少于6位",
  "errtip7": "請輸入機構名",

  "errp1": "密碼必須由至少三種字元組成:",
  "errp2": "大寫字母、小寫字母、數位或特殊字元",
  "errp3": "密碼長度為6~20個字元",
  "errp4": "密碼不能使用用戶名",
  "errp5": "不能有三個以上連續的數字(如:123,321)",
  "errp6": "不能有三個以上連續的字母(如:abc,cba)",
  "errp7": "不能包含空格",

  "Find account": "找回密碼",
  "Enter username": "請輸入用戶名",
  "Next": "下一步",
  "Cancel": "取消",
  "Back": "返回",
  "Enter veri": "請輸入驗證碼",
  "Create new": "創建新密碼",
  "Verify notice": "請輸入您郵箱/手機中Medtrum公司發送的驗證碼",
  "Create new notice": "請輸入6位元新密碼",
  "New pass": "新密碼",
  "Completed": "完成",
  "Created": "新密碼已創建.",
  "Login Now": "立即登錄",

  "Delete": "刪除",
  "New Patient": "添加患者",
  "Add Patient": "查找患者",
  "Filter": "篩選",
  "Name": "姓名",
  "Gender": "性別",
  "Age": "年齡",
  "Type": "糖尿病類型",
  "Duration": "病齡",
  "Connections": "帳號創建者",
  "UploadTime": "上傳時間",
  "Year": "年",
  "Years": "年",
  "Month": "月",
  "Month2": "月",
  "Months": "月",
  "Invite": "邀請",
  "Invited": "已邀請",
  "All": "全部",
  "Female": "女性",
  "Male": "  男",
  "Not Set": "未填寫",
  "Type 1": "類型 1",
  "Type 2": "類型 2",
  "Gestational": "妊娠糖尿病",
  "Prediabetes": "糖尿病前期",
  "LADA": "成人隱匿性免疫性糖尿病",
  "Apply": "保存",
  "addP": "添加患者",
  "newP": "新建患者",
  "findP": "查找患者",
  "disUn": "病類型未知",
  "ageUn": "未填寫年齡",
  "genUn": "未填寫性別",
  "GDRNF": "未填寫",
  "GDRF": "女",
  "GDRM": "男",
  "女": "男性",

  "DBTNF": "未填寫",
  "DBT1": "類型 1",
  "DBT2": "類型 2",
  "DBTLADA": "LADA",
  "DBTPRE": "前期",
  "DBTGEST": "DBTGEST",
  "前期": "前期",
  "beFore": "前期",
  "MODY": "其他",

  "No selection": "未填寫",
  "unspecif": "未填寫",
  "register": "患者",
  "hcp": "醫生",

  "BG": "血糖值",
  "CARB": "食物",
  "INS": "胰島素注射",
  "EXR": "運動",
  "OTR": "其他",
  "HBA1C": "HbA1c",
  "DOSE": "藥物",
  "URINEK": "尿酮",
  "HEL": "HEL",
  "OTR1": "其他",
  "Loading": "加載中",

  "home": "首頁",
  "pID": "患者編號",
  "fullName": "姓名",
  "gender": "性別",
  "height": "高",
  "weight": "體重",
  "cm": "釐米",
  "kg": "千克",
  "birthday": "出生日期",
  "disType": "糖尿病類型",
  "disDate": "確診日期",
  "Address": "地址",
  "Postcode": "郵編",
  "Inpatient": "住院資訊",
  "Yes": "是",
  "No": "否",
  "Pno": "住院編號",
  "Bno": "床位編號",
  "create": "創建",
  "Telephone": "座機",

  "enterU": "輸入用戶名（郵箱）",
  "search": "搜索",
  "noU": "未輸入用戶名",
  "searchR": "搜索结果",
  "uername": "用戶名",
  "alias": "昵稱",
  "remove": "移除",
  "viewG": "查看圖表",
  "sendR": "發送請求",
  "rSent": "請求已發送",
  "cancelR": "取消請求",
  "VcodeTip1": "驗證碼已發送到 ",
  "VcodeTip2": "中，請等待一分鐘，若仍然未收到，請點擊",
  "VcodeTip3": "重試",
  "Entercode": "輸入驗證碼",
  "Getcode": "獲取驗證碼",

  "messages": "消息",
  "profile": "個人信息",
  "sign out": "退出",
  "changeP": "修改密碼",
  "connection": "聯繫人",

  "myP": "個人資訊",
  "Portrait": "頭像",
  "Profession": "職業",
  "DPRONF": "未填寫",
  "DPROENDOCRIN": "內分泌醫師",
  "DPRODIABTRA": "糖尿病護理教育者",
  "DPRONURSE": "護理醫師",
  "DPRODIATIT": "營養師",
  "DPROOTR": "其他醫療服務人員",
  "Organization": "組織機構",
  "Bio": "簡介",
  "save": "保存",
  "oldPa": "舊密碼",
  "newPa": "新密碼",
  "RePa": "確認密碼",
  "forgetY": "忘記密碼",
  "applyM": "應用",
  "oldErr": "舊密碼輸入錯誤",
  "EntTheSame": "輸入相同密碼",
  "EnterOld": "輸入舊密碼",

  "pList": "患者列表",
  "connections": "患者列表",
  "settings": "設置",
  "monitor": "即時監控",
  "graphs": "報告",
  "events": "事件",
  "records": "病程記錄",
  "qPrint": "快速列印",

  "sensorIn": "血糖信息",
  "timeOfLaRead": "最近血糖更新時間",
  "tranSn": "發射器序號",
  "status": "狀態",
  "sensorLife": "血糖探頭剩餘使用時間",
  "lastSenorRead": "最近血糖讀數",
  "TranBattery": "發射器電量",
  "sg": "血糖",
  "alert": "告警",
  "target": "目標範圍",
  "hypo": "低限",
  "sensorGlucose": "血糖讀數",
  "calib": "校準",
  "newSen": "新探頭",
  "warm": "初始化",
  "InsulinPump": "胰島素泵",
  "timeOfLaPump": "最近一次泵資料更新時間",
  "pumpSN": "泵體控制器序號",
  "ReserviorLife": "儲藥貼剩餘時間",
  "InsulinLeft": "胰島素剩餘量",
  "basal": "基礎量",
  "bolus": "大劑量",
  "totalBasal": "基礎量總量",
  "lastBolus": "最近大劑量",
  "activeInsulin": "活性胰島素",
  "totalBolus": "大劑量總量",
  "tampBasal": "臨時基礎量",
  "normalBolus": "正常大劑量",
  "extendBolus": "擴展大劑量",
  "manualStop": "手動暫停",
  "autoStop": "自動暫停",
  "auto suspend": "自動暫停",
  "stop": "輸注停止",
  "newPatch": "新儲藥貼",
  "tempBasal": "臨時基礎量",
  "N": "正",
  "E": "擴",
  "CN1": "組正",
  "CE": "組擴",

  "staticSettings": "報告設置",
  "dataSource": "資料來源",
  "unit": "單位",
  "glucoseTarget": "血糖目標範圍",
  "overall": "總計",
  "Hypoglycemia": "低於3.1mmol/L（56mg/dL）",
  "timePeriod": "時間段",
  "postMeal": "餐後分析",
  "Breakfast": "早餐",
  "Lunch": "中餐",
  "Dinner": "晚餐",
  "night": "夜間",
  "Before": "前",
  "After": "後",
  "Low": "低限",
  "High": "高限",
  "From": "開始",
  "To": "結束",
  "Hours": "小时",
  "Reset": "恢復默認設置",
  "RealTime": "即時",
  "uploaded": "上傳",
  "sensor": "血糖探頭",
  "pdmSN": "手持機序號",
  "startTime": "開始時間",
  "endTime": "結束時間",
  "uploadTime": "上傳時間",
  "pdm": "手持機",
  "Uploaded": "上傳",
  "Patch Pump": "手持機",
  "overLapp": "數據重疊",
  "showAlert": "顯示告警",

  "dashboard": "綜合報表",
  "dboard_glucose_statistics": "統計",
  "dboard_glucose": "指尖血糖",
  "dboard_glucose_avg": "平均值",
  "dboard_sd": "標準方差",
  "dboard_num": "次數",
  "dboard_cgm": "動態血糖",
  "dboard_cgm_avg": "平均值",

  "dboard_insulin": "胰島素",
  "dboard_insulin_avg": "平均每天輸注的胰島素",

  "dboard_carbs": "食物",
  "dboard_carbs_avg": "平均每天攝入量",

  "dboard_exercise": "運動",
  "dboard_exercise_avg": "平均每天運動時間",

  "dboard_num_days": "# days",
  "est_a1c_t1": "估算糖化血紅蛋白：",
  "est_a1c_t2": "基於動態血糖值計算所得",
  "est_a1c_t3": "說明：估算的糖化血紅蛋白值不能替代實驗室所測量的值",
  "dboard_statistics": "統計",
  "dboard_BG": "血糖值",
  "dboard_SG": "動態血糖值",
  "dboard_BG_calibration": "BG/校準（每天）",
  "dboard_AUC_high": "AUC高>11.0mmol/L",
  "dboard_AUC_low": "AUC低<5.2mmol/L",
  "dboard_highest_value": "最高價值",
  "dboard_lowest_value": "最低價值",
  "dboard_pump": "泵",
  "dboard_avg_daily_dose": "平均每天輸注的胰島素",
  "dboard_SD": "標準方差",
  "dboard_daily_basal": "每日基礎量",
  "dboard_daily_bolus": "每日大劑量",
  "dboard_avg_bolus_num": "平均每天輸注大劑量次數",
  "dboard_avg_suspend_time": "平均暫停時間",
  "dboard_avg_reservoir_usage": "儲藥貼平均壽命",
  "dboard_days": "days",
  "dboard_manual_bolus": "手動大劑量（數量/次數）",
  "dboard_normal": "-正常",
  "dboard_extend": "-擴展",
  "dboard_combo": "-組合",
  "dboard_bolus_calculator": "大劑量嚮導（數量/次數）",
  "dboard_food_bolus": "-食物大劑量",
  "dboard_corr_bolus": "-校正大劑量",
  "dboard_override_add": "-向上調整(+)",
  "dboard_override_sub": "-向下調整(-)",

  "dboard_report": "綜合報表報告",

  "daily": "每日總結",
  "date": "日期",
  "print": "列印",
  "carbs": "食物",
  "exercise": "運動",
  "heavy": "劇烈",
  "Medium": "中度",
  "Light": "輕度",
  "dailyReport": "每日總結報告",
  "devices": "設備",
  "tran": "發射器",
  "pumpBase": "泵體控制器",
  "HbA1c": "糖化血紅蛋白",
  "statics": "統計",
  "glucose": "血糖",
  "item": "項",
  "BG1": "指尖血糖",
  "SG1": "血糖",
  "avgSD": "平均值(mmol/L)±標準差",
  "avgSD1": "平均值±標準差",
  "min": "最小值",
  "max": "最大值",
  "ofRead": "讀數",
  "ofHypo": "低血糖次數/持續時間",
  "ofAlert": "告警次數",
  "insulin": "胰島素",
  "insulin2": "胰島素",
  "totalDose": "全天輸注總量",
  "foodBolus": "食物大劑量",
  "Food+coor": "食物和校正大劑量",
  "calibBolus": "校正大劑量",
  "durationStop": "暫停輸注時間(分钟)",
  "ofPumpAlert": "泵告警次數",
  "ofMeal": "進餐次數",
  "totalExerTime": "運動總時間",
  "exerNum": "運動次數",
  "avgInten": "平均強度",
  "target1": "目標範圍",
  "high1": "高",
  "low1": "低",
  "BG Reading": "指尖血糖讀數",

  "dayByday": "多日流覽",
  "dayBydayRe": "多日總結報告",
  "period": "時間段",

  "sensorOverlay": "血糖疊加圖",
  "set": "設置",
  "setPeriod": "設置時間段",
  "Weekdays": "工作日",
  "Weekends": "週末",
  "Mon": "星期一",
  "Tue": "星期二",
  "Wed": "星期三",
  "Thur": "星期四",
  "Thu": "星期四",
  "Fri": "星期五",
  "Sat": "星期六",
  "Sun": "星期日",
  "Average": "平均值",
  "sensorOlRe": "血糖疊加圖報告",
  "Avg": "平均值",
  "±SD": "±标准差",
  "ofhypo": "低血糖次數",
  "Everyday": "每天",

  "TrendAna": "趨勢分析",
  "TrendRe": "趨勢分析報告",
  "sensorGlu": "血糖探頭讀數",
  "ofBGtest": "指尖血糖讀數（次數）",
  "Basics": "基本統計",
  "static": "統計",
  "Med": "中位數",
  "med": "中位數",
  "Q1": "1/4分位",
  "Q3": "3/4分位",
  "Q11": "1/4分位數",
  "Q31": "3/4分位數",
  "IQR": "四分位距",
  "SD": "標準差",
  "CV": "變異係數",
  "SE1": "均值標準誤差",
  "distri": "分佈",
  "stab": "穩定性",
  "#high": "#偏高",
  "#low": "#偏低",
  "aucBelow": "低限線下積分",
  "aucAbove": "高限線下積分",
  "bgRead": "指尖血糖讀數",
  "total": "總量",
  "ofBolus": "大劑量次數",
  "avgBolus": "大劑量平均值",
  "Dura1": "運動（分）",
  "Avg/Total": "平均值/總計",
  "high": "高",
  "low": "低限",
  "#hypo": "低血糖次數",
  "ofExer": "運動次數",

  "logbook": "日誌",
  "dailyTotal": "全天總量",
  "High Glucose": "血糖高",
  "Low Glucose": "血糖低",
  "No Active Patch": "無啟動儲藥貼",
  "Missed Meal": "錯過用餐時間",
  "Multiple BG Readings": "多個指尖血糖讀數",
  "Stop Patch": "儲藥貼終止",
  "Others": "其他",
  "Other Events": "其他事件",
  "logRe": "日誌報告",

  "DeviceSetting": "設備設置報告",
  "Insulin Pump": "胰島素泵",
  "MaxBasalRate": "基礎量最大值",
  "BasalPatterns": "基礎量程式",
  "Selected Basal Pattern": "啟動的基礎量程式",
  "Maximum Bolus": "大劑量最大值",
  "Combo/Extended Bolus": "組合/擴展大劑量",
  "BG Reminder": "指尖血糖提醒",
  "Bolus Increment": "大劑量步長",
  "Bolus Calculator": "大劑量嚮導",
  "Active Insulin Time": "活性胰島素",
  "IC Ratios": "胰島素食物比",
  "Insulin Sensitivity": "胰島素靈敏度",
  "BG Target": "目標血糖",
  "Bolus Reminder": "大劑量提醒",
  "CGM": "動態血糖",
  "CGM System": "動態血糖系統",
  "Glucose Unit": "血糖單位",
  "Glucose Limits": "血糖門限",
  "Predicitive Alerts": "血糖異常預測告警",
  "Rate Alerts": "血糖變化異常告警",
  "type": "類型",
  "time": "時間",
  "data": "數據",
  "Rate": "速率",
  "Calibration Reminder": "校準提醒",
  "Calibration Repeat": "校準重複告警",
  "Snooze": "重複告警間隔",
  "Audio Options": "聲音選項",
  "Confidence Reminder": "指令回應提示",
  "Backlight": "背光",
  "Sec": "秒",
  "Alarm Clock": "鬧鐘",
  "Patch Expiration": "儲藥貼過期告警",
  "Sensor Expiration": "探頭過期告警",
  "Hourly Max": "每小時最大輸注量",
  "Daily Max": "每天最大輸注總量",
  "Low Reservoir": "低儲藥量告警",
  "Low Suspend": "低血糖暫停輸注",
  "Predictive Low Suspend": "預測低血糖暫停輸注",
  "Rise": "上升",
  "Fall": "下降",
  "Auto Off": "自動暫停輸注",
  "Standard": "標準",
  "Exercise": "鍛煉",
  "Holiday": "假日",
  "ProgramA": "程式A",
  "ProgramB": "程式B",
  "--": "--",
  "Insulin": "胰島素",

  "SUSA": "自動暫停輸注告警",
  "SUSHM": "超出每小時最大量暫停輸注",
  "SUSDM": "超出每天最大量暫停輸注",
  "SUSLSG": "低血糖暫停輸注",
  "SUSPLSG": "預測低血糖暫停輸注",
  "Pump Restarted": "貼片泵重啟",
  "Meter BG Now": "立即輸入指尖血",
  "Sensor Exp in 2 Hours": "探頭2小時內過期",
  "Sensor Exp in 6 Hours": "探頭6小時內過期",
  "Sensor Exp in 30 Min": "探頭30分鐘內過期",
  "Sensor Calibration Error": "探頭校準錯誤",
  "Sensor Error": "無血糖讀數",

  "Device Settings Report": "設備設置報告",
  "Device Settings at": "設備設置時間",
  "24h Total": "24小時總量",
  "Start": "開始",
  "Combo/Ext Bolus": "組合/擴展大劑量",
  "Time Format": "時間制",
  "Device Options（CGM System)": "動態血糖系統",
  "Device Options（Insulin Pump)": "胰島素泵系統",
  "Dispay Settings (Screen)": "顯示（螢幕）",
  "Dispay Settings (Backlight)": "顯示（背光）",
  "Graph Range": "血糖趨勢圖顯示",
  "Range": "範圍",
  "Repeat": "模式",
  "Glucose Alerts": "血糖告警",
  "Alert Silence": "血糖告警靜音",

  "Create": "添加",
  "Event Filter": "篩選",
  "HbA1c1": "糖化血紅蛋白",
  "Urine Ketone": "尿酮",
  "Injection": "胰島素注射",
  "Other": "其他",
  "Event Type": "事件類型",
  "Details": "詳情",
  "Notes": "備註",
  "Source": "來源",
  "edit": "編輯",
  "Action": "操作",
  "EventReport": "事件匯總報告",
  "By Date": "按日期",
  "By Category": "按項目",
  "Event Summary": "事件匯總",
  "No data": "無數據",
  "No1": "無",
  "data1": "數據",
  "#": "次數",
  "BG Summary": "指尖血糖統計",
  "Carbs Summary": "食物統計",
  "Injection Summary": "胰島素注射統計",
  "Exercise Summary": "運動統計",
  "Input Notes": "輸入備註",

  "Profile": "個人資訊",
  "Complications": "併發症",
  "Concomitant diseases": "伴發病",
  "Suggestion": "建議",
  "Coronary heart disease": "冠心病",
  "High blood lipids": "高血脂",
  "High blood pressure": "高血壓",
  "Kidney disease": "腎病",
  "Neuropathy": "神經病變",
  "Obesity": "肥胖症",
  "Peripheral arterial disease": "外周動脈疾病",
  "Retinopathy": "視網膜病變",
  "Smoking addiction": "吸煙者",
  "Enter date": "輸入日期",
  "Enter suggestion": "輸入建議",
  "Enter Notes": "輸入備註",
  "Select": "選擇",
  "Prescription": "藥方",
  "Medicine": "藥物類型",
  "Dose": "用量",
  "Enter medicine": "輸入藥物類型",
  "Enter dose": "輸入藥量",
  "Enterdis": "輸入併發症",
  "Add note": "輸入備註",
  "Add Content": "不超過1000個字符",
  "Other suggestions": "其他建議",
  "OK": "確定",
  "HCP": "醫護人員",
  "Content": "內容",
  "Records Report": "病程記錄報告",

  "Quick Print": "快速列印",
  "Quick Print Settings": "快速列印設置",
  "Select duration": "選擇時間間隔",
  "One Week": "一周",
  "One Month": "一月",
  "One Quarter": "一個季度",
  "End date": "截止日期",
  "Yesterday": "昨天",
  "Last Sunday": "上周日",
  "Last Saturday": "上週六",
  "Last Day of Last Month": "上個月最後一天",
  "Last Day of Last Quarter": "上個季度最後一天",
  "Customized": "設置",
  "Week Filter": "星期刪選",
  "Select reports to print": "選擇需要列印的報告",
  "Daily Summary": "每日總結",
  "Day By Day Overview": "多日總結",
  "Sensor Overlay": "血糖疊加图",
  "Trend Analysis": "趨勢分析",
  "Logbook": "日誌",
  "Device Settings Review": "設備設置",
  "createReport": "創建報告",

  "Segment Analysis": "分段分析",
  "Sensor Glucose Profile": "動態血糖",
  "# of Boluses": "大劑量次數",
  "Bolus Insulin": "大劑量",
  "Basal Pattern": "基礎量程式",
  "Segment Analysis Report": "分段分析報告",
  "Avg Glucose": "血糖平均值",
  "Below": "低於",
  "In Target Range": "目標範圍",
  "Coefficient of variation": "變異係數",
  "% Time CGM Active": "CGM啟動時間百分比",

  "acceptTip": " 已授權監護。",
  "cancelTip": " 已取消對您的授權，如需遠程監護，請重新申請。",
  "rejectTip": " 拒絕了您的申請。",
  "Read": "閱讀",

  "Connection": "患者",
  "connections1": "聯繫人",
  "Add Connection": "添加患者",
  "SG": "血糖值",
  "Active Insulin": "活性胰島素",
  "Stop following": "停止監護",
  "Enter username (email)": "輸入用戶名（郵箱/手機號）",
  "Search results": "搜索結果",
  "Send request": "發送請求",
  "View graphs": "查看圖表",
  "Agree": "同意",
  "Deny": "拒絕",
  "Remove": "移除",
  "Cancel Requset": "取消申請監護的患者",
  "Remark": "備註",

  "Patient Profile": "患者信息",

  "Warm up": "初始化",
  "Monitoring": "正常監控中",
  "Transmitter Error": "發射器故障",
  "Sensor Failure": "血糖探頭失敗",
  "Sensor Expired": "血糖探頭過期",
  "Lost Sensor": "血糖探頭丟失",
  "Not Calibrated": "未校準",
  "Calibrating": "校準中",
  "Calibration Needed": "校準過期",
  "Calibration Error": "校準錯誤",
  "Charging Battery": "充電中",
  "Battery Charged": "充電完成",

  "To be filled": "等待灌藥",
  "Filled with insulin": "已灌藥",
  "Priming": "充盈中",
  "Priming completed": "充盈已完成",
  "Inserting needle": "正在注針過程中",
  "Patch activated": "注針已完成",
  "Delivering Basal": "正在輸注基礎量",
  "Exceeds Max 1 Hour Delivery": "超出每小時最大量暫停輸注",
  "Exceeds Max TDD": "超出每天最大量暫停輸注",
  "Suspend": "用戶手動暫停輸注",
  "Occlusion Detected": "儲藥貼堵塞",
  "Patch Expired": "儲藥貼過期",
  "Empty Reservoir": "儲藥貼空",
  "Patch Error": "儲藥貼故障",
  "Pump Base Error": "泵控制器故障",
  "Patch Battery Depleted": "電池沒電",
  "Magnetic sensor not calibrated": "磁感測器未校準",

  "On": "開啟",
  "on": "開啟",
  "Off": "關閉",
  "off": "關閉",

  "CORONARY_HEART_DISEASE": "冠心病",
  "HIGH_BLOOD_LIPIDS": "高脂血",
  "HIGH_BLOOD_PRESSURE": "高血壓",
  "KIDNEY_DISEASE": "腎病",
  "NEUROPATHY": "神經病變",
  "OBESITY": "肥胖症",
  "PERIPHERAL_ARTERIAL_DISEASE": "外周動脈疾病",
  "RETINOPATHY": "視網膜病變",
  "SMOKING_ADDICTION": "吸煙者",

  "saveTip": "保存成功!",
  "changePaTip": "密碼修改成功",
  "enterEmTip": "請輸入您的郵箱/手機",
  "verErrTip": "驗證碼輸入錯誤",
  "chooseEventTip": "選擇需要列印的事件",
  "chooseDataTip": "選擇需要列印的數據",
  "dateWrongTip": "截止日期不能小於開始日期",
  "infoWrongTip": "資訊未填寫完成",
  "createdSuccssTip": "創建成功",
  "selectData": "選擇要保存的數據",

  "acceSu": "已接受",
  "acceEr": "接受失敗",
  "rejeSu": "已拒絕",
  "rejeEr": "拒絕失敗",

  "userNotExist": "用戶名不存在",
  "Password incorrect": "密碼錯誤。",
  "UserType incorrect": "用戶類型錯誤",
  "registSuccess": "註冊成功",
  "registFailed": "註冊失敗",
  "sentSuccess": "發送成功",
  "sentFailed": "發送失敗",

  "Input error": "輸入錯誤",

  "deletePtip": "確定需要刪除這些患者嗎？",
  "deleteEvents": "請確認是否需要刪除這些事件？",
  "deleteData": "Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",
  "deleteThis": "請確認是否需要刪除這個事件？",
  "confirm": "確定",
  "deleteSuccess": "已刪除",
  "deleteFailed": "删除失敗",
  "modifySuccess": "修改成功",
  "modifyFailed": "修改失敗",
  "createSuccess": "創建成功",
  "createFailed": "創建成功",
  "editSuccess": "編輯成功",
  "editFailed": "編輯失敗",
  "Time overlapped": "時間重疊",

  "stopFollow": "你確定要停止監護此患者嗎？",
  "CancelTip1": "你確定要取消這個連接嗎？",

  "Warning": "提示",
  "agreeConnect": "點擊“同意”後，聯繫人將會看到您的血糖數據、胰島素泵數據及個人相關信息。",
  "denyConnect": "你確定要拒绝此聯繫人查看你的數據?",
  "deleteConnect": "確認是否要刪除此聯繫人，删除後，此聯繫人將不能再繼續查看你的數據。",

  "Choose the events to print": "選擇需要列印的事件",
  "tryAgain": "重試",
  "username and password is required": "請輸入用戶名和密碼",
  "A name is required": "請輸入姓名",
  "username is required": "請輸入用戶名",
  "The date choose wrong": "時間選擇錯誤",
  "Date no more than 14 days": "日期不能多於14天",

  "CancelTip": "確定刪除嗎？",
  "removeConnect": "刪除成功",

  "dateErr1": "选择的日期范围不能超过90天!",
  "dateErr2": "截止日期不能小於起始日期",

  "Not Filled": "未填寫",
  "Today": "今天",
  "duration": "病齡",
  "interval": "Interval",
  "7 days": "7天",
  "14 days": "14天",
  "30 days": "30 天",
  "90 days": "90 天",
  "g": "克",

  "Sound+Vibrate": "聲音+振動",
  "Sound": "聲音",
  "Vibrate": "振動",
  "Silent": "免打擾",
  "1": "一次",
  "2": "每天",
  "noMes": "無消息",
  "noConnect": "無聯繫人",
  "Customize": "設置",
  "GB": "United Kingdom",
  "CN": "China",
  "FR": "France",
  "DD": "Germany",
  "DE": "Germany",
  "SE": "Sweden",
  "AU": "Australia",
  "HKF": "Hongkong",
  "HU": "Hungary",
  "IT": "Italy",
  "NL": "Netherlands",
  "Nor": "Norway",
  "PT": "Portugal",
  "ES": "Spain",
  "TR": "Turkey",

  "Jan": "一月",
  "Feb": "二月",
  "Mar": "三月",
  "Apr": "四月",
  "May": "五月",
  "Jun": "六月",
  "Jul": "七月",
  "Aug": "八月",
  "Sep": "九月",
  "Oct": "十月",
  "Nov": "十一月",
  "Dec": "十二月",
  "ApplyTip": " 申請監護您的數據.",
  "noReadings": "無血糖讀數",

  "daop_A6_system": "A6 Touchcare System",
  "daop_easytouch_easyview": "EasyTouch / EasyView iPad",
  "daop_TY012_TY015": "TY012/TY015",
  "daop_easysense": "EasySense",
  "daop_delete_data": "Delete Data",
  "daop_uploaded_data": "已上傳數據",
  "daop_uploaded_data_text": "數據來源於EasyTouch移動應用程式或EasyView iPad移動應用",
  "daop_realtime_data": "即時數據",
  "daop_realtime_data_text": "The data is from EasySense App or EasyPatch App.",

  "ins_unit": "(U)",
  "ins_unit2": "U",
  "basal_unit": "（U/H）",
  "basal_unit2": "U/H",

  "Alerts_Patch_Battery_Low": "儲藥貼電量低",
  "Alerts_Patch_Battery_Depleted": "儲藥貼沒電",
  "Alerts_Lost_Pump": "Lost Pump",
  "Alerts_Low_Reservoir": "儲藥量低",
  "Alerts_Empty_Reservoir": "儲藥貼空",
  "Alerts_Patch_Expiration_Advisory": "儲藥貼過期預警",
  "Alerts_Patch_Exp_In_1_Hour": "Patch Exp In 1 Hour",
  "Alerts_Patch_Expired": "儲藥貼過期",
  "Alerts_Patch_Error": "儲藥貼故障",
  "Alerts_Pump_Base_Error": "泵控制器故障",
  "Alerts_Basal_Rate_Key_Error": "Basal Rate Key Error",
  "Alerts_Occlusion_Detected": "儲藥貼堵塞",
  "Alerts_End_Of_Suspend": "End Of Suspend",
  "Alerts_Exceeds_Max_TDD": "超過每天最大輸注量",
  "Alerts_Exceeds_Max_1Hr_Delivery": "超過每小時最大輸注量",

  "Alerts_Predictive_Low_Suspend": "預測低血糖暫停輸注",
  "Alerts_Low_Suspend": "低血糖暫停輸注",
  "Alerts_Auto_Off": "自動暫停輸注",

  "Alerts_Pump_Restart": "Pump Restart",
  "Alerts_Auto_Off_Warning": "Auto Off Warning",
  "Alerts_Pump_Out_Of_Range": "Pump Out Of Range",

  "Alerts_Lost_Sensor": "血糖探頭丟失",
  "Alerts_Transmitter_Battery_Low": "發射器電量低",
  "Alerts_Charge_Transmitter": "發射器需充電",
  "Alerts_Sensor_Error": "無血糖讀數",
  "Alerts_Transmitter_Error": "發射器故障",
  "Alerts_Sensor_Calibration_Error": "Sensor Calibration Error",

  "Alerts_Sensor_Failure": "血糖探頭失敗",
  "Alerts_Sensor_Calibration_Reminder": "Sensor Calibration Reminder",
  "Alerts_Meter_BG_Now": "立即輸入指尖血",
  "Alerts_Sensor_Exp_in_6_Hours": "探頭6小時內過期",
  "Alerts_Sensor_Exp_in_2_Hours": "探頭2小時內過期",
  "Alerts_Sensor_Exp_in_30_Min": "探頭30分鐘內過期",
  "Alerts_Sensor_Expired": "血糖探頭過期",
  "Alerts_Rapid_Rise": "上升快",
  "Alerts_Rapid_Fall": "下降低",
  "Alerts_High_Predicted": "預期血糖高",
  "Alerts_Low_Predicted": "預期血糖低",
  "Alerts_High_Glucose": "血糖高",
  "Alerts_Low_Glucose": "血糖低",
  "Alerts_Below_3.1_mmol/L": "低於3.1mmol/L",
  "Alerts_Transmitter_Battery_Low_2": "發射器電量低",

  "Alerts_PDM_Battery_Low": "手持機電量低",
  "Alerts_Replace_Battery": "手持機立即充電",

  "Alert": "Alert",
  "Alerts": "告警",
  "Alert Filter": "Alert Filter",
  "PDM": "PDM",
  "Pump": "泵",


  "Out Of Range": "Out Of Range",
  "t1221_Time_in_Auto_Mode": "自動模式時長",
  "t1221_Average_SG_SD": "平均血糖±標準差",
  "t1221_Time_in_Target_Range": "目標血糖比例",
  "t1221_Time_above_Range": "高血糖比例",
  "t1221_Time_below_Range": "低血糖比例",
  "t1221_Auto_Basal_per_day": "自動基礎量(每天)",
  "t1221_Auto_Bolus_per_day": "自動大劑量(每天)",
  "t1221_Auto_Mode_Exits": "自動模式退出",
  "t1221_No_Sensor_readings": "無血糖讀數",
  "t1221_Max_Delivery": "最大輸注",
  "t1221_Min_Delivery": "最小輸注",
  "t1222_autoModeBasal": "自動模式基礎量",
  "t1222_autoModeCorrBolus": "自動模式校正大劑量",
  "t1222_autoSnack": "自動零食",
  "t1222_autoBreakfast": "自動早餐",
  "t1222_autoLunch": "自動午餐",
  "t1222_autoDinner": "自動晚餐",
  "t1222_autoExercise": "自動運動",
  "t1222_Snack": "零食",
  "t1222_Auto_Mode": "自動模式",
  "t1222_Time_in_Auto_Mode": "自動模式時長",
  "t1222_Avg_SD": "平均值(mmol/L)±標準差",
  "t1222_Target_Range": "目標血糖次數",
  "t1222_Above_Range": "高血糖次數",
  "t1222_Below_Range": "低血糖次數",
  "t1222_Auto_Mode_Exits": "自動模式退出次數",
  "t1221_Auto_Mode": "自動模式總結",
  "t1222_auto_basal": "自動基礎量",
  "t1222_auto_bolus": "自動大劑量",
  "t0805_User_Management": "用戶管理",
  "t0805_Patient_Management": "患者管理",
  "t0805_Operation_History": "操作歷史",
  "t0805_User_List": "用戶列表",
  "t0805_User": "用戶",
  "t0805_Time": "時間",
  "t0805_Operation_Type": "操作類型",
  "t0805_Back": "返回",
  "t0805_Add": "增加",
  "t0805_Delete": "刪除",
  "t0809_Add_User": "添加用戶",
  "t1028_Pattern_C": "程式C",
  "t1028_Pattern_D": "程式D",
  "t1029_Auto_meal_bolus": "自動餐食大劑量",
  "t1029_Auto_mode_correction_bolus": "自動模式校正大劑量",
  "t1029_Sick": "生病",
  "t1029_Auto_Mode_Feature": "自動模式功能",
  "t1029_Target_SG": "目標血糖",
  "t1029_Auto_Meal_Handling": "自動餐食調整",
  "t1029_Total_Daily_Dose": "每日輸注總量",
  "t1029_Pump_Light": "泵控制器燈",
  "t1029_Alerts_for_Hypo": "低血糖報警",
  "t1102_Out_of_Range": "泵通信超過範圍",
  "t1102_Command_Reminder": "命令提醒",
  "t1102_Alarms_Alerts_on_APP": "貼片泵報警",
  "t1102_Alarms_on_App": "APP中高優先順序報警",
  "t1102_Alerts_on_App": "APP低優先順序報警",
  "t1102_Factory_Calibration": "免校準",
  "t1102_Alerts_for_Low": "血糖低報警",
  "t1102_Alerts_for_High": "血糖高報警",
  "t1102_Alerts_for_Others": "其他報警",
  "t1102_Adjustment": "調整",
  "t1102_Suggested": "建議輸注值",
  "t1103_Glucose": "血糖",
  "t1103_CGM": "動態血糖",
  "t1103_Insulin": "胰島素",
  "t1103_Carbs": "食物",
  "t1103_Exercise": "運動",
  "t1103_Min_Max": "最小值/最大值",
  "t1103_Target_Range": "目標範圍",
  "t1103_Overall_Tine_In_Range": "總計: 時間範圍",
  "t1103_Basal": "基礎量",
  "t1103_Bolus": "大劑量",
  "t1103_Basal_Bolus": "基礎量&大劑量",
  "t1103_Auto_Mode_Time_In_Range": "自動模式: 時間範圍",
  "t1103_Time_below_range": "低血糖比例",
  "t1103_Time_above_range": "高血糖比例",
  "t1103_Time_in_target_range": "目標血糖比例",
  "t1103_Incorrect_Password": "密碼輸入錯誤，還剩$1次嘗試機會，請確認登錄密碼是否正確。",
  "t1103_Incorrect_locked": "密碼錯誤次數超過限制，帳戶已被鎖定，請$1分鐘後再試。",
  "t1104_The_data_is_from": "數據來源於EasySense移動應用程式或EasyPatch移動應用程式",
  "t1104_Privacy_Policy": "隱私政策和服務協定",
  "t1104_updated_privacy_policy": "我們最近更新了隱私政策和服務協定。請仔細閱讀，同意並接受全部條款後再使用EasyView。",
  "t1104_Disagree": "不同意",
  "t1104_Agree": "同意",
  "t1105_Upload_History": "上傳歷史",
  "t1105_Delete_Data": "刪除數據",
  "t1105_Target_Range": "目標範圍",
  "t1105_request_to_view_your_data": "$1請求查看您的數據。",
  "t1105_Recent_Updates": "最近更新",
  "t1108_No_data": "無數據",
  "t1108_Pump_Bash_SN": "泵體控制器序號",
  "t1108_Transmitter_SN": "發射器序號",
  "t1112_Normal_Glucose": "正常血糖",
  "t1112_Manual_Bolus_or_Modified_Bolus": "手動大劑量或修改過的大劑量",
  "t1112_Auto_Mode_Started": "自動模式開始",
  "t1112_Auto_Mode_Exit": "自動模式退出",
  "t1112_Normal_Bolus": "正常大劑量",
  "t1112_Extended_Bolus": "擴展大劑量",
  "t1112_Combo_Bolus": "組合大劑量",
  "t1112_Carbs": "碳水化合物量",
  "t1112_Glucose": "血糖",
  "t1112_BG": "指尖血糖",
  "t1112_Audio": "聲音",
  "t1112_Tone": "告警聲音",
  "t1112_Audio_Options": "聲音選項",
  "t1112_Weight_Unit": "體重單位",
  "t1112_Height_Unit": "身高單位",
  "t1112_Not_available": "無法使用",
  "t1112_Number": "序號",
  "t1112_days": "天數",
  "t1112_min": "分鐘",
  "t1113_days": "天",
  "t1215_Security": "安全",
  "t1215_MFA": "多重身份驗證",
  "t1215_Enter_verification_code": "輸入驗證碼",
  "t1215_Multi_factor_ON": "多重身份認證已開啟。驗證碼已發送至 $1， 請提交驗證碼。",
  "t1215_Verification_code_incorrect": "驗證碼錯誤",
  "t1215_Show_Glucose_Value": "顯示血糖值",
  "t1221_enter_verification_code": "請輸入發送到$1的6位驗證碼。",
  "t1221_Verification_Success": "驗證成功",
  "t1222_We_will_only_process": "未獲得您的同意，我們不會通過Medtrum應用程式或網站處理您的醫療數據。",
  "t1222_If_you_are_under_years": "未滿16周歲的未成年人必須獲得父母或者監護人的同意才可以註冊帳號。",
  "t1221_register_cn": "你有權利選擇不上傳任何設備數據到應用程式，在此情況下，其他人無法訪問數據。如果選擇不註冊Medtrum帳號登錄應用程式/網站，您的醫療數據只記錄並保存在設備中。",
  "t1221_register_eu": "如果您選擇註冊Medtrum帳戶並使用帳戶訪問Medtrum的應用程式，該應用程式上記錄的醫療數據將被上傳至Medtrum在歐洲的伺服器，並保存2年。你有權利選擇不上傳任何設備數據到應用程式，在此情況下，其他人無法訪問數據。如果選擇不註冊Medtrum帳號登錄應用程式/網站，您的醫療數據只記錄並保存在設備中。",
  "t1221_register_follow": "未獲得您的同意，我們不會通過Medtrum 應用程式或網站處理您的醫療數據。",
  "t1222_Terms_of_Use": "移宇科技的使用條款",
  "t1222_Privacy_Policy": "移宇科技的隱私政策",
  "t1222_Create_Account": "創建帳號",
  "t1222_Back": "返回",
  "t1222_Verify_your_account": "驗證您的賬號",
  "t1222_please_check_your_account": "我們將會把驗證碼發送到$1，請檢查您的賬號。",
  "t1222_I_Agree_to": "我同意$1",
  "t1223_Invalid_Verification_Code": "無效的驗證碼，請重試。"
};

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return itMessages; });
var itMessages = {
  "privacy_policy_and_terms_of_use": "Privacy Policy and Terms of Use ",
  "privacy_confirm_text": "We've updated our <a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>Privacy Policy</a> and <a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>Terms of Use</a>. To continue using EasyView, you need to read and agree to all the terms.",
  "privacy_confirm_disagree": "Disagree",
  "privacy_confirm_accept": "Accept",

  "title": "EasyView Personal",
  "title1": "EasyView Pro",
  "user": "Email",
  "password": "Password",
  "remember": "Ricordami",
  "forget": "Password dimenticata?",
  "sign in": "Login",
  "login": "Login",
  "sign up now": "Registrati ora",
  "apply": "Registrati ora",
  "contact us": "Contattaci",
  "Privacy Policy": "Informativa sulla privacy",
  "Terms of Use": "Termini di utilizzo",
  "copyright": "Copyright © 2021 Medtrum Technologies Inc. Tutti i diritti riservati.",

  "chooseLang": "Seleziona il tuo paese o la lingua",
  "asia": "Asia",
  "europe": "Europa",

  "applyHcp": "Registra una nuova utenza HCP",
  "sign up": "Registrati",
  "Patient": "Paziente",
  "Caregiver": "Assistente domiciliare",
  "Email": "Email",
  "Mobile": "Cellulare",
  "Enter email": "Inserisci l'indirizzo email",
  "Enter mobile": "Inserisci il numero di cellulare",
  "Verification": "Codice di verifica",
  "Invitation": "Invitation code",
  "full name": "Inserisci il tuo nome completo",
  "Enter pass": "Inserisci la password",
  "org": "Organizzazione",
  "Register": "Registrati",
  "send": "Invia",
  "agree": "Dichiaro di aver letto e accettato l' ",
  "privacy": " 'Informativa sulla privacy' ",
  "and": "ed i ",
  "use": "'Termini di utilizzo'",
  "errtip1-1": "Devi inserire un indirizzo email valido,",
  "errtip1-2": " il quale diventerà il tuo nome utente Medtrum.",
  "errtip2": "Please enter a valid mobile number.",
  "errtip3": "Codice di verifica non corretto",
  "errtip4": "Incorrect invitation code.",
  "errtip5": "Nome utente non corretto",
  "errtip6": "Your password must have 8 or more characters.",
  "errtip7": "Si prega di inserire la propria organizzazione.",

  "errp1": "La password deve contenere almeno 3 tipi dei seguenti caratteri:",
  "errp2": "Lettere maiuscole, lettere minuscole, numeri e caratteri speciali.",
  "errp3": "La password deve essere lunga tra i 6 e i 20 caratteri.",
  "errp4": " La password deve essere diversa dal nome utente.",
  "errp5": "Una password con 3 numeri consecutivi non è valida (es. 123, 321).",
  "errp6": "Una password con 3 lettere consecutive non è valida (es. abc, cba).",
  "errp7": "La password non può contenere spazi.",

  "Find account": "Recupera la tua password.",
  "Enter username": "Inserisci il tuo cognome.",
  "Next": "Successivo",
  "Cancel": "Annulla",
  "Back": "Indietro",
  "Enter veri": "Inserisci Codice di verifica",
  "Verify notice": "Si prega di cercare il codice di verifica inviato in e-mail.",
  "Create new": "Crea una nuova password",
  "Create new notice": "Si prega di creare una nuova password che deve avere 6 o più caratteri.",
  "New pass": "Nuova password",
  "Completed": "Completato",
  "Created": "Nuova password creata.",
  "Login Now": "Registrati ora",

  "Delete": "Elimina",
  "New Patient": "New Patient",
  "Add Patient": "Aggiungi paziente",
  "Filter": "Filtra",
  "Name": "Nome",
  "Gender": "Sesso",
  "Age": "Età",
  "Type": "Tipo",
  "Duration": "Durata",
  "Connections": "Creatore di account",
  "UploadTime": "Tempo di caricamento",
  "Year": "anni",
  "Years": "anni",
  "Month": "mese",
  "Month2": "Mese",
  "Months": "mese",
  "Invite": "Invita",
  "Invited": "Invitato",
  "All": "Tutti",
  "Female": "Femmina",
  "Male": "Maschio",
  "Not Set": "Imprecisato",
  "Type 1": "Tipo 1",
  "Type 2": "Tipo 2",
  "Gestational": "Gestazionale",
  "Prediabetes": "Prediabete",
  "LADA": "Tipo 1.5 LADA",
  "Apply": "Applica",
  "disUn": "Tipo di diabete non corretto",
  "ageUn": "Età non specificata",
  "genUn": "Sesso non specificato",
  "addP": "Aggiungi paziente",
  "newP": "Nuovo paziente",
  "findP": "Trova paziente",

  "GDRNF": "Imprecisato",
  "GDRF": "Femmina",
  "GDRM": "Maschio",
  "女": "Maschio",

  "DBTNF": "imprecisato",
  "DBT1": "Tipo 1",
  "DBT2": "Tipo 2",
  "DBTLADA": "Tipo 1.5 LADA",
  "DBTPRE": "Prediabete",
  "DBTGEST": "Gestazionale",
  "前期": "beFore",
  "beFore": "beFore",
  "MODY": "Mody",

  "No selection": "Imprecisato",
  "unspecif": "Imprecisato",
  "register": "Paziente",
  "hcp": "Medico",

  "BG": "GS",
  "CARB": "Carboidrati",
  "INS": "Iniezione",
  "EXR": "Esercizio",
  "OTR": "Altro",
  "HBA1C": "HbA1c",
  "DOSE": "DOSE",
  "URINEK": "Chetone nelle urine",
  "HEL": "HEL",
  "OTR1": "Altro",
  "Loading": "Caricamento in corso",

  "home": "Casa",
  "pID": "ID paziente",
  "fullName": "Nome e cognome",
  "gender": "Sesso",
  "height": "Altezza",
  "weight": "Peso",
  "cm": "cm",
  "kg": "kg",
  "birthday": "Data di nascita",
  "disType": "Tipo di diabete",
  "disDate": "Data della diagnosi",
  "Address": "Indirizzo",
  "Postcode": "CAP",
  "Inpatient": "Ricoverato",
  "Yes": "Sì",
  "No": "No",
  "Pno": "N. paziente",
  "Bno": "N. letto",
  "create": "Crea",
  "Telephone": "Telefono",

  "enterU": "Inserisci il nome utente (email)",
  "search": "Ricerca",
  "noU": "È richiesto il nome utente.",
  "searchR": "Search results",
  "uername": "Nome utente",
  "alias": "Alias",
  "remove": "Rimuovi",
  "viewG": "Visualizza grafici",
  "sendR": "Invia richiesta",
  "rSent": "La tua richiesta è stata inviata.",
  "cancelR": "Annulla richiesta",

  "VcodeTip1": "Non l'hai ricevuto? Si prega di attendere un minuto e ",
  "VcodeTip2": "Riprova",
  "VcodeTip3": "Abbiamo appena inviato un codice di verifica a ",
  "Entercode": "Inserisci il codice",
  "Getcode": "Ottieni il codice",

  "messages": "Messaggi",
  "profile": "Profilo",
  "sign out": "Log out",
  "changeP": "Cambia la password",
  "connection": "Elenco contatti",

  "myP": "Il mio profilo",
  "Portrait": "Foto profilo",
  "Profession": "Professione",
  "DPRONF": "Imprecisata",
  "DPROENDOCRIN": "Endocrinologo",
  "DPRODIABTRA": "Educatore per il diabete",
  "DPRONURSE": "Infermiera",
  "DPRODIATIT": "Dietista",
  "DPROOTR": "Altri operatori sanitari",
  "Organization": "Organizzazione",
  "Bio": "Bio",
  "save": "Salva",
  "oldPa": "Vecchia password",
  "newPa": "Nuova password",
  "RePa": "Reinserisci la password",
  "forgetY": "Hai dimenticato la password?",
  "applyM": "Applica",
  "oldErr": "La vecchia password non è corretta.",
  "EntTheSame": "Inserisci nuovamente la nuova password.",
  "EnterOld": "Inserisci la vecchia password.",

  "pList": "Lista dei pazienti",
  "connections": "Elenco contatti",
  "settings": "Impostazioni",
  "monitor": "Monitor",
  "graphs": "Report",
  "events": "Eventi",
  "records": "Record",
  "qPrint": "Stampa veloce",

  "sensorIn": "Informazioni sul sensore",
  "timeOfLaRead": "Ora dell'ultima lettura dal sensore",
  "tranSn": "SN del trasmettitore",
  "status": "Stato",
  "sensorLife": "Durata rimanente del sensore",
  "lastSenorRead": "Ultima lettura dal sensore",
  "TranBattery": "Batteria del trasmettitore",
  "sg": "SG",
  "alert": "Avvisi",
  "target": "Obiettivo",
  "hypo": "Ipo",
  "sensorGlucose": "Glucosio sensore",
  "calib": "Calibrazione",
  "newSen": "Nuovo sensore",
  "warm": "Riscaldamento",
  "InsulinPump": "Microinfusore",
  "timeOfLaPump": "Ora dell'ultimo dato dal microinfusore",
  "pumpSN": "SN base microinfusore",
  "ReserviorLife": "Durata rimanente del serbatoio",
  "InsulinLeft": "Insulina rimanente",
  "basal": "Basale",
  "bolus": "Bolo",
  "totalBasal": "Basale giornaliera totale",
  "lastBolus": "Ultimo bolo",
  "activeInsulin": "Insulina attiva",
  "totalBolus": "Bolo giornaliero totale",
  "tampBasal": "Basale temp",
  "normalBolus": "Bolo normale",
  "extendBolus": "Bolo esteso",
  "manualStop": "Sospensione manuale",
  "autoStop": "Sospensione automatica",
  "auto suspend": "Sospensione automatica",
  "stop": "Somministrazione sospesa",
  "newPatch": "Nuova patch",
  "tempBasal": "Basale temp.",
  "N": "N",
  "E": "E",
  "CN1": "CN",
  "CE": "CE",

  "staticSettings": "Impostazioni report",
  "dataSource": "Origine dei dati",
  "unit": "Unità",
  "glucoseTarget": "Obiettivo glicemico",
  "overall": "Totale",
  "Hypoglycemia": "Ipoglicemia",
  "timePeriod": "Intervallo",
  "postMeal": "Analisi post pasto",
  "Breakfast": "Colazione",
  "Lunch": "Pranzo",
  "Dinner": "Cena",
  "night": "Notte",
  "Before": "Prima",
  "After": "Dopo",
  "Low": "Basso",
  "High": "Alto",
  "From": "Da",
  "To": "A",
  "Hours": "ore",
  "Reset": "Ripristina i valori predefiniti",
  "RealTime": "Tempo reale",
  "uploaded": "Caricato",
  "sensor": "Sensore",
  "pdmSN": "SN PDM",
  "startTime": "Ora di inizio",
  "endTime": "Ora di fine",
  "uploadTime": "Ora di caricamento",
  "pdm": "PDM",
  "Uploaded": "Caricato",
  "Patch Pump": "PDM",
  "overLapp": "Sessioni sovrapposte",

  "daily": "Riepilogo giornaliero",
  "date": "Data",
  "print": "Stampa",
  "carbs": "Carboidrati",
  "exercise": "Esercizio",
  "heavy": "Pesante",
  "Medium": "Medio",
  "Light": "Leggero",
  "dailyReport": "Report di riepilogo giornaliero",
  "devices": "Dispositivi",
  "tran": "Trasmettitore",
  "pumpBase": "Base del microinfusore",
  "HbA1c": "HbA1c",
  "statics": "Statistiche",
  "glucose": "Glucosio",
  "item": "Elemento",
  "BG1": "GS",
  "SG1": "SG",
  "avgSD": "Media (mmol/L)±SD",
  "avgSD1": "Media±SD",
  "min": "Min",
  "max": "Max",
  "ofRead": "# di letture",
  "ofHypo": "# di ipo/durata(min)",
  "ofAlert": "# di avvisi",
  "insulin": "Insulina",
  "insulin2": "Insulina",
  "totalDose": "Dose giornaliera totale",
  "foodBolus": "Bolo alimentare ",
  "Food+coor": "Food+corr",
  "calibBolus": "Correzione bolo",
  "durationStop": "Durata della sospensione(min)",
  "ofPumpAlert": "# di allarmi dal microinfusore",
  "ofMeal": "# di pasti",
  "totalExerTime": "Tempo totale di allenamento",
  "exerNum": "# di esercizi",
  "avgInten": "Intensità media",
  "target1": "Obiettivo",
  "high1": "Alta",
  "low1": "Basso",
  "BG Reading": "Letture GS",

  "dayByday": "Panoramica giornaliera",
  "dayBydayRe": "Report panoramica giornaliera",
  "period": "Periodo",

  "sensorOverlay": "Grafico di comparazione dati del sensore",
  "set": "Imposta",
  "setPeriod": "Imposta periodo",
  "Weekdays": "Giorni feriali",
  "Weekends": "Fine settimana",
  "Mon": "Lun",
  "Tue": "Mar",
  "Wed": "Mer",
  "Thur": "Gio",
  "Thu": "Gio",
  "Fri": "Ven",
  "Sat": "Sab",
  "Sun": "Dom",
  "Average": "Media",
  "sensorOlRe": "Raport di comparazione dati del sensore",
  "Avg": "Media",
  "±SD": "±SD",
  "ofhypo": "# di Ipo",
  "Everyday": "ogni giorno",

  "TrendAna": "Analisi dell'andamento",
  "TrendRe": "Report di analisi degli andamenti",
  "sensorGlu": "Glucosio sensore ",
  "ofBGtest": "# di test GS",
  "Basics": "Statistiche di base",
  "static": "Statistiche",
  "Med": "Mediana",
  "med": "Mediana",
  "Q1": "Q1",
  "Q3": "Q3",
  "Q11": "Q1",
  "Q31": "Q3",
  "IQR": "IQR",
  "SD": "SD",
  "CV": "CV",
  "SE1": "ES Medio",
  "distri": "di distribuzione",
  "stab": "Stabilità",
  "#high": "# di alti",
  "#low": "# di bassi",
  "aucBelow": "AUC sotto il limite",
  "aucAbove": "AUC sopra il limite",
  "bgRead": "Letture GS",
  "total": "Totale",
  "ofBolus": "# di boli",
  "avgBolus": "Bolo medio",
  "Dura1": "Durata (min)",
  "Avg/Total": "Media/Totale",
  "high": "Alto",
  "low": "Basso",
  "#hypo": "# di Ipo",
  "ofExer": "# di esercizi",

  "logbook": "Diario",
  "dailyTotal": "Totale giornaliero",
  "High Glucose": "Glucosio alto",
  "Low Glucose": "Glucosio basso",
  "No Active Patch": "Nessuna patch attiva",
  "Missed Meal": "Pasto mancato",
  "Multiple BG Readings": "Letture multiple di GS",
  "Stop Patch": "Fermo Patch",
  "Others": "Altri",
  "Other Events": "Altri eventi",
  "logRe": "Report diario",

  "DeviceSetting": "Impostazioni del dispositivo",
  "Insulin Pump": "Microinfusore",
  "MaxBasalRate": "Tasso basale massimo",
  "BasalPatterns": "Modelli basali",
  "Selected Basal Pattern": "Modello basale selezionato",
  "Maximum Bolus": "Bolo massimo",
  "Combo/Extended Bolus": "Bolo combinato/esteso",
  "BG Reminder": "Promemoria GS",
  "Bolus Increment": "Incremento del bolo",
  "Bolus Calculator": "Calcolatore di bolo",
  "Active Insulin Time": "Periodo di insulina attiva",
  "IC Ratios": "Rapporti IC",
  "Insulin Sensitivity": "Sensibilità insulinica",
  "BG Target": "Obiettivo GS",
  "Bolus Reminder": "Promemoria bolo",
  "CGM": "CGM",
  "CGM System": "Sistema CGM",
  "Glucose Unit": "Unità di glucosio",
  "Glucose Limits": "Limiti di glucosio",
  "Predicitive Alerts": "Avvisi predittivi",
  "Rate Alerts": "Avvisi di tasso",
  "type": "Tipo",
  "time": "Ora",
  "data": "Data",
  "Rate": "Rate",
  "Calibration Reminder": "Promemoria di calibrazione",
  "Calibration Repeat": "Ripetizione avviso di calibrazione",
  "Snooze": "Ripetizione",
  "Audio Options": "Opzioni audio",
  "Confidence Reminder": "Promemoria di conferma",
  "Backlight": "Retroilluminazione",
  "Sec": "sec.",
  "Alarm Clock": "Sveglia",
  "Patch Expiration": "Scadenza della patch",
  "Sensor Expiration": "Scadenza del sensore",
  "Hourly Max": "Max orario",
  "Daily Max": "Max giornaliero",
  "Low Reservoir": "Serbatoio basso",
  "Low Suspend": "Sospensione bassa",
  "Predictive Low Suspend": "Sospensione su basso previsto",
  "Rise": "Salita",
  "Fall": "Discesa",
  "Auto Off": "Spegnimento automatico",
  "Standard": "Standard",
  "Exercise": "Esercizio",
  "Holiday": "Vacanza",
  "ProgramA": "Modello A",
  "ProgramB": "Modello B",
  "--": "--",
  "Insulin": "Insulinica",

  "SUSA": "Spegnimento automatico",
  "SUSHM": "Superata somministrazione massima di 1 ora",
  "SUSDM": "Superata il dose massima giornaliera",
  "SUSLSG": "Sospensione su basso",
  "SUSPLSG": "Sospensione su basso previsto",
  "Pump Restarted": "Microinfusore riavviato",
  "Meter BG Now": "Misura GS adesso",
  "Sensor Exp in 2 Hours": "Scad. sensore in 2 ore",
  "Sensor Exp in 6 Hours": "Scad. sensore in 6 ore",
  "Sensor Exp in 30 Min": "Scad. sensore in 30 min",
  "Sensor Calibration Error": "Errore calibrazione sensore",
  "Sensor Error": "Nessuna lettura",

  "Device Settings Report": "Report impostazioni dispositivo",
  "24h Total": "24 ore totali",
  "Device Settings at": "Impostazioni dispositivo al",
  "Start": "Inizio",
  "Combo/Ext Bolus": "Bolo combinato/est.",
  "Time Format": "Formato orario",
  "Device Options（CGM System)": "Opzioni del dispositivo (sistema CGM)",
  "Device Options（Insulin Pump)": "Opzioni del dispositivo (microinfusore)",
  "Dispay Settings (Screen)": "Impostazioni Dispay (schermo)",
  "Dispay Settings (Backlight)": "Impostazioni Dispay (retroilluminazione)",
  "Graph Range": "Grafici andamento glucosio",
  "Range": "Range",
  "Repeat": "Ripetizione",
  "Glucose Alerts": "Avvisi glucosio",
  "Alert Silence": "Silenziamento avvisi",

  "Create": "Crea",
  "Event Filter": "Filtro eventi",
  "HbA1c1": "HbA1c",
  "Urine Ketone": "Chetone nelle urine",
  "Injection": "Iniezione",
  "Other": "Altro",
  "Event Type": "Tipo di evento",
  "Details": "Dettagli",
  "Notes": "Note",
  "Source": "Sorgente",
  "edit": "Modifica",
  "Action": "Azioni",
  "EventReport": "Report di riepilogo degli eventi",
  "By Date": "Per data",
  "By Category": "Per categoria",
  "Event Summary": "Riepilogo degli eventi",
  "No data": "Nessun dato",
  "No1": "Nessun",
  "data1": "dato",
  "#": "#",
  "BG Summary": "Riepilogo GS",
  "Carbs Summary": "Riepilogo dei carboidrati",
  "Injection Summary": "Riepilogo delle iniezioni",
  "Exercise Summary": "Riepilogo esercizi",
  "Input Notes": "Inserisci una nota",

  "Profile": "Profilo",
  "Complications": "Complicazioni",
  "Concomitant diseases": "Malattie concomitanti",
  "Suggestion": "Suggerimenti",
  "Coronary heart disease": "Malattia coronarica",
  "High blood lipids": "Lipidi nel sangue alti",
  "High blood pressure": "Alta pressione sanguigna",
  "Kidney disease": "Malattie renali",
  "Neuropathy": "Neuropatia",
  "Obesity": "Obesità",
  "Peripheral arterial disease": "Malattia arteriosa periferica",
  "Retinopathy": "Retinopatia",
  "Smoking addiction": "Dipendenza da fumo",
  "Enter date": "Inserisci la data",
  "Enter suggestion": "Inserisci il suggerimento",
  "Enter Notes": "Enter Notes",
  "Select": "Seleziona",
  "Prescription": "Prescrizione",
  "Medicine": "Medicinale",
  "Dose": "Dose",
  "Enter medicine": "Inserire il medicinale",
  "Enter dose": "Inserire la dose",
  "Enterdis": "Inserisci il malattie concomitanti",
  "Add note": "Aggiungi una nota",
  "Add Content": "La lunghezza massima è di 1000 caratteri.",
  "Other suggestions": "Altri suggerimenti",
  "OK": "OK",
  "HCP": "HCP",
  "Content": "Contenuto",
  "Records Report": "Report delle registrazioni",

  "Quick Print": "Stampa rapida",
  "Quick Print Settings": "Impostazioni di stampa rapida",
  "Select duration": "Seleziona la durata",
  "One Week": "Una settimana",
  "One Month": "Un mese",
  "One Quarter": "Tre mesi",
  "End date": "Data di fine",
  "Yesterday": "Ieri",
  "Last Sunday": "Domenica scorsa",
  "Last Saturday": "Sabato scorso",
  "Last Day of Last Month": "Last Day of Last Month",
  "Last Day of Last Quarter": "Last Day of Last Quarter",
  "Customized": "Imposta",
  "Week Filter": "Filtra settimana",
  "Select reports to print": "Seleziona i report da stampare",
  "Daily Summary": "Riepilogo giornaliero",
  "Day By Day Overview": "Panoramica giorno per giorno",
  "Sensor Overlay": "Comparazione dati sensore",
  "Trend Analysis": "Analisi dell'andamento",
  "Logbook": "Diario",
  "Device Settings Review": "Report delle impostazioni del dispositivo",
  "createReport": "Crea report",

  "Segment Analysis": "Analisi del periodo",
  "Sensor Glucose Profile": "Profilo del glucosio del sensore",
  "# of Boluses": "N. di boli",
  "Bolus Insulin": "Insulina Bolo",
  "Basal Pattern": "Modello basale ",
  "Segment Analysis Report": "Report di analisi del segmento",
  "Avg Glucose": "Glucosio medio",
  "Below": "Sotto",
  "In Target Range": "Nel range obiettivo",
  "Coefficient of variation": "Coefficiente di variazione",
  "% Time CGM Active": "% Tempo CGM attivo",
  "est_a1c_t1": "A1C stimato: ",
  "est_a1c_t2": "calcolato dai valori di SG",
  "est_a1c_t3": "Nota: l'A1C stimato non sostituisce la misurazione di laboratorio",

  "acceptTip": " ti ha permesso di visualizzare in remoto le sue informazioni di salute.",
  "cancelTip": " ha negato l'autorizzazione a visualizzare da remoto le sue informazioni di salute. Puoi fare una nuova richiesta se necessario.",
  "rejectTip": " ha negato la tua richiesta di visualizzazione remota.",
  "Read": "Leggi",

  "Connection": "Contatto",
  "connections1": "Elenco contatti",
  "Add Connection": "Aggiungi contatto",
  "SG": "SG",
  "Active Insulin": "Insulina attiva",
  "Stop following": "Smetti di seguire",
  "Enter username (email)": "Inserisci il nome utente (email)",
  "Search results": "Risultati di ricerca",
  "Send request": "Invia richiesta",
  "View graphs": "Visualizza grafici",
  "Agree": "Approva",
  "Deny": "Nega",
  "Remove": "Rimuovi",
  "Cancel Requset": "Annulla richiesta",
  "Remark": "Commento",

  "Warm up": "Riscaldamento",
  "Monitoring": "Monitoraggio in corso",
  "Transmitter Error": "Errore del trasmettitore",
  "Sensor Failure": "Sensore guasto",
  "Sensor Expired": "Sensore scaduto",
  "Lost Sensor": "Sensore perso",
  "Not Calibrated": "Non calibrato",
  "Calibrating": "Calibrazione in corso",
  "Calibration Needed": "Calibrazione necessaria",
  "Calibration Error": "Errore di calibrazione",
  "Charging Battery": "Caricamento della batteria in corso",
  "Battery Charged": "Batteria carica",

  "To be filled": "In attesa di riempimento",
  "Filled with insulin": "Riempito con insulina",
  "Priming": "Innesco in corso",
  "Priming completed": "Innesco completato",
  "Inserting needle": "Inserimento dell'ago in corso",
  "Patch activated": "Patch attivata",
  "Delivering Basal": "Somministrazione basale in corso",
  "Exceeds Max 1 Hour Delivery": "Superata somministrazione massima di 1 ora",
  "Exceeds Max TDD": "Superata il dose massima giornaliera",
  "Suspend": "Sospeso",
  "Occlusion Detected": "Occlusione rilevata",
  "Patch Expired": "Patch scaduta",
  "Empty Reservoir": "Serbatoio vuoto",
  "Patch Error": "Errore patch",
  "Pump Base Error": "Errore base microinfusore",
  "Patch Battery Depleted": "Batteria patch esaurita",
  "Magnetic sensor not calibrated": "Sensore magnetico non calibrato",

  "Patient Profile": "Profilo del paziente",

  "On": "Acceso",
  "on": "Acceso",
  "Off": "Spento",
  "off": "Spento",

  "CORONARY_HEART_DISEASE": "Malattia coronarica",
  "HIGH_BLOOD_LIPIDS": "Lipidi nel sangue alti",
  "HIGH_BLOOD_PRESSURE": "Alta pressione sanguigna",
  "KIDNEY_DISEASE": "Malattie renali",
  "NEUROPATHY": "Neuropatia",
  "OBESITY": "Obesità",
  "PERIPHERAL_ARTERIAL_DISEASE": "Malattia arteriosa periferica",
  "RETINOPATHY": "Retinopatia",
  "SMOKING_ADDICTION": "Dipendenza da fumo",

  "saveTip": "Salvato con successo.",
  "changePaTip": "La password è stata modificata.",
  "enterEmTip": "Inserisci il tuo indirizzo email.",
  "verErrTip": "Codice di verifica errato.",
  "chooseEventTip": "Scegli gli eventi da stampare",
  "chooseDataTip": "Seleziona i dati da stampare",
  "dateWrongTip": "La data di fine non può essere precedente alla data di inizio.",
  "infoWrongTip": "Si prega di compilare tutti i campi obbligatori.",
  "createdSuccssTip": "Creato con successo",
  "selectData": "Seleziona i dati da salvare",

  "acceSu": "Richiesta di connessione accettata",
  "acceEr": "Aggiunta del nuovo collegamento fallita",
  "rejeSu": "Richiesta di collegamento respinta",
  "rejeEr": "Rifiuto della richiesta fallito",

  "userNotExist": "Il nome utente non esiste.",
  "Password incorrect": "Password scorretta.",
  "UserType incorrect": "Tipo di utente errato",

  "registSuccess": "Il tuo account è stato creato con successo.",
  "registFailed": "Impossibile registrare un nuovo account.",
  "sentSuccess": "Messaggio inviato con successo",
  "sentFailed": "Impossibile inviare il messaggio",
  "Input error": "Errore di inserimento dati",

  "deletePtip": "Sei sicuro di voler eliminare questi pazienti?",
  "deleteEvents": "Sei sicuro di voler cancellare questi eventi?",
  "deleteData": "Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",
  "deleteThis": "Sei sicuro di voler cancellare?",
  "confirm": "Conferma",
  "deleteSuccess": "Cancellato con successo",
  "deleteFailed": "Impossibile eliminare l'elemento",
  "modifySuccess": "Modificato con successo",
  "modifyFailed": "Impossibile effettuare la modifica",
  "createSuccess": "Creato con successo",
  "createFailed": "Creazione fallita",
  "editSuccess": "Modifica eseguita",
  "editFailed": "Modifica fallita",
  "Time overlapped": "Le sessioni selezionate sono sovrapposte",
  "showAlert": "Mostra avvisi",

  "dashboard": "Riepilogo",
  "dboard_glucose_statistics": "Statistiche",
  "dboard_glucose": "Glucosio",
  "dboard_cgm": "CGM",
  "dboard_insulin": "Insulina",
  "dboard_carbs": "Carboidrati",
  "dboard_exercise": "Esercizio",
  "dboard_glucose_avg": "Media",
  "dboard_cgm_avg": "Media",
  "dboard_insulin_avg": "Dose giornaliera media",
  "dboard_carbs_avg": "Carboidrati medi/giorno",
  "dboard_exercise_avg": "Tempo medio/giorno",
  "dboard_sd": "DS",
  "dboard_num": "#",
  "dboard_num_days": "# days",
  "dboard_statistics": "Statistiche",
  "dboard_BG": "GS",
  "dboard_BG_calibration": "GS/Calibrazione (al giorno)",
  "dboard_SG": "SG",
  "dboard_AUC_high": "AUC alto >",
  "dboard_AUC_low": "AUC basso <",
  "dboard_highest_value": "Valore più alto ",
  "dboard_lowest_value": "Valore più basso",

  "dboard_pump": "Microinfusore",
  "dboard_avg_daily_dose": "Dose giornaliera media",
  "dboard_SD": "DS",
  "dboard_daily_basal": "Basale giornaliera",
  "dboard_daily_bolus": "Bolo giornaliero",
  "dboard_avg_bolus_num": "No. medio boli al giorno",
  "dboard_avg_suspend_time": "Tempo medio di sospensione",
  "dboard_avg_reservoir_usage": "Utilizzo medio del serbatoio",
  "dboard_days": "days",

  "dboard_manual_bolus": "Bolo manuale (volume/no. al giorno)",
  "dboard_normal": "-Normale",
  "dboard_extend": "-Esteso",
  "dboard_combo": "-Combinato",

  "dboard_bolus_calculator": "Calculatore Bolo (Volume/no. al giorno)",
  "dboard_food_bolus": "-Calc. bolo pasto",
  "dboard_corr_bolus": "-Calc. bolo correz.",
  "dboard_override_add": "-Bypassa (+)",
  "dboard_override_sub": "-Bypassa (-)",

  "dboard_report": "Riepilogo report",

  "stopFollow": "Sei sicuro di voler smettere di seguire questo paziente?",
  "CancelTip1": "Sei sicuro di voler eliminare questo collegamento?",

  "Warning": "Attenzione",
  "agreeConnect": "Se si fa clic su ''Accetto'' per accettare la richiesta di collegamento, i propri dati di salute saranno resi disponibili al nuovo contatto.",
  "denyConnect": "Sei sicuro di voler rifiutare la richiesta di contatto?",
  "deleteConnect": "Sei sicuro di voler eliminare questo collegamento? Se lo elimini, il contatto non sarà più in grado di visualizzare i tuoi dati di salute.",

  "Choose the events to print": "Scegli gli eventi da stampare",
  "tryAgain": "Riprova",
  "username and password is required": "username and password is required",
  "A name is required": "È richiesto un nome.",
  "username is required": "È richiesto il nome utente.",
  "The date choose wrong": "Scelta data errata",
  "Date no more than 14 days": "Non è possibile selezionare più di 14 giorni.",

  "CancelTip": "Sei sicuro di voler eliminare il collegamento?",
  "removeConnect": "Cancellato con successo",

  "dateErr1": "Non è possibile selezionare più di 90 giorni.",
  "dateErr2": "La data di fine non può essere precedente alla data di inizio.",

  "Not Filled": "Imprecisato",
  "Today": "Oggi",
  "duration": "Durata",
  "interval": "Interval",
  "7 days": "7 giorni",
  "14 days": "14 giorni",
  "30 days": "30 giorni",
  "90 days": "90 giorni",
  "g": "g",

  "Sound+Vibrate": "Audio + Vibrazione",
  "Sound": "Audio",
  "Vibrate": "Vibrazione",
  "Silent": "Non disturbare",
  "1": "Una volta",
  "2": "Giornaliero",
  "noMes": "Non ci sono messaggi.",
  "noConnect": "Non ci sono connessioni.",
  "Customize": "Imposta",
  "GB": "United Kingdom",
  "CN": "China",
  "FR": "France",
  "DD": "Germany",
  "DE": "Germany",
  "SE": "Sweden",
  "AU": "Australia",
  "HKF": "Hongkong",
  "HU": "Hungary",
  "IT": "Italy",
  "NL": "Netherlands",
  "Nor": "Norway",
  "PT": "Portugal",
  "ES": "Spain",
  "TR": "Turkey",

  "Jan": "Gen",
  "Feb": "Feb",
  "Mar": "Mar",
  "Apr": "Apr",
  "May": "Mag",
  "Jun": "Giu",
  "Jul": "Lug",
  "Aug": "Ago",
  "Sep": "Set",
  "Oct": "Ott",
  "Nov": "Nov",
  "Dec": "Dic",
  "ApplyTip": " Richiesta per visualizzare i tuoi dati.",
  "noReadings": "Nessuna lettura",

  "daop_A6_system": "A6 Touchcare System",
  "daop_easytouch_easyview": "EasyTouch / EasyView iPad",
  "daop_TY012_TY015": "TY012/TY015",
  "daop_easysense": "EasySense",
  "daop_delete_data": "Delete Data",
  "daop_uploaded_data": "Dati caricati",
  "daop_uploaded_data_text": "I dati provengono dall'app EasyTouch o dall'app EasyView per iPad.",
  "daop_realtime_data": "Dati in tempo reale",
  "daop_realtime_data_text": "The data is from EasySense App or EasyPatch App.",

  "ins_unit": "(U)",
  "ins_unit2": "U",
  "basal_unit": "(U/H)",
  "basal_unit2": "U/H",

  "Alerts_Patch_Battery_Low": "Batteria patch bassa",
  "Alerts_Patch_Battery_Depleted": "Batteria patch esaurita",
  "Alerts_Lost_Pump": "Lost Pump",
  "Alerts_Low_Reservoir": "Serbatoio basso",
  "Alerts_Empty_Reservoir": "Serbatoio vuoto",
  "Alerts_Patch_Expiration_Advisory": "Avviso di scadenza patch",
  "Alerts_Patch_Exp_In_1_Hour": "Patch Exp In 1 Hour",
  "Alerts_Patch_Expired": "Patch scaduta",
  "Alerts_Patch_Error": "Errore patch",
  "Alerts_Pump_Base_Error": "Errore base microinfusore",
  "Alerts_Basal_Rate_Key_Error": "Basal Rate Key Error",
  "Alerts_Occlusion_Detected": "Occlusione rilevata",
  "Alerts_End_Of_Suspend": "End Of Suspend",
  "Alerts_Exceeds_Max_TDD": "Superato max totale giornaliero",
  "Alerts_Exceeds_Max_1Hr_Delivery": "Superata somministr. max per 1h",

  "Alerts_Predictive_Low_Suspend": "Sospensione su basso previsto",
  "Alerts_Low_Suspend": "Sospensione bassa",
  "Alerts_Auto_Off": "Spegnimento automatico",

  "Alerts_Pump_Restart": "Pump Restart",
  "Alerts_Auto_Off_Warning": "Auto Off Warning",
  "Alerts_Pump_Out_Of_Range": "Pump Out Of Range",

  "Alerts_Lost_Sensor": "Sensore perso",
  "Alerts_Transmitter_Battery_Low": "Batteria del trasmettitore scarica",
  "Alerts_Charge_Transmitter": "Carica il trasmettitore",
  "Alerts_Sensor_Error": "Nessuna lettura",
  "Alerts_Transmitter_Error": "Errore del trasmettitore",
  "Alerts_Sensor_Calibration_Error": "Sensor Calibration Error",

  "Alerts_Sensor_Failure": "Sensore guasto",
  "Alerts_Sensor_Calibration_Reminder": "Sensor Calibration Reminder",
  "Alerts_Meter_BG_Now": "Misura GS adesso",
  "Alerts_Sensor_Exp_in_6_Hours": "Scad. sensore in 6 ore",
  "Alerts_Sensor_Exp_in_2_Hours": "Scad. sensore in 2 ore",
  "Alerts_Sensor_Exp_in_30_Min": "Scad. sensore in 30 min",
  "Alerts_Sensor_Expired": "Sensore scaduto",
  "Alerts_Rapid_Rise": "Salita rapida",
  "Alerts_Rapid_Fall": "Discesa rapida",
  "Alerts_High_Predicted": "Alto previsto",
  "Alerts_Low_Predicted": "Basso previsto",
  "Alerts_High_Glucose": "Glucosio alto",
  "Alerts_Low_Glucose": "Glucosio basso",
  "Alerts_Below_3.1_mmol/L": "Sotto 3,1 mmol/L",
  "Alerts_Transmitter_Battery_Low_2": "Batteria del trasmettitore scarica",

  "Alerts_PDM_Battery_Low": "Batteria PDM bassa",
  "Alerts_Replace_Battery": "Carica il PDM adesso",

  "Alert": "Alert",
  "Alerts": "Avvisi",
  "Alert Filter": "Alert Filter",
  "PDM": "PDM",
  "Pump": "Microinfusore",


  "Out Of Range": "Out Of Range",
  "t1221_Time_in_Auto_Mode": "Tempo in modalità auto",
  "t1221_Average_SG_SD": "Media SG± SD",
  "t1221_Time_in_Target_Range": "Tempo nel target",
  "t1221_Time_above_Range": "Tempo sopra il range",
  "t1221_Time_below_Range": "Tempo sotto il range",
  "t1221_Auto_Basal_per_day": "Basale automatica (al giorno)",
  "t1221_Auto_Bolus_per_day": "Bolo automatico (al giorno)",
  "t1221_Auto_Mode_Exits": "Uscita modalità automatica",
  "t1221_No_Sensor_readings": "nessuna lettura del sensore",
  "t1221_Max_Delivery": "Erogazione massima",
  "t1221_Min_Delivery": "Erogazione minima",
  "t1222_autoModeBasal": "Basale modalità auto",
  "t1222_autoModeCorrBolus": "Correzione del bolo modalità auto",
  "t1222_autoSnack": "Auto Merenda",
  "t1222_autoBreakfast": "Auto Colazione",
  "t1222_autoLunch": "Auto pranzo",
  "t1222_autoDinner": "Auto Cena",
  "t1222_autoExercise": "Auto esercizio",
  "t1222_Snack": "Merenda",
  "t1222_Auto_Mode": "Modalità auto",
  "t1222_Time_in_Auto_Mode": "Tempo in modalità auto(%)",
  "t1222_Avg_SD": "Avg(mg/dL)±SD",
  "t1222_Target_Range": "Range target(%)",
  "t1222_Above_Range": "Sopra il range(%)",
  "t1222_Below_Range": "Sotto il range(%)",
  "t1222_Auto_Mode_Exits": "# uscita di modalità auto",
  "t1221_Auto_Mode": "Modalità auto",
  "t1222_auto_basal": "Basale auto",
  "t1222_auto_bolus": "Bolo auto",
  "t0805_User_Management": "Gestione utenti",
  "t0805_Patient_Management": "Gestione del paziente",
  "t0805_Operation_History": "Cronologia delle operazioni",
  "t0805_User_List": "lista degli utenti",
  "t0805_User": "Utente",
  "t0805_Time": "Volta",
  "t0805_Operation_Type": "Tipo di operazione",
  "t0805_Back": "Indietro",
  "t0805_Add": "Aggiungi",
  "t0805_Delete": "Elimina",
  "t0809_Add_User": "Aggiungi utente",
  "t1028_Pattern_C": "Modello C",
  "t1028_Pattern_D": "Modello D",
  "t1029_Auto_meal_bolus": "Auto meal bolus",
  "t1029_Auto_mode_correction_bolus": "Auto mode correction bolus",
  "t1029_Sick": "Malato",
  "t1029_Auto_Mode_Feature": "Modi auto feator",
  "t1029_Target_SG": "Obbiettivo SG",
  "t1029_Auto_Meal_Handling": "Gestione Auto. Pasto",
  "t1029_Total_Daily_Dose": "Dose Giornaliera Totale",
  "t1029_Pump_Light": "Luce pompa.",
  "t1029_Alerts_for_Hypo": "Avvisi per Ipo",
  "t1102_Out_of_Range": "Fuori dal range",
  "t1102_Command_Reminder": "Promemoria comando",
  "t1102_Alarms_Alerts_on_APP": "Avvisi e allarmi pompa",
  "t1102_Alarms_on_App": "Allarmi App",
  "t1102_Alerts_on_App": "Aviisi App",
  "t1102_Factory_Calibration": "Fattore di calibrazione",
  "t1102_Alerts_for_Low": "Avvisi per basso",
  "t1102_Alerts_for_High": "Avvisi per alto",
  "t1102_Alerts_for_Others": "Altri avvisi",
  "t1102_Adjustment": "Regolazione",
  "t1102_Suggested": "Suggerito",
  "t1103_Glucose": "Glucosio",
  "t1103_CGM": "CGM",
  "t1103_Insulin": "Insulina",
  "t1103_Carbs": "Carboidrati",
  "t1103_Exercise": "Esercizio",
  "t1103_Min_Max": "Min/Max",
  "t1103_Target_Range": "Obiettivo ",
  "t1103_Overall_Tine_In_Range": "Panoramica: Time in range",
  "t1103_Basal": "Basale",
  "t1103_Bolus": "Bolo",
  "t1103_Basal_Bolus": "Basale e boli",
  "t1103_Auto_Mode_Time_In_Range": "Modalità automatica: Time in range",
  "t1103_Time_below_range": "Tempo sotto il range",
  "t1103_Time_above_range": "Tempo sopra il range",
  "t1103_Time_in_target_range": "Tempo nel range",
  "t1103_Incorrect_Password": "Password errata, $1 tentativo rimasto, inserire la password corretta.",
  "t1103_Incorrect_locked": "I tentativi falliti superano il limite, l'account è stato bloccato. Riprova tra $1 minuti.",
  "t1104_The_data_is_from": "I dati provengono dall'app EasySense o dall'app EasyPatch.",
  "t1104_Privacy_Policy": "Privacy policy e Termini d'uso",
  "t1104_updated_privacy_policy": "Abbiamo aggiornato la policy sulla privacy e i termini d'uso. Per favore leggere attentamente e acconsentire ai nuovi termini prima di utilizzare EasyPatch.",
  "t1104_Disagree": "Non acconsento",
  "t1104_Agree": "Acconsenti",
  "t1105_Upload_History": "Carica cronologia",
  "t1105_Delete_Data": "Elimina dati",
  "t1105_Target_Range": "Obiettivo ",
  "t1105_request_to_view_your_data": "$1 richiesta per visualizzare i tuoi dati.",
  "t1105_Recent_Updates": "Aggiornamenti recenti",
  "t1108_No_data": "Nessun dato",
  "t1108_Pump_Bash_SN": "SN base del microinfusore",
  "t1108_Transmitter_SN": "SN trasmettitore",
  "t1112_Normal_Glucose": "Glucosio Normale",
  "t1112_Manual_Bolus_or_Modified_Bolus": "Bolus manuale o bolus modificato",
  "t1112_Auto_Mode_Started": "Modalità auto avviata",
  "t1112_Auto_Mode_Exit": "Uscita dalla modalità auto",
  "t1112_Normal_Bolus": "Bolo normale",
  "t1112_Extended_Bolus": "Bolo esteso",
  "t1112_Combo_Bolus": "Bolo combinato",
  "t1112_Carbs": "Carboidrati",
  "t1112_Glucose": "Glucosio",
  "t1112_BG": "GS",
  "t1112_Audio": "Audio",
  "t1112_Tone": "Toni",
  "t1112_Audio_Options": "Opzioni audio",
  "t1112_Weight_Unit": "Unità Di Peso",
  "t1112_Height_Unit": "Unità Di Altezza",
  "t1112_Not_available": "Non Disponibile",
  "t1112_Number": "Numero",
  "t1112_days": "# giorni",
  "t1112_min": "min",
  "t1113_days": "giorni",
  "t1215_Security": "Sicurezza",
  "t1215_MFA": "Autenticazione a più fattori (MFA)",
  "t1215_Enter_verification_code": "Inserisci il codice di verifica",
  "t1215_Multi_factor_ON": "L'autenticazione a più fattori è ATTIVA. Il codice di verifica è stato inviato a $1 Invia il codice di verifica.",
  "t1215_Verification_code_incorrect": "Codice di verifica non corretto",
  "t1215_Show_Glucose_Value": "Mostra il valore del glucosio",
  "t1221_enter_verification_code": "Inserisci il codice di verifica a 6 cifre inviato a $1.",
  "t1221_Verification_Success": "Verificato con successo",
  "t1222_We_will_only_process": "Con il tuo consenso elaboreremo i tuoi dati sanitari solo tramite l'app/sito web di Medtrum. ",
  "t1222_If_you_are_under_years": "Se si ha meno di 16 anni, è necessario il consenso del genitore o del tutore legale per registrarsi in questa app.",
  "t1221_register_cn": "Hai il diritto di non caricare i dati del dispositivo sull'app, nel qual caso i dati non saranno accessibili ad altri. Se si sceglie di non registrarsi nell'app/sito Web di Medtrum, i dati sanitari rimarranno solamente sul dispositivo stesso. ",
  "t1221_register_eu": "Se si sceglie di registrare il proprio account Medtrum e accedere alla nostra app utilizzando l'account, i dati sanitari registrati sull'app verranno caricati sul nostro server in Europa e saranno conservati per 2 anni. Hai il diritto di non caricare i dati del dispositivo sull'app, nel qual caso i dati non saranno accessibili ad altri. Se si sceglie di non registrarsi nell'app/sito Web di Medtrum, i tuoi dati sanitari saranno conservati solamente sul dispositivo stesso.",
  "t1221_register_follow": "Elaboreremo i tuoi dati sanitari tramite l'app/sito web di Medtrum solo con il tuo consenso.",
  "t1222_Terms_of_Use": "le condizioni d'uso di Medtrum",
  "t1222_Privacy_Policy": "l'informativa sulla privacy di Medtrum",
  "t1222_Create_Account": "Crea un account",
  "t1222_Back": "Indietro",
  "t1222_Verify_your_account": "Verifica il tuo account",
  "t1222_please_check_your_account": "Invieremo un codice di verifica a $1, controlla il tuo account.",
  "t1222_I_Agree_to": "Accetto $1",
  "t1223_Invalid_Verification_Code": "Codice di verifica non valido. Per favore riprova."
};

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return plMessages; });
var plMessages = {
  "privacy_policy_and_terms_of_use": "Privacy Policy and Terms of Use ",
  "privacy_confirm_text": "We've updated our <a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>Privacy Policy</a> and <a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>Terms of Use</a>. To continue using EasyView, you need to read and agree to all the terms.",
  "privacy_confirm_disagree": "Disagree",
  "privacy_confirm_accept": "Accept",

  "title": "EasyView Personal",
  "title1": "EasyView Pro",
  "user": "E-mail",
  "password": "Hasło",
  "remember": "Zapamiętaj mnie",
  "forget": "Nie pamiętasz hasła?",
  "sign in": "Zaloguj się",
  "login": "Login",
  "sign up now": "Zarejestruj się teraz",
  "apply": "Poproś o założenie konta",
  "contact us": "Skontaktuj się z nami",
  "Privacy Policy": "Zasady zachowania poufności informacji",
  "Terms of Use": "Warunki użytkowania",
  "copyright": "Copyright © 2021 Medtrum Technologies Inc. Wszelkie prawa zastrzeżone.",

  "chooseLang": "Wybierz kraj lub język",
  "asia": "Azja",
  "europe": "Europa",
  "middleEast": "Middle East",

  "applyHcp": "Poproś o założenie konta pracownika służby zdrowia",
  "sign up": "Zarejestruj się",
  "Patient": "Pacjent",
  "Caregiver": "Opiekun",
  "Email": "E-mail",
  "Mobile": "Telefon komórkowy",
  "Enter email": "Podaj adres e-mail",
  "Enter mobile": "Podaj numer telefonu komórkowego",
  "Verification": "Kod weryfikacyjny",
  "Invitation": "Invitation code",
  "full name": "Podaj imię i nazwisko",
  "Enter pass": "Podaj hasło",
  "org": "Organizacja",
  "Register": "Register",
  "send": "Wyślij",
  "createAccount": "Create Account",
  "agree": "Znam i akceptuję zasady zachowania poufności informacji oraz warunki świadczenia usług firmy Medtrum.",
  "privacy": "   ",
  "and": " ",
  "use": " ",
  "errtip1-1": "Musisz podać działający adres e-mail, który będzie Twoją nazwą użytkownika nadaną przez firmę Medtrum.",
  "errtip1-2": "",
  "errtip2": "Please enter a valid mobile number.",
  "errtip3": "Błędny kod weryfikacyjny",
  "errtip4": "Incorrect invitation code.",
  "errtip5": "Błędna nazwa użytkownika",
  "errtip6": "Your password must have 8 or more characters.",
  "errtip7": "Podaj organizację.",

  "errp1": "Hasło musi zawierać co najmniej 3 następujące rodzaje znaków:",
  "errp2": "małe litery, wielkie litery, cyfry i znaki specjalne.",
  "errp3": "Hasło musi zawierać od 6 do 20 znaków.",
  "errp4": "Hasło nie może być identyczne jak nazwa użytkownika.",
  "errp5": "Hasło zawierające 3 kolejne cyfry jest nieprawidłowe (np.: 123, 321).",
  "errp6": "Hasło zawierające 3 kolejne litery jest nieprawidłowe (np.: abc, cba).",
  "errp7": "Hasło nie może zawierać spacji.",

  "Find account": "Pobierz hasło.",
  "Enter username": "Podaj nazwę użytkownika.",
  "Next": "Dalej",
  "Cancel": "Anuluj",
  "Back": "Wstecz",
  "Enter veri": "Enter verification code",
  "Verify notice": "Poszukaj kodu weryfikacyjnego w wiadomości e-mail.",
  "Create new": "Utwórz nowe hasło",
  "Create new notice": "Utwórz nowe hasło. Hasło musi mieć co najmniej 6 znaków.",
  "New pass": "Nowe hasło",
  "Completed": "Zakończono",
  "Created": "Utworzono nowe hasło.",
  "Login Now": "Zaloguj się",

  "Delete": "Usuń",
  "New Patient": "New Patient",
  "Add Patient": "Dodaj pacjenta",
  "Filter": "Filtr",
  "Name": "Imię i nazwisko",
  "Gender": "Płeć",
  "Age": "Wiek",
  "Type": "Typ",
  "Duration": "Czas trwania",
  "Connections": "Twórca konta",
  "UploadTime": "Czas przesyłania",
  "Year": "Rok",
  "Years": "Lata",
  "Month": "month",
  "Month2": "Miesiąc",
  "Months": "months",
  "Invite": "Zaproś",
  "Invited": "Zaproszono",
  "All": "Razem",
  "Female": "Kobieta",
  "Male": "Mężczyzna",
  "Not Set": "Not Set",
  "Type 1": "Typ 1",
  "Type 2": "Typ 2",
  "Gestational": "Ciążowy",
  "Prediabetes": "Stan przedcukrzycowy",
  "LADA": "Typ 1.5 LADA",
  "Apply": "Zastosuj",
  "disUn": "Nieokreślony typ cukrzycy",
  "ageUn": "Nieokreślony wiek",
  "genUn": "Nieokreślona płeć",
  "addP": "Dodaj pacjenta",
  "newP": "Nowy pacjent",
  "findP": "Znajdź pacjenta",

  "GDRNF": "Nie określono",
  "GDRF": "Kobieta",
  "GDRM": "Mężczyzna",
  "女": "Mężczyzna",

  "DBTNF": "Nie określono",
  "DBT1": "Typ 1",
  "DBT2": "Typ 2",
  "DBTLADA": "Typ 1.5 LADA",
  "DBTPRE": "Stan przedcukrzycowy",
  "DBTGEST": "Ciążowy",
  "前期": "beFore",
  "beFore": "beFore",
  "MODY": "Mody",

  "No selection": "No selection",
  "unspecif": "Nie określono",
  "register": "Pacjent",
  "hcp": "Lekarz",

  "BG": "GK",
  "CARB": "Węglowodany",
  "INS": "Iniekcja",
  "EXR": "Ćwiczenia",
  "OTR": "Inne",
  "HBA1C": "HbA1c",
  "DOSE": "Dawka",
  "URINEK": "Ketony w moczu",
  "HEL": "HEL",
  "OTR1": "Inne",
  "Loading": "Wczytywanie",

  "home": "Strona główna",
  "pID": "ID pacjenta",
  "fullName": "Imię i nazwisko",
  "gender": "Płeć",
  "height": "Wzrost",
  "weight": "Masa",
  "cm": "cm",
  "kg": "kg",
  "birthday": "Data urodzin",
  "disType": "Typ cukrzycy",
  "disDate": "Data zdiagnozowania",
  "Address": "Adres",
  "Postcode": "Kod pocztowy",
  "Inpatient": "Pacjent hospitalizowany",
  "Yes": "Tak",
  "No": "Nie",
  "Pno": "Nr pacjenta",
  "Bno": "Nr łóżka",
  "create": "Utwórz",
  "Telephone": "Telefon",

  "enterU": "Podaj nazwę użytkownika (e-mail)",
  "search": "Szukaj",
  "noU": "Wymagana jest nazwa użytkownika.",
  "searchR": "Wyniki wyszukiwania",
  "uername": "Nazwa użytkownika",
  "alias": "Alias:",
  "remove": "Usuń",
  "viewG": "Wyświetl wykresy",
  "sendR": "Wyślij prośbę",
  "rSent": "Prośba została wysłana.",
  "cancelR": "Anuluj prośbę",

  "VcodeTip1": "Nic nie dotarło? Poczekaj minutę i spróbuj ponownie.",
  "VcodeTip2": "",
  "VcodeTip3": "Wysłaliśmy kod weryfikacyjny na adres ",
  "Entercode": "Wpisz kod",
  "Getcode": "Uzyskaj kod",

  "messages": "Komunikaty",
  "profile": "Profil",
  "sign out": "Wyloguj się",
  "changeP": "Zmień hasło",
  "connection": "Połączenia",

  "myP": "Mój profil",
  "Portrait": "Zdjęcie profilowe",
  "Profession": "Zawód",
  "DPRONF": "Nie określono",
  "DPROENDOCRIN": "Endokrynolog",
  "DPRODIABTRA": "Edukator diabetologiczny",
  "DPRONURSE": "Pielęgniarka",
  "DPRODIATIT": "Dietetyk",
  "DPROOTR": "Inni pracownicy służby zdrowia",
  "Organization": "Organizacja",
  "Bio": "Bio",
  "save": "Zapisz",
  "oldPa": "Poprzednie hasło ",
  "newPa": "Nowe hasło",
  "RePa": "Powtórz hasło",
  "forgetY": "Nie pamiętasz hasła?",
  "applyM": "Zastosuj",
  "oldErr": "Błędne poprzednie hasło.",
  "EntTheSame": "Ponownie podaj nowe hasło.",
  "EnterOld": "Podaj poprzednie hasło.",

  "pList": "Lista pacjentów",
  "connections": "Połączenia",
  "settings": "Ustawienia",
  "monitor": "Monitor",
  "graphs": "Raporty",
  "events": "Zdarzenia",
  "records": "Rekordy",
  "qPrint": "Szybki wydruk",

  "sensorIn": "Informacje o czujniku",
  "timeOfLaRead": "Godzina ostatniego odczytu czujnika",
  "tranSn": "Numer seryjny nadajnika",
  "status": "Status",
  "sensorLife": "Pozostały czas przydatności czujnika",
  "lastSenorRead": "Ostatni odczyt czujnika",
  "TranBattery": "Bateria nadajnika",
  "sg": "SG",
  "alert": "Alert",
  "target": "Cel",
  "hypo": "Hipogl.",
  "sensorGlucose": "Poziom glukozy z czujnika",
  "calib": "Kalibracja",
  "newSen": "Nowy czujnik",
  "warm": "Rozgrzewanie",
  "InsulinPump": "Pompa insulinowa",
  "timeOfLaPump": "Godzina ostatnich danych pompy",
  "pumpSN": "Numer seryjny bazy pompy",
  "ReserviorLife": "Pozostały czas przydatności plastra zbiornika",
  "InsulinLeft": "Pozostała insulina",
  "basal": "Bazowa",
  "bolus": "Bolus",
  "totalBasal": "Całkowita dzienna bazowa",
  "lastBolus": "Ostatni bolus",
  "activeInsulin": "Aktywna insulina",
  "totalBolus": "Całkowity dzienny bolus",
  "tampBasal": "Tymcz. bazowa",
  "normalBolus": "Bolus normalny",
  "extendBolus": "Bolus przedłużony",
  "manualStop": "Ręczne zawieszenie",
  "autoStop": "Automatyczne zawieszenie",
  "auto suspend": "Automatyczne zawieszenie",
  "stop": "Zatrzymanie podawania",
  "newPatch": "Nowy plaster",
  "tempBasal": "Tymcz. bazowa",
  "N": "N",
  "E": "P",
  "CN1": "CN",
  "CE": "CP",

  "staticSettings": "Raportuj ustawienia",
  "dataSource": "Dane do wyświetlenia",
  "unit": "Jednostka",
  "glucoseTarget": "Docelowy zakres glukozy",
  "overall": "Ogólnie",
  "Hypoglycemia": "Hipoglikemia",
  "timePeriod": "Okres",
  "postMeal": "Analiza po posiłku",
  "Breakfast": "Śniad.",
  "Lunch": "Lancz",
  "Dinner": "Obiad",
  "night": "Pora nocna",
  "Before": "Przed",
  "After": "Po",
  "Low": "Niski",
  "High": "Wysoki",
  "From": "Od",
  "To": "Do",
  "Hours": "Godziny",
  "Reset": "Przywróć domyślne",
  "RealTime": "W czasie rzeczywistym",
  "uploaded": "Przesłane",
  "sensor": "Czujnik",
  "pdmSN": "Numer seryjny PDM",
  "startTime": "Godzina rozpoczęcia",
  "endTime": "Godzina zakończenia",
  "uploadTime": "Czas przesyłania",
  "pdm": "PDM",
  "Uploaded": "Przesłane",
  "Patch Pump": "Pompa plastra",
  "overLapp": "Sesje nakładają się",
  "showAlert": "Pokaż alerty",

  "dashboard": "Panel roboczy",
  "dboard_glucose_statistics": "Glucose Statistics",
  "dboard_glucose": "Glucose",
  "dboard_cgm": "CGM",
  "dboard_insulin": "Insulin",
  "dboard_carbs": "Carbs",
  "dboard_exercise": "Exercise",
  "dboard_glucose_avg": "Average",
  "dboard_cgm_avg": "Średnia",
  "dboard_insulin_avg": "Average Daily Dose",
  "dboard_carbs_avg": "Średnia ilość węglowodanów na dzień",
  "dboard_exercise_avg": "Średni czas na dzień",
  "dboard_sd": "SD",
  "dboard_num": "Nr",
  "dboard_num_days": "# days",
  "dboard_statistics": "Statistics",
  "dboard_BG": "BG",
  "dboard_BG_calibration": "BG / calibration (per day)",
  "dboard_SG": "SG",
  "dboard_AUC_high": "AUC high >",
  "dboard_AUC_low": "AUC low <",
  "dboard_highest_value": "Najwyższa wartość",
  "dboard_lowest_value": "Najniższa wartość",

  "dboard_pump": "Pump",
  "dboard_avg_daily_dose": "Średnia Dzienna Dawka",
  "dboard_SD": "Standardowe Odchylenie",
  "dboard_daily_basal": "Dzienna bazalna",
  "dboard_daily_bolus": "Dzienny bolus",
  "dboard_avg_bolus_num": "Średni dzienny bolus/nr. na dzień",
  "dboard_avg_suspend_time": "Średni czas zawieszenia",
  "dboard_avg_reservoir_usage": "Średnie zużycie zbiornika",
  "dboard_days": "days",

  "dboard_manual_bolus": "Ręcznie wprowadzony bolus (stężenie/nr na dzień)",
  "dboard_normal": "-Normalny",
  "dboard_extend": "-Rozszerzony",
  "dboard_combo": "-Połączony",

  "dboard_bolus_calculator": "Kalkulator insuliny (stężenie/nr na dzień)",
  "dboard_food_bolus": "-Kalkulator bolusa z jedzenia",
  "dboard_corr_bolus": "-Kalkulator bolusa",
  "dboard_override_add": "-Przekroczono(+)",
  "dboard_override_sub": "-Przekroczono(-)",

  "dboard_report": "Panel roboczy raport",

  "daily": "Zestawienie dzienne",
  "date": "Data",
  "print": "Drukuj",
  "carbs": "Węglowodany",
  "exercise": "Ruch",
  "heavy": "Ciężkie",
  "Medium": "Średnie",
  "Light": "Lekkie",
  "dailyReport": "Raport zestawienia dziennego",
  "devices": "Urządzenia",
  "tran": "Nadajnik",
  "pumpBase": "Baza pompy",
  "HbA1c": "HbA1c",
  "statics": "Statystyki",
  "glucose": "Glukoza",
  "item": "Pozycja",
  "BG1": "BG",
  "SG1": "SG",
  "avgSD": "Śr. (mmol/L)±SD",
  "avgSD1": "Śr.±SD",
  "min": "Min.",
  "max": "Maks.",
  "ofRead": "Liczba odczytów",
  "ofHypo": "Liczba hipogl./czas trwania",
  "ofAlert": "Liczba alertów",
  "insulin": "Insulina",
  "insulin2": "Insulina",
  "totalDose": "Całkowity dawka dzienna",
  "foodBolus": "Bolus korekcyjny",
  "Food+coor": "Food+corr",
  "calibBolus": "Bolus korekcyjny ",
  "durationStop": "Czas trwania zawieszenia (min)",
  "ofPumpAlert": "Liczba alarmów pompy",
  "ofMeal": "Liczba posiłków",
  "totalExerTime": "Całkowity czas ćwiczenia",
  "exerNum": "Liczba ćwiczeń",
  "avgInten": "Śr. intensywność",
  "target1": "Cel",
  "high1": "Niski",
  "low1": "Wysoki",
  "BG Reading": "BG Reading",

  "dayByday": "Przegląd dzień po dniu",
  "dayBydayRe": "Raport przeglądu dzień po dniu",
  "period": "Okres",

  "sensorOverlay": "Nakładka czujnika",
  "set": "Ustaw",
  "setPeriod": "Ustaw okres",
  "Weekdays": "Dni tygodnia",
  "Weekends": "Weekendy",
  "Mon": "Pon",
  "Tue": "Wt",
  "Wed": "Śr",
  "Thur": "Cz",
  "Thu": "Cz",
  "Fri": "Pt",
  "Sat": "Sob",
  "Sun": "Nd",
  "Average": "Średnia",
  "sensorOlRe": "Raport nakładki czujnika",
  "Avg": "Śr.",
  "±SD": "±SD",
  "ofhypo": "Liczba hipogl.",
  "Everyday": "codziennie",

  "TrendAna": "Analiza trendu",
  "TrendRe": "Raport analizy trendu",
  "sensorGlu": "Poziom glukozy ",
  "ofBGtest": "Liczba testów BG",
  "Basics": "Podstawy",
  "static": "Statystyki",
  "Med": "Med.",
  "med": "Med.",
  "Q1": "P 1",
  "Q3": "P 3",
  "Q11": "P 1",
  "Q31": "P 3",
  "IQR": "IQR",
  "SD": "SD",
  "CV": "CV",
  "SE1": "SE średniej",
  "distri": "Rozkład",
  "stab": "Stabilność",
  "#high": "Liczba wysokich",
  "#low": "Liczba niskich",
  "aucBelow": "Pole pod krzywą poniżej limitu",
  "aucAbove": "Pole pod krzywą nad limitem",
  "bgRead": "Odczyty BG",
  "total": "Całkowita",
  "avg_daily_basal": "Bazowa",
  "avg_daily_bolus": "Bolus",
  "ofBolus": "Liczba bolusów",
  "avgBolus": "Średni bolus",
  "Dura1": "Czas trwania (min)",
  "Avg/Total": "Śr./Całkowita",
  "high": "Wysoki",
  "low": "Niski",
  "#hypo": "Liczba hipogl.",
  "ofExer": "Liczba ćwiczeń",

  "logbook": "Dziennik",
  "dailyTotal": "Całkowita dzienna",
  "High Glucose": "Wysoki poziom glukozy",
  "Low Glucose": "Niski poziom glukozy",
  "No Active Patch": "Brak aktywnych plastrów",
  "Missed Meal": "Pominięty posiłek",
  "Multiple BG Readings": "Wiele odczytów BG",
  "Stop Patch": "Zatrzymaj plaster",
  "Others": "Inne",
  "Other Events": "Inne zdarzenia",
  "logRe": "Raport dziennika",

  "DeviceSetting": "Przegląd ustawień urządzenia",
  "Insulin Pump": "Pompa insulinowa",
  "MaxBasalRate": "Maksymalna szybkość bazowej",
  "BasalPatterns": "Wzorce bazowej",
  "Selected Basal Pattern": "Wybrany wzorzec bazowej",
  "Maximum Bolus": "Maksymalny bolus",
  "Combo/Extended Bolus": "Bolus combo/przedłużony",
  "BG Reminder": "Przypomnienie o BG",
  "Bolus Increment": "Przyrost bolusa",
  "Bolus Calculator": "Kalkulator bolusa",
  "Active Insulin Time": "Czas aktywnej insuliny",
  "IC Ratios": "Stosunki IW",
  "Insulin Sensitivity": "Czułość insuliny",
  "BG Target": "Cel BG",
  "Bolus Reminder": "Przypomnienie o bolusie",
  "CGM": "Ciągły monitor glukozy",
  "CGM System": "System CGM",
  "Glucose Unit": "Jednostka glukozy",
  "Glucose Limits": "Limity glukozy",
  "Predicitive Alerts": "Alerty predykcyjne",
  "Rate Alerts": "Alerty szybkości",
  "type": "Typ",
  "time": "Godzina",
  "data": "Dane",
  "Rate": "Rate",
  "Calibration Reminder": "Przypomnienie o kalibracji",
  "Calibration Repeat": "Powtórzenie kalibracji",
  "Snooze": "Drzemka",
  "Audio Options": "Opcje audio",
  "Confidence Reminder": "Przypomnienie o pewności",
  "Backlight": "Podświetlenie",
  "Sec": "sek.",
  "Alarm Clock": "Budzik",
  "Patch Expiration": "Utrata przydatności plastra",
  "Sensor Expiration": "Utrata przydatności czujnika",
  "Hourly Max": "Maks. godzinowa",
  "Daily Max": "Maks. dzienna",
  "Low Reservoir": "Zbiornik prawie pusty",
  "Low Suspend": "Niski - zawieszenie",
  "Predictive Low Suspend": "Niski predykcyjny - zawieszenie",
  "Rise": "Wzrost",
  "Fall": "Spadek",
  "Auto Off": "Auto Off",
  "Standard": "Standardowa",
  "Exercise": "Ruch",
  "Holiday": "Wakacje",
  "ProgramA": "Wzorzec A",
  "ProgramB": "Wzorzec B",
  "--": "--",
  "Insulin": "Insulina",

  "SUSA": "Auto wył.",
  "SUSHM": "Przekracza podawanie przez maks. 1 godzinę",
  "SUSDM": "Przekracza maks. dzienną dawkę całk.",
  "SUSLSG": "Niski - zawieszenie",
  "SUSPLSG": "Niski predykcyjny - zawieszenie",
  "Pump Restarted": "Pompa uruchomiona ponownie",
  "Meter BG Now": "Zmierz BG",
  "Sensor Exp in 2 Hours": "Przydatność czujnika wygaśnie za 2 godziny",
  "Sensor Exp in 6 Hours": "Przydatność czujnika wygaśnie za 6 godzin",
  "Sensor Exp in 30 Min": "Przydatność czujnika wygaśnie za 30 minut",
  "Sensor Calibration Error": "Błąd kalibracji czujnika",
  "Sensor Error": "Błąd czujnika",

  "Device Settings Report": "Raport ustawień urządzenia",
  "24h Total": "Całkowita 24h",
  "Device Settings at": "Ustawienia urządzenia z ",
  "Start": "Start",
  "Combo/Ext Bolus": "Bolus combo/przedłużony",
  "Time Format": "Format godziny",
  "Device Options（CGM System)": "Opcje urządzenia（system CGM)",
  "Device Options（Insulin Pump)": "Opcje urządzenia（pompa insulinowa)",
  "Dispay Settings (Screen)": "Ustawienia wyświetlania (ekran)",
  "Dispay Settings (Backlight)": "Ustawienia wyświetlania (podświetlenie)",
  "Graph Range": "Zakres wykresu",
  "Range": "Range",
  "Repeat": "Powtórz",
  "Glucose Alerts": "Alerty glukozy",
  "Alert Silence": "Wyciszenie alertu",

  "Create": "Utwórz",
  "Event Filter": "Filtr zdarzeń",
  "HbA1c1": "HbA1c",
  "Urine Ketone": "Ketony w moczu",
  "Injection": "Iniekcja",
  "Other": "Inne",
  "Event Type": "Typ zdarzenia",
  "Details": "Szczegóły",
  "Notes": "Uwagi",
  "Source": "Źródło",
  "edit": "Edytuj",
  "Action": "Działanie",
  "EventReport": "Raport zestawienia zdarzeń",
  "By Date": "Wg. daty",
  "By Category": "Wg. kategorii",
  "Event Summary": "Zestawienie zdarzeń",
  "No data": "Brak danych",
  "No1": "No",
  "data1": "data",
  "#": "#",
  "BG Summary": "Zestawienie BG",
  "Carbs Summary": "Zestawienie węglowodanów",
  "Injection Summary": "Zestawienie iniekcji",
  "Exercise Summary": "Zestawienie ćwiczeń",
  "Input Notes": "Wpisz uwagę",

  "Profile": "Profil",
  "Complications": "Komplikacje",
  "Concomitant diseases": "Choroby współistniejące",
  "Suggestion": "Sugestia",
  "Coronary heart disease": "Choroba wieńcowa",
  "High blood lipids": "Wysokie stężenie lipidów we krwi",
  "High blood pressure": "Wysokie stężenie lipidów we krwi",
  "Kidney disease": "Choroba nerek",
  "Neuropathy": "Neuropatia",
  "Obesity": "Otyłość",
  "Peripheral arterial disease": "Choroba naczyń obwodowych",
  "Retinopathy": "Retinopatia",
  "Smoking addiction": "Palenie nałogowe",
  "Enter date": "Wpisz datę",
  "Enter suggestion": "Wpisz sugestię",
  "Enter Notes": "Enter Notes",
  "Select": "Wybierz",
  "Prescription": "Recepta",
  "Medicine": "Lek",
  "Dose": "Dawka",
  "Enter medicine": "Wpisz lek",
  "Enter dose": "Wpisz dawkę",
  "Enterdis": "Enter concomitant diseases",
  "Add note": "Dodaj uwagę",
  "Add Content": "Maksymalna długość to 1000 znaków.",
  "Other suggestions": "Inne sugestie",
  "OK": "OK",
  "HCP": "Pracownik służby zdrowia",
  "Content": "Treść",
  "Records Report": "Raport rekordów",

  "Quick Print": "Szybki wydruk",
  "Quick Print Settings": "Ustawienia szybkiego wydruku",
  "Select duration": "Wybierz czas trwania",
  "One Week": "Tydzień",
  "One Month": "Miesiąc",
  "One Quarter": "Kwartał",
  "End date": "Data końcowa",
  "Yesterday": "Wczoraj",
  "Last Sunday": "Ostatnia niedziela",
  "Last Saturday": "Ostatnia sobota",
  "Last Day of Last Month": "Last Day of Last Month",
  "Last Day of Last Quarter": "Last Day of Last Quarter",
  "Customized": "Dostosuj",
  "Week Filter": "Filtr tygodni",
  "Select reports to print": "Wybierz raporty do wydrukowania",
  "Daily Summary": "Zestawienie dzienne",
  "Day By Day Overview": "Przegląd dzień po dniu",
  "Sensor Overlay": "Nakładka czujnika",
  "Trend Analysis": "Analiza trendu",
  "Logbook": "Dziennik",
  "Device Settings Review": "Przegląd ustawień urządzenia",
  "createReport": "Utwórz raport",

  "Segment Analysis": "Analiza segmentu",
  "Sensor Glucose Profile": "Profil poziomu glukozy",
  "# of Boluses": "Liczba bolusów",
  "Bolus Insulin": "Insulina w bolusie",
  "Basal Pattern": "Wzorce bazowej ",
  "Segment Analysis Report": "Raport analizy segmentu",
  "Avg Glucose": "Śr. poziom glukozy",
  "Below": "Poniżej ",
  "In Target Range": "W docelowym zakresie",
  "Coefficient of variation": "Współczynnik zmienności",
  "% Time CGM Active": "% czasu aktywności CGM",
  "est_a1c_t1": "Estimated A1C:",
  "est_a1c_t2": "calculated from SG values",
  "est_a1c_t3": "Uwaga: Szacunkowy A1C nie zastąpi badań laboratoryjnych.",

  "acceptTip": " zezwala już ha zdalne wyświetlanie informacji o stanie zdrowia. ",
  "cancelTip": " nie zezwala już ha zdalne wyświetlanie informacji o stanie zdrowia. W razie potrzeby możesz ponownie poprosić.",
  "rejectTip": " nie zgadza się na zdalny dostęp.",
  "Read": "Przeczytaj",

  "Connection": "Połączenie",
  "connections1": "Połączenie",
  "Add Connection": "Dodaj połączenie",
  "SG": "SG",
  "Active Insulin": "Aktywna insulina",
  "Stop following": "Zatrzymaj obserwowanie",
  "Enter username (email)": "Podaj nazwę użytkownika (e-mail)",
  "Search results": "Wyniki wyszukiwania",
  "Send request": "Wyślij prośbę",
  "View graphs": "Wyświetl wykresy",
  "Agree": "Zgoda",
  "Deny": "Odmowa",
  "Remove": "Usuń",
  "Cancel Requset": "Anuluj prośbę",
  "Remark": "Uwaga",

  "Warm up": "Rozgrzewanie",
  "Monitoring": "Monitorowanie",
  "Transmitter Error": "Błąd nadajnika",
  "Sensor Failure": "Awaria czujnika",
  "Sensor Expired": "Czujnik utracił przydatność",
  "Lost Sensor": "Utracony czujnik",
  "Not Calibrated": "Nie skalibrowano",
  "Calibrating": "Kalibrowanie",
  "Calibration Needed": "Wymagana kalibracja",
  "Calibration Error": "Błąd kalibracji",
  "Charging Battery": "Ładowanie baterii",
  "Battery Charged": "Bateria naładowana",

  "To be filled": "Do wypełnienia",
  "Filled with insulin": "Napełniono insuliną",
  "Priming": "Napełnianie",
  "Priming completed": "Zakończono napełnianie",
  "Inserting needle": "Wkładanie igły",
  "Patch activated": "Uaktywniono plaster",
  "Delivering Basal": "Podawanie bazowej",
  "Exceeds Max 1 Hour Delivery": "Przekracza podawanie przez maks. 1 godzinę",
  "Exceeds Max TDD": "Przekracza maks. dzienną dawkę całk.",
  "Suspend": "Zawieszenie",
  "Occlusion Detected": "Wykryto zatkanie",
  "Patch Expired": "Plaster utracił przydatność",
  "Empty Reservoir": "Pusty zbiornik",
  "Patch Error": "Błąd plastra",
  "Pump Base Error": "Błąd bazy pompy",
  "Patch Battery Depleted": "Rozładowana bateria plastra",
  "Magnetic sensor not calibrated": "Czujnik magnetyczny nieskalibrowany",

  "Patient Profile": "Profil pacjenta",

  "On": "Wł.",
  "on": "Wł.",
  "Off": "Wył.",
  "off": "Wył.",

  "CORONARY_HEART_DISEASE": "Choroba wieńcowa",
  "HIGH_BLOOD_LIPIDS": "Wysokie stężenie lipidów we krwi",
  "HIGH_BLOOD_PRESSURE": "Wysokie stężenie lipidów we krwi",
  "KIDNEY_DISEASE": "Choroba nerek",
  "NEUROPATHY": "Neuropatia",
  "OBESITY": "Otyłość",
  "PERIPHERAL_ARTERIAL_DISEASE": "Choroba naczyń obwodowych",
  "RETINOPATHY": "Retinopatia",
  "SMOKING_ADDICTION": "Palenie nałogowe",

  "saveTip": "Zapisano.",
  "changePaTip": "Hasło zostało zmienione.",
  "enterEmTip": "Podaj adres e-mail.",
  "verErrTip": "Błędny kod weryfikacyjny.",
  "chooseEventTip": "Wybierz zdarzenia do drukowania",
  "chooseDataTip": "Wybierz dane do wydrukowania",
  "dateWrongTip": "The end date cannot be earlier than the start date.",
  "infoWrongTip": "Wypełnij wszystkie wymagane pola.",
  "createdSuccssTip": "Utworzono",
  "selectData": "Wybierz dane do zapisania",

  "acceSu": "Zaakceptuj prośbę o połączenie",
  "acceEr": "Nie można dodać nowego połączenia",
  "rejeSu": "Prośba o połączenie odrzucona",
  "rejeEr": "Nie można odrzucić prośby",

  "userNotExist": "Nazwa użytkownika nie istnieje.",
  "Password incorrect": "Błędne hasło.",
  "UserType incorrect": "Błędny typ użytkownika",

  "registSuccess": "Twoje konto zostało utworzone.",
  "registFailed": "Nie można zarejestrować nowego konta.",
  "sentSuccess": "Wysłano komunikat",
  "sentFailed": "Nie można wysłać komunikatu",
  "Input error": "Błąd wejścia",

  "deletePtip": "Na pewno chcesz usunąć tych pacjentów?",
  "deleteEvents": "Na pewno chcesz usunąć te zdarzenia?",
  "deleteData": "Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",
  "deleteThis": "Na pewno chcesz usunąć?",
  "confirm": "Potwierdź",
  "deleteSuccess": "Usunięto",
  "deleteFailed": "Nie można usunąć tej pozycji",
  "modifySuccess": "Zmieniono",
  "modifyFailed": "Nie można zmienić",
  "createSuccess": "Utworzono",
  "createFailed": "Nie udało się utworzyć",
  "editSuccess": "Przeprowadzono edycję",
  "editFailed": "Nie udało się przeprowadzić edycji",
  "Time overlapped": "Wybrane sesja nakładają się.",

  "stopFollow": "Na pewno chcesz zatrzymać obserwowanie tego pacjenta?",
  "CancelTip1": "Na pewno chcesz usunąć to połączenie?",

  "Warning": "Ostrzeżenie",
  "agreeConnect": "Jeśli klikniesz „Zgoda”, aby zaakceptować prośbę o połączenie, dane o stanie Twojego zdrowia będą dostępne w nowym połączeniu.",
  "denyConnect": "Na pewno chcesz usunąć odrzucić prośbę o połączenie?",
  "deleteConnect": "Na pewno chcesz usunąć to połączenie? Jeśli odrzucisz, połączenie nie będzie dostępne w celu wyświetlania danych o stanie Twoje zdrowia.",

  "Choose the events to print": "Wybierz zdarzenia do drukowania",
  "tryAgain": "Spróbuj ponownie",
  "username and password is required": "username and password is required",
  "A name is required": "Wymagane jest imię i nazwisko.",
  "username is required": "Wymagana jest nazwa użytkownika.",
  "The date choose wrong": "Wybrano błędną datę",
  "Date no more than 14 days": "Nie można wybrać więcej niż 14 dni.",

  "CancelTip": "Na pewno chcesz usunąć połączenie?",
  "removeConnect": "Usunięto",

  "dateErr1": "Nie można wybrać więcej niż 90 dni.",
  "dateErr2": "Data końcowa nie może być wcześniejsza niż początkowa.",

  "Not Filled": "Unspecified",
  "Today": "Dzisiaj",
  "duration": "Czas trwania",
  "interval": "Interval",
  "7 days": "7 dni",
  "14 days": "14 dni",
  "30 days": "30 dni",
  "90 days": "90 dni",
  "g": "g",

  "Sound+Vibrate": "Audio+Wibracje",
  "Sound": "Audio",
  "Vibrate": "Wibracje",
  "Silent": "Nie przeszkadzać",
  "1": "Raz",
  "2": "Codziennie",
  "noMes": "Brak komunikatów.",
  "noConnect": "Brak połączeń.",
  "Customize": "Dostosuj",
  "GB": "United Kingdom",
  "CN": "China",
  "FR": "France",
  "DD": "Germany",
  "DE": "Germany",
  "SE": "Sweden",
  "AU": "Australia",
  "HKF": "Hongkong",
  "HU": "Hungary",
  "IT": "Italy",
  "NL": "Netherlands",
  "Nor": "Norway",
  "PT": "Portugal",
  "ES": "Spain",
  "TR": "Turkey",

  "Jan": "Jan",
  "Feb": "Feb",
  "Mar": "Mar",
  "Apr": "Apr",
  "May": "May",
  "Jun": "Jun",
  "Jul": "Jul",
  "Aug": "Aug",
  "Sep": "Sep",
  "Oct": "Oct",
  "Nov": "Nov",
  "Dec": "Dec",
  "ApplyTip": " request to view your data.",
  "noReadings": "Brak odczytów",

  "daop_A6_system": "A6 Touchcare System",
  "daop_easytouch_easyview": "EasyTouch / EasyView iPad",
  "daop_TY012_TY015": "TY012/TY015",
  "daop_easysense": "EasySense",
  "daop_delete_data": "Delete Data",
  "daop_uploaded_data": "Pobrane dane",
  "daop_uploaded_data_text": "Dane są z aplikacji EasyTouch lub EasyView z iPada.",
  "daop_realtime_data": "Dane w czasie rzeczywistym",
  "daop_realtime_data_text": "The data is from EasySense App or EasyPatch App.",

  "ins_unit": "(J)",
  "ins_unit2": "J",
  "basal_unit": "(J/G)",
  "basal_unit2": "J/G",

  "Alerts_Patch_Battery_Low": "Słaba bateria plastra",
  "Alerts_Patch_Battery_Depleted": "Rozładowana bateria plastra",
  "Alerts_Lost_Pump": "Lost Pump",
  "Alerts_Low_Reservoir": "Zbiornik prawie pusty",
  "Alerts_Empty_Reservoir": "Pusty zbiornik",
  "Alerts_Patch_Expiration_Advisory": "Rada dot. utraty przydatności plastra",
  "Alerts_Patch_Exp_In_1_Hour": "Patch Exp In 1 Hour",
  "Alerts_Patch_Expired": "Plaster utracił przydatność",
  "Alerts_Patch_Error": "Błąd plastra",
  "Alerts_Pump_Base_Error": "Błąd bazy pompy",
  "Alerts_Basal_Rate_Key_Error": "Basal Rate Key Error",
  "Alerts_Occlusion_Detected": "Wykryto zatkanie",
  "Alerts_End_Of_Suspend": "End Of Suspend",
  "Alerts_Exceeds_Max_TDD": "Przekracza maks. dzienną dawkę całk.",
  "Alerts_Exceeds_Max_1Hr_Delivery": "Przekracza podawanie przez maks. 1 godz.",

  "Alerts_Predictive_Low_Suspend": "Niski predykcyjny - zawieszenie",
  "Alerts_Low_Suspend": "Niski - zawieszenie",
  "Alerts_Auto_Off": "Auto wył.",

  "Alerts_Pump_Restart": "Pump Restart",
  "Alerts_Auto_Off_Warning": "Auto Off Warning",
  "Alerts_Pump_Out_Of_Range": "Pump Out Of Range",

  "Alerts_Lost_Sensor": "Utracony czujnik",
  "Alerts_Transmitter_Battery_Low": "Słaba bateria nadajnika",
  "Alerts_Charge_Transmitter": "Naładuj nadajnik",
  "Alerts_Sensor_Error": "Błąd czujnika",
  "Alerts_Transmitter_Error": "Błąd nadajnika",
  "Alerts_Sensor_Calibration_Error": "Sensor Calibration Error",

  "Alerts_Sensor_Failure": "Awaria czujnika",
  "Alerts_Sensor_Calibration_Reminder": "Sensor Calibration Reminder",
  "Alerts_Meter_BG_Now": "Zmierz BG",
  "Alerts_Sensor_Exp_in_6_Hours": "Przydatność czujnika wygaśnie za 6 godzin",
  "Alerts_Sensor_Exp_in_2_Hours": "Przydatność czujnika wygaśnie za 2 godziny",
  "Alerts_Sensor_Exp_in_30_Min": "Przydatność czujnika wygaśnie za 30 minut",
  "Alerts_Sensor_Expired": "Czujnik utracił przydatność",
  "Alerts_Rapid_Rise": "Szybki wzrost",
  "Alerts_Rapid_Fall": "Szybki spadek",
  "Alerts_High_Predicted": "Wysoki przewidywany",
  "Alerts_Low_Predicted": "Niski przewidywany",
  "Alerts_High_Glucose": "Wysoki poziom glukozy",
  "Alerts_Low_Glucose": "Niski poziom glukozy",
  "Alerts_Below_3.1_mmol/L": "Poniżej 3,1 mmol/L",
  "Alerts_Transmitter_Battery_Low_2": "Słaba bateria nadajnika",

  "Alerts_PDM_Battery_Low": "Słaba bateria PDM",
  "Alerts_Replace_Battery": "Naładuj PDM",

  "Alert": "Alert",
  "Alerts": "Alerty",
  "Alert Filter": "Alert Filter",
  "PDM": "PDM",
  "Pump": "Pompa",

  "Out Of Range": "Out Of Range",
  "t1221_Time_in_Auto_Mode": "Time in Auto Mode",
  "t1221_Average_SG_SD": "Average SG ± SD",
  "t1221_Time_in_Target_Range": "Time in Target Range",
  "t1221_Time_above_Range": "Time above Range",
  "t1221_Time_below_Range": "Time below Range",
  "t1221_Auto_Basal_per_day": "Auto Basal (per day)",
  "t1221_Auto_Bolus_per_day": "Auto Bolus (per day)",
  "t1221_Auto_Mode_Exits": "Auto Mode Exits",
  "t1221_No_Sensor_readings": "No Sensor readings",
  "t1221_Max_Delivery": "Max Delivery",
  "t1221_Min_Delivery": "Min Delivery",
  "t1222_autoModeBasal": "Auto Mode Basal",
  "t1222_autoModeCorrBolus": "Auto Mode Correct Bolus",
  "t1222_autoSnack": "Auto Snack",
  "t1222_autoBreakfast": "Auto Breakfast",
  "t1222_autoLunch": "Auto Lunch",
  "t1222_autoDinner": "Auto Dinner",
  "t1222_autoExercise": "Auto Exercise",
  "t1222_Snack": "Snack",
  "t1222_Auto_Mode": "Auto Mode",
  "t1222_Time_in_Auto_Mode": "Time in Auto Mode(%)",
  "t1222_Avg_SD": "Avg.(mmol/L)±SD",
  "t1222_Target_Range": "Target Range(%)",
  "t1222_Above_Range": "Above Range(%)",
  "t1222_Below_Range": "Below Range(%)",
  "t1222_Auto_Mode_Exits": "# of Auto Mode Exits",
  "t1221_Auto_Mode": "Auto Mode",
  "t1222_auto_basal": "Auto Basal",
  "t1222_auto_bolus": "Auto Bolus",
  "t0805_User_Management": "Zarządzanie użytkownikami",
  "t0805_Patient_Management": "Zarządzanie pacjentem",
  "t0805_Operation_History": "Historia operacji",
  "t0805_User_List": "Lista użytkowników",
  "t0805_User": "Użytkownik",
  "t0805_Time": "Czas",
  "t0805_Operation_Type": "Typ operacji",
  "t0805_Back": "Wstecz",
  "t0805_Add": "Dodaj",
  "t0805_Delete": "Usuń",
  "t0809_Add_User": "Dodaj użytkownika",
  "t1028_Pattern_C": "Wzorzec C",
  "t1028_Pattern_D": "Wzorzec D",
  "t1029_Auto_meal_bolus": "Auto meal bolus",
  "t1029_Auto_mode_correction_bolus": "Auto mode correction bolus",
  "t1029_Sick": "Chory",
  "t1029_Auto_Mode_Feature": "Auto Mode Feature",
  "t1029_Target_SG": "Target SG",
  "t1029_Auto_Meal_Handling": "Auto Meal Handling",
  "t1029_Total_Daily_Dose": "Total Daily Dose",
  "t1029_Pump_Light": "Pump Light",
  "t1029_Alerts_for_Hypo": "Alerts for Hypo",
  "t1102_Out_of_Range": "Pompa poza zakresem",
  "t1102_Command_Reminder": "Przypomnienie polecenia",
  "t1102_Alarms_Alerts_on_APP": "Alarmy i alerty na pompie",
  "t1102_Alarms_on_App": "Alarmy w aplikacji",
  "t1102_Alerts_on_App": "Alerty w aplikacji",
  "t1102_Factory_Calibration": "Kalibracja Fabryczna",
  "t1102_Alerts_for_Low": "Alerty dla niskich",
  "t1102_Alerts_for_High": "Alarrty dla wysokich",
  "t1102_Alerts_for_Others": "Alerty dla innych",
  "t1102_Adjustment": "Adjustment",
  "t1102_Suggested": "Sugerowane",
  "t1103_Glucose": "Glukoza",
  "t1103_CGM": "CGM",
  "t1103_Insulin": "Insulina",
  "t1103_Carbs": "Węglowodany",
  "t1103_Exercise": "Ruch",
  "t1103_Min_Max": "Min/Max",
  "t1103_Target_Range": "Target Range",
  "t1103_Overall_Tine_In_Range": "Overall: Time In Range",
  "t1103_Basal": "Basal",
  "t1103_Bolus": "Bolus",
  "t1103_Basal_Bolus": "Basal & Bolus",
  "t1103_Auto_Mode_Time_In_Range": "Auto Mode: Time In Range",
  "t1103_Time_below_range": "Time below range",
  "t1103_Time_above_range": "Time above range",
  "t1103_Time_in_target_range": "Time in target range",
  "t1103_Incorrect_Password": "Nieprawidłowe hasło, $1 Pozostała próba, wprowadź poprawne hasło.",
  "t1103_Incorrect_locked": "Nieudane próby przekraczają limit, konto zostało zablokowane. Spróbuj ponownie za $1 minut.",
  "t1104_The_data_is_from": "Dane są z aplikacji EasySense lub EasyPatch.",
  "t1104_Privacy_Policy": "Privacy Policy and Terms of Use",
  "t1104_updated_privacy_policy": "We have updated our privacy policy and terms of use. Please read and agree to all terms to continue using EasyView.",
  "t1104_Disagree": "Disagree",
  "t1104_Agree": "Zgoda",
  "t1105_Upload_History": "Historia przesyłania",
  "t1105_Delete_Data": "Usunąć dane",
  "t1105_Target_Range": "Target Range",
  "t1105_request_to_view_your_data": "$1 żądanie wyświetlenia Twoich danych.",
  "t1105_Recent_Updates": "Ostatnie aktualizacje",
  "t1108_No_data": "Brak danych",
  "t1108_Pump_Bash_SN": "Numer seryjny bazy pompy",
  "t1108_Transmitter_SN": "Numer seryjny nadajnika",
  "t1112_Normal_Glucose": "Normalna Glukoza",
  "t1112_Manual_Bolus_or_Modified_Bolus": "Bolus ręczny lub bolus zmodyfikowany",
  "t1112_Auto_Mode_Started": "Auto Mode Started",
  "t1112_Auto_Mode_Exit": "Auto Mode Exit",
  "t1112_Normal_Bolus": "Bolus normalny",
  "t1112_Extended_Bolus": "Bolus przedł.",
  "t1112_Combo_Bolus": "Bolus combo",
  "t1112_Carbs": "Węglowod.",
  "t1112_Glucose": "Glukoza",
  "t1112_BG": "BG",
  "t1112_Audio": "Audio",
  "t1112_Tone": "Stonować",
  "t1112_Audio_Options": "Opcje audio",
  "t1112_Weight_Unit": "Jednostka Wagi",
  "t1112_Height_Unit": "Jednostka Wzrostu",
  "t1112_Not_available": "Niedostępne",
  "t1112_Number": "Numer",
  "t1112_days": "# dni",
  "t1112_min": "min",
  "t1113_days": "dni",
  "t1215_Security": "Bezpieczeństwo",
  "t1215_MFA": "Uwierzytelnianie wieloskładnikowe (MFA)",
  "t1215_Enter_verification_code": "Wpisz kod weryfikacyjny",
  "t1215_Multi_factor_ON": "Uwierzytelnianie wieloskładnikowe jest WŁĄCZONE. Kod weryfikacyjny został wysłany na adres $1 Prześlij kod weryfikacyjny",
  "t1215_Verification_code_incorrect": "Błędny kod weryfikacyjny",
  "t1215_Show_Glucose_Value": "Pokaż wartość glukozy",
  "t1221_enter_verification_code": "Wprowadź 6-cyfrowy kod weryfikacyjny wysłany do $1.",
  "t1221_Verification_Success": "Zweryfikowano pomyślnie",
  "t1222_We_will_only_process": "Dane dotyczące opieki zdrowotnej będziemy przetwarzać wyłącznie za pośrednictwem aplikacji Medtrum/strony internetowej za Twoją zgodą. ",
  "t1222_If_you_are_under_years": "Jeśli masz mniej niż 16 lat, będziesz potrzebować zgody rodzica lub opiekuna prawnego, aby zarejestrować się w tej aplikacji.",
  "t1221_register_cn": "Masz prawo nie przesyłać żadnych danych urządzenia do aplikacji, w którym to przypadku dane nie będą dostępne dla innych. Jeśli zdecydujesz się nie rejestrować w aplikacji/witrynie Medtrum, jedyny zapis danych dotyczących opieki zdrowotnej znajduje się na samym urządzeniu. ",
  "t1221_register_eu": "Jeśli zdecydujesz się zarejestrować swoje konto Medtrum i uzyskać dostęp do naszej aplikacji za pomocą konta, dane medyczne zapisane w aplikacji zostaną przesłane na nasz serwer w Europie i będą przechowywane przez 2 lata. Masz prawo nie przesyłać żadnych danych urządzenia do aplikacji, w którym to przypadku dane nie będą dostępne dla innych. Jeśli zdecydujesz się nie rejestrować w aplikacji/witrynie Medtrum, jedyny zapis danych dotyczących opieki zdrowotnej znajduje się na samym urządzeniu.",
  "t1221_register_follow": "Dane dotyczące opieki zdrowotnej będziemy przetwarzać wyłącznie za pośrednictwem aplikacji Medtrum/strony internetowej za Twoją zgodą. ",
  "t1222_Terms_of_Use": "Warunki użytkowania firmy Medtrum",
  "t1222_Privacy_Policy": "zasady zachowania poufności informacji firmy Medtrum",
  "t1222_Create_Account": "Utwórz konto",
  "t1222_Back": "Wstecz",
  "t1222_Verify_your_account": "Zweryfikuj swoje konto",
  "t1222_please_check_your_account": "Wyślemy kod weryfikacyjny do $1, sprawdź swoje konto.",
  "t1222_I_Agree_to": "Akceptuję $1",
  "t1223_Invalid_Verification_Code": "Nieprawidłowy kod weryfikacyjny. Proszę spróbuj ponownie."
};

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return poMessages; });
var poMessages = {
  "privacy_policy_and_terms_of_use": "Privacy Policy and Terms of Use ",
  "privacy_confirm_text": "We've updated our <a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>Privacy Policy</a> and <a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>Terms of Use</a>. To continue using EasyView, you need to read and agree to all the terms.",
  "privacy_confirm_disagree": "Disagree",
  "privacy_confirm_accept": "Accept",

  "title": "EasyView Personal",
  "title1": "EasyView Pro",
  "user": "Email",
  "password": "Palavra-passe",
  "remember": "Lembrar de mim",
  "forget": "Esqueceu-se da sua palavra-chave?",
  "sign in": "Entrar",
  "login": "Login",
  "sign up now": "Regisrar-se agora",
  "apply": "Aplicar agora",
  "contact us": "Contacte Nós",
  "Privacy Policy": "Política de Privacidade",
  "Terms of Use": "Termos de Uso",
  "copyright": "Copyright © 2021 Medtrum Technologies Inc. Todos direitos reservados.",

  "chooseLang": "Escolha seu país ou sua língua",
  "asia": "Ásia",
  "europe": "Europa",

  "applyHcp": "Aplicar por uma conta de médico",
  "sign up": "Registrar-se",
  "Patient": "Paciente",
  "Caregiver": "Cuidador",
  "Email": "Email",
  "Mobile": "Telemóvel",
  "Enter email": "Insira o endereço de Email",
  "Enter mobile": "Insira o telemóvel",
  "Verification": "Código de Verificação",
  "Invitation": "Invitation code",
  "full name": "Insira seu nome completo",
  "Enter pass": "Insira palava-passe",
  "org": "Organização",
  "Register": "Registrar-se",
  "send": "Enviar",
  "agree": "Eu li e aceito a ",
  "privacy": " política de privacidade  ",
  "and": "e os ",
  "use": "temos de serviço.",
  "errtip1-1": "Você precisa inserir um endereço de email válido,",
  "errtip1-2": "na qual será seu nome de usuário Medtrum",
  "errtip2": "Please enter a valid mobile number.",
  "errtip3": "Código de Verificação Incorreto",
  "errtip4": "Incorrect invitation code.",
  "errtip5": "Usuário Incorreto",
  "errtip6": "Your password must have 8 or more characters.",
  "errtip7": "Por favor insira sua organização.",

  "errp1": "A palavra-passe precisa conter pelo menos 3 tipos dos seguintes caracteres:",
  "errp2": "letra maíuscula, letra minúscula, número e um caractere especial",
  "errp3": "A palavra-passe precisa ter entre 6 a 20 caracteres ",
  "errp4": "A palavra-passe precisa ser diferente do nome de usuário",
  "errp5": "A palavra-passe com 3 números consecutivos é inválida (ex: 123, 321).",
  "errp6": "A palavra-passe com 3 letras consecutivas é inválida (ex: abc, cba).",
  "errp7": "A palavra-passe não pode conter espaços.",

  "Find account": "Recupere sua palavra-passe",
  "Enter username": "Por favor insira seu nome de usuário",
  "Next": "Próximo",
  "Cancel": "Cancelar",
  "Back": "Voltar",
  "Enter veri": "Código de Verificação",
  "Verify notice": "Por favor encontre o código de verificação enviado ao seu email",
  "Create new": "Criar uma nova palavra-passe",
  "Create new notice": "Por favor crie uma nova palavra-passe, e sua palavra-passe precisa conter 6 ou mais caracteres",
  "New pass": "Nova Palavra-passe",
  "Completed": "Completado",
  "Created": "Nova Palavra-passe criada",
  "Login Now": "Registrar-se agora",

  "Delete": "Deletar",
  "New Patient": "New Patient",
  "Add Patient": "Adicionar Paciente",
  "Filter": "Filtrar",
  "Name": "Nome",
  "Gender": "Gênero",
  "Age": "Idade",
  "Type": "Tipo",
  "Duration": "Duration",
  "Connections": "Criador de Contas",
  "UploadTime": "Tempo de Carregamento",
  "Year": "anos",
  "Years": "Anos",
  "Month": "mês",
  "Month2": "Mês",
  "Months": "mês",
  "Invite": "Convidar",
  "Invited": "Convidado",
  "All": "Todos",
  "Female": "Feminino ",
  "Male": "Masculino",
  "Not Set": "Não especificado",
  "Type 1": "Tipo 1",
  "Type 2": "Tipo 2",
  "Gestational": "Gestacional",
  "Prediabetes": "Pré-Diabetes",
  "LADA": "Tipo 1.5 LADA",
  "Apply": "Aplicar",
  "disUn": "Tipo de Diabetes não especificado",
  "ageUn": "Idade não especificada",
  "genUn": "Género não especificado",
  "addP": "Adicionar Paciente",
  "newP": "Novo Paciente",
  "findP": "Encontrar Paciente",

  "GDRNF": "Não especificado",
  "GDRF": "Feminino ",
  "GDRM": "Masculino",
  "女": "Masculino",

  "DBTNF": "Não especificado",
  "DBT1": "Tipo 1",
  "DBT2": "Tipo 2",
  "DBTLADA": "Tipo 1.5 LADA",
  "DBTPRE": "Pré-Diabetes",
  "DBTGEST": "Gestacional",
  "前期": "beFore",
  "beFore": "beFore",
  "MODY": "Mody",

  "No selection": "Não especificado",
  "unspecif": "Não especificado",
  "register": "Paciente",
  "hcp": "Clínico",

  "BG": "GS",
  "CARB": "Carboidratos",
  "INS": "Injeção",
  "EXR": "Exercício",
  "OTR": "Outros",
  "HBA1C": "HbA1c",
  "DOSE": "DOSE",
  "URINEK": "Cetona na Urina",
  "HEL": "HEL",
  "OTR1": "Outros",
  "Loading": "A Carregar",

  "home": "Início",
  "pID": "ID do Paciente",
  "fullName": "Nome completo",
  "gender": "Gênero",
  "height": "Altura",
  "weight": "Peso",
  "cm": "cm",
  "kg": "kg",
  "birthday": "Data de nascimento",
  "disType": "Tipo de diabetes",
  "disDate": "Data do diagnóstico",
  "Address": "Endereço",
  "Postcode": "Código Postal",
  "Inpatient": "Paciente Internado",
  "Yes": "Sim",
  "No": "Não",
  "Pno": "Número do Paciente",
  "Bno": "Número da Cama",
  "create": "Criar",
  "Telephone": "Telefone",

  "enterU": "Insira nome de usuário (email)",
  "search": "Buscar",
  "noU": "Nome do usuário é necessário",
  "searchR": "Resultados da Busca",
  "uername": "Nome de usuário",
  "alias": "pseudônimo",
  "remove": "Remover",
  "viewG": "Visualizar gráficos",
  "sendR": "Enviar Pedido",
  "rSent": "Seu pedido foi enviado",
  "cancelR": "Cancelar requisição",

  "VcodeTip1": "Não recebeu? Por favor espere por um minuto e ",
  "VcodeTip2": "tente novamente.",
  "VcodeTip3": "Nós acabamos de enviar um código de verificação para ",
  "Entercode": "Inserir código",
  "Getcode": "Pegar código",

  "messages": "Mensagens",
  "profile": "Perfil",
  "sign out": "Sair",
  "changeP": "Alterar palavra-passe",
  "connection": "Conexões",

  "myP": "Meu perfil",
  "Portrait": "Foto do perfil",
  "Profession": "Profissão",
  "DPRONF": "Não especificado",
  "DPROENDOCRIN": "Endocrinologista",
  "DPRODIABTRA": "Educador de Diabetes",
  "DPRONURSE": "Enfermeiro",
  "DPRODIATIT": "Nutricionista",
  "DPROOTR": "Outros Médicos",
  "Organization": "Organização",
  "Bio": "Bio",
  "save": "Salvar",
  "oldPa": "Palavra-passe antiga",
  "newPa": "Nova Palavra-passe",
  "RePa": "Reinsira a palavra-passe",
  "forgetY": "Esqueceu a palavra-passe?",
  "applyM": "Aplicar",
  "oldErr": "A antiga palavra passe está incorreta",
  "EntTheSame": "Insira a nova palavra passe novamente",
  "EnterOld": "Insira a antiga palavra passe",

  "pList": "Lista de Paciente",
  "connections": "Conexões",
  "settings": "Configurações",
  "monitor": "Monitorar",
  "graphs": "Relatórios",
  "events": "Eventos",
  "records": "Registros",
  "qPrint": "Imprimir rápido",

  "sensorIn": "Informação do Sensor",
  "timeOfLaRead": "Hora da última leitura do sensor",
  "tranSn": "NS do Transmissor",
  "status": "Estado",
  "sensorLife": "Vida do Sensor Restante",
  "lastSenorRead": "Última leitura do sensor",
  "TranBattery": "Bateria do Transmissor",
  "sg": "SG",
  "alert": "Alerta",
  "target": "Alvo",
  "hypo": "Hipoglicemia",
  "sensorGlucose": "Sensor de Glicose",
  "calib": "Calibração",
  "newSen": "Novo Sensor",
  "warm": "Aquecendo",
  "InsulinPump": "Bomba de Insulina",
  "timeOfLaPump": "Hora do último dado da bomba",
  "pumpSN": "NS da Bomba Base",
  "ReserviorLife": "Vida do Reservatório Patch restante",
  "InsulinLeft": "Insulina Restante",
  "basal": "Basal",
  "bolus": "Bolus",
  "totalBasal": "Total diário basal",
  "lastBolus": "Último bolus",
  "activeInsulin": "Insulina Ativa",
  "totalBolus": "Total diário bolus",
  "tampBasal": "Basal Temporário",
  "normalBolus": "Bolus Normal",
  "extendBolus": "Bolus de Onda Quadrada",
  "manualStop": "Suspensão Manual",
  "autoStop": "Suspensão Automática",
  "auto suspend": "Suspensão Automática",
  "stop": "Entrega suspensa",
  "newPatch": "Novo Patch",
  "tempBasal": "Basal Temporário",
  "N": "N",
  "E": "E",
  "CN1": "CN",
  "CE": "CE",

  "staticSettings": "Configurações do Relatório",
  "dataSource": "Fonte de Dados",
  "unit": "Unidade",
  "glucoseTarget": "Intervalo de Glicose Alvo",
  "overall": "No total",
  "Hypoglycemia": "Hipoglicemia",
  "timePeriod": "Período de Tempo",
  "postMeal": "Análise de Pós-Refeição",
  "Breakfast": "Pequeno Almoço",
  "Lunch": "Almoço",
  "Dinner": "Janta",
  "night": "A noite",
  "Before": "Antes",
  "After": "Depois",
  "Low": "Baixo",
  "High": "Alto",
  "From": "De",
  "To": "Para",
  "Hours": "horas",
  "Reset": "Restaurar para configurações padrões",
  "RealTime": "Tempo Real",
  "uploaded": "Enviado",
  "sensor": "Sensor",
  "pdmSN": "NS do GPD",
  "startTime": "Hora de Inicio",
  "endTime": "Hora do término",
  "uploadTime": "Hora de envio",
  "pdm": "GPD",
  "Uploaded": "Enviado",
  "Patch Pump": "GPD",
  "overLapp": "Sessões sobrepostas",
  "showAlert": "Mostrar alertas",

  "dashboard": "Painel de Controlo",
  "dboard_glucose_statistics": "Estatísticas",
  "dboard_glucose": "Glicose",
  "dboard_cgm": "MCG",
  "dboard_insulin": "Insulina",
  "dboard_carbs": "Hidratos de Carbono",
  "dboard_exercise": "Exercício",
  "dboard_glucose_avg": "Média",
  "dboard_cgm_avg": "Média",
  "dboard_insulin_avg": "Dose Média Diária",
  "dboard_carbs_avg": "Ingestão Média Diária de Hidratos de Carbono Média de HC/Dia",
  "dboard_exercise_avg": "Tempo médio/dia",
  "dboard_sd": "DP",
  "dboard_num": "#",
  "dboard_num_days": "# days",
  "dboard_statistics": "Estatísticas",
  "dboard_BG": "GS",
  "dboard_BG_calibration": "GS/Calibração (por dia)",
  "dboard_SG": "GI",
  "dboard_AUC_high": "AUC max >",
  "dboard_AUC_low": "AUC min <",
  "dboard_highest_value": "Valor máximo",
  "dboard_lowest_value": "Valor mínimo",

  "dboard_pump": "Bomba",
  "dboard_avg_daily_dose": "Dose Média Diária",
  "dboard_SD": "DP",
  "dboard_daily_basal": "Basal Diário",
  "dboard_daily_bolus": "Bolus Diário",
  "dboard_avg_bolus_num": "Quant. média de bolus por dia ",
  "dboard_avg_suspend_time": "Tempo Médio de Suspensão",
  "dboard_avg_reservoir_usage": "Utilização Média do Reservatório",
  "dboard_days": "days",

  "dboard_manual_bolus": "Bolus Manual (Volume/quant. diária)",
  "dboard_normal": "-Normal",
  "dboard_extend": "-Alargado",
  "dboard_combo": "-Combinação",

  "dboard_bolus_calculator": "Cálculo de Bolus (Volume/quant. diária)",
  "dboard_food_bolus": "-Calc. bolus alim.",
  "dboard_corr_bolus": "-Calc. bolus corr.",
  "dboard_override_add": "-Sobrepor(+)",
  "dboard_override_sub": "-Sobrepor(-)",

  "dboard_report": "Painel de Controlo Relatório",

  "daily": "Resumo Diário",
  "date": "Data",
  "print": "Imprimir",
  "carbs": "Hidratos de Carbono",
  "exercise": "Exercício",
  "heavy": "Pesado",
  "Medium": "Médio",
  "Light": "Leve",
  "dailyReport": "Relatório do Resumo Diário",
  "devices": "Dispositivos",
  "tran": "Transmissor",
  "pumpBase": "Bomba Base",
  "HbA1c": "HbA1c",
  "statics": "Estatísticas",
  "glucose": "Glicose",
  "item": "Artigo",
  "BG1": "GS",
  "SG1": "GS",
  "avgSD": "Med (mmol/L) ± DP",
  "avgSD1": "Med ± DP",
  "min": "Min",
  "max": "Max",
  "ofRead": "# de leituras",
  "ofHypo": "# de hipoglicemia/duração(min)",
  "ofAlert": "# de alertas",
  "insulin": "Insulina",
  "insulin2": "Insulina",
  "totalDose": "Dose Diária Total",
  "foodBolus": "Bolus de Comida ",
  "Food+coor": "Food+corr",
  "calibBolus": "Correção de Bolus",
  "durationStop": "Duração da suspensão(min)",
  "ofPumpAlert": "# de alertas da boma",
  "ofMeal": "# de refeições",
  "totalExerTime": "Tempo total de exercícios",
  "exerNum": "# de exercícios",
  "avgInten": "Med Intensidade",
  "target1": "Alvo",
  "high1": "Alto",
  "low1": "Baixo ",
  "BG Reading": "Leituras de GS",

  "dayByday": "Visão Geral do Dia a Dia",
  "dayBydayRe": "Relatório da Visão Geral do Dia a Dia",
  "period": "Período",

  "sensorOverlay": "Superposição do Sensor",
  "set": "Configurar",
  "setPeriod": "Configurar Período",
  "Weekdays": "Dia de semana",
  "Weekends": "Final de semana",
  "Mon": "Seg",
  "Tue": "Ter",
  "Wed": "Qua",
  "Thur": "Qui",
  "Thu": "Qui",
  "Fri": "Sex",
  "Sat": "Sab",
  "Sun": "Dom",
  "Average": "Média",
  "sensorOlRe": "Relatório da Superposição do Sensor",
  "Avg": "Med",
  "±SD": "±DP",
  "ofhypo": "# de Hipoglicemia",
  "Everyday": "Todos os dias",

  "TrendAna": "Análise de Tendência",
  "TrendRe": "Relatório de Análise de Tendência",
  "sensorGlu": "Sensor de Glicose ",
  "ofBGtest": "# de testes de GS",
  "Basics": "Báscas",
  "static": "Estatísticas",
  "Med": "Mediano",
  "med": "Mediano",
  "Q1": "Q1",
  "Q3": "Q3",
  "Q11": "Q1",
  "Q31": "Q3",
  "IQR": "IQR",
  "SD": "Desvio Padrão",
  "CV": "Coeficiente de variação",
  "SE1": "Erro Padrão da Média",
  "distri": "Distribuição",
  "stab": "Estabilidade",
  "#high": "# de alto",
  "#low": "# de baixo",
  "aucBelow": "AAC Abaixo do limite ",
  "aucAbove": "AAC Acima do limite",
  "bgRead": "Leituras de GS",
  "total": "Total",
  "ofBolus": "# de bolus",
  "avgBolus": "Média de Bolus",
  "Dura1": "Duração (min)",
  "Avg/Total": "Média/Total",
  "high": "Alto",
  "low": "Baixo",
  "#hypo": "# de Hipoglicemia",
  "ofExer": "# de Exercícios",

  "logbook": "Diário de Bordo",
  "dailyTotal": "Total Diário",
  "High Glucose": "Glicose Alta",
  "Low Glucose": "Glicose Baixa",
  "No Active Patch": "Nenhum Patch Ativo",
  "Missed Meal": "Refeição Perdida",
  "Multiple BG Readings": "Múltiplas leituras de GS",
  "Stop Patch": "Parar Patch",
  "Others": "Outros",
  "Other Events": "Outros Eventos",
  "logRe": "Relatório do Diário de Bordo",

  "DeviceSetting": "Revisão das Configurações dos Dispositivos",
  "Insulin Pump": "Bomba de Insulina",
  "MaxBasalRate": "Taxa Basal Máxima",
  "BasalPatterns": "Padrões Basais",
  "Selected Basal Pattern": "Padrão Basal Selecionado",
  "Maximum Bolus": "Bolus Máximo",
  "Combo/Extended Bolus": "Onda Dupla/ Onda Quadrada",
  "BG Reminder": "Lembrete GS",
  "Bolus Increment": "Incremento de Bolus",
  "Bolus Calculator": "Calculadora de Bolus",
  "Active Insulin Time": "Tempo de Insulina Ativa",
  "IC Ratios": "Índice IC",
  "Insulin Sensitivity": "Sensibilidade à Insulina ",
  "BG Target": "GS Alvo",
  "Bolus Reminder": "Lembrete de Bolus",
  "CGM": "MCG",
  "CGM System": "Sistema CMG",
  "Glucose Unit": "Unidade de Glicose",
  "Glucose Limits": "Limites de Glicose",
  "Predicitive Alerts": "Alertas Previsivos ",
  "Rate Alerts": "Alertas de Taxa ",
  "type": "Tipo",
  "time": "Hora",
  "data": "Dado",
  "Rate": "Rate",
  "Calibration Reminder": "Lembrete de Calibração",
  "Calibration Repeat": "Repetição de Calibração",
  "Snooze": "Soneca",
  "Audio Options": "Opções de Áudio",
  "Confidence Reminder": "Lembrete de Confiança",
  "Backlight": "Luz de fundo",
  "Sec": "seg",
  "Alarm Clock": "Despertador",
  "Patch Expiration": "Expiração do Patch",
  "Sensor Expiration": "Expiração do Sensor",
  "Hourly Max": "Max por hora",
  "Daily Max": "Max diário",
  "Low Reservoir": "Reservatório Baixo",
  "Low Suspend": "Suspensão baixa",
  "Predictive Low Suspend": "Suspensão Preditiva Baixa",
  "Rise": "Aumentar",
  "Fall": "Cair",
  "Auto Off": "Desligar Automático",
  "Standard": "Padrão",
  "Exercise": "Exercícios",
  "Holiday": "Feriado",
  "ProgramA": "Padrão A",
  "ProgramB": "Padrão B",
  "--": "--",
  "Insulin": "Insulina",

  "SUSA": "Desligar Automático",
  "SUSHM": "Excede Max 1h Entregue",
  "SUSDM": "Excede Max TDD",
  "SUSLSG": "Suspensão Baixa",
  "SUSPLSG": "Suspensão Preditiva Baixa",
  "Pump Restarted": "Bomba reiniciado",
  "Meter BG Now": "Medir GS Agora",
  "Sensor Exp in 2 Hours": "Sensor Exp em 2 horas",
  "Sensor Exp in 6 Hours": "Sensor Exp em 6 horas",
  "Sensor Exp in 30 Min": "Sensor Exp em 30 min",
  "Sensor Calibration Error": "Erro na Cal do Sensor",
  "Sensor Error": "Sem leituras",

  "Device Settings Report": "Relatório das Configurações do Dispositivo",
  "24h Total": "Total de 24h",
  "Device Settings at": "Configurações do Dispositivo em ",
  "Start": "Iniciar",
  "Combo/Ext Bolus": "Onda Dupla/ Onda Quadrada",
  "Time Format": "Formato de Hora",
  "Device Options（CGM System)": "Opções do Dispositivo (Sistema CMG)",
  "Device Options（Insulin Pump)": "Opções do Dispositivo (Bomba de Insulina)",
  "Dispay Settings (Screen)": "Configurações de exibição (tela)",
  "Dispay Settings (Backlight)": "Configurações de exibição (Luz de Fundo)",
  "Graph Range": "Faixa Gráfica",
  "Range": "Gráfica",
  "Repeat": "Repetir",
  "Glucose Alerts": "Alarmes de Glicose",
  "Alert Silence": "Alerta Silencioso",

  "Create": "Criar",
  "Event Filter": "Filtros de Eventos",
  "HbA1c1": "HbA1c",
  "Urine Ketone": "Cetona na Urina",
  "Injection": "Injeção",
  "Other": "Outros",
  "Event Type": "Tipo de Evento",
  "Details": "Detalhes",
  "Notes": "Notas",
  "Source": "Recursos",
  "edit": "Editar",
  "Action": "Ação",
  "EventReport": "Relatório do Resumo de Eventos",
  "By Date": "Por Data",
  "By Category": "Por Categora",
  "Event Summary": "Resumo de Evento",
  "No data": "Sem dados",
  "No1": "Nenhum",
  "data1": "dado",
  "#": "#",
  "BG Summary": "Resumo da GS",
  "Carbs Summary": "Resume de Carboidratos",
  "Injection Summary": "Resumo de Injeções",
  "Exercise Summary": "Resumo de Exercícios",
  "Input Notes": "Introduzir uma nota",

  "Profile": "Perfil",
  "Complications": "Complicações",
  "Concomitant diseases": "Doenças Concomitantes",
  "Suggestion": "Sugestão",
  "Coronary heart disease": "Doença cardíaca coronária",
  "High blood lipids": "Lipídios sanguíneos elevados",
  "High blood pressure": "Pressão alta",
  "Kidney disease": "Doenca renal",
  "Neuropathy": "Neuropatia",
  "Obesity": "Obesidade",
  "Peripheral arterial disease": "Doença arterial periférica",
  "Retinopathy": "Retinopatia",
  "Smoking addiction": "Fumante",
  "Enter date": "Insira data",
  "Enter suggestion": "Insira sugestão",
  "Enter Notes": "Insira nota",
  "Select": "Selecionar",
  "Prescription": "Prescrição",
  "Medicine": "Remédio",
  "Dose": "Dose",
  "Enter medicine": "Insira remédio",
  "Enter dose": "Insira dose",
  "Enterdis": "Insira Doenças Concomitantes",
  "Add note": "Adicionar nota",
  "Add Content": "O comprimento máximo é de 1000 caracteres",
  "Other suggestions": "Outras sugestões",
  "OK": "OK",
  "HCP": "Médico",
  "Content": "Conteúdo",
  "Records Report": "Relatório de Registros",

  "Quick Print": "Impressão Rápida",
  "Quick Print Settings": "Configuração de Impressão Rápida",
  "Select duration": "Selecionar duração",
  "One Week": "Uma Semana",
  "One Month": "Um Mês",
  "One Quarter": "Um Trimestre",
  "End date": "Data de término",
  "Yesterday": "Ontem",
  "Last Sunday": "Domingo Passado",
  "Last Saturday": "Sábado Passado",
  "Last Day of Last Month": "Last Day of Last Month",
  "Last Day of Last Quarter": "Last Day of Last Quarter",
  "Customized": "Customizar",
  "Week Filter": "Filtro Semanal",
  "Select reports to print": "Selecione relatórios para imprimir",
  "Daily Summary": "Resumo Diário",
  "Day By Day Overview": "Visão Geral do Dia a Dia",
  "Sensor Overlay": "Superposição do Sensor",
  "Trend Analysis": "Análise de Tendência",
  "Logbook": "Diário de Bordo",
  "Device Settings Review": "Revisão das Configurações do Dispositivo",
  "createReport": "Gerar Relatório",

  "Segment Analysis": "Análise do Período",
  "Sensor Glucose Profile": "Perfil do Sensor de Glicose",
  "# of Boluses": "# de Doses de Bolus",
  "Bolus Insulin": "Bolus de Insulina",
  "Basal Pattern": "Padrões Basais",
  "Segment Analysis Report": "Relatório de Análise de Segmentos",
  "Avg Glucose": "Média Glicose",
  "Below": "Abaixo",
  "In Target Range": "No Intervalo Objetivo",
  "Coefficient of variation": "Coeficiente de variação",
  "% Time CGM Active": "% Tempo MCG Ativo",
  "est_a1c_t1": "A1C Estimada:",
  "est_a1c_t2": "calculada com base nos valores da GI ",
  "est_a1c_t3": "Nota: Esta estimativa do nível de A1C não substitui a medição em laboratório",

  "acceptTip": " permitiu que você visualize as informações de saúde dele (a)",
  "cancelTip": " parou de permitir a visualização remota da informação de saúde dele(a). Você pode aplicar novamente se necessário.",
  "rejectTip": " rejeitou seu pedido de visualização remota",
  "Read": "Consultar",

  "Connection": "Conexão",
  "connections1": "Conexões",
  "Add Connection": "Adicionar Conexão",
  "SG": "SG",
  "Active Insulin": "Insulina Ativa",
  "Stop following": "Parar os seguintes",
  "Enter username (email)": "Insira nome de usuário (email)",
  "Search results": "Resultados da Busca",
  "Send request": "Enviar Pedido",
  "View graphs": "Visualizar gráficos",
  "Agree": "Aceitar",
  "Deny": "Rejeitar",
  "Remove": "Remover",
  "Cancel Requset": "Cancelar Pedido",
  "Remark": "Observação",

  "Warm up": "Aquecendo",
  "Monitoring": "Monitorização",
  "Transmitter Error": "Erro no Transmissor",
  "Sensor Failure": "Falha no Sensor",
  "Sensor Expired": "Sensor Expirado",
  "Lost Sensor": "Sensor Perdido",
  "Not Calibrated": "Não calibrado",
  "Calibrating": "Calibrando",
  "Calibration Needed": "Calibração Necessária",
  "Calibration Error": "Erro na Calibração",
  "Charging Battery": "Carregando Bateria",
  "Battery Charged": "Bateria Carregada",

  "To be filled": "Para ser preenchido",
  "Filled with insulin": "Preenchido com insulina",
  "Priming": "Preparando",
  "Priming completed": "Preparação completada",
  "Inserting needle": "Inserindo agulha",
  "Patch activated": "Patch ativado",
  "Delivering Basal": "Entregando Basal",
  "Exceeds Max 1 Hour Delivery": "Excede Max 1h Entregue",
  "Exceeds Max TDD": "Excede Max TDD",
  "Suspend": "Suspender",
  "Occlusion Detected": "Oclusão Detectada",
  "Patch Expired": "Patch expirado",
  "Empty Reservoir": "Reservatório Vazio",
  "Patch Error": "Erro no Patch",
  "Pump Base Error": "Erro na Bomba Base",
  "Patch Battery Depleted": "Bateria do Patch esgotada",
  "Magnetic sensor not calibrated": "Sensor magnético não calibrado",

  "Patient Profile": "Perfil do Paciente",

  "On": "Ligado",
  "on": "Ligar",
  "Off": "Desligado",
  "off": "Desligado",

  "CORONARY_HEART_DISEASE": "Doença cardíaca coronária",
  "HIGH_BLOOD_LIPIDS": "Lipídios sanguíneos elevados",
  "HIGH_BLOOD_PRESSURE": "Pressão alta",
  "KIDNEY_DISEASE": "Doenca renal",
  "NEUROPATHY": "Neuropatia",
  "OBESITY": "Obesidade",
  "PERIPHERAL_ARTERIAL_DISEASE": "Doença arterial periférica",
  "RETINOPATHY": "Retinopatia",
  "SMOKING_ADDICTION": "Fumante",

  "saveTip": "Salvo com sucesso",
  "changePaTip": "Sua palava-passa foi alterada",
  "enterEmTip": "Insira seu endereço de email",
  "verErrTip": "Código de Verificação incorreto",
  "chooseEventTip": "Selecione eventos para imprimir",
  "chooseDataTip": "Selecione dados para imprimir",
  "dateWrongTip": "A data de término não pode ser antes da data de início",
  "infoWrongTip": "Por favor preencha todos os campos necessários",
  "createdSuccssTip": "Criado com sucesso",
  "selectData": "Selecione dados para salvar",

  "acceSu": "Pedido de conexão aceitada",
  "acceEr": "Falha em adicionar uma nova conexão",
  "rejeSu": "Pedido de conexão rejeitada",
  "rejeEr": "Falha em rejeitar o pedido",

  "userNotExist": "O usuário não existe",
  "Password incorrect": "Palavra-passe incorreta",
  "UserType incorrect": "Tipo de usuário incorreto",

  "registSuccess": "Sua conta foi criada com sucesso.",
  "registFailed": "Falha ao registrar uma nova conta.",
  "sentSuccess": "Mensagem enviada com sucesso",
  "sentFailed": "Falha ao enviar mensagem",
  "Input error": "Erro de introdução",

  "deletePtip": "Você tem certeza que deseja deletar esses pacientes?",
  "deleteEvents": "Tem a certeza de que pretende eliminar estes eventos?",
  "deleteData": "Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",
  "deleteThis": "Tem a certeza de que pretende eliminar ?",
  "confirm": "Confirmar",
  "deleteSuccess": "Deletado com sucesso",
  "deleteFailed": "Falha ao deletar item",
  "modifySuccess": "Trocado com sucesso",
  "modifyFailed": "Falha ao trocar",
  "createSuccess": "Criado com sucesso",
  "createFailed": "Falha ao criar",
  "editSuccess": "Edição com sucesso",
  "editFailed": "Falha ao editar",
  "Time overlapped": "As sessões que você selecionou sobrepuseram um a outro.",

  "stopFollow": "Tem a certeza de que pretende deixar de seguir este paciente?",
  "CancelTip1": "Você tem certeza que deseja deletar essa conexão?",

  "Warning": "Avisar",
  "agreeConnect": "Se você clicar “Aceitar” para aceitar o pedido de conexão, seus dados de saúde estarão disponíveis para a nova conexão.",
  "denyConnect": "Você tem certeza que deseja rejeitar o pedido de conexão?",
  "deleteConnect": "Você tem certeza que deseja deletar essa conexão? Se você deleta-lo(a), a conexão não poderá visualizar seu dado de saúde ",

  "Choose the events to print": "Selecione eventos para imprimir",
  "tryAgain": "Tente novamente",
  "username and password is required": "username and password is required",
  "A name is required": "Um nome é necessário",
  "username is required": "Nome do usuário é",
  "The date choose wrong": "Data incorreta",
  "Date no more than 14 days": "Você não pode selecionar mais de 14 dias.",

  "CancelTip": "Você tem certeza que deseja deletar a conexão?",
  "removeConnect": "Deletado com sucesso",

  "dateErr1": "Você não pode selecionar mais de 90 dias.",
  "dateErr2": "A data de término não pode ser antes da data de início",

  "Not Filled": "Não especificado",
  "Today": "Hoje",
  "duration": "Duração",
  "interval": "Interval",
  "7 days": "7 dias",
  "14 days": "14 dias",
  "30 days": "30 dias",
  "90 days": "90 dias",
  "g": "g",

  "Sound+Vibrate": "Áudio+Vibração",
  "Sound": "Audio",
  "Vibrate": "Vibração",
  "Silent": "Modo silencioso",
  "1": "Uma vez",
  "2": "Diariamente",
  "noMes": "Não há mensagens",
  "noConnect": "Não há conexões",
  "Customize": "Customizar",
  "GB": "United Kingdom",
  "CN": "China",
  "FR": "France",
  "DD": "Germany",
  "DE": "Germany",
  "SE": "Sweden",
  "AU": "Australia",
  "HKF": "Hongkong",
  "HU": "Hungary",
  "IT": "Italy",
  "NL": "Netherlands",
  "Nor": "Norway",
  "PT": "Portugal",
  "ES": "Spain",
  "TR": "Turkey",

  "Jan": "Jan",
  "Feb": "Fev",
  "Mar": "Mar",
  "Apr": "Abr",
  "May": "Mai",
  "Jun": "Jun",
  "Jul": "Jul",
  "Aug": "Ago",
  "Sep": "Sep",
  "Oct": "Out",
  "Nov": "Nov",
  "Dec": "Dez",
  "ApplyTip": " solicitação para visualizar seus dados.",
  "noReadings": "Sem leituras",

  "daop_A6_system": "A6 Touchcare System",
  "daop_easytouch_easyview": "EasyTouch / EasyView iPad",
  "daop_TY012_TY015": "TY012/TY015",
  "daop_easysense": "EasySense",
  "daop_delete_data": "Delete Data",
  "daop_uploaded_data": "Dados Enviados",
  "daop_uploaded_data_text": "Dados provenientes da Aplicação EasyTouch ou da Aplicação EasyView, para iPad.",
  "daop_realtime_data": "Dados em Tempo Real",
  "daop_realtime_data_text": "The data is from EasySense App or EasyPatch App.",

  "ins_unit": "(U)",
  "ins_unit2": "U",
  "basal_unit": "(U/H)",
  "basal_unit2": "U/H",

  "Alerts_Patch_Battery_Low": "Patch com Bateria Baixa",
  "Alerts_Patch_Battery_Depleted": "Patch com Bateria Esgotada",
  "Alerts_Lost_Pump": "Lost Pump",
  "Alerts_Low_Reservoir": "Reservatório baixo",
  "Alerts_Empty_Reservoir": "Reservatório Vazio",
  "Alerts_Patch_Expiration_Advisory": "Guia de Expiração do Patch",
  "Alerts_Patch_Exp_In_1_Hour": "Patch Exp In 1 Hour",
  "Alerts_Patch_Expired": "Patch Expirado",
  "Alerts_Patch_Error": "Erro no Patch",
  "Alerts_Pump_Base_Error": "Erro na Bomba Base",
  "Alerts_Basal_Rate_Key_Error": "Basal Rate Key Error",
  "Alerts_Occlusion_Detected": "Oclusão Detectada",
  "Alerts_End_Of_Suspend": "End Of Suspend",
  "Alerts_Exceeds_Max_TDD": "Excede Max TDD",
  "Alerts_Exceeds_Max_1Hr_Delivery": "Excede Max 1h Entregue",

  "Alerts_Predictive_Low_Suspend": "Suspensão Preditiva Baixa",
  "Alerts_Low_Suspend": "Suspensão baixa",
  "Alerts_Auto_Off": "Desligar Automático",

  "Alerts_Pump_Restart": "Pump Restart",
  "Alerts_Auto_Off_Warning": "Auto Off Warning",
  "Alerts_Pump_Out_Of_Range": "Pump Out Of Range",

  "Alerts_Lost_Sensor": "Sensor Perdido",
  "Alerts_Transmitter_Battery_Low": "Bateria Baixa do Transmissor",
  "Alerts_Charge_Transmitter": "Carregar Transmissor",
  "Alerts_Sensor_Error": "Sem leituras",
  "Alerts_Transmitter_Error": "Erro no Transmissor",
  "Alerts_Sensor_Calibration_Error": "Sensor Calibration Error",

  "Alerts_Sensor_Failure": "Falha no Sensor",
  "Alerts_Sensor_Calibration_Reminder": "Sensor Calibration Reminder",
  "Alerts_Meter_BG_Now": "Medir GS Agora",
  "Alerts_Sensor_Exp_in_6_Hours": "Sensor Exp em 6 horas",
  "Alerts_Sensor_Exp_in_2_Hours": "Sensor Exp em 2 horas",
  "Alerts_Sensor_Exp_in_30_Min": "Sensor Exp em 30 min",
  "Alerts_Sensor_Expired": "Sensor expirado",
  "Alerts_Rapid_Rise": "Aumento Rápido",
  "Alerts_Rapid_Fall": "Queda Rápida",
  "Alerts_High_Predicted": "Alta Previsivel",
  "Alerts_Low_Predicted": "Baixa Previsivel",
  "Alerts_High_Glucose": "Alta Glicose",
  "Alerts_Low_Glucose": "Baixa Glicose",
  "Alerts_Below_3.1_mmol/L": "Inferior a 3,1 mmol/L",
  "Alerts_Transmitter_Battery_Low_2": "Bateria Baixa do Transmissor",

  "Alerts_PDM_Battery_Low": "Bateria Baixa do GPD",
  "Alerts_Replace_Battery": "Charge PDM Now",
  "Alert": "Alert",
  "Alerts": "Alertas",
  "Alert Filter": "Alert Filter",
  "PDM": "PDM",
  "Pump": "Bomba",

  "Out Of Range": "Out Of Range",
  "t1221_Time_in_Auto_Mode": "Time in Auto Mode",
  "t1221_Average_SG_SD": "Average SG ± SD",
  "t1221_Time_in_Target_Range": "Time in Target Range",
  "t1221_Time_above_Range": "Time above Range",
  "t1221_Time_below_Range": "Time below Range",
  "t1221_Auto_Basal_per_day": "Auto Basal (per day)",
  "t1221_Auto_Bolus_per_day": "Auto Bolus (per day)",
  "t1221_Auto_Mode_Exits": "Auto Mode Exits",
  "t1221_No_Sensor_readings": "No Sensor readings",
  "t1221_Max_Delivery": "Max Delivery",
  "t1221_Min_Delivery": "Min Delivery",
  "t1222_autoModeBasal": "Auto Mode Basal",
  "t1222_autoModeCorrBolus": "Auto Mode Correct Bolus",
  "t1222_autoSnack": "Auto Snack",
  "t1222_autoBreakfast": "Auto Breakfast",
  "t1222_autoLunch": "Auto Lunch",
  "t1222_autoDinner": "Auto Dinner",
  "t1222_autoExercise": "Auto Exercise",
  "t1222_Snack": "Snack",
  "t1222_Auto_Mode": "Auto Mode",
  "t1222_Time_in_Auto_Mode": "Time in Auto Mode(%)",
  "t1222_Avg_SD": "Avg.(mmol/L)±SD",
  "t1222_Target_Range": "Target Range(%)",
  "t1222_Above_Range": "Above Range(%)",
  "t1222_Below_Range": "Below Range(%)",
  "t1222_Auto_Mode_Exits": "# of Auto Mode Exits",
  "t1221_Auto_Mode": "Auto Mode",
  "t1222_auto_basal": "Auto Basal",
  "t1222_auto_bolus": "Auto Bolus",
  "t0805_User_Management": "Gestão de Usuários",
  "t0805_Patient_Management": "Gestão de Pacientes",
  "t0805_Operation_History": "Histórico de Operação",
  "t0805_User_List": "Lista de usuários",
  "t0805_User": "Do utilizador",
  "t0805_Time": "Tempo",
  "t0805_Operation_Type": "Tipo de operação",
  "t0805_Back": "Voltar",
  "t0805_Add": "Adicionar",
  "t0805_Delete": "Deletar",
  "t0809_Add_User": "Adicionar usuário",
  "t1028_Pattern_C": "Padrão C",
  "t1028_Pattern_D": "Padrão D",
  "t1029_Auto_meal_bolus": "Auto meal bolus",
  "t1029_Auto_mode_correction_bolus": "Auto mode correction bolus",
  "t1029_Sick": "Sick",
  "t1029_Auto_Mode_Feature": "Auto Mode Feature",
  "t1029_Target_SG": "Target SG",
  "t1029_Auto_Meal_Handling": "Auto Meal Handling",
  "t1029_Total_Daily_Dose": "Total Daily Dose",
  "t1029_Pump_Light": "Pump Light",
  "t1029_Alerts_for_Hypo": "Alerts for Hypo",
  "t1102_Out_of_Range": "Out of Range",
  "t1102_Command_Reminder": "Lembrete de Comando",
  "t1102_Alarms_Alerts_on_APP": "Alarmes & Alertas na Bomba",
  "t1102_Alarms_on_App": "Alarmes na Aplicação",
  "t1102_Alerts_on_App": "Alertas na Aplicação",
  "t1102_Factory_Calibration": "Factory Calibration",
  "t1102_Alerts_for_Low": "Alertas para Níveis Baixos",
  "t1102_Alerts_for_High": "Alertas para Níveis Altos",
  "t1102_Alerts_for_Others": "Outros Alertas",
  "t1102_Adjustment": "Adjustment",
  "t1102_Suggested": "Sugerido",
  "t1103_Glucose": "Glicose",
  "t1103_CGM": "CMG",
  "t1103_Insulin": "Insulina",
  "t1103_Carbs": "Carboidratos",
  "t1103_Exercise": "Exercício",
  "t1103_Min_Max": "Min/Max",
  "t1103_Target_Range": "Target Range",
  "t1103_Overall_Tine_In_Range": "Overall: Time In Range",
  "t1103_Basal": "Basal",
  "t1103_Bolus": "Bolus",
  "t1103_Basal_Bolus": "Basal & Bolus",
  "t1103_Auto_Mode_Time_In_Range": "Auto Mode: Time In Range",
  "t1103_Time_below_range": "Time below range",
  "t1103_Time_above_range": "Time above range",
  "t1103_Time_in_target_range": "Time in target range",
  "t1103_Incorrect_Password": "Senha incorreta, $1 tentativa restante, digite a senha correta.",
  "t1103_Incorrect_locked": "As tentativas falhadas excedem o limite, a conta foi bloqueada. Tente novamente em $1 minutos.",
  "t1104_The_data_is_from": "Dados provenientes da Alicação EasySense ou da Aplicação EasyPatch.",
  "t1104_Privacy_Policy": "Privacy Policy and Terms of Use",
  "t1104_updated_privacy_policy": "We have updated our privacy policy and terms of use. Please read and agree to all terms to continue using EasyView.",
  "t1104_Disagree": "Disagree",
  "t1104_Agree": "Aceitar",
  "t1105_Upload_History": "Histórico de upload",
  "t1105_Delete_Data": "Apagar dados",
  "t1105_Target_Range": "Target Range",
  "t1105_request_to_view_your_data": "$1 pedido para ver seus dados.",
  "t1105_Recent_Updates": "Atualizações recentes",
  "t1108_No_data": "Sem dados",
  "t1108_Pump_Bash_SN": "NS da Bomba Base",
  "t1108_Transmitter_SN": "NS do Transmissor",
  "t1112_Normal_Glucose": "Glicose Normal",
  "t1112_Manual_Bolus_or_Modified_Bolus": "Bolus manual ou bolus modificado",
  "t1112_Auto_Mode_Started": "Auto Mode Started",
  "t1112_Auto_Mode_Exit": "Auto Mode Exit",
  "t1112_Normal_Bolus": "Bolus Normal",
  "t1112_Extended_Bolus": "Bolus O Quadrad",
  "t1112_Combo_Bolus": "Bolus de Onda Dupla",
  "t1112_Carbs": "Carboidratos",
  "t1112_Glucose": "Glicose",
  "t1112_BG": "GS",
  "t1112_Audio": "Áudio",
  "t1112_Tone": "Som",
  "t1112_Audio_Options": "Opções de Áudio",
  "t1112_Weight_Unit": "Unidade De Peso",
  "t1112_Height_Unit": "Unidade De Altura",
  "t1112_Not_available": "Não Disponível",
  "t1112_Number": "Número",
  "t1112_days": "# days",
  "t1112_min": "min",
  "t1113_days": "days",
  "t1215_Security": "Mostrar valor de glicose",
  "t1215_MFA": "Autenticação multifator (MFA)",
  "t1215_Enter_verification_code": "Digite o código de verificação",
  "t1215_Multi_factor_ON": "Multifaktorgodkendelse er TIL. Bekræftelseskoden er blevet sendt til $1 Indsend venligst bekræftelseskode.",
  "t1215_Verification_code_incorrect": "Código de Verificação Incorreto",
  "t1215_Show_Glucose_Value": "Mostrar valor de glicose",
  "t1221_enter_verification_code": "Insira o código de verificação de 6 dígitos enviado para $1.",
  "t1221_Verification_Success": "Verificado com sucesso",
  "t1222_We_will_only_process": "Apenas processaremos os seus dados de saúde através da aplicação/site Medtrum com o seu consentimento. ",
  "t1222_If_you_are_under_years": "Caso seja menor de 16 anos de idade, o seu registo nesta aplicação dependerá do consentimento dos seus pais ou responsáveis legais.",
  "t1221_register_cn": "Assiste-lhe o direito de não fazer upload de qualquer dado do dispositivo para a aplicação. Nesse caso, os dados não estarão acessíveis a outros utilizadores. Se optar por não se registar na aplicação/site Medtrum, o único registo dos seus dados de saúde estará armazenado no dispositivo. ",
  "t1221_register_eu": "Se optar por criar a sua conta Medtrum e aceder à nossa aplicação através dessa mesma conta, os dados de saúde registados na aplicação serão enviados para o nosso servidor europeu, onde serão conservados durante dois anos. Assiste-lhe o direito de não fazer upload de qualquer dado do dispositivo para a aplicação. Nesse caso, os dados não estarão acessíveis a outros utilizadores. Se optar por não se registar na aplicação/site Medtrum, o único registo dos seus dados de saúde estará armazenado no dispositivo.",
  "t1221_register_follow": "Apenas processaremos os seus dados de saúde através da aplicação/site Medtrum com o seu consentimento.",
  "t1222_Terms_of_Use": "os Termos de Uso da Medtrum",
  "t1222_Privacy_Policy": "a Política de Privacidade da Medtrum",
  "t1222_Create_Account": "Criar Conta",
  "t1222_Back": "Voltar",
  "t1222_Verify_your_account": "Verifique sua conta",
  "t1222_please_check_your_account": "Enviaremos um código de verificação para $1, verifique sua conta.",
  "t1222_I_Agree_to": "Eu Aceito $1",
  "t1223_Invalid_Verification_Code": "Código de verificação inválido. Por favor, tente novamente."
};

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return swMessages; });
var swMessages = {
  "privacy_policy_and_terms_of_use": "Privacy Policy and Terms of Use ",
  "privacy_confirm_text": "We've updated our <a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>Privacy Policy</a> and <a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>Terms of Use</a>. To continue using EasyView, you need to read and agree to all the terms.",
  "privacy_confirm_disagree": "Disagree",
  "privacy_confirm_accept": "Accept",

  "title": "EasyView Personal",
  "title1": "EasyView Pro",
  "user": "E-post",
  "password": "Lösenord",
  "remember": "Kom ihåg mig",
  "forget": "Har du glömt lösenordet?",
  "sign in": "Logga in",
  "login": "Logga",
  "sign up now": "Registrera dig nu",
  "apply": "Ansök nu",
  "contact us": "Kontakta oss",
  "Privacy Policy": "Integritetspolicy",
  "Terms of Use": "Användarvillkor",
  "copyright": "Copyright © 2021 Medtrum Technologies Inc. Med ensamrätt.",

  "chooseLang": "Välj ditt land eller språk",
  "asia": "Asien",
  "europe": "Europa",

  "applyHcp": "Ansök om ett vårdgivarkonto",
  "sign up": "Registrera dig",
  "Patient": "Patient",
  "Caregiver": "Vårdgivare",
  "Email": "E-post",
  "Mobile": "Mobiltelefon",
  "Enter email": "Ange e-postadress",
  "Enter mobile": "Ange mobiltelefonnummer",
  "Verification": "Verifieringskod",
  "Invitation": "Invitation code",
  "full name": "Ange ditt fullständiga namn",
  "Enter pass": "Ange lösenord",
  "org": "Organisation",
  "Register": "Register",
  "send": "Skicka",
  "agree": "Jag har läst och godkänner ",
  "privacy": " Medtrums integritetspolicy  ",
  "and": "och ",
  "use": "användarvillkor.",
  "errtip1-1": "Du måste ange en giltig e-postadress. Den ",
  "errtip1-2": "blir ditt användarnamn på Medtrum.",
  "errtip2": "Please enter a valid mobile number.",
  "errtip3": "Felaktig verifieringskod",
  "errtip4": "Incorrect invitation code.",
  "errtip5": "Felaktigt användarnamn",
  "errtip6": "Your password must have 8 or more characters.",
  "errtip7": "Ange din organisation.",

  "errp1": "Lösenordet måste innehålla minst tre av följande:",
  "errp2": "versal, gemen, siffra eller specialtecken.",
  "errp3": "Lösenordet måste vara mellan 6 och 20 tecken långt.",
  "errp4": "Lösenordet får inte vara identiskt med användarnamnet.",
  "errp5": "Lösenordet får inte ha tre identiska siffror i följd (t.ex. 123, 321).",
  "errp6": "Lösenordet får inte ha tre identiska bokstäver i följd (t.ex. abc, cba).",
  "errp7": "Lösenordet får inte innehålla mellanslag.",

  "Find account": "Återskapa ditt lösenord.",
  "Enter username": "Ange ditt användarnamn.",
  "Next": "Nästa",
  "Cancel": "Avbryt",
  "Back": "Tillbaka",
  "Enter veri": "Verifieringskod",
  "Verify notice": "Vi har skickat verifieringskoden via e-post.",
  "Create new": "Skapa ett nytt lösenord",
  "Create new notice": "Skapa ett nytt lösenord. Det måste ha minst 6 tecken.",
  "New pass": "Nytt lösenord",
  "Completed": "Slutfört",
  "Created": "Det nya lösenordet har skapats.",
  "Login Now": "Logga in nu",

  "Delete": "Ta bort",
  "New Patient": "Ny patient",
  "Add Patient": "Lägg till patient",
  "Filter": "Filter",
  "Name": "Namn",
  "Gender": "Kön",
  "Age": "Ålder",
  "Type": "Typ",
  "Duration": "Varaktighet",
  "Connections": "Kontoskapare",
  "UploadTime": "Uppladdningstid",
  "Year": "år",
  "Years": "år",
  "Month": "månad",
  "Month2": "Månad",
  "Months": "månad",
  "Invite": "Bjud in",
  "Invited": "Inbjuden",
  "All": "Alla",
  "Female": "Kvinna",
  "Male": "Man",
  "Not Set": "Ej angivet",
  "Type 1": "Typ 1",
  "Type 2": "Typ 2",
  "Gestational": "Graviditet",
  "Prediabetes": "Prediabetes",
  "LADA": "Typ 1,5 LADA",
  "Apply": "Använd",
  "disUn": "Diabetestyp ej specificerad",
  "ageUn": "Ålder ej specificerad",
  "genUn": "Kön ej specificerat",
  "addP": "Lägg till patient",
  "newP": "Ny patient",
  "findP": "Sök efter en patient",

  "GDRNF": "Ej angivet",
  "GDRF": "Kvinna",
  "GDRM": "Man",
  "女": "Man",

  "DBTNF": "Ej angivet",
  "DBT1": "Typ 1",
  "DBT2": "Typ 2",
  "DBTLADA": "Typ 1.5 LADA",
  "DBTPRE": "Prediabetes",
  "DBTGEST": "Graviditet",
  "前期": "beFore",
  "beFore": "beFore",
  "MODY": "Mody",

  "No selection": "Ej angivet",
  "unspecif": "Ej angivet",
  "register": "Patient",
  "hcp": "Kliniker",

  "BG": "BS",
  "CARB": "Kolhydrater",
  "INS": "Injektion",
  "EXR": "Träning",
  "OTR": "Övriga",
  "HBA1C": "HbA1c",
  "DOSE": "DOSE",
  "URINEK": "Urinketon",
  "HEL": "HEL",
  "OTR1": "Övrigt",
  "Loading": "Laddar",

  "home": "Hem",
  "pID": "Patient-ID",
  "fullName": "Fullständigt namn",
  "gender": "Kön",
  "height": "Längd",
  "weight": "Vikt",
  "cm": "cm",
  "kg": "kg",
  "birthday": "Födelsedatum",
  "disType": "Typ av diabetes",
  "disDate": "Diagnosdatum",
  "Address": "Adress",
  "Postcode": "Postnummer",
  "Inpatient": "Sluten vård",
  "Yes": "Ja",
  "No": "Nej",
  "Pno": "Patientnummer",
  "Bno": "Sängnummer",
  "create": "Skapa",
  "Telephone": "Telefon",

  "enterU": "Ange användarnamn (e-postadress)",
  "search": "Sök",
  "noU": "Du måste ange ett användarnamn.",
  "searchR": "Sökresultat",
  "uername": "Användarnamn",
  "alias": "Alias",
  "remove": "Ta bort",
  "viewG": "Visa diagram",
  "sendR": "Skicka begäran",
  "rSent": "Din begäran har skickats.",
  "cancelR": "Avbryt begäran",

  "VcodeTip1": "Har du inte fått det? Vänta i en minut och ",
  "VcodeTip2": "försök igen.",
  "VcodeTip3": "Vi har just skickat en verifikationskod till ",
  "Entercode": "Ange kod",
  "Getcode": "Hämta kod",

  "messages": "Meddelanden",
  "profile": "Profil",
  "sign out": "Logga ut",
  "changeP": "Byt lösenord",
  "connection": "Connections",

  "myP": "Min profil",
  "Portrait": "Profilbild",
  "Profession": "Yrke",
  "DPRONF": "Ej angivet",
  "DPROENDOCRIN": "Endokrinolog",
  "DPRODIABTRA": "Diabetesupplysare",
  "DPRONURSE": "Sjuksköterska",
  "DPRODIATIT": "Dietist",
  "DPROOTR": "Andra vårdgivare",
  "Organization": "Organisation",
  "Bio": "Bio",
  "save": "Spara",
  "oldPa": "Gammalt lösenord ",
  "newPa": "Nytt lösenord",
  "RePa": "Ange lösenordet igen",
  "forgetY": "Har du glömt lösenordet?",
  "applyM": "Använd",
  "oldErr": "Det gamla lösenordet är felaktigt.",
  "EntTheSame": "Ange det nya lösenordet igen.",
  "EnterOld": "Ange det gamla lösenordet.",

  "pList": "Patientlista",
  "connections": "Anslutningar",
  "settings": "Inställningar",
  "monitor": "Övervaka",
  "graphs": "Rapporter",
  "events": "Händelser",
  "records": "Poster",
  "qPrint": "Snabbutskrift",

  "sensorIn": "Sensorinformation",
  "timeOfLaRead": "Tid för senaste sensoravläsning",
  "tranSn": "Sändarens serienr",
  "status": "Status",
  "sensorLife": "Sensorns återstående användningstid",
  "lastSenorRead": "Senaste sensoravläsning",
  "TranBattery": "Sändarens batteri",
  "sg": "SG",
  "alert": "Varning",
  "target": "Mål",
  "hypo": "Hypo",
  "sensorGlucose": "Sensorglukos",
  "calib": "Kalibrering",
  "newSen": "Ny sensor",
  "warm": "Uppvärmning",
  "InsulinPump": "Insulinpump",
  "timeOfLaPump": "Tid för senaste pumpdata",
  "pumpSN": "Pumpbasens serienr",
  "ReserviorLife": "Återstående användningstid för reservoarpatchen",
  "InsulinLeft": "Återstående insulin",
  "basal": "Basal",
  "bolus": "Bolus",
  "totalBasal": "Total daglig basal",
  "lastBolus": "Senaste bolus",
  "activeInsulin": "Aktivt insulin",
  "totalBolus": "Total daglig bolus",
  "tampBasal": "Temporär basal",
  "normalBolus": "Normal bolus",
  "extendBolus": "Förlängd bolus",
  "manualStop": "Stoppa manuellt",
  "autoStop": "Stoppa automatiskt",
  "auto suspend": "Stoppa automatiskt",
  "stop": "Leveransstopp",
  "newPatch": "Ny patch",
  "tempBasal": "Temporär basal",
  "N": "N",
  "E": "F",
  "CN1": "KN",
  "CE": "KF",

  "staticSettings": "Rapportinställningar",
  "dataSource": "Datakälla",
  "unit": "Enhet",
  "glucoseTarget": "Målintervall för blodsocker",
  "overall": "Övergripande",
  "Hypoglycemia": "Hypoglykemi",
  "timePeriod": "Tidsperiod",
  "postMeal": "Analys efter måltid",
  "Breakfast": "Frukost",
  "Lunch": "Lunch",
  "Dinner": "Kvällsmat",
  "night": "Natt",
  "Before": "Före",
  "After": "Efter",
  "Low": "Lågt",
  "High": "Högt",
  "From": "Från",
  "To": "Till",
  "Hours": "timmar",
  "Reset": "Återställ standardvärden",
  "RealTime": "Realtid",
  "uploaded": "Uppladdat",
  "sensor": "Sensor",
  "pdmSN": "PDM-serienr",
  "startTime": "Starttid",
  "endTime": "Sluttid",
  "uploadTime": "Överföringstid",
  "pdm": "PDM",
  "Uploaded": "Uppladdat",
  "Patch Pump": "PDM",
  "overLapp": "Sessionerna överlappar",
  "showAlert": "Visa varningar",

  "dashboard": "Sammanställning",
  "dboard_glucose_statistics": "Glucose Statistics",
  "dboard_glucose": "Glucose",
  "dboard_cgm": "CGM",
  "dboard_insulin": "Insulin",
  "dboard_carbs": "Carbs",
  "dboard_exercise": "Exercise",
  "dboard_glucose_avg": "Average",
  "dboard_cgm_avg": "Medelvärde",
  "dboard_insulin_avg": "Average Daily Dose",
  "dboard_carbs_avg": "Genomsnittliga kolhydrater/dag",
  "dboard_exercise_avg": "Genomsnittlig tid/dag",
  "dboard_sd": "SD",
  "dboard_num": "#",
  "dboard_num_days": "# days",
  "dboard_statistics": "Statistics",
  "dboard_BG": "BG",
  "dboard_BG_calibration": "BG / calibration (per day)",
  "dboard_SG": "SG",
  "dboard_AUC_high": "AUC high >",
  "dboard_AUC_low": "AUC low <",
  "dboard_highest_value": "Högsta värde (mmol/L)",
  "dboard_lowest_value": "Lägsta värde (mmol/L)",

  "dboard_pump": "Pump",
  "dboard_avg_daily_dose": "Genomsnittlig daglig dos",
  "dboard_SD": "SD",
  "dboard_daily_basal": "Daglig Basaldos ",
  "dboard_daily_bolus": "Daglig Bolusdos ",
  "dboard_avg_bolus_num": "Genomsnittligt antal bolusdoser/dag",
  "dboard_avg_suspend_time": "Genomsnittlig Stoppad tid",
  "dboard_avg_reservoir_usage": "Genomsnittlig användning av Patch	",
  "dboard_days": "days",

  "dboard_manual_bolus": "Manuella bolussdoser (mängd/ antal/dag)",
  "dboard_normal": "-Normal",
  "dboard_extend": "-Förlängd",
  "dboard_combo": "-Kombibolus",

  "dboard_bolus_calculator": "Boluskalkylator (mängd/antal/dag)",
  "dboard_food_bolus": "-Måltidsboluskalk.",
  "dboard_corr_bolus": "-Korr.Boluskalk.",
  "dboard_override_add": "Öka föreslagen bolus",
  "dboard_override_sub": "Minska föreslagen bolus",

  "dboard_report": "Sammanställning Rapport",

  "daily": "Daglig sammanfattning",
  "date": "Datum",
  "print": "Skriv ut",
  "carbs": "Kolhydrater",
  "exercise": "Träning",
  "heavy": "Hård",
  "Medium": "Medelhård",
  "Light": "Lätt",
  "dailyReport": "Daglig sammanfattningsrapport",
  "devices": "Enheter",
  "tran": "Sändare",
  "pumpBase": "Pumpbas",
  "HbA1c": "HbA1c",
  "statics": "Statistik",
  "glucose": "Blodsocker",
  "item": "Objekt",
  "BG1": "BS",
  "SG1": "SG",
  "avgSD": "Medelvärde (mmol/L)±SD",
  "avgSD1": "Medelvärde ± SD",
  "min": "Min",
  "max": "Max",
  "ofRead": "# avläsningar",
  "ofHypo": "# hypo/varaktighet(min)",
  "ofAlert": "# varningar",
  "insulin": "Insulin",
  "insulin2": "Insulin",
  "totalDose": "Total daglig dos",
  "foodBolus": "Måltidsbolus",
  "Food+coor": "Food+corr",
  "calibBolus": "Korrektionsbolus",
  "durationStop": "Stoppvaraktighet(min)",
  "ofPumpAlert": "# pumpalarm",
  "ofMeal": "# måltider",
  "totalExerTime": "Total träningstid",
  "exerNum": "# träningstillfällen",
  "avgInten": "Genomsnittlig intensitet",
  "target1": "Mål",
  "high1": "Högt",
  "low1": "Lågt",
  "BG Reading": "BS-avläsningar",

  "dayByday": "Översikt, dag för dag",
  "dayBydayRe": "Översiktsrapport, dag för dag",
  "period": "Period",

  "sensorOverlay": "Sensoröverlagring",
  "set": "Ställ in",
  "setPeriod": "Ställ in period",
  "Weekdays": "Vardagar",
  "Weekends": "Helger",
  "Mon": "Mån",
  "Tue": "Tis",
  "Wed": "Ons",
  "Thur": "Tors",
  "Thu": "Tors",
  "Fri": "Fre",
  "Sat": "Lör",
  "Sun": "Sön",
  "Average": "Medelvärde",
  "sensorOlRe": "Sensoröverlagringsrapport",
  "Avg": "Medelvärde",
  "±SD": "±SD",
  "ofhypo": "# of Hypo",
  "Everyday": "varje dag",

  "TrendAna": "Trendanalys",
  "TrendRe": "Trendanalysrapport",
  "sensorGlu": "Sensorglukos ",
  "ofBGtest": "# BS-tester",
  "Basics": "Grundläggande",
  "static": "Statistik",
  "Med": "Med",
  "med": "medelvärde",
  "Q1": "Q1",
  "Q3": "Q3",
  "Q11": "Q1",
  "Q31": "Q3",
  "IQR": "IQR",
  "SD": "SD",
  "CV": "CV",
  "SE1": "SE",
  "distri": "Distribution",
  "stab": "Stabilitet",
  "#high": "# högt",
  "#low": "# lågt",
  "aucBelow": "AUC under",
  "aucAbove": "AUC över",
  "bgRead": "BS-avläsningar",
  "total": "Totalt",
  "ofBolus": "# bolus",
  "avgBolus": "Gen. bolus",
  "Dura1": "Varaktighet (min)",
  "Avg/Total": "Medelvärde/totalt",
  "high": "Högt",
  "low": "Lågt",
  "#hypo": "# hypo",
  "ofExer": "# träningstillfällen",

  "logbook": "Loggbok",
  "dailyTotal": "Totalt per dag",
  "High Glucose": "Högt blodsocker",
  "Low Glucose": "Lågt blodsocker",
  "No Active Patch": "Ingen aktiv patch",
  "Missed Meal": "Missad måltid",
  "Multiple BG Readings": "Flera BS-avläsningar",
  "Stop Patch": "Stoppa patch",
  "Others": "MODY",
  "Other Events": "Andra händelser",
  "logRe": "Loggboksrapport",

  "DeviceSetting": "Granska enhetsinställningar",
  "Insulin Pump": "Insulinpump",
  "MaxBasalRate": "Maximal basalhastighet",
  "BasalPatterns": "Basalmönster",
  "Selected Basal Pattern": "Valt basalmönster",
  "Maximum Bolus": "Maximal bolus",
  "Combo/Extended Bolus": "Dubbel/förlängd bolus",
  "BG Reminder": "BS-påminnelse",
  "Bolus Increment": "Bolusökning",
  "Bolus Calculator": "Boluskalkylator",
  "Active Insulin Time": "Aktiv insulintid",
  "IC Ratios": "IK-förhållande",
  "Insulin Sensitivity": "Insulinkänslighet",
  "BG Target": "BS-mål",
  "Bolus Reminder": "Boluspåminnelse",
  "CGM": "CGM",
  "CGM System": "CGM-system",
  "Glucose Unit": "Glukosenheter",
  "Glucose Limits": "Blodsockergränser",
  "Predicitive Alerts": "Förebyggande varningar",
  "Rate Alerts": "Hastighetsvarningar",
  "type": "Typ",
  "time": "Tid",
  "data": "Data",
  "Rate": "Rate",
  "Calibration Reminder": "Kalibreringspåminnelse",
  "Calibration Repeat": "Kalibreringsupprepning",
  "Snooze": "Snooze",
  "Audio Options": "Ljudalternativ",
  "Confidence Reminder": "Användningsfeedback",
  "Backlight": "Bakbelysning",
  "Sec": "sek",
  "Alarm Clock": "Väckarklocka",
  "Patch Expiration": "Utgång för patch",
  "Sensor Expiration": "Utgång för sensor",
  "Hourly Max": "Max per timme",
  "Daily Max": "Max per dag",
  "Low Reservoir": "Låg reservoar",
  "Low Suspend": "Stopp vid lågt värde",
  "Predictive Low Suspend": "Beräknat stopp vid lågt värde",
  "Rise": "Ökning",
  "Fall": "Minskning",
  "Auto Off": "Automatisk avstängning",
  "Standard": "Standard",
  "Exercise": "Träning",
  "Holiday": "Helgdag",
  "ProgramA": "Mönster A",
  "ProgramB": "Mönster B",
  "--": "--",
  "Insulin": "Insulin",

  "SUSA": "Automatisk avstängning",
  "SUSHM": "Överskrider max. leveransmängd under 1 timme",
  "SUSDM": "Överskrider max. TDD",
  "SUSLSG": "Stopp vid lågt värde",
  "SUSPLSG": "Beräknat stopp vid lågt värde",
  "Pump Restarted": "Pumpen har startat om",
  "Meter BG Now": "Mät blodsocker nu",
  "Sensor Exp in 2 Hours": "Sensor utgår om 2 timmar",
  "Sensor Exp in 6 Hours": "Sensor utgår om 2 timmar",
  "Sensor Exp in 30 Min": "Sensor utgår om 30 min",
  "Sensor Calibration Error": "Sensorkalibreringsfel",
  "Sensor Error": "Inga avläsningar",

  "Device Settings Report": "Enhetsinställningsrapport",
  "24h Total": "Dygnstotal",
  "Device Settings at": "Enhetsinställningar,",
  "Start": "Start",
  "Combo/Ext Bolus": "Dubbel/förlängd bolus",
  "Time Format": "Tidsformat",
  "Device Options（CGM System)": "Enhetsalternativ (CGM-system)",
  "Device Options（Insulin Pump)": "Enhetsalternativ (insulinpump)",
  "Dispay Settings (Screen)": "Visningsinställningar (skärm)",
  "Dispay Settings (Backlight)": "Visningsinställningar (bakbelysning)",
  "Graph Range": "Diagramintervall",
  "Range": "Range",
  "Repeat": "Upprepning",
  "Glucose Alerts": "Blodsockervarningar",
  "Alert Silence": "Varning tyst",

  "Create": "Skapa",
  "Event Filter": "Händelsefilter",
  "HbA1c1": "HbA1c",
  "Urine Ketone": "Urinketon",
  "Injection": "Injektion",
  "Other": "Övrigt",
  "Event Type": "Händelsetyp",
  "Details": "Information",
  "Notes": "Anteckningar",
  "Source": "Källa",
  "edit": "Redigera",
  "Action": "Åtgärd",
  "EventReport": "Händelsesammanfattningsrapport",
  "By Date": "Efter datum",
  "By Category": "Efter kategori",
  "Event Summary": "Händelsesammanfattning",
  "No data": "Inga data",
  "No1": "Inga",
  "data1": "data",
  "#": "#",
  "BG Summary": "Blodsockersammanfattning",
  "Carbs Summary": "Kolhydratsammanfattning",
  "Injection Summary": "Injektionssammanfattning",
  "Exercise Summary": "Träningssammanfattning",
  "Input Notes": "Ange en anteckning",

  "Profile": "Profil",
  "Complications": "Komplikationer",
  "Concomitant diseases": "Samtidiga sjukdomar",
  "Suggestion": "Förslag",
  "Coronary heart disease": "Kranskärlssjukdom",
  "High blood lipids": "Förhöjda blodfetter",
  "High blood pressure": "Högt blodtryck",
  "Kidney disease": "Njursjukdom",
  "Neuropathy": "Neuropati",
  "Obesity": "Fetma",
  "Peripheral arterial disease": "Perifer artärsjukdom",
  "Retinopathy": "Näthinnesjukdom",
  "Smoking addiction": "Rökare",
  "Enter date": "Ange datum",
  "Enter suggestion": "Ange förslag",
  "Enter Notes": "Lägg till anteckning",
  "Select": "Välj",
  "Prescription": "Ordination",
  "Medicine": "Läkemedel",
  "Dose": "Dos",
  "Enter medicine": "Ange läkemedel",
  "Enter dose": "Ange dos",
  "Enterdis": "Ange  samtidiga sjukdomar",
  "Add note": "Lägg till anteckning",
  "Add Content": "Den maximala längden är 1 000 tecken.",
  "Other suggestions": "Andra förslag",
  "OK": "OK",
  "HCP": "Vårdgivare",
  "Content": "Innehåll",
  "Records Report": "Postrapport",

  "Quick Print": "Snabbutskrift",
  "Quick Print Settings": "Inställningar för snabbutskrift",
  "Select duration": "Välj varaktighet",
  "One Week": "En vecka",
  "One Month": "En månad",
  "One Quarter": "Ett kvartal",
  "End date": "Slutdatum",
  "Yesterday": "I går",
  "Last Sunday": "Föregående söndag",
  "Last Saturday": "Föregående lördag",
  "Last Day of Last Month": "Last Day of Last Month",
  "Last Day of Last Quarter": "Last Day of Last Quarter",
  "Customized": "Anpassad",
  "Week Filter": "Veckofilter",
  "Select reports to print": "Välj rapporter som ska skrivas ut",
  "Daily Summary": "Daglig sammanfattning",
  "Day By Day Overview": "Översikt, dag för dag",
  "Sensor Overlay": "Sensoröverlagring",
  "Trend Analysis": "Trendanalys",
  "Logbook": "Loggbok",
  "Device Settings Review": "Granska enhetsinställningar",
  "createReport": "Skapa rapport",

  "Segment Analysis": "Segmentanalys",
  "Sensor Glucose Profile": "Sensorglukosprofil",
  "# of Boluses": "# bolus",
  "Bolus Insulin": "Bolusinsulin ",
  "Basal Pattern": "Basalmönster ",
  "Segment Analysis Report": "Segmentanalysrapport",
  "Avg Glucose": "Glukosmedelvärde",
  "Below": "Under",
  "In Target Range": "I målintervallet",
  "Coefficient of variation": "Variationskoefficient",
  "% Time CGM Active": "% tid då CGM var aktiv",
  "est_a1c_t1": "Estimated A1C:",
  "est_a1c_t2": "calculated from SG values",
  "est_a1c_t3": "Obs: Beräknat HbA1c ersätter inte provtagning på sjukhus HbA1c med det laboratoriskt prov.",

  "acceptTip": " har tillåtit att du fjärrvisar dennes hälsoinformation. ",
  "cancelTip": " tillåter inte längre att du fjärrvisar dennes hälsoinformation. Du kan ansöka igen vid behov.",
  "rejectTip": " har avböjt din ansökan om fjärrvisning.",
  "Read": "Läs",

  "Connection": "Anslutning",
  "connections1": "Anslutning",
  "Add Connection": "Lägg till anslutning",
  "SG": "SG",
  "Active Insulin": "Aktivt insulin",
  "Stop following": "Sluta följa",
  "Enter username (email)": "Ange användarnamn (e-postadress)",
  "Search results": "Sökresultat",
  "Send request": "Skicka begäran",
  "View graphs": "Visa diagram",
  "Agree": "Godkänn",
  "Deny": "Avböj",
  "Remove": "Ta bort",
  "Cancel Requset": "Avbryt begäran",
  "Remark": "Anteckning",

  "Warm up": "Uppvärmning",
  "Monitoring": "Övervakning",
  "Transmitter Error": "Sändarfel",
  "Sensor Failure": "Sensorfel",
  "Sensor Expired": "Sensor har utgått",
  "Lost Sensor": "Förlorad sensor",
  "Not Calibrated": "Ej kalibrerad",
  "Calibrating": "Kalibrerar",
  "Calibration Needed": "Kalibrering krävs",
  "Calibration Error": "Kalibreringsfel",
  "Charging Battery": "Laddar batteri",
  "Battery Charged": "Batteri laddat",

  "To be filled": "Ska fyllas",
  "Filled with insulin": "Fylld med insulin",
  "Priming": "Primar",
  "Priming completed": "Primning slutförd",
  "Inserting needle": "För in nål",
  "Patch activated": "Patch aktiverad",
  "Delivering Basal": "Levererar basal",
  "Exceeds Max 1 Hour Delivery": "Överskrider max. leveransmängd under 1 timme",
  "Exceeds Max TDD": "Överskrider max. TDD",
  "Suspend": "Stoppa",
  "Occlusion Detected": "Ocklusion upptäckt",
  "Patch Expired": "Patch har utgått",
  "Empty Reservoir": "Reservoar tom",
  "Patch Error": "Patchfel",
  "Pump Base Error": "Pumpbasfel",
  "Patch Battery Depleted": "Patch-batteri tomt",
  "Magnetic sensor not calibrated": "Magnetisk sensor ej kalibrerad",

  "Patient Profile": "Patientprofil",

  "On": "På",
  "on": "På",
  "Off": "Av",
  "off": "Av",

  "CORONARY_HEART_DISEASE": "Kranskärlssjukdom",
  "HIGH_BLOOD_LIPIDS": "Förhöjda blodfetter",
  "HIGH_BLOOD_PRESSURE": "Högt blodtryck",
  "KIDNEY_DISEASE": "Njursjukdom",
  "NEUROPATHY": "Neuropati",
  "OBESITY": "Fetma",
  "PERIPHERAL_ARTERIAL_DISEASE": "Perifer artärsjukdom",
  "RETINOPATHY": "Näthinnesjukdom",
  "SMOKING_ADDICTION": "Rökare",

  "saveTip": "Sparat.",
  "changePaTip": "Lösenordet har ändrats.",
  "enterEmTip": "Ange din e-postadress.",
  "verErrTip": "Felaktig verifieringskod.",
  "chooseEventTip": "Välj händelser som ska skrivas ut",
  "chooseDataTip": "Välj data att skriva ut",
  "dateWrongTip": "Slutdatumet kan inte vara senare än startdatumet.",
  "infoWrongTip": "Fyll i alla obligatoriska fält.",
  "createdSuccssTip": "Skapad",
  "selectData": "Välj data att spara",

  "acceSu": "Anslutningsbegäran accepterades",
  "acceEr": "Det gick inte att lägga till en ny anslutning",
  "rejeSu": "Anslutningsbegäran avvisades",
  "rejeEr": "Det gick inte att avvisa begäran",

  "userNotExist": "Användarnamnet finns inte.",
  "Password incorrect": "Felaktigt lösenord.",
  "UserType incorrect": "Felaktig användartyp",

  "registSuccess": "Ditt konto har skapats.",
  "registFailed": "Det gick inte att registrera ett nytt konto.",
  "sentSuccess": "Meddelandet har skickats",
  "sentFailed": "Det gick inte att skicka meddelandet",
  "Input error": "Inmatningsfel",

  "deletePtip": "Är du säker på att du vill ta bort de här patienterna?",
  "deleteEvents": "Är du säker på att du vill ta bort de här händelserna?",
  "deleteData": "Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",
  "deleteThis": "Är du säker på att du vill ta bort den här händelsen?",
  "confirm": "Bekräfta",
  "deleteSuccess": "Borttagen",
  "deleteFailed": "Det gick inte att ta bort objektet",
  "modifySuccess": "Ändringen har genomförts",
  "modifyFailed": "Det gick inte att ändra",
  "createSuccess": "Skapad",
  "createFailed": "Händelsen har skapats",
  "editSuccess": "Händelsen har redigerats.",
  "editFailed": "Det gick inte att redigera händelsen",
  "Time overlapped": "Sessionerna du har valt överlappar varandra.",

  "stopFollow": "Är du säker på att du vill sluta följa denna personen?",
  "CancelTip1": "Är du säker på att du vill ta bort den här anslutningen?",

  "Warning": "Varning",
  "agreeConnect": "Om du klickar på ”Acceptera” för att acceptera anslutningsbegäran blir dina hälsodata tillgängliga via den nya anslutningen.",
  "denyConnect": "Är du säker på att du vill avvisa anslutningsbegäran?",
  "deleteConnect": "Är du säker på att du vill ta bort anslutningen? Om du tar bort den här personen kan denne inte längre visa dina hälsodata.",

  "Choose the events to print": "Välj händelser som ska skrivas ut",
  "tryAgain": "Försök igen",
  "username and password is required": "username and password is required",
  "A name is required": "Du måste ange ett namn.",
  "username is required": "Du måste ange ett användarnamn.",
  "The date choose wrong": "Felaktigt datumval",
  "Date no more than 14 days": "Det går inte att välja mer än 14 dagar.",

  "CancelTip": "Är du säker på att du vill ta bort anslutningen?",
  "removeConnect": "Borttagen",

  "dateErr1": "Det går inte att välja mer än 90 dagar.",
  "dateErr2": "Slutdatumet kan inte vara senare än startdatumet.",

  "Not Filled": "Ej angivet",
  "Today": "I dag",
  "duration": "Varaktighet",
  "interval": "Interval",
  "7 days": "7 dagar",
  "14 days": "14 dagar",
  "30 days": "30 dagar",
  "90 days": "90 dagar",
  "g": "g",

  "Sound+Vibrate": "Ljud + vibration",
  "Sound": "Ljud",
  "Vibrate": "Vibration",
  "Silent": "Stör ej",
  "1": "En gång",
  "2": "Varje dag",
  "noMes": "Det finns inga meddelanden.",
  "noConnect": "Det finns inga anslutningar.",
  "Customize": "Anpassad",
  "GB": "United Kingdom",
  "CN": "China",
  "FR": "France",
  "DD": "Germany",
  "DE": "Germany",
  "SE": "Sweden",
  "AU": "Australia",
  "HKF": "Hongkong",
  "HU": "Hungary",
  "IT": "Italy",
  "NL": "Netherlands",
  "Nor": "Norway",
  "PT": "Portugal",
  "ES": "Spain",
  "TR": "Turkey",

  "Jan": "Jan",
  "Feb": "Feb",
  "Mar": "Mar",
  "Apr": "Apr",
  "May": "Maj",
  "Jun": "Jun",
  "Jul": "Jul",
  "Aug": "Aug",
  "Sep": "Sep",
  "Oct": "Okt",
  "Nov": "Nov",
  "Dec": "Dec",
  "ApplyTip": " förfrågan om att visa dina data.",
  "noReadings": "Inga avläsningar",

  "daop_A6_system": "A6 Touchcare System",
  "daop_easytouch_easyview": "EasyTouch / EasyView iPad",
  "daop_TY012_TY015": "TY012/TY015",
  "daop_easysense": "EasySense",
  "daop_delete_data": "Delete Data",
  "daop_uploaded_data": "Uppladdad Data",
  "daop_uploaded_data_text": "Datan är från EasyTouch App eller EasyView iPad App.",
  "daop_realtime_data": "Realtids Data",
  "daop_realtime_data_text": "The data is from EasySense App or EasyPatch App.",

  "ins_unit": "(E)",
  "ins_unit2": "E",
  "basal_unit": "(E/H)",
  "basal_unit2": "E/H",

  "Alerts_Patch_Battery_Low": "Patch-batteri lågt",
  "Alerts_Patch_Battery_Depleted": "Patch-batteri tomt",
  "Alerts_Lost_Pump": "Lost Pump",
  "Alerts_Low_Reservoir": "Låg reservoar",
  "Alerts_Empty_Reservoir": "Reservoar tom",
  "Alerts_Patch_Expiration_Advisory": "Meddelande om utgångstid för patch",
  "Alerts_Patch_Exp_In_1_Hour": "Patch Exp In 1 Hour",
  "Alerts_Patch_Expired": "Patch har utgått",
  "Alerts_Patch_Error": "Patchfel",
  "Alerts_Pump_Base_Error": "Pumpbasfel",
  "Alerts_Basal_Rate_Key_Error": "Basal Rate Key Error",
  "Alerts_Occlusion_Detected": "Ocklusion upptäckt",
  "Alerts_End_Of_Suspend": "End Of Suspend",
  "Alerts_Exceeds_Max_TDD": "Överskrider max. TDD",
  "Alerts_Exceeds_Max_1Hr_Delivery": "Överskrider max. leveransmängd under 1 tim",

  "Alerts_Predictive_Low_Suspend": "Beräknat stopp vid lågt värde",
  "Alerts_Low_Suspend": "Stopp vid lågt värde",
  "Alerts_Auto_Off": "Automatisk avstängning",

  "Alerts_Pump_Restart": "Pump Restart",
  "Alerts_Auto_Off_Warning": "Auto Off Warning",
  "Alerts_Pump_Out_Of_Range": "Pump Out Of Range",

  "Alerts_Lost_Sensor": "Förlorad sensor",
  "Alerts_Transmitter_Battery_Low": "Sändarbatteri lågt",
  "Alerts_Charge_Transmitter": "Ladda sändare",
  "Alerts_Sensor_Error": "Inga avläsningar",
  "Alerts_Transmitter_Error": "Sändarfel",
  "Alerts_Sensor_Calibration_Error": "Sensor Calibration Error",

  "Alerts_Sensor_Failure": "Sensorfel",
  "Alerts_Sensor_Calibration_Reminder": "Sensor Calibration Reminder",
  "Alerts_Meter_BG_Now": "Mät blodsocker nu",
  "Alerts_Sensor_Exp_in_6_Hours": "Sensor utgår om 6 timmar",
  "Alerts_Sensor_Exp_in_2_Hours": "Sensor utgår om 2 timmar",
  "Alerts_Sensor_Exp_in_30_Min": "Sensor utgår om 30 min",
  "Alerts_Sensor_Expired": "Sensor har utgått",
  "Alerts_Rapid_Rise": "Snabb ökning",
  "Alerts_Rapid_Fall": "Snabb minskning",
  "Alerts_High_Predicted": "Högt beräknat",
  "Alerts_Low_Predicted": "Lågt beräknat",
  "Alerts_High_Glucose": "Högt blodsocker",
  "Alerts_Low_Glucose": "Lågt blodsocker",
  "Alerts_Below_3.1_mmol/L": "Under 3,1 mmol/l",
  "Alerts_Transmitter_Battery_Low_2": "Sändarbatteri lågt",

  "Alerts_PDM_Battery_Low": "PDM-batteri lågt",
  "Alerts_Replace_Battery": "Ladda din PDM",

  "Alert": "Alert",
  "Alerts": "Varningar",
  "Alert Filter": "Alert Filter",
  "PDM": "PDM",
  "Pump": "Pump",

  "Out Of Range": "Out Of Range",
  "t1221_Time_in_Auto_Mode": "Tid i autoläge",
  "t1221_Average_SG_SD": "Genomsnittlig SG ± SD",
  "t1221_Time_in_Target_Range": "Tid i målintervall(%s)",
  "t1221_Time_above_Range": "Tid över mål",
  "t1221_Time_below_Range": "Tid under mål",
  "t1221_Auto_Basal_per_day": "Auto Basal (per dag)",
  "t1221_Auto_Bolus_per_day": "Auto Bolus (per dag)",
  "t1221_Auto_Mode_Exits": "Avslutade Autoläge",
  "t1221_No_Sensor_readings": "Inga sensor avläsningar",
  "t1221_Max_Delivery": "Max leverans",
  "t1221_Min_Delivery": "Min leverans",
  "t1222_autoModeBasal": "Autoläge Basal",
  "t1222_autoModeCorrBolus": "Autoläge korrigering bolus",
  "t1222_autoSnack": "Auto mellanmål",
  "t1222_autoBreakfast": "Auto frukost",
  "t1222_autoLunch": "Auto lunch",
  "t1222_autoDinner": "Auto middag",
  "t1222_autoExercise": "Auto träning",
  "t1222_Snack": "Mellanmål",
  "t1222_Auto_Mode": "Autoläge",
  "t1222_Time_in_Auto_Mode": "Tid i autoläge(%)",
  "t1222_Avg_SD": "Snitt(mmol/L)±SD",
  "t1222_Target_Range": "Målområde(%)",
  "t1222_Above_Range": "Över målområdet(%)",
  "t1222_Below_Range": "Under målområdet(%)",
  "t1222_Auto_Mode_Exits": "# Autoläge avslutas",
  "t1221_Auto_Mode": "Autoläge",
  "t1222_auto_basal": "Auto Basal",
  "t1222_auto_bolus": "Auto Bolus",
  "t0805_User_Management": "Användarhantering",
  "t0805_Patient_Management": "Patienthantering",
  "t0805_Operation_History": "Operationshistoria",
  "t0805_User_List": "Användarlista",
  "t0805_User": "Användare",
  "t0805_Time": "Tid",
  "t0805_Operation_Type": "Typ av operation",
  "t0805_Back": "Tillbaka",
  "t0805_Add": "Lägg till",
  "t0805_Delete": "Ta bort",
  "t0809_Add_User": "Lägg till användare",
  "t1028_Pattern_C": "Mönster C",
  "t1028_Pattern_D": "Mönster D",
  "t1029_Auto_meal_bolus": "Auto måltidshantering",
  "t1029_Auto_mode_correction_bolus": "Autoläge korrigerings bolus",
  "t1029_Sick": "Sjuk",
  "t1029_Auto_Mode_Feature": "Funktion för autoläge",
  "t1029_Target_SG": "Sensorglukos mål",
  "t1029_Auto_Meal_Handling": "Auto Måltidshantering",
  "t1029_Total_Daily_Dose": "Total daglig dos",
  "t1029_Pump_Light": "Pump Ljus",
  "t1029_Alerts_for_Hypo": "Varningar för Hypo",
  "t1102_Out_of_Range": "Utom räckhåll",
  "t1102_Command_Reminder": "Kommando påminnelse",
  "t1102_Alarms_Alerts_on_APP": "Larm och varningar på Patchpump",
  "t1102_Alarms_on_App": "Larm i App",
  "t1102_Alerts_on_App": "Varningar i App",
  "t1102_Factory_Calibration": "Fabrikskalibrering",
  "t1102_Alerts_for_Low": "Varning för Lågt",
  "t1102_Alerts_for_High": "Varning för Högt",
  "t1102_Alerts_for_Others": "Varning för Övrigt",
  "t1102_Adjustment": "Justering",
  "t1102_Suggested": "Föreslagen",
  "t1103_Glucose": "Blodsocker",
  "t1103_CGM": "CGM",
  "t1103_Insulin": "Insulin",
  "t1103_Carbs": "Kolhydrater",
  "t1103_Exercise": "Träning",
  "t1103_Min_Max": "Min/Max",
  "t1103_Target_Range": "Målområde",
  "t1103_Overall_Tine_In_Range": "Övergripande: Time In Range",
  "t1103_Basal": "Basal",
  "t1103_Bolus": "Bolus",
  "t1103_Basal_Bolus": "Basal & Bolus",
  "t1103_Auto_Mode_Time_In_Range": "Autoläge: Time In Range",
  "t1103_Time_below_range": "Tid under målområde",
  "t1103_Time_above_range": "Tid över målområde",
  "t1103_Time_in_target_range": "Tid i målområde",
  "t1103_Incorrect_Password": "Felaktigt lösenord, $1 Försök kvar, vänligen ange rätt lösenord.",
  "t1103_Incorrect_locked": "Misslyckade försök överskrider gränsen, kontot har låsts. Försök igen om $1 minuter.",
  "t1104_The_data_is_from": "Datan är från EasySense App eller EasyPatch App.",
  "t1104_Privacy_Policy": "Integritetspolicy och användarvillkor",
  "t1104_updated_privacy_policy": "Vi har uppdaterat Integritetspolicy och användarvillkor för tjänsten. Vänligen läs dem noga, EasyPatch kan endast användas efter att alla villkor är överenskomna och accepterade.",
  "t1104_Disagree": "Accepterar inte",
  "t1104_Agree": "Godkänn",
  "t1105_Upload_History": "Uppladdningshistorik",
  "t1105_Delete_Data": "Ta bort data",
  "t1105_Target_Range": "Målområde",
  "t1105_request_to_view_your_data": "$1 begäran om att se dina data.",
  "t1105_Recent_Updates": "Senaste uppdateringar",
  "t1108_No_data": "Inga data",
  "t1108_Pump_Bash_SN": "Pumpbasens serienr",
  "t1108_Transmitter_SN": "Sändarens serienr",
  "t1112_Normal_Glucose": "Normal Glukos",
  "t1112_Manual_Bolus_or_Modified_Bolus": "Manuell bolus eller modifierad bolus",
  "t1112_Auto_Mode_Started": "Autoläge startat",
  "t1112_Auto_Mode_Exit": "Avsluta Autoläge",
  "t1112_Normal_Bolus": "Normal Bolus",
  "t1112_Extended_Bolus": "Förlängd Bolus",
  "t1112_Combo_Bolus": "Kombibolus",
  "t1112_Carbs": "Kolhydrater",
  "t1112_Glucose": "Glukos",
  "t1112_BG": "BG",
  "t1112_Audio": "Ljud",
  "t1112_Tone": "Ljud",
  "t1112_Audio_Options": "Ljudalternativ",
  "t1112_Weight_Unit": "Viktenhet",
  "t1112_Height_Unit": "Höjdenhet",
  "t1112_Not_available": "Inte Tillgänglig",
  "t1112_Number": "Siffra",
  "t1112_days": "# dagar",
  "t1112_min": "min",
  "t1113_days": "dagar",
  "t1215_Security": "Säkerhet",
  "t1215_MFA": "Multifaktorautentisering (MFA)",
  "t1215_Enter_verification_code": "Ange verifieringskod",
  "t1215_Multi_factor_ON": "Multifaktorautentisering är PÅ. Verifieringskoden har skickats till $1 Vänligen skicka in verifieringskoden.",
  "t1215_Verification_code_incorrect": "Felaktig verifieringskod",
  "t1215_Show_Glucose_Value": "Visa glukosvärde",
  "t1221_enter_verification_code": "Ange den sexsiffriga verifieringskoden som skickats till $1.",
  "t1221_Verification_Success": "Verifierad framgångsrikt",
  "t1222_We_will_only_process": "Vi kommer endast att spara din data på Medtrum App/webbplats med ditt medgivande. ",
  "t1222_If_you_are_under_years": "Om du är under 16 år kommer du att behöva medgivande från din förälder eller förmyndare för att registrera dig i denna app.",
  "t1221_register_cn": "Du är inte tvungen att ladda upp data från PDM till App.I detta fall kommer inte uppgifterna att vara tillgängliga för andra. Om du väljer att inte registrera dig på Medtrum app/hemsida så är datan enbart sparad på själva enheten. ",
  "t1221_register_eu": "Om du väljer att registrera dig med ett Medtrum-konto och få tillgång till vår app via kontot, kommer hälsouppgifter som registrerats på appen att laddas upp till vår server i Europa och sparas i 2 år. Du kan välja att inte ladda upp dina data. Du kommer då inte att kunna dela informationen med andra genom följarapp eller via system eller applikationer som sjukvården använder sig av. Om du väljer att inte registrera dig på Medtrum app/hemsida, är datan endast sparad på själva enheten.",
  "t1221_register_follow": "Vi kommer endast att behandla din  data via Medtrum App/webbplats med ditt medgivande.",
  "t1222_Terms_of_Use": "användarvillkoren för Medtrum",
  "t1222_Privacy_Policy": "Medtrums integritetspolicy",
  "t1222_Create_Account": "Skapa konto",
  "t1222_Back": "Tillbaka",
  "t1222_Verify_your_account": "Verifiera ditt konto",
  "t1222_please_check_your_account": "Vi skickar en verifieringskod till $1, kontrollera ditt konto.",
  "t1222_I_Agree_to": "Jag godkänner $1",
  "t1223_Invalid_Verification_Code": "Ogiltig verifieringskod. Var god försök igen."
};

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return trMessages; });
var trMessages = {
  "privacy_policy_and_terms_of_use": "Privacy Policy and Terms of Use ",
  "privacy_confirm_text": "We've updated our <a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>Privacy Policy</a> and <a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>Terms of Use</a>. To continue using EasyView, you need to read and agree to all the terms.",
  "privacy_confirm_disagree": "Disagree",
  "privacy_confirm_accept": "Accept",

  "title": "EasyView Personal",
  "title1": "EasyView Pro",
  "user": "E-posta",
  "password": "Parola",
  "remember": "Beni Hatırla",
  "forget": "Parolanızı mı unuttunuz?",
  "sign in": "Oturum aç",
  "login": "Login",
  "sign up now": "Şimdi kayıt ol",
  "apply": "Bir hesap için başvur",
  "contact us": "Bizimle iletişime geçin",
  "Privacy Policy": "Gizlilik Politikası",
  "Terms of Use": "Kullanım Şartları",
  "copyright": "Telif Hakkı © 2021 Medtrum Technologies Inc. Tüm hakları saklıdır.",

  "chooseLang": "Ülkenizi veya dilinizi seçin",
  "asia": "Asia Pacific",
  "europe": "Avrupa",
  "middleEast": "Middle East",

  "applyHcp": "HCP hesabı için başvurun",
  "sign up": "Kayıt ol",
  "Patient": "Hasta",
  "Caregiver": "Bakıcı",
  "Email": "E-posta",
  "Mobile": "Mobil",
  "Enter email": "E-mail adresini girin",
  "Enter mobile": "Cep telefonu numarasını girin",
  "Verification": "Doğrulama kodu",
  "Invitation": "Invitation code",
  "full name": "Tam Adınızı ve soyadınızı girin",
  "Enter pass": "Enter password",
  "org": "Organizasyon",
  "Register": "Register",
  "send": "Gönder",
  "createAccount": "Create Account",
  "agree": "I have read and agree to the ",
  "privacy": " Medtrum privacy policy  ",
  "and": "ve",
  "use": "terms of service.",
  "errtip1-1": "You must enter a valid email address,which",
  "errtip1-2": "will become your Medtrum username.",
  "errtip2": "Please enter a valid mobile number.",
  "errtip3": "Doğrulama kodu yanlış",
  "errtip4": "Incorrect invitation code.",
  "errtip5": "Kullanıcı adı yanlış",
  "errtip6": "Your password must have 8 or more characters.",
  "errtip7": "Please enter your organization.",

  "errp1": "Password must contain at least 3 types of the following characters:",
  "errp2": "capital letter,lowercase letter, number and special character.",
  "errp3": "Parola uzunluğu 6 ile 20 karakter arasında olmalıdır.",
  "errp4": "Parola kullanıcı adından farklı olmalıdır.",
  "errp5": "Ardışık 3 rakamı içermekte olan parola geçersizdir (örneğin, 123, 321).",
  "errp6": "Ardışık 3 sayıyı harfi içermekte olan Parola geçersizdir (örneğin, abc, cba).",
  "errp7": "Parola boşluk içeremez.",

  "Find account": "Parolanızı alın.",
  "Enter username": "Lütfen kullanıcı adınızı giriniz.",
  "Next": "Sonraki",
  "Cancel": "İptal",
  "Back": "Geri",
  "Enter veri": "Enter verification code",
  "Verify notice": "Lütfen bir e-posta ile gönderilen doğrulama kodunu bulun.",
  "Create new": "Yeni bir parola oluştur",
  "Create new notice": "Lütfen yeni bir parola oluşturun ve parolanız 6 veya daha fazla karakter içermelidir.",
  "New pass": "Yeni Parola",
  "Completed": "Tamamlandı",
  "Created": "Yeni parola oluşturuldu.",
  "Login Now": "Şimdi giriş yapın",

  "Delete": "Sil",
  "New Patient": "Yeni Hasta",
  "Add Patient": "Hasta Ekle",
  "Filter": "Filtre",
  "Name": "isim",
  "Gender": "Cinsiyeti",
  "Age": "Yaş",
  "Type": "Türü",
  "Duration": "Süre",
  "Connections": "Hesap oluşturucu",
  "UploadTime": "Yükleme süresi",
  "Year": "year",
  "Years": "years",
  "Month": "month",
  "Month2": "Ay",
  "Months": "months",
  "Invite": "Davet",
  "Invited": "Davetli",
  "All": "Hepsi",
  "Female": "Kadın",
  "Male": "Erkek",
  "Not Set": "Not Set",
  "Type 1": "Tip 1",
  "Type 2": "Tip 2",
  "Gestational": "Gebe",
  "Prediabetes": "Prediyabet ",
  "LADA": "Tip 1,5 LADA",
  "Apply": "Uygula",
  "disUn": "Diabetes type unspeficied",
  "ageUn": "Yaş belirtilmemiş",
  "genUn": "Cinsiyet belirtilmemiş",
  "addP": "Hasta ekle",
  "newP": "Yeni Hasta",
  "findP": "Hasta Bul",

  "GDRNF": "Belirtilmemiş",
  "GDRF": "Kadın",
  "GDRM": "Erkek",
  "女": "Erkek",

  "DBTNF": "Belirtilmemiş ",
  "DBT1": "Tip 1",
  "DBT2": "Tip 2",
  "DBTLADA": "Tip 1,5 LADA",
  "DBTPRE": "Prediyabet",
  "DBTGEST": "Gebe",
  "前期": "beFore",
  "beFore": "beFore",
  "MODY": "Mody",

  "No selection": "No selection",
  "unspecif": "unspecified",
  "register": "Hasta",
  "hcp": "Klinik tedavi uzmanı",

  "BG": "BG",
  "CARB": "Karbonhidrat",
  "INS": "Enjeksiyon",
  "EXR": "Egzersiz",
  "OTR": "Diğer",
  "HBA1C": "HbA1c",
  "DOSE": "DOSE",
  "URINEK": "İdrar Ketonu",
  "HEL": "HEL",
  "OTR1": "Diğer",
  "Loading": "Yükleniyor",

  "home": "Ana Sayfa",
  "pID": "Hasta Kimliği",
  "fullName": "Tam Adı ve soyadı",
  "gender": "Cinsiyeti",
  "height": "Yükseklik",
  "weight": "Kilosu",
  "cm": "cm",
  "kg": "kg",
  "birthday": "Doğum tarihi",
  "disType": "Tip 2 diyabet",
  "disDate": "Tanı tarihi",
  "Address": "Adres",
  "Postcode": "Posta kodu",
  "Inpatient": "Ayakta tedavi",
  "Yes": "Evet",
  "No": "Hayır",
  "Pno": "Hasta No",
  "Bno": "Yatak no.",
  "create": "Oluştur",
  "Telephone": "Telefon",

  "enterU": "Kullanıcı adını girin (e-posta)",
  "search": "Arama",
  "noU": "Kullanıcı adı gerekli.",
  "searchR": "Arama sonuçları",
  "uername": "Kullanıcı adı",
  "alias": "Takma Ad",
  "remove": "Kaldır",
  "viewG": "Grafikleri görüntüle",
  "sendR": "İstek gönder",
  "rSent": "İsteğiniz gönderildi.",
  "cancelR": "Cancel request",

  "VcodeTip1": "Didn’t receive it? Please wait for a few minutes and",
  "VcodeTip2": "try again.",
  "VcodeTip3": "We just sent a code to ",
  "Entercode": "Enter code",
  "Getcode": "Get code",

  "messages": "Mesajlar",
  "profile": "Profil",
  "sign out": "Oturumu Kapat",
  "changeP": "Parolayı Değiştir",
  "connection": "Bağlantı",

  "myP": "Profilim",
  "Portrait": "Profil resmi",
  "Profession": "Meslek",
  "DPRONF": "Belirtilmemiş",
  "DPROENDOCRIN": "Endokrinolog",
  "DPRODIABTRA": "Diyabet Eğitimcisi",
  "DPRONURSE": "Hemşire",
  "DPRODIATIT": "Diyetisyen",
  "DPROOTR": "Diğer Sağlık Çalışanları",
  "Organization": "Organizasyon",
  "Bio": "Bio",
  "save": "Kaydet",
  "oldPa": "Eski Parola ",
  "newPa": "Yeni Parola",
  "RePa": "Parolayı tekrar Girin",
  "forgetY": "Parolanızı mı unuttunuz?",
  "applyM": "Uygula",
  "oldErr": "The old password is incorrect.",
  "EntTheSame": "Enter the new password again.",
  "EnterOld": "Enter the old Password!",

  "pList": "Hasta Listesi",
  "connections": "Bağlantı",
  "settings": "Ayarlar",
  "monitor": "İzle",
  "graphs": "Raporlar",
  "events": "Olaylar",
  "records": "Kayıtlar",
  "qPrint": "Hızlı Yazdır",

  "sensorIn": "Sensör Bilgisi",
  "timeOfLaRead": "Son sensör okuma zamanı",
  "tranSn": "Verici SN",
  "status": "Durum",
  "sensorLife": "Kalan sensör ömrü",
  "lastSenorRead": "Son sensör okuması",
  "TranBattery": "Verici pili",
  "sg": "SG",
  "alert": "Dikkat!",
  "target": "Hedef",
  "hypo": "Hipo",
  "sensorGlucose": "Sensör Glikozu",
  "calib": "Kalibrasyon",
  "newSen": "Yeni sensör",
  "warm": "Isınma",
  "InsulinPump": "İnsülin pompası",
  "timeOfLaPump": "Son pompa verisinin zamanı",
  "pumpSN": "Pompa tabanı SN",
  "ReserviorLife": "Kalan depo rezervuar ömrü",
  "InsulinLeft": "İnsülin kaldı",
  "basal": "Bazal",
  "bolus": "Bolus",
  "totalBasal": "Toplam günlük bazal",
  "lastBolus": "Son bolus",
  "activeInsulin": "Aktif insülin",
  "totalBolus": "Toplam günlük bolus",
  "tampBasal": "Sıcaklık Bazal",
  "normalBolus": "Normal Bolus",
  "extendBolus": "Genişletilmiş Bolus",
  "manualStop": "Manuel Askıya Alma",
  "autoStop": "Otomatik Askıya Alma",
  "auto suspend": "Otomatik Askıya Alma",
  "stop": "Teslimat Durdurma",
  "newPatch": "Yeni yama",
  "tempBasal": "Sıcaklık Bazal",
  "N": "N",
  "E": "E",
  "CN1": "CN",
  "CE": "CE",

  "staticSettings": "Raporlama Ayarları",
  "dataSource": "Görüntülenecek veriler",
  "unit": "Birim",
  "glucoseTarget": "Glikoz Hedef Aralığı",
  "overall": "Tam",
  "Hypoglycemia": "Hipoglisemi ",
  "timePeriod": "Zaman dilimi",
  "postMeal": "Yemek Sonrası Analiz",
  "Breakfast": "Kahvaltı",
  "Lunch": "Öğle yemeği",
  "Dinner": "Akşam yemeği",
  "night": "Gece-vakti",
  "Before": "Önce",
  "After": "Sonra",
  "Low": "Düşük",
  "High": "Yüksek",
  "From": "‘den",
  "To": "Kime",
  "Hours": "hours",
  "Reset": "Varsayılanları geri yükle",
  "RealTime": "Gerçek zamanlı",
  "uploaded": "Yüklenen",
  "sensor": "Sensör",
  "pdmSN": "PDM SN",
  "startTime": "Başlangıç Zamanı",
  "endTime": "Bitiş süresi",
  "uploadTime": "Time of upload",
  "pdm": "PDM",
  "Uploaded": "Yüklenen",
  "Patch Pump": "Patch Pompa",
  "overLapp": "Sessions overlapped",
  "showAlert": "Uyarıları göster",

  "dashboard": "Gösterge  tablosu",
  "dboard_glucose_statistics": "Glucose Statistics",
  "dboard_glucose": "BG",
  "dboard_cgm": "CGM",
  "dboard_insulin": "Insülin",
  "dboard_carbs": "Karbonhidrat",
  "dboard_exercise": "Egzersiz",
  "dboard_glucose_avg": "Ortalama",
  "dboard_cgm_avg": "Ortalama",
  "dboard_insulin_avg": "Ortalama Günlük Doz",
  "dboard_carbs_avg": "Ortalama Karbonhidrat / Gün",
  "dboard_exercise_avg": "Ortalama Zaman / Gün",
  "dboard_sd": "SD",
  "dboard_num": "#",
  "dboard_num_days": "# days",
  "dboard_statistics": "İstatistik",
  "dboard_BG": "BG",
  "dboard_BG_calibration": "BG / calibration (per day)",
  "dboard_SG": "SG",
  "dboard_AUC_high": "AUC high >",
  "dboard_AUC_low": "AUC low <",
  "dboard_highest_value": "En yüksek değer",
  "dboard_lowest_value": "En düşük değer",

  "dboard_pump": "Pompa",
  "dboard_avg_daily_dose": "Ortalama Günlük Doz",
  "dboard_SD": "SD",
  "dboard_daily_basal": "Günlük Bazal",
  "dboard_daily_bolus": "Günlük Bolus",
  "dboard_avg_bolus_num": "Ortalama bolus no. günlük",
  "dboard_avg_suspend_time": "Ortalama Askıya alma süresi",
  "dboard_avg_reservoir_usage": "Ortalama Rezervuar kullanımı",
  "dboard_days": "days",

  "dboard_manual_bolus": "Manuel bolus (Gün başına hacim / sayı)",
  "dboard_normal": "-Normal",
  "dboard_extend": "-Genişletilmiş",
  "dboard_combo": "-Combo",

  "dboard_bolus_calculator": "Bolus (Gün başına hacim / sayı)",
  "dboard_food_bolus": "-Yiyecek bolus hesaplama",
  "dboard_corr_bolus": "-Corr bolus hesaplama",
  "dboard_override_add": "-Geçersiz kıl (+)",
  "dboard_override_sub": "-Geçersiz kıl (-)",

  "dboard_report": "Kontrol Paneli Raporu",

  "daily": "Günlük özet",
  "date": "Tarih      ",
  "print": "Baskı",
  "carbs": "Karbonhidrat",
  "exercise": "Egzersiz",
  "heavy": "Ağır",
  "Medium": "Orta",
  "Light": "Hafif",
  "dailyReport": "Günlük Özel Rapor",
  "devices": "Cihazlar",
  "tran": "Verici ",
  "pumpBase": "Pompa tabanı ",
  "HbA1c": "HbA1c",
  "statics": "İstatistik",
  "glucose": "Glikoz",
  "item": "Madde",
  "BG1": "BG",
  "SG1": "SG",
  "avgSD": "Ortalama (mmol/L)±SD",
  "avgSD1": "Ort ± SD",
  "min": "Minimum",
  "max": "Maksimum",
  "ofRead": "Okuma sayısı",
  "ofHypo": "# of hypo/duration(min)",
  "ofAlert": "Uyarı sayısı",
  "insulin": "Insülin",
  "insulin2": "Insülin",
  "totalDose": "Total daily dose",
  "foodBolus": "Food Bolus",
  "Food+coor": "Food+corr",
  "calibBolus": "Correction Bolus",
  "durationStop": "Duration of suspension(min)",
  "ofPumpAlert": "pompa uyarı sayısı",
  "ofMeal": "Öğün sayısı",
  "totalExerTime": "Toplam Egzersiz Zamanı",
  "exerNum": "Egzersiz sayısı",
  "avgInten": "Ort. Yoğunluk",
  "target1": "Hedef",
  "high1": "Yüksek",
  "low1": "Düşük",
  "BG Reading": "BG Reading",

  "dayByday": "Günden Güne Genel Bakış",
  "dayBydayRe": "Day by Day Overview Report",
  "period": "Dönem",

  "sensorOverlay": "Sensör Yerleşimi",
  "set": "Ayar",
  "setPeriod": "Süreyi ayarla",
  "Weekdays": "Hafta içi",
  "Weekends": "Hafta sonu",
  "Mon": "Pazartesi",
  "Tue": "Salı",
  "Wed": "Çarşamba",
  "Thur": "Perşembe ",
  "Thu": "Perşembe",
  "Fri": "Cuma",
  "Sat": "Cumartesi",
  "Sun": "Pazar",
  "Average": "Ortalama",
  "sensorOlRe": "Sensör Yerleşimi Raporu",
  "Avg": "Ortalama",
  "±SD": "±SD",
  "ofhypo": "Hipo sayısı",
  "Everyday": "Her gün",

  "TrendAna": "Trend Analizi",
  "TrendRe": "Trend Analizi Raporu",
  "sensorGlu": "Sensör Glikozu",
  "ofBGtest": "BG test sayısı",
  "Basics": "Temel",
  "static": "İstatistik",
  "Med": "Orta",
  "med": "median",
  "Q1": "Q1",
  "Q3": "Q3",
  "Q11": "Q1",
  "Q31": "Q3",
  "IQR": "IQR",
  "SD": "SD",
  "CV": "CV",
  "SE1": "SE  ortalama",
  "distri": "Distribution",
  "stab": "Stabilite",
  "#high": "# yüksek",
  "#low": "# Düşük",
  "aucBelow": "AUC Below limit",
  "aucAbove": "AUC Above limit",
  "bgRead": "BG okumaları",
  "total": "Avg Daily Total",
  "avg_daily_basal": "Avg Daily Basal",
  "avg_daily_bolus": "Avg Daily Bolus",
  "ofBolus": "Avg # of bolus/Day",
  "avgBolus": "Avg bolus(U)/Each",
  "Dura1": "Süre (dakika)",
  "Avg/Total": "Ortalama/Toplam",
  "high": "Yüksek",
  "low": "Düşük",
  "#hypo": "Hipo sayısı",
  "ofExer": "Egzersizlerin sayısı",

  "logbook": "Log book",
  "dailyTotal": "Günlük Toplam",
  "High Glucose": "Yüksek Glikoz",
  "Low Glucose": "Düşük Glikoz",
  "No Active Patch": "Aktif  Yama Yok",
  "Missed Meal": "Kaçırılan Yemek",
  "Multiple BG Readings": "Çoklu BG Okumaları",
  "Stop Patch": "Yamayı Durdur",
  "Others": "Diğerleri",
  "Other Events": "Diğer olaylar",
  "logRe": "Günlük Kayıt Defteri Raporu",

  "DeviceSetting": "Cihaz Ayarları İncelemesi",
  "Insulin Pump": "İnsülin pompası",
  "MaxBasalRate": "Azami Bazal oranı",
  "BasalPatterns": "Bazal Örüntüleri",
  "Selected Basal Pattern": "Seçilmiş Bazal Örüntüi",
  "Maximum Bolus": "Maksimum Bolus",
  "Combo/Extended Bolus": "Birleşik / Genişletilmiş Bolus",
  "BG Reminder": "BG Hatırlatma",
  "Bolus Increment": "Bolus Artışı",
  "Bolus Calculator": "Bolus Hesaplama",
  "Active Insulin Time": "Aktif İnsülin Süresi",
  "IC Ratios": "IC Ratios",
  "Insulin Sensitivity": "İnsülin Hassasiyeti",
  "BG Target": "BG Hedef",
  "Bolus Reminder": "Bolus Hatırlatıcı",
  "CGM": "CGM",
  "CGM System": "CGM sistemi",
  "Glucose Unit": "Glikoz Ünitesi",
  "Glucose Limits": "Glikoz Sınırları",
  "Predicitive Alerts": "Tahmini Uyarılar",
  "Rate Alerts": "Oran Uyarıları",
  "type": "Türü",
  "time": "Zaman",
  "data": "Veri",
  "Rate": "Rate",
  "Calibration Reminder": "Kalibrasyon Hatırlatıcı",
  "Calibration Repeat": "Kalibrasyon Tekrarı",
  "Snooze": "Erteleme",
  "Audio Options": "Ses Seçenekleri",
  "Confidence Reminder": "Güven Hatırlatıcı",
  "Backlight": "Arka Işık",
  "Sec": "saniye",
  "Alarm Clock": "Alarm saati",
  "Patch Expiration": "Patch/Reservuar Bitişi",
  "Sensor Expiration": "Sensör Son Kullanma Tarihi",
  "Hourly Max": "Saatlik Maksimum",
  "Daily Max": "Günlük Maksimum",
  "Low Reservoir": "Düşük Rezervuar",
  "Low Suspend": "Düşük Askıya Alma",
  "Predictive Low Suspend": "Tahmini Düşük Askıya Alma",
  "Rise": "Yüksellme",
  "Fall": "Düşme",
  "Auto Off": "Otomatik Kapatma",
  "Standard": "Standart",
  "Exercise": "Egzersiz",
  "Holiday": "Tatil",
  "ProgramA": "Örüntü A",
  "ProgramB": "Örüntü",
  "--": "--",
  "Insulin": "Insülin",

  "SUSA": "Otomatik Kapatma",
  "SUSHM": "Maksimum 1 Saatlik Teslimatı aşıyor",
  "SUSDM": "Maksimum TDD'yi aşıyor",
  "SUSLSG": "Düşük Askıya Alma",
  "SUSPLSG": "Tahmini Düşük Askıya Alma",
  "Pump Restarted": "Pompa Yeniden Başlatıldı",
  "Meter BG Now": "Metre BG Şimdi",
  "Sensor Exp in 2 Hours": "Sensör 2 Saat İçinde Sona Erecek",
  "Sensor Exp in 6 Hours": "Sensör 6 Saat İçinde Sona Erecek",
  "Sensor Exp in 30 Min": "Sensör 30 Dakika İçinde Sona Erecek",
  "Sensor Calibration Error": "Sensor Calibration Error",
  "Sensor Error": "Okuma Yok",

  "Device Settings Report": "Cihaz Ayarları Raporu",
  "24h Total": "24saat=Toplam",
  "Device Settings at": "Device Settings at",
  "Start": "Başlat",
  "Combo/Ext Bolus": "Birleşik / Genişletilmiş Bolus",
  "Time Format": "Zaman formatı",
  "Device Options（CGM System)": "Device Options (CGM System)",
  "Device Options（Insulin Pump)": "Device Options (Insulin Pump)",
  "Dispay Settings (Screen)": "Ekran Ayarları (Ekran)",
  "Dispay Settings (Backlight)": "Ekran Ayarları (Arka Işık)",
  "Graph Range": "Grafik Aralığı",
  "Range": "Range",
  "Repeat": "Tekrar",
  "Glucose Alerts": "Glikoz Uyarısı",
  "Alert Silence": "Uyarı Sessizliği",

  "Create": "Oluştur",
  "Event Filter": "Olay Filtresi",
  "HbA1c1": "HbA1c",
  "Urine Ketone": "Ketone",
  "Injection": "Enjeksiyon",
  "Other": "Diğer",
  "Event Type": "Etkinlik Türü",
  "Details": "Detaylar",
  "Notes": "Notlar",
  "Source": "Kaynak",
  "edit": "Düzenle",
  "Action": "Aksiyon",
  "EventReport": "Etkinlik Özeti Raporu",
  "By Date": "Tarihe göre",
  "By Category": "Kategoriye göre",
  "Event Summary": "Etkinlik Özeti ",
  "No data": "Veri yok",
  "No1": "Hayır",
  "data1": "data",
  "#": "#",
  "BG Summary": "BG Özeti",
  "Carbs Summary": "Karbonhidrat Özeti",
  "Injection Summary": "Enjeksiyon özeti",
  "Exercise Summary": "Egzersiz Özeti",
  "Input Notes": "Not gir",

  "Profile": "Profil",
  "Complications": "Komplikasyonlar",
  "Concomitant diseases": "Eşlik eden hastalıklar",
  "Suggestion": "Suggestions",
  "Coronary heart disease": "Koroner Kalp hastalıklarında",
  "High blood lipids": "Yüksek kan lipitleri",
  "High blood pressure": "Yüksek tansiyon",
  "Kidney disease": "Böbrek hastalığı",
  "Neuropathy": "Nöropati ",
  "Obesity": "Obezite",
  "Peripheral arterial disease": "Koroner arter hastalıklarında",
  "Retinopathy": "Retinopati",
  "Smoking addiction": "Sigara bağımlılığı",
  "Enter date": "Tarih girin",
  "Enter suggestion": "Öneri girin",
  "Enter Notes": "Enter Notes",
  "Select": "Seçim",
  "Prescription": "Reçete",
  "Medicine": "ilaç",
  "Dose": "Doz",
  "Enter medicine": "İlaç girin",
  "Enter dose": "Dozu girin",
  "Enterdis": "Enter concomitant diseases",
  "Add note": "Yeni Not",
  "Add Content": "Maximum length is 1000 characters.",
  "Other suggestions": "Diğer öneriler",
  "OK": "TAMAM",
  "HCP": "HCP",
  "Content": "İçerik",
  "Records Report": "Kayıt Raporu",

  "Quick Print": "Hızlı Yazdır",
  "Quick Print Settings": "Hızlı Yazdırma Seçenekleri",
  "Select duration": "Süre seç:  ",
  "One Week": "Bir hafta",
  "One Month": "Bir ay",
  "One Quarter": "Bir çeyrek",
  "End date": "Bitiş tarihi",
  "Yesterday": "Dün",
  "Last Sunday": "Geçen pazar",
  "Last Saturday": "Geçen cumartesi",
  "Last Day of Last Month": "Last Day of Last Month",
  "Last Day of Last Quarter": "Last Day of Last Quarter",
  "Customized": "Özelleştirme",
  "Week Filter": "Hafta Filtresi",
  "Select reports to print": "Yazdırılacak raporları seçin",
  "Daily Summary": "Günlük özet",
  "Day By Day Overview": "Günden Güne Genel Bakış",
  "Sensor Overlay": "Sensör Yerleşimi",
  "Trend Analysis": "Trend Analizi",
  "Logbook": "Log book",
  "Device Settings Review": "Cihaz Ayarları İncelemesi",
  "createReport": "Rapor Oluştur",

  "Segment Analysis": "Segment Analizi",
  "Sensor Glucose Profile": "Sensör Glikoz Profili",
  "# of Boluses": "Bolus Sayısı",
  "Bolus Insulin": "Bolus Insulin",
  "Basal Pattern": "Basal Pattern",
  "Segment Analysis Report": "Segment Analiz Raporu",
  "Avg Glucose": "Avg Glucose",
  "Below": "Below",
  "In Target Range": "Hedef Alanında",
  "Coefficient of variation": "Varyasyon katsayısı",
  "% Time CGM Active": "% Zaman CGM Aktif",
  "est_a1c_t1": "Estimated A1C:",
  "est_a1c_t2": "calculated from SG values",
  "est_a1c_t3": "Not: Tahmini A1C laboratuar ölçümünün yerini almaz",

  "acceptTip": " has permitted you to remotely view his/her health information.",
  "cancelTip": " has stopped permitting you to remotely view his/her health information. You can apply again if necessary.",
  "rejectTip": " has rejected your remote view application.",
  "Read": "Oku",

  "Connection": "Bağlantı",
  "connections1": "Bağlantı",
  "Add Connection": "Bağlantı ekleyin",
  "SG": "SG",
  "Active Insulin": "Aktif insülin",
  "Stop following": "Takip etmeyi bırak",
  "Enter username (email)": "Kullanıcı adını girin (e-posta)",
  "Search results": "Arama sonuçları",
  "Send request": "İstek gönder",
  "View graphs": "Grafikleri görüntüle",
  "Agree": "Katılıyorum",
  "Deny": "Reddedildi",
  "Remove": "Kaldır",
  "Cancel Requset": "İsteği iptal et",
  "Remark": "Açıklama",

  "Warm up": "Isınma",
  "Monitoring": "Görüntüleme",
  "Transmitter Error": "Verici Hatası",
  "Sensor Failure": "Sensör Arızası",
  "Sensor Expired": "Sensör Süresi Doldu",
  "Lost Sensor": "Kayıp sensör",
  "Not Calibrated": "Kalibre Edilmedi",
  "Calibrating": "Kalibrasyon",
  "Calibration Needed": "Kalibrasyon Gerekli",
  "Calibration Error": "Kalibrasyon Hatası",
  "Charging Battery": "Batarya Şarj oluyor",
  "Battery Charged": "Batarya Şarj Edildi",

  "To be filled": "Doldurulacak",
  "Filled with insulin": "İnsülinle dolu",
  "Priming": "Hazırlanıyor",
  "Priming completed": "Kullanıma hazırlama tamamlandı",
  "Inserting needle": "İğne ekleniyor",
  "Patch activated": "Yama aktif",
  "Delivering Basal": "Bazal Teslimi",
  "Exceeds Max 1 Hour Delivery": "Maksimum 1 Saatlik Teslimatı aşıyor",
  "Exceeds Max TDD": "Maksimum TDD'yi aşıyor",
  "Suspend": "Askıya Alınmış",
  "Occlusion Detected": "Tıkanma Algılandı",
  "Patch Expired": "Yama Süresi Doldu",
  "Empty Reservoir": "Boş Rezervuar",
  "Patch Error": "Yama Hatası",
  "Pump Base Error": "Pompa tabanı Hatası",
  "Patch Battery Depleted": "Yama Pili Tükenmiş",
  "Magnetic sensor not calibrated": "Manyetik sensör kalibre edilmemiş",

  "Patient Profile": "Patient Profile",

  "On": "Açık",
  "on": "Açık",
  "Off": "Kapalı",
  "off": "Kapalı",

  "CORONARY_HEART_DISEASE": "Koroner Kalp hastalıklarında",
  "HIGH_BLOOD_LIPIDS": "Yüksek kan lipitleri",
  "HIGH_BLOOD_PRESSURE": "Yüksek tansiyon",
  "KIDNEY_DISEASE": "Böbrek hastalığı",
  "NEUROPATHY": "Nöropati ",
  "OBESITY": "Obezite",
  "PERIPHERAL_ARTERIAL_DISEASE": "Koroner arter hastalıklarında",
  "RETINOPATHY": "Retinopati",
  "SMOKING_ADDICTION": "Sigara bağımlılığı",

  "saveTip": "Başarılı şekilde kaydedildi.",
  "changePaTip": "Parolanız başarılı bir şekilde değiştirildi.",
  "enterEmTip": "E-mail adresini girin.",
  "verErrTip": "Doğrulama kodu yanlış.",
  "chooseEventTip": "Yazdırılacak olayları seçin",
  "chooseDataTip": "Select data to print",
  "dateWrongTip": "Bitiş tarihi, başlangıç tarihinden önce olmamalıdır.",
  "infoWrongTip": "Lütfen gerekli tüm alanları doldurunuz.",
  "createdSuccssTip": "Başarıyla düzenlendi",
  "selectData": "Select data to save",

  "acceSu": "Accepted connection request",
  "acceEr": "Failed to add new connection",
  "rejeSu": "Rejected connection request",
  "rejeEr": "Failed to reject request",

  "userNotExist": "Kullanıcı adı mevcut değil.",
  "Password incorrect": "Parola yanlış.",
  "UserType incorrect": "Incorrect user type",

  "registSuccess": "Your account has been successfully created.",
  "registFailed": "Failed to register a new account.",
  "sentSuccess": "Message sent successfully",
  "sentFailed": "Failed to send message",
  "Input error": "Giriş hatası",

  "deletePtip": "Bu hastaları silmek istediğinden emin misiniz?",
  "deleteEvents": "Bu etkinlikleri silmek istediğinize emin misiniz?",
  "deleteData": "Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",
  "deleteThis": "Silmek istediğinizden emin misiniz?",
  "confirm": "Onayla",
  "deleteSuccess": "Başarıyla silindi",
  "deleteFailed": "Failed to delete item",
  "modifySuccess": "Changed successfully",
  "modifyFailed": "Failed to change",
  "createSuccess": "Başarıyla düzenlendi",
  "createFailed": "Oluşturma başarısız oldu",
  "editSuccess": "Düzenleme başarılı",
  "editFailed": "Düzenleme başarısız oldu",
  "Time overlapped": "The sessions you selected overlapped each other.",

  "stopFollow": "Bu hastayı takip etmeyi bırakmak istediğinize emin misiniz?",
  "CancelTip1": "Are you sure to you want to delete this connection?",

  "Warning": "Uyarı",
  "agreeConnect": "If you click “Agree”to accept the connection request, your health data will become available to the new connection.",
  "denyConnect": "Are you sure you want to reject the connection request?",
  "deleteConnect": "Are you sure you want to delete this connection? If you delete him/her, the connection will not be able to view your health data any more.",

  "Choose the events to print": "Choose the events to print",
  "tryAgain": "Tekrar deneyin",
  "username and password is required": "username and password is required",
  "A name is required": "A name is required",
  "username is required": "Username is required",
  "The date choose wrong": "Tarih yanlış seçildi",
  "Date no more than 14 days": "You cannot select more than 14 days.",

  "CancelTip": "Are you sure you want to delete the connection?",
  "removeConnect": "Başarıyla silindi",

  "dateErr1": "You cannot select more than 90 days.",
  "dateErr2": "Bitiş tarihi, başlangıç tarihinden önce olmamalıdır.",

  "Not Filled": "Belirtilmemiş",
  "Today": "Bugün",
  "duration": "Süre",
  "interval": "Interval",
  "7 days": "7 gün",
  "14 days": "14 gün",
  "30 days": "30 days",
  "90 days": "90 days",
  "g": "g",

  "Sound+Vibrate": "Ses + Titreşim",
  "Sound": "Ses",
  "Vibrate": "Titreşim",
  "Silent": "Rahatsız etmeyin",
  "1": "Bir kez",
  "2": "Günlük",
  "noMes": "There is no message.",
  "noConnect": "There is no connection.",
  "Customize": "Özelleştirme",
  "GB": "United Kingdom",
  "CN": "China",
  "FR": "France",
  "DD": "Germany",
  "DE": "Germany",
  "SE": "Sweden",
  "AU": "Australia",
  "HKF": "Hongkong",
  "HU": "Hungary",
  "IT": "Italy",
  "NL": "Netherlands",
  "Nor": "Norway",
  "PT": "Portugal",
  "ES": "Spain",
  "TR": "Turkey",

  "Jan": "Jan",
  "Feb": "Feb",
  "Mar": "Mar",
  "Apr": "Apr",
  "May": "May",
  "Jun": "Jun",
  "Jul": "Jul",
  "Aug": "Aug",
  "Sep": "Sep",
  "Oct": "Oct",
  "Nov": "Nov",
  "Dec": "Dec",
  "ApplyTip": " request to view your data.",
  "noReadings": "Okuma Yok",

  "daop_A6_system": "A6 Touchcare System",
  "daop_easytouch_easyview": "EasyTouch / EasyView iPad",
  "daop_TY012_TY015": "TY012/TY015",
  "daop_easysense": "EasySense",
  "daop_delete_data": "Delete Data",
  "daop_uploaded_data": "Yüklenen Veri",
  "daop_uploaded_data_text": "Veriler EasyTouch Uygulamasından veya EasyView iPad Uygulamasından alınmıştır.",
  "daop_realtime_data": "Gerçek zamanlı veri",
  "daop_realtime_data_text": "The data is from EasySense App or EasyPatch App.",

  "ins_unit": "(U)",
  "ins_unit2": "U",
  "basal_unit": "(U/H)",
  "basal_unit2": "U/H",
  "dump_last": "Dump End",
  "Alerts_Patch_Battery_Low": "Yama Pili Düşük",
  "Alerts_Patch_Battery_Depleted": "Yama Pili Tükenmiş",
  "Alerts_Lost_Pump": "Lost Pump",
  "Alerts_Low_Reservoir": "Düşük Rezervuar",
  "Alerts_Empty_Reservoir": "Boş Rezervuar",
  "Alerts_Patch_Expiration_Advisory": "Yama Bitişi Danışmanlığı",
  "Alerts_Patch_Exp_In_1_Hour": "Patch Exp In 1 Hour",
  "Alerts_Patch_Expired": "Yama Süresi Doldu",
  "Alerts_Patch_Error": "Yama Hatası",
  "Alerts_Pump_Base_Error": "Pompa tabanı Hatası",
  "Alerts_Basal_Rate_Key_Error": "Basal Rate Key Error",
  "Alerts_Occlusion_Detected": "Tıkanma Algılandı",
  "Alerts_End_Of_Suspend": "End Of Suspend",
  "Alerts_Exceeds_Max_TDD": "Maksimum TDD'yi aşıyor",
  "Alerts_Exceeds_Max_1Hr_Delivery": "Maksimum 1saat Teslimatı aşıyor",

  "Alerts_Predictive_Low_Suspend": "Tahmini Düşük Askıya Alma",
  "Alerts_Low_Suspend": "Düşük Askıya Alma",
  "Alerts_Auto_Off": "Otomatik Kapatma",

  "Alerts_Pump_Restart": "Pump Restart",
  "Alerts_Auto_Off_Warning": "Auto Off Warning",
  "Alerts_Pump_Out_Of_Range": "Pump Out Of Range",

  "Alerts_Lost_Sensor": "Kayıp sensör",
  "Alerts_Transmitter_Battery_Low": "Verici Pili Düşük",
  "Alerts_Charge_Transmitter": "Şarj vericisi",
  "Alerts_Sensor_Error": "Okuma Yok",
  "Alerts_Transmitter_Error": "Verici Hatası",
  "Alerts_Sensor_Calibration_Error": "Sensor Calibration Error",

  "Alerts_Sensor_Failure": "Sensör Arızası",
  "Alerts_Sensor_Calibration_Reminder": "Sensor Calibration Reminder",
  "Alerts_Meter_BG_Now": "Metre BG Şimdi",
  "Alerts_Sensor_Exp_in_6_Hours": "Sensör 6 Saat İçinde Sona Erecek",
  "Alerts_Sensor_Exp_in_2_Hours": "Sensör 2 Saat İçinde Sona Erecek",
  "Alerts_Sensor_Exp_in_30_Min": "Sensör 30 Dakika İçinde Sona Erecek",
  "Alerts_Sensor_Expired": "Sensör Süresi Doldu",
  "Alerts_Rapid_Rise": "Hızlı yükseliş",
  "Alerts_Rapid_Fall": "Hızlı Düşüş",
  "Alerts_High_Predicted": "Yüksek Tahmin",
  "Alerts_Low_Predicted": "Düşük Tahmin",
  "Alerts_High_Glucose": "Yüksek Glikoz",
  "Alerts_Low_Glucose": "Düşük Glikoz",
  "Alerts_Below_3.1_mmol/L": "3.1 mmol / L'nin altında",
  "Alerts_Transmitter_Battery_Low_2": "Verici Pili Düşük",

  "Alerts_PDM_Battery_Low": "PDM Batarya Düşük",
  "Alerts_Replace_Battery": "KUM şimdi şarj et",

  "Alert": "Alert",
  "Alerts": "Uyarılar",
  "Alert Filter": "Alert Filter",
  "PDM": "PDM",
  "Pump": "Pompa",


  "Out Of Range": "Out Of Range",
  "t1221_Time_in_Auto_Mode": "Auto Modundaki zaman",
  "t1221_Average_SG_SD": "Averaj SG ± SD",
  "t1221_Time_in_Target_Range": "Hedef araliktaki zaman",
  "t1221_Time_above_Range": "hedef aralik uzerindeki zaman",
  "t1221_Time_below_Range": "hedef aralik altindaki zaman",
  "t1221_Auto_Basal_per_day": "Auto Basal (gün)",
  "t1221_Auto_Bolus_per_day": "Auto Bolus (gün)",
  "t1221_Auto_Mode_Exits": "Auto Modu cikis",
  "t1221_No_Sensor_readings": "sensor okumasi yok",
  "t1221_Max_Delivery": "max iletim",
  "t1221_Min_Delivery": "min iletim",
  "t1222_autoModeBasal": "basal Auto modu",
  "t1222_autoModeCorrBolus": "auto modu bolus duzelt",
  "t1222_autoSnack": "auto atıştırma",
  "t1222_autoBreakfast": "auto kahvalti",
  "t1222_autoLunch": "auto oglen yemek",
  "t1222_autoDinner": "auto aksam yemek",
  "t1222_autoExercise": "auto egzersiz",
  "t1222_Snack": "Atıştırma",
  "t1222_Auto_Mode": "Auto Modu",
  "t1222_Time_in_Auto_Mode": "auto modundaki zaman(%)",
  "t1222_Avg_SD": "Avg.(mmol/L)±SD",
  "t1222_Target_Range": "hedef aralik(%)",
  "t1222_Above_Range": "hedef aralik uzeri(%)",
  "t1222_Below_Range": "Hedef aralik alti(%)",
  "t1222_Auto_Mode_Exits": "# auto modundan cikisi sayisi",
  "t1221_Auto_Mode": "Auto Modu",
  "t1222_auto_basal": "Oto Bazal",
  "t1222_auto_bolus": "Oto Bolus",
  "t0805_User_Management": "Kullanıcı yönetimi",
  "t0805_Patient_Management": "Hasta yönetimi",
  "t0805_Operation_History": "Operasyon Geçmişi",
  "t0805_User_List": "Kullanıcı listesi",
  "t0805_User": "kullanıcı",
  "t0805_Time": "Zaman",
  "t0805_Operation_Type": "Operasyon türü",
  "t0805_Back": "Geri",
  "t0805_Add": "Ekle",
  "t0805_Delete": "Sil",
  "t0809_Add_User": "Kullanıcı Ekle",
  "t1028_Pattern_C": "Örüntü C",
  "t1028_Pattern_D": "Örüntü D",
  "t1029_Auto_meal_bolus": "Auto meal bolus",
  "t1029_Auto_mode_correction_bolus": "Auto mode correction bolus",
  "t1029_Sick": "Hasta",
  "t1029_Auto_Mode_Feature": "Oto Mod özelliği",
  "t1029_Target_SG": "Hedef SG",
  "t1029_Auto_Meal_Handling": "Oto Öğün İdaresi",
  "t1029_Total_Daily_Dose": "Günlük Toplam Dozu",
  "t1029_Pump_Light": "Pompa Işığı",
  "t1029_Alerts_for_Hypo": "Hİpo İçİn İkaz",
  "t1102_Out_of_Range": "Menzil disinda",
  "t1102_Command_Reminder": "Emir hatırlatması",
  "t1102_Alarms_Alerts_on_APP": "Pompa alarm ve ikazları",
  "t1102_Alarms_on_App": "App alarmları",
  "t1102_Alerts_on_App": "Düşük KŞ ikazlar",
  "t1102_Factory_Calibration": "Fabrika kalibrasyonu",
  "t1102_Alerts_for_Low": "Düşük KŞ ikazlar",
  "t1102_Alerts_for_High": "Yüksek KŞ ikazlar",
  "t1102_Alerts_for_Others": "Diğer ikazlar",
  "t1102_Adjustment": "Ayarlama",
  "t1102_Suggested": "Önerilen",
  "t1103_Glucose": "Glikoz",
  "t1103_CGM": "CGM",
  "t1103_Insulin": "Insülin",
  "t1103_Carbs": "Karbonhidrat",
  "t1103_Exercise": "Egzersiz",
  "t1103_Min_Max": "Min/Max",
  "t1103_Target_Range": "Target Range",
  "t1103_Overall_Tine_In_Range": "Overall: Time In Range",
  "t1103_Basal": "Basal",
  "t1103_Bolus": "Bolus",
  "t1103_Basal_Bolus": "Basal & Bolus",
  "t1103_Auto_Mode_Time_In_Range": "Auto Mode: Time In Range",
  "t1103_Time_below_range": "Time below range",
  "t1103_Time_above_range": "Time above range",
  "t1103_Time_in_target_range": "Time in target range",
  "t1103_Incorrect_Password": "Yanlış Şifre, $1 Deneme kaldı, lütfen doğru Şifreyi girin.",
  "t1103_Incorrect_locked": "Başarısız Denemeler sınırı aşıyor, hesap kilitlendi. Lütfen $1 dakika sonra tekrar deneyin.",
  "t1104_The_data_is_from": "Veriler EasySense Uygulamasından veya EasyPatch Uygulamasından alınmıştır.",
  "t1104_Privacy_Policy": "Kişisel Veri Gizliliği Politikasi ve Kullanim Kosullari",
  "t1104_updated_privacy_policy": "Kişisel Veri Gizliliği Politikasi ve Kullanim Kosullari güncelledik. Lutfen kullanmaya başlamadan once dikkatle okuyun.",
  "t1104_Disagree": "Kabul ediyorum",
  "t1104_Agree": "Katılıyorum",
  "t1105_Upload_History": "Yükleme Geçmişi",
  "t1105_Delete_Data": "Verileri sil",
  "t1105_Target_Range": "Target Range",
  "t1105_request_to_view_your_data": "Verilerinizi görüntülemek için $1 istek.",
  "t1105_Recent_Updates": "Son Güncellemeler",
  "t1108_No_data": "Veri yok",
  "t1108_Pump_Bash_SN": "Pompa tabanı SN",
  "t1108_Transmitter_SN": "Verici SN",
  "t1112_Normal_Glucose": "Normal Glikoz",
  "t1112_Manual_Bolus_or_Modified_Bolus": "Manuel Bolus veya Değiştirilmiş Bolus",
  "t1112_Auto_Mode_Started": "Oto Mod Başladı",
  "t1112_Auto_Mode_Exit": "Oto Mod Çıkış",
  "t1112_Normal_Bolus": "Normal Bolus",
  "t1112_Extended_Bolus": "Uzatılmış Bolus",
  "t1112_Combo_Bolus": "Combo bolus",
  "t1112_Carbs": "Karbonhidrat",
  "t1112_Glucose": "Glikoz",
  "t1112_BG": "Kan şekeri ",
  "t1112_Audio": "Ses",
  "t1112_Tone": "Ton",
  "t1112_Audio_Options": "Ses Seçenekleri",
  "t1112_Weight_Unit": "Ağırlık Birimi",
  "t1112_Height_Unit": "Yükseklik Birimi",
  "t1112_Not_available": "Müsait Değil",
  "t1112_Number": "Sayı",
  "t1112_days": "# günlr",
  "t1112_min": "dk",
  "t1113_days": "günlr",
  "t1215_Security": "Güvenlik",
  "t1215_MFA": "Çok faktörlü kimlik doğrulama (MFA)",
  "t1215_Enter_verification_code": "Dogrulama kodunu giriniz",
  "t1215_Multi_factor_ON": "Çok faktörlü kimlik doğrulama AÇIK. Doğrulama kodu $1 adresine gönderildi Lütfen doğrulama kodunu gönderin.",
  "t1215_Verification_code_incorrect": "Doğrulama kodu yanlış",
  "t1215_Show_Glucose_Value": "Glikoz değerini göster",
  "t1221_enter_verification_code": "Lütfen $1'e gönderilen 6 haneli doğrulama kodunu girin.",
  "t1221_Verification_Success": "Başarıyla doğrulandı",
  "t1222_We_will_only_process": "Sağlık hizmeti bilgilerinizi sizin rızanız halinde Medtrum APP/Web Sitesinde işleyeceğiz. ",
  "t1222_If_you_are_under_years": "Eğer 16 yaşından küçükseniz, bu uygulamaya kaydolmak için ebeveyn veya yasal velinizin rızası olmak zorundadır.",
  "t1221_register_cn": "APP'e hiç bir cihaz bilgisini yüklememe hakkına sahipsiniz, böylelikle bilgiler diğerleri tarafından ulaşılamaz olacaktır. Eğer Medtrum APP/Web Sitesine kaydolmayı seçmezseniz, tek sağlık bilginiz cihazdakiler olacaktır. ",
  "t1221_register_eu": "Eğer Medtrum hesabınızı kaydetmeyi ve hesabı kullanarak APP'e ulaşmayı seçerseniz, APP'te kaydedilen sağlık bilgileriniz Avrupa'daki serverlarımıza yüklenip 2 yıl süreyle saklanacaktır. APP'e hiç bir cihaz bilgisini yüklememe hakkına sahipsiniz, böylelikle bilgiler diğerleri tarafından ulaşılamaz olacaktır. Eğer Medtrum APP/Web Sitesine kaydolmayı seçmezseniz, tek sağlık bilginiz cihazdakiler olacaktır.",
  "t1221_register_follow": "Sağlık hizmeti bilgilerinizi sizin rızanız halinde Medtrum APP/Web Sitesinde işleyeceğiz.",
  "t1222_Terms_of_Use": "Medtrum Kullanım Koşullarına",
  "t1222_Privacy_Policy": "Medtrum'un Gizlilik Politikasına",
  "t1222_Create_Account": "Hesap aç",
  "t1222_Back": "Geri",
  "t1222_Verify_your_account": "Hesabınızı doğrulayın",
  "t1222_please_check_your_account": "$1'e bir Doğrulama Kodu göndereceğiz, lütfen hesabınızı kontrol edin.",
  "t1222_I_Agree_to": "$1 Katılıyorum",
  "t1223_Invalid_Verification_Code": "Geçersiz Doğrulama Kodu. Lütfen tekrar deneyin."
};

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return zhMessages; });
var zhMessages = {
  "Raw data": "数据",
  "Data Export": "导出数据",
  "Data Export Settings": "导出数据设置",
  "Select data to export": "导出数据选择",
  "Bolus": "大剂量",
  "Basal": "基础量",
  "Events": "事件",
  "Device Settings": "设备设置",
  "BG Export": "指尖血糖",

  "country_region": "国家/地区",

  "privacy_policy_and_terms_of_use": "隐私政策和服务协定",
  "privacy_confirm_text": "我们最近更新了<a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>隐私政策</a>和<a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>服务协定</a>。请仔细阅读，同意并接受全部条款后再使用EasyView</p>",
  "privacy_confirm_disagree": "不同意",
  "privacy_confirm_accept": "接受",

  "title": "EasyView Personal",
  "title1": "EasyView Pro",
  "user": "邮箱",
  "password": "密码",
  "remember": "记住密码",
  "forget": "忘记密码？",
  "sign in": "登录",
  "login": "登录",
  "sign up now": "立即注册",
  "apply": "立即申请账号",
  "contact us": "联系我们",
  "Privacy Policy": "隐私政策",
  "Terms of Use": "服务协议",
  "copyright": "2021，上海移宇科技有限公司，保留所有权利。",

  "chooseLang": "选择国家/地区和语言",
  "asia": "亚洲",
  "europe": "欧洲",
  "middleEast": "中东",

  "applyHcp": "申请HCP账号",
  "sign up": "注册",
  "Patient": "患者",
  "Caregiver": "监护人",
  "Email": "邮箱/用户名",
  "Mobile": "手机",
  "Enter email": "输入邮箱地址",
  "Enter mobile": "输入手机号",
  "Verification": "验证码",
  "Invitation": "邀请码",
  "full name": "输入真实姓名",
  "Enter pass": "输入密码",
  "org": "组织机构",
  "Register": "注册",
  "createAccount": "创建账户",
  "send": "发送",
  "agree": "我已阅读并同意此Medtrum的 ",
  "privacy": "隐私政策",
  "and": "及 ",
  "use": "服务协议",
  "errtip1-1": "您的邮箱地址将会成为您的用户名，",
  "errtip1-2": " 请输入有效的邮箱地址",
  "errtip2": "请输入正确的手机号",
  "errtip3": "验证码输入错误",
  "errtip4": "邀请码错误",
  "errtip5": "未输入姓名",
  "errtip6": "你的密码必须不少于6位",
  "errtip7": "请输入您的组织机构",

  "errp1": "密码必须由至少三种字符组成:",
  "errp2": "大写字母、小写字母、数字或特殊字符",
  "errp3": "密码长度为6~20个字符",
  "errp4": "密码不能使用用户名",
  "errp5": "不能有三个以上连续的数字(如:123,321)",
  "errp6": "不能有三个以上连续的字母(如:abc,cba)",
  "errp7": "不能包含空格",

  "Find account": "找回密码",
  "Enter username": "请输入用户名",
  "Next": "下一步",
  "Cancel": "取消",
  "Back": "返回",
  "Enter veri": "请输入验证码",
  "Create new": "创建新密码",
  "Verify notice": "请输入您邮箱/手机中Medtrum公司发送的验证码",
  "Create new notice": "请输入6位新密码",
  "New pass": "新密码",
  "Completed": "完成",
  "Created": "新密码已创建.",
  "Login Now": "立即登录",

  "Delete": "删除",
  "New Patient": "添加患者",
  "Add Patient": "查找患者",
  "Filter": "筛选",
  "Name": "姓名",
  "Gender": "性别",
  "Age": "年龄",
  "Type": "糖尿病类型",
  "Duration": "病龄",
  "Connections": "账号创建者",
  "UploadTime": "上传时间",
  "Year": "年",
  "Years": "年龄",
  "Month": "月",
  "Month2": "月",
  "Months": "月",
  "Invite": "邀请",
  "Invited": "已邀请",
  "All": "全部",
  "Female": "女性",
  "Male": "  男",
  "Not Set": "未填写",
  "Type 1": "类型 1",
  "Type 2": "类型 2",
  "Gestational": "妊娠糖尿病",
  "Prediabetes": "糖尿病前期",
  "LADA": "成人隐匿性免疫性糖尿病",
  "Apply": "保存",
  "addP": "添加患者",
  "newP": "新建患者",
  "findP": "查找患者",
  "disUn": "糖尿病类型 未填写",
  "ageUn": "未填写年龄",
  "genUn": "未填写性别",
  "GDRNF": "未填写",
  "GDRF": "女",
  "GDRM": "男",
  "女": "男性",

  "DBTNF": "未填写",
  "DBT1": "类型 1",
  "DBT2": "类型 2",
  "DBTLADA": "LADA",
  "DBTPRE": "前期",
  "DBTGEST": "DBTGEST",
  "前期": "前期",
  "beFore": "前期",
  "MODY": "其他",

  "No selection": "未填写",
  "unspecif": "未填写",
  "register": "患者",
  "hcp": "医生",

  "BG": "血糖值",
  "CARB": "食物",
  "INS": "胰岛素注射",
  "EXR": "运动",
  "OTR": "其他",
  "HBA1C": "HbA1c",
  "DOSE": "药物",
  "URINEK": "尿酮",
  "HEL": "HEL",
  "OTR1": "其他",
  "Loading": "加载中",

  "home": "首页",
  "pID": "患者编号",
  "fullName": "姓名",
  "gender": "性别",
  "height": "高",
  "weight": "体重",
  "cm": "厘米",
  "kg": "千克",
  "birthday": "出生日期",
  "disType": "糖尿病类型",
  "disDate": "确诊日期",
  "Address": "地址",
  "Postcode": "邮编",
  "Inpatient": "住院信息",
  "Yes": "是",
  "No": "否",
  "Pno": "住院编号",
  "Bno": "床位编号",
  "create": "创建",
  "Telephone": "座机",

  "enterU": "输入用户名（邮箱/手机号）",
  "search": "搜索",
  "noU": "未输入用户名",
  "searchR": "搜索结果",
  "uername": "用户名",
  "alias": "昵称",
  "remove": "移除",
  "viewG": "查看图表",
  "sendR": "发送请求",
  "rSent": "请求已发送",
  "cancelR": "取消申请监护的患者",
  "VcodeTip1": "验证码已发送到 ",
  "VcodeTip2": "中，请等待一分钟，若仍然未收到，请点击",
  "VcodeTip3": "重试",
  "Entercode": "输入验证码",
  "Getcode": "获取验证码",

  "messages": "消息",
  "profile": "个人信息",
  "sign out": "退出",
  "changeP": "修改密码",
  "connection": "联系人",

  "myP": "个人信息",
  "Portrait": "头像",
  "Profession": "职业",
  "DPRONF": "未填写",
  "DPROENDOCRIN": "内分泌医师",
  "DPRODIABTRA": "糖尿病护理教育者",
  "DPRONURSE": "护理医师",
  "DPRODIATIT": "营养师",
  "DPROOTR": "其他医疗服务人员",
  "Organization": "组织机构",
  "Bio": "简介",
  "save": "保存",
  "oldPa": "旧密码",
  "newPa": "新密码",
  "RePa": "确认密码",
  "forgetY": "忘记密码",
  "applyM": "应用",
  "oldErr": "旧密码错误。",
  "EntTheSame": "再次输入新密码。",
  "EnterOld": "输入旧密码",

  "pList": "患者列表",
  "connections": "患者列表",
  "settings": "设置",
  "monitor": "实时监控",
  "graphs": "报告",
  "events": "事件",
  "records": "病程记录",
  "qPrint": "快速打印",

  "sensorIn": "血糖信息",
  "timeOfLaRead": "最近血糖更新时间",
  "tranSn": "发射器序列号",
  "status": "状态",
  "sensorLife": "血糖探头剩余使用时间",
  "lastSenorRead": "最近血糖读数",
  "TranBattery": "发射器电量",
  "sg": "血糖",
  "alert": "告警",
  "target": "目标范围",
  "hypo": "低限",
  "sensorGlucose": "血糖读数",
  "calib": "校准",
  "newSen": "新探头",
  "warm": "初始化",
  "InsulinPump": "胰岛素泵",
  "timeOfLaPump": "最近一次泵数据更新时间",
  "pumpSN": "泵体控制器序列号",
  "ReserviorLife": "储药贴剩余时间",
  "InsulinLeft": "胰岛素剩余量",
  "basal": "基础量",
  "bolus": "大剂量",
  "totalBasal": "基础量总量",
  "lastBolus": "最近大剂量",
  "activeInsulin": "活性胰岛素",
  "totalBolus": "大剂量总量",
  "tampBasal": "临时基础量",
  "normalBolus": "正常大剂量",
  "extendBolus": "扩展大剂量",
  "manualStop": "手动暂停",
  "autoStop": "自动暂停",
  "auto suspend": "自动暂停",
  "stop": "输注停止",
  "newPatch": "新储药贴",
  "tempBasal": "临时基础量",
  "N": "正",
  "E": "扩",
  "CN1": "组正",
  "CE": "组扩",

  "staticSettings": "报告设置",
  "dataSource": "数据源",
  "unit": "单位",
  "glucoseTarget": "血糖目标范围",
  "overall": "总计",
  "Hypoglycemia": "低于3.1mmol/L（56mg/dL）",
  "timePeriod": "时间段",
  "postMeal": "餐后分析",
  "Breakfast": "早餐",
  "Lunch": "中餐",
  "Dinner": "晚餐",
  "night": "夜间",
  "Before": "前",
  "After": "后",
  "Low": "低限",
  "High": "高限",
  "From": "开始",
  "To": "结束",
  "Hours": "小时",
  "Reset": "恢复默认设置",
  "RealTime": "实时",
  "uploaded": "上传",
  "sensor": "血糖探头",
  "pdmSN": "手持机序列号",
  "startTime": "开始时间",
  "endTime": "结束时间",
  "uploadTime": "上传时间",
  "pdm": "手持机",
  "Uploaded": "上传",
  "Patch Pump": "贴片泵",
  "overLapp": "时间段重叠",
  "showAlert": "显示告警",

  "dashboard": "综合报表",
  "dboard_glucose_statistics": "统计",
  "dboard_glucose": "指尖血糖",
  "dboard_cgm": "动态血糖",
  "dboard_insulin": "胰岛素",
  "dboard_carbs": "食物",
  "dboard_exercise": "运动",
  "dboard_glucose_avg": "平均值",
  "dboard_cgm_avg": "平均值",
  "dboard_insulin_avg": "平均每天输注的胰岛素",
  "dboard_carbs_avg": "平均每天摄入量",
  "dboard_exercise_avg": "平均每天运动时间",
  "dboard_sd": "标准方差",
  "dboard_num": "次数",
  "dboard_num_days": "# days",
  "dboard_statistics": "统计",
  "dboard_BG": "血糖值",
  "dboard_BG_calibration": "BG/校准（每天）",
  "dboard_SG": "动态血糖值",
  "dboard_AUC_high": "AUC高 >",
  "dboard_AUC_low": "AUC低 <",
  "dboard_highest_value": "最高价值",
  "dboard_lowest_value": "最低价值",

  "dboard_pump": "泵",
  "dboard_avg_daily_dose": "平均每天输注的胰岛素",
  "dboard_SD": "标准方差",
  "dboard_daily_basal": "每日基础量",
  "dboard_daily_bolus": "每日大剂量",
  "dboard_avg_bolus_num": "平均每天输注大剂量次数",
  "dboard_avg_suspend_time": "平均暂停时间",
  "dboard_avg_reservoir_usage": "储药贴平均寿命",
  "dboard_days": "days",

  "dboard_manual_bolus": "手动大剂量（数量/次数）",
  "dboard_normal": "-正常",
  "dboard_extend": "-扩展",
  "dboard_combo": "-组合",

  "dboard_bolus_calculator": "大剂量向导（数量/次数）",
  "dboard_food_bolus": "-食物大剂量",
  "dboard_corr_bolus": "-校正大剂量",
  "dboard_override_add": "-向上调整(+)",
  "dboard_override_sub": "-向下调整(-)",

  "dboard_report": "综合报表报告",

  "daily": "每日总结",
  "date": "日期",
  "print": "打印",
  "carbs": "食物",
  "exercise": "运动",
  "heavy": "剧烈",
  "Medium": "中度",
  "Light": "轻度",
  "dailyReport": "每日总结报告",
  "devices": "设备",
  "tran": "发射器",
  "pumpBase": "泵体控制器",
  "HbA1c": "糖化血红蛋白",
  "statics": "统计",
  "glucose": "血糖",
  "item": "项",
  "BG1": "指尖血糖",
  "SG1": "血糖",
  "avgSD": "平均值(mmol/L)±标准差",
  "avgSD1": "平均值±标准差",
  "min": "最小值",
  "max": "最大值",
  "ofRead": "读数",
  "ofHypo": "低血糖次数/持续时间",
  "ofAlert": "告警次数",
  "insulin": "胰岛素",
  "insulin2": "胰岛素",
  "totalDose": "全天输注总量",
  "foodBolus": "食物大剂量",
  "Food+coor": "食物和校正大剂量",
  "calibBolus": "校正大剂量",
  "durationStop": "暂停输注时间(分钟)",
  "ofPumpAlert": "泵告警次数",
  "ofMeal": "进餐次数",
  "totalExerTime": "运动总时间",
  "exerNum": "运动次数",
  "avgInten": "平均强度",
  "target1": "目标范围",
  "high1": "高",
  "low1": "低",
  "BG Reading": "指尖血糖读数",

  "dayByday": "多日浏览",
  "dayBydayRe": "多日总结报告",
  "period": "时间段",

  "sensorOverlay": "血糖叠加图",
  "set": "设置",
  "setPeriod": "设置时间段",
  "Weekdays": "工作日",
  "Weekends": "周末",
  "Mon": "星期一",
  "Tue": "星期二",
  "Wed": "星期三",
  "Thur": "星期四",
  "Thu": "星期四",
  "Fri": "星期五",
  "Sat": "星期六",
  "Sun": "星期日",
  "Average": "平均值",
  "sensorOlRe": "血糖叠加图报告",
  "Avg": "平均值",
  "±SD": "±标准差",
  "ofhypo": "低血糖次数",
  "Everyday": "每天",

  "TrendAna": "趋势分析",
  "TrendRe": "趋势分析报告",
  "sensorGlu": "血糖探头读数",
  "ofBGtest": "指尖血糖读数（次数）",
  "Basics": "基本统计",
  "static": "统计",
  "Med": "中位数",
  "med": "中位数",
  "Q1": "1/4分位",
  "Q3": "3/4分位",
  "Q11": "1/4分位数",
  "Q31": "3/4分位数",
  "IQR": "四分位距",
  "SD": "标准差",
  "CV": "变异系数",
  "SE1": "均值标准误差",
  "distri": "分布",
  "stab": "稳定性",
  "#high": "#偏高",
  "#low": "#偏低",
  "aucBelow": "低限线下积分",
  "aucAbove": "高限线下积分",
  "bgRead": "指尖血糖读数",
  "total": "总量",
  "ofBolus": "大剂量次数",
  "avgBolus": "大剂量平均值",
  "Dura1": "运动（分）",
  "Avg/Total": "平均值/总计",
  "high": "高",
  "low": "低限",
  "#hypo": "低血糖次数",
  "ofExer": "运动次数",

  "logbook": "日志",
  "dailyTotal": "全天总量",
  "High Glucose": "血糖高",
  "Low Glucose": "血糖低",
  "No Active Patch": "无激活储药贴",
  "Missed Meal": "错过用餐时间",
  "Multiple BG Readings": "多个指尖血糖读数",
  "Stop Patch": "储药贴终止",
  "Others": "其他",
  "Other Events": "其他事件",
  "logRe": "日志报告",

  "DeviceSetting": "设备设置报告",
  "Insulin Pump": "胰岛素泵",
  "MaxBasalRate": "基础量最大值",
  "BasalPatterns": "基础量程序",
  "Selected Basal Pattern": "激活的基础量程序",
  "Maximum Bolus": "大剂量最大值",
  "Combo/Extended Bolus": "组合/扩展大剂量",
  "BG Reminder": "指尖血糖提醒",
  "Bolus Increment": "大剂量步长",
  "Bolus Calculator": "大剂量向导",
  "Active Insulin Time": "活性胰岛素",
  "IC Ratios": "胰岛素食物比",
  "Insulin Sensitivity": "胰岛素灵敏度",
  "BG Target": "目标血糖",
  "Bolus Reminder": "大剂量提醒",
  "CGM": "动态血糖",
  "CGM System": "动态血糖系统",
  "Glucose Unit": "血糖单位",
  "Glucose Limits": "血糖门限",
  "Predicitive Alerts": "血糖异常预测告警",
  "Rate Alerts": "血糖变化异常告警",
  "type": "类型",
  "time": "时间",
  "data": "数据",
  "Rate": "速率",
  "Calibration Reminder": "校准提醒",
  "Calibration Repeat": "校准重复告警",
  "Snooze": "重复告警间隔",
  "Audio Options": "声音选项",
  "Confidence Reminder": "指令响应提示",
  "Backlight": "背光",
  "Sec": "秒",
  "Alarm Clock": "闹钟",
  "Patch Expiration": "储药贴过期告警",
  "Sensor Expiration": "探头过期告警",
  "Hourly Max": "每小时最大输注量",
  "Daily Max": "每天最大输注总量",
  "Low Reservoir": "低储药量告警",
  "Low Suspend": "低血糖暂停输注",
  "Predictive Low Suspend": "预测低血糖暂停输注",
  "Rise": "上升",
  "Fall": "下降",
  "Auto Off": "自动暂停输注",
  "Standard": "标准",
  "Exercise": "锻炼",
  "Holiday": "假日",
  "ProgramA": "程序A",
  "ProgramB": "程序B",
  "--": "--",
  "Insulin": "胰岛素",

  "SUSA": "自动暂停输注告警",
  "SUSHM": "超出每小时最大量暂停输注",
  "SUSDM": "超出每天最大量暂停输注",
  "SUSLSG": "低血糖暂停输注",
  "SUSPLSG": "预测低血糖暂停输注",
  "Pump Restarted": "贴片泵重启",
  "Meter BG Now": "立即输入指尖血",
  "Sensor Exp in 2 Hours": "探头2小时内过期",
  "Sensor Exp in 6 Hours": "探头6小时内过期",
  "Sensor Exp in 30 Min": "探头30分钟内过期",
  "Sensor Calibration Error": "探头校准错误",
  "Sensor Error": "无血糖读数",

  "Device Settings Report": "设备设置报告",
  "Device Settings at": "设备设置时间",
  "24h Total": "24小时总量",
  "Start": "开始",
  "Combo/Ext Bolus": "组合/扩展大剂量",
  "Time Format": "时间制",
  "Device Options（CGM System)": "动态血糖系统",
  "Device Options（Insulin Pump)": "胰岛素泵系统",
  "Dispay Settings (Screen)": "显示（屏幕）",
  "Dispay Settings (Backlight)": "显示（背光）",
  "Graph Range": "血糖趋势图显示",
  "Range": "范围",
  "Repeat": "模式",
  "Glucose Alerts": "血糖告警",
  "Alert Silence": "血糖告警静音",

  "Create": "添加",
  "Event Filter": "筛选",
  "HbA1c1": "糖化血红蛋白",
  "Urine Ketone": "尿酮",
  "Injection": "胰岛素注射",
  "Other": "其他",
  "Event Type": "事件类型",
  "Details": "详情",
  "Notes": "备注",
  "Source": "来源",
  "edit": "编辑",
  "Action": "操作",
  "EventReport": "事件汇总报告",
  "By Date": "按日期",
  "By Category": "按项目",
  "Event Summary": "事件汇总",
  "No data": "无数据",
  "No1": "无",
  "data1": "数据",
  "#": "次数",
  "BG Summary": "指尖血糖统计",
  "Carbs Summary": "食物统计",
  "Injection Summary": "胰岛素注射统计",
  "Exercise Summary": "运动统计",
  "Input Notes": "输入备注",

  "Profile": "个人信息",
  "Complications": "并发症",
  "Concomitant diseases": "伴发病",
  "Suggestion": "建议",
  "Coronary heart disease": "冠心病",
  "High blood lipids": "高血脂",
  "High blood pressure": "高血压",
  "Kidney disease": "肾病",
  "Neuropathy": "神经病变",
  "Obesity": "肥胖症",
  "Peripheral arterial disease": "外周动脉疾病",
  "Retinopathy": "视网膜病变",
  "Smoking addiction": "吸烟者",
  "Enter date": "输入日期",
  "Enter suggestion": "输入建议",
  "Enter Notes": "输入备注",
  "Select": "选择",
  "Prescription": "药方",
  "Medicine": "药物类型",
  "Dose": "用量",
  "Enter medicine": "输入药物类型",
  "Enter dose": "输入药量",
  "Enterdis": "输入并发症",
  "Add note": "输入备注",
  "Add Content": "最大长度为1000字符。",
  "Other suggestions": "其他建议",
  "OK": "确定",
  "HCP": "医护人员",
  "Content": "内容",
  "Records Report": "病程记录报告",

  "Quick Print": "快速打印",
  "Quick Print Settings": "快速打印设置",
  "Select duration": "选择时间间隔",
  "One Week": "一周",
  "One Month": "一月",
  "One Quarter": "一个季度",
  "End date": "截止日期",
  "Yesterday": "昨天",
  "Last Sunday": "上周日",
  "Last Saturday": "上周六",
  "Last Day of Last Month": "上个月最后一天",
  "Last Day of Last Quarter": "上个季度最后一天",
  "Customized": "设置",
  "Week Filter": "星期删选",
  "Select reports to print": "选择需要打印的报告",
  "Daily Summary": "每日总结",
  "Day By Day Overview": "多日总结",
  "Sensor Overlay": "血糖叠加图",
  "Trend Analysis": "趋势分析",
  "Logbook": "日志",
  "Device Settings Review": "设备设置",
  "createReport": "创建报告",

  "Segment Analysis": "分段分析",
  "Sensor Glucose Profile": "动态血糖",
  "# of Boluses": "大剂量次数",
  "Bolus Insulin": "大剂量",
  "Basal Pattern": "基础量程序",
  "Segment Analysis Report": "分段分析报告",
  "Avg Glucose": "血糖平均值",
  "Below": "低于",
  "In Target Range": "目标范围",
  "Coefficient of variation": "变异系数",
  "% Time CGM Active": "CGM激活时间百分比",
  "est_a1c_t1": "估算糖化血红蛋白：",
  "est_a1c_t2": "基于动态血糖值计算所得",
  "est_a1c_t3": "说明：估算的糖化血红蛋白值不能替代实验室所测量的值",

  "acceptTip": " 已授权监护。",
  "cancelTip": " 已取消对您的授权，如需远程监护，请重新申请。",
  "rejectTip": " 拒绝了您的申请。",
  "Read": "阅读",

  "Connection": "患者",
  "connections1": "联系人",
  "Add Connection": "添加患者",
  "SG": "血糖值",
  "Active Insulin": "活性胰岛素",
  "Stop following": "停止监护",
  "Enter username (email)": "输入用户名（邮箱/手机号）",
  "Search results": "搜索结果",
  "Send request": "发送请求",
  "View graphs": "查看图表",
  "Agree": "同意",
  "Deny": "拒绝",
  "Remove": "移除",
  "Cancel Requset": "取消申请监护的患者",
  "Remark": "备注",

  "Patient Profile": "患者信息",

  "Warm up": "初始化",
  "Monitoring": "正常监控中",
  "Transmitter Error": "发射器故障",
  "Sensor Failure": "血糖探头失败",
  "Sensor Expired": "血糖探头过期",
  "Lost Sensor": "血糖探头丢失",
  "Not Calibrated": "未校准",
  "Calibrating": "校准中",
  "Calibration Needed": "校准过期",
  "Calibration Error": "校准错误",
  "Charging Battery": "充电中",
  "Battery Charged": "充电完成",

  "To be filled": "等待灌药",
  "Filled with insulin": "已灌药",
  "Priming": "充盈中",
  "Priming completed": "充盈已完成",
  "Inserting needle": "正在注针过程中",
  "Patch activated": "注针已完成",
  "Delivering Basal": "正在输注基础量",
  "Exceeds Max 1 Hour Delivery": "超出每小时最大量暂停输注",
  "Exceeds Max TDD": "超出每天最大量暂停输注",
  "Suspend": "用户手动暂停输注",
  "Occlusion Detected": "储药贴堵塞",
  "Patch Expired": "储药贴过期",
  "Empty Reservoir": "储药贴空",
  "Patch Error": "储药贴故障",
  "Pump Base Error": "泵控制器故障",
  "Patch Battery Depleted": "电池没电",
  "Magnetic sensor not calibrated": "磁传感器未校准",

  "On": "开启",
  "on": "开启",
  "Off": "关闭",
  "off": "关闭",

  "CORONARY_HEART_DISEASE": "冠心病",
  "HIGH_BLOOD_LIPIDS": "高脂血",
  "HIGH_BLOOD_PRESSURE": "高血压",
  "KIDNEY_DISEASE": "肾病",
  "NEUROPATHY": "神经病变",
  "OBESITY": "肥胖症",
  "PERIPHERAL_ARTERIAL_DISEASE": "外周动脉疾病",
  "RETINOPATHY": "视网膜病变",
  "SMOKING_ADDICTION": "吸烟者",

  "saveTip": "保存成功!",
  "changePaTip": "密码修改成功",
  "enterEmTip": "请输入您的邮箱/手机",
  "verErrTip": "验证码输入错误",
  "chooseEventTip": "选择需要打印的事件",
  "chooseDataTip": "选择要打印的数据",
  "dateWrongTip": "截止日期不能小于起始日期",
  "infoWrongTip": "信息未填写完成",
  "createdSuccssTip": "创建成功",
  "selectData": "选择要保存的数据",

  "acceSu": "已接受的联系人申请",
  "acceEr": "添加新联系人失败",
  "rejeSu": "已拒绝的联系人申请",
  "rejeEr": "拒绝联系人申请失败",

  "userNotExist": "用户名不存在",
  "Password incorrect": "密码错误。",
  "UserType incorrect": "账号类型错误",
  "registSuccess": "您的账号已成功创建。",
  "registFailed": "注册新账号失败。",
  "sentSuccess": "发送消息成功",
  "sentFailed": "发送消息失败",

  "Input error": "输入错误",

  "deletePtip": "确定需要删除这些患者吗？",
  "deleteEvents": "请确认是否需要删除这些事件？",
  "deleteData": "Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",
  "deleteThis": "请确认是否需要删除这个事件？",
  "confirm": "确定",
  "deleteSuccess": "已删除",
  "deleteFailed": "删除项失败",
  "modifySuccess": "修改成功",
  "modifyFailed": "修改失败",
  "createSuccess": "创建成功",
  "createFailed": "创建成功",
  "editSuccess": "编辑成功",
  "editFailed": "编辑失败",
  "Time overlapped": "选择的时间段重叠。",

  "stopFollow": "你确定要停止监护此患者吗？",
  "CancelTip1": "请确认是否需要删除此联系人？",

  "Warning": "提示",
  "agreeConnect": "点击“同意”后，联系人将会看到您的血糖数据、胰岛素泵数据及个人相关信息。",
  "denyConnect": "请确认是否拒绝联系人申请？",
  "deleteConnect": "请确认是否需要删除此联系人？如果确认删除，此联系人将无法远程查看您的血糖数据、胰岛素泵数据及个人相关信息。",

  "Choose the events to print": "选择要打印的事件",
  "tryAgain": "重试",
  "username and password is required": "请输入用户名和密码",
  "A name is required": "请输入姓名",
  "username is required": "请输入用户名",
  "The date choose wrong": "时间选择错误",
  "Date no more than 14 days": "所选的日期不能操过14天",

  "CancelTip": "请确认是否需要删除此联系人？",
  "removeConnect": "删除成功",

  "dateErr1": "日期选择范围不能超过90天.",
  "dateErr2": "截止日期不能小于起始日期",

  "Not Filled": "未填写",
  "Today": "今天",
  "duration": "病龄",
  "interval": "Interval",
  "7 days": "7天",
  "14 days": "14天",
  "30 days": "30 天",
  "90 days": "90 天",
  "g": "克",

  "Sound+Vibrate": "声音+振动",
  "Sound": "声音",
  "Vibrate": "振动",
  "Silent": "免打扰",
  "1": "一次",
  "2": "每天",
  "noMes": "无消息",
  "noConnect": "无联系人",
  "Customize": "设置",
  "GB": "United Kingdom",
  "CN": "China",
  "FR": "France",
  "DD": "Germany",
  "DE": "Germany",
  "SE": "Sweden",
  "AU": "Australia",
  "HKF": "Hongkong",
  "HU": "Hungary",
  "IT": "Italy",
  "NL": "Netherlands",
  "Nor": "Norway",
  "PT": "Portugal",
  "ES": "Spain",
  "TR": "Turkey",

  "Jan": "一月",
  "Feb": "二月",
  "Mar": "三月",
  "Apr": "四月",
  "May": "五月",
  "Jun": "六月",
  "Jul": "七月",
  "Aug": "八月",
  "Sep": "九月",
  "Oct": "十月",
  "Nov": "十一月",
  "Dec": "十二月",
  "ApplyTip": " 申请监护您的数据.",
  "noReadings": "无血糖读数",

  "daop_A6_system": "A6 Touchcare System",
  "daop_easytouch_easyview": "EasyTouch / EasyView iPad",
  "daop_TY012_TY015": "TY012/TY015",
  "daop_easysense": "EasySense",
  "daop_delete_data": "删除数据",
  "daop_uploaded_data": "已上传数据",
  "daop_uploaded_data_text": "数据来源于EasyTouch移动应用程序或EasyView iPad移动应用",
  "daop_realtime_data": "实时数据",
  "daop_realtime_data_text": "数据来源于EasySense移动应用程序",

  "ins_unit": "(U)",
  "ins_unit2": "U",
  "basal_unit": "（U/H）",
  "basal_unit2": "U/H",

  "dump_last": "Dump End",

  "Alerts_Patch_Battery_Low": "储药贴电量低",
  "Alerts_Patch_Battery_Depleted": "储药贴没电",
  "Alerts_Lost_Pump": "Lost Pump",
  "Alerts_Low_Reservoir": "储药量低",
  "Alerts_Empty_Reservoir": "储药贴空",
  "Alerts_Patch_Expiration_Advisory": "储药贴过期预警",
  "Alerts_Patch_Exp_In_1_Hour": "Patch Exp In 1 Hour",
  "Alerts_Patch_Expired": "储药贴过期",
  "Alerts_Patch_Error": "储药贴故障",
  "Alerts_Pump_Base_Error": "泵控制器故障",
  "Alerts_Basal_Rate_Key_Error": "Basal Rate Key Error",
  "Alerts_Occlusion_Detected": "储药贴堵塞",
  "Alerts_End_Of_Suspend": "End Of Suspend",
  "Alerts_Exceeds_Max_TDD": "超过每天最大输注量",
  "Alerts_Exceeds_Max_1Hr_Delivery": "超过每小时最大输注量",

  "Alerts_Predictive_Low_Suspend": "预测低血糖暂停输注",
  "Alerts_Low_Suspend": "低血糖暂停输注",
  "Alerts_Auto_Off": "自动暂停输注",

  "Alerts_Pump_Restart": "Pump Restart",
  "Alerts_Auto_Off_Warning": "Auto Off Warning",
  "Alerts_Pump_Out_Of_Range": "Pump Out Of Range",

  "Alerts_Lost_Sensor": "血糖探头丢失",
  "Alerts_Transmitter_Battery_Low": "发射器电量低",
  "Alerts_Charge_Transmitter": "发射器需充电",
  "Alerts_Sensor_Error": "无血糖读数",
  "Alerts_Transmitter_Error": "发射器故障",
  "Alerts_Sensor_Calibration_Error": "探头校准错误",

  "Alerts_Sensor_Failure": "血糖探头失败",
  "Alerts_Sensor_Calibration_Reminder": "探头校准提醒",
  "Alerts_Meter_BG_Now": "立即输入指尖血",
  "Alerts_Sensor_Exp_in_6_Hours": "探头6小时内过期",
  "Alerts_Sensor_Exp_in_2_Hours": "探头2小时内过期",
  "Alerts_Sensor_Exp_in_30_Min": "探头30分钟内过期",
  "Alerts_Sensor_Expired": "血糖探头过期",
  "Alerts_Rapid_Rise": "上升快",
  "Alerts_Rapid_Fall": "下降低",
  "Alerts_High_Predicted": "预期血糖高",
  "Alerts_Low_Predicted": "预期血糖低",
  "Alerts_High_Glucose": "血糖高",
  "Alerts_Low_Glucose": "血糖低",
  "Alerts_Below_3.1_mmol/L": "低于3.1mmol/L",
  "Alerts_Transmitter_Battery_Low_2": "发射器电量低",

  "Alerts_PDM_Battery_Low": "手持机电量低",
  "Alerts_Replace_Battery": "手持机立即充电",

  "Alert": "告警",
  "Alerts": "告警",
  "Alert Filter": "Alert Filter",
  "PDM": "PDM",
  "Pump": "泵",

  "alert_Time": "时间",
  "alert_Type": "类型",

  "Out Of Range": "超出范围",

  "t1221_Auto_Mode": "自动模式总结",
  "t1221_Time_in_Auto_Mode": "自动模式时长",
  "t1221_Average_SG_SD": "平均血糖±标准差",
  "t1221_Time_in_Target_Range": "目标血糖比例",
  "t1221_Time_above_Range": "高血糖比例",
  "t1221_Time_below_Range": "低血糖比例",
  "t1221_Auto_Basal_per_day": "自动基础量(每天)",
  "t1221_Auto_Bolus_per_day": "自动大剂量(每天)",
  "t1221_Auto_Mode_Exits": "自动模式退出",
  "t1221_No_Sensor_readings": "无血糖读数",
  "t1221_Max_Delivery": "最大输注",
  "t1221_Min_Delivery": "最小输注",

  "t1222_autoModeBasal": "自动模式基础量",
  "t1222_autoModeCorrBolus": "自动模式校正大剂量",
  "t1222_autoSnack": "自动零食",
  "t1222_autoBreakfast": "自动早餐",
  "t1222_autoLunch": "自动午餐",
  "t1222_autoDinner": "自动晚餐",
  "t1222_autoExercise": "自动运动",
  "t1222_Snack": "零食",
  "t1222_auto_basal": "自动基础量",
  "t1222_auto_bolus": "自动大剂量",
  "t1222_Auto_Mode": "自动模式",
  "t1222_Time_in_Auto_Mode": "自动模式时长",
  "t1222_Avg_SD": "平均值(mmol/L)±标准差",
  "t1222_Target_Range": "目标血糖次数",
  "t1222_Above_Range": "高血糖次数",
  "t1222_Below_Range": "低血糖次数",
  "t1222_Auto_Mode_Exits": "自动模式退出次数",

  "t0805_User_Management": "用户管理",
  "t0805_Patient_Management": "患者管理",
  "t0805_Operation_History": "操作历史",
  "t0805_User_List": "用户列表",
  "t0805_User": "用户",
  "t0805_Time": "时间",
  "t0805_Operation_Type": "操作类型",
  "t0805_Back": "返回",
  "t0805_Add": "增加",
  "t0805_Delete": "删除",
  "t0809_Add_User": "添加用户",
  "t1028_Pattern_C": "程序C",
  "t1028_Pattern_D": "程序D",
  "t1029_Auto_meal_bolus": "自动餐食大剂量",
  "t1029_Auto_mode_correction_bolus": "自动模式校正大剂量",
  "t1029_Sick": "生病",
  "t1029_Auto_Mode_Feature": "自动模式功能",
  "t1029_Target_SG": "目标血糖",
  "t1029_Auto_Meal_Handling": "自动餐食调整",
  "t1029_Total_Daily_Dose": "每日输注总量",
  "t1029_Pump_Light": "泵控制器灯",
  "t1029_Alerts_for_Hypo": "低血糖报警",
  "t1102_Out_of_Range": "泵通信超过范围",
  "t1102_Command_Reminder": "命令提醒",
  "t1102_Alarms_Alerts_on_APP": "贴片泵报警",
  "t1102_Alarms_on_App": "APP中高优先级报警",
  "t1102_Alerts_on_App": "APP低优先级报警",
  "t1102_Factory_Calibration": "免校准",
  "t1102_Alerts_for_Low": "血糖低报警",
  "t1102_Alerts_for_High": "血糖高报警",
  "t1102_Alerts_for_Others": "其他报警",
  "t1102_Adjustment": "调整",
  "t1102_Suggested": "建议输注值",
  "t1103_Glucose": "血糖",
  "t1103_CGM": "动态血糖",
  "t1103_Insulin": "胰岛素",
  "t1103_Carbs": "食物",
  "t1103_Exercise": "运动",
  "t1103_Min_Max": "最小值/最大值",
  "t1103_Target_Range": "目标范围",
  "t1103_Overall_Tine_In_Range": "总计: 时间范围",
  "t1103_Basal": "基础量",
  "t1103_Bolus": "大剂量",
  "t1103_Basal_Bolus": "基础量&大剂量",
  "t1103_Auto_Mode_Time_In_Range": "自动模式: 时间范围",
  "t1103_Time_below_range": "低血糖比例",
  "t1103_Time_above_range": "高血糖比例",
  "t1103_Time_in_target_range": "目标血糖比例",
  "t1103_Incorrect_Password": "密码输入错误，还剩$1次尝试机会，请确认登录密码是否正确。",
  "t1103_Incorrect_locked": "密码错误次数超过限制，账户已被锁定，请$1分钟后再试。",
  "t1104_The_data_is_from": "数据来源于EasySense移动应用程序或EasyPatch移动应用程序",
  "t1104_Privacy_Policy": "隐私政策和服务协定",
  "t1104_updated_privacy_policy": "我们最近更新了隐私政策和服务协定。请仔细阅读，同意并接受全部条款后再使用EasyView。",
  "t1104_Disagree": "不同意",
  "t1104_Agree": "同意",
  "t1105_Upload_History": "上传历史",
  "t1105_Delete_Data": "删除数据",
  "t1105_Target_Range": "目标范围",
  "t1105_request_to_view_your_data": "$1请求查看您的数据。",
  "t1105_Recent_Updates": "最近更新",
  "t1108_No_data": "无数据",
  "t1108_Pump_Bash_SN": "泵体控制器序列号",
  "t1108_Transmitter_SN": "发射器序列号",
  "t1112_Normal_Glucose": "正常血糖",
  "t1112_Manual_Bolus_or_Modified_Bolus": "手动大剂量或修改过的大剂量",
  "t1112_Auto_Mode_Started": "自动模式开始",
  "t1112_Auto_Mode_Exit": "自动模式退出",
  "t1112_Normal_Bolus": "正常大剂量",
  "t1112_Extended_Bolus": "扩展大剂量",
  "t1112_Combo_Bolus": "组合大剂量",
  "t1112_Carbs": "碳水化合物量",
  "t1112_Glucose": "血糖",
  "t1112_BG": "指尖血糖",
  "t1112_Audio": "声音",
  "t1112_Tone": "告警声音",
  "t1112_Audio_Options": "声音选项",
  "t1112_Weight_Unit": "体重单位",
  "t1112_Height_Unit": "身高单位",
  "t1112_Not_available": "无法使用",
  "t1112_Number": "序号",
  "t1112_days": "天数",
  "t1112_min": "分钟",
  "t1113_days": "天",
  "t1215_Security": "安全",
  "t1215_MFA": "多重身份验证",
  "t1215_Enter_verification_code": "输入验证码",
  "t1215_Multi_factor_ON": "多重身份认证已开启。验证码已发送至 $1， 请提交验证码。",
  "t1215_Verification_code_incorrect": "验证码错误",
  "t1215_Show_Glucose_Value": "显示血糖值",
  "t1221_enter_verification_code": "请输入发送到$1的6位验证码。",
  "t1221_Verification_Success": "验证成功",
  "t1222_We_will_only_process": "未获得您的同意，我们不会通过Medtrum应用程序或网站处理您的医疗数据。",
  "t1222_If_you_are_under_years": "未满16周岁的未成年人必须获得父母或者监护人的同意才可以注册账号。",
  "t1221_register_cn": "你有权利选择不上传任何设备数据到应用程序，在此情况下，其他人无法访问数据。如果选择不注册Medtrum账号登录应用程序/网站，您的医疗数据只记录并保存在设备中。",
  "t1221_register_eu": "如果您选择注册Medtrum账户并使用账户访问Medtrum的应用程序，该应用程序上记录的医疗数据将被上传至Medtrum在欧洲的服务器，并保存2年。你有权利选择不上传任何设备数据到应用程序，在此情况下，其他人无法访问数据。如果选择不注册Medtrum账号登录应用程序/网站，您的医疗数据只记录并保存在设备中。",
  "t1221_register_follow": "未获得您的同意，我们不会通过Medtrum 应用程序或网站处理您的医疗数据。",
  "t1222_Terms_of_Use": "移宇科技的使用条款",
  "t1222_Privacy_Policy": "移宇科技的隐私政策",
  "t1222_Create_Account": "创建账号",
  "t1222_Back": "返回",
  "t1222_Verify_your_account": "验证您的账号",
  "t1222_please_check_your_account": "我们将会把验证码发送到$1，请检查您的账号。",
  "t1222_I_Agree_to": "我同意$1",
  "t1223_Invalid_Verification_Code": "无效的验证码，请重试。"
};

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Login_vue__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_verificationCode_vue__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_verificationCode_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_verificationCode_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LoginHCPAdmin_vue__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LoginHCPAdmin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_LoginHCPAdmin_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_LoginAccountAdmin_vue__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_LoginAccountAdmin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_LoginAccountAdmin_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_LoginHCPClinic_vue__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_LoginHCPClinic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_LoginHCPClinic_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_hcpLogin_vue__ = __webpack_require__(1351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_hcpLogin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_hcpLogin_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PatientList_vue__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PatientList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_PatientList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_HcpMenu_vue__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_HcpMenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_HcpMenu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_HcpUserManagement_vue__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_HcpUserManagement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_HcpUserManagement_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_profile_templates_HcpGroupUserInfo_vue__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_profile_templates_HcpGroupUserInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_profile_templates_HcpGroupUserInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_HcpOperationHistory_vue__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_HcpOperationHistory_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_HcpOperationHistory_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_profile_templates_HcpAddUser_vue__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_profile_templates_HcpAddUser_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_profile_templates_HcpAddUser_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ClinicPatientList_vue__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ClinicPatientList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_ClinicPatientList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Sign_vue__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Sign_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Sign_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_hcpSign_vue__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_hcpSign_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_hcpSign_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_HCP_vue__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_HCP_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_HCP_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ClinicHCP_vue__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ClinicHCP_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_ClinicHCP_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_newPatient_vue__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_newPatient_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_newPatient_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_findPatient_vue__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_findPatient_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_findPatient_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_updatePassword_vue__ = __webpack_require__(1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_updatePassword_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_updatePassword_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_personalApply_vue__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_personalApply_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_personalApply_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_common_template_Header_vue__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_common_template_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_common_template_Header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_common_template_Footer_vue__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_common_template_Footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_common_template_Footer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_common_template_AccountAdminHeader_vue__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_common_template_AccountAdminHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_common_template_AccountAdminHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_common_template_AccountAdminFooter_vue__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_common_template_AccountAdminFooter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_common_template_AccountAdminFooter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_common_template_Signheader_vue__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_common_template_Signheader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_common_template_Signheader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_common_template_Signfooter_vue__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_common_template_Signfooter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_common_template_Signfooter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_common_template_HCPHeader_vue__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_common_template_HCPHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_common_template_HCPHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_common_template_CreateHCPHeader_vue__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_common_template_CreateHCPHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_common_template_CreateHCPHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_AccountAdmin_AccountAdminSuper_vue__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_AccountAdmin_AccountAdminSuper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_AccountAdmin_AccountAdminSuper_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_AccountAdmin_AccountAdminHome_vue__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_AccountAdmin_AccountAdminHome_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_AccountAdmin_AccountAdminHome_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_AccountAdmin_AccountAdminList_vue__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_AccountAdmin_AccountAdminList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_AccountAdmin_AccountAdminList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_AccountAdmin_dataStatistics_vue__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_AccountAdmin_dataStatistics_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_AccountAdmin_dataStatistics_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_AccountAdmin_dataSTS_HCLprint_vue__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_AccountAdmin_dataSTS_HCLprint_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_AccountAdmin_dataSTS_HCLprint_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_AccountAdmin_UserAdmin_vue__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_AccountAdmin_UserAdmin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_AccountAdmin_UserAdmin_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_AccountAdmin_DevDebug_vue__ = __webpack_require__(1315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_AccountAdmin_DevDebug_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_AccountAdmin_DevDebug_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_AccountAdmin_AccountAdminAdd_vue__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_AccountAdmin_AccountAdminAdd_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_AccountAdmin_AccountAdminAdd_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_AccountAdmin_AccountAdminSuperAdd_vue__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_AccountAdmin_AccountAdminSuperAdd_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_AccountAdmin_AccountAdminSuperAdd_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_AccountAdmin_AccountAdminMainHeader_vue__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_AccountAdmin_AccountAdminMainHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_AccountAdmin_AccountAdminMainHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_AccountAdmin_AccountAdminMainFooter_vue__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_AccountAdmin_AccountAdminMainFooter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_AccountAdmin_AccountAdminMainFooter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_AccountAdmin_BasicQuantityRecord_vue__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_AccountAdmin_BasicQuantityRecord_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_AccountAdmin_BasicQuantityRecord_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_charts_vue__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_charts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_charts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_home_template_chart0_vue__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_home_template_chart0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_home_template_chart0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_home_template_chart1_vue__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_home_template_chart1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_home_template_chart1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_home_template_chart2_2_vue__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_home_template_chart2_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_home_template_chart2_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_home_template_chart3_vue__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_home_template_chart3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_home_template_chart3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_home_template_chart4_vue__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_home_template_chart4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_home_template_chart4_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_home_template_chart5_2_vue__ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_home_template_chart5_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_home_template_chart5_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_home_template_chart6_vue__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_home_template_chart6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_home_template_chart6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_home_template_chart7_vue__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_home_template_chart7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__components_home_template_chart7_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_home_template_chart8_vue__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_home_template_chart8_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__components_home_template_chart8_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_home_template_chart9_vue__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_home_template_chart9_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__components_home_template_chart9_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_home_template_refresh_vue__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_home_template_refresh_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__components_home_template_refresh_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_chartSetting_vue__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_chartSetting_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__components_chartSetting_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_home_template_setting_vue__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_home_template_setting_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__components_home_template_setting_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_home_template_dateView_vue__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_home_template_dateView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__components_home_template_dateView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_home_template_dateView2_vue__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_home_template_dateView2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__components_home_template_dateView2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_monitor_vue__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_monitor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__components_monitor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_events_vue__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_events_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__components_events_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_records_vue__ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_records_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__components_records_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_print_vue__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_print_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__components_print_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_ClinicExportData_vue__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_ClinicExportData_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__components_ClinicExportData_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_profile_templates_patientProfile_edit_vue__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_profile_templates_patientProfile_edit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__components_profile_templates_patientProfile_edit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_profile_templates_patientProfile_noEdit_vue__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_profile_templates_patientProfile_noEdit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__components_profile_templates_patientProfile_noEdit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_profile_templates_patientProfile_carer_vue__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_profile_templates_patientProfile_carer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__components_profile_templates_patientProfile_carer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_profile_templates_messages_vue__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_profile_templates_messages_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__components_profile_templates_messages_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_profile_templates_profile_patient_vue__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_profile_templates_profile_patient_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__components_profile_templates_profile_patient_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_profile_templates_create_hcp_vue__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_profile_templates_create_hcp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__components_profile_templates_create_hcp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_profile_templates_recent_updates_vue__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_profile_templates_recent_updates_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__components_profile_templates_recent_updates_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_profile_templates_changePassword_vue__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_profile_templates_changePassword_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__components_profile_templates_changePassword_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_care_templates_carer_connect_vue__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_care_templates_carer_connect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__components_care_templates_carer_connect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_care_templates_addConnect_vue__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_care_templates_addConnect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__components_care_templates_addConnect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_care_templates_patient_connect_vue__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_care_templates_patient_connect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__components_care_templates_patient_connect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_print_htmplate_chart0_print_vue__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_print_htmplate_chart0_print_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__components_print_htmplate_chart0_print_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_print_htmplate_chart1_print_vue__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_print_htmplate_chart1_print_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__components_print_htmplate_chart1_print_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_print_htmplate_chart2_print_vue__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_print_htmplate_chart2_print_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__components_print_htmplate_chart2_print_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_print_htmplate_chart3_print_vue__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_print_htmplate_chart3_print_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__components_print_htmplate_chart3_print_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_print_htmplate_chart4_print_vue__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_print_htmplate_chart4_print_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77__components_print_htmplate_chart4_print_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_print_htmplate_chart5_print_vue__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_print_htmplate_chart5_print_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__components_print_htmplate_chart5_print_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_print_htmplate_chart6_print_vue__ = __webpack_require__(1377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_print_htmplate_chart6_print_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__components_print_htmplate_chart6_print_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_print_htmplate_chart6_print2_vue__ = __webpack_require__(1378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_print_htmplate_chart6_print2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__components_print_htmplate_chart6_print2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_print_htmplate_chart7_print_vue__ = __webpack_require__(1379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_print_htmplate_chart7_print_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81__components_print_htmplate_chart7_print_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_print_htmplate_alerts_print_vue__ = __webpack_require__(1370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_print_htmplate_alerts_print_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82__components_print_htmplate_alerts_print_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_print_htmplate_events_print1_vue__ = __webpack_require__(1380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_print_htmplate_events_print1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83__components_print_htmplate_events_print1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_print_htmplate_record_print_vue__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_print_htmplate_record_print_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84__components_print_htmplate_record_print_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_print_htmplate_quickPrint1_vue__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_print_htmplate_quickPrint1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85__components_print_htmplate_quickPrint1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__components_print_htmplate_quickPrint2_vue__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__components_print_htmplate_quickPrint2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86__components_print_htmplate_quickPrint2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__components_print_htmplate_quickPrint3_vue__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__components_print_htmplate_quickPrint3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87__components_print_htmplate_quickPrint3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__components_print_htmplate_quickPrint4_vue__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__components_print_htmplate_quickPrint4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88__components_print_htmplate_quickPrint4_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__components_print_htmplate_quickPrint5_vue__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__components_print_htmplate_quickPrint5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89__components_print_htmplate_quickPrint5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__components_print_htmplate_quickPrint6_vue__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__components_print_htmplate_quickPrint6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90__components_print_htmplate_quickPrint6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__components_print_htmplate_quickPrint7_vue__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__components_print_htmplate_quickPrint7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91__components_print_htmplate_quickPrint7_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__components_print_htmplate_quickPrint8_vue__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__components_print_htmplate_quickPrint8_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92__components_print_htmplate_quickPrint8_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__components_print_htmplate_quickPrint9_vue__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__components_print_htmplate_quickPrint9_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93__components_print_htmplate_quickPrint9_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__components_print_htmplate_quickPrint10_vue__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__components_print_htmplate_quickPrint10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94__components_print_htmplate_quickPrint10_vue__);












































































































var paths = '/path';

var routes = [{
  path: '/',
  redirect: '/login'
}, {
  path: '/login',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_0__components_Login_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_21__components_common_template_Header_vue___default.a,
    footer: __WEBPACK_IMPORTED_MODULE_22__components_common_template_Footer_vue___default.a
  }
}, {
  path: '/verificationCode',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_1__components_verificationCode_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_21__components_common_template_Header_vue___default.a,
    footer: __WEBPACK_IMPORTED_MODULE_22__components_common_template_Footer_vue___default.a
  }
}, {
  path: '/accountsmanagement',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_2__components_LoginHCPAdmin_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_21__components_common_template_Header_vue___default.a,
    footer: __WEBPACK_IMPORTED_MODULE_22__components_common_template_Footer_vue___default.a
  }
}, {
  path: '/managementtools',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_3__components_LoginAccountAdmin_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_23__components_common_template_AccountAdminHeader_vue___default.a,
    footer: __WEBPACK_IMPORTED_MODULE_24__components_common_template_AccountAdminFooter_vue___default.a
  }
}, {
  path: '/accountsadmin_super',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_29__components_AccountAdmin_AccountAdminSuper_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_38__components_AccountAdmin_AccountAdminMainHeader_vue___default.a,
    footer: __WEBPACK_IMPORTED_MODULE_39__components_AccountAdmin_AccountAdminMainFooter_vue___default.a
  }
}, {
  path: '/accountsadmin_home',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_30__components_AccountAdmin_AccountAdminHome_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_38__components_AccountAdmin_AccountAdminMainHeader_vue___default.a,
    footer: __WEBPACK_IMPORTED_MODULE_39__components_AccountAdmin_AccountAdminMainFooter_vue___default.a
  }
}, {
  path: '/accountsadmin_add',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_36__components_AccountAdmin_AccountAdminAdd_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_38__components_AccountAdmin_AccountAdminMainHeader_vue___default.a,
    footer: __WEBPACK_IMPORTED_MODULE_39__components_AccountAdmin_AccountAdminMainFooter_vue___default.a
  }
}, {
  path: '/accountsadmin_list',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_31__components_AccountAdmin_AccountAdminList_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_38__components_AccountAdmin_AccountAdminMainHeader_vue___default.a,
    footer: __WEBPACK_IMPORTED_MODULE_39__components_AccountAdmin_AccountAdminMainFooter_vue___default.a
  }
}, {
  path: '/dataStatistics',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_32__components_AccountAdmin_dataStatistics_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_38__components_AccountAdmin_AccountAdminMainHeader_vue___default.a,
    footer: __WEBPACK_IMPORTED_MODULE_39__components_AccountAdmin_AccountAdminMainFooter_vue___default.a
  }
}, {
  path: '/HCLprint',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_33__components_AccountAdmin_dataSTS_HCLprint_vue___default.a
  }
}, {
  path: '/UserAdmin',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_34__components_AccountAdmin_UserAdmin_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_38__components_AccountAdmin_AccountAdminMainHeader_vue___default.a,
    footer: __WEBPACK_IMPORTED_MODULE_39__components_AccountAdmin_AccountAdminMainFooter_vue___default.a
  }
}, {
  path: '/History',
  components: {
    default: function _default() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1572));
    },
    header: __WEBPACK_IMPORTED_MODULE_38__components_AccountAdmin_AccountAdminMainHeader_vue___default.a,
    footer: __WEBPACK_IMPORTED_MODULE_39__components_AccountAdmin_AccountAdminMainFooter_vue___default.a
  }
}, {
  path: '/Member',
  components: {
    default: function _default() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1571));
    },
    header: __WEBPACK_IMPORTED_MODULE_38__components_AccountAdmin_AccountAdminMainHeader_vue___default.a,
    footer: __WEBPACK_IMPORTED_MODULE_39__components_AccountAdmin_AccountAdminMainFooter_vue___default.a
  }
}, {
  path: '/DevDebug',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_35__components_AccountAdmin_DevDebug_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_38__components_AccountAdmin_AccountAdminMainHeader_vue___default.a,
    footer: __WEBPACK_IMPORTED_MODULE_39__components_AccountAdmin_AccountAdminMainFooter_vue___default.a
  }
}, {
  path: '/BasicQuantityRecord',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_40__components_AccountAdmin_BasicQuantityRecord_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_38__components_AccountAdmin_AccountAdminMainHeader_vue___default.a,
    footer: __WEBPACK_IMPORTED_MODULE_39__components_AccountAdmin_AccountAdminMainFooter_vue___default.a
  }
}, {
  path: '/CreateHCP_list',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_67__components_profile_templates_create_hcp_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_38__components_AccountAdmin_AccountAdminMainHeader_vue___default.a,
    footer: __WEBPACK_IMPORTED_MODULE_39__components_AccountAdmin_AccountAdminMainFooter_vue___default.a
  }
}, {
  path: '/accountsadmin_super_add',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_37__components_AccountAdmin_AccountAdminSuperAdd_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_38__components_AccountAdmin_AccountAdminMainHeader_vue___default.a,
    footer: __WEBPACK_IMPORTED_MODULE_39__components_AccountAdmin_AccountAdminMainFooter_vue___default.a
  }
}, {
  path: '/clinic',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_4__components_LoginHCPClinic_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_21__components_common_template_Header_vue___default.a,
    footer: __WEBPACK_IMPORTED_MODULE_22__components_common_template_Footer_vue___default.a
  }
}, {
  path: '/hcpLogin',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_5__components_hcpLogin_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_21__components_common_template_Header_vue___default.a,
    footer: __WEBPACK_IMPORTED_MODULE_22__components_common_template_Footer_vue___default.a
  }
}, {
  path: '/sign',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_13__components_Sign_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_25__components_common_template_Signheader_vue___default.a,
    footer: __WEBPACK_IMPORTED_MODULE_26__components_common_template_Signfooter_vue___default.a
  }
}, {
  path: '/hcpSign',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_14__components_hcpSign_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_25__components_common_template_Signheader_vue___default.a,
    footer: __WEBPACK_IMPORTED_MODULE_26__components_common_template_Signfooter_vue___default.a
  }
}, {
  path: '/personalApply',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_20__components_personalApply_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_25__components_common_template_Signheader_vue___default.a,
    footer: __WEBPACK_IMPORTED_MODULE_26__components_common_template_Signfooter_vue___default.a
  }
}, {
  path: '/updatePassword',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_19__components_updatePassword_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_25__components_common_template_Signheader_vue___default.a,
    footer: __WEBPACK_IMPORTED_MODULE_22__components_common_template_Footer_vue___default.a
  }
}, {
  path: '/PatientList',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_6__components_PatientList_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_27__components_common_template_HCPHeader_vue___default.a
  }
}, {
  path: '/HcpMenu',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_7__components_HcpMenu_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_27__components_common_template_HCPHeader_vue___default.a
  }
}, {
  path: '/HcpUserManagement',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_8__components_HcpUserManagement_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_27__components_common_template_HCPHeader_vue___default.a
  }
}, {
  path: '/HcpGroupUserInfo',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_9__components_profile_templates_HcpGroupUserInfo_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_27__components_common_template_HCPHeader_vue___default.a
  }
}, {
  path: '/HcpOperationHistory',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_10__components_HcpOperationHistory_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_27__components_common_template_HCPHeader_vue___default.a
  }
}, {
  path: '/HcpAddUser',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_11__components_profile_templates_HcpAddUser_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_27__components_common_template_HCPHeader_vue___default.a
  }
}, {
  path: '/ClinicPatientList',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_12__components_ClinicPatientList_vue___default.a,

    header: __WEBPACK_IMPORTED_MODULE_28__components_common_template_CreateHCPHeader_vue___default.a
  }
}, {
  path: '/newPatient',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_17__components_newPatient_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_27__components_common_template_HCPHeader_vue___default.a
  }
}, {
  path: '/findPatient',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_18__components_findPatient_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_27__components_common_template_HCPHeader_vue___default.a
  }
}, {
  path: '/ClinicHcp',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_16__components_ClinicHCP_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_28__components_common_template_CreateHCPHeader_vue___default.a
  },
  children: [{ path: '/ClinicExportData',
    component: __WEBPACK_IMPORTED_MODULE_61__components_ClinicExportData_vue___default.a
  }, { path: '/clinic_patientProfile2',
    component: __WEBPACK_IMPORTED_MODULE_63__components_profile_templates_patientProfile_noEdit_vue___default.a
  }]
}, {
  path: '/Hcp',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_15__components_HCP_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_27__components_common_template_HCPHeader_vue___default.a
  },
  children: [{ path: '/charts',
    component: __WEBPACK_IMPORTED_MODULE_41__components_charts_vue___default.a,
    children: [{ path: '/chart0', component: __WEBPACK_IMPORTED_MODULE_42__components_home_template_chart0_vue___default.a }, { path: '/chart1', component: __WEBPACK_IMPORTED_MODULE_43__components_home_template_chart1_vue___default.a }, { path: '/chart2', component: __WEBPACK_IMPORTED_MODULE_44__components_home_template_chart2_2_vue___default.a }, { path: '/chart3', component: __WEBPACK_IMPORTED_MODULE_45__components_home_template_chart3_vue___default.a }, { path: '/chart4', component: __WEBPACK_IMPORTED_MODULE_46__components_home_template_chart4_vue___default.a }, { path: '/chart5', component: __WEBPACK_IMPORTED_MODULE_47__components_home_template_chart5_2_vue___default.a }, { path: '/chart6', component: __WEBPACK_IMPORTED_MODULE_48__components_home_template_chart6_vue___default.a }, { path: '/chart7', component: __WEBPACK_IMPORTED_MODULE_49__components_home_template_chart7_vue___default.a }, { path: '/chart8', component: __WEBPACK_IMPORTED_MODULE_50__components_home_template_chart8_vue___default.a }, { path: '/chart9', component: __WEBPACK_IMPORTED_MODULE_51__components_home_template_chart9_vue___default.a }]
  }, { path: '/chartSetting',
    component: __WEBPACK_IMPORTED_MODULE_53__components_chartSetting_vue___default.a,
    children: [{ path: '/setting', component: __WEBPACK_IMPORTED_MODULE_54__components_home_template_setting_vue___default.a }, { path: '/dateView', component: __WEBPACK_IMPORTED_MODULE_55__components_home_template_dateView_vue___default.a }, { path: '/dateView2', component: __WEBPACK_IMPORTED_MODULE_56__components_home_template_dateView2_vue___default.a }]
  }, { path: '/monitor',
    component: __WEBPACK_IMPORTED_MODULE_57__components_monitor_vue___default.a
  }, { path: '/events',
    component: __WEBPACK_IMPORTED_MODULE_58__components_events_vue___default.a
  }, { path: '/records',
    component: __WEBPACK_IMPORTED_MODULE_59__components_records_vue___default.a
  }, { path: '/print',
    component: __WEBPACK_IMPORTED_MODULE_60__components_print_vue___default.a
  }, { path: '/patientProfile',
    component: __WEBPACK_IMPORTED_MODULE_62__components_profile_templates_patientProfile_edit_vue___default.a
  }, { path: '/patientProfile2',
    component: __WEBPACK_IMPORTED_MODULE_63__components_profile_templates_patientProfile_noEdit_vue___default.a
  }, { path: '/patientProfile3',
    component: __WEBPACK_IMPORTED_MODULE_64__components_profile_templates_patientProfile_carer_vue___default.a
  }]
}, {
  path: '/carerConnection',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_70__components_care_templates_carer_connect_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_27__components_common_template_HCPHeader_vue___default.a
  }
}, {
  path: '/addConnection',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_71__components_care_templates_addConnect_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_27__components_common_template_HCPHeader_vue___default.a
  }
}, {
  path: '/connection',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_72__components_care_templates_patient_connect_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_27__components_common_template_HCPHeader_vue___default.a
  }
}, {
  path: '/messages',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_65__components_profile_templates_messages_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_27__components_common_template_HCPHeader_vue___default.a
  }
}, {
  path: '/Profile1',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_66__components_profile_templates_profile_patient_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_27__components_common_template_HCPHeader_vue___default.a
  }
}, {
  path: '/CreateHCP',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_67__components_profile_templates_create_hcp_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_28__components_common_template_CreateHCPHeader_vue___default.a
  }
}, {
  path: '/recent-updates',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_68__components_profile_templates_recent_updates_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_27__components_common_template_HCPHeader_vue___default.a
  }
}, {
  path: '/changePassword',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_69__components_profile_templates_changePassword_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_27__components_common_template_HCPHeader_vue___default.a
  }
}, {
  path: '/chart0-print',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_73__components_print_htmplate_chart0_print_vue___default.a
  }
}, {
  path: '/chart1-print',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_74__components_print_htmplate_chart1_print_vue___default.a
  }
}, {
  path: '/chart2-print',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_75__components_print_htmplate_chart2_print_vue___default.a
  }
}, {
  path: '/chart3-print',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_76__components_print_htmplate_chart3_print_vue___default.a
  }
}, {
  path: '/chart4-print',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_77__components_print_htmplate_chart4_print_vue___default.a
  }
}, {
  path: '/chart5-print',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_78__components_print_htmplate_chart5_print_vue___default.a
  }
}, {
  path: '/chart6-print',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_79__components_print_htmplate_chart6_print_vue___default.a
  }
}, {
  path: '/chart6-print2',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_80__components_print_htmplate_chart6_print2_vue___default.a
  }
}, {
  path: '/chart7-print',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_81__components_print_htmplate_chart7_print_vue___default.a
  }
}, {
  path: '/events-print1',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_83__components_print_htmplate_events_print1_vue___default.a
  }
}, {
  path: '/chart9-print',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_82__components_print_htmplate_alerts_print_vue___default.a
  }
}, {
  path: '/record-print',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_84__components_print_htmplate_record_print_vue___default.a
  }
}, {
  path: '/quickPrint1',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_85__components_print_htmplate_quickPrint1_vue___default.a
  }
}, {
  path: '/quickPrint2',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_86__components_print_htmplate_quickPrint2_vue___default.a
  }
}, {
  path: '/quickPrint3',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_87__components_print_htmplate_quickPrint3_vue___default.a
  }
}, {
  path: '/quickPrint4',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_88__components_print_htmplate_quickPrint4_vue___default.a
  }
}, {
  path: '/quickPrint5',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_89__components_print_htmplate_quickPrint5_vue___default.a
  }
}, {
  path: '/quickPrint6',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_90__components_print_htmplate_quickPrint6_vue___default.a
  }
}, {
  path: '/quickPrint7',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_91__components_print_htmplate_quickPrint7_vue___default.a
  }
}, {
  path: '/quickPrint8',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_92__components_print_htmplate_quickPrint8_vue___default.a
  }
}, {
  path: '/quickPrint9',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_93__components_print_htmplate_quickPrint9_vue___default.a
  }
}, {
  path: '/quickPrint10',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_94__components_print_htmplate_quickPrint10_vue___default.a
  }
}, {
  path: '/refresh',
  components: {
    default: __WEBPACK_IMPORTED_MODULE_52__components_home_template_refresh_vue___default.a,
    header: __WEBPACK_IMPORTED_MODULE_27__components_common_template_HCPHeader_vue___default.a
  }
}, {
  path: '/updating',
  components: {
    default: function _default() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1574));
    }
  }
}, {
  path: '/error',
  components: {
    default: function _default() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1573));
    }
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 579 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 580 */,
/* 581 */,
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(635),
  /* template */
  __webpack_require__(1431),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  computed: {
    key: function key() {
      return this.$route.name !== undefined ? this.$route.name + new Date() : this.$route + new Date();
    }
  }
});

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      account: '',
      remake: '',
      deviceSN: '',
      remark: '',
      version: '',
      deviceId: '',
      addBtnTitle: 'Add',
      checkInfo: [{
        check: false,
        text: 'EasyPatch Login Account management',
        permission: 'EasyPatchLogin'
      }, {
        check: false,
        text: 'HCP Account management',
        permission: 'HCPCreate'
      }, {
        check: false,
        text: 'Software upgrade product SN management',
        permission: 'FirmwareUpdateConfig'
      }, {
        check: false,
        text: 'HCL Function management -PDM',
        permission: 'HCLConfig'
      }, {
        check: false,
        text: 'HCL Function management -EasyPatch',
        permission: 'HCLConfigForEasyPatch'
      }, {
        check: false,
        text: 'EasyUpdate account management',
        permission: 'EasyUpdateLogin'
      }, {
        check: false,
        text: 'Accounts',
        permission: 'Accounts'
      }],
      checkInfo2: [],
      permission: '',
      title: ''
    };
  },

  computed: {},
  watch: {},
  mounted: function mounted() {
    var permission = sessionStorage.getItem('account_admin_permission_value');
    var title = sessionStorage.getItem('account_admin_permission_title');
    this.permission = permission;
    this.title = title;
  },

  methods: {
    addPatchAccount: function addPatchAccount() {
      this.$http.post('/api/v2.1/account_manage/add', {
        data: [{
          account: this.account,
          param: {
            remark: this.remake
          }
        }],
        role: this.permission,
        permission: this.permission
      }).then(function (res) {
        var error = res.body.error;
        if (error) {
          if (2 == error) {
            this.$message.error('Account is not found.');
          } else {
            this.$message.error('code:' + error);
          }
        } else {
          var result = res.body.result;
          if (result) {
            var resError = result[0].error;
            if (resError) {
              if (2 == resError) {
                this.$message.error('Account is not found.');
              } else {
                this.$message.error('code:' + resError);
              }

              return;
            }
          }

          this.$message({
            type: 'success',
            message: 'Account created successfully.'
          });
          this.$router.push('/accountsadmin_list');
        }
      }, function (err) {});
    },
    addFirmwareUpdateConfig: function addFirmwareUpdateConfig() {
      this.$http.post('/api/v2.1/account_manage/add', {
        data: [{
          deviceSN: this.deviceSN,
          deviceId: this.deviceId,
          version: this.version
        }],
        role: this.permission,
        permission: this.permission
      }).then(function (res) {
        var error = res.body.error;

        if (error) {
          this.$message.error('code:' + error);
        } else {
          this.$message({
            type: 'success',
            message: 'Success'
          });
          this.$router.push('/accountsadmin_list');
        }
      }, function (err) {});
    },
    checkSNFormat: function checkSNFormat(sn) {
      var flag = false;

      if (/^[\d]{9}$/.test(sn)) {
        var value = parseInt(sn);
        if (100000000 <= value && value <= 109999999) {
          flag = true;
        }
      } else if (/^[\da-fA-F]{8}$/.test(sn)) {
        flag = true;
      }
      return flag;
    },
    addAccount: function addAccount() {

      if ('EasyPatchLogin' == this.permission || 'EasyUpdateLogin' == this.permission || 'HCLConfig' == this.permission || 'HCLConfigForEasyPatch' == this.permission) {
        if (!this.account) {
          this.$message({
            type: 'warning',
            message: 'empty'
          });
          return;
        }
        if ('HCLConfig' == this.permission) {
          if (!this.checkSNFormat(this.account)) {
            this.$message({
              type: 'warning',
              message: 'SN error'
            });
            return;
          } else {
            this.account = this.account;
          }
        }
        if ('HCLConfigForEasyPatch' == this.permission) {
          this.account = this.account;
        }

        this.addPatchAccount();
      } else if ('FirmwareUpdateConfig' == this.permission) {
        if (!this.deviceSN || !this.deviceId || !this.version) {
          this.$message({
            type: 'warning',
            message: 'empty'
          });
          return;
        }

        if (!this.checkSNFormat(this.deviceSN)) {
          this.$message({
            type: 'warning',
            message: 'SN error'
          });
          return;
        } else {
          this.deviceSN = this.deviceSN;
        }

        this.addFirmwareUpdateConfig();
      }
    },
    navToHome: function navToHome() {
      this.$router.push('/accountsadmin_home');
    },
    navToList: function navToList() {
      this.$router.push('/accountsadmin_list');
    }
  }
});

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      'noData': true,
      permission: {},
      menuInfo: [{
        title: 'EasyPatch',
        bkColor: '#0c544f',
        imgUrl: "/static/accountadmin/icon_easypatch.png",
        permission: 'EasyPatchLogin'
      }, {
        title: 'EasyUpdate',
        bkColor: '#0c544f',
        imgUrl: "/static/accountadmin/icon_easypatch.png",
        permission: 'EasyUpdateLogin'
      }, {
        title: 'HCP',
        bkColor: '#335ea8',
        imgUrl: "/static/accountadmin/icon_hcp.png",
        permission: 'HCPCreate'
      }, {
        title: 'Software Upgrade',
        bkColor: '#ee7c58',
        imgUrl: "/static/accountadmin/icon_software.png",
        permission: 'FirmwareUpdateConfig'
      }, {
        title: 'HCL function -PDM',
        bkColor: '#5b7f70',
        imgUrl: "/static/accountadmin/icon_hcl_pdm.png",
        permission: 'HCLConfig'
      }, {
        title: 'HCL function -EasyPatch',
        bkColor: '#5b7f70',
        imgUrl: "/static/accountadmin/icon_hcl_easypatch.png",
        permission: 'HCLConfigForEasyPatch'
      }, {
        title: 'DataExport',
        bkColor: '#5b7f70',
        imgUrl: "/static/accountadmin/download.png",
        permission: 'DataExport'
      }, {
        title: 'FileUpload',
        bkColor: '#5b7f70',
        imgUrl: "/static/accountadmin/fileupload.png",
        permission: 'FileUpload'
      }, {
        title: 'Data statistics',
        bkColor: '#5b7f70',
        imgUrl: "/static/accountadmin/icon_hcl.png",
        permission: 'HCLStatistics'
      }, {
        title: 'User',
        bkColor: '#5b7f70',
        imgUrl: "/static/accountadmin/icon_user@2x.png",
        permission: 'UserAdmin'
      }, {
        title: 'DevDebug',
        bkColor: '#5b7f70',
        imgUrl: "/static/accountadmin/explain.png",
        permission: 'DevDebug'
      }, {
        title: 'Member',
        bkColor: '#5b7f70',
        imgUrl: "/static/accountadmin/icon_member.png",
        permission: 'Agency'
      }, {
        title: 'History',
        bkColor: '#5b7f70',
        imgUrl: "/static/accountadmin/icon_history.png",
        permission: 'History'
      }],
      menuInfo2: []
    };
  },

  computed: {},
  watch: {},
  mounted: function mounted() {
    this.loadData();
  },

  methods: {
    loadData: function loadData() {
      var permission = JSON.parse(sessionStorage.getItem('account_admin_permission'));
      var role = sessionStorage.getItem('role');
      var permissionFlag = {};
      var menuInfo = [];
      permission.map(function (e, i) {
        permissionFlag[e] = true;
      });
      if (role !== 'AgencyAccountAdmin') {
        permissionFlag.History = true;
      }

      this.menuInfo.map(function (e, i) {
        if (permissionFlag[e.permission]) {
          menuInfo.push(e);
        }
      });
      this.permission = permissionFlag;

      this.menuInfo2 = menuInfo;
    },
    addAccount: function addAccount() {},
    deleteAccount: function deleteAccount() {},
    clickMenu: function clickMenu(permission, title) {
      sessionStorage.setItem('account_admin_permission_value', permission);
      sessionStorage.setItem('account_admin_permission_title', title);
      if ('HCPCreate' == permission) {
        this.$router.push('/CreateHCP_list');
      } else if ('HCLStatistics' == permission) {
        this.$router.push('/dataStatistics');
      } else if ('UserAdmin' == permission) {
        this.$router.push('/UserAdmin');
      } else if ('DevDebug' == permission) {
        this.$router.push('/DevDebug');
      } else if ('Agency' == permission) {
        this.$router.push('/Member');
      } else if ('History' == permission) {
        this.$router.push('/History');
      } else {
        this.$router.push('/accountsadmin_list');
      }
    }
  }
});

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      source: [],
      noData: true,
      accounts: [],
      permission: '',
      title: '',
      addBtnTitle: 'Add',
      checked: false,
      currentPage: 1,
      pageSize: 11,
      totalPage: 1,
      textarea: '',
      fileList: [],
      filedList: []
    };
  },

  computed: {
    currentPageData: function currentPageData() {
      var pa = Math.ceil(this.accounts.length / this.pageSize);
      pa = pa == 0 ? 1 : pa;
      this.totalPage = pa;
      var begin = (this.currentPage - 1) * this.pageSize;
      var end = this.currentPage * this.pageSize;
      this.displayTab = false;
      return this.accounts.slice(begin, end);
    }
  },
  watch: {},
  mounted: function mounted() {
    var permission = sessionStorage.getItem('account_admin_permission_value');
    var title = sessionStorage.getItem('account_admin_permission_title');
    this.permission = permission;
    this.title = title;

    this.loadData();

    if ('EasyPatchLogin' == permission) {
      this.title = 'EasyPatch';
    } else if ('EasyUpdateLogin' == permission) {
      this.title = 'EasyUpdate';
    }
  },

  methods: {
    uploadFile: function uploadFile(file) {
      var _this = this;

      var fileData = new FormData();
      fileData.append('files' + file.file.name, file.file);
      var name = file.file.name;
      var ss = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.CancelToken.source();
      this.source.push({
        name: name,
        token: ss
      });
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'post',
        url: '/api/v2.1/admin/utils/file_upload',
        headers: { 'Content-Type': 'multipart/form-data;' },
        data: fileData,
        cancelToken: ss.token,
        onUploadProgress: function onUploadProgress(progressEvent) {
          var num = progressEvent.loaded / progressEvent.total * 100 | 0;
          file.onProgress({ percent: num });
        }
      }).then(function (res) {
        file.onSuccess();
      }).catch(function (err) {
        _this.$message.error('上传失败');
      });
    },
    submitUpload: function submitUpload() {
      this.$refs.uploadButton.submit();
    },
    progressA: function progressA(event, file) {},
    handleRemove: function handleRemove(file, fileList) {
      for (var i = 0; i < this.source.length; i++) {
        if (this.source[i].name === file.name) {
          this.source[i].token.cancel('取消上传');
        }
      }
      this.$refs.uploadButton.abort();
    },
    handleExceed: function handleExceed(files, fileList) {
      this.$message.warning('\u5F53\u524D\u9650\u5236\u9009\u62E9 20 \u4E2A\u6587\u4EF6\uFF0C\u672C\u6B21\u9009\u62E9\u4E86 ' + files.length + ' \u4E2A\u6587\u4EF6\uFF0C\u5171\u9009\u62E9\u4E86 ' + (files.length + fileList.length) + ' \u4E2A\u6587\u4EF6');
    },
    handleChange: function handleChange(file, fileList) {
      this.filedList = fileList;
    },
    download: function download() {
      var inputValue = this.textarea.replace(/\n/g, ',');
      var uri = '/api/v2.1/admin/utils/HDGYTS671Q/export_data?username=' + inputValue;
      window.open(uri, '_self');
    },
    download2: function download2() {
      var uri = '/api/v2.1/admin/utils/HDGYTS671Q/export_data?flag=update_record';
      window.open(uri, '_self');
    },
    nextPage: function nextPage() {
      if (this.currentPage == this.totalPage) return;
      this.currentPage++;
    },
    prevPage: function prevPage() {
      if (this.currentPage == 1) return;
      this.currentPage--;
    },
    go: function go() {
      if (0 < this.currentPage && this.currentPage < this.totalPage + 1) {
        this.currentPage = this.currentPage;
      } else {
        this.currentPage = 1;
      }
    },
    loadData: function loadData() {
      this.$http.post('/api/v2.1/account_manage/get_record', {
        permission: this.permission
      }).then(function (res) {
        var accountData = res.body.data;
        if (accountData && accountData.length > 0) {
          this.noData = false;
          this.accounts = accountData;
        } else {
          this.noData = true;
          this.accounts = [];
        }
      }, function (err) {});
    },
    addAccount: function addAccount() {
      this.$router.push('/accountsadmin_add');
    },
    navToHome: function navToHome() {
      this.$router.push('/accountsadmin_home');
    },
    deleteAccount: function deleteAccount() {
      var accounts = [];
      accounts = this.accounts.filter(function (e, i) {
        return e.check;
      });
      accounts = accounts.map(function (e, i) {
        return e.account;
      });
      if (0 == accounts.length) {
        this.$message({
          type: 'warning',
          message: 'Select'
        });
        return;
      }
      this.$http.post('/api/v2.1/account_manage/delete', {
        accounts: accounts,
        permission: this.permission
      }).then(function (res) {
        var error = res.body.error;
        if (error) {
          this.$message.error('code:' + error);
        } else {
          this.$message({
            type: 'success',
            message: "Success"
          });

          this.loadData();
        }
      }, function (err) {});
    },
    chooseAll: function chooseAll() {
      if (!this.checked) {
        for (var i = 0; i < this.accounts.length; i++) {
          this.accounts[i].check = false;
        }
      } else {
        for (var _i = 0; _i < this.accounts.length; _i++) {
          this.accounts[_i].check = true;
        }
      }
    }
  }
});

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },
  mounted: function mounted() {}
});

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      'username': ''
    };
  },

  computed: {},
  watch: {},
  methods: {
    logout: function logout() {
      this.$http.post('/api/v2.1/logout').then(function (res) {
        var error = res.body.error;
        if (0 == error) {
          this.$router.push('/managementtools');
        }
      });
    }
  },

  created: function created() {},
  mounted: function mounted() {
    this.username = sessionStorage.getItem('account_admin_username');
  }
});

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      'noData': true,
      checked: false,
      accounts: []
    };
  },

  computed: {},
  watch: {},
  mounted: function mounted() {
    this.loadData();
  },

  methods: {
    loadData: function loadData() {
      this.$http.post('/api/v2.1/account_manage/get_record', {
        permission: 'AccountAdmin'
      }).then(function (res) {
        var accountData = res.body.data;
        if (accountData && accountData.length > 0) {
          this.noData = false;
          this.accounts = accountData;
        } else {
          this.noData = true;
          this.accounts = [];
        }
      }, function (err) {});
    },
    addAccount: function addAccount() {
      this.$router.push('/accountsadmin_super_add');
    },
    deleteAccount: function deleteAccount() {
      var accounts = [];
      accounts = this.accounts.filter(function (e, i) {
        return e.check;
      });
      accounts = accounts.map(function (e, i) {
        return e.account;
      });
      this.$http.post('/api/v2.1/account_manage/delete', {
        accounts: accounts,
        permission: 'AccountAdmin'
      }).then(function (res) {
        var error = res.body.error;
        if (error) {
          this.$message.error('code:' + error);
        } else {
          this.$message({
            type: 'success',
            message: "Success"
          });

          this.loadData();
        }
      }, function (err) {});
    },
    chooseAll: function chooseAll() {
      if (!this.checked) {
        for (var i = 0; i < this.accounts.length; i++) {
          this.accounts[i].check = false;
        }
      } else {
        for (var _i = 0; _i < this.accounts.length; _i++) {
          this.accounts[_i].check = true;
        }
      }
    }
  }
});

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      account: '',
      checkInfo: [{
        check: false,
        text: 'EasyPatch Login Account management',
        permission: 'EasyPatchLogin'
      }, {
        check: false,
        text: 'HCP Account management',
        permission: 'HCPCreate'
      }, {
        check: false,
        text: 'Software upgrade product SN management',
        permission: 'FirmwareUpdateConfig'
      }, {
        check: false,
        text: 'HCL Function management -PDM',
        permission: 'HCLConfig'
      }, {
        check: false,
        text: 'HCL Function management -EasyPatch',
        permission: 'HCLConfigForEasyPatch'
      }, {
        check: false,
        text: 'EasyUpdate account management',
        permission: 'EasyUpdateLogin'
      }, {
        check: false,
        text: 'User',
        permission: 'UserAdmin'
      }, {
        check: false,
        text: 'Agency ',
        permission: 'Agency'
      }]
    };
  },

  computed: {},
  watch: {},
  mounted: function mounted() {},

  methods: {
    addAccount: function addAccount() {
      var permission = [];

      for (var i = 0; i < this.checkInfo.length; i++) {
        if (this.checkInfo[i].check) {
          permission.push(this.checkInfo[i].permission);
        }
      }
      if (!this.account || permission.length == 0) {
        this.$message({
          type: 'warning',
          message: 'error'
        });
        return;
      }

      this.$http.post('/api/v2.1/account_manage/add', {
        data: [{
          account: this.account,
          param: {
            permission: permission
          }
        }],
        role: 'AccountAdmin',
        permission: 'AccountAdmin'
      }).then(function (res) {
        var error = res.body.error;

        if (error) {
          this.$message.error('code:' + error);
        } else {
          var result = res.body.result;
          if (result) {
            var resError = result[0].error;
            if (resError) {
              this.$message.error('Account is not found.');
              return;
            }
          }
          this.$message({
            type: 'success',
            message: 'Account has already been added'
          });
          this.$router.push('/accountsadmin_super');
        }
      }, function (err) {});
    },
    navToHome: function navToHome() {
      this.$router.push('/accountsadmin_super');
    }
  }
});

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DevDebugData_BasicQuantity_vue__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DevDebugData_BasicQuantity_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DevDebugData_BasicQuantity_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BasicQuantity: __WEBPACK_IMPORTED_MODULE_0__DevDebugData_BasicQuantity_vue___default.a
  },
  data: function data() {
    return {
      aType: '3',
      activeIndex2: '3'
    };
  },

  methods: {
    handleSelect: function handleSelect(key, keyPath) {
      this.aType = key;
    }
  }
});

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__method__ = __webpack_require__(341);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            platform: '',
            username: '',
            flag: '',
            setHospital: [{ id: 'ios', name: 'ios' }, { id: 'google', name: 'google' }],
            tableData: [],
            searData: [],
            title: 'DevDebug',
            pagesize: 10,
            currentPage: 1,
            filterPage: 1,
            total: 0
        };
    },

    methods: {
        current_change: function current_change(currentPage) {
            this.currentPage = currentPage;
        },
        navToHome: function navToHome() {
            this.$router.push('/accountsadmin_home');
        },
        search: function search() {
            var val = {
                num: 100
            };
            var that = this;
            this.$http.post('/api/v2.1/admin/devdebug/get_rtd', val).then(function (res) {
                if (res.status === 200) {
                    that.searData = res.data.data;
                    for (var i = 0; i < that.searData.length; i++) {
                        that.searData[i].uploadTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__method__["a" /* format */])(that.searData[i].uploadTime);
                    }
                    that.tableData = that.searData;
                    that.total = res.data.data.length;
                } else {}
            });
        },
        select: function select() {
            var Data1 = [];
            var Data2 = [];
            var Data3 = [];
            if (this.platform) {
                for (var i = 0; i < this.searData.length; i++) {
                    if (this.searData[i].platform === this.platform) {
                        Data1.push(this.searData[i]);
                    }
                }
            } else {
                Data1 = this.searData;
            }

            if (this.flag) {
                for (var _i = 0; _i < Data1.length; _i++) {
                    if (Data1[_i].flag === this.flag) {
                        Data2.push(Data1[_i]);
                    }
                }
            } else {
                Data2 = Data1;
            }

            if (this.username) {
                var arr = this.username.split(',');
                for (var _i2 = 0; _i2 < Data2.length; _i2++) {
                    for (var j = 0; j < arr.length; j++) {
                        if (Data2[_i2].username.search(arr[j]) != -1) {
                            Data3.push(Data2[_i2]);
                            break;
                        }
                    }
                }
            } else {
                Data3 = Data2;
            }
            this.tableData = Data3;
            this.currentPage = 1;
            this.filterPage = 1;
            this.total = this.tableData.length;
        },

        ceclick: function ceclick(item) {
            this.$router.push({ path: '/BasicQuantityRecord', query: item });
        }
    },
    computed: {},
    created: function created() {
        var that = this;
        document.onkeydown = function (e) {
            e = window.event || e;
            if (that.$route.path === '/UserAdmin' && (e.code === 'Enter' || e.code === 'enter' || e.code === 'NumpadEnter') && !e.isComposing) {
                that.search();
            }
        };
    },
    mounted: function mounted() {
        this.search();
    }
});

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__method__ = __webpack_require__(341);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        return {
            value1: [new Date(new Date().toLocaleDateString()), new Date(new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1))],
            pickerOptions: {
                onPick: function onPick(_ref) {
                    var maxDate = _ref.maxDate,
                        minDate = _ref.minDate;

                    _this.choiceDate = minDate.getTime();

                    if (maxDate) _this.choiceDate = "";
                },
                disabledDate: function disabledDate(time) {
                    if (_this.choiceDate) {
                        var one = 7 * 24 * 3600 * 1000;

                        var minTime = _this.choiceDate - one;

                        var maxTime = _this.choiceDate + one;
                        return time.getTime() < minTime || time.getTime() > maxTime || time.getTime() - 2 * 24 * 3600 * 1000 > Date.now();
                    } else {
                        return time.getTime() - 2 * 24 * 3600 * 1000 > Date.now();
                    }
                }
            },
            value: '',
            options: [{
                value: 'N',
                label: 'N'
            }, {
                value: 'Y',
                label: 'Y'
            }],
            options1: [{
                value: 'daopapp',
                label: 'daopapp'
            }, {
                value: 'daoppdf',
                label: 'daoppdf'
            }],
            tableData: [],
            pagesize: 10,
            currentPage: 1,
            filterPage: 1,
            total: 0,
            id: '',
            type: '',
            data_source: 'daopapp'
        };
    },

    methods: {
        search: function search(val) {
            var _this2 = this;

            var that = this;
            this.$http.post('/api/v2.1/admin/devdebug/data/get_record', val).then(function (res) {
                if (res.status === 200) {
                    if (res.data.error === 0) {
                        console.log(res.data.data);
                        _this2.tableData = res.data.data;
                        for (var i = 0; i < that.tableData.length; i++) {
                            that.tableData[i][1] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__method__["a" /* format */])(that.tableData[i][1]);
                        }
                        that.total = res.data.data.length;
                    }
                } else {}
            });
        },

        current_change: function current_change(currentPage) {
            this.currentPage = currentPage;
        },
        select: function select() {
            var data = this.$route.query;
            var st = void 0,
                et = 0;
            if (this.value1.length > 1) {
                st = this.value1[0].getTime() / 1000;
                et = this.value1[1].getTime() / 1000;
            }
            var val = {
                username: data.username,
                et: et,
                st: st,
                data_source: this.data_source,
                flag: data.flag
            };
            var that = this;
            this.$http.post('/api/v2.1/admin/devdebug/data/get_record', val).then(function (res) {
                if (res.status === 200) {
                    if (res.data.error === 0) {
                        var _data = res.data.data;
                        that.tableData = [];
                        for (var i = 0; i < _data.length; i++) {
                            _data[i][1] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__method__["a" /* format */])(_data[i][1]);
                        }
                        for (var j = 0; j < _data.length; j++) {
                            if ((_data[j][0].search(that.id) != -1 || that.id == '') && (_data[j][2].search(that.type) != -1 || that.type == '') && (_data[j][8].search(that.value) != -1 || that.value == '')) {
                                that.tableData.push(_data[j]);
                            }
                        }
                        that.total = that.tableData.length;
                    }
                } else {}
            });
        }
    },
    mounted: function mounted() {
        var data = this.$route.query;
        var st = void 0,
            et = 0;
        console.log(this.value1);
        if (this.value1.length > 1) {
            st = this.value1[0].getTime() / 1000;
            et = this.value1[1].getTime() / 1000;
        }

        var val = {
            username: data.username,
            et: et,
            st: st,
            data_source: 'daopapp',
            flag: data.flag
        };
        this.search(val);
    }
});

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
   data: function data() {
      return {
         formLabelAlign: {
            accounts: '123',
            region: '',
            name: '',
            orz: '',
            email: '',
            mobile: '',
            password: '',
            type: ''
         },
         shoWFalse: false,
         input3: '',
         input4: '',
         input5: '',
         token: '',
         title: 'Accounts',
         disabled: false,
         totalCount: 0,
         labelPosition: 'left',
         hasAccount: false,
         dialogVisible: false,
         centerDialogVisible: false,
         RefreshDialogVisible: false,
         countries: [{ id: 'CN', name: 'CN' }, { id: 'GB', name: 'GB' }, { id: 'FR', name: 'FR' }, { id: 'DD', name: 'DD' }, { id: 'SE', name: 'SE' }, { id: 'AU', name: 'AU' }, { id: 'HKF', name: 'HKF' }, { id: 'HU', name: 'HU' }, { id: 'IT', name: 'IT' }, { id: 'NL', name: 'NL' }, { id: 'Nor', name: 'Nor' }, { id: 'PT', name: 'PT' }, { id: 'ES', name: 'ES' }, { id: 'TR', name: 'TR' }, { id: 'AE', name: 'AE' }, { id: 'Ro', name: 'Ro' }, { id: 'CZ', name: 'CZ' }, { id: 'SK', name: 'SK' }, { id: 'LT', name: 'LT' }, { id: 'PL', name: 'PL' }, { id: 'DK', name: 'DK' }, { id: 'FI', name: 'FI' }]
      };
   },

   methods: {
      del: function del() {
         this.centerDialogVisible = true;
      },
      delTest: function delTest() {
         var _this = this;

         this.disabled = true;
         this.totalCount = 60;
         this.interval = setInterval(function () {
            _this.totalCount--;
            if (_this.totalCount === 0) {
               clearInterval(_this.interval);
               _this.disabled = false;
            }
         }, 1000);
         var val = {
            'purpose': 'user_admin',
            'data': {
               'action': 'delete_user',
               'username': this.input3
            }
         };
         this.$http.post('/api/v2.1/seccode/send', val).then(function (res) {
            if (res.status === 200) {
               if (res.body.error === 0) {
                  _this.token = res.body.token;
               } else {
                  _this.token = '';
               }
            }
         });
      },
      cancelDel: function cancelDel() {
         this.centerDialogVisible = false;
         this.input4 = '';
         this.shoWFalse = false;
      },
      determineDel: function determineDel() {
         this.delAccounts();
      },
      delAccounts: function delAccounts() {
         var _this2 = this;

         var val = {
            username: this.input3,
            seccode: this.input4,
            token: this.token
         };
         this.$http.post('/api/v2.1/admin/user/delete_user', val).then(function (res) {
            if (res.status === 200) {
               if (res.body.error === 0) {
                  _this2.$message({
                     type: 'success',
                     message: '删除成功!'
                  });
                  _this2.centerDialogVisible = false;
                  _this2.input4 = '';
                  _this2.hasAccount = false;
               } else if (res.body.error === 26) {
                  _this2.shoWFalse = true;
               } else {
                  _this2.$message({
                     type: 'info',
                     message: '删除失败'
                  });
                  _this2.centerDialogVisible = false;
                  _this2.input4 = '';
               }
            } else {
               _this2.$message({
                  type: 'info',
                  message: '删除失败'
               });
               _this2.centerDialogVisible = false;
               _this2.input4 = '';
            }
         });
      },
      refresh: function refresh() {
         this.RefreshDialogVisible = true;
      },
      refreshTest: function refreshTest() {
         var _this3 = this;

         this.disabled = true;
         this.totalCount = 60;
         this.interval = setInterval(function () {
            _this3.totalCount--;
            if (_this3.totalCount === 0) {
               clearInterval(_this3.interval);
               _this3.disabled = false;
            }
         }, 1000);
         var val = {
            'purpose': 'user_admin',
            'data': {
               'action': 'update_info',
               'username': this.input3
            }
         };
         this.$http.post('/api/v2.1/seccode/send', val).then(function (res) {
            if (res.status === 200) {
               if (res.body.error === 0) {
                  _this3.token = res.body.token;
               } else {
                  _this3.token = '';
               }
            }
         });
      },
      cancelRefresh: function cancelRefresh() {
         this.RefreshDialogVisible = false;
         this.input5 = '';
         this.shoWFalse = false;
      },
      determineRefresh: function determineRefresh() {
         this.refreshUser();
      },
      refreshUser: function refreshUser() {
         var _this4 = this;

         var val = void 0;
         if (this.formLabelAlign.password === '') {
            val = {
               username: this.input3,
               info: {
                  "country": this.formLabelAlign.region,
                  "email": this.formLabelAlign.email,
                  "mobile": this.formLabelAlign.mobile,
                  "serve_for": this.formLabelAlign.orz,
                  "username": this.formLabelAlign.name
               },
               seccode: this.input5,
               token: this.token
            };
         } else {
            val = {
               username: this.input3,
               info: {
                  "country": this.formLabelAlign.region,
                  "email": this.formLabelAlign.email,
                  "mobile": this.formLabelAlign.mobile,
                  "serve_for": this.formLabelAlign.orz,
                  "username": this.formLabelAlign.name,
                  "password": this.formLabelAlign.password
               },
               seccode: this.input5,
               token: this.token
            };
         }

         this.$http.post('/api/v2.1/admin/user/update_info', val).then(function (res) {
            if (res.status === 200) {
               if (res.body.error === 0) {
                  _this4.$message({
                     type: 'success',
                     message: '更新成功!'
                  });
                  _this4.RefreshDialogVisible = false;
                  _this4.input5 = '';
               } else if (res.body.error === 26) {
                  _this4.shoWFalse = true;
               } else {
                  _this4.$message({
                     type: 'info',
                     message: '删除失败'
                  });
                  _this4.RefreshDialogVisible = false;
                  _this4.input5 = '';
               }
            } else {
               _this4.$message({
                  type: 'info',
                  message: '删除失败'
               });
               _this4.RefreshDialogVisible = false;
               _this4.input5 = '';
            }
         });
      },
      handleDialogClose: function handleDialogClose() {
         this.input5 = '';
         this.input4 = '';
         this.centerDialogVisible = false;
         this.RefreshDialogVisible = false;
         this.shoWFalse = false;
      },
      navToHome: function navToHome() {
         this.$router.push('/accountsadmin_home');
      },
      search: function search() {
         var _this5 = this;

         if (this.input3 === '') {
            this.$message({
               type: 'info',
               message: '请输入正确的账号'
            });
            return;
         }
         var val = {
            username: this.input3
         };
         this.$http.post('/api/v2.1/admin/user/get_user', val).then(function (res) {
            if (res.status === 200) {
               if (res.body.error === 0 && res.body.info.length !== 0) {
                  _this5.formLabelAlign.name = res.body.info.realname;
                  _this5.formLabelAlign.accounts = res.body.info.username;
                  _this5.formLabelAlign.region = res.body.info.country, _this5.formLabelAlign.orz = res.body.info.serve_for, _this5.formLabelAlign.email = res.body.info.email, _this5.formLabelAlign.mobile = res.body.info.mobile;
                  _this5.formLabelAlign.type = res.body.info.user_type;
                  _this5.hasAccount = true;
               } else {
                  _this5.hasAccount = false;
                  _this5.dialogVisible = true;
               }
            } else {
               _this5.hasAccount = false;
            }
         });
      }
   },
   computed: {
      alignType: function alignType() {
         if (this.formLabelAlign.type === 'P') {
            return 'Patient';
         } else if (this.formLabelAlign.type === 'M') {
            return 'Carer';
         } else if (this.formLabelAlign.type === 'D') {
            return 'HCP';
         }
      },
      btnText: function btnText() {
         return this.totalCount !== 0 ? this.totalCount + '\u79D2\u518D\u6B21\u83B7\u53D6' : "获取验证码";
      }
   },
   created: function created() {
      var that = this;
      document.onkeydown = function (e) {
         e = window.event || e;
         if (that.$route.path === '/UserAdmin' && (e.code === 'Enter' || e.code === 'enter' || e.code === 'NumpadEnter') && !e.isComposing) {
            that.search();
         }
      };
   }
});

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__HCLTable_vue__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__HCLTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__HCLTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_Export2Excel_js__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dataStatisticsTaableHeader_json__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dataStatisticsTaableHeader_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__dataStatisticsTaableHeader_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__publicMethod__ = __webpack_require__(340);
















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HCLStatistics',
  prop: {
    postData: Array
  },
  components: {
    HCLTable: __WEBPACK_IMPORTED_MODULE_9__HCLTable_vue___default.a
  },
  data: function data() {
    return {
      groupMap: {},
      dailyDataMap: {},
      accountDataList: [],
      groupDataList: [],
      dailyDataList: [],
      accountInsulinDataMap: {},
      rangeList: {},
      outliers: {},
      Loading: false,
      activeName: 'group',
      pagesize: 10,
      invalidAccount: [],
      dataType: "HCL",
      allowType: ['BAS', 'BAE', 'BAH', 'BAPB', 'BAPA', 'BAPC', 'BAPD', 'BASK'],
      notAllowType: ['BAAMS', 'BAAME', 'BAAMBreakfast', 'BAAMLunch', 'BAAMDinner', 'BAAMSnack', 'BAAMExerciseStart', 'BAAMExerciseExit'],
      tabLabel: [],
      accountList: {},
      sel_time: new Date(2019, 0, 1).getTime(),
      BGAttribute: ['SGnum', 'TBRNum', 'TirNum', 'below30Num', 'beyond13Num', 'sumSG', 'tarNum'],
      AGPGraph: {
        'open': __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from___default()(new Array(144), function () {
          return new Array();
        }),
        'close': __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from___default()(new Array(144), function () {
          return new Array();
        })
      },
      AGPGraphList: {
        'open': {
          'T1Data': new Array(144),
          'Q1Data': new Array(144),
          'midData': new Array(144),
          'Q2Data': new Array(144),
          'T9Data': new Array(144)
        },
        'close': {
          'T1Data': new Array(144),
          'Q1Data': new Array(144),
          'midData': new Array(144),
          'Q2Data': new Array(144),
          'T9Data': new Array(144)
        }
      },
      TIRComparisonGraph: {
        'open': {},
        'close': {}
      },
      TIRComparisonList: {
        'Q1Data': new Array(),
        'midData': new Array(),
        'Q2Data': new Array(),
        'avgData': new Array()
      },
      TBRComparisonGraph: {
        'open': {},
        'close': {}
      },
      TBRComparisonList: {
        'Q1Data': new Array(),
        'midData': new Array(),
        'Q2Data': new Array(),
        'avgData': new Array()
      },
      TIRDistributionGraph: {
        'open': new Array(),
        'close': new Array()
      },
      TIRDistributionList: {
        'open': {
          nameList: new Array(),
          value: new Array()
        },
        'close': {
          nameList: new Array(),
          value: new Array()
        }
      },
      A1CDistributionGraph: {
        'open': new Array(),
        'close': new Array()
      },
      A1CDistributionList: {
        'open': {
          nameList: new Array(),
          value: new Array()
        },
        'close': {
          nameList: new Array(),
          value: new Array()
        }
      }
    };
  },

  methods: {
    exportExcel: function exportExcel() {
      if (this.Loading) {
        this.$message.warning('数据量较大请等待加载完成');
      } else {
        var writeData = [{
          'tableType': __WEBPACK_IMPORTED_MODULE_11__dataStatisticsTaableHeader_json__["groupData"],
          'tableData': this.groupDataList,
          'sheetName': '汇总数据'
        }, {
          'tableType': __WEBPACK_IMPORTED_MODULE_11__dataStatisticsTaableHeader_json__["accountData"],
          'tableData': this.accountDataList,
          'sheetName': '个人汇总数据'
        }, {
          'tableType': __WEBPACK_IMPORTED_MODULE_11__dataStatisticsTaableHeader_json__["dailyData"],
          'tableData': this.dailyDataList,
          'sheetName': '个人每日数据',
          'needMarkOutliers': true
        }, {
          'tableType': __WEBPACK_IMPORTED_MODULE_11__dataStatisticsTaableHeader_json__["invalidAccountData"],
          'tableData': this.invalidAccount,
          'sheetName': '无效账号'
        }];
        if (this.groupDataList.length) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_Export2Excel_js__["a" /* default */])(writeData, 'HCLstatistics', this.outliers);
        }
      }
    },
    exportGraph: function exportGraph() {
      if (this.Loading) {
        this.$message.warning('数据量较大请等待加载完成');
      } else {
        if (localStorage.getItem('HCLGraph')) {
          window.open('/#/HCLprint', '_black');
        }
      }
    },
    getSG: function getSG(item, startTime, isOpen) {
      var _this = this;

      var targetLow = 3.9,
          targetHigh = 10;

      var daysumSG = 0,
          daySGnum = 0,
          daybelow30Num = 0,
          dayTBRNum = 0,
          dayTirNum = 0,
          daytarNum = 0,
          daybeyond13Num = 0;
      if (item.length) {
        item.map(function (i) {
          if (i.length) {
            if (['C', 'CX', 'NC'].includes(i[4]) && i[3] && i[3] > 0.001) {
              if (i[3] < 2.2) {
                i[3] = 2.2;
              } else if (i[3] > 22.2) {
                i[3] = 22.2;
              }
              var SG = i[3];
              var count = Math.floor(parseInt(i[1] - startTime) / 600);
              if (count < 144 && count >= 0) {
                _this.AGPGraph[isOpen][count].push(SG);
              }
              daySGnum += 1;
              if (SG < 3.0) {
                daybelow30Num += 1;
              }
              if (SG < targetLow) {
                dayTBRNum += 1;
              } else if (SG <= targetHigh) {
                dayTirNum += 1;
              } else {
                daytarNum += 1;
              }
              if (SG > 13.9) {
                daybeyond13Num += 1;
              }
              daysumSG += SG;
            }
          }
        });
      }
      return { sumSG: daysumSG, SGnum: daySGnum, below30Num: daybelow30Num, TBRNum: dayTBRNum, TirNum: dayTirNum, tarNum: daytarNum, beyond13Num: daybeyond13Num };
    },
    getAutoMode: function getAutoMode(item) {
      var newUmax = 0,
          newIbasal = 0;
      if (item[0] && item[0].length) {
        newUmax = Math.floor(item[0][2].newUmax * 100) / 100;
        newIbasal = Math.floor(item[0][2].newIbasal * 100) / 100;
      }
      return { umax: newUmax, newbasal: newIbasal };
    },
    getBasal: function getBasal(dayData, today) {
      var _this2 = this;

      var dayTime = 0,
          dayAutoTime = 0,
          dayBasal = 0,
          dayAutoBolus = 0;
      var tomorrow = today + 86400;
      if (dayData.length) {
        dayData.map(function (item, i) {
          var basalType = item[2];
          var recordIdPart = item[0].split('-')[3];
          var tmpTime = item[3];
          if (item[1] < today) {
            tmpTime = item[3] + item[1] - today;
          } else if (item[1] + item[3] > tomorrow) {
            tmpTime = tomorrow - item[1];
          }
          if ('9999' !== recordIdPart && '65535' !== recordIdPart) {
            if ('BAAM' === basalType) {
              dayAutoTime += tmpTime;
              dayTime += tmpTime;
              var autoModeData = item[7];
              if (autoModeData) {
                autoModeData = JSON.parse(autoModeData);
                var microBolusJson = autoModeData['autoModeJSON'];
                var cur_auto_basal_total = 0;
                var cur_auto_bolus_total = 0;

                microBolusJson.map(function (microBolusitem) {
                  cur_auto_basal_total += microBolusitem['auto_basal_delivery'];
                  cur_auto_bolus_total += microBolusitem['auto_food_delivery'] + microBolusitem['auto_corr_delivery'];
                });
                dayBasal += cur_auto_basal_total * 0.05;
                dayAutoBolus += cur_auto_bolus_total * 0.05;
              }
            } else if (!_this2.notAllowType.includes(basalType)) {
              dayBasal += item[5];
              dayTime += tmpTime;
            }
          }
        });
      }
      return { totalTime: dayTime, autoTime: dayAutoTime, totalBasal: dayBasal, dayAutoBolus: dayAutoBolus };
    },
    getBolus: function getBolus(dayData) {
      var dayBolus = 0;
      if (dayData.length) {
        dayData.map(function (item) {
          if (item[0].split('-')[3] < 8888) {
            dayBolus += item[4] + item[6];
          }
        });
      }
      return { totalBolus: dayBolus };
    },
    getPercent: function getPercent(Numerator, denominator, flag) {
      var res = 0.00;
      if (denominator) {
        res = Numerator / denominator;
      }
      if (flag === 1) {
        return Math.round(res * 100) / 100;
      }
      return Math.round(res * 1000) / 10 + '%';
    },
    calGroupAvg: function calGroupAvg(numeratorList, denominatorList) {
      var needPercent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var len = numeratorList.length;
      var arr = numeratorList.map(function (numerator, index) {
        if (numerator === 0 || denominatorList[index] === 0) {
          return 0;
        }
        return numerator / denominatorList[index];
      });
      var avg = arr.reduce(function (sum, next) {
        return sum + next;
      }) / len;
      var SD = Math.sqrt(arr.map(function (item) {
        return Math.pow(item - avg, 2);
      }).reduce(function (sum, next) {
        return sum + next;
      }) / len);
      if (needPercent) {
        return Math.round(avg * 1000) / 10 + '% ± ' + Math.round(SD * 1000) / 10 + '%';
      } else {
        return Math.round(avg * 10) / 10 + ' ± ' + Math.round(SD * 10) / 10;
      }
    },
    calculateData: function calculateData(rawData) {
      var isGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var SGnum = void 0,
          avgSG = void 0,
          below30Percent = void 0,
          TBRPercent = void 0,
          TirPercent = void 0,
          tarPercent = void 0,
          beyond13Percent = void 0,
          AutoPercent = void 0,
          avgBasal = void 0,
          basalPercent = void 0,
          avgBolus = void 0,
          bolusPercent = void 0,
          TDDPercent = void 0,
          TDD = void 0;
      var groupName = rawData.groupName;
      if (!isGroup) {
        SGnum = rawData.SGnum;
        if (rawData.SGnum) {
          avgSG = Math.round(rawData.sumSG / rawData.SGnum * 10) / 10;
        } else {
          avgSG = 0.0;
        }
        below30Percent = this.getPercent(rawData.below30Num, rawData.SGnum, 2);
        TBRPercent = this.getPercent(rawData.TBRNum, rawData.SGnum, 2);
        TirPercent = this.getPercent(rawData.TirNum, rawData.SGnum, 2);
        tarPercent = this.getPercent(rawData.tarNum, rawData.SGnum, 2);
        beyond13Percent = this.getPercent(rawData.beyond13Num, rawData.SGnum, 2);
      } else {
        SGnum = rawData.SGnum.reduce(function (sum, next) {
          return sum + next;
        });
        avgSG = this.calGroupAvg(rawData.sumSG, rawData.SGnum, false);
        below30Percent = this.calGroupAvg(rawData.below30Num, rawData.SGnum);
        TBRPercent = this.calGroupAvg(rawData.TBRNum, rawData.SGnum);
        TirPercent = this.calGroupAvg(rawData.TirNum, rawData.SGnum);
        tarPercent = this.calGroupAvg(rawData.tarNum, rawData.SGnum);
        beyond13Percent = this.calGroupAvg(rawData.beyond13Num, rawData.SGnum);
      }

      AutoPercent = this.getPercent(rawData.autoTime, rawData.totalTime, 2);
      avgBasal = this.getPercent(rawData.totalBasal, rawData.dayNum, 1);
      avgBolus = this.getPercent(rawData.totalBolus, rawData.dayNum, 1);
      TDD = avgBasal + avgBolus;
      if (rawData.hasOwnProperty('avgTDD')) {
        TDDPercent = rawData.avgTDD ? this.getPercent(TDD, rawData.avgTDD, 2) : 'error0';
      }
      basalPercent = this.getPercent(avgBasal, TDD, 2);
      bolusPercent = this.getPercent(avgBolus, TDD, 2);
      return { groupName: groupName, SGnum: SGnum, avgSG: avgSG, below30Percent: below30Percent, TBRPercent: TBRPercent, TirPercent: TirPercent, tarPercent: tarPercent, beyond13Percent: beyond13Percent, AutoPercent: AutoPercent, avgBasal: avgBasal, basalPercent: basalPercent, avgBolus: avgBolus, bolusPercent: bolusPercent, TDDPercent: TDDPercent, TDD: TDD };
    },
    resetHCL: function resetHCL() {
      this.invalidAccount.length = 0;
      this.accountDataList.length = 0;
      this.groupDataList.length = 0;
      this.dailyDataList.length = 0;
      this.dailyDataMap = {};
      this.groupMap = {};
      this.TIRComparisonGraph = {
        'open': {},
        'close': {}
      };
      this.AGPGraph = {
        'open': __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from___default()(new Array(144), function () {
          return new Array();
        }),
        'close': __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from___default()(new Array(144), function () {
          return new Array();
        })
      };
      this.TBRComparisonGraph = {
        'open': {},
        'close': {}
      };
      this.TIRDistributionGraph = {
        'open': new Array(),
        'close': new Array()
      };
      this.A1CDistributionGraph = {
        'open': new Array(),
        'close': new Array()
      };

      this.AGPGraphList = {
        'open': {
          'T1Data': new Array(144),
          'Q1Data': new Array(144),
          'midData': new Array(144),
          'Q2Data': new Array(144),
          'T9Data': new Array(144)
        },
        'close': {
          'T1Data': new Array(144),
          'Q1Data': new Array(144),
          'midData': new Array(144),
          'Q2Data': new Array(144),
          'T9Data': new Array(144)
        }
      };
      this.TIRComparisonList = {
        'Q1Data': new Array(),
        'midData': new Array(),
        'Q2Data': new Array(),
        'avgData': new Array()
      };
      this.TBRComparisonList = {
        'Q1Data': new Array(),
        'midData': new Array(),
        'Q2Data': new Array(),
        'avgData': new Array()
      };
      this.TIRDistributionList = {
        'open': {
          nameList: new Array(),
          value: new Array()
        },
        'close': {
          nameList: new Array(),
          value: new Array()
        }
      };
      this.A1CDistributionList = {
        'open': {
          nameList: new Array(),
          value: new Array()
        },
        'close': {
          nameList: new Array(),
          value: new Array()
        }
      };
    },
    isInRange: function isInRange(num, _ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
          min = _ref2[0],
          max = _ref2[1];

      var realNum = 0;
      if (typeof num === 'string') {
        if (num.match(/%$/g)) {
          realNum = +num.replace('%', '') / 100;
        } else {
          realNum = +num;

          if (realNum !== realNum) {
            return false;
          }
        }
      } else if (typeof num === 'number') {
        realNum = num;
      } else {
        return false;
      }
      if (realNum <= max && realNum >= min) {
        return true;
      } else {
        return false;
      }
    },
    checkDate: function checkDate(date, _ref3, rangeList) {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
          prop = _ref4[0],
          propData = _ref4[1];

      if (propData === 'error0') {
        return false;
      }

      var DATE = new Date(date) / 1000;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(rangeList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item[prop] && Array.isArray(item[prop])) {
            if (this.isInRange(DATE, [new Date(item.startDate.split('GMT')[0]) / 1000, new Date(item.endDate.split('GMT')[0]) / 1000])) {
              return this.isInRange(propData, item[prop]);
            } else {
              continue;
            }
          } else {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return true;
    },
    calA1C: function calA1C(avgSG) {
      return Math.floor((avgSG * 18 + 46.7) / 28.7 * 10);
    },
    getDistributionList: function getDistributionList(distributionGraph, distributionList) {
      var isA1C = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var tmpDistributionList = {
        'open': new Array(100).fill(0),
        'close': new Array(100).fill(0)
      };

      var _loop = function _loop(isopen, isopenData) {
        var totalNum = isopenData.length;
        isopenData.sort(function (x, y) {
          return x[1] - y[1];
        });
        isopenData.map(function (item) {
          tmpDistributionList[isopen].push([item[1], 1]);
          distributionList[isopen].nameList.push(item[0]);
        });
        var preItem = 0;
        tmpDistributionList[isopen].map(function (item) {
          if (item !== 0) {
            if (isA1C) {
              distributionList[isopen].value.push([item[0] / 10, Math.floor((preItem + item[1]) / totalNum * 100) / 100]);
            } else {
              distributionList[isopen].value.push([item[0], Math.floor((preItem + item[1]) / totalNum * 100)]);
            }
            preItem = item[1] + preItem;
          }
        });
      };

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(distributionGraph)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ref5 = _step2.value;

          var _ref6 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);

          var isopen = _ref6[0];
          var isopenData = _ref6[1];

          _loop(isopen, isopenData);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    insertData: function insertData(isopenData, index, tmpComparisonList, baseLineDate) {
      var isTBR = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      var duration = 28 * 86400000;
      var dateList = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(isopenData).sort(function (x, y) {
        return x - y;
      });
      var endDate = new Date(baseLineDate).getTime() + duration;
      tmpComparisonList[index] = tmpComparisonList[index] || [];
      dateList.map(function (date) {
        if (index !== 0 && new Date(date).getTime() > endDate) {
          endDate = endDate + duration;
          index += 1;
          tmpComparisonList[index] = tmpComparisonList[index] || [];
        }

        if (isTBR) {
          if (isopenData[date] >= 0 && isopenData[date] !== null) {
            tmpComparisonList[index].push(isopenData[date]);
          }
        } else if (isopenData[date]) {
          tmpComparisonList[index].push(isopenData[date]);
        }
      });
    },
    getComparisonList: function getComparisonList(comparisonGraph, comparisonList) {
      var _this3 = this;

      var isTBR = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var tmpComparisonList = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(comparisonGraph)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _ref7 = _step3.value;

          var _ref8 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref7, 2);

          var isopen = _ref8[0];
          var isopenData = _ref8[1];
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(isopenData)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var _ref9 = _step4.value;

              var _ref10 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref9, 2);

              var _account = _ref10[0];
              var _accountData = _ref10[1];

              if (isopen === 'open') {
                this.insertData(comparisonGraph['open'][_account], 0, tmpComparisonList, '', isTBR);
              } else {
                var dateList = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(_accountData).sort(function (x, y) {
                  return x - y;
                });
                var baseLineDate = dateList[0];

                this.insertData(comparisonGraph['close'][_account], 1, tmpComparisonList, baseLineDate, isTBR);
              }
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      tmpComparisonList.map(function (item, index) {
        var len = item.length;
        if (len) {
          var offset = 0.75;
          item.sort(function (x, y) {
            return x - y;
          });
          comparisonList.Q1Data[index] = [index + offset, item[Math.floor(0.25 * len)]];
          comparisonList.Q2Data[index] = [index + offset, item[Math.floor(0.75 * len)]];
          comparisonList.midData.push([index + offset, item[Math.floor(0.5 * len)]]);
          comparisonList.midData.push([index + 0.5 + offset, item[Math.floor(0.5 * len)]]);
          comparisonList.midData.push(null);
          comparisonList.avgData[index] = [index + 1, _this3.getAvg(item)];
        }
      });
    },
    getTime: function getTime(index) {
      return this.sel_time + (index * 10 + 5) * 60000;
    },
    getAvg: function getAvg(arr) {
      return Math.floor(arr.reduce(function (sum, data) {
        return sum + data;
      }) / arr.length * 100) / 100;
    },
    getAGPGraphList: function getAGPGraphList() {
      var _this4 = this;

      var _loop2 = function _loop2(isopen, isopenData) {
        isopenData.map(function (item, index) {
          var len = item.length;
          if (len) {
            item.sort(function (x, y) {
              return x - y;
            });
            var T1index = Math.floor(0.1 * len);
            var Q1index = Math.floor(0.25 * len);
            var midIndex = Math.floor(0.5 * len);
            var Q3index = Math.floor(0.75 * len);
            var T9index = Math.floor(0.9 * len);
            var tmpTime = _this4.getTime(index);
            _this4.AGPGraphList[isopen]['T1Data'][index] = [tmpTime, item[T1index]];
            _this4.AGPGraphList[isopen]['Q1Data'][index] = [tmpTime, item[Q1index]];
            _this4.AGPGraphList[isopen]['midData'][index] = [tmpTime, item[midIndex]];
            _this4.AGPGraphList[isopen]['Q2Data'][index] = [tmpTime, parseFloat((item[Q3index] - item[Q1index]).toFixed(1))];
            _this4.AGPGraphList[isopen]['T9Data'][index] = [tmpTime, parseFloat((item[T9index] - item[T1index]).toFixed(1))];
          }
        });
      };

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(this.AGPGraph)), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _ref11 = _step5.value;

          var _ref12 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref11, 2);

          var isopen = _ref12[0];
          var isopenData = _ref12[1];

          _loop2(isopen, isopenData);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    },
    calGraphData: function calGraphData() {
      localStorage.removeItem('HCLGraph');
      this.getAGPGraphList();
      this.getComparisonList(this.TIRComparisonGraph, this.TIRComparisonList);
      this.getComparisonList(this.TBRComparisonGraph, this.TBRComparisonList, true);
      this.getDistributionList(this.TIRDistributionGraph, this.TIRDistributionList);
      this.getDistributionList(this.A1CDistributionGraph, this.A1CDistributionList, true);
      localStorage.setItem('HCLGraph', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
        AGPGraphList: this.AGPGraphList,
        TIRComparisonList: this.TIRComparisonList,
        TBRComparisonList: this.TBRComparisonList,
        TIRDistributionList: this.TIRDistributionList,
        A1CDistributionList: this.A1CDistributionList
      }));
    },
    sendRequest: function sendRequest(arr, max, callback, oneRequest) {
      var promiseList = [],
          i = 0;
      var LENGTH = arr.length;
      function toFetch() {
        if (i === LENGTH) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
        }

        var one = oneRequest(arr[i++]);
        promiseList.push(one);
        var oneRequestResult = true;
        one.then(function () {
          promiseList.splice(promiseList.indexOf(one), 1);
          oneRequestResult = true;
        }).catch(function (reject) {
          if (reject === 'error') {
            oneRequestResult = false;
          }
        });
        if (oneRequestResult) {
          var p = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
          if (promiseList.length >= max) {
            p = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.race(promiseList);
          }
          return p.then(function () {
            return toFetch();
          });
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
        }
      }

      toFetch().then(function () {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promiseList);
      }).then(function () {
        callback();
      });
    },
    afterRequest: function afterRequest() {
      this.outliers['个人每日数据'] = [];
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(this.dailyDataMap)), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var _ref13 = _step6.value;

          var _ref15 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref13, 2),
              groupindex = _ref15[0],
              groupValue = _ref15[1];

          var _iteratorNormalCompletion8 = true;
          var _didIteratorError8 = false;
          var _iteratorError8 = undefined;

          try {
            for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(groupValue)), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
              var _ref16 = _step8.value;

              var _ref17 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref16, 2),
                  account = _ref17[0],
                  accountValue = _ref17[1];

              var _iteratorNormalCompletion9 = true;
              var _didIteratorError9 = false;
              var _iteratorError9 = undefined;

              try {
                for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(accountValue)), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                  var _ref18 = _step9.value;

                  var _ref19 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref18, 2),
                      dataSource = _ref19[0],
                      datasourceValue = _ref19[1];

                  var _iteratorNormalCompletion10 = true;
                  var _didIteratorError10 = false;
                  var _iteratorError10 = undefined;

                  try {
                    for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(datasourceValue)), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                      var _dailyDataList;

                      var _ref20 = _step10.value;

                      var _ref21 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref20, 2),
                          isOpen = _ref21[0],
                          isOpenValue = _ref21[1];

                      var unsortedData = [];
                      var _iteratorNormalCompletion11 = true;
                      var _didIteratorError11 = false;
                      var _iteratorError11 = undefined;

                      try {
                        for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(isOpenValue)), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                          var _ref22 = _step11.value;

                          var _ref23 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref22, 2),
                              date = _ref23[0],
                              dateValue = _ref23[1];

                          var dailyMap = { groupName: groupindex, date: date, account: account, userName: dateValue.userName, data_source: dataSource, isOpen: isOpen === 'open' ? '开环' : '闭环' };

                          var hasOutlier = false,
                              tmpOutlier = { date: date, data_source: dataSource, account: account, isOpen: isOpen === 'open' ? '开环' : '闭环' };
                          tmpOutlier.props = [];

                          __WEBPACK_IMPORTED_MODULE_12__publicMethod__["a" /* default */].addProps(dailyMap, this.calculateData(dateValue));
                          dailyMap.umax = dateValue.umax;
                          dailyMap.newbasal = dateValue.newbasal;

                          if (!this.isInRange(dailyMap.newbasal, [0.5 * (dailyMap.basal / 24), 2 * (dailyMap.basal / 24)])) {
                            tmpOutlier.props.push('newbasal');
                            hasOutlier = true;
                          }
                          if (!this.isInRange(dailyMap.umax, [0.5 * dailyMap.newbasal, 5 * dailyMap.newbasal])) {
                            tmpOutlier.props.push('umax');
                            hasOutlier = true;
                          }
                          var _iteratorNormalCompletion12 = true;
                          var _didIteratorError12 = false;
                          var _iteratorError12 = undefined;

                          try {
                            for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(dailyMap)), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                              var _ref24 = _step12.value;

                              var _ref25 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref24, 2),
                                  prop = _ref25[0],
                                  propData = _ref25[1];

                              if (!this.checkDate(date, [prop, propData], this.rangeList[account][dataSource][isOpen])) {
                                tmpOutlier.props.push(prop);
                                hasOutlier = true;
                              }
                            }
                          } catch (err) {
                            _didIteratorError12 = true;
                            _iteratorError12 = err;
                          } finally {
                            try {
                              if (!_iteratorNormalCompletion12 && _iterator12.return) {
                                _iterator12.return();
                              }
                            } finally {
                              if (_didIteratorError12) {
                                throw _iteratorError12;
                              }
                            }
                          }

                          if (hasOutlier) {
                            this.outliers['个人每日数据'].push(tmpOutlier);
                          }
                          unsortedData.push(dailyMap);
                        }
                      } catch (err) {
                        _didIteratorError11 = true;
                        _iteratorError11 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion11 && _iterator11.return) {
                            _iterator11.return();
                          }
                        } finally {
                          if (_didIteratorError11) {
                            throw _iteratorError11;
                          }
                        }
                      }

                      unsortedData.sort(function (obj1, obj2) {
                        return new Date(obj1.date) - new Date(obj2.date);
                      });
                      (_dailyDataList = this.dailyDataList).push.apply(_dailyDataList, unsortedData);
                    }
                  } catch (err) {
                    _didIteratorError10 = true;
                    _iteratorError10 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion10 && _iterator10.return) {
                        _iterator10.return();
                      }
                    } finally {
                      if (_didIteratorError10) {
                        throw _iteratorError10;
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError9 = true;
                _iteratorError9 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion9 && _iterator9.return) {
                    _iterator9.return();
                  }
                } finally {
                  if (_didIteratorError9) {
                    throw _iteratorError9;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError8 = true;
            _iteratorError8 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion8 && _iterator8.return) {
                _iterator8.return();
              }
            } finally {
              if (_didIteratorError8) {
                throw _iteratorError8;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(this.groupMap)), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var _ref14 = _step7.value;

          var _ref26 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref14, 2),
              key = _ref26[0],
              value = _ref26[1];

          this.groupDataList.push(this.calculateData(value, true));
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      this.accountDataList.sort(function (obj1, obj2) {
        return obj1.groupName.split('组')[1] - obj2.groupName.split('组')[1];
      });
      this.groupDataList.sort(function (obj1, obj2) {
        return obj1.groupName.split('组')[1] - obj2.groupName.split('组')[1];
      });
      this.Loading = false;
      __WEBPACK_IMPORTED_MODULE_12__publicMethod__["a" /* default */].invalidAccountMSG(this.invalidAccount, this);

      this.calGraphData();
    },
    oneRequest: function oneRequest(postDataitem) {
      var _this5 = this;

      var startDate = postDataitem.startDate;
      var beforeStartDate = new Date(startDate) / 1000 - 86400 * 14;
      var TS = __WEBPACK_IMPORTED_MODULE_8__auth_auth__["a" /* default */].getTs(beforeStartDate, new Date(postDataitem.endDate) / 1000);

      var autoModeTS = __WEBPACK_IMPORTED_MODULE_8__auth_auth__["a" /* default */].getTs(new Date(startDate) / 1000 - 86400, new Date(postDataitem.endDate) / 1000);
      var accountName = postDataitem.account;
      var userName = this.accountList[accountName].userName;
      var dataSource = postDataitem.data_source === '实时' ? 'daopapp' : 'daoppdm';
      var isOpen = postDataitem.isOpen === '开环' ? 'open' : 'close';
      if (this.accountList[accountName].uid) {
        var param = {
          sg: { ts: TS },
          bolus: { ts: TS },
          basal: { ts: TS },
          data_source: dataSource,
          auto_mode: { ts: autoModeTS }
        };
        var groupName = postDataitem.group;
        var targetTime = 23.5 * 3600;

        this.dailyDataMap[groupName] = this.dailyDataMap[groupName] || {};
        this.dailyDataMap[groupName][accountName] = this.dailyDataMap[groupName][accountName] || {};
        this.dailyDataMap[groupName][accountName][dataSource] = this.dailyDataMap[groupName][accountName][dataSource] || {};
        this.dailyDataMap[groupName][accountName][dataSource][isOpen] = this.dailyDataMap[groupName][accountName][dataSource][isOpen] || {};
        this.TIRComparisonGraph[isOpen][accountName] = {};
        this.TBRComparisonGraph[isOpen][accountName] = {};
        var sumSG = 0,
            SGnum = 0,
            below30Num = 0,
            TBRNum = 0,
            TirNum = 0,
            tarNum = 0,
            beyond13Num = 0;
        var totalTime = 0,
            autoTime = 0,
            totalBasal = 0,
            totalBolus = 0,
            avgTDD = 0,
            dayNum = 0,
            umax = 0,
            newbasal = 0;
        var twoWeekRecords = new Array(),
            tdd = 0;

        var promise = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          _this5.$http.post('/api/v2.1/data/' + _this5.accountList[accountName].uid, param).then(function (res) {
            if (res.status === 200) {
              if (res.body.error === 0) {
                res.data.data.bolus.map(function (dayData, index) {
                  var day = __WEBPACK_IMPORTED_MODULE_12__publicMethod__["a" /* default */].formatterDate(startDate, index - 14);
                  var tmpDayTime = beforeStartDate + 86400 * index;

                  var SGlength = res.data.data.sg[index].length;

                  var tmpDayData = _this5.getBasal(res.data.data.basal[index], tmpDayTime, isOpen === 'open', SGlength);

                  __WEBPACK_IMPORTED_MODULE_12__publicMethod__["a" /* default */].addProps(tmpDayData, _this5.getBolus(dayData, tmpDayData.autoTime || isOpen === 'open'));

                  tmpDayData.totalBolus += tmpDayData.dayAutoBolus;

                  tdd = 0;

                  if (tmpDayData.totalTime > targetTime && (isOpen === 'open' || tmpDayData.autoTime)) {
                    tdd += tmpDayData.totalBasal;
                    tdd += tmpDayData.totalBolus;
                  }
                  if (index < 14) {
                    twoWeekRecords.push(tdd);
                  } else {
                    __WEBPACK_IMPORTED_MODULE_12__publicMethod__["a" /* default */].addProps(tmpDayData, _this5.getSG(res.data.data.sg[index], tmpDayTime, isOpen));
                    __WEBPACK_IMPORTED_MODULE_12__publicMethod__["a" /* default */].addProps(tmpDayData, { dayNum: 1, userName: userName });

                    __WEBPACK_IMPORTED_MODULE_12__publicMethod__["a" /* default */].addProps(tmpDayData, _this5.getAutoMode(res.data.data.auto_mode[index - 14]));

                    if (tmpDayData.autoTime || isOpen === 'open') {
                      SGnum += tmpDayData.SGnum;
                      sumSG += tmpDayData.sumSG;
                      below30Num += tmpDayData.below30Num;
                      TBRNum += tmpDayData.TBRNum;
                      TirNum += tmpDayData.TirNum;
                      tarNum += tmpDayData.tarNum;
                      beyond13Num += tmpDayData.beyond13Num;
                    }

                    if (tmpDayData.totalTime > targetTime) {
                      if (tmpDayData.autoTime) {
                        totalTime += tmpDayData.totalTime;
                        autoTime += tmpDayData.autoTime;
                      }

                      if (isOpen === 'open' || tmpDayData.autoTime) {
                        totalBasal = __WEBPACK_IMPORTED_MODULE_12__publicMethod__["a" /* default */].addNumFixed(totalBasal, tmpDayData.totalBasal);
                        totalBolus = __WEBPACK_IMPORTED_MODULE_12__publicMethod__["a" /* default */].addNumFixed(totalBolus, tmpDayData.totalBolus);
                      }
                      dayNum += 1;
                    }

                    umax = tmpDayData.umax;
                    newbasal = tmpDayData.newbasal;
                    var sumTDD = 0,
                        TDDnum = 0;
                    twoWeekRecords.map(function (i) {
                      if (i > 0) {
                        sumTDD += i;
                        TDDnum += 1;
                      }
                    });
                    avgTDD = _this5.getPercent(sumTDD, TDDnum, 1);
                    tmpDayData['avgTDD'] = avgTDD;
                    _this5.dailyDataMap[groupName][accountName][dataSource][isOpen][day] = tmpDayData;

                    var TIRPercent = _this5.getPercent(tmpDayData.TirNum, tmpDayData.SGnum, 2);

                    var TBRPercent = tmpDayData.SGnum ? _this5.getPercent(tmpDayData.TBRNum, tmpDayData.SGnum, 2) : -1;

                    _this5.TIRComparisonGraph[isOpen][accountName][day] = parseFloat(TIRPercent);

                    _this5.TBRComparisonGraph[isOpen][accountName][day] = parseFloat(TBRPercent);
                    twoWeekRecords.shift();
                    twoWeekRecords.push(tdd);
                  }
                });

                var lineData = { dayNum: dayNum, groupName: groupName, sumSG: sumSG, SGnum: SGnum, below30Num: below30Num, TBRNum: TBRNum, TirNum: TirNum, tarNum: tarNum, beyond13Num: beyond13Num, totalTime: totalTime, autoTime: autoTime, totalBasal: totalBasal, totalBolus: totalBolus };
                var _accountData2 = _this5.calculateData(lineData);
                _accountData2.account = accountName;
                _accountData2.userName = userName;
                _accountData2.data_source = dataSource;
                _accountData2.isOpen = postDataitem.isOpen;
                _accountData2.umax = umax;
                _accountData2.newbasal = newbasal;
                _this5.accountDataList.push(_accountData2);

                _this5.TIRDistributionGraph[isOpen].push([userName, parseFloat(_accountData2.TirPercent)]);

                _this5.A1CDistributionGraph[isOpen].push([userName, _this5.calA1C(_accountData2.avgSG)]);

                if (_this5.groupMap[groupName]) {
                  var _iteratorNormalCompletion13 = true;
                  var _didIteratorError13 = false;
                  var _iteratorError13 = undefined;

                  try {
                    for (var _iterator13 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(lineData)), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                      var _ref27 = _step13.value;

                      var _ref28 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref27, 2),
                          key = _ref28[0],
                          value = _ref28[1];

                      if (_this5.BGAttribute.find(function (x) {
                        return x === key;
                      }) !== undefined) {
                        _this5.groupMap[groupName][key] = _this5.groupMap[groupName][key] ? [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this5.groupMap[groupName][key]), [value]) : [_this5.groupMap[groupName][key]];
                      } else if (key !== 'groupName') {
                        _this5.groupMap[groupName][key] = _this5.groupMap[groupName][key] + value;
                      }
                    }
                  } catch (err) {
                    _didIteratorError13 = true;
                    _iteratorError13 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion13 && _iterator13.return) {
                        _iterator13.return();
                      }
                    } finally {
                      if (_didIteratorError13) {
                        throw _iteratorError13;
                      }
                    }
                  }
                } else {
                  _this5.groupMap[groupName] = lineData;
                  _this5.BGAttribute.map(function (key) {
                    _this5.groupMap[groupName][key] = [lineData[key]];
                  });
                }
                resolve('success');
              }
            } else {
              _this5.$message.warning("请求失败: ", _this5.accountList[accountName], ': ', { accountName: accountName, dataSource: dataSource });
              _this5.Loading = false;
              reject('error');
            }
          }).catch(function (e) {
            _this5.$message.warning("请求失败: ", _this5.accountList[accountName], ': ', { accountName: accountName, dataSource: dataSource });
            _this5.Loading = false;
            reject('error');
          });
        });
        return promise;
      } else {
        this.invalidAccount.push({ accountName: accountName });
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      }
    },
    uploadToServer: function uploadToServer(postData) {
      var _this6 = this;

      this.accountList = {};
      this.rangeList = {};
      postData.map(function (item) {
        _this6.accountList[item.account] = {};
        _this6.rangeList[item.account] = _this6.rangeList[item.account] || {};

        var dataSource = item.data_source === '实时' ? 'daopapp' : 'daoppdm';
        var isOpen = item.isOpen === '开环' ? 'open' : 'close';
        _this6.rangeList[item.account][dataSource] = _this6.rangeList[item.account][dataSource] || {};
        _this6.rangeList[item.account][dataSource][isOpen] = _this6.rangeList[item.account][dataSource][isOpen] ? [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this6.rangeList[item.account][dataSource][isOpen]), [item]) : [item];
      });
      var getUidData = {
        'username': __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.accountList)
      };
      this.Loading = true;
      this.$http.post('/api/v2.0/admin/user/get_uids', getUidData).then(function (res) {
        if (res.status === 200) {
          _this6.resetHCL();
          if (res.body.error === 0 && res.body.data.length !== 0) {
            res.body.data.map(function (item) {
              _this6.accountList[item[0]] = { uid: item[1], userName: item[2] };
            });
            _this6.sendRequest(postData, 3, _this6.afterRequest, _this6.oneRequest);
          } else {
            _this6.Loading = false;
            postData.map(function (item) {
              _this6.invalidAccount.push({ accountName: item.account });
            });
            __WEBPACK_IMPORTED_MODULE_12__publicMethod__["a" /* default */].invalidAccountMSG(_this6.invalidAccount, _this6);
          }
        } else {
          _this6.Loading = false;
          _this6.$message.warning('请求错误，网络异常');
        }
      }).catch(function (e) {
        _this6.Loading = false;
        _this6.$message.warning('请求错误，网络异常');
        console.log({ e: e });
      });
    }
  },
  created: function created() {
    this.tabLabel = [{
      'label': '汇总数据',
      'name': 'group',
      'tableData': this.groupDataList,
      'tabType': __WEBPACK_IMPORTED_MODULE_11__dataStatisticsTaableHeader_json__["groupData"]
    }, {
      'label': '个人汇总数据',
      'name': 'account',
      'tableData': this.accountDataList,
      'tabType': __WEBPACK_IMPORTED_MODULE_11__dataStatisticsTaableHeader_json__["accountData"]
    }, {
      'label': '个人每日数据',
      'name': 'daily',
      'tableData': this.dailyDataList,
      'tabType': __WEBPACK_IMPORTED_MODULE_11__dataStatisticsTaableHeader_json__["dailyData"]
    }];
  }
});

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HCLTable',
  data: function data() {
    return {
      currentPage: 1,
      dataText: '暂无数据',
      multipleTable: [],
      total: this.tableData.length
    };
  },

  props: {
    tableData: Array,
    tabType: Array,
    loading: Boolean,
    pagesize: Number
  },
  methods: {
    current_change: function current_change(currentPage) {
      this.currentPage = currentPage;
    }
  },
  watch: {
    tableData: {
      handler: function handler(val, oldval) {
        this.total = val.length;
      },

      deep: true
    }
  },
  created: function created() {}
});

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jspdf__ = __webpack_require__(1253);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HCLprint',
  data: function data() {
    return {
      sgMax: 25,
      sel_time: new Date(2019, 0, 1).getTime(),
      AGPGraphList: {
        'open': {
          'Q1Data': new Array(144),
          'midData': new Array(144),
          'Q2Data': new Array(144)
        },
        'close': {
          'Q1Data': new Array(144),
          'midData': new Array(144),
          'Q2Data': new Array(144)
        }
      },
      TIRComparisonList: {
        'open': {
          'Q1Data': new Array(),
          'midData': new Array(),
          'Q2Data': new Array(),
          'avgData': new Array()
        },
        'close': {
          'Q1Data': new Array(),
          'midData': new Array(),
          'Q2Data': new Array(),
          'avgData': new Array()
        }
      },
      TBRComparisonList: {
        'open': {
          'Q1Data': new Array(),
          'midData': new Array(),
          'Q2Data': new Array(),
          'avgData': new Array()
        },
        'close': {
          'Q1Data': new Array(),
          'midData': new Array(),
          'Q2Data': new Array(),
          'avgData': new Array()
        }
      },
      TIRDistributionList: {
        'open': new Array(),
        'close': new Array()
      },
      A1CDistributionList: {
        'open': new Array(),
        'close': new Array()
      }
    };
  },

  methods: {
    drawAGPGraph: function drawAGPGraph() {
      var id = 'AGPgraph';
      var XTimeMin = this.sel_time;
      var XTimeMax = this.sel_time + 86400 * 1000;
      this.AGPgraphChart = __WEBPACK_IMPORTED_MODULE_3_echarts__["init"](document.getElementById(id));
      this.AGPgraphChart.setOption({
        xAxis: [{
          type: 'time',
          interval: 3600 * 1000,
          min: XTimeMin,
          max: XTimeMax,
          splitNumber: 24,
          name: 'Hour of Day',
          nameGap: 25,
          nameTextStyle: {
            fontSize: 12,
            color: 'black'
          },
          axisLabel: {
            showMaxLabel: true,
            margin: 10, textStyle: { color: '#282828', baseline: 'middle' },
            formatter: function formatter(value, index) {
              index = (value - XTimeMin) / 3600000;
              var H = index;
              if (index < 24) {
                if (index % 3 === 0) {
                  H = H < 10 ? '0' + H + ':00' : H + ':00';
                  return H;
                } else {
                  return ' ';
                }
              } else {
                return '24:00';
              }
            }
          },
          nameLocation: 'middle'
        }],
        yAxis: [{
          type: 'value',
          min: 0,
          max: this.sgMax,
          show: true,
          name: 'Sensor Glucose [mmol/L]',
          nameLocation: 'middle',
          nameTextStyle: {
            color: '#282828',
            fontSize: 12
          },
          axisLabel: {
            margin: 1,
            textStyle: { color: '#282828', baseline: 'middle' }
          },
          splitLine: {
            show: false
          }
        }],
        grid: {
          show: true,
          borderColor: 'black'
        },
        legend: {
          top: '15%',
          right: '10%',
          orient: 'vertical',
          itemHeight: 5,
          itemStyle: {
            borderWidth: 2,
            borderType: 'solid'
          },
          formatter: function formatter(name) {
            var nameLegendMap = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a([['50%', 'Median Glucose Standard Therapy'], ['close50%', 'Median Glucose Hybrid Closed-Loop'], ['75%', '25%-75% Distribution Standard Therapy'], ['close75%', '25%-75% Distribution Hybrid Closed-Loop']]);
            return nameLegendMap.get(name);
          },

          data: [{
            name: 'close75%', icon: 'rect', itemStyle: { color: '#8caabe' }
          }, {
            name: '75%', icon: 'rect', itemStyle: { color: '#f5999a' }
          }, {
            name: 'close50%'
          }, {
            name: '50%'
          }]
        },
        series: [{
          name: '25%',
          type: 'line',
          data: this.AGPGraphList['open']['Q1Data'],
          stack: 'open',
          lineStyle: {
            normal: {
              color: '#f5999a',
              width: 1
            }
          },
          symbol: 'none',
          markLine: {
            data: [{ yAxis: 3.9 }, { yAxis: 10 }],
            silent: true,
            symbol: ['circle', 'circle'],
            symbolSize: 1,
            lineStyle: {
              normal: {
                color: 'black',
                type: [5, 10],
                dashOffset: 5,
                width: 1
              }
            },
            label: { normal: { show: false } }
          }
        }, {
          name: '50%',
          type: 'line',
          data: this.AGPGraphList['open']['midData'],
          lineStyle: {
            normal: {
              color: '#f5999a',
              width: 2
            }
          },
          symbol: 'none'
        }, {
          name: '75%',
          type: 'line',
          data: this.AGPGraphList['open']['Q2Data'],
          stack: 'open',
          areaStyle: { normal: { color: '#f5999a' } },
          lineStyle: {
            normal: {
              color: '#f5999a',
              width: 1
            }
          },
          symbol: 'none'
        }, {
          name: 'close25%',
          type: 'line',
          data: this.AGPGraphList['close']['Q1Data'],
          stack: 'close',
          lineStyle: {
            normal: {
              color: '#8caabe',
              width: 1
            }
          },
          symbol: 'none'
        }, {
          name: 'close50%',
          type: 'line',
          data: this.AGPGraphList['close']['midData'],
          lineStyle: {
            normal: {
              color: '#8caabe',
              width: 2,
              type: 'dashed'
            }
          },
          symbol: 'none'
        }, {
          name: 'close75%',
          type: 'line',
          data: this.AGPGraphList['close']['Q2Data'],
          stack: 'close',
          areaStyle: { normal: { color: '#8caabe' } },
          lineStyle: {
            normal: {
              color: '#8caabe',
              width: 1
            }
          },
          symbol: 'none'
        }]
      });
    },
    drawAGP19Graph: function drawAGP19Graph() {
      var id = 'AGP19graph';
      var XTimeMin = this.sel_time;
      var XTimeMax = this.sel_time + 86400 * 1000;
      this.AGP19graphChart = __WEBPACK_IMPORTED_MODULE_3_echarts__["init"](document.getElementById(id));
      this.AGP19graphChart.setOption({
        xAxis: [{
          type: 'time',
          interval: 3600 * 1000,
          min: XTimeMin,
          max: XTimeMax,
          splitNumber: 24,
          name: 'Hour of Day',
          nameGap: 25,
          nameTextStyle: {
            fontSize: 12,
            color: 'black'
          },
          axisLabel: {
            showMaxLabel: true,
            margin: 10, textStyle: { color: '#282828', baseline: 'middle' },
            formatter: function formatter(value, index) {
              index = (value - XTimeMin) / 3600000;
              var H = index;
              if (index < 24) {
                if (index % 3 === 0) {
                  H = H < 10 ? '0' + H + ':00' : H + ':00';
                  return H;
                } else {
                  return ' ';
                }
              } else {
                return '24:00';
              }
            }
          },
          nameLocation: 'middle'
        }],
        yAxis: [{
          type: 'value',
          min: 0,
          max: this.sgMax,
          show: true,
          name: 'Sensor Glucose [mmol/L]',
          nameLocation: 'middle',
          nameTextStyle: {
            color: '#282828',
            fontSize: 12
          },
          axisLabel: {
            margin: 1,
            textStyle: { color: '#282828', baseline: 'middle' }
          },
          splitLine: {
            show: false
          }
        }],
        grid: {
          show: true,
          borderColor: 'black'
        },
        legend: {
          top: '15%',
          right: '10%',
          orient: 'vertical',
          itemHeight: 5,
          itemStyle: {
            borderWidth: 2,
            borderType: 'solid'
          },
          formatter: function formatter(name) {
            var nameLegendMap = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a([['50%', 'Median Glucose Standard Therapy'], ['close50%', 'Median Glucose Hybrid Closed-Loop'], ['90%', '10%-90% Distribution Standard Therapy'], ['close90%', '10%-90% Distribution Hybrid Closed-Loop']]);
            return nameLegendMap.get(name);
          },

          data: [{
            name: 'close90%', icon: 'rect', itemStyle: { color: '#8caabe' }
          }, {
            name: '90%', icon: 'rect', itemStyle: { color: '#f5999a' }
          }, {
            name: 'close50%'
          }, {
            name: '50%'
          }]
        },
        series: [{
          name: '10%',
          type: 'line',
          data: this.AGPGraphList['open']['T1Data'],
          stack: 'open',
          lineStyle: {
            normal: {
              color: '#f5999a',
              width: 1
            }
          },
          symbol: 'none',
          markLine: {
            data: [{ yAxis: 3.9 }, { yAxis: 10 }],
            silent: true,
            symbol: ['circle', 'circle'],
            symbolSize: 1,
            lineStyle: {
              normal: {
                color: 'black',
                type: [5, 10],
                dashOffset: 5,
                width: 1
              }
            },
            label: { normal: { show: false } }
          }
        }, {
          name: '50%',
          type: 'line',
          data: this.AGPGraphList['open']['midData'],
          lineStyle: {
            normal: {
              color: '#f5999a',
              width: 2
            }
          },
          symbol: 'none'
        }, {
          name: '90%',
          type: 'line',
          data: this.AGPGraphList['open']['T9Data'],
          stack: 'open',
          areaStyle: { normal: { color: '#f5999a' } },
          lineStyle: {
            normal: {
              color: '#f5999a',
              width: 1
            }
          },
          symbol: 'none'
        }, {
          name: 'close10%',
          type: 'line',
          data: this.AGPGraphList['close']['T1Data'],
          stack: 'close',
          lineStyle: {
            normal: {
              color: '#8caabe',
              width: 1
            }
          },
          symbol: 'none'
        }, {
          name: 'close50%',
          type: 'line',
          data: this.AGPGraphList['close']['midData'],
          lineStyle: {
            normal: {
              color: '#8caabe',
              width: 2,
              type: 'dashed'
            }
          },
          symbol: 'none'
        }, {
          name: 'close90%',
          type: 'line',
          data: this.AGPGraphList['close']['T9Data'],
          stack: 'close',
          areaStyle: { normal: { color: '#8caabe' } },
          lineStyle: {
            normal: {
              color: '#8caabe',
              width: 1
            }
          },
          symbol: 'none'
        }]
      });
    },
    drawComparison: function drawComparison(comparisonList, id) {
      var _ref2;

      var maxY = 100,
          Yname = 'Percent of Time with Glucose \n3.9-10mmol/L';
      var maxX = comparisonList.Q2Data[comparisonList.Q2Data.length - 1][0] + 1;
      var baseLineAvg = [comparisonList.avgData.shift()];
      var baseLineQ2 = [comparisonList.Q2Data.shift()];
      if (id.match(/TBR/g)) {
        maxY = 10;
        Yname = 'Percent of Time with Glucose \n<3.9mmol/L';
      }
      this.comparisonChart = __WEBPACK_IMPORTED_MODULE_3_echarts__["init"](document.getElementById(id));
      this.comparisonChart.setOption({
        xAxis: [__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
          type: 'value',
          name: 'Weeks',
          min: 0,
          max: maxX,
          interval: 0.5,
          nameTextStyle: {
            color: '#282828'
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            margin: 15, textStyle: { color: '#282828', baseline: 'middle', fontSize: 16 },
            formatter: function formatter(value, index) {
              if (value === 0) {
                return '0';
              } else if (value === 1) {
                return 'Baseline';
              } else if (parseInt(value) === value) {
                return (value - 1) * 4 - 3 + '-' + (value - 1) * 4;
              }
            }
          },
          axisTick: {
            show: true
          },
          nameLocation: 'middle',
          nameGap: 25
        }, "nameTextStyle", {
          fontSize: 18,
          color: 'black'
        })],
        yAxis: [(_ref2 = {
          type: 'value',
          min: 0,
          max: maxY,
          show: true,
          name: Yname,
          nameLocation: 'middle',
          nameTextStyle: {
            color: '#282828'
          },
          nameGap: 30
        }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref2, "nameTextStyle", {
          fontSize: 18,
          color: 'black'
        }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref2, "axisLabel", {
          margin: 8,
          textStyle: { color: '#282828', baseline: 'middle', fontSize: 16 }
        }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref2, "splitNumber", 10), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref2, "splitLine", {
          show: false
        }), _ref2)],
        legend: {
          top: '10%',
          itemHeight: 5,
          itemStyle: {
            borderWidth: 2,
            borderType: 'solid'
          },
          formatter: function formatter(name) {
            var nameLegendMap = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a([['75%', 'Control (N=56)'], ['close75%', 'Closed loop (N=112)']]);
            return nameLegendMap.get(name);
          },
          data: [{
            name: 'close75%', icon: 'roundRect', itemStyle: { color: '#8caabe', borderColor: '#8caabe' }
          }, {
            name: '75%', icon: 'roundRect', itemStyle: { color: '#f5999a', borderColor: '#f5999a' }
          }]
        },
        series: [{
          name: '25%',
          type: 'custom',
          stack: 'open',
          itemStyle: {
            borderColor: 'white',
            color: 'white'
          },
          data: comparisonList.Q1Data,
          zlevel: -1,
          renderItem: function renderItem(params, api) {
            var y = api.value(1);
            var start = api.coord([api.value(0), y]);
            var size = api.size([1, y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0] - 1,
                y: start[1],
                width: size[0] / 2 + 2,
                height: size[1]
              },
              style: style
            };
          }
        }, {
          name: '75%',
          stack: 'open',
          type: 'custom',
          itemStyle: {
            color: '#f5999a',
            borderColor: 'white'
          },
          data: baseLineQ2,
          zlevel: -999,
          renderItem: function renderItem(params, api) {
            var y = api.value(1);
            var start = api.coord([api.value(0), y]);
            var size = api.size([1, y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0] / 2,
                height: size[1]
              },
              style: style
            };
          }
        }, {
          name: 'avg',
          type: 'line',
          data: baseLineAvg,
          symbol: 'circle',
          symbolSize: 6,
          itemStyle: {
            color: 'black'
          }
        }, {
          name: '50%',
          type: 'line',
          data: comparisonList.midData,
          lineStyle: {
            normal: {
              color: 'black',
              width: 2
            }
          },
          symbol: 'none'
        }, {
          name: 'close75%',
          type: 'custom',
          itemStyle: {
            color: '#8caabe',
            borderColor: 'white'
          },
          zlevel: -999,
          data: comparisonList.Q2Data,
          renderItem: function renderItem(params, api) {
            var y = api.value(1);
            var start = api.coord([api.value(0), y]);
            var size = api.size([1, y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0] / 2,
                height: size[1]
              },
              style: style
            };
          }
        }, {
          name: 'closeavg',
          type: 'line',
          data: comparisonList.avgData,
          symbol: 'circle',
          symbolSize: 6,
          lineStyle: {
            color: 'black',
            type: 'dashed'
          },
          itemStyle: {
            color: 'black'
          }
        }]
      });
    },
    drawDistributionList: function drawDistributionList() {
      var _ref4,
          _this = this;

      var id = 'TIRDistribution';
      this.distributionChart = __WEBPACK_IMPORTED_MODULE_3_echarts__["init"](document.getElementById(id));
      this.distributionChart.setOption({
        xAxis: [__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
          type: 'value',
          name: 'Time sensor glucose within target range(%)',
          nameTextStyle: {
            color: '#282828'
          },
          min: 0,
          max: 100,
          interval: 10,
          splitLine: {
            show: false
          },
          axisLabel: {
            margin: 15, textStyle: { color: '#282828', baseline: 'middle', fontSize: 16 }
          },
          nameLocation: 'middle',
          nameGap: 25
        }, "nameTextStyle", {
          fontSize: 18,
          color: 'black'
        })],
        yAxis: [(_ref4 = {
          type: 'value',
          min: 0,
          max: 100,
          interval: 20,
          show: true,
          name: 'Cumulative distribution(%)',
          nameLocation: 'middle',
          nameTextStyle: {
            color: '#282828'
          },
          nameGap: 30
        }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref4, "nameTextStyle", {
          fontSize: 18,
          color: 'black'
        }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref4, "axisLabel", {
          margin: 8,
          textStyle: { color: '#282828', baseline: 'middle', fontSize: 16 }
        }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref4, "splitLine", {
          show: false
        }), _ref4)],
        tooltip: {
          show: true,
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            axis: 'x',
            lineStyle: { color: '#333' }
          },
          backgroundColor: '#555',
          textStyle: {
            color: ' #ffffff',
            align: 'left'
          },
          formatter: function formatter(params) {
            var tip = '';
            params.map(function (item) {
              tip += item.marker + _this.TIRDistributionList[item.seriesName].nameList[item.dataIndex] + ': ' + item.value[0] + '%';
              tip += '<br/>';
            });
            return tip;
          }
        },
        legend: {
          top: '10%',
          left: '15%',
          orient: 'vertical',
          formatter: function formatter(name) {
            var nameLegendMap = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a([['open', 'Control'], ['close', 'Closed loop']]);
            return nameLegendMap.get(name);
          }
        },
        series: [{
          name: 'open',
          type: 'line',
          data: this.TIRDistributionList['open'].value,
          symbol: 'triangle',
          symbolSize: 8,
          itemStyle: {
            color: '#851b3d'
          }
        }, {
          name: 'close',
          type: 'line',
          data: this.TIRDistributionList['close'].value,
          symbol: 'circle',
          symbolSize: 6,
          itemStyle: {
            color: '#50a2bb'
          }
        }]
      });
    },
    drawA1CDistribution: function drawA1CDistribution() {
      var _ref5,
          _this2 = this;

      var id = 'A1CDistribution';
      this.distributionChart = __WEBPACK_IMPORTED_MODULE_3_echarts__["init"](document.getElementById(id));
      this.distributionChart.setOption({
        xAxis: [{
          type: 'value',
          name: 'A1C(%)',
          min: 4,
          max: 10,
          interval: 1,
          axisLabel: {
            margin: 15, textStyle: { color: '#282828', baseline: 'middle', fontSize: 16 }
          },
          nameLocation: 'middle',
          nameGap: 25,
          nameTextStyle: {
            fontSize: 18,
            color: 'black'
          }
        }],
        yAxis: [(_ref5 = {
          type: 'value',
          min: 0,
          max: 1,
          interval: 0.2,
          show: true,
          name: 'Cumulative distribution(%)',
          nameLocation: 'middle',
          nameTextStyle: {
            color: '#282828'
          },
          nameGap: 30
        }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref5, "nameTextStyle", {
          fontSize: 18,
          color: 'black'
        }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref5, "axisLabel", {
          margin: 8,
          textStyle: { color: '#282828', baseline: 'middle', fontSize: 16 }
        }), _ref5)],
        legend: {
          top: '15%',
          left: '15%',
          orient: 'vertical',
          borderType: 'solid',
          borderColor: 'black',
          borderWidth: '1',
          formatter: function formatter(name) {
            var nameLegendMap = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a([['open', 'A1C(%)@baseline'], ['close', 'A1C(%)@study']]);
            return nameLegendMap.get(name);
          },
          data: [{
            name: 'open', icon: 'roundRect', itemStyle: { color: '#fd0301', borderColor: '#fd0301' }
          }, {
            name: 'close', icon: 'roundRect', itemStyle: { color: '#0100c8', borderColor: '#0100c8' }
          }]
        },
        grid: {
          show: true,
          borderColor: 'black'
        },
        tooltip: {
          show: true,
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            axis: 'x',
            lineStyle: { color: '#333' }
          },
          backgroundColor: '#555',
          textStyle: {
            color: ' #ffffff',
            align: 'left'
          },
          formatter: function formatter(params) {
            var tip = '';
            params.map(function (item) {
              tip += item.marker + _this2.A1CDistributionList[item.seriesName].nameList[item.dataIndex] + ': ' + item.value[0] + '%';
              tip += '<br/>';
            });
            return tip;
          }
        },
        series: [{
          name: 'open',
          type: 'line',
          data: this.A1CDistributionList['open'].value,
          lineStyle: {
            width: 6,
            color: '#fd0301'
          },
          symbol: 'circle',
          symbolSize: 6,
          itemStyle: {
            color: '#fd0301'
          }
        }, {
          name: 'close',
          type: 'line',
          data: this.A1CDistributionList['close'].value,
          symbol: 'circle',
          symbolSize: 6,
          itemStyle: {
            color: '#0100c8'
          },
          lineStyle: {
            width: 6,
            color: '#0100c8'
          }
        }]
      });
    },
    validateList: function validateList(list) {
      if (list && list['open'] && list['open'].Q1Data.length) {
        return true;
      } else {
        return false;
      }
    },
    drawGraph: function drawGraph() {
      if (this.validateList(this.AGPGraphList)) {
        this.drawAGPGraph();
        this.drawAGP19Graph();
      }

      if (this.TIRComparisonList && this.TIRComparisonList.Q1Data.length) {
        this.drawComparison(this.TIRComparisonList, 'TIRComparison');
      }

      if (this.TBRComparisonList && this.TBRComparisonList.Q1Data.length) {
        this.drawComparison(this.TBRComparisonList, 'TBRComparison');
      }

      if (this.TIRDistributionList && this.TIRDistributionList.open.value.length) {
        this.drawDistributionList();
      }

      if (this.A1CDistributionList && this.A1CDistributionList.open.value.length) {
        this.drawA1CDistribution();
      }
    },
    exportPDF: function exportPDF() {
      var target = document.getElementsByClassName("graph");
      var promiseList = [];
      var pdf = new __WEBPACK_IMPORTED_MODULE_5_jspdf__["a" /* default */]('1', 'pt', 'a4');
      var position = 20;

      var _loop = function _loop(i) {
        var promise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          __WEBPACK_IMPORTED_MODULE_4_html2canvas___default()(target[i]).then(function (canvas) {
            target[i].style.background = "#FFFFFF";
            var pageData = canvas.toDataURL('image/jpeg', 1.0);
            var contentWidth = canvas.width;
            var contentHeight = canvas.height;
            var imgWidth = 595.28;
            var imgHeight = 592.28 / contentWidth * contentHeight;

            if (i !== 0 && i % 2 === 0) {
              position = 20;
              pdf.addPage();
              pdf.setPage(i / 2 + 1);
            }
            pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
            position += imgHeight;
            resolve();
          });
        });
        promiseList.push(promise);
      };

      for (var i = 0; i < target.length; i++) {
        _loop(i);
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promiseList).then(function () {
        pdf.save("graph.pdf", { returnPromise: true }).then(function (res) {
          localStorage.removeItem('HCLGraph');
          setTimeout(function () {
            window.close();
          }, 500);
        });
      });
    }
  },
  mounted: function mounted() {
    var graphData = JSON.parse(localStorage.getItem('HCLGraph'));
    if (graphData) {
      this.AGPGraphList = graphData.AGPGraphList;
      this.TIRComparisonList = graphData.TIRComparisonList;
      this.TIRDistributionList = graphData.TIRDistributionList;
      this.TBRComparisonList = graphData.TBRComparisonList;
      this.A1CDistributionList = graphData.A1CDistributionList;
      this.drawGraph();
    }
  }
});

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xlsx__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_xlsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_format_js__ = __webpack_require__(8);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Upload',
  mounted: function mounted() {},

  props: {
    dataType: String
  },
  data: function data() {
    return {
      uploadFileName: '',

      isUploaded: false,
      uploadPercentage: 0,
      uploadData: [],
      isEmpty: false,
      dialogVisible: false,
      error: false
    };
  },

  methods: {
    showProcess: function showProcess(filename) {
      this.uploadPercentage = 0;
      this.uploadFileName = '';
      this.isUploaded = true;
      this.isEmpty = false;
      for (var i = 0; i < 10; i++) {
        (function (i) {
          var _this = this;

          setTimeout(function () {
            _this.uploadPercentage = (i + 1) * 10;
            if (_this.uploadPercentage === 100) {
              _this.uploadFileName = filename;
            }
          }, 15 * (i + 1));
        }).call(this, i);
      }
    },
    upload: function upload(event) {
      this.uploadData = [];
      this.readExcel(event);
    },
    formatDate: function formatDate(numb, timeZone) {
      var resTime = numb;
      if (typeof numb === 'number') {
        var old = numb - 1;
        var t = Math.round((old - Math.floor(old)) * 24 * 60 * 60);
        var time = new Date(1900, 0, old, 0, 0, t);
        resTime = time.getFullYear() + '/' + (time.getMonth() + 1) + '/' + time.getDate();
      }
      if (typeof resTime !== 'string') {
        return false;
      }
      if (timeZone && timeZone.match(/^GMT/g)) {
        var number = timeZone.split('GMT')[1];
        if (number && !['-', '+'].includes(number[0])) {
          timeZone = 'GMT' + '+' + number;
        }
        resTime = resTime + ' ' + timeZone;
      }
      return resTime;
    },
    isvalidDate: function isvalidDate(date) {
      if (!date.startDate || !date.endDate) {
        return false;
      }
      var flag = true;
      try {
        flag = new Date(date.startDate).getFullYear();
      } catch (e) {
        console.log("error: ", { date: date }, e);
      }

      if (!flag) {
        return flag;
      }
      if (date.endDate) {
        flag = new Date(date.endDate).getFullYear();
      }

      return flag;
    },
    getRange: function getRange(value) {
      var testReg = new RegExp('^\\[.+,.+]$', 'g');
      var min = 0,
          max = 0;
      if (typeof value === 'string' && value.match(testReg)) {
        var _value$replace$split = value.replace(/\[|]/g, '').split(','),
            _value$replace$split2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_value$replace$split, 2),
            left = _value$replace$split2[0],
            right = _value$replace$split2[1];

        min = +left, max = +right;
        if (!__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default()(min) && !__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default()(max) && min <= max) {
          return [min, max];
        }
      }
      return false;
    },
    readExcel: function readExcel(e) {
      var _this2 = this;

      var inputDOM = this.$refs.inputer;
      var files = inputDOM.files[0];
      this.error = false;
      if (!files) {
        return false;
      } else if (!/\.(xls||xlsx)$/.test(files.name.toLowerCase())) {
        this.$message.error('上传格式不正确，请上传xls或xlsx格式');
        return false;
      }
      var fileReader = new FileReader();
      fileReader.readAsBinaryString(files);
      fileReader.onload = function (ev) {
        var data = ev.target.result;
        var workbook = __WEBPACK_IMPORTED_MODULE_4_xlsx___default.a.read(data, {
          type: 'binary'
        });
        var wsname = workbook.SheetNames[0];
        var ws = __WEBPACK_IMPORTED_MODULE_4_xlsx___default.a.utils.sheet_to_json(workbook.Sheets[wsname]);
        var errorAccount = [];
        if (ws.length !== 0) {
          var relateName = { '开始日期': 'startDate', '开闭环': 'isOpen', '数据来源': 'data_source', '组别': 'group', '结束日期': 'endDate', '账号': 'account',
            'Avg.SG': 'avgSG', '<3.0': 'below30Percent', 'TBR': 'TBRPercent', 'TIR': 'TirPercent', 'TAR': 'tarPercent', '>13.9': 'beyond13Percent',
            'Auto%': 'AutoPercent', 'Basal%': 'basalPercent', 'Bolus%': 'bolusPercent', '(TDD/Avg.TDD)%': 'TDDPercent',
            '时区': 'timeZone'
          };
          for (var item in ws) {
            var tmp = {
              'startDate': '',
              'isOpen': '',
              'data_source': '',
              'group': '',
              'endDate': '',
              'account': '',
              'avgSG': '',
              'below30Percent': '',
              'TBRPercent': '',
              'TirPercent': '',
              'tarPercent': '',
              'beyond13Percent': '',
              'AutoPercent': '',
              'basalPercent': '',
              'bolusPercent': '',
              'TDDPercent': '',
              'timeZone': ''
            };
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(ws[item])), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _ref = _step.value;

                var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                var key = _ref2[0];
                var value = _ref2[1];

                if (['开始日期', '结束日期'].includes(key)) {
                  value = _this2.formatDate(value, ws[item]['时区']);
                  tmp[relateName[key]] = value;
                } else if (['开闭环', '数据来源', '组别', '账号'].includes(key)) {
                  if (typeof value !== 'string') {
                    value = value + '';
                  }
                  tmp[relateName[key]] = value.trim();
                } else if (['Avg.SG', '<3.0', 'TBR', 'TIR', 'TAR', '>13.9', 'Auto%', 'Basal%', 'Bolus%', '(TDD/Avg.TDD)%'].includes(key)) {
                  var range = _this2.getRange(value);
                  if (range) {
                    tmp[relateName[key]] = range;
                  } else {
                    _this2.$message({
                      showClose: true,
                      message: ws[item]['组别'] + '\u7EC4\u522B\u4E0B, ' + ws[item]['账号'] + '\u8D26\u53F7\u7684' + key + '\u53D6\u503C\u8303\u56F4\u6709\u8BEF\uFF01',
                      type: 'error'
                    });
                    _this2.error = true;
                  }
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            if (!tmp.endDate) {
              var time = new Date();
              var gmt = tmp.startDate.split('GMT')[1];
              time = __WEBPACK_IMPORTED_MODULE_5__lib_format_js__["a" /* default */].convertTimeZone(time, gmt).setHours(0, 0, 0, 0) / 1000;
              tmp.endDate = __WEBPACK_IMPORTED_MODULE_5__lib_format_js__["a" /* default */].formatterDateHCL(time) + ' GMT' + gmt;
            }
            if (!_this2.isvalidDate(tmp) || new Date(tmp.startDate) > new Date(tmp.endDate)) {
              errorAccount.push(tmp);
            } else {
              _this2.uploadData.push(tmp);
            }
            _this2.showProcess(inputDOM.files[0]['name']);
          }
        } else {
          _this2.$message.error('文件内容不规范！');
        }
        if (errorAccount.length !== 0) {
          var h = _this2.$createElement;
          _this2.$msgbox({
            confirmButtonText: '确定',
            message: h('div', [h('span', '提示: 下列账号时间设置有误，将不会显示结果!'), h('div', {
              style: {
                border: "1px solid black",
                margin: "30px 0 0 10%",
                width: "80%",
                height: "100px",
                overflow: "auto"
              } }, errorAccount.map(function (item) {
              if (_this2.dataType === 'HCL') {
                return h('p', item.group + '\u7EC4\u522B\u4E0B, ' + item.account + '\u8D26\u53F7\u7684' + item.data_source + '\u6570\u636E');
              } else {
                return h('p', '\u8D26\u6237' + item.account + '\u7684' + item.data_source + '\u6570\u636E');
              }
            }))])
          });
        }

        _this2.$refs.inputer.value = null;
      };
    },
    cancelUpload: function cancelUpload() {
      this.isUploaded = false;
      this.uploadPercentage = 0;
      this.uploadFileName = '';
      this.uploadData = '';
      this.error = false;
    },
    uploadToServer: function uploadToServer() {
      if (this.uploadData.length !== 0 && !this.error) {
        this.$emit('uploadToServer', this.uploadData);
        this.cancelUpload();
      } else {
        this.isEmpty = true;
        this.$message.warning('请先上传文件');
      }
    }
  },
  watch: {}
});

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__HCLTable_vue__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__HCLTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__HCLTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_Export2Excel_js__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dataStatisticsTaableHeader_json__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dataStatisticsTaableHeader_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__dataStatisticsTaableHeader_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__publicMethod__ = __webpack_require__(340);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'insulinStatistics',
  components: {
    HCLTable: __WEBPACK_IMPORTED_MODULE_6__HCLTable_vue___default.a
  },
  data: function data() {
    return {
      insulinData: __WEBPACK_IMPORTED_MODULE_8__dataStatisticsTaableHeader_json__["insulinData"],
      InsulinDataList: [],
      InsulinDataMap: {},
      accountInsulinDataMap: {},
      rangeList: {},
      outliers: {},
      loading: false,
      pagesize: 10,
      invalidAccount: [],
      allowType: ['BAS', 'BAE', 'BAH', 'BAPB', 'BAPA', 'BAPC', 'BAPD', 'BASK']
    };
  },

  methods: {
    exportExcel: function exportExcel() {
      if (this.loading) {
        this.$message.warning('数据量较大请等待加载完成');
      } else {
        var writeData = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(this.accountInsulinDataMap)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref = _step.value;

            var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                account = _ref2[0],
                accountValue = _ref2[1];

            writeData.push({
              'tableType': __WEBPACK_IMPORTED_MODULE_8__dataStatisticsTaableHeader_json__["insulinData"],
              'sheetName': account,
              'tableData': accountValue
            });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        writeData.push({
          'tableType': __WEBPACK_IMPORTED_MODULE_8__dataStatisticsTaableHeader_json__["invalidAccountData"],
          'tableData': this.invalidAccount,
          'sheetName': '无效账号'
        });
        if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.accountInsulinDataMap).length) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_Export2Excel_js__["a" /* default */])(writeData, 'Insulin statistics');
        }
      }
    },
    getInsulinBasal: function getInsulinBasal(dayData, dayTime) {
      var _this = this;

      var HOUR = 3600;
      var index = 0,
          interval = 3600,
          startTime = 0,
          endTime = 0,
          speed = 0,
          totalBasal = 0,
          autoBasal = 0,
          autoBolus = 0;
      var baseIndex = parseInt(dayTime / interval);
      var res = {};
      if (dayData.length) {
        dayData.map(function (item, i) {
          var basalType = item[2];
          var recordIdPart = item[0].split('-')[3];
          if ('9999' !== recordIdPart && '65535' !== recordIdPart) {
            startTime = item[1];

            if (_this.allowType.includes(basalType)) {
              speed = item[4];
              endTime = item[1] + item[3];
              while (startTime < endTime) {
                index = Math.floor(startTime / interval);
                var endIndex = Math.floor(endTime / interval);
                if (endIndex !== index) {
                  res['Basal' + (index - baseIndex + 1)] = __WEBPACK_IMPORTED_MODULE_9__publicMethod__["a" /* default */].addNumFixed(res['Basal' + (index - baseIndex + 1)] || 0, (interval - startTime % interval) / HOUR * speed);
                  startTime = (index + 1) * interval;
                } else {
                  res['Basal' + (index - baseIndex + 1)] = __WEBPACK_IMPORTED_MODULE_9__publicMethod__["a" /* default */].addNumFixed(res['Basal' + (index - baseIndex + 1)] || 0, (endTime - startTime) / HOUR * speed);
                  startTime = endTime;
                }
              }
              totalBasal += item[5];
            } else if ('BAAM' === basalType) {
                var duration = 360;
                var autoModeData = item[7];
                endTime = startTime;
                if (autoModeData) {
                  autoModeData = JSON.parse(autoModeData);
                  var microBolusJson = autoModeData['autoModeJSON'];
                  var cur_auto_basal_total = 0;
                  var cur_auto_bolus_total = 0;

                  microBolusJson.map(function (microBolusitem) {
                    endTime = endTime + duration;
                    while (startTime < endTime) {
                      index = Math.floor(startTime / interval);
                      var _endIndex = Math.floor(endTime / interval);

                      var autoBasalSpeed = microBolusitem['auto_basal_delivery'] * 0.5;
                      var autoBolusSpeed = (microBolusitem['auto_food_delivery'] + microBolusitem['auto_corr_delivery']) * 0.5;

                      if (_endIndex !== index) {
                        res['Basal' + (index - baseIndex + 1)] = __WEBPACK_IMPORTED_MODULE_9__publicMethod__["a" /* default */].addNumFixed(res['Basal' + (index - baseIndex + 1)] || 0, (interval - startTime % interval) / HOUR * autoBasalSpeed);
                        res['Bolus' + (index - baseIndex + 1)] = __WEBPACK_IMPORTED_MODULE_9__publicMethod__["a" /* default */].addNumFixed(res['Bolus' + (index - baseIndex + 1)] || 0, (interval - startTime % interval) / HOUR * autoBolusSpeed);
                        startTime = (index + 1) * interval;
                      } else {
                        res['Basal' + (index - baseIndex + 1)] = __WEBPACK_IMPORTED_MODULE_9__publicMethod__["a" /* default */].addNumFixed(res['Basal' + (index - baseIndex + 1)] || 0, (endTime - startTime) / HOUR * autoBasalSpeed);
                        res['Bolus' + (index - baseIndex + 1)] = __WEBPACK_IMPORTED_MODULE_9__publicMethod__["a" /* default */].addNumFixed(res['Bolus' + (index - baseIndex + 1)] || 0, (endTime - startTime) / HOUR * autoBolusSpeed);
                        startTime = endTime;
                      }
                    }
                    cur_auto_basal_total += microBolusitem['auto_basal_delivery'];
                    cur_auto_bolus_total += microBolusitem['auto_food_delivery'] + microBolusitem['auto_corr_delivery'];
                  });
                  autoBasal += cur_auto_basal_total * 0.05;
                  autoBolus += cur_auto_bolus_total * 0.05;
                }
              }
          }
        });
        res["totalBasal"] = __WEBPACK_IMPORTED_MODULE_9__publicMethod__["a" /* default */].addNumFixed(totalBasal, autoBasal);
        res['autoBolus'] = Math.round(autoBolus * 100) / 100;

        res['totalBolus'] = Math.round(autoBolus * 100) / 100;
      }
      return res;
    },
    getInsulinBolus: function getInsulinBolus(dayData, dayTime) {
      var index = 0,
          interval = 3600,
          startTime = 0,
          totalBolus = 0;
      var baseIndex = parseInt(dayTime / interval);
      var res = {};
      if (dayData.length) {
        dayData.map(function (item) {
          if (item[0].split('-')[3] < 8888) {
            startTime = item[1];
            index = Math.floor(startTime / interval);
            res['Bolus' + (index - baseIndex + 1)] = __WEBPACK_IMPORTED_MODULE_9__publicMethod__["a" /* default */].addNumFixed(res['Bolus' + (index - baseIndex + 1)] || 0, item[4] + item[6]);
            totalBolus += item[4] + item[6];
          }
        });
        res['totalBolus'] = Math.round(totalBolus * 100) / 100;
      }
      return res;
    },
    resetInsulin: function resetInsulin() {
      this.invalidAccount.length = 0;
      this.InsulinDataList.length = 0;
      this.InsulinDataMap = {};
      this.accountInsulinDataMap = {};
    },
    uploadToServer: function uploadToServer(postData) {
      var _this2 = this;

      var accountList = {};
      this.rangeList = {};
      postData.map(function (item) {
        accountList[item.account] = '';
      });
      var getUidData = {
        'username': __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(accountList)
      };
      this.loading = true;
      this.$http.post('/api/v2.0/admin/user/get_uids', getUidData).then(function (res) {
        if (res.status === 200) {
          _this2.resetInsulin();
          if (res.body.error === 0 && res.body.data.length !== 0) {
            res.body.data.map(function (item) {
              accountList[item[0]] = { uid: item[1], userName: item[2] };
            });
            var promiseList = [];
            postData.map(function (postDataitem, index) {
              var TS = __WEBPACK_IMPORTED_MODULE_5__auth_auth__["a" /* default */].getTs(new Date(postDataitem.startDate) / 1000, new Date(postDataitem.endDate) / 1000);
              var accountName = postDataitem.account;
              var userName = accountList[accountName].userName;
              var startDate = postDataitem.startDate;
              var dataSource = postDataitem.data_source === '实时' ? 'daopapp' : 'daoppdm';
              if (accountList[accountName].uid) {
                var param = {
                  basal: { ts: TS },
                  bolus: { ts: TS },
                  data_source: dataSource
                };
                _this2.InsulinDataMap[accountName] = _this2.InsulinDataMap[accountName] || {};
                _this2.InsulinDataMap[accountName][dataSource] = _this2.InsulinDataMap[accountName][dataSource] || {};
                var promise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this2.$http.post('/api/v2.1/data/' + accountList[accountName].uid, param).then(function (res) {
                    if (res.status === 200) {
                      if (res.body.error === 0) {
                        res.data.data.basal.map(function (dayData, index) {
                          var dayTime = new Date(startDate).getTime() / 1000 + 86400 * index;
                          var day = __WEBPACK_IMPORTED_MODULE_9__publicMethod__["a" /* default */].formatterDate(startDate, index);

                          _this2.InsulinDataMap[accountName][dataSource][day] = _this2.getInsulinBasal(dayData, dayTime);
                          __WEBPACK_IMPORTED_MODULE_9__publicMethod__["a" /* default */].addProps(_this2.InsulinDataMap[accountName][dataSource][day], _this2.getInsulinBolus(res.data.data.bolus[index], dayTime));
                          _this2.InsulinDataMap[accountName][dataSource][day].userName = userName;
                        });
                        resolve();
                      }
                    } else {
                      console.log("请求失败：", accountList[accountName], ': ', { accountName: accountName, dataSource: dataSource });
                    }
                  });
                });
                promiseList.push(promise);
              } else {
                _this2.invalidAccount.push({ accountName: accountName });
              }
            });
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promiseList).then(function () {
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(_this2.InsulinDataMap)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _InsulinDataList;

                  var _ref3 = _step2.value;

                  var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
                      account = _ref4[0],
                      accountValue = _ref4[1];

                  var tmpData = [];
                  var _iteratorNormalCompletion3 = true;
                  var _didIteratorError3 = false;
                  var _iteratorError3 = undefined;

                  try {
                    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(accountValue)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                      var _ref5 = _step3.value;

                      var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
                          dataSource = _ref6[0],
                          dataSourceValue = _ref6[1];

                      var _iteratorNormalCompletion4 = true;
                      var _didIteratorError4 = false;
                      var _iteratorError4 = undefined;

                      try {
                        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(dataSourceValue)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                          var _ref7 = _step4.value;

                          var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref7, 2),
                              date = _ref8[0],
                              dateValue = _ref8[1];

                          var dailyMap = { data_source: dataSource, date: date, account: account };
                          __WEBPACK_IMPORTED_MODULE_9__publicMethod__["a" /* default */].addProps(dailyMap, dateValue);
                          tmpData.push(dailyMap);
                        }
                      } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                          }
                        } finally {
                          if (_didIteratorError4) {
                            throw _iteratorError4;
                          }
                        }
                      }
                    }
                  } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                      }
                    } finally {
                      if (_didIteratorError3) {
                        throw _iteratorError3;
                      }
                    }
                  }

                  tmpData.sort(function (x, y) {
                    return new Date(x.date) - new Date(y.date);
                  });
                  (_InsulinDataList = _this2.InsulinDataList).push.apply(_InsulinDataList, tmpData);
                  _this2.accountInsulinDataMap[account] = tmpData;
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }

              _this2.loading = false;
              __WEBPACK_IMPORTED_MODULE_9__publicMethod__["a" /* default */].invalidAccountMSG(_this2.invalidAccount, _this2);
            });
          } else {
            _this2.loading = false;
            postData.map(function (item) {
              _this2.invalidAccount.push({ accountName: item.account });
            });
            __WEBPACK_IMPORTED_MODULE_9__publicMethod__["a" /* default */].invalidAccountMSG(_this2.invalidAccount, _this2);
          }
        } else {}
      });
    }
  }
});

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dataSTS_Upload_vue__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dataSTS_Upload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__dataSTS_Upload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dataSTS_insulinStatistics_vue__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dataSTS_insulinStatistics_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__dataSTS_insulinStatistics_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dataSTS_HCLStatistics_vue__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dataSTS_HCLStatistics_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__dataSTS_HCLStatistics_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Upload: __WEBPACK_IMPORTED_MODULE_1__dataSTS_Upload_vue___default.a,
    insulinStatistics: __WEBPACK_IMPORTED_MODULE_2__dataSTS_insulinStatistics_vue___default.a,
    HCLStatistics: __WEBPACK_IMPORTED_MODULE_3__dataSTS_HCLStatistics_vue___default.a
  },
  data: function data() {
    return {
      currentComponent: 'HCLStatistics',
      permission: '',
      title: '',
      dataType: 'HCL',
      componentMap: new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a([['HCL', 'HCLStatistics'], ['Insulin', 'insulinStatistics']]),
      dataTypeList: [{
        "value": "HCL",
        "label": "HCL statistics"
      }, {
        "value": "Insulin",
        "label": "Insulin statistics"
      }]
    };
  },

  methods: {
    navToHome: function navToHome() {
      this.$router.push('/accountsadmin_home');
    },
    uploadToServer: function uploadToServer(uploadData) {
      this.$refs.upload.dialogVisible = false;
      this.$refs.child.uploadToServer(uploadData);
    },
    exportExcel: function exportExcel() {
      this.$refs.child.exportExcel();
    },
    exportGraph: function exportGraph() {
      this.$refs.child.exportGraph();
    },
    changeDadaType: function changeDadaType() {
      this.currentComponent = this.componentMap.get(this.dataType);
    },
    showUploadDialog: function showUploadDialog() {
      this.$refs.upload.dialogVisible = true;
    }
  },
  mounted: function mounted() {
    var permission = sessionStorage.getItem('account_admin_permission_value');
    var title = sessionStorage.getItem('account_admin_permission_title');
    this.permission = permission;
    this.title = title;
  }
});

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_base64__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_format__ = __webpack_require__(8);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      value1: '', value2: '',
      defaultDate: '17-8-2017', count1: 0, count: 0, end: '', sta: '', st: '', et: '',
      defaultDate2: '17-8-2017',
      typeChooseVisible: false, dialogSize: 'tiny',
      timeInterval: this.$t('One Week'), endDate: this.$t('Yesterday'), time1: true, time2: false, time3: false, timeRange: '',
      defaultDate1: '17-8-2017',
      selectDateTip: this.$t('Select Date'),
      defaultStartDate: '',
      defaultEndDate: '',
      cust: false, custTime: '', custDate: '', isM: false, isDe: false, isIt: false, isPo: false, isDu: false, isFr: false, isSw: false, isCz: false,
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e7;
        }
      },
      weekmode: 'yyyyyyyy', evType: this.$t('date'),
      value11: '', value12: '', qst1: '', qet1: '',
      value21: '', value22: '', qst2: '', qet2: '',
      value31: '', value32: '', qst3: '', qet3: '',
      value41: '', value42: '',
      value51: '', value52: '',
      value61: '', value62: '',
      bolusStartDate: '',
      bolusEndDate: '',
      isEn: false,
      isT1: true, isT2: true, isT3: true, isT4: true, isT5: true, isT6: true,

      uid: 0, page: 1, pages: 5, has_next: '', has_prev: '', PDM: [], value71: '', value72: '',
      download_url: '',
      glucose_unit: ''

    };
  },


  methods: {
    timeIntervalChange: function timeIntervalChange() {
      if (this.timeInterval === this.$t('One Week')) {
        this.time1 = true;
        this.time2 = false;
        this.time3 = false;
      }
      if (this.timeInterval === this.$t('One Month')) {
        this.time1 = false;
        this.time2 = true;
        this.time3 = false;
      }
      if (this.timeInterval === this.$t('One Quarter')) {
        this.time1 = false;
        this.time2 = false;
        this.time3 = true;
      }
      this.endDate = this.$t('Yesterday');
      this.timeChange();
    },
    timeChange: function timeChange() {
      if (this.timeInterval === this.$t('One Week') && this.endDate === this.$t('Yesterday')) {
        this.end = new Date().setHours(0, 0, 0, 0) / 1000 - 86400;
        this.sta = this.end - 86400 * 6;
      }
      if (this.timeInterval === this.$t('One Week') && this.endDate === this.$t('Last Saturday')) {
        var now = new Date().setHours(0, 0, 0, 0);
        var currentDay = new Date(now).getDay();
        this.end = now / 1000 - 86400 * (currentDay + 1);
        this.sta = this.sta = this.end - 86400 * 6;
      }
      if (this.timeInterval === this.$t('One Week') && this.endDate === this.$t('Last Sunday')) {
        var _now = new Date().setHours(0, 0, 0, 0);
        var _currentDay = new Date(_now).getDay();
        this.end = _now / 1000 - 86400 * _currentDay;
        this.sta = this.sta = this.end - 86400 * 6;
      }
      if (this.timeInterval === this.$t('One Month') && this.endDate === this.$t('Yesterday')) {
        this.end = new Date().setHours(0, 0, 0, 0) / 1000 - 86400;
        this.sta = this.end - 86400 * 30;
      }
      if (this.timeInterval === this.$t('One Month') && this.endDate === this.$t('Last Day of Last Month')) {
        var _now2 = new Date().setHours(0, 0, 0, 0);
        var _currentDay2 = new Date(_now2).getDate();
        this.end = _now2 / 1000 - 86400 * _currentDay2;
        this.sta = this.end - 86400 * 30;
      }
      if (this.timeInterval === this.$t('One Quarter') && this.endDate === this.$t('Yesterday')) {
        this.end = new Date().setHours(0, 0, 0, 0) / 1000 - 86400;
        this.sta = this.end - 86400 * 30 * 3;
      }
      if (this.timeInterval === this.$t('One Quarter') && this.endDate === this.$t('Last Day of Last Quarter')) {
        var _now3 = new Date().setHours(0, 0, 0, 0);
        var end = _now3 / 1000 - 86400 * 30 * 3;
        var endDay = new Date(end * 1000).getDate();
        this.end = end + 86400 * (30 - endDay);
        this.sta = this.end - 86400 * 30 * 3;
      }
      if (this.endDate === this.$t('Customize')) {
        this.cust = true;
        this.custTime = '';
        this.custDate = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate4(new Date().setHours(0, 0, 0, 0) / 1000 - 86400);
        this.end = new Date().setHours(0, 0, 0, 0) / 1000 - 86400;
        if (this.timeInterval === this.$t('One Week')) {
          this.sta = this.end - 86400 * 6;
        }
        if (this.timeInterval === this.$t('One Month')) {
          this.sta = this.end - 86400 * 30;
        }
        if (this.timeInterval === this.$t('One Quarter')) {
          this.sta = this.end - 86400 * 30 * 3;
        }
      } else {
        this.cust = false;
      }
      this.timeRange = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate2(this.sta) + ' - ' + __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate2(this.end);
      var day = (this.end - this.sta) / 86400 + 1;
      this.defaultDate1 = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate4(this.sta);
      this.defaultDate2 = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate4(this.end);

      this.defaultStartDate = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate4(this.sta);
      this.defaultEndDate = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate4(this.end);
    },
    customizeDate: function customizeDate() {
      this.end = this.custTime.getTime() / 1000;
      if (this.timeInterval === this.$t('One Week')) {
        this.sta = this.end - 86400 * 6;
      }
      if (this.timeInterval === this.$t('One Month')) {
        this.sta = this.end - 86400 * 30;
      }
      if (this.timeInterval === this.$t('One Quarter')) {
        this.sta = this.end - 86400 * 30 * 3;
      }
      this.timeRange = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate2(this.sta) + ' - ' + __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate2(this.end);
      var day = (this.end - this.sta) / 86400 + 1;
      this.defaultDate1 = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate4(this.sta);
      this.defaultDate2 = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate4(this.end);
    },
    choose: function choose(e) {
      var parent = e.target.parentNode.parentNode;
      var labels = parent.getElementsByTagName('label');
      if (e.target.className === '') {
        e.target.className = 'no';
        labels[0].className = 'no';
      } else {
        e.target.className = '';
        for (var i = 1; i < labels.length; i++) {
          if (labels[i].className === '') {
            this.count++;
          }
        }
        if (this.count === labels.length - 1) {
          labels[0].className = '';
        }
        this.count = 0;
      }
    },
    choose1: function choose1(e) {
      var parent = e.target.parentNode.parentNode;
      var labels = parent.getElementsByTagName('label');
      if (e.target.className === '') {
        e.target.className = 'no';
        labels[0].className = 'no';
      } else {
        e.target.className = '';
        for (var i = 1; i < labels.length; i++) {
          if (labels[i].className === '') {
            this.count1++;
          }
        }
        if (this.count1 === labels.length - 1) {
          labels[0].className = '';
        }
        this.count1 = 0;
      }
    },
    chooseAll: function chooseAll(e) {
      var parent = e.target.parentNode.parentNode;
      var labels = parent.getElementsByTagName('label');
      for (var i = 0; i < labels.length; i++) {
        if (this.flag === 0) {
          labels[i].className = 'no';
        } else {
          labels[i].className = '';
        }
      }
      if (labels[0].className === 'no') {
        this.flag = 1;
      } else {
        this.flag = 0;
      }
    },
    dateChange: function dateChange() {
      this.end = this.value1;
      if (this.end === '') {
        this.sta = new Date().getTime() / 1000;
        this.end = this.sta - 3600 * 24;
        this.sta = this.sta - 3600 * 24 * 8;
        this.sta = new Date(this.sta * 1000);
      } else {
        this.end = new Date(this.end).getTime() / 1000;
        this.sta = this.end - 3600 * 24 * 7;
        this.sta = new Date(this.sta * 1000);
      }
      var y = this.sta.getFullYear();
      var m = this.sta.getMonth() + 1;
      var d = this.sta.getDate();
      m = m < 10 ? '0' + m : m;
      d = d < 10 ? '0' + d : d;
      this.sta = d + '-' + m + '-' + y;
      this.startDate = this.sta;
    },
    dateChange2: function dateChange2() {
      var t = this.getTime(this.value71, this.value72);
      var qst = t[0];
      var qet = t[1];
      var param = {
        page: 1,
        st: qst,
        et: qet,
        tz: parseInt(sessionStorage.getItem('tz'))
      };

      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getPdm1(this, this.uid, param);
    },
    print: function print() {
      var obj1 = document.getElementById('dash');
      var obj2 = document.getElementById('ds');
      var obj3 = document.getElementById('dd');
      var obj4 = document.getElementById('ol');
      var obj5 = document.getElementById('ta');
      var obj6 = document.getElementById('lg');

      var report = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      this.checkDate();
      console.log('export:', obj1, obj2, obj3, obj4, obj5, obj6);
      var obj_list = [obj1, obj2, obj3, obj4, obj5, obj6];
      var uid = parseInt(sessionStorage.getItem('patientId'));
      console.log('patientId:', uid);
      console.log('startTime:', this.value11);
      console.log('sta:', this.sta, this.end);

      var params = {
        select: ['bolus'],
        st: this.sta,
        et: this.end + 86400,
        glucose_unit: this.glucose_unit
      };

      this.$http.post('/api/v2.1/data/export/' + uid, params).then(function (res) {
        console.log('export:', res.body);
        var file_name = res.body.file_name;
        this.download_url = '/api/v2.1/data/export/download/' + file_name;

        window.location.href = this.download_url;
      }, function (err) {});
    },
    xx_print: function xx_print() {
      var obj1 = document.getElementById('ds');
      var obj2 = document.getElementById('dd');
      var obj3 = document.getElementById('ol');
      var obj4 = document.getElementById('ta');
      var obj5 = document.getElementById('lg');
      var obj6 = document.getElementById('ev');
      var obj7 = document.getElementById('dSet');
      var obj8 = document.getElementById('dash');
      var obj9 = document.getElementById('alert');
      var report = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      this.checkDate();

      if (obj9.className !== 'no') {
        var t1 = this.getTime(this.value11, this.value12);
        this.qst1 = t1[0];
        this.qet1 = t1[1];

        var dayNum1 = parseInt((this.qet1 - this.qst1) / 86400) + 1;
        console.log('quick print:', dayNum1, this.qet1, this.qst1);
        report[10] = 1;
        if (dayNum1 > 14) {
          this.isT1 = true;
          this.qst1 = this.qet1 - 13 * 86400;
          sessionStorage.setItem('qst1', this.qst1);
          sessionStorage.setItem('qet1', this.qet1);
        } else if (dayNum1 < 1) {
          this.$message.error("Alert Report: date select wrong!");
          return;
        } else {
          this.isT1 = true;
          sessionStorage.setItem('qst1', this.qst1);
          sessionStorage.setItem('qet1', this.qet1);
        }
      }

      if (obj8.className !== 'no') {
        var _t = this.getTime(this.value11, this.value12);
        this.qst1 = _t[0];
        this.qet1 = _t[1];
        var _dayNum = parseInt((this.qet1 - this.qst1) / 86400) + 1;
        report[9] = 1;
        if (_dayNum > 14) {
          this.isT1 = true;
          this.qst1 = this.qet1 - 13 * 86400;
          sessionStorage.setItem('qst1', this.qst1);
          sessionStorage.setItem('qet1', this.qet1);
        } else if (_dayNum < 1) {} else {
          this.isT1 = true;
          sessionStorage.setItem('qst1', this.qst1);
          sessionStorage.setItem('qet1', this.qet1);
        }
      }

      if (obj1.className !== 'no') {
        var _t2 = this.getTime(this.value11, this.value12);
        this.qst1 = _t2[0];
        this.qet1 = _t2[1];
        var _dayNum2 = parseInt((this.qet1 - this.qst1) / 86400) + 1;
        report[1] = 1;
        if (_dayNum2 > 14) {
          this.isT1 = true;
          this.qst1 = this.qet1 - 13 * 86400;
          sessionStorage.setItem('qst1', this.qst1);
          sessionStorage.setItem('qet1', this.qet1);
        } else if (_dayNum2 < 1) {} else {
          this.isT1 = true;
          sessionStorage.setItem('qst1', this.qst1);
          sessionStorage.setItem('qet1', this.qet1);
        }
      }
      if (obj2.className !== 'no') {
        var t2 = this.getTime(this.value21, this.value22);
        this.qst2 = t2[0];
        this.qet2 = t2[1];
        var dayNum2 = parseInt((this.qet2 - this.qst2) / 86400) + 1;
        report[2] = 1;
        if (dayNum2 > 14) {
          this.isT2 = true;
          this.qst2 = this.qet2 - 13 * 86400;
          sessionStorage.setItem('qst2', this.qst2);
          sessionStorage.setItem('qet2', this.qet2);
        } else if (dayNum2 < 1) {
          this.isT2 = false;
        } else {
          this.isT2 = true;
          sessionStorage.setItem('qst2', this.qst2);
          sessionStorage.setItem('qet2', this.qet2);
        }
      }
      if (obj3.className !== 'no') {
        var t3 = this.getTime(this.value31, this.value32);
        this.qst3 = t3[0];
        this.qet3 = t3[1];
        var dayNum3 = parseInt((this.qet3 - this.qst3) / 86400) + 1;
        report[3] = 1;
        if (dayNum3 > 7) {
          this.isT3 = true;
          this.qst3 = this.qet3 - 6 * 86400;
          sessionStorage.setItem('qst3', this.qst3);
          sessionStorage.setItem('qet3', this.qet3);
          sessionStorage.setItem('qweekMode', this.weekmode);
        } else if (dayNum3 < 1) {
          this.isT3 = false;
        } else {
          this.isT3 = true;
          sessionStorage.setItem('qst3', this.qst3);
          sessionStorage.setItem('qet3', this.qet3);
          sessionStorage.setItem('qweekMode', this.weekmode);
        }
      }
      if (obj4.className !== 'no') {
        var t4 = this.getTime(this.value41, this.value42);
        var qst4 = t4[0];
        var qet4 = t4[1];
        var dayNum4 = parseInt((qet4 - qst4) / 86400) + 1;
        report[4] = 1;
        if (dayNum4 > 90) {
          this.isT4 = true;
          this.qst4 = this.qet4 - 89 * 86400;
          sessionStorage.setItem('qst4', qst4);
          sessionStorage.setItem('qet4', qet4);
          sessionStorage.setItem('qweekMode', this.weekmode);
        } else if (dayNum4 < 1) {
          this.isT4 = false;
        } else {
          this.isT4 = true;
          sessionStorage.setItem('qst4', qst4);
          sessionStorage.setItem('qet4', qet4);
          sessionStorage.setItem('qweekMode', this.weekmode);
        }
      }
      if (obj5.className !== 'no' && !this.isM) {
        var t5 = this.getTime(this.value51, this.value52);
        var qst5 = t5[0];
        var qet5 = t5[1];
        var dayNum5 = parseInt((qet5 - qst5) / 86400) + 1;
        report[5] = 1;
        if (dayNum5 > 14) {
          this.isT5 = true;
          qst5 = qet5 - 13 * 86400;
          sessionStorage.setItem('qst5', qst5);
          sessionStorage.setItem('qet5', qet5);
          sessionStorage.setItem('qweekMode', this.weekmode);
        } else if (dayNum5 < 1) {
          this.isT5 = false;
        } else {
          this.isT5 = true;
          sessionStorage.setItem('qst5', qst5);
          sessionStorage.setItem('qet5', qet5);
          sessionStorage.setItem('qweekMode', this.weekmode);
        }
      }
      if (obj6.className !== 'no' && !this.isM) {
        var t6 = this.getTime(this.value61, this.value62);
        var qst6 = t6[0];
        var qet6 = t6[1];
        var dayNum6 = parseInt((qet6 - qst6) / 86400) + 1;
        if (this.evType === this.$t('date')) {
          report[6] = 1;
        }
        if (this.evType === this.$t('item')) {
          report[7] = 1;
        }
        if (dayNum6 > 30) {
          this.isT6 = true;
          qst6 = qet6 - 29 * 86400;
          sessionStorage.setItem('qst6', qst6);
          sessionStorage.setItem('qet6', qet6);
        } else if (dayNum6 < 1) {
          this.isT6 = false;
        } else {
          this.isT6 = true;
          sessionStorage.setItem('qst6', qst6);
          sessionStorage.setItem('qet6', qet6);
        }
      }
      if (obj7.className !== 'no' && !this.isM) {
        if (this.PDM.length > 0) {
          report[8] = 1;
          var pdm = this.PDM[0][1] + ',' + this.PDM[0][2];
          var rid = this.PDM[0][0];
          sessionStorage.setItem('qPdm', pdm);
          sessionStorage.setItem('qRid', rid);
        }
      }
      report.map(function (e, i) {
        if (e === 1) {
          var key = 'qFirst' + i;
          sessionStorage.setItem(key, 1);
        }
      });
      sessionStorage.setItem('Reports', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(report));

      if (this.checkDayNum()) {
        for (var i = 1; i < report.length; i++) {
          if (report[i] === 1) {
            var path = '/#/quickPrint' + i;
            console.log('quickReport:', path, i);
            var open = window.open(path, '_blank');
            if (open === null) {
              this.$message.error('popup window intercepted');
            }
            break;
          }
        }
      }
    },
    getTime: function getTime(t1, t2) {
      var qst = 0,
          qet = 0;
      if (t1 && t2) {
        qst = t1.getTime() / 1000;
        qet = t2.getTime() / 1000;
      } else if (t1) {
        qst = t1.getTime() / 1000;
        var ti = this.defaultDate2.split('-');
        qet = new Date(parseInt(ti[2]), parseInt(ti[1]) - 1, parseInt(ti[0])).getTime() / 1000;
      } else if (t2) {
        qet = t2.getTime() / 1000;
        var _ti = this.defaultDate1.split('-');
        qst = new Date(parseInt(_ti[2]), parseInt(_ti[1]) - 1, parseInt(_ti[0])).getTime() / 1000;
      } else {
        var _ti2 = this.defaultDate1.split('-');
        qst = new Date(parseInt(_ti2[2]), parseInt(_ti2[1]) - 1, parseInt(_ti2[0])).getTime() / 1000;
        var ti1 = this.defaultDate2.split('-');
        qet = new Date(parseInt(ti1[2]), parseInt(ti1[1]) - 1, parseInt(ti1[0])).getTime() / 1000;
      }
      return [qst, qet];
    },
    checkDate: function checkDate() {
      var weeks = document.getElementById('weeks');
      var weken = document.getElementById('weken');
      if (weeks) {
        var labels1 = weeks.getElementsByTagName('label');
        var labels2 = weken.getElementsByTagName('label');
        if (labels1[0].className === '' && labels2[0].className === '') {
          this.weekmode = 'yyyyyyy';
        } else {
          this.weekmode = '';
          for (var i = 1; i < labels1.length; i++) {
            if (labels1[i].className === '') {
              this.weekmode += 'y';
            } else {
              this.weekmode += 'n';
            }
          }
          for (var _i = 1; _i < labels2.length; _i++) {
            if (labels2[_i].className === '') {
              this.weekmode += 'y';
            } else {
              this.weekmode += 'n';
            }
          }
        }
      }
    },
    checkDayNum: function checkDayNum() {
      var dateTrue = true;
      var report = JSON.parse(sessionStorage.getItem('Reports'));

      return dateTrue;
    },
    getPdm1: function getPdm1() {
      var param = {
        page: 1,
        st: this.st,
        et: this.et,
        tz: parseInt(sessionStorage.getItem('tz'))
      };
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getPdm1(this, this.uid, param);
    },
    apply: function apply() {},
    cancel: function cancel() {
      this.typeChooseVisible = false;
    }
  },
  mounted: function mounted() {
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isSw = lang === 'sw' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    this.isM = sessionStorage.getItem('userType') === 'M' ? true : false;
    var win = window.innerWidth;
    this.dialogSize = win < 1500 ? 'small' : 'tiny';
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }
    var glucose_unit = localStorage.getItem('unit');
    console.log('glucose_unit:', glucose_unit);
    if ('mmol' == glucose_unit) {
      this.glucose_unit = 'mmol/L';
    } else {
      this.glucose_unit = 'mg/dL';
    }
    this.et = new Date().setHours(0, 0, 0, 0) / 1000 - 86400;
    this.st = this.et - 86400 * 6;

    this.defaultDate1 = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate4(this.st);
    this.defaultDate2 = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate4(this.et);
    this.timeChange();
  }
});

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isA: '', isB: '', isC: '', isD: '', isE: '', isF: '', isG: '', isHcp: true, notM: true, no: true, isDe: false, isEs: false, isDu: false,
      isPo: false, isFr: false, isZh: false,
      isEU: true,
      contactURL: '',
      privacyURL: '',
      termsOfUseURL: ''
    };
  },

  computed: {
    portrait: function portrait() {
      if (sessionStorage.getItem('patientId')) {
        return '/api/v2.0/person/' + parseInt(sessionStorage.getItem('patientId')) + '/portrait';
      } else {
        return '/api/v2.0/person/' + parseInt(sessionStorage.getItem('uid')) + '/portrait';
      }
    },
    patientName: function patientName() {
      return this.$store.state.patientName;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.isA = this.$route.path === '/setting' || this.$route.path === '/dateView2' ? true : false;
    this.isB = this.$route.path === '/monitor' ? true : false;
    this.isC = this.$route.path === '/chart1' || this.$route.path === '/chart2' || this.$route.path === '/chart3' || this.$route.path === '/chart4' || this.$route.path === '/chart5' || this.$route.path === '/chart6' ? true : false;
    this.isD = this.$route.path === '/events' ? true : false;
    this.isE = this.$route.path === '/records' ? true : false;

    this.isF = this.$route.path === '/ClinicExportData' ? true : false;
    this.isG = this.$route.path === '/patientProfile' || this.$route.path === '/patientProfile2' ? true : false;
    this.isHcp = sessionStorage.getItem('userType') === 'P' ? false : true;
    this.notM = sessionStorage.getItem('userType') === 'M' ? false : true;

    var lang = sessionStorage.getItem('language');
    this.isDe = lang === 'de' ? true : false;
    this.isEs = lang === 'es' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isZh = lang === 'zh' ? true : false;
    if (sessionStorage.getItem('userType') !== 'P') {
      var Pid = parseInt(sessionStorage.getItem('patientId'));

      var patientName = sessionStorage.getItem('patientName');
      this.$store.commit('updatePatientName', patientName);
    }

    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }

    var countryIndex = localStorage.getItem('index');

    if (1 == countryIndex || 6 == countryIndex || 14 == countryIndex) {
      this.isEU = false;
    }
    setTimeout(function () {
      var host = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getOuterHost();
      _this.contactURL = host + '/contact.html';
      _this.privacyURL = host + '/privacy_policy.html';
      _this.termsOfUseURL = host + '/terms_of_use.html';
    }, 50);
  },

  methods: {
    changeMenu1: function changeMenu1() {
      this.isA = true;
      this.isB = false;
      this.isC = false;
      this.isD = false;
      this.isE = false;
      this.isF = false;
      this.isG = false;
      if (this.$route.path === '/setting' || this.$route.path === '/dateView2') {
        this.$router.push(this.$route.path);
      } else {
        if (sessionStorage.getItem('userType') === 'M') {
          this.$router.push('/setting');
        } else {
          this.$router.push('/dateView2');
        }
      }
    },
    changeMenu2: function changeMenu2() {
      this.isB = true;
      this.isA = false;
      this.isC = false;
      this.isD = false;
      this.isE = false;
      this.isF = false;
      this.isG = false;
      this.$router.push('/monitor');
    },
    changeMenu3: function changeMenu3() {
      this.isC = true;
      this.isA = false;
      this.isB = false;
      this.isD = false;
      this.isE = false;
      this.isF = false;
      this.isG = false;
      console.log("hcp.vue:" + this.$route.path);
      var that = this;

      __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getDataMap(this, this.uid, function (res) {
        if (0 != res.error) {
          return;
        }

        var chart_end_time = res.end.cgms > res.end.pump ? res.end.cgms : res.end.pump;
        sessionStorage.setItem('chart_end_time', chart_end_time);

        if (that.$route.path === '/chart1' || that.$route.path === '/chart2' || that.$route.path === '/chart3' || that.$route.path === '/chart4' || that.$route.path === '/chart5' || that.$route.path === '/chart6') {
          that.$router.push(that.$route.path);
        } else {
          that.$router.push('/chart0');
        }
      });
    },
    changeMenu4: function changeMenu4() {
      this.isD = true;
      this.isA = false;
      this.isB = false;
      this.isC = false;
      this.isE = false;
      this.isF = false;
      this.isG = false;
      this.$router.push('/events');
    },
    changeMenu5: function changeMenu5() {
      this.isE = true;
      this.isA = false;
      this.isB = false;
      this.isC = false;
      this.isD = false;
      this.isF = false;
      this.isG = false;
      this.$router.push('/records');
    },
    changeMenu6: function changeMenu6() {
      this.isF = true;
      this.isA = false;
      this.isB = false;
      this.isC = false;
      this.isD = false;
      this.isE = false;
      this.isG = false;
      this.$router.push('/ClinicExportData');
    },
    changeMenu7: function changeMenu7() {
      this.isG = true;
      this.isA = false;
      this.isB = false;
      this.isC = false;
      this.isD = false;
      this.isE = false;
      this.isF = false;
      var Pid = parseInt(sessionStorage.getItem('patientId'));
      if (sessionStorage.getItem('userType') === 'D') {
        __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].goClinicPatientProfile(this, Pid);
      } else {
        this.$router.push('/patientProfile3');
      }
    },
    back: function back() {
      sessionStorage.removeItem('rid');
      sessionStorage.removeItem('dateViewA');
      __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].clearSession();
      if (this.notM) {
        this.$router.push('/ClinicPatientList');
      } else {
        this.$router.push('/carerConnection');
      }
    }
  }
});

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_format__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_base64__ = __webpack_require__(9);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home1',
  data: function data() {
    return {
      keywords: '',
      searchPatient: false, activeIndex: '1', dialogFormVisible: false,
      typeChooseVisible: false, tooltipVisible: true, styleChange: '', isEs: false, isZh: false,
      pages: '', page: 1, has_next: '', has_prev: '', dialogSize: 'tiny', dialogSize2: 'small', isC: false, isSw: false, isCz: false,
      uids: [], flag: 0, count: 0, filter: '', filFlag: false, filFlag2: false, isDe: false, isIt: false, isPo: false, isPl: false, isDu: false, isFr: false,
      lab1: false, lab2: false, lab3: false, lab5: false, lab6: false, lab7: false, lab8: false, lab17: false, lab18: false,
      lab9: false, lab10: false, lab11: false, lab12: false, lab13: false, lab14: false, lab15: false, lab16: false, lab19: false,
      isEU: true,
      showConfirmDialog: false,
      contactURL: '',
      privacyURL: '',
      termsOfUseURL: ''
    };
  },
  beforeCreate: function beforeCreate() {
    __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].checkAuth();
    if (!__WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].authenticated) {}
  },

  computed: {
    users: function users() {
      return this.$store.state.users;
    }
  },
  methods: {
    getUsers: function getUsers() {
      this.filFlag2 = this.keywords ? true : false;
      if (this.filFlag || this.keywords) {
        var para = {
          filter: this.filter
        };
        para = __WEBPACK_IMPORTED_MODULE_3__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(para));
        __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].getUserList(this, { 'param': para, 'page': this.page });
      } else {
        var _para = {
          page: this.page
        };
        __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].getUserList(this, _para);
      }
      this.start();
    },
    start: function start() {
      var table = document.getElementById('patientList');
      var labels = table.getElementsByTagName('label');
      for (var i = 0; i < labels.length; i++) {
        labels[i].className = ' ';
      }
    },
    chooseAll: function chooseAll() {
      var table = document.getElementById('patientList');
      var labels = table.getElementsByTagName('label');
      for (var i = 0; i < labels.length; i++) {
        if (this.flag === 0) {
          labels[i].className = 'checked';
          if (i > 0) {
            var uid = this.users[i - 1].uid;
            this.uids.push(uid);
          }
        } else {
          labels[i].className = '';
          if (i > 0) {
            var _uid = this.users[i - 1].uid;
            this.uids.pop(_uid);
          }
        }
      }

      if (labels[0].className === 'checked') {
        this.flag = 1;
      } else {
        this.flag = 0;
      }
    },
    select: function select(e) {
      var index = e.target.id;
      var parent = document.getElementById('patientList');
      var labels = parent.getElementsByTagName('label');
      var uid = this.users[index].uid;
      if (e.target.className === '') {
        e.target.className = 'checked';
        this.uids.push(uid);
        for (var i = 1; i < labels.length; i++) {
          if (labels[i].className === 'checked') {
            this.count++;
          }
        }
        if (this.count === labels.length - 1) {
          labels[0].className = "checked";
        }
        this.count = 0;
      } else {
        e.target.className = '';
        labels[0].className = "";
        for (var _i = 0; _i < this.uids.length; _i++) {
          if (uid === this.uids[_i]) {
            this.uids.splice(_i, 1);
          }
        }
      }
    },
    deleteP: function deleteP() {
      var _this = this;

      if (this.uids.length > 0) {
        var tip = this.$t('deletePtip');
        var tip1 = this.$t('confirm');
        var tip2 = this.$t('Yes');
        var tip3 = this.$t('No');
        this.$confirm(tip, tip1, {
          confirmButtonText: tip2,
          cancelButtonText: tip3,
          type: 'warning'
        }).then(function () {
          var uids = _this.uids;
          _this.$http.post('api/v2.0/patients/delete', { 'uids': uids }).then(function (res) {
            var err = res.body.error;
            if (err === 0) {
              var _tip = this.$t('deleteSuccess');
              this.$message({
                type: 'success',
                message: _tip
              });
              this.getUsers();
            }
          }, function (err) {
            var tip = this.$t('deleteFailed');
            this.$message.error(tip);
          });
        }, function () {});
      }
    },
    goDetail: function goDetail(e) {
      var index = e.target.parentNode.id;
      var uid = this.users[index].uid;
      var name = this.users[index].name;
      sessionStorage.setItem('patientId', uid);
      sessionStorage.setItem('patientName', name);

      this.$router.push('/ClinicExportData');
    },
    nextPage: function nextPage() {
      if (this.page < this.pages) {
        this.page++;
        this.getUsers();
      }
    },
    prevPage: function prevPage() {
      if (this.page > 1) {
        this.page--;
        this.getUsers();
      }
    },
    go: function go() {
      if (0 < this.page && this.page < this.pages + 1) {
        this.getUsers();
      } else {
        this.page = 1;
        this.getUsers();
      }
    },
    NewPatient: function NewPatient() {
      this.$router.push('/newPatient');
    },
    findPatient: function findPatient() {
      this.$router.push('/findPatient');
    },
    choose1: function choose1() {
      this.lab1 = !this.lab1;
      this.lab2 = false;
      this.lab3 = false;
      this.lab17 = false;
    },
    choose2: function choose2() {
      this.lab2 = !this.lab2;
      this.lab1 = false;
    },
    choose3: function choose3() {
      this.lab3 = !this.lab3;
      this.lab1 = false;
    },
    choose17: function choose17() {
      this.lab17 = !this.lab17;
      this.lab1 = false;
    },
    choose5: function choose5() {
      this.lab5 = !this.lab5;
      this.lab6 = false;
      this.lab7 = false;
      this.lab8 = false;
      this.lab9 = false;
      this.lab18 = false;
    },
    choose6: function choose6() {
      this.lab6 = !this.lab6;
      this.lab5 = false;
    },
    choose7: function choose7() {
      this.lab7 = !this.lab7;
      this.lab5 = false;
    },
    choose8: function choose8() {
      this.lab8 = !this.lab8;
      this.lab5 = false;
    },
    choose9: function choose9() {
      this.lab9 = !this.lab9;
      this.lab5 = false;
    },
    choose18: function choose18() {
      this.lab18 = !this.lab18;
      this.lab5 = false;
    },
    choose10: function choose10() {
      this.lab10 = !this.lab10;
      this.lab11 = false;
      this.lab12 = false;
      this.lab13 = false;
      this.lab14 = false;
      this.lab15 = false;
      this.lab16 = false;
      this.lab19 = false;
    },
    choose11: function choose11() {
      this.lab11 = !this.lab11;
      this.lab10 = false;
    },
    choose12: function choose12() {
      this.lab12 = !this.lab12;
      this.lab10 = false;
    },
    choose13: function choose13() {
      this.lab13 = !this.lab13;
      this.lab10 = false;
    },
    choose14: function choose14() {
      this.lab14 = !this.lab14;
      this.lab10 = false;
    },
    choose15: function choose15() {
      this.lab15 = !this.lab15;
      this.lab10 = false;
    },
    choose16: function choose16() {
      this.lab16 = !this.lab16;
      this.lab10 = false;
    },
    choose19: function choose19() {
      this.lab19 = !this.lab19;
      this.lab10 = false;
    },
    checkFilter: function checkFilter() {
      this.dialogFormVisible = false;
      var flag = this.lab2 || this.lab3 || this.lab6 || this.lab7 || this.lab8 || this.lab9 || this.lab11 || this.lab12 || this.lab13 || this.lab14 || this.lab15 || this.lab16 || this.lab17 || this.lab18 || this.lab19;
      this.filFlag = flag;
      if (flag || this.keywords) {
        if (flag) {
          this.tooltipVisible = false;
        }
        var gender = [],
            age = [],
            diabetes_type = [],
            filter = {};
        if (this.lab2) {
          gender.push('GDRF');
        }
        if (this.lab3) {
          gender.push('GDRM');
        }
        if (this.lab17) {
          gender.push('GDRNF');
        }

        if (this.lab6) {
          age.push([0, 17]);
        }
        if (this.lab7) {
          age.push([18, 40]);
        }
        if (this.lab8) {
          age.push([41, 60]);
        }
        if (this.lab9) {
          age.push([61, 200]);
        }
        if (this.lab18) {
          age.push(null);
        }

        if (this.lab11) {
          diabetes_type.push('DBT1');
        }
        if (this.lab12) {
          diabetes_type.push('DBT2');
        }
        if (this.lab13) {
          diabetes_type.push('DBTGEST');
        }
        if (this.lab14) {
          diabetes_type.push('DBTPRE');
        }
        if (this.lab15) {
          diabetes_type.push('DBTLADA');
        }
        if (this.lab19) {
          diabetes_type.push('DBTNF');
        }

        if (gender.length !== 0 && gender.length !== 3) {
          filter.gender = gender;
        }
        if (age.length !== 0 && age.length !== 5) {
          filter.age = age;
        }
        if (diabetes_type.length !== 0 && diabetes_type.length !== 6) {
          filter.diabetes_type = diabetes_type;
        }

        filter.keywords = this.keywords;
        this.filFlag2 = this.keywords ? true : false;
        this.filter = filter;
        var para = {
          filter: filter
        };
        para = __WEBPACK_IMPORTED_MODULE_3__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(para));
        __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].getUserList(this, { 'param': para, 'page': 1 });
      } else {
        this.tooltipVisible = true;
        this.getUsers();
      }
    },
    check: function check(flag) {
      if (flag === 1) {
        this.checkFilter();
      }
      this.searchPatient = !this.searchPatient;
    },
    cancelFilter: function cancelFilter() {
      this.dialogFormVisible = false;
      this.checkFilter();
    },
    cancelAdd: function cancelAdd() {
      this.typeChooseVisible = false;
    },
    formateDate: function formateDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth();
      var d = date.getDate();
      var h = date.getHours();
      var mi = date.getMinutes();
      var s = date.getSeconds();
      m = m < 10 ? '0' + m : m;
      d = d < 10 ? '0' + d : d;
      return y + '-' + m + '-' + d + ' ' + h + ':' + mi + ':' + s;
    },
    checkPrivacyVersion: function checkPrivacyVersion() {
      this.$http.get('/api/v2.1/user/privacy/confirm').then(function (res) {
        console.log("privacy confirm:", res.data);
        if (0 == res.data.error) {
          if (0 == res.data.confirm) {
            this.showConfirmDialog = true;
          }
        }
      }, function (err) {});
    },
    denyPrivacyConfirm: function denyPrivacyConfirm() {
      this.showConfirmDialog = false;
    },
    agreePrivacyConfirm: function agreePrivacyConfirm() {
      this.showConfirmDialog = false;
      this.$http.post('/api/v2.1/user/privacy/confirm').then(function (res) {
        console.log('privacy confirm:', res.data);
      }, function (err) {});
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    var para = {
      page: this.page
    };
    var win = window.innerWidth;
    this.dialogSize = win < 1500 ? 'small' : 'tiny';
    var lang = sessionStorage.getItem('language');
    this.styleChange = lang === 'zh' || lang === 'hk' ? true : false;
    this.isEs = lang === 'es' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isPl = lang === 'pl' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isSw = lang === 'sw' ? true : false;
    this.isZh = lang === 'zh' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    var countryIndex = localStorage.getItem('index');
    console.info('countryIndex:' + countryIndex + ',' + lang + ',' + this.isPl);
    if (1 == countryIndex || 6 == countryIndex || 14 == countryIndex) {
      this.isEU = false;
    }
    __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].getUserList(this, para);

    setTimeout(function () {
      var host = __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].getOuterHost();
      _this2.contactURL = host + '/contact.html';
      _this2.privacyURL = host + '/privacy_policy.html';
      _this2.termsOfUseURL = host + '/terms_of_use.html';
    }, 50);
  }
});

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isA: '', isB: '', isC: '', isD: '', isE: '', isF: '', isG: '', isHcp: true, notM: true, no: true, isDe: false, isEs: false, isDu: false,
      isPo: false, isFr: false, isZh: false,
      isEU: true,
      contactURL: '',
      privacyURL: '',
      termsOfUseURL: ''
    };
  },

  computed: {
    portrait: function portrait() {
      if (sessionStorage.getItem('patientId')) {
        return '/api/v2.0/person/' + parseInt(sessionStorage.getItem('patientId')) + '/portrait';
      } else {
        return '/api/v2.0/person/' + parseInt(sessionStorage.getItem('uid')) + '/portrait';
      }
    },
    patientName: function patientName() {
      return this.$store.state.patientName;
    },
    updateLocCode: function updateLocCode() {
      console.log('compute updateLocCode:');
      return this.$store.state.loc_code;
    }
  },
  watch: {
    updateLocCode: function updateLocCode(val) {
      console.log('watch updateLocCode:', val);
      var host = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getOuterHost();
      this.contactURL = host + '/contact.html';
      this.privacyURL = host + '/privacy_policy.html';
      this.termsOfUseURL = host + '/terms_of_use.html';
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.isA = this.$route.path === '/setting' || this.$route.path === '/dateView2' ? true : false;
    this.isB = this.$route.path === '/monitor' ? true : false;
    this.isC = this.$route.path === '/chart1' || this.$route.path === '/chart2' || this.$route.path === '/chart3' || this.$route.path === '/chart4' || this.$route.path === '/chart5' || this.$route.path === '/chart6' ? true : false;
    this.isD = this.$route.path === '/events' ? true : false;
    this.isE = this.$route.path === '/records' ? true : false;
    this.isF = this.$route.path === '/print' ? true : false;
    this.isG = this.$route.path === '/patientProfile' || this.$route.path === '/patientProfile2' ? true : false;
    this.isHcp = sessionStorage.getItem('userType') === 'P' ? false : true;
    this.notM = sessionStorage.getItem('userType') === 'M' ? false : true;

    var lang = sessionStorage.getItem('language');
    this.isDe = lang === 'de' ? true : false;
    this.isEs = lang === 'es' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isZh = lang === 'zh' ? true : false;
    if (sessionStorage.getItem('userType') !== 'P') {
      var Pid = parseInt(sessionStorage.getItem('patientId'));

      var patientName = sessionStorage.getItem('patientName');
      this.$store.commit('updatePatientName', patientName);
    }

    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }

    var countryIndex = localStorage.getItem('index');

    if (1 == countryIndex || 6 == countryIndex || 14 == countryIndex) {
      this.isEU = false;
    }
    setTimeout(function () {
      var host = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getOuterHost();
      _this.contactURL = host + '/contact.html';
      _this.privacyURL = host + '/privacy_policy.html';
      _this.termsOfUseURL = host + '/terms_of_use.html';
    }, 50);
  },

  methods: {
    changeMenu1: function changeMenu1() {
      this.isA = true;
      this.isB = false;
      this.isC = false;
      this.isD = false;
      this.isE = false;
      this.isF = false;
      this.isG = false;
      if (this.$route.path === '/setting' || this.$route.path === '/dateView2') {
        this.$router.push(this.$route.path);
      } else {
        if (sessionStorage.getItem('userType') === 'M') {
          this.$router.push('/setting');
        } else {
          this.$router.push('/dateView2');
        }
      }
    },
    changeMenu2: function changeMenu2() {
      this.isB = true;
      this.isA = false;
      this.isC = false;
      this.isD = false;
      this.isE = false;
      this.isF = false;
      this.isG = false;
      this.$router.push('/monitor');
    },
    changeMenu3: function changeMenu3() {
      this.isC = true;
      this.isA = false;
      this.isB = false;
      this.isD = false;
      this.isE = false;
      this.isF = false;
      this.isG = false;
      console.log("hcp.vue:" + this.$route.path);
      var that = this;

      __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getDataMap(this, this.uid, function (res) {
        if (0 != res.error) {
          return;
        }

        var chart_end_time = res.end.cgms > res.end.pump ? res.end.cgms : res.end.pump;
        sessionStorage.setItem('chart_end_time', chart_end_time);

        if (that.$route.path === '/chart1' || that.$route.path === '/chart2' || that.$route.path === '/chart3' || that.$route.path === '/chart4' || that.$route.path === '/chart5' || that.$route.path === '/chart6') {
          that.$router.push(that.$route.path);
        } else {
          that.$router.push('/chart0');
        }
      });
    },
    changeMenu4: function changeMenu4() {
      this.isD = true;
      this.isA = false;
      this.isB = false;
      this.isC = false;
      this.isE = false;
      this.isF = false;
      this.isG = false;
      this.$router.push('/events');
    },
    changeMenu5: function changeMenu5() {
      this.isE = true;
      this.isA = false;
      this.isB = false;
      this.isC = false;
      this.isD = false;
      this.isF = false;
      this.isG = false;
      this.$router.push('/records');
    },
    changeMenu6: function changeMenu6() {
      this.isF = true;
      this.isA = false;
      this.isB = false;
      this.isC = false;
      this.isD = false;
      this.isE = false;
      this.isG = false;
      this.$router.push('/print');
    },
    changeMenu7: function changeMenu7() {
      this.isG = true;
      this.isA = false;
      this.isB = false;
      this.isC = false;
      this.isD = false;
      this.isE = false;
      this.isF = false;
      var Pid = parseInt(sessionStorage.getItem('patientId'));
      if (sessionStorage.getItem('userType') === 'D') {
        __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].goPatientProfile(this, Pid);
      } else {
        this.$router.push('/patientProfile3');
      }
    },
    back: function back() {
      sessionStorage.removeItem('rid');
      sessionStorage.removeItem('dateViewA');
      __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].clearSession();
      if (this.notM) {
        this.$router.push('/PatientList');
      } else {
        this.$router.push('/carerConnection');
      }
    }
  }
});

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_format__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_base64__ = __webpack_require__(9);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home1',
  data: function data() {
    return {
      isZh: false, isEU: false,
      menuInfo2: [{
        title: 't0805_User_Management',
        bkColor: '#0c544f',
        imgUrl: "/static/accountadmin/icon_userman.png",
        permission: 'EasyPatchLogin'
      }, {
        title: 't0805_Patient_Management',
        bkColor: '#335ea8',
        imgUrl: "/static/accountadmin/icon_patientman.png",
        permission: 'EasyPatchLogin'
      }, {
        title: 't0805_Operation_History',
        bkColor: '#ee7c58',
        imgUrl: "/static/accountadmin/icon_operationhis.png",
        permission: 'EasyPatchLogin'
      }],
      contactURL: '',
      privacyURL: '',
      termsOfUseURL: ''
    };
  },
  beforeCreate: function beforeCreate() {
    __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].checkAuth();
    if (!__WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].authenticated) {}
  },

  computed: {
    users: function users() {
      return this.$store.state.users;
    },
    updateLocCode: function updateLocCode() {
      console.log('compute updateLocCode:');
      return this.$store.state.loc_code;
    }
  },
  watch: {
    updateLocCode: function updateLocCode(val) {
      console.log('watch updateLocCode:', val);
      var host = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getOuterHost();
      this.contactURL = host + '/contact.html';
      this.privacyURL = host + '/privacy_policy.html';
      this.termsOfUseURL = host + '/terms_of_use.html';
    }
  },
  methods: {
    clickMenu: function clickMenu(index) {
      console.log('clickMenu:', index);
      if (0 == index) {
        this.$router.push('/HcpUserManagement');
      } else if (1 == index) {
        this.$router.push('/PatientList');
      } else if (2 == index) {
        this.$router.push('/HcpOperationHistory');
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    var para = {
      page: this.page
    };
    var win = window.innerWidth;
    this.dialogSize = win < 1500 ? 'small' : 'tiny';
    var lang = sessionStorage.getItem('language');
    this.styleChange = lang === 'zh' || lang === 'hk' ? true : false;

    this.isZh = lang === 'zh' ? true : false;

    var countryIndex = localStorage.getItem('index');
    console.info('countryIndex:' + countryIndex + ',' + lang + ',' + this.isPl);
    if (1 == countryIndex || 6 == countryIndex || 14 == countryIndex) {
      this.isEU = false;
    }

    setTimeout(function () {
      var host = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getOuterHost();
      _this.contactURL = host + '/contact.html';
      _this.privacyURL = host + '/privacy_policy.html';
      _this.termsOfUseURL = host + '/terms_of_use.html';
    }, 50);
  }
});

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_base64__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_format__ = __webpack_require__(8);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home1',
  data: function data() {
    return {
      isZh: false, isEU: false,
      menuInfo2: [{
        title: 't0805_User_Management',
        bkColor: '#0c544f',
        imgUrl: "/static/accountadmin/icon_userman.png",
        permission: 'EasyPatchLogin'
      }, {
        title: 't0805_Patient_Management',
        bkColor: '#335ea8',
        imgUrl: "/static/accountadmin/icon_patientman.png",
        permission: 'EasyPatchLogin'
      }, {
        title: 't0805_Operation_History',
        bkColor: '#ee7c58',
        imgUrl: "/static/accountadmin/icon_operationhis.png",
        permission: 'EasyPatchLogin'
      }],
      users: [{}, {}],
      contactURL: '',
      privacyURL: '',
      termsOfUseURL: ''
    };
  },
  beforeCreate: function beforeCreate() {
    __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].checkAuth();
    if (!__WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].authenticated) {}
  },

  methods: {
    clickMenu: function clickMenu(index) {
      console.log('clickMenu:', index);
      if (1 == index) {
        this.$router.push('/PatientList');
      }
    },
    getHcpGroupAction: function getHcpGroupAction() {
      var actionMap = {
        'add': this.$t('t0805_Add'),
        'delete': this.$t('t0805_Delete')
      };

      this.$http.post('/api/v2.1/hcp_group/get_action_record').then(function (res) {
        console.log('action record:', res.data);
        if (0 == res.data.error) {
          this.users = res.data.data.map(function (e, i) {
            e['update_time'] = __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate1a(new Date(e['update_time'] * 1000));
            if (actionMap[e['action']]) {
              e['action'] = actionMap[e['action']];
            }

            return e;
          });
        }
      }, function (err) {});
    },
    backToMenu: function backToMenu() {
      this.$router.push('/HcpMenu');
    }
  },

  mounted: function mounted() {
    var _this = this;

    var para = {
      page: this.page
    };
    var win = window.innerWidth;
    this.dialogSize = win < 1500 ? 'small' : 'tiny';
    var lang = sessionStorage.getItem('language');
    this.styleChange = lang === 'zh' || lang === 'hk' ? true : false;

    this.isZh = lang === 'zh' ? true : false;

    var countryIndex = localStorage.getItem('index');
    console.info('countryIndex:' + countryIndex + ',' + lang + ',' + this.isPl);
    if (1 == countryIndex || 6 == countryIndex || 14 == countryIndex) {
      this.isEU = false;
    }

    this.getHcpGroupAction();

    setTimeout(function () {
      var host = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getOuterHost();
      _this.contactURL = host + '/contact.html';
      _this.privacyURL = host + '/privacy_policy.html';
      _this.termsOfUseURL = host + '/terms_of_use.html';
    }, 50);
  }
});

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_format__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_base64__ = __webpack_require__(9);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home1',
  data: function data() {
    return {
      isZh: false, isEU: false,
      contactURL: '',
      privacyURL: '',
      termsOfUseURL: '',
      menuInfo2: [{
        title: 't0805_User_Management',
        bkColor: '#0c544f',
        imgUrl: "/static/accountadmin/icon_userman.png",
        permission: 'EasyPatchLogin'
      }, {
        title: 't0805_Patient_Management',
        bkColor: '#335ea8',
        imgUrl: "/static/accountadmin/icon_patientman.png",
        permission: 'EasyPatchLogin'
      }, {
        title: 't0805_Operation_History',
        bkColor: '#ee7c58',
        imgUrl: "/static/accountadmin/icon_operationhis.png",
        permission: 'EasyPatchLogin'
      }],
      users: [],
      selectAll: false
    };
  },
  beforeCreate: function beforeCreate() {
    __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].checkAuth();
    if (!__WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].authenticated) {}
  },

  computed: {},
  methods: {
    clickMenu: function clickMenu(index) {
      console.log('clickMenu:', index);
      if (1 == index) {
        this.$router.push('/PatientList');
      }
    },
    hcpGroupUser: function hcpGroupUser(uid) {
      console.log('uid:', uid);
      sessionStorage.setItem('hcp_group_user_uid', uid);
      this.$router.push('/HcpGroupUserInfo');
    },
    addUser: function addUser() {
      this.$router.push('/HcpAddUser');
    },
    backToMenu: function backToMenu() {
      this.$router.push('/HcpMenu');
    },
    deleteUser: function deleteUser() {
      var ids = [];
      var username = [];
      this.users.map(function (e, i) {
        if (e.check) {
          ids.push(e.id);
          username.push(e.username);
        }
      });
      this.$http.post('/api/v2.1/hcp_group/delete_user', {
        ids: ids,
        username: username
      }).then(function (res) {
        console.log('delete_user:', res.data);
        if (0 == res.data.error) {
          this.$message({
            type: 'success',
            message: 'OK'
          });
          this.getHcpGroupUser();
        }
      }, function (err) {});
    },
    chooseAll: function chooseAll() {
      var _this = this;

      this.selectAll = !this.selectAll;
      this.users.map(function (e, i) {
        e.check = _this.selectAll;
      });
    },
    select: function select(index) {
      this.users[index].check = !this.users[index].check;
      var selectAll = true;
      var selectNone = true;
      this.users.map(function (e, i) {
        if (!e.check) {
          selectAll = false;
        }
        if (e.check) {
          selectNone = false;
        }
      });
      if (selectAll) {
        this.selectAll = true;
      } else {
        this.selectAll = false;
      }
    },
    getHcpGroupUser: function getHcpGroupUser() {
      this.$http.post('/api/v2.1/hcp_group/get_user_list').then(function (res) {
        console.log('hcp_group:', res.data);
        if (0 == res.data.error) {
          this.users = res.data.data;
        }
      }, function (err) {});
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    var para = {
      page: this.page
    };
    var win = window.innerWidth;
    this.dialogSize = win < 1500 ? 'small' : 'tiny';
    var lang = sessionStorage.getItem('language');
    this.styleChange = lang === 'zh' || lang === 'hk' ? true : false;

    this.isZh = lang === 'zh' ? true : false;

    var countryIndex = localStorage.getItem('index');
    console.info('countryIndex:' + countryIndex + ',' + lang + ',' + this.isPl);
    if (1 == countryIndex || 6 == countryIndex || 14 == countryIndex) {
      this.isEU = false;
    }

    this.getHcpGroupUser();

    setTimeout(function () {
      var host = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getOuterHost();
      _this2.contactURL = host + '/contact.html';
      _this2.privacyURL = host + '/privacy_policy.html';
      _this2.termsOfUseURL = host + '/terms_of_use.html';
    }, 50);
  }
});

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      username: '', password: '', user: this.$t('user'), pas: this.$t('password'),
      error: '', isA: false, isB: false, isC: false, isEs: false, isPo: false
    };
  },

  computed: {
    getLanguage: function getLanguage() {
      return this.$store.state.language;
    }
  },
  watch: {
    getLanguage: function getLanguage(val) {
      this.user = this.$t('user');
      this.pas = this.$t('password');
    }
  },
  mounted: function mounted() {
    var host = window.location.host;
    var protocol = window.location.protocol;
    var url = '/v3/#/login';
    var href = protocol + '//' + host + url;
    window.location.href = href;

    var f = localStorage.getItem('hcpRemember');
    if (f === '1') {
      this.username = localStorage.getItem('hcpUsername');
      this.password = localStorage.getItem('hcpPassword');
      this.isA = true;
    } else {
      this.isA = false;
    }
    var tz = -(new Date().getTimezoneOffset() / 60);
    sessionStorage.setItem('tz', tz);
    if (!sessionStorage.getItem('flag')) {
      __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].checkBrowser(this);
      sessionStorage.setItem('loginPath', '/login');
      var OS = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].detectOS();
      sessionStorage.setItem('OS', OS);
    }
    this.isEs = sessionStorage.getItem('language') === 'es' ? true : false;
    this.isPo = sessionStorage.getItem('language') === 'po' ? true : false;
  },
  created: function created() {

    var that = this;
    document.onkeydown = function (e) {
      e = window.event || e;
      if (that.$route.path === '/login' && (e.code === 'Enter' || e.code === 'enter' || e.code === 'NumpadEnter') && !e.isComposing) {
        that.submit();
      }
    };
  },

  methods: {
    submit: function submit() {
      var info = {
        user_name: this.username,
        user_type: 'P',
        password: this.password
      };
      if (this.isA) {
        localStorage.setItem('hcpUsername', this.username);
        localStorage.setItem('hcpPassword', this.password);
        localStorage.setItem('hcpRemember', 1);
      } else {
        localStorage.setItem('hcpRemember', 0);
      }
      if (this.username === "" || this.password === "") {
        var tip = this.$t('username and password is required');
        this.$message.error(tip);
      } else {
        __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].login(this, info);
      }
    },
    choose: function choose() {
      this.isA = !this.isA;
    },
    check2: function check2() {
      this.isB = !this.isB;
      if (this.user === '') {
        this.user = this.$t('user');
      } else {
        this.user = '';
      }
    },
    check3: function check3() {
      this.isC = !this.isC;
      if (this.pas === '') {
        this.pas = this.$t('password');
      } else {
        this.pas = '';
      }
    },
    up: function up() {
      var obj = document.getElementById('name');
      obj.focus();
    },
    down: function down() {
      var obj = document.getElementById('psd');
      obj.focus();
    },
    sign: function sign() {
      this.$router.push('/sign');
    },
    forgot: function forgot() {
      sessionStorage.removeItem('A');
      sessionStorage.removeItem('B');
      sessionStorage.removeItem('C');
      sessionStorage.removeItem('D');
      this.$router.push('/updatePassword');
      sessionStorage.setItem('udHcp', 1);
    }
  }
});

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      username: '',
      password: '',
      errorTip: '',
      contactURL: '',
      privacyURL: '',
      termsOfUseURL: ''
    };
  },

  computed: {},
  watch: {},
  mounted: function mounted() {
    this.contactURL = 'https://www.medtrum.com/contact.html';
    this.privacyURL = 'https://www.medtrum.com/contact.html';
    this.termsOfUseURL = 'https://www.medtrum.com/contact.html';
  },
  created: function created() {
    var that = this;
    document.onkeydown = function (e) {
      e = window.event || e;
      if ((e.code === 'Enter' || e.code === 'enter' || e.code === 'NumpadEnter') && that.$route.path === '/managementtools' && !e.isComposing) {
        that.accountAdminLogin();
      }
    };
  },

  methods: {
    accountAdminLogin: function accountAdminLogin() {
      this.$http.post('/api/v2.0/login', {
        user_name: this.username,
        user_type: 'P',
        password: this.password,
        flag: 'account_admin_login'
      }).then(function (res) {
        var errorCode = res.body.error;
        if (2 == errorCode) {
          this.$message.error('Account not exist.');
        } else if (errorCode) {
          this.$message.error('Login fail.');
        } else {
          var role = res.body.role;
          sessionStorage.setItem('token', 'Header:' + res.bodyText);
          sessionStorage.setItem('account_admin_username', res.body.username);
          sessionStorage.setItem('uid', res.body.uid);
          sessionStorage.setItem('role', role);
          if ('AccountAdminSuper' == role) {
            this.$router.push('/accountsadmin_super');
          } else if ('AccountAdmin' == role || 'AgencyAccountAdmin' == role) {
            sessionStorage.setItem('account_admin_permission', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.body.permission));
            this.$router.push('/accountsadmin_home');
          }
        }
      }, function (err) {});
    }
  }
});

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      username: '', password: '', user: this.$t('user'), pas: this.$t('password'),
      error: '', isA: false, isB: false, isC: false, isEs: false, isPo: false
    };
  },

  computed: {
    getLanguage: function getLanguage() {
      return this.$store.state.language;
    }
  },
  watch: {
    getLanguage: function getLanguage(val) {
      this.user = this.$t('user');
      this.pas = this.$t('password');
    }
  },
  created: function created() {
    var that = this;
    document.onkeydown = function (e) {
      e = window.event || e;
      if (that.$route.path === '/accountsmanagement' && (e.code === 'Enter' || e.code === 'enter' || e.code === 'NumpadEnter') && !e.isComposing) {
        that.submit();
      }
    };
  },
  mounted: function mounted() {
    var f = localStorage.getItem('hcpRemember');
    if (f === '1') {
      this.username = localStorage.getItem('hcpUsername');
      this.password = localStorage.getItem('hcpPassword');
      this.isA = true;
    } else {
      this.isA = false;
    }
    var tz = -(new Date().getTimezoneOffset() / 60);
    sessionStorage.setItem('tz', tz);
    if (!sessionStorage.getItem('flag')) {
      __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].checkBrowser(this);
      sessionStorage.setItem('loginPath', '/login');
      var OS = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].detectOS();
      sessionStorage.setItem('OS', OS);
    }
    this.isEs = sessionStorage.getItem('language') === 'es' ? true : false;
    this.isPo = sessionStorage.getItem('language') === 'po' ? true : false;
  },

  methods: {
    submit: function submit() {
      var info = {
        user_name: this.username,
        user_type: 'P',
        password: this.password,
        flag: 'admin_login'
      };
      if (this.isA) {
        localStorage.setItem('hcpUsername', this.username);
        localStorage.setItem('hcpPassword', this.password);
        localStorage.setItem('hcpRemember', 1);
      } else {
        localStorage.setItem('hcpRemember', 0);
      }
      if (this.username === "" || this.password === "") {
        var tip = this.$t('username and password is required');
        this.$message.error(tip);
      } else {
        __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].login(this, info);
      }
    },
    choose: function choose() {
      this.isA = !this.isA;
    },
    check2: function check2() {
      this.isB = !this.isB;
      if (this.user === '') {
        this.user = this.$t('user');
      } else {
        this.user = '';
      }
    },
    check3: function check3() {
      this.isC = !this.isC;
      if (this.pas === '') {
        this.pas = this.$t('password');
      } else {
        this.pas = '';
      }
    },
    up: function up() {
      var obj = document.getElementById('name');
      obj.focus();
    },
    down: function down() {
      var obj = document.getElementById('psd');
      obj.focus();
    },
    sign: function sign() {
      this.$router.push('/sign');
    },
    forgot: function forgot() {
      sessionStorage.removeItem('A');
      sessionStorage.removeItem('B');
      sessionStorage.removeItem('C');
      sessionStorage.removeItem('D');
      this.$router.push('/updatePassword');
      sessionStorage.setItem('udHcp', 1);
    }
  }
});

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      username: '', password: '', user: this.$t('user'), pas: this.$t('password'),
      error: '', isA: false, isB: false, isC: false, isEs: false, isPo: false
    };
  },

  computed: {
    getLanguage: function getLanguage() {
      return this.$store.state.language;
    }
  },
  watch: {
    getLanguage: function getLanguage(val) {
      this.user = this.$t('user');
      this.pas = this.$t('password');
    }
  },
  created: function created() {
    var that = this;
    document.onkeydown = function (e) {
      e = window.event || e;
      if (that.$route.path === '/clinic' && (e.code === 'Enter' || e.code === 'enter' || e.code === 'NumpadEnter') && !e.isComposing) {
        that.submit();
      }
    };
  },
  mounted: function mounted() {
    var f = localStorage.getItem('hcpRemember');
    if (f === '1') {
      this.username = localStorage.getItem('hcpUsername');
      this.password = localStorage.getItem('hcpPassword');
      this.isA = true;
    } else {
      this.isA = false;
    }
    var tz = -(new Date().getTimezoneOffset() / 60);
    sessionStorage.setItem('tz', tz);
    if (!sessionStorage.getItem('flag')) {
      __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].checkBrowser(this);
      sessionStorage.setItem('loginPath', '/login');
      var OS = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].detectOS();
      sessionStorage.setItem('OS', OS);
    }
    this.isEs = sessionStorage.getItem('language') === 'es' ? true : false;
    this.isPo = sessionStorage.getItem('language') === 'po' ? true : false;
  },

  methods: {
    submit: function submit() {
      var info = {
        user_name: this.username,
        user_type: 'P',
        password: this.password,
        flag: 'clinic_login'
      };
      if (this.isA) {
        localStorage.setItem('hcpUsername', this.username);
        localStorage.setItem('hcpPassword', this.password);
        localStorage.setItem('hcpRemember', 1);
      } else {
        localStorage.setItem('hcpRemember', 0);
      }
      if (this.username === "" || this.password === "") {
        var tip = this.$t('username and password is required');
        this.$message.error(tip);
      } else {
        __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].login(this, info);
      }
    },
    choose: function choose() {
      this.isA = !this.isA;
    },
    check2: function check2() {
      this.isB = !this.isB;
      if (this.user === '') {
        this.user = this.$t('user');
      } else {
        this.user = '';
      }
    },
    check3: function check3() {
      this.isC = !this.isC;
      if (this.pas === '') {
        this.pas = this.$t('password');
      } else {
        this.pas = '';
      }
    },
    up: function up() {
      var obj = document.getElementById('name');
      obj.focus();
    },
    down: function down() {
      var obj = document.getElementById('psd');
      obj.focus();
    },
    sign: function sign() {
      this.$router.push('/sign');
    },
    forgot: function forgot() {
      sessionStorage.removeItem('A');
      sessionStorage.removeItem('B');
      sessionStorage.removeItem('C');
      sessionStorage.removeItem('D');
      this.$router.push('/updatePassword');
      sessionStorage.setItem('udHcp', 1);
    }
  }
});

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_base64__ = __webpack_require__(9);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home1',
  data: function data() {
    return {
      keywords: '',
      searchPatient: false, activeIndex: '1', dialogFormVisible: false,
      tooltipVisible: true, styleChange: '', isEs: false, isZh: false,
      pages: '', page: 1, has_next: '', has_prev: '', dialogSize: 'tiny', dialogSize2: 'small', isC: false, isSw: false, isCz: false,
      uids: [], flag: 0, count: 0, filter: '', filFlag: false, filFlag2: false, isDe: false, isIt: false, isPo: false, isPl: false, isDu: false, isFr: false,
      lab1: false, lab2: false, lab3: false, lab5: false, lab6: false, lab7: false, lab8: false, lab17: false, lab18: false,
      lab9: false, lab10: false, lab11: false, lab12: false, lab13: false, lab14: false, lab15: false, lab16: false, lab19: false,
      isEU: true,
      showConfirmDialog: false,
      hcpGroupMenu: false,
      contactURL: '',
      privacyURL: '',
      termsOfUseURL: '',
      currentPage: 1,
      pageSize: 11,
      totalPage: 1,
      displayTab: true,
      imgSrc: __webpack_require__(1304),
      checked: false,
      checkList: [],
      autocomplate: 'off'
    };
  },
  beforeCreate: function beforeCreate() {
    __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].checkAuth();
    if (!__WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].authenticated) {}
    this.$store.state.users = [];
  },

  computed: {
    users: function users() {
      return this.$store.state.users;
    },
    currentPageData: function currentPageData() {
      var pa = Math.ceil(this.$store.state.users.length / this.pageSize);
      pa = pa == 0 ? 1 : pa;
      this.totalPage = pa;
      var begin = (this.currentPage - 1) * this.pageSize;
      var end = this.currentPage * this.pageSize;
      this.displayTab = false;
      return this.$store.state.users.slice(begin, end);
    }
  },
  methods: {
    getUsers: function getUsers() {
      this.displayTab = true;
      this.filFlag2 = this.keywords ? true : false;
      if (this.filFlag || this.keywords) {
        var para = {
          filter: this.filter
        };
        para = __WEBPACK_IMPORTED_MODULE_2__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(para));
      } else {
        var _para = {
          page: this.page
        };
        __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].getUserListAll(this, { per_page: 9999 });
      }
    },
    start: function start() {
      var table = document.getElementById('patientList');
      var labels = table.getElementsByTagName('label');
      for (var i = 0; i < labels.length; i++) {
        labels[i].className = ' ';
      }
    },
    imgload: function imgload(e) {
      var c = '/api/v2.0/person/' + e + '/portrait?t';
      return 'this.οnlοad=null;this.src=' + '"' + c + '";';
    },
    chooseAll: function chooseAll() {
      var _this = this;
      if (!_this.checked) {
        _this.checkList = [];
      } else {
        _this.checkList = [];
        _this.users.forEach(function (item, index) {
          if (index >= 0) {
            _this.checkList.push(item.uid);
          }
        });
      }
      console.log(_this.users);
    },
    reportrait: function reportrait() {
      for (var i = 0; i < this.$refs.imgs.length; i++) {
        this.$refs.imgs[i].src = this.imgSrc;
      }
    },
    deleteP: function deleteP() {
      var _this2 = this;

      if (this.checkList.length > 0) {
        var tip = this.$t('deletePtip');
        var tip1 = this.$t('confirm');
        var tip2 = this.$t('Yes');
        var tip3 = this.$t('No');
        this.$confirm(tip, tip1, {
          confirmButtonText: tip2,
          cancelButtonText: tip3,
          type: 'warning'
        }).then(function () {
          var uids = _this2.checkList;
          _this2.$http.post('api/v2.0/patients/delete', { 'uids': uids }).then(function (res) {
            var err = res.body.error;
            if (err === 0) {
              var _tip = this.$t('deleteSuccess');
              this.$message({
                type: 'success',
                message: _tip
              });
              this.reportrait();
              this.getUsers();
            }
          }, function (err) {
            var tip = this.$t('deleteFailed');
            this.$message.error(tip);
          });
        }, function () {});
      }
    },
    goDetail: function goDetail(e) {
      var num = (this.currentPage - 1) * 11;
      console.log('num:' + num);
      var parentNodeid = e.currentTarget.id;
      var index = +parentNodeid + +num;

      var uid = this.users[index].uid;
      var name = this.users[index].name;
      if (name === null || undefined) {
        name = '';
      }
      console.log('uid' + uid + '，name' + name);
      sessionStorage.setItem('chart6page', '');
      sessionStorage.setItem('patientId', uid);
      sessionStorage.setItem('patientName', name);
      var danum = this.currentPage;
      sessionStorage.setItem('patientPages', danum);

      this.$router.push('/monitor');
    },
    nextPage: function nextPage() {
      if (this.currentPage == this.totalPage) return;
      this.reportrait();
      this.currentPage++;
      this.start();
    },
    prevPage: function prevPage() {
      if (this.currentPage == 1) return;
      this.reportrait();
      this.currentPage--;
      this.start();
    },
    go: function go() {
      if (0 < this.currentPage && this.currentPage < this.totalPage + 1) {
        this.reportrait();
        this.getUsers();
      } else {
        this.reportrait();
        this.currentPage = 1;
        this.getUsers();
      }
    },
    NewPatient: function NewPatient() {
      this.$router.push('/newPatient');
    },
    findPatient: function findPatient() {
      this.$router.push('/findPatient');
    },
    choose1: function choose1() {
      this.lab1 = !this.lab1;
      this.lab2 = false;
      this.lab3 = false;
      this.lab17 = false;
    },
    choose2: function choose2() {
      this.lab2 = !this.lab2;
      this.lab1 = false;
    },
    choose3: function choose3() {
      this.lab3 = !this.lab3;
      this.lab1 = false;
    },
    choose17: function choose17() {
      this.lab17 = !this.lab17;
      this.lab1 = false;
    },
    choose5: function choose5() {
      this.lab5 = !this.lab5;
      this.lab6 = false;
      this.lab7 = false;
      this.lab8 = false;
      this.lab9 = false;
      this.lab18 = false;
    },
    choose6: function choose6() {
      this.lab6 = !this.lab6;
      this.lab5 = false;
    },
    choose7: function choose7() {
      this.lab7 = !this.lab7;
      this.lab5 = false;
    },
    choose8: function choose8() {
      this.lab8 = !this.lab8;
      this.lab5 = false;
    },
    choose9: function choose9() {
      this.lab9 = !this.lab9;
      this.lab5 = false;
    },
    choose18: function choose18() {
      this.lab18 = !this.lab18;
      this.lab5 = false;
    },
    choose10: function choose10() {
      this.lab10 = !this.lab10;
      this.lab11 = false;
      this.lab12 = false;
      this.lab13 = false;
      this.lab14 = false;
      this.lab15 = false;
      this.lab16 = false;
      this.lab19 = false;
    },
    choose11: function choose11() {
      this.lab11 = !this.lab11;
      this.lab10 = false;
    },
    choose12: function choose12() {
      this.lab12 = !this.lab12;
      this.lab10 = false;
    },
    choose13: function choose13() {
      this.lab13 = !this.lab13;
      this.lab10 = false;
    },
    choose14: function choose14() {
      this.lab14 = !this.lab14;
      this.lab10 = false;
    },
    choose15: function choose15() {
      this.lab15 = !this.lab15;
      this.lab10 = false;
    },
    choose16: function choose16() {
      this.lab16 = !this.lab16;
      this.lab10 = false;
    },
    choose19: function choose19() {
      this.lab19 = !this.lab19;
      this.lab10 = false;
    },
    checkFilter: function checkFilter() {
      this.dialogFormVisible = false;
      var flag = this.lab2 || this.lab3 || this.lab6 || this.lab7 || this.lab8 || this.lab9 || this.lab11 || this.lab12 || this.lab13 || this.lab14 || this.lab15 || this.lab16 || this.lab17 || this.lab18 || this.lab19;
      this.filFlag = flag;
      if (flag || this.keywords) {
        if (flag) {
          this.tooltipVisible = false;
        }
        var gender = [],
            age = [],
            diabetes_type = [],
            filter = {};
        if (this.lab2) {
          gender.push('GDRF');
        }
        if (this.lab3) {
          gender.push('GDRM');
        }
        if (this.lab17) {
          gender.push('GDRNF');
        }

        if (this.lab6) {
          age.push([0, 17]);
        }
        if (this.lab7) {
          age.push([18, 40]);
        }
        if (this.lab8) {
          age.push([41, 60]);
        }
        if (this.lab9) {
          age.push([61, 200]);
        }
        if (this.lab18) {
          age.push(null);
        }

        if (this.lab11) {
          diabetes_type.push('DBT1');
        }
        if (this.lab12) {
          diabetes_type.push('DBT2');
        }
        if (this.lab13) {
          diabetes_type.push('DBTGEST');
        }
        if (this.lab14) {
          diabetes_type.push('DBTPRE');
        }
        if (this.lab15) {
          diabetes_type.push('DBTLADA');
        }
        if (this.lab19) {
          diabetes_type.push('DBTNF');
        }

        if (gender.length !== 0 && gender.length !== 3) {
          filter.gender = gender;
        }
        if (age.length !== 0 && age.length !== 5) {
          filter.age = age;
        }
        if (diabetes_type.length !== 0 && diabetes_type.length !== 6) {
          filter.diabetes_type = diabetes_type;
        }

        filter.keywords = this.keywords;
        this.filFlag2 = this.keywords ? true : false;
        this.filter = filter;
        var para = {
          filter: filter
        };
        para = __WEBPACK_IMPORTED_MODULE_2__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(para));
        __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].getUserList(this, { 'param': para, 'page': 1 });
      } else {
        this.tooltipVisible = true;
        this.getUsers();
      }
    },
    check: function check(flag) {
      if (flag === 1) {
        this.currentPage = 1;
        this.checkFilter();
      }
      this.searchPatient = !this.searchPatient;
    },
    cancelFilter: function cancelFilter() {
      this.dialogFormVisible = false;
      this.checkFilter();
    },
    formateDate: function formateDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth();
      var d = date.getDate();
      var h = date.getHours();
      var mi = date.getMinutes();
      var s = date.getSeconds();
      m = m < 10 ? '0' + m : m;
      d = d < 10 ? '0' + d : d;
      return y + '-' + m + '-' + d + ' ' + h + ':' + mi + ':' + s;
    },
    checkPrivacyVersion: function checkPrivacyVersion() {
      this.$http.get('/api/v2.1/user/privacy/confirm').then(function (res) {
        console.log("privacy confirm:", res.data);
        if (0 == res.data.error) {
          if (0 == res.data.confirm) {
            this.showConfirmDialog = true;
          }
        }
      }, function (err) {});
    },
    denyPrivacyConfirm: function denyPrivacyConfirm() {
      this.showConfirmDialog = false;
    },
    agreePrivacyConfirm: function agreePrivacyConfirm() {
      this.showConfirmDialog = false;
      this.$http.post('/api/v2.1/user/privacy/confirm').then(function (res) {
        console.log('privacy confirm:', res.data);
      }, function (err) {});
    },
    backToMenu: function backToMenu() {
      this.$router.push('/HcpMenu');
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    var dnum = sessionStorage.getItem('patientPages');
    if (dnum == null || dnum === 'null' || !dnum) {
      dnum = 1;
    }
    this.currentPage = dnum;
    this.displayTab = true;
    var para = {
      page: this.page
    };
    var win = window.innerWidth;
    this.dialogSize = win < 1500 ? 'small' : 'tiny';
    var lang = sessionStorage.getItem('language');
    this.styleChange = lang === 'zh' || lang === 'hk' ? true : false;
    this.isEs = lang === 'es' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isPl = lang === 'pl' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isSw = lang === 'sw' ? true : false;
    this.isZh = lang === 'zh' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    var userCreatedBy = localStorage.getItem('userCreatedBy');
    console.log('userCreatedBy:', userCreatedBy);
    this.hcpGroupMenu = localStorage.getItem('userCreatedBy') != 'hcp_group';
    var countryIndex = localStorage.getItem('index');
    console.info('countryIndex:' + countryIndex + ',' + lang + ',' + this.isPl);
    if (1 == countryIndex || 6 == countryIndex || 14 == countryIndex) {
      this.isEU = false;
    }
    __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].getUserListAll(this, { per_page: 9999 });
    this.checkPrivacyVersion();
    setTimeout(function () {
      var host = __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].getOuterHost();
      _this3.contactURL = host + '/contact.html';
      _this3.privacyURL = host + '/privacy_policy.html';
      _this3.termsOfUseURL = host + '/terms_of_use.html';
    }, 50);
  },
  watch: {
    currentPageData: function currentPageData() {
      this.displayTab = false;
    },
    checkList: function checkList() {},
    checked: function checked() {
      var _this = this;
      if (!_this.checked) {
        _this.checkList = [];
      } else {
        _this.checkList = [];
        _this.users.forEach(function (item, index) {
          if (index >= 0) {
            _this.checkList.push(item.uid);
          }
        });
      }
    }
  }
});

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_format__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      email: '',
      mobile: '',
      vcode: '',
      icode: '',
      password: '',
      error: '',
      realname: '',
      token: '', time: 60, showTime: false,
      newStyle: false,
      send: this.$t('Getcode'), Ema: this.$t('Enter email'), Mob: this.$t('Enter mobile'),
      Veri: this.$t('Entercode'), invi: this.$t('Invitation'), fullname: this.$t('full name'), Enterpas: this.$t('Enter pass'),
      canClick: false,

      country: ['GB', 'CN', 'FR', 'DD', 'SE', 'AU', 'HKF', 'HU', 'IT', 'NL', 'Nor', 'PT', 'ES', 'TR', 'AE', 'Ro', 'CZ', 'SK', 'LT', 'PL', 'DK', 'FI', 'TH', 'ID', 'MY', 'IN', 'CH', 'SA', 'AE', 'QA', 'QW', 'RH', 'AT', 'SI', 'EE', 'LV', 'BA', 'BG', 'CL', 'BE'],

      isA: false, isB: true, isC: false, isD: true, isE: false, isF: false,
      isG: false, isH: false, isI: false, isJ: false, isK: false,
      isO: false, isP: false, isQ: false, isR: false, isS: false, isT: false,
      disA: true, disB: true, disC: true, disD: true, disE: true, disF: true,
      ps1: false, ps2: false, ps3: false, ps4: false, ps5: false, ps6: false, hostname: '',
      tabA: true, tabB: false, isA2: false, isAgree: false, isEU: true, isNext: false,

      privacyURL: '',
      termsOfUseURL: ''
    };
  },

  vuerify: {
    realname: 'realname',
    icode: 'icode',
    vcode: 'icode',
    mobile: 'mobile',
    email: 'email'
  },
  computed: {
    errors: function errors() {
      return this.$vuerify.$errors;
    },
    getLanguage: function getLanguage() {
      return this.$store.state.language;
    }
  },
  watch: {
    getLanguage: function getLanguage(val) {
      this.send = this.$t('Getcode');
      this.Ema = this.$t('Enter email');
      this.Mob = this.$t('Enter mobile');
      this.Veri = this.$t('Entercode');
      this.fullname = this.$t('full name');
      this.Enterpas = this.$t('Enter pass');
      if (val === 'zh') {
        this.newStyle = true;
      } else {
        this.newStyle = false;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].initLanguages(this);
    var lang = sessionStorage.getItem('language');
    this.newStyle = lang === 'zh' || lang === 'hk' ? true : false;
    var index = localStorage.getItem('index');
    if (index) {
      var country = this.country[index];
      var obj = document.getElementById('chooseCountry');
      for (var i = 0; i < obj.options.length; i++) {
        if (obj.options[i].value === country) {
          obj.options[i].selected = true;
          break;
        }
      }
    }

    setTimeout(function () {
      var host = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getOuterHost();
      console.log("sign host:", host);

      _this.privacyURL = host + '/privacy_policy.html';
      _this.termsOfUseURL = host + '/terms_of_use.html';
    }, 50);
  },

  methods: {
    register: function register(e) {
      var info = {
        user_type: this.isB ? 'P' : 'M',
        user_name: this.isD ? this.email : this.mobile,
        password: this.password,
        real_name: this.realname.trim(),
        country: '',
        token: this.token,
        seccode: this.vcode,
        ver: 2
      };
      if (this.$vuerify.valid) {
        var obj = document.getElementById('chooseCountry');
        info.country = obj.value;
        info.test = 'yes';

        if (-1 == e.target.className.indexOf('create-account')) {} else {
          delete info.test;
        }

        __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].register(this, info);


        if ('CN' == info.country) {
          this.isEU = false;
        }
      } else {
        var err = this.$t('infoWrongTip');
        alert(this.$vuerify.$errors.email || err);
      }
    },
    sendSeccode: function sendSeccode() {
      var para = {
        user_name: this.isD ? this.email : this.mobile,
        country: '',
        flag: this.isD ? 'email' : 'mobile',
        purpose: 'regist'
      };
      var obj = document.getElementById('chooseCountry');
      para.country = obj.value;
      var wright = this.isD ? this.disA : this.disB;
      if (para.user_name !== "" && wright) {
        this.$http.get('api/v2.0/user/' + para.user_name).then(function (res) {
          var exist = res.body.exist;
          if (exist) {
            this.$message.error('The username entered already exists.');
          } else {
            var tip = '';
            if (this.newStyle) {
              tip = this.$t('VcodeTip1') + ' ' + para.user_name;
            } else {
              tip = this.$t('VcodeTip3') + ' ' + para.user_name;
            }
            this.$message({
              type: 'success',
              message: tip
            });
            __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].sendSeccode(this, para);
            __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].setTime(this);
          }
        });
      } else {
        var tip = this.$t('Input error');
        this.$message.error(tip);
        this.isO = true;
      }
    },
    checkPassword: function checkPassword() {
      var password = this.password.trim();
      if (password.length > 5 && password.length < 21) {
        this.ps2 = true;
      } else {
        this.ps2 = false;
      }
      if (password.length > 0) {
        if (password.indexOf(' ') === -1) {
          this.ps6 = true;
        } else {
          this.ps6 = false;
        }
        if (password !== this.realname.trim()) {
          this.ps3 = true;
        } else {
          this.ps3 = false;
        }
        var p1 = /[a-z]/.test(password),
            p2 = /[A-Z]/.test(password),
            p3 = /[0-9]/.test(password),
            p4 = /[!@#$%^&*()_+={},.;'\\":~`\[\]<>|/?]/.test(password),
            count = 0;
        if (p1) {
          count++;
        }
        if (p2) {
          count++;
        }
        if (p3) {
          count++;
        }
        if (p4) {
          count++;
        }
        if (count > 2) {
          this.ps1 = true;
        } else {
          this.ps1 = false;
        }

        for (var i = 0; i < password.length - 2; i++) {
          if (password[i + 1] - password[i] === 1 && password[i + 2] - password[i + 1] === 1) {
            this.flag = 1;break;
          } else {
            this.flag = 0;
          }
          if (password[i] - password[i + 1] === 1 && password[i + 1] - password[i + 2] === 1) {
            this.flag = 1;break;
          } else {
            this.flag = 0;
          }
        }
        if (this.flag === 0) {
          this.ps4 = true;
        } else {
          this.ps4 = false;
        }

        for (var _i = 0; _i < password.length - 2; _i++) {
          if (password[_i + 1].charCodeAt() - password[_i].charCodeAt() === 1 && password[_i + 2].charCodeAt() - password[_i + 1].charCodeAt() === 1) {
            this.flag1 = 1;break;
          } else {
            this.flag1 = 0;
          }
          if (password[_i].charCodeAt() - password[_i + 1].charCodeAt() === 1 && password[_i + 1].charCodeAt() - password[_i + 2].charCodeAt() === 1) {
            this.flag1 = 1;break;
          } else {
            this.flag1 = 0;
          }
        }
        if (this.flag1 === 0) {
          this.ps5 = true;
        } else {
          this.ps5 = false;
        }
      }
      if (this.ps1 === true && this.ps2 === true && this.ps3 === true && this.ps4 === true && this.ps5 === true && this.ps6 === true) {
        this.isT = false;
        this.disF = true;
      } else {
        this.isT = true;
        this.disF = false;
      }
    },


    check1: function check1() {
      this.isA = !this.isA;
      this.isAgree = this.isA && this.isA2;
    },
    check1_2: function check1_2() {
      this.isA2 = !this.isA2;
      this.isAgree = this.isA && this.isA2;
    },
    check2: function check2() {
      this.isB = !this.isB;
      this.isC = !this.isC;
    },
    registerBack: function registerBack() {
      this.tabA = true;
      this.tabB = false;
    },
    check3: function check3() {
      this.isD = !this.isD;
      this.isE = !this.isE;
    },

    check54: function check54(flag) {
      this.isF = !this.isF;

      if (this.Ema === '') {
        this.Ema = this.$t('Enter email');
      } else {
        this.Ema = '';
      }

      if (flag === 1) {
        if (this.$vuerify.$errors.email || this.email === '') {
          this.isO = true;
          this.disA = false;
        } else {
          this.isO = false;
          this.disA = true;
        }
      }
    },
    check55: function check55(flag) {
      this.isG = !this.isG;
      if (this.Mob === '') {
        this.Mob = this.$t('Enter mobile');
      } else {
        this.Mob = '';
      }
      if (flag === 1) {
        if (this.$vuerify.$errors.mobile || this.mobile === '') {
          this.isP = true;
          this.disB = false;
        } else {
          this.isP = false;
          this.disB = true;
        }
      }
    },
    check56: function check56(flag) {
      this.isH = !this.isH;
      if (this.Veri === '') {
        this.Veri = this.$t('Entercode');
      } else {
        this.Veri = '';
      }
      if (flag === 1) {
        if (this.$vuerify.$errors.vcode || this.vcode === '') {
          this.isQ = true;
          this.disC = false;
        } else {
          this.isQ = false;
          this.disC = true;
        }
      }
    },
    check58: function check58(flag) {
      this.isJ = !this.isJ;
      if (this.fullname === '') {
        this.fullname = this.$t('full name');
      } else {
        this.fullname = '';
      }
      if (flag === 1) {
        if (this.$vuerify.$errors.realname || this.realname === '') {
          this.isS = true;
          this.disE = false;
        } else {
          this.isS = false;
          this.disE = true;
        }
      }
    },
    check59: function check59(flag) {
      this.isK = !this.isK;
      if (this.Enterpas === '') {
        this.Enterpas = this.$t('Enter pass');
      } else {
        this.Enterpas = '';
      }
      if (flag === 1) {
        this.checkPassword();
      }
    },
    down: function down(index) {
      var obj = document.getElementById('inputGroup');
      var inputs = obj.getElementsByTagName('input');
      inputs[index + 1].focus();
    },
    up: function up(index) {
      var obj = document.getElementById('inputGroup');
      var inputs = obj.getElementsByTagName('input');
      if (index === 2) {
        if (this.isD) {
          inputs[0].focus();
        }
        if (this.isE) {
          inputs[1].focus();
        }
      } else {
        inputs[index - 1].focus();
      }
    },
    select: function select(e) {
      var country = e.target.value;
      var route = 'sign';
      __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].changeServer(this, country, route);
    }
  }
});

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isA: true, isB: false, isC: false, isD: false, Remark: false, isE: false, isCz: false,
      username: '', user: {}, mark: ' ', isEn: false, uids: [], isDe: false, isIt: false, isZh: false,
      isEU: true,
      contactURL: '',
      privacyURL: '',
      termsOfUseURL: ''
    };
  },

  methods: {
    search: function search() {
      var params = {
        username: this.username
      };
      if (this.username === '') {
        var tip = this.$t('username is required');
        this.$message.error(tip);
      } else {
        this.$http.post('api/v2.0/search/patient', { 'params': params }).then(function (res) {
          var err = res.body.error;

          if (err === 0) {
            this.user = res.data.patient;

            if (this.user.has_relation === true) {
              if (this.user.relation_state === 'ACCEPT') {
                this.isC = false;this.isD = true;this.isE = false;
                this.uids.push(this.user.uid);
                this.mark = this.user.motton ? this.user.motton : '--';
              } else {
                this.isC = false;this.isD = false;this.isE = true;
              }
            } else {
              this.isC = true;this.isD = false;this.isE = false;
            }
            this.isA = false;
            this.isB = true;
          } else if (err === 2) {
            var _tip = this.$t('userNotExist');
            this.$message.error(_tip);
          }
        }, function (err) {
          console.log(err + "," + err.body.message);
          this.error = err.body.message;
        });
      }
    },
    back: function back() {
      this.$router.push('/carerConnection');
    },
    cancel: function cancel() {
      this.Remark = false;
    },
    goCharts: function goCharts() {
      sessionStorage.setItem('patientId', this.user.uid);
      sessionStorage.setItem('patientName', this.user.username);
      this.$router.push('/monitor');
    },
    request: function request() {
      var param = {
        username: this.username
      };
      this.$http.post('/api/v2.0/relations/apply', param).then(function (res) {
        var err = res.body.error;

        if (err === 0) {
          var tip = this.$t('rSent');
          this.$message({
            type: 'success',
            message: tip
          });
          this.$router.push('carerConnection');
        }
        if (err === 19) {
          alert('The userType incorrect');
        }
      }, function (err) {
        console.log(err + "," + err.body.message);
        this.error = err.body.message;
      });
    },
    cancelRequest: function cancelRequest() {
      var param = {
        username: this.username
      };
      this.$http.post('/api/v2.0/relations/apply/cancel', param).then(function (res) {
        var err = res.body.error;

        if (err === 0) {
          var tip = this.$t('cancelR');
          this.$message({
            type: 'success',
            message: tip
          });
          if (sessionStorage.getItem('userType') === 'D') {
            this.$router.push('PatientList');
          } else {
            this.$router.push('carerConnection');
          }
        }
      }, function (err) {
        console.log(err + "," + err.body.message);
        this.error = err.body.message;
      });
    },
    Remove: function Remove() {
      var _this = this;

      var tip = this.$t('CancelTip1');
      var tip1 = this.$t('confirm');
      var tip2 = this.$t('Yes');
      var tip3 = this.$t('Cancel');
      this.$confirm(tip, tip1, {
        confirmButtonText: tip2,
        cancelButtonText: tip3,
        type: 'warning'
      }).then(function () {
        var uids = _this.uids;
        _this.$http.post('api/v2.0/patients/delete', { 'uids': uids }).then(function (res) {
          var err = res.body.error;
          if (err === 0) {
            var _tip2 = this.$t('removeConnect');
            this.$message({
              type: 'success',
              message: _tip2
            });
            this.$router.push('/carerConnection');
          }
        }, function (err) {
          var tip = this.$t('deleteFailed');
          this.$message.error(tip);
        });
      }, function () {});
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isZh = lang === 'zh' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    var countryIndex = localStorage.getItem('index');

    if (1 == countryIndex || 6 == countryIndex || 14 == countryIndex) {
      this.isEU = false;
    }
    setTimeout(function () {
      var host = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getOuterHost();
      _this2.contactURL = host + '/contact.html';
      _this2.privacyURL = host + '/privacy_policy.html';
      _this2.termsOfUseURL = host + '/terms_of_use.html';
    }, 50);
  }
});

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home1',
  data: function data() {
    return {
      dialogSize: 'small',
      activeIndex: '1', loading: false, loadingText: this.$t('Loading'),
      pages: '', page: 1, has_next: '', has_prev: '', unit: '', isDe: false, isZh: false,
      connections: [],
      isEU: true,
      showConfirmDialog: false,
      contactURL: '',
      privacyURL: '',
      termsOfUseURL: ''
    };
  },


  computed: {
    users: function users() {
      return this.$store.state.users;
    }
  },
  methods: {
    add: function add() {
      this.$router.push('/addConnection');
    },
    go: function go(e) {
      var index = e.target.parentNode.id;
      var uid = this.connections[index].uid;
      var name = this.connections[index].alias;
      sessionStorage.setItem('patientId', uid);
      sessionStorage.setItem('patientName', name);
      this.$router.push('/monitor');
    },
    StopFollow: function StopFollow(e) {
      var _this = this;

      var index = e.target.parentNode.id;
      var uid = this.connections[index].uid;
      var tip = this.$t('stopFollow');
      var tip1 = this.$t('confirm');
      var tip2 = this.$t('Yes');
      var tip3 = this.$t('Cancel');
      this.$confirm(tip, tip1, {
        confirmButtonText: tip2,
        cancelButtonText: tip3,
        type: 'warning'
      }).then(function () {
        _this.$http.post('api/v2.0/relations/monitor/cancel', { uid: uid }).then(function (res) {
          var err = res.body.error;
          if (err === 0) {
            this.$message({
              type: 'success',
              message: 'Stop following succeed!'
            });
            __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getConnections(this, { page: this.page });
          } else {
            this.$message.error('Stop following failed!');
          }
        });
      }, function () {});
    },
    nextPage: function nextPage() {
      if (this.page < this.pages) {
        this.page++;
        this.getConnections();
      }
    },
    prevPage: function prevPage() {
      if (this.page > 1) {
        this.page--;
        this.getConnections();
      }
    },
    goPage: function goPage() {
      if (0 < this.page && this.page < this.pages + 1) {
        this.getConnections();
      } else {
        this.page = 1;
        this.getConnections();
      }
    },
    openFullScreen: function openFullScreen() {
      var _this2 = this;

      this.loading = true;
      setTimeout(function () {
        _this2.loading = false;
      }, 2000);
    },
    getConnections: function getConnections() {
      var para = {
        page: this.page
      };
      this.openFullScreen();
      __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getConnections(this, para);
    },
    checkPrivacyVersion: function checkPrivacyVersion() {
      this.$http.get('/api/v2.1/user/privacy/confirm').then(function (res) {
        console.log("privacy confirm:", res.data);
        if (0 == res.data.error) {
          if (0 == res.data.confirm) {
            this.showConfirmDialog = true;
          }
        }
      }, function (err) {});
    },
    denyPrivacyConfirm: function denyPrivacyConfirm() {
      this.showConfirmDialog = false;
    },
    agreePrivacyConfirm: function agreePrivacyConfirm() {
      this.showConfirmDialog = false;
      this.$http.post('/api/v2.1/user/privacy/confirm').then(function (res) {
        console.log('privacy confirm:', res.data);
      }, function (err) {});
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.getConnections();
    this.unit = localStorage.getItem('unit') === 'mg' ? 'mg/dL' : 'mmol/L';
    this.isDe = sessionStorage.getItem('language') === 'de' ? true : false;
    this.isZh = sessionStorage.getItem('language') === 'zh' ? true : false;
    var countryIndex = localStorage.getItem('index');

    if (1 == countryIndex || 6 == countryIndex || 14 == countryIndex) {
      this.isEU = false;
    }

    this.checkPrivacyVersion();
    setTimeout(function () {
      var host = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getOuterHost();
      _this3.contactURL = host + '/contact.html';
      _this3.privacyURL = host + '/privacy_policy.html';
      _this3.termsOfUseURL = host + '/terms_of_use.html';
    }, 50);
  }
});

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      ChooseVisible: false, isA: false, ChooseVisible2: false, isEn: false, isEs: false, isCz: false,
      hcp: [], hcpApply: [], carer: [], carerApply: [], uid: 0, noMes: false, isFr: false, isZh: false,
      oauth2: [], flag: 'delete_connection', oauth2_name: '',
      isEU: true,
      contactURL: '',
      privacyURL: '',
      termsOfUseURL: ''
    };
  },

  computed: {
    updateLocCode: function updateLocCode() {
      console.log('compute updateLocCode:');
      return this.$store.state.loc_code;
    }
  },
  watch: {
    updateLocCode: function updateLocCode(val) {
      console.log('watch updateLocCode:', val);
      var host = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getOuterHost();
      this.contactURL = host + '/contact.html';
      this.privacyURL = host + '/privacy_policy.html';
      this.termsOfUseURL = host + '/terms_of_use.html';
    }
  },
  methods: {
    back: function back() {
      this.$router.push('/monitor');
    },
    getConnections: function getConnections() {
      __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getPatientConnections(this);
    },
    open: function open(flag, e) {
      this.ChooseVisible = true;
      if (e) {
        this.uid = parseInt(e.target.parentNode.parentNode.id);
      }

      flag === 1 ? this.isA = true : this.isA = false;
    },
    agree: function agree() {
      __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].addConnection(this, this.uid);
      this.ChooseVisible = false;
    },
    reject: function reject() {
      __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].rejectConnection(this, this.uid);

      this.ChooseVisible = false;
    },
    openDelete: function openDelete(e) {
      this.flag = 'delete_connection';
      this.ChooseVisible2 = true;
      if (e) {
        this.uid = parseInt(e.target.parentNode.id);
      }
    },
    deleteAuth: function deleteAuth(e) {
      this.flag = 'delete_oauth2';
      console.log("deleteAuth:");
      this.ChooseVisible2 = true;
      if (e) {
        this.oauth2_name = e.target.parentNode.id;
      }
    },
    delete1: function delete1(e) {
      if ('delete_connection' == this.flag) {
        __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].deleteConnection(this, this.uid);
      } else if ('delete_oauth2' == this.flag) {
        var param = { 'name': this.oauth2_name };
        this.$http.post('/api/v2.0/oauth2.0/authorize/cancel', param).then(function (res) {
          console.log('authorize.cancel:', res.body);
          if (0 == res.body.error) {
            __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getPatientConnections(this);
          }
        }, function (err) {});
      }
      this.ChooseVisible2 = false;
    },
    cancel: function cancel() {
      this.ChooseVisible = false;
      this.ChooseVisible2 = false;
    }
  },
  mounted: function mounted() {
    var _this = this;

    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isEs = lang === 'es' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isZh = lang === 'zh' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    var countryIndex = localStorage.getItem('index');

    if (1 == countryIndex || 6 == countryIndex || 14 == countryIndex) {
      this.isEU = false;
    }
    __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getPatientConnections(this);
    setTimeout(function () {
      var host = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getOuterHost();
      _this.contactURL = host + '/contact.html';
      _this.privacyURL = host + '/privacy_policy.html';
      _this.termsOfUseURL = host + '/terms_of_use.html';
    }, 50);
  }
});

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isA: 'true',
      isB: 'false', isM: true, isEs: false, isPo: false, isFr: false
    };
  },
  mounted: function mounted() {
    this.isA = this.$route.path === '/setting' ? true : false;
    this.isB = this.$route.path === '/dateView2' ? true : false;
    var uid = 0;
    this.isM = sessionStorage.getItem('userType') === 'M' ? false : true;

    var lang = sessionStorage.getItem('language');
    this.isEs = lang === 'es' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    if (sessionStorage.getItem('userType') !== 'P') {
      uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      uid = parseInt(sessionStorage.getItem('uid'));
    }
    __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getSettingData(this, uid);
  },

  methods: {
    changeStype1: function changeStype1() {
      this.isA = true;
      this.isB = false;
      this.$router.push('setting');
    },
    changeStype2: function changeStype2() {
      this.isB = true;
      this.isA = false;
      this.$router.push('dateView2');
    },
    back: function back() {
      this.$router.push('/PatientList');
    }
  }
});

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      A0: '', A: '', B: '', C: '', D: '', E: '', F: '', items: [true, false, false, false, false, false], isSw: false,
      value1: '', value2: '', value3: '', notM: true, isEn: false, G: '', H: '', J: '', segment: true, isDe: false, isDu: false,
      chart: '',

      navbar: [{
        'name': 'dashboard',
        'index': 0
      }, {
        'name': 'dashboard',
        'index': 0
      }, {
        'name': 'dashboard',
        'index': 0
      }]
    };
  },
  mounted: function mounted() {
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isSw = lang === 'sw' ? true : false;

    this.A0 = this.$route.path === '/chart0' ? true : false;
    this.A = this.$route.path === '/chart1' ? true : false;
    this.B = this.$route.path === '/chart2' ? true : false;
    this.C = this.$route.path === '/chart3' ? true : false;
    this.D = this.$route.path === '/chart4' ? true : false;
    this.E = this.$route.path === '/chart5' ? true : false;
    this.F = this.$route.path === '/chart6' ? true : false;
    this.G = this.$route.path === '/chart7' ? true : false;
    this.H = this.$route.path === '/chart8' ? true : false;
    this.J = this.$route.path === '/chart9' ? true : false;
    this.notM = sessionStorage.getItem('userType') === 'M' ? false : true;

    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }
  },


  methods: {
    select: function select(index) {
      var path = '/chart' + index;
      this.A0 = path === '/chart0' ? true : false;
      this.A = path === '/chart1' ? true : false;
      this.B = path === '/chart2' ? true : false;
      this.C = path === '/chart3' ? true : false;
      this.D = path === '/chart4' ? true : false;
      this.E = path === '/chart5' ? true : false;
      this.F = path === '/chart6' ? true : false;
      this.G = path === '/chart7' ? true : false;
      this.H = path === '/chart8' ? true : false;
      this.J = path === '/chart9' ? true : false;
      this.$router.push(path);
    },
    back: function back() {
      this.$router.push('/PatientList');
    },
    reload: function reload() {
      this.chart = new Date().getTime();
    }
  }
});

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },
  mounted: function mounted() {}
});

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },

    computed: {},
    watch: {},
    methods: {},
    created: function created() {},
    mounted: function mounted() {}
});

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isHcp: true

    };
  },

  computed: {
    portrait: function portrait() {
      return '/api/v2.0/person/' + parseInt(sessionStorage.getItem('uid')) + '/portrait';
    },
    username: function username() {
      return sessionStorage.getItem('username');
    },
    messageTip: function messageTip() {
      var unRead = parseInt(this.$store.state.unRead);
      var tip = unRead === 0 ? false : true;

      return tip;
    }
  },
  methods: {
    handleCommand: function handleCommand(command) {
      if (command === 'loginOut') {
        sessionStorage.removeItem('token');
        this.$http.post('api/v2.0/logout').then(function (res) {
          var err = res.body.error;
          if (err === 0) {
            if (false) {
              if (sessionStorage.getItem('userType') === 'P' || sessionStorage.getItem('userType') === 'M') {
                this.$router.push('/login');
              }
              if (sessionStorage.getItem('userType') === 'D') {
                this.$router.push('/hcpLogin');
              }
            }
            if ('/CreateHCP' == this.$route.path) {
              this.$router.push('/accountsmanagement');
            } else if ('/ClinicPatientList' == this.$route.path || '/ClinicExportData' == this.$route.path) {
              this.$router.push('/clinic');
            }

            var lang = sessionStorage.getItem('language');
            sessionStorage.clear();
            sessionStorage.setItem('language', lang);
          }
        });
      }
      if (command === 'connect') {
        this.$router.push('/connection');
      }
      if (command === 'profile') {
        this.$router.push('/profile1');
      }
      if (command === 'changePassword') {
        this.$router.push('/changePassword');
      }
      if (command === 'messages') {
        this.$router.push('/messages');
      }
    },
    home: function home() {
      var user = sessionStorage.getItem('userType');
      if (user === 'P') {
        this.$router.push('/refresh');
      }
      if (user === 'D') {
        this.$router.push('/ClinicPatientList');
      }
      if (user === 'M') {
        this.$router.push('/carerConnection');
      }
    },
    linkRecentUpdates: function linkRecentUpdates() {}
  },
  mounted: function mounted() {
    this.isHcp = sessionStorage.getItem('userType') === 'P' ? false : true;
    var uid = parseInt(sessionStorage.getItem('uid'));
    if (this.isHcp) {
      __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getUnread(this);
    } else {
      __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getUnread1(this);
    }
  }
});

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isZh: false,
      isEU: true,
      contactURL: '',
      privacyURL: '',
      termsOfUseURL: ''
    };
  },
  computed: {
    updateLocCode: function updateLocCode() {
      console.log('compute updateLocCode:');
      return this.$store.state.loc_code;
    }
  },
  watch: {
    updateLocCode: function updateLocCode(val) {
      console.log('watch updateLocCode:', val);
      var host = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getOuterHost();
      this.contactURL = host + '/contact.html';
      this.privacyURL = host + '/privacy_policy.html';
      this.termsOfUseURL = host + '/terms_of_use.html';
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isZh = sessionStorage.getItem('language') === 'zh' ? true : false;
    var countryIndex = localStorage.getItem('index');

    if (1 == countryIndex || 6 == countryIndex || 14 == countryIndex) {
      this.isEU = false;
    }

    setTimeout(function () {
      var host = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getOuterHost();
      _this.contactURL = host + '/contact.html';
      _this.privacyURL = host + '/privacy_policy.html';
      _this.termsOfUseURL = host + '/terms_of_use.html';
    }, 50);
  }
});

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isHcp: true,
      isHcpDoctor: true
    };
  },

  computed: {
    portrait: function portrait() {
      return '/api/v2.0/person/' + parseInt(sessionStorage.getItem('uid')) + '/portrait';
    },
    username: function username() {
      return sessionStorage.getItem('username');
    },
    messageTip: function messageTip() {
      var unRead = parseInt(this.$store.state.unRead);
      var tip = unRead === 0 ? false : true;

      return tip;
    }
  },
  methods: {
    handleCommand: function handleCommand(command) {
      if (command === 'loginOut') {
        sessionStorage.removeItem('token');
        this.$http.post('api/v2.0/logout').then(function (res) {
          var err = res.body.error;
          if (err === 0) {
            if (sessionStorage.getItem('userType') === 'P' || sessionStorage.getItem('userType') === 'M') {
              this.$router.push('/login');
            }
            if (sessionStorage.getItem('userType') === 'D') {
              this.$router.push('/hcpLogin');
            }

            var lang = sessionStorage.getItem('language');
            sessionStorage.clear();
            sessionStorage.setItem('language', lang);
          }
        });
      }
      if (command === 'connect') {
        this.$router.push('/connection');
      }
      if (command === 'profile') {
        this.$router.push('/profile1');
      }
      if (command === 'changePassword') {
        this.$router.push('/changePassword');
      }
      if (command === 'messages') {
        this.$router.push('/messages');
      }
    },
    home: function home() {
      var user = sessionStorage.getItem('userType');
      if (user === 'P') {
        this.$router.push('/refresh');
      }
      if (user === 'D') {
        this.$router.push('/PatientList');
      }
      if (user === 'M') {
        this.$router.push('/carerConnection');
      }
    },
    linkRecentUpdates: function linkRecentUpdates() {}
  },
  mounted: function mounted() {
    this.isHcp = sessionStorage.getItem('userType') === 'P' ? false : true;
    this.isHcpDoctor = sessionStorage.getItem('userType') === 'D' ? true : false;
    var uid = parseInt(sessionStorage.getItem('uid'));
    if (this.isHcp) {
      __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getUnread(this);
    } else {
      __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getUnread1(this);
    }
  }
});

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      locale: 'en',
      languageFormVisible: false, isA: true, flag: '', isB: false, dialogSize: 'small', hostname: '',
      showCountry: true,
      chooseLang: '', asia: '', europe: '',

      country: ['GB', 'CN', 'FR', 'DD', 'SE', 'AU', 'HKF', 'HU', 'IT', 'NL', 'Nor', 'PT', 'ES', 'TR', 'AE', 'Ro', 'CZ', 'SK', 'LT', 'PL', 'DK', 'FI', 'TH', 'ID', 'MY', 'IN', 'CH', 'SA', 'AE', 'QA', 'QW', 'RH', 'AT', 'SI', 'EE', 'LV', 'BA', 'BG', 'CL', 'BE']
    };
  },

  computed: {
    changeLanguage: function changeLanguage() {
      console.log('compute changeLanguage');
      return this.$store.state.language;
    }
  },
  watch: {
    changeLanguage: function changeLanguage(val) {
      this.$i18n.locale = val;
      console.log('watch changeLanguage:', val);
    }
  },
  methods: {
    languageChoose: function languageChoose(countryIndex, languageIndex) {
      var info = [countryIndex, languageIndex];
      this.languageFormVisible = false;
      var country = this.country[countryIndex];
      var flag = 1;
      console.log('loc_code:', countryIndex, country);
      localStorage.setItem('loc_code', country);
      this.$store.commit('updateLocCode', country);

      if (1) {
        if (countryIndex === 1) {
          if (this.hostname !== 'cn') {
            if (this.isA) {
              window.location = 'https://easyview.medtrum.cn/#/login?country=' + country;
            } else {
              window.location = 'https://easyview.medtrum.cn/#/hcpLogin?country=' + country;
            }
            flag = 0;
          }
        } else {
          if (this.hostname !== 'eu') {
            if (this.isA) {
              window.location = 'https://easyview.medtrum.eu/#/login?country=' + country;
            } else {
              window.location = 'https://easyview.medtrum.eu/#/hcpLogin?country=' + country;
            }
            flag = 0;
          }
        }
      }

      info.push(flag);
      this.$store.commit('changLanguage', info);
    },
    cancelChoose: function cancelChoose() {
      this.languageFormVisible = false;
    }
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].initLanguages(this);
  },
  mounted: function mounted() {
    this.isA = this.$route.path === '/login' || this.$route.path === '/sign' ? true : false;
    if ('/login' == this.$route.path || '/sign' == this.$route.path) {
      this.flag = 'patient';
    } else if ('/accountsmanagement' == this.$route.path) {
      this.flag = 'accountsmanagement';
      this.showCountry = false;
    } else if ('/clinic' == this.$route.path) {
      this.flag = 'clinic';
      this.showCountry = false;
    } else {
      this.flag = 'hcp';
    }
    var win = window.innerWidth;
    this.dialogSize = win < 1850 ? 'large' : 'small';
  }
});

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isZh: false,
      isEU: true,
      contactURL: '',
      privacyURL: '',
      termsOfUseURL: ''
    };
  },
  computed: {
    updateLocCode: function updateLocCode() {
      console.log('compute updateLocCode:');
      return this.$store.state.loc_code;
    }
  },
  watch: {
    updateLocCode: function updateLocCode(val) {
      console.log('watch updateLocCode:', val);
      var host = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getOuterHost();
      this.contactURL = host + '/contact.html';
      this.privacyURL = host + '/privacy_policy.html';
      this.termsOfUseURL = host + '/terms_of_use.html';
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.isZh = sessionStorage.getItem('language') === 'zh' ? true : false;
    var countryIndex = localStorage.getItem('index');
    console.info('countryIndex:' + countryIndex);
    if (1 == countryIndex || 6 == countryIndex || 14 == countryIndex) {
      this.isEU = false;
    }
    setTimeout(function () {
      var host = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getOuterHost();
      _this.contactURL = host + '/contact.html';
      _this.privacyURL = host + '/privacy_policy.html';
      _this.termsOfUseURL = host + '/terms_of_use.html';
    }, 50);
  }
});

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      locale: 'en',
      languageFormVisible: false,
      isA: true, dialogSize: 'tiny', chooseLang: '', asia: '', europe: ''
    };
  },

  computed: {
    changeLanguage: function changeLanguage() {
      return this.$store.state.language;
    }
  },
  watch: {
    changeLanguage: function changeLanguage(val) {
      this.$i18n.locale = val;
    }
  },
  methods: {
    languageChoose: function languageChoose(index) {
      this.languageFormVisible = false;
      this.$store.commit('changLanguage', index);
    },
    cancelChoose: function cancelChoose() {
      this.languageFormVisible = false;
    }
  },
  mounted: function mounted() {
    this.isA = this.$route.path === '/login' || this.$route.path === '/sign' || this.$route.path === '/personalApply' ? true : false;

    if (sessionStorage.getItem('udHcp')) {
      this.isA = sessionStorage.getItem('udHcp') === '1' ? true : false;
    }
    var win = window.innerWidth;
    this.dialogSize = win < 1850 ? 'small' : 'tiny';
  }
});

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_format__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_base64__ = __webpack_require__(9);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      value1: '', value2: '', defaultDate1: '', defaultDate2: '', isA: false, isB: false, value10: '', value11: '', loading: '', time: [0, 0],
      value5: '', value6: '', event: [0, 0, 0, { "note": 'BG', "value": '202mg/dL' }, 'web'], isWeb: false, isMg: false, isCz: false,
      type: 'Carbs', note: '', uid: 0, eids: [], EXEtime: '', detail: '', isEn: false, isEs: false, isDe: false, isIt: false, isPo: false, isDu: false,
      deta1: '', deta2: 'Light', deta3: '', deta4: 'Negative', deta5: '', deta6: '', deta7: '', filterFlag: false, info: {}, isFr: false, isSw: false,
      type1: true, type2: false, type3: false, type4: false, type5: false, type6: false, type7: false, type8: false,
      value4: new Date(), value3: '',
      eDetail1: '', eDetail2: '', eDetail3: '', eDetail4: '', eDetail5: '', eDetail6: '', eDetail7: '', eDetail8: '',
      eNote: '', edEXEtime: '', exeType: { Light: 0, Medium: 1, Heavy: 2 },

      edType1: true, edType2: false, edType3: false, edType4: false, edType5: false, edType6: false, edType7: false, edType8: false,
      urinekType: ['Negative', 'Macro', '+', '++', '+++', '++++'],
      Tr1: false, Tr2: false, Tr3: false, Tr4: false, Tr5: false, Tr6: false, Tr7: false,
      bgRange: '', unit: '',
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        }
      }, dialogSize: 'tiny',
      activeIndex: '1', pages: '', page: 1, has_next: '', has_prev: '',
      isC: false, uids: [], flag: 0, order: 'desc', orderFlag: true, indexs: [],
      tip: this.$t('Input Notes')
    };
  },

  computed: {
    events: function events() {
      return this.$store.state.events;
    }
  },
  methods: {
    getEvents: function getEvents() {
      if (this.filterFlag) {
        var param = __WEBPACK_IMPORTED_MODULE_3__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.info));
        __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].getEvents(this, this.uid, { param: param, page: this.page });
      } else {
        var _param = {
          page: this.page,
          'order': [['time', this.order]]
        };
        _param = __WEBPACK_IMPORTED_MODULE_3__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_param));
        __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].getEvents(this, this.uid, { param: _param, page: this.page });
      }
      this.start();
    },
    orderChange: function orderChange(e) {
      var obj = e.target;
      this.orderFlag = !this.orderFlag;
      if (this.orderFlag) {
        this.order = 'desc';
      } else {
        this.order = 'asc';
      }
      this.getEvents();
    },
    filter: function filter(e) {
      var type = e.target.value;
      if (type !== 'ALL') {
        if (this.value1 === '' && this.value2 === '') {
          this.info = {
            'filter': {
              'type': [type]
            },
            'tz': parseInt(sessionStorage.getItem('tz')),
            'order': [['time', this.order]]
          };
        } else {
          var st = 0;
          var et = 0;
          if (this.value1 === '' || this.value2 === '') {
            et = new Date().getTime() / 1000;
            st = et - 86400 * 6;
          } else {
            et = this.value1.getTime() / 1000;
            st = this.value2.getTime() / 1000;
          }
          this.info = {
            'filter': {
              'type': [type]
            },
            'st': st,
            'et': et,
            'tz': parseInt(sessionStorage.getItem('tz')),
            'order': [['time', this.order]]
          };
        }
        var param = __WEBPACK_IMPORTED_MODULE_3__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.info));
        this.filterFlag = true;
        __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].getEvents(this, this.uid, { param: param, page: this.page });
        this.start();
      } else {
        this.filterFlag = false;
        this.getEvents();
      }
    },
    filter2: function filter2() {
      var st = 0;
      var et = 0;
      if (this.value1 !== '' && this.value2 !== '') {
        et = this.value1.getTime() / 1000;
        st = this.value2.getTime() / 1000;
        if (st > et) {
          var tip = this.$t('The date choose wrong');
          this.$message.error(tip);
        } else {
          this.info = {
            'filter': {
              'type': []
            },
            'st': st,
            'et': et,
            'tz': parseInt(sessionStorage.getItem('tz')),
            'order': [['time', this.order]]
          };
          var param = __WEBPACK_IMPORTED_MODULE_3__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.info));
          this.filterFlag = true;
          __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].getEvents(this, this.uid, { param: param, page: this.page });
        }
      }
    },
    start: function start() {
      var table = document.getElementById('patientList');
      var labels = table.getElementsByTagName('label');
      for (var i = 0; i < labels.length; i++) {
        labels[i].className = "";
      }
    },
    chooseAll: function chooseAll() {
      var table = document.getElementById('patientList');
      var labels = table.getElementsByTagName('label');
      for (var i = 0; i < labels.length; i++) {
        if (this.flag === 0) {
          labels[i].className = 'checked';
          if (this.events[i]) {
            var eid = this.events[i][5];
            this.eids.push(eid);
            this.indexs.push(i);
          }
        } else {
          labels[i].className = '';
          this.eids = [];
          this.indexs = [];
        }
      }

      if (labels[0].className === 'checked') {
        this.flag = 1;
      } else {
        this.flag = 0;
      }
    },
    select: function select(e) {
      var index = e.target.id;
      var parent = document.getElementById('patientList');
      var labels = parent.getElementsByTagName('label');
      var eid = this.events[index][5];
      if (e.target.className === "") {
        e.target.className = 'checked';
        this.eids.push(eid);
        this.indexs.push(parseInt(index));
        for (var i = 1; i < labels.length; i++) {
          if (labels[i].className === 'checked') {
            this.count++;
          }
        }
        if (this.count === labels.length - 1) {
          labels[0].className = "checked";
        }
        this.count = 0;
      } else {
        e.target.className = "";
        labels[0].className = "";
        for (var _i = 0; _i < this.eids.length; _i++) {
          if (eid === this.eids[_i]) {
            this.eids.splice(_i, 1);
            this.indexs.splice(_i, 1);
          }
        }
      }
    },
    delete1: function delete1(e) {
      var _this = this;

      var tip = this.$t('deleteThis');
      var tip1 = this.$t('confirm');
      var tip2 = this.$t('Yes');
      var tip3 = this.$t('Cancel');
      this.$confirm(tip, tip1, {
        confirmButtonText: tip2,
        cancelButtonText: tip3,
        type: 'warning'
      }).then(function () {
        var index = e.target.parentNode.parentNode.id;
        var eid = _this.events[index][5];
        var eids = [];
        eids.push(eid);
        __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].deleteEvents(_this, _this.uid, eids);
      }, function () {});
    },
    delete2: function delete2() {
      var _this2 = this;

      if (this.eids.length > 0) {
        var tip = this.$t('deleteEvents');
        var tip1 = this.$t('confirm');
        var tip2 = this.$t('Yes');
        var tip3 = this.$t('Cancel');
        this.$confirm(tip, tip1, {
          confirmButtonText: tip2,
          cancelButtonText: tip3,
          type: 'warning'
        }).then(function () {
          __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].deleteEvents(_this2, _this2.uid, _this2.eids);
        }, function () {});
      }
    },
    create: function create() {
      this.isA = true;
      this.initAdd();
    },
    initAdd: function initAdd() {
      this.type = this.$t('carbs');this.note = '';
      this.Tr1 = false;this.Tr2 = false;this.Tr3 = false;this.Tr5 = false;this.Tr6 = false;this.Tr7 = false;
      this.deta4 = 'Negative';this.deta2 = 'Light';this.deta1 = '';this.deta3 = '';this.deta5 = '';this.deta6 = '';this.deta7 = '';this.EXEtime = '';
      this.type1 = true;this.type2 = false;this.type3 = false;this.type4 = false;this.type5 = false;this.type6 = false;this.type7 = false;this.type8 = false;
      var st1 = __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate3(new Date().getTime() / 1000) + ' 00:00:00';
      var st2 = Date.parse(st1.replace(/-/g, "/"));
      this.value3 = new Date(st2);
      this.value4 = new Date();
    },
    cancel: function cancel() {
      this.isA = false;
    },
    check: function check(index) {
      if (index === 1) {
        if (isNaN(this.deta1)) {
          this.Tr1 = true;
        } else {
          var value = parseInt(this.deta1);
          if (value > 300 || value < 1 || isNaN(value)) {
            this.Tr1 = true;
          } else {
            this.Tr1 = false;
          }
        }
      }
      if (index === 2) {
        if (isNaN(this.EXEtime)) {
          this.Tr2 = true;
        } else {
          var _value = parseInt(this.EXEtime);
          if (_value > 480 || _value < 5 || isNaN(_value)) {
            this.Tr2 = true;
          } else {
            this.Tr2 = false;
          }
        }
      }
      if (index === 3) {
        if (isNaN(this.deta3)) {
          this.Tr3 = true;
        } else {
          var _value2 = parseFloat(this.deta3);
          if (_value2 > 19.9 || _value2 < 3.3 || isNaN(_value2)) {
            this.Tr3 = true;
          } else {
            this.Tr3 = false;
          }
        }
      }
      if (index === 5) {
        if (isNaN(this.deta5)) {
          this.Tr5 = true;
        } else {
          if (this.isMg) {
            var _value3 = parseInt(this.deta5);
            if (_value3 > 400 || _value3 < 40 || isNaN(_value3)) {
              this.Tr5 = true;
            } else {
              this.Tr5 = false;
            }
          } else {
            var _value4 = parseFloat(this.deta5);
            if (_value4 > 22.2 || _value4 < 2.2 || isNaN(_value4)) {
              this.Tr5 = true;
            } else {
              this.Tr5 = false;
            }
          }
        }
      }
      if (index === 6) {
        if (isNaN(this.deta6)) {
          this.Tr6 = true;
        } else {
          var _value5 = parseFloat(this.deta6);
          if (_value5 > 99.0 || _value5 < 0.1 || isNaN(_value5)) {
            this.Tr6 = true;
          } else {
            this.Tr6 = false;
          }
        }
      }
    },
    newEvents: function newEvents() {
      if (this.Tr1 || this.Tr2 || this.Tr3 || this.Tr5 || this.Tr6) {
        var tip = this.$t('Input error');
        this.$message.error(tip);
      } else {
        var data = [];
        var time = this.value3 ? this.value3.getTime() / 1000 : ' ';
        var mi = this.value4 ? __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate5(this.value4) : [0, 0];
        time = time + parseInt(mi[0]) * 3600 + parseInt(mi[1]) * 60;
        var _tip = this.$t('infoWrongTip');
        data[0] = time;
        if (this.type === this.$t('BG1')) {
          if (!this.deta5) {
            this.Tr5 = true;
            this.$message.error(_tip);
          } else {
            data[1] = 'BG';
            data[2] = {
              value: this.isMg ? parseInt(this.deta5) : Math.round(parseFloat(this.deta5).toFixed(1) * 18),
              glucoseType: 0,
              note: this.note
            };
            __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].newEvents(this, this.uid, data);
          }
        } else if (this.type === this.$t('carbs')) {
          if (!this.deta1) {
            this.Tr1 = true;
            this.$message.error(_tip);
          } else {
            data[1] = 'CARB';
            data[2] = {
              value: this.deta1 ? parseInt(this.deta1) : '',
              name: '',
              note: this.note
            };
            __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].newEvents(this, this.uid, data);
          }
        } else if (this.type === this.$t('Injection')) {
          if (!this.deta6) {
            this.Tr6 = true;
            this.$message.error(_tip);
          } else {
            data[1] = 'INS';
            data[2] = {
              value: this.deta6 ? parseFloat(this.deta6).toFixed(1) : '',
              name: '',
              note: this.note,
              insulinType: ''
            };
            __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].newEvents(this, this.uid, data);
          }
        } else if (this.type === this.$t('exercise')) {
          if (!this.EXEtime) {
            this.Tr2 = true;
            this.$message.error(_tip);
          } else {
            data[1] = 'EXR';
            data[2] = {
              value: parseInt(this.EXEtime),
              name: '',
              note: this.note,
              exerciseType: '',
              exerciseIntensity: this.exeType[this.deta2]
            };
            __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].newEvents(this, this.uid, data);
          }
        } else if (this.type === this.$t('HbA1c1')) {
          if (!this.deta3) {
            this.Tr3 = true;
            this.$message.error(_tip);
          } else {
            data[1] = 'HBA1C';
            data[2] = {
              value: parseFloat(this.deta3).toFixed(1),
              note: this.note
            };
            __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].newEvents(this, this.uid, data);
          }
        } else if (this.type === this.$t('Other')) {
          if (!this.deta7) {
            this.Tr7 = true;
            this.$message.error(_tip);
          } else {
            data[1] = 'OTR';
            data[2] = {
              value: '',
              note: this.deta7
            };
            __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].newEvents(this, this.uid, data);
          }
        } else if (this.type === this.$t('Urine Ketone')) {
          data[1] = 'URINEK';
          var j = 0;
          for (var i = 0; i < this.urinekType.length; i++) {
            if (this.deta4 === this.urinekType[i]) {
              j = i + 1;
              break;
            }
          }
          data[2] = {
            value: j,
            note: this.note
          };
          __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].newEvents(this, this.uid, data);
        }
      }
    },
    typeShow: function typeShow(e) {
      var type = e.target.value;
      if (type === this.$t('carbs')) {
        this.type1 = true;this.type2 = false;this.type3 = false;this.type4 = false;this.type5 = false;this.type6 = false;this.type7 = false;this.type8 = false;
      }
      if (type === this.$t('exercise')) {
        this.type2 = true;this.type1 = false;this.type3 = false;this.type4 = false;this.type5 = false;this.type6 = false;this.type7 = false;this.type8 = false;
      }
      if (type === this.$t('HbA1c1')) {
        this.type3 = true;this.type2 = false;this.type1 = false;this.type4 = false;this.type5 = false;this.type6 = false;this.type7 = false;this.type8 = false;
      }
      if (type === this.$t('Urine Ketone')) {
        this.type4 = true;this.type2 = false;this.type3 = false;this.type1 = false;this.type5 = false;this.type6 = false;this.type7 = false;this.type8 = false;
      }
      if (type === this.$t('BG1')) {
        this.type5 = true;this.type2 = false;this.type3 = false;this.type4 = false;this.type1 = false;this.type6 = false;this.type7 = false;this.type8 = false;
      }
      if (type === this.$t('Injection')) {
        this.type6 = true;this.type2 = false;this.type3 = false;this.type4 = false;this.type5 = false;this.type1 = false;this.type7 = false;this.type8 = false;
      }
      if (type === this.$t('Other')) {
        this.type8 = true;this.type2 = false;this.type3 = false;this.type4 = false;this.type5 = false;this.type6 = false;this.type7 = false;this.type1 = false;
      }
      this.Tr1 = false;this.Tr2 = false;this.Tr3 = false;this.Tr5 = false;this.Tr6 = false;this.Tr7 = false;
    },
    edit: function edit(e) {
      var index = e.target.parentNode.parentNode.id;
      this.event = this.events[index];
      this.isWeb = this.event[4] === 'web' ? true : false;
      var time = this.event[1].split(' ');
      var mi = time[1].split(':');
      var m = mi[0] + ":" + mi[1];
      time[1] = m;
      this.time = time;
      this.isB = true;
      this.eNote = this.event[3].note;
      this.edTypeShow();
    },
    cancel2: function cancel2() {
      this.isB = false;
    },
    edTypeShow: function edTypeShow() {
      var type = this.event[2];
      this.Tr1 = false;this.Tr2 = false;this.Tr3 = false;this.Tr5 = false;this.Tr6 = false;this.Tr7 = false;
      if (type === this.$t('CARB')) {
        this.eDetail1 = this.event[3].value.split(' ')[0];
        this.edType1 = true;this.edType2 = false;this.edType3 = false;this.edType4 = false;this.edType5 = false;this.edType6 = false;this.edType7 = false;this.edType8 = false;
      }
      if (type === this.$t('EXR')) {
        var value = this.event[3].value.split(' ');
        this.eDetail2 = value[2];
        this.edEXEtime = value[0];
        this.edType2 = true;this.edType1 = false;this.edType3 = false;this.edType4 = false;this.edType5 = false;this.edType6 = false;this.edType7 = false;this.edType8 = false;
      }
      if (type === this.$t('HBA1C')) {
        this.eDetail3 = this.event[3].value.split(' ')[0];
        this.edType3 = true;this.edType2 = false;this.edType1 = false;this.edType4 = false;this.edType5 = false;this.edType6 = false;this.edType7 = false;this.edType8 = false;
      }
      if (type === this.$t('URINEK')) {
        this.eDetail4 = this.event[3].value;
        this.edType4 = true;this.edType2 = false;this.edType3 = false;this.edType1 = false;this.edType5 = false;this.edType6 = false;this.edType7 = false;this.edType8 = false;
      }
      if (type === this.$t('BG')) {
        this.eDetail5 = this.event[3].value.split(' ')[0];
        this.edType5 = true;this.edType2 = false;this.edType3 = false;this.edType4 = false;this.edType1 = false;this.edType6 = false;this.edType7 = false;this.edType8 = false;
      }
      if (type === this.$t('INS')) {
        this.eDetail6 = this.event[3].value.split(' ')[0];
        this.edType6 = true;this.edType2 = false;this.edType3 = false;this.edType4 = false;this.edType5 = false;this.edType1 = false;this.edType7 = false;this.edType8 = false;
      }
      if (type === this.$t('OTR')) {
        this.eDetail7 = this.event[3].note;
        this.edType8 = true;this.edType2 = false;this.edType3 = false;this.edType4 = false;this.edType5 = false;this.edType6 = false;this.edType7 = false;this.edType1 = false;
      }
    },
    edCheck: function edCheck(index) {
      if (index === 1) {
        if (isNaN(this.eDetail1)) {
          this.Tr1 = true;
        } else {
          var value = parseInt(this.eDetail1);
          if (value > 300 || value < 1 || isNaN(value)) {
            this.Tr1 = true;
          } else {
            this.Tr1 = false;
          }
        }
      }
      if (index === 2) {
        if (isNaN(this.edEXEtime)) {
          this.Tr2 = true;
        } else {
          var _value6 = parseInt(this.edEXEtime);
          if (_value6 > 480 || _value6 < 5 || isNaN(_value6)) {
            this.Tr2 = true;
          } else {
            this.Tr2 = false;
          }
        }
      }
      if (index === 3) {
        if (isNaN(this.eDetail3)) {
          this.Tr3 = true;
        } else {
          var _value7 = parseFloat(this.eDetail3);
          if (_value7 > 19.9 || _value7 < 3.3 || isNaN(_value7)) {
            this.Tr3 = true;
          } else {
            this.Tr3 = false;
          }
        }
      }
      if (index === 5) {
        if (isNaN(this.eDetail5)) {
          this.Tr5 = true;
        } else {
          if (this.isMg) {
            var _value8 = parseInt(this.eDetail5);
            if (_value8 > 400 || _value8 < 40 || isNaN(_value8)) {
              this.Tr5 = true;
            } else {
              this.Tr5 = false;
            }
          } else {
            var _value9 = parseFloat(this.eDetail5);
            if (_value9 > 22.2 || _value9 < 2.2 || isNaN(_value9)) {
              this.Tr5 = true;
            } else {
              this.Tr5 = false;
            }
          }
        }
      }
      if (index === 6) {
        if (isNaN(this.eDetail6)) {
          this.Tr6 = true;
        } else {
          var _value10 = parseFloat(this.eDetail6);
          if (_value10 > 99.0 || _value10 < 0.1 || isNaN(_value10)) {
            this.Tr6 = true;
          } else {
            this.Tr6 = false;
          }
        }
      }
    },
    editEvents: function editEvents() {
      var info = this.event;
      var event = [];
      var st = info[1].split(' ');
      var day = st[0].split('-');
      var day2 = day[2] + '-' + day[1] + '-' + day[0];
      var t = st[1].split(':');
      var second = new Date(day2).getTime() / 1000 - 3600 * 8;
      var time = this.value5 ? this.value5.getTime() / 1000 : second;
      var mi = this.value6 ? __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate5(this.value6) : [t[0], t[1]];
      time = time + parseInt(mi[0]) * 3600 + parseInt(mi[1]) * 60;
      event[0] = time;

      if (this.Tr1 || this.Tr2 || this.Tr3 || this.Tr5 || this.Tr6) {
        var tip = this.$t('Input error');
        this.$message.error(tip);
      } else {
        if (info[2] === this.$t('BG')) {
          event[1] = 'BG';
          event[2] = {
            value: this.isMg ? parseInt(this.eDetail5) : Math.round(parseFloat(this.eDetail5).toFixed(1) * 18),
            glucoseType: 0,
            note: this.eNote
          };
          __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].editEvents(this, this.uid, info[5], event);
        } else if (info[2] === this.$t('CARB')) {
          event[1] = 'CARB';
          event[2] = {
            value: this.eDetail1 ? parseInt(this.eDetail1) : '',
            name: '',
            note: this.eNote
          };
          __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].editEvents(this, this.uid, info[5], event);
        } else if (info[2] === this.$t('EXR')) {
          event[1] = 'EXR';
          event[2] = {
            value: parseInt(this.edEXEtime),
            name: '',
            note: this.eNote,
            exerciseType: '',
            exerciseIntensity: this.exeType[this.eDetail2]
          };
          __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].editEvents(this, this.uid, info[5], event);
        } else if (info[2] === this.$t('INS')) {
          event[1] = 'INS';
          event[2] = {
            value: this.eDetail6 ? parseFloat(this.eDetail6).toFixed(1) : '',
            name: '',
            note: this.eNote,
            insulinType: ''
          };
          __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].editEvents(this, this.uid, info[5], event);
        } else if (info[2] === this.$t('HBA1C')) {
          event[1] = 'HBA1C';
          event[2] = {
            value: parseFloat(this.eDetail3).toFixed(1),
            note: this.eNote
          };
          __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].editEvents(this, this.uid, info[5], event);
        } else if (info[2] === this.$t('OTR')) {
          if (!this.eDetail7) {
            this.Tr7 = true;
            var _tip2 = this.$t('infoWrongTip');
            this.$message.error(_tip2);
          } else {
            event[1] = 'OTR';
            event[2] = {
              value: '',
              note: this.eDetail7
            };
            __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].editEvents(this, this.uid, info[5], event);
          }
        } else if (info[2] === this.$t('URINEK')) {
          event[1] = 'URINEK';
          var j = 0;
          for (var i = 0; i < this.urinekType.length; i++) {
            if (this.eDetail4 === this.urinekType[i]) {
              j = i + 1;
              break;
            }
          }
          event[2] = {
            value: j,
            note: this.eNote
          };
          __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].editEvents(this, this.uid, info[5], event);
        }
      }
    },
    nextPage: function nextPage() {
      if (this.page < this.pages) {
        this.page++;
        this.getEvents();
      }
    },
    prevPage: function prevPage() {
      if (this.page > 1) {
        this.page--;
        this.getEvents();
      }
    },
    go: function go() {
      if (0 < this.page && this.page < this.pages + 1) {
        this.getEvents();
      } else {
        this.page = 1;
        this.getEvents();
      }
    },
    print: function print() {
      if (this.eids.length > 0) {
        var max = Math.max.apply(null, this.indexs);
        var min = Math.min.apply(null, this.indexs);
        var st = this.events[max][1];
        var et = this.events[min][1];
        sessionStorage.setItem('eveSt', st);
        sessionStorage.setItem('eveEt', et);
        window.open('/#/events-print1', '_blank');
      } else {
        var tip = this.$t('Choose the events to print');
        this.$message({
          type: 'warning',
          message: tip
        });
      }
    }
  },

  mounted: function mounted() {
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isEs = lang === 'es' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isSw = lang === 'sw' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    this.bgRange = this.isMg ? '(40-400)' : '(2.2-22.2)';
    this.unit = this.isMg ? 'mg/dL' : 'mmol/L';
    var param = {
      page: this.page,
      'order': [['time', this.order]]
    };
    var t1 = new Date().getTime() / 1000;
    var t2 = t1 - 86400 * 6;
    var st1 = __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate3(t1) + ' 00:00:00';
    var st2 = Date.parse(st1.replace(/-/g, "/"));
    this.value3 = new Date(st2);
    this.defaultDate1 = __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate4(t1);
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }
    param = __WEBPACK_IMPORTED_MODULE_3__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));
    var win = window.innerWidth;
    this.dialogSize = win < 1500 ? 'small' : 'tiny';
    __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].getEvents(this, this.uid, { param: param, page: this.page });
  }
});

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_format__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isA: true, isB: false, isC: false, isD: false, Remark: false, isE: false, isEs: false, isDe: false,
      username: '', user: [], mark: ' ', uids: [], isFr: false, isZh: false, isCz: false,
      isEU: true,
      contactURL: '',
      privacyURL: '',
      termsOfUseURL: ''
    };
  },

  methods: {
    search: function search() {
      var params = {
        username: this.username
      };
      if (this.username === '') {
        var tip = this.$t('A name is required');
        this.$message.error(tip);
      } else {
        this.$http.post('api/v2.0/search/patient', { 'params': params }).then(function (res) {
          var err = res.body.error;

          if (err === 0) {
            this.user = res.data.patient;
            if (this.user.has_relation === true) {
              if (this.user.relation_state === 'ACCEPT') {
                this.isC = false;this.isD = true;this.isE = false;
                this.mark = this.user.motton ? this.user.motton : '--';
                this.uids.push(this.user.uid);
              } else {
                this.isC = false;this.isD = false;this.isE = true;
              }
            } else {
              this.isC = true;this.isD = false;this.isE = false;
            }
            this.isA = false;
            this.isB = true;
          } else if (err === 2) {
            var _tip = this.$t('userNotExist');
            this.$message.error(_tip);
          }
        }, function (err) {
          console.log(err + "," + err.body.message);
          this.error = err.body.message;
        });
      }
    },
    back: function back() {
      this.$router.push('/PatientList');
    },
    cancel: function cancel() {
      this.Remark = false;
    },
    goCharts: function goCharts() {
      sessionStorage.setItem('patientId', this.user.uid);
      sessionStorage.setItem('patientName', this.user.username);
      this.$router.push('/monitor');
    },
    request: function request() {
      var param = {
        username: this.username
      };
      this.$http.post('/api/v2.0/relations/apply', param).then(function (res) {
        var err = res.body.error;

        if (err === 0) {
          var tip = this.$t('rSent');
          this.$message({
            type: 'success',
            message: tip
          });
          this.$router.push('PatientList');
        }
      }, function (err) {
        console.log(err + "," + err.body.message);
        this.error = err.body.message;
      });
    },
    cancelRequest: function cancelRequest() {
      var param = {
        username: this.username
      };
      this.$http.post('/api/v2.0/relations/apply/cancel', param).then(function (res) {
        var err = res.body.error;
        console.log(res.data);
        if (err === 0) {
          var tip = this.$t('cancelR');
          this.$message({
            type: 'success',
            message: tip
          });
          this.$router.push('PatientList');
        }
      }, function (err) {
        console.log(err + "," + err.body.message);
        this.error = err.body.message;
      });
    },
    Remove: function Remove() {
      var _this = this;

      var tip = this.$t('CancelTip1');
      var tip1 = this.$t('confirm');
      var tip2 = this.$t('Yes');
      var tip3 = this.$t('Cancel');
      this.$confirm(tip, tip1, {
        confirmButtonText: tip2,
        cancelButtonText: tip3,
        type: 'warning'
      }).then(function () {
        var uids = _this.uids;
        _this.$http.post('api/v2.0/patients/delete', { 'uids': uids }).then(function (res) {
          var err = res.body.error;
          if (err === 0) {
            var _tip2 = this.$t('removeConnect');
            this.$message({
              type: 'success',
              message: _tip2
            });
            this.$router.push('/PatientList');
          }
        }, function (err) {
          var tip = this.$t('deleteFailed');
          this.$message.error(tip);
        });
      }, function () {});
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    var lang = sessionStorage.getItem('language');
    this.isEs = lang === 'es' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isZh = lang === 'zh' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    var countryIndex = localStorage.getItem('index');

    if (1 == countryIndex || 6 == countryIndex || 14 == countryIndex) {
      this.isEU = false;
    }
    setTimeout(function () {
      var host = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getOuterHost();
      _this2.contactURL = host + '/contact.html';
      _this2.privacyURL = host + '/privacy_policy.html';
      _this2.termsOfUseURL = host + '/terms_of_use.html';
    }, 50);
  }
});

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_format__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      username: '',
      password: '',
      user: this.$t('user'),
      pas: this.$t('password'),
      error: '',
      isA: false,
      isB: false,
      isC: false, isEs: false, isPo: false
    };
  },

  computed: {
    getLanguage: function getLanguage() {
      return this.$store.state.language;
    }
  },
  watch: {
    getLanguage: function getLanguage(val) {
      this.user = this.$t('user');
      this.pas = this.$t('password');
    }
  },
  mounted: function mounted() {
    var f = localStorage.getItem('perRemember');
    if (f === '1') {
      this.username = localStorage.getItem('perUsername');
      this.password = localStorage.getItem('perPassword');
      this.isA = true;
    } else {
      this.isA = false;
    }
    var tz = -(new Date().getTimezoneOffset() / 60);
    sessionStorage.setItem('tz', tz);
    if (!sessionStorage.getItem('flag')) {
      __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].checkBrowser(this);
      sessionStorage.setItem('loginPath', '/hcpLogin');
      var OS = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].detectOS();
      sessionStorage.setItem('OS', OS);
    }
    this.isEs = sessionStorage.getItem('language') === 'es' ? true : false;
    this.isPo = sessionStorage.getItem('language') === 'po' ? true : false;
  },
  created: function created() {
    var that = this;
    document.onkeydown = function (e) {
      e = window.event || e;
      if ((e.code === 'Enter' || e.code === 'enter' || e.code === 'NumpadEnter') && that.$route.path === '/hcpLogin' && !e.isComposing) {
        that.submit();
      }
    };
  },

  methods: {
    submit: function submit() {
      var info = {
        user_name: this.username,
        user_type: 'D',
        password: this.password
      };
      if (this.isA) {
        localStorage.setItem('perUsername', this.username);
        localStorage.setItem('perPassword', this.password);
        localStorage.setItem('perRemember', 1);
      } else {
        localStorage.setItem('perRemember', 0);
      }
      if (this.username === "" || this.password === "") {
        var tip = this.$t('username and password is required');
        this.$message.error(tip);
      } else {
        __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].login(this, info);
      }
    },
    choose: function choose() {
      this.isA = !this.isA;
    },
    check2: function check2() {
      this.isB = !this.isB;
      if (this.user === '') {
        this.user = this.$t('user');
      } else {
        this.user = '';
      }
    },
    check3: function check3() {
      this.isC = !this.isC;
      if (this.pas === '') {
        this.pas = this.$t('password');
      } else {
        this.pas = '';
      }
    },
    up: function up() {
      var obj = document.getElementById('name');
      obj.focus();
    },
    down: function down() {
      var obj = document.getElementById('psd');
      obj.focus();
    },
    forgot: function forgot() {
      sessionStorage.removeItem('A');
      sessionStorage.removeItem('B');
      sessionStorage.removeItem('C');
      sessionStorage.removeItem('D');
      this.$router.push('/updatePassword');
      sessionStorage.setItem('udHcp', 0);
    }
  }
});

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_format__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      try_enable: false,
      try_timer: '',
      try_timer_text: '60 sec',
      try_timer_value: 60,
      veri_focus: false,
      veri_placeholder: 'Enter code',
      veri_code: '',
      email: '', name: '', organization: '', mobile: '', error: '', token: '', isDe: false, isCz: false,
      disE: true, disF: true, disA: true, disB: true, applyHcp: '', isIt: false, isPo: false, isSw: false,
      isNext: true, tabA: true, tabA1: false, tabA2: false, tabA3: false, tabB: false, isAgree: false, isA2: false, isEU: false,

      country: ['GB', 'CN', 'FR', 'DD', 'SE', 'AU', 'HKF', 'HU', 'IT', 'NL', 'Nor', 'PT', 'ES', 'TR', 'AE', 'Ro', 'CZ', 'SK', 'LT', 'PL', 'DK', 'FI', 'TH', 'ID', 'MY', 'IN', 'CH', 'SA', 'AE', 'QA', 'QW', 'RH', 'AT', 'SI', 'EE', 'LV', 'BA', 'BG', 'CL', 'BE'],

      nam: '',
      org: '',
      ema: '',
      phone: '',

      canClick: false, hostname: '',

      newStyle: false,
      isA: false, isB: true, isC: false, isD: true, isE: false, isF: false,
      isG: false, isH: false, isI: false, isJ: false, isK: false,
      isO: false, isP: false, isQ: false, isR: false, isS: false, isT: false
    };
  },

  computed: {
    errors: function errors() {
      return this.$vuerify.$errors;
    },
    getLanguage: function getLanguage() {
      return this.$store.state.language;
    }
  },
  vuerify: {
    mobile: 'mobile',
    email: 'email'
  },
  watch: {
    getLanguage: function getLanguage(val) {
      this.ema = this.$t('Enter email');
      this.nam = this.$t('Name');
      this.org = this.$t('org');
      this.phone = this.$t('Enter mobile');
      if (val === 'zh') {
        this.newStyle = true;
      } else {
        this.newStyle = false;
      }
    }
  },
  methods: {
    register: function register(e) {
      var info = {
        name: this.name,
        org: this.organization,
        country: '',
        email: this.email,
        phone: this.mobile
      };
      console.log('register:' + [this.disA, this.disB, this.disE, this.disF]);
      console.log('register:' + [this.isO, this.isR, this.isS, this.isO]);

      if (this.name && this.organization && this.email && this.mobile) {
        if (this.disA && this.disB && this.disE && this.disF) {
          var obj = document.getElementById('chooseCountry');
          info.country = obj.value;
          info.test = 'yes';
          if (-1 == e.target.className.indexOf('send-apply')) {} else {
            delete info.test;
          }
          __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].HcpRegister(this, info);
        } else {}
      } else {
        this.$message.error("Wrong info!");
      }
    },
    nextStepA1: function nextStepA1() {

      if (false) {
        this.tabA1 = false;
        this.tabA2 = true;

        var str_html = document.getElementById('check_email_for_code').innerHTML;
        str_html = str_html.replace('XXX@XXX.com', 'iosdevelop@medtrum.com');
        document.getElementById('check_email_for_code').innerHTML = str_html;
      } else {
        this.$http.post('/api/v2.1/seccode/send', {
          user_name: this.email,
          flag: 'email',
          purpose: 'update_to_hcp'
        }).then(function (res) {
          console.log("nextStepA1:", res.body);
          var err = res.body.error;
          if (0 == err) {
            this.tabA1 = false;
            this.tabA2 = true;

            this.try_timer = setInterval(this.tryTimerHandler, 1000);

            var _str_html = document.getElementById('check_email_for_code').innerHTML;
            _str_html = _str_html.replace('XXX@XXX.com', 'iosdevelop@medtrum.com');
            document.getElementById('check_email_for_code').innerHTML = _str_html;
          }
        }, function (err) {});
      }
    },
    tryAgainProc: function tryAgainProc() {
      if (!this.try_enable) {
        return;
      }

      this.$http.post('/api/v2.1/seccode/send', {
        user_name: this.email,
        flag: 'email',
        purpose: 'update_to_hcp'
      }).then(function (res) {
        console.log("nextStepA1:", res.body);
        var err = res.body.error;
        if (0 == err) {
          this.try_enable = false;
          this.try_timer_value = 60;
        }
      }, function (err) {});
    },
    prevStepA1: function prevStepA1() {
      this.tabA1 = false;
      this.tabA = true;
    },
    nextStepA2: function nextStepA2() {
      console.log('veri_code:', this.veri_code);
      if (!/^\d{6}$/.test(this.veri_code)) {
        var tip = this.$t('verErrTip');
        this.$message.error(tip);
        return;
      }

      var obj = document.getElementById('chooseCountry');
      var select_country = obj.value;

      this.$http.post('/api/v2.1/hcp/update_to_hcp', {
        'veri_code': this.veri_code,
        'email': this.email,
        'country': select_country,
        'name': this.name,
        'org': this.organization,
        'phone': this.mobile,
        'flag': 'change_to_hcp'
      }).then(function (res) {
        var err = res.body.error;
        console.log('update_to_hcp:', res.body);
        if (0 == err) {
          this.tabA2 = false;
          this.tabA3 = true;
        } else {
          this.veri_code = '';
          var _tip = this.$t('verErrTip');
          this.$message.error(_tip);
          return;
        }
      }, function (err) {});
    },
    tryTimerHandler: function tryTimerHandler() {
      this.try_timer_value -= 1;
      console.log("try_timer_value:", this.try_timer_value);
      if (this.try_timer_value > 0) {
        this.try_timer_text = this.try_timer_value + ' ' + 'sec';
      } else if (this.try_timer_value == 0) {
        this.try_timer_text = '';
        this.try_enable = true;
      }
    },
    prevStepA2: function prevStepA2() {
      this.tabA1 = true;
      this.tabA2 = false;
    },
    checkVeriCode: function checkVeriCode() {
      this.veri_focus = !this.veri_focus;
    },
    signInNow: function signInNow() {
      this.$router.push('/hcpLogin');
    },
    select: function select(e) {
      var country = e.target.value;
      var route = 'hcpSign';
      __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].changeServer(this, country, route);
    },


    check1: function check1() {
      this.isA = !this.isA;
      this.isAgree = this.isA && this.isA2;
    },

    check1_2: function check1_2() {
      this.isA2 = !this.isA2;
      this.isAgree = this.isA && this.isA2;
    },
    registerBack: function registerBack() {
      this.tabA = true;
      this.tabB = false;
    },
    check2: function check2() {
      this.isB = !this.isB;
      this.isC = !this.isC;
    },
    check3: function check3() {
      this.isD = !this.isD;
      this.isE = !this.isE;
    },

    check54: function check54(flag) {
      this.isF = !this.isF;
      if (this.ema === '') {
        this.ema = this.$t('Enter email');
      } else {
        this.ema = '';
      }
      if (flag === 1) {
        if (this.$vuerify.$errors.email || this.email === '') {
          this.isO = true;
          this.disA = false;
        } else {
          this.isO = false;
          this.disA = true;
        }
      }
    },
    check57: function check57(flag) {
      this.isI = !this.isI;
      if (this.nam === '') {
        this.nam = this.$t('Name');
      } else {
        this.nam = '';
      }
      if (flag === 1) {
        if (this.name === '') {
          this.isR = true;
          this.disE = false;
        } else {
          this.isR = false;
          this.disE = true;
        }
      }
    },
    check58: function check58(flag) {
      this.isJ = !this.isJ;
      if (this.org === '') {
        this.org = this.$t('org');
      } else {
        this.org = '';
      }
      if (flag === 1) {
        if (this.organization === '') {
          this.isS = true;
          this.disF = false;
        } else {
          this.isS = false;
          this.disF = true;
        }
      }
    },
    check59: function check59(flag) {
      this.isK = !this.isK;
      if (this.phone === '') {
        this.phone = this.$t('Enter mobile');
      } else {
        this.phone = '';
      }
      if (flag === 1) {
        if (this.$vuerify.$errors.mobile || this.mobile === '') {
          this.isT = true;
          this.disB = false;
        } else {
          this.isT = false;
          this.disB = true;
        }
      }
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].initLanguages(this);
    var lang = sessionStorage.getItem('language');
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isSw = lang === 'sw' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    this.ema = this.$t('Enter email');
    this.nam = this.$t('Name');
    this.org = this.$t('org');
    this.phone = this.$t('Enter mobile');
    var index = localStorage.getItem('index');
    if (index) {
      var country = this.country[index];
      var obj = document.getElementById('chooseCountry');
      for (var i = 0; i < obj.options.length; i++) {
        if (obj.options[i].value === country) {
          obj.options[i].selected = true;
          break;
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.try_timer);
  }
});

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_base64__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_loading__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_format__ = __webpack_require__(8);









/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_loading__["a" /* loading */]],
  data: function data() {
    return {
      isA: false, value2: '', value3: '', uid: 0, st: 0, et: 0, basal: [], bolus: [], timeSection: [],
      staTime: '', endTime: '', timeRange2: '', isMg: '', glucoseUnit: '', isEn: '',
      basalMax: 5,
      custo: false, value4: '', timeType: '', update_time: '',
      timeRangeSelect: 1, timeRangeSelectActive: 1,
      ts: [[], []], sg1: [], sgHalf: [], target_high: '', target_low: '', bolus1: [], bolCount: [], sg: [],
      typeChooseVisible: false, dialogSize: 'tiny', sgMax: 25, bolusMax: 20,
      sgDate: ['00:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30', '06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30'],
      sgDate1: ['00:00', '', '01:00', '', '02:00', '', '03:00', '', '04:00', '', '05:00', '', '06:00', '', '07:00', '', '08:00', '', '09:00', '', '10:00', '', '11:00', '', '12:00', '', '13:00', '', '14:00', '', '15:00', '', '16:00', '', '17:00', '', '18:00', '', '19:00', '', '20:00', '', '21:00', '', '22:00', '', '23:00', ''],

      XTimeMin: 0,
      XTimeMax: 0,
      XData: [],

      YDataMin: [],
      YDataMax: [],
      YDataMed: [],
      YData10P: [],
      YDataQ1: [],
      YDataQ3: [],
      YData90P: [],

      bgAvg: '--',
      bgSD: '--',
      bgNum: '--',

      sgAvg: '--',
      sgSD: '--',
      sgNum: '--',

      insAvg: '--', insSD: '--', insNum: '--', patchAvgLife: '--',
      carbAvg: '--', carbSD: '--', carbNum: '--',
      exerAvg: '--', exerSD: '--', exerNum: '--',
      exerAvgHour: 0,

      est_a1c: '--',
      a1c_available: false,

      calibPerDay: '--',
      bgPerDay: '--',

      highLevelText: '--',
      lowLevelText: '--',

      aucu: '--',
      aucl: '--',

      sgHighest: '--',
      sgLowest: '--',

      sgDistPie: {},
      sgDistPieLabels: ['--', '--', '--', '--'],

      autoModeSGDistPie: {},

      autoModeSGDistPieLabels: [this.$t('t1103_Time_below_range'), this.$t('t1103_Time_in_target_range'), this.$t('t1103_Time_above_range')],

      insPieData: [],

      basalPercent: '--',
      bolusPercent: '--',
      avgBolusNum: '--',
      avgSuspendTime: '--',

      avgManualBolus: '--',
      avgManualNormalBolus: '--',
      avgManualExtendBolus: '--',
      avgManualComboBolus: '--',

      avgWizzardBolus: '--',
      avgFoodWizzardBolus: '--',
      avgCorrWizzardBolus: '--',
      avgWizzardOverrideAdd: '--',
      avgWizzardOverrideSub: '--',

      timeInAutoMode: '--',
      autoModeSGAvgSD: '--',
      autoModeSGInTargetRange: '--',
      autoModeSGAboveRange: '--',
      autoModeSGBelowRange: '--',
      autoModeBasalPerDay: '--',
      autoModeBolusPerDay: '--',
      autoModeExitCauseNoSensorReadings: 0,
      autoModeExitCauseMaxDelivery: 0,
      autoModeExitCauseMinDelivery: 0,

      chart5NoData: false,
      chart6NoData: false,
      chart7NoData: false,

      pickerOptions: {
        disabledDate: function disabledDate(time) {
          var t1 = time.getTime();
          var d2 = new Date();
          var t2 = d2.getTime();

          return t1 > t2 || t1 < t2 - 730 * 86400 * 1000;
        }
      },

      textStyle: {
        color: '#282828',
        fontWeight: 'normal',
        fontSize: '14',
        fontFamily: 'SFUIText-Regular'
      },
      titlePadding: [0, 0, 8, 33],
      grid: { x: '4%', y: '16%', width: '90%', height: '50%' }, legend1Right: '', legend2Right: '',
      sgRange: [['', '4.4', '8.9', '13.3', '17.8', '22.2'], ['', '0.2', '0.4', '0.6', '0.8', '1.0'], ['', '1', '2', '3', '4', '5'], ['0', '1', '2', '3', '4', '5'], ['', this.$t('Light'), '', this.$t('Medium'), '', this.$t('heavy')]],
      dateTime: ["00:00", " ", "", "3:00", "", "", "6:00", "", "", "9:00", "", "", "12:00", "", "", "15:00", "", "", "18:00", "", "", "21:00", "", "", "24:00"],
      yAxisLabel: { interval: 0, margin: 5, textStyle: { color: '#282828', baseline: 'middle' }, showMinLabel: false },
      axisPointer: {
        type: 'line',
        axis: 'x',
        lineStyle: { color: '#777' }
      },
      devices: ['--', '--', '--']
    };
  },

  methods: {
    drawChart1_6: function drawChart1_6() {
      var data = [{ value: 6.75, name: 'Bolus' }, { value: 3.25, name: 'Basal' }];
      data = this.insPieData;
      var ins_unit2 = this.$t('ins_unit2');

      var that = this;
      this.chart1_6 = __WEBPACK_IMPORTED_MODULE_1_echarts__["init"](document.getElementById('chart1_6'));
      this.registLoading('chart1_6', this.chart1_6);
      this.chart1_6.setOption({
        tooltip: {
          trigger: 'item',

          formatter: function formatter(params, ticket, callback) {
            return params.percent.toFixed(1) + '%';
          }
        },

        series: [{
          name: 'insulin_usage',
          type: 'pie',
          radius: ['40%', '60%'],
          center: ['45%', '45%'],
          avoidLabelOverlap: false,
          label: {
            normal: {
              show: true,
              position: 'outside',

              formatter: function formatter(params, ticket, callback) {
                return params.name + '\n' + params.value + ins_unit2 + ', ' + params.percent.toFixed(1) + '%';
              }
            },
            emphasis: {
              show: true,
              textStyle: {}
            }

          },
          labelLine: {
            normal: {
              show: false,
              length: 10,
              length2: 15
            }
          },
          color: ['rgba(38,95,156,1)', 'rgba(123,168,220,1)'],
          data: data
        }]
      });
    },
    drawChart1_5: function drawChart1_5() {
      function genData(count) {
        var nameList = ['赵', '钱', '孙', '李', '周', '吴', '郑', '王', '冯', '陈', '褚', '卫', '蒋', '沈', '韩', '杨', '朱', '秦', '尤', '许', '何', '吕', '施', '张', '孔', '曹', '严', '华', '金', '魏', '陶', '姜', '戚', '谢', '邹', '喻', '柏', '水', '窦', '章', '云', '苏', '潘', '葛', '奚', '范', '彭', '郎', '鲁', '韦', '昌', '马', '苗', '凤', '花', '方', '俞', '任', '袁', '柳', '酆', '鲍', '史', '唐', '费', '廉', '岑', '薛', '雷', '贺', '倪', '汤', '滕', '殷', '罗', '毕', '郝', '邬', '安', '常', '乐', '于', '时', '傅', '皮', '卞', '齐', '康', '伍', '余', '元', '卜', '顾', '孟', '平', '黄', '和', '穆', '萧', '尹', '姚', '邵', '湛', '汪', '祁', '毛', '禹', '狄', '米', '贝', '明', '臧', '计', '伏', '成', '戴', '谈', '宋', '茅', '庞', '熊', '纪', '舒', '屈', '项', '祝', '董', '梁', '杜', '阮', '蓝', '闵', '席', '季', '麻', '强', '贾', '路', '娄', '危'];
        var legendData = [];
        var seriesData = [];
        var selected = {};
        for (var i = 0; i < count; i++) {
          var name = Math.random() > 0.65 ? makeWord(4, 1) + '·' + makeWord(3, 0) : makeWord(2, 1);
          legendData.push(name);
          seriesData.push({
            name: name,
            value: Math.round(Math.random() * 100000)
          });
          selected[name] = i < 6;
        }

        return {
          legendData: legendData,
          seriesData: seriesData,
          selected: selected
        };

        function makeWord(max, min) {
          var nameLen = Math.ceil(Math.random() * max + min);
          var name = [];
          for (var i = 0; i < nameLen; i++) {
            name.push(nameList[Math.round(Math.random() * nameList.length - 1)]);
          }
          return name.join('');
        }
      }

      var data = genData(4);
      data = {
        'legendData': ['high', 'target', 'low', 'hypo'],
        'selected': { 'hypo': true, 'low': true, 'target': true, 'high': true },
        'seriesData': [{ name: 'high', value: 40 }, { name: 'target', value: 25 }, { name: 'low', value: 20 }, { name: 'hypo', value: 15 }]
      };
      data = this.sgDistPie;
      var sgDistPieLabels = this.sgDistPieLabels;
      console.log('dataNum:', data);
      if (!data.dataNum) {
        this.chart5NoData = true;
      }


      var that = this;
      this.chart1_5 = __WEBPACK_IMPORTED_MODULE_1_echarts__["init"](document.getElementById('chart1_5'));
      this.chart1_5.setOption({
        title: {
          text: '',
          subtext: '',
          x: 'center'
        },
        tooltip: {
          trigger: 'item',

          formatter: function formatter(params, ticket, callback) {
            return params.percent.toFixed(1) + '%';
          }
        },
        legend: {
          show: false,
          selectedMode: false,
          orient: 'vertical',
          right: 10,

          bottom: 40,
          data: data.legendData,
          formatter: function formatter(name) {
            if ('high' == name) {
              return sgDistPieLabels[3];
            } else if ('target' == name) {
              return sgDistPieLabels[2];
            } else if ('low' == name) {
              return sgDistPieLabels[1];
            } else if ('hypo' == name) {
              return sgDistPieLabels[0];
            }
            return name;
          }

        },

        series: [{
          name: 'sg_dist',
          label: {
            normal: {
              position: 'outside',

              color: '#000',

              formatter: function formatter(data) {
                var range = '';
                var name = data.name;
                if ('high' == name) {
                  range = sgDistPieLabels[3];
                } else if ('target' == name) {
                  range = sgDistPieLabels[2];
                } else if ('low' == name) {
                  range = sgDistPieLabels[1];
                } else if ('hypo' == name) {
                  range = sgDistPieLabels[0];
                }

                return range + ': ' + data.percent.toFixed(1) + '%';
              },

              rich: {
                aa: {
                  color: '#000',
                  fontSize: 18
                }
              }
            }

          },
          labelLine: {
            normal: {
              lineStyle: {
                color: '#000'
              }
            }
          },
          type: 'pie',
          radius: '65%',
          center: ['50%', '50%'],
          data: data.seriesData,

          color: ['rgba(255,170,0,1)', 'rgba(42,222,154,1)', 'rgba(254,102,102,1)', 'rgba(255,38,38,1)'],
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }

          }
        }]
      });
    },
    drawChart1_7: function drawChart1_7() {
      var id = 'chart1_7';
      function genData(count) {
        var nameList = ['赵', '钱', '孙', '李', '周', '吴', '郑', '王', '冯', '陈', '褚', '卫', '蒋', '沈', '韩', '杨', '朱', '秦', '尤', '许', '何', '吕', '施', '张', '孔', '曹', '严', '华', '金', '魏', '陶', '姜', '戚', '谢', '邹', '喻', '柏', '水', '窦', '章', '云', '苏', '潘', '葛', '奚', '范', '彭', '郎', '鲁', '韦', '昌', '马', '苗', '凤', '花', '方', '俞', '任', '袁', '柳', '酆', '鲍', '史', '唐', '费', '廉', '岑', '薛', '雷', '贺', '倪', '汤', '滕', '殷', '罗', '毕', '郝', '邬', '安', '常', '乐', '于', '时', '傅', '皮', '卞', '齐', '康', '伍', '余', '元', '卜', '顾', '孟', '平', '黄', '和', '穆', '萧', '尹', '姚', '邵', '湛', '汪', '祁', '毛', '禹', '狄', '米', '贝', '明', '臧', '计', '伏', '成', '戴', '谈', '宋', '茅', '庞', '熊', '纪', '舒', '屈', '项', '祝', '董', '梁', '杜', '阮', '蓝', '闵', '席', '季', '麻', '强', '贾', '路', '娄', '危'];
        var legendData = [];
        var seriesData = [];
        var selected = {};
        for (var i = 0; i < count; i++) {
          var name = Math.random() > 0.65 ? makeWord(4, 1) + '·' + makeWord(3, 0) : makeWord(2, 1);
          legendData.push(name);
          seriesData.push({
            name: name,
            value: Math.round(Math.random() * 100000)
          });
          selected[name] = i < 6;
        }

        return {
          legendData: legendData,
          seriesData: seriesData,
          selected: selected
        };

        function makeWord(max, min) {
          var nameLen = Math.ceil(Math.random() * max + min);
          var name = [];
          for (var i = 0; i < nameLen; i++) {
            name.push(nameList[Math.round(Math.random() * nameList.length - 1)]);
          }
          return name.join('');
        }
      }

      var data = genData(4);
      data = {
        'legendData': ['high', 'target', 'low', 'hypo'],
        'selected': { 'hypo': true, 'low': true, 'target': true, 'high': true },
        'seriesData': [{ name: 'high', value: 40 }, { name: 'target', value: 25 }, { name: 'low', value: 20 }, { name: 'hypo', value: 15 }]
      };
      data = this.autoModeSGDistPie;
      var autoModeSGDistPieLabels = this.autoModeSGDistPieLabels;
      console.log('dataNum:', data);
      if (!data.dataNum) {
        this.chart7NoData = true;
      }


      var that = this;
      this.chart1_7 = __WEBPACK_IMPORTED_MODULE_1_echarts__["init"](document.getElementById(id));
      this.chart1_7.setOption({
        title: {
          text: '',
          subtext: '',
          x: 'center'
        },
        tooltip: {
          trigger: 'item',

          formatter: function formatter(params, ticket, callback) {
            return params.percent.toFixed() + '%';
          }
        },
        legend: {
          show: false,
          selectedMode: false,
          orient: 'vertical',
          right: 10,

          bottom: 40,
          data: data.legendData,
          formatter: function formatter(name) {
            if ('high' == name) {
              return autoModeSGDistPieLabels[2];
            } else if ('target' == name) {
              return autoModeSGDistPieLabels[1];
            } else if ('low' == name) {
              return autoModeSGDistPieLabels[0];
            }
            return name;
          }

        },

        series: [{
          name: 'sg_dist',
          label: {
            normal: {
              position: 'outside',

              color: '#000',

              formatter: function formatter(data) {
                var range = '';
                var name = data.name;
                if ('high' == name) {
                  range = autoModeSGDistPieLabels[2];
                } else if ('target' == name) {
                  range = autoModeSGDistPieLabels[1];
                } else if ('low' == name) {
                  range = autoModeSGDistPieLabels[0];
                }

                return range + ': ' + data.percent.toFixed() + '%';
              },

              rich: {
                aa: {
                  color: '#000',
                  fontSize: 18
                }
              }
            }

          },
          labelLine: {
            normal: {
              lineStyle: {
                color: '#000'
              }
            }
          },
          type: 'pie',
          radius: '65%',
          center: ['45%', '45%'],
          data: data.seriesData,

          color: ['rgba(255,170,0,1)', 'rgba(42,222,154,1)', 'rgba(254,102,102,1)', 'rgba(255,38,38,1)'],
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }

          }
        }]
      });
    },
    drawChart1_4: function drawChart1_4() {
      var id = 'chart1_4';
      var sel_time = new Date(2019, 0, 1).getTime();

      if (false) {
        this.XData = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];
        this.YData10P = [];
        this.YDataQ1 = [];
        this.YDataQ3 = [];
        this.YData90P = [];
        var first_time = sel_time + 5 * 60 * 1000;
        for (var i = 0; i < 144; i++) {
          this.YDataMin.push([first_time + i * 60 * 10 * 1000, 2, 2]);
          this.YData10P.push([first_time + i * 60 * 10 * 1000, 4, 2]);
          this.YDataQ1.push([first_time + i * 60 * 10 * 1000, 2, 2]);
          this.YDataMed.push([first_time + i * 60 * 10 * 1000, 2, 2]);
          this.YDataQ3.push([first_time + i * 60 * 10 * 1000, 2, 2]);
          this.YData90P.push([first_time + i * 60 * 10 * 1000, 4, 2]);
          this.YDataMax.push([first_time + i * 60 * 10 * 1000, 2, 2]);
        }
      }

      this.XTimeMin = sel_time;
      this.XTimeMax = sel_time + 86400 * 1000;

      var that = this;
      this.chart1_4 = __WEBPACK_IMPORTED_MODULE_1_echarts__["init"](document.getElementById(id));
      var t_min_max = this.$t('t1103_Min_Max');
      var t_target_range = this.$t('t1103_Target_Range');
      this.chart1_4.setOption({
        title: {
          text: this.isMg ? this.$t('Sensor Glucose Profile') + ' \nmg/dL' : this.$t('Sensor Glucose Profile') + ' \nmmol/L',
          textStyle: this.textStyle,
          padding: this.titlePadding
        },
        tooltip: {
          trigger: 'axis',

          axisPointer: {
            label: {
              backgroundColor: '#6a7985'
            }
          },

          formatter: function formatter(params, ticket, callback) {
            if (params instanceof Array) {
              var minuteFormat = function minuteFormat(minute) {
                var h = Math.floor(minute / 60);
                var m = Math.floor(minute % 60);
                if (h < 10) {
                  h = '0' + h;
                }
                if (m < 10) {
                  m = '0' + m;
                }
                return h + ':' + m;
              };

              var paramSize = params.length;
              var strMinute = params[0].axisValueLabel;
              var strTooptip = strMinute.slice(0, 5);
              var t = new Date(params[0].axisValue);
              var minute = t.getHours() * 60 + t.getMinutes();
              var startMinute = minute - 5;
              var endMinute = minute + 5;

              strTooptip = minuteFormat(startMinute) + ' ~ ' + minuteFormat(endMinute);

              for (var _i = paramSize - 1; _i >= 0; _i--) {
                var series = params[_i];
                strTooptip += '<br/>' + series.seriesName + ': ' + series.value[2];
              }
              return strTooptip;
            }
            return 'Loading';
          }
        },
        xAxis: [{
          type: 'time',

          interval: 3600 * 1000,
          min: this.XTimeMin,
          max: this.XTimeMax,
          splitNumber: 24,

          axisLabel: {
            showMaxLabel: true,
            margin: 10, textStyle: { color: '#282828', baseline: 'middle' },
            formatter: function formatter(value, index) {
              index = (value - that.XTimeMin) / 3600000;
              var H = index;

              if (index < 24) {
                if (index % 3 === 0) {
                  H = H < 10 ? '0' + H + ':00' : H + ':00';
                  return H;
                } else {
                  return ' ';
                }
              } else {
                return '24:00';
              }
            }
          },
          axisLine: { lineStyle: { color: '#ccc' } }
        }],

        yAxis: [{
          type: 'value',
          min: 0,
          max: this.sgMax,
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          boundaryGap: false,
          axisTick: { length: 0 }
        }, {
          type: 'value',
          min: 0,
          max: this.sgMax,
          axisLabel: { show: false },
          axisLine: { lineStyle: { color: '#ccc' } },
          boundaryGap: false,
          axisTick: { length: 0 }
        }],
        grid: this.grid,

        legend: {
          selectedMode: false,
          itemWidth: 40,
          itemHeight: 15,
          itemGap: 25,
          symbolKeepAspect: false,

          bottom: 30,
          formatter: function formatter(name) {
            if ('50%' == name) {
              return '50%';
            } else if ('25%' == name) {
              return '25% - 75%';
            } else if ('10%' == name) {
              return '10% - 90%';
            } else if ('Min' == name) {
              return t_min_max;
            } else if ('Max' == name) {
              return t_target_range;
            }

            return name;
          },

          data: [{
            name: '50%', icon: 'image://static/dashboardLegend/Medium.png'
          }, {
            name: '25%', icon: 'image://static/dashboardLegend/IQR.png'
          }, {
            name: '10%', icon: 'image://static/dashboardLegend/10_90.png'
          }, {
            name: 'Min', icon: 'image://static/dashboardLegend/Min_Max.png'
          }, {
            name: 'Max', icon: 'image://static/dashboardLegend/TargetRange.png'
          }]
        },
        series: [{
          name: 'Min',
          type: 'line',

          data: this.YDataMin,
          stack: 'total',
          lineStyle: {
            normal: {
              color: '#979797',
              width: 1,
              type: 'dashed'
            }
          },
          symbol: 'none',
          markArea: {
            data: [[{ yAxis: this.target_low }, { yAxis: this.target_high }]],
            tooltip: { show: false },
            itemStyle: {
              normal: {
                color: 'rgba(211,255,213,0.6)'
              }
            }
          }
        }, {
          name: '10%',
          type: 'line',

          data: this.YData10P,
          stack: 'total',

          symbol: 'none',
          lineStyle: {
            normal: {
              color: 'rgba(140, 201, 239, 0.5)',
              width: 1
            }
          }

        }, {
          name: '25%',
          type: 'line',

          data: this.YDataQ1,
          stack: 'total',
          areaStyle: {
            normal: {
              color: 'rgba(140, 201, 239, 0.5)'
            }
          },
          lineStyle: {
            normal: {
              color: 'rgba(62, 176, 245, 0.6)',
              width: 1
            }
          },
          symbol: 'none'

        }, {
          name: '50%',
          type: 'line',

          data: this.YDataMed,
          stack: 'total',
          areaStyle: {
            normal: { color: 'rgba(62, 176, 245, 0.6)' }
          },
          lineStyle: {
            normal: {
              color: '#505050',
              width: 1
            }
          },
          symbol: 'none'
        }, {
          name: '75%',
          type: 'line',

          data: this.YDataQ3,
          stack: 'total',
          areaStyle: { normal: { color: 'rgba(62, 176, 245, 0.6)' } },
          lineStyle: {
            normal: {
              color: 'rgba(62, 176, 245, 0.6)',
              width: 1
            }
          },
          symbol: 'none'
        }, {
          name: '90%',
          type: 'line',

          data: this.YData90P,
          stack: 'total',
          areaStyle: { normal: { color: 'rgba(140, 201, 239, 0.5)' } },
          lineStyle: {
            normal: {
              color: 'rgba(62, 176, 245, 0.6)',
              width: 1
            }
          },
          symbol: 'none'
        }, {
          name: 'Max',
          type: 'line',

          data: this.YDataMax,
          stack: 'total',
          lineStyle: {
            normal: {
              color: '#979797',
              width: 1,
              type: 'dashed'
            }
          },
          symbol: 'none'
        }]
      });
    },
    drawChart1_1: function drawChart1_1() {
      return;
      var that = this;
      this.chart1_1 = __WEBPACK_IMPORTED_MODULE_1_echarts__["init"](document.getElementById('chart1_1'));
      this.chart1_1.setOption({
        title: {
          text: this.isMg ? this.$t('Sensor Glucose Profile') + ' (mg/dL)' : this.$t('Sensor Glucose Profile') + ' (mmol/L)',
          textStyle: this.textStyle,
          padding: this.titlePadding
        },
        xAxis: [{
          type: 'category',
          data: this.sgDate,
          axisLabel: { show: false, interval: 0 },
          axisLine: { lineStyle: { color: '#ccc' } }
        }],
        yAxis: [{
          type: 'value',
          min: 0,
          max: this.sgMax,
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          boundaryGap: false,
          axisTick: { length: 0 }
        }, {
          type: 'value',
          min: 0,
          max: this.sgMax,
          axisLabel: { show: false },
          axisLine: { lineStyle: { color: '#ccc' } },
          boundaryGap: false,
          axisTick: { length: 0 }
        }],
        tooltip: {
          trigger: 'axis',
          confine: true,
          axisPointer: this.axisPointer,
          backgroundColor: '#333',
          formatter: function formatter(params) {
            var tip = that.tooltipFormat(params, that);
            return tip;
          }
        },
        grid: this.grid,
        legend: {
          selectedMode: false,
          itemWidth: 50,
          itemHeight: 110,
          right: this.legend1Right,
          top: 'middle',
          data: [{ name: '25%', icon: 'image://static/segLegend/legend1.png' }],
          textStyle: { color: 'rgba(0,0,0,0)' }
        },
        series: [{
          name: '10%',
          type: 'bar',
          barWidth: '60%',
          stack: 'sg',
          data: this.sg1[0],
          itemStyle: {
            normal: {
              barBorderColor: 'rgba(0,0,0,0)',
              color: 'rgba(0,0,0,0)'
            },
            emphasis: {
              barBorderColor: 'rgba(0,0,0,0)',
              color: 'rgba(0,0,0,0)'
            }
          },
          markLine: {
            data: [{ yAxis: this.isMg ? this.target_low * 18 : this.target_low }],
            symbol: ['circle', 'circle'],
            silent: true,
            symbolSize: 1,
            lineStyle: { normal: {
                color: '#2cd200',
                type: 'solid'
              } },
            label: { normal: { show: false } }
          },
          markArea: {
            data: [[{ yAxis: this.isMg ? this.target_low * 18 : this.target_low }, { yAxis: this.isMg ? this.target_high * 18 : this.target_high }]],
            tooltip: { show: false },
            itemStyle: {
              normal: {
                color: 'rgba(211,255,213,0.6)'
              }
            }
          }
        }, {
          name: '25%',
          type: 'bar',
          stack: 'sg',
          data: this.sg1[1],
          itemStyle: {
            normal: {
              barBorderRadius: [0, 0, 20, 20],
              color: '#a2ebff'
            }
          },
          markLine: {
            data: [{ yAxis: this.isMg ? this.target_high * 18 : this.target_high }],
            symbol: ['circle', 'circle'],
            silent: true,
            symbolSize: 1,
            lineStyle: { normal: {
                color: '#2cd200',
                type: 'solid'
              } },
            label: { normal: { show: false } }
          }
        }, {
          name: '75%',
          type: 'bar',
          stack: 'sg',
          data: this.sg1[2],
          itemStyle: {
            normal: {
              color: '#00ceef'
            }

          }
        }, {
          name: '90%',
          type: 'bar',
          stack: 'sg',
          data: this.sg1[3],
          itemStyle: {
            normal: {
              barBorderRadius: [20, 20, 0, 0],
              color: '#a2ebff'
            }

          }
        }, {
          type: 'line',
          data: this.sgHalf,
          itemStyle: { normal: {
              color: 'transparent',
              borderColor: '#0095ff',
              borderWidth: 1
            } },
          lineStyle: { normal: {
              color: '#e89b00',
              width: 1
            } },
          symbol: 'diamond',
          symbolSize: 4
        }]
      });
    },
    drawChart1_3: function drawChart1_3() {
      return;
      var that = this;
      this.chart1_3 = __WEBPACK_IMPORTED_MODULE_1_echarts__["init"](document.getElementById('chart1_3'));
      this.chart1_3.setOption({
        title: [{}],
        tooltip: {
          trigger: 'axis',
          confine: true,
          axisPointer: this.axisPointer,
          backgroundColor: '#333',
          formatter: function formatter(params) {
            var tip = that.tooltipFormat2(params[0], that);
            return tip;
          }
        },
        xAxis: [{
          type: 'category',
          data: this.sgDate,
          axisLabel: { show: false, interval: 0 },
          axisLine: { lineStyle: { color: '#ccc' } }
        }],
        legend: {
          selectedMode: false,
          itemWidth: 50,
          itemHeight: 118,
          right: this.legend2Right,
          top: 'middle',
          data: [{ name: 'bolus', icon: 'image://static/segLegend/legend2.png' }],
          textStyle: { color: 'rgba(0,0,0,0)' }
        },
        yAxis: [{
          type: 'value',
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          min: 0,
          max: this.bolusMax,
          boundaryGap: false,
          splitLine: { show: false },
          axisTick: { length: 0 },
          name: this.$t('Bolus Insulin') + ' ' + this.$t('ins_unit'),
          nameTextStyle: {
            color: '#000',
            fontWeight: 'normal',
            fontSize: '13',
            fontFamily: 'SFUIText-Regular'
          },
          nameLocation: 'middle',
          nameGap: 25
        }, {
          type: 'value',
          axisLabel: { show: false },
          axisLine: { lineStyle: { color: '#ccc' } },
          min: 0,
          max: this.bolusMax,
          axisTick: { length: 0 }
        }],
        grid: this.grid,
        series: [{
          name: 'bolus',
          type: 'boxplot',
          data: this.bolus1,
          hoverAnimation: false,
          boxWidth: ['30%', '35%'],
          itemStyle: { normal: { borderColor: '#0095ff' } }
        }]
      });
    },
    drawChart1_2: function drawChart1_2() {
      return;
      var that = this;
      this.chart1_2 = __WEBPACK_IMPORTED_MODULE_1_echarts__["init"](document.getElementById('chart1_2'));
      this.chart1_2.setOption({
        title: [{
          text: this.update_time,
          textStyle: this.textStyle,
          padding: [5, 0, 8, 50]
        }],
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'line', lineStyle: { color: '#333' } },
          backgroundColor: '#333',
          formatter: function formatter(params) {
            var icon = " <div style='background: #00ff4c;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
            var timeDetail = '',
                value = '';
            params.map(function (e) {
              timeDetail = e.value[2] + '<br>';
              value = e.value[1];
            });
            return timeDetail + icon + 'Basal: ' + value + that.$t('basal_unit2');
          }
        },
        xAxis: [{
          type: 'time',
          boundaryGap: false,
          min: new Date(this.ts[0][0] * 1000),
          max: new Date(this.ts[0][1] * 1000),
          interlval: 0,
          axisLabel: {
            showMaxLabel: true,
            margin: 10, textStyle: { color: '#282828', baseline: 'middle' },
            formatter: function formatter(value, index) {
              var H = that.getXlabel(value, index, that.ts[0][0]);
              return H;
            }
          },
          axisLine: { lineStyle: { color: '#ccc' } },
          splitNumber: 24
        }],
        yAxis: [{
          type: 'value',
          boundaryGap: false,
          min: 0,
          max: this.basalMax,
          splitNumber: 5,
          axisTick: { length: 0 },
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          name: this.$t('Basal Pattern') + ' ' + this.$t('basal_unit'),
          nameTextStyle: {
            color: '#000',
            fontWeight: 'normal',
            fontSize: '13',
            fontFamily: 'SFUIText-Regular'
          },
          nameLocation: 'middle',
          nameGap: 25
        }],
        grid: this.grid,
        series: [{
          type: 'line',
          name: 'Basal',
          data: this.basal,

          itemStyle: { normal: { color: '#00ff40' } },
          symbolSize: 2
        }]
      });
    },
    getXlabel: function getXlabel(value, index, st) {
      index = (value - st * 1000) / 3600000;
      var H = index;
      if (index < 24) {
        H = H < 10 ? '0' + H + ':00' : H + ':00';
        return H;
      } else {
        return '24:00';
      }
    },
    tooltipFormat: function tooltipFormat(params, context) {
      var tipArray = [0, 0, 0, 0, 0],
          tip = '',
          time = '',
          data = context.sg1;
      var icon1 = " <div style='background: #00ceef;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
      var icon2 = " <div style='background: #0095ff;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";

      if (params[0]) {
        time = context.getTimeRange(params[0].name);
      }
      tip = tip + time + '<br>';
      params.map(function (e, i) {
        var value = e.value;
        if (value !== undefined) {
          var seriesIndex = e.seriesIndex,
              dataIndex = e.dataIndex;
          if (seriesIndex === 0) {
            var realData = context.isMg ? data[0][dataIndex] : data[0][dataIndex].toFixed(1);
            tipArray[4] = icon1 + '10% : ' + ' ' + realData;
          }
          if (seriesIndex === 1) {
            var _realData = data[0][dataIndex] + data[1][dataIndex];
            _realData = context.isMg ? _realData : _realData.toFixed(1);
            tipArray[3] = icon2 + '25% : ' + ' ' + _realData;
          }
          if (seriesIndex === 4) {
            var _realData2 = context.isMg ? value : value.toFixed(1);
            tipArray[2] = icon2 + '50% : ' + ' ' + _realData2;
          }
          if (seriesIndex === 2) {
            var _realData3 = data[0][dataIndex] + data[1][dataIndex] + data[2][dataIndex];
            _realData3 = context.isMg ? _realData3 : _realData3.toFixed(1);
            tipArray[1] = icon2 + '75% : ' + ' ' + _realData3;
          }
          if (seriesIndex === 3) {
            var _realData4 = data[0][dataIndex] + data[1][dataIndex] + data[2][dataIndex] + data[3][dataIndex];
            _realData4 = context.isMg ? _realData4 : _realData4.toFixed(1);
            tipArray[0] = icon1 + '90% : ' + ' ' + _realData4;
          }
        }
      });
      tipArray.map(function (e, i) {
        if (e) {
          tip = tip + e + '<br>';
        }
      });
      return tip;
    },
    tooltipFormat2: function tooltipFormat2(params, context) {
      var index = params.seriesIndex,
          name = params.name,
          tip = '',
          value = params.value;
      if (index === 0 && value[1]) {
        var time = context.getTimeRange(name);
        var tip1 = ' - ' + '10%' + ' : ' + value[1] + '<br>';
        var tip2 = ' - ' + '25%' + ' : ' + value[2] + '<br>';
        var tip3 = ' - ' + '50%' + ' : ' + value[3] + '<br>';
        var tip4 = ' - ' + '75%' + ' : ' + value[4] + '<br>';
        var tip5 = ' - ' + '90%' + ' : ' + value[5] + '<br>';
        tip = time + '<br>' + tip5 + tip4 + tip3 + tip2 + tip1;
      }
      return tip;
    },
    getTimeRange: function getTimeRange(val) {
      var time = '',
          t1 = val.split(':');
      if (t1[1] === '00') {
        time = t1[0] + ':00' + ' - ' + t1[0] + ':30';
      } else {
        var t2 = parseInt(t1[0]) + 1;
        t2 = t2 < 10 ? '0' + t2 : t2;
        time = t1[0] + ':30' + ' - ' + t2 + ':00';
      }
      return time;
    },
    drawCharts: function drawCharts() {
      this.drawChart1_4();
      this.drawChart1_5();
      this.drawChart1_6();
      this.drawChart1_7();
    },
    chartsDispose: function chartsDispose() {
      this.chart1_4.dispose();
      this.chart1_5.dispose();
      this.chart1_6.dispose();
      this.chart1_7.dispose();
    },
    handleResize: function handleResize() {
      var win = window.innerWidth;
      var scale = win < 1500 ? 0.91 : 0.62;
      var chartWidth = win * scale * 0.98 * 0.94 + 'px';

      var chart1_4 = document.getElementById('chart1_4');
      var chart1_5 = document.getElementById('chart1_5');
      var chart1_6 = document.getElementById('chart1_6');
      var chart1_7 = document.getElementById('chart1_7');
      if (chart1_4) {
        chart1_4.style.width = chartWidth;
        chart1_5.style.width = chartWidth * 0.6;
        chart1_6.style.width = chartWidth * 0.33;
        chart1_7.style.width = chartWidth * 0.6;
      }
    },
    getData: function getData() {
      this.ts = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getTs(this.st, this.et);

      var param = {
        sg: { ts: this.ts },
        basal: { ts: this.ts },
        bolus: { ts: this.ts },
        event: { ts: this.ts },
        calib: { ts: this.ts },
        custom: {
          usemode: 'sa',
          ts: [this.st, this.et]
        }
      };

      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getDashboard(this, this.uid, param);
    },
    open: function open() {
      this.value4 = new Date(this.st * 1000);
      this.staTime = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate4(this.st);
      this.value3 = new Date(this.et * 1000);
      this.endTime = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate4(this.et);
      this.timeRangeSelect = this.timeRangeSelectActive;
      if (0 == this.timeRangeSelect) {
        this.custo = true;
      } else {
        this.custo = false;
      }
      this.typeChooseVisible = true;
    },
    cancel: function cancel() {
      this.typeChooseVisible = false;
    },
    dateApply: function dateApply() {
      var st = this.value4.getTime() / 1000;
      var et = this.value3.getTime() / 1000;
      if (st >= et) {
        this.$message.error("Date select wrong");
        return;
      }
      this.st = st;
      this.et = et;

      var curDate = new Date();
      if (curDate.getTime() - this.st * 1000 > 730 * 86400 * 1000) {}

      sessionStorage.setItem('st7', this.st);
      sessionStorage.setItem('et7', this.et);
      sessionStorage.setItem('timeRangeSelect7', this.timeRangeSelect);

      this.getDate();

      this.typeChooseVisible = false;

      sessionStorage.setItem('st4', this.st);
      sessionStorage.setItem('et4', this.et);
      sessionStorage.setItem('timeRange4', this.timeRange2);
      sessionStorage.setItem('timeRangeSelect4', this.timeRangeSelect);
      console.log('set st4.2:', this.st);

      sessionStorage.setItem('st8', this.st);
      sessionStorage.setItem('et8', this.et);
      sessionStorage.setItem('timeRangeSelect8', this.timeRangeSelect);

      var daySpan = (this.et - this.st) / 86400 + 1;
      var st2 = this.et - 86400 * (7 - 1);
      if (daySpan > 7) {
        st2 = this.et - 86400 * (14 - 1);
      }
      sessionStorage.setItem('st2', st2);
      sessionStorage.setItem('et2', this.et);

      var st3 = this.et - 86400 * (7 - 1);
      sessionStorage.setItem('st3', st3);
      sessionStorage.setItem('et3', this.et);
      if (!sessionStorage.getItem('week3')) {
        sessionStorage.setItem('week3', 'yyyyyyy');
      }

      var st5 = this.et - 86400 * (7 - 1);
      if (daySpan > 7) {
        st5 = this.et - 86400 * (14 - 1);
      }
      sessionStorage.setItem('st5', st5);
      sessionStorage.setItem('et5', this.et);
      if (!sessionStorage.getItem('week5')) {
        sessionStorage.setItem('week5', 'yyyyyyy');
      }

      window.location.reload();
    },
    getDate: function getDate() {
      this.timeRange2 = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate2(this.st) + ' - ' + __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate2(this.et);
      this.staTime = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate4(this.st);
      this.endTime = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate4(this.et);
      this.value4 = new Date(this.st * 1000);
      this.value3 = new Date(this.et * 1000);
    },
    startDateChange: function startDateChange() {},
    endDateChange: function endDateChange() {
      var endDate = this.value3;
      var et = endDate.getTime() / 1000;
      var daySpan = 0;
      if (1 == this.timeRangeSelect) {
        daySpan = 7;
      } else if (2 == this.timeRangeSelect) {
        daySpan = 14;
      } else if (3 == this.timeRangeSelet) {
        daySpan = 30;
      } else if (4 == this.timeRangeSelect) {
        daySpan = 90;
      }
      if (daySpan) {
        var st = et - 86400 * (daySpan - 1);
        this.value4 = new Date(st * 1000);
        this.staTime = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate4(st);
      }
    },
    procTimeRangeSelect: function procTimeRangeSelect(e) {
      console.log('procTimeRangeSelect:', this.timeRangeSelect);
      var daySpan = 0;
      if (1 == this.timeRangeSelect) {
        daySpan = 7;
      } else if (2 == this.timeRangeSelect) {
        daySpan = 14;
      } else if (3 == this.timeRangeSelect || 4 == this.timeRangeSelect) {
        daySpan = 30;
        if (4 == this.timeRangeSelect) {
          daySpan = 90;
        }
      }

      var et = this.value3.getTime() / 1000;

      console.log('daySpan:', daySpan);
      this.dayNum = daySpan;
      if (daySpan) {
        var st = et - 86400 * (daySpan - 1);
        this.staTime = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate4(st);
        this.value4 = new Date(st * 1000);
      }
      if (0 == this.timeRangeSelect) {
        this.custo = true;
      } else {
        this.custo = false;
      }
      console.log('startDateDisable:', this.startDateDisable);
    },
    print: function print() {
      var src1 = this.chart1_4.getDataURL();
      var src2 = this.chart1_5.getDataURL();
      var src3 = this.chart1_6.getDataURL();
      var src4 = this.chart1_7.getDataURL();
      sessionStorage.setItem('src7_1', src1);
      sessionStorage.setItem('src7_2', src2);
      sessionStorage.setItem('src7_3', src3);
      sessionStorage.setItem('src7_4', src4);
      sessionStorage.setItem('timeRange7', this.timeRange2);
      sessionStorage.setItem('targetH7', this.target_high);
      sessionStorage.setItem('targetL7', this.target_low);
      sessionStorage.setItem('sg7', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.sg));
      sessionStorage.setItem('count7', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.bolCount));
      sessionStorage.setItem('st7', this.st);
      sessionStorage.setItem('et7', this.et);
      sessionStorage.setItem('dashboardStatInfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        devices: this.devices,
        bgAvg: this.bgAvg,
        bgSD: this.bgSD,
        bgNum: this.bgNum,

        sgAvg: this.sgAvg,
        sgSD: this.sgSD,
        sgNum: this.sgNum,

        insAvg: this.insAvg, insSD: this.insSD, insNum: this.insNum, patchAvgLife: this.patchAvgLife,
        carbAvg: this.carbAvg, carbSD: this.carbSD, carbNum: this.carbNum,
        exerAvg: this.exerAvg, exerSD: this.exerSD, exerNum: this.exerNum,

        est_a1c: this.est_a1c,
        a1c_available: this.a1c_available,

        calibPerDay: this.calibPerDay,
        bgPerDay: this.bgPerDay,

        highLevelText: this.highLevelText,
        lowLevelText: this.lowLevelText,

        aucu: this.aucu,
        aucl: this.aucl,

        sgHighest: this.sgHighest,
        sgLowest: this.sgLowest,

        basalPercent: this.basalPercent,
        bolusPercent: this.bolusPercent,
        avgBolusNum: this.avgBolusNum,
        avgSuspendTime: this.avgSuspendTime,

        avgManualBolus: this.avgManualBolus,
        avgManualNormalBolus: this.avgManualNormalBolus,
        avgManualExtendBolus: this.avgManualExtendBolus,
        avgManualComboBolus: this.avgManualComboBolus,

        avgWizzardBolus: this.avgWizzardBolus,
        avgFoodWizzardBolus: this.avgFoodWizzardBolus,
        avgCorrWizzardBolus: this.avgCorrWizzardBolus,
        avgWizzardOverrideAdd: this.avgWizzardOverrideAdd,
        avgWizzardOverrideSub: this.avgWizzardOverrideSub,
        chart5NoData: this.chart5NoData,
        chart6NoData: this.chart6NoData,
        chart7NoData: this.chart7NoData,

        timeInAutoMode: this.timeInAutoMode,
        autoModeSGAvgSD: this.autoModeSGAvgSD,
        autoModeSGInTargetRange: this.autoModeSGInTargetRange,
        autoModeSGAboveRange: this.autoModeSGAboveRange,
        autoModeSGBelowRange: this.autoModeSGBelowRange,
        autoModeBasalPerDay: this.autoModeBasalPerDay,
        autoModeBolusPerDay: this.autoModeBolusPerDay,
        autoModeExitCauseNoSensorReadings: this.autoModeExitCauseNoSensorReadings,
        autoModeExitCauseMaxDelivery: this.autoModeExitCauseMaxDelivery,
        autoModeExitCauseMinDelivery: this.autoModeExitCauseMinDelivery

      }));

      window.open('/#/chart0-print', '_blank');
    }
  },
  mounted: function mounted() {
    var win = window.innerWidth;
    this.dialogSize = win < 1500 ? 'small' : 'tiny';
    this.legend1Right = win < 1150 ? -35 : -30;
    this.legend2Right = win < 1150 ? -43 : -38;
    this.isEn = sessionStorage.getItem('language') !== 'zh' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    this.glucoseUnit = this.isMg ? 'mg/dL' : 'mmol/L';
    this.titleText = this.isMg ? this.$t('SG') + ' (mg/dL)' : this.$t('SG') + ' (mmol/L)';
    this.sgMax = this.isMg ? 400 : 25;
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }

    console.log('mounted:', sessionStorage.getItem('st7'));
    if (!sessionStorage.getItem('st7')) {
      var nd = new Date();
      var cur_day = new Date(nd.getFullYear(), nd.getMonth(), nd.getDate() - 1);
      this.et = cur_day / 1000;
      var chart_end_time = sessionStorage.getItem('chart_end_time');
      console.log('chart_end_time:', chart_end_time);
      for (var d = 0; d < 3000; d++) {
        if (this.et > chart_end_time) {
          cur_day = new Date(cur_day.getFullYear(), cur_day.getMonth(), cur_day.getDate() - 1);
          this.et = cur_day / 1000;
        } else {
          break;
        }
      }
      this.st = this.et - 86400 * 6;
    } else {
      this.st = parseInt(sessionStorage.getItem('st7'));
      this.et = parseInt(sessionStorage.getItem('et7'));
      var timeRangeSelect7 = parseInt(sessionStorage.getItem('timeRangeSelect7'));
      if (timeRangeSelect7 != NaN && timeRangeSelect7 >= 0 && timeRangeSelect7 <= 4) {
        this.timeRangeSelect = timeRangeSelect7;
      } else {
        this.timeRangeSelect = 0;
      }
      this.timeRangeSelectActive = this.timeRangeSelect;
    }
    console.log('timeRangeSelect:', this.timeRangeSelect);

    sessionStorage.setItem('st7', this.st);
    sessionStorage.setItem('et7', this.et);
    sessionStorage.setItem('timeRangeSelect7', this.timeRangeSelect);

    this.dayNum = (this.et - this.st) / 86400 + 1;
    this.getDate();
    this.getData();

    sessionStorage.setItem('st4', this.st);
    sessionStorage.setItem('et4', this.et);
    sessionStorage.setItem('timeRange4', this.timeRange2);
    sessionStorage.setItem('timeRangeSelect4', this.timeRangeSelect);
    console.log('set st4.1:', this.st);

    sessionStorage.setItem('st8', this.st);
    sessionStorage.setItem('et8', this.et);
    sessionStorage.setItem('timeRangeSelect8', this.timeRangeSelect);

    var daySpan = (this.et - this.st) / 86400 + 1;
    var st2 = this.et - 86400 * (7 - 1);
    if (daySpan > 7) {
      st2 = this.et - 86400 * (14 - 1);
    }
    sessionStorage.setItem('st2', st2);
    sessionStorage.setItem('et2', this.et);

    var st3 = this.et - 86400 * (7 - 1);
    sessionStorage.setItem('st3', st3);
    sessionStorage.setItem('et3', this.et);
    if (!sessionStorage.getItem('week3')) {
      sessionStorage.setItem('week3', 'yyyyyyy');
    }

    var st5 = this.et - 86400 * (7 - 1);
    if (daySpan > 7) {
      st5 = this.et - 86400 * (14 - 1);
    }
    sessionStorage.setItem('st5', st5);
    sessionStorage.setItem('et5', this.et);
    if (!sessionStorage.getItem('week5')) {
      sessionStorage.setItem('week5', 'yyyyyyy');
    }

    var that = this;
    window.onresize = function () {
      that.handleResize();

      if (that.chart1_4) {
        that.chart1_4.resize();
        that.chart1_5.resize();
        that.chart1_6.resize();
        that.chart1_7.resize();
      }
    };
  }
});

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_base64__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_loading__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_format__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_chartTipFormat__ = __webpack_require__(149);










/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_loading__["a" /* loading */]],
  data: function data() {
    var _ref;

    return _ref = {
      chartWidth: '', timer: false, value1: '', uid: 0, et: 0, st: 0, newBasal: [], stopBasal: [], time: '', unit: '', isMg: '', ts: [], isEs: false,
      sgMax: 20, basalMax: 5, bolusMax: 10, timeSection: [], transmtr: [], carbMax: 100, isIt: false, isPo: false, isCz: false,
      sensor_alarm: [], pump_alarm: [], carb: [], exercise: [[10, 10, 10, 10, 10]], calib: [], bg: [],
      extend_bolus: [[10, 10, 10, 10, 10]], basal_suspend: [], basal_suspend2: [], tempBasal: [], isEn: false, isDu: false, isFr: false,
      autoModeBasal: [[0, 0, 1]],
      autoModeCorrBolus: [[0, 0, 1]],
      autoBreakfast: [],
      autoLunch: [],
      autoDinner: [],
      autoSnack: [],
      autoExercise: [],
      sleepTime1: [[10, 10, 10], [10, 10, 10]],
      sleepTime2: [[10, 10, 10], [10, 10, 10]],
      sleepTime3: [[10, 10, 10], [10, 10, 10]],
      chartColumn: null, chartColumn1: null, chartBar: null,
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          var t1 = time.getTime();
          var d2 = new Date();
          var t2 = d2.getTime();

          return t1 > t2 || t1 < t2 - 730 * 86400 * 1000;
        }
      },
      textStyle: {
        color: '#282828',
        fontWeight: 'normal',
        fontSize: '14',
        fontFamily: 'SFUIText-Regular'
      },
      titlePadding: [0, 0, 8, 33],
      grid: { x: '3%', y: '16%', width: '92%', height: '73%' },
      sgRange: [['', '4.4', '8.9', '13.3', '17.8', '22.2'], ['', '0.2', '0.4', '0.6', '0.8', '1.0'], ['', '1', '2', '3', '4', '5'], ['0', '1', '2', '3', '4', '5'], ['', this.$t('Light'), '', this.$t('Medium'), '', this.$t('heavy')]],
      dateTime: ["00:00", " ", "", "3:00", "", "", "6:00", "", "", "9:00", "", "", "12:00", "", "", "15:00", "", "", "18:00", "", "", "21:00", "", "", "24:00"],
      yAxisLabel: { interval: 0, margin: 5, textStyle: { color: '#282828', baseline: 'middle' }, showMinLabel: false },

      glucose: [], insulin: [], events: [],
      foodCoor: '',
      isDe: false }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'isIt', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'isFr', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'isSw', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'isCz', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'timeInAutoMode', '--'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'autoModeSGAvgSD', '--'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'autoModeSGInTargetRange', '--'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'autoModeSGAboveRange', '--'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'autoModeSGBelowRange', '--'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'autoModeExits', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'autoModeStat', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'glucose_unit', ''), _ref;
  },

  computed: {
    DataS: function DataS() {
      return this.$store.state.DataS;
    },
    DataSG: function DataSG() {
      return this.$store.state.DataSG;
    },
    DataBasal: function DataBasal() {
      return this.$store.state.DataBasal;
    },
    DataBolus: function DataBolus() {
      return this.$store.state.DataBolus;
    }
  },
  methods: {
    getData: function getData() {
      this.et = this.st + 86400;
      this.ts = [[this.st, this.et]];
      var param = {
        ts: this.ts,
        tz: parseInt(sessionStorage.getItem('tz')),
        gu: this.isMg ? 'mg/dL' : 'mmol/L'
      };
      param = __WEBPACK_IMPORTED_MODULE_4__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));

      __WEBPACK_IMPORTED_MODULE_3__auth_auth__["a" /* default */].getDs(this, this.uid, param, 0);
    },
    getDs: function getDs() {
      var next = document.getElementById('next');
      if (next.className) {
        next.className = '';
      }

      if (this.value1) {
        if (this.st == this.value1.getTime() / 1000) {} else {
          this.st = this.value1.getTime() / 1000;
          this.et = this.st;
          sessionStorage.setItem('st', this.st);
          this.$emit('reload');
        }
      }
    },
    getStatistics: function getStatistics(report_data) {
      var data = report_data;
      data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
      this.statics = data;
      this.devices = data.devices ? data.devices[0] : this.devices;
      this.hb1c = data.hba1cList ? data.hba1cList : this.hb1c;
      this.glucose = data.glucose_stat ? data.glucose_stat[0] : this.glucose;

      this.insulin = data.insulin_stat ? data.insulin_stat[0] : this.insulin;
      this.foodCoor = this.insulin.carb_corr_bolus ? this.insulin.carb_corr_bolus.toFixed(2) : 0;
      this.events = data.event_stat ? data.event_stat[0] : this.events;

      report_data.timeInAutoMode = this.timeInAutoMode;

      report_data.autoModeSGAvgSD = this.autoModeSGAvgSD;
      report_data.autoModeSGInTargetRange = this.autoModeSGInTargetRange;
      report_data.autoModeSGAboveRange = this.autoModeSGAboveRange;
      report_data.autoModeSGBelowRange = this.autoModeSGBelowRange;
      report_data.autoModeExits = this.autoModeExits;

      sessionStorage.setItem('ds_report_data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(report_data));
    },
    drawChart1_1: function drawChart1_1() {
      var _this = this;

      var that = this;
      this.chart1_1 = __WEBPACK_IMPORTED_MODULE_2_echarts__["init"](document.getElementById('chart1_1'));
      this.chart1_1.setOption({
        title: {
          text: this.isMg ? this.$t('SG') + ' (mg/dL)' : this.$t('SG') + ' (mmol/L)',
          textStyle: this.textStyle,
          padding: this.titlePadding
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            axis: 'x',
            lineStyle: { color: '#333' }
          },
          backgroundColor: '#555',
          textStyle: {
            color: '#ffffff'
          },
          formatter: function formatter(params) {
            var tip = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterTip1(params, that);
            return tip;
          }
        },

        xAxis: [{
          type: 'time',
          boundaryGap: false,
          min: new Date(this.timeSection[0] * 1000),
          max: new Date(this.timeSection[1] * 1000),
          axisLabel: { show: false },
          axisLine: { lineStyle: { color: '#ccc' } },
          splitNumber: 24,
          axisPointer: { snap: true }
        }],
        yAxis: [{
          type: 'value',
          min: 0,
          max: this.sgMax,
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          boundaryGap: false,
          axisTick: { length: 0 }
        }],
        grid: this.grid,
        series: [{
          name: 'SG',
          type: 'scatter',
          data: this.DataSG,
          markArea: {
            data: [[{ yAxis: this.isMg ? this.DataS.blos_low * 18 : this.DataS.blos_low }, { yAxis: this.isMg ? this.DataS.blos_high * 18 : this.DataS.blos_high }]],
            tooltip: { show: false,
              trigger: 'none' },
            itemStyle: {
              normal: {
                color: 'rgba(211,255,213,0.6)'
              }
            }
          },
          markLine: {
            data: [{ yAxis: this.isMg ? this.DataS.hypo * 18 : this.DataS.hypo }],
            symbol: ['circle', 'circle'],
            silent: true,
            symbolSize: 1,
            lineStyle: { normal: {
                color: 'rgba(255,0,0,0.5)',
                type: 'solid'
              } },
            label: { normal: { show: false } }
          },
          itemStyle: { normal: {
              color: function color(params) {
                var color = '#2cd200';
                if (params.value[1] < 0.1 && params.value[2] === 'H') {
                  color = '#a4a4a4';
                } else {
                  if (that.isMg) {
                    if (params.value[1] > that.DataS.blos_high * 18) {
                      color = '#e6be00';
                    }
                    if (params.value[1] < that.DataS.blos_low * 18) {
                      color = '#ff5c5c';
                    }
                  } else {
                    if (params.value[1] > that.DataS.blos_high) {
                      color = '#e6be00';
                    }
                    if (params.value[1] < that.DataS.blos_low) {
                      color = '#ff5c5c';
                    }
                  }
                }
                var type = params.value[2];
                if (type === 'NC' && params.value[1] == 0 || type === 'DE' || type === 'CE0' || type === 'CE1') {
                  color = 'transparent';
                }
                return color;
              }
            } },
          tooltip: { backgroundColor: '#555',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);
              if (params.value[1] > 0) {
                if (params.value[2] === 'CX' || params.value[2] === 'NC') {
                  return time[0] + ':' + time[1] + ', ' + params.value[1] + '<hr style="width: 20px;background:#FFF;height:1px;border:none;margin-left: 42px;">';
                }
                return time[0] + ':' + time[1] + ', ' + params.value[1];
              } else {
                if (params.value[2] === 'NC') {
                  return time[0] + ':' + time[1] + ', Not Calibrated';
                }
                if (params.value[2] === 'DE') {
                  return time[0] + ':' + time[1] + ', No Readings';
                }
                if (params.value[2] === 'CE0' || params.value[2] === 'CE1') {
                  return time[0] + ':' + time[1] + ',Calib Error';
                }
                return time[0] + ':' + time[1] + ', warm up';
              }
            }
          },
          symbolSize: 2
        }, {
          type: 'scatter',
          data: this.bg,
          name: 'bg',
          symbol: 'image://static/legend/calibrate_1.png',
          symbolSize: 10,
          tooltip: { backgroundColor: '#555',
            trigger: 'item',
            formatter: function formatter(params) {
              var timeDetail = __WEBPACK_IMPORTED_MODULE_7__lib_chartTipFormat__["a" /* default */].getFormatterTip1TimeDetail(params.value[0]);
              var tip = timeDetail + __WEBPACK_IMPORTED_MODULE_7__lib_chartTipFormat__["a" /* default */].bgFormat(params, _this);
              return tip;
            }
          },
          label: {
            show: this.$store.state.glucose_display === 'On',
            color: '#114C9A',
            backgroundColor: '#E7F5F9',
            position: 'top',
            distance: 10,
            fontSize: 16,
            width: 40,
            height: 20,
            borderColor: '#7AACBF'
          },
          emphasis: {
            focus: 'self'
          }
        }, {
          type: 'scatter',
          data: this.calib,
          name: 'calib',
          symbol: 'image://static/legend/calib.png',
          tooltip: { backgroundColor: '#555',
            trigger: 'item',
            z: 999,
            formatter: function formatter(params) {
              var timeDetail = __WEBPACK_IMPORTED_MODULE_7__lib_chartTipFormat__["a" /* default */].getFormatterTip1TimeDetail(params.value[0]);
              var tip = timeDetail + __WEBPACK_IMPORTED_MODULE_7__lib_chartTipFormat__["a" /* default */].calibFormat(params, _this);
              return tip;
            }
          },
          label: {
            show: this.$store.state.glucose_display === 'On',
            color: '#114C9A',
            backgroundColor: '#E7F5F9',
            position: 'top',
            distance: 10,
            fontSize: 16,
            width: 40,
            height: 20,
            borderColor: '#7AACBF'
          },
          emphasis: {
            focus: 'self'
          }
        }, {
          type: 'scatter',
          name: 'transmtr',
          data: this.transmtr,
          symbol: 'rect',
          symbolSize: 5,
          itemStyle: { normal: { color: '#00a107' } },
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + 'New Sensor';
            }
          }
        }, {
          type: 'scatter',
          name: 'alarm',
          data: this.sensor_alarm,
          symbol: 'image://static/legend/Alert.png',
          symbolSize: 13,
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + params.value[2];
            }
          }
        }, {
          type: 'custom',
          data: this.sleepTime1,
          z: -1,
          renderItem: function renderItem(params, api) {
            var y = api.value(2);
            var start = api.coord([api.value(0), y]);
            var size = api.size([api.value(1) - api.value(0), y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },
          tooltip: { show: false },
          itemStyle: { normal: { color: 'rgba(170,170,170,0.2)' } }
        }]
      });
    },
    drawChart1_2: function drawChart1_2() {
      var that = this;
      this.chart1_2 = __WEBPACK_IMPORTED_MODULE_2_echarts__["init"](document.getElementById('chart1_2'));
      this.registLoading('chart1_2', this.chart1_2);
      this.chart1_2.setOption({
        title: [{
          text: this.$t('basal') + ' ' + this.$t('basal_unit'),
          textStyle: this.textStyle,
          padding: this.titlePadding
        }, {
          text: this.$t('bolus') + ' ' + this.$t('ins_unit'),
          textStyle: this.textStyle,
          right: '18'
        }],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            axis: 'x',
            lineStyle: { color: '#333' }
          },
          backgroundColor: '#555',
          textStyle: {
            color: ' #ffffff'
          },
          formatter: function formatter(params) {
            var tip = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterTip(params, that, 'chart1');
            return tip;
          }
        },
        xAxis: [{
          type: 'time',
          boundaryGap: false,
          min: new Date(this.timeSection[0] * 1000),
          max: new Date(this.timeSection[1] * 1000),
          interlval: 0,
          axisLabel: { show: false },
          axisLine: { lineStyle: { color: '#ccc' } },
          splitNumber: 24
        }],
        yAxis: [{
          type: 'value',
          boundaryGap: false,
          min: 0,
          max: this.basalMax,
          axisTick: { length: 0 },
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } }
        }, {
          type: 'value',
          boundaryGap: false,
          min: 0,
          max: this.bolusMax,
          axisTick: { length: 0 },
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          splitLine: { show: false }
        }],
        grid: this.grid,
        series: [{
          type: 'line',
          name: this.$t('basal'),
          data: this.DataBasal,
          itemStyle: { normal: { color: '#00ff40' } },
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + params.value[1];
            }
          },
          symbolSize: 2
        }, {
          type: 'line',
          name: this.$t('auto suspend'),
          data: this.basal_suspend,
          itemStyle: { normal: { color: '#ff0000' } },
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + params.value[2];
            }
          },
          lineStyle: { normal: { type: 'dashed' } },
          symbolSize: 1
        }, {
          type: 'line',
          name: this.$t('tempBasal'),
          data: this.tempBasal,
          itemStyle: { normal: { color: '#00ff40' } },
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + 'TempBasal: ' + params.value[1];
            }
          },
          lineStyle: { normal: { type: 'dashed' } },
          symbolSize: 1
        }, {
          type: 'line',
          name: this.$t('manualStop'),
          data: this.basal_suspend2,
          itemStyle: { normal: { color: '#ff0000' } },
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + 'Manual Suspend';
            }
          },
          symbolSize: 1
        }, {
          type: 'custom',
          name: this.$t('normalBolus'),
          data: this.DataBolus,
          z: 999,
          yAxisIndex: 1,
          itemStyle: { normal: { color: '#182f82' } },
          renderItem: function renderItem(params, api) {
            var y = api.value(1);
            var start = api.coord([api.value(0), y]);
            var size = api.size([600000, y]);
            var style = api.style();

            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);

              return time[0] + ':1125254' + time[1] + ', ' + params.value[2] + ': ' + params.value[1] + ins_unit2;
            }
          },
          barWidth: '4'
        }, {
          type: 'custom',
          name: this.$t('extendBolus'),
          data: this.extend_bolus,
          yAxisIndex: 1,
          renderItem: function renderItem(params, api) {
            var y = api.value(2);
            var start = api.coord([api.value(0), y]);
            var size = api.size([api.value(1) - api.value(0), y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + params.value[4] + ': ' + params.value[2] + ins_unit2 + '/' + params.value[3] + 'min';
            }
          },
          itemStyle: { normal: { color: '#f9b4ff' }, emphasis: { color: '#f9b4ff' } }
        }, {
          type: 'scatter',
          name: this.$t('newPatch'),
          data: this.newBasal,
          symbol: 'image://static/legend/new%20Patch.png',
          symbolSize: 10,
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ',New Patch ';
            }
          }
        }, {
          type: 'scatter',
          name: this.$t('stop'),
          data: this.stopBasal,
          symbol: 'image://static/legend/patch%20Deactivated.png',
          symbolSize: 8,
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', Delivery Stop';
            }
          }
        }, {
          type: 'scatter',
          name: this.$t('alert'),
          data: this.pump_alarm,
          symbol: 'image://static/legend/Alert.png',
          symbolSize: 13,
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + params.value[2];
            }
          }
        }, {
          type: 'custom',
          data: this.sleepTime2,
          z: -1,
          renderItem: function renderItem(params, api) {
            var y = api.value(2);
            var start = api.coord([api.value(0), y]);
            var size = api.size([api.value(1) - api.value(0), y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },
          tooltip: { show: false },
          itemStyle: { normal: { color: 'rgba(170,170,170,0.2)' }, emphasis: { show: false } }
        }, {
          type: 'custom',
          name: this.$t('t1222_autoModeBasal'),
          data: this.autoModeBasal,
          yAxisIndex: 0,
          renderItem: function renderItem(params, api) {
            var y = api.value(2);
            var start = api.coord([api.value(0), y]);
            var size = api.size([api.value(1) - api.value(0), y]);
            var style = api.style();

            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },

              style: {
                fill: 'rgba(0, 255, 76, 0.5)'
              }
            };
          },
          tooltip: { backgroundColor: '#333'
          },
          itemStyle: { normal: { color: '#00ff4c' }, emphasis: { color: '#00ff5c' } }
        }, {
          type: 'custom',
          data: this.autoModeCorrBolus,
          name: this.$t('t1222_autoModeCorrBolus'),
          yAxisIndex: 1,
          itemStyle: { normal: { color: '#009bff' } },
          renderItem: function renderItem(params, api) {
            var y = api.value(2) + api.value(1);
            var start = api.coord([api.value(0), y]);
            var size = api.size([600000, y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },
          barWidth: '4'
        }]
      });
    },
    drawChart1_3: function drawChart1_3() {
      var s_breakfast = this.$t('Breakfast');
      var s_lunch = this.$t('Lunch');
      var s_dinner = this.$t('Dinner');
      var s_snack = this.$t('t1222_Snack');
      var s_exercise = this.$t('Exercise');
      var that = this;
      this.chart1_3 = __WEBPACK_IMPORTED_MODULE_2_echarts__["init"](document.getElementById('chart1_3'));
      this.chart1_3.setOption({
        title: [{
          text: this.$t('carbs') + ' (' + this.$t('g') + ')',
          textStyle: this.textStyle,
          left: this.titleLeft,
          padding: this.titlePadding
        }, {
          text: this.$t('exercise'),
          textStyle: this.textStyle,
          right: '22'
        }],
        tooltip: {
          backgroundColor: '#555',
          borderColor: '#333',
          padding: 2,
          textStyle: {
            color: ' #ffffff'
          }
        },
        xAxis: [{
          type: 'time',
          boundaryGap: false,
          min: new Date(this.timeSection[0] * 1000),
          max: new Date(this.timeSection[1] * 1000),
          axisLabel: {
            showMaxLabel: true,
            margin: 10, textStyle: { color: '#282828', baseline: 'middle' },
            formatter: function formatter(value, index) {
              index = (value - that.timeSection[0] * 1000) / 3600000;
              var H = index;
              if (index < 24) {
                if (index % 3 === 0) {
                  H = H < 10 ? '0' + H + ':00' : H + ':00';
                  return H;
                } else {
                  return ' ';
                }
              } else {
                return '24:00';
              }
            }
          },
          axisLine: { lineStyle: { color: '#ccc' } },
          splitNumber: 24
        }],
        yAxis: [{
          type: 'value',
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          min: 0,
          max: this.carbMax,
          boundaryGap: false,
          splitLine: { show: true },
          axisTick: { length: 0 }
        }, {
          data: this.sgRange[4],
          boundaryGap: false,
          axisTick: { length: 0 },
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } }
        }],
        grid: this.grid,
        series: [{
          type: 'custom',
          data: this.sleepTime3,
          z: -1,
          renderItem: function renderItem(params, api) {
            var y = api.value(2);
            var start = api.coord([api.value(0), y]);
            var size = api.size([api.value(1) - api.value(0), y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },
          tooltip: { show: false },
          itemStyle: { normal: { color: 'rgba(170,170,170,0.2)' } }
        }, {
          type: 'custom',
          data: this.exercise,
          renderItem: function renderItem(params, api) {
            var y = api.value(2);
            var start = api.coord([api.value(0), y]);
            var size = api.size([api.value(1) - api.value(0), y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + params.value[3] + 'min, ' + params.value[4];
            }
          },
          itemStyle: { normal: { color: '#009bff' }, emphasis: { color: '#009bff' } }
        }, {
          type: 'scatter',
          data: this.carb,
          symbol: 'rect',
          symbolSize: [29, 18],
          itemStyle: { normal: { color: '#00ff4c' }, emphasis: { color: '#00ff4c' } },
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + params.value[1] + 'g';
            }
          }
        }, {
          type: 'scatter',
          name: this.$t('t1222_autoSnack'),
          data: this.autoSnack,
          symbol: 'image://static/legend/automode/零食.png',
          symbolSize: [29, 18],
          symbolOffset: [0, -10],
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);

              return time[0] + ':' + time[1] + ', ' + s_snack;
            }
          }
        }, {
          type: 'scatter',
          name: this.$t('t1222_autoBreakfast'),
          data: this.autoBreakfast,
          symbol: 'image://static/legend/automode/早餐.png',
          symbolSize: [29, 18],
          symbolOffset: [0, -10],
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + s_breakfast;
            }
          }
        }, {
          type: 'scatter',
          name: this.$t('t1222_autoLunch'),
          data: this.autoLunch,
          symbolOffset: [0, -10],
          symbol: 'image://static/legend/automode/中餐.png',
          symbolSize: [29, 18],
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + s_lunch;
            }
          }
        }, {
          type: 'scatter',
          name: this.$t('t1222_autoDinner'),
          data: this.autoDinner,
          symbol: 'image://static/legend/automode/晚餐.png',
          symbolSize: [29, 18],
          symbolOffset: [0, -10],
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + s_dinner;
            }
          }
        }, {
          type: 'scatter',
          name: this.$t('t1222_autoExercise'),
          data: this.autoExercise,
          symbol: 'image://static/legend/automode/运动[30059].png',
          symbolSize: [29, 18],
          symbolOffset: [0, -10],
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);

              return time[0] + ':' + time[1] + ', ' + s_exercise;
            }
          }
        }]
      });
    },
    drawCharts: function drawCharts(i) {
      this.drawChart1_1();
      this.drawChart1_2();
      this.drawChart1_3();
    },
    chartsDispose: function chartsDispose() {
      this.chart1_1.dispose();
      this.chart1_2.dispose();
      this.chart1_3.dispose();
    },
    handleResize: function handleResize() {
      var win = window.innerWidth;
      var scale = win < 1500 ? 0.91 : 0.62;
      var chartWidth = win * scale * 0.98 * 0.96 + 'px';
      var chart1_1 = document.getElementById('chart1_1');
      var chart1_2 = document.getElementById('chart1_2');
      var chart1_3 = document.getElementById('chart1_3');
      if (chart1_3) {
        chart1_1.style.width = chartWidth;
        chart1_2.style.width = chartWidth;
        chart1_3.style.width = chartWidth;
      }
    },
    prev: function prev() {
      var time = this.value1 ? this.value1.getTime() / 1000 : this.st;

      var cur_date = new Date(time * 1000);
      var prev_date = new Date(cur_date.getFullYear(), cur_date.getMonth(), cur_date.getDate() - 1);
      this.value1 = prev_date;
    },
    next: function next(e) {
      var now = new Date().setHours(0, 0, 0, 0) / 1000;
      var time = this.value1 ? this.value1.getTime() / 1000 : this.st;

      var cur_date = new Date(time * 1000);
      var next_date = new Date(cur_date.getFullYear(), cur_date.getMonth(), cur_date.getDate() + 1);
      var next = next_date / 1000;
      if (next > now) {
        e.target.className = 'next';
      } else {
        this.value1 = new Date(next * 1000);
      }
    },
    print: function print() {
      var src1 = this.chart1_1.getDataURL();
      var src2 = this.chart1_2.getDataURL();
      var src3 = this.chart1_3.getDataURL();
      sessionStorage.setItem('src1_1', src1);
      sessionStorage.setItem('src1_2', src2);
      sessionStorage.setItem('src1_3', src3);
      window.open('/#/chart1-print', '_blank');
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.chart1_1) {
      this.chartsDispose();
    }
    this.chart1_1 = null;
    this.chart1_2 = null;
    this.chart1_3 = null;
    this.$store.commit('updateDataSG', []);
    sessionStorage.removeItem('flagg');
  },

  mounted: function mounted() {
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isEs = lang === 'es' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    this.unit = this.isMg ? ' (mg/dL)' : ' (mmol/L)';
    this.glucose_unit = this.isMg ? 'mg/dL' : 'mmol/L';
    this.sgMax = this.isMg ? 400 : 25;

    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }
    if (!sessionStorage.getItem('st')) {
      var et = new Date().setHours(0, 0, 0, 0) / 1000;
      var nd = new Date();
      var cur_day = new Date(nd.getFullYear(), nd.getMonth(), nd.getDate());
      var chart_end_time = sessionStorage.getItem('chart_end_time');

      for (var d = 0; d < 3000; d++) {
        if (et > chart_end_time) {
          cur_day = new Date(cur_day.getFullYear(), cur_day.getMonth(), cur_day.getDate() - 1);

          et = cur_day / 1000;
        } else {
          break;
        }
      }
      this.st = et;
    } else {
      this.st = parseInt(sessionStorage.getItem('st'));
    }
    this.value1 = new Date(this.st * 1000);
    this.et = this.st + 86400;
    sessionStorage.setItem('st', this.st);
    this.time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate4(this.st);
    this.ts = [[this.st, this.et]];
    var param = {
      ts: this.ts,
      tz: parseInt(sessionStorage.getItem('tz')),
      gu: this.isMg ? 'mg/dL' : 'mmol/L'
    };
    param = __WEBPACK_IMPORTED_MODULE_4__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));

    if (!sessionStorage.getItem('flagg')) {
      this.getData();
      sessionStorage.setItem('flagg', 1);
    }

    var that = this;


    window.onresize = function () {
      that.handleResize();
      if (that.chart1_1) {
        that.chart1_1.resize();
        that.chart1_2.resize();
        that.chart1_3.resize();
      }
    };
  }

});

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_base64__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_loading__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_format__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_chartTipFormat__ = __webpack_require__(149);










/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_loading__["a" /* loading */]],
  data: function data() {
    return {
      pump_device: '--',
      isA: false, value2: '', value3: '', uid: 0, st: 0, et: 0, sg: [], basal: [], bolus: [], timeSection: [], staTime: '', endTime: '', timeRange2: '', isMg: '', Select: '',
      mealTime1: [[10, 10, 10], [10, 10, 10], [10, 10, 10], [10, 10, 10], [10, 10, 10], [10, 10, 10], [10, 10, 10]],
      mealTime2: [[10, 10, 10], [10, 10, 10], [10, 10, 10], [10, 10, 10], [10, 10, 10], [10, 10, 10], [10, 10, 10]],
      mealTime3: [[10, 10, 10], [10, 10, 10], [10, 10, 10], [10, 10, 10], [10, 10, 10], [10, 10, 10], [10, 10, 10]], NewBasal: [], isEn: false, ts: [], trans: [], isIt: false, isPo: false,
      sensor_alarm: [], pump_alarm: [], carb: [], exercise: [], calib: [], bg: [], basalMax: 5, bolusMax: 5, timeType: "", isDu: false, isFr: false, isCz: false,
      extend_bolus: [[10, 10, 10, 10, 10], [10, 10, 10, 10, 10], [10, 10, 10, 10, 10], [10, 10, 10, 10, 10], [10, 10, 10, 10, 10], [10, 10, 10, 10, 10], [10, 10, 10, 10, 10]],
      basal_suspend: [], stopBasal: [], manualStop: [], tempBasal: [], typeChooseVisible: false, dialogSize: 'tiny',
      autoModeBasal: [],
      autoModeCorrBolus: [],
      autoBreakfast: [],
      autoLunch: [],
      autoDinner: [],
      autoSnack: [],
      sgChart0: null, sgChart1: null, sgChart2: null, sgChart3: null, sgChart4: null,
      sgChart5: null, sgChart6: null, sgChart7: null, sgChart8: null, sgChart9: null,
      sgChart10: null, sgChart11: null, sgChart12: null, sgChart13: null,
      baChart0: null, baChart1: null, baChart2: null, baChart3: null, baChart4: null,
      baChart5: null, baChart6: null, baChart7: null, baChart8: null, baChart9: null,
      baChart10: null, baChart11: null, baChart12: null, baChart13: null,
      chart2: null, dayNum: 7,
      sgMax: 20,
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          var t1 = time.getTime();
          var d2 = new Date();
          var t2 = d2.getTime();

          return t1 > t2 || t1 < t2 - 730 * 86400 * 1000;
        }
      },
      pickerOptions2: {
        disabledDate: function disabledDate(time) {
          var flag1 = time.getTime() > Date.now(),
              flag2 = true;
          return flag1;
        }
      },
      date: ['', '', '', '', '', ''],
      titleText: 'SG (mmol/L)',
      textStyle: {
        color: '#282828',
        fontWeight: 'normal',
        fontSize: '12',
        fontFamily: 'SFUIText-Regular'
      },
      titlePadding: [12, 0, 0, 35],
      grid2: { x: '8%', y: '5%', width: '87%', height: '60%' },
      yAxisLabel: { interval: 0, margin: 5, textStyle: { color: '#282828', baseline: 'middle' }, showMinLabel: false },
      yAxisLabel2: { show: false }
    };
  },

  computed: {
    DataD: function DataD() {
      return this.$store.state.DataD;
    },
    DataSG: function DataSG() {
      return this.$store.state.DataSG;
    },
    DataBasal: function DataBasal() {
      return this.$store.state.DataBasal;
    },
    DataBolus: function DataBolus() {
      return this.$store.state.DataBolus;
    }
  },
  methods: {
    drawSgChart: function drawSgChart(id, i) {
      var _this = this;

      var that = this;
      this[id] = __WEBPACK_IMPORTED_MODULE_1_echarts__["getInstanceByDom"](document.getElementById(id));
      if (this[id] === undefined) {
        this[id] = __WEBPACK_IMPORTED_MODULE_1_echarts__["init"](document.getElementById(id));
      }
      this.registLoading(id, this[id]);
      this[id].setOption({
        title: {
          textStyle: this.textStyle,
          padding: this.titlePadding
        },
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'line',
            axis: 'x',
            lineStyle: { color: '#333' }
          },
          backgroundColor: '#555',
          textStyle: {
            color: ' #ffffff'
          },
          formatter: function formatter(params) {
            var tip = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterTip1(params, that);
            return tip;
          }
        },
        xAxis: [{
          type: 'time',
          boundaryGap: false,
          min: new Date(this.timeSection[i][0] * 1000),
          max: new Date(this.timeSection[i][1] * 1000),
          axisLabel: { show: false },
          axisLine: { lineStyle: { color: '#ccc' } },
          interval: 3600 * 3000,
          axisPointer: {
            snap: true,
            show: true,
            type: 'line',
            label: {
              show: false
            },
            lineStyle: {
              color: 'black'
            },
            triggerTooltip: true
          }
        }],
        yAxis: [{
          type: 'value',
          min: 0,
          max: this.sgMax,
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          boundaryGap: false,
          splitLine: { show: true },
          axisTick: { length: 0 }
        }],
        grid: this.grid2,
        animation: false,
        series: [{
          type: 'scatter',
          data: this.bg[i],
          name: 'bg',
          symbol: 'image://static/legend/calibrate_1.png',
          symbolSize: 10,
          tooltip: { backgroundColor: '#555',
            trigger: 'item',
            formatter: function formatter(params) {
              var timeDetail = __WEBPACK_IMPORTED_MODULE_6__lib_chartTipFormat__["a" /* default */].getFormatterTip1TimeDetail(params.value[0]);
              var tip = timeDetail + __WEBPACK_IMPORTED_MODULE_6__lib_chartTipFormat__["a" /* default */].bgFormat(params, _this);
              return tip;
            }
          },
          label: {
            show: this.$store.state.glucose_display === 'On',
            color: '#114C9A',
            backgroundColor: '#E7F5F9',
            position: 'top',
            distance: 10,
            fontSize: 12,
            width: 30,
            height: 15,
            borderColor: '#7AACBF'
          },
          emphasis: {
            focus: 'self'
          }
        }, {
          type: 'scatter',
          data: this.calib[i],
          name: 'calib',
          symbol: 'image://static/legend/calib.png',
          symbolSize: 10,
          tooltip: { backgroundColor: '#555',
            formatter: function formatter(params) {
              var timeDetail = __WEBPACK_IMPORTED_MODULE_6__lib_chartTipFormat__["a" /* default */].getFormatterTip1TimeDetail(params.value[0]);
              var tip = timeDetail + __WEBPACK_IMPORTED_MODULE_6__lib_chartTipFormat__["a" /* default */].calibFormat(params, _this);
              return tip;
            }
          },
          label: {
            show: this.$store.state.glucose_display === 'On',
            color: '#114C9A',
            backgroundColor: '#E7F5F9',
            position: 'top',
            distance: 10,
            fontSize: 12,
            width: 30,
            height: 15,
            borderColor: '#7AACBF'
          },
          emphasis: {
            focus: 'self'
          }
        }, {
          type: 'scatter',
          name: 'transmtr',
          data: this.trans[i],
          symbol: 'rect',
          symbolSize: 5,
          itemStyle: { normal: { color: '#00a107' } },
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + 'New Sensor';
            }
          }
        }, {
          name: 'SG',
          type: 'scatter',
          data: this.sg[i],
          markArea: {
            data: [[{ yAxis: this.isMg ? this.DataD.target_low * 18 : this.DataD.target_low }, { yAxis: this.isMg ? this.DataD.target_high * 18 : this.DataD.target_high }]],
            tooltip: { show: false,
              trigger: 'none' },
            itemStyle: {
              normal: {
                color: 'rgba(211,255,213,0.6)'
              }
            }
          },
          markLine: {
            data: [{ yAxis: this.isMg ? this.DataD.hypo * 18 : this.DataD.hypo }],
            symbol: ['circle', 'circle'],
            silent: true,
            symbolSize: 1,
            tooltip: { show: false,
              trigger: 'none' },
            lineStyle: { normal: { color: 'rgba(255,0,0,0.5)', type: 'solid' } },
            label: { normal: { show: false } }
          },
          itemStyle: { normal: {
              color: function color(params) {
                var color = '#2cd200';
                if (params.value[1] < 0.1 && params.value[2] === 'H') {
                  color = '#a4a4a4';
                } else {
                  if (that.isMg) {
                    if (params.value[1] > that.DataD.target_high * 18) {
                      color = '#e6be00';
                    }
                    if (params.value[1] < that.DataD.target_low * 18) {
                      color = '#ff5c5c';
                    }
                  } else {
                    if (params.value[1] > that.DataD.target_high) {
                      color = '#e6be00';
                    }
                    if (params.value[1] < that.DataD.target_low) {
                      color = '#ff5c5c';
                    }
                  }
                }
                var type = params.value[2];
                if (type === 'NC' && params.value[1] == 0 || type === 'DE' || type === 'CE0' || type === 'CE1') {
                  color = 'transparent';
                }
                return color;
              }
            } },
          symbolSize: 2,
          tooltip: { backgroundColor: '#555',
            formatter: function formatter(params) {
              var timeDetail = __WEBPACK_IMPORTED_MODULE_6__lib_chartTipFormat__["a" /* default */].getFormatterTip1TimeDetail(params.value[0]);
              var tip = timeDetail + __WEBPACK_IMPORTED_MODULE_6__lib_chartTipFormat__["a" /* default */].SGFormat(params, _this);
              return tip;
            }
          }
        }, {
          type: 'custom',
          data: this.mealTime1,
          z: -1,
          renderItem: function renderItem(params, api) {
            var y = api.value(2);
            var start = api.coord([api.value(0), y]);
            var size = api.size([api.value(1) - api.value(0), y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },
          tooltip: { show: false,
            trigger: 'none' },
          itemStyle: { normal: { color: 'rgba(170,170,170,0.15)' } }
        }, {
          type: 'custom',
          data: this.mealTime2,
          z: -1,
          renderItem: function renderItem(params, api) {
            var y = api.value(2);
            var start = api.coord([api.value(0), y]);
            var size = api.size([api.value(1) - api.value(0), y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },
          tooltip: { show: false,
            trigger: 'none' },
          itemStyle: { normal: { color: 'rgba(170,170,170,0.15)' } }
        }, {
          type: 'custom',
          data: this.mealTime3,
          z: -1,
          renderItem: function renderItem(params, api) {
            var y = api.value(2);
            var start = api.coord([api.value(0), y]);
            var size = api.size([api.value(1) - api.value(0), y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },
          tooltip: { show: false,
            trigger: 'none' },
          itemStyle: { normal: { color: 'rgba(170,170,170,0.15)' } }
        }]
      });
    },
    drawBasalChart: function drawBasalChart(id, i) {
      var that = this;

      this[id] = __WEBPACK_IMPORTED_MODULE_1_echarts__["init"](document.getElementById(id));
      this.registLoading(id, this[id]);
      this[id].setOption({
        title: [{
          text: this.$t('basal') + ' ' + this.$t('basal_unit'),
          textStyle: this.textStyle,
          padding: this.titlePadding
        }, {
          text: this.$t('bolus') + ' ' + this.$t('ins_unit'),
          textStyle: this.textStyle,
          right: '17',
          top: '7'
        }],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            axis: 'x',
            lineStyle: { color: '#333' }
          },
          backgroundColor: '#555',
          textStyle: {
            color: ' #ffffff'
          },
          formatter: function formatter(params) {
            var tip = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterTip(params, that, 'chart2');
            return tip;
          }
        },
        xAxis: [{
          type: 'time',
          boundaryGap: false,
          min: new Date(this.timeSection[i][0] * 1000),
          max: new Date(this.timeSection[i][1] * 1000),
          axisLabel: {
            showMaxLabel: true,
            interval: 0, margin: 12, textStyle: { color: '#282828', baseline: 'middle' },
            formatter: function formatter(value, index) {
              index = (value - that.timeSection[i][0] * 1000) / (3600000 * 3);
              var H = index * 3;

              if (H < 24) {
                if (H % 3 === 0) {
                  H = H < 10 ? '0' + H + ':00' : H + ':00';
                  return H;
                } else {
                  return ' ';
                }
              } else {
                return '24:00';
              }
            }
          },
          axisLine: { lineStyle: { color: '#ccc' } },

          splitNumber: 8
        }],
        yAxis: [{
          type: 'value',
          boundaryGap: false,
          min: 0,
          max: this.basalMax,
          splitLine: { show: true },
          axisTick: { length: 0 },
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } }
        }, {
          type: 'value',
          boundaryGap: false,
          min: 0,
          max: this.bolusMax,
          axisTick: { length: 0 },
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } }
        }],
        grid: this.grid2,
        animation: false,
        series: [{
          type: 'line',
          name: this.$t('basal'),
          data: this.basal[i],

          itemStyle: { normal: { color: '#00ff40' } },
          symbolSize: 2,
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + params.value[1];
            }
          }
        }, {
          type: 'line',
          name: this.$t('auto suspend'),
          data: this.basal_suspend[i],
          itemStyle: { normal: { color: '#ff0000' } },
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + params.value[2];
            }
          },
          lineStyle: { normal: { type: 'dashed' } },
          symbolSize: 1
        }, {
          type: 'line',
          name: this.$t('tempBasal'),
          data: this.tempBasal[i],
          itemStyle: { normal: { color: '#00ff40' } },
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + 'TempBasal: ' + params.value[1];
            }
          },
          lineStyle: { normal: { type: 'dashed' } },
          symbolSize: 1
        }, {
          type: 'line',
          name: this.$t('manualStop'),
          data: this.manualStop[i],
          itemStyle: { normal: { color: '#ff0000' } },
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + 'Manual Suspend';
            }
          },
          symbolSize: 1
        }, {
          type: 'bar',
          name: this.$t('normalBolus'),
          data: this.bolus[i],
          yAxisIndex: 1,
          itemStyle: { normal: { color: '#182f82' } },
          barWidth: '4',
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + params.value[2] + ': ' + params.value[1] + ins_unit2;
            }
          }
        }, {
          type: 'custom',
          name: this.$t('extendBolus'),
          data: this.extend_bolus[i],
          yAxisIndex: 1,
          renderItem: function renderItem(params, api) {
            var y = api.value(2);
            var start = api.coord([api.value(0), y]);
            var size = api.size([api.value(1) - api.value(0), y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + params.value[4] + ': ' + params.value[2] + ins_unit2 + '/' + params.value[3] + 'min';
            }
          },
          itemStyle: { normal: { color: '#f9b4ff' }, emphasis: { color: '#f9b4ff' } }
        }, {
          type: 'scatter',
          name: this.$t('newPatch'),
          data: this.NewBasal[i],
          symbol: 'image://static/legend/new%20Patch.png',
          symbolSize: 10,
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ',New Patch ';
            }
          }
        }, {
          type: 'scatter',
          name: this.$t('stop'),
          data: this.stopBasal[i],
          symbol: 'image://static/legend/patch%20Deactivated.png',
          symbolSize: 8,
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', Delivery Stop';
            }
          }
        }, {
          type: 'custom',
          name: this.$t('t1222_autoModeBasal'),
          data: this.autoModeBasal[i],
          yAxisIndex: 0,
          renderItem: function renderItem(params, api) {
            var y = api.value(2);
            var start = api.coord([api.value(0), y]);
            var size = api.size([api.value(1) - api.value(0), y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },

          itemStyle: { normal: { color: '#00ff4c' }, emphasis: { color: '#00ff5c' } }
        }, {
          type: 'custom',
          name: this.$t('t1222_autoModeCorrBolus'),
          data: this.autoModeCorrBolus[i],
          yAxisIndex: 1,
          itemStyle: { normal: { color: '#009bff' } },
          renderItem: function renderItem(params, api) {
            console.log('value: ', api.value);
            var y = api.value(2) + api.value(1);
            var start = api.coord([api.value(0), y]);
            var size = api.size([600000, y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },
          barWidth: '4'
        }]
      });
    },
    drawCharts2: function drawCharts2() {
      var that = this;
      this.date.map(function (e, i) {
        var id1 = 'sgChart' + i;
        var id2 = 'baChart' + i;
        that.drawSgChart(id1, i);
        that.drawBasalChart(id2, i);
      });
      var timer = setTimeout(this.makeCarb, 1000);
    },
    chartsDispose2: function chartsDispose2() {
      var dayNum = parseInt(sessionStorage.getItem('dayNum'));
      for (var i = 0; i < dayNum; i++) {
        var id1 = 'sgChart' + i;
        var id2 = 'baChart' + i;
        this[id1].dispose();
        this[id2].dispose();
        this[id1] = null;
        this[id2] = null;
      }
      sessionStorage.setItem('dayNum', this.dayNum);
    },
    makeCarb: function makeCarb() {
      var carbs = this.carb;
      var time = this.timeSection;

      for (var i = 0; i < carbs.length; i++) {
        if (carbs[i].length > 0) {
          for (var j = 0; j < carbs[i].length; j++) {
            var t1 = 0;
            var w = 0;
            t1 = carbs[i][j][0] - time[i][0];
            w = (t1 / 864).toFixed(1) + '%';

            var id = 'carb' + i;
            var OBJ = document.getElementById(id);
            var label = OBJ.getElementsByTagName('label');
            label[j].style.zIndex = 100 + i + j;
            label[j].style.left = w;
          }
        }
      }

      var className = ['breakfast', 'lunch', 'dinner', 'snack'];
      var autoMeal = [this.autoBreakfast, this.autoLunch, this.autoDinner, this.autoSnack];

      for (var _i = 0; _i < className.length; _i++) {

        for (var d = 0; d < autoMeal[_i].length; d++) {
          for (var _j = 0; _j < autoMeal[_i][d].length; _j++) {
            var _t = 0;
            var _w = 0;
            _t = autoMeal[_i][d][_j][0] - time[d][0];
            _w = (_t / 864).toFixed(1) + '%';
            var _id = 'carb' + d;
            var _OBJ = document.getElementById(_id);
            var _label = _OBJ.getElementsByClassName(className[_i]);
            console.log('autoMeal:', _OBJ, _label, className[_i]);
            _label[_j].style.zIndex = 100 + d + _j;
            _label[_j].style.left = _w;
          }
        }
      }
    },
    open: function open() {
      this.staTime = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate4(this.st);
      this.typeChooseVisible = true;

      this.timeType = this.dayNum === 7 ? 1 : 2;
      this.Select = this.dayNum === 7 ? true : false;
    },
    cancel: function cancel() {
      this.typeChooseVisible = false;
    },
    dateApply: function dateApply() {
      if (!this.value3) {
        var t = this.endTime.split('-');
        this.et = new Date(parseInt(t[2]), parseInt(t[1]) - 1, parseInt(t[0])).getTime() / 1000;
      } else {
        this.et = this.value3.getTime() / 1000;
      }

      this.dayNum = this.timeType == 1 ? 7 : 14;
      this.st = this.et - 86400 * (this.dayNum - 1);
      sessionStorage.setItem('st2', this.st);
      sessionStorage.setItem('et2', this.et);
      this.ts = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getTs(this.st, this.et);
      this.typeChooseVisible = false;
      this.getDate();
      this.$emit('reload');
    },
    procTimeRangeSelect: function procTimeRangeSelect(e) {
      var daySpan = 7;
      if (1 == this.timeType) {
        daySpan = 7;
      } else if (2 == this.timeType) {
        daySpan = 14;
      }

      var et = this.value3.getTime() / 1000;

      console.log('daySpan:', daySpan);

      if (daySpan) {
        var st = et - 86400 * (daySpan - 1);
        this.staTime = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate4(st);
      }
    },
    getDate: function getDate() {
      this.date = [];
      for (var i = 0; i < this.dayNum; i++) {
        var day = this.st + i * 86400;

        if (23 == new Date(day * 1000).getHours()) {
          day += 3600;
        }
        var time = this.isEn ? __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate4(day) : __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate3(day);
        var weeks = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDay(this, day);
        this.date[i] = time + ' ' + weeks;
      }
      this.timeRange2 = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate2(this.st) + ' - ' + __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate2(this.st + (this.dayNum - 1) * 86400);
      this.staTime = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate4(this.st);
      this.endTime = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate4(this.et);

      this.value3 = new Date(this.et * 1000);
    },
    print: function print() {
      var src2_1 = [],
          src2_2 = [];
      var dayNum = parseInt(sessionStorage.getItem('dayNum'));
      for (var i = 0; i < dayNum; i++) {
        var id1 = 'sgChart' + i;
        var id2 = 'baChart' + i;
        var src1 = this[id1].getDataURL();
        src2_1.push(src1);
        var src2 = this[id2].getDataURL();
        src2_2.push(src2);
      }
      sessionStorage.setItem('src2_1', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(src2_1));
      sessionStorage.setItem('src2_2', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(src2_2));
      sessionStorage.setItem('date2_2', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.date));
      sessionStorage.setItem('carb2_2', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.carb));
      sessionStorage.setItem('autoBreakfast2_2', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.autoBreakfast));
      sessionStorage.setItem('autoLunch2_2', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.autoLunch));
      sessionStorage.setItem('autoDinner2_2', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.autoDinner));
      sessionStorage.setItem('autoSnack2_2', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.autoSnack));
      sessionStorage.setItem('timeS2_2', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.timeSection));
      sessionStorage.setItem('dd_pump_device', this.pump_device);
      window.open('/#/chart2-print', '_blank');
    },
    handleResize: function handleResize() {
      var win = window.innerWidth;
      var scale = win < 1500 ? 0.91 : 0.62;
      var chartWidth = win * scale * 0.98 * 0.945 * 0.33 + 'px';
      var carbWidth = win * scale * 0.98 * 0.945 * 0.37 * 0.865 + 'px';
      for (var i = 0; i < this.dayNum; i++) {
        var id1 = 'sgChart' + i;
        var id2 = 'baChart' + i;
        var id3 = 'carb' + i;
        var chart1 = document.getElementById(id1);
        var chart2 = document.getElementById(id2);
        var carb = document.getElementById(id3);
        if (chart1) {
          chart1.style.width = chartWidth;
          chart2.style.width = chartWidth;
          carb.style.width = carbWidth;
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.sgChart1) {
      this.chartsDispose2();
    }
    this.sg = [];
    this.basal = [];
  },

  mounted: function mounted() {

    var win = window.innerWidth;
    this.dialogSize = win < 1500 ? 'small' : 'tiny';
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    this.titleText = this.isMg ? this.$t('SG') + ' (mg/dL)' : this.$t('SG') + ' (mmol/L)';
    this.sgMax = this.isMg ? 400 : 25;

    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }

    if (!sessionStorage.getItem('st2')) {
      var nd = new Date();
      var cur_day = new Date(nd.getFullYear(), nd.getMonth(), nd.getDate() - 1);

      this.et = cur_day / 1000;
      var chart_end_time = sessionStorage.getItem('chart_end_time');
      for (var d = 0; d < 3000; d++) {
        if (this.et > chart_end_time) {
          cur_day = new Date(cur_day.getFullYear(), cur_day.getMonth(), cur_day.getDate() - 1);

          this.et = cur_day / 1000;
        } else {
          break;
        }
      }
      this.st = this.et - 86400 * 6;
    } else {
      console.log('st2 init.2:');
      this.st = parseInt(sessionStorage.getItem('st2'));
      this.et = parseInt(sessionStorage.getItem('et2'));
    }
    sessionStorage.setItem('st2', this.st);
    sessionStorage.setItem('et2', this.et);
    this.dayNum = (this.et - this.st) / 86400 + 1;
    sessionStorage.setItem('dayNum', this.dayNum);
    this.getDate();
    this.ts = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getTs(this.st, this.et);

    for (var i = 0; i < this.ts.length; i++) {
      if (23 == new Date(this.ts[i][0] * 1000).getHours()) {
        this.ts[i][0] += 3600;
      }
      if (23 == new Date(this.ts[i][1] * 1000).getHours()) {
        this.ts[i][1] += 3600;
      }
    }
    var param = {
      ts: this.ts,
      tz: parseInt(sessionStorage.getItem('tz'))
    };
    param = __WEBPACK_IMPORTED_MODULE_3__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));

    __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getDd(this, this.uid, param);
    var that = this;


    window.onresize = function () {
      that.handleResize();
      if (that.sgChart0) {
        for (var _i2 = 0; _i2 < that.dayNum; _i2++) {
          var id1 = 'sgChart' + _i2;
          var id2 = 'baChart' + _i2;
          that[id1].resize();
          that[id2].resize();
        }
      }
    };
  }
});

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_base64__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_loading__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_format__ = __webpack_require__(8);









/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_loading__["a" /* loading */]],
  data: function data() {
    return {
      chartWidth: '', timer: false, typeChooseVisible: false, value1: '', isC: false, flag: 0, count: 0, sta: '', end: '', Average: [],
      chart3_1: null, startDate: '', timeRange3: '', defaultDate: '', whichDay: 'Everyday', weekmode: 'yyyyyyy', isMg: '', ts: [], isFr: false,
      legendDate: ['', '', '', '', '', '', ''], Kday: [], DataSG: [], calib: [], bg: [], isEn: false, avg: [], isCz: false,
      show: { A: false, B: false, C: false, D: false, E: false, F: false, G: false }, dialogSize: 'tiny', i: 0, weekModeSp: [], weekM1: false, weekM2: false, isSw: false,
      uid: 0, st: 0, et: 0, startTine: 1505836800000, isDe: false, isIt: false, isPo: false, isDu: false,
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          var t1 = time.getTime();
          var d2 = new Date();
          var t2 = d2.getTime();

          return t1 > t2 || t1 < t2 - 730 * 86400 * 1000;
        }
      },
      textStyle: {
        color: '#282828',
        fontWeight: 'normal',
        fontSize: '14',
        fontFamily: 'SFUIText-Regular'
      },
      titlePadding: [0, 0, 8, 33],
      grid: { x: '3%', y: '4%', width: '94.5%', height: '89%' },
      yAxisLabel: { interval: 0, margin: 5, textStyle: { color: '#282828', baseline: 'middle' }, showMinLabel: false },

      glucose: [[], [], [], [], [], [], [], []], glucoseLength: 7, date: []
    };
  },

  computed: {
    DataS: function DataS() {
      return this.$store.state.DataS;
    }
  },
  methods: {
    getData: function getData() {
      this.ts = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getTs2(this, this.st, this.et);

      this.$emit('reload');
    },
    procTimeRangeSelect: function procTimeRangeSelect(e) {
      var et = this.value1.getTime() / 1000;
      var st = et - 86400 * (7 - 1);
      this.startDate = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate4(st);
    },
    drawChart3_1: function drawChart3_1() {
      var that = this;
      this.chart3_1 = __WEBPACK_IMPORTED_MODULE_1_echarts__["init"](document.getElementById('chart3_1'));
      this.registLoading('chart3_1', this.chart3_1);
      this.chart3_1.setOption({
        title: {
          text: this.isMg ? this.$t('SG') + ' (mg/dL)' : this.$t('SG') + ' (mmol/L)',
          textStyle: this.textStyle,
          padding: this.titlePadding
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            axis: 'x',
            lineStyle: { color: '#333' }
          },
          backgroundColor: '#555',
          textStyle: {
            color: ' #ffffff'
          },
          formatter: function formatter(params) {
            var tip = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterTip3(params, that);
            return tip;
          }
        },
        xAxis: [{
          type: 'time',
          boundaryGap: false,
          min: new Date(this.startTime),
          max: new Date(this.startTime + 8.64e7),
          axisLine: { lineStyle: { color: '#ccc' } },
          splitNumber: 24,
          splieLine: { show: true },
          axisLabel: {
            showMaxLabel: true,
            margin: 15, textStyle: { color: '#282828', baseline: 'middle' },
            formatter: function formatter(value, index) {
              index = (value - that.startTime) / 3600000;
              var H = index;
              if (index < 24) {
                if (index % 3 === 0) {
                  H = H < 10 ? '0' + H + ':00' : H + ':00';
                  return H;
                } else {
                  return ' ';
                }
              } else {
                return '24:00';
              }
            }
          },
          axisPointer: { snap: false }
        }],
        yAxis: [{
          type: 'value',
          min: 0, max: this.isMg ? 400 : 25,
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          boundaryGap: false,
          axisTick: { length: 0 }
        }],
        grid: this.grid,
        animation: false,
        series: [{
          type: 'scatter',
          data: this.DataSG[0],
          markArea: {
            data: [[{ yAxis: this.isMg ? this.DataS.target_low * 18 : this.DataS.target_low }, { yAxis: this.isMg ? this.DataS.target_high * 18 : this.DataS.target_high }]],
            tooltip: { show: false },
            silent: true,
            itemStyle: { normal: { color: 'rgba(211,255,213,0.6)' } }
          },
          markLine: {
            data: [{ yAxis: this.isMg ? this.DataS.hypo * 18 : this.DataS.hypo }],
            symbol: ['circle', 'circle'],
            silent: true,
            symbolSize: 1,
            tooltip: { backgroundColor: '#777', formatter: '' + this.DataS.hypo.toFixed(1) + '', textStyle: { color: '#f00' } },
            lineStyle: { normal: {
                color: 'rgba(255,0,0,0.5)',
                type: 'solid'
              } },
            label: { normal: { show: false } }
          },
          itemStyle: { normal: { color: '#3ce8dc' } },
          tooltip: { backgroundColor: '#777',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate5(date);
              if (params.value[1] > 0) {
                if (params.value[2] === 'CX' || params.value[2] === 'NC') {
                  return time[0] + ':' + time[1] + ', ' + params.value[1] + '<hr style="width: 20px;background:#000;height:1px;border:none;margin-left: 42px;">';
                }
                return time[0] + ':' + time[1] + ', ' + params.value[1];
              } else {
                if (params.value[2] === 'NC') {
                  return time[0] + ':' + time[1] + ', Not Calibrated';
                }
                if (params.value[2] === 'DE') {
                  return time[0] + ':' + time[1] + ', No Readings';
                }
                if (params.value[2] === 'CE0' || params.value[2] === 'CE1') {
                  return time[0] + ':' + time[1] + ',Calib Error';
                }
                return time[0] + ':' + time[1] + ', warm up';
              }
            },
            textStyle: { color: '#3ce8dc' }
          },
          symbolSize: 3
        }, {
          type: 'scatter',
          data: this.DataSG[1],
          itemStyle: { normal: { color: '#2842d2' } },
          tooltip: { backgroundColor: '#777',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate5(date);
              if (params.value[1] > 0) {
                if (params.value[2] === 'CX' || params.value[2] === 'NC') {
                  return time[0] + ':' + time[1] + ', ' + params.value[1] + '<hr style="width: 20px;background:#000;height:1px;border:none;margin-left: 42px;">';
                }
                return time[0] + ':' + time[1] + ', ' + params.value[1];
              } else {
                if (params.value[2] === 'NC') {
                  return time[0] + ':' + time[1] + ', Not Calibrated';
                }
                if (params.value[2] === 'DE') {
                  return time[0] + ':' + time[1] + ', No Readings';
                }
                if (params.value[2] === 'CE0' || params.value[2] === 'CE1') {
                  return time[0] + ':' + time[1] + ',Calib Error';
                }
                return time[0] + ':' + time[1] + ', warm up';
              }
            },
            textStyle: { color: '#2842d2' }
          },
          symbolSize: 3
        }, {
          type: 'scatter',
          data: this.DataSG[2],
          itemStyle: { normal: { color: '#79bd39' } },
          tooltip: { backgroundColor: '#777',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate5(date);
              if (params.value[1] > 0) {
                if (params.value[2] === 'CX' || params.value[2] === 'NC') {
                  return time[0] + ':' + time[1] + ', ' + params.value[1] + '<hr style="width: 20px;background:#000;height:1px;border:none;margin-left: 42px;">';
                }
                return time[0] + ':' + time[1] + ', ' + params.value[1];
              } else {
                if (params.value[2] === 'NC') {
                  return time[0] + ':' + time[1] + ', Not Calibrated';
                }
                if (params.value[2] === 'DE') {
                  return time[0] + ':' + time[1] + ', No Readings';
                }
                if (params.value[2] === 'CE0' || params.value[2] === 'CE1') {
                  return time[0] + ':' + time[1] + ',Calib Error';
                }
                return time[0] + ':' + time[1] + ', warm up';
              }
            },
            textStyle: { color: '#79bd39' }
          },
          symbolSize: 3
        }, {
          type: 'scatter',
          data: this.DataSG[3],
          itemStyle: { normal: { color: '#dce573' } },
          tooltip: { backgroundColor: '#777',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate5(date);
              if (params.value[1] > 0) {
                if (params.value[2] === 'CX' || params.value[2] === 'NC') {
                  return time[0] + ':' + time[1] + ', ' + params.value[1] + '<hr style="width: 20px;background:#000;height:1px;border:none;margin-left: 42px;">';
                }
                return time[0] + ':' + time[1] + ', ' + params.value[1];
              } else {
                if (params.value[2] === 'NC') {
                  return time[0] + ':' + time[1] + ', Not Calibrated';
                }
                if (params.value[2] === 'DE') {
                  return time[0] + ':' + time[1] + ', No Readings';
                }
                if (params.value[2] === 'CE0' || params.value[2] === 'CE1') {
                  return time[0] + ':' + time[1] + ',Calib Error';
                }
                return time[0] + ':' + time[1] + ', warm up';
              }
            },
            textStyle: { color: '#dce573' }
          },
          symbolSize: 3
        }, {
          type: 'scatter',
          data: this.DataSG[4],
          itemStyle: { normal: { color: '#e61795' } },
          tooltip: { backgroundColor: '#777',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate5(date);
              if (params.value[1] > 0) {
                if (params.value[2] === 'CX' || params.value[2] === 'NC') {
                  return time[0] + ':' + time[1] + ', ' + params.value[1] + '<hr style="width: 20px;background:#000;height:1px;border:none;margin-left: 42px;">';
                }
                return time[0] + ':' + time[1] + ', ' + params.value[1];
              } else {
                if (params.value[2] === 'NC') {
                  return time[0] + ':' + time[1] + ', Not Calibrated';
                }
                if (params.value[2] === 'DE') {
                  return time[0] + ':' + time[1] + ', No Readings';
                }
                if (params.value[2] === 'CE0' || params.value[2] === 'CE1') {
                  return time[0] + ':' + time[1] + ',Calib Error';
                }
                return time[0] + ':' + time[1] + ', warm up';
              }
            },
            textStyle: { color: '#e61795' }
          },
          symbolSize: 3
        }, {
          type: 'scatter',
          data: this.DataSG[5],
          itemStyle: { normal: { color: '#c9711e' } },
          tooltip: { backgroundColor: '#777',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate5(date);
              if (params.value[1] > 0) {
                if (params.value[2] === 'CX' || params.value[2] === 'NC') {
                  return time[0] + ':' + time[1] + ', ' + params.value[1] + '<hr style="width: 20px;background:#000;height:1px;border:none;margin-left: 42px;">';
                }
                return time[0] + ':' + time[1] + ', ' + params.value[1];
              } else {
                if (params.value[2] === 'NC') {
                  return time[0] + ':' + time[1] + ', Not Calibrated';
                }
                if (params.value[2] === 'DE') {
                  return time[0] + ':' + time[1] + ', No Readings';
                }
                if (params.value[2] === 'CE0' || params.value[2] === 'CE1') {
                  return time[0] + ':' + time[1] + ',Calib Error';
                }
                return time[0] + ':' + time[1] + ', warm up';
              }
            },
            textStyle: { color: '#c9711e' }
          },
          symbolSize: 3
        }, {
          type: 'scatter',
          data: this.DataSG[6],
          itemStyle: { normal: { color: '#a922d9' } },
          tooltip: { backgroundColor: '#777',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate5(date);
              if (params.value[1] > 0) {
                if (params.value[2] === 'CX' || params.value[2] === 'NC') {
                  return time[0] + ':' + time[1] + ', ' + params.value[1] + '<hr style="width: 20px;background:#000;height:1px;border:none;margin-left: 42px;">';
                }
                return time[0] + ':' + time[1] + ', ' + params.value[1];
              } else {
                if (params.value[2] === 'NC') {
                  return time[0] + ':' + time[1] + ', Not Calibrated';
                }
                if (params.value[2] === 'DE') {
                  return time[0] + ':' + time[1] + ', No Readings';
                }
                if (params.value[2] === 'CE0' || params.value[2] === 'CE1') {
                  return time[0] + ':' + time[1] + ',Calib Error';
                }
                return time[0] + ':' + time[1] + ', warm up';
              }
            },
            textStyle: { color: '#a922d9' }
          },
          symbolSize: 3
        }, {
          type: 'scatter',
          data: this.avg,
          itemStyle: { normal: { color: '#464646' } },
          tooltip: { backgroundColor: '#777',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate5(date);
              if (params.value[1] > 0) {
                if (params.value[2] === 'CX') {
                  return time[0] + ':' + time[1] + ', ' + params.value[1] + '<hr style="width: 17px;background:#000;height:1px;border:none;margin-left: 42px;">';
                }
                return time[0] + ':' + time[1] + ', ' + params.value[1];
              } else {
                if (params.value[2] === 'NC') {
                  return time[0] + ':' + time[1] + ', Not Calibrated';
                }
                if (params.value[2] === 'DE') {
                  return time[0] + ':' + time[1] + ', No Readings';
                }
                if (params.value[2] === 'CE0' || params.value[2] === 'CE1') {
                  return time[0] + ':' + time[1] + ',Calib Error';
                }
                return time[0] + ':' + time[1] + ', warm up';
              }
            },
            textStyle: { color: '#fff' }
          },
          symbolSize: 3
        }, {
          type: 'scatter',
          data: this.calib,
          symbol: 'image://static/legend/calib.png',
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate5(date);
              return params.value[2] + ' ' + time[0] + ':' + time[1] + ',Calibration  ' + params.value[1];
            }
          }
        }, {
          type: 'scatter',
          data: this.bg,
          symbol: 'image://static/legend/calibrate_1.png',
          symbolSize: [10, 20],
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate5(date);
              return params.value[2] + ' ' + time[0] + ':' + time[1] + ',BG ' + params.value[1];
            }
          }
        }]
      }, false, true);
    },
    handleResize: function handleResize() {
      var win = window.innerWidth;
      var scale = win < 1500 ? 0.91 : 0.62;
      var chartWidth = win * scale * 0.98 * 0.94 + 'px';
      var chart3_1 = document.getElementById('chart3_1');
      if (chart3_1) {
        chart3_1.style.width = chartWidth;
      }
    },
    cancel: function cancel() {
      this.typeChooseVisible = false;
    },
    choose: function choose(e) {
      var parent = e.target.parentNode.parentNode;
      var labels = parent.getElementsByTagName('label');
      if (e.target.className === '') {
        e.target.className = 'no';
        labels[0].className = 'no';
      } else {
        e.target.className = '';
        for (var i = 1; i < labels.length; i++) {
          if (labels[i].className === '') {
            this.count++;
          }
        }
        if (this.count === labels.length - 1) {
          labels[0].className = '';
        }
        this.count = 0;
      }
    },
    chooseAll: function chooseAll(e) {
      var parent = e.target.parentNode.parentNode;
      var labels = parent.getElementsByTagName('label');
      this.flag = labels[0].className === 'no' ? 1 : 0;
      for (var i = 0; i < labels.length; i++) {
        if (this.flag === 0) {
          labels[i].className = 'no';
        } else {
          labels[i].className = '';
        }
      }
    },
    open: function open() {
      this.typeChooseVisible = true;
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].checkWeekMode(this);
      this.$nextTick(this.initWeeks);
    },
    initWeeks: function initWeeks() {
      var weeks = document.getElementById('weeks');
      var weken = document.getElementById('weken');
      var labels1 = weeks.getElementsByTagName('label');
      var labels2 = weken.getElementsByTagName('label');
      labels1[0].className = this.weekM1 ? 'no' : '';
      labels2[0].className = this.weekM2 ? 'no' : '';
      for (var i = 1; i < labels1.length; i++) {
        labels1[i].className = this.weekModeSp[i - 1] ? 'no' : '';
      }
      for (var _i = 1; _i < labels2.length; _i++) {
        labels2[_i].className = this.weekModeSp[_i + 4] ? 'no' : '';
      }
    },
    dateApply: function dateApply() {
      this.end = this.value1;
      if (this.end === '') {
        var t = this.defaultDate.split('-');
        this.end = new Date(parseInt(t[2]), parseInt(t[1]) - 1, parseInt(t[0])).getTime() / 1000;
        this.sta = this.end - 3600 * 24 * 6;
      } else {
        this.end = new Date(this.end).getTime() / 1000;
        this.sta = this.end - 3600 * 24 * 6;
      }
      var weekmode = this.checkDate();

      if (weekmode !== 'nnnnnnn') {
        this.weekmode = weekmode;
        this.st = this.sta;
        this.et = this.end;
        this.startTime = this.st * 1000;
        this.sta = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate2(this.sta);
        this.end = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate2(this.end);
        this.timeRange3 = this.sta + '-' + this.end + ', ' + this.$t(this.whichDay);
        this.formatterSelect(this.sta, this.end);
        sessionStorage.setItem('st3', this.st);
        sessionStorage.setItem('et3', this.et);
        sessionStorage.setItem('week3', this.weekmode);
        sessionStorage.setItem('timeRange3', this.timeRange3);
        this.getData();
      }
      this.typeChooseVisible = false;
    },
    checkDate: function checkDate() {
      var weeks = document.getElementById('weeks');
      var weken = document.getElementById('weken');
      if (weeks) {
        var labels1 = weeks.getElementsByTagName('label');
        var labels2 = weken.getElementsByTagName('label');
        var weekmode = '';
        if (labels1[0].className === '' && labels2[0].className === '') {
          this.whichDay = 'Everyday';weekmode = 'yyyyyyy';
        } else {
          this.whichDay = ' ';weekmode = '';
          for (var i = 1; i < labels1.length; i++) {
            if (labels1[i].className === '') {
              this.whichDay = this.whichDay + ' ' + labels1[i].innerHTML + '.';
              weekmode = weekmode + 'y';
            } else {
              weekmode = weekmode + 'n';
            }
          }
          for (var _i2 = 1; _i2 < labels2.length; _i2++) {
            if (labels2[_i2].className === '') {
              this.whichDay = this.whichDay + ' ' + labels2[_i2].innerHTML + '.';
              weekmode = weekmode + 'y';
            } else {
              weekmode = weekmode + 'n';
            }
          }
        }
        return weekmode;
      }
    },
    init: function init() {
      this.sta = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate2(this.st);
      this.end = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate2(this.et);
      this.formatterSelect(this.sta, this.end);
    },
    formatterSelect: function formatterSelect(st, et) {
      st = st.split('/');
      et = et.split('/');
      this.startDate = st[0] + '-' + st[1] + '-' + st[2];
      this.defaultDate = et[0] + '-' + et[1] + '-' + et[2];
    },
    checkLegend: function checkLegend() {
      var legendTime = this.DataSG;
      this.legendDate = [];
      this.show = { A: false, B: false, C: false, D: false, E: false, F: false, G: false };
      for (var i = 0; i < legendTime.length; i++) {
        if (legendTime[i]) {
          var time = legendTime[i][0][0];
          time = new Date(time);
          var y1 = time.getFullYear();
          var m1 = time.getMonth() + 1;
          var d1 = time.getDate();
          d1 = d1 + this.Kday[i];

          if ((m1 === 1 || m1 === 3 || m1 === 5 || m1 === 7 || m1 === 8 || m1 === 10 || m1 === 12) && d1 > 31) {
            d1 = d1 - 31;
            m1 = m1 + 1;
          }
          if ((m1 === 4 || m1 === 6 || m1 === 9 || m1 === 11) && d1 > 30) {
            d1 = d1 - 30;
            m1 = m1 + 1;
          }
          if (m1 === 2 && d1 > 29) {
            d1 = d1 - 29;
            m1 = m1 + 1;
          }
          if (m1 > 12) {
            m1 = m1 - 12;
            y1 = y1 + 1;
          }
          m1 = m1 < 10 ? '0' + m1 : m1;
          d1 = d1 < 10 ? '0' + d1 : d1;

          this.legendDate[i] = d1 + '-' + m1 + '-' + y1;
        }
      }

      if (this.legendDate[0]) {
        this.show.A = true;
      }
      if (this.legendDate[1]) {
        this.show.B = true;
      }
      if (this.legendDate[2]) {
        this.show.C = true;
      }
      if (this.legendDate[3]) {
        this.show.D = true;
      }
      if (this.legendDate[4]) {
        this.show.E = true;
      }
      if (this.legendDate[5]) {
        this.show.F = true;
      }
      if (this.legendDate[6]) {
        this.show.G = true;
      }
    },
    getAverage: function getAverage(SG) {
      var length = SG.length;
      var average = new Array(720);
      if (length > 0) {
        for (var j = 0; j < 720; j++) {
          average[j] = new Array(2);
          average[j][0] = parseInt(this.startTime / 1000) + j * 120;
          average[j][1] = 0;
          var num = 0;
          for (var i = 0; i < length; i++) {
            for (var k = 0; k < 720; k++) {
              if (SG[i][k]) {
                var t = SG[i][k][0].getTime() / 1000;
                var mt = t - average[j][0];
                if (mt <= 120 && mt >= 0) {
                  average[j][1] = average[j][1] + SG[i][k][1];
                  num++;
                }
              }
            }
          }
          average[j][0] = new Date(average[j][0] * 1000);
          average[j][1] = (average[j][1] / num).toFixed(1);
        }
        this.avg = average;
      }
    },
    getOlReportInfo: function getOlReportInfo(report_data) {
      var data = report_data;
      data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
      this.statics = data;
      this.devices = data.devices ? data.devices : this.devices;
      this.hb1c = data.hba1c ? data.hba1c : this.hb1c;
      this.glucose = data.sg_stat ? data.sg_stat : this.glucose;

      sessionStorage.setItem('ol_report_data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(report_data));
    },
    print: function print() {
      var src1 = this.chart3_1.getDataURL();
      sessionStorage.setItem('st3', this.st);
      sessionStorage.setItem('et3', this.et);
      sessionStorage.setItem('week3', this.weekmode);
      sessionStorage.setItem('timeRange3', this.timeRange3);
      sessionStorage.setItem('src3_1', src1);
      sessionStorage.setItem('legendDate3', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.legendDate));
      window.open('/#/chart3-print', '_blank');
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.chart3_1.dispose();
    this.chart3_1 = null;
    this.DataSG = [];
  },

  mounted: function mounted() {
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isSw = lang === 'sw' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;

    if (!sessionStorage.getItem('st3')) {
      var nd = new Date();
      var cur_day = new Date(nd.getFullYear(), nd.getMonth(), nd.getDate() - 1);
      this.et = cur_day / 1000;

      var chart_end_time = sessionStorage.getItem('chart_end_time');
      for (var d = 0; d < 3000; d++) {
        if (this.et > chart_end_time) {
          cur_day = new Date(cur_day.getFullYear(), cur_day.getMonth(), cur_day.getDate() - 1);
          this.et = cur_day / 1000;
        } else {
          break;
        }
      }
      this.st = this.et - 86400 * 6;
      this.weekmode = 'yyyyyyy';
      this.timeRange3 = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate2(this.st) + '-' + __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate2(this.et) + ', ' + this.$t(this.whichDay);
    } else {
      this.st = parseInt(sessionStorage.getItem('st3'));
      this.et = parseInt(sessionStorage.getItem('et3'));
      this.weekmode = sessionStorage.getItem('week3');

      this.timeRange3 = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate2(this.st) + '-' + __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate2(this.et) + ', ' + this.$t(this.whichDay);
    }
    this.value1 = new Date(this.et * 1000);
    this.init();
    this.ts = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getTs2(this, this.st, this.et);
    var param = {
      ts: this.ts,
      tz: parseInt(sessionStorage.getItem('tz')),
      weekmode: this.weekmode,
      gu: this.isMg ? 'mg/dL' : 'mmol/L'
    };
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }
    param = __WEBPACK_IMPORTED_MODULE_3__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));

    var length = this.ts.length;
    this.glucoseLength = length;

    for (var i = 0; i < length; i++) {
      var t = __WEBPACK_IMPORTED_MODULE_5__lib_format__["a" /* default */].formatterDate9(this.ts[i][0]);
      t[1] = t[1] + 1;
      t[1] = t[1] < 10 ? '0' + t[1] : t[1];
      t[2] = t[2] < 10 ? '0' + t[2] : t[2];
      this.date[i] = t[2] + '-' + t[1] + '-' + t[0];
    }

    __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getOl(this, this.uid, param);
    var win = window.innerWidth;
    this.dialogSize = win < 1500 ? 'small' : 'tiny';
    var that = this;

    window.onresize = function () {
      that.handleResize();
      if (that.chart3_1) {
        that.chart3_1.resize();
      }
    };
  }
});

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_format__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth_base64__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth_dataTool__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_loading__ = __webpack_require__(77);











/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_loading__["a" /* loading */]],
  data: function data() {
    return {
      TaData1: [], TaData2: [], TaData3: [], xDate: [], xDate2: [], sgMax: 20, value2: '', value1: '', dayNum: 0, dayNum2: 0, isMg: '', ts: [], interval: '',
      chartWidth: '', timer: false, typeChooseVisible: false, isC: false, flag: 0, count: 0, sta: '', end: '', Average: [], days: '', isSw: false,
      chart4_1: null, chart4_2: null, chart4_3: null, chart4_4: null, weekModeSp: [], weekM1: false, weekM2: false, isDe: false, isIt: false, isPo: false, isDu: false,
      startDate: '', timeRange: '', defaultDate: '', whichDay: 'Everyday', weekmode: 'yyyyyyy', isEn: false,
      uid: 0, st: 0, et: 0, basalMax: 25, bgMax: 10, dialogSize: 'small', isFr: false, isCz: false, timeRangeSelect: 1, timeIntervalSelect: 1,
      intervalOption: [[1, this.$t('Day')]],
      chartNameList: ['chart4_1', 'chart4_2', 'chart4_3', 'chart4_4'],

      intervalOptionSave: [],
      timeIntervalSelectSave: 1,
      timeRangeSelectSave: 1,

      startDateEditable: false,
      startDateDisable: true,
      date: [true, true, true, true, true, true, true],
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          var t1 = time.getTime();
          var d2 = new Date();
          var t2 = d2.getTime();

          return t1 > t2 || t1 < t2 - 730 * 86400 * 1000;
        }
      },
      textStyle: {
        color: '#282828',
        fontWeight: 'normal',
        fontSize: '14',
        fontFamily: 'SFUIText-Regular'
      },
      titlePadding: [0, 0, 8, 33],
      grid: { x: '3%', y: '15%', width: '94.5%', height: '70%' },
      yAxisLabel: { interval: 0, margin: 5, textStyle: { color: '#282828', baseline: 'middle' }, showMinLabel: false },
      xLabel: ['18-07-2017', '19-07-2017', '20-07-2017', '21-07-2017', '22-07-2017', '23-07-2017', '24-07-2017', '25-07-2017', '26-07-2017', '27-07-2017', '28-07-2017', '29-07-2017', '30-07-2017', '31-07-2017'],

      glucose: [],
      glucoseDefault: [{
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--', "bg_hypo_num": '--', "bg_lp": '--', "bg_tp": '--', "bg_up": '--', "bg_low_num": '--',
        "bg_num": '--', "bg_sd": '--', "sg_aucl": "--", "sg_aucu": "--", "sg_avg": "--", "sg_cv": "--", "sg_iqr": "--", "sg_lp": "--",
        "sg_lpr": "--", "sg_max": "--", "sg_median": "--", "sg_min": "--", "sg_mpr": "--", "sg_nl": "--", "sg_nu": "--", "sg_q1": "--",
        "sg_q3": "--", "sg_sd": "--", "sg_sdr": "--", "sg_se": "--", "sg_spr": "--", "sg_tp": "--", "sg_up": "--"
      }, {
        "bg_avg": '--', "bg_hypo_num": '--', "bg_lp": '--', "bg_tp": '--', "bg_up": '--', "bg_low_num": '--',
        "bg_num": '--', "bg_sd": '--', "sg_aucl": "--", "sg_aucu": "--", "sg_avg": "--", "sg_cv": "--", "sg_iqr": "--", "sg_lp": "--",
        "sg_lpr": "--", "sg_max": "--", "sg_median": "--", "sg_min": "--", "sg_mpr": "--", "sg_nl": "--", "sg_nu": "--", "sg_q1": "--",
        "sg_q3": "--", "sg_sd": "--", "sg_sdr": "--", "sg_se": "--", "sg_spr": "--", "sg_tp": "--", "sg_up": "--"
      }, {
        "bg_avg": '--', "bg_hypo_num": '--', "bg_lp": '--', "bg_tp": '--', "bg_up": '--', "bg_low_num": '--',
        "bg_num": '--', "bg_sd": '--', "sg_aucl": "--", "sg_aucu": "--", "sg_avg": "--", "sg_cv": "--", "sg_iqr": "--", "sg_lp": "--",
        "sg_lpr": "--", "sg_max": "--", "sg_median": "--", "sg_min": "--", "sg_mpr": "--", "sg_nl": "--", "sg_nu": "--", "sg_q1": "--",
        "sg_q3": "--", "sg_sd": "--", "sg_sdr": "--", "sg_se": "--", "sg_spr": "--", "sg_tp": "--", "sg_up": "--"
      }, {
        "bg_avg": '--', "bg_hypo_num": '--', "bg_lp": '--', "bg_tp": '--', "bg_up": '--', "bg_low_num": '--',
        "bg_num": '--', "bg_sd": '--', "sg_aucl": "--", "sg_aucu": "--", "sg_avg": "--", "sg_cv": "--", "sg_iqr": "--", "sg_lp": "--",
        "sg_lpr": "--", "sg_max": "--", "sg_median": "--", "sg_min": "--", "sg_mpr": "--", "sg_nl": "--", "sg_nu": "--", "sg_q1": "--",
        "sg_q3": "--", "sg_sd": "--", "sg_sdr": "--", "sg_se": "--", "sg_spr": "--", "sg_tp": "--", "sg_up": "--"
      }, {
        "bg_avg": '--', "bg_hypo_num": '--', "bg_lp": '--', "bg_tp": '--', "bg_up": '--', "bg_low_num": '--',
        "bg_num": '--', "bg_sd": '--', "sg_aucl": "--", "sg_aucu": "--", "sg_avg": "--", "sg_cv": "--", "sg_iqr": "--", "sg_lp": "--",
        "sg_lpr": "--", "sg_max": "--", "sg_median": "--", "sg_min": "--", "sg_mpr": "--", "sg_nl": "--", "sg_nu": "--", "sg_q1": "--",
        "sg_q3": "--", "sg_sd": "--", "sg_sdr": "--", "sg_se": "--", "sg_spr": "--", "sg_tp": "--", "sg_up": "--"
      }, {
        "bg_avg": '--', "bg_hypo_num": '--', "bg_lp": '--', "bg_tp": '--', "bg_up": '--', "bg_low_num": '--',
        "bg_num": '--', "bg_sd": '--', "sg_aucl": "--", "sg_aucu": "--", "sg_avg": "--", "sg_cv": "--", "sg_iqr": "--", "sg_lp": "--",
        "sg_lpr": "--", "sg_max": "--", "sg_median": "--", "sg_min": "--", "sg_mpr": "--", "sg_nl": "--", "sg_nu": "--", "sg_q1": "--",
        "sg_q3": "--", "sg_sd": "--", "sg_sdr": "--", "sg_se": "--", "sg_spr": "--", "sg_tp": "--", "sg_up": "--"
      }, {
        "bg_avg": '--', "bg_hypo_num": '--', "bg_lp": '--', "bg_tp": '--', "bg_up": '--', "bg_low_num": '--',
        "bg_num": '--', "bg_sd": '--', "sg_aucl": "--", "sg_aucu": "--", "sg_avg": "--", "sg_cv": "--", "sg_iqr": "--", "sg_lp": "--",
        "sg_lpr": "--", "sg_max": "--", "sg_median": "--", "sg_min": "--", "sg_mpr": "--", "sg_nl": "--", "sg_nu": "--", "sg_q1": "--",
        "sg_q3": "--", "sg_sd": "--", "sg_sdr": "--", "sg_se": "--", "sg_spr": "--", "sg_tp": "--", "sg_up": "--"
      }, {
        "bg_avg": '--', "bg_hypo_num": '--', "bg_lp": '--', "bg_tp": '--', "bg_up": '--', "bg_low_num": '--',
        "bg_num": '--', "bg_sd": '--', "sg_aucl": "--", "sg_aucu": "--", "sg_avg": "--", "sg_cv": "--", "sg_iqr": "--", "sg_lp": "--",
        "sg_lpr": "--", "sg_max": "--", "sg_median": "--", "sg_min": "--", "sg_mpr": "--", "sg_nl": "--", "sg_nu": "--", "sg_q1": "--",
        "sg_q3": "--", "sg_sd": "--", "sg_sdr": "--", "sg_se": "--", "sg_spr": "--", "sg_tp": "--", "sg_up": "--"
      }, {
        "bg_avg": '--', "bg_hypo_num": '--', "bg_lp": '--', "bg_tp": '--', "bg_up": '--', "bg_low_num": '--',
        "bg_num": '--', "bg_sd": '--', "sg_aucl": "--", "sg_aucu": "--", "sg_avg": "--", "sg_cv": "--", "sg_iqr": "--", "sg_lp": "--",
        "sg_lpr": "--", "sg_max": "--", "sg_median": "--", "sg_min": "--", "sg_mpr": "--", "sg_nl": "--", "sg_nu": "--", "sg_q1": "--",
        "sg_q3": "--", "sg_sd": "--", "sg_sdr": "--", "sg_se": "--", "sg_spr": "--", "sg_tp": "--", "sg_up": "--"
      }, {
        "bg_avg": '--', "bg_hypo_num": '--', "bg_lp": '--', "bg_tp": '--', "bg_up": '--', "bg_low_num": '--',
        "bg_num": '--', "bg_sd": '--', "sg_aucl": "--", "sg_aucu": "--", "sg_avg": "--", "sg_cv": "--", "sg_iqr": "--", "sg_lp": "--",
        "sg_lpr": "--", "sg_max": "--", "sg_median": "--", "sg_min": "--", "sg_mpr": "--", "sg_nl": "--", "sg_nu": "--", "sg_q1": "--",
        "sg_q3": "--", "sg_sd": "--", "sg_sdr": "--", "sg_se": "--", "sg_spr": "--", "sg_tp": "--", "sg_up": "--"
      }, {
        "bg_avg": '--', "bg_hypo_num": '--', "bg_lp": '--', "bg_tp": '--', "bg_up": '--', "bg_low_num": '--',
        "bg_num": '--', "bg_sd": '--', "sg_aucl": "--", "sg_aucu": "--", "sg_avg": "--", "sg_cv": "--", "sg_iqr": "--", "sg_lp": "--",
        "sg_lpr": "--", "sg_max": "--", "sg_median": "--", "sg_min": "--", "sg_mpr": "--", "sg_nl": "--", "sg_nu": "--", "sg_q1": "--",
        "sg_q3": "--", "sg_sd": "--", "sg_sdr": "--", "sg_se": "--", "sg_spr": "--", "sg_tp": "--", "sg_up": "--"
      }, {
        "bg_avg": '--', "bg_hypo_num": '--', "bg_lp": '--', "bg_tp": '--', "bg_up": '--', "bg_low_num": '--',
        "bg_num": '--', "bg_sd": '--', "sg_aucl": "--", "sg_aucu": "--", "sg_avg": "--", "sg_cv": "--", "sg_iqr": "--", "sg_lp": "--",
        "sg_lpr": "--", "sg_max": "--", "sg_median": "--", "sg_min": "--", "sg_mpr": "--", "sg_nl": "--", "sg_nu": "--", "sg_q1": "--",
        "sg_q3": "--", "sg_sd": "--", "sg_sdr": "--", "sg_se": "--", "sg_spr": "--", "sg_tp": "--", "sg_up": "--"
      }, {
        "bg_avg": '--', "bg_hypo_num": '--', "bg_lp": '--', "bg_tp": '--', "bg_up": '--', "bg_low_num": '--',
        "bg_num": '--', "bg_sd": '--', "sg_aucl": "--", "sg_aucu": "--", "sg_avg": "--", "sg_cv": "--", "sg_iqr": "--", "sg_lp": "--",
        "sg_lpr": "--", "sg_max": "--", "sg_median": "--", "sg_min": "--", "sg_mpr": "--", "sg_nl": "--", "sg_nu": "--", "sg_q1": "--",
        "sg_q3": "--", "sg_sd": "--", "sg_sdr": "--", "sg_se": "--", "sg_spr": "--", "sg_tp": "--", "sg_up": "--"
      }, {
        "bg_avg": '--', "bg_hypo_num": '--', "bg_lp": '--', "bg_tp": '--', "bg_up": '--', "bg_low_num": '--',
        "bg_num": '--', "bg_sd": '--', "sg_aucl": "--", "sg_aucu": "--", "sg_avg": "--", "sg_cv": "--", "sg_iqr": "--", "sg_lp": "--",
        "sg_lpr": "--", "sg_max": "--", "sg_median": "--", "sg_min": "--", "sg_mpr": "--", "sg_nl": "--", "sg_nu": "--", "sg_q1": "--",
        "sg_q3": "--", "sg_sd": "--", "sg_sdr": "--", "sg_se": "--", "sg_spr": "--", "sg_tp": "--", "sg_up": "--"
      }, {
        "bg_avg": '--', "bg_hypo_num": '--', "bg_lp": '--', "bg_tp": '--', "bg_up": '--', "bg_low_num": '--',
        "bg_num": '--', "bg_sd": '--', "sg_aucl": "--", "sg_aucu": "--", "sg_avg": "--", "sg_cv": "--", "sg_iqr": "--", "sg_lp": "--",
        "sg_lpr": "--", "sg_max": "--", "sg_median": "--", "sg_min": "--", "sg_mpr": "--", "sg_nl": "--", "sg_nu": "--", "sg_q1": "--",
        "sg_q3": "--", "sg_sd": "--", "sg_sdr": "--", "sg_se": "--", "sg_spr": "--", "sg_tp": "--", "sg_up": "--"
      }, {
        "bg_avg": '--', "bg_hypo_num": '--', "bg_lp": '--', "bg_tp": '--', "bg_up": '--', "bg_low_num": '--',
        "bg_num": '--', "bg_sd": '--', "sg_aucl": "--", "sg_aucu": "--", "sg_avg": "--", "sg_cv": "--", "sg_iqr": "--", "sg_lp": "--",
        "sg_lpr": "--", "sg_max": "--", "sg_median": "--", "sg_min": "--", "sg_mpr": "--", "sg_nl": "--", "sg_nu": "--", "sg_q1": "--",
        "sg_q3": "--", "sg_sd": "--", "sg_sdr": "--", "sg_se": "--", "sg_spr": "--", "sg_tp": "--", "sg_up": "--"
      }],
      event: [],
      eventDefault: [{
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--', "carb_num": '--', "exer_num": '--', "exer_time": '--',
        "ins_basal": '--', "ins_bolus": '--', "ins_bolus_avg": "--", "ins_bolus_n": '--',
        "ins_bolus_p": "--", "ins_total": '--', "other": "--"
      }, {
        "carb_gram": '--', "carb_num": '--', "exer_num": '--', "exer_time": '--',
        "ins_basal": '--', "ins_bolus": '--', "ins_bolus_avg": "--", "ins_bolus_n": '--',
        "ins_bolus_p": "--", "ins_total": '--', "other": "--"
      }, {
        "carb_gram": '--', "carb_num": '--', "exer_num": '--', "exer_time": '--',
        "ins_basal": '--', "ins_bolus": '--', "ins_bolus_avg": "--", "ins_bolus_n": '--',
        "ins_bolus_p": "--", "ins_total": '--', "other": "--"
      }, {
        "carb_gram": '--', "carb_num": '--', "exer_num": '--', "exer_time": '--',
        "ins_basal": '--', "ins_bolus": '--', "ins_bolus_avg": "--", "ins_bolus_n": '--',
        "ins_bolus_p": "--", "ins_total": '--', "other": "--"
      }, {
        "carb_gram": '--', "carb_num": '--', "exer_num": '--', "exer_time": '--',
        "ins_basal": '--', "ins_bolus": '--', "ins_bolus_avg": "--", "ins_bolus_n": '--',
        "ins_bolus_p": "--", "ins_total": '--', "other": "--"
      }, {
        "carb_gram": '--', "carb_num": '--', "exer_num": '--', "exer_time": '--',
        "ins_basal": '--', "ins_bolus": '--', "ins_bolus_avg": "--", "ins_bolus_n": '--',
        "ins_bolus_p": "--", "ins_total": '--', "other": "--"
      }, {
        "carb_gram": '--', "carb_num": '--', "exer_num": '--', "exer_time": '--',
        "ins_basal": '--', "ins_bolus": '--', "ins_bolus_avg": "--", "ins_bolus_n": '--',
        "ins_bolus_p": "--", "ins_total": '--', "other": "--"
      }, {
        "carb_gram": '--', "carb_num": '--', "exer_num": '--', "exer_time": '--',
        "ins_basal": '--', "ins_bolus": '--', "ins_bolus_avg": "--", "ins_bolus_n": '--',
        "ins_bolus_p": "--", "ins_total": '--', "other": "--"
      }, {
        "carb_gram": '--', "carb_num": '--', "exer_num": '--', "exer_time": '--',
        "ins_basal": '--', "ins_bolus": '--', "ins_bolus_avg": "--", "ins_bolus_n": '--',
        "ins_bolus_p": "--", "ins_total": '--', "other": "--"
      }, {
        "carb_gram": '--', "carb_num": '--', "exer_num": '--', "exer_time": '--',
        "ins_basal": '--', "ins_bolus": '--', "ins_bolus_avg": "--", "ins_bolus_n": '--',
        "ins_bolus_p": "--", "ins_total": '--', "other": "--"
      }, {
        "carb_gram": '--', "carb_num": '--', "exer_num": '--', "exer_time": '--',
        "ins_basal": '--', "ins_bolus": '--', "ins_bolus_avg": "--", "ins_bolus_n": '--',
        "ins_bolus_p": "--", "ins_total": '--', "other": "--"
      }, {
        "carb_gram": '--', "carb_num": '--', "exer_num": '--', "exer_time": '--',
        "ins_basal": '--', "ins_bolus": '--', "ins_bolus_avg": "--", "ins_bolus_n": '--',
        "ins_bolus_p": "--", "ins_total": '--', "other": "--"
      }, {
        "carb_gram": '--', "carb_num": '--', "exer_num": '--', "exer_time": '--',
        "ins_basal": '--', "ins_bolus": '--', "ins_bolus_avg": "--", "ins_bolus_n": '--',
        "ins_bolus_p": "--", "ins_total": '--', "other": "--"
      }, {
        "carb_gram": '--', "carb_num": '--', "exer_num": '--', "exer_time": '--',
        "ins_basal": '--', "ins_bolus": '--', "ins_bolus_avg": "--", "ins_bolus_n": '--',
        "ins_bolus_p": "--", "ins_total": '--', "other": "--"
      }, {
        "carb_gram": '--', "carb_num": '--', "exer_num": '--', "exer_time": '--',
        "ins_basal": '--', "ins_bolus": '--', "ins_bolus_avg": "--", "ins_bolus_n": '--',
        "ins_bolus_p": "--", "ins_total": '--', "other": "--"
      }, {
        "carb_gram": '--', "carb_num": '--', "exer_num": '--', "exer_time": '--',
        "ins_basal": '--', "ins_bolus": '--', "ins_bolus_avg": "--", "ins_bolus_n": '--',
        "ins_bolus_p": "--", "ins_total": '--', "other": "--"
      }]
    };
  },

  computed: {
    DataS: function DataS() {
      return this.$store.state.DataS;
    }
  },
  methods: {
    getData: function getData() {
      this.glucose = this.glucoseDefault;
      this.event = this.eventDefault;


      this.ts = this.getTs2(this, this.st, this.et);

      var param = {
        ts: this.ts,
        interval: this.interval,
        tz: parseInt(sessionStorage.getItem('tz')),
        weekmode: this.weekmode,
        gu: this.isMg ? 'mg/dL' : 'mmol/L'
      };

      param = __WEBPACK_IMPORTED_MODULE_5__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(param));
      __WEBPACK_IMPORTED_MODULE_3__auth_auth__["a" /* default */].getTa(this, this.uid, param);
    },
    procTimeRangeSelect: function procTimeRangeSelect(e) {
      console.log('procTimeRangeSelect:', this.timeRangeSelect);
      var daySpan = 0;
      if (1 == this.timeRangeSelect) {
        this.intervalOption = [[1, this.$t('Day')]];
        this.timeIntervalSelect = 1;
        daySpan = 7;
      } else if (2 == this.timeRangeSelect) {
        this.intervalOption = [[1, this.$t('Day')], [2, this.$t('Week')]];
        this.timeIntervalSelect = 1;
        daySpan = 14;
      } else if (3 == this.timeRangeSelect || 4 == this.timeRangeSelect) {
        this.intervalOption = [[2, this.$t('Week')], [3, this.$t('Month2')]];
        this.timeIntervalSelect = 2;
        daySpan = 30;
        if (4 == this.timeRangeSelect) {
          daySpan = 90;
        }
      }

      console.log('daySpan:', daySpan);
      if (daySpan) {
        var st = this.et - 86400 * (daySpan - 1);
        this.startDate = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate4(st);
        this.value2 = new Date(st * 1000);
      }
      if (0 == this.timeRangeSelect) {
        this.startDateDisable = false;
      } else {
        this.startDateDisable = true;
      }
      console.log('startDateDisable:', this.startDateDisable);
    },
    procTimeIntervalSelect: function procTimeIntervalSelect(e) {
      console.log('procTimeIntervalSelect:', this.timeIntervalSelect);
    },
    drawChart4_1: function drawChart4_1() {
      var id = 'chart4_1';
      var that = this;

      var textTitle = '';
      if (this) {
        textTitle = this.isMg ? this.$t('sensorGlu') + ' (mg/dL)' : this.$t('sensorGlu') + ' (mmol/L)';
      }
      this.chart4_1 = __WEBPACK_IMPORTED_MODULE_2_echarts__["init"](document.getElementById(id));
      this.registLoading(id, this.chart4_1);
      this.chart4_1.setOption({
        title: {
          text: textTitle,
          textStyle: this.textStyle,
          padding: this.titlePadding
        },
        tooltip: {
          backgroundColor: '#555',
          textStyle: {
            color: '#ffffff'
          },
          formatter: function formatter(params) {
            var index = params.seriesIndex,
                name = params.name,
                tip = '',
                value = params.value,
                seriesName = params.seriesName;
            var icon = " <div style='background: #0095ff;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
            if (index === 0) {
              var tip1 = seriesName + ' ' + that.$t('min') + ' : ' + value[1] + '<br>';
              var tip2 = seriesName + ' ' + that.$t('Q11') + ' : ' + value[2] + '<br>';
              var tip3 = seriesName + ' ' + that.$t('med') + ' : ' + value[3] + '<br>';
              var tip4 = seriesName + ' ' + that.$t('Q31') + ' : ' + value[4] + '<br>';
              var tip5 = seriesName + ' ' + that.$t('max') + ' : ' + value[5] + '<br>';
              tip = icon + name + '<br>' + tip5 + tip4 + tip3 + tip2 + tip1;
            }
            if (index === 1) {}
            return tip;
          }
        },
        xAxis: [{
          data: this.xDate,
          axisLine: { lineStyle: { color: '#ccc' } },
          splitLine: { show: true, interval: 0 },
          axisLabel: { margin: 15, interval: 0, textStyle: { color: '#282828', baseline: 'middle' },
            xx_formatter: function xx_formatter(value, index) {
              console.log("value.index:", value, index);
              return '112';
            }
          }

        }],
        yAxis: [{
          type: 'value',
          min: 0, max: this.isMg ? 400 : 25,
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          boundaryGap: false,
          axisTick: { length: 0 }
        }],
        grid: this.grid,
        series: [{
          type: 'boxplot',
          data: this.TaData3[1],
          hoverAnimation: false,
          boxWidth: ['10%', '15%'],
          itemStyle: { normal: { borderColor: '#0095ff' } }
        }, {
          name: this.$t('med'),
          type: 'line',
          data: this.TaData3[0],
          itemStyle: { normal: {
              color: 'transparent',
              borderColor: '#0095ff',
              borderWidth: 1
            } },
          lineStyle: { normal: {
              color: '#e89b00',
              width: 1
            } },
          symbol: 'diamond',
          symbolSize: 5
        }]
      });
    },
    drawChart4_2: function drawChart4_2() {
      var id = 'chart4_2';
      this.chart4_2 = __WEBPACK_IMPORTED_MODULE_2_echarts__["init"](document.getElementById(id));
      this.chart4_2.setOption({
        title: {
          text: this.$t('insulin') + ' ' + this.$t('ins_unit'),
          textStyle: this.textStyle,
          padding: this.titlePadding
        },
        tooltip: {},
        xAxis: [{
          data: this.xDate,
          axisLine: { lineStyle: { color: '#ccc' } },
          splitLine: { show: true, interval: 0 },
          splitNumber: 14,
          axisLabel: {
            margin: 15, interval: 0, textStyle: { color: '#282828', baseline: 'middle' }
          }
        }],
        yAxis: [{
          type: 'value',
          min: 0,
          max: this.basalMax,
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          boundaryGap: false,
          axisTick: { length: 0 }
        }],
        grid: this.grid,
        legend: {
          itemWidth: 11,
          itemHeight: 11,
          right: 35,
          data: [{ name: this.$t('basal'), icon: 'rect' }, { name: this.$t('bolus'), icon: 'rect' }]
        },
        series: [{
          name: this.$t('basal'),
          type: 'bar',
          data: this.TaData2[0],
          barWidth: '32%',
          itemStyle: { normal: { color: '#75e28a' } }
        }, {
          name: this.$t('bolus'),
          type: 'bar',
          data: this.TaData2[1],
          barWidth: '32%',
          itemStyle: { normal: { color: '#4e86f4' } }
        }]
      });
    },
    drawChart4_3: function drawChart4_3() {
      var id = 'chart4_3';
      this.chart4_3 = __WEBPACK_IMPORTED_MODULE_2_echarts__["init"](document.getElementById('chart4_3'));
      this.chart4_3.setOption({
        title: {
          text: this.$t('sensorGlu') + ' (%)',
          textStyle: this.textStyle,
          padding: this.titlePadding
        },
        tooltip: {},
        xAxis: [{
          data: this.xDate,
          axisLine: { lineStyle: { color: '#ccc' } },
          splitLine: { show: true, interval: 0 },
          splitNumber: 14,
          axisLabel: {
            margin: 15, interval: 0, textStyle: { color: '#282828', baseline: 'middle' }
          }
        }],
        yAxis: [{
          type: 'value',
          min: 0, max: 100,
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          boundaryGap: false,
          axisTick: { length: 0 }
        }],
        grid: this.grid,
        legend: {
          itemWidth: 11,
          itemHeight: 11,
          right: 33,
          data: [{ name: this.$t('target'), icon: 'rect' }, { name: this.$t('low'), icon: 'rect' }, { name: this.$t('high'), icon: 'rect' }]
        },
        series: [{
          name: this.$t('target'),
          type: 'bar',
          data: this.TaData1[1][0],
          barWidth: '25%',
          itemStyle: { normal: {
              color: '#63d644'
            } }
        }, {
          name: this.$t('low'),
          type: 'bar',
          data: this.TaData1[1][1],
          barWidth: '25%',
          itemStyle: { normal: {
              color: '#ff5c5c'
            } }
        }, {
          name: this.$t('high'),
          type: 'bar',
          data: this.TaData1[1][2],
          barWidth: '25%',
          itemStyle: { normal: {
              color: '#ffd71d'
            } }
        }]
      });
    },
    drawChart4_4: function drawChart4_4() {
      var id = 'chart4_4';
      this.chart4_4 = __WEBPACK_IMPORTED_MODULE_2_echarts__["init"](document.getElementById('chart4_4'));
      this.chart4_4.setOption({
        title: {
          text: this.$t('ofBGtest'),
          textStyle: this.textStyle,
          padding: this.titlePadding
        },
        tooltip: {},
        xAxis: [{
          data: this.xDate,
          axisLine: { lineStyle: { color: '#ccc' } },
          splitLine: { show: true, interval: 0 },
          splitNumber: 14,
          axisLabel: {
            margin: 15, interval: 0, textStyle: { color: '#282828', baseline: 'middle' }
          }
        }],
        yAxis: [{
          type: 'value',
          min: 0, max: this.bgMax,
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          boundaryGap: false,
          axisTick: { length: 0 }
        }],
        grid: this.grid,
        legend: {
          itemWidth: 11,
          itemHeight: 11,
          right: 33,
          data: [{ name: this.$t('target'), icon: 'rect' }, { name: this.$t('low'), icon: 'rect' }, { name: this.$t('high'), icon: 'rect' }]
        },
        series: [{
          name: this.$t('target'),
          type: 'bar',
          data: this.TaData1[0][0],
          barWidth: '25%',
          itemStyle: { normal: {
              color: '#63d644'
            } }
        }, {
          name: this.$t('low'),
          type: 'bar',
          data: this.TaData1[0][1],
          barWidth: '25%',
          itemStyle: { normal: {
              color: '#ff5c5c'
            } }
        }, {
          name: this.$t('high'),
          type: 'bar',
          data: this.TaData1[0][2],
          barWidth: '25%',
          itemStyle: { normal: {
              color: '#ffd71d'
            } }
        }]
      });
    },
    getTaReportInfo: function getTaReportInfo(report_data) {
      sessionStorage.setItem('ta_report_data', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(report_data));
      var data = report_data;

      data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
      this.statics = data;
      this.devices = data.devices ? data.devices : this.devices;
      this.hb1c = data.hba1c ? data.hba1c : this.hb1c;
      this.glucose = data.glucose_stat ? data.glucose_stat : this.glucose;
      this.glucose.map(function (e, i) {
        if (e.bg_up !== '--') {
          e.bg_up = e.bg_up.toFixed(1);
        }
        if (e.bg_tp !== '--') {
          e.bg_tp = e.bg_tp.toFixed(1);
        }
        if (e.bg_lp !== '--') {
          e.bg_lp = e.bg_lp.toFixed(1);
        }
      });
      this.dayNum = this.glucose.length - 1;
      this.event = data.insulin_and_event_stat ? data.insulin_and_event_stat : this.event;
    },
    drwCharts: function drwCharts() {
      this.drawChart4_1();
      this.drawChart4_2();
    },
    chartsDispose: function chartsDispose() {
      if (this.chart4_3) {
        this.chart4_1.dispose();
        this.chart4_2.dispose();
      }
    },
    handleResize: function handleResize() {
      var win = window.innerWidth;
      var scale = win < 1500 ? 0.91 : 0.62;
      var chartWidth = win * scale * 0.98 * 0.94 + 'px';
      var chart4_1 = document.getElementById('chart4_1');
      var chart4_2 = document.getElementById('chart4_2');

      if (chart4_1) {
        chart4_1.style.width = chartWidth;chart4_2.style.width = chartWidth;
      }
    },
    cancel: function cancel() {
      this.typeChooseVisible = false;
    },
    choose: function choose(e) {
      var parent = e.target.parentNode.parentNode;
      var labels = parent.getElementsByTagName('label');
      if (e.target.className === '') {
        e.target.className = 'no';
        labels[0].className = 'no';
      } else {
        e.target.className = '';
        for (var i = 1; i < labels.length; i++) {
          if (labels[i].className === '') {
            this.count++;
          }
        }
        if (this.count === labels.length - 1) {
          labels[0].className = '';
        }
        this.count = 0;
      }
    },
    chooseAll: function chooseAll(e) {
      var parent = e.target.parentNode.parentNode;
      var labels = parent.getElementsByTagName('label');
      this.flag = labels[0].className === 'no' ? 1 : 0;
      for (var i = 0; i < labels.length; i++) {
        if (this.flag === 0) {
          labels[i].className = 'no';
        } else {
          labels[i].className = '';
        }
      }
    },
    open: function open() {
      this.value2 = new Date(this.st * 1000);
      this.value1 = new Date(this.et * 1000);
      this.timeRangeSelect = this.timeRangeSelectSave;
      this.timeIntervalSelect = this.timeIntervalSelectSave;
      this.intervalOption = this.intervalOptionSave.concat();
      if (0 == this.timeRangeSelect) {
        this.startDateDisable = false;
      } else {
        this.startDateDisable = true;
      }
      console.log('intervalOption:', this.intervalOption);

      this.typeChooseVisible = true;
      __WEBPACK_IMPORTED_MODULE_3__auth_auth__["a" /* default */].checkWeekMode(this);
      this.$nextTick(this.initWeeks);
    },
    initWeeks: function initWeeks() {
      var weeks = document.getElementById('weeks');
      var weken = document.getElementById('weken');
      var labels1 = weeks.getElementsByTagName('label');
      var labels2 = weken.getElementsByTagName('label');
      labels1[0].className = this.weekM1 ? 'no' : '';
      labels2[0].className = this.weekM2 ? 'no' : '';
      for (var i = 1; i < labels1.length; i++) {
        labels1[i].className = this.weekModeSp[i - 1] ? 'no' : '';
      }
      for (var _i = 1; _i < labels2.length; _i++) {
        labels2[_i].className = this.weekModeSp[_i + 4] ? 'no' : '';
      }
    },
    dateApply: function dateApply() {
      this.dateChange();
      if (this.dayNum2 > 90) {
        var tip = this.$t('dateErr1');
        this.$message.error(tip);
      } else if (this.dayNum2 < 1) {
        var _tip = this.$t('dateErr2');
        this.$message.error(_tip);
      } else {
        var weekmode = this.checkDate();
        if (weekmode === 'nnnnnnn') {
          this.$message({
            type: 'warning',
            message: 'The date should be 1 or more day !'
          });
        } else {
          this.startDate = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate4(this.st);
          this.defaultDate = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate4(this.et);
          var st = this.startDate.split('-');
          var et = this.defaultDate.split('-');
          this.weekmode = weekmode;
          sessionStorage.setItem('st4', this.st);
          sessionStorage.setItem('et4', this.et);
          this.whichDay = this.weekmode === 'yyyyyyy' ? ' Everyday' : this.whichDay;
          this.timeRange = st[0] + '/' + st[1] + '/' + st[2] + ' - ' + et[0] + '/' + et[1] + '/' + et[2] + ', ' + this.$t(this.whichDay);
          sessionStorage.setItem('week4', this.weekmode);
          sessionStorage.setItem('timeRange4', this.timeRange);
          sessionStorage.setItem('timeRangeSelect4', this.timeRangeSelect);
          sessionStorage.setItem('timeIntervalSelect4', this.timeIntervalSelect);
          this.typeChooseVisible = false;

          sessionStorage.setItem('st7', this.st);
          sessionStorage.setItem('et7', this.et);
          sessionStorage.setItem('timeRangeSelect7', this.timeRangeSelect);

          sessionStorage.setItem('st8', this.st);
          sessionStorage.setItem('et8', this.et);
          sessionStorage.setItem('timeRangeSelect8', this.timeRangeSelect);

          var daySpan = (this.et - this.st) / 86400 + 1;
          var st2 = this.et - 86400 * (7 - 1);
          if (daySpan > 7) {
            st2 = this.et - 86400 * (14 - 1);
          }
          sessionStorage.setItem('st2', st2);
          sessionStorage.setItem('et2', this.et);

          var st3 = this.et - 86400 * (7 - 1);
          sessionStorage.setItem('st3', st3);
          sessionStorage.setItem('et3', this.et);
          if (!sessionStorage.getItem('week3')) {
            sessionStorage.setItem('week3', 'yyyyyyy');
          }

          var st5 = this.et - 86400 * (7 - 1);
          if (daySpan > 7) {
            st5 = this.et - 86400 * (14 - 1);
          }
          sessionStorage.setItem('st5', st5);
          sessionStorage.setItem('et5', this.et);
          if (!sessionStorage.getItem('week5')) {
            sessionStorage.setItem('week5', 'yyyyyyy');
          }

          this.$emit('reload');
        }
      }
    },
    dateChange: function dateChange() {
      if (this.value2 && this.value1) {
        this.et = this.value1.getTime() / 1000;
        this.st = this.value2.getTime() / 1000;
      } else if (!this.value2 && this.value1) {
        this.et = this.value1.getTime() / 1000;
        var t = this.startDate.split('-');
        this.st = new Date(parseInt(t[2]), parseInt(t[1]) - 1, parseInt(t[0])).getTime() / 1000;
      } else if (!this.value1 && this.value2) {
        this.st = this.value2.getTime() / 1000;
        var _t = this.defaultDate.split('-');
        this.et = new Date(parseInt(_t[2]), parseInt(_t[1]) - 1, parseInt(_t[0])).getTime() / 1000;
      }
      this.dayNum2 = parseInt((this.et - this.st) / 86400 + 1);

      this.timeRangeSelectSave = this.timeRangeSelect;
      this.timeIntervalSelectSave = this.timeIntervalSelect;
      this.intervalOptionSave = this.intervalOption.concat();
    },
    startDateChange: function startDateChange() {
      var st = this.value2.getTime() / 1000;
      var daySpan = 0;
      if (1 == this.timeRangeSelect) {
        daySpan = 7;
      } else if (2 == this.timeRangeSelect) {
        daySpan = 14;
      } else if (3 == this.timeRangeSelet) {
        daySpan = 30;
      } else if (4 == this.timeRangeSelect) {
        daySpan = 90;
      }
      if (daySpan) {
        var et = st + 86400 * (daySpan - 1);
        this.value1 = new Date(et * 1000);
        this.defaultDate = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate4(et);
      } else {
        if (st > this.et) {
          this.$message.error("Start date bigger than end date.");
          this.value2 = new Date(this.st * 1000);
        } else {
          daySpan = (this.et - st) / 86400 + 1;
          console.log('startDateChange:', daySpan);
          if (daySpan >= 30) {
            this.intervalOption = [[2, this.$t('Week')], [3, this.$t('Month2')]];
            this.timeIntervalSelect = 2;
          } else if (daySpan >= 14) {
            this.intervalOption = [[1, this.$t('Day')], [2, this.$t('Week')]];
            this.timeIntervalSelect = 1;
          } else {
            this.intervalOption = [[1, this.$t('Day')]];
            this.timeIntervalSelect = 1;
          }
        }
      }
    },
    endDateChange: function endDateChange() {
      var endDate = this.value1;
      var et = endDate.getTime() / 1000;
      var daySpan = 0;
      if (1 == this.timeRangeSelect) {
        daySpan = 7;
      } else if (2 == this.timeRangeSelect) {
        daySpan = 14;
      } else if (3 == this.timeRangeSelet) {
        daySpan = 30;
      } else if (4 == this.timeRangeSelect) {
        daySpan = 90;
      }
      if (daySpan) {
        var st = et - 86400 * (daySpan - 1);
        this.value2 = new Date(st * 1000);
        this.startDate = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate4(st);
      } else {
        this.st = this.value2.getTime() / 1000;
        if (et < this.st) {
          this.$message.error("End date less than start date.");
          this.value1 = new Date(this.et * 1000);
        } else {
          daySpan = (et - this.st) / 86400 + 1;
          console.log('endDateChange:', daySpan);
          if (daySpan >= 30) {
            this.intervalOption = [[2, this.$t('Week')], [3, this.$t('Month2')]];
            this.timeIntervalSelect = 2;
          } else if (daySpan >= 14) {
            this.intervalOption = [[1, this.$t('Day')], [2, this.$t('Week')]];
            this.timeIntervalSelect = 1;
          } else {
            this.intervalOption = [[1, this.$t('Day')]];
            this.timeIntervalSelect = 1;
          }
        }
      }
    },
    checkDate: function checkDate() {
      var weeks = document.getElementById('weeks');
      var weken = document.getElementById('weken');
      if (weeks) {
        var labels1 = weeks.getElementsByTagName('label');
        var labels2 = weken.getElementsByTagName('label');
        var weekmode = '';
        if (labels1[0].className === '' && labels2[0].className === '') {
          this.whichDay = 'Everyday';weekmode = 'yyyyyyy';
        } else {
          this.whichDay = ' ';weekmode = '';
          for (var i = 1; i < labels1.length; i++) {
            if (labels1[i].className === '') {
              this.whichDay = this.whichDay + ' ' + labels1[i].innerHTML + '.';
              weekmode = weekmode + 'y';
            } else {
              weekmode = weekmode + 'n';
            }
          }
          for (var _i2 = 1; _i2 < labels2.length; _i2++) {
            if (labels2[_i2].className === '') {
              this.whichDay = this.whichDay + ' ' + labels2[_i2].innerHTML + '.';
              weekmode = weekmode + 'y';
            } else {
              weekmode = weekmode + 'n';
            }
          }
        }
        return weekmode;
      }
    },
    print: function print() {
      var src1 = this.chart4_1.getDataURL();
      var src2 = this.chart4_2.getDataURL();
      sessionStorage.setItem('src4_1', src1);
      sessionStorage.setItem('src4_2', src2);
      sessionStorage.setItem('xDate4', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.xDate2));
      sessionStorage.setItem('xTs4', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.ts));
      window.open('/#/chart4-print', '_blank');
    },
    getTs2: function getTs2(context, st, et) {
      console.log('getTs2.1:', context.weekmode);
      var ts = [];this.xDate = [];
      this.days = (et - st) / 86400 + 1;
      var No = __WEBPACK_IMPORTED_MODULE_3__auth_auth__["a" /* default */].chekcNoDate(context.weekmode);
      var star = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate9(st);
      var starDate = new Date(star[0], star[1], star[2]);

      if (1 == this.timeIntervalSelect) {
        var k = 0;
        for (var i = 0; i < this.days; i++) {
          starDate = new Date(star[0], star[1], star[2]);
          var d = star[2] + i;
          var now = starDate.setDate(d);
          var day = new Date(now).getDay();
          if (No.indexOf(day) === -1) {
            ts[k] = [];
            ts[k][0] = new Date(now).getTime() / 1000;

            starDate = new Date(star[0], star[1], star[2]);
            ts[k][1] = new Date(starDate.setDate(d + 1)).getTime() / 1000;

            this.xDate[k] = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate4_1(ts[k][0]);
            k++;
          }
        }
        this.interval = 'd';
      } else if (2 == this.timeIntervalSelect) {
          for (var _i3 = 0; _i3 < this.days; _i3++) {
            var week = Math.floor(_i3 / 7);
            ts[week] = [];
          }

          var _k = 0;
          for (var _i4 = 0; _i4 < this.days; _i4++) {
            var _week = Math.floor(_i4 / 7);
            if (_i4 > 0 && Math.floor(_i4 / 7) !== Math.floor((_i4 - 1) / 7)) {
              _k = 0;
            }
            starDate = new Date(star[0], star[1], star[2]);
            var _d = star[2] + _i4;
            var _now = starDate.setDate(_d);
            var _day = new Date(_now).getDay();
            if (No.indexOf(_day) === -1) {
              ts[_week][_k] = [];
              ts[_week][_k][0] = new Date(_now).getTime() / 1000;
              starDate = new Date(star[0], star[1], star[2]);
              ts[_week][_k][1] = new Date(starDate.setDate(_d + 1)).getTime() / 1000;
              _k++;
            }
          }

          var length1 = ts.length,
              m = 0;
          for (var _i5 = 0; _i5 < length1; _i5++) {
            var length2 = ts[_i5].length;
            if (length2 === 0) {
              ts.splice(_i5, 1);
              continue;
            } else {
              var sta = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate8(ts[_i5][0][0]);
              var end = '';
              if (length2 > 1) {
                end = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate8(ts[_i5][length2 - 1][0]);
              } else {
                end = sta;
              }
              this.xDate[m] = sta + '-' + end;
              m++;
            }
          }
          this.interval = 'w';
        } else {
          for (var _i6 = 0; _i6 < this.days; _i6++) {
            starDate = new Date(star[0], star[1], star[2]);
            var _d2 = star[2] + _i6;
            var _m2 = new Date(starDate.setDate(_d2)).getMonth();
            var month = _m2 - star[1];
            ts[month] = [];
            starDate = new Date(star[0], star[1], star[2]);
          }
          var _k2 = 0;
          for (var _i7 = 0; _i7 < this.days; _i7++) {
            starDate = new Date(star[0], star[1], star[2]);
            var _d3 = star[2] + _i7;
            var _now2 = starDate.setDate(_d3);
            var _m3 = new Date(_now2).getMonth();
            var _month = _m3 - star[1];
            starDate = new Date(star[0], star[1], star[2]);

            if (_i7 > 0 && new Date(_now2).getMonth() !== new Date(starDate.setDate(_d3 - 1)).getMonth()) {
              _k2 = 0;
            }
            var _day2 = new Date(_now2).getDay();
            if (No.indexOf(_day2) === -1) {
              ts[_month][_k2] = [];
              ts[_month][_k2][0] = new Date(_now2).getTime() / 1000;

              starDate = new Date(star[0], star[1], star[2]);
              ts[_month][_k2][1] = new Date(starDate.setDate(_d3 + 1)).getTime() / 1000;
              _k2++;
            }
          }

          var _length = ts.length,
              _m = 0;
          for (var _i8 = 0; _i8 < _length; _i8++) {
            var _length2 = ts[_i8].length;
            if (_length2 === 0) {
              ts.splice(_i8, 1);
              continue;
            } else {
              var _sta = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate8(ts[_i8][0][0]);
              var _end = '';
              if (_length2 > 1) {
                _end = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate8(ts[_i8][_length2 - 1][0]);
              } else {
                _end = _sta;
              }
              this.xDate[_i8] = _sta + '-' + _end;
            }
          }
          this.interval = 'm';
        }

      this.xDate2 = this.xDate;
      return ts;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.chartsDispose();
  },

  created: function created() {
    var strGlucose = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.glucoseDefault);
    var strEvent = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.eventDefault);
    this.glucose = JSON.parse(strGlucose);
    this.event = JSON.parse(strEvent);
  },
  mounted: function mounted() {
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isSw = lang === 'sw' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }
    console.log('st4:', sessionStorage.getItem('st4'));
    if (!sessionStorage.getItem('st4')) {
      var nd = new Date();
      var cur_day = new Date(nd.getFullYear(), nd.getMonth(), nd.getDate() - 1);
      this.et = cur_day / 1000;
      var chart_end_time = sessionStorage.getItem('chart_end_time');
      for (var d = 0; d < 3000; d++) {
        if (this.et > chart_end_time) {
          cur_day = new Date(cur_day.getFullYear(), cur_day.getMonth(), cur_day.getDate() - 1);
          this.et = cur_day / 1000;
        } else {
          break;
        }
      }
      this.st = this.et - 86400 * 6;
      this.weekmode = 'yyyyyyy';
      this.timeRange = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate2(this.st) + '-' + __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate2(this.et) + ', ' + this.$t(this.whichDay);
    } else {
      this.st = parseInt(sessionStorage.getItem('st4'));
      this.et = parseInt(sessionStorage.getItem('et4'));
      this.weekmode = sessionStorage.getItem('week4');
      this.timeRange = sessionStorage.getItem('timeRange4');
      this.timeRangeSelect = sessionStorage.getItem('timeRangeSelect4');
      this.timeIntervalSelect = sessionStorage.getItem('timeIntervalSelect4');

      console.log('timeRangeSelect.1:', this.timeRangeSelect, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.timeRangeSelect), this.weekmode, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.weekmode), this.timeIntervalSelect, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.timeIntervalSelect));

      if ('null' == this.timeRangeSelect || 'NaN' == this.timeRangeSelect || !this.timeRangeSelect) {
        this.timeRangeSelect = 1;
      }

      console.log('weekmode.1:', this.weekmode, this.weekmode === null, !this.weekmode, '' + this.weekmode == 'null', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.weekmode));
      if ('null' == this.weekmode || !this.weekmode) {
        this.weekmode = 'yyyyyyy';
        console.log('weekmode.2:');
      }

      if ('null' == this.timeIntervalSelect || 'NaN' == this.timeIntervalSelect || !this.timeIntervalSelect) {
        this.timeIntervalSelect = 1;
      } else {
        this.timeIntervalSelect = parseInt(this.timeIntervalSelect);
        if (this.timeIntervalSelect == NaN || this.timeIntervalSelect > 4) {
          this.timeIntervalSelect = 1;
        }
      }
      console.log('timeRangeSelect.2:', this.timeRangeSelect, this.weekmode, this.timeIntervalSelect);
      if (1 == this.timeRangeSelect) {
        this.intervalOption = [[1, this.$t('Day')]];

        if ('null' == this.timeIntervalSelect) {
          this.timeIntervalSelect = 1;
        }
      } else if (2 == this.timeRangeSelect) {
        this.intervalOption = [[1, this.$t('Day')], [2, this.$t('Week')]];

        if ('null' == this.timeIntervalSelect) {
          this.timeIntervalSelect = 1;
        }
      } else if (3 == this.timeRangeSelect || 4 == this.timeRangeSelect) {
        this.intervalOption = [[2, this.$t('Week')], [3, this.$t('Month2')]];

        if ('null' == this.timeIntervalSelect) {
          this.timeIntervalSelect = 2;
        }
      } else if (0 == this.timeRangeSelect) {
        var _daySpan = (this.et - this.st) / 86400 + 1;
        console.log("customize daySpan:", _daySpan);

        if (_daySpan >= 30) {
          this.intervalOption = [[2, this.$t('Week')], [3, this.$t('Month2')]];
          this.timeIntervalSelect = 2;
        } else if (_daySpan >= 14) {
          this.intervalOption = [[1, this.$t('Day')], [2, this.$t('Week')]];
          this.timeIntervalSelect = 1;
        } else {
          this.intervalOption = [[1, this.$t('Day')]];
          this.timeIntervalSelect = 1;
        }
      }

      if (0 == this.timeRangeSelect) {
        this.startDateDisable = false;
      } else {
        this.startDateDisable = true;
      }
    }

    this.timeRangeSelectSave = this.timeRangeSelect;
    this.timeIntervalSelectSave = this.timeIntervalSelect;
    this.intervalOptionSave = this.intervalOption.concat();

    sessionStorage.setItem('st4', this.st);
    sessionStorage.setItem('et4', this.et);
    sessionStorage.setItem('week4', this.weekmode);
    sessionStorage.setItem('timeRange4', this.timeRange);
    sessionStorage.setItem('timeRangeSelect4', this.timeRangeSelect);
    sessionStorage.setItem('timeIntervalSelect4', this.timeIntervalSelect);
    this.startDate = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate4(this.st);
    this.defaultDate = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate4(this.et);
    this.value2 = new Date(this.st * 1000);
    this.value1 = new Date(this.et * 1000);
    var win = window.innerWidth;

    this.getData();

    sessionStorage.setItem('st7', this.st);
    sessionStorage.setItem('et7', this.et);
    sessionStorage.setItem('timeRangeSelect7', this.timeRangeSelect);

    sessionStorage.setItem('st8', this.st);
    sessionStorage.setItem('et8', this.et);
    sessionStorage.setItem('timeRangeSelect8', this.timeRangeSelect);

    var daySpan = (this.et - this.st) / 86400 + 1;
    var st2 = this.et - 86400 * (7 - 1);
    if (daySpan > 7) {
      st2 = this.et - 86400 * (14 - 1);
    }
    sessionStorage.setItem('st2', st2);
    sessionStorage.setItem('et2', this.et);

    var st3 = this.et - 86400 * (7 - 1);
    sessionStorage.setItem('st3', st3);
    sessionStorage.setItem('et3', this.et);
    if (!sessionStorage.getItem('week3')) {
      sessionStorage.setItem('week3', 'yyyyyyy');
    }

    var st5 = this.et - 86400 * (7 - 1);
    if (daySpan > 7) {
      st5 = this.et - 86400 * (14 - 1);
    }
    sessionStorage.setItem('st5', st5);
    sessionStorage.setItem('et5', this.et);
    if (!sessionStorage.getItem('week5')) {
      sessionStorage.setItem('week5', 'yyyyyyy');
    }

    var that = this;
    window.onresize = function () {
      that.handleResize();
      if (that.chart4_1) {
        that.chart4_1.resize();that.chart4_2.resize();
      }
    };
  }

});

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_format__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_base64__ = __webpack_require__(9);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      pump_device: '--',
      timer: false, typeChooseVisible: false, value1: '', value2: '', isC: false, flag: 0, count: 0, sta: '', end: '', isMg: '', ts: [], tz: [], noPump: [], isEs: false, isDe: false, isCz: false,
      uid: 0, st: 0, et: 0, autoStop: [], manualStop: [], stop: [], Newer: [], noMeal: [], mt: [], dialogSize: 'tiny', mt1: [], weekModeSp: [], weekM1: false, weekM2: false, isSw: false,
      bgAvg: [{ avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }],
      bgAvg1: [{ avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }],
      carb: [{ total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }],
      carb1: [{ total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }],
      ins: [{ total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }],
      ins1: [{ total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }],
      chartColumn: null, defaultDate1: '', defaultDate2: '', whichDay: 'Everyday', weekmode: 'yyyyyyy', timeRange: '', isA: false, isPo: false, isDu: false, isFr: false,
      whichDate: [], timeRangeSelect: 1,
      whichDate1: ['', '', '', '', '', '', '', '', '', '', '', '', '', ''],
      hours: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          var t1 = time.getTime();
          var d2 = new Date();
          var t2 = d2.getTime();

          return t1 > t2 || t1 < t2 - 730 * 86400 * 1000;
        }
      },
      isEn: false,
      wrapDiv: '', contentDiv: '', contentDiv1: '', sliderWrap: '', slider: '', disX: '', disY: '', mouseFlag: true, isIt: false
    };
  },

  computed: {
    DataS: function DataS() {
      return this.$store.state.DataS;
    },
    DataSG: function DataSG() {
      return JSON.parse(sessionStorage.getItem('olDataSG'));
    }
  },
  methods: {
    getData: function getData() {
      this.ts = this.getTs(this.st, this.et);

      var param = {
        ts: this.ts,
        tz: this.tz,
        gu: this.isMg ? 'mg/dL' : 'mmol/L',
        weekmode: this.weekmode
      };

      var daysNum = this.ts.length;
      var w1 = document.getElementById("wrap");
      var w2 = document.getElementById("wrap1");
      var w3 = document.getElementById("sliderWrap");
      var w4 = document.getElementById("table-wrapper");
      w1.style.height = 0 + 124 * daysNum + 'px';
      w2.style.height = 0 + 124 * daysNum + 'px';
      w3.style.height = 0 + 124 * daysNum + 'px';
      w4.style.height = 100 + 124 * daysNum + 'px';

      this.bgAvg = this.bgAvg1;
      this.carb = this.carb1;
      this.ins = this.ins1;
      param = __WEBPACK_IMPORTED_MODULE_4__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getLgb1(this, this.uid, param);
    },
    cancel: function cancel() {
      this.typeChooseVisible = false;
    },
    open: function open() {
      this.typeChooseVisible = true;
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].checkWeekMode(this);
      this.$nextTick(this.initWeeks);
    },
    initWeeks: function initWeeks() {
      var weeks = document.getElementById('weeks');
      var weken = document.getElementById('weken');
      var labels1 = weeks.getElementsByTagName('label');
      var labels2 = weken.getElementsByTagName('label');
      labels1[0].className = this.weekM1 ? 'no' : '';
      labels2[0].className = this.weekM2 ? 'no' : '';
      for (var i = 1; i < labels1.length; i++) {
        labels1[i].className = this.weekModeSp[i - 1] ? 'no' : '';
      }
      for (var _i = 1; _i < labels2.length; _i++) {
        labels2[_i].className = this.weekModeSp[_i + 4] ? 'no' : '';
      }
    },
    procTimeRangeSelect: function procTimeRangeSelect(e) {
      console.log('procTimeRangeSelect:', this.timeRangeSelect);
      var daySpan = 0;
      if (1 == this.timeRangeSelect) {
        daySpan = 7;
      } else if (2 == this.timeRangeSelect) {
        daySpan = 14;
      }

      console.log('daySpan:', daySpan);
      if (daySpan) {
        this.st = this.et - 86400 * (daySpan - 1);
        this.defaultDate1 = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate4(this.st);
        this.value1 = new Date(this.st * 1000);
      }
    },
    endDateChange: function endDateChange() {
      var endDate = this.value2;
      this.et = endDate.getTime() / 1000;
      var daySpan = 0;
      if (1 == this.timeRangeSelect) {
        daySpan = 7;
      } else if (2 == this.timeRangeSelect) {
        daySpan = 14;
      }

      if (daySpan) {
        this.st = this.et - 86400 * (daySpan - 1);
        this.value1 = new Date(this.st * 1000);
        this.defaultDate1 = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate4(this.st);
      }
    },
    dateApply: function dateApply() {
      var prev_st = this.st;
      var prev_et = this.et;

      if (this.value1 && this.value2) {
        this.st = this.value1.getTime() / 1000;
        this.et = this.value2.getTime() / 1000;
      } else if (!this.value2 && this.value1) {
        this.st = this.value1.getTime() / 1000;
        var t = this.defaultDate2.split('-');
        this.et = new Date(parseInt(t[2]), parseInt(t[1]) - 1, parseInt(t[0])).getTime() / 1000;
      } else if (!this.value1 && this.value2) {
        this.et = this.value2.getTime() / 1000;
        var _t = this.defaultDate1.split('-');
        this.st = new Date(parseInt(_t[2]), parseInt(_t[1]) - 1, parseInt(_t[0])).getTime() / 1000;
      }
      var count = (this.et - this.st) / 86400 + 1;

      console.log('dateApply.4:' + this.st + ',' + this.et + ',' + count);
      console.log('dateApply.5:' + prev_st + ',' + prev_et);

      if (count <= 0) {
        try {
          this.st = prev_st;
          this.et = prev_et;
          this.value1 = new Date(prev_st * 1000);
          this.value2 = new Date(prev_et * 1000);
        } catch (e) {}

        this.$message.error(this.$t('dateErr2'));
      } else if (this.st <= this.et) {
        if (count > 14 || count <= 0) {
          try {
            this.st = prev_st;
            this.et = prev_et;
            this.value1 = new Date(prev_st * 1000);
            this.value2 = new Date(prev_et * 1000);
          } catch (e) {}

          this.$message.error(this.$t('Date no more than 14 days'));
        } else {
          var weekmode = this.checkDate();
          if (weekmode !== 'nnnnnnn') {
            this.weekmode = weekmode;
            var st = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate2(this.st);
            var et = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate2(this.et);
            this.formatterSelect(st, et);
            this.timeRange = st + '-' + et + ', ' + this.$t(this.whichDay);
            sessionStorage.setItem('st5', this.st);
            sessionStorage.setItem('et5', this.et);
            sessionStorage.setItem('week5', this.weekmode);
            sessionStorage.setItem('timeRange5', this.timeRange);

            this.isA = count > 7 ? true : false;
            if (count <= 14) {
              this.getData();
            }
          }
        }
      }
      this.typeChooseVisible = false;
    },
    checkDate: function checkDate() {
      var weeks = document.getElementById('weeks');
      var weken = document.getElementById('weken');
      if (weeks) {
        var labels1 = weeks.getElementsByTagName('label');
        var labels2 = weken.getElementsByTagName('label');
        var weekmode = '';
        if (labels1[0].className === '' && labels2[0].className === '') {
          this.whichDay = 'Everyday';weekmode = 'yyyyyyy';
        } else {
          this.whichDay = ' ';weekmode = '';
          for (var i = 1; i < labels1.length; i++) {
            if (labels1[i].className === '') {
              this.whichDay = this.whichDay + ' ' + labels1[i].innerHTML + '.';
              weekmode = weekmode + 'y';
            } else {
              weekmode = weekmode + 'n';
            }
          }
          for (var _i2 = 1; _i2 < labels2.length; _i2++) {
            if (labels2[_i2].className === '') {
              this.whichDay = this.whichDay + ' ' + labels2[_i2].innerHTML + '.';
              weekmode = weekmode + 'y';
            } else {
              weekmode = weekmode + 'n';
            }
          }
        }
        return weekmode;
      }
    },
    choose: function choose(e) {
      var parent = e.target.parentNode.parentNode;
      var labels = parent.getElementsByTagName('label');
      if (e.target.className === '') {
        e.target.className = 'no';
        labels[0].className = 'no';
      } else {
        e.target.className = '';
        for (var i = 1; i < labels.length; i++) {
          if (labels[i].className === '') {
            this.count++;
          }
        }
        if (this.count === labels.length - 1) {
          labels[0].className = '';
        }
        this.count = 0;
      }
    },
    chooseAll: function chooseAll(e) {
      var parent = e.target.parentNode.parentNode;
      var labels = parent.getElementsByTagName('label');
      this.flag = labels[0].className === 'no' ? 1 : 0;
      for (var i = 0; i < labels.length; i++) {
        if (this.flag === 0) {
          labels[i].className = 'no';
        } else {
          labels[i].className = '';
        }
      }
    },
    formatterSelect: function formatterSelect(st, et) {
      st = st.split('/');
      et = et.split('/');
      this.defaultDate1 = st[0] + '-' + st[1] + '-' + st[2];
      this.defaultDate2 = et[0] + '-' + et[1] + '-' + et[2];
    },
    initTable: function initTable() {
      var table = document.getElementById('context-table');
      var tr = table.getElementsByTagName('tr');
      for (var j = 0; j < tr.length; j++) {
        var td = tr[j].getElementsByTagName('td');
        for (var k = 0; k < td.length; k++) {
          td[k].innerHTML = '';
          td[k].style.backgroundColor = '#fff';
        }
      }
      var length1 = this.ts.length;
      for (var i = 0; i < length1; i++) {
        var id = 'date' + i;
        var _table = document.getElementById(id);
        var _tr = _table.getElementsByTagName('tr')[2];
        var _td = _tr.getElementsByTagName('td')[1];
        _td.style.backgroundColor = '#fff';
      }
      this.scroll();
    },
    print: function print() {
      sessionStorage.setItem('whichDate5', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.whichDate));
      sessionStorage.setItem('lgb_pump_device', this.pump_device);
      window.open('/#/chart5-print', '_blank');
    },
    getTs: function getTs(st, et) {
      var ts = [],
          days = (et - st) / 86400 + 1,
          time = 0,
          sp1 = 0,
          k = 0;
      var No = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].chekcNoDate(this.weekmode);
      this.whichDate = [];
      for (var i = 0; i < days; i++) {
        var day = new Date((st + i * 86400) * 1000).getDay();
        if (No.indexOf(day) === -1) {
          ts[k] = [];
          ts[k][0] = st + i * 86400;
          ts[k][1] = st + (i + 1) * 86400;
          time = new Date(ts[k][0] * 1000).toString();
          sp1 = time.split(' ');
          if (this.isEn) {
            this.whichDate[k] = sp1[2] + ' ' + this.$t(sp1[1]) + ', ' + sp1[3] + ' ' + this.$t(sp1[0]);
          } else {
            var m = new Date(ts[k][0] * 1000).getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            this.whichDate[k] = sp1[3] + '-' + m + '-' + sp1[2] + ' ' + this.$t(sp1[0]);
          }
          k++;
        }
      }
      return ts;
    },
    makebg1: function makebg1(val, high, low) {
      for (var i = 0; i < val.length; i++) {
        if (val[i].length > 0) {
          var id = i * 4 + 1;
          var tr = document.getElementById(id);

          for (var j = 0; j < val[i].length; j++) {
            if (val[i][j].length > 0) {
              var td = tr.getElementsByTagName('td')[j];
              if (val[i][j].length === 2) {
                var div1 = document.createElement('div');
                var div2 = document.createElement('div');
                div2.style.float = 'left';
                div2.style.marginLeft = '30px';
                div2.innerHTML = val[i][j][0];
                var div3 = document.createElement('div');
                div3.style.float = 'left';
                div3.style.width = '6px';
                div3.style.height = '6px';
                div3.style.borderRadius = '3px';
                div3.style.backgroundColor = '#0f0f0f';
                div1.appendChild(div2);
                div1.appendChild(div3);
                td.appendChild(div1);
              } else {
                td.innerHTML = val[i][j][0];
              }
              if (val[i][j][0] > high) {
                td.style.backgroundColor = '#ffd125';
              } else if (val[i][j][0] < low) {
                td.style.backgroundColor = '#ff3d3d';
              } else {
                td.style.backgroundColor = '#c6deb5';
              }
            }
          }
        }
      }
    },
    makecarb: function makecarb(val) {
      for (var i = 0; i < val.length; i++) {
        if (val[i].length > 0) {
          var id = i * 4 + 2;
          var tr = document.getElementById(id);
          for (var j = 0; j < val[i].length; j++) {
            if (val[i][j] !== 0) {
              var td = tr.getElementsByTagName('td')[j];
              td.innerHTML = val[i][j];
            }
          }
        }
      }
    },
    makeOth: function makeOth(val, flag) {
      for (var i = 0; i < val.length; i++) {
        if (val[i].length > 0) {
          var id = i * 4 + 3;
          var tr = document.getElementById(id);
          for (var j = 0; j < val[i].length; j++) {
            var td = tr.getElementsByTagName('td')[val[i][j]];
            var img = document.createElement('img');
            if (flag === 0) {
              img.src = '/static/Lgb Icon/Auto Suspend.png';
            }
            if (flag === 1) {
              img.src = '/static/Lgb Icon/Manual Suspend.png';
            }
            if (flag === 2) {
              img.src = '/static/Lgb Icon/Stop Patch .png';
            }
            if (flag === 3) {
              img.src = '/static/Lgb Icon/New Patch .png';
            }
            img.style.height = '12px';
            img.style.width = '12px';
            img.style.marginRight = '2px';
            img.style.float = 'left';
            td.appendChild(img);
          }
        }
      }
    },
    makeOth1: function makeOth1(val, flag) {
      console.log('makeOth1:', flag, val);
      for (var i = 0; i < val.length; i++) {
        var id = 0;
        if (flag === 4 || flag === 5 || 7 === flag || 8 === flag || 9 === flag || 10 === flag || 11 === flag) {
          id = i * 4 + 4;
        } else {
          id = i * 4 + 3;
        }
        var tr = document.getElementById(id);
        for (var j = 0; j < val[i].length; j++) {
          if (val[i][j] === 1) {
            var td = tr.getElementsByTagName('td')[j];
            var img = document.createElement('img');
            img.style.height = '12px';
            img.style.width = '12px';
            if (flag === 0) {
              img.src = '/static/Lgb Icon/Auto Suspend.png';
            }
            if (flag === 1) {
              img.src = '/static/Lgb Icon/Manual Suspend.png';
            }
            if (flag === 2) {
              img.src = '/static/Lgb Icon/Stop Patch .png';
            }
            if (flag === 3) {
              img.src = '/static/Lgb Icon/New Patch .png';
            }
            if (flag === 4) {
              img.src = '/static/Lgb Icon/Exercise.png';
            }
            if (flag === 5) {
              img.src = '/static/Lgb Icon/Others.png';
            }
            if (flag === 6) {
              img.src = '/static/Lgb Icon/temp basal.png';
            }
            if (7 === flag) {
              img.src = '/static/legend/automode/早餐.png';
              img.style.height = '15px';
              img.style.width = '22px';
            } else if (flag === 8) {
              img.src = '/static/legend/automode/中餐.png';
              img.style.height = '15px';
              img.style.width = '22px';
            } else if (flag === 9) {
              img.src = '/static/legend/automode/晚餐.png';
              img.style.height = '15px';
              img.style.width = '22px';
            } else if (flag === 10) {
              img.src = '/static/legend/automode/零食.png';
              img.style.height = '15px';
              img.style.width = '22px';
            } else if (flag === 11) {
              img.src = '/static/legend/automode/运动[30059].png';
              img.style.height = '15px';
              img.style.width = '22px';
            } else if (flag === 12) {
              img.src = '/static/legend/automode/进入自动模式.png';
              img.style.height = '15px';
              img.style.width = '15px';
            } else if (flag === 13) {
              img.src = '/static/legend/automode/退出自动模式.png';
              img.style.height = '15px';
              img.style.width = '15px';
            }
            img.style.marginRight = '2px';
            img.style.marginLeft = '2px';
            img.style.float = 'left';
            td.appendChild(img);
          }
        }
      }
    },
    makeBolus: function makeBolus(val, flag) {
      for (var i = 0; i < val.length; i++) {
        var leng = val[i].length;
        var id = i * 4 + 3;
        var tr = document.getElementById(id);
        for (var k = 0; k < leng; k++) {
          if (val[i][k] !== 0) {
            var td = tr.getElementsByTagName('td')[k];
            if (flag[i][k]) {
              var div3 = document.createElement('div');
              div3.style.float = 'left';
              div3.style.width = '32px';
              div3.style.height = '18px';
              div3.style.borderRadius = '4px';
              div3.style.paddingTop = '2px';
              div3.style.border = '1px solid #222';
              div3.innerHTML = val[i][k].toFixed(2);
              td.appendChild(div3);
            } else {
              td.innerHTML = val[i][k].toFixed(2);
            }
          }
        }
      }
    },
    makeBolus2: function makeBolus2(val) {
      for (var i = 0; i < val.length; i++) {
        var leng = val[i].length;
        if (leng > 0) {
          var id = i * 4 + 3;
          var tr = document.getElementById(id);
          for (var k = 0; k < leng; k++) {
            if (val[i][k].length > 0) {
              var td = tr.getElementsByTagName('td')[val[i][k][0]];

              var div3 = document.createElement('div');
              div3.style.float = 'left';
              div3.style.width = '32px';
              div3.style.height = '18px';
              div3.style.borderRadius = '4px';
              div3.style.paddingTop = '2px';
              div3.style.border = '1px solid #222';
              div3.innerHTML = val[i][k][1].toFixed(2);

              td.appendChild(div3);
            }
          }
        }
      }
    },
    makeNoMeal: function makeNoMeal() {
      var noMeal = this.noMeal,
          mt = this.mt;
      for (var i = 0; i < noMeal.length; i++) {
        for (var j = 0; j < 3; j++) {
          if (noMeal[i][j] === 0) {
            var id = i * 4 + 2;
            var tr = document.getElementById(id);
            var td = tr.getElementsByTagName('td')[mt[j][0]];
            var img = document.createElement('img');
            img.src = '/static/Lgb Icon/Missed Meal.png';
            img.className = 'insertImg';
            td.appendChild(img);
          }
        }
      }
      var mt1 = this.mt1;
      for (var _i3 = 0; _i3 < 3; _i3++) {
        var obj = document.getElementById('m' + _i3);
        obj.style.left = parseFloat(mt1[_i3][0]) / 24 * 100 + '%';
        obj.style.width = (parseFloat(mt1[_i3][1]) - parseFloat(mt1[_i3][0])) * 80 + 'px';
      }
    },
    makeNoPump: function makeNoPump(val) {
      for (var i = 0; i < val.length; i++) {
        if (val[i] === 1) {
          var id = 'date' + i;
          var table = document.getElementById(id);
          var tr = table.getElementsByTagName('tr')[2];
          var td = tr.getElementsByTagName('td')[1];
          td.style.backgroundColor = '#ccc';
        }
      }
    },
    scroll: function scroll() {
      this.wrapDiv = document.getElementById("wrap");
      this.contentDiv = document.getElementById("context-table");
      this.contentDiv1 = document.getElementById("context-table1");
      this.sliderWrap = document.getElementById("sliderWrap");
      this.slider = document.getElementById("slider");
      var tableRight = document.getElementById("table-right");

      this.sliderWrap.style.visibility = 'visible';
      this.initScroll();

      var scale = this.wrapDiv.clientHeight / this.contentDiv.clientHeight;
      if (scale < 1) {
        this.mouseFlag = true;
        var h1 = this.sliderWrap.clientHeight * scale;
        h1 = h1 < 50 ? 50 : h1;
        this.slider.style.height = h1 + "px";
        var y = 0;
        var that = this;

        if (document.addEventListener) {
          document.addEventListener('DOMMouseScroll', function (e) {
            if (that.mouseFlag) {
              var event1 = window.event || e;
              y = event1.detail > 0 ? y + 8 : y - 8;
              y = y < 0 ? 0 : y;
              var max = that.sliderWrap.clientHeight - that.slider.clientHeight;
              y = y > max + 1 ? max + 1 : y;
              that.slider.style.top = y + "px";
              scale = that.wrapDiv.clientHeight / that.contentDiv.clientHeight;
              var y1 = -y / scale;
              that.contentDiv.style.top = y1 + "px";
              that.contentDiv1.style.top = y1 + "px";
            }
          }, false);
        }
        this.wrapDiv.onmousewheel = function (e) {
          if (scale < 1) {
            var event1 = window.event || e;
            y = event1.wheelDelta < 0 ? y + 8 : y - 8;
            y = y < 0 ? 0 : y;
            var max = that.sliderWrap.clientHeight - that.slider.clientHeight;

            y = y > max + 1 ? max + 1 : y;
            that.slider.style.top = y + "px";
            scale = that.wrapDiv.clientHeight / that.contentDiv.clientHeight;
            var y1 = -y / scale;
            that.contentDiv.style.top = y1 + "px";
            that.contentDiv1.style.top = y1 + "px";
          }
        };
      } else {
        this.wrapDiv.onmousewheel = null;
        if (document.addEventListener) {
          this.mouseFlag = false;
        }
        this.sliderWrap.style.visibility = 'hidden';
        var height = this.contentDiv.clientHeight;
        tableRight.style.height = height + 72 + 'px';
        this.wrapDiv.style.height = height + 2 + 'px';
      }
    },
    drag: function drag(ev) {
      this.slider.className = 'focus';
      var that = this;
      var scale = this.wrapDiv.clientHeight / this.contentDiv.clientHeight;
      var oEvent = ev || event;
      var pos = that.getPos(oEvent);
      this.disY = pos.y - this.slider.offsetTop;
      this.disX = pos.x - this.slider.offsetLeft;
      document.onmousemove = function (ev) {
        var oEvent = ev || event;
        var pos = that.getPos(oEvent);
        var t = pos.y - that.disY;
        t = t < 0 ? 0 : t;
        if (t > that.sliderWrap.clientHeight - that.slider.offsetHeight) {
          t = that.sliderWrap.clientHeight - that.slider.offsetHeight;
        }
        that.slider.style.top = t + 'px';
        var t1 = -(t + 1) / scale;
        that.contentDiv.style.top = t1 + "px";
        that.contentDiv1.style.top = t1 + "px";
      };
      document.onmouseup = function () {
        that.slider.className = '';
        document.onmousemove = null;
        document.onmouseup = null;
      };
      return false;
    },
    initScroll: function initScroll() {
      this.slider.style.top = 0;
      this.contentDiv.style.top = 0;
      this.contentDiv1.style.top = 0;
    },
    getPos: function getPos(ev) {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      var scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
      return { x: ev.clientX + scrollLeft, y: ev.clientY + scrollTop };
    },
    handleScroll: function handleScroll() {
      var scrollTop = document.documentElement.scrollTop;
      var heightTop = document.querySelector(".searchBar").getBoundingClientRect().top;
      var heightTwoTop = document.querySelector(".searchBarTd").getBoundingClientRect().top;
      if (heightTop <= 0 || heightTwoTop <= 25) {
        var top = scrollTop - 373;
        document.getElementsByClassName("searchBar")[0].style.position = "relative";
        document.getElementsByClassName("searchBar")[0].style.zIndex = "500";
        document.getElementsByClassName("searchBar")[0].style.top = top + 'px';
        document.getElementsByClassName("searchBar")[0].style.backgroundColor = '#fff';
        document.getElementsByClassName("searchBar")[1].style.position = "relative";
        document.getElementsByClassName("searchBar")[1].style.zIndex = "500";
        document.getElementsByClassName("searchBar")[1].style.top = top + 'px';
        document.getElementsByClassName("searchBar")[1].style.width = '750px';
        document.getElementsByClassName("searchBarRight")[0].style.backgroundColor = '#fff';
      }
      if (scrollTop <= 340) {
        document.getElementsByClassName("searchBar")[0].style.position = "";
        document.getElementsByClassName("searchBar")[0].style.zIndex = "";
        document.getElementsByClassName("searchBar")[0].style.top = "";
        document.getElementsByClassName("searchBar")[1].style.position = "";
        document.getElementsByClassName("searchBar")[1].style.zIndex = "";
        document.getElementsByClassName("searchBar")[1].style.top = "";
      }
    }
  },
  mounted: function mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isEs = lang === 'es' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isSw = lang === 'sw' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    this.tz = parseInt(sessionStorage.getItem('tz'));
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }
    console.log(sessionStorage.getItem('st5'));
    if (!sessionStorage.getItem('st5')) {
      var nd = new Date();
      var cur_day = new Date(nd.getFullYear(), nd.getMonth(), nd.getDate() - 1);
      this.et = cur_day / 1000;
      var chart_end_time = sessionStorage.getItem('chart_end_time');
      console.log(chart_end_time);
      for (var d = 0; d < 3000; d++) {
        if (this.et > chart_end_time) {
          cur_day = new Date(cur_day.getFullYear(), cur_day.getMonth(), cur_day.getDate() - 1);
          this.et = cur_day / 1000;
        } else {
          break;
        }
      }
      this.st = this.et - 86400 * 6;
      this.weekmode = 'yyyyyyy';
      this.timeRange = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate2(this.st) + '-' + __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate2(this.et) + ', ' + this.$t(this.whichDay);
    } else {
      this.st = parseInt(sessionStorage.getItem('st5'));
      this.et = parseInt(sessionStorage.getItem('et5'));
      this.weekmode = sessionStorage.getItem('week5');

      this.timeRange = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate2(this.st) + '-' + __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate2(this.et) + ', ' + this.$t(this.whichDay);
    }
    sessionStorage.setItem('st5', this.st);
    sessionStorage.setItem('et5', this.et);
    sessionStorage.setItem('week5', this.weekmode);
    sessionStorage.setItem('timeRange5', this.timeRange);
    this.defaultDate1 = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate4(this.st);
    this.defaultDate2 = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate4(this.et);
    this.value1 = new Date(this.st * 1000);
    this.value2 = new Date(this.et * 1000);
    var count = (this.et - this.st) / 86400 + 1;
    if (count > 14) {
      var nd = new Date();
      var cur_day = new Date(nd.getFullYear(), nd.getMonth(), nd.getDate() - 1);
      this.et = cur_day / 1000;
      var chart_end_time = sessionStorage.getItem('chart_end_time');
      console.log(chart_end_time);
      for (var d = 0; d < 3000; d++) {
        if (this.et > chart_end_time) {
          cur_day = new Date(cur_day.getFullYear(), cur_day.getMonth(), cur_day.getDate() - 1);
          this.et = cur_day / 1000;
        } else {
          break;
        }
      }
      this.st = this.et - 86400 * 6;
      this.weekmode = 'yyyyyyy';
      this.timeRange = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate2(this.st) + '-' + __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate2(this.et) + ', ' + this.$t(this.whichDay);
    }

    if (7 == count) {
      this.timeRangeSelect = 1;
    } else if (14 == count) {
      this.timeRangeSelect = 2;
    }

    this.ts = this.getTs(this.st, this.et);
    var param = {
      ts: this.ts,
      tz: this.tz,
      weekmode: this.weekmode,
      gu: this.isMg ? 'mg/dL' : 'mmol/L'
    };

    var daysNum = this.ts.length;

    var w1 = document.getElementById("wrap");
    var w2 = document.getElementById("wrap1");
    var w3 = document.getElementById("sliderWrap");
    var w4 = document.getElementById("table-wrapper");
    w1.style.height = 0 + 124 * daysNum + 'px';
    w2.style.height = 0 + 124 * daysNum + 'px';
    w3.style.height = 0 + 124 * daysNum + 'px';
    w4.style.height = 100 + 124 * daysNum + 'px';

    var win = window.innerWidth;
    this.dialogSize = win < 1500 ? 'small' : 'tiny';
    param = __WEBPACK_IMPORTED_MODULE_4__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));
    __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getLgb1(this, this.uid, param);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll, true);
  }
});

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_format__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_base64__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_loading__ = __webpack_require__(77);








/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_loading__["a" /* loading */]],
  data: function data() {
    return {
      pumpSN: '--', tranSN: '--',
      easypatch_reminder: [],
      showEasyPatch: '',
      unit1: '',
      chartWidth: '', timer: false, typeChooseVisible: false, value1: '', isC: false, flag: 0, count: 0, sta: '', end: '', Average: [], unit: '', isMg: '', unit2: "",
      chartColumn: null, startDate: '', timeRange: '', defaultDate: '', whichDay: ' EverDay', weekmode: 'yyyyyyy', isEn: false, isPo: false,
      date: [true, true, true, true, true, true, true], dialogSize: 'tiny', isEs: false,
      hours: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
      hours2: ['08:00', '10:00', '12:00', '13:00', '19:00', '20:00', '21:00'],
      repeat: ['once', 'once', 'once', 'once', 'once', 'once', 'once'], max_bolus_length: 0,
      selectId: 0,
      tempSelectId: 0,
      page: 1, pages: 5, has_next: '', has_prev: '', PDM: [], time: '', rid: 0,
      chart6_1: null, chart6_2: null, chart6_3: null, chart6_4: null, chart6_5: null, maxBolOption: '',
      chart6_6: null, chart6_7: null, chart6_8: null,

      IcRatio: [], ins_sen: [], bg_target: [], max_bolus: [], cgmLimit: [], uid: 0, isA: true, index: 0, first: true,

      textStyle: {
        color: '#282828',
        fontWeight: 'normal',
        fontSize: '14',
        fontFamily: 'SFUIText-Regular'
      },
      titlePadding: [0, 0, 8, 30],
      grid: { x: '3%', y: '15%', width: '95.5%', height: '68%' },
      yAxisLabel: { interval: 0, margin: 5, textStyle: { color: '#282828', baseline: 'middle' }, showMinLabel: false },
      xLabel: ['18-07-2017', '19-07-2017', '20-07-2017', '21-07-2017', '22-07-2017', '23-07-2017', '24-07-2017', '25-07-2017', '26-07-2017', '27-07-2017', '28-07-2017', '29-07-2017', '30-07-2017', '31-07-2017'],

      basal: {
        "basal_onoff": "--",
        "basal_select": "--",
        "max_rate": '--',
        "exer_basal": {
          "day_total": '--',
          "seg": []
        }
      },
      exeBasal: [], standBasal: [], holidayBasal: [], programA: [], programB: [], sgMax: 4,
      sickBasal: [], programC: [], programD: [],

      standardSeg: [], standardSeg1: [], standardSeg2: [], standardSeg3: [], standardSeg4: [],
      exerSeg: [], exerSeg1: [], exerSeg2: [], exerSeg3: [], exerSeg4: [],
      holidaySeg: [], holidaySeg1: [], holidaySeg2: [], holidaySeg3: [], holidaySeg4: [],
      programASeg: [], programASeg1: [], programASeg2: [], programASeg3: [], programASeg4: [],
      programBSeg: [], programBSeg1: [], programBSeg2: [], programBSeg3: [], programBSeg4: [],

      sickSeg: [], sickSeg1: [], sickSeg2: [], sickSeg3: [], sickSeg4: [],
      programCSeg: [], programCSeg1: [], programCSeg2: [], programCSeg3: [], programCSeg4: [],
      programDSeg: [], programDSeg1: [], programDSeg2: [], programDSeg3: [], programDSeg4: [],
      axisMaxArr: [],
      moreBasal: true,

      basalInfo: [{}, {}, {}, {}, {}, {}, {}, {}],

      bolus: {
        "bg_reminder": "--",
        "bg_target": [],
        "bolus_reminder": [],
        "bolus_step": '--',
        "bolus_wizard": "--",
        "extent_option": "--",
        "ins_active_time": '--',
        "ins_carb_ratio": [],
        "ins_sen": [],
        "max_bolus": '--'
      },

      bolus_rem: [],
      cgm: {
        "alarm_silent_option": "--",
        "sensor_alarm_option": "--",
        "sensor_alarm_repeat": {
          "high": ["--", "--"],
          "low": ["--", "--"]
        },
        "sensor_alarm_settings": {
          "auto_calib_option": "--",
          "calib_remind_interval": "--",
          "calib_remind_option": "--",
          "calib_remind_time": "--",
          "no_calib_display": "--",
          "sensor_lost_time": '--',
          "trend_time_scope": '--'
        },
        "sensor_alarm_threshold": [],
        "sensor_forecast_alarm": {
          "high": ["--", "--"],
          "low": ["--", "--"]
        },
        "sensor_rate_alarm": {
          "fall": ["--", '--'],
          "rise": ["--", '--']
        }
      },
      userset: {
        "user_name": "--",
        "alarm_type": "--",
        "auto_off_option": "--",
        "auto_off_time": "--",
        "backlight_timeout": "--",
        "beep_off_tip_interval": "--",
        "beep_off_tip_option": "--",
        "cgms_module_flag": "--",
        "clock": [],
        "clock_option": "--",
        "cmd_response": "--",
        "day_bolus_max": "--",
        "device_option": "--",
        "glucose_unit": "--",
        "hour_bolus_max": "--",
        "keypad_lock": "--",
        "low_reservoir_ins": "--",
        "low_reservoir_time": "--",
        "low_reservoir_type": "--",
        "password_option": "--",
        "patch_expire_ahead": "--",
        "patch_expire_alarm": "--",
        "pre_suspend_on_lowbg_level": "--",
        "pre_suspend_on_lowbg_option": "--",
        "pump_module_flag": "--",
        "screen_timeout": "--",
        "suspend_on_lowbg_level": "--",
        "suspend_on_lowbg_option": "--",
        "sensor_expire_option": "--",
        "time_style": "--",
        "pump_sn": "--",
        "sensor_sn": "--",
        auto_basal: {}
      }
    };
  },

  methods: {
    getPdm1: function getPdm1() {
      var param = {
        page: this.page,
        flag: 'web'
      };
      console.log('12312param', param);
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getPdm1(this, this.uid, param);
    },
    getAxisMax: function getAxisMax(seg) {
      var valArr = seg.map(function (e, i) {
        return e[1];
      });
      var maxVal = Math.max.apply(null, valArr);
      var axisMax = (parseInt(maxVal / 2) + 1) * 2;
      return axisMax;
    },
    getOptionText: function getOptionText(optionVal) {
      var optionText = '--';
      if (1 == optionVal) {
        optionText = this.$t('Off');
      } else if (2 == optionVal) {
        optionText = this.$t('On');
      }
      return optionText;
    },
    getPdm2: function getPdm2() {
      this.isA = false;
      this.exeBasal = [];this.standBasal = [];this.holidayBasal = [];this.programA = [];this.programB = [];
      this.sickBasal = [];this.programC = [];this.programD = [];
      var rid = parseInt(sessionStorage.getItem('rid'));
      console.log('getPdm2.1:', rid);
      if (rid === 0) {
        rid = this.PDM[0][0];
      }
      var param = {
        gu: this.isMg ? 'mg/dL' : 'mmol/L'
      };
      var ins_unit2 = this.$t('ins_unit2');
      param = __WEBPACK_IMPORTED_MODULE_4__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));
      this.$http.get('api/v2.0/pdm/' + this.uid + '/settings/' + rid, { params: { param: param } }).then(function (res) {
        var err = res.body.error;

        this.typeChooseVisible = false;
        if (err === 0) {
          var data = res.data.settings;

          data.pdm_version_str = res.data.pdm_version_str;
          data.device_type = res.data.device_type;
          var device_type = res.data.device_type;
          if (18 == res.data.device_type) {
            this.moreBasal = true;
            this.showEasyPatch = 'PDM';
          } else if ('easypatch' == device_type) {
            this.moreBasal = true;
            this.showEasyPatch = 'easypatch';
          } else if ('easysense' == device_type) {
            this.moreBasal = false;
            this.showEasyPatch = 'easysense';
          } else {
            this.moreBasal = false;
            this.showEasyPatch = 'PDM';
          }
          if (this.moreBasal) {
            this.basalInfo = [{}, {}, {}, {}, {}, {}, {}, {}];
          }

          sessionStorage.setItem('deviceSet', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
          if (data.basal_settings) {
            this.exeBasal = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getPdmSG(data.basal_settings.exer_basal.seg);
            this.standBasal = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getPdmSG(data.basal_settings.stand_basal.seg);
            this.holidayBasal = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getPdmSG(data.basal_settings.holiday_basal.seg);
            this.programA = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getPdmSG(data.basal_settings.program_a_basal.seg);
            this.programB = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getPdmSG(data.basal_settings.program_b_basal.seg);
            this.axisMaxArr[0] = this.getAxisMax(data.basal_settings.stand_basal.seg);
            this.axisMaxArr[1] = this.getAxisMax(data.basal_settings.exer_basal.seg);
            this.axisMaxArr[2] = this.getAxisMax(data.basal_settings.holiday_basal.seg);
            this.axisMaxArr[3] = this.getAxisMax(data.basal_settings.program_a_basal.seg);
            this.axisMaxArr[4] = this.getAxisMax(data.basal_settings.program_b_basal.seg);

            if (this.moreBasal) {
              console.log('data.basal_settings.program_c_basal.seg: ', data.basal_settings.program_c_basal.seg);
              this.programC = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getPdmSG(data.basal_settings.program_c_basal.seg);
              this.programD = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getPdmSG(data.basal_settings.program_d_basal.seg);
              this.sickBasal = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getPdmSG(data.basal_settings.sick_basal.seg);

              this.axisMaxArr[5] = this.getAxisMax(data.basal_settings.program_c_basal.seg);
              this.axisMaxArr[6] = this.getAxisMax(data.basal_settings.program_d_basal.seg);
              this.axisMaxArr[7] = this.getAxisMax(data.basal_settings.sick_basal.seg);
            }

            this.basal = data.basal_settings;
            this.basal.max_rate = this.basal.max_rate ? this.basal.max_rate.toFixed(2) + this.$t('basal_unit2') : '--';

            this.basalInfo[0].total = this.basal.stand_basal.day_total.toFixed(2);;
            this.basalInfo[0].title = this.$t('Standard');
            this.standardSeg = this.basal.stand_basal.seg;

            this.basalInfo[1].total = this.basal.exer_basal.day_total.toFixed(2);;
            this.basalInfo[1].title = this.$t('Exercise');
            this.exerSeg = this.basal.exer_basal.seg;

            this.basalInfo[2].total = this.basal.holiday_basal.day_total.toFixed(2);;
            this.basalInfo[2].title = this.$t('Holiday');
            this.holidaySeg = this.basal.holiday_basal.seg;

            this.basalInfo[3].total = this.basal.program_a_basal.day_total.toFixed(2);;
            this.basalInfo[3].title = this.$t('ProgramA');
            this.programASeg = this.basal.program_a_basal.seg;

            this.basalInfo[4].total = this.basal.program_b_basal.day_total.toFixed(2);;
            this.basalInfo[4].title = this.$t('ProgramB');
            this.programBSeg = this.basal.program_b_basal.seg;

            if (this.moreBasal) {
              this.basalInfo[5].total = this.basal.program_c_basal.day_total.toFixed(2);;
              this.basalInfo[5].title = this.$t('t1028_Pattern_C');
              this.programCSeg = this.basal.program_c_basal.seg;

              this.basalInfo[6].total = this.basal.program_d_basal.day_total.toFixed(2);;
              this.basalInfo[6].title = this.$t('t1028_Pattern_D');
              this.programDSeg = this.basal.program_d_basal.seg;

              this.basalInfo[7].total = this.basal.sick_basal.day_total.toFixed(2);;
              this.basalInfo[7].title = this.$t('t1029_Sick');
              this.sickSeg = this.basal.sick_basal.seg;
            } else {
              this.basalInfo.splice(5, 3);
            }

            var segName = ['standardSeg', 'exerSeg', 'holidaySeg', 'programASeg', 'programBSeg', 'programCSeg', 'programDSeg', 'sickSeg'];
            if (!this.moreBasal) {
              segName.splice(5, 3);
            }

            for (var n = 0; n < segName.length; n++) {
              this.basalInfo[n].bsg1 = [];
              this.basalInfo[n].bsg2 = [];
              this.basalInfo[n].bsg3 = [];
              this.basalInfo[n].bsg4 = [];

              this.basalInfo[n].bsg2show = false;
              this.basalInfo[n].bsg3show = false;
              this.basalInfo[n].bsg4show = false;
            }

            for (var _n = 0; _n < segName.length; _n++) {
              var curSeg = this[segName[_n]];
              curSeg = curSeg.map(function (e, i) {
                return [e[0], e[1].toFixed(2)];
              });

              for (var i = 0; i < curSeg.length; i++) {
                if (i < 12) {
                  this[segName[_n] + '1'].push(curSeg[i]);
                  this.basalInfo[_n].bsg1.push(curSeg[i]);
                } else if (i < 24) {
                  this[segName[_n] + '2'].push(curSeg[i]);
                  this.basalInfo[_n].bsg2.push(curSeg[i]);
                  this.basalInfo[_n].bsg2show = true;
                } else if (i < 36) {
                  this[segName[_n] + '3'].push(curSeg[i]);
                  this.basalInfo[_n].bsg3.push(curSeg[i]);
                  this.basalInfo[_n].bsg3show = true;
                } else {
                  this[segName[_n] + '4'].push(curSeg[i]);
                  this.basalInfo[_n].bsg4.push(curSeg[i]);
                  this.basalInfo[_n].bsg4show = true;
                }
              }
            }
          }
          if (data.bolus_settings) {
            data.bolus_settings.max_bolus = data.bolus_settings.max_bolus ? data.bolus_settings.max_bolus + ins_unit2 : '--';
            data.bolus_settings.bolus_step = data.bolus_settings.bolus_step ? data.bolus_settings.bolus_step + ins_unit2 : '--';
            data.bolus_settings.ins_active_time = data.bolus_settings.ins_active_time ? data.bolus_settings.ins_active_time + 'H' : '--';
            this.bolus = data.bolus_settings;
            this.cgm = data.sensor_settings;
            if (this.cgm.sensor_rate_alarm) {
              this.cgm.sensor_rate_alarm.fall[1] = this.cgm.sensor_rate_alarm.fall[0] !== "Off" ? this.cgm.sensor_rate_alarm.fall[1].toFixed(3) : '--';
              this.cgm.sensor_rate_alarm.rise[1] = this.cgm.sensor_rate_alarm.rise[0] !== "Off" ? this.cgm.sensor_rate_alarm.rise[1].toFixed(3) : '--';
            }
            if (this.cgm.sensor_alarm_repeat) {
              this.cgm.sensor_alarm_repeat.high[1] = this.cgm.sensor_alarm_repeat.high[0] !== "Off" ? this.cgm.sensor_alarm_repeat.high[1] : '--';
              this.cgm.sensor_alarm_repeat.low[1] = this.cgm.sensor_alarm_repeat.low[0] !== "Off" ? this.cgm.sensor_alarm_repeat.low[1] : '--';
            }
            if (this.cgm.sensor_forecast_alarm) {
              this.cgm.sensor_forecast_alarm.high[1] = this.cgm.sensor_forecast_alarm.high[0] !== "Off" ? this.cgm.sensor_forecast_alarm.high[1] : '--';
              this.cgm.sensor_forecast_alarm.low[1] = this.cgm.sensor_forecast_alarm.low[0] !== "Off" ? this.cgm.sensor_forecast_alarm.low[1] : '--';
            }
            this.cgm.sensor_alarm_settings.calib_remind_time = this.cgm.sensor_alarm_settings.calib_remind_option.toUpperCase() != 'OFF' ? this.cgm.sensor_alarm_settings.calib_remind_time : "--";
            this.cgm.sensor_alarm_settings.calib_remind_interval = this.cgm.sensor_alarm_settings.auto_calib_option.toUpperCase() != 'OFF' ? this.cgm.sensor_alarm_settings.calib_remind_interval : "--";

            this.userset = data.user_settings;
            this.unit2 = this.userset.glucose_unit;
            this.userset.sensor_sn = this.userset.sensor_sn ? this.userset.sensor_sn : '--';
            this.tranSN = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].deviceSNFormat(this.userset.sensor_sn, 'TRANS');
            this.userset.user_name = this.userset.user_name ? this.userset.user_name : '--';
            this.userset.sensor_expire_option = this.userset.sensor_expire_option ? this.$t(this.userset.sensor_expire_option) : '--';
            this.userset.pump_sn = this.userset.pump_sn ? this.userset.pump_sn : '--';
            this.pumpSN = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].deviceSNFormat(this.userset.pump_sn, 'PUMP');
            this.userset.alarm_type = this.userset.alarm_type ? this.$t(this.userset.alarm_type) : '--';
            this.userset.low_reservoir_time = this.userset.low_reservoir_type === 'time' ? this.userset.low_reservoir_time : this.$t(this.userset.low_reservoir_type) + ' ' + this.userset.low_reservoir_ins + ins_unit2;
            var opt = this.userset.patch_expire_alarm;
            this.userset.patch_expire_alarm = opt === 'On' ? this.$t(opt) + ' ' + this.userset.patch_expire_ahead + 'H' : this.$t(opt);
            this.userset.auto_off_option = this.userset.auto_off_option === 'On' ? this.$t(this.userset.auto_off_option) + ' ' + this.userset.auto_off_time + 'H' : this.$t(this.userset.auto_off_option);
            this.userset.pre_suspend_on_lowbg_option = this.userset.pre_suspend_on_lowbg_option === 'On' ? this.$t(this.userset.pre_suspend_on_lowbg_option) + ' ' + this.userset.pre_suspend_on_lowbg_level + ' min' : this.$t(this.userset.pre_suspend_on_lowbg_option);
            if ('On' == this.userset.out_of_range_option) {
              var time_format = function time_format(minute) {

                if (minute < 60) {
                  return minute + 'min';
                } else if (0 == minute % 60) {
                  return Math.floor(minute / 60) + 'h';
                } else {
                  return Math.floor(minute / 60) + 'h ' + minute % 60 + 'min';
                }
              };

              this.userset.out_of_range_option = this.$t('On') + ' ' + time_format(this.userset.out_of_range_time);
            } else if ('Off' == this.userset.out_of_range_option) {
              this.userset.out_of_range_option = this.$t('Off');
            } else {
              this.userset.out_of_range_option = '--';
            }

            if (!this.userset.telephone) {
              this.userset.telephone = '--';
            }

            if (this.userset.clock) {
              var that = this;
              this.userset.clock.map(function (e, i) {
                e[1] = that.$t(e[1]);
              });
            }
            this.userset.suspend_on_lowbg_option = this.$t(this.userset.suspend_on_lowbg_option);
            if (this.userset.suspend_on_lowbg_option === this.$t('On')) {
              this.userset.suspend_on_lowbg_level = this.isMg ? parseInt(this.userset.suspend_on_lowbg_level) : this.userset.suspend_on_lowbg_level.toFixed(1);
              this.userset.suspend_on_lowbg_option_app = this.userset.suspend_on_lowbg_option;
            }

            if (this.userset.auto_basal) {
              var auto_basal = this.userset.auto_basal;

              var auto_basal_option = auto_basal.autobasalflag;
              auto_basal.autobasalflag = this.getOptionText(auto_basal.autobasalflag);

              if (this.isMg) {
                if (0 == auto_basal.BGTarget) {
                  auto_basal.BGTarget = '100 mg/dL';
                } else if (1 == auto_basal.BGTarget) {
                  auto_basal.BGTarget = '110 mg/dL';
                } else if (2 == auto_basal.BGTarget) {
                  auto_basal.BGTarget = '120 mg/dL';
                }
              } else {
                if (0 == auto_basal.BGTarget) {
                  auto_basal.BGTarget = '5.6 mmol/L';
                } else if (1 == auto_basal.BGTarget) {
                  auto_basal.BGTarget = '6.1 mmol/L';
                } else if (2 == auto_basal.BGTarget) {
                  auto_basal.BGTarget = '6.7 mmol/L';
                }
              }

              auto_basal.nFoodFlag = this.getOptionText(auto_basal.nFoodFlag);
              if (!auto_basal.AutoBasalWeight) {
                auto_basal.AutoBasalWeight = '--';
              }
              if (!auto_basal.AutoBasalTDD) {
                auto_basal.AutoBasalTDD = '--';
              }
            } else {
              this.userset.auto_basal = {
                autobasalflag: 'Off',
                BGTarget: '--',
                nFoodFlag: '--',
                AutoBasalWeight: '--',
                AutoBasalTDD: '--'
              };
            }

            this.IcRatio = data.bolus_settings.ins_carb_ratio;
            this.ins_sen = data.bolus_settings.ins_sen;
            this.bg_target = data.bolus_settings.bg_target;
            this.bolus_rem = data.bolus_settings.bolus_reminder;

            this.max_bolus = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getMaxBolus(data.bolus_settings.bolus_reminder);

            this.max_bolus_length = data.bolus_settings.bolus_reminder.length;
            this.initRatio();
            if (this.max_bolus_length > 0) {}
            var option = this.$t(data.bolus_settings.bolus_reminder_option);
            this.maxBolOption = ' (' + option + ')';

            this.cgmLimit = data.sensor_settings.sensor_alarm_threshold;

            this.userset.clock.map(function (e, i) {
              var time = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getTime2(e[0]);
              e[0] = time[0] + ":" + time[1];
              return e;
            });
            if (this.userset.clock.length) {
              this.userset.clock_option = 'on';
            } else {
              this.userset.clock_option = 'off';
            }

            var basal_select_map = {
              'ProgramC': 't1028_Pattern_C',
              'ProgramD': 't1028_Pattern_D',
              'Sick': 't1029_Sick'
            };
            if (basal_select_map[this.basal.basal_select]) {
              this.basal.basal_select = basal_select_map[this.basal.basal_select];
            }

            this.basal.basal_select = this.$t(this.basal.basal_select);
            this.basal.basal_onoff = this.$t(this.basal.basal_onoff);
            this.bolus.bg_reminder = this.$t(this.bolus.bg_reminder);
            this.bolus.extent_option = this.$t(this.bolus.extent_option);
            this.bolus.bolus_wizard = this.$t(this.bolus.bolus_wizard);
            this.userset.cgms_module_flag = this.$t(this.userset.cgms_module_flag);
            this.userset.cmd_response = this.$t(this.userset.cmd_response);
            this.userset.clock_option = this.$t(this.userset.clock_option);
            this.userset.pump_module_flag = this.$t(this.userset.pump_module_flag);

            this.cgm.sensor_rate_alarm.fall[0] = this.$t(this.cgm.sensor_rate_alarm.fall[0]);
            this.cgm.sensor_rate_alarm.rise[0] = this.$t(this.cgm.sensor_rate_alarm.rise[0]);
            this.cgm.sensor_alarm_repeat.high[0] = this.$t(this.cgm.sensor_alarm_repeat.high[0]);
            this.cgm.sensor_alarm_repeat.low[0] = this.$t(this.cgm.sensor_alarm_repeat.low[0]);
            this.cgm.sensor_forecast_alarm.high[0] = this.$t(this.cgm.sensor_forecast_alarm.high[0]);
            this.cgm.sensor_forecast_alarm.low[0] = this.$t(this.cgm.sensor_forecast_alarm.low[0]);
            this.cgm.sensor_alarm_settings.calib_remind_option = this.$t(this.cgm.sensor_alarm_settings.calib_remind_option);
            this.cgm.sensor_alarm_option = this.$t(this.cgm.sensor_alarm_option);
            this.cgm.alarm_silent_option = this.$t(this.cgm.alarm_silent_option);
          }
          if (this.showEasyPatch === 'easysense') {
            this.cgm.sensor_forecast_alarm.high[0] = data.SensorAlarmSetting[5] !== 1 && data.SensorAlarmSetting[5] !== true ? 'Off' : 'On';
            this.cgm.sensor_forecast_alarm.high[1] = data.SensorAlarmSetting[5] === 1 || data.SensorAlarmSetting[5] === true ? data.SensorAlarmSetting[6] : '--';
            this.cgm.sensor_forecast_alarm.low[0] = data.SensorAlarmSetting[7] !== 1 && data.SensorAlarmSetting[7] !== true ? 'Off' : 'On';
            this.cgm.sensor_forecast_alarm.low[1] = data.SensorAlarmSetting[7] === 1 || data.SensorAlarmSetting[7] === true ? data.SensorAlarmSetting[8] : '--';
            this.cgm.sensor_forecast_alarm.high[0] = this.$t(this.cgm.sensor_forecast_alarm.high[0]);
            this.cgm.sensor_forecast_alarm.low[0] = this.$t(this.cgm.sensor_forecast_alarm.low[0]);

            this.cgm.sensor_rate_alarm.fall[0] = data.SensorAlarmSetting[1] !== 1 && data.SensorAlarmSetting[1] !== true ? 'Off' : 'On';
            this.cgm.sensor_rate_alarm.rise[0] = data.SensorAlarmSetting[3] !== 1 && data.SensorAlarmSetting[3] !== true ? 'Off' : 'On';
            this.cgm.sensor_rate_alarm.fall[1] = this.cgm.sensor_rate_alarm.fall[0] !== "Off" ? data.SensorAlarmSetting[2].toFixed(3) : '--';
            this.cgm.sensor_rate_alarm.rise[1] = this.cgm.sensor_rate_alarm.rise[0] !== "Off" ? data.SensorAlarmSetting[4].toFixed(3) : '--';
            this.cgm.sensor_rate_alarm.fall[0] = this.$t(this.cgm.sensor_rate_alarm.fall[0]);
            this.cgm.sensor_rate_alarm.rise[0] = this.$t(this.cgm.sensor_rate_alarm.rise[0]);

            this.cgm.easypatch_cgm_alerts_low_repeat = data.GlucoseSettings.AlarmLowRepeat;
            this.cgm.easypatch_cgm_alerts_low_snooze = data.GlucoseSettings.AlarmLowSnooze;
            this.cgm.easypatch_cgm_alerts_low_tone = data.GlucoseSettings.AlarmLowTone;

            this.cgm.easypatch_cgm_alerts_high_repeat = data.GlucoseSettings.AlarmHighRepeat;
            this.cgm.easypatch_cgm_alerts_high_snooze = data.GlucoseSettings.AlarmHighSnooze;
            this.cgm.easypatch_cgm_alerts_high_tone = data.GlucoseSettings.AlarmHighTone;

            this.cgm.easypatch_cgm_alerts_other_repeat = data.GlucoseSettings.AlarmRepeat;
            this.cgm.easypatch_cgm_alerts_other_snooze = data.GlucoseSettings.AlarmSnooze;
            this.cgm.easypatch_cgm_alerts_other_tone = data.GlucoseSettings.AlarmTone;

            this.userset.glucose_unit = data.UnitGlucose === 1 ? 'mmol/L' : 'mg/dL';
            this.userset.easypatch_height_unit = data.UnitHeight === 1 ? 'cm' : '';
            this.userset.easypatch_weight_unit = data.UnitWeight === 1 ? 'kg' : '';
            var str = '';
            if (data.GeneralAlarmSetting[0] === 1 && data.GeneralAlarmSetting[1] !== 1 || data.GeneralAlarmSetting[0] === true && data.GeneralAlarmSetting[1] !== true) {
              str = 'Sound';
            } else if (data.GeneralAlarmSetting[0] !== 1 && data.GeneralAlarmSetting[1] === 1 || data.GeneralAlarmSetting[0] !== true && data.GeneralAlarmSetting[1] === true) {
              str = 'Vibrate';
            } else if (data.GeneralAlarmSetting[0] === 1 && data.GeneralAlarmSetting[1] === 1 || data.GeneralAlarmSetting[0] === true && data.GeneralAlarmSetting[1] === true) {
              str = 'Sound+Vibrate';
            }
            this.userset.alarm_type = this.$t(str);
            var ar1 = data.SensorAlarmSetting.splice(10);
            var resule = [];
            for (var _i = 0; _i < ar1.length; _i += 3) {
              resule.push(ar1.slice(_i, _i + 3));
            }
            for (var j = 0; j < resule.length; j++) {
              resule[j][0] = this.ChangeHourMinutestr(resule[j][0]);
              if ('mg/dL' !== this.userset.glucose_unit) {
                resule[j][1] = Number(resule[j][1] / 18).toFixed(1);
                resule[j][2] = Number(resule[j][2] / 18).toFixed(1);
              }
            }
            this.cgmLimit = resule;
            console.log('da', resule);
            this.userset.sensor_expire_option = data.SensorAlarmOverdueEnabled ? 'On' : 'Off';
            this.userset.factory_calibration_option = data.SensorCodeEnable ? 'On' : 'Off';
            this.cgm.sensor_alarm_option = data.SensorAlarmSetting[0] !== 1 && data.SensorAlarmSetting[0] !== true ? 'Off' : 'On';
            this.cgm.sensor_alarm_option = this.$t(this.cgm.sensor_alarm_option);
            this.tranSN = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].deviceSNFormat(data.sensor_sn, "TRANS");
            this.cgm.easypatch_cgm_alerts_low_tone = this.cgm.easypatch_cgm_alerts_low_tone ? this.cgm.easypatch_cgm_alerts_low_tone.split(".")[0] : this.cgm.easypatch_cgm_alerts_low_tone;
            this.cgm.easypatch_cgm_alerts_high_tone = this.cgm.easypatch_cgm_alerts_high_tone ? this.cgm.easypatch_cgm_alerts_high_tone.split(".")[0] : this.cgm.easypatch_cgm_alerts_high_tone;
            this.cgm.easypatch_cgm_alerts_other_tone = this.cgm.easypatch_cgm_alerts_other_tone ? this.cgm.easypatch_cgm_alerts_other_tone.split(".")[0] : this.cgm.easypatch_cgm_alerts_other_tone;
            this.cgm.easypatch_cgm_alerts_hypo_tone = this.cgm.easypatch_cgm_alerts_hypo_tone ? this.cgm.easypatch_cgm_alerts_hypo_tone.split(".")[0] : this.cgm.easypatch_cgm_alerts_hypo_tone;

            this.userset.glucose_unit = data.UnitGlucose === 1 ? 'mmol/L' : 'mg/dL';
            this.userset.easypatch_height_unit = data.UnitHeight === 1 ? 'cm' : 'ft';
            this.userset.easypatch_weight_unit = data.UnitWeight === 1 ? 'kg' : 'lb';
            this.userset.user_name = data.user_name;
            this.cgm.sensor_forecast_alarm.high[1] = data.SensorAlarmSetting[5] === 1 || data.SensorAlarmSetting[5] === true ? this.ChangeHourMinutestr(data.SensorAlarmSetting[6]) : '--';
            this.cgm.sensor_forecast_alarm.low[1] = data.SensorAlarmSetting[7] === 1 || data.SensorAlarmSetting[7] === true ? this.ChangeHourMinutestr(data.SensorAlarmSetting[8]) : '--';
            if ('mg/dL' == this.userset.glucose_unit) {
              this.cgm.sensor_rate_alarm.fall[1] = this.cgm.sensor_rate_alarm.fall[0] !== "Off" ? data.SensorAlarmSetting[4].toFixed(3) : '--';
              this.cgm.sensor_rate_alarm.rise[1] = this.cgm.sensor_rate_alarm.rise[0] !== "Off" ? data.SensorAlarmSetting[2].toFixed(3) : '--';
            } else {

              this.cgm.sensor_rate_alarm.fall[1] = this.cgm.sensor_rate_alarm.fall[0] !== "Off" ? (data.SensorAlarmSetting[4] / 1800).toFixed(3) : '--';
              this.cgm.sensor_rate_alarm.rise[1] = this.cgm.sensor_rate_alarm.rise[0] !== "Off" ? (data.SensorAlarmSetting[2] / 1800).toFixed(3) : '--';
            }
          }

          if (this.chart6_1) {
            this.chart6_1.dispose();
          }
          if (this.chart6_2) {
            this.chart6_2.dispose();
          }
          if (this.chart6_3) {
            this.chart6_3.dispose();
          }
          if (this.chart6_4) {
            this.chart6_4.dispose();
          }
          if (this.chart6_5) {
            this.chart6_5.dispose();
          }

          if (true) {
            if (this.chart6_6) {
              this.chart6_6.dispose();
            }
            if (this.chart6_7) {
              this.chart6_7.dispose();
            }
            if (this.chart6_8) {
              this.chart6_8.dispose();
            }
          }
          this.drawCharts();
        }
      }, function (err) {
        alert('error!');
      });
    },
    cancel: function cancel() {
      this.typeChooseVisible = false;
    },
    open: function open() {
      this.tempSelectId = this.selectId;
      this.typeChooseVisible = true;
    },
    nextPage: function nextPage() {
      if (this.page < this.pages) {
        this.page++;
        this.getPdm1();
      }
    },
    prevPage: function prevPage() {
      if (this.page > 1) {
        this.page--;
        this.getPdm1();
      }
    },
    go: function go() {
      if (0 < this.page && this.page < this.pages + 1) {
        this.getPdm1();
      } else {
        this.page = 1;
        this.getPdm1();
      }
    },
    choose: function choose(e) {
      sessionStorage.setItem('chart6page', this.page);
      var parent = document.getElementById('pdm');
      var labels = parent.getElementsByTagName('label');
      console.log('choose.1:', e.target.id);
      this.tempSelectId = e.target.id;

      if (e.target.className === '') {
        for (var i = 0; i < labels.length; i++) {
          if (e.target === labels[i]) {
            e.target.className = 'no';
            this.index = e.target.id;
          } else {
            labels[i].className = '';
          }
        }
      } else {
        e.target.className = '';
      }
    },
    apply: function apply() {
      console.log('apply.1:', this.index, this.tempSelectId);
      var selectPdmSN = '';
      var preTime = sessionStorage.getItem('time6');
      this.selectId = this.tempSelectId;
      if (this.selectId) {
        console.log('apply.2:', this.index);
        for (var i = 0; i < this.PDM.length; i++) {
          var record = this.PDM[i];
          if (record[0] == this.selectId) {
            this.rid = record[0];
            this.time = record[1] + ', ' + record[2];
            this.index = i;
            selectPdmSN = record[2];
            break;
          }
          var index = this.index;
        }
        sessionStorage.setItem('time6', this.time);
        sessionStorage.setItem('rid', this.rid);
        sessionStorage.setItem('pdmSN', selectPdmSN);
        if (this.index === '0') {
          var that = this;
        }
        this.getPdm2();
      } else {
        this.typeChooseVisible = false;
      }
      if (preTime !== this.time) {
        this.$emit('reload');
      }
    },
    drawChart6_1: function drawChart6_1(chartId, basalPattern, chartTitle, axisMax) {
      var basal_unit2 = this.$t('basal_unit2');
      this[chartId] = __WEBPACK_IMPORTED_MODULE_1_echarts__["init"](document.getElementById(chartId));
      this.registLoading(chartId, this[chartId]);
      this[chartId].setOption({
        title: {
          text: chartTitle + ' ' + this.$t('basal_unit'),

          textStyle: this.textStyle,
          padding: this.titlePadding
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'line', lineStyle: { color: '#333' } },
          backgroundColor: '#333',
          textStyle: {
            color: '#ffffff'
          },
          formatter: function formatter(params) {
            var date = new Date(params[0].value[0]);
            var time = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate5(date);
            var icon = " <div style='background: #00ff4c;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
            var timeDetail = time[0] + ':' + time[1] + '<br>';
            return timeDetail + icon + 'Basal: ' + params[0].value[1].toFixed(2) + basal_unit2;
          }
        },
        xAxis: [{
          type: 'time',
          boundaryGap: false,
          min: new Date(new Date().setHours(0, 0, 0, 0)),
          max: new Date(new Date().setHours(0, 0, 0, 0) + 86400000),
          axisLine: { lineStyle: { color: '#ccc' } },
          splitNumber: 24,
          splitLine: {
            show: true,
            lineStyle: {
              color: ['#ccc'],
              type: 'solid'
            }
          },
          axisLabel: {
            showMaxLabel: true,
            margin: 20, textStyle: { color: '#282828', baseline: 'middle' },
            formatter: function formatter(value, index) {
              var zero_hour = new Date();
              zero_hour.setHours(0, 0, 0, 0);
              index = (value - zero_hour.getTime()) / 3600000;
              var H = index;
              if (index < 24) {
                if (index % 3 === 0) {
                  H = H < 10 ? '0' + H + ':00' : H + ':00';
                  return H;
                } else {
                  return ' ';
                }
              } else {
                return '24:00';
              }
            }
          }
        }],
        yAxis: [{
          type: 'value',
          min: 0,

          max: axisMax,
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          boundaryGap: false,
          axisTick: { length: 0 },
          splitLine: { show: true },
          splitNumber: 2
        }],
        grid: this.grid,
        series: [{
          type: 'line',
          step: 'end',
          data: basalPattern,
          itemStyle: { normal: { color: '#0e0' } },
          symbolSize: 1
        }]
      });
    },
    drawLine: function drawLine() {
      var canvas = document.getElementById('canvas');
      if (canvas) {
        var context = canvas.getContext('2d');
        context.strokeStyle = '#d3d3d3';
        context.lineWidth = '1px';
        context.beginPath();
        context.moveTo(0, 0);
        context.lineTo(95, 36);
        context.stroke();
      }
    },
    drawLine2: function drawLine2() {
      var canvas2 = document.getElementById('canvas2');
      if (canvas2) {
        var context = canvas2.getContext('2d');
        context.strokeStyle = '#d3d3d3';
        context.lineWidth = '1px';
        context.beginPath();
        context.moveTo(0, 0);
        context.lineTo(95, 46);
        context.stroke();
      }
    },
    handleResize: function handleResize() {
      var win = window.innerWidth;
      var scale = win < 1500 ? 0.91 : 0.62;
      var chartWidth = win * scale * 0.98 * 0.90 + 'px';
      var chart6_1 = document.getElementById('chart6_1');
      if (chart6_1) {
        chart6_1.style.width = chartWidth;
      }

      var chart6_2 = document.getElementById('chart6_2');
      if (chart6_2) {
        chart6_2.style.width = chartWidth;
      }

      var chart6_3 = document.getElementById('chart6_3');
      if (chart6_3) {
        chart6_3.style.width = chartWidth;
      }

      var chart6_4 = document.getElementById('chart6_4');
      if (chart6_4) {
        chart6_4.style.width = chartWidth;
      }

      var chart6_5 = document.getElementById('chart6_5');
      if (chart6_5) {
        chart6_5.style.width = chartWidth;
      }

      if (true) {
        var chart6_6 = document.getElementById('chart6_6');
        console.log('chart6_6:', chart6_6);
        if (chart6_6) {
          chart6_6.style.width = chartWidth;
        }
        var chart6_7 = document.getElementById('chart6_7');
        if (chart6_7) {
          chart6_7.style.width = chartWidth;
        }
        var chart6_8 = document.getElementById('chart6_8');
        if (chart6_8) {
          chart6_8.style.width = chartWidth;
        }
      }
    },
    ChangeHourMinutestr: function ChangeHourMinutestr(str) {
      if (str !== "0" && str !== "" && str !== null) {
        return (Math.floor(str / 60).toString().length < 2 ? "0" + Math.floor(str / 60).toString() : Math.floor(str / 60).toString()) + ":" + ((str % 60).toString().length < 2 ? "0" + (str % 60).toString() : (str % 60).toString());
      } else {
        return "";
      }
    },
    drawCharts: function drawCharts() {
      this.drawChart6_1('chart6_1', this.standBasal, this.$t('Standard'), this.axisMaxArr[0]);
      this.drawChart6_1('chart6_2', this.exeBasal, this.$t('Exercise'), this.axisMaxArr[1]);
      this.drawChart6_1('chart6_3', this.holidayBasal, this.$t('Holiday'), this.axisMaxArr[2]);
      this.drawChart6_1('chart6_4', this.programA, this.$t('ProgramA'), this.axisMaxArr[3]);
      this.drawChart6_1('chart6_5', this.programB, this.$t('ProgramB'), this.axisMaxArr[4]);
      if (this.moreBasal) {
        this.drawChart6_1('chart6_6', this.programC, this.$t('t1028_Pattern_C'), this.axisMaxArr[5]);
        this.drawChart6_1('chart6_7', this.programD, this.$t('t1028_Pattern_D'), this.axisMaxArr[6]);
        this.drawChart6_1('chart6_8', this.sickBasal, this.$t('t1029_Sick'), this.axisMaxArr[7]);
      }
    },
    print: function print() {
      if (sessionStorage.getItem('rid')) {
        console.log('dse.print.1');
        var src1 = this.chart6_1.getDataURL();
        sessionStorage.setItem('src6_1', src1);

        console.log('dse.print.2');
        var src2 = this.chart6_2.getDataURL();
        sessionStorage.setItem('src6_2', src2);

        console.log('dse.print.3');
        var src3 = this.chart6_3.getDataURL();
        sessionStorage.setItem('src6_3', src3);

        console.log('dse.print.4');
        var src4 = this.chart6_4.getDataURL();
        sessionStorage.setItem('src6_4', src4);

        console.log('dse.print.5');
        var src5 = this.chart6_5.getDataURL();
        sessionStorage.setItem('src6_5', src5);

        if (this.chart6_6) {
          console.log('dse.print.6:', this.chart6_6);
          var src6 = this.chart6_6.getDataURL();
          sessionStorage.setItem('src6_6', src6);

          console.log('dse.print.7');
          var src7 = this.chart6_7.getDataURL();
          sessionStorage.setItem('src6_7', src7);

          console.log('dse.print.8');
          var src8 = this.chart6_8.getDataURL();
          sessionStorage.setItem('src6_8', src8);
        }

        window.open('/#/chart6-print', '_blank');
      } else {
        var tip = this.$t('chooseDataTip');
        this.$message({
          type: 'warning',
          message: tip
        });
      }
    },
    print2: function print2() {
      if (sessionStorage.getItem('rid')) {
        var src1 = this.chart6_1.getDataURL();
        sessionStorage.setItem('src6_1', src1);

        var src2 = this.chart6_2.getDataURL();
        sessionStorage.setItem('src6_2', src2);

        var src3 = this.chart6_3.getDataURL();
        sessionStorage.setItem('src6_3', src3);

        var src4 = this.chart6_4.getDataURL();
        sessionStorage.setItem('src6_4', src4);

        var src5 = this.chart6_5.getDataURL();
        sessionStorage.setItem('src6_5', src5);

        var src6 = this.chart6_6.getDataURL();
        sessionStorage.setItem('src6_6', src6);

        var src7 = this.chart6_7.getDataURL();
        sessionStorage.setItem('src6_7', src7);

        var src8 = this.chart6_8.getDataURL();
        sessionStorage.setItem('src6_8', src8);

        window.open('/#/chart6-print2', '_blank');
      } else {
        var tip = this.$t('chooseDataTip');
        this.$message({
          type: 'warning',
          message: tip
        });
      }
    },
    makeRatio: function makeRatio() {
      return;
      var tr = document.getElementById('maxBolus');
      var Ratio = this.max_bolus;
      for (var i = 0; i < Ratio.length; i++) {
        if (Ratio[i].length === 2) {
          for (var j = 1; j < Ratio[i][1] + 1; j++) {
            var td = tr.getElementsByTagName('td')[Ratio[i][0] + j];
            td.style.backgroundColor = '#add9ff';
            td.style.borderLeft = 'none';
            if (j !== Ratio[i][1]) {
              td.style.borderRight = 'none';
            }
          }
        }
      }
    },
    initRatio: function initRatio() {}
  },
  mounted: function mounted() {
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isEs = lang === 'es' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    this.unit = this.isMg ? 'mg/dL' : 'mmol/L';
    this.unit1 = this.isMg ? 'mg/dL' : 'mmol/L';
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }
    this.page = sessionStorage.getItem('chart6page');
    if (!this.page) {
      this.page = 1;
    }
    __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getPdm1(this, this.uid, {
      page: this.page,
      flag: 'web'
    });

    if (sessionStorage.getItem('rid')) {}
    var that = this;

    var win = window.innerWidth;
    this.dialogSize = win < 1500 ? 'small' : 'tiny';
    window.onresize = function () {
      that.handleResize();
      if (that.chart6_1) {
        that.chart6_1.resize();
      }
      if (that.chart6_2) {
        that.chart6_2.resize();
      }
      if (that.chart6_3) {
        that.chart6_3.resize();
      }
      if (that.chart6_4) {
        that.chart6_4.resize();
      }
      if (that.chart6_5) {
        that.chart6_5.resize();
      }

      if (true) {
        if (that.chart6_6) {
          that.chart6_6.resize();
        }
        if (that.chart6_7) {
          that.chart6_7.resize();
        }
        if (that.chart6_8) {
          that.chart6_8.resize();
        }
      }
    };
  }
});

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_format__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_base64__ = __webpack_require__(9);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isA: false, value2: '', value3: '', uid: 0, st: 0, et: 0, basal: [], bolus: [], timeSection: [],
      staTime: '', endTime: '', timeRange2: '', isMg: '', isEn: '', loading: false, basalMax: 5,
      custo: false, value4: '', timeType: '', update_time: '',

      ts: [[], []], sg1: [], sgHalf: [], target_high: '', target_low: '', bolus1: [], bolCount: [], sg: [],
      typeChooseVisible: false, dialogSize: 'tiny', sgMax: 25, bolusMax: 20,
      sgDate: ['00:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30', '06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30'],
      sgDate1: ['00:00', '', '01:00', '', '02:00', '', '03:00', '', '04:00', '', '05:00', '', '06:00', '', '07:00', '', '08:00', '', '09:00', '', '10:00', '', '11:00', '', '12:00', '', '13:00', '', '14:00', '', '15:00', '', '16:00', '', '17:00', '', '18:00', '', '19:00', '', '20:00', '', '21:00', '', '22:00', '', '23:00', ''],
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          var t1 = time.getTime();
          var d2 = new Date();
          var t2 = d2.getTime();

          return t1 > t2 || t1 < t2 - 730 * 86400 * 1000;
        }
      },

      date: ['', '', '', '', '', ''],
      textStyle: {
        color: '#282828',
        fontWeight: 'normal',
        fontSize: '14',
        fontFamily: 'SFUIText-Regular'
      },
      titlePadding: [0, 0, 8, 33],
      grid: { x: '4%', y: '16%', width: '90%', height: '75%' }, legend1Right: '', legend2Right: '',
      sgRange: [['', '4.4', '8.9', '13.3', '17.8', '22.2'], ['', '0.2', '0.4', '0.6', '0.8', '1.0'], ['', '1', '2', '3', '4', '5'], ['0', '1', '2', '3', '4', '5'], ['', this.$t('Light'), '', this.$t('Medium'), '', this.$t('heavy')]],
      dateTime: ["00:00", " ", "", "3:00", "", "", "6:00", "", "", "9:00", "", "", "12:00", "", "", "15:00", "", "", "18:00", "", "", "21:00", "", "", "24:00"],
      yAxisLabel: { interval: 0, margin: 5, textStyle: { color: '#282828', baseline: 'middle' }, showMinLabel: false },
      axisPointer: {
        type: 'line',
        axis: 'x',
        lineStyle: { color: '#777' }
      }
    };
  },

  methods: {
    drawChart1_1: function drawChart1_1() {
      var that = this;
      this.chart1_1 = __WEBPACK_IMPORTED_MODULE_1_echarts__["init"](document.getElementById('chart1_1'));
      this.chart1_1.setOption({
        title: {
          text: this.isMg ? this.$t('Sensor Glucose Profile') + ' (mg/dL)' : this.$t('Sensor Glucose Profile') + ' (mmol/L)',
          textStyle: this.textStyle,
          padding: this.titlePadding
        },
        xAxis: [{
          type: 'category',
          data: this.sgDate,
          axisLabel: { show: false, interval: 0 },
          axisLine: { lineStyle: { color: '#ccc' } }
        }],
        yAxis: [{
          type: 'value',
          min: 0,
          max: this.sgMax,
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          boundaryGap: false,
          axisTick: { length: 0 }
        }, {
          type: 'value',
          min: 0,
          max: this.sgMax,
          axisLabel: { show: false },
          axisLine: { lineStyle: { color: '#ccc' } },
          boundaryGap: false,
          axisTick: { length: 0 }
        }],
        tooltip: {
          trigger: 'axis',
          confine: true,
          axisPointer: this.axisPointer,
          backgroundColor: '#333',
          formatter: function formatter(params) {
            var tip = that.tooltipFormat(params, that);
            return tip;
          }
        },
        grid: this.grid,
        legend: {
          selectedMode: false,
          itemWidth: 50,
          itemHeight: 110,
          right: this.legend1Right,
          top: 'middle',
          data: [{ name: '25%', icon: 'image://static/segLegend/legend1.png' }],
          textStyle: { color: 'rgba(0,0,0,0)' }
        },
        series: [{
          name: '10%',
          type: 'bar',
          barWidth: '60%',
          stack: 'sg',
          data: this.sg1[0],
          itemStyle: {
            normal: {
              barBorderColor: 'rgba(0,0,0,0)',
              color: 'rgba(0,0,0,0)'
            },
            emphasis: {
              barBorderColor: 'rgba(0,0,0,0)',
              color: 'rgba(0,0,0,0)'
            }
          },
          markLine: {
            data: [{ yAxis: this.isMg ? this.target_low * 18 : this.target_low }],
            symbol: ['circle', 'circle'],
            silent: true,
            symbolSize: 1,
            lineStyle: { normal: {
                color: '#2cd200',
                type: 'solid'
              } },
            label: { normal: { show: false } }
          },
          markArea: {
            data: [[{ yAxis: this.isMg ? this.target_low * 18 : this.target_low }, { yAxis: this.isMg ? this.target_high * 18 : this.target_high }]],
            tooltip: { show: false },
            itemStyle: {
              normal: {
                color: 'rgba(211,255,213,0.6)'
              }
            }
          }
        }, {
          name: '25%',
          type: 'bar',
          stack: 'sg',
          data: this.sg1[1],
          itemStyle: {
            normal: {
              barBorderRadius: [0, 0, 20, 20],
              color: '#a2ebff'
            }
          },
          markLine: {
            data: [{ yAxis: this.isMg ? this.target_high * 18 : this.target_high }],
            symbol: ['circle', 'circle'],
            silent: true,
            symbolSize: 1,
            lineStyle: { normal: {
                color: '#2cd200',
                type: 'solid'
              } },
            label: { normal: { show: false } }
          }
        }, {
          name: '75%',
          type: 'bar',
          stack: 'sg',
          data: this.sg1[2],
          itemStyle: {
            normal: {
              color: '#00ceef'
            }

          }
        }, {
          name: '90%',
          type: 'bar',
          stack: 'sg',
          data: this.sg1[3],
          itemStyle: {
            normal: {
              barBorderRadius: [20, 20, 0, 0],
              color: '#a2ebff'
            }

          }
        }, {
          type: 'line',
          data: this.sgHalf,
          itemStyle: { normal: {
              color: 'transparent',
              borderColor: '#0095ff',
              borderWidth: 1
            } },
          lineStyle: { normal: {
              color: '#e89b00',
              width: 1
            } },
          symbol: 'diamond',
          symbolSize: 4
        }]
      });
    },
    drawChart1_3: function drawChart1_3() {
      var that = this;
      this.chart1_3 = __WEBPACK_IMPORTED_MODULE_1_echarts__["init"](document.getElementById('chart1_3'));
      this.chart1_3.setOption({
        title: [{}],
        tooltip: {
          trigger: 'axis',
          confine: true,
          axisPointer: this.axisPointer,
          backgroundColor: '#333',
          formatter: function formatter(params) {
            var tip = that.tooltipFormat2(params[0], that);
            return tip;
          }
        },
        xAxis: [{
          type: 'category',
          data: this.sgDate,
          axisLabel: { show: false, interval: 0 },
          axisLine: { lineStyle: { color: '#ccc' } }
        }],
        legend: {
          selectedMode: false,
          itemWidth: 50,
          itemHeight: 118,
          right: this.legend2Right,
          top: 'middle',
          data: [{ name: 'bolus', icon: 'image://static/segLegend/legend2.png' }],
          textStyle: { color: 'rgba(0,0,0,0)' }
        },
        yAxis: [{
          type: 'value',
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          min: 0,
          max: this.bolusMax,
          boundaryGap: false,
          splitLine: { show: false },
          axisTick: { length: 0 },
          name: this.$t('Bolus Insulin') + ' ' + this.$t('ins_unit'),
          nameTextStyle: {
            color: '#000',
            fontWeight: 'normal',
            fontSize: '13',
            fontFamily: 'SFUIText-Regular'
          },
          nameLocation: 'middle',
          nameGap: 25
        }, {
          type: 'value',
          axisLabel: { show: false },
          axisLine: { lineStyle: { color: '#ccc' } },
          min: 0,
          max: this.bolusMax,
          axisTick: { length: 0 }
        }],
        grid: this.grid,
        series: [{
          name: 'bolus',
          type: 'boxplot',
          data: this.bolus1,
          hoverAnimation: false,
          boxWidth: ['30%', '35%'],
          itemStyle: { normal: { borderColor: '#0095ff' } }
        }]
      });
    },
    drawChart1_2: function drawChart1_2() {
      var that = this;
      var basal_unit = this.$t('basal_unit');
      var basal_unit2 = this.$t('basal_unit2');
      this.chart1_2 = __WEBPACK_IMPORTED_MODULE_1_echarts__["init"](document.getElementById('chart1_2'));
      this.chart1_2.setOption({
        title: [{
          text: this.update_time,
          textStyle: this.textStyle,
          padding: [5, 0, 8, 50]
        }],
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'line', lineStyle: { color: '#333' } },
          backgroundColor: '#333',
          formatter: function formatter(params) {
            var icon = " <div style='background: #00ff4c;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
            var timeDetail = '',
                value = '';
            params.map(function (e) {
              timeDetail = e.value[2] + '<br>';
              value = e.value[1];
            });
            return timeDetail + icon + 'Basal: ' + value + basal_unit2;
          }
        },
        xAxis: [{
          type: 'time',
          boundaryGap: false,
          min: new Date(this.ts[0][0] * 1000),
          max: new Date(this.ts[0][1] * 1000),
          interlval: 0,
          axisLabel: {
            margin: 10, textStyle: { color: '#282828', baseline: 'middle' },
            formatter: function formatter(value, index) {
              var H = that.getXlabel(value, index);
              return H;
            }
          },
          axisLine: { lineStyle: { color: '#ccc' } },
          splitNumber: 24
        }],
        yAxis: [{
          type: 'value',
          boundaryGap: false,
          min: 0,
          max: this.basalMax,
          splitNumber: 5,
          axisTick: { length: 0 },
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          name: this.$t('Basal Pattern') + ' ' + this.$t('basal_unit'),
          nameTextStyle: {
            color: '#000',
            fontWeight: 'normal',
            fontSize: '13',
            fontFamily: 'SFUIText-Regular'
          },
          nameLocation: 'middle',
          nameGap: 25
        }],
        grid: this.grid,
        series: [{
          type: 'line',
          name: 'Basal',
          data: this.basal,

          itemStyle: { normal: { color: '#00ff40' } },
          symbolSize: 2
        }]
      });
    },
    getXlabel: function getXlabel(value, index) {
      var H = new Date(value).getHours();
      if (index < 24) {
        H = H < 10 ? '0' + H + ':00' : H + ':00';
        return H;
      } else {
        return '24:00';
      }
    },
    tooltipFormat: function tooltipFormat(params, context) {
      var tipArray = [0, 0, 0, 0, 0],
          tip = '',
          time = '',
          data = context.sg1;
      var icon1 = " <div style='background: #00ceef;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
      var icon2 = " <div style='background: #0095ff;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";

      if (params[0]) {
        time = context.getTimeRange(params[0].name);
      }
      tip = tip + time + '<br>';
      params.map(function (e, i) {
        var value = e.value;
        if (value !== undefined) {
          var seriesIndex = e.seriesIndex,
              dataIndex = e.dataIndex;
          if (seriesIndex === 0) {
            var realData = context.isMg ? data[0][dataIndex] : data[0][dataIndex].toFixed(1);
            tipArray[4] = icon1 + '10% : ' + ' ' + realData;
          }
          if (seriesIndex === 1) {
            var _realData = data[0][dataIndex] + data[1][dataIndex];
            _realData = context.isMg ? _realData : _realData.toFixed(1);
            tipArray[3] = icon2 + '25% : ' + ' ' + _realData;
          }
          if (seriesIndex === 4) {
            var _realData2 = context.isMg ? value : value.toFixed(1);
            tipArray[2] = icon2 + '50% : ' + ' ' + _realData2;
          }
          if (seriesIndex === 2) {
            var _realData3 = data[0][dataIndex] + data[1][dataIndex] + data[2][dataIndex];
            _realData3 = context.isMg ? _realData3 : _realData3.toFixed(1);
            tipArray[1] = icon2 + '75% : ' + ' ' + _realData3;
          }
          if (seriesIndex === 3) {
            var _realData4 = data[0][dataIndex] + data[1][dataIndex] + data[2][dataIndex] + data[3][dataIndex];
            _realData4 = context.isMg ? _realData4 : _realData4.toFixed(1);
            tipArray[0] = icon1 + '90% : ' + ' ' + _realData4;
          }
        }
      });
      tipArray.map(function (e, i) {
        if (e) {
          tip = tip + e + '<br>';
        }
      });
      return tip;
    },
    tooltipFormat2: function tooltipFormat2(params, context) {
      var index = params.seriesIndex,
          name = params.name,
          tip = '',
          value = params.value;
      if (index === 0 && value[1]) {
        var time = context.getTimeRange(name);
        var tip1 = ' - ' + '10%' + ' : ' + value[1] + '<br>';
        var tip2 = ' - ' + '25%' + ' : ' + value[2] + '<br>';
        var tip3 = ' - ' + '50%' + ' : ' + value[3] + '<br>';
        var tip4 = ' - ' + '75%' + ' : ' + value[4] + '<br>';
        var tip5 = ' - ' + '90%' + ' : ' + value[5] + '<br>';
        tip = time + '<br>' + tip5 + tip4 + tip3 + tip2 + tip1;
      }
      return tip;
    },
    getTimeRange: function getTimeRange(val) {
      var time = '',
          t1 = val.split(':');
      if (t1[1] === '00') {
        time = t1[0] + ':00' + ' - ' + t1[0] + ':30';
      } else {
        var t2 = parseInt(t1[0]) + 1;
        t2 = t2 < 10 ? '0' + t2 : t2;
        time = t1[0] + ':30' + ' - ' + t2 + ':00';
      }
      return time;
    },
    drawCharts: function drawCharts() {
      this.initCount();
      var timer = setTimeout(this.showCount, 500);
      this.drawChart1_1();
      this.drawChart1_3();
      this.drawChart1_2();
    },
    chartsDispose: function chartsDispose() {
      this.chart1_1.dispose();
      this.chart1_2.dispose();
      this.chart1_3.dispose();
    },
    handleResize: function handleResize() {
      var win = window.innerWidth;
      var scale = win < 1500 ? 0.91 : 0.62;
      var chartWidth = win * scale * 0.98 * 0.94 + 'px';
      var chart1_1 = document.getElementById('chart1_1');
      var chart1_2 = document.getElementById('chart1_2');
      var chart1_3 = document.getElementById('chart1_3');
      if (chart1_3) {
        chart1_1.style.width = chartWidth;
        chart1_2.style.width = chartWidth;
        chart1_3.style.width = chartWidth;
      }
    },
    showCount: function showCount() {
      var count = this.bolCount,
          length = this.bolCount.length;
      var tr = document.getElementById('count');

      for (var i = 0; i < length; i++) {
        var td = tr.getElementsByTagName('td')[count[i][0]];
        td.innerHTML = count[i][1];
      }
    },
    initCount: function initCount() {
      var tr = document.getElementById('count');
      var td = tr.getElementsByTagName('td');
      for (var i = 0; i < td.length; i++) {
        td[i].innerHTML = '';
      }
    },
    getData: function getData() {
      this.ts = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getTs(this.st, this.et);

      var param = {
        sg: { ts: this.ts },
        basal: { ts: this.ts },
        bolus: { ts: this.ts },
        event: { ts: this.ts },
        custom: {
          usemode: 'sa',
          ts: [this.st, this.et]
        }
      };

      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getSegment(this, this.uid, param);
      if (this.dayNum > 7) {
        this.openFullScreen();
      }
    },
    open: function open() {
      this.typeChooseVisible = true;
      this.ckeckType();
    },
    ckeckType: function ckeckType() {
      if (!this.custo) {
        if (this.dayNum === 7) {
          this.timeType = this.$t('7 days');
        } else if (this.dayNum === 14) {
          this.timeType = this.$t('14 days');
        } else if (this.dayNum === 30) {
          this.timeType = this.$t('30 days');
        } else if (this.dayNum === 90) {
          this.timeType = this.$t('90 days');
        } else {
          this.timeType = this.$t('Customize');
        }
      } else {
        this.timeType = this.$t('Customize');
      }
    },
    cancel: function cancel() {
      this.typeChooseVisible = false;
    },
    dateApply: function dateApply() {
      if (!this.value3) {
        var t = this.endTime.split('-');
        this.et = new Date(parseInt(t[2]), parseInt(t[1]) - 1, parseInt(t[0])).getTime() / 1000;
      } else {
        this.et = this.value3.getTime() / 1000;
      }
      var duration = document.getElementById('duration').value;
      if (duration === this.$t('7 days')) {
        this.dayNum = 7;
      }
      if (duration === this.$t('14 days')) {
        this.dayNum = 14;
      }
      if (duration === this.$t('30 days')) {
        this.dayNum = 30;
      }
      if (duration === this.$t('90 days')) {
        this.dayNum = 90;
      }
      if (duration === this.$t('Customize')) {
        if (this.value4) {
          var _t = this.value4.getTime() / 1000;
          this.dayNum = (this.et - _t) / 86400 + 1;
          if (this.dayNum < 0 || this.dayNum > 90) {
            this.$message.error('Segment Analysis Report Should Be 1-90 Days!');
            this.dayNum = 7;
          }
        } else {
          this.dayNum = 7;
        }
      }
      this.st = this.et - 86400 * (this.dayNum - 1);
      sessionStorage.setItem('st7', this.st);
      sessionStorage.setItem('et7', this.et);

      this.getDate();
      this.getData();
      this.typeChooseVisible = false;
    },
    getDate: function getDate() {
      this.date = [];
      for (var i = 0; i < this.dayNum; i++) {
        var day = this.st + i * 86400;
        var time = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate4(day);
        var weeks = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDay(this, day);
        this.date[i] = time + ' ' + weeks;
      }
      this.timeRange2 = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate2(this.st) + ' - ' + __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate2(this.st + (this.dayNum - 1) * 86400);
      this.staTime = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate4(this.st);
      this.endTime = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate4(this.et);
    },
    timeChange: function timeChange() {
      if (!this.value3) {
        var t = this.endTime.split('-');
        this.et = new Date(parseInt(t[2]), parseInt(t[1]) - 1, parseInt(t[0])).getTime() / 1000;
      } else {
        this.et = this.value3.getTime() / 1000;
      }
      var duration = document.getElementById('duration').value;
      if (duration === this.$t('7 days')) {
        this.dayNum = 7;
      }
      if (duration === this.$t('14 days')) {
        this.dayNum = 14;
      }
      if (duration === this.$t('30 days')) {
        this.dayNum = 30;
      }
      if (duration === this.$t('90 days')) {
        this.dayNum = 90;
      }
      if (duration === this.$t('Customize')) {
        this.custo = true;
        this.st = this.et - 86400 * 6;
      } else {
        this.custo = false;
        this.st = this.et - 86400 * (this.dayNum - 1);
      }
      this.staTime = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate4(this.st);
    },
    print: function print() {
      var src1 = this.chart1_1.getDataURL();
      var src2 = this.chart1_2.getDataURL();
      var src3 = this.chart1_3.getDataURL();
      sessionStorage.setItem('src7_1', src1);
      sessionStorage.setItem('src7_2', src2);
      sessionStorage.setItem('src7_3', src3);
      sessionStorage.setItem('timeRange7', this.timeRange2);
      sessionStorage.setItem('targetH7', this.target_high);
      sessionStorage.setItem('targetL7', this.target_low);
      sessionStorage.setItem('sg7', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.sg));
      sessionStorage.setItem('count7', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.bolCount));
      sessionStorage.setItem('st7', this.st);
      sessionStorage.setItem('et7', this.et);
      window.open('/#/chart7-print', '_blank');
    },
    openFullScreen: function openFullScreen() {
      this.loading = true;
    }
  },
  mounted: function mounted() {
    var win = window.innerWidth;
    this.dialogSize = win < 1500 ? 'small' : 'tiny';
    this.legend1Right = win < 1150 ? -35 : -30;
    this.legend2Right = win < 1150 ? -43 : -38;
    this.isEn = sessionStorage.getItem('language') !== 'zh' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    this.titleText = this.isMg ? this.$t('SG') + ' (mg/dL)' : this.$t('SG') + ' (mmol/L)';
    this.sgMax = this.isMg ? 400 : 25;
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }
    if (!sessionStorage.getItem('st7')) {
      var nd = new Date();
      var cur_day = new Date(nd.getFullYear(), nd.getMonth(), nd.getDate() - 1);
      this.et = cur_day / 1000;
      var chart_end_time = sessionStorage.getItem('chart_end_time');
      for (var d = 0; d < 3000; d++) {
        if (this.et > chart_end_time) {
          cur_day = new Date(cur_day.getFullYear(), cur_day.getMonth(), cur_day.getDate() - 1);
          this.et = cur_day / 1000;
        } else {
          break;
        }
      }
      this.st = this.et - 86400 * 6;
    } else {
      this.st = parseInt(sessionStorage.getItem('st7'));
      this.et = parseInt(sessionStorage.getItem('et7'));
    }
    sessionStorage.setItem('st7', this.st);
    sessionStorage.setItem('et7', this.et);
    this.dayNum = (this.et - this.st) / 86400 + 1;
    this.getDate();
    this.getData();
    var that = this;
    window.onresize = function () {
      that.handleResize();
      if (that.chart1_1) {
        that.chart1_1.resize();
        that.chart1_2.resize();
        that.chart1_3.resize();
      }
    };
  }
});

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_format__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_base64__ = __webpack_require__(9);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      value1: '', value2: '', defaultDate1: '', defaultDate2: '', isA: false, isB: false, value10: '', value11: '', loading: '', time: [0, 0],
      value5: '', value6: '', event: [0, 0, 0, { "note": 'BG', "value": '202mg/dL' }, 'web'], isWeb: false, isMg: false, isCz: false,
      type: 'Carbs', note: '', uid: 0, eids: [], EXEtime: '', detail: '', isEn: false, isEs: false, isDe: false, isIt: false, isPo: false, isDu: false,
      deta1: '', deta2: 'Light', deta3: '', deta4: 'Negative', deta5: '', deta6: '', deta7: '', filterFlag: false, info: {}, isFr: false, isSw: false,
      type1: true, type2: false, type3: false, type4: false, type5: false, type6: false, type7: false, type8: false,
      value4: new Date(), value3: '',
      eDetail1: '', eDetail2: '', eDetail3: '', eDetail4: '', eDetail5: '', eDetail6: '', eDetail7: '', eDetail8: '',
      eNote: '', edEXEtime: '', exeType: { Light: 0, Medium: 1, Heavy: 2 },

      edType1: true, edType2: false, edType3: false, edType4: false, edType5: false, edType6: false, edType7: false, edType8: false,
      urinekType: ['Negative', 'Macro', '+', '++', '+++', '++++'],
      Tr1: false, Tr2: false, Tr3: false, Tr4: false, Tr5: false, Tr6: false, Tr7: false,
      bgRange: '', unit: '',
      typeChooseVisible: false, timeRangeSelect: 1, timeIntervalSelect: 1, intervalOption: [], startDateDisable: true,
      startDate: '', defaultDate: '',
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          var t1 = time.getTime();
          var d2 = new Date();
          var t2 = d2.getTime();

          return t1 > t2 || t1 < t2 - 730 * 86400 * 1000;
        }
      }, dialogSize: 'tiny',
      activeIndex: '1', pages: '', page: 1, has_next: '', has_prev: '',
      isC: false, uids: [], flag: 0, order: 'desc', orderFlag: true, indexs: [],
      tip: this.$t('Input Notes'),
      st: 0, et: 1, eventTypeSelect: 'ALL', timeRange: ''
    };
  },

  computed: {
    events: function events() {
      return this.$store.state.events;
    }
  },
  methods: {
    getEvents: function getEvents() {
      if (this.filterFlag) {
        var param = __WEBPACK_IMPORTED_MODULE_3__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.info));
        __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].getEvents(this, this.uid, { param: param, page: this.page });
      } else {
        var _param = {
          page: this.page,
          'order': [['time', this.order]]
        };
        _param = __WEBPACK_IMPORTED_MODULE_3__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_param));
        __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].getEvents(this, this.uid, { param: _param, page: this.page });
      }
      this.start();
    },
    orderChange: function orderChange(e) {
      var obj = e.target;
      this.orderFlag = !this.orderFlag;
      if (this.orderFlag) {
        this.order = 'desc';
      } else {
        this.order = 'asc';
      }
      this.getEvents();
    },
    filter: function filter(e) {
      var type = e.target.value;
      if (type !== 'ALL') {
        if (this.value1 === '' && this.value2 === '') {
          this.info = {
            'filter': {
              'type': [type]
            },
            'tz': parseInt(sessionStorage.getItem('tz')),
            'order': [['time', this.order]]
          };
        } else {
          var st = 0;
          var et = 0;
          if (this.value1 === '' || this.value2 === '') {
            et = new Date().getTime() / 1000;
            st = et - 86400 * 6;
          } else {
            et = this.value1.getTime() / 1000;
            st = this.value2.getTime() / 1000;
          }
          this.info = {
            'filter': {
              'type': [type]
            },
            'st': st,
            'et': et,
            'tz': parseInt(sessionStorage.getItem('tz')),
            'order': [['time', this.order]]
          };
        }
        var param = __WEBPACK_IMPORTED_MODULE_3__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.info));
        this.filterFlag = true;
        __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].getEvents(this, this.uid, { param: param, page: this.page });
        this.start();
      } else {
        this.filterFlag = false;
        this.getEvents();
      }
    },
    filter2: function filter2() {
      var st = 0;
      var et = 0;
      if (this.value1 !== '' && this.value2 !== '') {
        et = this.value1.getTime() / 1000;
        st = this.value2.getTime() / 1000;
        if (st > et) {
          var tip = this.$t('The date choose wrong');
          this.$message.error(tip);
        } else {
          this.info = {
            'filter': {
              'type': []
            },
            'st': st,
            'et': et,
            'tz': parseInt(sessionStorage.getItem('tz')),
            'order': [['time', this.order]]
          };
          if (this.eventTypeSelect && 'ALL' != this.eventTypeSelect) {
            this.info['filter']['type'].push(this.eventTypeSelect);
          }
          var param = __WEBPACK_IMPORTED_MODULE_3__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.info));
          this.filterFlag = true;
          __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].getEvents(this, this.uid, { param: param, page: this.page });
        }
      }
    },
    procTimeRangeSelect: function procTimeRangeSelect(e) {
      console.log('procTimeRangeSelect:', this.timeRangeSelect);
      var daySpan = 0;
      if (1 == this.timeRangeSelect) {
        daySpan = 7;
      } else if (2 == this.timeRangeSelect) {
        daySpan = 14;
      } else if (3 == this.timeRangeSelect || 4 == this.timeRangeSelect) {
        daySpan = 30;
        if (4 == this.timeRangeSelect) {
          daySpan = 90;
        }
      }

      console.log('daySpan:', daySpan);
      if (daySpan) {
        this.st = this.et - 86400 * (daySpan - 1);
        this.startDate = __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate4(this.st);
        this.value2 = new Date(this.st * 1000);
      }
      if (0 == this.timeRangeSelect) {
        this.startDateDisable = false;
      } else {
        this.startDateDisable = true;
      }
      console.log('startDateDisable:', this.startDateDisable);
    },
    procTimeIntervalSelect: function procTimeIntervalSelect(e) {},
    procEventTypeSelect: function procEventTypeSelect(e) {},
    dateApply: function dateApply() {
      var daySpan = (this.et - this.st) / 86400 + 1;
      console.log('daySpan:', daySpan);
      if (daySpan > 90) {
        var tip = this.$t('dateErr1');
        this.$message.error(tip);
        return;
      }
      this.typeChooseVisible = false;
      this.updateTimeRange();
      this.filter2();

      sessionStorage.setItem('st8', this.st);
      sessionStorage.setItem('et8', this.et);
      sessionStorage.setItem('eventTypeSelect', this.eventTypeSelect);
      sessionStorage.setItem('timeRangeSelect8', this.timeRangeSelect);
    },
    startDateChange: function startDateChange() {
      this.st = this.value2.getTime() / 1000;
    },
    endDateChange: function endDateChange() {
      var daySpan = 0;
      if (1 == this.timeRangeSelect) {
        daySpan = 7;
      } else if (2 == this.timeRangeSelect) {
        daySpan = 14;
      } else if (3 == this.timeRangeSelect || 4 == this.timeRangeSelect) {
        daySpan = 30;
        if (4 == this.timeRangeSelect) {
          daySpan = 90;
        }
      }

      this.et = this.value1.getTime() / 1000;

      console.log('daySpan:', daySpan, this.et);
      if (daySpan) {
        this.st = this.et - 86400 * (daySpan - 1);
        this.startDate = __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate4(this.st);
        this.value2 = new Date(this.st * 1000);
      }
      if (0 == this.timeRangeSelect) {
        this.startDateDisable = false;
      } else {
        this.startDateDisable = true;
      }
      console.log('startDateDisable:', this.startDateDisable);
    },
    start: function start() {
      var table = document.getElementById('patientList');
      var labels = table.getElementsByTagName('label');
      for (var i = 0; i < labels.length; i++) {
        labels[i].className = "";
      }
    },
    chooseAll: function chooseAll() {
      var table = document.getElementById('patientList');
      var labels = table.getElementsByTagName('label');
      for (var i = 0; i < labels.length; i++) {
        if (this.flag === 0) {
          labels[i].className = 'checked';
          if (this.events[i]) {
            var eid = this.events[i][5];
            this.eids.push(eid);
            this.indexs.push(i);
          }
        } else {
          labels[i].className = '';
          this.eids = [];
          this.indexs = [];
        }
      }

      if (labels[0].className === 'checked') {
        this.flag = 1;
      } else {
        this.flag = 0;
      }
    },
    select: function select(e) {
      var index = e.target.id;
      var parent = document.getElementById('patientList');
      var labels = parent.getElementsByTagName('label');
      var eid = this.events[index][5];
      if (e.target.className === "") {
        e.target.className = 'checked';
        this.eids.push(eid);
        this.indexs.push(parseInt(index));
        for (var i = 1; i < labels.length; i++) {
          if (labels[i].className === 'checked') {
            this.count++;
          }
        }
        if (this.count === labels.length - 1) {
          labels[0].className = "checked";
        }
        this.count = 0;
      } else {
        e.target.className = "";
        labels[0].className = "";
        for (var _i = 0; _i < this.eids.length; _i++) {
          if (eid === this.eids[_i]) {
            this.eids.splice(_i, 1);
            this.indexs.splice(_i, 1);
          }
        }
      }
    },
    delete1: function delete1(e) {
      var _this = this;

      var tip = this.$t('deleteThis');
      var tip1 = this.$t('confirm');
      var tip2 = this.$t('Yes');
      var tip3 = this.$t('Cancel');
      this.$confirm(tip, tip1, {
        confirmButtonText: tip2,
        cancelButtonText: tip3,
        type: 'warning'
      }).then(function () {
        var index = e.target.parentNode.parentNode.id;
        var eid = _this.events[index][5];
        var eids = [];
        eids.push(eid);
        __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].deleteEvents(_this, _this.uid, eids);
      }, function () {});
    },
    delete2: function delete2() {
      var _this2 = this;

      if (this.eids.length > 0) {
        var tip = this.$t('deleteEvents');
        var tip1 = this.$t('confirm');
        var tip2 = this.$t('Yes');
        var tip3 = this.$t('Cancel');
        this.$confirm(tip, tip1, {
          confirmButtonText: tip2,
          cancelButtonText: tip3,
          type: 'warning'
        }).then(function () {
          __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].deleteEvents(_this2, _this2.uid, _this2.eids);
        }, function () {});
      }
    },
    create: function create() {
      this.isA = true;
      this.initAdd();
    },
    initAdd: function initAdd() {
      this.type = this.$t('carbs');this.note = '';
      this.Tr1 = false;this.Tr2 = false;this.Tr3 = false;this.Tr5 = false;this.Tr6 = false;this.Tr7 = false;
      this.deta4 = 'Negative';this.deta2 = 'Light';this.deta1 = '';this.deta3 = '';this.deta5 = '';this.deta6 = '';this.deta7 = '';this.EXEtime = '';
      this.type1 = true;this.type2 = false;this.type3 = false;this.type4 = false;this.type5 = false;this.type6 = false;this.type7 = false;this.type8 = false;
      var st1 = __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate3(new Date().getTime() / 1000) + ' 00:00:00';
      var st2 = Date.parse(st1.replace(/-/g, "/"));
      this.value3 = new Date(st2);
      this.value4 = new Date();
    },
    cancel: function cancel() {
      this.isA = false;
    },
    cancelSet: function cancelSet() {
      this.typeChooseVisible = false;
    },
    open: function open() {
      this.typeChooseVisible = true;
    },
    check: function check(index) {
      if (index === 1) {
        if (isNaN(this.deta1)) {
          this.Tr1 = true;
        } else {
          var value = parseInt(this.deta1);
          if (value > 300 || value < 1 || isNaN(value)) {
            this.Tr1 = true;
          } else {
            this.Tr1 = false;
          }
        }
      }
      if (index === 2) {
        if (isNaN(this.EXEtime)) {
          this.Tr2 = true;
        } else {
          var _value = parseInt(this.EXEtime);
          if (_value > 480 || _value < 5 || isNaN(_value)) {
            this.Tr2 = true;
          } else {
            this.Tr2 = false;
          }
        }
      }
      if (index === 3) {
        if (isNaN(this.deta3)) {
          this.Tr3 = true;
        } else {
          var _value2 = parseFloat(this.deta3);
          if (_value2 > 19.9 || _value2 < 3.3 || isNaN(_value2)) {
            this.Tr3 = true;
          } else {
            this.Tr3 = false;
          }
        }
      }
      if (index === 5) {
        if (isNaN(this.deta5)) {
          this.Tr5 = true;
        } else {
          if (this.isMg) {
            var _value3 = parseInt(this.deta5);
            if (_value3 > 400 || _value3 < 40 || isNaN(_value3)) {
              this.Tr5 = true;
            } else {
              this.Tr5 = false;
            }
          } else {
            var _value4 = parseFloat(this.deta5);
            if (_value4 > 22.2 || _value4 < 2.2 || isNaN(_value4)) {
              this.Tr5 = true;
            } else {
              this.Tr5 = false;
            }
          }
        }
      }
      if (index === 6) {
        if (isNaN(this.deta6)) {
          this.Tr6 = true;
        } else {
          var _value5 = parseFloat(this.deta6);
          if (_value5 > 99.0 || _value5 < 0.1 || isNaN(_value5)) {
            this.Tr6 = true;
          } else {
            this.Tr6 = false;
          }
        }
      }
    },
    newEvents: function newEvents() {
      if (this.Tr1 || this.Tr2 || this.Tr3 || this.Tr5 || this.Tr6) {
        var tip = this.$t('Input error');
        this.$message.error(tip);
      } else {
        var data = [];
        var time = this.value3 ? this.value3.getTime() / 1000 : ' ';
        var mi = this.value4 ? __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate5(this.value4) : [0, 0];
        time = time + parseInt(mi[0]) * 3600 + parseInt(mi[1]) * 60;
        var _tip = this.$t('infoWrongTip');
        data[0] = time;
        if (this.type === this.$t('BG1')) {
          if (!this.deta5) {
            this.Tr5 = true;
            this.$message.error(_tip);
          } else {
            data[1] = 'BG';
            data[2] = {
              value: this.isMg ? parseInt(this.deta5) : Math.round(parseFloat(this.deta5).toFixed(1) * 18),
              glucoseType: 0,
              note: this.note
            };
            __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].newEvents(this, this.uid, data);
          }
        } else if (this.type === this.$t('carbs')) {
          if (!this.deta1) {
            this.Tr1 = true;
            this.$message.error(_tip);
          } else {
            data[1] = 'CARB';
            data[2] = {
              value: this.deta1 ? parseInt(this.deta1) : '',
              name: '',
              note: this.note
            };
            __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].newEvents(this, this.uid, data);
          }
        } else if (this.type === this.$t('Injection')) {
          if (!this.deta6) {
            this.Tr6 = true;
            this.$message.error(_tip);
          } else {
            data[1] = 'INS';
            data[2] = {
              value: this.deta6 ? parseFloat(this.deta6).toFixed(1) : '',
              name: '',
              note: this.note,
              insulinType: ''
            };
            __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].newEvents(this, this.uid, data);
          }
        } else if (this.type === this.$t('exercise')) {
          if (!this.EXEtime) {
            this.Tr2 = true;
            this.$message.error(_tip);
          } else {
            data[1] = 'EXR';
            data[2] = {
              value: parseInt(this.EXEtime),
              name: '',
              note: this.note,
              exerciseType: '',
              exerciseIntensity: this.exeType[this.deta2]
            };
            __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].newEvents(this, this.uid, data);
          }
        } else if (this.type === this.$t('HbA1c1')) {
          if (!this.deta3) {
            this.Tr3 = true;
            this.$message.error(_tip);
          } else {
            data[1] = 'HBA1C';
            data[2] = {
              value: parseFloat(this.deta3).toFixed(1),
              note: this.note
            };
            __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].newEvents(this, this.uid, data);
          }
        } else if (this.type === this.$t('Other')) {
          if (!this.deta7) {
            this.Tr7 = true;
            this.$message.error(_tip);
          } else {
            data[1] = 'OTR';
            data[2] = {
              value: '',
              note: this.deta7
            };
            __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].newEvents(this, this.uid, data);
          }
        } else if (this.type === this.$t('Urine Ketone')) {
          data[1] = 'URINEK';
          var j = 0;
          for (var i = 0; i < this.urinekType.length; i++) {
            if (this.deta4 === this.urinekType[i]) {
              j = i + 1;
              break;
            }
          }
          data[2] = {
            value: j,
            note: this.note
          };
          __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].newEvents(this, this.uid, data);
        }
      }
    },
    typeShow: function typeShow(e) {
      var type = e.target.value;
      if (type === this.$t('carbs')) {
        this.type1 = true;this.type2 = false;this.type3 = false;this.type4 = false;this.type5 = false;this.type6 = false;this.type7 = false;this.type8 = false;
      }
      if (type === this.$t('exercise')) {
        this.type2 = true;this.type1 = false;this.type3 = false;this.type4 = false;this.type5 = false;this.type6 = false;this.type7 = false;this.type8 = false;
      }
      if (type === this.$t('HbA1c1')) {
        this.type3 = true;this.type2 = false;this.type1 = false;this.type4 = false;this.type5 = false;this.type6 = false;this.type7 = false;this.type8 = false;
      }
      if (type === this.$t('Urine Ketone')) {
        this.type4 = true;this.type2 = false;this.type3 = false;this.type1 = false;this.type5 = false;this.type6 = false;this.type7 = false;this.type8 = false;
      }
      if (type === this.$t('BG1')) {
        this.type5 = true;this.type2 = false;this.type3 = false;this.type4 = false;this.type1 = false;this.type6 = false;this.type7 = false;this.type8 = false;
      }
      if (type === this.$t('Injection')) {
        this.type6 = true;this.type2 = false;this.type3 = false;this.type4 = false;this.type5 = false;this.type1 = false;this.type7 = false;this.type8 = false;
      }
      if (type === this.$t('Other')) {
        this.type8 = true;this.type2 = false;this.type3 = false;this.type4 = false;this.type5 = false;this.type6 = false;this.type7 = false;this.type1 = false;
      }
      this.Tr1 = false;this.Tr2 = false;this.Tr3 = false;this.Tr5 = false;this.Tr6 = false;this.Tr7 = false;
    },
    edit: function edit(e) {
      var index = e.target.parentNode.parentNode.id;
      this.event = this.events[index];
      this.isWeb = this.event[4] === 'web' ? true : false;
      var time = this.event[1].split(' ');
      var mi = time[1].split(':');
      var m = mi[0] + ":" + mi[1];
      time[1] = m;
      this.time = time;
      this.isB = true;
      this.eNote = this.event[3].note;
      this.edTypeShow();
    },
    cancel2: function cancel2() {
      this.isB = false;
    },
    edTypeShow: function edTypeShow() {
      var type = this.event[2];
      this.Tr1 = false;this.Tr2 = false;this.Tr3 = false;this.Tr5 = false;this.Tr6 = false;this.Tr7 = false;
      if (type === this.$t('CARB')) {
        this.eDetail1 = this.event[3].value.split(' ')[0];
        this.edType1 = true;this.edType2 = false;this.edType3 = false;this.edType4 = false;this.edType5 = false;this.edType6 = false;this.edType7 = false;this.edType8 = false;
      }
      if (type === this.$t('EXR')) {
        var value = this.event[3].value.split(' ');
        this.eDetail2 = value[2];
        this.edEXEtime = value[0];
        this.edType2 = true;this.edType1 = false;this.edType3 = false;this.edType4 = false;this.edType5 = false;this.edType6 = false;this.edType7 = false;this.edType8 = false;
      }
      if (type === this.$t('HBA1C')) {
        this.eDetail3 = this.event[3].value.split(' ')[0];
        this.edType3 = true;this.edType2 = false;this.edType1 = false;this.edType4 = false;this.edType5 = false;this.edType6 = false;this.edType7 = false;this.edType8 = false;
      }
      if (type === this.$t('URINEK')) {
        this.eDetail4 = this.event[3].value;
        this.edType4 = true;this.edType2 = false;this.edType3 = false;this.edType1 = false;this.edType5 = false;this.edType6 = false;this.edType7 = false;this.edType8 = false;
      }
      if (type === this.$t('BG')) {
        this.eDetail5 = this.event[3].value.split(' ')[0];
        this.edType5 = true;this.edType2 = false;this.edType3 = false;this.edType4 = false;this.edType1 = false;this.edType6 = false;this.edType7 = false;this.edType8 = false;
      }
      if (type === this.$t('INS')) {
        this.eDetail6 = this.event[3].value.split(' ')[0];
        this.edType6 = true;this.edType2 = false;this.edType3 = false;this.edType4 = false;this.edType5 = false;this.edType1 = false;this.edType7 = false;this.edType8 = false;
      }
      if (type === this.$t('OTR')) {
        this.eDetail7 = this.event[3].note;
        this.edType8 = true;this.edType2 = false;this.edType3 = false;this.edType4 = false;this.edType5 = false;this.edType6 = false;this.edType7 = false;this.edType1 = false;
      }
    },
    edCheck: function edCheck(index) {
      if (index === 1) {
        if (isNaN(this.eDetail1)) {
          this.Tr1 = true;
        } else {
          var value = parseInt(this.eDetail1);
          if (value > 300 || value < 1 || isNaN(value)) {
            this.Tr1 = true;
          } else {
            this.Tr1 = false;
          }
        }
      }
      if (index === 2) {
        if (isNaN(this.edEXEtime)) {
          this.Tr2 = true;
        } else {
          var _value6 = parseInt(this.edEXEtime);
          if (_value6 > 480 || _value6 < 5 || isNaN(_value6)) {
            this.Tr2 = true;
          } else {
            this.Tr2 = false;
          }
        }
      }
      if (index === 3) {
        if (isNaN(this.eDetail3)) {
          this.Tr3 = true;
        } else {
          var _value7 = parseFloat(this.eDetail3);
          if (_value7 > 19.9 || _value7 < 3.3 || isNaN(_value7)) {
            this.Tr3 = true;
          } else {
            this.Tr3 = false;
          }
        }
      }
      if (index === 5) {
        if (isNaN(this.eDetail5)) {
          this.Tr5 = true;
        } else {
          if (this.isMg) {
            var _value8 = parseInt(this.eDetail5);
            if (_value8 > 400 || _value8 < 40 || isNaN(_value8)) {
              this.Tr5 = true;
            } else {
              this.Tr5 = false;
            }
          } else {
            var _value9 = parseFloat(this.eDetail5);
            if (_value9 > 22.2 || _value9 < 2.2 || isNaN(_value9)) {
              this.Tr5 = true;
            } else {
              this.Tr5 = false;
            }
          }
        }
      }
      if (index === 6) {
        if (isNaN(this.eDetail6)) {
          this.Tr6 = true;
        } else {
          var _value10 = parseFloat(this.eDetail6);
          if (_value10 > 99.0 || _value10 < 0.1 || isNaN(_value10)) {
            this.Tr6 = true;
          } else {
            this.Tr6 = false;
          }
        }
      }
    },
    editEvents: function editEvents() {
      var info = this.event;
      var event = [];
      var st = info[1].split(' ');
      var day = st[0].split('-');
      var day2 = day[2] + '-' + day[1] + '-' + day[0];
      var t = st[1].split(':');
      var second = new Date(day2).getTime() / 1000 - 3600 * 8;
      var time = this.value5 ? this.value5.getTime() / 1000 : second;
      var mi = this.value6 ? __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate5(this.value6) : [t[0], t[1]];
      time = time + parseInt(mi[0]) * 3600 + parseInt(mi[1]) * 60;
      event[0] = time;

      if (this.Tr1 || this.Tr2 || this.Tr3 || this.Tr5 || this.Tr6) {
        var tip = this.$t('Input error');
        this.$message.error(tip);
      } else {
        if (info[2] === this.$t('BG')) {
          event[1] = 'BG';
          event[2] = {
            value: this.isMg ? parseInt(this.eDetail5) : Math.round(parseFloat(this.eDetail5).toFixed(1) * 18),
            glucoseType: 0,
            note: this.eNote
          };
          __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].editEvents(this, this.uid, info[5], event);
        } else if (info[2] === this.$t('CARB')) {
          event[1] = 'CARB';
          event[2] = {
            value: this.eDetail1 ? parseInt(this.eDetail1) : '',
            name: '',
            note: this.eNote
          };
          __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].editEvents(this, this.uid, info[5], event);
        } else if (info[2] === this.$t('EXR')) {
          event[1] = 'EXR';
          event[2] = {
            value: parseInt(this.edEXEtime),
            name: '',
            note: this.eNote,
            exerciseType: '',
            exerciseIntensity: this.exeType[this.eDetail2]
          };
          __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].editEvents(this, this.uid, info[5], event);
        } else if (info[2] === this.$t('INS')) {
          event[1] = 'INS';
          event[2] = {
            value: this.eDetail6 ? parseFloat(this.eDetail6).toFixed(1) : '',
            name: '',
            note: this.eNote,
            insulinType: ''
          };
          __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].editEvents(this, this.uid, info[5], event);
        } else if (info[2] === this.$t('HBA1C')) {
          event[1] = 'HBA1C';
          event[2] = {
            value: parseFloat(this.eDetail3).toFixed(1),
            note: this.eNote
          };
          __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].editEvents(this, this.uid, info[5], event);
        } else if (info[2] === this.$t('OTR')) {
          if (!this.eDetail7) {
            this.Tr7 = true;
            var _tip2 = this.$t('infoWrongTip');
            this.$message.error(_tip2);
          } else {
            event[1] = 'OTR';
            event[2] = {
              value: '',
              note: this.eDetail7
            };
            __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].editEvents(this, this.uid, info[5], event);
          }
        } else if (info[2] === this.$t('URINEK')) {
          event[1] = 'URINEK';
          var j = 0;
          for (var i = 0; i < this.urinekType.length; i++) {
            if (this.eDetail4 === this.urinekType[i]) {
              j = i + 1;
              break;
            }
          }
          event[2] = {
            value: j,
            note: this.eNote
          };
          __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].editEvents(this, this.uid, info[5], event);
        }
      }
    },
    nextPage: function nextPage() {
      if (this.page < this.pages) {
        this.page++;
        this.getEvents();
      }
    },
    prevPage: function prevPage() {
      if (this.page > 1) {
        this.page--;
        this.getEvents();
      }
    },
    go: function go() {
      if (0 < this.page && this.page < this.pages + 1) {
        this.getEvents();
      } else {
        this.page = 1;
        this.getEvents();
      }
    },
    print: function print() {
      if (true) {

        window.open('/#/events-print1', '_blank');
      } else {
        var tip = this.$t('Choose the events to print');
        this.$message({
          type: 'warning',
          message: tip
        });
      }
    },
    updateTimeRange: function updateTimeRange() {
      var startDateTemp = new Date(this.st * 1000);
      var endDateTemp = new Date(this.et * 1000);
      function addPreZero(s, n) {
        var pre = '';
        var d = n - s.length;
        for (var i = 0; i < d; i++) {
          pre += '0';
        }
        return pre + s;
      }
      function DateFormat(d) {
        return addPreZero(d.getDate(), 2) + '/' + addPreZero(d.getMonth() + 1, 2) + '/' + addPreZero(d.getFullYear(), 4);
      }
      function eventText(e) {
        if ('ALL' == e) {
          return 'All';
        } else if ('CARB' == e) {
          return 'carbs';
        } else if ('EXR' == e) {
          return 'exercise';
        } else if ('HBA1C' == e) {
          return 'HbA1c1';
        } else if ('URINEK' == e) {
          return 'Urine Ketone';
        } else if ('BG' == e) {
          return 'BG1';
        } else if ('INS' == e) {
          return 'Injection';
        } else if ('OTR' == e) {
          return 'Other';
        }
        return '';
      }
      console.log('eventTypeSelect:', this.eventTypeSelect);
      this.timeRange = DateFormat(startDateTemp) + ' - ' + DateFormat(endDateTemp) + ', ' + this.$t(eventText(this.eventTypeSelect));
    }
  },

  mounted: function mounted() {
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isEs = lang === 'es' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isSw = lang === 'sw' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    this.bgRange = this.isMg ? '(40-400)' : '(2.2-22.2)';
    this.unit = this.isMg ? 'mg/dL' : 'mmol/L';

    if (!sessionStorage.getItem('st8')) {
      var curDate = new Date();
      curDate = new Date(curDate.getFullYear(), curDate.getMonth(), curDate.getDate());
      this.et = curDate.getTime() / 1000;
      this.st = this.et - (7 - 1) * 86400;
      this.startDate = __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate4(this.st);
      this.value2 = new Date(this.st * 1000);
      this.defaultDate = __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate4(this.et);
      this.value1 = new Date(this.et * 1000);
      this.timeRangeSelect = 1;
      this.eventTypeSelect = 'ALL';
      this.updateTimeRange();
      console.log('eventTypeSelect.1:', this.eventTypeSelect);
    } else {
      this.st = parseInt(sessionStorage.getItem('st8'));
      this.et = parseInt(sessionStorage.getItem('et8'));
      this.startDate = __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate4(this.st);
      this.value2 = new Date(this.st * 1000);
      this.defaultDate = __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate4(this.et);
      this.value1 = new Date(this.et * 1000);
      var timeRangeSelect8 = sessionStorage.getItem('timeRangeSelect8');
      timeRangeSelect8 = parseInt(timeRangeSelect8);
      if (timeRangeSelect8 != NaN && timeRangeSelect8 >= 0 && timeRangeSelect8 <= 4) {
        this.timeRangeSelect = timeRangeSelect8;
      } else {
        this.timeRangeSelect = 0;
        this.startDateDisable = false;
      }

      var eventTypeSelect = sessionStorage.getItem('eventTypeSelect');
      if (eventTypeSelect && typeof eventTypeSelect == 'string' && 'null' != eventTypeSelect) {
        this.eventTypeSelect = eventTypeSelect;
      } else {
        this.eventTypeSelect = 'ALL';
      }
      console.log('eventTypeSelect.1:', this.eventTypeSelect);

      this.updateTimeRange();
    }

    sessionStorage.setItem('st8', this.st);
    sessionStorage.setItem('et8', this.et);
    sessionStorage.setItem('eventTypeSelect', this.eventTypeSelect);
    sessionStorage.setItem('timeRangeSelect8', this.timeRangeSelect);
    var param = {
      page: this.page,
      'order': [['time', this.order]],
      st: this.st,
      et: this.et
    };

    var t1 = new Date().getTime() / 1000;
    var t2 = t1 - 86400 * 6;
    var st1 = __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate3(t1) + ' 00:00:00';
    var st2 = Date.parse(st1.replace(/-/g, "/"));
    this.value3 = new Date(st2);
    this.defaultDate1 = __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate4(t1);
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }
    param = __WEBPACK_IMPORTED_MODULE_3__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));
    var win = window.innerWidth;
    this.dialogSize = win < 1500 ? 'small' : 'tiny';
    __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].getEvents(this, this.uid, { param: param, page: this.page });
  }
});

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_base64__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_format__ = __webpack_require__(8);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      uid: 0, st: 0, et: 0,

      isEn: false,

      dialogSize: 'small',
      haveData: true,

      typeChooseVisible: false,
      timeRangeSelect: 1,
      timeRangeSelectActive: 1,
      alertTypeSelect: 1,
      alertTypeSelectActive: 1,
      startDateText: '',
      startDateValue: new Date(),
      startDatePlaceholder: '',
      customDaySpan: false,
      endDateText: '',
      endDateValue: new Date(),
      endDatePlaceholder: '',
      timeRangeDisplay: '',

      alerts: [],

      pickerOptions: {
        disabledDate: function disabledDate(time) {
          var t1 = time.getTime();
          var d2 = new Date();
          var t2 = d2.getTime();

          return t1 > t2 || t1 < t2 - 730 * 86400 * 1000;
        }
      }
    };
  },


  methods: {
    open: function open() {
      this.startDateValue = new Date(this.st * 1000);
      this.startDateText = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate4(this.st);
      this.endDateValue = new Date(this.et * 1000);

      this.timeRangeSelect = this.timeRangeSelectActive;
      if (0 == this.timeRangeSelect) {
        this.customDaySpan = true;
      } else {
        this.customDaySpan = false;
      }

      this.typeChooseVisible = true;
    },
    cancel: function cancel() {
      this.typeChooseVisible = false;
    },
    getAlertTypeText: function getAlertTypeText(alertTypeValue) {
      var alertTypeSelect = parseInt(alertTypeValue);
      var alertType = '--';
      var AlertTypeTexts = [this.$t('PDM'), this.$t('Pump'), this.$t('CGM')];
      if (alertTypeSelect == NaN || alertTypeSelect < 1 || alertTypeSelect > 3) {} else {
        alertType = AlertTypeTexts[alertTypeSelect - 1];
      }

      return alertType;
    },
    dateApply: function dateApply() {
      var st = this.startDateValue.getTime() / 1000;
      var et = this.endDateValue.getTime() / 1000;
      if (st >= et) {
        this.$message.error("Date select wrong");
        return;
      }
      var daySpan = (et - st) / 86400 + 1;
      if (daySpan > 90) {
        this.$message.error("Date select wrong");
        return;
      }
      this.st = st;
      this.et = et;

      this.timeRangeDisplay = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate2(this.st) + ' - ' + __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate2(this.et) + ', ' + this.getAlertTypeText(this.alertTypeSelect);
      this.timeRangeSelectActive = this.timeRangeSelect;
      this.alertTypeSelectActive = this.alertTypeSelect;
      this.typeChooseVisible = false;
      this.getAlertData();

      sessionStorage.setItem('st9', this.st);
      sessionStorage.setItem('et9', this.et);
      sessionStorage.setItem('timeRangeSelect9', this.timeRangeSelect);
      sessionStorage.setItem('alertTypeSelect', this.alertTypeSelect);
    },
    startDateChange: function startDateChange() {},
    endDateChange: function endDateChange() {
      var endDate = this.endDateValue;
      var et = endDate.getTime() / 1000;
      var daySpan = 0;
      if (1 == this.timeRangeSelect) {
        daySpan = 7;
      } else if (2 == this.timeRangeSelect) {
        daySpan = 14;
      } else if (3 == this.timeRangeSelet) {
        daySpan = 30;
      } else if (4 == this.timeRangeSelect) {
        daySpan = 90;
      }
      if (daySpan) {
        var st = et - 86400 * (daySpan - 1);
        this.startDateValue = new Date(st * 1000);
        this.startDateText = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate4(st);
      }
    },
    procAlertTypeSelect: function procAlertTypeSelect(e) {},
    procTimeRangeSelect: function procTimeRangeSelect(e) {
      console.log('procTimeRangeSelect:', this.timeRangeSelect);
      var daySpan = 0;
      if (1 == this.timeRangeSelect) {
        daySpan = 7;
      } else if (2 == this.timeRangeSelect) {
        daySpan = 14;
      } else if (3 == this.timeRangeSelect || 4 == this.timeRangeSelect) {
        daySpan = 30;
        if (4 == this.timeRangeSelect) {
          daySpan = 90;
        }
      }

      var et = this.endDateValue.getTime() / 1000;

      console.log('daySpan:', daySpan);

      if (daySpan) {
        var st = et - 86400 * (daySpan - 1);

        this.startDateText = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate4(st);
        this.startDateValue = new Date(st * 1000);
      }
      if (0 == this.timeRangeSelect) {
        this.customDaySpan = true;
      } else {
        this.customDaySpan = false;
      }
    },
    print: function print() {
      sessionStorage.setItem('alert-data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        'alerts': this.alerts
      }));

      window.open('/#/chart9-print', '_blank');
    },
    procAlertData: function procAlertData(alerts) {
      var isEn = this.isEn;
      var getAlertTypeTextFunc = this.getAlertTypeText;
      var that = this;
      alerts = alerts.filter(function (e, i) {
        return e[1];
      });
      return alerts.map(function (e, i) {
        var item = [];

        item[0] = isEn ? __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate1(new Date(e[0] * 1000)) : __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formateDate(new Date(e[0] * 1000));

        if (e[1]) {
          e[1] = '' + e[1];
          var alert_sid = 'Alerts_' + e[1].replace(/ /g, '_');
          item[1] = that.$t(alert_sid);
        } else {
          var alertId = e[2];
          if (26 == alertId) {
            item[1] = 'Auto Mode Exit';
          } else if (27 == alertId) {
            item[1] = 'Auto Mode Max';
          }
          item[1] = '';
        }
        item[2] = e[2];
        item[3] = getAlertTypeTextFunc(e[3]);
        return item;
      });
    },
    getAlertData: function getAlertData() {
      var params = {
        st: this.st,
        et: this.et,
        alert_type: this.alertTypeSelect
      };
      this.$http.get('/api/v2.1/alerts/' + this.uid, { params: params }).then(function (res) {
        if (0 == res.data.error) {
          console.log('alerts:', res.data.alerts);
          var alerts = this.procAlertData(res.data.alerts);
          if (alerts.length > 0) {
            this.alerts = alerts;
            this.haveData = true;
          } else {
            this.haveData = false;
            this.alerts = [];
          }
        }
      }, function (err) {});
    }
  },

  mounted: function mounted() {
    var width = window.innerWidth;

    this.isEn = sessionStorage.getItem('language') !== 'zh' ? true : false;
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }

    if (!sessionStorage.getItem('st9')) {
      var nd = new Date();
      var cur_day = new Date(nd.getFullYear(), nd.getMonth(), nd.getDate() - 1);
      this.et = cur_day / 1000;
      var chart_end_time = sessionStorage.getItem('chart_end_time');
      console.log('chart_end_time:', chart_end_time);
      for (var d = 0; d < 3000; d++) {
        if (this.et > chart_end_time) {
          cur_day = new Date(cur_day.getFullYear(), cur_day.getMonth(), cur_day.getDate() - 1);
          this.et = cur_day / 1000;
        } else {
          break;
        }
      }
      this.st = this.et - 86400 * 6;
    } else {
      this.st = parseInt(sessionStorage.getItem('st9'));
      this.et = parseInt(sessionStorage.getItem('et9'));
      var timeRangeSelect = parseInt(sessionStorage.getItem('timeRangeSelect9'));
      var alertTypeSelect = parseInt(sessionStorage.getItem('alertTypeSelect'));
      console.log('alertTypeSelect:', timeRangeSelect, alertTypeSelect);
      this.timeRangeSelect = timeRangeSelect;
      this.timeRangeSelectActive = timeRangeSelect;
      this.alertTypeSelect = alertTypeSelect;
      this.alertTypeSelectActive = alertTypeSelect;
    }
    this.getAlertData();

    this.timeRangeDisplay = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate2(this.st) + ' - ' + __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate2(this.et) + ', ' + this.getAlertTypeText(this.alertTypeSelect);

    this.startDateText = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate4(this.st);
    this.startDateValue = new Date(this.st * 1000);
    this.endDateValue = new Date(this.et * 1000);

    sessionStorage.setItem('st9', this.st);
    sessionStorage.setItem('et9', this.et);
    sessionStorage.setItem('timeRangeSelect9', this.timeRangeSelect);
    sessionStorage.setItem('alertTypeSelect', this.alertTypeSelect);
  }
});

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      Sessions: '', overLapp1: [], overLapp2: [], isLapp1: false, isLapp2: false, LapList1: '', LapList2: '',
      isA: '', isB: '',
      isC: false,
      isP: '',
      isK: false, flag: 0, flag1: 0, uid: 0, cgms: [], pump: [], set: [], isZh: false,
      haveSensorData: false,
      havePumpData: false
    };
  },
  created: function created() {
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }
    __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getSet(this, this.uid);
    __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getSessions(this, this.uid);
  },

  mounted: function mounted() {
    if (!sessionStorage.getItem('dateViewA')) {} else {
      this.isA = sessionStorage.getItem('dateViewA') === '1' ? true : false;
      this.isB = sessionStorage.getItem('dateViewB') === '1' ? true : false;
    }

    var lang = sessionStorage.getItem('language');
    this.isZh = lang === 'zh' ? true : false;
    this.isP = sessionStorage.getItem('userType') === 'P';
  },
  methods: {
    changeType1: function changeType1() {
      this.isA = true;
      this.isB = false;
      this.set1();
      this.initSet();
      sessionStorage.setItem('dateViewA', 1);
      sessionStorage.setItem('dateViewB', 0);
    },
    changeType2: function changeType2() {
      this.isB = true;
      this.isA = false;
    },
    deleteData: function deleteData() {
      var _this = this;

      var tip = this.$t('deleteData');
      var tip1 = this.$t('confirm');
      var tip2 = this.$t('Delete');
      var tip3 = this.$t('Cancel');
      this.$confirm(tip, tip1, {
        confirmButtonText: tip2,
        cancelButtonText: tip3,
        type: 'warning'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].deleteData(_this);
      }, function () {});
    },
    choose: function choose() {
      this.isC = !this.isC;
      var table1 = document.getElementById('table1');
      var labels = table1.getElementsByTagName('label');
      for (var i = 0; i < labels.length; i++) {
        if (this.flag === 0) {
          labels[i].className = 'checked';
        } else {
          labels[i].className = '';
        }
      }

      if (labels[0].className === 'checked') {
        this.flag = 1;
      } else {
        this.flag = 0;
      }
      this.checkOverLapp();
    },
    select: function select(flag, e) {
      var index = e.target.parentNode.id;
      var id = 0;
      if (e.target.className === '') {
        e.target.className = 'checked';
      } else {
        e.target.className = '';
      }
      this.checkOverLapp();
    },
    choose2: function choose2() {
      this.isK = !this.isK;
      var table2 = document.getElementById('table2');
      var labels = table2.getElementsByTagName('label');
      for (var i = 0; i < labels.length; i++) {
        if (this.flag1 === 0) {
          labels[i].className = 'checked';
        } else {
          labels[i].className = '';
        }
      }
      if (labels[0].className === 'checked') {
        this.flag1 = 1;
      } else {
        this.flag1 = 0;
      }

      this.checkOverLapp();
    },
    set1: function set1() {
      var data = {
        option: 'daopapp',
        cgms: [],
        pump: []
      };
      __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].setData(this, this.uid, { data: data });
    },
    set2: function set2() {
      if (0) {}
      this.$router.push('/dateView2');
    },
    checkData: function checkData() {
      this.cgms = [];
      this.pump = [];
      var table1 = document.getElementById('table1');
      var labels1 = table1.getElementsByTagName('label');
      for (var i = 0; i < labels1.length; i++) {
        if (labels1[i].className === 'checked') {
          var id = this.Sessions[0][i][2];
          this.cgms.push(id);
        }
      }
      var table2 = document.getElementById('table2');
      var labels2 = table2.getElementsByTagName('label');
      for (var _i = 0; _i < labels2.length; _i++) {
        if (labels2[_i].className === 'checked') {
          var _id = this.Sessions[1][_i][2];
          this.pump.push(_id);
        }
      }

      if (this.cgms.length === this.Sessions[0].length) {
        this.isC = true;
        this.flag = 1;
      } else {
        this.isC = false;
        this.flag = 0;
      }
      if (this.pump.length === this.Sessions[1].length) {
        this.isK = true;
        this.flag1 = 1;
      } else {
        this.isK = false;
        this.flag1 = 0;
      }
    },
    checkOverLapp: function checkOverLapp() {
      this.checkData();
      var cgm = [],
          p = 0;
      this.isLapp1 = false;
      this.LapList1 = ' ';
      this.initSession1();
      if (this.cgms.length > 0) {
        for (var i = 0; i < this.cgms.length; i++) {
          for (var j = 0; j < this.Sessions[0].length; j++) {
            if (this.cgms[i] === this.Sessions[0][j][2]) {
              cgm[p] = [];
              cgm[p][0] = j + 1;
              cgm[p][1] = this.Sessions[0][j][3];
              cgm[p][2] = this.Sessions[0][j][4];
              p++;
            }
          }
        }
        this.forMatter(cgm);

        this.overLapp1 = this.getOverLapp(cgm);
        if (this.overLapp1.length > 0) {
          var tips = 0;
          if (this.overLapp1.length < 11) {
            tips = this.overLapp1.length;
          } else {
            tips = 10;
          }
          for (var _i2 = 0; _i2 < tips; _i2++) {
            this.LapList1 += this.overLapp1[_i2][0] + ' and ' + this.overLapp1[_i2][1] + '; ';
            this.isLapp1 = true;
            var id1 = 'lap' + (this.overLapp1[_i2][0] - 1);
            var tr1 = document.getElementById(id1);
            tr1.style.color = "#f00";
            var id2 = 'lap' + (this.overLapp1[_i2][1] - 1);
            var tr2 = document.getElementById(id2);
            tr2.style.color = "#f00";
          }
        }
      }
      var pump = [],
          k = 0;
      this.isLapp2 = false;
      this.LapList2 = ' ';
      this.initSession2();
      if (this.pump.length > 0) {
        for (var _i3 = 0; _i3 < this.pump.length; _i3++) {
          for (var _j = 0; _j < this.Sessions[1].length; _j++) {
            if (this.pump[_i3] === this.Sessions[1][_j][2]) {
              pump[k] = [];
              pump[k][0] = _j + 1;
              pump[k][1] = this.Sessions[1][_j][3];
              pump[k][2] = this.Sessions[1][_j][4];
              k++;
            }
          }
        }
        this.forMatter(pump);
        this.overLapp2 = this.getOverLapp(pump);

        if (this.overLapp2.length > 0) {
          var _tips = 0;
          if (this.overLapp2.length < 11) {
            _tips = this.overLapp2.length;
          } else {
            _tips = 10;
          }
          for (var _i4 = 0; _i4 < _tips; _i4++) {
            this.LapList2 += this.overLapp2[_i4][0] + ' and ' + this.overLapp2[_i4][1] + '; ';
            this.isLapp2 = true;
            var _id2 = 'lapp' + (this.overLapp2[_i4][0] - 1);
            var _tr = document.getElementById(_id2);
            _tr.style.color = "#f00";
            var _id3 = 'lapp' + (this.overLapp2[_i4][1] - 1);
            var _tr2 = document.getElementById(_id3);
            _tr2.style.color = "#f00";
          }
        }
      }
    },
    forMatter: function forMatter(val) {
      var that = this;
      val.map(function (e, i) {
        var t1 = e[1].split(' ');
        var t11 = t1[0].split('-');
        e[1] = that.isZh ? Date.parse(t11[0] + '/' + t11[1] + '/' + t11[2] + ' ' + t1[1]) / 1000 : Date.parse(t11[2] + '/' + t11[1] + '/' + t11[0] + ' ' + t1[1]) / 1000;

        var t2 = e[2].split(' ');
        var t21 = t2[0].split('-');
        e[2] = that.isZh ? Date.parse(t21[0] + '/' + t21[1] + '/' + t21[2] + ' ' + t2[1]) / 1000 : Date.parse(t21[2] + '/' + t21[1] + '/' + t21[0] + ' ' + t2[1]) / 1000;
        return e;
      });
    },
    getOverLapp: function getOverLapp(val) {
      var over = [],
          p = 0;
      for (var i = 0; i < val.length - 1; i++) {
        for (var j = i + 1; j < val.length; j++) {
          if (val[i][1] > val[j][2] || val[i][2] < val[j][1]) {
            continue;
          } else {
            over[p] = [];
            over[p][0] = val[i][0];
            over[p][1] = val[j][0];
            p++;
          }
        }
      }
      return over;
    },
    initSession1: function initSession1() {
      for (var i = 0; i < this.Sessions[0].length; i++) {
        var id1 = 'lap' + i;
        var tr1 = document.getElementById(id1);
        tr1.style.color = "#282828";
      }
    },
    initSession2: function initSession2() {
      for (var i = 0; i < this.Sessions[1].length; i++) {
        var id1 = 'lapp' + i;
        var tr1 = document.getElementById(id1);
        tr1.style.color = "#282828";
      }
    },
    back: function back() {
      this.$router.push('/PatientList');
    },
    checkSet: function checkSet() {
      return;
      var table1 = document.getElementById('table1');
      var labels = table1.getElementsByTagName('label');
      if (this.cgms) {
        for (var i = 0; i < this.cgms.length; i++) {
          var id = this.cgms[i];
          for (var j = 0; j < this.Sessions[0].length; j++) {
            if (id === this.Sessions[0][j][2]) {
              labels[j].className = 'checked';
            }
          }
        }
        if (this.cgms.length === this.Sessions[0].length) {
          var all = document.getElementById('all1');
          all.className = 'checked';
        }
      }
      if (this.pump) {
        var table2 = document.getElementById('table2');
        var labels2 = table2.getElementsByTagName('label');
        for (var _i5 = 0; _i5 < this.pump.length; _i5++) {
          var _id4 = this.pump[_i5];
          for (var _j2 = 0; _j2 < this.Sessions[1].length; _j2++) {
            if (_id4 === this.Sessions[1][_j2][2]) {
              labels2[_j2].className = 'checked';
            }
          }
        }
        if (this.pump.length === this.Sessions[1].length) {
          var _all = document.getElementById('all2');
          _all.className = 'checked';
        }
      }
    },
    initSet: function initSet() {
      return;
      var table1 = document.getElementById('table1');
      var labels1 = table1.getElementsByTagName('label');
      var all = document.getElementById('all1');
      all.className = '';
      var all2 = document.getElementById('all2');
      all2.className = '';
      for (var i = 0; i < labels1.length; i++) {
        labels1[i].className = '';
      }
      var table2 = document.getElementById('table2');
      var labels2 = table2.getElementsByTagName('label');
      for (var _i6 = 0; _i6 < labels2.length; _i6++) {
        labels2[_i6].className = '';
      }
    }
  }
});

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      Sessions: '', overLapp1: [], overLapp2: [], isLapp1: false, isLapp2: false, LapList1: '', LapList2: '',
      isA: '', isB: '',
      isC: false,
      isP: '',
      isK: false, flag: 0, flag1: 0, uid: 0, cgms: [], pump: [], set: [], isZh: false,
      isPDM: false, isRealtime: false

    };
  },
  created: function created() {
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }
    __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getSet(this, this.uid);
  },

  mounted: function mounted() {
    if (!sessionStorage.getItem('dateViewA')) {} else {
      this.isA = sessionStorage.getItem('dateViewA') === '1' ? true : false;
      this.isB = sessionStorage.getItem('dateViewB') === '1' ? true : false;
    }

    var lang = sessionStorage.getItem('language');
    this.isZh = lang === 'zh' ? true : false;
    this.isP = sessionStorage.getItem('userType') === 'P';
  },
  methods: {
    selectPDM: function selectPDM() {
      if (this.isPDM) return;

      this.isPDM = true;
      this.isRealtime = false;

      this.saveOption();
    },
    selectRealtime: function selectRealtime() {
      if (this.isRealtime) return;

      this.isPDM = false;
      this.isRealtime = true;
      this.saveOption();
    },
    changeType1: function changeType1() {},
    changeType2: function changeType2() {
      this.isB = true;
      this.isA = false;
    },
    deleteData: function deleteData() {
      var _this = this;

      var tip = this.$t('deleteData');
      var tip1 = this.$t('confirm');
      var tip2 = this.$t('Delete');
      var tip3 = this.$t('Cancel');
      this.$confirm(tip, tip1, {
        confirmButtonText: tip2,
        cancelButtonText: tip3,
        type: 'warning'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].deleteData(_this);
      }, function () {});
    },
    choose: function choose() {
      this.isC = !this.isC;
      var table1 = document.getElementById('table1');
      var labels = table1.getElementsByTagName('label');
      for (var i = 0; i < labels.length; i++) {
        if (this.flag === 0) {
          labels[i].className = 'checked';
        } else {
          labels[i].className = '';
        }
      }

      if (labels[0].className === 'checked') {
        this.flag = 1;
      } else {
        this.flag = 0;
      }
      this.checkOverLapp();
    },
    select: function select(flag, e) {
      var index = e.target.parentNode.id;
      var id = 0;
      if (e.target.className === '') {
        e.target.className = 'checked';
      } else {
        e.target.className = '';
      }
      this.checkOverLapp();
    },
    choose2: function choose2() {
      this.isK = !this.isK;
      var table2 = document.getElementById('table2');
      var labels = table2.getElementsByTagName('label');
      for (var i = 0; i < labels.length; i++) {
        if (this.flag1 === 0) {
          labels[i].className = 'checked';
        } else {
          labels[i].className = '';
        }
      }
      if (labels[0].className === 'checked') {
        this.flag1 = 1;
      } else {
        this.flag1 = 0;
      }

      this.checkOverLapp();
    },
    goToUploadHistory: function goToUploadHistory() {
      this.$router.push('/dateView');
    },
    set1: function set1() {
      var data = {
        option: 'daopapp',
        cgms: [],
        pump: []
      };
      __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].setData(this, this.uid, { data: data });
    },
    set2: function set2() {
      if (this.isLapp1 || this.isLapp2) {
        var tip = this.$t('Time overlapped');
        this.$message.error(tip);
      } else {
        var data = {
          option: 'daoppdm',
          cgms: this.cgms,
          pump: this.pump
        };
        if (this.cgms.length === 0 && this.pump.length === 0) {
          var _tip = this.$t('selectData');
          this.$message.error(_tip);
        } else {
          __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].setData(this, this.uid, { data: data });
          sessionStorage.setItem('dateViewA', 0);
          sessionStorage.setItem('dateViewB', 1);
        }
      }
    },
    saveOption: function saveOption() {
      var data = {
        option: 'daoppdm',

        cgms: [],
        pump: []
      };
      if (this.isPDM && !this.isRealtime) {
        data.option = 'daoppdm';
      } else if (!this.isPDM && this.isRealtime) {
        data.option = 'daopapp';
      } else {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].setData(this, this.uid, { data: data });
    },
    checkData: function checkData() {
      this.cgms = [];
      this.pump = [];
      var table1 = document.getElementById('table1');
      var labels1 = table1.getElementsByTagName('label');
      for (var i = 0; i < labels1.length; i++) {
        if (labels1[i].className === 'checked') {
          var id = this.Sessions[0][i][2];
          this.cgms.push(id);
        }
      }
      var table2 = document.getElementById('table2');
      var labels2 = table2.getElementsByTagName('label');
      for (var _i = 0; _i < labels2.length; _i++) {
        if (labels2[_i].className === 'checked') {
          var _id = this.Sessions[1][_i][2];
          this.pump.push(_id);
        }
      }

      if (this.cgms.length === this.Sessions[0].length) {
        this.isC = true;
        this.flag = 1;
      } else {
        this.isC = false;
        this.flag = 0;
      }
      if (this.pump.length === this.Sessions[1].length) {
        this.isK = true;
        this.flag1 = 1;
      } else {
        this.isK = false;
        this.flag1 = 0;
      }
    },
    forMatter: function forMatter(val) {
      var that = this;
      val.map(function (e, i) {
        var t1 = e[1].split(' ');
        var t11 = t1[0].split('-');
        e[1] = that.isZh ? Date.parse(t11[0] + '/' + t11[1] + '/' + t11[2] + ' ' + t1[1]) / 1000 : Date.parse(t11[2] + '/' + t11[1] + '/' + t11[0] + ' ' + t1[1]) / 1000;

        var t2 = e[2].split(' ');
        var t21 = t2[0].split('-');
        e[2] = that.isZh ? Date.parse(t21[0] + '/' + t21[1] + '/' + t21[2] + ' ' + t2[1]) / 1000 : Date.parse(t21[2] + '/' + t21[1] + '/' + t21[0] + ' ' + t2[1]) / 1000;
        return e;
      });
    },
    initSession1: function initSession1() {
      for (var i = 0; i < this.Sessions[0].length; i++) {
        var id1 = 'lap' + i;
        var tr1 = document.getElementById(id1);
        tr1.style.color = "#282828";
      }
    },
    initSession2: function initSession2() {
      for (var i = 0; i < this.Sessions[1].length; i++) {
        var id1 = 'lapp' + i;
        var tr1 = document.getElementById(id1);
        tr1.style.color = "#282828";
      }
    },
    back: function back() {
      this.$router.push('/PatientList');
    }
  }
});

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_base64__ = __webpack_require__(9);





/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    this.$router.push('/monitor');
  }
});

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      uid: 0, isEn: false, isMg: '', isEs: false, isDe: false, isIt: false, isPo: false, isDu: false, isFr: false, isSw: false, isCz: false
    };
  },

  computed: {
    settingsData: function settingsData() {
      return this.$store.state.settingData;
    },
    sgLow: function sgLow() {
      var low = [];
      if (this.isMg) {
        for (var i = 60; i < 101; i = i + 1) {
          low.push(i.toFixed(0));
        }
      } else {
        for (var _i = 2.8; _i < 5.6; _i = _i + 0.1) {
          low.push(_i.toFixed(1));
        }
      }
      return low;
    },
    sgHigh: function sgHigh() {
      var high = [];
      if (this.isMg) {
        for (var i = 100; i < 361; i = i + 1) {
          high.push(i.toFixed(0));
        }
      } else {
        for (var _i2 = 5.6; _i2 < 20.1; _i2 = _i2 + 0.1) {
          high.push(_i2.toFixed(1));
        }
      }
      return high;
    },
    sgLowAfter: function sgLowAfter() {
      var low = [];
      if (this.isMg) {
        for (var i = 60; i < 131; i = i + 1) {
          low.push(i.toFixed(0));
        }
      } else {
        for (var _i3 = 3.3; _i3 < 7.2; _i3 = _i3 + 0.1) {
          low.push(_i3.toFixed(1));
        }
      }
      return low;
    },
    sgHighAfter: function sgHighAfter() {
      var high = [];
      if (this.isMg) {
        for (var i = 130; i < 361; i = i + 1) {
          high.push(i.toFixed(0));
        }
      } else {
        for (var _i4 = 7.2; _i4 < 20.1; _i4 = _i4 + 0.1) {
          high.push(_i4.toFixed(1));
        }
      }
      return high;
    },
    alertOption: function alertOption() {
      var option = this.$store.state.alarm_display;
      return option === 'On' ? true : false;
    },
    glucoseOption: function glucoseOption() {
      var option = this.$store.state.glucose_display;
      return option === 'On' ? true : false;
    }
  },
  methods: {
    apply: function apply() {
      if (sessionStorage.getItem('userType') !== 'P') {
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      } else {
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      var flag = this.isMg;
      var settings = {
        glucose_unit: 'mmol/L',
        btime1_s: this.settingsData.btime1_s,
        btime1_e: this.settingsData.btime1_e,
        afterb_s: this.settingsData.afterb_s,
        afterb_e: this.settingsData.afterb_e,
        blos_low_before_b: flag ? parseFloat(this.settingsData.blos_low_before_b / 18) : parseFloat(this.settingsData.blos_low_before_b),
        blos_high_before_b: flag ? parseFloat(this.settingsData.blos_high_before_b / 18) : parseFloat(this.settingsData.blos_high_before_b),
        blos_low_after_b: flag ? parseFloat(this.settingsData.blos_low_after_b / 18) : parseFloat(this.settingsData.blos_low_after_b),
        blos_high_after_b: flag ? parseFloat(this.settingsData.blos_high_after_b / 18) : parseFloat(this.settingsData.blos_high_after_b),
        ltime1_s: this.settingsData.ltime1_s,
        ltime1_e: this.settingsData.ltime1_e,
        afterl_s: this.settingsData.afterl_s,
        afterl_e: this.settingsData.afterl_e,
        blos_low_before_l: flag ? parseFloat(this.settingsData.blos_low_before_l / 18) : parseFloat(this.settingsData.blos_low_before_l),
        blos_high_before_l: flag ? parseFloat(this.settingsData.blos_high_before_l / 18) : parseFloat(this.settingsData.blos_high_before_l),
        blos_low_after_l: flag ? parseFloat(this.settingsData.blos_low_after_l / 18) : parseFloat(this.settingsData.blos_low_after_l),
        blos_high_after_l: flag ? parseFloat(this.settingsData.blos_high_after_l / 18) : parseFloat(this.settingsData.blos_high_after_l),
        stime1_s: this.settingsData.stime1_s,
        stime1_e: this.settingsData.stime1_e,
        afters_s: this.settingsData.afters_s,
        afters_e: this.settingsData.afters_e,
        blos_low_before_s: flag ? parseFloat(this.settingsData.blos_low_before_s / 18) : parseFloat(this.settingsData.blos_low_before_s),
        blos_high_before_s: flag ? parseFloat(this.settingsData.blos_high_before_s / 18) : parseFloat(this.settingsData.blos_high_before_s),
        blos_low_after_s: flag ? parseFloat(this.settingsData.blos_low_after_s / 18) : parseFloat(this.settingsData.blos_low_after_s),
        blos_high_after_s: flag ? parseFloat(this.settingsData.blos_high_after_s / 18) : parseFloat(this.settingsData.blos_high_after_s),
        etime1_s: this.settingsData.etime1_s,
        etime1_e: this.settingsData.etime1_e,
        blos_low_night: flag ? parseFloat(this.settingsData.blos_low_night / 18) : parseFloat(this.settingsData.blos_low_night),
        blos_high_night: flag ? parseFloat(this.settingsData.blos_high_night / 18) : parseFloat(this.settingsData.blos_high_night),
        blos_low: flag ? parseFloat(this.settingsData.blos_low / 18) : parseFloat(this.settingsData.blos_low),
        blos_high: flag ? parseFloat(this.settingsData.blos_high / 18) : parseFloat(this.settingsData.blos_high),
        hypo: flag ? parseFloat(this.settingsData.hypo / 18) : parseFloat(this.settingsData.hypo),
        alarm_display: this.alertOption ? "On" : "Off",
        glucose_display: this.glucoseOption ? "On" : "Off"
      };
      this.$http.post('api/v2.0/settings/' + this.uid, { settings: settings }).then(function (res) {
        var err = res.body.error;
        if (err === 0) {
          var tip = this.$t('saveTip');
          this.$message({
            type: 'success',
            message: tip
          });
          __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getSettingData(this, this.uid);
        } else {
          var _tip = this.$t('Input error');
          this.$message.error(_tip);
        }
      });
    },
    cancel: function cancel() {
      this.$router.push('/monitor');
    },
    restore: function restore() {
      var flag = this.isMg;
      var settings = {
        glucose_unit: "mmol/L",
        btime1_s: '7:00',
        btime1_e: "8:00",
        afterb_s: '1:00',
        afterb_e: '3:00',
        blos_low_before_b: flag ? 70 : 3.9,
        blos_high_before_b: flag ? 130 : 7.2,
        blos_low_after_b: flag ? 100 : 5.6,
        blos_high_after_b: flag ? Math.round(8.9 * 18) : 8.9,
        ltime1_s: '12:00',
        ltime1_e: '13:00',
        afterl_s: '1:00',
        afterl_e: '3:00',
        blos_low_before_l: flag ? 70 : 3.9,
        blos_high_before_l: flag ? 130 : 7.2,
        blos_low_after_l: flag ? 100 : 5.6,
        blos_high_after_l: flag ? 160 : 8.9,
        stime1_s: '18:00',
        stime1_e: '19:00',
        afters_s: '1:00',
        afters_e: '3:00',
        blos_low_before_s: flag ? 70 : 3.9,
        blos_high_before_s: flag ? 130 : 7.2,
        blos_low_after_s: flag ? 100 : 5.6,
        blos_high_after_s: flag ? 160 : 8.9,
        etime1_s: '23:00',
        etime1_e: '6:00',
        blos_low_night: flag ? 100 : 5.6,
        blos_high_night: flag ? 160 : 8.9,
        blos_low: flag ? 70 : 3.9,
        blos_high: flag ? 180 : '10.0',
        hypo: flag ? 56 : 3.1
      };
      this.$store.commit('updateAlarm', 'Off');
      this.$store.commit('updateSettingData', settings);
    },
    changeAlarm: function changeAlarm(flag) {
      var alarm_display = flag === 0 ? 'On' : 'Off';
      this.$store.commit('updateAlarm', alarm_display);
    },
    changeGlucose: function changeGlucose(flag) {
      var glucose_display = flag === 0 ? 'On' : 'Off';
      this.$store.commit('updateGlucose', glucose_display);
    }
  },
  mounted: function mounted() {
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isEs = lang === 'es' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isSw = lang === 'sw' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
  }
});

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_base64__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_loading__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_format__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_chartTipFormat__ = __webpack_require__(149);










/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_loading__["a" /* loading */]],
  data: function data() {
    return {
      chartWidth: '', timer: false, st: 0, et: 0, clock: '', updateTime1: '', sgIcon: '', batteryIcon: '', uid: 0, isMg: '', st1: '', DataSG: [], ts: [], isEs: false,
      sensor_alarm: [], pump_alarm: [], carb: [], exercise: [], calib: [], lastBolus: '--', isDe: false, isIt: false, isPo: false, isDu: false,
      extend_bolus: [[10, 10, 10, 10, 10]], basal_suspend: [], newBasal: [], stopBasal: [], basal_suspend2: [], isFr: false, isSw: false, isCz: false,
      sgMax: 25, basalMax: 5, bolusMax: 10, DataBolus: [], tempBasal: [], sensorTime: '--', pumpTime: '', updateXhr: null,
      sleepTime1: [[10, 10, 10], [10, 10, 10]],
      sleepTime2: [[10, 10, 10], [10, 10, 10]],

      autoModeBasal: [],
      autoModeCorrBolus: [],

      showConfirmDialog: false,
      dialogSize: 'small',
      bolus: [],
      basal: [],
      chartColumn: null, chartColumn1: null, isEn: false, tz: 8, timeout2: '',
      textStyle: {
        color: '#282828',
        fontWeight: 'normal',
        fontSize: '14',
        fontFamily: 'SFUIText-Regular'
      },
      titlePadding: [0, 0, 8, 33],
      grid: { x: '3%', y: '16%', width: '94%', height: '73%' },
      sgRange: [['', '4.4', '8.9', '13.3', '17.8', '22.2'], ['', '0.2', '0.4', '0.6', '0.8', '1.0'], ['', '1', '2', '3', '4', '5'], ['0', '1', '2', '3', '4', '5'], ['', this.$t('Light'), '', this.$t('Medium'), '', this.$t('heavy')]],
      dateTime: ["00:00", " ", "", "3:00", "", "", "6:00", "", "", "9:00", "", "", "12:00", "", "", "15:00", "", "", "18:00", "", "", "21:00", "", "", "24:00"],
      yAxisLabel: { interval: 0, margin: 5, textStyle: { color: '#282828', baseline: 'middle' }, showMinLabel: false },
      areaStyle: {
        color: ['rgba(200,200,200,0.3)', 'rgba(200,200,200,0.3)', 'rgba(200,200,200,0.3)', 'rgba(200,200,200,0.3)', 'rgba(200,200,200,0.3)', 'rgba(200,200,200,0.3)', 'rgba(200,200,200,0.3)', 'rgba(250,250,250,0.3)', 'rgba(250,250,250,0.3)', 'rgba(250,250,250,0.3)', 'rgba(250,250,250,0.3)', 'rgba(250,250,250,0.3)', 'rgba(250,250,250,0.3)', 'rgba(250,250,250,0.3)', 'rgba(250,250,250,0.3)', 'rgba(250,250,250,0.3)', 'rgba(250,250,250,0.3)', 'rgba(250,250,250,0.3)', 'rgba(250,250,250,0.3)', 'rgba(250,250,250,0.3)', 'rgba(250,250,250,0.3)']
      },
      status: ['--', this.$t('Warm up'), this.$t('Warm up'), this.$t('Monitoring'), this.$t('Transmitter Error'), this.$t('Sensor Failure'), this.$t('Sensor Expired'), this.$t('Lost Sensor'), this.$t('Not Calibrated'), this.$t('Calibrating'), this.$t('Calibration Needed'), this.$t('Calibration Error'), this.$t('Calibration Error'), this.$t('Charging Battery'), this.$t('Battery Charged')],
      state1: ['--', this.$t('To be filled'), this.$t('Filled with insulin'), this.$t('Priming'), this.$t('Priming completed'), this.$t('Inserting needle'), this.$t('Patch activated')],
      state2: [this.$t('Delivering Basal'), this.$t('Delivering Basal')],
      state3: [this.$t('Low Suspend'), this.$t('Predictive Low Suspend'), this.$t('Auto Off'), this.$t('Exceeds Max 1 Hour Delivery'), this.$t('Exceeds Max TDD'), this.$t('Suspend')],
      state4: [this.$t('Occlusion Detected'), this.$t('Patch Expired'), this.$t('Empty Reservoir'), this.$t('Patch Error'), this.$t('Patch Error'), this.$t('Pump Base Error'), this.$t('Patch Battery Depleted'), this.$t('Magnetic sensor not calibrated')],
      injState: {
        'BART': this.$t('Delivering Temp Basal'),
        'Bolus': this.$t('Delivering Bolus')
      },
      showCGMStatus: false,
      basalChartUpdateTime: 0,
      bolusChartUpdateTime: 0
    };
  },


  computed: {
    sensor: function sensor() {
      return this.$store.state.sensor;
    },
    pump: function pump() {
      return this.$store.state.pump;
    },
    DataS: function DataS() {
      return this.$store.state.DataS;
    },
    DataBasal: function DataBasal() {
      return this.$store.state.DataBasal;
    },

    timeout1: {
      set: function set(val) {
        this.$store.state.compileTimeout = val;
      },
      get: function get() {
        return this.$store.state.compileTimeout;
      }
    },
    getGlucose: function getGlucose() {
      if (this.sensor.glucose && this.sensor.glucose !== '--') {
        var range = this.isMg === true ? [40, 400] : [2.2, 22.2];
        var num = +this.sensor.glucose.match(/[0-9\\.]+/g)[0];
        if (num > range[1]) return 'HIGH';else if (num < range[0]) return 'LOW';else return this.sensor.glucose;
      }
      return this.sensor.glucose;
    }
  },
  methods: {
    addBasalRecord: function addBasalRecord(newBasal) {
      var curDate = new Date();
      var curDateStart = new Date(curDate.getFullYear(), curDate.getMonth(), curDate.getDate());
      var curDateStart = curDateStart.getTime() / 1000;
      if (newBasal[1] + newBasal[3] <= curDateStart || newBasal[1] >= curDateStart + 86400) {
        return false;
      }

      var i = 0;
      for (; i < this.basal.length; i++) {
        if (newBasal[0] == this.basal[i][0]) {
          this.basal[i] = newBasal;
          return true;
        }
      }
      if (i == this.basal.length) {
        this.basal.push(newBasal);

        return true;
      }
      return false;
    },
    addBolusRecord: function addBolusRecord(newBolus) {
      var curDate = new Date();
      var curDateStart = new Date(curDate.getFullYear(), curDate.getMonth(), curDate.getDate());
      var curDateStart = curDateStart.getTime() / 1000;
      if (newBolus[1] < curDateStart || newBolus[1] >= curDateStart + 86400) {
        return false;
      }

      var i = 0;
      for (; i < this.bolus.length; i++) {
        if (newBolus[0] == this.bolus[i][0]) {
          this.bolus[i] = newBolus;
          return true;
        }
      }
      if (i == this.bolus.length) {
        this.bolus.push(newBolus);
        return true;
      }
      return false;
    },
    calDayBasalTotal: function calDayBasalTotal() {
      var basalTotal = 0;
      for (var i = 0; i < this.basal.length; i++) {
        if ('BAAM' != this.basal[i][2]) {
          basalTotal += this.basal[i][5];
        }
      }
      return basalTotal;
    },
    calDayAutoModeTotal: function calDayAutoModeTotal() {
      var autoBasalTotal = 0;
      var autoBolusTotal = 0;
      for (var i = 0; i < this.basal.length; i++) {
        var basalType = this.basal[i][2];
        if ('BAAM' == basalType) {
          var autoModeData = this.basal[i][7];

          try {
            autoModeData = JSON.parse(autoModeData);
            var autoModeJson = autoModeData['autoModeJSON'];
            autoModeJson.map(function (e, i) {
              autoBasalTotal += e['auto_basal_delivery'] * 0.05;
              autoBolusTotal += (e['auto_food_delivery'] + e['auto_corr_delivery']) * 0.05;
            });
          } catch (e) {
            console.log('calDayAutoModeTotal error:', e);
          }
        }
      }
      return [autoBasalTotal, autoBolusTotal];
    },
    calDayBolusTotal: function calDayBolusTotal() {
      var bolusTotal = 0;
      for (var i = 0; i < this.bolus.length; i++) {
        bolusTotal += this.bolus[i][4] + this.bolus[i][6];
      }
      return bolusTotal;
    },
    drawColumnChart: function drawColumnChart() {
      var _this = this;

      var id = 'chart1';
      var that = this;
      this.chart1 = __WEBPACK_IMPORTED_MODULE_2_echarts__["init"](document.getElementById(id));
      this.registLoading(id, this.chart1);
      this.chart1.setOption({
        title: {
          text: this.isMg ? this.$t('SG') + ' (mg/dL)' : this.$t('SG') + ' (mmol/L)',
          textStyle: this.textStyle,
          padding: this.titlePadding
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            axis: 'x',
            lineStyle: { color: '#333' }
          },
          backgroundColor: '#555',
          textStyle: {
            color: ' #ffffff'
          },
          formatter: function formatter(params) {
            var tip = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterTip1(params, that);

            return tip;
          }
        },
        xAxis: [{
          type: 'time',
          boundaryGap: false,
          min: this.st * 1000,
          max: this.et * 1000,
          axisLabel: {
            showMaxLabel: true,
            margin: 10, textStyle: { color: '#282828', baseline: 'middle' },
            formatter: function formatter(value, index) {
              index = (value - that.st * 1000) / 3600000;
              var H = index;
              if (index < 24) {
                if (index % 3 === 0) {
                  H = H < 10 ? '0' + H + ':00' : H + ':00';
                  return H;
                } else {
                  return ' ';
                }
              } else {
                return '24:00';
              }
            }
          },
          axisLine: { lineStyle: { color: '#ccc' } },
          splitNumber: 24,
          axisPointer: { snap: true }
        }],
        yAxis: [{
          type: 'value',
          min: 0,
          max: this.sgMax,
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          boundaryGap: false,
          axisTick: { length: 0 }
        }],
        grid: this.grid,
        series: [{
          name: 'SG',
          type: 'scatter',
          data: this.DataSG,
          itemStyle: { normal: {
              color: function color(params) {
                var color = '#2cd200';
                if (params.value[1] < 0.1 && params.value[2] === 'H') {
                  color = '#a4a4a4';
                } else {
                  if (that.isMg) {
                    if (params.value[1] > that.DataS.blos_high * 18) {
                      color = '#e6be00';
                    }
                    if (params.value[1] < that.DataS.blos_low * 18) {
                      color = '#ff5c5c';
                    }
                  } else {
                    if (params.value[1] > that.DataS.blos_high) {
                      color = '#e6be00';
                    }
                    if (params.value[1] < that.DataS.blos_low) {
                      color = '#ff5c5c';
                    }
                  }
                }
                var type = params.value[2];
                if (type === 'NC' && params.value[1] == 0 || type === 'DE' || type === 'CE0' || type === 'CE1') {
                  color = 'transparent';
                }
                return color;
              }
            } },
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);
              if (params.value[1] > 0) {
                if (params.value[2] === 'CX' || params.value[2] === 'NC') {
                  return time[0] + ':' + time[1] + ', ' + params.value[1] + '<hr style="width: 20px;background:#fff;height:1px;border:none;margin-left: 42px;">';
                }
                return time[0] + ':' + time[1] + ', ' + params.value[1];
              } else {
                if (params.value[2] === 'NC') {
                  return time[0] + ':' + time[1] + ', Not Calibrated';
                }
                if (params.value[2] === 'DE') {
                  return time[0] + ':' + time[1] + ', No Readings';
                }
                if (params.value[2] === 'CE0' || params.value[2] === 'CE1') {
                  return time[0] + ':' + time[1] + ',Calib Error';
                }
                return time[0] + ':' + time[1] + ', warm up';
              }
            }
          },
          markArea: {
            data: [[{ yAxis: this.isMg ? this.DataS.blos_low * 18 : this.DataS.blos_low }, { yAxis: this.isMg ? this.DataS.blos_high * 18 : this.DataS.blos_high }]],
            tooltip: { show: false,
              trigger: 'none' },
            itemStyle: {
              normal: {
                color: 'rgba(211,255,213,0.6)'
              }
            }
          },
          markLine: {
            data: [{ yAxis: this.isMg ? this.DataS.hypo * 18 : this.DataS.hypo }],
            silent: true,
            symbol: ['circle', 'circle'],
            symbolSize: 1,
            lineStyle: { normal: {
                color: 'rgba(255,0,0,0.5)',
                type: 'solid'
              } },
            label: { normal: { show: false } }
          },
          symbolSize: 2
        }, {
          type: 'scatter',
          data: this.calib,
          name: 'calib',
          symbol: 'image://static/legend/calib.png',
          tooltip: { backgroundColor: '#555',
            trigger: 'item',
            formatter: function formatter(params) {
              var timeDetail = __WEBPACK_IMPORTED_MODULE_7__lib_chartTipFormat__["a" /* default */].getFormatterTip1TimeDetail(params.value[0]);
              var tip = timeDetail + __WEBPACK_IMPORTED_MODULE_7__lib_chartTipFormat__["a" /* default */].calibFormat(params, _this);
              return tip;
            }
          },
          label: {
            show: this.$store.state.glucose_display === 'On',
            color: '#114C9A',
            backgroundColor: '#E7F5F9',
            position: 'top',
            distance: 10,
            fontSize: 16,
            width: 40,
            height: 20,
            borderColor: '#7AACBF'
          },
          emphasis: {
            focus: 'self'
          }
        }, {
          type: 'scatter',
          name: 'alarm',
          data: this.sensor_alarm,
          symbol: 'image://static/legend/Alert.png',
          symbolSize: 13,
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);

              return time[0] + ':' + time[1] + ', ' + params.value[2];
            }
          }
        }, {
          type: 'scatter',
          name: 'transmtr',
          data: this.transmtr,
          symbol: 'rect',
          symbolSize: 5,
          itemStyle: { normal: { color: '#00a107' } },
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + 'New Sensor';
            }
          }
        }, {
          type: 'custom',
          data: this.sleepTime1,
          z: -1,
          renderItem: function renderItem(params, api) {
            var y = api.value(2);
            var start = api.coord([api.value(0), y]);
            var size = api.size([api.value(1) - api.value(0), y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },
          tooltip: { show: false },
          itemStyle: { normal: { color: 'rgba(170,170,170,0.2)' } }
        }]
      });
    },
    drawColumnChart1: function drawColumnChart1() {
      var id = 'chart2';
      var ins_unit2 = this.$t('ins_unit2');
      var that = this;
      this.chart2 = __WEBPACK_IMPORTED_MODULE_2_echarts__["init"](document.getElementById(id));
      this.chart2.setOption({
        title: [{
          text: this.$t('basal') + ' ' + this.$t('basal_unit'),
          textStyle: this.textStyle,
          padding: this.titlePadding
        }, {
          text: this.$t('bolus') + ' ' + this.$t('ins_unit'),
          textStyle: this.textStyle,
          right: '18'
        }],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            axis: 'x',
            lineStyle: { color: '#333' }
          },
          backgroundColor: '#555',
          textStyle: {
            color: ' #ffffff'
          },
          formatter: function formatter(params) {
            var tip = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterTip(params, that, 'monitor');
            return tip;
          }
        },
        xAxis: [{
          type: 'time',
          boundaryGap: false,
          min: this.st * 1000,
          max: this.et * 1000,
          interlval: 0,

          axisLabel: {
            showMaxLabel: true,
            margin: 10, textStyle: { color: '#282828', baseline: 'middle' },
            formatter: function formatter(value, index) {
              index = (value - that.st * 1000) / 3600000;
              var H = index;

              if (index < 24) {
                if (index % 3 === 0) {
                  H = H < 10 ? '0' + H + ':00' : H + ':00';
                  return H;
                } else {
                  return ' ';
                }
              } else {
                return '24:00';
              }
            }
          },
          axisLine: { lineStyle: { color: '#ccc' } },
          splitNumber: 24
        }],
        yAxis: [{
          type: 'value',
          boundaryGap: false,
          min: 0,
          max: this.basalMax,
          axisTick: { length: 0 },
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } }
        }, {

          type: 'value',
          boundaryGap: false,
          min: 0,
          max: this.bolusMax,
          axisTick: { length: 0 },
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          splitLine: { show: false }
        }],
        grid: this.grid,
        series: [{
          type: 'line',
          name: this.$t('basal'),
          data: this.DataBasal,

          itemStyle: { normal: { color: '#00ff40' } },
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + params.value[1];
            }
          },
          symbolSize: 2
        }, {
          type: 'line',
          name: this.$t('auto suspend'),
          data: this.basal_suspend,
          itemStyle: { normal: { color: '#ff0000' } },
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + params.value[2];
            }
          },
          lineStyle: { normal: { type: 'dashed' } },
          symbolSize: 1
        }, {
          type: 'line',
          name: this.$t('tempBasal'),
          data: this.tempBasal,
          itemStyle: { normal: { color: '#00ff40' } },
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + 'TempBasal: ' + params.value[1];
            }
          },
          lineStyle: { normal: { type: 'dashed' } },
          symbolSize: 1
        }, {
          type: 'line',
          name: this.$t('manualStop'),
          data: this.basal_suspend2,
          itemStyle: { normal: { color: '#ff0000' } },
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + 'Manual Suspend';
            }
          },
          symbolSize: 1
        }, {
          type: 'custom',
          name: this.$t('normalBolus'),

          data: this.DataBolus,
          z: 999,
          yAxisIndex: 1,
          itemStyle: { normal: { color: '#182f82' } },
          renderItem: function renderItem(params, api) {
            var y = api.value(1);
            var start = api.coord([api.value(0), y]);
            var size = api.size([600000, y]);
            var style = api.style();

            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + params.value[2] + ': ' + params.value[1] + ins_unit2;
            }
          },
          barWidth: '4'
        }, {
          type: 'custom',
          name: this.$t('extendBolus'),
          data: this.extend_bolus,
          yAxisIndex: 1,
          renderItem: function renderItem(params, api) {
            var y = api.value(2);
            var start = api.coord([api.value(0), y]);
            var size = api.size([api.value(1) - api.value(0), y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + params.value[4] + ': ' + params.value[2] + ins_unit2 + '/' + params.value[3] + 'min';
            }
          },
          itemStyle: { normal: { color: '#f9b4ff' }, emphasis: { color: '#f9b4ff' } }
        }, {
          type: 'scatter',
          name: this.$t('newPatch'),
          data: this.newBasal,
          itemStyle: { normal: { color: '#fff', borderColor: '#f00' } },
          symbol: 'image://static/legend/new%20Patch.png',
          symbolSize: 10,
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ',New Patch ';
            }
          }
        }, {
          type: 'scatter',
          name: this.$t('stop'),
          data: this.stopBasal,
          symbol: 'image://static/legend/patch%20Deactivated.png',
          symbolSize: 8,
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', Delivery Stop';
            }
          }
        }, {
          type: 'scatter',
          name: this.$t('alert'),
          data: this.pump_alarm,
          symbol: 'image://static/legend/Alert.png',
          symbolSize: 13,
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + params.value[2];
            }
          }
        }, {
          type: 'custom',
          data: this.sleepTime2,
          z: -1,
          renderItem: function renderItem(params, api) {
            var y = api.value(2);
            var start = api.coord([api.value(0), y]);
            var size = api.size([api.value(1) - api.value(0), y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },
          tooltip: { show: false },
          itemStyle: { normal: { color: 'rgba(170,170,170,0.2)' } }
        }, {
          type: 'custom',
          name: this.$t('t1222_autoModeBasal'),
          data: this.autoModeBasal,
          yAxisIndex: 0,
          renderItem: function renderItem(params, api) {
            var y = api.value(2);
            var start = api.coord([api.value(0), y]);
            var size = api.size([api.value(1) - api.value(0), y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: {
                fill: 'rgba(0, 255, 76, 0.5)'
              }
            };
          },
          tooltip: { backgroundColor: '#333'
          },
          itemStyle: { normal: { color: '#00ff4c' }, emphasis: { color: '#00ff5c' } }
        }, {
          type: 'custom',
          name: this.$t('t1222_autoModeCorrBolus'),
          data: this.autoModeCorrBolus,
          yAxisIndex: 1,
          itemStyle: { normal: { color: '#009bff' } },
          renderItem: function renderItem(params, api) {
            var y = api.value(2) + api.value(1);
            var start = api.coord([api.value(0), y]);
            var size = api.size([600000, y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },
          barWidth: '4'
        }]
      });
    },
    drawCharts: function drawCharts() {
      this.drawColumnChart();
      this.drawColumnChart1();
    },
    handleResize: function handleResize() {
      var win = window.innerWidth;
      var scale = win < 1500 ? 0.91 : 0.62;
      var chartWidth = win * scale * 0.98 * 0.95 + 'px';
      var chart1 = document.getElementById('chart1');
      var chart2 = document.getElementById('chart2');
      if (chart1) {
        chart1.style.width = chartWidth;
        chart2.style.width = chartWidth;
      }
    },
    reFresh: function reFresh() {
      var uid = [this.uid];
      var param = {
        uids: uid
      };
      sessionStorage.setItem('monitor', 1);
      __WEBPACK_IMPORTED_MODULE_3__auth_auth__["a" /* default */].getMonData1(this, param);
    },
    checkPrivacyVersion: function checkPrivacyVersion() {
      this.$http.get('/api/v2.1/user/privacy/confirm').then(function (res) {
        if (0 == res.data.error) {
          if (0 == res.data.confirm) {
            this.showConfirmDialog = true;
          }
        }
      }, function (err) {});
    },
    denyPrivacyConfirm: function denyPrivacyConfirm() {
      this.showConfirmDialog = false;
    },
    agreePrivacyConfirm: function agreePrivacyConfirm() {
      this.showConfirmDialog = false;
      this.$http.post('/api/v2.1/user/privacy/confirm').then(function (res) {}, function (err) {});
    },
    testButton: function testButton() {
      __WEBPACK_IMPORTED_MODULE_3__auth_auth__["a" /* default */].updateBasalChart(this);
    }
  },
  created: function created() {
    if (this.timeout1) {
      clearTimeout(this.timeout1);
    }
  },
  beforeDestroy: function beforeDestroy() {
    var request = this.$store.state.Request;
    if (request.length > 0) {
      request.map(function (e, i) {
        e.abort();
      });
    }
    this.$store.commit('updateRequest', null);
    sessionStorage.removeItem('monitor');
    if (this.timeout1) {
      clearTimeout(this.timeout1);
    }
  },


  mounted: function mounted() {
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isEs = lang === 'es' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isSw = lang === 'sw' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    this.sgMax = this.isMg ? 400 : 25;
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }
    this.st1 = new Date().setHours(0, 0, 0, 0) / 1000;
    var sta = __WEBPACK_IMPORTED_MODULE_6__lib_format__["a" /* default */].formatterDate9(this.st1);
    var starDate = new Date(this.st1 * 1000);
    var et = new Date(starDate.setDate(sta[2] + 1)).getTime() / 1000;
    this.ts = [this.st1, et];
    this.tz = parseInt(sessionStorage.getItem('tz'));
    var param = {
      ts: this.ts,
      tz: this.tz
    };
    param = __WEBPACK_IMPORTED_MODULE_4__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));
    __WEBPACK_IMPORTED_MODULE_3__auth_auth__["a" /* default */].getMonData(this, param, this.uid);
    this.checkPrivacyVersion();
    var that = this;
    window.onresize = function () {
      that.handleResize();
      that.chart1.resize();
      that.chart2.resize();
    };
    this.reFresh();
  }
});

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_format__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      realname: '', gender: '', height: '', weight: '', isEs: false, isDe: false, Time: this.$t('time'),
      birthday: '', diabetes_type: '', diabetes_diagnosis_date: '',
      address1: '', address2: '', postcode: '', mobile: '', telephone: '', email: '', isIt: false, isPo: false, isCz: false,
      inpatient: '', patient_no: '', bed_no: '', isDu: false, isFr: false, isZh: false, isSw: false, isEU: true,
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      contactURL: '',
      privacyURL: '',
      termsOfUseURL: ''
    };
  },

  vuerify: {
    mobile: 'mobile',
    height: 'height',
    weight: 'weight',
    email: 'email'
  },
  methods: {
    back: function back() {
      this.$router.push('/PatientList');
    },
    create: function create() {
      var bthday = this.birthday ? __WEBPACK_IMPORTED_MODULE_1__lib_format__["a" /* default */].formatterDate3(this.birthday.getTime() / 1000) : '';
      var diagnosis_date = this.diabetes_diagnosis_date ? __WEBPACK_IMPORTED_MODULE_1__lib_format__["a" /* default */].formatterDate3(this.diabetes_diagnosis_date.getTime() / 1000) : '';
      var obj1 = document.getElementById('dis_type');
      var dis_type = obj1.value;
      if (!dis_type) {
        dis_type = "DBTNF";
      }
      var obj2 = document.getElementById('gender');
      var gender = obj2.value;
      if (!gender) {
        gender = "GDRNF";
      }
      var info = {
        realname: this.realname,
        gender: gender,
        height: this.height,
        weight: this.weight,
        birthday: bthday,
        diabetes_type: dis_type,
        diabetes_diagonosis_date: diagnosis_date,
        address: this.address1 + this.address2, postcode: this.postcode,
        mobile: this.mobile, telephone: this.telephone, email: this.email,
        inHospital: this.inpatient,
        patientNo: this.patient_no,
        bedNo: this.bed_no
      };

      if (this.realname === '') {
        var tip = this.$t('A name is required');
        this.$message.error(tip);
      } else {
        this.$http.post('api/v2.0/patients/new', { 'info': info }).then(function (res) {
          var err = res.body.error;
          if (err === 0) {
            this.$message({
              type: 'success',
              message: 'Created sucessfully'
            });
            this.$router.push('/PatientList');
          } else {
            this.$message.error('Create failed');
          }
        }, function (err) {
          console.log(err + "," + err.body.message);
          this.error = err.body.message;
        });
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    var lang = sessionStorage.getItem('language');
    this.isEs = lang === 'es' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isZh = lang === 'zh' ? true : false;
    this.isSw = lang === 'sw' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    var countryIndex = localStorage.getItem('index');

    if (1 == countryIndex || 6 == countryIndex || 14 == countryIndex) {
      this.isEU = false;
    }
    setTimeout(function () {
      var host = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getOuterHost();
      _this.contactURL = host + '/contact.html';
      _this.privacyURL = host + '/privacy_policy.html';
      _this.termsOfUseURL = host + '/terms_of_use.html';
    }, 50);
  }
});

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_format__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      email: '',
      mobile: '',
      vcode: '',
      icode: '',
      password: '',
      error: '',
      full_name: '',
      token: '',
      newStyle: false, flag: 0, flag1: 0, country: "", countryShow: '', invite_token: '',

      send: this.$t('send'), Ema: this.$t('Enter email'), Mob: this.$t('Enter mobile'), userName: '',
      Veri: this.$t('Verification'), invi: this.$t('Invitation'), fullname: this.$t('full name'), Enterpas: this.$t('Enter pass'),
      canClick: false,

      isA: false, isB: true, isC: false, isD: true, isE: false, isF: false,
      isG: false, isH: false, isI: false, isJ: false, isK: false,
      isO: false, isP: false, isQ: false, isR: false, isS: false, isT: false,
      disA: true, disB: true, disC: true, disD: true, disE: true, disF: true,
      ps1: false, ps2: false, ps3: false, ps4: false, ps5: false, ps6: false
    };
  },

  vuerify: {
    full_name: 'realname',
    vcode: 'icode'
  },
  computed: {
    errors: function errors() {
      return this.$vuerify.$errors;
    },
    getLanguage: function getLanguage() {
      return this.$store.state.language;
    }
  },
  watch: {
    getLanguage: function getLanguage(val) {
      this.send = this.$t('send');
      this.Ema = this.$t('Enter email');
      this.Mob = this.$t('Enter mobile');
      this.Veri = this.$t('Verification');
      this.invi = this.$t('Invitation');
      this.fullname = this.$t('full name');
      this.Enterpas = this.$t('Enter pass');
      if (val === 'zh') {
        this.newStyle = true;
      } else {
        this.newStyle = false;
      }
      console.log(this.newStyle);
    }
  },
  methods: {
    register: function register() {
      var info = {
        user_type: 'P',
        user_name: this.userName,
        password: this.password,
        real_name: this.full_name,
        country: this.country,
        token: this.token,
        invite_token: this.invite_token,
        seccode: this.vcode,
        ver: 2
      };

      if (this.$vuerify.valid) {
        __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].register(this, info);
      } else {
        var err = 'some required is not fill!';
        alert(this.$vuerify.$errors.email || err);
      }
    },
    sendSeccode: function sendSeccode() {
      var para = {
        user_name: this.userName,
        country: this.country,
        flag: 'email',
        purpose: 'regist'
      };
      if (para.user_name === "") {
        alert('email  is required!');
      } else {
        __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].sendSeccode(this, para);
        __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].setTime(this);
      }
    },
    checkPassword: function checkPassword() {
      var password = this.password.trim();
      if (password.length > 5 && password.length < 21) {
        this.ps2 = true;
      } else {
        this.ps2 = false;
      }
      if (password.length > 0) {
        if (password.indexOf(' ') === -1) {
          this.ps6 = true;
        } else {
          this.ps6 = false;
        }
        if (password === this.full_name) {
          this.ps3 = false;
        } else {
          this.ps3 = true;
        }
        var p1 = /[a-z]/.test(password),
            p2 = /[A-Z]/.test(password),
            p3 = /[0-9]/.test(password),
            p4 = /[!@#$%^&*()_+={},.;'\\":~`\[\]<>|/?]/.test(password),
            count = 0;
        if (p1) {
          count++;
        }
        if (p2) {
          count++;
        }
        if (p3) {
          count++;
        }
        if (p4) {
          count++;
        }
        if (count > 2) {
          this.ps1 = true;
        } else {
          this.ps1 = false;
        }

        for (var i = 0; i < password.length - 2; i++) {
          if (password[i + 1] - password[i] === 1 && password[i + 2] - password[i + 1] === 1) {
            this.flag = 1;break;
          } else {
            this.flag = 0;
          }
          if (password[i] - password[i + 1] === 1 && password[i + 1] - password[i + 2] === 1) {
            this.flag = 1;break;
          } else {
            this.flag = 0;
          }
        }
        if (this.flag === 0) {
          this.ps4 = true;
        } else {
          this.ps4 = false;
        }

        for (var _i = 0; _i < password.length - 2; _i++) {
          if (password[_i + 1].charCodeAt() - password[_i].charCodeAt() === 1 && password[_i + 2].charCodeAt() - password[_i + 1].charCodeAt() === 1) {
            this.flag1 = 1;break;
          } else {
            this.flag1 = 0;
          }
          if (password[_i].charCodeAt() - password[_i + 1].charCodeAt() === 1 && password[_i + 1].charCodeAt() - password[_i + 2].charCodeAt() === 1) {
            this.flag1 = 1;break;
          } else {
            this.flag1 = 0;
          }
        }
        if (this.flag1 === 0) {
          this.ps5 = true;
        } else {
          this.ps5 = false;
        }
      }
      console.log();
      if (this.ps1 === true && this.ps2 === true && this.ps3 === true && this.ps4 === true && this.ps5 === true && this.ps6 === true) {
        this.isT = false;
        this.disF = true;
      } else {
        this.isT = true;
        this.disF = false;
      }
    },


    check1: function check1() {
      this.isA = !this.isA;
    },
    check2: function check2() {
      this.isB = !this.isB;
      this.isC = !this.isC;
    },
    check3: function check3() {
      this.isD = !this.isD;
      this.isE = !this.isE;
    },

    check56: function check56(flag) {
      this.isH = !this.isH;
      if (this.Veri === '') {
        this.Veri = this.$t('Verification');
      } else {
        this.Veri = '';
      }
      if (flag === 1) {
        if (this.$vuerify.$errors.vcode || this.vcode === '') {
          this.isQ = true;
          this.disC = false;
        } else {
          this.isQ = false;
          this.disC = true;
        }
      }
    },
    check58: function check58(flag) {
      this.isJ = !this.isJ;
      if (this.fullname === '') {
        this.fullname = this.$t('full name');
      } else {
        this.fullname = '';
      }
      if (flag === 1) {
        if (this.$vuerify.$errors.full_name || this.full_name === '') {
          this.isS = true;
          this.disE = false;
        } else {
          this.isS = false;
          this.disE = true;
        }
      }
    },
    check59: function check59(flag) {
      this.isK = !this.isK;
      if (this.Enterpas === '') {
        this.Enterpas = this.$t('Enter pass');
      } else {
        this.Enterpas = '';
      }
      if (flag === 1) {
        this.checkPassword();
      }
    }
  },
  mounted: function mounted() {
    var url = location.href;
    if (url.indexOf('?') !== -1) {
      var str = url.substr(1);
      this.invite_token = str.split('=')[1];
      var param = {
        token: this.invite_token
      };
      this.$http.post('api/v2.0/invite/validate', param).then(function (res) {
        var err = res.data.error;
        if (err === 0) {
          this.userName = res.data.email;
          this.country = res.data.country;
          this.countryShow = this.country ? this.$t(this.country) : "";
        } else {
          var tip = 'Incorrect verification';
          alert(tip);
          this.$router.push('/');
        }
      });
    } else {
      this.$router.push('/');
    }
  }
});

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_base64__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_format__ = __webpack_require__(8);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      uid: 0, st: 0, et: 0, days: '', dayNum: 0, isEn: false,
      statics: {}, hb1c: '--', devices: ['--', '--', '--'],
      pagePos: [], perPage: [], chartEndPage: { show: false },
      whichDate: [], alerts: [], haveData: true,
      styleText: '<style type="text/css" media="print">@page{size:portrait;margin:0;}</style>'

    };
  },

  methods: {
    getReportData: function getReportData() {
      if (sessionStorage.getItem('userType') !== 'P') {
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      } else {
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      this.ts = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getTs(this.st, this.et);

      var param = {
        ts: this.ts,
        tz: parseInt(sessionStorage.getItem('tz')),
        gu: this.isMg ? 'mg/dL' : 'mmol/L'
      };
      param = __WEBPACK_IMPORTED_MODULE_3__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));
      var context = this;

      this.$http.get('api/v2.1/report/' + this.uid + '/data/alert', { params: { param: param } }).then(function (res) {
        var err = res.body.error;
        if (err === 0) {
          var data = res.data.data;
          console.log("alert report data:", data);
          context.statics = data;
          context.devices = data.devices ? data.devices : context.devices;

          if ('EasyPatch' == context.devices[0]) {
            document.getElementById('reportPdmTitle').innerHTML = 'APP';
          }
        }
      }, function (err) {
        var tip = this.$t('tryAgain');
        this.$message.error(tip);
      });
    },
    printPdf: function printPdf() {
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].print_page();
    }
  },
  mounted: function mounted() {
    self.document.title = this.$t('EventReport');
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;

    var st9 = sessionStorage.getItem('st9');
    var et9 = sessionStorage.getItem('et9');
    var t1 = parseInt(st9);
    var t2 = parseInt(et9);

    this.st = t1;
    this.et = t2;

    this.getReportData();

    this.days = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate2(t1) + ' - ' + __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate2(t2);

    try {
      var alertData = sessionStorage.getItem('alert-data');
      alertData = JSON.parse(alertData);
      console.log('alertData:', alertData);
      this.alerts = alertData.alerts;
      if (0 == this.alerts.length) {
        this.haveData = false;
      } else {
        this.haveData = true;
      }

      if (false) {
        var item = [format.formatterDate2(new Date().getTime() / 1000), "AAA", 8601, "CGM"];

        console.log('alert test:', item);
        for (var i = 0; i < 100; i++) {
          var temp = item.slice(0, item.length);
          temp[1] = temp[1] + '#' + (i + 1);
          this.alerts.push(temp);
        }
        this.haveData = true;
      }
    } catch (e) {
      console.log('alert error:', e);
    }

    var page_index = 0;
    var PER_PAGE1 = 22;
    var PER_PAGE2 = 26;
    while (page_index < this.alerts.length) {
      this.pagePos.push(page_index);
      if (1 == this.pagePos.length) {
        page_index += PER_PAGE1;
        this.perPage.push(PER_PAGE1);
      } else {
        page_index += PER_PAGE2;
        this.perPage.push(PER_PAGE2);
      }
    }
  }
});

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_base64__ = __webpack_require__(9);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      uid: 0, et: 0, st: 0, time: '', isEn: false, foodCoor: '', unit: '', isMg: '', glucoseUnit: '', ts: [], hypo: 3.1, high: 10.0, low: 5.6, isDe: false, isIt: false,
      statics: {}, devices: ['--', '--', '--'], hb1c: ['--'], target: '', avg: '--', active: '--', seg: ['--', '--', '--', '--'], sd: '--', cv: '--',


      bgAvg: '--',
      bgSD: '--',
      bgNum: '--',

      sgAvg: '--',
      sgSD: '--',
      sgNum: '--',

      insAvg: '--', insSD: '--', insNum: '--',
      carbAvg: '--', carbSD: '--', carbNum: '--',
      exerAvg: '--', exerSD: '--', exerNum: '--',

      est_a1c: '--',
      a1c_available: false,

      calibPerDay: '--',
      bgPerDay: '--',

      highLevelText: '--',
      lowLevelText: '--',

      aucu: '--',
      aucl: '--',

      sgHighest: '--',
      sgLowest: '--',

      sgDistPie: {},
      sgDistPieLabels: ['--', '--', '--', '--'],

      insPieData: [],

      basalPercent: '--',
      bolusPercent: '--',
      avgBolusNum: '--',
      avgSuspendTime: '--',

      avgManualBolus: '--',
      avgManualNormalBolus: '--',
      avgManualExtendBolus: '--',
      avgManualComboBolus: '--',

      avgWizzardBolus: '--',
      avgFoodWizzardBolus: '--',
      avgCorrWizzardBolus: '--',
      avgWizzardOverrideAdd: '--',
      avgWizzardOverrideSub: '--',

      chart5NoData: false,
      chart6NoData: false
    };
  },

  methods: {
    getStatics: function getStatics(param) {
      this.$http.get('api/v2.1/report/' + this.uid + '/data/sa', { params: { param: param } }).then(function (res) {
        var err = res.body.error;

        if (err === 0) {
          var data = res.data.data;
          data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
          this.statics = data;
          this.devices = data.devices ? data.devices : this.devices;
          if ('EasyPatch' == this.devices[0]) {
            document.getElementById('reportPdmTitle').innerHTML = 'APP';
          }
          this.hb1c = data.hba1cList ? data.hba1cList : this.hb1c;
          setTimeout(__WEBPACK_IMPORTED_MODULE_3__auth_auth__["a" /* default */]._printPdf(), 2000);
        }
      }, function (err) {
        var tip = this.$t('tryAgain');
        this.$message.error(tip);
      });
    },
    analySg: function analySg() {
      var sg = JSON.parse(sessionStorage.getItem('sg7')),
          validSg = [],
          totalCount = 0,
          that = this;

      sg.map(function (e, i) {
        var length = e.length;
        if (length > 0) {
          totalCount += length;
          e.map(function (e1, i1) {
            if (e1[4] === 'C' || e1[4] === 'NC') {
              e1[3] = e1[3] > 22.2 ? 22.2 : e1[3];
              e1[3] = e1[3] < 2.2 ? 2.2 : e1[3];
              validSg.push(e1[3]);
            }
          });
        }
      });
      var length1 = validSg.length;
      if (totalCount > 0 && length1 > 0) {
        var totalSg = 0,
            Seg = [0, 0, 0, 0];
        var high = this.isMg ? parseFloat((this.high / 18).toFixed(1)) : this.high;
        var low = this.isMg ? parseFloat((this.low / 18).toFixed(1)) : this.low;
        this.active = (length1 / totalCount * 100).toFixed(1) + ' %';
        validSg.map(function (e, i) {
          totalSg += e;
          if (e < 3.1) {
            Seg[0]++;
          } else if (e < low) {
            Seg[1]++;
          } else if (e < high) {
            Seg[2]++;
          } else {
            Seg[3]++;
          }
        });
        var avg = totalSg / length1;
        this.avg = this.isMg ? Math.round(avg * 18) : avg.toFixed(1);
        this.est_a1c = ((avg * 18 + 46.7) / 28.7).toFixed(1) + '%';
        console.log('a1c_available:', sg.length, totalCount);
        if (totalCount > sg.length * 720 * 0.8) {
          this.a1c_available = true;
        }

        Seg.map(function (e, i) {
          var scale = (e / length1 * 100).toFixed(1);
          that.seg[i] = scale + ' %';
        });

        var tran = 0;
        validSg.map(function (e, i) {
          var d = e - avg;
          tran += Math.pow(d, 2);
        });
        var sd = Math.sqrt(tran / length1);
        this.sd = this.isMg ? Math.round(sd * 18) : sd.toFixed(1);
        this.cv = (sd / avg * 100).toFixed(1) + ' %';
      }
    },
    showCount: function showCount() {
      var count = JSON.parse(sessionStorage.getItem('count7'));
      var length = count.length;
      var tr = document.getElementById('count');
      for (var i = 0; i < length; i++) {
        var td = tr.getElementsByTagName('td')[count[i][0]];
        td.innerHTML = count[i][1];
      }
    },
    printPdf: function printPdf() {
      __WEBPACK_IMPORTED_MODULE_3__auth_auth__["a" /* default */].print_page();
    }
  },
  mounted: function mounted() {
    self.document.title = this.$t('dboard_report');
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    this.glucoseUnit = this.isMg ? 'mg/dL' : 'mmol/L';
    this.unit = this.isMg ? ' mg/dL' : ' mmol/L';
    this.hypo = this.isMg ? 54 : 3.1;
    var st = sessionStorage.getItem('st7');
    var et = sessionStorage.getItem('et7');
    this.st = parseInt(st);
    this.et = parseInt(et);
    this.ts = [[this.st, this.et]];
    var param = {
      ts: this.ts,
      tz: parseInt(sessionStorage.getItem('tz')),
      gu: this.isMg ? 'mg/dL' : 'mmol/L'
    };
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }

    param = __WEBPACK_IMPORTED_MODULE_4__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(param));
    this.getStatics(param);
    this.time = sessionStorage.getItem('timeRange7');
    var img1 = document.getElementById('img1_1');
    img1.src = sessionStorage.getItem('src7_1');
    var img2 = document.getElementById('img1_2');
    img2.src = sessionStorage.getItem('src7_2');
    var img3 = document.getElementById('img1_3');
    img3.src = sessionStorage.getItem('src7_3');
    var img4 = document.getElementById('img1_4');
    img4.src = sessionStorage.getItem('src7_4');

    var dashboardStatInfo = sessionStorage.getItem('dashboardStatInfo');
    console.log('dashboardStatInfo:', dashboardStatInfo, typeof dashboardStatInfo === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(dashboardStatInfo));
    dashboardStatInfo = JSON.parse(dashboardStatInfo);
    for (var p in dashboardStatInfo) {
      this[p] = dashboardStatInfo[p];
    }

    this.high = parseFloat(sessionStorage.getItem('targetH7'));
    this.low = parseFloat(sessionStorage.getItem('targetL7'));
    this.target = '( ' + this.low + ' - ' + this.high + this.unit + ' )';
  }
});

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_base64__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_format__ = __webpack_require__(8);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      uid: 0, et: 0, st: 0, time: '', isEn: false, foodCoor: '', unit: '', isMg: '', ts: [], isDe: false, isIt: false, isFr: false, isSw: false, isCz: false,
      statics: {}, devices: ['--', '--', '--'], hb1c: ['--'], glucose: [], insulin: [], events: [], isPo: false, isEs: false, isDu: false,

      timeInAutoMode: '--',
      autoModeSGAvgSD: '--',
      autoModeSGInTargetRange: '--',
      autoModeSGAboveRange: '--',
      autoModeSGBelowRange: '--',
      autoModeExits: 0

    };
  },

  methods: {
    getStatics: function getStatics(param) {
      this.$http.get('api/v2.1/report/' + this.uid + '/data/ds', { params: { param: param } }).then(function (res) {
        var err = res.body.error;
        if (err === 0) {
          var data = res.data.data;
          data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
          this.statics = data;
          this.devices = data.devices ? data.devices[0] : this.devices;
          if ('EasyPatch' == this.devices[0]) {
            document.getElementById('reportPdmTitle').innerHTML = 'APP';
          }
          this.hb1c = data.hba1cList ? data.hba1cList : this.hb1c;
          this.glucose = data.glucose_stat ? data.glucose_stat[0] : this.glucose;

          this.insulin = data.insulin_stat ? data.insulin_stat[0] : this.insulin;
          this.foodCoor = this.insulin.carb_corr_bolus ? this.insulin.carb_corr_bolus.toFixed(2) : 0;
          this.events = data.event_stat ? data.event_stat[0] : this.events;
        }
      }, function (err) {
        var tip = this.$t('tryAgain');
        this.$message.error(tip);
      });
    },
    getStatics2: function getStatics2(report_data) {
      var data = report_data;

      data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
      this.statics = data;
      this.devices = data.devices ? data.devices[0] : this.devices;
      this.hb1c = data.hba1cList ? data.hba1cList : this.hb1c;
      this.glucose = data.glucose_stat ? data.glucose_stat[0] : this.glucose;

      this.insulin = data.insulin_stat ? data.insulin_stat[0] : this.insulin;
      this.foodCoor = this.insulin.carb_corr_bolus ? this.insulin.carb_corr_bolus.toFixed(2) : 0;
      this.events = data.event_stat ? data.event_stat[0] : this.events;

      this.timeInAutoMode = report_data.timeInAutoMode;
      this.autoModeSGAvgSD = report_data.autoModeSGAvgSD;
      this.autoModeSGInTargetRange = report_data.autoModeSGInTargetRange;
      this.autoModeSGAboveRange = report_data.autoModeSGAboveRange;
      this.autoModeSGBelowRange = report_data.autoModeSGBelowRange;
      this.autoModeExits = report_data.autoModeExits;
    },
    printPdf: function printPdf() {
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].print_page();
    }
  },
  mounted: function mounted() {
    self.document.title = this.$t('dailyReport');
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isEs = lang === 'es' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isSw = lang === 'sw' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    this.unit = this.isMg ? ' (mg/dL)' : ' (mmol/L)';
    this.glucose_unit = this.unit;
    var st = sessionStorage.getItem('st');
    this.st = parseInt(st);
    this.et = this.st + 86400;
    this.time = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate2(this.st);
    this.ts = [[this.st, this.et]];
    var param = {
      ts: this.ts,
      tz: parseInt(sessionStorage.getItem('tz')),
      gu: this.isMg ? 'mg/dL' : 'mmol/L'
    };
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }
    param = __WEBPACK_IMPORTED_MODULE_3__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));

    var report_data = sessionStorage.getItem('ds_report_data');
    report_data = JSON.parse(report_data);

    this.getStatics2(report_data);

    var img1 = document.getElementById('img1_1');
    img1.src = sessionStorage.getItem('src1_1');
    var img2 = document.getElementById('img1_2');
    img2.src = sessionStorage.getItem('src1_2');
    var img3 = document.getElementById('img1_3');
    img3.src = sessionStorage.getItem('src1_3');
    setTimeout(__WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */]._printPdf(), 2000);
  }
});

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_format__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_base64__ = __webpack_require__(9);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      pump_device: '--',
      uid: 0, st: 0, et: 0, isEn: false, ts: [],
      timeSection: [], staTime: '', endTime: '',
      src2_1: [], src2_2: [], date: [], carb: [], isFr: false,
      autoBreakfast: [],
      autoLunch: [],
      autoDinner: [],
      autoSnack: [],
      isDu: false, isCz: false,
      pagePos: [], perPage: [],
      chartEndPage: { show: false },
      statics: {}, devices: ['--', '--', '--'], hb1c: ['--'], long: false, isMg: "", isDe: false, isIt: false, isPo: false
    };
  },

  computed: {
    DataD: function DataD() {
      return this.$store.state.DataD;
    },
    DataSG: function DataSG() {
      return this.$store.state.DataSG;
    },
    DataBasal: function DataBasal() {
      return this.$store.state.DataBasal;
    },
    DataBolus: function DataBolus() {
      return this.$store.state.DataBolus;
    }
  },
  methods: {
    makeCarb: function makeCarb() {
      var carbs = this.carb;
      var time = this.timeSection;
      for (var i = 0; i < carbs.length; i++) {
        if (carbs[i].length > 0) {
          for (var j = 0; j < carbs[i].length; j++) {
            var t1 = 0;
            var w = 0;
            t1 = carbs[i][j][0] - time[i][0];
            w = (t1 / 864).toFixed(1) + '%';
            var id = 'carb' + i;
            var OBJ = document.getElementById(id);
            var label = OBJ.getElementsByTagName('label');
            label[j].style.zIndex = 100 + i + j;
            label[j].style.left = w;
          }
        }
      }

      var className = ['breakfast', 'lunch', 'dinner', 'snack'];
      var autoMeal = [this.autoBreakfast, this.autoLunch, this.autoDinner, this.autoSnack];

      for (var _i = 0; _i < className.length; _i++) {

        for (var d = 0; d < autoMeal[_i].length; d++) {
          for (var _j = 0; _j < autoMeal[_i][d].length; _j++) {
            var _t = 0;
            var _w = 0;
            _t = autoMeal[_i][d][_j][0] - time[d][0];
            _w = (_t / 864).toFixed(1) + '%';
            var _id = 'carb' + d;
            var _OBJ = document.getElementById(_id);
            var _label = _OBJ.getElementsByClassName(className[_i]);
            console.log('autoMeal:', _OBJ, _label, className[_i]);
            _label[_j].style.zIndex = 100 + d + _j;
            _label[_j].style.left = _w;
          }
        }
      }
    },
    getDate: function getDate() {
      for (var i = 0; i < this.date.length; i++) {
        var day = this.st + i * 86400;
        var time = this.isEn ? __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate4(day) : __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate3(day);
        var weeks = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDay(this, day);
        this.date[i] = time + ' ' + weeks;
      }
      var t1 = this.date[0].split(' ')[0].split('-');
      this.staTime = t1[0] + '/' + t1[1] + '/' + t1[2];
      var t2 = this.date[this.date.length - 1].split(' ')[0].split('-');
      this.endTime = t2[0] + '/' + t2[1] + '/' + t2[2];
    },
    getStatics: function getStatics(param) {
      this.$http.get('api/v2.1/report/' + this.uid + '/data/dd', { params: { param: param } }).then(function (res) {
        var err = res.body.error;
        if (err === 0) {
          var data = res.data.data;
          data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
          this.statics = data;
          this.devices = data.devices ? data.devices : this.devices;
          if ('EasyPatch' == this.devices[0]) {
            document.getElementById('reportPdmTitle').innerHTML = 'APP';
          }
          this.hb1c = data.hba1c ? data.hba1c : this.hb1c;
        }
      }, function (err) {
        var tip = this.$t('tryAgain');
        this.$message.error(tip);
      });
    },
    getStatics2: function getStatics2(report_data) {
      var data = report_data;
      data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
      this.statics = data;
      this.devices = data.devices ? data.devices : this.devices;
      this.hb1c = data.hba1c ? data.hba1c : this.hb1c;
    },
    printPdf: function printPdf() {
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].print_page();
    }
  },
  mounted: function mounted() {
    self.document.title = this.$t('dayBydayRe');
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    this.st = parseInt(sessionStorage.getItem('st2'));
    this.et = parseInt(sessionStorage.getItem('et2'));
    this.ts = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getTs(this.st, this.et);
    var param = {
      ts: this.ts,
      tz: parseInt(sessionStorage.getItem('tz')),
      gu: this.isMg ? 'mg/dL' : 'mmol/L'
    };
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }
    param = __WEBPACK_IMPORTED_MODULE_4__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));
    this.src2_1 = JSON.parse(sessionStorage.getItem('src2_1'));
    this.src2_2 = JSON.parse(sessionStorage.getItem('src2_2'));
    this.pump_device = sessionStorage.getItem('dd_pump_device');

    var page_index = 0;
    var PER_PAGE1 = 9;
    var PER_PAGE2 = 9;

    while (page_index < this.src2_1.length) {
      this.pagePos.push(page_index);
      if (1 == this.pagePos.length) {
        page_index += PER_PAGE1;
        this.perPage.push(PER_PAGE1);
      } else {
        page_index += PER_PAGE2;
        this.perPage.push(PER_PAGE2);
      }
    }
    var chartNum = this.src2_1.length;
    if (chartNum > 6 && chartNum <= 9) {
      this.chartEndPage.show = true;
    }
    console.log('pagePos:', this.pagePos, chartNum, this.chartEndPage.show);

    this.date = JSON.parse(sessionStorage.getItem('date2_2'));
    if (this.date.length > 9) {
      this.long = true;
    }
    this.carb = JSON.parse(sessionStorage.getItem('carb2_2'));
    this.autoBreakfast = JSON.parse(sessionStorage.getItem('autoBreakfast2_2'));
    this.autoLunch = JSON.parse(sessionStorage.getItem('autoLunch2_2'));
    this.autoDinner = JSON.parse(sessionStorage.getItem('autoDinner2_2'));
    this.autoSnack = JSON.parse(sessionStorage.getItem('autoSnack2_2'));
    this.timeSection = JSON.parse(sessionStorage.getItem('timeS2_2'));
    var report_data = JSON.parse(sessionStorage.getItem('dd_report_data'));
    this.getStatics2(report_data);

    this.getDate();
    var timer = setTimeout(this.makeCarb, 1000);
    setTimeout(__WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */]._printPdf(), 2000);
  }
});

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_format__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_base64__ = __webpack_require__(9);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      timeRange3: '', weekmode: 'yyyyyyy', isEn: false, isMg: '', ts: [], isDe: false,
      legendDate: [], show: {}, uid: 0, st: 0, et: 0, isIt: false,
      statics: {}, devices: ['--', '--', '--'], hb1c: ['--'],
      glucose: [[], [], [], [], [], [], [], []], glucoseLength: 7, date: [], isFr: false
    };
  },

  methods: {
    checkLegend: function checkLegend() {
      this.legendDate = [];
      this.show = { A: false, B: false, C: false, D: false, E: false, F: false, G: false };
      this.legendDate = JSON.parse(sessionStorage.getItem('legendDate3'));
      if (this.legendDate[0]) {
        this.show.A = true;
      }
      if (this.legendDate[1]) {
        this.show.B = true;
      }
      if (this.legendDate[2]) {
        this.show.C = true;
      }
      if (this.legendDate[3]) {
        this.show.D = true;
      }
      if (this.legendDate[4]) {
        this.show.E = true;
      }
      if (this.legendDate[5]) {
        this.show.F = true;
      }
      if (this.legendDate[6]) {
        this.show.G = true;
      }

      var length = this.ts.length;
      this.glucoseLength = length;
      for (var i = 0; i < length; i++) {
        var t = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate9(this.ts[i][0]);
        t[1] = t[1] + 1;
        t[1] = t[1] < 10 ? '0' + t[1] : t[1];
        t[2] = t[2] < 10 ? '0' + t[2] : t[2];
        this.date[i] = t[2] + '-' + t[1] + '-' + t[0];
      }
    },
    getStatics: function getStatics(param) {
      this.$http.get('api/v2.1/report/' + this.uid + '/data/ol', { params: { param: param } }).then(function (res) {
        var err = res.body.error;
        if (err === 0) {
          var data = res.data.data;
          data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
          this.statics = data;
          this.devices = data.devices ? data.devices : this.devices;
          if ('EasyPatch' == this.devices[0]) {
            document.getElementById('reportPdmTitle').innerHTML = 'APP';
          }
          this.hb1c = data.hba1c ? data.hba1c : this.hb1c;
          this.glucose = data.sg_stat ? data.sg_stat : this.glucose;
        }
      }, function (err) {
        var tip = this.$t('tryAgain');
        this.$message.error(tip);
      });
    },
    getStatics2: function getStatics2(report_data) {
      var data = report_data;
      data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
      this.statics = data;
      this.devices = data.devices ? data.devices : this.devices;
      this.hb1c = data.hba1c ? data.hba1c : this.hb1c;
      this.glucose = data.sg_stat ? data.sg_stat : this.glucose;
    },
    printPdf: function printPdf() {
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].print_page();
    }
  },
  mounted: function mounted() {
    self.document.title = this.$t('sensorOlRe');
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    this.et = parseInt(sessionStorage.getItem('et3'));
    this.st = parseInt(sessionStorage.getItem('st3'));
    this.weekmode = sessionStorage.getItem('week3');
    this.timeRange3 = sessionStorage.getItem('timeRange3');
    this.ts = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getTs2(this, this.st, this.et);
    var param = {
      ts: this.ts,
      tz: parseInt(sessionStorage.getItem('tz')),
      weekmode: this.weekmode,
      gu: this.isMg ? 'mg/dL' : 'mmol/L'
    };
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }
    param = __WEBPACK_IMPORTED_MODULE_4__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));
    var img1 = document.getElementById('img3_1');
    img1.src = sessionStorage.getItem('src3_1');
    this.checkLegend();

    var report_data = sessionStorage.getItem('ol_report_data');
    report_data = JSON.parse(report_data);
    this.getStatics2(report_data);

    setTimeout(__WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */]._printPdf(), 2000);
  }
});

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_base64__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_dataTool__ = __webpack_require__(231);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      xDate2: [], timeRange: '', weekmode: 'yyyyyyy', uid: 0, st: 0, et: 0, isEn: false, isMg: '', ts: [],
      statics: {}, devices: ['--', '--', '--'], hb1c: ['--'], dayNum: 0, interval: '', isDe: false, isIt: false,
      styleText: '<style type="text/css" media="print">@page{size:landscape;margin:0;}</style>',
      glucose: [{
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_hypo_num": '--',
        "bg_lp": '--',
        "bg_tp": '--',
        "bg_up": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }],
      event: [{
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }]
    };
  },

  methods: {
    getTaReportInfo: function getTaReportInfo(report_data) {
      var data = report_data;

      data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
      this.statics = data;
      this.devices = data.devices ? data.devices : this.devices;
      if ('EasyPatch' == this.devices[0]) {
        document.getElementById('reportPdmTitle').innerHTML = 'APP';
      }
      this.hb1c = data.hba1c ? data.hba1c : this.hb1c;
      this.glucose = data.glucose_stat ? data.glucose_stat : this.glucose;
      this.glucose.map(function (e, i) {
        if (e.bg_up !== '--') {
          e.bg_up = e.bg_up.toFixed(1);
        }
        if (e.bg_tp !== '--') {
          e.bg_tp = e.bg_tp.toFixed(1);
        }
        if (e.bg_lp !== '--') {
          e.bg_lp = e.bg_lp.toFixed(1);
        }
      });
      this.dayNum = this.glucose.length - 1;
      this.event = data.insulin_and_event_stat ? data.insulin_and_event_stat : this.event;
      var t = this.interval !== 'd' ? 3000 : 2000;
      setTimeout(__WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */]._printPdf(), t);
    },
    printPdf: function printPdf() {
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].print_page();
    }
  },
  mounted: function mounted() {
    self.document.title = this.$t('TrendRe');
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }
    this.et = parseInt(sessionStorage.getItem('et4'));
    this.st = parseInt(sessionStorage.getItem('st4'));
    var days = parseInt((this.et - this.st) / 86400) + 1;
    if (days <= 7) {
      this.interval = 'd';
    } else if (days <= 56) {
      this.interval = 'w';
    } else {
      this.interval = 'm';
    }

    var timeIntervalSelect = sessionStorage.getItem('timeIntervalSelect4');
    timeIntervalSelect = parseInt(timeIntervalSelect);
    console.log("timeIntervalSelect:", timeIntervalSelect);
    if (NaN == timeIntervalSelect || !(timeIntervalSelect >= 1 && timeIntervalSelect <= 3)) {
      return;
    }

    if (1 == timeIntervalSelect) {
      this.interval = 'd';
    } else if (2 == timeIntervalSelect) {
      this.interval = 'w';
    } else if (3 == timeIntervalSelect) {
      this.interval = 'm';
    }

    this.weekmode = sessionStorage.getItem('week4');
    this.timeRange = sessionStorage.getItem('timeRange4');
    this.xDate2 = JSON.parse(sessionStorage.getItem('xDate4'));
    this.ts = JSON.parse(sessionStorage.getItem('xTs4'));

    var param = {
      ts: this.ts,
      interval: this.interval,
      tz: parseInt(sessionStorage.getItem('tz')),
      weekmode: this.weekmode,
      gu: this.isMg ? 'mg/dL' : 'mmol/L'
    };
    param = __WEBPACK_IMPORTED_MODULE_3__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));

    var report_data = JSON.parse(sessionStorage.getItem('ta_report_data'));
    this.getTaReportInfo(report_data);
    var img1 = document.getElementById('img4_1');
    img1.src = sessionStorage.getItem('src4_1');
    var img2 = document.getElementById('img4_2');
    img2.src = sessionStorage.getItem('src4_2');
  }
});

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_base64__ = __webpack_require__(9);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _ref;

    return _ref = {
      pump_device: '--',
      timer: false, typeChooseVisible: false, value1: '', value2: '', isC: false, flag: 0, count: 0, sta: '', end: '', isMg: "", long: false, ts: [] }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'long', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'isDe', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'uid', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'st', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'et', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'autoStop', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'manualStop', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'stop', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'Newer', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'noMeal', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'mt', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'isIt', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'isPo', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'isFr', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'isSw', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'uid', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'st', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'et', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'autoStop', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'manualStop', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'stop', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'Newer', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'noMeal', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'mt', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'isEn', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'mt1', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'isDe', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'isIt', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'isPo', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'isDu', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'isCz', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'bgAvg', [{ avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'carb', [{ total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'ins', [{ total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'weekmode', 'yyyyyyy'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'timeRange', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'isA', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'whichDate', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'pagePos', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'perPage', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'chartEndPage', { show: false }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'styleText', '<style type="text/css" media="print">@page {size:landscape;margin:0;}</style>'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'hours', ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00']), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'statics', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'devices', ['--', '--', '--']), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'hb1c', ['--']), _ref;
  },

  computed: {
    DataS: function DataS() {
      return this.$store.state.DataS;
    },
    DataSG: function DataSG() {
      return JSON.parse(sessionStorage.getItem('olDataSG'));
    }
  },
  methods: {
    initTable: function initTable() {
      var wrap = document.getElementById('table-wrapper');
      var wraps = document.getElementsByClassName('table-wrapper');
      console.log("wraps:", wraps);

      for (var w = 0; w < wraps.length; w++) {
        var _wrap = wraps[w];
        var tables = _wrap.getElementsByTagName('table')[1];
        for (var i = 0; i < tables.length; i++) {
          var tr = tables[i].getElementsByTagName('tr');
          for (var j = 0; j < tr.length; j++) {
            var td = tr[j].getElementsByTagName('td');
            for (var k = 3; k < td.length - 1; k++) {
              td[k].innerHTML = '';
              td[k].style.backgroundColor = '#fff';
            }
          }
        }
      }
    },
    makeNoMeal: function makeNoMeal() {
      var noMeal = this.noMeal,
          mt = this.mt;
      for (var i = 0; i < noMeal.length; i++) {
        for (var j = 0; j < 3; j++) {
          if (noMeal[i][j] === 0) {
            var id = i;
            var table1 = document.getElementById(id);
            var tr = table1.getElementsByTagName('tr')[1];
            var td = tr.getElementsByTagName('td')[2 + mt[j][0]];
            var img = document.createElement('img');
            img.src = '/static/Lgb Icon/Missed Meal.png';
            img.className = 'insertImg';
            td.appendChild(img);
          }
        }
      }
      var mt1 = this.mt1;
      for (var _i = 0; _i < 3; _i++) {
        var obj = document.getElementById('m' + _i);
        obj.style.left = parseFloat(mt1[_i][0]) / 24 * 100 + '%';
        obj.style.width = (parseFloat(mt1[_i][1]) - parseFloat(mt1[_i][0])) * 36 + 'px';
      }
    },
    getLgbReportInfo: function getLgbReportInfo(report_data) {
      var data = report_data;

      data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
      this.statics = data;
      this.devices = data.devices ? data.devices : this.devices;
      if ('EasyPatch' == this.devices[0]) {
        document.getElementById('reportPdmTitle').innerHTML = 'APP';
      }
      this.hb1c = data.hba1c ? data.hba1c : this.hb1c;
    },
    getTs: function getTs(st, et) {
      var ts = [],
          days = (et - st) / 86400 + 1,
          time = 0,
          sp1 = 0,
          k = 0;
      var No = __WEBPACK_IMPORTED_MODULE_3__auth_auth__["a" /* default */].chekcNoDate(this.weekmode);
      this.whichDate = [];
      for (var i = 0; i < days; i++) {
        var day = new Date((st + i * 86400) * 1000).getDay();
        if (No.indexOf(day) === -1) {
          ts[k] = [];
          ts[k][0] = st + i * 86400;
          ts[k][1] = st + (i + 1) * 86400;
          time = new Date(ts[k][0] * 1000).toString();
          sp1 = time.split(' ');
          if (this.isEn) {
            this.whichDate[k] = sp1[2] + ' ' + this.$t(sp1[1]) + ', ' + sp1[3] + ' ' + this.$t(sp1[0]);
          } else {
            var m = new Date(ts[k][0] * 1000).getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            this.whichDate[k] = sp1[3] + '-' + m + '-' + sp1[2] + ' ' + this.$t(sp1[0]);
          }
          k++;
        }
      }

      var page_index = 0;
      var PER_PAGE1 = 6;
      var PER_PAGE2 = 8;

      while (page_index < this.whichDate.length) {
        this.pagePos.push(page_index);
        if (1 == this.pagePos.length) {
          page_index += PER_PAGE1;
          this.perPage.push(PER_PAGE1);
        } else {
          page_index += PER_PAGE2;
          this.perPage.push(PER_PAGE2);
        }
      }
      var chartNum = this.whichDate.length;
      if (chartNum == 14) {
        this.chartEndPage.show = true;
      }
      console.log('pagePos:', this.pagePos);

      return ts;
    },
    makebg1: function makebg1(val, high, low) {
      for (var i = 0; i < val.length; i++) {
        if (val[i].length > 0) {
          var id = i;
          var table1 = document.getElementById(id);
          var tr = table1.getElementsByTagName('tr')[0];
          for (var j = 0; j < val[i].length; j++) {
            if (val[i][j].length > 0) {
              var td = tr.getElementsByTagName('td')[3 + j];
              if (val[i][j].length === 2) {
                var div1 = document.createElement('div');
                var div2 = document.createElement('div');
                div2.style.float = 'left';
                div2.style.marginLeft = '3px';
                div2.innerHTML = val[i][j][0];
                var div3 = document.createElement('div');
                div3.style.float = 'left';
                div3.style.width = '6px';
                div3.style.height = '6px';
                div3.style.borderRadius = '3px';
                div3.style.backgroundColor = '#0f0f0f';
                div1.appendChild(div2);
                div1.appendChild(div3);
                td.appendChild(div1);
              } else {
                td.innerHTML = val[i][j][0];
              }
              if (val[i][j][0] > high) {
                td.style.backgroundColor = '#ffd125';
              } else if (val[i][j][0] < low) {
                td.style.backgroundColor = '#ff3d3d';
              } else {
                td.style.backgroundColor = '#c6deb5';
              }
            }
          }
        }
      }
    },
    makecarb: function makecarb(val) {
      for (var i = 0; i < val.length; i++) {
        if (val[i].length > 0) {
          var table1 = document.getElementById(i);
          var tr = table1.getElementsByTagName('tr')[1];
          for (var j = 0; j < val[i].length; j++) {
            if (val[i][j] !== 0) {
              var td = tr.getElementsByTagName('td')[j + 2];
              td.innerHTML = val[i][j];
            }
          }
        }
      }
    },
    makeOth1: function makeOth1(val, flag) {
      for (var i = 0; i < val.length; i++) {
        var table1 = document.getElementById(i);
        var k = 2;
        if (flag === 4 || flag === 5 || 7 === flag || 8 === flag || 9 === flag || 10 === flag || 11 === flag) {
          k = 3;
        }
        var tr = table1.getElementsByTagName('tr')[k];
        for (var j = 0; j < val[i].length; j++) {
          if (val[i][j] === 1) {
            var td = tr.getElementsByTagName('td')[2 + j];
            var img = document.createElement('img');
            img.style.height = '10px';
            img.style.width = '10px';
            if (flag === 0) {
              img.src = '/static/Lgb Icon/Auto Suspend.png';
            }
            if (flag === 1) {
              img.src = '/static/Lgb Icon/Manual Suspend.png';
            }
            if (flag === 2) {
              img.src = '/static/Lgb Icon/Stop Patch .png';
            }
            if (flag === 3) {
              img.src = '/static/Lgb Icon/New Patch .png';
            }
            if (flag === 4) {
              img.src = '/static/Lgb Icon/Exercise.png';
            }
            if (flag === 5) {
              img.src = '/static/Lgb Icon/Others.png';
            }
            if (flag === 6) {
              img.src = '/static/Lgb Icon/temp basal.png';
            }
            if (7 === flag) {
              img.src = '/static/legend/automode/早餐.png';
              img.style.height = '15px';
              img.style.width = '22px';
            } else if (flag === 8) {
              img.src = '/static/legend/automode/中餐.png';
              img.style.height = '15px';
              img.style.width = '22px';
            } else if (flag === 9) {
              img.src = '/static/legend/automode/晚餐.png';
              img.style.height = '15px';
              img.style.width = '22px';
            } else if (flag === 10) {
              img.src = '/static/legend/automode/零食.png';
              img.style.height = '15px';
              img.style.width = '22px';
            } else if (flag === 11) {
              img.src = '/static/legend/automode/运动[30059].png';
              img.style.height = '15px';
              img.style.width = '22px';
            } else if (flag === 12) {
              img.src = '/static/legend/automode/进入自动模式.png';
              img.style.height = '15px';
              img.style.width = '15px';
            } else if (flag === 13) {
              img.src = '/static/legend/automode/退出自动模式.png';
              img.style.height = '15px';
              img.style.width = '15px';
            }
            img.style.marginRight = '2px';
            img.style.marginLeft = '2px';
            img.style.float = 'left';
            td.appendChild(img);
          }
        }
      }
    },
    makeBolus: function makeBolus(val, flag) {
      for (var i = 0; i < val.length; i++) {
        var leng = val[i].length;
        var table1 = document.getElementById(i);
        var tr = table1.getElementsByTagName('tr')[2];
        for (var k = 0; k < leng; k++) {
          if (val[i][k] !== 0) {
            var td = tr.getElementsByTagName('td')[k + 2];
            if (flag[i][k]) {
              var div3 = document.createElement('div');
              div3.style.float = 'left';
              div3.style.width = '24px';
              div3.style.height = '16px';
              div3.style.borderRadius = '4px';
              div3.style.paddingTop = '1px';
              div3.style.border = '1px solid #222';
              div3.innerHTML = val[i][k].toFixed(2);
              td.appendChild(div3);
            } else {
              td.innerHTML = val[i][k].toFixed(2);
            }
          }
        }
      }
    },
    makeBolus2: function makeBolus2(val) {
      for (var i = 0; i < val.length; i++) {
        var leng = val[i].length;
        if (leng > 0) {
          var table1 = document.getElementById(i);
          var tr = table1.getElementsByTagName('tr')[2];
          for (var k = 0; k < leng; k++) {
            if (val[i][k].length > 0) {
              var td = tr.getElementsByTagName('td')[val[i][k][0] + 2];

              var div3 = document.createElement('div');
              div3.style.float = 'left';
              div3.style.width = '32px';
              div3.style.height = '18px';
              div3.style.borderRadius = '4px';
              div3.style.paddingTop = '2px';
              div3.style.border = '1px solid #222';
              div3.innerHTML = val[i][k][1].toFixed(2);

              td.appendChild(div3);
            }
          }
        }
      }
    },
    makeNoPump: function makeNoPump(val) {
      for (var i = 0; i < val.length; i++) {
        if (val[i] === 1) {
          var table = document.getElementById(i);
          var tr = table.getElementsByTagName('tr')[2];
          var td = tr.getElementsByTagName('td')[1];
          td.style.backgroundColor = '#ccc';
        }
      }
    },
    printPdf: function printPdf() {
      __WEBPACK_IMPORTED_MODULE_3__auth_auth__["a" /* default */].print_page();
    }
  },
  mounted: function mounted() {
    self.document.title = this.$t('logRe');
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isSw = lang === 'sw' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }
    this.et = parseInt(sessionStorage.getItem('et5'));
    this.st = parseInt(sessionStorage.getItem('st5'));
    this.weekmode = sessionStorage.getItem('week5');
    this.whichDate = JSON.parse(sessionStorage.getItem('whichDate5'));
    this.timeRange = sessionStorage.getItem('timeRange5');
    this.pump_device = sessionStorage.getItem('lgb_pump_device');
    this.ts = this.getTs(this.st, this.et);
    var param = {
      ts: this.ts,
      tz: parseInt(sessionStorage.getItem('tz')),
      weekmode: this.weekmode,
      gu: this.isMg ? 'mg/dL' : 'mmol/L'
    };
    var dayNum = (this.et - this.st) / 86400 + 1;
    this.long = dayNum > 7 ? true : false;
    param = __WEBPACK_IMPORTED_MODULE_4__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));
    __WEBPACK_IMPORTED_MODULE_3__auth_auth__["a" /* default */].getLgb1(this, this.uid, param);

    setTimeout(__WEBPACK_IMPORTED_MODULE_3__auth_auth__["a" /* default */]._printPdf(), 5000);
  }
});

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_base64__ = __webpack_require__(9);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      showEasyPatch: false,
      easypatch_reminder: [],
      time: '', rid: 0, uid: 0, st: 0, et: 0, data: {}, unit: '', isMg: "", unit1: '', colock: '', isFr: false,
      statics: {}, devices: ['--', '--', '--'], hb1c: ['--'], pdmSN: '', tranSN: '', pumpSN: '', maxBolOption: '',
      basal: {
        "basal_onoff": "--",
        "basal_select": "--",
        "max_rate": '--',
        "exer_basal": {
          "day_total": '--',
          "seg": []
        }
      },
      page4: true,
      moreBasal: true,
      basalPagePos: -9,
      basalPagePos2: -9,

      bolusStartPage: { show: false },
      pdmStartPage: { show: false },
      cgmStartPage: { show: false },

      pumpStartPage: { show: false },
      appStartPage: { show: false },

      cgmSep5: false,
      basalPageSep6: false,

      basalSeg: [], bsg1: [], bsg2: [], bsg3: [], bsg4: [], total: 0,
      standardTotal: 0, exerTotal: 0, holidayTotal: 0, programATotal: 0, programBTotal: 0,

      standardSeg: [], standardSeg1: [], standardSeg2: [], standardSeg3: [], standardSeg4: [],
      exerSeg: [], exerSeg1: [], exerSeg2: [], exerSeg3: [], exerSeg4: [],
      holidaySeg: [], holidaySeg1: [], holidaySeg2: [], holidaySeg3: [], holidaySeg4: [],
      programASeg: [], programASeg1: [], programASeg2: [], programASeg3: [], programASeg4: [],
      programBSeg: [], programBSeg1: [], programBSeg2: [], programBSeg3: [], programBSeg4: [],

      sickSeg: [], sickSeg1: [], sickSeg2: [], sickSeg3: [], sickSeg4: [],
      programCSeg: [], programCSeg1: [], programCSeg2: [], programCSeg3: [], programCSeg4: [],
      programDSeg: [], programDSeg1: [], programDSeg2: [], programDSeg3: [], programDSeg4: [],

      basalInfo: [{}, {}, {}, {}, {}, {}, {}, {}],

      pdmTitle: '',

      bolus: {
        "bg_reminder": "--",
        "bg_target": [],
        "bolus_reminder": [],
        "bolus_step": '--',
        "bolus_wizard": "--",
        "extent_option": "--",
        "ins_active_time": '--',
        "ins_carb_ratio": [],
        "ins_sen": [],
        "max_bolus": '--'
      },
      IcRatio: [], ins_sen: [], bg_target: [], bolus_rem: [], cgmLimit: [],
      cgm: {
        "alarm_silent_option": "--",
        "sensor_alarm_option": "--",
        "sensor_alarm_repeat": {
          "high": ["--", "--"],
          "low": ["--", "--"]
        },
        "sensor_alarm_settings": {
          "auto_calib_option": "--",
          "calib_remind_interval": "--",
          "calib_remind_option": "--",
          "calib_remind_time": "--",
          "no_calib_display": "--",
          "sensor_lost_time": '--',
          "trend_time_scope": '--'
        },
        "sensor_alarm_threshold": [],
        "sensor_forecast_alarm": {
          "high": ["--", "--"],
          "low": ["--", "--"]
        },
        "sensor_rate_alarm": {
          "fall": ["--", '--'],
          "rise": ["--", '--']
        }
      },
      userset: {
        "alarm_type": "--",
        "auto_off_option": "--",
        "auto_off_time": "--",
        "backlight_timeout": "--",
        "beep_off_tip_interval": "--",
        "beep_off_tip_option": "--",
        "cgms_module_flag": "--",
        "clock": [],
        "clock_option": "--",
        "cmd_response": "--",
        "day_bolus_max": "--",
        "device_option": "--",
        "glucose_unit": "--",
        "hour_bolus_max": "--",
        "keypad_lock": "--",
        "low_reservoir_ins": "--",
        "low_reservoir_time": "--",
        "low_reservoir_type": "--",
        "password_option": "--",
        "patch_expire_ahead": "--",
        "patch_expire_alarm": "--",
        "pre_suspend_on_lowbg_level": "--",
        "pre_suspend_on_lowbg_option": "--",
        "pump_module_flag": "--",
        "screen_timeout": "--",
        "suspend_on_lowbg_level": "--",
        "suspend_on_lowbg_option": "--",
        "time_style": "--",
        auto_basal: {}
      },
      isEn: false, isDe: false
    };
  },

  methods: {
    getStatics: function getStatics() {
      this.et = new Date(2017, 9, 19).getTime() / 1000;
      this.st = this.et;
      var param = {
        st: this.st,
        et: this.et,
        tz: parseInt(sessionStorage.getItem('tz')),
        gu: this.isMg ? 'mg/dL' : 'mmol/L'
      };
      param = __WEBPACK_IMPORTED_MODULE_3__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));
      this.$http.get('api/v2.1/report/' + this.uid + '/data/dse', { params: { param: param } }).then(function (res) {
        var err = res.body.error;
        if (err === 0) {
          var data = res.data.data;
          data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
          this.statics = data;
          this.devices = data.devices ? data.devices : this.devices;
          this.hb1c = data.hba1c ? data.hba1c : this.hb1c;
        }
      }, function (err) {
        var tip = this.$t('tryAgain');
        this.$message.error(tip);
      });
    },
    getOptionText: function getOptionText(optionVal) {
      var optionText = '--';
      if (1 == optionVal) {
        optionText = this.$t('Off');
      } else if (2 == optionVal) {
        optionText = this.$t('On');
      }
      return optionText;
    },
    printPdf: function printPdf() {
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].print_page();
    }
  },
  mounted: function mounted() {
    self.document.title = this.$t('Device Settings Report');
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isDe = lang === 'de' || lang === 'it' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    var ins_unit2 = this.$t('ins_unit2');
    this.unit = this.isMg ? ' (mg/dL/' + ins_unit2 + ')' : ' (mmol/L/' + ins_unit2 + ')';
    this.unit1 = this.isMg ? 'mg/dL' : 'mmol/L';
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }
    this.time = sessionStorage.getItem('time6').split(',')[0];
    this.pdmTitle = this.$t('pdm');
    var img1 = document.getElementById('img6_1');
    img1.src = sessionStorage.getItem('src6_1');

    var img2 = document.getElementById('img6_2');
    img2.src = sessionStorage.getItem('src6_2');

    var img3 = document.getElementById('img6_3');
    img3.src = sessionStorage.getItem('src6_3');

    var img4 = document.getElementById('img6_4');
    img4.src = sessionStorage.getItem('src6_4');

    var img5 = document.getElementById('img6_5');
    img5.src = sessionStorage.getItem('src6_5');

    this.getStatics();
    this.data = JSON.parse(sessionStorage.getItem('deviceSet'));


    if (false) {
      var padInt = function padInt(v, n) {
        var v_str = v.toString();
        var pre_num = n - v_str.length;
        var pre_str = '';
        for (var i = 0; i < pre_num; i++) {
          pre_str += '0';
        }
        return pre_str + v_str;
      };

      var minute_format = function minute_format(m) {
        var hour = padInt(Math.floor(m / 60), 2);
        var minute = padInt(m % 60, 2);
        return hour + ':' + minute;
      };

      this.data.device_type = 'easypatch';

      var testSegs = [];
      for (var i = 0; i < 48; i++) {
        var minute = i * 30;
        testSegs.push([minute_format(minute), parseFloat((i % 20 * 0.1).toFixed(2))]);
      }

      this.data.basal_settings.stand_basal.seg = testSegs.slice(0, 40);
      this.data.basal_settings.exer_basal.seg = testSegs.slice(0, 40);
      this.data.basal_settings.holiday_basal.seg = testSegs.slice(0, 40);
      this.data.basal_settings.program_a_basal.seg = testSegs.slice(0, 40);
      this.data.basal_settings.program_b_basal.seg = testSegs.slice(0, 10);

      this.data.basal_settings.program_c_basal.seg = testSegs.slice(0, 10);
      this.data.basal_settings.program_d_basal.seg = testSegs.slice(0, 20);
      this.data.basal_settings.sick_basal.seg = testSegs.slice(0, 20);

      var testICRSeg = [];
      for (var _i = 0; _i < 8; _i++) {
        var _minute = _i * 30;
        testICRSeg.push([minute_format(_minute), 15]);
      }
      this.data.bolus_settings.ins_carb_ratio = testICRSeg;

      var testSeg = [];
      for (var _i2 = 0; _i2 < 8; _i2++) {
        var _minute2 = _i2 * 30;
        testSeg.push([minute_format(_minute2), "5.6-5.6"]);
      }
      this.data.bolus_settings.bg_target = testSeg;

      console.log('device setting test:', this.data);
    }

    var device_type = this.data.device_type;

    if (18 == this.data.device_type) {
      this.moreBasal = true;
      this.showEasyPatch = 'PDM';
    } else if ('easypatch' == this.data.device_type) {
      this.moreBasal = true;
      this.showEasyPatch = 'easypatch';
    } else if ('easysense' == device_type) {
      this.moreBasal = false;
      this.showEasyPatch = 'easysense';
    } else {
      this.moreBasal = false;
      this.showEasyPatch = 'PDM';
    }

    if (true) {
      var totalRow = 0;
      var prePageTotalRow = 0;

      var firstPageTotalRow = 0;
      var secondPageTotalRow = 0;

      var basalKey = ["stand_basal", "exer_basal", "holiday_basal", "program_a_basal", "program_b_basal", "program_c_basal", "program_d_basal", "sick_basal"];
      var basalNum = 5;
      var firstPageRow = 16;
      if (this.moreBasal) {
        basalNum = 8;
        firstPageRow = 12;
      }

      for (var _i3 = 0; _i3 < basalNum; _i3++) {
        var basal_pattern = this.data.basal_settings[basalKey[_i3]];
        totalRow += Math.floor((basal_pattern.seg.length + 11) / 12);
        var nextRow = 0;
        if (_i3 < basalNum - 1) {
          var next_basal = this.data.basal_settings[basalKey[_i3 + 1]];
          nextRow = Math.floor((next_basal.seg.length + 11) / 12);
        }
        console.log("totalRow:", totalRow, nextRow, _i3);
        if (totalRow + nextRow > firstPageRow && this.basalPagePos < 0) {
          this.basalPagePos = _i3;

          firstPageTotalRow = totalRow;
        }
        if (totalRow + nextRow > firstPageRow + 16 && this.basalPagePos2 < 0) {
          this.basalPagePos2 = _i3;

          secondPageTotalRow = totalRow;
        }
      }

      var leftBasalRow = 0;
      if (this.basalPagePos2 > 0) {
        leftBasalRow = totalRow - secondPageTotalRow;
      } else if (this.basalPagePos > 0) {
        leftBasalRow = totalRow - firstPageTotalRow;
      } else {
        leftBasalRow = totalRow;
      }
      console.log("basalTotalRow:", totalRow, firstPageTotalRow, secondPageTotalRow, this.basalPagePos, this.basalPagePos2, leftBasalRow);

      if (this.basalPagePos2 > 0) {
        var basalPage2Id = 'basalPage2' + (this.basalPagePos2 + 1);
        var secondPageRow = secondPageTotalRow - firstPageTotalRow;

        var sepNode = document.getElementById(basalPage2Id);
        var baseRow = 0;

        if (secondPageRow + baseRow <= 13) {} else if (secondPageRow + baseRow <= 14) {} else if (secondPageRow + baseRow <= 15) {} else if (secondPageRow + baseRow <= 16) {}
      }

      if (this.basalPagePos > 0) {
        var basalPageId = 'basalPage' + (this.basalPagePos + 1);
        console.log("basalPageId:", basalPageId);
        var _sepNode = document.getElementById(basalPageId);
        var _baseRow = 0;
        if (this.moreBasal) {
          _baseRow = 4;
        } else {
          _baseRow = 0;
        }

        if (firstPageTotalRow + _baseRow <= 13) {} else if (firstPageTotalRow + _baseRow <= 14) {} else if (firstPageTotalRow + _baseRow <= 15) {} else if (firstPageTotalRow + _baseRow <= 16) {}
      }

      var backgroundNode = document.getElementById('background');
      var containerNode = document.getElementById('chart-container');
      var pageNum = 4;

      if (this.basalPagePos2 < 0 && this.basalPagePos < 0) {
        if (this.moreBasal) {
          leftBasalRow += 4;
        }
        pageNum = 3;
      } else if (this.basalPagePos2 > 0 && this.basalPagePos > 0) {
        if (leftBasalRow > 1) {
          pageNum = 5;
        } else {
          pageNum = 4;
        }
      } else if (this.basalPagePos > 0 && this.basalPagePos2 < 0) {
        if (leftBasalRow > 1) {
          pageNum = 4;
        } else {
          pageNum = 3;
        }
      }

      console.log("leftBasalRow:", leftBasalRow, pageNum);

      if (leftBasalRow > 10) {
        var bolusPageId = 'bolusStartPage';
        console.log("bolusPageId:", bolusPageId);
        var _sepNode2 = document.getElementById(bolusPageId);
        if (leftBasalRow >= 16) {} else if (leftBasalRow >= 14) {} else if (leftBasalRow >= 13) {} else if (leftBasalRow >= 12) {} else if (leftBasalRow >= 11) {}

        this.bolusStartPage.show = true;
        this.pdmStartPage.show = false;
        this.cgmStartPage.show = false;
      } else if (leftBasalRow > 5) {

        var pdmPageId = 'pdmStartPage';
        console.log("pdmPageId:", pdmPageId);
        var _sepNode3 = document.getElementById(pdmPageId);

        if (leftBasalRow >= 10) {} else if (leftBasalRow >= 7) {} else if (leftBasalRow >= 6) {}

        this.bolusStartPage.show = false;
        this.pdmStartPage.show = true;
        this.cgmStartPage.show = false;
      } else if (leftBasalRow > 1) {

        var cgmPageId = 'cgmStartPage';
        console.log("cgmPageId:", cgmPageId);
        var _sepNode4 = document.getElementById(cgmPageId);

        if (leftBasalRow >= 5) {} else if (leftBasalRow >= 4) {} else if (leftBasalRow >= 3) {} else if (leftBasalRow >= 2) {}

        this.bolusStartPage.show = false;
        this.pdmStartPage.show = false;
        this.cgmStartPage.show = true;
      }
      this.pumpStartPage.show = true;
      this.appStartPage.show = false;
    }

    if (this.moreBasal) {
      var img6 = document.getElementById('img6_6');
      img6.src = sessionStorage.getItem('src6_6');
      var img7 = document.getElementById('img6_7');
      img7.src = sessionStorage.getItem('src6_7');
      var img8 = document.getElementById('img6_8');
      img8.src = sessionStorage.getItem('src6_8');
    }

    this.basal = this.data.basal_settings;
    this.basal.max_rate = this.basal.max_rate ? this.basal.max_rate.toFixed(2) : '--';

    this.basalSeg = this.basal.exer_basal.seg;
    this.total = this.basal.exer_basal.day_total.toFixed(2);
    this.exerTotal = this.total;
    this.exerSeg = this.basalSeg;
    this.basalInfo[1].total = this.total;
    this.basalInfo[1].title = this.$t('Exercise');

    this.basalSeg = this.basal.stand_basal.seg;
    this.total = this.basal.stand_basal.day_total.toFixed(2);
    this.standardTotal = this.total;
    this.standardSeg = this.basalSeg;
    this.basalInfo[0].total = this.total;
    this.basalInfo[0].title = this.$t('Standard');

    this.basalSeg = this.basal.holiday_basal.seg;
    this.total = this.basal.holiday_basal.day_total.toFixed(2);
    this.holidayTotal = this.total;
    this.holidaySeg = this.basalSeg;
    this.basalInfo[2].total = this.total;
    this.basalInfo[2].title = this.$t('Holiday');

    this.basalSeg = this.basal.program_a_basal.seg;
    this.total = this.basal.program_a_basal.day_total.toFixed(2);
    this.programATotal = this.total;
    this.programASeg = this.basalSeg;
    this.basalInfo[3].total = this.total;
    this.basalInfo[3].title = this.$t('ProgramA');

    this.basalSeg = this.basal.program_b_basal.seg;
    this.total = this.basal.program_b_basal.day_total.toFixed(2);
    this.programBTotal = this.total;
    this.programBSeg = this.basalSeg;
    this.basalInfo[4].total = this.total;
    this.basalInfo[4].title = this.$t('Program B');

    if (this.moreBasal) {
      this.programCSeg = this.basal.program_c_basal.seg;
      this.basalInfo[5].total = this.basal.program_c_basal.day_total.toFixed(2);
      this.basalInfo[5].title = this.$t('t1028_Pattern_C');

      this.programDSeg = this.basal.program_d_basal.seg;
      this.basalInfo[6].total = this.basal.program_d_basal.day_total.toFixed(2);
      this.basalInfo[6].title = this.$t('t1028_Pattern_D');

      this.sickSeg = this.basal.sick_basal.seg;
      this.basalInfo[7].total = this.basal.sick_basal.day_total.toFixed(2);
      this.basalInfo[7].title = this.$t('t1029_Sick');
    } else {
      this.basalInfo.splice(5, 3);
    }

    for (var _i4 = 0; _i4 < this.basalSeg.length; _i4++) {
      if (_i4 < 12) {
        this.bsg1.push(this.basalSeg[_i4]);
      } else if (_i4 < 24) {
        this.bsg2.push(this.basalSeg[_i4]);
      } else if (_i4 < 36) {
        this.bsg3.push(this.basalSeg[_i4]);
      } else {
        this.bsg4.push(this.basalSeg[_i4]);
      }
    }

    console.log(this.basalInfo);

    var segName = ['standardSeg', 'exerSeg', 'holidaySeg', 'programASeg', 'programBSeg', 'programCSeg', 'programDSeg', 'sickSeg'];
    if (!this.moreBasal) {
      segName.splice(5, 3);
    }
    for (var n = 0; n < segName.length; n++) {
      this.basalInfo[n].bsg1 = [];
      this.basalInfo[n].bsg2 = [];
      this.basalInfo[n].bsg3 = [];
      this.basalInfo[n].bsg4 = [];

      this.basalInfo[n].bsg2show = false;
      this.basalInfo[n].bsg3show = false;
      this.basalInfo[n].bsg4show = false;
    }

    for (var _n = 0; _n < segName.length; _n++) {
      var curSeg = this[segName[_n]];
      curSeg = curSeg.map(function (e, i) {
        return [e[0], e[1].toFixed(2)];
      });
      for (var _i5 = 0; _i5 < curSeg.length; _i5++) {
        if (_i5 < 12) {
          this[segName[_n] + '1'].push(curSeg[_i5]);
          this.basalInfo[_n].bsg1.push(curSeg[_i5]);
        } else if (_i5 < 24) {
          this[segName[_n] + '2'].push(curSeg[_i5]);
          this.basalInfo[_n].bsg2.push(curSeg[_i5]);
          this.basalInfo[_n].bsg2show = true;
        } else if (_i5 < 36) {
          this[segName[_n] + '3'].push(curSeg[_i5]);
          this.basalInfo[_n].bsg3.push(curSeg[_i5]);
          this.basalInfo[_n].bsg3show = true;
        } else {
          this[segName[_n] + '4'].push(curSeg[_i5]);
          this.basalInfo[_n].bsg4.push(curSeg[_i5]);
          this.basalInfo[_n].bsg4show = true;
        }
      }
    }
    console.log(this.basalInfo);

    if (true) {
      var _basalPageId = 'basalPage' + this.basalPagePos;
    }

    this.bolus = this.data.bolus_settings;
    this.IcRatio = this.data.bolus_settings.ins_carb_ratio;
    this.ins_sen = this.data.bolus_settings.ins_sen;
    this.bg_target = this.data.bolus_settings.bg_target;
    this.bolus_rem = this.data.bolus_settings.bolus_reminder;

    this.userset = this.data.user_settings;
    this.userset.sensor_sn = this.userset.sensor_sn ? this.userset.sensor_sn : '--';
    this.userset.user_name = this.userset.user_name ? this.userset.user_name : '--';
    this.userset.sensor_expire_option = this.userset.sensor_expire_option ? this.$t(this.userset.sensor_expire_option) : '--';
    this.userset.pump_sn = this.userset.pump_sn ? this.userset.pump_sn : '--';
    this.userset.alarm_type = this.userset.alarm_type ? this.$t(this.userset.alarm_type) : '--';
    this.userset.low_reservoir_time = this.userset.low_reservoir_type === 'time' ? this.userset.low_reservoir_time : this.$t(this.userset.low_reservoir_type) + ' ' + this.userset.low_reservoir_ins + ins_unit2;
    var opt = this.userset.patch_expire_alarm;
    this.userset.patch_expire_alarm = opt === 'On' ? this.$t(opt) + ' ' + this.userset.patch_expire_ahead + 'H' : this.$t(opt);
    this.userset.auto_off_option = this.userset.auto_off_option === 'On' ? this.$t(this.userset.auto_off_option) + ' ' + this.userset.auto_off_time + 'H' : this.$t(this.userset.auto_off_option);
    this.userset.pre_suspend_on_lowbg_option = this.userset.pre_suspend_on_lowbg_option === 'On' ? this.$t(this.userset.pre_suspend_on_lowbg_option) + ' ' + this.userset.pre_suspend_on_lowbg_level : this.$t(this.userset.pre_suspend_on_lowbg_option);
    if (this.userset.clock) {
      var that = this;
      this.userset.clock.map(function (e, i) {
        e[1] = that.$t(e[1]);
      });
    }

    this.userset.suspend_on_lowbg_option = this.$t(this.userset.suspend_on_lowbg_option);
    if (this.userset.suspend_on_lowbg_option === this.$t('On')) {
      this.userset.suspend_on_lowbg_level = this.isMg ? parseInt(this.userset.suspend_on_lowbg_level) : this.userset.suspend_on_lowbg_level.toFixed(1);
    }

    if (this.userset.auto_basal) {
      var auto_basal = this.userset.auto_basal;

      auto_basal.autobasalflag = this.getOptionText(auto_basal.autobasalflag);

      if (this.isMg) {
        if (0 == auto_basal.BGTarget) {
          auto_basal.BGTarget = '100 mg/dL';
        } else if (1 == auto_basal.BGTarget) {
          auto_basal.BGTarget = '110 mg/dL';
        } else if (2 == auto_basal.BGTarget) {
          auto_basal.BGTarget = '120 mg/dL';
        }
      } else {
        if (0 == auto_basal.BGTarget) {
          auto_basal.BGTarget = '5.6 mmol/L';
        } else if (1 == auto_basal.BGTarget) {
          auto_basal.BGTarget = '6.1 mmol/L';
        } else if (2 == auto_basal.BGTarget) {
          auto_basal.BGTarget = '6.7 mmol/L';
        }
      }
      auto_basal.nFoodFlag = this.getOptionText(auto_basal.nFoodFlag);

      if (!auto_basal.AutoBasalWeight) {
        auto_basal.AutoBasalWeight = '--';
      }
      if (!auto_basal.AutoBasalTDD) {
        auto_basal.AutoBasalTDD = '--';
      }
    } else {
      this.userset.auto_basal = {};
    }

    var option = this.$t(this.data.bolus_settings.bolus_reminder_option);
    this.maxBolOption = ' (' + option + ')';

    this.pdmSN = sessionStorage.getItem('pdmSN');
    if ('EasyPatch' == this.pdmSN) {
      this.pdmTitle = 'APP';
    }
    this.pumpSN = this.userset.pump_sn ? this.userset.pump_sn : '--';
    this.tranSN = this.userset.sensor_sn ? this.userset.sensor_sn : '--';
    this.pumpSN = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].deviceSNFormat(this.pumpSN, 'PUMP');
    this.tranSN = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].deviceSNFormat(this.tranSN, 'TRANS');

    this.userset.clock.map(function (e, i) {
      var time = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getTime2(e[0]);
      e[0] = time[0] + ":" + time[1];
      return e;
    });

    this.cgm = this.data.sensor_settings;
    if (this.cgm.sensor_rate_alarm) {
      this.cgm.sensor_rate_alarm.fall[1] = this.cgm.sensor_rate_alarm.fall[0] !== "Off" ? this.cgm.sensor_rate_alarm.fall[1].toFixed(3) : '--';
      this.cgm.sensor_rate_alarm.rise[1] = this.cgm.sensor_rate_alarm.rise[0] !== "Off" ? this.cgm.sensor_rate_alarm.rise[1].toFixed(3) : '--';
    }
    if (this.cgm.sensor_alarm_repeat) {
      this.cgm.sensor_alarm_repeat.high[1] = this.cgm.sensor_alarm_repeat.high[0] !== "Off" ? this.cgm.sensor_alarm_repeat.high[1] : '--';
      this.cgm.sensor_alarm_repeat.low[1] = this.cgm.sensor_alarm_repeat.low[0] !== "Off" ? this.cgm.sensor_alarm_repeat.low[1] : '--';
    }
    if (this.cgm.sensor_forecast_alarm) {
      this.cgm.sensor_forecast_alarm.high[1] = this.cgm.sensor_forecast_alarm.high[0] !== "Off" ? this.cgm.sensor_forecast_alarm.high[1] : '--';
      this.cgm.sensor_forecast_alarm.low[1] = this.cgm.sensor_forecast_alarm.low[0] !== "Off" ? this.cgm.sensor_forecast_alarm.low[1] : '--';
    }
    this.cgm.sensor_alarm_settings.calib_remind_time = this.cgm.sensor_alarm_settings.calib_remind_option !== 'Off' ? this.cgm.sensor_alarm_settings.calib_remind_time : "--";
    this.cgm.sensor_alarm_settings.calib_remind_interval = this.cgm.sensor_alarm_settings.auto_calib_option !== 'Off' ? this.cgm.sensor_alarm_settings.calib_remind_interval : "--";

    this.cgmLimit = this.cgm.sensor_alarm_threshold;

    var basal_select_map = {
      'ProgramC': 't1028_Pattern_C',
      'ProgramD': 't1028_Pattern_D',
      'Sick': 't1029_Sick'
    };
    if (basal_select_map[this.basal.basal_select]) {
      this.basal.basal_select = basal_select_map[this.basal.basal_select];
    }
    this.basal.basal_select = this.$t(this.basal.basal_select);
    this.basal.basal_onoff = this.$t(this.basal.basal_onoff);
    this.bolus.bg_reminder = this.$t(this.bolus.bg_reminder);
    this.bolus.extent_option = this.$t(this.bolus.extent_option);
    this.bolus.bolus_wizard = this.$t(this.bolus.bolus_wizard);
    this.userset.cgms_module_flag = this.$t(this.userset.cgms_module_flag);
    this.userset.cmd_response = this.$t(this.userset.cmd_response);
    this.userset.clock_option = this.$t(this.userset.clock_option);
    this.userset.pump_module_flag = this.$t(this.userset.pump_module_flag);

    this.cgm.sensor_rate_alarm.fall[0] = this.$t(this.cgm.sensor_rate_alarm.fall[0]);
    this.cgm.sensor_rate_alarm.rise[0] = this.$t(this.cgm.sensor_rate_alarm.rise[0]);
    this.cgm.sensor_alarm_repeat.high[0] = this.$t(this.cgm.sensor_alarm_repeat.high[0]);
    this.cgm.sensor_alarm_repeat.low[0] = this.$t(this.cgm.sensor_alarm_repeat.low[0]);
    this.cgm.sensor_forecast_alarm.high[0] = this.$t(this.cgm.sensor_forecast_alarm.high[0]);
    this.cgm.sensor_forecast_alarm.low[0] = this.$t(this.cgm.sensor_forecast_alarm.low[0]);
    this.cgm.sensor_alarm_settings.calib_remind_option = this.$t(this.cgm.sensor_alarm_settings.calib_remind_option);
    this.cgm.sensor_alarm_option = this.$t(this.cgm.sensor_alarm_option);
    this.cgm.alarm_silent_option = this.$t(this.cgm.alarm_silent_option);
  }
});

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_base64__ = __webpack_require__(9);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      time: '', rid: 0, uid: 0, st: 0, et: 0, data: {}, unit: '', isMg: "", unit1: '', colock: '', isFr: false,
      statics: {}, devices: ['--', '--', '--'], hb1c: ['--'], pdmSN: '', tranSN: '', pumpSN: '', maxBolOption: '',
      basal: {
        "basal_onoff": "--",
        "basal_select": "--",
        "max_rate": '--',
        "exer_basal": {
          "day_total": '--',
          "seg": []
        }
      },
      page4: true,
      moreBasal: true,
      basalPagePos: -9,
      basalPagePos2: -9,
      basalEndPage: { show: false },
      cgmStartPage: { show: true },

      basalSeg: [], bsg1: [], bsg2: [], bsg3: [], bsg4: [], total: 0,
      standardTotal: 0, exerTotal: 0, holidayTotal: 0, programATotal: 0, programBTotal: 0,

      standardSeg: [], standardSeg1: [], standardSeg2: [], standardSeg3: [], standardSeg4: [],
      exerSeg: [], exerSeg1: [], exerSeg2: [], exerSeg3: [], exerSeg4: [],
      holidaySeg: [], holidaySeg1: [], holidaySeg2: [], holidaySeg3: [], holidaySeg4: [],
      programASeg: [], programASeg1: [], programASeg2: [], programASeg3: [], programASeg4: [],
      programBSeg: [], programBSeg1: [], programBSeg2: [], programBSeg3: [], programBSeg4: [],

      sickSeg: [], sickSeg1: [], sickSeg2: [], sickSeg3: [], sickSeg4: [],
      programCSeg: [], programCSeg1: [], programCSeg2: [], programCSeg3: [], programCSeg4: [],
      programDSeg: [], programDSeg1: [], programDSeg2: [], programDSeg3: [], programDSeg4: [],

      basalInfo: [{}, {}, {}, {}, {}, {}, {}, {}],

      bolus: {
        "bg_reminder": "--",
        "bg_target": [],
        "bolus_reminder": [],
        "bolus_step": '--',
        "bolus_wizard": "--",
        "extent_option": "--",
        "ins_active_time": '--',
        "ins_carb_ratio": [],
        "ins_sen": [],
        "max_bolus": '--'
      },
      IcRatio: [], ins_sen: [], bg_target: [], bolus_rem: [], cgmLimit: [],
      cgm: {
        "alarm_silent_option": "--",
        "sensor_alarm_option": "--",
        "sensor_alarm_repeat": {
          "high": ["--", "--"],
          "low": ["--", "--"]
        },
        "sensor_alarm_settings": {
          "auto_calib_option": "--",
          "calib_remind_interval": "--",
          "calib_remind_option": "--",
          "calib_remind_time": "--",
          "no_calib_display": "--",
          "sensor_lost_time": '--',
          "trend_time_scope": '--'
        },
        "sensor_alarm_threshold": [],
        "sensor_forecast_alarm": {
          "high": ["--", "--"],
          "low": ["--", "--"]
        },
        "sensor_rate_alarm": {
          "fall": ["--", '--'],
          "rise": ["--", '--']
        }
      },
      userset: {
        "alarm_type": "--",
        "auto_off_option": "--",
        "auto_off_time": "--",
        "backlight_timeout": "--",
        "beep_off_tip_interval": "--",
        "beep_off_tip_option": "--",
        "cgms_module_flag": "--",
        "clock": [],
        "clock_option": "--",
        "cmd_response": "--",
        "day_bolus_max": "--",
        "device_option": "--",
        "glucose_unit": "--",
        "hour_bolus_max": "--",
        "keypad_lock": "--",
        "low_reservoir_ins": "--",
        "low_reservoir_time": "--",
        "low_reservoir_type": "--",
        "password_option": "--",
        "patch_expire_ahead": "--",
        "patch_expire_alarm": "--",
        "pre_suspend_on_lowbg_level": "--",
        "pre_suspend_on_lowbg_option": "--",
        "pump_module_flag": "--",
        "screen_timeout": "--",
        "suspend_on_lowbg_level": "--",
        "suspend_on_lowbg_option": "--",
        "time_style": "--"
      },
      isEn: false, isDe: false
    };
  },

  methods: {
    getStatics: function getStatics() {
      this.et = new Date(2017, 9, 19).getTime() / 1000;
      this.st = this.et;
      var param = {
        st: this.st,
        et: this.et,
        tz: parseInt(sessionStorage.getItem('tz')),
        gu: this.isMg ? 'mg/dL' : 'mmol/L'
      };
      param = __WEBPACK_IMPORTED_MODULE_3__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));
      this.$http.get('api/v2.1/report/' + this.uid + '/data/dse', { params: { param: param } }).then(function (res) {
        var err = res.body.error;
        if (err === 0) {
          var data = res.data.data;
          data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
          this.statics = data;
          this.devices = data.devices ? data.devices : this.devices;
          this.hb1c = data.hba1c ? data.hba1c : this.hb1c;
        }
      }, function (err) {
        var tip = this.$t('tryAgain');
        this.$message.error(tip);
      });
    },
    printPdf: function printPdf() {
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].print_page();
    }
  },
  mounted: function mounted() {
    self.document.title = this.$t('Device Settings Report');
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isDe = lang === 'de' || lang === 'it' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    var ins_unit2 = this.$t('ins_unit2');
    this.unit = this.isMg ? ' (mg/dL/' + ins_unit2 + ')' : ' (mmol/L/' + ins_unit2 + ')';
    this.unit1 = this.isMg ? 'mg/dL' : 'mmol/L';
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }
    this.time = sessionStorage.getItem('time6').split(',')[0];
    var img1 = document.getElementById('img6_1');
    img1.src = sessionStorage.getItem('src6_1');

    var img2 = document.getElementById('img6_2');
    img2.src = sessionStorage.getItem('src6_2');

    var img3 = document.getElementById('img6_3');
    img3.src = sessionStorage.getItem('src6_3');

    var img4 = document.getElementById('img6_4');
    img4.src = sessionStorage.getItem('src6_4');

    var img5 = document.getElementById('img6_5');
    img5.src = sessionStorage.getItem('src6_5');

    this.getStatics();
    this.data = JSON.parse(sessionStorage.getItem('deviceSet'));
    console.log('device setting:', this.data);

    if (true) {
      var padInt = function padInt(v, n) {
        var v_str = v.toString();
        var pre_num = n - v_str.length;
        var pre_str = '';
        for (var i = 0; i < pre_num; i++) {
          pre_str += '0';
        }
        return pre_str + v_str;
      };

      var minute_format = function minute_format(m) {
        var hour = padInt(Math.floor(m / 60), 2);
        var minute = padInt(m % 60, 2);
        return hour + ':' + minute;
      };

      var testSegs = [];
      for (var i = 0; i < 48; i++) {
        var minute = i * 30;
        testSegs.push([minute_format(minute), parseFloat((i % 20 * 0.1).toFixed(2))]);
      }

      this.data.basal_settings.stand_basal.seg = testSegs;
      this.data.basal_settings.exer_basal.seg = testSegs;
      this.data.basal_settings.holiday_basal.seg = testSegs;
      this.data.basal_settings.program_a_basal.seg = testSegs;
      this.data.basal_settings.program_b_basal.seg = testSegs;
      this.data.basal_settings.program_c_basal.seg = testSegs;
      this.data.basal_settings.program_d_basal.seg = testSegs;
      this.data.basal_settings.sick_basal.seg = testSegs;

      console.log('device setting test:', this.data);
    }

    if (18 == this.data.device_type) {
      this.moreBasal = true;
    } else {
      this.moreBasal = false;
    }

    if (true) {
      if (this.moreBasal) {
        var totalRow = 0;

        var pageTotalRow = 0;
        var basalKey = ["stand_basal", "exer_basal", "holiday_basal", "program_a_basal", "program_b_basal", "program_c_basal", "program_d_basal", "sick_basal"];
        for (var _i = 0; _i < 8; _i++) {
          var basal_pattern = this.data.basal_settings[basalKey[_i]];
          totalRow += Math.floor((basal_pattern.seg.length + 11) / 12);
          if (totalRow >= 12 && this.basalPagePos < 0) {
            this.basalPagePos = _i;

            pageTotalRow = totalRow;
          }
          if (totalRow >= 12 + 16 && this.basalPagePos2 < 0) {
            this.basalPagePos2 = _i;

            pageTotalRow = totalRow;
          }
        }
        console.log("basalTotalRow:", totalRow, pageTotalRow, this.basalPagePos, this.basalPagePos2);
      }
    }

    if (this.moreBasal) {
      var img6 = document.getElementById('img6_6');
      img6.src = sessionStorage.getItem('src6_6');
      var img7 = document.getElementById('img6_7');
      img7.src = sessionStorage.getItem('src6_7');
      var img8 = document.getElementById('img6_8');
      img8.src = sessionStorage.getItem('src6_8');
    }

    this.basal = this.data.basal_settings;

    this.basalSeg = this.basal.exer_basal.seg;
    this.total = this.basal.exer_basal.day_total.toFixed(2);
    this.exerTotal = this.total;
    this.exerSeg = this.basalSeg;
    this.basalInfo[1].total = this.total;
    this.basalInfo[1].title = 'Exercise';

    this.basalSeg = this.basal.stand_basal.seg;
    this.total = this.basal.stand_basal.day_total.toFixed(2);
    this.standardTotal = this.total;
    this.standardSeg = this.basalSeg;
    this.basalInfo[0].total = this.total;
    this.basalInfo[0].title = 'Standard';

    this.basalSeg = this.basal.holiday_basal.seg;
    this.total = this.basal.holiday_basal.day_total.toFixed(2);
    this.holidayTotal = this.total;
    this.holidaySeg = this.basalSeg;
    this.basalInfo[2].total = this.total;
    this.basalInfo[2].title = 'Holiday';

    this.basalSeg = this.basal.program_a_basal.seg;
    this.total = this.basal.program_a_basal.day_total.toFixed(2);
    this.programATotal = this.total;
    this.programASeg = this.basalSeg;
    this.basalInfo[3].total = this.total;
    this.basalInfo[3].title = 'Program A';

    this.basalSeg = this.basal.program_b_basal.seg;
    this.total = this.basal.program_b_basal.day_total.toFixed(2);
    this.programBTotal = this.total;
    this.programBSeg = this.basalSeg;
    this.basalInfo[4].total = this.total;
    this.basalInfo[4].title = 'Program B';

    if (this.moreBasal) {
      this.programCSeg = this.basal.program_c_basal.seg;
      this.basalInfo[5].total = this.basal.program_c_basal.day_total.toFixed(2);
      this.basalInfo[5].title = 'Program C';

      this.programDSeg = this.basal.program_d_basal.seg;
      this.basalInfo[6].total = this.basal.program_d_basal.day_total.toFixed(2);
      this.basalInfo[6].title = 'Program D';

      this.sickSeg = this.basal.sick_basal.seg;
      this.basalInfo[7].total = this.basal.sick_basal.day_total.toFixed(2);
      this.basalInfo[7].title = 'Sick';
    } else {
      this.basalInfo.splice(5, 3);
    }

    for (var _i2 = 0; _i2 < this.basalSeg.length; _i2++) {
      if (_i2 < 12) {
        this.bsg1.push(this.basalSeg[_i2]);
      } else if (_i2 < 24) {
        this.bsg2.push(this.basalSeg[_i2]);
      } else if (_i2 < 36) {
        this.bsg3.push(this.basalSeg[_i2]);
      } else {
        this.bsg4.push(this.basalSeg[_i2]);
      }
    }

    console.log(this.basalInfo);

    var segName = ['standardSeg', 'exerSeg', 'holidaySeg', 'programASeg', 'programBSeg', 'programCSeg', 'programDSeg', 'sickSeg'];
    if (!this.moreBasal) {
      segName.splice(5, 3);
    }
    for (var n = 0; n < segName.length; n++) {
      this.basalInfo[n].bsg1 = [];
      this.basalInfo[n].bsg2 = [];
      this.basalInfo[n].bsg3 = [];
      this.basalInfo[n].bsg4 = [];

      this.basalInfo[n].bsg2show = false;
      this.basalInfo[n].bsg3show = false;
      this.basalInfo[n].bsg4show = false;
    }

    for (var _n = 0; _n < segName.length; _n++) {
      var curSeg = this[segName[_n]];
      for (var _i3 = 0; _i3 < curSeg.length; _i3++) {
        if (_i3 < 12) {
          this[segName[_n] + '1'].push(curSeg[_i3]);
          this.basalInfo[_n].bsg1.push(curSeg[_i3]);
        } else if (_i3 < 24) {
          this[segName[_n] + '2'].push(curSeg[_i3]);
          this.basalInfo[_n].bsg2.push(curSeg[_i3]);
          this.basalInfo[_n].bsg2show = true;
        } else if (_i3 < 36) {
          this[segName[_n] + '3'].push(curSeg[_i3]);
          this.basalInfo[_n].bsg3.push(curSeg[_i3]);
          this.basalInfo[_n].bsg3show = true;
        } else {
          this[segName[_n] + '4'].push(curSeg[_i3]);
          this.basalInfo[_n].bsg4.push(curSeg[_i3]);
          this.basalInfo[_n].bsg4show = true;
        }
      }
    }
    console.log(this.basalInfo);

    if (true) {
      var basalPageId = 'basalPage' + this.basalPagePos;
    }

    this.bolus = this.data.bolus_settings;
    this.IcRatio = this.data.bolus_settings.ins_carb_ratio;
    this.ins_sen = this.data.bolus_settings.ins_sen;
    this.bg_target = this.data.bolus_settings.bg_target;
    this.bolus_rem = this.data.bolus_settings.bolus_reminder;

    this.userset = this.data.user_settings;
    this.userset.sensor_sn = this.userset.sensor_sn ? this.userset.sensor_sn : '--';
    this.userset.user_name = this.userset.user_name ? this.userset.user_name : '--';
    this.userset.sensor_expire_option = this.userset.sensor_expire_option ? this.$t(this.userset.sensor_expire_option) : '--';
    this.userset.pump_sn = this.userset.pump_sn ? this.userset.pump_sn : '--';
    this.userset.alarm_type = this.userset.alarm_type ? this.$t(this.userset.alarm_type) : '--';
    this.userset.low_reservoir_time = this.userset.low_reservoir_type === 'time' ? this.userset.low_reservoir_time : this.$t(this.userset.low_reservoir_type) + ' ' + this.userset.low_reservoir_ins + ins_unit2;
    var opt = this.userset.patch_expire_alarm;
    this.userset.patch_expire_alarm = opt === 'On' ? this.$t(opt) + ' ' + this.userset.patch_expire_ahead + 'H' : this.$t(opt);
    this.userset.auto_off_option = this.userset.auto_off_option === 'On' ? this.$t(this.userset.auto_off_option) + ' ' + this.userset.auto_off_time + 'H' : this.$t(this.userset.auto_off_option);
    this.userset.pre_suspend_on_lowbg_option = this.userset.pre_suspend_on_lowbg_option === 'On' ? this.$t(this.userset.pre_suspend_on_lowbg_option) + ' ' + this.userset.pre_suspend_on_lowbg_level : this.$t(this.userset.pre_suspend_on_lowbg_option);
    if (this.userset.clock) {
      var that = this;
      this.userset.clock.map(function (e, i) {
        e[1] = that.$t(e[1]);
      });
    }

    this.userset.suspend_on_lowbg_option = this.$t(this.userset.suspend_on_lowbg_option);
    if (this.userset.suspend_on_lowbg_option === this.$t('On')) {
      this.userset.suspend_on_lowbg_level = this.isMg ? parseInt(this.userset.suspend_on_lowbg_level) : this.userset.suspend_on_lowbg_level.toFixed(1);
      this.userset.suspend_on_lowbg_option = this.userset.suspend_on_lowbg_option + ' ' + this.userset.suspend_on_lowbg_level + this.unit1;
    }
    var option = this.$t(this.data.bolus_settings.bolus_reminder_option);
    this.maxBolOption = ' (' + option + ')';

    this.pdmSN = sessionStorage.getItem('pdmSN');
    this.pumpSN = this.userset.pump_sn ? this.userset.pump_sn : '--';
    this.tranSN = this.userset.sensor_sn ? this.userset.sensor_sn : '--';
    function HexSNProc(deviceSN, decimalRange) {

      if ('--' != deviceSN) {
        var tranSN = parseInt(deviceSN);
        console.log('tranSN.1:', tranSN);
        if (!isNaN(tranSN)) {
          var inRange = false;
          for (var i = 0; i < decimalRange.length; i++) {
            if (decimalRange[i][0] <= tranSN && tranSN <= decimalRange[i][0]) {
              inRange = true;
              break;
            }
          }
          if (inRange) {
            return deviceSN;
          } else {
            var addPreZero = function addPreZero(pdm_sn_hex, num) {
              var pre = '';
              for (var _i4 = 0; _i4 < num; _i4++) {
                pre += '0';
              }
              return pre + pdm_sn_hex;
            };

            tranSN = tranSN.toString(16).toUpperCase();
            return addPreZero(tranSN, 8 - tranSN.length);
          }
        }
      } else {
        return deviceSN;
      }
    }
    console.log('tranSN:', this.tranSN);
    this.tranSN = HexSNProc(this.tranSN, [[102000000, 103999999]]);
    this.pumpSN = HexSNProc(this.pumpSN, [[106000000, 106999999], [108000000, 108999999]]);

    this.userset.clock.map(function (e, i) {
      var time = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getTime2(e[0]);
      e[0] = time[0] + ":" + time[1];
      return e;
    });

    this.cgm = this.data.sensor_settings;
    if (this.cgm.sensor_rate_alarm) {
      this.cgm.sensor_rate_alarm.fall[1] = this.cgm.sensor_rate_alarm.fall[0] !== "Off" ? this.cgm.sensor_rate_alarm.fall[1].toFixed(3) : '--';
      this.cgm.sensor_rate_alarm.rise[1] = this.cgm.sensor_rate_alarm.rise[0] !== "Off" ? this.cgm.sensor_rate_alarm.rise[1].toFixed(3) : '--';
    }
    if (this.cgm.sensor_alarm_repeat) {
      this.cgm.sensor_alarm_repeat.high[1] = this.cgm.sensor_alarm_repeat.high[0] !== "Off" ? this.cgm.sensor_alarm_repeat.high[1] : '--';
      this.cgm.sensor_alarm_repeat.low[1] = this.cgm.sensor_alarm_repeat.low[0] !== "Off" ? this.cgm.sensor_alarm_repeat.low[1] : '--';
    }
    if (this.cgm.sensor_forecast_alarm) {
      this.cgm.sensor_forecast_alarm.high[1] = this.cgm.sensor_forecast_alarm.high[0] !== "Off" ? this.cgm.sensor_forecast_alarm.high[1] : '--';
      this.cgm.sensor_forecast_alarm.low[1] = this.cgm.sensor_forecast_alarm.low[0] !== "Off" ? this.cgm.sensor_forecast_alarm.low[1] : '--';
    }
    this.cgm.sensor_alarm_settings.calib_remind_time = this.cgm.sensor_alarm_settings.calib_remind_option !== 'Off' ? this.cgm.sensor_alarm_settings.calib_remind_time : "--";
    this.cgm.sensor_alarm_settings.calib_remind_interval = this.cgm.sensor_alarm_settings.auto_calib_option !== 'Off' ? this.cgm.sensor_alarm_settings.calib_remind_interval : "--";

    this.cgmLimit = this.cgm.sensor_alarm_threshold;

    this.basal.basal_select = this.$t(this.basal.basal_select);
    this.basal.basal_onoff = this.$t(this.basal.basal_onoff);
    this.bolus.bg_reminder = this.$t(this.bolus.bg_reminder);
    this.bolus.extent_option = this.$t(this.bolus.extent_option);
    this.bolus.bolus_wizard = this.$t(this.bolus.bolus_wizard);
    this.userset.cgms_module_flag = this.$t(this.userset.cgms_module_flag);
    this.userset.cmd_response = this.$t(this.userset.cmd_response);
    this.userset.clock_option = this.$t(this.userset.clock_option);
    this.userset.pump_module_flag = this.$t(this.userset.pump_module_flag);

    this.cgm.sensor_rate_alarm.fall[0] = this.$t(this.cgm.sensor_rate_alarm.fall[0]);
    this.cgm.sensor_rate_alarm.rise[0] = this.$t(this.cgm.sensor_rate_alarm.rise[0]);
    this.cgm.sensor_alarm_repeat.high[0] = this.$t(this.cgm.sensor_alarm_repeat.high[0]);
    this.cgm.sensor_alarm_repeat.low[0] = this.$t(this.cgm.sensor_alarm_repeat.low[0]);
    this.cgm.sensor_forecast_alarm.high[0] = this.$t(this.cgm.sensor_forecast_alarm.high[0]);
    this.cgm.sensor_forecast_alarm.low[0] = this.$t(this.cgm.sensor_forecast_alarm.low[0]);
    this.cgm.sensor_alarm_settings.calib_remind_option = this.$t(this.cgm.sensor_alarm_settings.calib_remind_option);
    this.cgm.sensor_alarm_option = this.$t(this.cgm.sensor_alarm_option);
    this.cgm.alarm_silent_option = this.$t(this.cgm.alarm_silent_option);
  }
});

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_base64__ = __webpack_require__(9);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      uid: 0, et: 0, st: 0, time: '', isEn: false, foodCoor: '', unit: '', isMg: '', ts: [], hypo: 3.1, high: 10.0, low: 5.6, isDe: false, isIt: false,
      statics: {}, devices: ['--', '--', '--'], hb1c: ['--'], target: '', avg: '--', active: '--', seg: ['--', '--', '--', '--'], sd: '--', cv: '--',
      est_a1c: '--'
    };
  },

  methods: {
    getStatics: function getStatics(param) {
      this.$http.get('api/v2.1/report/' + this.uid + '/data/sa', { params: { param: param } }).then(function (res) {
        var err = res.body.error;

        if (err === 0) {
          var data = res.data.data;
          data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
          this.statics = data;
          this.devices = data.devices ? data.devices : this.devices;
          if ('EasyPatch' == this.devices[0]) {
            document.getElementById('reportPdmTitle').innerHTML = 'APP';
          }
          this.hb1c = data.hba1cList ? data.hba1cList : this.hb1c;
          setTimeout(__WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */]._printPdf(), 2000);
        }
      }, function (err) {
        var tip = this.$t('tryAgain');
        this.$message.error(tip);
      });
    },
    analySg: function analySg() {
      var sg = JSON.parse(sessionStorage.getItem('sg7')),
          validSg = [],
          totalCount = 0,
          that = this;

      sg.map(function (e, i) {
        var length = e.length;
        if (length > 0) {
          totalCount += length;
          e.map(function (e1, i1) {
            if (e1[4] === 'C' || e1[4] === 'NC') {
              e1[3] = e1[3] > 22.2 ? 22.2 : e1[3];
              e1[3] = e1[3] < 2.2 ? 2.2 : e1[3];
              validSg.push(e1[3]);
            }
          });
        }
      });
      var length1 = validSg.length;
      if (totalCount > 0 && length1 > 0) {
        var totalSg = 0,
            Seg = [0, 0, 0, 0];
        var high = this.isMg ? parseFloat((this.high / 18).toFixed(1)) : this.high;
        var low = this.isMg ? parseFloat((this.low / 18).toFixed(1)) : this.low;
        this.active = (length1 / totalCount * 100).toFixed(1) + ' %';
        validSg.map(function (e, i) {
          totalSg += e;
          if (e < 3.1) {
            Seg[0]++;
          } else if (e < low) {
            Seg[1]++;
          } else if (e < high) {
            Seg[2]++;
          } else {
            Seg[3]++;
          }
        });
        var avg = totalSg / length1;
        this.avg = this.isMg ? Math.round(avg * 18) : avg.toFixed(1);
        this.est_a1c = ((avg * 18 + 46.7) / 28.7).toFixed(1) + '%';

        Seg.map(function (e, i) {
          var scale = (e / length1 * 100).toFixed(1);
          that.seg[i] = scale + ' %';
        });

        var tran = 0;
        validSg.map(function (e, i) {
          var d = e - avg;
          tran += Math.pow(d, 2);
        });
        var sd = Math.sqrt(tran / length1);
        this.sd = this.isMg ? Math.round(sd * 18) : sd.toFixed(1);
        this.cv = (sd / avg * 100).toFixed(1) + ' %';
      }
    },
    showCount: function showCount() {
      var count = JSON.parse(sessionStorage.getItem('count7'));
      var length = count.length;
      var tr = document.getElementById('count');
      for (var i = 0; i < length; i++) {
        var td = tr.getElementsByTagName('td')[count[i][0]];
        td.innerHTML = count[i][1];
      }
    },
    printPdf: function printPdf() {
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].print_page();
    }
  },
  mounted: function mounted() {
    self.document.title = this.$t('Segment Analysis Report');
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    this.unit = this.isMg ? ' mg/dL' : ' mmol/L';
    this.hypo = this.isMg ? 54 : 3.1;
    var st = sessionStorage.getItem('st7');
    var et = sessionStorage.getItem('et7');
    this.st = parseInt(st);
    this.et = parseInt(et);
    this.ts = [[this.st, this.et]];
    var param = {
      ts: this.ts,
      tz: parseInt(sessionStorage.getItem('tz')),
      gu: this.isMg ? 'mg/dL' : 'mmol/L'
    };
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }
    param = __WEBPACK_IMPORTED_MODULE_3__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));
    this.getStatics(param);
    this.time = sessionStorage.getItem('timeRange7');
    var img1 = document.getElementById('img1_1');
    img1.src = sessionStorage.getItem('src7_1');
    var img2 = document.getElementById('img1_2');
    img2.src = sessionStorage.getItem('src7_2');
    var img3 = document.getElementById('img1_3');
    img3.src = sessionStorage.getItem('src7_3');
    this.high = parseFloat(sessionStorage.getItem('targetH7'));
    this.low = parseFloat(sessionStorage.getItem('targetL7'));
    this.target = '( ' + this.low + ' - ' + this.high + this.unit + ' )';
    this.analySg();
    this.showCount();
  }
});

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_format__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_base64__ = __webpack_require__(9);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      whichDate: [], ts: [],
      hours: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
      uid: 0, st: 0, et: 0, days: '', dayNum: 0, isEn: false, ISmG: '',
      statics: {}, hb1c: ['--'], long: false,
      pagePos: [], perPage: [], chartEndPage: { show: false },
      styleText: '<style type="text/css" media="print">@page{size:landscape;margin:0;}</style>',
      bgstat: { "day": {
          "avg": "--",
          "max": "--",
          "min": "--",
          "num": "--",
          "sd": "--",
          "total": "--"
        }
      },
      carbstat: { "day": {
          "avg": "--",
          "max": "--",
          "min": "--",
          "num": "--",
          "sd": "--",
          "total": "--"
        }
      },
      bolstat: { "day": {
          "avg": "--",
          "max": "--",
          "min": "--",
          "num": "--",
          "sd": "--",
          "total": "--"
        }
      },
      exerstat: { "day": {
          "avg": "--",
          "max": "--",
          "min": "--",
          "num": "--",
          "sd": "--",
          "total": "--"
        }
      }
    };
  },

  methods: {
    getStatics: function getStatics() {
      if (sessionStorage.getItem('userType') !== 'P') {
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      } else {
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      this.ts = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getTs(this.st, this.et);

      var param = {
        ts: this.ts,
        tz: parseInt(sessionStorage.getItem('tz')),
        gu: this.isMg ? 'mg/dL' : 'mmol/L'
      };
      param = __WEBPACK_IMPORTED_MODULE_4__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));
      this.$http.get('api/v2.1/report/' + this.uid + '/data/erd', { params: { param: param } }).then(function (res) {
        var err = res.body.error;
        if (err === 0) {
          var data = res.data.data;
          data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
          if (data.medical_history) {
            data.medical_history = data.medical_history.split(',')[0];
          }
          this.statics = data;
          this.hb1c = data.hba1c ? data.hba1c : this.hb1c;
          this.bgstat = data.event_period_stat.bg ? data.event_period_stat.bg : this.bgstat;
          this.carbstat = data.event_period_stat.carb ? data.event_period_stat.carb : this.carbstat;
          this.bolstat = data.event_period_stat.bolus ? data.event_period_stat.bolus : this.bolstat;
          this.exerstat = data.event_period_stat.exer ? data.event_period_stat.exer : this.exerstat;
          var that = this;
          data.event_summary_bytime.map(function (e, i) {
            e.bg = that.makeBg(e.bg, i);
            e.carb = that.makeCarb(e.carb, i, 1);
            e.bolus = that.makeCarb(e.bolus, i, 2);
            e.exer = that.makeCarb(e.exer, i, 3);
          });
        }
      }, function (err) {
        var tip = this.$t('tryAgain');
        this.$message.error(tip);
      });
    },
    makeBg: function makeBg(val, i) {
      var table = document.getElementById(i);
      var tr = table.getElementsByTagName('tr')[0];
      var h = 'hour';
      if (val.no_data) {
        var td = tr.getElementsByTagName('td');
        var tip1 = this.$t('No1');
        var tip2 = this.$t('data1');
        td[2].innerHTML = tip1;
        td[2].style.textAlign = 'right';
        td[3].innerHTML = tip2;
        td[3].style.textAlign = 'left';
      } else {
        for (var item in val) {
          if (item.indexOf(h) >= 0) {
            var j = parseInt(item.replace(/[^0-9]/ig, ""));
            var _td = tr.getElementsByTagName('td')[j + 2];
            _td.innerHTML = val[item];
          } else {
            var _td2 = tr.getElementsByTagName('td')[26];
            _td2.innerHTML = val.total;
          }
        }
      }
    },
    makeCarb: function makeCarb(val, i, type) {
      var table = document.getElementById(i);
      var tr = table.getElementsByTagName('tr')[type];
      var h = 'hour';
      if (val.no_data) {
        var td = tr.getElementsByTagName('td');
        var tip1 = this.$t('No1');
        var tip2 = this.$t('data1');
        td[1].innerHTML = tip1;
        td[1].style.textAlign = 'right';
        td[2].innerHTML = tip2;
        td[2].style.textAlign = 'left';
      } else {
        for (var item in val) {
          if (item.indexOf(h) >= 0) {
            var j = parseInt(item.replace(/[^0-9]/ig, ""));
            var _td3 = tr.getElementsByTagName('td')[j + 1];
            _td3.innerHTML = val[item];
          } else {
            var _td4 = tr.getElementsByTagName('td')[25];
            _td4.innerHTML = val.total;
          }
        }
      }
    },
    printPdf: function printPdf() {
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].print_page();
    }
  },
  mounted: function mounted() {
    self.document.title = this.$t('Alerts Report');
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;

    var st8 = sessionStorage.getItem('st8');
    var et8 = sessionStorage.getItem('et8');
    var t1 = parseInt(st8);
    var t2 = parseInt(et8);

    this.dayNum = parseInt((t2 - t1) / 86400 + 1);
    if (this.dayNum > 8) {
      this.long = true;
    }

    this.days = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate2(t1) + ' - ' + __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate2(t2);
    for (var i = 0; i < this.dayNum; i++) {
      console.log('whichDate:', i, t1 + i * 86400, new Date((t1 + i * 86400) * 1000));
      var ti = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate2(t1 + i * 86400) + ' ' + __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDay(this, t1 + i * 86400);
      this.whichDate[i] = ti;
    }
    console.log("event.st8:", st8, et8, t1, t2, this.dayNum, this.whichDate);
    var page_index = 0;
    var PER_PAGE1 = 9;
    var PER_PAGE2 = 10;
    while (page_index < this.whichDate.length) {
      this.pagePos.push(page_index);
      if (1 == this.pagePos.length) {
        page_index += PER_PAGE1;
        this.perPage.push(PER_PAGE1);
      } else {
        page_index += PER_PAGE2;
        this.perPage.push(PER_PAGE2);
      }
    }
    var chartNum = this.whichDate.length;

    if ((chartNum - 9) % 10 == 0) {
      this.chartEndPage.show = true;
    }

    console.log('pagePos:', this.pagePos);
    var pageNum = this.pagePos.length;

    this.st = t1;
    this.et = t2;
    this.getStatics();
    setTimeout(__WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */]._printPdf(), 4000);
  }
});

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_format__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_base64__ = __webpack_require__(9);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      uid: 0, et: 0, st: 0, time: '', qst1: '', qet1: '', day1: [''], dayNum1: 0, id11: [], id12: [], id13: [], foodCoor: [], isMg: '', ts: [], isIt: false, isPo: false, isEs: false,
      chart1_10: null, chart1_11: null, chart1_12: null, chart1_13: null, chart1_14: null, chart1_15: null, chart1_16: null, isCz: false,
      chart1_20: null, chart1_21: null, chart1_22: null, chart1_23: null, chart1_24: null, chart1_25: null, chart1_26: null,
      chart1_30: null, chart1_31: null, chart1_32: null, chart1_33: null, chart1_34: null, chart1_35: null, chart1_36: null, isDu: false, isFr: false,

      statics: {}, hb1c: ['--'],
      devices: [['--', '--', '--'], ['--', '--', '--'], ['--', '--', '--'], ['--', '--', '--'], ['--', '--', '--'], ['--', '--', '--'], ['--', '--', '--'], ['--', '--', '--'], ['--', '--', '--'], ['--', '--', '--'], ['--', '--', '--'], ['--', '--', '--'], ['--', '--', '--'], ['--', '--', '--']],
      glucose: [[], [], [], [], [], [], [], [], [], [], [], [], [], []],
      insulin: [[], [], [], [], [], [], [], [], [], [], [], [], [], []],
      events: [[], [], [], [], [], [], [], [], [], [], [], [], [], []],

      newBasal: [], stopBasal: [],
      sgMax: 20, basalMax: 5, bolusMax: 10, timeSection: [], transmtr: [],
      sensor_alarm: [], pump_alarm: [], carb: [], exercise: [[10, 10, 10, 10, 10]], calib: [], bg: [], isSw: false,
      extend_bolus: [[10, 10, 10, 10, 10]], basal_suspend: [], basal_suspend2: [], tempBasal: [], isDe: false,
      sleepTime1: [[10, 10, 10], [10, 10, 10]],
      sleepTime2: [[10, 10, 10], [10, 10, 10]],
      sleepTime3: [[10, 10, 10], [10, 10, 10]],
      chartColumn: null, chartColumn1: null, chartBar: null, isEn: false,
      autoModeBasal: [],
      autoModeCorrBolus: [],
      autoBreakfast: [],
      autoLunch: [],
      autoDinner: [],
      autoSnack: [],
      autoExercise: [],
      autoModeStat: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      textStyle: {
        color: '#282828',
        fontWeight: 'normal',
        fontSize: '14',
        fontFamily: 'SFUIText-Regular'
      },
      titlePadding: [0, 0, 8, 33],
      grid: { x: '3.5%', y: '16%', width: '90%', height: '70%' }, carbMax: 100,
      sgRange: [['', '4.4', '8.9', '13.3', '17.8', '22.2'], ['', '0.2', '0.4', '0.6', '0.8', '1.0'], ['', '1', '2', '3', '4', '5'], ['0', '1', '2', '3', '4', '5'], ['', this.$t('Light'), '', this.$t('Medium'), '', this.$t('heavy')]],
      dateTime: ["00:00", " ", "", "3:00", "", "", "6:00", "", "", "9:00", "", "", "12:00", "", "", "15:00", "", "", "18:00", "", "", "21:00", "", "", "24:00"],
      yAxisLabel: { interval: 0, margin: 5, textStyle: { color: '#282828', baseline: 'middle' }, showMinLabel: false },
      glucose_unit: ''
    };
  },

  computed: {
    DataS: function DataS() {
      return this.$store.state.DataS;
    },
    DataSG: function DataSG() {
      return this.$store.state.DataSG;
    },
    DataBasal: function DataBasal() {
      return this.$store.state.DataBasal;
    },
    DataBolus: function DataBolus() {
      return this.$store.state.DataBolus;
    }
  },
  methods: {
    drawChart1_1: function drawChart1_1(id) {
      var that = this;
      this[id] = __WEBPACK_IMPORTED_MODULE_1_echarts__["init"](document.getElementById(id));
      this[id].setOption({
        title: {
          text: this.isMg ? this.$t('SG') + ' (mg/dL)' : this.$t('SG') + ' (mmol/L)',
          textStyle: this.textStyle,
          padding: this.titlePadding
        },
        xAxis: [{
          type: 'time',
          boundaryGap: false,
          min: new Date(this.timeSection[0] * 1000),
          max: new Date(this.timeSection[1] * 1000),
          axisLabel: { show: false },
          axisLine: { lineStyle: { color: '#ccc' } },
          splitNumber: 24
        }],
        yAxis: [{
          type: 'value',
          min: 0,
          max: this.sgMax,
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          boundaryGap: false,
          axisTick: { length: 0 }
        }],
        grid: this.grid,
        series: [{
          name: 'SG',
          type: 'scatter',
          data: this.DataSG,
          markArea: {
            data: [[{ yAxis: this.isMg ? this.DataS.blos_low * 18 : this.DataS.blos_low }, { yAxis: this.isMg ? this.DataS.blos_high * 18 : this.DataS.blos_high }]],
            itemStyle: {
              normal: {
                color: 'rgba(211,255,213,0.6)'
              }
            }
          },
          markLine: {
            data: [{ yAxis: this.isMg ? this.DataS.hypo * 18 : this.DataS.hypo }],
            symbol: ['circle', 'circle'],
            silent: true,
            symbolSize: 1,
            lineStyle: { normal: {
                color: 'rgba(255,0,0,0.5)',
                type: 'solid'
              } },
            label: { normal: { show: false } }
          },
          itemStyle: { normal: {
              color: function color(params) {
                var color = '#2cd200';
                if (params.value[1] < 0.1 && params.value[2] === 'H') {
                  color = '#666';
                } else {
                  if (that.isMg) {
                    if (params.value[1] > that.DataS.blos_high * 18) {
                      color = '#e6be00';
                    }
                    if (params.value[1] < that.DataS.blos_low * 18) {
                      color = '#ff5c5c';
                    }
                  } else {
                    if (params.value[1] > that.DataS.blos_high) {
                      color = '#e6be00';
                    }
                    if (params.value[1] < that.DataS.blos_low) {
                      color = '#ff5c5c';
                    }
                  }
                }
                var type = params.value[2];
                if (type === 'NC' && params.value[1] === 0 || type === 'DE' || type === 'CE0' || type === 'CE1') {
                  color = 'transparent';
                }
                return color;
              }
            } },
          symbolSize: 2
        }, {
          type: 'scatter',
          data: this.sensor_alarm,
          symbol: 'image://static/legend/Alert.png',
          symbolSize: 13
        }, {
          type: 'scatter',
          data: this.calib,
          symbol: 'image://static/legend/calib.png'
        }, {
          type: 'scatter',
          data: this.bg,
          symbol: 'image://static/legend/calibrate_1.png'
        }, {
          type: 'scatter',
          data: this.transmtr,
          symbol: 'rect',
          symbolSize: 5,
          itemStyle: { normal: { color: '#00a107' } }
        }, {
          type: 'custom',
          data: this.sleepTime1,
          z: -1,
          renderItem: function renderItem(params, api) {
            var y = api.value(2);
            var start = api.coord([api.value(0), y]);
            var size = api.size([api.value(1) - api.value(0), y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },
          itemStyle: { normal: { color: 'rgba(170,170,170,0.2)' } }
        }]
      });
    },
    drawChart1_2: function drawChart1_2(id) {
      this[id] = __WEBPACK_IMPORTED_MODULE_1_echarts__["init"](document.getElementById(id));
      this[id].setOption({
        title: [{
          text: this.$t('basal') + ' ' + this.$t('basal_unit'),
          textStyle: this.textStyle,
          padding: this.titlePadding
        }, {
          text: this.$t('bolus') + ' ' + this.$t('ins_unit'),
          textStyle: this.textStyle,
          right: '18'
        }],
        xAxis: [{
          type: 'time',
          boundaryGap: false,
          min: new Date(this.timeSection[0] * 1000),
          max: new Date(this.timeSection[1] * 1000),
          interlval: 0,
          axisLabel: { show: false },
          axisLine: { lineStyle: { color: '#ccc' } },
          splitNumber: 24
        }],
        yAxis: [{
          type: 'value',
          boundaryGap: false,
          min: 0,
          max: this.basalMax,
          axisTick: { length: 0 },
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } }
        }, {
          type: 'value',
          boundaryGap: false,
          min: 0,
          max: this.bolusMax,
          axisTick: { length: 0 },
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          splitLine: { show: false }
        }],
        grid: this.grid,
        series: [{
          type: 'line',
          data: this.DataBasal,

          itemStyle: { normal: { color: '#00ff40' } },
          symbolSize: 2
        }, {
          type: 'line',
          data: this.basal_suspend,
          itemStyle: { normal: { color: '#ff0000' } },
          lineStyle: { normal: { type: 'dashed' } },
          symbolSize: 1
        }, {
          type: 'line',
          data: this.tempBasal,
          itemStyle: { normal: { color: '#00ff40' } },
          lineStyle: { normal: { type: 'dashed' } },
          symbolSize: 1
        }, {
          type: 'line',
          data: this.basal_suspend2,
          itemStyle: { normal: { color: '#ff0000' } },
          symbolSize: 1
        }, {
          type: 'scatter',
          data: this.newBasal,
          symbol: 'image://static/legend/new Patch.png',
          symbolSize: 10
        }, {
          type: 'scatter',
          data: this.stopBasal,
          symbol: 'image://static/legend/patch Deactivated.png',
          symbolSize: 8
        }, {
          type: 'scatter',
          data: this.pump_alarm,
          symbol: 'image://static/legend/Alert.png',
          symbolSize: 13
        }, {
          type: 'bar',
          data: this.DataBolus,
          yAxisIndex: 1,
          itemStyle: { normal: { color: '#182f82' } },
          barWidth: '4'
        }, {
          type: 'custom',
          data: this.extend_bolus,
          yAxisIndex: 1,
          renderItem: function renderItem(params, api) {
            var y = api.value(2);
            var start = api.coord([api.value(0), y]);
            var size = api.size([api.value(1) - api.value(0), y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },
          itemStyle: { normal: { color: '#ffe3ef' }, emphasis: { color: '#f00' } }
        }, {
          type: 'custom',
          data: this.sleepTime2,
          z: -1,
          renderItem: function renderItem(params, api) {
            var y = api.value(2);
            var start = api.coord([api.value(0), y]);
            var size = api.size([api.value(1) - api.value(0), y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },
          itemStyle: { normal: { color: 'rgba(170,170,170,0.2)' }, emphasis: { show: false } }
        }, {
          type: 'custom',
          name: this.$t('t1222_autoModeBasal'),
          data: this.autoModeBasal,
          yAxisIndex: 0,
          renderItem: function renderItem(params, api) {
            var y = api.value(2);
            var start = api.coord([api.value(0), y]);
            var size = api.size([api.value(1) - api.value(0), y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },
          tooltip: { backgroundColor: '#333'
          },
          itemStyle: { normal: { color: '#00ff4c' }, emphasis: { color: '#00ff5c' } }
        }, {
          type: 'bar',
          name: this.$t('t1222_autoModeCorrBolus'),
          data: this.autoModeCorrBolus,
          yAxisIndex: 1,
          itemStyle: { normal: { color: '#182f82' } },
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {}
          },
          barWidth: '4'
        }]
      }, false, true);
    },
    drawChart1_3: function drawChart1_3(id) {
      var st_xaxis = this.timeSection[0] * 1000;
      this[id] = __WEBPACK_IMPORTED_MODULE_1_echarts__["init"](document.getElementById(id));
      this[id].setOption({
        title: [{
          text: this.$t('carbs') + ' (g)',
          textStyle: this.textStyle,
          left: this.titleLeft,
          padding: this.titlePadding
        }, {
          text: this.$t('exercise'),
          textStyle: this.textStyle,
          right: '22'
        }],
        xAxis: [{
          type: 'time',
          boundaryGap: false,
          min: new Date(this.timeSection[0] * 1000),
          max: new Date(this.timeSection[1] * 1000),
          axisLabel: {
            showMaxLabel: true,
            margin: 10, textStyle: { color: '#282828', baseline: 'middle' },
            formatter: function formatter(value, index) {
              index = (value - st_xaxis) / 3600000;
              var H = index;
              if (index < 24) {
                if (index % 3 === 0) {
                  H = H < 10 ? '0' + H + ':00' : H + ':00';
                  return H;
                } else {
                  return ' ';
                }
              } else {
                return '24:00';
              }
            }
          },
          axisLine: { lineStyle: { color: '#ccc' } },
          splitNumber: 24
        }],
        yAxis: [{
          type: 'value',
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          min: 0,
          max: this.carbMax,
          boundaryGap: false,
          splitLine: { show: true },
          axisTick: { length: 0 }
        }, {
          data: this.sgRange[4],
          boundaryGap: false,
          axisTick: { length: 0 },
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } }
        }],
        grid: this.grid,
        series: [{
          type: 'custom',
          data: this.sleepTime3,
          z: -1,
          renderItem: function renderItem(params, api) {
            var y = api.value(2);
            var start = api.coord([api.value(0), y]);
            var size = api.size([api.value(1) - api.value(0), y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },
          itemStyle: { normal: { color: 'rgba(170,170,170,0.2)' } }
        }, {
          type: 'custom',
          data: this.exercise,
          renderItem: function renderItem(params, api) {
            var y = api.value(2);
            var start = api.coord([api.value(0), y]);
            var size = api.size([api.value(1) - api.value(0), y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },
          itemStyle: { normal: { color: '#a1d9fd' }, emphasis: { color: '#a1d9fd' } }
        }, {
          type: 'scatter',
          data: this.carb,
          symbol: 'rect',
          symbolSize: 8,
          itemStyle: { normal: { color: '#00ff4c' }, emphasis: { color: '#00ff4c' } }
        }, {
          type: 'scatter',
          name: this.$t('t1222_autoSnack'),
          data: this.autoSnack,
          symbol: 'image://static/legend/automode/零食.png',
          symbolSize: [29, 18],
          symbolOffset: [0, -10],
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate5(date);

              return time[0] + ':' + time[1] + ', Snack';
            }
          }
        }, {
          type: 'scatter',
          name: this.$t('t1222_autoBreakfast'),
          data: this.autoBreakfast,
          symbol: 'image://static/legend/automode/早餐.png',
          symbolSize: [29, 18],
          symbolOffset: [0, -10],
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', Breakfast';
            }
          }
        }, {
          type: 'scatter',
          name: this.$t('t1222_autoLunch'),
          data: this.autoLunch,
          symbol: 'image://static/legend/automode/中餐.png',
          symbolSize: [29, 18],
          symbolOffset: [0, -10],
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', Lunch';
            }
          }
        }, {
          type: 'scatter',
          name: this.$t('t1222_autoDinner'),
          data: this.autoDinner,
          symbol: 'image://static/legend/automode/晚餐.png',
          symbolSize: [29, 18],
          symbolOffset: [0, -10],
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', Dinner';
            }
          }
        }, {
          type: 'scatter',
          name: this.$t('t1222_autoExercise'),
          data: this.autoExercise,
          symbol: 'image://static/legend/automode/运动[30059].png',
          symbolSize: [29, 18],
          symbolOffset: [0, -10],
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate5(date);

              return time[0] + ':' + time[1] + ', Exercise';
            }
          }
        }]
      }, false, true);
    },
    drawCharts: function drawCharts(i) {
      this.drawChart1_1(this.id11[i]);
      this.drawChart1_2(this.id12[i]);
      this.drawChart1_3(this.id13[i]);
    },
    chartsDispose: function chartsDispose() {
      this.chart1_3.dispose();
    },
    getStatisticsQuick: function getStatisticsQuick(report_data, i) {
      console.log('getStatisticsQuick:', report_data, i);
      var data = report_data;
      data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
      this.statics = data;
      this.devices[i] = data.devices ? data.devices[0] : ['--', '--', '--'];

      this.hb1c = data.hba1cList ? data.hba1cList : this.hb1c;
      this.glucose[i] = data.glucose_stat ? data.glucose_stat[0] : [];
      this.insulin[i] = data.insulin_stat ? data.insulin_stat[0] : [];
      this.foodCoor[i] = this.insulin[i].carb_corr_bolus ? this.insulin[i].carb_corr_bolus.toFixed(2) : 0;
      this.events[i] = data.event_stat ? data.event_stat[0] : [];
    },
    getStatics: function getStatics(param, i) {
      this.$http.get('api/v2.1/report/' + this.uid + '/data/ds', { params: { param: param } }).then(function (res) {
        var err = res.body.error;
        if (err === 0) {
          var data = res.data.data;
          data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
          this.statics = data;
          this.devices[i] = data.devices ? data.devices[0] : ['--', '--', '--'];
          this.hb1c = data.hba1cList ? data.hba1cList : this.hb1c;
          this.glucose[i] = data.glucose_stat ? data.glucose_stat[0] : [];
          this.insulin[i] = data.insulin_stat ? data.insulin_stat[0] : [];
          this.foodCoor[i] = this.insulin[i].carb_corr_bolus ? this.insulin[i].carb_corr_bolus.toFixed(2) : 0;
          this.events[i] = data.event_stat ? data.event_stat[0] : [];
        }
      }, function (err) {
        var tip = this.$t('tryAgain');
        this.$message.error(tip);
      });
    },
    printPdf: function printPdf() {
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].print_page();
    }
  },
  mounted: function mounted() {
    self.document.title = this.$t('dailyReport');
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isEs = lang === 'es' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isSw = lang === 'sw' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    this.sgMax = this.isMg ? 400 : 25;
    this.glucose_unit = this.isMg ? 'mg/dL' : 'mmol/L';
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }
    this.qst1 = parseInt(sessionStorage.getItem('qst1'));
    this.qet1 = parseInt(sessionStorage.getItem('qet1'));
    this.dayNum1 = parseInt((this.qet1 - this.qst1) / 86400) + 1;
    console.log(this.dayNum1);
    for (var i = 0; i < this.dayNum1; i++) {
      this.st = this.qst1 + i * 86400;
      this.day1[i] = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate2(this.st);
      this.id11[i] = 'chart1_1' + i;
      this.id12[i] = 'chart1_2' + i;
      this.id13[i] = 'chart1_3' + i;
      this.ts = [[this.st, this.st + 86400]];
      var param = {
        ts: this.ts,
        tz: parseInt(sessionStorage.getItem('tz')),
        gu: this.isMg ? 'mg/dL' : 'mmol/L'
      };

      param = __WEBPACK_IMPORTED_MODULE_4__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));

      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getDs(this, this.uid, param, i);
      var first = parseInt(sessionStorage.getItem('qFirst1'));
      if (first === 1) {
        __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].checkPrint(this, 2, 1);
      }
    }
  }
});

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_base64__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_format__ = __webpack_require__(8);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      uid: 0, et: 0, st: 0, time: '', isEn: false, foodCoor: '', unit: '', isMg: '', glucoseUnit: '', ts: [], hypo: 3.1, high: 10.0, low: 5.6, isDe: false, isIt: false,
      statics: {}, devices: ['--', '--', '--'], hb1c: ['--'], target: '', avg: '--', active: '--', seg: ['--', '--', '--', '--'], sd: '--', cv: '--',

      alerts: [], pagePos: [], perPage: [], chartEndPage: { show: false }

    };
  },

  methods: {
    getAlertReportInfo: function getAlertReportInfo(param) {
      this.$http.get('api/v2.1/report/' + this.uid + '/data/alert', { params: { param: param } }).then(function (res) {
        var err = res.body.error;
        if (err === 0) {
          var data = res.data.data;
          console.log('alert report:', res.data);
          data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
          this.statics = data;
          this.devices = data.devices ? data.devices : this.devices;
          if ('EasyPatch' == this.devices[0]) {
            document.getElementById('reportPdmTitle').innerHTML = 'APP';
          }
          this.hb1c = data.hba1cList ? data.hba1cList : this.hb1c;
        }
      }, function (err) {
        var tip = this.$t('tryAgain');
        this.$message.error(tip);
      });
    },
    getAlertTypeText: function getAlertTypeText(alertTypeValue) {
      var alertTypeSelect = parseInt(alertTypeValue);
      var alertType = '--';
      var AlertTypeTexts = [this.$t('PDM'), this.$t('Pump'), this.$t('CGM')];
      if (alertTypeSelect == NaN || alertTypeSelect < 1 || alertTypeSelect > 3) {} else {
        alertType = AlertTypeTexts[alertTypeSelect - 1];
      }

      return alertType;
    },
    procAlertData: function procAlertData(alerts) {
      var isEn = this.isEn;
      var that = this;
      var getAlertTypeTextFunc = this.getAlertTypeText;

      alerts = alerts.filter(function (e, i) {
        return e[1];
      });

      return alerts.map(function (e, i) {
        var item = [];

        item[0] = isEn ? __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate1(new Date(e[0] * 1000)) : __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formateDate(new Date(e[0] * 1000));

        var alert_sid = 'Alerts_' + e[1].replace(/ /g, '_');
        item[1] = that.$t(alert_sid);
        item[2] = e[2];
        item[3] = getAlertTypeTextFunc(e[3]);
        return item;
      });
    },
    getAlertData: function getAlertData() {
      this.ts = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getTs(this.st, this.et);


      var params = {
        st: this.st,
        et: this.et
      };
      this.$http.get('/api/v2.1/alerts/' + this.uid, { params: params }).then(function (res) {
        if (0 == res.data.error) {
          var alerts = this.procAlertData(res.data.alerts);
          if (alerts.length > 0) {
            this.alerts = alerts;
            this.haveData = true;
          } else {
            this.haveData = false;
          }
          console.log('alerts:', alerts);

          if (false) {
            var item = this.alerts.slice(0, 1)[0];
            console.log('alert test:', item);
            for (var i = 0; i < 100; i++) {
              var temp = item.slice(0, item.length);
              temp[1] = temp[1] + '#' + (i + 1);
              this.alerts.push(temp);
            }
            this.haveData = false;
          }

          var page_index = 0;
          var PER_PAGE1 = 22;
          var PER_PAGE2 = 26;
          while (page_index < this.alerts.length) {
            this.pagePos.push(page_index);
            if (1 == this.pagePos.length) {
              page_index += PER_PAGE1;
              this.perPage.push(PER_PAGE1);
            } else {
              page_index += PER_PAGE2;
              this.perPage.push(PER_PAGE2);
            }
          }
        }
      }, function (err) {});
    },
    printPdf: function printPdf() {
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].print_page();
    }
  },
  mounted: function mounted() {
    self.document.title = this.$t('Alerts Report');
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    this.glucoseUnit = this.isMg ? 'mg/dL' : 'mmol/L';
    this.unit = this.isMg ? ' mg/dL' : ' mmol/L';
    this.hypo = this.isMg ? 54 : 3.1;
    this.sgMax = this.isMg ? 400 : 25;

    var st = sessionStorage.getItem('qst1');
    var et = sessionStorage.getItem('qet1');
    this.st = parseInt(st);
    this.et = parseInt(et);
    this.ts = [[this.st, this.et + 86400]];
    var param = {
      ts: this.ts,
      tz: parseInt(sessionStorage.getItem('tz')),
      gu: this.isMg ? 'mg/dL' : 'mmol/L'
    };
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }

    param = __WEBPACK_IMPORTED_MODULE_3__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));
    this.getAlertReportInfo(param);

    this.time = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate2(this.st) + ' - ' + __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate2(this.et);

    this.getAlertData();
  }
});

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_format__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_base64__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_loading__ = __webpack_require__(77);








/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_loading__["a" /* loading */]],
  data: function data() {
    return {
      pringtPre: false,
      pump_device: '--',
      uid: 0, st: 0, et: 0, statics: {}, devices: ['--', '--', '--'], hb1c: ['--'], long: false, isDe: false, isIt: false, isPo: false, isFr: false,
      isDu: false, isCz: false,
      pagePos: [], perPage: [],
      chartEndPage: { show: false },

      sg: [], basal: [], bolus: [], timeSection: [], staTime: '', endTime: '', isEn: false, isMg: '', ts: [], trans: [],
      mealTime1: [[10, 10, 10], [10, 10, 10], [10, 10, 10], [10, 10, 10], [10, 10, 10], [10, 10, 10], [10, 10, 10]],
      mealTime2: [[10, 10, 10], [10, 10, 10], [10, 10, 10], [10, 10, 10], [10, 10, 10], [10, 10, 10], [10, 10, 10]],
      mealTime3: [[10, 10, 10], [10, 10, 10], [10, 10, 10], [10, 10, 10], [10, 10, 10], [10, 10, 10], [10, 10, 10]], NewBasal: [],
      sensor_alarm: [], pump_alarm: [], carb: [], exercise: [], calib: [], bg: [], basalMax: 5, bolusMax: 5,
      extend_bolus: [[10, 10, 10, 10, 10], [10, 10, 10, 10, 10], [10, 10, 10, 10, 10], [10, 10, 10, 10, 10], [10, 10, 10, 10, 10], [10, 10, 10, 10, 10], [10, 10, 10, 10, 10]],
      basal_suspend: [], stopBasal: [], manualStop: [], tempBasal: [],
      sgChart0: null, sgChart1: null, sgChart2: null, sgChart3: null, sgChart4: null,
      sgChart5: null, sgChart6: null, sgChart7: null, sgChart8: null, sgChart9: null,
      sgChart10: null, sgChart11: null, sgChart12: null, sgChart13: null,
      baChart0: null, baChart1: null, baChart2: null, baChart3: null, baChart4: null,
      baChart5: null, baChart6: null, baChart7: null, baChart8: null, baChart9: null,
      baChart10: null, baChart11: null, baChart12: null, baChart13: null,
      chart2: null, dayNum: 7,
      autoModeBasal: [],
      autoModeCorrBolus: [],
      autoBreakfast: [],
      autoLunch: [],
      autoDinner: [],
      autoSnack: [],
      sgMax: 20, titleText: '',
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      pickerOptions2: {
        disabledDate: function disabledDate(time) {
          var flag1 = time.getTime() > Date.now(),
              flag2 = true;
          return flag1;
        }
      },
      date: [],
      textStyle: {
        color: '#282828',
        fontWeight: 'normal',
        fontSize: '12',
        fontFamily: 'SFUIText-Regular'
      },
      titlePadding: [12, 0, 0, 35],
      grid2: { x: '10%', y: '5%', width: '83%', height: '60%' },
      yAxisLabel: { interval: 0, margin: 5, textStyle: { color: '#282828', baseline: 'middle' }, showMinLabel: false },
      yAxisLabel2: { show: false }
    };
  },

  computed: {
    DataD: function DataD() {
      return this.$store.state.DataD;
    },
    DataSG: function DataSG() {
      return this.$store.state.DataSG;
    },
    DataBasal: function DataBasal() {
      return this.$store.state.DataBasal;
    },
    DataBolus: function DataBolus() {
      return this.$store.state.DataBolus;
    }
  },
  methods: {
    drawSgChart: function drawSgChart(id, i) {
      var that = this;
      this[id] = __WEBPACK_IMPORTED_MODULE_1_echarts__["init"](document.getElementById(id));
      this.registLoading(id, this[id]);
      this[id].setOption({
        title: {
          text: this.titleText,
          textStyle: this.textStyle,
          padding: this.titlePadding
        },
        xAxis: [{
          type: 'time',
          boundaryGap: false,
          min: new Date(this.timeSection[i][0] * 1000),
          max: new Date(this.timeSection[i][1] * 1000),
          axisLabel: { show: false },
          axisLine: { lineStyle: { color: '#ccc' } },
          interval: 3600 * 3000
        }],
        yAxis: [{
          type: 'value',
          min: 0,
          max: this.sgMax,
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          boundaryGap: false,
          splitLine: { show: true },
          axisTick: { length: 0 }
        }],
        grid: this.grid2,
        animation: false,
        series: [{
          type: 'scatter',
          data: this.sg[i],
          markArea: {
            data: [[{ yAxis: this.isMg ? this.DataD.target_low * 18 : this.DataD.target_low }, { yAxis: this.isMg ? this.DataD.target_high * 18 : this.DataD.target_high }]],
            tooltip: { show: false },
            itemStyle: {
              normal: {
                color: 'rgba(211,255,213,0.6)'
              }
            }
          },
          markLine: {
            data: [{ yAxis: this.isMg ? this.DataD.hypo * 18 : this.DataD.hypo }],
            symbol: ['circle', 'circle'],
            symbolSize: 1,
            silent: true,
            lineStyle: { normal: { color: 'rgba(255,0,0,0.5)', type: 'solid' } },
            label: { normal: { show: false } }
          },
          itemStyle: { normal: {
              color: function color(params) {
                var color = '#2cd200';
                if (params.value[1] < 0.1 && params.value[2] === 'H') {
                  color = '#666';
                } else {
                  if (that.isMg) {
                    if (params.value[1] > that.DataD.target_high * 18) {
                      color = '#e6be00';
                    }
                    if (params.value[1] < that.DataD.target_low * 18) {
                      color = '#ff5c5c';
                    }
                  } else {
                    if (params.value[1] > that.DataD.target_high) {
                      color = '#e6be00';
                    }
                    if (params.value[1] < that.DataD.target_low) {
                      color = '#ff5c5c';
                    }
                  }
                }
                var type = params.value[2];
                if (type === 'NC' && params.value[1] === 0 || type === 'DE' || type === 'CE0' || type === 'CE1') {
                  color = 'transparent';
                }
                return color;
              }
            } },
          symbolSize: 2
        }, {
          type: 'scatter',
          data: this.trans[i],
          symbol: 'rect',
          symbolSize: 5,
          itemStyle: { normal: { color: '#00a107' } },
          tooltip: { backgroundColor: '#333',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate5(date);
              return time[0] + ':' + time[1] + ', ' + 'New Sensor';
            }
          }
        }, {
          type: 'scatter',
          data: this.calib[i],
          symbol: 'image://static/legend/calib.png'
        }, {
          type: 'scatter',
          data: this.bg[i],
          symbol: 'image://static/legend/calibrate_1.png'
        }, {
          type: 'custom',
          data: this.mealTime1,
          z: -1,
          renderItem: function renderItem(params, api) {
            var y = api.value(2);
            var start = api.coord([api.value(0), y]);
            var size = api.size([api.value(1) - api.value(0), y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },
          itemStyle: { normal: { color: 'rgba(170,170,170,0.15)' } }
        }, {
          type: 'custom',
          data: this.mealTime2,
          z: -1,
          renderItem: function renderItem(params, api) {
            var y = api.value(2);
            var start = api.coord([api.value(0), y]);
            var size = api.size([api.value(1) - api.value(0), y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },
          itemStyle: { normal: { color: 'rgba(170,170,170,0.15)' } }
        }, {
          type: 'custom',
          data: this.mealTime3,
          z: -1,
          renderItem: function renderItem(params, api) {
            var y = api.value(2);
            var start = api.coord([api.value(0), y]);
            var size = api.size([api.value(1) - api.value(0), y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },
          itemStyle: { normal: { color: 'rgba(170,170,170,0.15)' } }
        }]
      }, false, true);
    },
    drawBasalChart: function drawBasalChart(id, i) {
      var that = this;
      this[id] = __WEBPACK_IMPORTED_MODULE_1_echarts__["init"](document.getElementById(id));
      this[id].setOption({
        title: [{
          text: this.$t('basal') + ' ' + this.$t('basal_unit'),
          textStyle: this.textStyle,
          padding: this.titlePadding
        }, {
          text: this.$t('bolus') + ' ' + this.$t('ins_unit'),
          textStyle: this.textStyle,
          right: '17',
          top: '7'
        }],
        xAxis: [{
          type: 'time',
          boundaryGap: false,
          min: new Date(this.timeSection[i][0] * 1000),
          max: new Date(this.timeSection[i][1] * 1000),

          splitNumber: 8,
          axisLabel: {
            showMaxLabel: true,
            interval: 0, margin: 12, textStyle: { color: '#282828', baseline: 'middle' },
            formatter: function formatter(value, index) {
              index = (value - that.timeSection[i][0] * 1000) / (3600000 * 3);
              var H = index * 3;

              if (H < 24) {
                if (H % 3 === 0) {
                  H = H < 10 ? '0' + H + ':00' : H + ':00';
                  return H;
                } else {
                  return ' ';
                }
              } else {
                return '24:00';
              }
            }
          },
          axisLine: { lineStyle: { color: '#ccc' } }
        }],
        yAxis: [{
          type: 'value',
          boundaryGap: false,
          min: 0,
          max: this.basalMax,
          splitLine: { show: true },
          axisTick: { length: 0 },
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } }
        }, {
          type: 'value',
          boundaryGap: false,
          min: 0,
          max: this.bolusMax,
          axisTick: { length: 0 },
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } }
        }],
        grid: this.grid2,
        animation: false,
        series: [{
          type: 'line',
          data: this.basal[i],

          itemStyle: { normal: { color: '#00ff40' } },
          symbolSize: 2
        }, {
          type: 'line',
          data: this.basal_suspend[i],
          itemStyle: { normal: { color: '#ff0000' } },
          lineStyle: { normal: { type: 'dashed' } },
          symbolSize: 1
        }, {
          type: 'line',
          data: this.tempBasal[i],
          itemStyle: { normal: { color: '#00ff40' } },
          lineStyle: { normal: { type: 'dashed' } },
          symbolSize: 1
        }, {
          type: 'line',
          data: this.manualStop[i],
          itemStyle: { normal: { color: '#ff0000' } },
          symbolSize: 1
        }, {
          type: 'scatter',
          data: this.stopBasal[i],
          symbol: 'image://static/legend/patch Deactivated.png',
          symbolSize: 8
        }, {
          type: 'scatter',
          data: this.NewBasal[i],
          symbol: 'image://static/legend/new Patch.png',
          symbolSize: 10
        }, {
          type: 'bar',
          data: this.bolus[i],
          yAxisIndex: 1,
          itemStyle: { normal: { color: '#182f82' } },
          barWidth: '4'
        }, {
          type: 'custom',
          data: this.extend_bolus[i],
          yAxisIndex: 1,
          renderItem: function renderItem(params, api) {
            var y = api.value(2);
            var start = api.coord([api.value(0), y]);
            var size = api.size([api.value(1) - api.value(0), y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },
          itemStyle: { normal: { color: '#ffe3ef' }, emphasis: { color: '#f00' } }
        }, {
          type: 'custom',
          name: this.$t('t1222_autoModeBasal'),
          data: this.autoModeBasal[i],
          yAxisIndex: 0,
          renderItem: function renderItem(params, api) {
            var y = api.value(2);
            var start = api.coord([api.value(0), y]);
            var size = api.size([api.value(1) - api.value(0), y]);
            var style = api.style();
            return {
              type: 'rect',
              shape: {
                x: start[0],
                y: start[1],
                width: size[0],
                height: size[1]
              },
              style: style
            };
          },

          itemStyle: { normal: { color: '#00ff4c' }, emphasis: { color: '#00ff5c' } }
        }, {
          type: 'bar',
          name: this.$t('t1222_autoModeCorrBolus'),
          data: this.autoModeCorrBolus[i],
          yAxisIndex: 1,
          itemStyle: { normal: { color: '#182f82' } },

          barWidth: '4'
        }]
      }, false, true);
    },
    drawCharts2: function drawCharts2() {
      var that = this;
      this.date.map(function (e, i) {
        var id1 = 'sgChart' + i;
        var id2 = 'baChart' + i;
        that.drawSgChart(id1, i);
        that.drawBasalChart(id2, i);
      });
      var timer = setTimeout(this.makeCarb, 1000);
    },
    chartsDispose2: function chartsDispose2() {
      var dayNum = parseInt(sessionStorage.getItem('dayNum'));
      for (var i = 0; i < dayNum; i++) {
        var id1 = 'sgChart' + i;
        var id2 = 'baChart' + i;
        this[id1].dispose();
        this[id2].dispose();
      }
      sessionStorage.setItem('dayNum', this.dayNum);
    },
    makeCarb: function makeCarb() {
      var carbs = this.carb;
      var time = this.timeSection;
      for (var i = 0; i < carbs.length; i++) {
        if (carbs[i].length > 0) {
          for (var j = 0; j < carbs[i].length; j++) {
            var t1 = 0;
            var w = 0;
            t1 = carbs[i][j][0] - time[i][0];
            w = (t1 / 864).toFixed(1) + '%';
            var id = 'carb' + i;
            var OBJ = document.getElementById(id);
            var label = OBJ.getElementsByTagName('label');
            label[j].style.zIndex = 100 + i + j;
            label[j].style.left = w;
          }
        }
      }

      var className = ['breakfast', 'lunch', 'dinner', 'snack'];
      var autoMeal = [this.autoBreakfast, this.autoLunch, this.autoDinner, this.autoSnack];

      for (var _i = 0; _i < className.length; _i++) {

        for (var d = 0; d < autoMeal[_i].length; d++) {
          for (var _j = 0; _j < autoMeal[_i][d].length; _j++) {
            var _t = 0;
            var _w = 0;
            _t = autoMeal[_i][d][_j][0] - time[d][0];
            _w = (_t / 864).toFixed(1) + '%';
            var _id = 'carb' + d;
            var _OBJ = document.getElementById(_id);
            var _label = _OBJ.getElementsByClassName(className[_i]);
            console.log('autoMeal:', _OBJ, _label, className[_i]);
            this.pringtPre = true;
            _label[_j].style.zIndex = 100 + d + _j;
            _label[_j].style.left = _w;
          }
        }
      }
    },
    getDate: function getDate() {
      for (var i = 0; i < this.dayNum; i++) {
        var day = this.st + i * 86400;
        var time = this.isEn ? __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate4(day) : __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate3(day);
        var weeks = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDay(this, day);
        this.date[i] = time + ' ' + weeks;
      }
      this.staTime = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate2(this.st);
      this.endTime = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate2(this.et);
    },
    getDdReportInfo: function getDdReportInfo(report_data) {
      var data = report_data;
      data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
      this.statics = data;
      this.devices = data.devices ? data.devices : this.devices;
      if ('EasyPatch' == this.devices[0]) {
        document.getElementById('reportPdmTitle').innerHTML = 'APP';
      }
      this.hb1c = data.hba1c ? data.hba1c : this.hb1c;
    },
    getStatics: function getStatics(param) {
      this.$http.get('api/v2.1/report/' + this.uid + '/data/dd', { params: { param: param } }).then(function (res) {
        var err = res.body.error;
        if (err === 0) {
          var data = res.data.data;
          data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
          this.statics = data;
          this.devices = data.devices ? data.devices : this.devices;
          this.hb1c = data.hba1c ? data.hba1c : this.hb1c;
        }
      }, function (err) {
        var tip = this.$t('tryAgain');
        this.$message.error(tip);
      });
    },
    openFullScreen: function openFullScreen() {
      var _this = this;

      this.loading = true;
      setTimeout(function () {
        _this.loading = false;
      }, 4000);
    },
    printPdf: function printPdf() {
      if (this.pringtPre === false) {
        this.$message({
          type: 'info',
          message: '数据加载中，请稍候再打印'
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].print_page();
      }
    }
  },
  mounted: function mounted() {
    self.document.title = this.$t('dayBydayRe');
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    this.grid2.height = lang === 'fr' ? '55%' : '60%';
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    this.titleText = this.isMg ? this.$t('SG') + ' (mg/dL)' : this.$t('SG') + ' (mmol/L)';
    this.sgMax = this.isMg ? 400 : 25;
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }

    this.st = parseInt(sessionStorage.getItem('qst2'));
    this.et = parseInt(sessionStorage.getItem('qet2'));
    this.dayNum = parseInt((this.et - this.st) / 86400) + 1;
    if (this.dayNum > 9) {
      this.long = true;
    }

    var page_index = 0;
    var PER_PAGE1 = 9;
    var PER_PAGE2 = 9;

    while (page_index < this.dayNum) {
      this.pagePos.push(page_index);
      if (1 == this.pagePos.length) {
        page_index += PER_PAGE1;
        this.perPage.push(PER_PAGE1);
      } else {
        page_index += PER_PAGE2;
        this.perPage.push(PER_PAGE2);
      }
    }
    var chartNum = this.dayNum;
    if (chartNum > 6 && chartNum <= 9) {
      this.chartEndPage.show = true;
    }
    console.log('pagePos:', this.pagePos, chartNum, this.chartEndPage.show);

    this.ts = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getTs(this.st, this.et);
    var param = {
      ts: this.ts,
      tz: parseInt(sessionStorage.getItem('tz')),
      gu: this.isEn ? 'mg/dL' : 'mmol/L'
    };
    param = __WEBPACK_IMPORTED_MODULE_4__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));

    __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getDd(this, this.uid, param);
    this.getDate();

    var first = parseInt(sessionStorage.getItem('qFirst2'));
    if (first === 1) {
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].checkPrint(this, 3, 2);
    }
  }
});

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_format__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_base64__ = __webpack_require__(9);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      statics: {}, devices: ['--', '--', '--'], hb1c: ['--'], isMg: '', ts: [], avg: [],
      glucose: [[], [], [], [], [], [], [], []],
      chartWidth: '', timer: false, typeChooseVisible: false, value1: '', isC: false, flag: 0, count: 0, sta: '', end: '', Average: [],
      chart3_1: null, startDate: '', timeRange3: '', defaultDate: '', whichDay: ' Everyday', weekmode: 'yyyyyyy',
      legendDate: ['', '', '', '', '', '', ''], Kday: [], DataSG: [], calib: [], bg: [], isEn: false, isFr: false,
      show: { A: false, B: false, C: false, D: false, E: false, F: false, G: false },
      uid: 0, st: 0, et: 0, startTine: 1505836800000, loading: true, glucoseLength: 7, date: [], isDe: false, isIt: false,
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      textStyle: {
        color: '#282828',
        fontWeight: 'normal',
        fontSize: '14',
        fontFamily: 'SFUIText-Regular'
      },
      titlePadding: [0, 0, 8, 33],
      grid: { x: '3%', y: '4%', width: '94.5%', height: '89%' },
      yAxisLabel: { interval: 0, margin: 5, textStyle: { color: '#282828', baseline: 'middle' }, showMinLabel: false }
    };
  },

  computed: {
    DataS: function DataS() {
      return this.$store.state.DataS;
    }
  },
  methods: {
    drawChart3_1: function drawChart3_1() {
      var that = this;
      self.document.title = this.$t('sensorOlRe');
      this.chart3_1 = __WEBPACK_IMPORTED_MODULE_1_echarts__["init"](document.getElementById('chart3_1'));
      this.chart3_1.setOption({
        title: {
          text: this.isMg ? this.$t('SG') + ' (mg/dL)' : this.$t('SG') + ' (mmol/L)',
          textStyle: this.textStyle,
          padding: this.titlePadding
        },
        xAxis: [{
          type: 'time',
          boundaryGap: false,
          min: new Date(this.startTime),
          max: new Date(this.startTime + 8.64e7),
          axisLine: { lineStyle: { color: '#ccc' } },
          splitNumber: 24,
          splieLine: { show: true },
          axisLabel: {
            showMaxLabel: true,
            margin: 15, textStyle: { color: '#282828', baseline: 'middle' },
            formatter: function formatter(value, index) {
              index = (value - that.startTime) / 3600000;
              var H = index;
              if (index < 24) {
                if (index % 3 === 0) {
                  H = H < 10 ? '0' + H + ':00' : H + ':00';
                  return H;
                } else {
                  return ' ';
                }
              } else {
                return '24:00';
              }
            }
          }
        }],
        yAxis: [{
          type: 'value',
          min: 0, max: this.isMg ? 400 : 25,
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          boundaryGap: false,
          axisTick: { length: 0 }
        }],
        grid: this.grid,
        animation: false,
        series: [{
          type: 'scatter',
          data: this.DataSG[0],
          markArea: {
            data: [[{ yAxis: this.isMg ? this.DataS.target_low * 18 : this.DataS.target_low }, { yAxis: this.isMg ? this.DataS.target_high * 18 : this.DataS.target_high }]],
            silent: true,
            itemStyle: { normal: { color: 'rgba(211,255,213,0.6)' } }
          },
          markLine: {
            data: [{ yAxis: this.isMg ? this.DataS.hypo * 18 : this.DataS.hypo }],
            symbol: ['circle', 'circle'],
            symbolSize: 1,
            silent: true,
            lineStyle: { normal: {
                color: 'rgba(255,0,0,0.5)',
                type: 'solid'
              } },
            label: { normal: { show: false } }
          },
          itemStyle: { normal: { color: '#3ce8dc' } },
          symbolSize: 3
        }, {
          type: 'scatter',
          data: this.DataSG[1],
          itemStyle: { normal: { color: '#2842d2' } },
          symbolSize: 3
        }, {
          type: 'scatter',
          data: this.DataSG[2],
          itemStyle: { normal: { color: '#79bd39' } },
          symbolSize: 3
        }, {
          type: 'scatter',
          data: this.DataSG[3],
          itemStyle: { normal: { color: '#dce573' } },
          symbolSize: 3
        }, {
          type: 'scatter',
          data: this.DataSG[4],
          itemStyle: { normal: { color: '#e61795' } },
          symbolSize: 3
        }, {
          type: 'scatter',
          data: this.DataSG[5],
          itemStyle: { normal: { color: '#c9711e' } },
          symbolSize: 3
        }, {
          type: 'scatter',
          data: this.DataSG[6],
          itemStyle: { normal: { color: '#a922d9' } },
          symbolSize: 3
        }, {
          type: 'scatter',
          data: this.avg,
          itemStyle: { normal: { color: '#464646' } },
          tooltip: { backgroundColor: '#777',
            formatter: function formatter(params) {
              var date = params.value[0];
              var time = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate5(date);
              if (params.value[1] > 0) {
                if (params.value[2] === 'CX') {
                  return time[0] + ':' + time[1] + ', ' + params.value[1] + '<hr style="width: 17px;background:#000;height:1px;border:none;margin-left: 42px;">';
                }
                return time[0] + ':' + time[1] + ', ' + params.value[1];
              } else {
                if (params.value[2] === 'NC') {
                  return time[0] + ':' + time[1] + ', Not Calibrated';
                }
                if (params.value[2] === 'DE') {
                  return time[0] + ':' + time[1] + ', No Readings';
                }
                if (params.value[2] === 'CE0' || params.value[2] === 'CE1') {
                  return time[0] + ':' + time[1] + ',Calib Error';
                }
                return time[0] + ':' + time[1] + ', warm up';
              }
            },
            textStyle: { color: '#fff' }
          },
          symbolSize: 3
        }, {
          type: 'scatter',
          data: this.calib,
          symbol: 'image://static/legend/calib.png'
        }, {
          type: 'scatter',
          data: this.bg,
          symbol: 'image://static/legend/calibrate_1.png'
        }]
      }, false, true);
    },
    checkLegend: function checkLegend() {
      var legendTime = this.DataSG;
      this.legendDate = ['', '', '', '', '', '', ''];
      this.show = { A: false, B: false, C: false, D: false, E: false, F: false, G: false };
      for (var i = 0; i < legendTime.length; i++) {
        if (legendTime[i]) {
          var time = legendTime[i][0][0];
          time = new Date(time);
          var y1 = time.getFullYear();
          var m1 = time.getMonth() + 1;
          var d1 = time.getDate();
          d1 = d1 + this.Kday[i];
          if ((m1 === 1 || m1 === 3 || m1 === 5 || m1 === 7 || m1 === 8 || m1 === 10 || m1 === 12) && d1 > 31) {
            d1 = d1 - 31;
            m1 = m1 + 1;
          }
          if ((m1 === 4 || m1 === 6 || m1 === 9 || m1 === 11) && d1 > 30) {
            d1 = d1 - 30;
            m1 = m1 + 1;
          }
          if (m1 === 2 && d1 > 29) {
            d1 = d1 - 29;
            m1 = m1 + 1;
          }
          if (m1 > 12) {
            m1 = m1 - 12;
            y1 = y1 + 1;
          }
          m1 = m1 < 10 ? '0' + m1 : m1;
          d1 = d1 < 10 ? '0' + d1 : d1;

          this.legendDate[i] = d1 + '-' + m1 + '-' + y1;
        }
      }
      if (this.legendDate[0] !== '') {
        this.show.A = true;
      }
      if (this.legendDate[1] !== '') {
        this.show.B = true;
      }
      if (this.legendDate[2] !== '') {
        this.show.C = true;
      }
      if (this.legendDate[3] !== '') {
        this.show.D = true;
      }
      if (this.legendDate[4] !== '') {
        this.show.E = true;
      }
      if (this.legendDate[5] !== '') {
        this.show.F = true;
      }
      if (this.legendDate[6] !== '') {
        this.show.G = true;
      }

      var length = this.ts.length;
      this.glucoseLength = length;
      for (var _i = 0; _i < length; _i++) {
        var t = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate9(this.ts[_i][0]);
        t[1] = t[1] + 1;
        t[1] = t[1] < 10 ? '0' + t[1] : t[1];
        t[2] = t[2] < 10 ? '0' + t[2] : t[2];
        this.date[_i] = t[2] + '-' + t[1] + '-' + t[0];
      }
    },
    getOlReportInfo: function getOlReportInfo(report_data) {
      var data = report_data;
      data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
      this.statics = data;
      this.devices = data.devices ? data.devices : this.devices;
      if ('EasyPatch' == this.devices[0]) {
        document.getElementById('reportPdmTitle').innerHTML = 'APP';
      }
      this.hb1c = data.hba1c ? data.hba1c : this.hb1c;
      this.glucose = data.sg_stat ? data.sg_stat : this.glucose;
    },
    getStatics: function getStatics(param) {
      this.$http.get('api/v2.1/report/' + this.uid + '/data/ol', { params: { param: param } }).then(function (res) {
        var err = res.body.error;
        if (err === 0) {
          var data = res.data.data;
          data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
          this.statics = data;
          this.devices = data.devices ? data.devices : this.devices;
          this.hb1c = data.hba1c ? data.hba1c : this.hb1c;
          this.glucose = data.sg_stat ? data.sg_stat : this.glucose;
        }
      }, function (err) {
        var tip = this.$t('tryAgain');
        this.$message.error(tip);
      });
    },
    openFullScreen: function openFullScreen() {
      var _this = this;

      this.loading = true;
      setTimeout(function () {
        _this.loading = false;
      }, 3000);
    },
    getAverage: function getAverage(SG) {
      var length = SG.length;
      var average = new Array(720);
      for (var j = 0; j < 720; j++) {
        average[j] = new Array(2);
        average[j][0] = parseInt(this.startTime / 1000) + j * 120;
        average[j][1] = 0;
        var num = 0;
        for (var i = 0; i < length; i++) {
          for (var k = 0; k < 720; k++) {
            if (SG[i][k]) {
              var t = SG[i][k][0].getTime() / 1000;
              var mt = t - average[j][0];
              if (mt <= 120 && mt >= 0) {
                average[j][1] = average[j][1] + SG[i][k][1];
                num++;
              }
            }
          }
        }
        average[j][0] = new Date(average[j][0] * 1000);
        average[j][1] = (average[j][1] / num).toFixed(1);
      }
      this.avg = average;
    },
    printPdf: function printPdf() {
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].print_page();
    }
  },
  mounted: function mounted() {
    this.openFullScreen();
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    this.et = parseInt(sessionStorage.getItem('qet3'));
    this.st = parseInt(sessionStorage.getItem('qst3'));
    this.weekmode = sessionStorage.getItem('qweekMode');
    this.timeRange3 = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate2(this.st) + ' - ' + __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate2(this.et);
    this.ts = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getTs2(this, this.st, this.et);
    var param = {
      ts: this.ts,
      tz: parseInt(sessionStorage.getItem('tz')),
      weekmode: this.weekmode,
      gu: this.isMg ? 'mg/dL' : 'mmol/L'
    };
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }
    param = __WEBPACK_IMPORTED_MODULE_4__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));

    __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getOl(this, this.uid, param);
    var first = parseInt(sessionStorage.getItem('qFirst3'));
    if (first === 1) {
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].checkPrint(this, 4, 3);
    }
  }
});

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_format__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_base64__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth_dataTool__ = __webpack_require__(231);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      statics: {}, devices: ['--', '--', '--'], hb1c: ['--'], isMg: '', interval: '', ts: [], isDe: false,
      styleText: '<style type="text/css" media="print">@page{size:landscape;margin:0;}</style>',
      glucose: [{
        "bg_avg": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }, {
        "bg_avg": '--',
        "bg_low_num": '--',
        "bg_num": '--',
        "bg_sd": '--',
        "sg_aucl": "--",
        "sg_aucu": "--",
        "sg_avg": "--",
        "sg_cv": "--",
        "sg_iqr": "--",
        "sg_lp": "--",
        "sg_lpr": "--",
        "sg_max": "--",
        "sg_median": "--",
        "sg_min": "--",
        "sg_mpr": "--",
        "sg_nl": "--",
        "sg_nu": "--",
        "sg_q1": "--",
        "sg_q3": "--",
        "sg_sd": "--",
        "sg_sdr": "--",
        "sg_se": "--",
        "sg_spr": "--",
        "sg_tp": "--",
        "sg_up": "--"
      }],
      event: [{
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }, {
        "carb_gram": '--',
        "carb_num": '--',
        "exer_num": '--',
        "exer_time": '--',
        "ins_basal": '--',
        "ins_bolus": '--',
        "ins_bolus_avg": "--",
        "ins_bolus_n": '--',
        "ins_bolus_p": "--",
        "ins_total": '--',
        "other": "--"
      }],

      TaData1: [], TaData2: [], TaData3: [], xDate: [], xDate2: [], sgMax: 20, value2: '', value1: '', dayNum: 0, isEn: false,
      chartWidth: '', timer: false, typeChooseVisible: false, isC: false, flag: 0, count: 0, sta: '', end: '', Average: [],
      chart4_1: null, chart4_2: null,
      startDate: '', timeRange: '', defaultDate: '', whichDay: ' Everyday', weekmode: 'yyyyyyy', isIt: false,
      uid: 0, st: 0, et: 0, basalMax: 25, bgMax: 10, days: '',
      date: [true, true, true, true, true, true, true],
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      textStyle: {
        color: '#282828',
        fontWeight: 'normal',
        fontSize: '12',
        fontFamily: 'SFUIText-Regular'
      },
      titlePadding: [0, 0, 8, 33],
      grid: { x: '3.5%', y: '15%', width: '94%', height: '70%' },
      yAxisLabel: { interval: 0, margin: 5, textStyle: { color: '#282828', baseline: 'middle' }, showMinLabel: false },
      xLabel: ['18-07-2017', '19-07-2017', '20-07-2017', '21-07-2017', '22-07-2017', '23-07-2017', '24-07-2017', '25-07-2017', '26-07-2017', '27-07-2017', '28-07-2017', '29-07-2017', '30-07-2017', '31-07-2017']
    };
  },

  computed: {
    DataS: function DataS() {
      return this.$store.state.DataS;
    }
  },
  methods: {
    drawChart4_1: function drawChart4_1() {
      this.chart4_1 = __WEBPACK_IMPORTED_MODULE_1_echarts__["init"](document.getElementById('chart4_1'));
      this.chart4_1.setOption({
        title: {
          text: this.isMg ? this.$t('sensorGlu') + ' (mg/dL)' : this.$t('sensorGlu') + ' (mmol/L)',
          textStyle: this.textStyle,
          padding: this.titlePadding
        },
        xAxis: [{
          data: this.xDate,
          axisLine: { lineStyle: { color: '#ccc' } },
          splitLine: { show: true, interval: 0 },

          axisLabel: { margin: 15, interval: 0, textStyle: { color: '#282828', baseline: 'middle' } }
        }],
        yAxis: [{
          type: 'value',
          min: 0, max: this.isMg ? 400 : 25,
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          boundaryGap: false,
          axisTick: { length: 0 }
        }],
        grid: this.grid,
        series: [{
          type: 'boxplot',
          data: this.TaData3[1],
          hoverAnimation: false,
          boxWidth: ['10%', '15%'],
          itemStyle: { normal: { borderColor: '#0095ff' } }
        }, {
          name: 'line3',
          type: 'line',
          data: this.TaData3[0],
          itemStyle: { normal: {
              color: 'transparent',
              borderColor: '#0095ff',
              borderWidth: 1
            } },
          lineStyle: { normal: {
              color: '#e89b00',
              width: 1
            } },
          symbol: 'diamond',
          symbolSize: 5
        }]
      });
    },
    drawChart4_2: function drawChart4_2() {
      this.chart4_2 = __WEBPACK_IMPORTED_MODULE_1_echarts__["init"](document.getElementById('chart4_2'));
      this.chart4_2.setOption({
        title: {
          text: this.$t('insulin') + ' ' + this.$t('ins_unit'),
          textStyle: this.textStyle,
          padding: this.titlePadding
        },
        xAxis: [{
          data: this.xDate,
          axisLine: { lineStyle: { color: '#ccc' } },
          splitLine: { show: true, interval: 0 },
          splitNumber: 14,
          axisLabel: {
            margin: 15, interval: 0, textStyle: { color: '#282828', baseline: 'middle' }
          }
        }],
        yAxis: [{
          type: 'value',
          min: 0, max: this.basalMax,
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          boundaryGap: false,
          axisTick: { length: 0 }
        }],
        grid: this.grid,
        legend: {
          itemWidth: 11,
          itemHeight: 11,
          right: 35,
          data: [{ name: this.$t('basal'), icon: 'rect' }, { name: this.$t('bolus'), icon: 'rect' }]
        },
        series: [{
          name: this.$t('basal'),
          type: 'bar',
          data: this.TaData2[0],
          barWidth: '32%',
          itemStyle: { normal: { color: '#75e28a' } }
        }, {
          name: this.$t('bolus'),
          type: 'bar',
          data: this.TaData2[1],
          barWidth: '32%',
          itemStyle: { normal: { color: '#4e86f4' } }
        }]
      });
    },
    drwCharts: function drwCharts() {
      this.drawChart4_1();
      this.drawChart4_2();
    },
    chartsDispose: function chartsDispose() {
      this.chart4_1.dispose();
      this.chart4_2.dispose();
    },
    getStatics: function getStatics(param) {
      this.$http.get('api/v2.1/report/' + this.uid + '/data/ta', { params: { param: param } }).then(function (res) {
        var err = res.body.error;
        if (err === 0) {
          var data = res.data.data;
          data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
          this.statics = data;
          this.devices = data.devices ? data.devices : this.devices;
          if ('EasyPatch' == this.devices[0]) {
            document.getElementById('reportPdmTitle').innerHTML = 'APP';
          }
          this.hb1c = data.hba1c ? data.hba1c : this.hb1c;
          this.glucose = data.glucose_stat ? data.glucose_stat : this.glucose;
          this.glucose.map(function (e, i) {
            if (e.bg_up !== '--') {
              e.bg_up = e.bg_up.toFixed(1);
            }
            if (e.bg_tp !== '--') {
              e.bg_tp = e.bg_tp.toFixed(1);
            }
            if (e.bg_lp !== '--') {
              e.bg_lp = e.bg_lp.toFixed(1);
            }
          });
          this.dayNum = this.glucose.length - 1;
          this.event = data.insulin_and_event_stat ? data.insulin_and_event_stat : this.event;
        }
      }, function (err) {
        context.$message.error('Try again!');
      });
    },
    getTaReportInfo: function getTaReportInfo(report_data) {
      var data = report_data;
      data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
      this.statics = data;
      this.devices = data.devices ? data.devices : this.devices;
      this.hb1c = data.hba1c ? data.hba1c : this.hb1c;
      this.glucose = data.glucose_stat ? data.glucose_stat : this.glucose;
      this.glucose.map(function (e, i) {
        if (e.bg_up !== '--') {
          e.bg_up = e.bg_up.toFixed(1);
        }
        if (e.bg_tp !== '--') {
          e.bg_tp = e.bg_tp.toFixed(1);
        }
        if (e.bg_lp !== '--') {
          e.bg_lp = e.bg_lp.toFixed(1);
        }
      });
      this.dayNum = this.glucose.length - 1;
      this.event = data.insulin_and_event_stat ? data.insulin_and_event_stat : this.event;
    },
    getTs2: function getTs2(context, st, et) {
      var ts = [];this.xDate = [];
      this.days = (et - st) / 86400 + 1;
      var No = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].chekcNoDate(context.weekmode);
      var star = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate9(st);
      var starDate = new Date(star[0], star[1], star[2]);
      if (this.days <= 7) {
        var k = 0;
        for (var i = 0; i < this.days; i++) {
          starDate = new Date(star[0], star[1], star[2]);
          var d = star[2] + i;
          var now = starDate.setDate(d);
          var day = new Date(now).getDay();
          if (No.indexOf(day) === -1) {
            ts[k] = [];
            ts[k][0] = new Date(now).getTime() / 1000;

            starDate = new Date(star[0], star[1], star[2]);
            ts[k][1] = new Date(starDate.setDate(d + 1)).getTime() / 1000;
            this.xDate[k] = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate4(ts[k][0]);
            k++;
          }
        }
        this.interval = 'd';
      } else if (this.days <= 56) {
        for (var _i = 0; _i < this.days; _i++) {
          var week = Math.floor(_i / 7);
          ts[week] = [];
        }

        var _k = 0;
        for (var _i2 = 0; _i2 < this.days; _i2++) {
          var _week = Math.floor(_i2 / 7);
          if (_i2 > 0 && Math.floor(_i2 / 7) !== Math.floor((_i2 - 1) / 7)) {
            _k = 0;
          }
          starDate = new Date(star[0], star[1], star[2]);
          var _d = star[2] + _i2;
          var _now = starDate.setDate(_d);
          var _day = new Date(_now).getDay();
          if (No.indexOf(_day) === -1) {
            ts[_week][_k] = [];
            ts[_week][_k][0] = new Date(_now).getTime() / 1000;
            starDate = new Date(star[0], star[1], star[2]);
            ts[_week][_k][1] = new Date(starDate.setDate(_d + 1)).getTime() / 1000;
            _k++;
          }
        }

        var length1 = ts.length,
            m = 0;
        for (var _i3 = 0; _i3 < length1; _i3++) {
          var length2 = ts[_i3].length;
          if (length2 === 0) {
            ts.splice(_i3, 1);
            continue;
          } else {
            var sta = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate8(ts[_i3][0][0]);
            var end = '';
            if (length2 > 1) {
              end = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate8(ts[_i3][length2 - 1][0]);
            } else {
              end = sta;
            }
            this.xDate[m] = sta + '-' + end;
            m++;
          }
        }
        this.interval = 'w';
      } else {
        for (var _i4 = 0; _i4 < this.days; _i4++) {
          starDate = new Date(star[0], star[1], star[2]);
          var _d2 = star[2] + _i4;
          var _m2 = new Date(starDate.setDate(_d2)).getMonth();
          var month = _m2 - star[1];
          ts[month] = [];
          starDate = new Date(star[0], star[1], star[2]);
        }
        var _k2 = 0;
        for (var _i5 = 0; _i5 < this.days; _i5++) {
          starDate = new Date(star[0], star[1], star[2]);
          var _d3 = star[2] + _i5;
          var _now2 = starDate.setDate(_d3);
          var _m3 = new Date(_now2).getMonth();
          var _month = _m3 - star[1];
          starDate = new Date(star[0], star[1], star[2]);

          if (_i5 > 0 && new Date(_now2).getMonth() !== new Date(starDate.setDate(_d3 - 1)).getMonth()) {
            _k2 = 0;
          }
          var _day2 = new Date(_now2).getDay();
          if (No.indexOf(_day2) === -1) {
            ts[_month][_k2] = [];
            ts[_month][_k2][0] = new Date(_now2).getTime() / 1000;

            starDate = new Date(star[0], star[1], star[2]);
            ts[_month][_k2][1] = new Date(starDate.setDate(_d3 + 1)).getTime() / 1000;
            _k2++;
          }
        }

        var _length = ts.length,
            _m = 0;
        for (var _i6 = 0; _i6 < _length; _i6++) {
          var _length2 = ts[_i6].length;
          if (_length2 === 0) {
            ts.splice(_i6, 1);
            continue;
          } else {
            var _sta = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate8(ts[_i6][0][0]);
            var _end = '';
            if (_length2 > 1) {
              _end = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate8(ts[_i6][_length2 - 1][0]);
            } else {
              _end = _sta;
            }
            this.xDate[_i6] = _sta + '-' + _end;
          }
        }
        this.interval = 'm';
      }

      this.xDate2 = this.xDate;
      return ts;
    },
    printPdf: function printPdf() {
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].print_page();
    }
  },
  mounted: function mounted() {
    self.document.title = this.$t('TrendRe');
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }
    this.et = parseInt(sessionStorage.getItem('qet4'));
    this.st = parseInt(sessionStorage.getItem('qst4'));
    var days = parseInt((this.et - this.st) / 86400) + 1;
    if (days <= 7) {
      this.interval = 'd';
    } else if (days <= 56) {
      this.interval = 'w';
    } else {
      this.interval = 'm';
    }
    this.timeRange = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate2(this.st) + ' - ' + __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate2(this.et);
    this.weekmode = sessionStorage.getItem('qweekMode');
    this.ts = this.getTs2(this, this.st, this.et);
    var param = {
      ts: this.ts,
      interval: this.interval,
      tz: parseInt(sessionStorage.getItem('tz')),
      weekmode: this.weekmode,
      gu: this.isMg ? 'mg/dL' : 'mmol/L'
    };
    param = __WEBPACK_IMPORTED_MODULE_4__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));

    __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getTa(this, this.uid, param);
    var first = parseInt(sessionStorage.getItem('qFirst4'));
    if (first === 1) {
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].checkPrint(this, 5, 4);
    }
  }
});

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_format__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth_base64__ = __webpack_require__(9);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _ref;

    return _ref = {
      pringtPre: false,
      pump_device: '--',
      timer: false, typeChooseVisible: false, value1: '', value2: '', isC: false, flag: 0, count: 0, sta: '', end: '', isMg: "", ts: [], long: false, isFr: false, isSw: false,
      uid: 0, st: 0, et: 0, autoStop: [], manualStop: [], stop: [], Newer: [], noMeal: [], mt: [], isEn: false, mt1: [], isDe: false, isEs: false
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'uid', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'st', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'et', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'autoStop', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'manualStop', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'stop', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'Newer', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'noMeal', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'mt', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'isIt', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'isPo', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'isFr', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'isCz', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'bgAvg', [{ avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }, { avg: "--" }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'carb', [{ total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }, { total: "--" }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'ins', [{ total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }, { total: "--", percent: "--" }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'weekmode', 'yyyyyyy'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'timeRange', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'isA', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'isDu', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'whichDate', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'pagePos', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'perPage', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'chartEndPage', { show: false }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'hours', ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00']), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'statics', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'devices', ['--', '--', '--']), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'hb1c', ['--']), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'isEn', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'styleText', '<style type="text/css" media="print">@page{size:landscape;margin:0;}</style>'), _ref;
  },

  computed: {
    DataS: function DataS() {
      return this.$store.state.DataS;
    },
    DataSG: function DataSG() {
      return JSON.parse(sessionStorage.getItem('olDataSG'));
    }
  },
  methods: {
    getLogDate: function getLogDate(st, et) {
      var count = (et - st) / (3600 * 24) + 1;
      var day = [];
      et = new Date((et + 3600 * 8) * 1000).toUTCString();
      for (var i = 0; i < count; i++) {
        var time = new Date((st + 3600 * 24 * i + 3600 * 8) * 1000).toUTCString();
        var sp1 = time.split(',');
        var sp2 = sp1[1].split(' ');
        day[i] = sp2[2] + ' ' + sp2[1] + ', ' + sp2[3] + ' ' + sp1[0];
      }
      this.whichDate = day;
    },
    initTable: function initTable() {
      var wrap = document.getElementById('table-wrapper');
      var wraps = document.getElementsByClassName('table-wrapper');
      console.log("wraps:", wraps);

      for (var w = 0; w < wraps.length; w++) {
        var _wrap = wraps[w];
        var tables = _wrap.getElementsByTagName('table')[1];
        for (var i = 0; i < tables.length; i++) {
          var tr = tables[i].getElementsByTagName('tr');
          for (var j = 0; j < tr.length; j++) {
            var td = tr[j].getElementsByTagName('td');
            for (var k = 3; k < td.length - 1; k++) {
              td[k].innerHTML = '';
              td[k].style.backgroundColor = '#fff';
            }
          }
        }
      }
    },
    makeNoMeal: function makeNoMeal() {
      var noMeal = this.noMeal,
          mt = this.mt;
      for (var i = 0; i < noMeal.length; i++) {
        for (var j = 0; j < 3; j++) {
          if (noMeal[i][j] === 0) {
            var id = i;
            var table1 = document.getElementById(id);
            var tr = table1.getElementsByTagName('tr')[1];
            var td = tr.getElementsByTagName('td')[2 + mt[j][0]];
            var img = document.createElement('img');
            img.src = '/static/Lgb Icon/Missed Meal.png';
            img.className = 'insertImg';
            td.appendChild(img);
          }
        }
      }
      var mt1 = this.mt1;
      for (var _i = 0; _i < 3; _i++) {
        var obj = document.getElementById('m' + _i);
        obj.style.left = parseFloat(mt1[_i][0]) / 24 * 100 + '%';
        obj.style.width = (parseFloat(mt1[_i][1]) - parseFloat(mt1[_i][0])) * 36 + 'px';
      }
    },
    getLgbReportInfo: function getLgbReportInfo(report_data) {
      var data = report_data;
      data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
      this.statics = data;
      this.devices = data.devices ? data.devices : this.devices;
      if ('EasyPatch' == this.devices[0]) {
        document.getElementById('reportPdmTitle').innerHTML = 'APP';
      }
      this.hb1c = data.hba1c ? data.hba1c : this.hb1c;
    },
    getTs: function getTs(st, et) {
      var ts = [],
          days = (et - st) / 86400 + 1,
          time = 0,
          sp1 = 0,
          k = 0;
      var No = __WEBPACK_IMPORTED_MODULE_3__auth_auth__["a" /* default */].chekcNoDate(this.weekmode);
      this.whichDate = [];
      for (var i = 0; i < days; i++) {
        var day = new Date((st + i * 86400) * 1000).getDay();
        if (No.indexOf(day) === -1) {
          ts[k] = [];
          ts[k][0] = st + i * 86400;
          ts[k][1] = st + (i + 1) * 86400;
          time = new Date(ts[k][0] * 1000).toString();
          sp1 = time.split(' ');
          if (this.isEn) {
            this.whichDate[k] = sp1[2] + ' ' + this.$t(sp1[1]) + ', ' + sp1[3] + ' ' + this.$t(sp1[0]);
          } else {
            var m = new Date(ts[k][0] * 1000).getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            this.whichDate[k] = sp1[3] + '-' + m + '-' + sp1[2] + ' ' + this.$t(sp1[0]);
          }
          k++;
        }
      }

      var page_index = 0;
      var PER_PAGE1 = 6;
      var PER_PAGE2 = 8;

      while (page_index < this.whichDate.length) {
        this.pagePos.push(page_index);
        if (1 == this.pagePos.length) {
          page_index += PER_PAGE1;
          this.perPage.push(PER_PAGE1);
        } else {
          page_index += PER_PAGE2;
          this.perPage.push(PER_PAGE2);
        }
      }
      var chartNum = this.whichDate.length;
      if (chartNum == 14) {
        this.chartEndPage.show = true;
        this.long = true;
      }

      console.log('pagePos:', this.pagePos);

      return ts;
    },
    makebg1: function makebg1(val, high, low) {
      for (var i = 0; i < val.length; i++) {
        if (val[i].length > 0) {
          var id = i;
          var table1 = document.getElementById(id);
          var tr = table1.getElementsByTagName('tr')[0];
          for (var j = 0; j < val[i].length; j++) {
            if (val[i][j].length > 0) {
              var td = tr.getElementsByTagName('td')[3 + j];
              if (val[i][j].length === 2) {
                var div1 = document.createElement('div');
                var div2 = document.createElement('div');
                div2.style.float = 'left';
                div2.style.marginLeft = '3px';
                div2.innerHTML = val[i][j][0];
                var div3 = document.createElement('div');
                div3.style.float = 'left';
                div3.style.width = '6px';
                div3.style.height = '6px';
                div3.style.borderRadius = '3px';
                div3.style.backgroundColor = '#0f0f0f';
                div1.appendChild(div2);
                div1.appendChild(div3);
                td.appendChild(div1);
              } else {
                td.innerHTML = val[i][j][0];
              }
              if (val[i][j][0] > high) {
                td.style.backgroundColor = '#ffd125';
              } else if (val[i][j][0] < low) {
                td.style.backgroundColor = '#ff3d3d';
              } else {
                td.style.backgroundColor = '#c6deb5';
              }
            }
          }
        }
      }
    },
    makecarb: function makecarb(val) {
      for (var i = 0; i < val.length; i++) {
        if (val[i].length > 0) {
          var table1 = document.getElementById(i);
          var tr = table1.getElementsByTagName('tr')[1];
          for (var j = 0; j < val[i].length; j++) {
            if (val[i][j] !== 0) {
              var td = tr.getElementsByTagName('td')[j + 2];
              td.innerHTML = val[i][j];
            }
          }
        }
      }
      this.pringtPre = true;
    },
    makeOth1: function makeOth1(val, flag) {
      for (var i = 0; i < val.length; i++) {
        var table1 = document.getElementById(i);
        var k = 2;
        if (flag === 4 || flag === 5 || 7 === flag || 8 === flag || 9 === flag || 10 === flag || 11 === flag) {
          k = 3;
        }
        var tr = table1.getElementsByTagName('tr')[k];
        for (var j = 0; j < val[i].length; j++) {
          if (val[i][j] === 1) {
            var td = tr.getElementsByTagName('td')[2 + j];
            var img = document.createElement('img');
            img.style.height = '10px';
            img.style.width = '10px';
            if (flag === 0) {
              img.src = '/static/Lgb Icon/Auto Suspend.png';
            }
            if (flag === 1) {
              img.src = '/static/Lgb Icon/Manual Suspend.png';
            }
            if (flag === 2) {
              img.src = '/static/Lgb Icon/Stop Patch .png';
            }
            if (flag === 3) {
              img.src = '/static/Lgb Icon/New Patch .png';
            }
            if (flag === 4) {
              img.src = '/static/Lgb Icon/Exercise.png';
            }
            if (flag === 5) {
              img.src = '/static/Lgb Icon/Others.png';
            }
            if (flag === 6) {
              img.src = '/static/Lgb Icon/temp basal.png';
            }
            if (7 === flag) {
              img.src = '/static/legend/automode/早餐.png';
              img.style.height = '15px';
              img.style.width = '22px';
            } else if (flag === 8) {
              img.src = '/static/legend/automode/中餐.png';
              img.style.height = '15px';
              img.style.width = '22px';
            } else if (flag === 9) {
              img.src = '/static/legend/automode/晚餐.png';
              img.style.height = '15px';
              img.style.width = '22px';
            } else if (flag === 10) {
              img.src = '/static/legend/automode/零食.png';
              img.style.height = '15px';
              img.style.width = '22px';
            } else if (flag === 11) {
              img.src = '/static/legend/automode/运动[30059].png';
              img.style.height = '15px';
              img.style.width = '22px';
            } else if (flag === 12) {
              img.src = '/static/legend/automode/进入自动模式.png';
              img.style.height = '15px';
              img.style.width = '15px';
            } else if (flag === 13) {
              img.src = '/static/legend/automode/退出自动模式.png';
              img.style.height = '15px';
              img.style.width = '15px';
            }
            img.style.marginRight = '2px';
            img.style.marginLeft = '2px';
            img.style.float = 'left';
            td.appendChild(img);
          }
        }
      }
    },
    makeBolus: function makeBolus(val, flag) {
      for (var i = 0; i < val.length; i++) {
        var leng = val[i].length;
        var table1 = document.getElementById(i);
        var tr = table1.getElementsByTagName('tr')[2];
        for (var k = 0; k < leng; k++) {
          if (val[i][k] !== 0) {
            var td = tr.getElementsByTagName('td')[k + 2];
            if (flag[i][k]) {
              var div3 = document.createElement('div');
              div3.style.float = 'left';
              div3.style.width = '24px';
              div3.style.height = '16px';
              div3.style.borderRadius = '4px';
              div3.style.paddingTop = '1px';
              div3.style.border = '1px solid #222';
              div3.innerHTML = val[i][k].toFixed(2);
              td.appendChild(div3);
            } else {
              td.innerHTML = val[i][k].toFixed(2);
            }
          }
        }
      }
    },
    makeBolus2: function makeBolus2(val) {
      for (var i = 0; i < val.length; i++) {
        var leng = val[i].length;
        if (leng > 0) {
          var table1 = document.getElementById(i);
          var tr = table1.getElementsByTagName('tr')[2];
          for (var k = 0; k < leng; k++) {
            if (val[i][k].length > 0) {
              var td = tr.getElementsByTagName('td')[val[i][k][0] + 2];

              var div3 = document.createElement('div');
              div3.style.float = 'left';
              div3.style.width = '32px';
              div3.style.height = '18px';
              div3.style.borderRadius = '4px';
              div3.style.paddingTop = '2px';
              div3.style.border = '1px solid #222';
              div3.innerHTML = val[i][k][1].toFixed(2);

              td.appendChild(div3);
            }
          }
        }
      }
    },
    makeNoPump: function makeNoPump(val) {
      for (var i = 0; i < val.length; i++) {
        if (val[i] === 1) {
          var table = document.getElementById(i);
          var tr = table.getElementsByTagName('tr')[2];
          var td = tr.getElementsByTagName('td')[1];
          td.style.backgroundColor = '#ccc';
        }
      }
    },
    printPdf: function printPdf() {
      if (this.pringtPre === false) {
        this.$message({
          type: 'info',
          message: '数据加载中，请稍候再打印'
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_3__auth_auth__["a" /* default */].print_page();
      }
    }
  },
  mounted: function mounted() {
    self.document.title = this.$t('logRe');
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isSw = lang === 'sw' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }
    this.et = parseInt(sessionStorage.getItem('qet5'));
    this.st = parseInt(sessionStorage.getItem('qst5'));
    this.timeRange = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate2(this.st) + ' - ' + __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate2(this.et);
    this.weekmode = sessionStorage.getItem('qweekMode');
    this.getLogDate(this.st, this.et);
    this.ts = this.getTs(this.st, this.et);
    var param = {
      ts: this.ts,
      tz: parseInt(sessionStorage.getItem('tz')),
      weekmode: this.weekmode,
      gu: this.isMg ? 'mg/dL' : 'mmol/L'
    };
    param = __WEBPACK_IMPORTED_MODULE_5__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));
    __WEBPACK_IMPORTED_MODULE_3__auth_auth__["a" /* default */].getLgb1(this, this.uid, param);

    var first = parseInt(sessionStorage.getItem('qFirst5'));
    if (first === 1) {
      __WEBPACK_IMPORTED_MODULE_3__auth_auth__["a" /* default */].checkPrint(this, 6, 5);
    }
  }
});

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_format__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_base64__ = __webpack_require__(9);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      whichDate: [], isMg: "",
      hours: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
      uid: 0, st: 0, et: 0, days: '', dayNum: 0, ts: [],
      statics: {}, hb1c: ['--'], long: false,
      pagePos: [], perPage: [], chartEndPage: { show: false },
      styleText: '<style type="text/css" media="print">@page{size:landscape;margin:0;}</style>',
      bgstat: { "day": {
          "avg": "--",
          "max": "--",
          "min": "--",
          "num": "--",
          "sd": "--",
          "total": "--"
        }
      },
      carbstat: { "day": {
          "avg": "--",
          "max": "--",
          "min": "--",
          "num": "--",
          "sd": "--",
          "total": "--"
        }
      },
      bolstat: { "day": {
          "avg": "--",
          "max": "--",
          "min": "--",
          "num": "--",
          "sd": "--",
          "total": "--"
        }
      },
      exerstat: { "day": {
          "avg": "--",
          "max": "--",
          "min": "--",
          "num": "--",
          "sd": "--",
          "total": "--"
        }
      }
    };
  },

  methods: {
    getStatics: function getStatics() {
      if (sessionStorage.getItem('userType') !== 'P') {
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      } else {
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      this.ts = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getTs(this.st, this.et);
      var param = {
        ts: this.ts,
        tz: parseInt(sessionStorage.getItem('tz')),
        gu: this.isMg ? 'mg/dL' : 'mmol/L'
      };

      param = __WEBPACK_IMPORTED_MODULE_4__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));
      this.$http.get('api/v2.1/report/' + this.uid + '/data/erd', { params: { param: param } }).then(function (res) {
        var err = res.body.error;
        if (err === 0) {
          var data = res.data.data;
          data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
          if (data.medical_history) {
            data.medical_history = data.medical_history.split(',')[0];
          }
          this.statics = data;
          this.hb1c = data.hba1c ? data.hba1c : this.hb1c;
          this.bgstat = data.event_period_stat.bg ? data.event_period_stat.bg : this.bgstat;
          this.carbstat = data.event_period_stat.carb ? data.event_period_stat.carb : this.carbstat;
          this.bolstat = data.event_period_stat.bolus ? data.event_period_stat.bolus : this.bolstat;
          this.exerstat = data.event_period_stat.exer ? data.event_period_stat.exer : this.exerstat;
          var that = this;
          data.event_summary_bytime.map(function (e, i) {
            e.bg = that.makeBg(e.bg, i);
            e.carb = that.makeCarb(e.carb, i, 1);
            e.bolus = that.makeCarb(e.bolus, i, 2);
            e.exer = that.makeCarb(e.exer, i, 3);
          });
        }
      }, function (err) {
        var tip = this.$t('tryAgain');
        this.$message.error(tip);
      });
    },
    makeBg: function makeBg(val, i) {
      var table = document.getElementById(i);
      var tr = table.getElementsByTagName('tr')[0];
      var h = 'hour';
      if (val.no_data) {
        var td = tr.getElementsByTagName('td');
        var tip1 = this.$t('No1');
        var tip2 = this.$t('data1');
        td[2].innerHTML = tip1;
        td[2].style.textAlign = 'right';
        td[3].innerHTML = tip2;
        td[3].style.textAlign = 'left';
      } else {
        for (var item in val) {
          if (item.indexOf(h) >= 0) {
            var j = parseInt(item.replace(/[^0-9]/ig, ""));
            var _td = tr.getElementsByTagName('td')[j + 2];
            _td.innerHTML = val[item];
          } else {
            var _td2 = tr.getElementsByTagName('td')[26];
            _td2.innerHTML = val.total;
          }
        }
      }
    },
    makeCarb: function makeCarb(val, i, type) {
      var table = document.getElementById(i);
      var tr = table.getElementsByTagName('tr')[type];
      var h = 'hour';
      if (val.no_data) {
        var td = tr.getElementsByTagName('td');
        var tip1 = this.$t('No1');
        var tip2 = this.$t('data1');
        td[1].innerHTML = tip1;
        td[1].style.textAlign = 'right';
        td[2].innerHTML = tip2;
        td[2].style.textAlign = 'left';
      } else {
        for (var item in val) {
          if (item.indexOf(h) >= 0) {
            var j = parseInt(item.replace(/[^0-9]/ig, ""));
            var _td3 = tr.getElementsByTagName('td')[j + 1];
            _td3.innerHTML = val[item];
          } else {
            var _td4 = tr.getElementsByTagName('td')[25];
            _td4.innerHTML = val.total;
          }
        }
      }
    },
    printPdf: function printPdf() {
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].print_page();
    }
  },
  mounted: function mounted() {
    self.document.title = this.$t('EventReport');
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    var t2 = parseInt(sessionStorage.getItem('qet6'));
    var t1 = parseInt(sessionStorage.getItem('qst6'));
    this.dayNum = parseInt((t2 - t1) / 86400 + 1);
    if (this.dayNum > 13) {
      this.long = true;
    }
    this.days = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate2(t1) + ' - ' + __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate2(t2);
    for (var i = 0; i < this.dayNum; i++) {
      var ti = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate2(t1 + i * 86400) + ' ' + __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDay(this, t1 + i * 86400);
      this.whichDate[i] = ti;
    }

    var page_index = 0;
    var PER_PAGE1 = 9;
    var PER_PAGE2 = 10;
    while (page_index < this.whichDate.length) {
      this.pagePos.push(page_index);
      if (1 == this.pagePos.length) {
        page_index += PER_PAGE1;
        this.perPage.push(PER_PAGE1);
      } else {
        page_index += PER_PAGE2;
        this.perPage.push(PER_PAGE2);
      }
    }
    var chartNum = this.whichDate.length;
    if (chartNum < 8) {
      this.chartEndPage.show = false;
    } else if (8 == chartNum) {
      this.chartEndPage.show = true;
    } else if ((chartNum - 9) % 10 == 0) {
      this.chartEndPage.show = true;
    }

    console.log('pagePos:', this.pagePos);
    var pageNum = this.pagePos.length;
    if (8 == chartNum || 9 == chartNum) {
      pageNum += 1;
    }

    this.st = t1;
    this.et = t2;
    this.getStatics();
    var first = parseInt(sessionStorage.getItem('qFirst6'));
    if (first === 1) {
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].checkPrint(this, 8, 6);
    }
  }
});

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_format__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_base64__ = __webpack_require__(9);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      whichDate: [],
      hours: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
      uid: 0, st: 0, et: 0, timeRange: '', long: false, isEn: false, isMg: "", ts: [],
      styleText: '<style type="text/css" media="print">@page{size:landscape;margin:0;}</style>',
      statics: {}, hb1c: ['--'],
      bgstat: [],
      carbstat: [],
      bolstat: [],
      exerstat: { "day": {
          "avg": "--",
          "max": "--",
          "min": "--",
          "num": "--",
          "sd": "--",
          "total": "--"
        }
      },
      pagePosBG: [], perPageBG: [], endPageBG: { show: false },
      pagePosCarb: [], perPageCarb: [], endPageCarb: { show: false },
      pagePosInj: [], perPageInj: [], endPageInj: { show: false },
      pagePosExer: [], perPageExer: [], endPageExer: { show: false }
    };
  },


  methods: {
    getStatics: function getStatics() {
      if (sessionStorage.getItem('userType') !== 'P') {
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      } else {
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      this.et = parseInt(sessionStorage.getItem('qet6'));
      this.st = parseInt(sessionStorage.getItem('qst6'));
      this.timeRange = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate2(this.st) + ' - ' + __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate2(this.et);
      this.ts = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getTs(this.st, this.et);
      this.getDate();
      var param = {
        ts: this.ts,
        tz: parseInt(sessionStorage.getItem('tz')),
        gu: this.isMg ? 'mg/dL' : 'mmol/L'
      };
      param = __WEBPACK_IMPORTED_MODULE_4__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));
      this.$http.get('api/v2.1/report/' + this.uid + '/data/erc', { params: { param: param } }).then(function (res) {
        var err = res.body.error;
        if (err === 0) {
          console.log(res.data);
          var data = res.data.data;
          data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
          if (data.medical_history) {
            data.medical_history = data.medical_history.split(',')[0];
          }
          this.statics = data;
          this.hb1c = data.hba1c ? data.hba1c : this.hb1c;
          this.bgstat = data.bg_event_stat ? data.bg_event_stat : this.bgstat;
          this.carbstat = data.carb_event_stat ? data.carb_event_stat : this.carbstat;
          this.bolstat = data.bolus_event_stat ? data.bolus_event_stat : this.bolstat;
          this.exerstat = data.exercise_event_stat ? data.exercise_event_stat : this.exerstat;
          var that = this;
          data.bg_event.map(function (e, i) {
            that.makeData(e, i, 'bg');
          });
          data.carb_event.map(function (e, i) {
            that.makeData(e, i, 'carb');
          });
          data.bolus_event.map(function (e, i) {
            that.makeData(e, i, 'bol');
          });
          data.exercise_event.map(function (e, i) {
            that.makeData(e, i, 'exer');
          });
        }
      }, function (err) {
        var tip = this.$t('tryAgain');
        this.$message.error(tip);
      });
    },
    getDate: function getDate() {
      var dayNum = parseInt((this.et - this.st) / 86400) + 1;
      for (var i = 0; i < dayNum; i++) {
        var t = this.st + i * 86400;
        this.whichDate[i] = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate2(t) + ',' + __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDay(this, t);
      }
      if (dayNum > 8) {
        this.long = true;
      }
      console.log("whichDate:", this.whichDate);
      var PER_PAGE1 = 26;
      var PER_PAGE2 = 32;

      var totalRow = dayNum * 4;
      var itemRow = dayNum;

      console.log("dayNum:", dayNum, totalRow);

      var rowIndex = 0;
      var itemIndex = 0;
      var currentItem = 0;
      var currentPerPage = PER_PAGE1;
      var currentRowIndex = 0;
      var activePagePos = void 0;
      var activePerPage = void 0;
      var activeEndPage = void 0;
      var isFirstPage = true;
      var usedPageRow = 0;
      var pageIndex = 0;
      var pageLeftRow = 0;
      var titleUsedRow = 0;

      while (currentItem < 4 && pageIndex < 100) {

        while (currentRowIndex < itemRow && pageIndex < 100) {

          if (0 == pageIndex) {
            currentPerPage = PER_PAGE1;
          } else {
            currentPerPage = PER_PAGE2;
          }

          pageLeftRow = currentPerPage - usedPageRow - titleUsedRow;


          console.log("pageLeftRow:", pageIndex, currentItem, currentPerPage, usedPageRow, titleUsedRow, pageLeftRow, currentRowIndex, itemRow);
          if (pageLeftRow <= 0) {
            var preItem = currentItem - 1;
            if (preItem >= 0) {
              if (0 == preItem) {
                this.endPageBG.show = true;
              } else if (1 == preItem) {
                this.endPageCarb.show = true;
              } else if (2 == preItem) {
                this.endPageInj.show = true;
              } else if (3 == preItem) {
                this.endPageExer.show = true;
              }
            }
            pageIndex += 1;
            usedPageRow = 0;
            titleUsedRow = 0;
            break;
          }

          if (0 == currentItem) {
            this.pagePosBG.push(currentRowIndex);
            this.perPageBG.push(pageLeftRow);
          } else if (1 == currentItem) {
            this.pagePosCarb.push(currentRowIndex);
            this.perPageCarb.push(pageLeftRow);
          } else if (2 == currentItem) {
            this.pagePosInj.push(currentRowIndex);
            this.perPageInj.push(pageLeftRow);
          } else if (3 == currentItem) {
            this.pagePosExer.push(currentRowIndex);
            this.perPageExer.push(pageLeftRow);
          }

          console.log('currentRowIndex:', currentItem, pageIndex, currentRowIndex, pageLeftRow, usedPageRow, itemRow - currentRowIndex);
          if (pageLeftRow > itemRow - currentRowIndex) {
            currentItem++;
            usedPageRow += itemRow - currentRowIndex;
            currentRowIndex = 0;
            titleUsedRow += 2;

            console.log('branch1:', usedPageRow, pageIndex, currentItem);
            break;
          } else if (pageLeftRow < itemRow - currentRowIndex) {
            pageIndex += 1;
            currentRowIndex += pageLeftRow;
            usedPageRow = 0;
            titleUsedRow = 0;

            console.log('branch2:', currentRowIndex, pageIndex, currentItem);
          } else if (pageLeftRow == itemRow - currentRowIndex) {
            if (0 == currentItem) {
              this.endPageBG.show = true;
            } else if (1 == currentItem) {
              this.endPageCarb.show = true;
            } else if (2 == currentItem) {
              this.endPageInj.show = true;
            } else if (3 == currentItem) {
              this.endPageExer.show = true;
            }

            pageIndex += 1;
            usedPageRow = 0;
            currentItem++;
            currentRowIndex = 0;
            titleUsedRow = 0;

            console.log('branch3:', usedPageRow, pageIndex, currentItem);

            break;
          }
        }
      }

      console.log("pagePosBG:", this.pagePosBG);
      console.log("perPageBG:", this.perPageBG);
      console.log("endPageBG:", this.endPageBG);

      console.log("pagePosCarb:", this.pagePosCarb);
      console.log("perPageCarb:", this.perPageCarb);
      console.log("endPageCarb:", this.endPageCarb);

      console.log("pagePosInj:", this.pagePosInj);
      console.log("perPageInj:", this.perPageInj);
      console.log("endPageInj:", this.endPageInj);

      console.log("pagePosExer:", this.pagePosExer);
      console.log("perPageExer:", this.perPageExer);
      console.log("endPageExer:", this.endPageExer);
    },
    makeData: function makeData(val, i, id) {
      var tempPagePos = [];
      var tempPerPage = [];
      if ('bg' == id) {
        tempPagePos = this.pagePosBG;
        tempPerPage = this.perPageBG;
      } else if ('carb' == id) {
        tempPagePos = this.pagePosCarb;
        tempPerPage = this.perPageCarb;
      } else if ('bol' == id) {
        tempPagePos = this.pagePosInj;
        tempPerPage = this.perPageInj;
      } else if ('exer' == id) {
        tempPagePos = this.pagePosExer;
        tempPerPage = this.perPageExer;
      }

      var p = 0;
      for (p = 0; p < tempPagePos.length; p++) {
        if (i < tempPagePos[p]) {
          break;
        }
      }

      console.log('tempPerPage:', tempPagePos);
      console.log('makeData:', id, i, p);

      id = id + tempPagePos[p - 1];
      i = i - tempPagePos[p - 1];
      console.log('makeData.2:', id, i);

      var table = document.getElementById(id);
      var tr = table.getElementsByTagName('tr')[i + 1];

      var td0 = tr.getElementsByTagName('td')[0];
      var day = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate9(this.ts[i][0]);
      val.day = day[2] + '/' + day[1] + '/' + day[0];
      var day1 = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDay(this, this.ts[i][0]);


      var h = 'hour';
      if (val.no_data) {
        var td = tr.getElementsByTagName('td');
        var tip1 = this.$t('No1');
        var tip2 = this.$t('data1');
        td[1].innerHTML = tip1;
        td[1].style.textAlign = 'right';
        td[2].innerHTML = tip2;
        td[2].style.textAlign = 'left';
      } else {
        for (var item in val) {
          if (item.indexOf(h) >= 0) {
            var j = parseInt(item.replace(/[^0-9]/ig, ""));
            var _td = tr.getElementsByTagName('td')[j + 1];
            _td.innerHTML = val[item];
          } else {
            var _td2 = tr.getElementsByTagName('td')[25];
            _td2.innerHTML = val.total;
          }
        }
      }
    },
    printPdf: function printPdf() {
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].print_page();
    }
  },
  mounted: function mounted() {
    self.document.title = this.$t('EventReport');
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    this.getStatics();
    var first = parseInt(sessionStorage.getItem('qFirst7'));
    if (first === 1) {
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].checkPrint(this, 8, 7);
    }
  }
});

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_base64__ = __webpack_require__(9);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      time: '', rid: 0, uid: 0, st: 0, et: 0, data: {}, pdm: '', isEn: false, pumpSN: '', tranSN: '', pdmSN: '', isMg: "", isDe: false,
      statics: {}, devices: ['--', '--', '--'], hb1c: ['--'], maxBolOption: '', unit1: '', isFr: false,
      basal: {
        "basal_onoff": "--",
        "basal_select": "--",
        "max_rate": '--',
        "exer_basal": {
          "day_total": '--',
          "seg": []
        }
      },
      basalSeg: [], bsg1: [], bsg2: [], bsg3: [], bsg4: [], total: 0,

      pdmTitle: '',

      standardSeg: [], standardSeg1: [], standardSeg2: [], standardSeg3: [], standardSeg4: [],
      exerSeg: [], exerSeg1: [], exerSeg2: [], exerSeg3: [], exerSeg4: [],
      holidaySeg: [], holidaySeg1: [], holidaySeg2: [], holidaySeg3: [], holidaySeg4: [],
      programASeg: [], programASeg1: [], programASeg2: [], programASeg3: [], programASeg4: [],
      programBSeg: [], programBSeg1: [], programBSeg2: [], programBSeg3: [], programBSeg4: [],

      programCSeg: [], programCSeg1: [], programCSeg2: [], programCSeg3: [], programCSeg4: [],
      programDSeg: [], programDSeg1: [], programDSeg2: [], programDSeg3: [], programDSeg4: [],
      sickSeg: [], sickSeg1: [], sickSeg2: [], sickSeg3: [], sickSeg4: [],
      moreBasal: true,
      showEasyPatch: false,
      basalPagePos: -9,
      basalPagePos2: -9,

      bolusStartPage: { show: false },
      pdmStartPage: { show: false },
      cgmStartPage: { show: false },

      pumpStartPage: { show: false },
      appStartPage: { show: false },

      basalInfo: [{}, {}, {}, {}, {}, {}, {}, {}],

      bolus: {
        "bg_reminder": "--",
        "bg_target": [],
        "bolus_reminder": [],
        "bolus_step": '--',
        "bolus_wizard": "--",
        "extent_option": "--",
        "ins_active_time": '--',
        "ins_carb_ratio": [],
        "ins_sen": [],
        "max_bolus": '--'
      },
      IcRatio: [], ins_sen: [], bg_target: [], bolus_rem: [], cgmLimit: [],
      cgm: {
        "alarm_silent_option": "--",
        "sensor_alarm_option": "--",
        "sensor_alarm_repeat": {
          "high": ["--", "--"],
          "low": ["--", "--"]
        },
        "sensor_alarm_settings": {
          "auto_calib_option": "--",
          "calib_remind_interval": "--",
          "calib_remind_option": "--",
          "calib_remind_time": "--",
          "no_calib_display": "--",
          "sensor_lost_time": '--',
          "trend_time_scope": '--'
        },
        "sensor_alarm_threshold": [],
        "sensor_forecast_alarm": {
          "high": ["--", "--"],
          "low": ["--", "--"]
        },
        "sensor_rate_alarm": {
          "fall": ["--", '--'],
          "rise": ["--", '--']
        }
      },
      userset: {
        "alarm_type": "--",
        "auto_off_option": "--",
        "auto_off_time": "--",
        "backlight_timeout": "--",
        "beep_off_tip_interval": "--",
        "beep_off_tip_option": "--",
        "cgms_module_flag": "--",
        "clock": [],
        "clock_option": "--",
        "cmd_response": "--",
        "day_bolus_max": "--",
        "device_option": "--",
        "glucose_unit": "--",
        "hour_bolus_max": "--",
        "keypad_lock": "--",
        "low_reservoir_ins": "--",
        "low_reservoir_time": "--",
        "low_reservoir_type": "--",
        "password_option": "--",
        "patch_expire_ahead": "--",
        "patch_expire_alarm": "--",
        "pre_suspend_on_lowbg_level": "--",
        "pre_suspend_on_lowbg_option": "--",
        "pump_module_flag": "--",
        "screen_timeout": "--",
        "suspend_on_lowbg_level": "--",
        "suspend_on_lowbg_option": "--",
        "time_style": "--",
        auto_basal: {}
      },

      exeBasal: [], standBasal: [], holidayBasal: [], programA: [], programB: [], programC: [], programD: [], sickBasal: [], sgMax: 4,
      textStyle: {
        color: '#282828',
        fontWeight: 'normal',
        fontSize: '12',
        fontFamily: 'SFUIText-Regular'
      },
      axisMaxArr: [],
      titlePadding: [0, 0, 8, 30],
      grid: { x: '3%', y: '15%', width: '95%', height: '60%' },
      yAxisLabel: { interval: 0, margin: 5, textStyle: { color: '#282828', baseline: 'middle' }, showMinLabel: false },
      xLabel: ['18-07-2017', '19-07-2017', '20-07-2017', '21-07-2017', '22-07-2017', '23-07-2017', '24-07-2017', '25-07-2017', '26-07-2017', '27-07-2017', '28-07-2017', '29-07-2017', '30-07-2017', '31-07-2017']
    };
  },

  methods: {
    getStatics: function getStatics() {
      this.et = new Date(2017, 9, 19).getTime() / 1000;
      this.st = this.et;
      var param = {
        st: this.st,
        et: this.et,
        tz: parseInt(sessionStorage.getItem('tz')),
        gu: this.isMg ? 'mg/dL' : 'mmol/L'
      };
      param = __WEBPACK_IMPORTED_MODULE_3__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));
      this.$http.get('api/v2.1/report/' + this.uid + '/data/dse', { params: { param: param } }).then(function (res) {
        var err = res.body.error;
        if (err === 0) {
          var data = res.data.data;
          data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
          this.statics = data;
          this.devices = data.devices ? data.devices : this.devices;
          this.hb1c = data.hba1c ? data.hba1c : this.hb1c;
        }
      }, function (err) {
        var tip = this.$t('tryAgain');
        this.$message.error(tip);
      });
    },
    getAxisMax: function getAxisMax(seg) {
      var valArr = seg.map(function (e, i) {
        return e[1];
      });
      var maxVal = Math.max.apply(null, valArr);
      var axisMax = (parseInt(maxVal / 2) + 1) * 2;
      return axisMax;
    },
    getOptionText: function getOptionText(optionVal) {
      var optionText = '--';
      if (1 == optionVal) {
        optionText = this.$t('Off');
      } else if (2 == optionVal) {
        optionText = this.$t('On');
      }
      return optionText;
    },
    getPdm2: function getPdm2() {
      var ins_unit2 = this.$t('ins_unit2');
      this.$http.get('api/v2.0/pdm/' + this.uid + '/settings/' + this.rid).then(function (res) {
        var err = res.body.error;
        if (err === 0) {
          this.data = res.data.settings;
          this.data.device_type = res.data.device_type;

          if (false) {
            var padInt = function padInt(v, n) {
              var v_str = v.toString();
              var pre_num = n - v_str.length;
              var pre_str = '';
              for (var i = 0; i < pre_num; i++) {
                pre_str += '0';
              }
              return pre_str + v_str;
            };

            var minute_format = function minute_format(m) {
              var hour = padInt(Math.floor(m / 60), 2);
              var minute = padInt(m % 60, 2);
              return hour + ':' + minute;
            };

            this.data.device_type = 18;

            var testSegs = [];
            for (var i = 0; i < 48; i++) {
              var minute = i * 30;
              testSegs.push([minute_format(minute), parseFloat((i % 20 * 0.1).toFixed(2))]);
            }

            this.data.basal_settings.stand_basal.seg = testSegs.slice(0, 40);
            this.data.basal_settings.exer_basal.seg = testSegs.slice(0, 40);
            this.data.basal_settings.holiday_basal.seg = testSegs.slice(0, 40);
            this.data.basal_settings.program_a_basal.seg = testSegs.slice(0, 40);
            this.data.basal_settings.program_b_basal.seg = testSegs.slice(0, 40);

            this.data.basal_settings.program_c_basal.seg = testSegs.slice(0, 40);
            this.data.basal_settings.program_d_basal.seg = testSegs.slice(0, 40);
            this.data.basal_settings.sick_basal.seg = testSegs.slice(0, 40);

            var testICRSeg = [];
            for (var _i = 0; _i < 8; _i++) {
              var _minute = _i * 30;
              testICRSeg.push([minute_format(_minute), 15]);
            }
            this.data.bolus_settings.ins_carb_ratio = testICRSeg;

            var testSeg = [];
            for (var _i2 = 0; _i2 < 8; _i2++) {
              var _minute2 = _i2 * 30;
              testSeg.push([minute_format(_minute2), "5.6-5.6"]);
            }
            this.data.bolus_settings.bg_target = testSeg;

            console.log('device setting test:', this.data);
          }

          if (18 == this.data.device_type) {
            this.moreBasal = true;
            this.showEasyPatch = false;
          } else if ('easypatch' == this.data.device_type) {
            this.moreBasal = true;
            this.showEasyPatch = true;
          } else {
            this.moreBasal = false;
            this.showEasyPatch = false;
          }

          if (true) {
            if (true) {
              var totalRow = 0;
              var prePageTotalRow = 0;

              var firstPageTotalRow = 0;
              var secondPageTotalRow = 0;

              var basalKey = ["stand_basal", "exer_basal", "holiday_basal", "program_a_basal", "program_b_basal", "program_c_basal", "program_d_basal", "sick_basal"];
              var basalNum = 5;
              var firstPageRow = 16;
              if (this.moreBasal) {
                basalNum = 8;
                firstPageRow = 12;
              }

              for (var _i3 = 0; _i3 < basalNum; _i3++) {
                var basal_pattern = this.data.basal_settings[basalKey[_i3]];
                totalRow += Math.floor((basal_pattern.seg.length + 11) / 12);
                var nextRow = 0;
                if (_i3 < basalNum - 1) {
                  var next_basal = this.data.basal_settings[basalKey[_i3 + 1]];
                  nextRow = Math.floor((next_basal.seg.length + 11) / 12);
                }
                console.log("totalRow:", totalRow, nextRow, _i3);
                if (totalRow + nextRow > firstPageRow && this.basalPagePos < 0) {
                  this.basalPagePos = _i3;

                  firstPageTotalRow = totalRow;
                }
                if (totalRow + nextRow > firstPageRow + 16 && this.basalPagePos2 < 0) {
                  this.basalPagePos2 = _i3;

                  secondPageTotalRow = totalRow;
                }
              }

              var leftBasalRow = 0;
              if (this.basalPagePos2 > 0) {
                leftBasalRow = totalRow - secondPageTotalRow;
              } else if (this.basalPagePos > 0) {
                leftBasalRow = totalRow - firstPageTotalRow;
              } else {
                leftBasalRow = totalRow;
              }
              console.log("basalTotalRow:", totalRow, firstPageTotalRow, secondPageTotalRow, this.basalPagePos, this.basalPagePos2, leftBasalRow);

              if (this.basalPagePos2 > 0) {
                var basalPage2Id = 'basalPage2' + (this.basalPagePos2 + 1);
                var secondPageRow = secondPageTotalRow - firstPageTotalRow;

                var sepNode = document.getElementById(basalPage2Id);
                var baseRow = 0;

                if (secondPageRow + baseRow <= 13) {} else if (secondPageRow + baseRow <= 14) {} else if (secondPageRow + baseRow <= 15) {} else if (secondPageRow + baseRow <= 16) {}
              }

              if (this.basalPagePos > 0) {
                var basalPageId = 'basalPage' + (this.basalPagePos + 1);
                console.log("basalPageId:", basalPageId);
                var _sepNode = document.getElementById(basalPageId);
                var _baseRow = 0;
                if (this.moreBasal) {
                  _baseRow = 4;
                } else {
                  _baseRow = 0;
                }

                if (firstPageTotalRow + _baseRow <= 13) {} else if (firstPageTotalRow + _baseRow <= 14) {} else if (firstPageTotalRow + _baseRow <= 15) {} else if (firstPageTotalRow + _baseRow <= 16) {}
              }

              if (false) {
                if (this.basalPagePos > 0 || this.basalPagePos2 > 0) {
                  if (leftBasalRow > 9) {
                    this.bolusStartPage.show = true;
                    this.pdmStartPage.show = false;
                    this.cgmStartPage.show = false;
                  } else if (leftBasalRow > 5) {
                    this.bolusStartPage.show = false;
                    this.pdmStartPage.show = true;
                    this.cgmStartPage.show = false;
                  } else if (leftBasalRow > 1) {
                    this.bolusStartPage.show = false;
                    this.pdmStartPage.show = false;
                    this.cgmStartPage.show = true;
                  } else if (leftBasalRow == 1) {
                    this.bolusStartPage.show = false;
                    this.pdmStartPage.show = false;
                    this.cgmStartPage.show = false;
                  } else {
                    this.bolusStartPage.show = true;
                    this.pdmStartPage.show = false;
                    this.cgmStartPage.show = false;
                  }
                } else {
                  this.bolusStartPage.show = true;
                  this.pdmStartPage.show = false;
                  this.cgmStartPage.show = false;
                }
              } else if (false) {

                var _backgroundNode = document.getElementById('background');
                var _containerNode = document.getElementById('chart-container');
                var _pageNum = 4;

                if (this.basalPagePos > 0 || this.basalPagePos2 > 0) {

                  if (leftBasalRow > 1) {
                    this.bolusStartPage.show = false;
                    this.pdmStartPage.show = false;
                    this.cgmStartPage.show = true;

                    var cgmPageId = 'cgmStartPage';
                    console.log("cgmPageId:", cgmPageId);
                    var _sepNode2 = document.getElementById(cgmPageId);
                  } else if (leftBasalRow > 0) {
                    this.bolusStartPage.show = false;
                    this.pdmStartPage.show = false;
                    this.cgmStartPage.show = false;
                    _pageNum = 3;
                  } else if (leftBasalRow == 0) {
                    this.bolusStartPage.show = true;
                    this.pdmStartPage.show = false;
                    this.cgmStartPage.show = false;
                    _pageNum = 3;
                  }
                } else {
                  _pageNum = 3;
                  if (leftBasalRow > 10) {
                    var bolusPageId = 'bolusStartPage';
                    console.log("bolusPageId:", bolusPageId);
                    var _sepNode3 = document.getElementById(bolusPageId);
                    if (leftBasalRow >= 16) {} else if (leftBasalRow >= 14) {} else if (leftBasalRow >= 13) {} else if (leftBasalRow >= 12) {} else if (leftBasalRow >= 11) {}

                    this.bolusStartPage.show = true;
                    this.pdmStartPage.show = false;
                    this.cgmStartPage.show = false;
                  } else if (leftBasalRow > 5) {
                    var pdmPageId = 'pdmStartPage';
                    console.log("pdmPageId:", pdmPageId);
                    var _sepNode4 = document.getElementById(pdmPageId);

                    if (leftBasalRow >= 10) {} else if (leftBasalRow >= 7) {} else if (leftBasalRow >= 6) {}

                    this.bolusStartPage.show = false;
                    this.pdmStartPage.show = true;
                    this.cgmStartPage.show = false;
                  } else {
                    this.bolusStartPage.show = false;
                    this.pdmStartPage.show = false;
                    this.cgmStartPage.show = true;
                  }
                  this.pumpStartPage.show = true;
                }
              }

              var backgroundNode = document.getElementById('background');
              var containerNode = document.getElementById('chart-container');
              var pageNum = 4;

              if (this.basalPagePos2 < 0 && this.basalPagePos < 0) {
                if (this.moreBasal) {
                  leftBasalRow += 4;
                }
                pageNum = 3;
              } else if (this.basalPagePos2 > 0 && this.basalPagePos > 0) {
                if (leftBasalRow > 1) {
                  pageNum = 5;
                } else {
                  pageNum = 4;
                }
              } else if (this.basalPagePos > 0 && this.basalPagePos2 < 0) {
                if (leftBasalRow > 1) {
                  pageNum = 4;
                } else {
                  pageNum = 3;
                }
              }

              console.log("leftBasalRow:", leftBasalRow, pageNum);

              if (leftBasalRow > 10) {
                var _bolusPageId = 'bolusStartPage';
                console.log("bolusPageId:", _bolusPageId);
                var _sepNode5 = document.getElementById(_bolusPageId);
                if (leftBasalRow >= 16) {} else if (leftBasalRow >= 14) {} else if (leftBasalRow >= 13) {} else if (leftBasalRow >= 12) {} else if (leftBasalRow >= 11) {}

                this.bolusStartPage.show = true;
                this.pdmStartPage.show = false;
                this.cgmStartPage.show = false;
              } else if (leftBasalRow > 5) {

                var _pdmPageId = 'pdmStartPage';
                console.log("pdmPageId:", _pdmPageId);
                var _sepNode6 = document.getElementById(_pdmPageId);

                if (leftBasalRow >= 10) {} else if (leftBasalRow >= 7) {} else if (leftBasalRow >= 6) {}

                this.bolusStartPage.show = false;
                this.pdmStartPage.show = true;
                this.cgmStartPage.show = false;
              } else if (leftBasalRow > 1) {

                var _cgmPageId = 'cgmStartPage';
                console.log("cgmPageId:", _cgmPageId);
                var _sepNode7 = document.getElementById(_cgmPageId);

                if (leftBasalRow >= 5) {} else if (leftBasalRow >= 4) {} else if (leftBasalRow >= 3) {} else if (leftBasalRow >= 2) {}

                this.bolusStartPage.show = false;
                this.pdmStartPage.show = false;
                this.cgmStartPage.show = true;
              }
              this.pumpStartPage.show = true;
            }
          }

          this.basal = this.data.basal_settings;
          this.basal.max_rate = this.basal.max_rate ? this.basal.max_rate.toFixed(2) : '--';

          this.basalSeg = this.basal.exer_basal.seg;
          this.total = this.basal.exer_basal.day_total.toFixed(2);
          this.exeBasal = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getPdmSG(this.data.basal_settings.exer_basal.seg);

          this.basalSeg = this.basal.stand_basal.seg;
          this.total = this.basal.stand_basal.day_total.toFixed(2);
          this.standBasal = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getPdmSG(this.data.basal_settings.stand_basal.seg);

          this.basalSeg = this.basal.holiday_basal.seg;
          this.total = this.basal.holiday_basal.day_total.toFixed(2);
          this.holidayBasal = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getPdmSG(this.data.basal_settings.holiday_basal.seg);

          this.basalSeg = this.basal.program_a_basal.seg;
          this.total = this.basal.program_a_basal.day_total.toFixed(2);
          this.programA = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getPdmSG(this.data.basal_settings.program_a_basal.seg);

          this.basalSeg = this.basal.program_b_basal.seg;
          this.total = this.basal.program_b_basal.day_total.toFixed(2);
          this.programB = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getPdmSG(this.data.basal_settings.program_b_basal.seg);


          this.axisMaxArr[0] = this.getAxisMax(this.data.basal_settings.stand_basal.seg);
          this.axisMaxArr[1] = this.getAxisMax(this.data.basal_settings.exer_basal.seg);
          this.axisMaxArr[2] = this.getAxisMax(this.data.basal_settings.holiday_basal.seg);
          this.axisMaxArr[3] = this.getAxisMax(this.data.basal_settings.program_a_basal.seg);
          this.axisMaxArr[4] = this.getAxisMax(this.data.basal_settings.program_b_basal.seg);

          if (this.moreBasal) {
            this.basalSeg = this.basal.program_c_basal.seg;
            this.total = this.basal.program_c_basal.day_total.toFixed(2);
            this.programC = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getPdmSG(this.data.basal_settings.program_c_basal.seg);

            this.basalSeg = this.basal.program_d_basal.seg;
            this.total = this.basal.program_d_basal.day_total.toFixed(2);
            this.programD = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getPdmSG(this.data.basal_settings.program_d_basal.seg);

            this.basalSeg = this.basal.sick_basal.seg;
            this.total = this.basal.sick_basal.day_total.toFixed(2);
            this.sickBasal = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getPdmSG(this.data.basal_settings.sick_basal.seg);

            this.axisMaxArr[5] = this.getAxisMax(this.data.basal_settings.program_c_basal.seg);
            this.axisMaxArr[6] = this.getAxisMax(this.data.basal_settings.program_d_basal.seg);
            this.axisMaxArr[7] = this.getAxisMax(this.data.basal_settings.sick_basal.seg);
          }

          for (var _i4 = 0; _i4 < this.basalSeg.length; _i4++) {
            if (_i4 < 12) {
              this.bsg1.push(this.basalSeg[_i4]);
            } else if (_i4 < 24) {
              this.bsg2.push(this.basalSeg[_i4]);
            } else if (_i4 < 36) {
              this.bsg3.push(this.basalSeg[_i4]);
            } else {
              this.bsg4.push(this.basalSeg[_i4]);
            }
          }

          this.basalInfo[0].total = this.basal.stand_basal.day_total.toFixed(2);;
          this.basalInfo[0].title = this.$t('Standard');
          this.standardSeg = this.basal.stand_basal.seg;

          this.basalInfo[1].total = this.basal.exer_basal.day_total.toFixed(2);;
          this.basalInfo[1].title = this.$t('Exercise');
          this.exerSeg = this.basal.exer_basal.seg;

          this.basalInfo[2].total = this.basal.holiday_basal.day_total.toFixed(2);;
          this.basalInfo[2].title = this.$t('Holiday');
          this.holidaySeg = this.basal.holiday_basal.seg;

          this.basalInfo[3].total = this.basal.program_a_basal.day_total.toFixed(2);;
          this.basalInfo[3].title = this.$t('ProgramA');
          this.programASeg = this.basal.program_a_basal.seg;

          this.basalInfo[4].total = this.basal.program_b_basal.day_total.toFixed(2);;
          this.basalInfo[4].title = this.$t('ProgramB');
          this.programBSeg = this.basal.program_b_basal.seg;

          if (this.moreBasal) {
            this.basalInfo[5].total = this.basal.program_c_basal.day_total.toFixed(2);;
            this.basalInfo[5].title = this.$t('t1028_Pattern_C');
            this.programCSeg = this.basal.program_c_basal.seg;

            this.basalInfo[6].total = this.basal.program_d_basal.day_total.toFixed(2);;
            this.basalInfo[6].title = this.$t('t1028_Pattern_D');
            this.programDSeg = this.basal.program_d_basal.seg;

            this.basalInfo[7].total = this.basal.sick_basal.day_total.toFixed(2);;
            this.basalInfo[7].title = this.$t('t1029_Sick');
            this.sickSeg = this.basal.sick_basal.seg;
          } else {
            this.basalInfo.splice(5, 3);
          }

          var segName = ['standardSeg', 'exerSeg', 'holidaySeg', 'programASeg', 'programBSeg', 'programCSeg', 'programDSeg', 'sickSeg'];
          if (!this.moreBasal) {
            segName.splice(5, 3);
          }

          for (var n = 0; n < segName.length; n++) {
            this.basalInfo[n].bsg1 = [];
            this.basalInfo[n].bsg2 = [];
            this.basalInfo[n].bsg3 = [];
            this.basalInfo[n].bsg4 = [];

            this.basalInfo[n].bsg2show = false;
            this.basalInfo[n].bsg3show = false;
            this.basalInfo[n].bsg4show = false;
          }

          for (var _n = 0; _n < segName.length; _n++) {
            var curSeg = this[segName[_n]];
            curSeg = curSeg.map(function (e, i) {
              return [e[0], e[1].toFixed(2)];
            });
            for (var _i5 = 0; _i5 < curSeg.length; _i5++) {
              if (_i5 < 12) {
                this[segName[_n] + '1'].push(curSeg[_i5]);
                this.basalInfo[_n].bsg1.push(curSeg[_i5]);
              } else if (_i5 < 24) {
                this[segName[_n] + '2'].push(curSeg[_i5]);
                this.basalInfo[_n].bsg2.push(curSeg[_i5]);
                this.basalInfo[_n].bsg2show = true;
              } else if (_i5 < 36) {
                this[segName[_n] + '3'].push(curSeg[_i5]);
                this.basalInfo[_n].bsg3.push(curSeg[_i5]);
                this.basalInfo[_n].bsg3show = true;
              } else {
                this[segName[_n] + '4'].push(curSeg[_i5]);
                this.basalInfo[_n].bsg4.push(curSeg[_i5]);
                this.basalInfo[_n].bsg4show = true;
              }
            }
          }

          this.bolus = this.data.bolus_settings;
          this.IcRatio = this.data.bolus_settings.ins_carb_ratio;
          this.ins_sen = this.data.bolus_settings.ins_sen;
          this.bg_target = this.data.bolus_settings.bg_target;
          this.bolus_rem = this.data.bolus_settings.bolus_reminder;

          this.userset = this.data.user_settings;
          this.userset.sensor_sn = this.userset.sensor_sn ? this.userset.sensor_sn : '--';
          this.userset.user_name = this.userset.user_name ? this.userset.user_name : '--';
          this.userset.sensor_expire_option = this.userset.sensor_expire_option ? this.$t(this.userset.sensor_expire_option) : '--';
          this.userset.pump_sn = this.userset.pump_sn ? this.userset.pump_sn : '--';
          this.userset.alarm_type = this.userset.alarm_type ? this.$t(this.userset.alarm_type) : '--';
          this.userset.low_reservoir_time = this.userset.low_reservoir_type === 'time' ? this.userset.low_reservoir_time : this.$t(this.userset.low_reservoir_type) + ' ' + this.userset.low_reservoir_ins + ins_unit2;
          var opt = this.userset.patch_expire_alarm;
          this.userset.patch_expire_alarm = opt === 'On' ? this.$t(opt) + ' ' + this.userset.patch_expire_ahead + 'H' : this.$t(opt);
          this.userset.auto_off_option = this.userset.auto_off_option === 'On' ? this.$t(this.userset.auto_off_option) + ' ' + this.userset.auto_off_time + 'H' : this.$t(this.userset.auto_off_option);
          this.userset.pre_suspend_on_lowbg_option = this.userset.pre_suspend_on_lowbg_option === 'On' ? this.$t(this.userset.pre_suspend_on_lowbg_option) + ' ' + this.userset.pre_suspend_on_lowbg_level : this.$t(this.userset.pre_suspend_on_lowbg_option);
          if (this.userset.clock) {
            var that = this;
            this.userset.clock.map(function (e, i) {
              e[1] = that.$t(e[1]);
            });
          }

          this.userset.suspend_on_lowbg_option = this.$t(this.userset.suspend_on_lowbg_option);
          if (this.userset.suspend_on_lowbg_option === this.$t('On')) {
            this.userset.suspend_on_lowbg_level = this.isMg ? parseInt(this.userset.suspend_on_lowbg_level) : this.userset.suspend_on_lowbg_level.toFixed(1);
          }

          if (this.userset.auto_basal) {
            var auto_basal = this.userset.auto_basal;

            auto_basal.autobasalflag = this.getOptionText(auto_basal.autobasalflag);

            if (this.isMg) {
              if (0 == auto_basal.BGTarget) {
                auto_basal.BGTarget = '100 mg/dL';
              } else if (1 == auto_basal.BGTarget) {
                auto_basal.BGTarget = '110 mg/dL';
              } else if (2 == auto_basal.BGTarget) {
                auto_basal.BGTarget = '120 mg/dL';
              }
            } else {
              if (0 == auto_basal.BGTarget) {
                auto_basal.BGTarget = '5.6 mmol/L';
              } else if (1 == auto_basal.BGTarget) {
                auto_basal.BGTarget = '6.1 mmol/L';
              } else if (2 == auto_basal.BGTarget) {
                auto_basal.BGTarget = '6.7 mmol/L';
              }
            }
            auto_basal.nFoodFlag = this.getOptionText(auto_basal.nFoodFlag);

            if (!auto_basal.AutoBasalWeight) {
              auto_basal.AutoBasalWeight = '--';
            }
            if (!auto_basal.AutoBasalTDD) {
              auto_basal.AutoBasalTDD = '--';
            }
          } else {
            this.userset.auto_basal = {};
          }

          var option = this.$t(this.data.bolus_settings.bolus_reminder_option);
          this.maxBolOption = ' (' + option + ')';

          this.pumpSN = this.userset.pump_sn ? this.userset.pump_sn : '--';
          this.tranSN = this.userset.sensor_sn ? this.userset.sensor_sn : '--';
          this.pumpSN = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].deviceSNFormat(this.pumpSN, 'PUMP');
          this.tranSN = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].deviceSNFormat(this.tranSN, 'TRANS');

          this.userset.clock.map(function (e, i) {
            var time = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getTime2(e[0]);
            e[0] = time[0] + ":" + time[1];
            return e;
          });

          this.cgm = this.data.sensor_settings;
          if (this.cgm.sensor_rate_alarm) {
            this.cgm.sensor_rate_alarm.fall[1] = this.cgm.sensor_rate_alarm.fall[0] !== "Off" ? this.cgm.sensor_rate_alarm.fall[1].toFixed(3) : '--';
            this.cgm.sensor_rate_alarm.rise[1] = this.cgm.sensor_rate_alarm.rise[0] !== "Off" ? this.cgm.sensor_rate_alarm.rise[1].toFixed(3) : '--';
          }
          if (this.cgm.sensor_alarm_repeat) {
            this.cgm.sensor_alarm_repeat.high[1] = this.cgm.sensor_alarm_repeat.high[0] !== "Off" ? this.cgm.sensor_alarm_repeat.high[1] : '--';
            this.cgm.sensor_alarm_repeat.low[1] = this.cgm.sensor_alarm_repeat.low[0] !== "Off" ? this.cgm.sensor_alarm_repeat.low[1] : '--';
          }
          if (this.cgm.sensor_forecast_alarm) {
            this.cgm.sensor_forecast_alarm.high[1] = this.cgm.sensor_forecast_alarm.high[0] !== "Off" ? this.cgm.sensor_forecast_alarm.high[1] : '--';
            this.cgm.sensor_forecast_alarm.low[1] = this.cgm.sensor_forecast_alarm.low[0] !== "Off" ? this.cgm.sensor_forecast_alarm.low[1] : '--';
          }
          this.cgm.sensor_alarm_settings.calib_remind_time = this.cgm.sensor_alarm_settings.calib_remind_option !== 'Off' ? this.cgm.sensor_alarm_settings.calib_remind_time : "--";
          this.cgm.sensor_alarm_settings.calib_remind_interval = this.cgm.sensor_alarm_settings.auto_calib_option !== 'Off' ? this.cgm.sensor_alarm_settings.calib_remind_interval : "--";
          this.cgmLimit = this.cgm.sensor_alarm_threshold;

          var basal_select_map = {
            'ProgramC': 't1028_Pattern_C',
            'ProgramD': 't1028_Pattern_D',
            'Sick': 't1029_Sick'
          };
          if (basal_select_map[this.basal.basal_select]) {
            this.basal.basal_select = basal_select_map[this.basal.basal_select];
          }
          this.basal.basal_select = this.$t(this.basal.basal_select);
          this.basal.basal_onoff = this.$t(this.basal.basal_onoff);
          this.bolus.bg_reminder = this.$t(this.bolus.bg_reminder);
          this.bolus.extent_option = this.$t(this.bolus.extent_option);
          this.bolus.bolus_wizard = this.$t(this.bolus.bolus_wizard);
          this.userset.cgms_module_flag = this.$t(this.userset.cgms_module_flag);
          this.userset.cmd_response = this.$t(this.userset.cmd_response);
          this.userset.clock_option = this.$t(this.userset.clock_option);
          this.userset.pump_module_flag = this.$t(this.userset.pump_module_flag);

          this.cgm.sensor_rate_alarm.fall[0] = this.$t(this.cgm.sensor_rate_alarm.fall[0]);
          this.cgm.sensor_rate_alarm.rise[0] = this.$t(this.cgm.sensor_rate_alarm.rise[0]);
          this.cgm.sensor_alarm_repeat.high[0] = this.$t(this.cgm.sensor_alarm_repeat.high[0]);
          this.cgm.sensor_alarm_repeat.low[0] = this.$t(this.cgm.sensor_alarm_repeat.low[0]);
          this.cgm.sensor_forecast_alarm.high[0] = this.$t(this.cgm.sensor_forecast_alarm.high[0]);
          this.cgm.sensor_forecast_alarm.low[0] = this.$t(this.cgm.sensor_forecast_alarm.low[0]);
          this.cgm.sensor_alarm_settings.calib_remind_option = this.$t(this.cgm.sensor_alarm_settings.calib_remind_option);
          this.cgm.sensor_alarm_option = this.$t(this.cgm.sensor_alarm_option);
          this.cgm.alarm_silent_option = this.$t(this.cgm.alarm_silent_option);
          if (this.chart6_1) {
            this.chart6_1.dispose();
          }
          if (this.chart6_2) {
            this.chart6_2.dispose();
          }
          if (this.chart6_3) {
            this.chart6_3.dispose();
          }
          if (this.chart6_4) {
            this.chart6_4.dispose();
          }
          if (this.chart6_5) {
            this.chart6_5.dispose();
          }

          if (this.moreBasal) {
            if (this.chart6_6) {
              this.chart6_6.dispose();
            }
            if (this.chart6_7) {
              this.chart6_7.dispose();
            }
            if (this.chart6_8) {
              this.chart6_8.dispose();
            }
          }

          this.drawChart6_1('chart6_1', this.standBasal, this.$t('Standard'), this.axisMaxArr[0]);
          this.drawChart6_1('chart6_2', this.exeBasal, this.$t('Exercise'), this.axisMaxArr[1]);
          this.drawChart6_1('chart6_3', this.holidayBasal, this.$t('Holiday'), this.axisMaxArr[2]);
          this.drawChart6_1('chart6_4', this.programA, this.$t('ProgramA'), this.axisMaxArr[3]);
          this.drawChart6_1('chart6_5', this.programB, this.$t('ProgramB'), this.axisMaxArr[4]);
          if (this.moreBasal) {
            this.drawChart6_1('chart6_6', this.programC, this.$t('t1028_Pattern_C'), this.axisMaxArr[5]);
            this.drawChart6_1('chart6_7', this.programD, this.$t('t1028_Pattern_D'), this.axisMaxArr[6]);
            this.drawChart6_1('chart6_8', this.sickBasal, this.$t('t1029_Sick'), this.axisMaxArr[7]);
          }
        }
      });
    },
    drawChart6_1: function drawChart6_1(chartId, basalPattern, chartTitle, axisMax) {
      this[chartId] = __WEBPACK_IMPORTED_MODULE_1_echarts__["init"](document.getElementById(chartId));

      this[chartId].setOption({
        title: {
          text: chartTitle + ' ' + this.$t('basal_unit'),
          textStyle: this.textStyle,
          padding: this.titlePadding
        },
        xAxis: [{
          type: 'time',
          boundaryGap: false,
          min: new Date(new Date().setHours(0, 0, 0, 0)),
          max: new Date(new Date().setHours(0, 0, 0, 0) + 86400000),
          axisLine: { lineStyle: { color: '#ccc' } },
          splitNumber: 24,
          splieLine: { show: true },
          axisLabel: {
            showMaxLabel: true,
            margin: 20, textStyle: { color: '#282828', baseline: 'middle' },
            formatter: function formatter(value, index) {
              var zero_hour = new Date();
              zero_hour.setHours(0, 0, 0, 0);
              index = (value - zero_hour.getTime()) / 3600000;
              var H = index;
              if (index < 24) {
                if (index % 3 === 0) {
                  H = H < 10 ? '0' + H + ':00' : H + ':00';
                  return H;
                } else {
                  return ' ';
                }
              } else {
                return '24:00';
              }
            }
          }
        }],
        yAxis: [{
          type: 'value',
          min: 0,
          max: axisMax,
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          boundaryGap: false,
          axisTick: { length: 0 },
          splitLine: { show: true },
          splitNumber: 2
        }],
        grid: this.grid,
        series: [{
          type: 'line',
          step: 'end',

          data: basalPattern,
          itemStyle: { normal: {
              color: '#0e0'
            } },
          symbolSize: 1
        }]
      });
    },
    printPdf: function printPdf() {
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].print_page();
    }
  },
  mounted: function mounted() {
    self.document.title = this.$t('Device Settings Report');
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isDe = lang === 'de' || lang === 'it' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    this.unit1 = this.isMg ? 'mg/dL' : 'mmol/L';
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }
    var pdm = sessionStorage.getItem('qPdm').split(',');
    this.pdmSN = pdm[1];
    if ('EasyPatch' == this.pdmSN) {
      this.pdmTitle = 'APP';
    } else {
      this.pdmTitle = this.$t('pdm');
    }
    this.rid = parseInt(sessionStorage.getItem('qRid'));
    var ti = pdm[0].split(' ');
    var tt = ti[0].split('-');
    this.time = tt[0] + '/' + tt[1] + '/' + tt[2] + ' ' + ti[1];
    this.getStatics();
    this.getPdm2();
    var first = parseInt(sessionStorage.getItem('qFirst8'));
    if (first === 1) {
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].checkPrint(this, 9, 8);
    }
  }
});

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_format__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_base64__ = __webpack_require__(9);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      uid: 0, et: 0, st: 0, time: '', isEn: false, foodCoor: '', unit: '', isMg: '', glucoseUnit: '', ts: [], hypo: 3.1, high: 10.0, low: 5.6, isDe: false, isIt: false,
      statics: {}, devices: ['--', '--', '--'], hb1c: ['--'], target: '', avg: '--', active: '--', seg: ['--', '--', '--', '--'], sd: '--', cv: '--',


      bgAvg: '--',
      bgSD: '--',
      bgNum: '--',

      sgAvg: '--',
      sgSD: '--',
      sgNum: '--',

      insAvg: '--', insSD: '--', insNum: '--',
      carbAvg: '--', carbSD: '--', carbNum: '--',
      exerAvg: '--', exerSD: '--', exerNum: '--',

      est_a1c: '--',
      a1c_available: false,

      calibPerDay: '--',
      bgPerDay: '--',

      highLevelText: '--',
      lowLevelText: '--',

      aucu: '--',
      aucl: '--',

      sgHighest: '--',
      sgLowest: '--',

      sgDistPie: {},
      sgDistPieLabels: ['--', '--', '--', '--'],

      insPieData: [],

      basalPercent: '--',
      bolusPercent: '--',
      avgBolusNum: '--',
      avgSuspendTime: '--',

      avgManualBolus: '--',
      avgManualNormalBolus: '--',
      avgManualExtendBolus: '--',
      avgManualComboBolus: '--',

      avgWizzardBolus: '--',
      avgFoodWizzardBolus: '--',
      avgCorrWizzardBolus: '--',
      avgWizzardOverrideAdd: '--',
      avgWizzardOverrideSub: '--',

      autoModeSGDistPie: {},

      autoModeSGDistPieLabels: [this.$t('t1103_Time_below_range'), this.$t('t1103_Time_in_target_range'), this.$t('t1103_Time_above_range')],

      autoModeExitCauseNoSensorReadings: 0,
      autoModeExitCauseMaxDelivery: 0,
      autoModeExitCauseMinDelivery: 0,

      textStyle: {
        color: '#282828',
        fontWeight: 'normal',
        fontSize: '14',
        fontFamily: 'SFUIText-Regular'
      },
      titlePadding: [0, 0, 8, 33],
      grid: { x: '4%', y: '16%', width: '90%', height: '50%' },
      sgMax: 25,
      yAxisLabel: { interval: 0, margin: 5, textStyle: { color: '#282828', baseline: 'middle' }, showMinLabel: false },

      chart5NoData: false,
      chart6NoData: false,
      chart7NoData: false
    };
  },


  methods: {
    getStatics: function getStatics(param) {
      this.$http.get('api/v2.1/report/' + this.uid + '/data/sa', { params: { param: param } }).then(function (res) {
        var err = res.body.error;

        if (err === 0) {
          var data = res.data.data;
          data.medical_history = data.medical_history ? this.$t(data.medical_history) : "--";
          this.statics = data;
          this.devices = data.devices ? data.devices : this.devices;
          if ('EasyPatch' == this.devices[0]) {
            document.getElementById('reportPdmTitle').innerHTML = 'APP';
          }
          this.hb1c = data.hba1cList ? data.hba1cList : this.hb1c;
        }
      }, function (err) {
        var tip = this.$t('tryAgain');
        this.$message.error(tip);
      });
    },
    getData: function getData() {
      this.ts = __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getTs(this.st, this.et);

      var param = {
        sg: { ts: this.ts },
        basal: { ts: this.ts },
        bolus: { ts: this.ts },
        event: { ts: this.ts },
        calib: { ts: this.ts },
        custom: {
          usemode: 'sa',
          ts: [this.st, this.et]
        }
      };
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getDashboard(this, this.uid, param);
    },
    drawChart1_7: function drawChart1_7() {
      function genData(count) {
        var nameList = ['赵', '钱', '孙', '李', '周', '吴', '郑', '王', '冯', '陈', '褚', '卫', '蒋', '沈', '韩', '杨', '朱', '秦', '尤', '许', '何', '吕', '施', '张', '孔', '曹', '严', '华', '金', '魏', '陶', '姜', '戚', '谢', '邹', '喻', '柏', '水', '窦', '章', '云', '苏', '潘', '葛', '奚', '范', '彭', '郎', '鲁', '韦', '昌', '马', '苗', '凤', '花', '方', '俞', '任', '袁', '柳', '酆', '鲍', '史', '唐', '费', '廉', '岑', '薛', '雷', '贺', '倪', '汤', '滕', '殷', '罗', '毕', '郝', '邬', '安', '常', '乐', '于', '时', '傅', '皮', '卞', '齐', '康', '伍', '余', '元', '卜', '顾', '孟', '平', '黄', '和', '穆', '萧', '尹', '姚', '邵', '湛', '汪', '祁', '毛', '禹', '狄', '米', '贝', '明', '臧', '计', '伏', '成', '戴', '谈', '宋', '茅', '庞', '熊', '纪', '舒', '屈', '项', '祝', '董', '梁', '杜', '阮', '蓝', '闵', '席', '季', '麻', '强', '贾', '路', '娄', '危'];
        var legendData = [];
        var seriesData = [];
        var selected = {};
        for (var i = 0; i < count; i++) {
          var name = Math.random() > 0.65 ? makeWord(4, 1) + '·' + makeWord(3, 0) : makeWord(2, 1);
          legendData.push(name);
          seriesData.push({
            name: name,
            value: Math.round(Math.random() * 100000)
          });
          selected[name] = i < 6;
        }

        return {
          legendData: legendData,
          seriesData: seriesData,
          selected: selected
        };

        function makeWord(max, min) {
          var nameLen = Math.ceil(Math.random() * max + min);
          var name = [];
          for (var i = 0; i < nameLen; i++) {
            name.push(nameList[Math.round(Math.random() * nameList.length - 1)]);
          }
          return name.join('');
        }
      }

      var data = genData(4);
      data = {
        'legendData': ['high', 'target', 'low', 'hypo'],
        'selected': { 'hypo': true, 'low': true, 'target': true, 'high': true },
        'seriesData': [{ name: 'high', value: 40 }, { name: 'target', value: 25 }, { name: 'low', value: 20 }, { name: 'hypo', value: 15 }]
      };
      data = this.autoModeSGDistPie;
      var autoModeSGDistPieLabels = this.autoModeSGDistPieLabels;
      console.log('dataNum:', data);
      if (!data.dataNum) {
        this.chart7NoData = true;
      }


      var that = this;
      this.chart1_7 = __WEBPACK_IMPORTED_MODULE_1_echarts__["init"](document.getElementById('chart1_7'));
      this.chart1_7.setOption({
        title: {
          text: '',
          subtext: '',
          x: 'center'
        },
        tooltip: {
          trigger: 'item',

          formatter: function formatter(params, ticket, callback) {
            return params.percent.toFixed() + '%';
          }
        },
        legend: {
          show: false,
          selectedMode: false,
          orient: 'vertical',
          right: 10,

          bottom: 40,
          data: data.legendData,
          formatter: function formatter(name) {
            if ('high' == name) {
              return autoModeSGDistPieLabels[2];
            } else if ('target' == name) {
              return autoModeSGDistPieLabels[1];
            } else if ('low' == name) {
              return autoModeSGDistPieLabels[0];
            }
            return name;
          }

        },

        series: [{
          name: 'sg_dist',
          label: {
            normal: {
              position: 'outside',

              color: '#000',

              formatter: function formatter(data) {
                var range = '';
                var name = data.name;
                if ('high' == name) {
                  range = autoModeSGDistPieLabels[2];
                } else if ('target' == name) {
                  range = autoModeSGDistPieLabels[1];
                } else if ('low' == name) {
                  range = autoModeSGDistPieLabels[0];
                }

                return range + ': ' + data.percent.toFixed() + '%';
              },

              rich: {
                aa: {
                  color: '#000',
                  fontSize: 18
                }
              }
            }

          },
          labelLine: {
            normal: {
              lineStyle: {
                color: '#000'
              }
            }
          },
          type: 'pie',
          radius: '65%',
          center: ['50%', '50%'],
          data: data.seriesData,

          color: ['rgba(255,170,0,1)', 'rgba(42,222,154,1)', 'rgba(254,102,102,1)', 'rgba(255,38,38,1)'],
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }

          }
        }]
      });
    },
    drawChart1_6: function drawChart1_6() {

      var data = [{ value: 6.75, name: 'Bolus' }, { value: 3.25, name: 'Basal' }];
      data = this.insPieData;
      var ins_unit2 = this.$t('ins_unit2');

      var that = this;
      this.chart1_6 = __WEBPACK_IMPORTED_MODULE_1_echarts__["init"](document.getElementById('chart1_6'));
      this.chart1_6.setOption({
        tooltip: {
          trigger: 'item',

          formatter: function formatter(params, ticket, callback) {
            return params.percent.toFixed(1) + '%';
          }
        },

        series: [{
          name: 'insulin_usage',
          type: 'pie',
          radius: ['40%', '60%'],
          center: ['45%', '45%'],
          avoidLabelOverlap: false,
          label: {
            normal: {
              show: true,
              position: 'outside',

              formatter: function formatter(params, ticket, callback) {
                return params.name + '\n' + params.value + ins_unit2 + ', ' + params.percent.toFixed(1) + '%';
              }
            },
            emphasis: {
              show: true,
              textStyle: {}
            }

          },
          labelLine: {
            normal: {
              show: false,
              length: 10,
              length2: 15
            }
          },
          color: ['rgba(38,95,156,1)', 'rgba(123,168,220,1)'],
          data: data
        }]
      });
    },
    drawChart1_5: function drawChart1_5() {
      function genData(count) {
        var nameList = ['赵', '钱', '孙', '李', '周', '吴', '郑', '王', '冯', '陈', '褚', '卫', '蒋', '沈', '韩', '杨', '朱', '秦', '尤', '许', '何', '吕', '施', '张', '孔', '曹', '严', '华', '金', '魏', '陶', '姜', '戚', '谢', '邹', '喻', '柏', '水', '窦', '章', '云', '苏', '潘', '葛', '奚', '范', '彭', '郎', '鲁', '韦', '昌', '马', '苗', '凤', '花', '方', '俞', '任', '袁', '柳', '酆', '鲍', '史', '唐', '费', '廉', '岑', '薛', '雷', '贺', '倪', '汤', '滕', '殷', '罗', '毕', '郝', '邬', '安', '常', '乐', '于', '时', '傅', '皮', '卞', '齐', '康', '伍', '余', '元', '卜', '顾', '孟', '平', '黄', '和', '穆', '萧', '尹', '姚', '邵', '湛', '汪', '祁', '毛', '禹', '狄', '米', '贝', '明', '臧', '计', '伏', '成', '戴', '谈', '宋', '茅', '庞', '熊', '纪', '舒', '屈', '项', '祝', '董', '梁', '杜', '阮', '蓝', '闵', '席', '季', '麻', '强', '贾', '路', '娄', '危'];
        var legendData = [];
        var seriesData = [];
        var selected = {};
        for (var i = 0; i < count; i++) {
          var name = Math.random() > 0.65 ? makeWord(4, 1) + '·' + makeWord(3, 0) : makeWord(2, 1);
          legendData.push(name);
          seriesData.push({
            name: name,
            value: Math.round(Math.random() * 100000)
          });
          selected[name] = i < 6;
        }

        return {
          legendData: legendData,
          seriesData: seriesData,
          selected: selected
        };

        function makeWord(max, min) {
          var nameLen = Math.ceil(Math.random() * max + min);
          var name = [];
          for (var i = 0; i < nameLen; i++) {
            name.push(nameList[Math.round(Math.random() * nameList.length - 1)]);
          }
          return name.join('');
        }
      }

      var data = genData(4);
      data = {
        'legendData': ['high', 'target', 'low', 'hypo'],
        'selected': { 'hypo': true, 'low': true, 'target': true, 'high': true },
        'seriesData': [{ name: 'high', value: 40 }, { name: 'target', value: 25 }, { name: 'low', value: 20 }, { name: 'hypo', value: 15 }]
      };
      data = this.sgDistPie;
      var sgDistPieLabels = this.sgDistPieLabels;
      console.log('dataNum:', data);
      if (!data.dataNum) {
        this.chart5NoData = true;
        return;
      }


      var that = this;
      this.chart1_5 = __WEBPACK_IMPORTED_MODULE_1_echarts__["init"](document.getElementById('chart1_5'));
      this.chart1_5.setOption({
        title: {
          text: '',
          subtext: '',
          x: 'center'
        },
        tooltip: {
          trigger: 'item',

          formatter: function formatter(params, ticket, callback) {
            return params.percent.toFixed(1) + '%';
          }
        },
        legend: {
          show: false,
          selectedMode: false,
          orient: 'vertical',
          right: 10,

          bottom: 40,
          data: data.legendData,
          formatter: function formatter(name) {
            if ('high' == name) {
              return sgDistPieLabels[3];
            } else if ('target' == name) {
              return sgDistPieLabels[2];
            } else if ('low' == name) {
              return sgDistPieLabels[1];
            } else if ('hypo' == name) {
              return sgDistPieLabels[0];
            }
            return name;
          }

        },

        series: [{
          name: 'sg_dist',
          label: {
            normal: {
              position: 'outside',

              color: '#000',

              formatter: function formatter(data) {
                var range = '';
                var name = data.name;
                if ('high' == name) {
                  range = sgDistPieLabels[3];
                } else if ('target' == name) {
                  range = sgDistPieLabels[2];
                } else if ('low' == name) {
                  range = sgDistPieLabels[1];
                } else if ('hypo' == name) {
                  range = sgDistPieLabels[0];
                }

                return range + ': ' + data.percent.toFixed(1) + '%';
              },

              rich: {
                aa: {
                  color: '#000',
                  fontSize: 18
                }
              }
            }

          },
          labelLine: {
            normal: {
              lineStyle: {
                color: '#000'
              }
            }
          },
          type: 'pie',
          radius: '65%',
          center: ['50%', '50%'],
          data: data.seriesData,

          color: ['rgba(255,170,0,1)', 'rgba(42,222,154,1)', 'rgba(254,102,102,1)', 'rgba(255,38,38,1)'],
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }

          }
        }]
      });
    },
    drawChart1_4: function drawChart1_4() {
      var sel_time = new Date(2019, 0, 1).getTime();

      if (false) {
        this.XData = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];
        this.YData10P = [];
        this.YDataQ1 = [];
        this.YDataQ3 = [];
        this.YData90P = [];
        var first_time = sel_time + 5 * 60 * 1000;
        for (var i = 0; i < 144; i++) {
          this.YDataMin.push([first_time + i * 60 * 10 * 1000, 2, 2]);
          this.YData10P.push([first_time + i * 60 * 10 * 1000, 4, 2]);
          this.YDataQ1.push([first_time + i * 60 * 10 * 1000, 2, 2]);
          this.YDataMed.push([first_time + i * 60 * 10 * 1000, 2, 2]);
          this.YDataQ3.push([first_time + i * 60 * 10 * 1000, 2, 2]);
          this.YData90P.push([first_time + i * 60 * 10 * 1000, 4, 2]);
          this.YDataMax.push([first_time + i * 60 * 10 * 1000, 2, 2]);
        }
      }

      this.XTimeMin = sel_time;
      this.XTimeMax = sel_time + 86400 * 1000;

      var t_min_max = this.$t('t1103_Min_Max');
      var t_target_range = this.$t('t1103_Target_Range');

      var that = this;
      this.chart1_4 = __WEBPACK_IMPORTED_MODULE_1_echarts__["init"](document.getElementById('chart1_4'));

      this.chart1_4.setOption({
        title: {
          text: this.isMg ? this.$t('Sensor Glucose Profile') + ' \nmg/dL' : this.$t('Sensor Glucose Profile') + ' \nmmol/L',
          textStyle: this.textStyle,
          padding: this.titlePadding
        },
        tooltip: {
          trigger: 'axis',

          axisPointer: {
            label: {
              backgroundColor: '#6a7985'
            }
          },

          formatter: function formatter(params, ticket, callback) {
            if (params instanceof Array) {
              var minuteFormat = function minuteFormat(minute) {
                var h = Math.floor(minute / 60);
                var m = Math.floor(minute % 60);
                if (h < 10) {
                  h = '0' + h;
                }
                if (m < 10) {
                  m = '0' + m;
                }
                return h + ':' + m;
              };

              var paramSize = params.length;
              var strMinute = params[0].axisValueLabel;
              var strTooptip = strMinute.slice(0, 5);
              var t = new Date(params[0].axisValue);
              var minute = t.getHours() * 60 + t.getMinutes();
              var startMinute = minute - 5;
              var endMinute = minute + 5;

              strTooptip = minuteFormat(startMinute) + ' ~ ' + minuteFormat(endMinute);

              for (var _i = paramSize - 1; _i >= 0; _i--) {
                var series = params[_i];
                strTooptip += '<br/>' + series.seriesName + ': ' + series.value[2];
              }
              return strTooptip;
            }
            return 'Loading';
          }
        },
        xAxis: [{
          type: 'time',

          interval: 3600 * 1000,
          min: this.XTimeMin,
          max: this.XTimeMax,
          splitNumber: 24,

          axisLabel: {
            showMaxLabel: true,
            margin: 10, textStyle: { color: '#282828', baseline: 'middle' },
            formatter: function formatter(value, index) {
              index = (value - that.XTimeMin) / 3600000;
              var H = index;

              if (index < 24) {
                if (index % 3 === 0) {
                  H = H < 10 ? '0' + H + ':00' : H + ':00';
                  return H;
                } else {
                  return ' ';
                }
              } else {
                return '24:00';
              }
            }
          },
          axisLine: { lineStyle: { color: '#ccc' } }
        }],

        yAxis: [{
          type: 'value',
          min: 0,
          max: this.sgMax,
          axisLabel: this.yAxisLabel,
          axisLine: { lineStyle: { color: '#ccc' } },
          boundaryGap: false,
          axisTick: { length: 0 }
        }, {
          type: 'value',
          min: 0,
          max: this.sgMax,
          axisLabel: { show: false },
          axisLine: { lineStyle: { color: '#ccc' } },
          boundaryGap: false,
          axisTick: { length: 0 }
        }],
        grid: this.grid,

        legend: {
          selectedMode: false,
          itemWidth: 40,
          itemHeight: 15,
          itemGap: 25,
          symbolKeepAspect: false,

          bottom: 10,
          formatter: function formatter(name) {
            if ('50%' == name) {
              return '50%';
            } else if ('25%' == name) {
              return '25% - 75%';
            } else if ('10%' == name) {
              return '10% - 90%';
            } else if ('Min' == name) {
              return t_min_max;
            } else if ('Max' == name) {
              return t_target_range;
            }

            return name;
          },

          data: [{
            name: '50%', icon: 'image://static/dashboardLegend/Medium.png'
          }, {
            name: '25%', icon: 'image://static/dashboardLegend/IQR.png'
          }, {
            name: '10%', icon: 'image://static/dashboardLegend/10_90.png'
          }, {
            name: 'Min', icon: 'image://static/dashboardLegend/Min_Max.png'
          }, {
            name: 'Max', icon: 'image://static/dashboardLegend/TargetRange.png'
          }]
        },
        series: [{
          name: 'Min',
          type: 'line',

          data: this.YDataMin,
          stack: 'total',
          lineStyle: {
            normal: {
              color: '#979797',
              width: 1,
              type: 'dashed'
            }
          },
          symbol: 'none',
          markArea: {
            data: [[{ yAxis: this.isMg ? this.target_low * 18 : this.target_low }, { yAxis: this.isMg ? this.target_high * 18 : this.target_high }]],
            tooltip: { show: false },
            itemStyle: {
              normal: {
                color: 'rgba(211,255,213,0.6)'
              }
            }
          }
        }, {
          name: '10%',
          type: 'line',

          data: this.YData10P,
          stack: 'total',

          symbol: 'none',
          lineStyle: {
            normal: {
              color: 'rgba(140, 201, 239, 0.5)',
              width: 1
            }
          }

        }, {
          name: '25%',
          type: 'line',

          data: this.YDataQ1,
          stack: 'total',
          areaStyle: {
            normal: {
              color: 'rgba(140, 201, 239, 0.5)'
            }
          },
          lineStyle: {
            normal: {
              color: 'rgba(62, 176, 245, 0.6)',
              width: 1
            }
          },
          symbol: 'none'

        }, {
          name: '50%',
          type: 'line',

          data: this.YDataMed,
          stack: 'total',
          areaStyle: {
            normal: { color: 'rgba(62, 176, 245, 0.6)' }
          },
          lineStyle: {
            normal: {
              color: '#505050',
              width: 1
            }
          },
          symbol: 'none'
        }, {
          name: '75%',
          type: 'line',

          data: this.YDataQ3,
          stack: 'total',
          areaStyle: { normal: { color: 'rgba(62, 176, 245, 0.6)' } },
          lineStyle: {
            normal: {
              color: 'rgba(62, 176, 245, 0.6)',
              width: 1
            }
          },
          symbol: 'none'
        }, {
          name: '90%',
          type: 'line',

          data: this.YData90P,
          stack: 'total',
          areaStyle: { normal: { color: 'rgba(140, 201, 239, 0.5)' } },
          lineStyle: {
            normal: {
              color: 'rgba(62, 176, 245, 0.6)',
              width: 1
            }
          },
          symbol: 'none'
        }, {
          name: 'Max',
          type: 'line',

          data: this.YDataMax,
          stack: 'total',
          lineStyle: {
            normal: {
              color: '#979797',
              width: 1,
              type: 'dashed'
            }
          },
          symbol: 'none'
        }]
      });
    },
    drawCharts: function drawCharts() {
      this.drawChart1_4();
      this.drawChart1_5();
      this.drawChart1_6();
      this.drawChart1_7();
    },
    analySg: function analySg() {
      var sg = JSON.parse(sessionStorage.getItem('sg7')),
          validSg = [],
          totalCount = 0,
          that = this;

      sg.map(function (e, i) {
        var length = e.length;
        if (length > 0) {
          totalCount += length;
          e.map(function (e1, i1) {
            if (e1[4] === 'C' || e1[4] === 'NC') {
              e1[3] = e1[3] > 22.2 ? 22.2 : e1[3];
              e1[3] = e1[3] < 2.2 ? 2.2 : e1[3];
              validSg.push(e1[3]);
            }
          });
        }
      });
      var length1 = validSg.length;
      if (totalCount > 0 && length1 > 0) {
        var totalSg = 0,
            Seg = [0, 0, 0, 0];
        var high = this.isMg ? parseFloat((this.high / 18).toFixed(1)) : this.high;
        var low = this.isMg ? parseFloat((this.low / 18).toFixed(1)) : this.low;
        this.active = (length1 / totalCount * 100).toFixed(1) + ' %';
        validSg.map(function (e, i) {
          totalSg += e;
          if (e < 3.1) {
            Seg[0]++;
          } else if (e < low) {
            Seg[1]++;
          } else if (e < high) {
            Seg[2]++;
          } else {
            Seg[3]++;
          }
        });
        var avg = totalSg / length1;
        this.avg = this.isMg ? Math.round(avg * 18) : avg.toFixed(1);
        this.est_a1c = ((avg * 18 + 46.7) / 28.7).toFixed(1) + '%';

        Seg.map(function (e, i) {
          var scale = (e / length1 * 100).toFixed(1);
          that.seg[i] = scale + ' %';
        });

        var tran = 0;
        validSg.map(function (e, i) {
          var d = e - avg;
          tran += Math.pow(d, 2);
        });
        var sd = Math.sqrt(tran / length1);
        this.sd = this.isMg ? Math.round(sd * 18) : sd.toFixed(1);
        this.cv = (sd / avg * 100).toFixed(1) + ' %';
      }
    },
    showCount: function showCount() {
      var count = JSON.parse(sessionStorage.getItem('count7'));
      var length = count.length;
      var tr = document.getElementById('count');
      for (var i = 0; i < length; i++) {
        var td = tr.getElementsByTagName('td')[count[i][0]];
        td.innerHTML = count[i][1];
      }
    },
    printPdf: function printPdf() {
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].print_page();
    }
  },
  mounted: function mounted() {
    self.document.title = this.$t('dboard_report');
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isMg = localStorage.getItem('unit') === 'mg' ? true : false;
    this.glucoseUnit = this.isMg ? 'mg/dL' : 'mmol/L';
    this.unit = this.isMg ? ' mg/dL' : ' mmol/L';
    this.hypo = this.isMg ? 54 : 3.1;
    this.sgMax = this.isMg ? 400 : 25;

    var st = sessionStorage.getItem('qst1');
    var et = sessionStorage.getItem('qet1');
    this.st = parseInt(st);
    this.et = parseInt(et);
    this.ts = [[this.st, this.et]];
    var param = {
      ts: this.ts,
      tz: parseInt(sessionStorage.getItem('tz')),
      gu: this.isMg ? 'mg/dL' : 'mmol/L'
    };
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }

    param = __WEBPACK_IMPORTED_MODULE_4__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));
    this.getStatics(param);

    this.time = __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate2(this.st) + ' - ' + __WEBPACK_IMPORTED_MODULE_3__lib_format__["a" /* default */].formatterDate2(this.et);

    this.getData();

    this.high = parseFloat(sessionStorage.getItem('targetH7'));
    this.low = parseFloat(sessionStorage.getItem('targetL7'));
    this.target = '( ' + this.low + ' - ' + this.high + this.unit + ' )';


    var first = parseInt(sessionStorage.getItem('qFirst9'));
    if (first === 1) {
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].checkPrint(this, 10, 9);
    }
  }
});

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_base64__ = __webpack_require__(9);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      profile: {}, complications: [], prescription: [], suggestions: []
    };
  },

  methods: {
    printPdf: function printPdf() {
      __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].print_page();
    }
  },
  mounted: function mounted() {
    self.document.title = this.$t('Records Report');
    this.profile = JSON.parse(sessionStorage.getItem('Rpro'));
    this.complications = JSON.parse(sessionStorage.getItem('Rcop'));
    this.prescription = JSON.parse(sessionStorage.getItem('Rpre'));
    this.suggestions = JSON.parse(sessionStorage.getItem('Rsug'));
    setTimeout('window.print()', 1500);
  }
});

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_base64__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_format__ = __webpack_require__(8);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      value1: '', value2: '', defaultDate: '17-8-2017', count1: 0, count: 0, end: '', sta: '', st: '', et: '', defaultDate2: '17-8-2017', typeChooseVisible: false, dialogSize: 'tiny',
      timeInterval: this.$t('One Week'), endDate: this.$t('Yesterday'), time1: true, time2: false, time3: false, timeRange: '', defaultDate1: '17-8-2017',
      cust: false, custTime: '', custDate: '', isM: false, isDe: false, isIt: false, isPo: false, isDu: false, isFr: false, isSw: false, isCz: false,
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e7;
        }
      },
      weekmode: 'yyyyyyyy', evType: this.$t('date'),
      value11: '', value12: '', qst1: '', qet1: '',
      value21: '', value22: '', qst2: '', qet2: '',
      value31: '', value32: '', qst3: '', qet3: '',
      value41: '', value42: '', value51: '', value52: '', value61: '', value62: '', isEn: false,
      isT1: true, isT2: true, isT3: true, isT4: true, isT5: true, isT6: true,

      uid: 0, page: 1, pages: 5, has_next: '', has_prev: '', PDM: [], value71: '', value72: ''
    };
  },


  methods: {
    timeIntervalChange: function timeIntervalChange() {
      if (this.timeInterval === this.$t('One Week')) {
        this.time1 = true;
        this.time2 = false;
        this.time3 = false;
      }
      if (this.timeInterval === this.$t('One Month')) {
        this.time1 = false;
        this.time2 = true;
        this.time3 = false;
      }
      if (this.timeInterval === this.$t('One Quarter')) {
        this.time1 = false;
        this.time2 = false;
        this.time3 = true;
      }
      this.endDate = this.$t('Yesterday');
      this.timeChange();
    },
    timeChange: function timeChange() {
      if (this.timeInterval === this.$t('One Week') && this.endDate === this.$t('Yesterday')) {
        this.end = new Date().setHours(0, 0, 0, 0) / 1000 - 86400;
        this.sta = this.end - 86400 * 6;
      }
      if (this.timeInterval === this.$t('One Week') && this.endDate === this.$t('Last Saturday')) {
        var now = new Date().setHours(0, 0, 0, 0);
        var currentDay = new Date(now).getDay();
        this.end = now / 1000 - 86400 * (currentDay + 1);
        this.sta = this.sta = this.end - 86400 * 6;
      }
      if (this.timeInterval === this.$t('One Week') && this.endDate === this.$t('Last Sunday')) {
        var _now = new Date().setHours(0, 0, 0, 0);
        var _currentDay = new Date(_now).getDay();
        this.end = _now / 1000 - 86400 * _currentDay;
        this.sta = this.sta = this.end - 86400 * 6;
      }
      if (this.timeInterval === this.$t('One Month') && this.endDate === this.$t('Yesterday')) {
        this.end = new Date().setHours(0, 0, 0, 0) / 1000 - 86400;
        this.sta = this.end - 86400 * 30;
      }
      if (this.timeInterval === this.$t('One Month') && this.endDate === this.$t('Last Day of Last Month')) {
        var _now2 = new Date().setHours(0, 0, 0, 0);
        var _currentDay2 = new Date(_now2).getDate();
        this.end = _now2 / 1000 - 86400 * _currentDay2;
        this.sta = this.end - 86400 * 30;
      }
      if (this.timeInterval === this.$t('One Quarter') && this.endDate === this.$t('Yesterday')) {
        this.end = new Date().setHours(0, 0, 0, 0) / 1000 - 86400;
        this.sta = this.end - 86400 * 30 * 3;
      }
      if (this.timeInterval === this.$t('One Quarter') && this.endDate === this.$t('Last Day of Last Quarter')) {
        var _now3 = new Date().setHours(0, 0, 0, 0);
        var end = _now3 / 1000 - 86400 * 30 * 3;
        var endDay = new Date(end * 1000).getDate();
        this.end = end + 86400 * (30 - endDay);
        this.sta = this.end - 86400 * 30 * 3;
      }
      if (this.endDate === this.$t('Customize')) {
        this.cust = true;
        this.custTime = '';
        this.custDate = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate4(new Date().setHours(0, 0, 0, 0) / 1000 - 86400);
        this.end = new Date().setHours(0, 0, 0, 0) / 1000 - 86400;
        if (this.timeInterval === this.$t('One Week')) {
          this.sta = this.end - 86400 * 6;
        }
        if (this.timeInterval === this.$t('One Month')) {
          this.sta = this.end - 86400 * 30;
        }
        if (this.timeInterval === this.$t('One Quarter')) {
          this.sta = this.end - 86400 * 30 * 3;
        }
      } else {
        this.cust = false;
      }
      this.timeRange = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate2(this.sta) + ' - ' + __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate2(this.end);
      var day = (this.end - this.sta) / 86400 + 1;
      this.defaultDate1 = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate4(this.sta);
      this.defaultDate2 = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate4(this.end);
    },
    customizeDate: function customizeDate() {
      this.end = this.custTime.getTime() / 1000;
      if (this.timeInterval === this.$t('One Week')) {
        this.sta = this.end - 86400 * 6;
      }
      if (this.timeInterval === this.$t('One Month')) {
        this.sta = this.end - 86400 * 30;
      }
      if (this.timeInterval === this.$t('One Quarter')) {
        this.sta = this.end - 86400 * 30 * 3;
      }
      this.timeRange = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate2(this.sta) + ' - ' + __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate2(this.end);
      var day = (this.end - this.sta) / 86400 + 1;
      this.defaultDate1 = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate4(this.sta);
      this.defaultDate2 = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate4(this.end);
    },
    choose: function choose(e) {
      var parent = e.target.parentNode.parentNode;
      var labels = parent.getElementsByTagName('label');
      if (e.target.className === '') {
        e.target.className = 'no';
        labels[0].className = 'no';
      } else {
        e.target.className = '';
        for (var i = 1; i < labels.length; i++) {
          if (labels[i].className === '') {
            this.count++;
          }
        }
        if (this.count === labels.length - 1) {
          labels[0].className = '';
        }
        this.count = 0;
      }
    },
    choose1: function choose1(e) {
      var parent = e.target.parentNode.parentNode;
      var labels = parent.getElementsByTagName('label');
      if (e.target.className === '') {
        e.target.className = 'no';
        labels[0].className = 'no';
      } else {
        e.target.className = '';
        for (var i = 1; i < labels.length; i++) {
          if (labels[i].className === '') {
            this.count1++;
          }
        }
        if (this.count1 === labels.length - 1) {
          labels[0].className = '';
        }
        this.count1 = 0;
      }
    },
    chooseAll: function chooseAll(e) {
      var parent = e.target.parentNode.parentNode;
      var labels = parent.getElementsByTagName('label');
      for (var i = 0; i < labels.length; i++) {
        if (this.flag === 0) {
          labels[i].className = 'no';
        } else {
          labels[i].className = '';
        }
      }
      if (labels[0].className === 'no') {
        this.flag = 1;
      } else {
        this.flag = 0;
      }
    },
    dateChange: function dateChange() {
      this.end = this.value1;
      if (this.end === '') {
        this.sta = new Date().getTime() / 1000;
        this.end = this.sta - 3600 * 24;
        this.sta = this.sta - 3600 * 24 * 8;
        this.sta = new Date(this.sta * 1000);
      } else {
        this.end = new Date(this.end).getTime() / 1000;
        this.sta = this.end - 3600 * 24 * 7;
        this.sta = new Date(this.sta * 1000);
      }
      var y = this.sta.getFullYear();
      var m = this.sta.getMonth() + 1;
      var d = this.sta.getDate();
      m = m < 10 ? '0' + m : m;
      d = d < 10 ? '0' + d : d;
      this.sta = d + '-' + m + '-' + y;
      this.startDate = this.sta;
    },
    dateChange2: function dateChange2() {
      var t = this.getTime(this.value71, this.value72);
      var qst = t[0];
      var qet = t[1];
      var param = {
        page: 1,
        st: qst,
        et: qet,
        tz: parseInt(sessionStorage.getItem('tz')),
        flag: 'web'
      };

      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getPdm1(this, this.uid, param);
    },
    print: function print() {
      var obj1 = document.getElementById('ds');
      var obj2 = document.getElementById('dd');
      var obj3 = document.getElementById('ol');
      var obj4 = document.getElementById('ta');
      var obj5 = document.getElementById('lg');
      var obj6 = document.getElementById('ev');
      var obj7 = document.getElementById('dSet');
      var obj8 = document.getElementById('dash');
      var obj9 = document.getElementById('alert');
      var report = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      this.checkDate();

      if (obj9.className !== 'no') {
        var t1 = this.getTime(this.value11, this.value12);
        this.qst1 = t1[0];
        this.qet1 = t1[1];

        var dayNum1 = parseInt((this.qet1 - this.qst1) / 86400) + 1;
        console.log('quick print:', dayNum1, this.qet1, this.qst1);
        report[10] = 1;
        if (dayNum1 > 14) {
          this.isT1 = true;
          this.qst1 = this.qet1 - 13 * 86400;
          sessionStorage.setItem('qst1', this.qst1);
          sessionStorage.setItem('qet1', this.qet1);
        } else if (dayNum1 < 1) {
          this.$message.error("Alert Report: date select wrong!");
          return;
        } else {
          this.isT1 = true;
          sessionStorage.setItem('qst1', this.qst1);
          sessionStorage.setItem('qet1', this.qet1);
        }
      }

      if (obj8.className !== 'no') {
        var _t = this.getTime(this.value11, this.value12);
        this.qst1 = _t[0];
        this.qet1 = _t[1];
        var _dayNum = parseInt((this.qet1 - this.qst1) / 86400) + 1;
        report[9] = 1;
        if (_dayNum > 14) {
          this.isT1 = true;
          this.qst1 = this.qet1 - 13 * 86400;
          sessionStorage.setItem('qst1', this.qst1);
          sessionStorage.setItem('qet1', this.qet1);
        } else if (_dayNum < 1) {} else {
          this.isT1 = true;
          sessionStorage.setItem('qst1', this.qst1);
          sessionStorage.setItem('qet1', this.qet1);
        }
      }

      if (obj1.className !== 'no') {
        var _t2 = this.getTime(this.value11, this.value12);
        this.qst1 = _t2[0];
        this.qet1 = _t2[1];
        var _dayNum2 = parseInt((this.qet1 - this.qst1) / 86400) + 1;
        report[1] = 1;
        if (_dayNum2 > 14) {
          this.isT1 = true;
          this.qst1 = this.qet1 - 13 * 86400;
          sessionStorage.setItem('qst1', this.qst1);
          sessionStorage.setItem('qet1', this.qet1);
        } else if (_dayNum2 < 1) {} else {
          this.isT1 = true;
          sessionStorage.setItem('qst1', this.qst1);
          sessionStorage.setItem('qet1', this.qet1);
        }
      }
      if (obj2.className !== 'no') {
        var t2 = this.getTime(this.value21, this.value22);
        this.qst2 = t2[0];
        this.qet2 = t2[1];
        var dayNum2 = parseInt((this.qet2 - this.qst2) / 86400) + 1;
        report[2] = 1;
        if (dayNum2 > 14) {
          this.isT2 = true;
          this.qst2 = this.qet2 - 13 * 86400;
          sessionStorage.setItem('qst2', this.qst2);
          sessionStorage.setItem('qet2', this.qet2);
        } else if (dayNum2 < 1) {
          this.isT2 = false;
        } else {
          this.isT2 = true;
          sessionStorage.setItem('qst2', this.qst2);
          sessionStorage.setItem('qet2', this.qet2);
        }
      }
      if (obj3.className !== 'no') {
        var t3 = this.getTime(this.value31, this.value32);
        this.qst3 = t3[0];
        this.qet3 = t3[1];
        var dayNum3 = parseInt((this.qet3 - this.qst3) / 86400) + 1;
        report[3] = 1;
        if (dayNum3 > 7) {
          this.isT3 = true;
          this.qst3 = this.qet3 - 6 * 86400;
          sessionStorage.setItem('qst3', this.qst3);
          sessionStorage.setItem('qet3', this.qet3);
          sessionStorage.setItem('qweekMode', this.weekmode);
        } else if (dayNum3 < 1) {
          this.isT3 = false;
        } else {
          this.isT3 = true;
          sessionStorage.setItem('qst3', this.qst3);
          sessionStorage.setItem('qet3', this.qet3);
          sessionStorage.setItem('qweekMode', this.weekmode);
        }
      }
      if (obj4.className !== 'no') {
        var t4 = this.getTime(this.value41, this.value42);
        var qst4 = t4[0];
        var qet4 = t4[1];
        var dayNum4 = parseInt((qet4 - qst4) / 86400) + 1;
        report[4] = 1;
        if (dayNum4 > 90) {
          this.isT4 = true;
          this.qst4 = this.qet4 - 89 * 86400;
          sessionStorage.setItem('qst4', qst4);
          sessionStorage.setItem('qet4', qet4);
          sessionStorage.setItem('qweekMode', this.weekmode);
        } else if (dayNum4 < 1) {
          this.isT4 = false;
        } else {
          this.isT4 = true;
          sessionStorage.setItem('qst4', qst4);
          sessionStorage.setItem('qet4', qet4);
          sessionStorage.setItem('qweekMode', this.weekmode);
        }
      }
      if (obj5.className !== 'no' && !this.isM) {
        var t5 = this.getTime(this.value51, this.value52);
        var qst5 = t5[0];
        var qet5 = t5[1];
        var dayNum5 = parseInt((qet5 - qst5) / 86400) + 1;
        report[5] = 1;
        if (dayNum5 > 14) {
          this.isT5 = true;
          qst5 = qet5 - 13 * 86400;
          sessionStorage.setItem('qst5', qst5);
          sessionStorage.setItem('qet5', qet5);
          sessionStorage.setItem('qweekMode', this.weekmode);
        } else if (dayNum5 < 1) {
          this.isT5 = false;
        } else {
          this.isT5 = true;
          sessionStorage.setItem('qst5', qst5);
          sessionStorage.setItem('qet5', qet5);
          sessionStorage.setItem('qweekMode', this.weekmode);
        }
      }
      if (obj6.className !== 'no' && !this.isM) {
        var t6 = this.getTime(this.value61, this.value62);
        var qst6 = t6[0];
        var qet6 = t6[1];
        var dayNum6 = parseInt((qet6 - qst6) / 86400) + 1;
        if (this.evType === this.$t('date')) {
          report[6] = 1;
        }
        if (this.evType === this.$t('item')) {
          report[7] = 1;
        }
        if (dayNum6 > 30) {
          this.isT6 = true;
          qst6 = qet6 - 29 * 86400;
          sessionStorage.setItem('qst6', qst6);
          sessionStorage.setItem('qet6', qet6);
        } else if (dayNum6 < 1) {
          this.isT6 = false;
        } else {
          this.isT6 = true;
          sessionStorage.setItem('qst6', qst6);
          sessionStorage.setItem('qet6', qet6);
        }
      }
      if (obj7.className !== 'no' && !this.isM) {
        if (this.PDM.length > 0) {
          report[8] = 1;
          var pdm = this.PDM[0][1] + ',' + this.PDM[0][2];
          var rid = this.PDM[0][0];
          sessionStorage.setItem('qPdm', pdm);
          sessionStorage.setItem('qRid', rid);
        }
      }
      report.map(function (e, i) {
        if (e === 1) {
          var key = 'qFirst' + i;
          sessionStorage.setItem(key, 1);
        }
      });
      sessionStorage.setItem('Reports', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(report));

      if (this.checkDayNum()) {
        for (var i = 1; i < report.length; i++) {
          if (report[i] === 1) {
            var path = '/#/quickPrint' + i;
            console.log('quickReport:', path, i);
            var open = window.open(path, '_blank');
            if (open === null) {
              this.$message.error('popup window intercepted');
            }
            break;
          }
        }
      }
    },
    getTime: function getTime(t1, t2) {
      var qst = 0,
          qet = 0;
      if (t1 && t2) {
        qst = t1.getTime() / 1000;
        qet = t2.getTime() / 1000;
      } else if (t1) {
        qst = t1.getTime() / 1000;
        var ti = this.defaultDate2.split('-');
        qet = new Date(parseInt(ti[2]), parseInt(ti[1]) - 1, parseInt(ti[0])).getTime() / 1000;
      } else if (t2) {
        qet = t2.getTime() / 1000;
        var _ti = this.defaultDate1.split('-');
        qst = new Date(parseInt(_ti[2]), parseInt(_ti[1]) - 1, parseInt(_ti[0])).getTime() / 1000;
      } else {
        var _ti2 = this.defaultDate1.split('-');
        qst = new Date(parseInt(_ti2[2]), parseInt(_ti2[1]) - 1, parseInt(_ti2[0])).getTime() / 1000;
        var ti1 = this.defaultDate2.split('-');
        qet = new Date(parseInt(ti1[2]), parseInt(ti1[1]) - 1, parseInt(ti1[0])).getTime() / 1000;
      }
      return [qst, qet];
    },
    checkDate: function checkDate() {
      var weeks = document.getElementById('weeks');
      var weken = document.getElementById('weken');
      if (weeks) {
        var labels1 = weeks.getElementsByTagName('label');
        var labels2 = weken.getElementsByTagName('label');
        if (labels1[0].className === '' && labels2[0].className === '') {
          this.weekmode = 'yyyyyyy';
        } else {
          this.weekmode = '';
          for (var i = 1; i < labels1.length; i++) {
            if (labels1[i].className === '') {
              this.weekmode += 'y';
            } else {
              this.weekmode += 'n';
            }
          }
          for (var _i = 1; _i < labels2.length; _i++) {
            if (labels2[_i].className === '') {
              this.weekmode += 'y';
            } else {
              this.weekmode += 'n';
            }
          }
        }
      }
    },
    checkDayNum: function checkDayNum() {
      var dateTrue = true;
      var report = JSON.parse(sessionStorage.getItem('Reports'));

      return dateTrue;
    },
    getPdm1: function getPdm1() {
      var param = {
        page: 1,
        st: this.st,
        et: this.et,
        tz: parseInt(sessionStorage.getItem('tz')),
        flag: 'web'
      };
      __WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].getPdm1(this, this.uid, param);
    },
    apply: function apply() {},
    cancel: function cancel() {
      this.typeChooseVisible = false;
    }
  },
  mounted: function mounted() {
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isSw = lang === 'sw' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    this.isM = sessionStorage.getItem('userType') === 'M' ? true : false;
    var win = window.innerWidth;
    this.dialogSize = win < 1500 ? 'small' : 'tiny';
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }
    this.et = new Date().setHours(0, 0, 0, 0) / 1000 - 86400;
    this.st = this.et - 86400 * 6;
    this.getPdm1();
    this.defaultDate1 = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate4(this.st);
    this.defaultDate2 = __WEBPACK_IMPORTED_MODULE_4__lib_format__["a" /* default */].formatterDate4(this.et);
    this.timeChange();
  }
});

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_format__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isCN: false,
      realname: '', gender: '', height: '', weight: '', isP: true, isD: false, isM: false, isEs: false, isDe: false, isCz: false,
      birthday: '', value2: '', value3: '', isEn: false, isIt: false, isPo: false, isFr: false, isDu: false, isZh: false, isSw: false,
      birthdayShow: '', disDateShow: '',
      dis_type: '11',
      diabetes_type: '', diabetes_diagnosis_date: '',

      address1: '', address2: '', postcode: '', mobile: '', telephone: '', email: '',

      profile: {
        birthday: ''
      }, imageUrl: '', uid: 0, newPortrait: '', usterType: '',
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      isEU: true,
      contactURL: '',
      privacyURL: '',
      termsOfUseURL: ''
    };
  },

  computed: {
    portrait: function portrait() {
      if (this.imageUrl) {
        return this.imageUrl;
      } else {
        return '/api/v2.0/person/' + parseInt(sessionStorage.getItem('uid')) + '/portrait';
      }
    }
  },
  methods: {
    checkInput: function checkInput(info) {
      if (this.profile.email) {
        var re = /@/;
        if (re.test(this.profile.email)) {
          __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].modifyPersonProfile(this, info);
        } else {
          alert('Email Error!');
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].modifyPersonProfile(this, info);
      }
    },
    back: function back() {
      if (this.usterType === 'D') {
        this.$router.push('/HcpUserManagement');
      } else if (this.usterType === 'M') {
        this.$router.push('/carerConnection');
      } else {
        this.$router.push('/monitor');
      }
    },
    create1: function create1() {
      var bthday = '';
      if (typeof this.profile.birthday !== 'string' && this.profile.birthday !== undefined) {
        bthday = __WEBPACK_IMPORTED_MODULE_1__lib_format__["a" /* default */].formatterDate3(this.profile.birthday.getTime() / 1000);
      } else {
        bthday = this.profile.birthday;
      }

      var diagonosis_date = '';
      if (typeof this.profile.diabetes_diagonosis_date !== 'string' && this.profile.diabetes_diagonosis_date !== undefined) {
        diagonosis_date = __WEBPACK_IMPORTED_MODULE_1__lib_format__["a" /* default */].formatterDate3(this.profile.diabetes_diagonosis_date.getTime() / 1000);
      } else {
        diagonosis_date = this.profile.diabetes_diagonosis_date;
      }

      var obj1 = document.getElementById('dis_type');
      var dis_type = obj1.value;
      var obj2 = document.getElementById('gender');
      var gender = obj2.value;

      var info = {
        realname: this.profile.realname,
        gender: gender,
        height: this.height || this.profile.height,
        weight: this.weight || this.profile.weight,
        birthday: bthday,
        diabetes_type: dis_type,
        diabetes_diagonosis_date: diagonosis_date,
        address: this.profile.address + this.address2,
        zipcode: this.profile.zipcode,
        mobile: this.profile.mobile,
        telephone: this.profile.telephone,
        email: this.profile.email,
        motto: this.profile.motto,
        country: this.profile.country_region
      };
      if (this.newPortrait.length > 1) {
        info.portrait = this.newPortrait;
      }
      this.checkInput(info);
    },
    create2: function create2() {
      var bthday = '';
      if (typeof this.profile.birthday !== 'string' && this.profile.birthday !== undefined) {
        bthday = __WEBPACK_IMPORTED_MODULE_1__lib_format__["a" /* default */].formatterDate3(this.profile.birthday.getTime() / 1000);
      } else {
        bthday = this.profile.birthday;
      }
      var obj2 = document.getElementById('gender');
      var gender = obj2.value;
      var obj3 = document.getElementById('major');
      var major = obj3.value;

      var info = {
        realname: this.profile.realname,
        gender: gender,
        birthday: bthday,
        serve_for: this.profile.serve_for,
        major: major,
        address: this.profile.address + this.address2,
        zipcode: this.profile.zipcode,
        mobile: this.profile.mobile,
        telephone: this.profile.telephone,
        email: this.profile.email,
        motto: this.profile.motto
      };
      if (this.newPortrait.length > 1) {
        info.portrait = this.newPortrait;
      }
      this.checkInput(info);
    },
    create3: function create3() {
      var bthday = '';
      if (typeof this.profile.birthday !== 'string' && this.profile.birthday !== undefined) {
        bthday = __WEBPACK_IMPORTED_MODULE_1__lib_format__["a" /* default */].formatterDate3(this.profile.birthday.getTime() / 1000);
      } else {
        bthday = this.profile.birthday;
      }
      var obj2 = document.getElementById('gender');
      var gender = obj2.value;
      var info = {
        realname: this.profile.realname,
        gender: gender,
        birthday: bthday,
        address: this.profile.address + this.address2,
        zipcode: this.profile.zipcode,
        mobile: this.profile.mobile,
        telephone: this.profile.telephone,
        email: this.profile.email,
        motto: this.profile.motto
      };
      if (this.newPortrait.length > 1) {
        info.portrait = this.newPortrait;
      }
      this.checkInput(info);
    },
    create: function create() {
      if (this.birthday) {
        this.profile.birthday = __WEBPACK_IMPORTED_MODULE_1__lib_format__["a" /* default */].formatterDate3(this.birthday.getTime() / 1000);
      }
      console.log('profile:', this.profile);
      if (!this.profile.username) {
        this.$message.error('An email is required.');
        return;
      }
      if (!this.profile.realname) {
        this.$message.error('A name is required.');
        return;
      }
      var email_part = this.profile.username.split('@');
      if (2 != email_part.length) {
        this.$message.error('Invalid email format.');
        return;
      }

      this.$http.post('/api/v2.1/hcp_group/add_user', this.profile).then(function (res) {
        console.log('add_user:', res.data);
        if (0 == res.data.error) {
          this.$message({
            type: 'success',
            message: 'Created Successfully. Check the email.'
          });
          this.$router.push('/HcpUserManagement');
        } else if (3 == res.data.error) {
          this.$message.error('The email is already used.');
        } else {
          this.$message.error('Fail');
        }
      }, function (err) {});
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      this.newPortrait = res.path;
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.uid = parseInt(sessionStorage.getItem('uid'));
    this.usterType = sessionStorage.getItem('userType');
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isEs = lang === 'es' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isZh = lang === 'zh' ? true : false;
    this.isSw = lang === 'sw' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    if (this.usterType === 'P') {
      this.isP = true;this.isD = false;this.isM = false;
    }
    if (this.usterType === 'D') {
      this.isD = true;this.isP = false;this.isM = false;
    }
    if (this.usterType === 'M') {
      this.isM = true;this.isD = false;this.isP = false;
    }
    var countryIndex = localStorage.getItem('index');

    if (1 == countryIndex || 6 == countryIndex || 14 == countryIndex) {
      this.isEU = false;
    }
    this.isCN = this.isZh;

    setTimeout(function () {
      var host = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getOuterHost();
      _this.contactURL = host + '/contact.html';
      _this.privacyURL = host + '/privacy_policy.html';
      _this.termsOfUseURL = host + '/terms_of_use.html';
    }, 50);
  }
});

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_format__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isCN: false,
      realname: '', gender: '', height: '', weight: '', isP: true, isD: false, isM: false, isEs: false, isDe: false, isCz: false,
      birthday: '', value2: '', value3: '', isEn: false, isIt: false, isPo: false, isFr: false, isDu: false, isZh: false, isSw: false,
      birthdayShow: '', disDateShow: '',
      dis_type: '11',
      diabetes_type: '', diabetes_diagnosis_date: '',

      address1: '', address2: '', postcode: '', mobile: '', telephone: '', email: '',

      profile: {},
      imageUrl: '', uid: 0, newPortrait: '', usterType: '',
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      isEU: true,
      contactURL: '',
      privacyURL: '',
      termsOfUseURL: ''
    };
  },

  computed: {
    portrait: function portrait() {
      if (this.imageUrl) {
        return this.imageUrl;
      } else {
        return '/api/v2.0/person/' + parseInt(sessionStorage.getItem('uid')) + '/portrait';
      }
    }
  },
  methods: {
    checkInput: function checkInput(info) {
      if (this.profile.email) {
        var re = /@/;
        if (re.test(this.profile.email)) {
          __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].modifyPersonProfile(this, info);
        } else {
          alert('Email Error!');
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].modifyPersonProfile(this, info);
      }
    },
    back: function back() {
      this.$router.push('/HcpUserManagement');
    },
    create1: function create1() {
      var bthday = '';
      if (typeof this.profile.birthday !== 'string' && this.profile.birthday !== undefined) {
        bthday = __WEBPACK_IMPORTED_MODULE_1__lib_format__["a" /* default */].formatterDate3(this.profile.birthday.getTime() / 1000);
      } else {
        bthday = this.profile.birthday;
      }

      var diagonosis_date = '';
      if (typeof this.profile.diabetes_diagonosis_date !== 'string' && this.profile.diabetes_diagonosis_date !== undefined) {
        diagonosis_date = __WEBPACK_IMPORTED_MODULE_1__lib_format__["a" /* default */].formatterDate3(this.profile.diabetes_diagonosis_date.getTime() / 1000);
      } else {
        diagonosis_date = this.profile.diabetes_diagonosis_date;
      }

      var obj1 = document.getElementById('dis_type');
      var dis_type = obj1.value;
      var obj2 = document.getElementById('gender');
      var gender = obj2.value;

      var info = {
        realname: this.profile.realname,
        gender: gender,
        height: this.height || this.profile.height,
        weight: this.weight || this.profile.weight,
        birthday: bthday,
        diabetes_type: dis_type,
        diabetes_diagonosis_date: diagonosis_date,
        address: this.profile.address + this.address2,
        zipcode: this.profile.zipcode,
        mobile: this.profile.mobile,
        telephone: this.profile.telephone,
        email: this.profile.email,
        motto: this.profile.motto,
        country: this.profile.country_region
      };
      if (this.newPortrait.length > 1) {
        info.portrait = this.newPortrait;
      }
      this.checkInput(info);
    },
    create2: function create2() {
      var bthday = '';
      if (typeof this.profile.birthday !== 'string' && this.profile.birthday !== undefined) {
        bthday = __WEBPACK_IMPORTED_MODULE_1__lib_format__["a" /* default */].formatterDate3(this.profile.birthday.getTime() / 1000);
      } else {
        bthday = this.profile.birthday;
      }
      var obj2 = document.getElementById('gender');
      var gender = obj2.value;
      var obj3 = document.getElementById('major');
      var major = obj3.value;

      var info = {
        realname: this.profile.realname,
        gender: gender,
        birthday: bthday,
        serve_for: this.profile.serve_for,
        major: major,
        address: this.profile.address + this.address2,
        zipcode: this.profile.zipcode,
        mobile: this.profile.mobile,
        telephone: this.profile.telephone,
        email: this.profile.email,
        motto: this.profile.motto
      };
      if (this.newPortrait.length > 1) {
        info.portrait = this.newPortrait;
      }
      this.checkInput(info);
    },
    create3: function create3() {
      var bthday = '';
      if (typeof this.profile.birthday !== 'string' && this.profile.birthday !== undefined) {
        bthday = __WEBPACK_IMPORTED_MODULE_1__lib_format__["a" /* default */].formatterDate3(this.profile.birthday.getTime() / 1000);
      } else {
        bthday = this.profile.birthday;
      }
      var obj2 = document.getElementById('gender');
      var gender = obj2.value;
      var info = {
        realname: this.profile.realname,
        gender: gender,
        birthday: bthday,
        address: this.profile.address + this.address2,
        zipcode: this.profile.zipcode,
        mobile: this.profile.mobile,
        telephone: this.profile.telephone,
        email: this.profile.email,
        motto: this.profile.motto
      };
      if (this.newPortrait.length > 1) {
        info.portrait = this.newPortrait;
      }
      this.checkInput(info);
    },
    create: function create() {
      console.log('profile:', this.profile);
      if (!this.profile.username) {
        this.$message.error('An email is required.');
        return;
      }
      if (!this.profile.realname) {
        this.$message.error('A name is required.');
        return;
      }
      var email_part = this.profile.username.split('@');
      if (2 != email_part.length) {
        this.$message.error('Invalid email format.');
        return;
      }
      this.$http.post('/api/v2.1/hcp_group/add_user', this.profile).then(function (res) {
        console.log('add_user:', res.data);
        if (0 == res.data.error) {
          this.$message({
            type: 'success',
            message: 'Created Successfully. Check the email.'
          });
          this.$router.push('/HcpUserManagement');
        } else if (3 == res.data.error) {
          this.$message.error('The email is already used.');
        } else {
          this.$message.error('Fail');
        }
      }, function (err) {});
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      this.newPortrait = res.path;
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    getProfile: function getProfile(uid) {
      this.$http.post('/api/v2.1/hcp_group/get_user_info', {
        'uid': uid
      }).then(function (res) {
        console.log('get_user_info:', res.data);
        if (0 == res.data.error) {
          var profile = res.data.profile;
          for (var p in profile) {
            console.log('p.1:', p);
            if (!profile[p]) {
              profile[p] = '--';
            }
          }
          console.log('profile:', profile);
          this.profile = profile;
        }
      }, function (err) {});
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.uid = parseInt(sessionStorage.getItem('uid'));
    this.usterType = sessionStorage.getItem('userType');
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isEs = lang === 'es' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isZh = lang === 'zh' ? true : false;
    this.isSw = lang === 'sw' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    if (this.usterType === 'P') {
      this.isP = true;this.isD = false;this.isM = false;
    }
    if (this.usterType === 'D') {
      this.isD = true;this.isP = false;this.isM = false;
    }
    if (this.usterType === 'M') {
      this.isM = true;this.isD = false;this.isP = false;
    }
    var countryIndex = localStorage.getItem('index');

    if (1 == countryIndex || 6 == countryIndex || 14 == countryIndex) {
      this.isEU = false;
    }
    this.isCN = this.isZh;

    var hcp_group_user_uid = sessionStorage.getItem('hcp_group_user_uid');
    this.getProfile(hcp_group_user_uid);
    setTimeout(function () {
      var host = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getOuterHost();
      _this.contactURL = host + '/contact.html';
      _this.privacyURL = host + '/privacy_policy.html';
      _this.termsOfUseURL = host + '/terms_of_use.html';
    }, 50);
  }
});

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vertifyDialog_vue__ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vertifyDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__vertifyDialog_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    vertifyDialog: __WEBPACK_IMPORTED_MODULE_1__vertifyDialog_vue___default.a
  },
  data: function data() {
    return {
      password: '', new_password: '', new_password2: '', userType: '', isEn: false, isCz: false,
      isMg: false, isEs: false, isDe: false, isIt: false, isPo: false, isDu: false, isFr: false, isZh: false, isSw: false,

      ps1: false, ps2: false, ps3: false, ps4: false, ps5: false, ps6: false, disF: true, isT: false,
      isEU: true,
      contactURL: '',
      privacyURL: '',
      termsOfUseURL: '',
      MFA: sessionStorage.getItem('MFA') === 'Y',
      confirmText: this.$t('send'),
      title: this.$t('t1222_Verify_your_account'),
      isVertify: true, isSendEmail: false,
      verifyInputs: new Array(6), verCode: '', errVeritifyCode: false, userName: sessionStorage.getItem('username')
    };
  },

  computed: {
    updateLocCode: function updateLocCode() {
      console.log('compute updateLocCode:');
      return this.$store.state.loc_code;
    }
  },
  watch: {
    updateLocCode: function updateLocCode(val) {
      console.log('watch updateLocCode:', val);
      var host = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getOuterHost();
      this.contactURL = host + '/contact.html';
      this.privacyURL = host + '/privacy_policy.html';
      this.termsOfUseURL = host + '/terms_of_use.html';
    }
  },
  methods: {
    vertifyInput: function vertifyInput(index) {
      if (this.verifyInputs[index].length) {
        var char = this.verifyInputs[index][this.verifyInputs[index].length - 1];
        if (char.match(/^[0-9]$/g)) {
          this.verifyInputs[index] = char;
          var tmpIndex = index;
          if (index < 5) {
            tmpIndex += 1;
            document.getElementsByClassName('input-code')[tmpIndex].focus();
          }
        } else {
          this.verifyInputs[index] = '';
          document.getElementsByClassName('input-code')[index].focus();
        }
      }
    },
    changeMFA: function changeMFA(flag) {
      if (this.MFA !== flag) {
        if (flag) {
          if (!this.isSendEmail) {
            this.isVertify = true;

            this.confirmText = this.$t('send');
          }
          this.$refs.verifyEmail.dialogVisible = true;
        } else {
          this.sendChangeMFA();
        }
      }
    },
    sendChangeMFA: function sendChangeMFA() {
      var _this = this;

      var info = {
        'mfa': this.MFA ? 'N' : 'Y'
      };
      this.$http.post('/api/v2.1/account/mfa/setting', info).then(function (res) {
        if (res.data.error === 0) {
          sessionStorage.setItem('MFA', info.mfa);
          var tip = _this.$t('saveTip');
          _this.$message({
            type: 'success',
            message: tip
          });
          _this.$refs.verifyEmail.dialogVisible = false;
          _this.isSendEmail = false;
          _this.MFA = !_this.MFA;
        }
      });
    },
    confirm: function confirm() {
      var _this2 = this;

      if (this.isVertify) {
        var postData = {
          user_name: this.userName,
          flag: this.userName.match(/^[\d]+$/g) ? 'mobile' : 'email',
          country: sessionStorage.getItem('country'),
          purpose: 'login_mfa'
        };
        this.$http.post('/api/v2.0/seccode/send', postData).then(function (res) {
          if (res.body.error === 0) {
            _this2.isVertify = false;
            _this2.confirmText = _this2.$t('confirm');
            _this2.isSendEmail = true;
          } else if (res.body.error === 1) {
            var tip = _this2.$t('userNotExist');
            _this2.$message.error(tip);
          } else {
            var _tip = _this2.$t('tryAgain');
            _this2.$message.error(_tip);
          }
        });
      } else {
        var _postData = {
          expire: 5
        };
        _postData['' + (this.userName.match(/^[\d]+$/g) ? 'mobile' : 'email')] = this.userName;
        _postData.seccode = this.verifyInputs.join('');
        if (_postData.seccode.length === 6) {
          this.$http.post('/api/v2.1/seccode/check', _postData).then(function (res) {
            if (res.body.error === 0) {
              _this2.sendChangeMFA();
            } else {
              _this2.errVeritifyCode = true;
            }
          });
        }
      }
    },
    handleClose: function handleClose() {
      this.$refs.verifyEmail.dialogVisible = false;
    },
    back: function back() {
      this.usterType = sessionStorage.getItem('userType');
      if (this.usterType === 'D') {
        this.$router.push('/PatientList');
      } else if (this.usterType === 'M') {
        this.$router.push('/carerConnection');
      } else {
        this.$router.push('/monitor');
      }
    },
    forgot: function forgot() {
      sessionStorage.removeItem('A');
      sessionStorage.removeItem('B');
      sessionStorage.removeItem('C');
      sessionStorage.removeItem('D');
      this.$router.push('/updatePassword');
      if (sessionStorage.getItem('userType') === 'D') {
        sessionStorage.setItem('udHcp', 0);
      } else {
        sessionStorage.setItem('udHcp', 1);
      }
    },
    apply: function apply() {
      var info = {
        password: this.password,
        new_password: this.new_password
      };
      if (this.password) {
        if (this.disF === true) {
          if (this.new_password === this.new_password2) {
            __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].modifyPassword(this, info);
          } else {
            var tip = this.$t('EntTheSame');
            this.$message.error(tip);
          }
        }
      } else {
        var _tip2 = this.$t('EnterOld');
        this.$message.error(_tip2);
      }
    },
    checkPassword: function checkPassword() {
      var password = this.new_password.trim();
      if (password.length > 5 && password.length < 21) {
        this.ps2 = true;
      } else {
        this.ps2 = false;
      }
      if (password.length > 0) {
        if (password.indexOf(' ') === -1) {
          this.ps6 = true;
        } else {
          this.ps6 = false;
        }
        if (password === this.full_name) {
          this.ps3 = false;
        } else {
          this.ps3 = true;
        }
        var p1 = /[a-z]/.test(password),
            p2 = /[A-Z]/.test(password),
            p3 = /[0-9]/.test(password),
            p4 = /[!@#$%^&*()_+={},.;'\\":~`\[\]<>|/?]/.test(password),
            count = 0;
        if (p1) {
          count++;
        }
        if (p2) {
          count++;
        }
        if (p3) {
          count++;
        }
        if (p4) {
          count++;
        }
        if (count > 2) {
          this.ps1 = true;
        } else {
          this.ps1 = false;
        }

        for (var i = 0; i < password.length - 2; i++) {
          if (password[i + 1] - password[i] === 1 && password[i + 2] - password[i + 1] === 1) {
            this.flag = 1;break;
          } else {
            this.flag = 0;
          }
          if (password[i] - password[i + 1] === 1 && password[i + 1] - password[i + 2] === 1) {
            this.flag = 1;break;
          } else {
            this.flag = 0;
          }
        }
        if (this.flag === 0) {
          this.ps4 = true;
        } else {
          this.ps4 = false;
        }

        for (var _i = 0; _i < password.length - 2; _i++) {
          if (password[_i + 1].charCodeAt() - password[_i].charCodeAt() === 1 && password[_i + 2].charCodeAt() - password[_i + 1].charCodeAt() === 1) {
            this.flag1 = 1;break;
          } else {
            this.flag1 = 0;
          }
          if (password[_i].charCodeAt() - password[_i + 1].charCodeAt() === 1 && password[_i + 1].charCodeAt() - password[_i + 2].charCodeAt() === 1) {
            this.flag1 = 1;break;
          } else {
            this.flag1 = 0;
          }
        }
        if (this.flag1 === 0) {
          this.ps5 = true;
        } else {
          this.ps5 = false;
        }
      }
      if (this.ps1 === true && this.ps2 === true && this.ps3 === true && this.ps4 === true && this.ps5 === true && this.ps6 === true) {
        this.isT = false;
        this.disF = true;
      } else {
        this.isT = true;
        this.disF = false;
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isEs = lang === 'es' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isSw = lang === 'sw' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    this.isZh = sessionStorage.getItem('language') === 'zh' ? true : false;
    var countryIndex = localStorage.getItem('index');

    if (1 == countryIndex || 6 == countryIndex || 14 == countryIndex) {
      this.isEU = false;
    }
    setTimeout(function () {
      var host = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getOuterHost();
      _this3.contactURL = host + '/contact.html';
      _this3.privacyURL = host + '/privacy_policy.html';
      _this3.termsOfUseURL = host + '/terms_of_use.html';
    }, 50);
  }
});

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_format__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isCN: false,
      realname: '', gender: '', height: '', weight: '', isP: true, isD: false, isM: false, isEs: false, isDe: false, isCz: false,
      birthday: '', value2: '', value3: '', isEn: false, isIt: false, isPo: false, isFr: false, isDu: false, isZh: false, isSw: false,
      birthdayShow: '', disDateShow: '',
      tabA: true, tabB: false, tabC: false, tabD: false,
      dis_type: '11',
      diabetes_type: '', diabetes_diagnosis_date: '',

      address1: '', address2: '', postcode: '', mobile: '', telephone: '', email: '',

      profile: '', imageUrl: '', uid: 0, newPortrait: '', usterType: '',
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      isEU: true,
      contactURL: '',
      privacyURL: '',
      termsOfUseURL: ''
    };
  },

  computed: {
    portrait: function portrait() {
      if (this.imageUrl) {
        return this.imageUrl;
      } else {
        return '/api/v2.0/person/' + parseInt(sessionStorage.getItem('uid')) + '/portrait';
      }
    }
  },
  methods: {
    navToHome: function navToHome() {
      this.$router.push('/accountsadmin_home');
    },
    checkInput: function checkInput(info) {
      if (this.profile.email) {
        var re = /@/;
        if (re.test(this.profile.email)) {
          __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].modifyPersonProfile(this, info);
        } else {
          alert('Email Error!');
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].modifyPersonProfile(this, info);
      }
    },
    checkInput2: function checkInput2(info) {
      var res = true;
      var tip = '';
      if (!this.isCN) {
        if (!this.profile.country_region) {
          tip += 'Select country/region \n';
          res = false;
        }
      }
      if (!this.profile.realname) {
        tip += 'Input name \n';
        res = false;
      }
      if (!this.profile.serve_for) {
        tip += 'Input organization info \n';
        res = false;
      }
      if (!this.profile.email) {
        tip += 'Input email info \n';
        res = false;
      } else {
        var re = /@/;
        if (!re.test(this.profile.email)) {
          tip += 'Input correct email \n';
          res = false;
        }
      }
      if (!this.profile.mobile) {
        tip += 'Input mobile info \n';
        res = false;
      }

      if (!res) {
        alert(tip);
      }

      return res;
    },
    back: function back() {
      if (this.usterType === 'D') {
        this.$router.push('/PatientList');
      } else if (this.usterType === 'M') {
        this.$router.push('/carerConnection');
      } else {
        this.$router.push('/monitor');
      }
    },
    create1: function create1() {
      var bthday = '';
      if (typeof this.profile.birthday !== 'string' && this.profile.birthday !== undefined) {
        bthday = __WEBPACK_IMPORTED_MODULE_1__lib_format__["a" /* default */].formatterDate3(this.profile.birthday.getTime() / 1000);
      } else {
        bthday = this.profile.birthday;
      }

      var diagonosis_date = '';
      if (typeof this.profile.diabetes_diagonosis_date !== 'string' && this.profile.diabetes_diagonosis_date !== undefined) {
        diagonosis_date = __WEBPACK_IMPORTED_MODULE_1__lib_format__["a" /* default */].formatterDate3(this.profile.diabetes_diagonosis_date.getTime() / 1000);
      } else {
        diagonosis_date = this.profile.diabetes_diagonosis_date;
      }

      var obj1 = document.getElementById('dis_type');
      var dis_type = obj1.value;
      var obj2 = document.getElementById('gender');
      var gender = obj2.value;

      var info = {
        realname: this.profile.realname,
        gender: gender,
        height: this.height || this.profile.height,
        weight: this.weight || this.profile.weight,
        birthday: bthday,
        diabetes_type: dis_type,
        diabetes_diagonosis_date: diagonosis_date,
        address: this.profile.address + this.address2,
        zipcode: this.profile.zipcode,
        mobile: this.profile.mobile,
        telephone: this.profile.telephone,
        email: this.profile.email,
        motto: this.profile.motto,
        country: this.profile.country_region
      };
      if (this.newPortrait.length > 1) {
        info.portrait = this.newPortrait;
      }
      this.checkInput(info);
    },
    backProc: function backProc() {
      this.tabB = false;
      this.tabC = false;
      this.tabA = true;
    },
    addNewProc: function addNewProc() {
      this.profile.realname = '';
      this.profile.email = '';
      this.profile.mobile = '';
      this.profile.serve_for = '';
      this.profile.country_region = '';
      this.tabD = false;
      this.tabA = true;
    },
    nextProc: function nextProc() {
      var param = {
        name: this.profile.realname,
        org: this.profile.serve_for,
        country: this.profile.country_region,
        email: this.profile.email,
        phone: this.profile.mobile,
        flag: 'direct_update'
      };

      this.$http.post('/api/v2.1/hcp/update_to_hcp', param).then(function (res) {
        console.log('update_to_hcp:', res);
        var error = res.data.error;
        if (0 == error) {
          this.tabB = false;
          this.tabC = false;
          this.tabD = true;
        }
      }, function (err) {});
    },
    create2: function create2() {
      if (false) {
        var bthday = '';
        if (typeof this.profile.birthday !== 'string' && this.profile.birthday !== undefined) {
          bthday = format.formatterDate3(this.profile.birthday.getTime() / 1000);
        } else {
          bthday = this.profile.birthday;
        }
        var obj2 = document.getElementById('gender');
        var gender = obj2.value;
        var obj3 = document.getElementById('major');
        var major = obj3.value;

        var _info = {
          realname: this.profile.realname,
          gender: gender,
          birthday: bthday,
          serve_for: this.profile.serve_for,
          major: major,
          address: this.profile.address + this.address2,
          zipcode: this.profile.zipcode,
          mobile: this.profile.mobile,
          telephone: this.profile.telephone,
          email: this.profile.email,
          motto: this.profile.motto
        };
        if (this.newPortrait.length > 1) {
          _info.portrait = this.newPortrait;
        }
        this.checkInput(_info);
      }
      var info = {
        realname: this.profile.realname,
        mobile: this.profile.mobile,
        email: this.profile.email,
        serve_for: this.profile.serve_for,
        country: this.profile.country_region
      };
      console.log('info:', info);
      if (this.checkInput2(info)) {
        var param = {
          info: {
            name: this.profile.realname,
            org: this.profile.serve_for,
            country: this.profile.country_region,
            email: this.profile.email,
            phone: this.profile.mobile,
            test: 'yes',
            flag: 'direct_create'
          }
        };

        this.$http.post('/api/v2.0/hcp/apply', param).then(function (res) {
          console.log('res:', res);
          var error = res.data.error;
          var user_type = res.data.user_type;
          if (3 == error) {
            if ('D' == user_type) {
              this.$message.error('HCP account exist.');
            } else if ('P' == user_type) {
              this.tabA = false;
              this.tabB = true;
            } else if ('M' == user_type) {
              this.tabA = false;
              this.tabC = true;
            }
          } else if (0 == error) {
            this.tabA = false;
            this.tabD = true;
          } else {
            this.$message.error('error:' + error);
          }
        }, function (err) {});
      }
    },
    create3: function create3() {
      if (false) {
        var bthday = '';
        if (typeof this.profile.birthday !== 'string' && this.profile.birthday !== undefined) {
          bthday = format.formatterDate3(this.profile.birthday.getTime() / 1000);
        } else {
          bthday = this.profile.birthday;
        }
        var obj2 = document.getElementById('gender');
        var gender = obj2.value;
        var info = {
          realname: this.profile.realname,
          gender: gender,
          birthday: bthday,
          address: this.profile.address + this.address2,
          zipcode: this.profile.zipcode,
          mobile: this.profile.mobile,
          telephone: this.profile.telephone,
          email: this.profile.email,
          motto: this.profile.motto
        };
        if (this.newPortrait.length > 1) {
          info.portrait = this.newPortrait;
        }
        this.checkInput(info);
      }
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      this.newPortrait = res.path;
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.uid = parseInt(sessionStorage.getItem('uid'));
    this.usterType = sessionStorage.getItem('userType');
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isEs = lang === 'es' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isZh = lang === 'zh' ? true : false;
    this.isSw = lang === 'sw' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    if (this.usterType === 'P') {
      this.isP = true;this.isD = false;this.isM = false;
    }
    if (this.usterType === 'D') {
      this.isD = true;this.isP = false;this.isM = false;
    }
    if (this.usterType === 'M') {
      this.isM = true;this.isD = false;this.isP = false;
    }
    var countryIndex = localStorage.getItem('index');

    if (1 == countryIndex || 6 == countryIndex || 14 == countryIndex) {
      this.isEU = false;
    }
    this.isCN = this.isZh;

    this.profile = {};
    this.profile.realname = '';
    this.profile.email = '';
    this.profile.mobile = '';
    this.profile.serve_for = '';
    this.profile.country_region = '';

    setTimeout(function () {
      var host = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getOuterHost();
      _this.contactURL = host + '/contact.html';
      _this.privacyURL = host + '/privacy_policy.html';
      _this.termsOfUseURL = host + '/terms_of_use.html';
    }, 50);
  }
});

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isRead: true, open: false, tip: false, usterType: '', uid: 0, noMes: false, isZh: false, isDe: false, isFr: false, isZh1: false,
      messages: [], isCz: false,
      accept: this.$t('acceptTip'),
      cancel: this.$t('cancelTip'),
      reject: this.$t('rejectTip'),
      isEU: true,
      contactURL: '',
      privacyURL: '',
      termsOfUseURL: ''
    };
  },

  computed: {
    portrait: function portrait() {
      return '/api/v2.0/person/' + parseInt(sessionStorage.getItem('uid')) + '/portrait';
    }
  },
  methods: {
    back: function back() {
      this.usterType = sessionStorage.getItem('userType');
      if (this.usterType === 'D') {
        this.$router.push('/PatientList');
      } else if (this.usterType === 'M') {
        this.$router.push('/carerConnection');
      }
    },
    read: function read(index) {
      var obj = document.getElementById(index);
      var mid = this.messages[index][0];
      obj.className = 'note1';
      this.$http.post('api/v2.0/messages/' + mid + '/read', {}).then(function (res) {
        var err = res.body.error;
        if (err === 0) {
          __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getMessages(this, this.uid);
          __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getUnread(this);
        }
      });
    },
    Open: function Open() {
      this.tip = !this.tip;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.uid = parseInt(sessionStorage.getItem('uid'));
    var lang = sessionStorage.getItem('language');
    this.isZh = lang === 'zh' || lang === 'hk' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isZh1 = lang === 'zh' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    var countryIndex = localStorage.getItem('index');

    if (1 == countryIndex || 6 == countryIndex || 14 == countryIndex) {
      this.isEU = false;
    }
    __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getMessages(this, this.uid);

    setTimeout(function () {
      var host = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getOuterHost();
      _this.contactURL = host + '/contact.html';
      _this.privacyURL = host + '/privacy_policy.html';
      _this.termsOfUseURL = host + '/terms_of_use.html';
    }, 50);
  }
});

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isA: false, profile: '', Remark: false, isM: false, alias: ''
    };
  },

  computed: {
    portrait: function portrait() {
      return '/api/v2.0/person/' + parseInt(sessionStorage.getItem('patientId')) + '/portrait';
    }
  },
  methods: {
    back: function back() {
      this.$router.push('/monitor');
    },
    create: function create() {
      var info = {
        data: {
          alias: this.alias
        }
      };
      var Pid = parseInt(sessionStorage.getItem('patientId'));
      __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].modifyPatientProfile2(this, Pid, info);
    }
  },
  mounted: function mounted() {
    var Pid = parseInt(sessionStorage.getItem('patientId'));
    __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getPatientProfile3(this, Pid);
  }
});

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_format__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      realname: '', gender: '', height: '', weight: '', username: '', birthdayShow: '', alias: '', isEs: false, isDe: false, isIt: false, isPo: false,
      birthday: '',
      birthday_d: '', birthday_m: '', birthday_y: '', isFr: false, isSw: false, isCz: false,
      diabetes_type: '', diabetes_diagnosis_date: '', disDateShow: '',
      address1: '', address2: '', postcode: '', mobile: '', telephone: '', email: '',
      inHospital: '', patientNo: '', bedNo: '',
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      isA: false, profile: '', value2: '', value3: ''
    };
  },

  computed: {
    portrait: function portrait() {
      return '/api/v2.0/person/' + parseInt(sessionStorage.getItem('patientId')) + '/portrait';
    }
  },
  methods: {
    back: function back() {
      this.$router.push('/monitor');
    },
    save: function save() {
      var bthday = '';
      this.profile.birthday = this.birthday;
      if (typeof this.profile.birthday !== 'string' && this.profile.birthday !== undefined) {
        bthday = __WEBPACK_IMPORTED_MODULE_1__lib_format__["a" /* default */].formatterDate3(this.profile.birthday.getTime() / 1000);
      } else {
        bthday = this.profile.birthday;
      }
      var diagonosis_date = '';
      if (typeof this.profile.diabetes_diagonosis_date !== 'string' && this.profile.diabetes_diagonosis_date !== undefined) {
        diagonosis_date = __WEBPACK_IMPORTED_MODULE_1__lib_format__["a" /* default */].formatterDate3(this.profile.diabetes_diagonosis_date.getTime() / 1000);
      } else {
        diagonosis_date = this.profile.diabetes_diagonosis_date;
      }

      var obj1 = document.getElementById('dis_type');
      var dis_type = obj1.value;
      var obj2 = document.getElementById('gender');
      var gender = obj2.value;

      var info = {
        realname: this.profile.realname,
        gender: gender,
        height: this.height || this.profile.height,
        weight: this.weight || this.profile.weight,
        birthday: bthday,

        diabetes_type: dis_type,
        diabetes_diagonosis_date: diagonosis_date,

        address: this.profile.address,
        zipcode: this.profile.zipcode,
        mobile: this.profile.mobile,
        telephone: this.profile.telephone,
        email: this.profile.email,
        inHospital: this.profile.inHospital,
        patientNo: this.profile.patientNo,
        bedNo: this.profile.bedNo
      };
      var Pid = parseInt(sessionStorage.getItem('patientId'));
      __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].modifyPatientProfile(this, Pid, info);
    }
  },
  mounted: function mounted() {
    var Pid = parseInt(sessionStorage.getItem('patientId'));
    var lang = sessionStorage.getItem('language');
    this.isEs = lang === 'es' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isSw = lang === 'sw' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getPatientProfile2(this, Pid);
  }
});

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      inpatient: '', patient_no: '', bed_no: '', alias: '', isSw: false, isCz: false,
      isA: false, profile: '', Remark: false, isM: false, isEs: '', isDe: false, isPo: false
    };
  },

  computed: {
    portrait: function portrait() {
      return '/api/v2.0/person/' + parseInt(sessionStorage.getItem('patientId')) + '/portrait';
    }
  },
  methods: {
    back: function back() {
      this.$router.push('/monitor');
    },
    cancel: function cancel() {
      this.Remark = false;
    },
    create: function create() {
      var info = {
        alias: this.alias,
        inHospital: this.profile.inHospital,
        patientNo: this.profile.patientNo,
        bedNo: this.profile.bedNo
      };
      var Pid = parseInt(sessionStorage.getItem('patientId'));
      __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].modifyPatientProfile(this, Pid, info);
    }
  },
  mounted: function mounted() {
    var Pid = parseInt(sessionStorage.getItem('patientId'));
    __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getPatientProfile2(this, Pid);
    var lang = sessionStorage.getItem('language');
    this.isEs = lang === 'es' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isSw = lang === 'sw' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
  }
});

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_format__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isCN: false,
      realname: '', gender: '', height: '', weight: '', isP: true, isD: false, isM: false, isEs: false, isDe: false, isCz: false,
      birthday: '', value2: '', value3: '', isEn: false, isIt: false, isPo: false, isFr: false, isDu: false, isZh: false, isSw: false,
      birthdayShow: '', disDateShow: '',
      dis_type: '11',
      diabetes_type: '', diabetes_diagnosis_date: '',

      address1: '', address2: '', postcode: '', mobile: '', telephone: '', email: '',

      profile: '', imageUrl: '', uid: 0, newPortrait: '', usterType: '',
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      isEU: true,
      contactURL: '',
      privacyURL: '',
      termsOfUseURL: ''
    };
  },

  computed: {
    portrait: function portrait() {
      if (this.imageUrl) {
        return this.imageUrl;
      } else {
        return '/api/v2.0/person/' + parseInt(sessionStorage.getItem('uid')) + '/portrait';
      }
    },
    updateLocCode: function updateLocCode() {
      console.log('compute updateLocCode:');
      return this.$store.state.loc_code;
    }
  },
  watch: {
    updateLocCode: function updateLocCode(val) {
      console.log('watch updateLocCode:', val);
      var host = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getOuterHost();
      this.contactURL = host + '/contact.html';
      this.privacyURL = host + '/privacy_policy.html';
      this.termsOfUseURL = host + '/terms_of_use.html';
    }
  },
  methods: {
    checkInput: function checkInput(info) {
      if (this.profile.email) {
        var re = /@/;
        if (re.test(this.profile.email)) {
          __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].modifyPersonProfile(this, info);
        } else {
          alert('Email Error!');
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].modifyPersonProfile(this, info);
      }
    },
    back: function back() {
      if (this.usterType === 'D') {
        this.$router.push('/PatientList');
      } else if (this.usterType === 'M') {
        this.$router.push('/carerConnection');
      } else {
        this.$router.push('/monitor');
      }
    },
    create1: function create1() {
      var bthday = '';
      if (typeof this.profile.birthday !== 'string' && this.profile.birthday !== undefined) {
        bthday = __WEBPACK_IMPORTED_MODULE_1__lib_format__["a" /* default */].formatterDate3(this.profile.birthday.getTime() / 1000);
      } else {
        bthday = this.profile.birthday;
      }

      var diagonosis_date = '';
      if (typeof this.profile.diabetes_diagonosis_date !== 'string' && this.profile.diabetes_diagonosis_date !== undefined) {
        diagonosis_date = __WEBPACK_IMPORTED_MODULE_1__lib_format__["a" /* default */].formatterDate3(this.profile.diabetes_diagonosis_date.getTime() / 1000);
      } else {
        diagonosis_date = this.profile.diabetes_diagonosis_date;
      }

      var obj1 = document.getElementById('dis_type');
      var dis_type = obj1.value;
      var obj2 = document.getElementById('gender');
      var gender = obj2.value;

      var info = {
        realname: this.profile.realname,
        gender: gender,
        height: this.height || this.profile.height,
        weight: this.weight || this.profile.weight,
        birthday: bthday,
        diabetes_type: dis_type,
        diabetes_diagonosis_date: diagonosis_date,
        address: this.profile.address + this.address2,
        zipcode: this.profile.zipcode,
        mobile: this.profile.mobile,
        telephone: this.profile.telephone,
        email: this.profile.email,
        motto: this.profile.motto,
        country: this.profile.country_region
      };
      if (this.newPortrait.length > 1) {
        info.portrait = this.newPortrait;
      }
      this.checkInput(info);
    },
    create2: function create2() {
      var bthday = '';
      if (typeof this.profile.birthday !== 'string' && this.profile.birthday !== undefined) {
        bthday = __WEBPACK_IMPORTED_MODULE_1__lib_format__["a" /* default */].formatterDate3(this.profile.birthday.getTime() / 1000);
      } else {
        bthday = this.profile.birthday;
      }
      var obj2 = document.getElementById('gender');
      var gender = obj2.value;
      var obj3 = document.getElementById('major');
      var major = obj3.value;

      var info = {
        realname: this.profile.realname,
        gender: gender,
        birthday: bthday,
        serve_for: this.profile.serve_for,
        major: major,
        address: this.profile.address + this.address2,
        zipcode: this.profile.zipcode,
        mobile: this.profile.mobile,
        telephone: this.profile.telephone,
        email: this.profile.email,
        motto: this.profile.motto
      };
      if (this.newPortrait.length > 1) {
        info.portrait = this.newPortrait;
      }
      this.checkInput(info);
    },
    create3: function create3() {
      var bthday = '';
      if (typeof this.profile.birthday !== 'string' && this.profile.birthday !== undefined) {
        bthday = __WEBPACK_IMPORTED_MODULE_1__lib_format__["a" /* default */].formatterDate3(this.profile.birthday.getTime() / 1000);
      } else {
        bthday = this.profile.birthday;
      }
      var obj2 = document.getElementById('gender');
      var gender = obj2.value;
      var info = {
        realname: this.profile.realname,
        gender: gender,
        birthday: bthday,
        address: this.profile.address + this.address2,
        zipcode: this.profile.zipcode,
        mobile: this.profile.mobile,
        telephone: this.profile.telephone,
        email: this.profile.email,
        motto: this.profile.motto
      };
      if (this.newPortrait.length > 1) {
        info.portrait = this.newPortrait;
      }
      this.checkInput(info);
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      this.newPortrait = res.path;
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.uid = parseInt(sessionStorage.getItem('uid'));
    this.usterType = sessionStorage.getItem('userType');
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isEs = lang === 'es' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isZh = lang === 'zh' ? true : false;
    this.isSw = lang === 'sw' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    if (this.usterType === 'P') {
      this.isP = true;this.isD = false;this.isM = false;
    }
    if (this.usterType === 'D') {
      this.isD = true;this.isP = false;this.isM = false;
    }
    if (this.usterType === 'M') {
      this.isM = true;this.isD = false;this.isP = false;
    }
    var countryIndex = localStorage.getItem('index');

    if (1 == countryIndex || 6 == countryIndex || 14 == countryIndex) {
      this.isEU = false;
    }
    this.isCN = this.isZh;
    __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getProfile(this);

    setTimeout(function () {
      var host = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getOuterHost();
      _this.contactURL = host + '/contact.html';
      _this.privacyURL = host + '/privacy_policy.html';
      _this.termsOfUseURL = host + '/terms_of_use.html';
    }, 50);
  }
});

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_format__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      realname: '', gender: '', height: '', weight: '', isP: true, isD: false, isM: false, isEs: false, isDe: false, isCz: false,
      birthday: '', value2: '', value3: '', isEn: false, isIt: false, isPo: false, isFr: false, isDu: false, isZh: false, isSw: false,
      birthdayShow: '', disDateShow: '',
      dis_type: '11',
      diabetes_type: '', diabetes_diagnosis_date: '',

      address1: '', address2: '', postcode: '', mobile: '', telephone: '', email: '',

      profile: '', imageUrl: '', uid: 0, newPortrait: '', usterType: '',
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      isEU: true,
      contactURL: '',
      privacyURL: '',
      termsOfUseURL: ''
    };
  },

  computed: {
    portrait: function portrait() {
      if (this.imageUrl) {
        return this.imageUrl;
      } else {
        return '/api/v2.0/person/' + parseInt(sessionStorage.getItem('uid')) + '/portrait';
      }
    }
  },
  methods: {
    checkInput: function checkInput(info) {
      if (this.profile.email) {
        var re = /@/;
        if (re.test(this.profile.email)) {
          __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].modifyPersonProfile(this, info);
        } else {
          alert('Email Error!');
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].modifyPersonProfile(this, info);
      }
    },
    back: function back() {
      if (this.usterType === 'D') {
        this.$router.push('/PatientList');
      } else if (this.usterType === 'M') {
        this.$router.push('/carerConnection');
      } else {
        this.$router.push('/monitor');
      }
    },
    create1: function create1() {
      var bthday = '';
      if (typeof this.profile.birthday !== 'string' && this.profile.birthday !== undefined) {
        bthday = __WEBPACK_IMPORTED_MODULE_1__lib_format__["a" /* default */].formatterDate3(this.profile.birthday.getTime() / 1000);
      } else {
        bthday = this.profile.birthday;
      }

      var diagonosis_date = '';
      if (typeof this.profile.diabetes_diagonosis_date !== 'string' && this.profile.diabetes_diagonosis_date !== undefined) {
        diagonosis_date = __WEBPACK_IMPORTED_MODULE_1__lib_format__["a" /* default */].formatterDate3(this.profile.diabetes_diagonosis_date.getTime() / 1000);
      } else {
        diagonosis_date = this.profile.diabetes_diagonosis_date;
      }

      var obj1 = document.getElementById('dis_type');
      var dis_type = obj1.value;
      var obj2 = document.getElementById('gender');
      var gender = obj2.value;

      var info = {
        realname: this.profile.realname,
        gender: gender,
        height: this.height || this.profile.height,
        weight: this.weight || this.profile.weight,
        birthday: bthday,
        diabetes_type: dis_type,
        diabetes_diagonosis_date: diagonosis_date,
        address: this.profile.address + this.address2,
        zipcode: this.profile.zipcode,
        mobile: this.profile.mobile,
        telephone: this.profile.telephone,
        email: this.profile.email,
        motto: this.profile.motto
      };
      if (this.newPortrait.length > 1) {
        info.portrait = this.newPortrait;
      }
      this.checkInput(info);
    },
    create2: function create2() {
      var bthday = '';
      if (typeof this.profile.birthday !== 'string' && this.profile.birthday !== undefined) {
        bthday = __WEBPACK_IMPORTED_MODULE_1__lib_format__["a" /* default */].formatterDate3(this.profile.birthday.getTime() / 1000);
      } else {
        bthday = this.profile.birthday;
      }
      var obj2 = document.getElementById('gender');
      var gender = obj2.value;
      var obj3 = document.getElementById('major');
      var major = obj3.value;

      var info = {
        realname: this.profile.realname,
        gender: gender,
        birthday: bthday,
        serve_for: this.profile.serve_for,
        major: major,
        address: this.profile.address + this.address2,
        zipcode: this.profile.zipcode,
        mobile: this.profile.mobile,
        telephone: this.profile.telephone,
        email: this.profile.email,
        motto: this.profile.motto
      };
      if (this.newPortrait.length > 1) {
        info.portrait = this.newPortrait;
      }
      this.checkInput(info);
    },
    create3: function create3() {
      var bthday = '';
      if (typeof this.profile.birthday !== 'string' && this.profile.birthday !== undefined) {
        bthday = __WEBPACK_IMPORTED_MODULE_1__lib_format__["a" /* default */].formatterDate3(this.profile.birthday.getTime() / 1000);
      } else {
        bthday = this.profile.birthday;
      }
      var obj2 = document.getElementById('gender');
      var gender = obj2.value;
      var info = {
        realname: this.profile.realname,
        gender: gender,
        birthday: bthday,
        address: this.profile.address + this.address2,
        zipcode: this.profile.zipcode,
        mobile: this.profile.mobile,
        telephone: this.profile.telephone,
        email: this.profile.email,
        motto: this.profile.motto
      };
      if (this.newPortrait.length > 1) {
        info.portrait = this.newPortrait;
      }
      this.checkInput(info);
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      this.newPortrait = res.path;
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.uid = parseInt(sessionStorage.getItem('uid'));
    this.usterType = sessionStorage.getItem('userType');
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isEs = lang === 'es' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isZh = lang === 'zh' ? true : false;
    this.isSw = lang === 'sw' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    if (this.usterType === 'P') {
      this.isP = true;this.isD = false;this.isM = false;
    }
    if (this.usterType === 'D') {
      this.isD = true;this.isP = false;this.isM = false;
    }
    if (this.usterType === 'M') {
      this.isM = true;this.isD = false;this.isP = false;
    }
    var countryIndex = localStorage.getItem('index');

    if (1 == countryIndex || 6 == countryIndex || 14 == countryIndex) {
      this.isEU = false;
    }
    __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getProfile(this);
    setTimeout(function () {
      var host = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].getOuterHost();
      _this.contactURL = host + '/contact.html';
      _this.privacyURL = host + '/privacy_policy.html';
      _this.termsOfUseURL = host + '/terms_of_use.html';
    }, 50);
  }
});

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vertifyDialog',
  props: {
    title: String,
    confirmText: String
  },
  data: function data() {
    return {
      dialogVisible: false
    };
  },

  methods: {
    confirm: function confirm() {
      this.$emit('confirm');
    },
    handleClose: function handleClose() {
      this.$emit('handleClose');
    }
  }
});

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_echarts__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_format__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_base64__ = __webpack_require__(9);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      value1: '', value2: '', defaultDate: '17-8-2017', value3: '', value4: '', value5: '', value6: '', uid: 0, maxlength: 40, isIt: false,
      t1: '', t2: '', t3: '', t4: '', t5: '', t6: '', t7: '', userType: '', username: '', now: '', isCz: false,
      isEn: false, isEs: false, Time: this.$t('time'), isDe: false, isPo: false, isDu: false, isFr: false, isSw: false,
      tip0: this.$t('Enterdis'),
      tip1: this.$t('Enter suggestion'),
      tip2: this.$t('Enter dose'),
      tip3: this.$t('Enter medicine'),
      tip4: this.$t('Add note'),
      tip5: this.$t('Add Content'),

      profile: {}, complications: [], prescription: [], suggestions: [],
      comp: [], compl: [], pre: [], sug: [], dialogSize: 'tiny',

      CreateVisible: false, typeA: false, typeB: false, typeC: false,
      EditVisible: false, typeA1: false, typeB1: false, typeC1: false,

      edNote1: "", edNote2: "", edNote3: "", edNote4: "", edNote5: "", edNote0: "",

      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      dis: ["CORONARY_HEART_DISEASE", "HIGH_BLOOD_LIPIDS", "HIGH_BLOOD_PRESSURE", "KIDNEY_DISEASE", "NEUROPATHY", "OBESITY", "PERIPHERAL_ARTERIAL_DISEASE", "RETINOPATHY", "SMOKING_ADDICTION"]
    };
  },

  methods: {
    cancel: function cancel() {
      this.CreateVisible = false;
    },
    create1: function create1() {
      this.CreateVisible = true;
      this.typeA = true;
      this.typeB = false;
      this.typeC = false;
      this.t2 = '';
      this.t1 = '';
    },
    create2: function create2() {
      this.CreateVisible = true;
      this.typeB = true;
      this.typeA = false;
      this.typeC = false;
      this.t3 = '';this.t4 = '';this.t5 = '';
    },
    create3: function create3() {
      this.CreateVisible = true;
      this.typeC = true;
      this.typeA = false;
      this.typeB = false;
      this.t7 = '';
    },
    createRecord1: function createRecord1() {
      var comp = [];
      comp[1] = this.t1;
      comp[2] = this.t2;
      var time1 = this.value3 ? this.value3.getTime() / 1000 : '';
      comp[0] = time1;
      var data = {
        complications: [comp]
      };
      if (comp[1] && comp[0]) {
        __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].newRecords(this, this.uid, data);
      } else {
        alert('Concomitant disease and Date of diagnosis is required!');
      }
    },
    createRecord2: function createRecord2() {
      var pre = [];
      pre[0] = this.t3;
      pre[1] = this.t4;
      pre[2] = this.t5;
      var data = {
        prescription: [pre]
      };
      if (pre[1] && pre[0]) {
        __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].newRecords(this, this.uid, data);
      } else {
        alert('Medicine and Dose is required!');
      }
    },
    createRecord3: function createRecord3() {
      var sug = [];
      sug[1] = this.t7;
      sug[2] = this.t6;
      var time1 = new Date().getTime() / 1000;
      sug[0] = time1;
      var data = {
        suggestions: [sug]
      };
      if (sug[1]) {
        __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].newRecords(this, this.uid, data);
      } else {
        alert('Input content');
      }
    },
    delete1: function delete1(e) {
      var _this = this;

      var tip = this.$t('deleteThis');
      var tip1 = this.$t('confirm');
      var tip2 = this.$t('Yes');
      var tip3 = this.$t('Cancel');
      this.$confirm(tip, tip1, {
        confirmButtonText: tip2,
        cancelButtonText: tip3,
        type: 'warning'
      }).then(function () {
        var index = e.target.parentNode.parentNode.id;
        var eid = _this.complications[index][0];
        var eids = [];
        eids.push(eid);
        var rids = {
          complications: eids,
          prescription: [],
          suggestions: []
        };
        __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].deleteRecords(_this, _this.uid, rids);
      }, function () {});
    },
    delete2: function delete2(e) {
      var _this2 = this;

      var tip = this.$t('deleteThis');
      var tip1 = this.$t('confirm');
      var tip2 = this.$t('Yes');
      var tip3 = this.$t('Cancel');
      this.$confirm(tip, tip1, {
        confirmButtonText: tip2,
        cancelButtonText: tip3
      }).then(function () {
        var index = e.target.parentNode.parentNode.id;
        var eid = _this2.prescription[index][0];
        var eids = [];
        eids.push(eid);
        var rids = {
          complications: [],
          prescription: eids,
          suggestions: []
        };
        __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].deleteRecords(_this2, _this2.uid, rids);
      }, function () {});
    },
    delete3: function delete3(e) {
      var _this3 = this;

      var tip = this.$t('deleteThis');
      var tip1 = this.$t('confirm');
      var tip2 = this.$t('Yes');
      var tip3 = this.$t('Cancel');
      this.$confirm(tip, tip1, {
        confirmButtonText: tip2,
        cancelButtonText: tip3
      }).then(function () {
        var index = e.target.parentNode.parentNode.id;
        var eid = _this3.suggestions[index][0];
        var eids = [];
        eids.push(eid);
        var rids = {
          suggestions: eids
        };
        __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].deleteRecords(_this3, _this3.uid, rids);
      }, function () {});
    },
    cancel1: function cancel1() {
      this.EditVisible = false;
    },
    edit1: function edit1(e) {
      var index = e.target.parentNode.parentNode.id;
      this.comp = this.complications[index];
      this.edNote0 = this.comp[1];
      this.edNote1 = this.comp[3];
      this.EditVisible = true;
      this.typeA1 = true;
      this.typeB1 = false;
      this.typeC1 = false;
    },
    edit2: function edit2(e) {
      var index = e.target.parentNode.parentNode.id;
      this.pre = this.prescription[index];
      this.edNote2 = this.pre[1];
      this.edNote3 = this.pre[2];
      this.edNote4 = this.pre[3];
      this.EditVisible = true;
      this.typeB1 = true;
      this.typeA1 = false;
      this.typeC1 = false;
    },
    edit3: function edit3(e) {
      var index = e.target.parentNode.parentNode.id;
      this.sug = this.suggestions[index];
      this.edNote5 = this.sug[2];
      this.EditVisible = true;
      this.typeC1 = true;
      this.typeB1 = false;
      this.typeA1 = false;
    },
    editRecords1: function editRecords1() {
      var comp = [];
      comp[0] = this.comp[0];
      var day = this.comp[2].split('-');
      var isEn = sessionStorage.getItem('language') !== 'zh' ? true : false;
      var day2 = isEn ? day[2] + '-' + day[1] + '-' + day[0] : day[0] + '-' + day[1] + '-' + day[2];
      var second = new Date(day2).getTime() / 1000 - 3600 * 8;
      var time1 = this.value5 ? this.value5.getTime() / 1000 : second;
      comp[1] = time1;
      comp[2] = this.edNote0;
      comp[3] = this.edNote1;
      var data = {
        complications: comp
      };
      __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].editRecords(this, this.uid, data);
    },
    editRecords2: function editRecords2() {
      var pre = [];
      pre[0] = this.pre[0];
      pre[1] = this.edNote2;
      pre[2] = this.edNote3;
      pre[3] = this.edNote4;
      var data = {
        prescription: pre
      };
      if (pre[1] && pre[2]) {
        __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].editRecords(this, this.uid, data);
      } else {
        alert('Medicine and Dose is required!');
      }
    },
    editRecords3: function editRecords3() {
      var sug = [];
      sug[0] = this.sug[0];
      var time1 = new Date().getTime() / 1000;
      sug[1] = time1;
      sug[2] = this.edNote5;
      var data = {
        suggestions: sug
      };
      if (sug[2]) {
        __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].editRecords(this, this.uid, data);
      } else {
        alert('Input content');
      }
    },
    print: function print() {
      window.open('/#/record-print', '_blank');
    }
  },
  mounted: function mounted() {
    var lang = sessionStorage.getItem('language');
    this.isEn = lang !== 'zh' && lang !== 'hk' ? true : false;
    this.isEs = lang === 'es' ? true : false;
    this.isDe = lang === 'de' ? true : false;
    this.isIt = lang === 'it' ? true : false;
    this.isPo = lang === 'po' ? true : false;
    this.isDu = lang === 'du' ? true : false;
    this.isFr = lang === 'fr' ? true : false;
    this.isSw = lang === 'sw' ? true : false;
    this.isCz = lang === 'cz' ? true : false;
    this.userType = sessionStorage.getItem('userType');
    this.username = sessionStorage.getItem('username');
    var isEn = lang !== 'zh' ? true : false;
    this.now = isEn ? __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate4(new Date().getTime() / 1000) : __WEBPACK_IMPORTED_MODULE_2__lib_format__["a" /* default */].formatterDate3(new Date().getTime() / 1000);
    if (sessionStorage.getItem('userType') !== 'P') {
      this.uid = parseInt(sessionStorage.getItem('patientId'));
    } else {
      this.uid = parseInt(sessionStorage.getItem('uid'));
    }
    var win = window.innerWidth;
    this.dialogSize = win < 1500 ? 'small' : 'tiny';
    __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].getRecords(this, this.uid);
  }
});

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_base64__ = __webpack_require__(9);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      username: '', tryAgain: false, isZh: false,
      Vcode: '',
      password: '',
      error: '',
      send: this.$t('send'),
      canClick: false,
      user: this.$t('user'),
      veri: this.$t('Entercode'),
      newpass: this.$t('New pass'),
      styleChange: this.$store.state.language === 'zh' ? true : false, token: '', passwordToken: '',
      isA: true, isB: false, isC: false, isD: false,
      isE: false,
      isF: false, udHcp: true
    };
  },

  computed: {
    getLanguage: function getLanguage() {
      return this.$store.state.language;
    }
  },
  watch: {
    getLanguage: function getLanguage(val) {
      this.user = this.$t('user');
      this.send = this.$t('send');
      if (val === 'zh') {
        this.styleChange = true;
      } else {
        this.styleChange = false;
      }
    }
  },
  methods: {
    check1: function check1(flag) {
      if (flag === 0) {
        if (this.username === "") {
          var tip = this.$t('enterEmTip');
          this.$message.error(tip);
        } else {
          this.$http.get('api/v2.0/user/' + this.username).then(function (res) {
            var exist = res.body.exist;
            if (exist) {
              this.isA = false;
              this.isB = true;
              sessionStorage.setItem('A', 0);
              sessionStorage.setItem('B', 1);
              this.sendSeccode2();
            } else {
              var _tip = this.$t('userNotExist');
              this.$message.error(_tip);
            }
          });
        }
      }
      if (flag === 1) {
        this.isA = true;
        this.isB = false;
        sessionStorage.setItem('A', 1);
        sessionStorage.setItem('B', 0);
      }
    },
    sendSeccode1: function sendSeccode1() {
      if (!this.tryAgain) {
        this.sendSeccode2();
        var tip = '';
        if (this.isZh) {
          tip = this.$t('VcodeTip1') + ' ' + this.username;
        } else {
          tip = this.$t('VcodeTip3') + ' ' + this.username;
        }
        this.$message({
          type: 'success',
          message: tip
        });
        this.tryAgain = true;
      }
    },
    sendSeccode2: function sendSeccode2() {
      var para = {
        user_name: this.username,
        country: 'CN',
        flag: '',
        purpose: 'findpw'
      };
      if (this.username.indexOf('@') === -1) {
        para.flag = 'mobile';
      } else {
        para.flag = 'email';
      }
      __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].sendSeccode(this, para);
      __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].setTime(this);
    },
    check2: function check2(flag) {
      var param = {
        seccode: this.Vcode,
        token: this.token
      };
      param = __WEBPACK_IMPORTED_MODULE_2__auth_base64__["a" /* default */].base64encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param));

      if (flag === 0) {
        __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].getToken(this, param);
      }
      if (flag === 1) {
        this.isB = true;
        this.isC = false;
        sessionStorage.setItem('B', 1);
        sessionStorage.setItem('C', 0);
      }
    },
    check3: function check3() {
      var para = {
        username: this.username,
        new_password: this.password,
        token: this.passwordToken
      };
      __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].resetPassword(this, para);
    },
    check4: function check4() {
      this.isE = !this.isE;
      if (this.user === '') {
        this.user = this.$t('user');
      } else {
        this.user = '';
      }
      if (this.veri === '') {
        this.veri = this.$t('Entercode');
      } else {
        this.veri = '';
      }
      if (this.newpass === '') {
        this.newpass = this.$t('New pass');
      } else {
        this.newpass = '';
      }
    },
    choose: function choose() {
      this.isF = !this.isF;
    },
    goHome: function goHome() {
      if (this.udHcp) {
        this.$router.push('/login');
      } else {
        this.$router.push('/hcpLogin');
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    sessionStorage.removeItem('udHcp');
  },
  mounted: function mounted() {
    if (sessionStorage.getItem('udHcp')) {
      this.udHcp = sessionStorage.getItem('udHcp') === '1' ? true : false;
    }
    var lang = sessionStorage.getItem('language');
    this.isZh = lang === 'zh' || lang === 'hk' ? true : false;
  }
});

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      routeData: {},
      mfa_seccode: '',
      codeText: this.$t('Getcode'),
      canGetCode: true,
      isErrorCode: false,
      tipHtml: ''
    };
  },
  created: function created() {
    this.routeData = JSON.parse(sessionStorage.getItem('loginInfo'));
    this.tipHtml = this.$t('t1215_Multi_factor_ON');
  },

  watch: {
    mfa_seccode: function mfa_seccode(val, oldval) {
      this.isErrorCode = false;
    }
  },
  methods: {
    next: function next() {
      this.routeData.mfa_seccode = this.mfa_seccode;
      var postData = this.routeData;
      __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].login(this, postData);
    },
    setCode: function setCode() {
      var _this = this;

      this.canGetCode = false;
      var time = 60;
      this.codeText = time + ' s';
      var timer = setInterval(function () {
        if (time <= 0) {
          clearInterval(timer);
          _this.canGetCode = true;
          _this.codeText = _this.$t('Getcode');
        } else {
          time -= 1;
          _this.codeText = time + ' s';
        }
      }, 1000);
    },
    getCode: function getCode() {
      var _this2 = this;

      this.isErrorCode = false;
      if (this.canGetCode) {
        var postData = {
          user_name: this.routeData.user_name,
          flag: this.routeData.user_name.match(/^[\d]+$/g) ? 'mobile' : 'email',
          country: this.routeData.country,
          purpose: 'login_mfa'
        };
        this.$http.post('/api/v2.0/seccode/send', postData).then(function (res) {
          if (res.body.error === 0) {
            _this2.setCode();
          } else if (res.body.error === 1) {
            var tip = _this2.$t('userNotExist');
            _this2.$message.error(tip);
          } else {
            var _tip = _this2.$t('tryAgain');
            _this2.$message.error(_tip);
          }
        });
      }
    }
  }
});

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);



(function (view) {
    "use strict";

    view.URL = view.URL || view.webkitURL;

    if (view.Blob && view.URL) {
        try {
            new Blob();
            return;
        } catch (e) {}
    }

    var BlobBuilder = view.BlobBuilder || view.WebKitBlobBuilder || view.MozBlobBuilder || function (view) {
        var get_class = function get_class(object) {
            return Object.prototype.toString.call(object).match(/^\[object\s(.*)\]$/)[1];
        },
            FakeBlobBuilder = function BlobBuilder() {
            this.data = [];
        },
            FakeBlob = function Blob(data, type, encoding) {
            this.data = data;
            this.size = data.length;
            this.type = type;
            this.encoding = encoding;
        },
            FBB_proto = FakeBlobBuilder.prototype,
            FB_proto = FakeBlob.prototype,
            FileReaderSync = view.FileReaderSync,
            FileException = function FileException(type) {
            this.code = this[this.name = type];
        },
            file_ex_codes = ("NOT_FOUND_ERR SECURITY_ERR ABORT_ERR NOT_READABLE_ERR ENCODING_ERR " + "NO_MODIFICATION_ALLOWED_ERR INVALID_STATE_ERR SYNTAX_ERR").split(" "),
            file_ex_code = file_ex_codes.length,
            real_URL = view.URL || view.webkitURL || view,
            real_create_object_URL = real_URL.createObjectURL,
            real_revoke_object_URL = real_URL.revokeObjectURL,
            URL = real_URL,
            btoa = view.btoa,
            atob = view.atob,
            ArrayBuffer = view.ArrayBuffer,
            Uint8Array = view.Uint8Array,
            origin = /^[\w-]+:\/*\[?[\w\.:-]+\]?(?::[0-9]+)?/;
        FakeBlob.fake = FB_proto.fake = true;
        while (file_ex_code--) {
            FileException.prototype[file_ex_codes[file_ex_code]] = file_ex_code + 1;
        }

        if (!real_URL.createObjectURL) {
            URL = view.URL = function (uri) {
                var uri_info = document.createElementNS("http://www.w3.org/1999/xhtml", "a"),
                    uri_origin;
                uri_info.href = uri;
                if (!("origin" in uri_info)) {
                    if (uri_info.protocol.toLowerCase() === "data:") {
                        uri_info.origin = null;
                    } else {
                        uri_origin = uri.match(origin);
                        uri_info.origin = uri_origin && uri_origin[1];
                    }
                }
                return uri_info;
            };
        }
        URL.createObjectURL = function (blob) {
            var type = blob.type,
                data_URI_header;
            if (type === null) {
                type = "application/octet-stream";
            }
            if (blob instanceof FakeBlob) {
                data_URI_header = "data:" + type;
                if (blob.encoding === "base64") {
                    return data_URI_header + ";base64," + blob.data;
                } else if (blob.encoding === "URI") {
                    return data_URI_header + "," + decodeURIComponent(blob.data);
                }
                if (btoa) {
                    return data_URI_header + ";base64," + btoa(blob.data);
                } else {
                    return data_URI_header + "," + encodeURIComponent(blob.data);
                }
            } else if (real_create_object_URL) {
                return real_create_object_URL.call(real_URL, blob);
            }
        };
        URL.revokeObjectURL = function (object_URL) {
            if (object_URL.substring(0, 5) !== "data:" && real_revoke_object_URL) {
                real_revoke_object_URL.call(real_URL, object_URL);
            }
        };
        FBB_proto.append = function (data) {
            var bb = this.data;

            if (Uint8Array && (data instanceof ArrayBuffer || data instanceof Uint8Array)) {
                var str = "",
                    buf = new Uint8Array(data),
                    i = 0,
                    buf_len = buf.length;
                for (; i < buf_len; i++) {
                    str += String.fromCharCode(buf[i]);
                }
                bb.push(str);
            } else if (get_class(data) === "Blob" || get_class(data) === "File") {
                if (FileReaderSync) {
                    var fr = new FileReaderSync();
                    bb.push(fr.readAsBinaryString(data));
                } else {
                    throw new FileException("NOT_READABLE_ERR");
                }
            } else if (data instanceof FakeBlob) {
                if (data.encoding === "base64" && atob) {
                    bb.push(atob(data.data));
                } else if (data.encoding === "URI") {
                    bb.push(decodeURIComponent(data.data));
                } else if (data.encoding === "raw") {
                    bb.push(data.data);
                }
            } else {
                if (typeof data !== "string") {
                    data += "";
                }

                bb.push(unescape(encodeURIComponent(data)));
            }
        };
        FBB_proto.getBlob = function (type) {
            if (!arguments.length) {
                type = null;
            }
            return new FakeBlob(this.data.join(""), type, "raw");
        };
        FBB_proto.toString = function () {
            return "[object BlobBuilder]";
        };
        FB_proto.slice = function (start, end, type) {
            var args = arguments.length;
            if (args < 3) {
                type = null;
            }
            return new FakeBlob(this.data.slice(start, args > 1 ? end : this.data.length), type, this.encoding);
        };
        FB_proto.toString = function () {
            return "[object Blob]";
        };
        FB_proto.close = function () {
            this.size = 0;
            delete this.data;
        };
        return FakeBlobBuilder;
    }(view);

    view.Blob = function (blobParts, options) {
        var type = options ? options.type || "" : "";
        var builder = new BlobBuilder();
        if (blobParts) {
            for (var i = 0, len = blobParts.length; i < len; i++) {
                if (Uint8Array && blobParts[i] instanceof Uint8Array) {
                    builder.append(blobParts[i].buffer);
                } else {
                    builder.append(blobParts[i]);
                }
            }
        }
        var blob = builder.getBlob(type);
        if (!blob.slice && blob.webkitSlice) {
            blob.slice = blob.webkitSlice;
        }
        return blob;
    };

    var getPrototypeOf = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a || function (object) {
        return object.__proto__;
    };
    view.Blob.prototype = getPrototypeOf(new view.Blob());
})(typeof self !== "undefined" && self || typeof window !== "undefined" && window || this);

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_index_css__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuerify__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuerify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuerify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_v_vuerify_next__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_v_vuerify_next___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_v_vuerify_next__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_i18n__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_locale_lang_en__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_locale_lang_zh_CN__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_locale_lang_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_locale_lang_zh_CN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_locale_lang_es__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_locale_lang_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_locale_lang_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_locale_lang_de__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_locale_lang_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_locale_lang_de__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_locale_lang_it__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_locale_lang_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_locale_lang_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_locale_lang_pt__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_locale_lang_pt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_locale_lang_pt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_locale_lang_pl__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_locale_lang_pl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_locale_lang_pl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_locale_lang_fi__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_locale_lang_fi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_locale_lang_fi__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_locale_lang_zh_TW__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_locale_lang_zh_TW___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_locale_lang_zh_TW__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_locale_lang_nl__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_locale_lang_nl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_locale_lang_nl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_locale_lang_fr__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_locale_lang_fr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_locale_lang_fr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_locale_lang_sv_SE__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_locale_lang_sv_SE___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_locale_lang_sv_SE__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_locale_lang_cz__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_locale_lang_cz___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_element_ui_lib_locale_lang_cz__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_locale_lang_da__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_locale_lang_da___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_element_ui_lib_locale_lang_da__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_locale_lang_tr_TR__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_locale_lang_tr_TR___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_element_ui_lib_locale_lang_tr_TR__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__static_login_css__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__static_login_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__static_login_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__auth_store__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__routes__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__lang_cz_js__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__lang_de_js__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__lang_dk_js__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__lang_du_js__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__lang_en_js__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__lang_es_js__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__lang_fi_js__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__lang_fr_js__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__lang_hk_js__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__lang_it_js__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__lang_pl_js__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__lang_po_js__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__lang_sw_js__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__lang_tr_js__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__lang_zh_js__ = __webpack_require__(560);































__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vuerify___default.a, {
  icode: { test: /^\d{6}$/, message: '请输入6位数字' },
  mobile: { test: /\d{1,}/, message: 'Mobile must have 1 or more numbers' },
  realname: { test: /^[A-Za-z0-9][A-Za-z0-9\s]{2,18}[A-Za-z0-9]$/, message: '请输入正确姓名' },
  password: { test: /\S{6,20}/, message: '密码格式不对' },
  postcode: { test: /^\d{6}$/, message: '请输入6位数字' },
  height: { test: /^\d{2,}$/, message: 'Height must have 2 or more numbers' },
  weight: { test: /^\d{2,}$/, message: 'Weight must have 2 or more numbers' },
  email: { test: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/, message: 'Please enter a valid Email.' }
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_v_vuerify_next___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* default */]);

var hostname = window.location.hostname.split('.')[2];
var href = window.location.href;
var lang = 'en';
var search = href.split('=')[1];
var country = ['GB', 'CN', 'FR', 'DD', 'SE', 'AU', 'HKF', 'HU', 'IT', 'NL', 'Nor', 'PT', 'ES', 'TR', 'AE', 'Ro', 'CZ', 'SK', 'LT', 'PL', 'DK', 'FI'];
var languages = ['en', 'zh', 'fr', 'de', 'sw', 'en', 'hk', 'en', 'it', 'du', 'en', 'po', 'es', 'tr', 'en', 'en', 'cz', 'en', 'en', 'pl', 'dk', 'fi'];

if (1) {
  if (!search) {
    if (hostname === 'cn') {
      lang = 'zh';
    } else {
      var langStore = localStorage.getItem('language');
      if (!langStore) {
        lang = 'en';
      } else {
        lang = langStore;
      }
    }
  } else {
    var index = 0;
    country.map(function (e, i) {
      if (e === search) {
        index = i;
      }
    });
    if (search === 'DE') {
      index = 3;
    }
    lang = languages[index];
  }
} else {
  var _langStore = localStorage.getItem('language');
  if (!_langStore) {
    if (!search) {
      if (hostname === 'cn') {
        lang = 'zh';
      } else {
        lang = 'en';
      }
    } else {
      var _index = 0;
      country.map(function (e, i) {
        if (e === search) {
          _index = i;
        }
      });
      if (search === 'DE') {
        _index = 3;
      }
      lang = languages[_index];
    }
  } else {
    lang = _langStore;
  }
  console.log('lang:' + _langStore + ',' + lang + ',' + search + ',' + hostname);
}

















var _i18n = new __WEBPACK_IMPORTED_MODULE_9_vue_i18n__["a" /* default */]({
  locale: lang,

  messages: {
    'cz': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_29__lang_cz_js__["a" /* czMessages */], __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_locale_lang_cz___default.a),
    'de': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_30__lang_de_js__["a" /* deMessages */], __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_locale_lang_de___default.a),
    'dk': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_31__lang_dk_js__["a" /* dkMessages */], __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_locale_lang_da___default.a),
    'du': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_32__lang_du_js__["a" /* duMessages */], __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_locale_lang_nl___default.a),
    'en': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_33__lang_en_js__["a" /* enMessages */], __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_locale_lang_en___default.a),
    'es': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_34__lang_es_js__["a" /* esMessages */], __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_locale_lang_es___default.a),
    'fi': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_35__lang_fi_js__["a" /* fiMessages */], __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_locale_lang_fi___default.a),
    'fr': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_36__lang_fr_js__["a" /* frMessages */], __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_locale_lang_fr___default.a),
    'hk': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_37__lang_hk_js__["a" /* hkMessages */], __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_locale_lang_zh_TW___default.a),
    'it': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_38__lang_it_js__["a" /* itMessages */], __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_locale_lang_it___default.a),
    'pl': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_39__lang_pl_js__["a" /* plMessages */], __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_locale_lang_pl___default.a),
    'po': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_40__lang_po_js__["a" /* poMessages */], __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_locale_lang_pt___default.a),
    'sw': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_41__lang_sw_js__["a" /* swMessages */], __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_locale_lang_sv_SE___default.a),
    'tr': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_42__lang_tr_js__["a" /* trMessages */], __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_locale_lang_tr_TR___default.a),
    'zh': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_43__lang_zh_js__["a" /* zhMessages */], __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_locale_lang_zh_CN___default.a)

  }
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui___default.a, {
  i18n: function i18n(key, value) {
    return _i18n.t(key, value);
  }
});

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_28__routes__["a" /* default */]
});

router.beforeEach(function (to, from, next) {
  if (!sessionStorage.getItem('token')) {
    if (to.path !== '/login' && to.path !== '/sign' && to.path !== '/hcpSign' && to.path !== '/hcpLogin' && to.path !== '/updating' && to.path !== '/error' && to.path !== '/updatePassword' && to.path !== '/personalApply' && to.path !== '/accountsmanagement' && to.path !== '/managementtools' && to.path !== '/verificationCode' && to.path !== '/clinic') {
      next({ path: '/login' });
    } else {
      next();
    }
  } else {
    next();
  }
});

var vm = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  router: router,
  store: __WEBPACK_IMPORTED_MODULE_27__auth_store__["a" /* default */],
  i18n: _i18n,
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__App_vue___default.a);
  }
}).$mount('#app');

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.pushRequest = function (request) {
  this.$store.commit('updateRequest', request);
};
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.interceptors.push(function (request, next) {
  if (request.method === 'GET') {
    request.url += '?_=' + new Date().getTime();
  }
  if (request.url === 'api/v2.0/monitor/data') {
    vm.pushRequest(request);
  }
  var timeout = void 0;
  if (request._timeout) {
    timeout = setTimeout(function () {
      if (request.onTimeout) {
        request.onTimeout(request);
        request.abort();
      }
    }, request._timeout);
  }
  next(function (response) {
    clearTimeout(timeout);
    return response;
  });
});

/***/ }),
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */
/***/ (function(module, exports) {

module.exports = {
	"modp1": {
		"gen": "02",
		"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
	},
	"modp2": {
		"gen": "02",
		"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
	},
	"modp5": {
		"gen": "02",
		"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
	},
	"modp14": {
		"gen": "02",
		"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
	},
	"modp15": {
		"gen": "02",
		"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
	},
	"modp16": {
		"gen": "02",
		"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
	},
	"modp17": {
		"gen": "02",
		"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
	},
	"modp18": {
		"gen": "02",
		"prime": "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"
	}
};

/***/ }),
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */
/***/ (function(module, exports) {

module.exports = {
	"_args": [
		[
			{
				"raw": "elliptic@^6.0.0",
				"scope": null,
				"escapedName": "elliptic",
				"name": "elliptic",
				"rawSpec": "^6.0.0",
				"spec": ">=6.0.0 <7.0.0",
				"type": "range"
			},
			"E:\\myvue1\\myVue1\\node_modules\\browserify-sign"
		]
	],
	"_from": "elliptic@>=6.0.0 <7.0.0",
	"_id": "elliptic@6.4.0",
	"_inCache": true,
	"_location": "/elliptic",
	"_nodeVersion": "7.0.0",
	"_npmOperationalInternal": {
		"host": "packages-18-east.internal.npmjs.com",
		"tmp": "tmp/elliptic-6.4.0.tgz_1487798866428_0.30510620190761983"
	},
	"_npmUser": {
		"name": "indutny",
		"email": "fedor@indutny.com"
	},
	"_npmVersion": "3.10.8",
	"_phantomChildren": {},
	"_requested": {
		"raw": "elliptic@^6.0.0",
		"scope": null,
		"escapedName": "elliptic",
		"name": "elliptic",
		"rawSpec": "^6.0.0",
		"spec": ">=6.0.0 <7.0.0",
		"type": "range"
	},
	"_requiredBy": [
		"/browserify-sign",
		"/create-ecdh"
	],
	"_resolved": "https://registry.npmjs.org/elliptic/-/elliptic-6.4.0.tgz",
	"_shasum": "cac9af8762c85836187003c8dfe193e5e2eae5df",
	"_shrinkwrap": null,
	"_spec": "elliptic@^6.0.0",
	"_where": "E:\\myvue1\\myVue1\\node_modules\\browserify-sign",
	"author": {
		"name": "Fedor Indutny",
		"email": "fedor@indutny.com"
	},
	"bugs": {
		"url": "https://github.com/indutny/elliptic/issues"
	},
	"dependencies": {
		"bn.js": "^4.4.0",
		"brorand": "^1.0.1",
		"hash.js": "^1.0.0",
		"hmac-drbg": "^1.0.0",
		"inherits": "^2.0.1",
		"minimalistic-assert": "^1.0.0",
		"minimalistic-crypto-utils": "^1.0.0"
	},
	"description": "EC cryptography",
	"devDependencies": {
		"brfs": "^1.4.3",
		"coveralls": "^2.11.3",
		"grunt": "^0.4.5",
		"grunt-browserify": "^5.0.0",
		"grunt-cli": "^1.2.0",
		"grunt-contrib-connect": "^1.0.0",
		"grunt-contrib-copy": "^1.0.0",
		"grunt-contrib-uglify": "^1.0.1",
		"grunt-mocha-istanbul": "^3.0.1",
		"grunt-saucelabs": "^8.6.2",
		"istanbul": "^0.4.2",
		"jscs": "^2.9.0",
		"jshint": "^2.6.0",
		"mocha": "^2.1.0"
	},
	"directories": {},
	"dist": {
		"shasum": "cac9af8762c85836187003c8dfe193e5e2eae5df",
		"tarball": "https://registry.npmjs.org/elliptic/-/elliptic-6.4.0.tgz"
	},
	"files": [
		"lib"
	],
	"gitHead": "6b0d2b76caae91471649c8e21f0b1d3ba0f96090",
	"homepage": "https://github.com/indutny/elliptic",
	"keywords": [
		"EC",
		"Elliptic",
		"curve",
		"Cryptography"
	],
	"license": "MIT",
	"main": "lib/elliptic.js",
	"maintainers": [
		{
			"name": "indutny",
			"email": "fedor@indutny.com"
		}
	],
	"name": "elliptic",
	"optionalDependencies": {},
	"readme": "ERROR: No README data found!",
	"repository": {
		"type": "git",
		"url": "git+ssh://git@github.com/indutny/elliptic.git"
	},
	"scripts": {
		"jscs": "jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js",
		"jshint": "jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js",
		"lint": "npm run jscs && npm run jshint",
		"test": "npm run lint && npm run unit",
		"unit": "istanbul test _mocha --reporter=spec test/index.js",
		"version": "grunt dist && git add dist/"
	},
	"version": "6.4.0"
};

/***/ }),
/* 1143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1170 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1174 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1176 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */
/***/ (function(module, exports) {

module.exports = {
	"2.16.840.1.101.3.4.1.1": "aes-128-ecb",
	"2.16.840.1.101.3.4.1.2": "aes-128-cbc",
	"2.16.840.1.101.3.4.1.3": "aes-128-ofb",
	"2.16.840.1.101.3.4.1.4": "aes-128-cfb",
	"2.16.840.1.101.3.4.1.21": "aes-192-ecb",
	"2.16.840.1.101.3.4.1.22": "aes-192-cbc",
	"2.16.840.1.101.3.4.1.23": "aes-192-ofb",
	"2.16.840.1.101.3.4.1.24": "aes-192-cfb",
	"2.16.840.1.101.3.4.1.41": "aes-256-ecb",
	"2.16.840.1.101.3.4.1.42": "aes-256-cbc",
	"2.16.840.1.101.3.4.1.43": "aes-256-ofb",
	"2.16.840.1.101.3.4.1.44": "aes-256-cfb"
};

/***/ }),
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Completed.be59011.png";

/***/ }),
/* 1280 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAWCAYAAADeiIy1AAAAAXNSR0IArs4c6QAAAqtJREFUSA3dVb9rVEEQnnlKPBQJVoKgndEgxEJFBCUEsRDiP2AVSJFGLNQUAUEQFBsLLQIWkvwHgiJYWChGOMHO1s5eYpB7P27fjt/se7u3d3kcWztwt/NmZuebH9+9Y0qQ7e/yVIQ24lAm+rByiW/Gtmn6wWlO76sMzTHTL2J65GyWVqGf8f6UMwkoN4S89PvuVd7SpC926kUWPpEC4GOSgKqh+Hh3VkMcQFZ5/llOWqGLzVPzfUDox70l/hnbkoDyOuR1dwsFogZ8UNWbQrysFsVWa0bcx3EFnyBZ0KYopbFUmFFXJYBL27RU1Nmh0kjfDrPZ+mg2i7i3eS29yXRpHbkObLibKyhoqFJUsDOZJ7d4T58fvDMY9ChWbSpJQGWFpBx1BHJ4KaFL5Cv0eRTqw9KACowqlgKjbFfkRhrnzVEUR8D+XlpHmtjTDJqSwefSjmKpUBRYuE8SgcbvuQ7b+bh9Re4Bisqk5X5kD0DLr4t14uyxWGGIC8FSv7xf7d0YVJiGbwGeUsnRVu12JKPlF4gNzi6g0vA5JP7LlD1s/PY2ki2oDjrH+8boFKVBUtbFDbjYJsHYd+ioGOIC8Z+dOzOvNOLaZnFeRM6qXiJxPHaN9dn19eRBQ+z+yY1Ypz9CG/HSVd1uNWaZJotZ2OxLrY0ovbskdJRHc9fAsgpFk/NFVbodtT1Odptrtx0SgPSyiD12+lnudpQP5QLo465ot0xyPPiMXeCW7q5byk55H8gxz2xR5rgEoNzYb5j7dQxwzf9mQLVPGo7/oz7IeBmlwKcCGJaPqpV19lVqOw91TcvSxkHaNzj+c+Heer5o2Sx19ZnhT8Rit3qqeF1PFTWrGv5rJgwahyHvbhw+8pLp/t4WHlcQr2xwA+58/apf3xg+piu+279LMzT3Dw1gUj+XMu9eAAAAAElFTkSuQmCC"

/***/ }),
/* 1281 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAVCAYAAACt4nWrAAAAAXNSR0IArs4c6QAAAzhJREFUOBGtVU1oE1EQnre7aZoqKIhFpLRIEbGhPakXqydRPHhQpOBF8KR4EFEKij8US9WiJ3sQEartReiPBQ/ixbZQ1KAJIigUW0EP4l9Ns9sk+7/jzCZbd2OCYB14O/PmzXxv3vcmL+J+Gi2EfxNBaZzLmiWwy9pSTAdigAF8RXjFtAQR+nJeTOwCG26Rd5zGOkppJz2AAsYU3cbQziUb/RpCIIHJYILSy8UIth28QL4WCjlMaXHSa8l9mlMUg8EF9CNICxI5PBqsWQKbdUn4KCyBLs3o+3TZ8le9DRTTqRgOzSRpsGePeB8OWIl9ZRKT6OIpiWkxzdpQ6TTGhjN4aOQd1nHU4zmMD2Xw4BSiUivLtgAYVzIdAq8RdSeNzS8teJ03cfynBpO3U3jp0wJMF0x8OJuCzN0UNlVLzTM49aDif9xqIQBaAWTH8ZI+xYg7KYpHWbCD6KxavUXgDl26ohPn8Rrg2QJs9DuHO1WIObr4DHXEdvK1ckPJMjTSysfybsuKsMEmXIm7RVt2lwyiI3ZyzDmwqNtDqo6Q072RTY1S8tp++Ui8RWrTDJhQDYRs0Rk+MWbv65mK8p+n0n3ODeLcqiB9Zt5uy5neIwJpJWAoeLFzx7cJm7fuSQpLc+TzvKlaxC2aiU8+fIPN4fqYFu5C6nP6OFF0VYeE5wbdLaChDrLhZDMP2YIXrFM+2PXhdb5QjziX9CrdsgSxWdXEPtqkwJV//WF0hZO/FM0urpxOltd0vA4iNh9eZ85NukfFoJYx6SEIy/QxkaP5xY4bxbd0bw9QiIH2m3oT3WpKUNcQcDc/U5IsHX1zpn4inMs2Vw50cr9b5N8njMQtmeKF41EJQsTpPbkcWaRJXSLxrNLHc+YcCdN/W6o2KwXlTGh2XXBBoCwAc4DiFbl3UCuuASE5YBf5wfpOIyL8C7WZc75VPkU1WexNzGiutJt4HVUtsVW9unqvKqSkZsGoZopOrXcVb/aHMC3lbkEwatDiZ/U3PCfNoyR9DZ/JiFxwsBRoLtb2f/78wMiB+//oPPGCjiDOiRYo2GeV7nykl1eyja7Deu4mxUUcZE0Tficq5O9/H9GESPy9X8LGqDLk6FGOAAAAAElFTkSuQmCC"

/***/ }),
/* 1282 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAaCAYAAACtv5zzAAAAAXNSR0IArs4c6QAABFFJREFUSA2lVX9M1VUUP+e+x+O3GOWWmCujyMnGH4mk/aDWQovkDzIq13JDljQcbiVWDKjHdG1ZvDb+KFk0VmgjwGi5bGGUC5oR9oeSm/RjMxBttoGD9+P7697TuW992QMf9DbO9t25957P+Zx7zz3nfhESkI9/oXIi6AICz39wS3igeNe9eDYB98Qh7SPU8tEw1SbuASASBRORMG1IMySk8xgT9VsSGBiiQk7Lc6iglClzgcgXJUaMIMGYQnXC5xWf1t6PFxcLGDfA29/RPbzLdwipDAgnEelLQHFOEW3l8TUE8SspVQiAZYCQjUCd6BP1rz2IVxYGuiFA8wCVg1SdfKlXhRANTY9BDzKrdvR/K5uRxKU3S7BDz9vOUtLf12E3SeXnQMKLYkdjCQ5pmyvzAjScdJ5XiJ28o76bhGfXgW0YcoFaa8KrG0H6kZMWI/UnaRWi/JxPWyRQbDv0BJ52zXOX/OoJKuILbLcc9ZNp0/opCWkuyNXVhWgvJNc2R8JKy8G1hqPOG7bqrfuG1rk+0QB+rpCIdD60HBrNvNP7iA3YHLYh2wX9nzYlrOKNVfmEd2vEoaARlq2uTzRFLx53XgClPvEQ3HfkGd/PrnGhfv8MHeRcj9VsxqMLbe58T49TQaS6vYjFH1QkDUZPYNlUaTt4ailyTTA+rTL5W+GSxdNtT3t6LQW/hSVVaruo6qZsw6FiQ1JPPIfYtfFpCRP8LSW64kxJvaYDZTr1YsZwNvAJPLak4aUcte3ydQV/Tc8roLgulu0ZNh265fwxyPGGbJXD3QqocNOTHXbWV5VJg3G9eHF8SnG/wR3rDoWLNCbZg9cu1qde0mNXStvtxw1bbgAmFY6d47Vt8BFPuPa38N6yGLhogIlZNQKKqhmzWRMi4Air/XrsiinVQ4LgrmhnIvr4qiOPKgkD3IZ5P7yU8rsLXI5++IhRIh3qB4G5QomUPywHwDSwYDmksb6GAQW2RCPTSZ4UQ9U4zo0yykcrjwUtZ8xVVG46qv/rfWhG+8CW0MVltaOgNXzbcoi1b/671iYu+wdshZ/peTQApqe0WlLNhIJwWC+uf8vIyw9Qwk9Fbkt4bV4gvKaimzwR0wlYkkYr6lK65gJc2ItBQ1EdP1Q71zQHA0FbDswGrdUakIjYQcwLB2HwzFi4jdO9xZJin/soRk+gSSYbMzo5Ve8x4GX++sbfSL6QCLnG7KaU7zkt/JJSlWXDK5ebUk+7vnMB9EKNSK+zJAS4C2uzGoJdKxsit7tArbMaQntWNIZKY9eym2bzA1aon+9wO29s/z8H0+ZeUo2b98NxHVNfD+5UBC3827yZIX0epC8kwTl+Z6q5Jye8CP08L+RmeooZSvlf/Sfj9pqHM065HK6OGyBq9FMazIRquAyeBQUbufUZq/tTu0S15OGPgHQUMjI7wI/cTTfK4gFisQeCtwKouznGaiaVQJ4rkJE6xqRTsbB4438B6zcISk0Z4PIAAAAASUVORK5CYII="

/***/ }),
/* 1283 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAATCAYAAACUef2IAAAAAXNSR0IArs4c6QAAAlJJREFUOBGtVL+LE0EUfm92z+ClUKOlJ4jaqNHCH91VgoE0FiLYHYKIlQo2ImelhaV3lRZ6/hfngYVg510jtiJIrETjr83u7M7OPN/bOEvcTS4BfSSZeTPf++a9N98EoWJrW/QICG5Wlse6yKvEX4WwsnQab42CwlFH5mkOexHh+kILnlf3xvm9r7DE5IvVvRqxzgtI3j2CaRU8zl95TYYk9YrViJPUgVKqApvsDjIABFcDlMTL6/kGIrYZuFsp+6qGnLCgjQVCvHjvhT0HiO/ud1RHoGVq2uIx7dSlNKeN2ExgGbOsLUCccYxVl7Whox5SZqwzomAOejaHyG/OMsZyE8gxAfQoF40MrSSODUHIF2fJcWllIR43cZSMiXuMJgBHY4g1lx/uADA8stxmtoHhi+OPxNqRFuKFNd1FDE7yuXf4yMes9vNA9IHT2Kqxi1ocs/ylGneKUzmEQC8dwTVE9ZDIvsXOk1QDUkNIpBD/msT3c1+AVCrV+Ir9vFohAqZhkgtp40DzIHwWsn+19CPsM1Z/ChO+tLkGpOvd2V7atIMXVynT0vM4cxCMNH1a4LR90WqWEajkP5LKob+YWbOei1YgS0Xs8Co14m+DTW6+fBLRpeKp16efyyhW7APsJCI332qefX9j2E5+iRDKv5kbFDjQfWgmObQ57Gr/wfzT4er2v63l6AqL5ZniWEam0oriTQh7kkfHm3ej/pdU7yJLLDPcz/6J7SmHu7HBBU4YEqvbHPPjexTtIU4W4fbPNzycKWBVoU5llpZ49Qv4zxxp8zc5dA0JxIMTCAAAAABJRU5ErkJggg=="

/***/ }),
/* 1284 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAUCAYAAACJfM0wAAAAAXNSR0IArs4c6QAAAyVJREFUOBGVVD1oVEEQnnm3yeUHEcQIamEj/nQiiIWkUrERFIOFgoViIUIO1BBQRE8CQgoDIdqJtVipkE5UEC1FEIkiKDYaYnFGc/d+dt+O37x9Fy5wSjLwbndnvjf7zTfzjqnDHn2QDc2YPpLQUIf7n1tGRPDoqlbsmTzOoya4wm8jpq1iZSiKeBLBz52x1e69UB0X7FmROMuI8pwoYpodJHrXjGj7ahOanBYvDvOX6VdSU+YrEjctysmFKsgce3/VE59mpnkFdrWidkgBILa7gFnfyoQYJzPxXHbmzp+FQFGS+iGPWgyu8zn1cMR3bh7mma5JO5z1F2LI+t/qSl2gYf7EvhYRnYJv1otsBkMCcfLeh42iV2HKVK3llH5EJnFiWOTb9PGeM5ce20NQ4mClRxOTA/ta7YkdIdzxP2ssOtBhp5gUrDzKN60UN5RvLaFxhMzGOaoaM5lZ97QMdV9UM2BVO/HUUFBL0+NgUiSTUAX0KbQlg5uaLj8CyJiC2wacRZ3oOs8AYsiBnmqHVUi+A3csUUk02EIsKhMnSVkGpiKvVma9y+Z6gcYUFmZcr83ZbWQPEStyjqiMcm+FcvdGQbE2SBMnFlIw2gdrgr3ODV6jgSp6B5Di2uY5o8xFxJALELwerpTcRlKWnVhlzJAC5Qs0UQtSeOoxES3+yo66XMbwFaKRoaSI2TLJqKI5pwfqD3ElR880R4zEonOsUuDqwpIkLz507ezrWvUhnPp0s/3dnOpLHPJiNSo2awNg2khUCXO0dyoehv+kqo4uqBPW3ocKO4/CPP/2cv/t2Op/EKRIMNBtzks6KihPLzLCC5bzOU2H68JClXKva2llCMovqCfWHCBntItQpUAFjZEYun691vcJTn3WZFAAyaBx0tH2JA3F6pBsqTfPQ6y7CiuVKpgUDQk8QqANEHr/oz6wD4wLZQ02SFfojY8C5DAh6LRvTAzex0mfNRnGF59jlJpWxi8xQhf6x1snUutGlADyHugbX9qxpowKjmRbbHk3iN0I43CleR1UR/FsKuQOXhxLHXQtTAO6XwaU++X4Tzju0dS6W38BIiqTVPz9nJgAAAAASUVORK5CYII="

/***/ }),
/* 1285 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAVCAYAAACt4nWrAAAAAXNSR0IArs4c6QAAAjhJREFUOBG1lMtrE1EUxjPJjKNZNYhFROpCpMkMZpNlH2SlZOFCEcGNf4MgQouPnaBbu3ahm4r2Aa4EUQTxARKaQF74gGyELIK0YEJImsTfmc7AHTuZUKMXztzvPO53zz3nJFoqlepG/s/q6sPh0JiEOxaLLQwGg4dwrCNHkbPRaHQF25o+CbGc7ff7tzRNOwW8jJjIFLbr2CIOOeAB0sTxt+u1epBqHEef15LJ5BAwW6vVvqgBk2DLsmwu2IqOI8lkMgYJXLJt+5DE5nI5kyG4mM1mx5Y0lBzCmXa7vQXnOnV8A+mder3+lqw2Go1GPp1OnwxLLvR2JiEGqe0SzEE6p5ClmYrQ86GZQ3zCI6PhX5GnyHfP1uv1pj0ctAeSS50pyQVm9bEcgvBZPB63q9XqVbK10DfFzuVPiDs/qv6B5J1Ox+LgC8pwWkgMw1jK5/M9weVyuYu+LJg1S9zLZrN5Zk/1fwPJyfiIGgbZT1WnFT6d+MOq38OB5KZp1nj6PaQlga1W64p3QHZe5uj4f1Gm+4lE4pvq93BgtwuFwjYBtxm9EvsqssIPQ8bukzsxN8GyrlUqFaf+e6r/G0iuhHx0scnT7yp2B1Ku93/aVD2wLF4Az54B90UHbyOvgDuuvksz5Q9r5Aol58nvdF1fhPQ5tU0xiufohy06Ms/kfB7JjGNcWSKlUukDcSLOKhaLPwC+BruufVto5vuiD2jwMr/BNPhm94A8vnAm6pgYNMbtkc/zjxQu2P0NHKfB1ApCKCYAAAAASUVORK5CYII="

/***/ }),
/* 1286 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAYhJREFUOBHVVD1LxEAQzeZLUONBAgoRQkAsbA0oeI1gY3lNKv0DFlb+D9EupRbX2MghaifoHxDBJjaGUw/vbEL05EJC4tuQyDbGnKRx4LEzs29eNjObcFyJCYLgACmD4xJ6tsWXEQgh89h3eJ5fhn+Yx2UlXKkgrYRIL4qiW7i9UqV8U6xCYjmqqs4EQXCJ3FSej9CSrTAMH2j86wnzou9lOBzOpmm6hpM7wAH8xTiOFwrC2IJFYaPRaKMVR4g/ixxd/yzIirD+PxHUdX1SkqRdURT3KODv2LYtsK9S1c+uzWAwWMW09jG1GxTySZKsdzqd66oiLK/oIUHyHePfME1zMyfQ3NhWCI5d+FNB7YLspzeNgZx5nlc8JMUpKLaRX8FKv4YXIDPf90+Qj9F7Fb2nvMyySWqa9jYajT6QeQWeQThvNpsX3W73CXEAUKF7oN1qte5c1/Xh92ke3CtFUU5RHyKu34gsy0u4JnN1SOO/2Sf49TxCzKxDEBoesSxLQq8m6hA0DCP8AlSlc8eKrFjEAAAAAElFTkSuQmCC"

/***/ }),
/* 1287 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAaCAYAAACtv5zzAAAAAXNSR0IArs4c6QAAA4pJREFUSA2tlktIlFEUx+eliFKCzdBkExSWOTMyIjpRhCJBEYKLEi2pFiYklEEPWkQQI60qrGjbwoUhpqY9FoISGdaiDEbnodmDpNDIkaAIzHEe/c7g6LyMD+3C5d5z7v/8z+M+vk+tUtDMZvMhYB3hcFi7CPfrdLpyj8fzVoG5cojFYmmhn1VuoVJplIIdDoeGDDJDoVAWo1qp3T+BhYWFpYFA4Khara6EMA/i9EXiOXQTzJ9Sqna32/1uJYcpHdhstp1+v/8mRlX0Kcie0EdxcAB5hu5hXoquijGHsS0jI+Oy0+mcZi2uJTlY3NA2UN8wvOL1ersYw2JF/ZsZJsfGxlpFLikpSZubmzuJEwddo9Vqq8G/lLWUDYJjBQUFIZw8JIusRJAQyl4k6ouLiw3YDNHnKWtF7PpSBlardVcwGHxBtE4A2aRcQcq+WPBKc4h3sDZAFj7st6WlpdldLtdnwUeikaggv4fs1mg0FYCakXMEoKRRGgM2DRDLHv1eWFi4G2dHBCcoTViyiFtIEMBdo4zHE9RxIus1wsVYJguRDEitnggG2KA3cehkYR3Y9cnqZQ0c3XC9577Ui1ZD1FKKcgy7lmGrn0EOVbgbhiopvWRgoWu5MK9XTxtvyZ4Il76npydXh7dcWWZT7dQtmzM+FA9PkrZG94pNnRkZGZmMRbB2EC4JWjhzdYzR67+HumUjr+iA9IcJqBHcbiHgtg8zXJR5tEFaBm47OFGlq/G4D+UzlPnj4+MfosC1jJy2/TjoJ8M82YOPQsb5t62FNNaWYIXrj8lkmtJwrL4guMlCPir/pVFC4erv6+ubj9wDou9AUc37Y1qrB0puh2MvJ+mBcEUckJJc7V9c8Rui5CbmA1T8VPDAbSkqKtpcU1OjJfpbULiZS9CqyDfW5/P5DQbDdzbmKqOcpOs4fYxe0WOn1+vtfJh6gRfCUcWdquvs7Fx+7MQTJ6gN0tsAziP2ch+8olfSamtrn2PrwraBcl/gZ2AwahfJICo0NTUNQCzvzTkyMdOHZ2dnf0bXKd0pdBvRLR1nLqcVwnZs5CW9RKB3ongZl74HsUqI6oioBd0Gei/9EZs2yklrRP+VeT/zUkgP0yvRfQJzBvIBxriW0oEg+Hpl8jk8zaYdEZGeiA1C/AoH941GY+vg4GBA7BJbolHiekTmRBkhkq/WJkgJPjhNFhPcoR8pDWKUfwGMX4cHePxtdAAAAABJRU5ErkJggg=="

/***/ }),
/* 1288 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAATCAYAAACUef2IAAAAAXNSR0IArs4c6QAAAZNJREFUOBG1VL9Lw1AQ7gspQRxUdDSW4JLmh1JENydBqasIbiKIuOnon+Com4vif1EEB2frIh2ayUKUDA6CUNDE1PhdaR8xCUkKzcHj3t1935fj3stjpYhVq9WLIAhOIunUkDF22W63T8MgMRwM9rOCIBxXKpXbhFos1el09pFcjxaShEvo2G80Gm4UnBRrmvYDfKwkxDJjSvCOMds7aJr4+jRm9jCKPjg74G+A08Kst4jLO0ZRx2x3IUofGMkGnD1oaEMiF0aCBvWK1R0WR/DdcrlMXG5hYZ4cx6YwYYahb2M2y+jyDLO6gt/EekHuKWfnK+AtAn8P/BHWOeJnpqrqNwIpp0hemEvXTRJFcUGW5fe8rDSc4zhzruu+9e8xrpmb909LE6VarVbzyBd2eIUJ81+a2q/X6xJeqyZOleGUvyiXZYBOAPurKMpaeJz/hG3bnoSQiXVoWdZ1lijV8bodQPhmwOUvYl+41+sZuq5/wE8RGMB5wzCWaJ9lvu/LhAHXhMan53kzFNM9foRfpWCM1vwDrY6JRzcs5tAAAAAASUVORK5CYII="

/***/ }),
/* 1289 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAUCAYAAACJfM0wAAAAAXNSR0IArs4c6QAAAghJREFUOBGllD9oU1EUxvteXrKWSCuIFBfR/IHQRRxECFToIhQsLgUHRcQlmboUSqmL0MGpuomzc6FbB6fOJYEkIhS6lJd2CDrl8V5e+jtpbzkp7yY+vXA553znu9+995z7njOjRrlcvjUYDDpA8wpO68aO49Q8vcp13bsIz5PYAf+lc3/rD4fDbbiLY8JmMcL7+Xz+qNfr3TfYNJvJZH43m83jQqFQF26isCQQ3WD3NVxf4inDCcOwAGfW8LxKpfIQ8DWAi72ubRzHWUrzqdVq7RqyzVarVc/3/T86L2Jy9HfMO5RgQSf/x/e4rofgSbvdflUsFp8htiSCnDYiVwdbnbZBt9t14ESaZ61xLpfb6ff7e5o8yc9msz2dtwoHQbAMcV2TuVlI9+s8yV25qc5R0lPiFYONJQ0ollLsI9TWGH5IU+ckzQnfmBxYhs0OTSzWKqxJST4nlrqOBsKu8Y21CkN+zuKkUtQ43UwURd+MyJU90LFVmFfyHaLMpPE4CbzChmKtwqVS6SmnfjlBYCxFT3w+po+AoxJZhT3PO6PTN5s3JqYDGn2mY6two9H4CVFm2jG5FHxxb2ne5xSqzU6n8wj+dSkC/XREiGvF1OsrrsxUg7XyiwikFD9w3vMffcEGo/8CTXtC8x6kUrwk32NtkUZujY7NtTcRrZG7/Q9iesk5wRdK8uECAUHAhvM9h3QAAAAASUVORK5CYII="

/***/ }),
/* 1290 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1291 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/New password.00c8b4b.png";

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Real-time.3dab3a2.png";

/***/ }),
/* 1294 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAAHhSr/lAAAAAXNSR0IArs4c6QAAAO5JREFUSA3tVksOAjEILcYbuNClC2/k8V14Ae+gAxGCSAk2LBrTbkqZx+NBPxl4nC/Pto3T9YgTDWDn4X5jX9uzBQBsNkLqUPqC4XZQuA5FpCTCxRcNOt/jA6hVMYBnUYkOm45B9I1rjNLudETPFm2RrhSTiI+Ep5hEkxYdVapx1k5ltEG9tass6lyPCP2lyqT7OmO0Expn7VJlbs+m2M3SMkvJ3J5Ncc5Kyywlm/cGlJZZSuaeM/sa4Hr0vnpcGV9plZmEWcwSlu0U49JnbPR940S/zmsr/6Zj7tvvVTf6R+RxZXzrjGW6pDHTduwF/tQ9TUcooSgAAAAASUVORK5CYII="

/***/ }),
/* 1295 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAPCAYAAAD3T6+hAAAAAXNSR0IArs4c6QAAAQhJREFUOBFjZCAAMh976P359zsYpoyDjW3KZMntr0H8lEeu2Yz//4lhk4OJodNM6ALo/L//f6cxMDIy/Wdi/AfCP/+z/IepYWL4DxZDl0t77JKT88hVCqaO5nTqQ+ezKQ/djLFZRNCH2DRRIkbQwtRHLiWFj92FKLEEWS9BCxkY/mf8ZGAgzUJGpsncHBxPkC2CsVlgDGrSs+V2L8BlHhE+xKWVPHGCFjL+Z+pm4+F8Q4rx+LIFwSCdJb97JimWgdQCc2fiDwam40DmM3S9BH2IroFSPkELh362wFcAg+T+//+nzMBIWkDCsgU2s1lABfA/YKEMMxK9cGZgZA6cJrvzDkyeFBqb2QA6TnFjOW20iQAAAABJRU5ErkJggg=="

/***/ }),
/* 1296 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAQCAYAAAAvf+5AAAAAAXNSR0IArs4c6QAAAJNJREFUKBVjYAACZ2fnLE9PT1EQGxdgAin69+/f1J8/f+7Hp5iJjY1tNSMj49X///9r41PMCLIKZBJIEUgxSBM7O7vj9u3bXyM7A6yQGMVwhYQUoyjEpxhDIS7FTCAJYgCGibhCAEUhLkUgG+EK8SmCKySkCKyQGEUghUysrKw/gPRHXFEHUgQHfn5+vCCT4QJYGACVoJH2cySrnAAAAABJRU5ErkJggg=="

/***/ }),
/* 1297 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAQCAYAAAAvf+5AAAAAAXNSR0IArs4c6QAAAIhJREFUKBWN0T0OgCAMBWBoQpgcPYWnMEwsHEQPyOgpPIWTm0zIYyAS+evA9LW0eYw1Sms9K6U2EF5zQM65w3u/ENFehF/EOT+llOsPlpC19spgDWU7tlCCPRThCAIkPCMVjxmZmq7u4QTxfQtnsIV/sIaLVyOymG/IOTTeQogHA6qFnY0xE8ALxiuQZFdj+4EAAAAASUVORK5CYII="

/***/ }),
/* 1298 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1299 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1300 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1301 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAIAAAADnC86AAAACXBIWXMAAA7EAAAOxAGVKw4bAAABlElEQVRYR2MUPpfGMBCABV2AXmDUYrqBUYvpBkYtphsYtZhuYOhbzMjAWCXl7ydgFHSn/+mv9+jSGIA6FjMyMNZJBeaKuzMwMKxXKTK7VouuAgNQwWJGBsZG6ZAsMRcId8nbI6jy2AEJFmtzyjz8+ebLvx/IgowMjC0yoemizhBu3dM1017tRlaACxBrsSe//jzF9IvfHobenfj5L9RuRgbGdpnwFFFHCLfm6aoZr/Yi9OAFjES2ua7rdouy8DEwMJz5eg9iNxMDY6dsZKKIPURBxZMVc17vR9GDFxBrsRm38iqVPB4mDgYGhjNf74XfnVwvFRQnYguRLX28bP6bgygaCAFiLWZgYDDhVlqtnM/LzMHAwPDuz1chFm6IeNHjJYveHEZRSgQgwWIGBgYjLoU1KgV8zJwQ7n+G/wWPFi99exRVFVGANIsZGBgMuRTWqOTzM3P9Z/if+3DhinfH0VUQB0i2mIGBQZ9LfrlSTsOztavenUCXIxqQYzFVALH5mOpg1GK6gVGL6QZGLaYbGLWYbgAA5fVuUHiGBMIAAAAASUVORK5CYII="

/***/ }),
/* 1302 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1303 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/portrait.379b17f.png";

/***/ }),
/* 1305 */,
/* 1306 */,
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1237)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(636),
  /* template */
  __webpack_require__(1503),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e74eedfc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1179)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(637),
  /* template */
  __webpack_require__(1444),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2e0752ce",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1231)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(638),
  /* template */
  __webpack_require__(1497),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c991d1e6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1199)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(639),
  /* template */
  __webpack_require__(1464),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4e6466e3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1213)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(640),
  /* template */
  __webpack_require__(1479),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6f96cad5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1145)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(641),
  /* template */
  __webpack_require__(1409),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-036b149c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1233)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(642),
  /* template */
  __webpack_require__(1499),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d1288bd6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1212)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(643),
  /* template */
  __webpack_require__(1478),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6d81a66d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1192)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(644),
  /* template */
  __webpack_require__(1457),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3b3be36b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1207)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(645),
  /* template */
  __webpack_require__(1472),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-613277df",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1214)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(646),
  /* template */
  __webpack_require__(1480),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-73258e32",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1194)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(647),
  /* template */
  __webpack_require__(1459),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4034d8d0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1164)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(649),
  /* template */
  __webpack_require__(1428),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1dca41a0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1168)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(650),
  /* template */
  __webpack_require__(1433),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-231b8996",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1147)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(651),
  /* template */
  __webpack_require__(1411),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-06a9cb49",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1170)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(652),
  /* template */
  __webpack_require__(1435),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-24997d3a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1191)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(653),
  /* template */
  __webpack_require__(1456),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-389ccb14",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1232)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(654),
  /* template */
  __webpack_require__(1498),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d0dd7ce6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1239)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(655),
  /* template */
  __webpack_require__(1505),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-eb119e0a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1193)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(656),
  /* template */
  __webpack_require__(1458),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3f979cd6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1217)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(657),
  /* template */
  __webpack_require__(1483),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-78a42114",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1226)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(658),
  /* template */
  __webpack_require__(1492),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9e2ef33c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1236)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(659),
  /* template */
  __webpack_require__(1502),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e25e6b3a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1154)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(660),
  /* template */
  __webpack_require__(1418),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-16ffc3ae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1172)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(661),
  /* template */
  __webpack_require__(1437),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2689e62a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1144)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(662),
  /* template */
  __webpack_require__(1408),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-020485c3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1178)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(663),
  /* template */
  __webpack_require__(1443),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2c7eefa4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1196)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(664),
  /* template */
  __webpack_require__(1461),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4964cdfa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1229)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(665),
  /* template */
  __webpack_require__(1495),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bc5f47a6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1197)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(666),
  /* template */
  __webpack_require__(1462),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4b5794bb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1223)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(667),
  /* template */
  __webpack_require__(1489),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9800eb48",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1211)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(668),
  /* template */
  __webpack_require__(1476),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6bdcf660",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1202)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(669),
  /* template */
  __webpack_require__(1467),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-587fc862",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1149)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(670),
  /* template */
  __webpack_require__(1413),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0a10f6b6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1203)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(671),
  /* template */
  __webpack_require__(1468),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5895c720",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1218)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(672),
  /* template */
  __webpack_require__(1484),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-79c82b12",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1208)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(673),
  /* template */
  __webpack_require__(1473),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-632e9df3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1143)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(674),
  /* template */
  __webpack_require__(1407),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-004378de",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1201)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(675),
  /* template */
  __webpack_require__(1466),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5753a14f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1167)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(676),
  /* template */
  __webpack_require__(1432),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2175dcd0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1148)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(677),
  /* template */
  __webpack_require__(1412),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-07a400db",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1174)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(678),
  /* template */
  __webpack_require__(1439),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-28d664cd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1209)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(679),
  /* template */
  __webpack_require__(1474),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6997812e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1180)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(680),
  /* template */
  __webpack_require__(1445),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2f702a6c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1240)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(681),
  /* template */
  __webpack_require__(1506),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ed893738",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1198)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(682),
  /* template */
  __webpack_require__(1463),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4bc5e292",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1156)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(683),
  /* template */
  __webpack_require__(1420),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1b516ea9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1157)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(684),
  /* template */
  __webpack_require__(1421),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1b5f862a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1165)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(685),
  /* template */
  __webpack_require__(1429),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1e2c5fe0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1158)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(686),
  /* template */
  __webpack_require__(1422),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1b7bb52c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1159)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(687),
  /* template */
  __webpack_require__(1423),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1b89ccad",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1235)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(688),
  /* template */
  __webpack_require__(1501),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e0c6fc5a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1160)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(689),
  /* template */
  __webpack_require__(1424),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1ba5fbaf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1161)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(690),
  /* template */
  __webpack_require__(1425),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1bb41330",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1162)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(691),
  /* template */
  __webpack_require__(1426),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1bc22ab1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1163)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(692),
  /* template */
  __webpack_require__(1427),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1bd04232",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1153)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(693),
  /* template */
  __webpack_require__(1417),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-14c385ca",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1241)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(694),
  /* template */
  __webpack_require__(1507),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f8764650",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(695),
  /* template */
  __webpack_require__(1477),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1222)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(696),
  /* template */
  __webpack_require__(1488),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8fe7706e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1221)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(697),
  /* template */
  __webpack_require__(1487),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7f794c8c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1234)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(698),
  /* template */
  __webpack_require__(1500),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d41b5cd6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1151)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(699),
  /* template */
  __webpack_require__(1415),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0c047d24",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1220)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(700),
  /* template */
  __webpack_require__(1486),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7d1ee2bf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1204)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(701),
  /* template */
  __webpack_require__(1469),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5983067a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1169)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(702),
  /* template */
  __webpack_require__(1434),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-23308d8a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1242)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(703),
  /* template */
  __webpack_require__(1508),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f9672808",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1155)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(704),
  /* template */
  __webpack_require__(1419),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-18311ebd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1227)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(705),
  /* template */
  __webpack_require__(1493),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a5d45d04",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1195)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(706),
  /* template */
  __webpack_require__(1460),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-41fa843f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1200)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(707),
  /* template */
  __webpack_require__(1465),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-52419200",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1146)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(708),
  /* template */
  __webpack_require__(1410),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-051f5262",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1210)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(709),
  /* template */
  __webpack_require__(1475),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6bc3e9c1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1225)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(710),
  /* template */
  __webpack_require__(1491),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9cabf980",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1181)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(711),
  /* template */
  __webpack_require__(1446),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-315dd5a7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1150)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(712),
  /* template */
  __webpack_require__(1414),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0b4f4cce",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1182)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(713),
  /* template */
  __webpack_require__(1447),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-316bed28",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1183)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(714),
  /* template */
  __webpack_require__(1448),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-317a04a9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1184)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(715),
  /* template */
  __webpack_require__(1449),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-31881c2a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1185)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(716),
  /* template */
  __webpack_require__(1450),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-319633ab",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1186)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(717),
  /* template */
  __webpack_require__(1451),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-31a44b2c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1187)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(718),
  /* template */
  __webpack_require__(1452),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-31b262ad",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1188)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(719),
  /* template */
  __webpack_require__(1453),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-31c07a2e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1189)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(720),
  /* template */
  __webpack_require__(1454),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-31ce91af",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1228)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(721),
  /* template */
  __webpack_require__(1494),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-aa7f680e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1216)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(722),
  /* template */
  __webpack_require__(1482),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-786c7f8d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1219)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(723),
  /* template */
  __webpack_require__(1485),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7b1e5bbe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1206)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(724),
  /* template */
  __webpack_require__(1471),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5d717d0d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1238)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(725),
  /* template */
  __webpack_require__(1504),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e821ac16",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1176)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(726),
  /* template */
  __webpack_require__(1441),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2ab8c68e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1215)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(727),
  /* template */
  __webpack_require__(1481),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-73328dd6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1175)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(728),
  /* template */
  __webpack_require__(1440),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-298342e2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1152)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(729),
  /* template */
  __webpack_require__(1416),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-146a258e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1166)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(730),
  /* template */
  __webpack_require__(1430),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1eae045a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1230)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(731),
  /* template */
  __webpack_require__(1496),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c6adb672",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1171)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(732),
  /* template */
  __webpack_require__(1436),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-25b02f3c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1190)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(733),
  /* template */
  __webpack_require__(1455),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-385605b9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1224)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(734),
  /* template */
  __webpack_require__(1490),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9ca1f2bc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1177)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(735),
  /* template */
  __webpack_require__(1442),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2b0d1158",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1173)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(736),
  /* template */
  __webpack_require__(1438),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-275ce910",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1407 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n\n\n          " + _vm._s(_vm.$t('copyright'))), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])])
},staticRenderFns: []}

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('img', {
    attrs: {
      "id": "user",
      "src": __webpack_require__(220)
    }
  }), _vm._v(" "), _c('p', [_vm._v("EasyView Accounts management")]), _vm._v(" "), _c('div', {
    staticClass: "icon-bor",
    class: {
      'in': _vm.isB
    }
  }, [_c('div', {
    class: {
      'in1': _vm.isB
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(173)
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": _vm.user,
      "maxlength": "80"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "focus": _vm.check2,
      "blur": _vm.check2,
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.down($event)
      }, function($event) {
        if (!('button' in $event) && $event.keyCode !== 13) { return null; }
        _vm.down($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon-bor",
    class: {
      'in': _vm.isC
    }
  }, [_c('div', {
    class: {
      'in1': _vm.isC
    }
  }, [_c('img', {
    attrs: {
      "id": "img1",
      "src": __webpack_require__(172)
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "id": "psd",
      "type": "password",
      "placeholder": _vm.pas,
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.up($event)
      },
      "focus": _vm.check3,
      "blur": _vm.check3,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "operate",
    class: {
      'po1': _vm.isEs || _vm.isPo
    }
  }, [_c('div', {
    staticClass: "operate-left",
    class: [_vm.isA ? 'Select' : 'noSelect']
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": _vm.choose
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('remember')))])]), _vm._v(" "), _c('div', {
    staticClass: "operate-right"
  }, [_c('label', {
    on: {
      "click": _vm.forgot
    }
  }, [_vm._v(_vm._s(_vm.$t('forget')))])])]), _vm._v(" "), _c('button', {
    staticClass: "login",
    class: {
      'po2': _vm.isEs || _vm.isPo
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('sign in')))])])
},staticRenderFns: []}

/***/ }),
/* 1409 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "center"
  }, [(_vm.noData) ? _c('div', {
    staticClass: "no-data"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("No Account")]), _vm._v(" "), _c('div', {
    staticClass: "add-btn",
    on: {
      "click": _vm.addAccount
    }
  }, [_c('p', [_vm._v("Add Account")])])]) : _c('div', {
    staticClass: "account-list"
  }, [_c('div', {
    staticClass: "tool-bar"
  }, [_c('div', {
    staticClass: "add-btn",
    on: {
      "click": _vm.addAccount
    }
  }, [_c('p', [_vm._v("Add Account")])]), _vm._v(" "), _c('div', {
    staticClass: "del-btn",
    on: {
      "click": _vm.deleteAccount
    }
  }, [_c('p', [_vm._v("Delete")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', [_c('tr', {
    staticClass: "table-head"
  }, [_c('td', {
    staticClass: "col1",
    attrs: {
      "width": "15%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked),
      expression: "checked"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checked) ? _vm._i(_vm.checked, null) > -1 : (_vm.checked)
    },
    on: {
      "click": _vm.chooseAll,
      "__c": function($event) {
        var $$a = _vm.checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.checked = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Account")])]), _vm._v(" "), _c('td', [_vm._v("\n              EasyPatch\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              HCP\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              SW upgrade\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              HCL-PDM\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              HCL-EasyPatch\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n             EasyUpdate\n           ")]), _vm._v(" "), _c('td', [_vm._v("\n             User\n           ")]), _vm._v(" "), _c('td', [_vm._v("\n            Agency\n           ")])]), _vm._v(" "), _vm._l((_vm.accounts), function(item, index) {
    return _c('tr', {
      staticClass: "data-row",
      class: {
        'even': (index) % 2
      }
    }, [_c('td', {
      staticClass: "col1"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.check),
        expression: "item.check"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.check) ? _vm._i(item.check, null) > -1 : (item.check)
      },
      on: {
        "__c": function($event) {
          var $$a = item.check,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (item.check = $$a.concat($$v))
            } else {
              $$i > -1 && (item.check = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            item.check = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.account))])]), _vm._v(" "), _vm._l((['EasyPatchLogin', 'HCPCreate', 'FirmwareUpdateConfig', 'HCLConfig', 'HCLConfigForEasyPatch', 'EasyUpdateLogin', 'UserAdmin', 'Agency']), function(key) {
      return _c('td', {
        staticClass: "col2"
      }, [(item.permission[key]) ? _c('img', {
        attrs: {
          "src": "/static/accountadmin/icon_selected.png"
        }
      }) : _vm._e()])
    })], 2)
  })], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "chart-container"
  }, [_c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Device Settings Report')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.$t('Device Settings at')) + " " + _vm._s(_vm.time))])])])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(19)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background2"
  }, [_c('div', {
    staticClass: "chart-container2"
  })])
}]}

/***/ }),
/* 1411 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tabs', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "胰岛素数据统计"
    }
  }, [_c('HCLTable', {
    staticStyle: {
      "margin-top": "13px"
    },
    attrs: {
      "tableData": _vm.InsulinDataList,
      "tabType": _vm.insulinData,
      "pagesize": _vm.pagesize,
      "loading": _vm.loading
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1412 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n\n             " + _vm._s(_vm.$t('copyright'))), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])])
},staticRenderFns: []}

/***/ }),
/* 1413 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "charts-container"
  }, [_c('div', {
    staticClass: "Hcp-operate",
    class: {
      'zh1': !_vm.isEn, 'de1': _vm.isDe, 'du1': _vm.isDu || _vm.isSw
    },
    attrs: {
      "id": "operate-button"
    }
  }, [_c('button', {
    staticClass: "operate-spe3",
    class: {
      'operate-spe1': _vm.A0
    },
    on: {
      "click": function($event) {
        _vm.select(0)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('dashboard')))])]), _vm._v(" "), _c('button', {
    class: {
      'operate-spe1': _vm.A
    },
    on: {
      "click": function($event) {
        _vm.select(1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('daily')))])]), _vm._v(" "), _c('button', {
    class: {
      'operate-spe1': _vm.B
    },
    on: {
      "click": function($event) {
        _vm.select(2)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('dayByday')))])]), _vm._v(" "), _c('button', {
    class: {
      'operate-spe1': _vm.C
    },
    on: {
      "click": function($event) {
        _vm.select(3)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('sensorOverlay')))])]), _vm._v(" "), _c('button', {
    class: {
      'operate-spe1': _vm.D
    },
    on: {
      "click": function($event) {
        _vm.select(4)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('TrendAna')))])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.segment),
      expression: "segment"
    }],
    class: {
      'operate-spe1': _vm.H
    },
    on: {
      "click": function($event) {
        _vm.select(8)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('events')))])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notM),
      expression: "notM"
    }],
    class: {
      'operate-spe1': _vm.E
    },
    on: {
      "click": function($event) {
        _vm.select(5)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('logbook')))])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notM),
      expression: "notM"
    }],
    class: {
      'operate-spe1': _vm.J
    },
    on: {
      "click": function($event) {
        _vm.select(9)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('alert')))])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notM),
      expression: "notM"
    }],
    staticClass: "operate-spe2",
    class: {
      'operate-spe1': _vm.F
    },
    on: {
      "click": function($event) {
        _vm.select(6)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('DeviceSetting')))])])]), _vm._v(" "), _c('el-card', {
    attrs: {
      "id": "Hcp-main"
    }
  }, [_c('div', {
    staticClass: "Hcp-main-context"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('router-view', {
    key: _vm.chart,
    on: {
      "reload": _vm.reload
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "chart-container",
    attrs: {
      "id": "container"
    }
  }, [_c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Alerts Report')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.$t('date')) + ":" + _vm._s(_vm.time))])])]), _vm._v(" "), _c('table', {
    staticClass: "status-table1",
    class: {
      'zh1': !_vm.isEn, 'de1': _vm.isDe || _vm.isIt
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('uername')))]), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.username))]), _vm._v(" "), _c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('fullName')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('devices')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "id": "reportPdmTitle"
    }
  }, [_vm._v(_vm._s(_vm.$t('pdm')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('tran')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('pumpBase')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[2]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td4"
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _c('td', {
    staticClass: "td4",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v(_vm._s(_vm.statics.medical_history))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.haveData),
      expression: "!haveData"
    }],
    staticClass: "no-data"
  }, [_vm._v("\n      No Data\n    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveData),
      expression: "haveData"
    }]
  }, _vm._l((_vm.pagePos), function(base, p) {
    return _c('div', [(p >= 1) ? _c('div', [_c('div', {
      staticClass: "page-seperator"
    }), _vm._v(" "), _c('div', {
      staticClass: "page-starter"
    })]) : _vm._e(), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _vm._l((_vm.alerts.slice(base, base + _vm.perPage[p])), function(item, index) {
      return _c('table', {
        staticClass: "alert-table",
        attrs: {
          "id": 'tbl' + base + index
        }
      }, [_c('tr', {
        class: (index % 2 === 0) ? '' : 'x_even'
      }, [_c('td', {
        attrs: {
          "width": "30%"
        }
      }, [_vm._v(_vm._s(item[0]))]), _vm._v(" "), _c('td', {
        attrs: {
          "width": "20%"
        }
      }, [_vm._v(_vm._s(item[3]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item[1]))])])])
    })], 2)
  })), _vm._v(" "), _c('div', {
    staticClass: "page-end"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(19)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "alert-table-header"
  }, [_c('tr', [_c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Time")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('td', [_vm._v("Alert")])])])
}]}

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "cont-head",
    class: {
      'newStyle': !_vm.newStyle
    }
  }, [_c('span', [_vm._v("Register a personal account")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('p', [_vm._v("Country/Region:"), _c('span', [_vm._v(_vm._s(_vm.countryShow))])]), _vm._v(" "), _c('p', [_vm._v("Username:"), _c('span', [_vm._v(_vm._s(_vm.userName))])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-spe2",
    class: {
      'in': _vm.isH, 'vuerify-invalid': _vm.isQ
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": _vm.disC,
      "placement": "top",
      "effect": "light"
    }
  }, [_c('div', {
    staticClass: "tooltip",
    slot: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('errtip3')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vcode),
      expression: "vcode"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.Veri
    },
    domProps: {
      "value": (_vm.vcode)
    },
    on: {
      "focus": function($event) {
        _vm.check56(0)
      },
      "blur": function($event) {
        _vm.check56(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'in2': (_vm.isH || _vm.isQ)
    }
  }, [_c('button', {
    attrs: {
      "disabled": _vm.canClick
    },
    on: {
      "click": _vm.sendSeccode
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.send))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "icon-bor",
    class: {
      'in': _vm.isJ, 'vuerify-invalid': _vm.isS
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": _vm.disE,
      "placement": "top",
      "effect": "light"
    }
  }, [_c('div', {
    staticClass: "tooltip",
    slot: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('errtip5')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.full_name),
      expression: "full_name"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.fullname
    },
    domProps: {
      "value": (_vm.full_name)
    },
    on: {
      "focus": function($event) {
        _vm.check58(0)
      },
      "blur": function($event) {
        _vm.check58(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.full_name = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "icon-bor",
    class: {
      'in': _vm.isK, 'vuerify-invalid': _vm.isT
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": _vm.disF,
      "placement": "bottom",
      "effect": "light"
    }
  }, [_c('div', {
    staticClass: "tooltip",
    slot: "content"
  }, [_c('p', {
    staticClass: "longP",
    class: {
      'correct1': _vm.ps1
    }
  }, [_vm._v(_vm._s(_vm.$t('errp1'))), _c('br'), _vm._v(_vm._s(_vm.$t('errp2')))]), _vm._v(" "), _c('p', {
    class: {
      'correct': _vm.ps2
    }
  }, [_vm._v(_vm._s(_vm.$t('errp3')))]), _vm._v(" "), _c('p', {
    class: {
      'correct': _vm.ps3
    }
  }, [_vm._v(_vm._s(_vm.$t('errp4')))]), _vm._v(" "), _c('p', {
    class: {
      'correct': _vm.ps4
    }
  }, [_vm._v(_vm._s(_vm.$t('errp5')))]), _vm._v(" "), _c('p', {
    class: {
      'correct': _vm.ps5
    }
  }, [_vm._v(_vm._s(_vm.$t('errp6')))]), _vm._v(" "), _c('p', {
    class: {
      'correct': _vm.ps6
    }
  }, [_vm._v(_vm._s(_vm.$t('errp7')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "longps",
    attrs: {
      "type": "password",
      "placeholder": _vm.Enterpas
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "focus": function($event) {
        _vm.check59(0)
      },
      "blur": function($event) {
        _vm.check59(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "operate",
    class: [_vm.isA ? 'Select' : 'noSelect']
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": function($event) {
        _vm.check1()
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('agree'))), _c('span', [_c('a', {
    attrs: {
      "href": "http://www.medtrum.com/privacy_policy.html"
    }
  }, [_vm._v(_vm._s(_vm.$t('privacy')))])]), _vm._v("\n        " + _vm._s(_vm.$t('and'))), _c('span', [_c('a', {
    attrs: {
      "href": "http://www.medtrum.com/terms_of_use.html"
    }
  }, [_vm._v(_vm._s(_vm.$t('use')))])])])]), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.register
    }
  }, [_c('button', {
    staticClass: "register",
    class: {
      'click': _vm.isA
    },
    attrs: {
      "disabled": !_vm.isA
    }
  }, [_vm._v(_vm._s(_vm.$t('Register')))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1303)
    }
  })])
}]}

/***/ }),
/* 1416 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newPatient-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Patient Profile')))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('span', {
    class: {
      'es2': _vm.isIt || _vm.isFr
    }
  }, [_vm._v(_vm._s(_vm.$t('uername')) + ":")]), _c('label', {
    staticClass: "ID"
  }, [_vm._v(_vm._s(_vm.profile.username))])]), _vm._v(" "), _c('div', {
    staticClass: "item portrait"
  }, [_c('span', {
    staticClass: "long-portrait"
  }, [_vm._v(_vm._s(_vm.$t('Portrait')) + ":")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.portrait
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    class: {
      'es2': _vm.isFr || _vm.isSw
    }
  }, [_vm._v(_vm._s(_vm.$t('fullName')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.realname),
      expression: "profile.realname"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.realname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.realname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('gender')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.gender),
      expression: "profile.gender"
    }],
    staticClass: "gender",
    attrs: {
      "id": "gender"
    },
    domProps: {
      "value": _vm.profile.gender
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.profile.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "GDRNF"
    }
  }, [_vm._v(_vm._s(_vm.$t('GDRNF')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GDRM"
    }
  }, [_vm._v(_vm._s(_vm.$t('GDRM')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GDRF"
    }
  }, [_vm._v(_vm._s(_vm.$t('GDRF')))])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('height')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.height),
      expression: "profile.height"
    }],
    staticClass: "height",
    attrs: {
      "placeholder": _vm.profile.height
    },
    domProps: {
      "value": (_vm.profile.height)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.height = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.$t('cm')))])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('weight')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.weight),
      expression: "profile.weight"
    }],
    staticClass: "height",
    attrs: {
      "placeholder": _vm.profile.weight
    },
    domProps: {
      "value": (_vm.profile.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.weight = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.$t('kg')))])]), _vm._v(" "), _c('div', {
    staticClass: "item spe-item"
  }, [_c('span', {
    class: {
      'es2': _vm.isEs || _vm.isIt || _vm.isPo || _vm.isFr || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('birthday')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": _vm.birthdayShow,
      "clearable": false,
      "picker-options": _vm.pickerOptions,
      "format": "dd/MM  yyyy"
    },
    model: {
      value: (_vm.birthday),
      callback: function($$v) {
        _vm.birthday = $$v
      },
      expression: "birthday"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('label', {
    staticClass: "spe-span"
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _vm._v(" "), _c('select', {
    staticClass: "weight",
    attrs: {
      "id": "dis_type"
    },
    domProps: {
      "value": _vm.profile.diabetes_type
    }
  }, [_c('option', {
    attrs: {
      "value": "DBTNF"
    }
  }, [_vm._v(_vm._s(_vm.$t('DBTNF')))]), _vm._v(" "), _c('option', {
    attrs: {
      "selected": "",
      "value": "DBT1"
    }
  }, [_vm._v(_vm._s(_vm.$t('DBT1')))]), _c('option', {
    attrs: {
      "value": "DBT2"
    }
  }, [_vm._v(_vm._s(_vm.$t('DBT2')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DBTLADA"
    }
  }, [_vm._v(_vm._s(_vm.$t('LADA')))]), _c('option', {
    attrs: {
      "value": "DBTGEST"
    }
  }, [_vm._v(_vm._s(_vm.$t('Gestational')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DBTPRE"
    }
  }, [_vm._v(_vm._s(_vm.$t('Prediabetes')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "OTR"
    }
  }, [_vm._v(_vm._s(_vm.$t('Other')))])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('label', {
    staticClass: "spe-span"
  }, [_vm._v(_vm._s(_vm.$t('disDate')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": _vm.disDateShow,
      "clearable": false,
      "picker-options": _vm.pickerOptions,
      "format": "dd/MM  yyyy"
    },
    model: {
      value: (_vm.profile.diabetes_diagonosis_date),
      callback: function($$v) {
        _vm.profile.diabetes_diagonosis_date = $$v
      },
      expression: "profile.diabetes_diagonosis_date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "addSpan"
  }, [_vm._v(_vm._s(_vm.$t('Address')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.address),
      expression: "profile.address"
    }],
    staticClass: "address",
    domProps: {
      "value": (_vm.profile.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.address = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address2),
      expression: "address2"
    }],
    staticClass: "address",
    domProps: {
      "value": (_vm.address2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item post"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Postcode')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.zipcode),
      expression: "profile.zipcode"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.zipcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.zipcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Mobile')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.mobile),
      expression: "profile.mobile"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.mobile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Telephone')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.telephone),
      expression: "profile.telephone"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.telephone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.telephone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item email"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Email')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.email),
      expression: "profile.email"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "item1"
  }, [_c('span', {
    class: {
      'es1': _vm.isEs || _vm.isDe || _vm.isPo || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('Inpatient')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.inHospital),
      expression: "profile.inHospital"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.profile.inHospital = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v(_vm._s(_vm.$t('Yes')))]), _c('option', [_vm._v(_vm._s(_vm.$t('No')))])])]), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_c('span', {
    class: {
      'po1': _vm.isPo || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('Pno')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.patientNo),
      expression: "profile.patientNo"
    }],
    domProps: {
      "value": (_vm.profile.patientNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.patientNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item1 spe-item1"
  }, [_c('span', {
    class: {
      'po1': _vm.isPo || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('Bno')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.bedNo),
      expression: "profile.bedNo"
    }],
    domProps: {
      "value": (_vm.profile.bedNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.bedNo = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('button', {
    staticClass: "cancel",
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "create",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dateView-Container"
  }, [_c('button', {
    on: {
      "click": _vm.set2
    }
  }, [_vm._v(_vm._s(_vm.$t('Back')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isA),
      expression: "isA"
    }],
    staticClass: "view-main"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1293)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isB),
      expression: "isB"
    }],
    staticClass: "view-main2"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('sensor')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLapp1),
      expression: "isLapp1"
    }],
    staticStyle: {
      "color": "#ff3c3c"
    }
  }, [_vm._v(_vm._s(_vm.$t('overLapp')) + ":" + _vm._s(_vm.LapList1))])]), _vm._v(" "), (_vm.haveSensorData) ? _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('table', [_c('tr', {
    staticClass: "table-title"
  }, [_c('td', {
    staticStyle: {
      "width": "52px"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1112_Number')))]), _vm._v(" "), _c('td', {
    staticClass: "spe-td1"
  }, [_vm._v(_vm._s(_vm.$t('tranSn')))]), _vm._v(" "), _c('td', {
    staticClass: "spe-td2"
  }, [_vm._v(_vm._s(_vm.$t('pdmSN')))]), _vm._v(" "), _c('td', {
    staticClass: "spe-td3"
  }, [_vm._v(_vm._s(_vm.$t('startTime')))]), _vm._v(" "), _c('td', {
    staticClass: "spe-td4"
  }, [_vm._v(_vm._s(_vm.$t('endTime')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('UploadTime')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    attrs: {
      "id": "table1"
    }
  }, _vm._l((_vm.Sessions[0]), function(item, index) {
    return _c('tr', {
      class: (index % 2 === 0) ? '' : 'even',
      attrs: {
        "id": 'lap' + index
      }
    }, [_c('td', {
      staticStyle: {
        "width": "54px"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "spe-td1"
    }, [_vm._v(_vm._s(item[1]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item[6]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item[3]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item[4]))]), _c('td', [_vm._v(_vm._s(item[5]))])])
  }))])]) : _c('div', [_c('div', {
    staticClass: "no-data"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('No data')))])])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-left pdm"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Patch Pump')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLapp2),
      expression: "isLapp2"
    }],
    staticStyle: {
      "color": "#ff3c3c"
    }
  }, [_vm._v(_vm._s(_vm.$t('overLapp')) + ":" + _vm._s(_vm.LapList2))])]), _vm._v(" "), (_vm.havePumpData) ? _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('table', [_c('tr', {
    staticClass: "table-title"
  }, [_c('td', {
    staticStyle: {
      "width": "52px"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1112_Number')))]), _vm._v(" "), _c('td', {
    staticClass: "spe-td1"
  }, [_vm._v(_vm._s(_vm.$t('pumpSN')))]), _vm._v(" "), _c('td', {
    staticClass: "spe-td2"
  }, [_vm._v(_vm._s(_vm.$t('pdmSN')))]), _vm._v(" "), _c('td', {
    staticClass: "spe-td3"
  }, [_vm._v(_vm._s(_vm.$t('startTime')))]), _vm._v(" "), _c('td', {
    staticClass: "spe-td4"
  }, [_vm._v(_vm._s(_vm.$t('endTime')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('UploadTime')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    attrs: {
      "id": "table2"
    }
  }, _vm._l((_vm.Sessions[1]), function(item, index) {
    return _c('tr', {
      class: (index % 2 === 0) ? '' : 'even',
      attrs: {
        "id": 'lapp' + index
      }
    }, [_c('td', {
      staticStyle: {
        "width": "54px"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "spe-td1"
    }, [_vm._v(_vm._s(item[1]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item[6]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item[3]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item[4]))]), _c('td', [_vm._v(_vm._s(item[5]))])])
  }))])]) : _c('div', [_c('div', {
    staticClass: "no-data"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('No data')))])])])])])
},staticRenderFns: []}

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('img', {
    attrs: {
      "id": "user",
      "src": __webpack_require__(220)
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('title')))]), _vm._v(" "), _c('div', {
    staticClass: "icon-bor",
    class: {
      'in': _vm.isB
    }
  }, [_c('div', {
    class: {
      'in1': _vm.isB
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(173)
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": _vm.user,
      "maxlength": "80"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "focus": _vm.check2,
      "blur": _vm.check2,
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.down($event)
      }, function($event) {
        if (!('button' in $event) && $event.keyCode !== 13) { return null; }
        _vm.down($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon-bor",
    class: {
      'in': _vm.isC
    }
  }, [_c('div', {
    class: {
      'in1': _vm.isC
    }
  }, [_c('img', {
    attrs: {
      "id": "img1",
      "src": __webpack_require__(172)
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "id": "psd",
      "type": "password",
      "placeholder": _vm.pas,
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.up($event)
      },
      "focus": _vm.check3,
      "blur": _vm.check3,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "operate",
    class: {
      'po1': _vm.isEs || _vm.isPo
    }
  }, [_c('div', {
    staticClass: "operate-left",
    class: [_vm.isA ? 'Select' : 'noSelect']
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": _vm.choose
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('remember')))])]), _vm._v(" "), _c('div', {
    staticClass: "operate-right"
  }, [_c('label', {
    on: {
      "click": _vm.forgot
    }
  }, [_vm._v(_vm._s(_vm.$t('forget')))])])]), _vm._v(" "), _c('button', {
    staticClass: "login",
    class: {
      'po2': _vm.isEs || _vm.isPo
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('sign in')))]), _vm._v(" "), _c('button', {
    staticClass: "sign",
    on: {
      "click": _vm.sign
    }
  }, [_vm._v(_vm._s(_vm.$t('sign up now')))])])
},staticRenderFns: []}

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "chart-container"
  }, [_c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('sensorOlRe')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.$t('period')) + ": " + _vm._s(_vm.timeRange3))])])]), _vm._v(" "), _c('table', {
    staticClass: "status-table1",
    class: {
      'zh1': !_vm.isEn, 'de1': _vm.isDe || _vm.isIt || _vm.isFr
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('uername')))]), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.username))]), _vm._v(" "), _c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('fullName')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('devices')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "id": "reportPdmTitle"
    }
  }, [_vm._v(_vm._s(_vm.$t('pdm')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('tran')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('pumpBase')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[2]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td4"
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _c('td', {
    staticClass: "td4",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v(_vm._s(_vm.statics.medical_history))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('img', {
    staticClass: "graph",
    attrs: {
      "id": "img3_1"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "spe-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "legend-group"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.A),
      expression: "show.A"
    }],
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(297)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.legendDate[0]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.B),
      expression: "show.B"
    }],
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(298)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.legendDate[1]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.C),
      expression: "show.C"
    }],
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(299)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.legendDate[2]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.D),
      expression: "show.D"
    }],
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(300)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.legendDate[3]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.E),
      expression: "show.E"
    }],
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(301)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.legendDate[4]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.F),
      expression: "show.F"
    }],
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(302)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.legendDate[5]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.G),
      expression: "show.G"
    }],
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(303)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.legendDate[6]))])]), _vm._v(" "), _c('div', {
    staticClass: "legend",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(294)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Average')))])])]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('date')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Avg')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('min')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('max')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('ofhypo')))])]), _vm._v(" "), _vm._l((_vm.date), function(item, i) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item),
        expression: "item"
      }]
    }, [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(item))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[i].avg))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[i].min))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[i].max))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[i].nh))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('overall')))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.glucose[_vm.glucoseLength].avg))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.glucose[_vm.glucoseLength].min))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.glucose[_vm.glucoseLength].max))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.glucoseLength].nh))])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "page-end"
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(19)
    }
  })])
}]}

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "chart-container"
  }, [_c('div', {
    staticClass: "Hcp-main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('dashboard')))])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('button', {
    on: {
      "click": _vm.print
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('print')))])]), _vm._v(" "), _c('button', {
    staticClass: "set",
    on: {
      "click": _vm.open
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('set')))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('period')) + ":"), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.timeRange2))])])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr spe-hr"
  }), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "rb bb",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_glucose')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_cgm')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_insulin')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_carbs')))]), _vm._v(" "), _c('td', {
    staticClass: "bb",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_exercise')))])]), _vm._v(" "), _c('tr', {
    staticClass: "trh1"
  }, [_c('td', {
    staticClass: "rb ",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_glucose_avg')))]), _vm._v(" "), _c('td', {
    staticClass: "rb ",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_cgm_avg')))]), _vm._v(" "), _c('td', {
    staticClass: "rb ",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_insulin_avg')))]), _vm._v(" "), _c('td', {
    staticClass: "rb ",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_carbs_avg')))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_exercise_avg')))])]), _vm._v(" "), _c('tr', {
    staticClass: "trh1"
  }, [_c('td', {
    staticClass: "rb bb sp",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "bbv"
  }, [_vm._v(_vm._s(_vm.bgAvg))]), _vm._v(" " + _vm._s(_vm.glucoseUnit))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "bbv"
  }, [_vm._v(_vm._s(_vm.sgAvg))]), _vm._v(" " + _vm._s(_vm.glucoseUnit))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "bbv"
  }, [_vm._v(_vm._s(_vm.insAvg))]), _vm._v(" " + _vm._s(_vm.$t('ins_unit2')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "bbv"
  }, [_vm._v(_vm._s(_vm.carbAvg))]), _vm._v(" g")]), _vm._v(" "), (_vm.exerAvgHour == 0) ? _c('td', {
    staticClass: "bb",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "bbv"
  }, [_vm._v(_vm._s(_vm.exerAvg))]), _vm._v(_vm._s(_vm.$t('t1112_min')))]) : _c('td', {
    staticClass: "bb",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "bbv"
  }, [_vm._v(_vm._s(_vm.exerAvgHour))]), _vm._v(_vm._s(_vm.$t('Hours')) + "   "), _c('span', {
    staticClass: "bbv"
  }, [_vm._v(_vm._s(_vm.exerAvg))]), _vm._v(" " + _vm._s(_vm.$t('t1112_min')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_sd')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_num')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_sd')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_num')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_sd')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('t1112_days')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_sd')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_num')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_sd')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_num')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.bgSD))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.bgNum))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.sgSD))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.sgNum))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.insSD))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.insNum))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.carbSD))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.carbNum))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.exerSD))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.exerNum))])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "est-a1c"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "est-title"
  }, [_vm._v(_vm._s(_vm.$t("est_a1c_t1")) + " ")]), _vm._v(" "), (_vm.a1c_available) ? _c('span', [_c('span', [_vm._v(_vm._s(_vm.est_a1c) + "  ")]), _c('span', [_vm._v(_vm._s(_vm.$t("est_a1c_t2")))])]) : _c('span', [_c('span', [_vm._v(_vm._s(_vm.$t('t1112_Not_available')))])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "x_est-ita"
  }, [_vm._v(_vm._s(_vm.$t("est_a1c_t3")))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "graph2",
    attrs: {
      "id": "chart1_4",
      "element-loading-text": _vm.loadingText
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "row1"
  }, [_c('div', {
    staticClass: "left-table"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('dboard_statistics')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_BG')))]), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_BG_calibration')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.bgPerDay) + " / " + _vm._s(_vm.calibPerDay))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_SG')))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_AUC_high')) + " " + _vm._s(_vm.highLevelText))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.aucu))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_AUC_low')) + " " + _vm._s(_vm.lowLevelText))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.aucl))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_highest_value')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.sgHighest))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_lowest_value')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.sgLowest))])])]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "rb",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_pump')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_daily_basal')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.basalPercent))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_daily_bolus')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.bolusPercent))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_avg_bolus_num')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgBolusNum))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_avg_suspend_time')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgSuspendTime))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_avg_reservoir_usage')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.patchAvgLife) + " " + _vm._s(_vm.$t('t1113_days')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "right-chart"
  }, [_c('div', {
    class: {
      'hide': _vm.chart5NoData
    },
    attrs: {
      "id": "chart1_5"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "chart_title",
    class: {
      'hide': _vm.chart5NoData
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('t1103_Overall_Tine_In_Range')))]), _vm._v(" "), _c('p', {
    class: {
      'hide': !_vm.chart5NoData
    },
    attrs: {
      "id": "chart1_5_no_data"
    }
  }, [_vm._v("No data")])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "row2 left-table"
  }, [_c('table', {
    staticClass: "statics-table mtop"
  }, [_c('tr', [_c('td', {
    staticClass: "rb bb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_manual_bolus')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgManualBolus))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb bb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_normal')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgManualNormalBolus))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb bb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_extend')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgManualExtendBolus))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_combo')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.avgManualComboBolus))])])]), _vm._v(" "), _c('table', {
    staticClass: "statics-table mtop"
  }, [_c('tr', [_c('td', {
    staticClass: "rb bb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_bolus_calculator')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgWizzardBolus))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb bb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_food_bolus')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgFoodWizzardBolus))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_corr_bolus')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.avgCorrWizzardBolus))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb bb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_override_add')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgWizzardOverrideAdd))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_override_sub')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.avgWizzardOverrideSub))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row2 right-chart"
  }, [_c('div', {
    class: {
      'hide': _vm.chart6NoData
    },
    attrs: {
      "id": "chart1_6"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "chart_title",
    class: {
      'hide': _vm.chart6NoData
    }
  }, [_vm._v(_vm._s(_vm.$t('t1103_Basal_Bolus')))]), _vm._v(" "), _c('p', {
    class: {
      'hide': !_vm.chart6NoData
    },
    attrs: {
      "id": "chart1_6_no_data"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1108_No_data')))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "row1"
  }, [_c('div', {
    staticClass: "left-table"
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: " rb",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Auto_Mode')))]), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Time_in_Auto_Mode')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.timeInAutoMode))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: " rb",
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Average_SG_SD')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.autoModeSGAvgSD) + " " + _vm._s(_vm.glucoseUnit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: " rb",
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Time_in_Target_Range')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.autoModeSGInTargetRange))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: " rb",
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Time_above_Range')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.autoModeSGAboveRange))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: " rb",
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Time_below_Range')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.autoModeSGBelowRange))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: " rb",
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Auto_Basal_per_day')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.autoModeBasalPerDay))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Auto_Bolus_per_day')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.autoModeBolusPerDay))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('t1221_Auto_Mode_Exits')))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('t1221_No_Sensor_readings')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.autoModeExitCauseNoSensorReadings))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('t1221_Max_Delivery')) + " ")]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.autoModeExitCauseMaxDelivery))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('t1221_Min_Delivery')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.autoModeExitCauseMinDelivery))])])])]), _vm._v(" "), _c('div', {
    staticClass: "right-chart"
  }, [_c('div', {
    class: {
      'hide': _vm.chart7NoData
    },
    attrs: {
      "id": "chart1_7"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "chart_title",
    class: {
      'hide': _vm.chart7NoData
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('t1103_Time_in_target_range')))]), _vm._v(" "), _c('p', {
    class: {
      'hide': !_vm.chart7NoData
    },
    attrs: {
      "id": "chart1_7_no_data"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1108_No_data')))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart1_1"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "bolCount"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('# of Boluses')))]), _vm._v(" "), _c('table', {
    staticClass: "countLabel"
  }, [_c('tr', {
    attrs: {
      "id": "count"
    }
  }, _vm._l((48), function(i) {
    return _c('td')
  }))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart1_3"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart1_2"
    }
  })])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.typeChooseVisible,
      "size": _vm.dialogSize,
      "id": "dialog-form2",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.typeChooseVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('setPeriod')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(21)
    },
    on: {
      "click": _vm.cancel
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('div', {
    staticClass: "duration"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('duration')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeRangeSelect),
      expression: "timeRangeSelect"
    }],
    attrs: {
      "id": "duration"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.timeRangeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.procTimeRangeSelect]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('7 days')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('14 days')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('30 days')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v(_vm._s(_vm.$t('90 days')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('Customize')))])])]), _vm._v(" "), _c('div', {
    staticClass: "time-range",
    class: {
      'zh2': !_vm.isEn
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('From')))]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.custo),
      expression: "!custo"
    }]
  }, [_vm._v(_vm._s(_vm.staTime))]), _vm._v(" "), _c('el-date-picker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.custo),
      expression: "custo"
    }],
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.staTime,
      "format": "dd-MM-yyyy"
    },
    on: {
      "change": _vm.startDateChange
    },
    model: {
      value: (_vm.value4),
      callback: function($$v) {
        _vm.value4 = $$v
      },
      expression: "value4"
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.endTime,
      "format": "dd-MM-yyyy"
    },
    on: {
      "change": _vm.endDateChange
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1)]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    on: {
      "click": _vm.dateApply
    }
  }, [_vm._v(_vm._s(_vm.$t('applyM')))]), _vm._v(" "), _c('button', {
    staticClass: "cancelButton",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-container"
  }, [_c('div', {
    staticClass: "Hcp-main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('daily')))])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('date')))]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.print
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('print')))])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(121)
    },
    on: {
      "click": _vm.prev
    }
  }), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": _vm.time,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "editable": false,
      "format": "dd/MM  yyyy"
    },
    on: {
      "change": _vm.getDs
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(120),
      "id": "next"
    },
    on: {
      "click": _vm.next
    }
  })], 1)])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr spe-hr"
  }), _vm._v(" "), _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart1_1"
    }
  })])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "graph",
    attrs: {
      "id": "chart1_2",
      "element-loading-text": _vm.loadingText
    }
  })])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart1_3"
    }
  })])], 1), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "legend-group",
    class: {
      'zh1': !_vm.isEn, 'es1': _vm.isEs, 'it1': _vm.isIt, 'po1': _vm.isPo, 'du1': _vm.isDu || _vm.isCz
    }
  }, [_c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(88)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('alert')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(116)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('target')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": __webpack_require__(112)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('hypo')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": __webpack_require__(105)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('sensorGlucose')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(110)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('calib')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend "
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(118)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('newSen')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1",
    class: {
      'zh10': !_vm.isEn, 'es10': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(119)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('warm')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe8",
    class: {
      'zh2': !_vm.isEn, 'es2': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(109)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('basal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe9",
    class: {
      'zh3': !_vm.isEn, 'es3': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(117)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('tampBasal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe3",
    class: {
      'zh4': !_vm.isEn, 'es4': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(114)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('normalBolus')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe4",
    class: {
      'zh5': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(111)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('extendBolus')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe5",
    class: {
      'zh6': !_vm.isEn, 'es6': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(106)
    }
  }), _c('span', {
    staticClass: "span1"
  }, [_vm._v(_vm._s(_vm.$t('manualStop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1",
    class: {
      'zh7': !_vm.isEn, 'es7': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(104)
    }
  }), _c('span', {
    staticClass: "span1"
  }, [_vm._v(_vm._s(_vm.$t('autoStop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe10",
    class: {
      'zh11': !_vm.isEn, 'es11': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(115)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('stop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe6",
    class: {
      'zh8': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(113)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('newPatch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe7",
    class: {
      'zh9': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(143)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('carbs')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe2",
    class: {
      'zh15': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(144)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('exercise')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(142)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('BG Reading')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(71)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Breakfast')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(70)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Lunch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(72)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Dinner')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(73)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1222_Snack')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(219)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Exercise')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(108)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1222_auto_basal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(107)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1222_auto_bolus')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('statics')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table",
    class: {
      'de3': _vm.isDe
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('glucose')))]), _vm._v(" "), _c('td', {
    staticClass: "td1",
    attrs: {
      "rowspan": "2",
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('insulin')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "rowspan": "2",
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('events')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('BG1')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('SG1')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Avg')) + _vm._s(_vm.unit) + _vm._s(_vm.$t('±SD')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.bg_avg_dev))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.sg_avg_dev))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(" " + _vm._s(_vm.$t('totalDose')) + " " + _vm._s(_vm.$t('ins_unit')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.insulin.total))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(" " + _vm._s(_vm.$t('carbs')) + " (g)")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.events.carb_total))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('min')) + _vm._s(_vm.unit))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.bg_min))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.sg_min))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('bolus')) + " " + _vm._s(_vm.$t('ins_unit')) + "/%")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.insulin.bolus))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(" " + _vm._s(_vm.$t('ofMeal')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.events.meal_count))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('max')) + _vm._s(_vm.unit))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.bg_max))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.sg_max))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('basal')) + " " + _vm._s(_vm.$t('ins_unit')) + "/%")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.insulin.basal))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('avgSD1')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.events.meal_avg_sd))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('target')) + " (%)")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.bg_np))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.sg_np))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('foodBolus')) + " " + _vm._s(_vm.$t('ins_unit')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.insulin.carb_bolus))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('totalExerTime')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.events.exercise_time))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('low1')) + " (%)")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.bg_lp))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.sg_lp))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('calibBolus')) + " " + _vm._s(_vm.$t('ins_unit')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.insulin.corr_bolus))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('exerNum')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.events.exercise_count))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('high1')) + " (%)")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.bg_hp))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.sg_hp))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(" " + _vm._s(_vm.$t('Food+coor')) + " " + _vm._s(_vm.$t('ins_unit')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.foodCoor))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(" " + _vm._s(_vm.$t('avgInten')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.events.exercise_avg_time))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('ofRead')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.bg_rds_time))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.sg_data_num))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(" " + _vm._s(_vm.$t('normalBolus')) + " " + _vm._s(_vm.$t('ins_unit')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.insulin.normal_bolus))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }), _c('td', {
    staticClass: "td2"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('ofHypo')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.bg_hypo_rds_time))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.sg_hypo_num) + "/" + _vm._s(_vm.glucose.sg_hypo_duration))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('extendBolus')) + " " + _vm._s(_vm.$t('ins_unit')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.insulin.extent_bolus))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }), _c('td', {
    staticClass: "td2"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('ofAlert')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.bg_alarm_cnt))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.sg_alarm_cnt))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('tampBasal')) + " " + _vm._s(_vm.$t('ins_unit')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.insulin.temp_basal))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }), _c('td', {
    staticClass: "td2"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }), _c('td', {
    staticClass: "td1"
  }), _c('td', {
    staticClass: "td1"
  }), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('durationStop')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.insulin.suspend_time))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }), _c('td', {
    staticClass: "td2"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }), _c('td', {
    staticClass: "td3"
  }), _c('td', {
    staticClass: "td3"
  }), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('ofPumpAlert')))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.insulin.pump_alarm_cnt))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }), _c('td')])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('table', {
    staticClass: "statics-table auto_mode",
    class: {
      'de3': _vm.isDe
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td2",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1222_Auto_Mode')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(" " + _vm._s(_vm.$t('t1222_Time_in_Auto_Mode')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.timeInAutoMode))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(" " + _vm._s(_vm.$t('t1222_Avg_SD')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.autoModeSGAvgSD) + " " + _vm._s(_vm.glucose_unit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1222_Target_Range')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.autoModeSGInTargetRange))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1222_Above_Range')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.autoModeSGAboveRange))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1222_Below_Range')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.autoModeSGBelowRange))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: " td3"
  }, [_vm._v(" " + _vm._s(_vm.$t('t1222_Auto_Mode_Exits')))]), _vm._v(" "), _c('td', {
    staticClass: " "
  }, [_vm._v(_vm._s(_vm.autoModeExits))])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-container"
  }, [_c('div', {
    staticClass: "Hcp-main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('sensorOverlay')))])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right",
    class: {
      'it1': _vm.isIt || _vm.isFr
    }
  }, [_c('button', {
    on: {
      "click": _vm.print
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('print')))])]), _vm._v(" "), _c('button', {
    staticClass: "set",
    on: {
      "click": _vm.open
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('set')))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('period')) + ":"), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.timeRange3))])])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr spe-hr"
  }), _vm._v(" "), _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "graph",
    attrs: {
      "id": "chart3_1",
      "element-loading-text": _vm.loadingText
    }
  })])], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "legend-group"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.A),
      expression: "show.A"
    }],
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(297)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.legendDate[0]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.B),
      expression: "show.B"
    }],
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(298)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.legendDate[1]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.C),
      expression: "show.C"
    }],
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(299)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.legendDate[2]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.D),
      expression: "show.D"
    }],
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(300)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.legendDate[3]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.E),
      expression: "show.E"
    }],
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(301)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.legendDate[4]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.F),
      expression: "show.F"
    }],
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(302)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.legendDate[5]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.G),
      expression: "show.G"
    }],
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(303)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.legendDate[6]))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe2"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(294)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Average')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    attrs: {
      "id": "sa_stat_table"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('date')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Avg')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('min')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('max')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('ofhypo')))])]), _vm._v(" "), _vm._l((_vm.date), function(item, i) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item),
        expression: "item"
      }]
    }, [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(item))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[i].avg))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[i].min))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[i].max))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[i].nh))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('overall')))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.glucose[_vm.glucoseLength].avg))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.glucose[_vm.glucoseLength].min))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.glucose[_vm.glucoseLength].max))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.glucoseLength].nh))])])], 2)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.typeChooseVisible,
      "size": _vm.dialogSize,
      "id": "dialog-form2",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.typeChooseVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('setPeriod')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(21)
    },
    on: {
      "click": _vm.cancel
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('div', {
    staticClass: "time-range",
    class: {
      'zh2': !_vm.isEn
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('From')))]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_c('span', [_vm._v(_vm._s(_vm.startDate))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate,
      "format": "dd-MM-yyyy"
    },
    on: {
      "change": _vm.procTimeRangeSelect
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1)]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "weeks",
    class: {
      'zh3': !_vm.isEn
    },
    attrs: {
      "id": "weeks"
    }
  }, [_c('span', {
    staticClass: "tittle",
    class: {
      'zh4': !_vm.isEn
    }
  }, [_c('label', {
    on: {
      "click": _vm.chooseAll
    }
  }, [_vm._v(_vm._s(_vm.$t('Weekdays')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Mon')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Tue')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Wed')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Thur')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Fri')))])])]), _vm._v(" "), _c('div', {
    staticClass: "weeks weken",
    class: {
      'zh3': !_vm.isEn
    },
    attrs: {
      "id": "weken"
    }
  }, [_c('span', {
    staticClass: "tittle",
    class: {
      'zh5': !_vm.isEn, 'de5': _vm.isDe, 'it5': _vm.isIt, 'po5': _vm.isPo, 'du5': _vm.isDu, 'sw5': _vm.isSw, 'cz5': _vm.isCz
    }
  }, [_c('label', {
    on: {
      "click": _vm.chooseAll
    }
  }, [_vm._v(_vm._s(_vm.$t('Weekends')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Sat')))])]), _vm._v(" "), _c('span', {
    staticClass: "weeken-spe",
    class: {
      'it2': _vm.isIt, 'po2': _vm.isPo, 'du2': _vm.isDu, 'fr3': _vm.isFr, 'sw2': _vm.isSw, 'cz2': _vm.isCz
    }
  }, [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Sun')))])])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    on: {
      "click": _vm.dateApply
    }
  }, [_vm._v(_vm._s(_vm.$t('applyM')))]), _vm._v(" "), _c('button', {
    staticClass: "cancelButton",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-container"
  }, [_c('div', {
    staticClass: "Hcp-main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('TrendAna')))])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('button', {
    on: {
      "click": _vm.print
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('print')))])]), _vm._v(" "), _c('button', {
    staticClass: "set",
    on: {
      "click": _vm.open
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('set')))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('period')) + ":"), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.timeRange))])])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr spe-hr"
  }), _vm._v(" "), _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "graph",
    attrs: {
      "id": "chart4_1",
      "element-loading-text": _vm.loadingText
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "rowspan": "2",
      "width": "9%"
    }
  }, [_vm._v(_vm._s(_vm.$t('static')))]), _vm._v(" "), _c('td', {
    staticClass: "td1",
    attrs: {
      "colspan": "10",
      "width": "29%"
    }
  }, [_vm._v(_vm._s(_vm.$t('Basics')))]), _vm._v(" "), _c('td', {
    staticClass: "td1",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('distri')) + "%")]), _vm._v(" "), _c('td', {
    staticClass: "td1",
    attrs: {
      "colspan": "4",
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('stab')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v(_vm._s(_vm.$t('BG1')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Avg')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('max')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('min')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Med')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Q1')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Q3')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('IQR')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('SD')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('CV')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('SE1')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('high')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('low')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('target')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('aucAbove')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('aucBelow')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('#high')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('#low')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('high')) + "%")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('low')) + "%")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('target')) + "%")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Avg')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('SD')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('#hypo')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('bgRead')))])]), _vm._v(" "), _vm._l((_vm.xDate2), function(day, j) {
    return _c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(day))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_avg))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_max))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_min))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_median))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_q1))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_q3))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_iqr))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_sd))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_cv))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_se))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_up))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_lp))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_tp))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_aucu))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_aucl))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_nu))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_nl))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].bg_up))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].bg_lp))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[j].bg_tp))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].bg_avg))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].bg_sd))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].bg_hypo_num))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].bg_num))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Avg/Total')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_avg))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_max))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_min))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_median))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_q1))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_q3))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_iqr))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_sd))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_cv))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_se))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_up))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_lp))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_tp))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_aucu))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_aucl))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_nu))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_nl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].bg_up))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].bg_lp))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].bg_tp))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].bg_avg))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].bg_sd))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].bg_hypo_num))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].bg_num))])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart4_2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "statics spe-statics"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table",
    class: {
      'de2': _vm.isDe
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "rowspan": "2",
      "width": "11%"
    }
  }, [_vm._v(_vm._s(_vm.$t('static')))]), _vm._v(" "), _c('td', {
    staticClass: "td1",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.$t('insulin2')))]), _vm._v(" "), _c('td', {
    staticClass: "td1",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('carbs')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('exercise')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('total')) + " " + _vm._s(_vm.$t('ins_unit')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('avg_daily_basal')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('avg_daily_bolus')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('ofBolus')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('avgBolus')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('carbs')) + " (g)")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('ofMeal')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Dura1')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('ofExer')))])]), _vm._v(" "), _vm._l((_vm.xDate2), function(day, i) {
    return _c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(day))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.event[i].ins_total))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_c('span', {
      staticClass: "value_percent_cell left_value"
    }, [_vm._v(_vm._s(_vm.event[i].ins_basal))]), _vm._v(" "), _c('span', {
      staticClass: "value_percent_cell right_percent"
    }, [_vm._v(_vm._s(_vm.event[i].ins_basal_p))])]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_c('span', {
      staticClass: "value_percent_cell left_value"
    }, [_vm._v(_vm._s(_vm.event[i].ins_bolus))]), _vm._v(" "), _c('span', {
      staticClass: "value_percent_cell right_percent"
    }, [_vm._v(_vm._s(_vm.event[i].ins_bolus_p))])]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.event[i].ins_bolus_n))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.event[i].ins_bolus_avg))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.event[i].carb_gram))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.event[i].carb_num))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.event[i].exer_time))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.event[i].exer_num))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Avg/Total')))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].ins_total))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_c('span', {
    staticClass: "value_percent_cell left_value"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].ins_basal))]), _vm._v(" "), _c('span', {
    staticClass: "value_percent_cell right_percent"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].ins_basal_p))])]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_c('span', {
    staticClass: "value_percent_cell left_value"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].ins_bolus))]), _vm._v(" "), _c('span', {
    staticClass: "value_percent_cell right_percent"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].ins_bolus_p))])]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].ins_bolus_n))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].ins_bolus_avg))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].carb_gram))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].carb_num))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].exer_time))]), _c('td', [_vm._v(_vm._s(_vm.event[_vm.dayNum].exer_num))])])], 2)]), _vm._v(" "), _c('br'), _c('br')])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.typeChooseVisible,
      "size": _vm.dialogSize,
      "id": "dialog-form2",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.typeChooseVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('setPeriod')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(21)
    },
    on: {
      "click": _vm.cancel
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('div', {
    staticClass: "select-interval-wrap"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.$t('duration')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeRangeSelect),
      expression: "timeRangeSelect"
    }],
    staticClass: "select-timerange",
    attrs: {
      "id": "timeRangeSelect"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.timeRangeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.procTimeRangeSelect]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('7 days')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('14 days')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('30 days')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v(_vm._s(_vm.$t('90 days')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('Customize')))])]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(_vm.$t('interval')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeIntervalSelect),
      expression: "timeIntervalSelect"
    }],
    staticClass: "select-interval",
    attrs: {
      "id": "timeIntervalSelect"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.timeIntervalSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.procTimeIntervalSelect]
    }
  }, _vm._l((_vm.intervalOption), function(item) {
    return _c('option', {
      domProps: {
        "value": item[0]
      }
    }, [_vm._v(_vm._s(item[1]))])
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "time-range",
    class: {
      'zh2': !_vm.isEn
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('From')))]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "disabled": _vm.startDateDisable,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.startDate,
      "format": "dd-MM-yyyy"
    },
    on: {
      "change": _vm.startDateChange
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate,
      "format": "dd-MM-yyyy"
    },
    on: {
      "change": _vm.endDateChange
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1)]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "weeks",
    class: {
      'zh3': !_vm.isEn
    },
    attrs: {
      "id": "weeks"
    }
  }, [_c('span', {
    staticClass: "tittle",
    class: {
      'zh4': !_vm.isEn
    }
  }, [_c('label', {
    on: {
      "click": _vm.chooseAll
    }
  }, [_vm._v(_vm._s(_vm.$t('Weekdays')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Mon')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Tue')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Wed')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Thur')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Fri')))])])]), _vm._v(" "), _c('div', {
    staticClass: "weeks weken",
    class: {
      'zh3': !_vm.isEn
    },
    attrs: {
      "id": "weken"
    }
  }, [_c('span', {
    staticClass: "tittle",
    class: {
      'zh5': !_vm.isEn, 'de5': _vm.isDe, 'it5': _vm.isIt, 'po5': _vm.isPo, 'du5': _vm.isDu, 'sw5': _vm.isSw, 'cz5': _vm.isCz
    }
  }, [_c('label', {
    on: {
      "click": _vm.chooseAll
    }
  }, [_vm._v(_vm._s(_vm.$t('Weekends')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Sat')))])]), _vm._v(" "), _c('span', {
    class: {
      'it2': _vm.isIt, 'po2': _vm.isPo, 'du2': _vm.isDu, 'fr3': _vm.isFr, 'sw2': _vm.isSw, 'cz2': _vm.isCz
    }
  }, [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Sun')))])])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    on: {
      "click": _vm.dateApply
    }
  }, [_vm._v(_vm._s(_vm.$t('applyM')))]), _vm._v(" "), _c('button', {
    staticClass: "cancelButton",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-container"
  }, [_c('div', {
    staticClass: "Hcp-main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('DeviceSetting')))])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('button', {
    on: {
      "click": _vm.print
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('print')))])]), _vm._v(" "), _c('button', {
    staticClass: "set",
    on: {
      "click": _vm.open
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('set')))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.time))])])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr spe-hr"
  }), _vm._v(" "), (_vm.showEasyPatch !== 'easysense') ? _c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "tit1e"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('basal')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('MaxBasalRate')) + ": " + _vm._s(_vm.basal.max_rate) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Selected Basal Pattern')) + ": " + _vm._s(_vm.basal.basal_select))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('BasalPatterns')) + ": " + _vm._s(_vm.basal.basal_onoff))])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart6_1"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "graph",
    attrs: {
      "id": "chart6_2",
      "element-loading-text": _vm.loadingText
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart6_3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart6_4"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart6_5"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.moreBasal),
      expression: "moreBasal"
    }]
  }, [_c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart6_6"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart6_7"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart6_8"
    }
  })]), _vm._v(" "), _vm._l((this.basalInfo), function(item) {
    return _c('div', [_c('div', {
      staticClass: "statics"
    }, [_c('p', {
      staticClass: "custom"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "margin-right": "30px"
      }
    }, [_vm._v(_vm._s(_vm.$t('24h Total')) + ": " + _vm._s(item.total) + _vm._s(_vm.$t('ins_unit2')))]), _vm._v(" "), _c('table', {
      staticClass: "statics-table"
    }, [_c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('Start')))]), _vm._l((item.bsg1), function(i) {
      return _c('td', {
        staticClass: "td1"
      }, [_vm._v(_vm._s(i[0]))])
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(_vm.$t('basal_unit2')))]), _vm._l((item.bsg1), function(i) {
      return _c('td', {
        staticClass: "td3"
      }, [_vm._v(_vm._s(i[1]))])
    })], 2)])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((item.bsg2show)),
        expression: "(item.bsg2show)"
      }],
      staticClass: "statics"
    }, [_c('table', {
      staticClass: "statics-table"
    }, [_c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('Start')))]), _vm._l((item.bsg2), function(i) {
      return _c('td', {
        staticClass: "td1"
      }, [_vm._v(_vm._s(i[0]))])
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(_vm.$t('basal_unit2')))]), _vm._l((item.bsg2), function(i) {
      return _c('td', {
        staticClass: "td3"
      }, [_vm._v(_vm._s(i[1]))])
    })], 2)])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((item.bsg3show)),
        expression: "(item.bsg3show)"
      }],
      staticClass: "statics"
    }, [_c('table', {
      staticClass: "statics-table"
    }, [_c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('Start')))]), _vm._l((item.bsg3), function(i) {
      return _c('td', {
        staticClass: "td1"
      }, [_vm._v(_vm._s(i[0]))])
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(_vm.$t('basal_unit2')))]), _vm._l((item.bsg3), function(i) {
      return _c('td', {
        staticClass: "td3"
      }, [_vm._v(_vm._s(i[1]))])
    })], 2)])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((item.bsg4show)),
        expression: "(item.bsg4show)"
      }],
      staticClass: "statics"
    }, [_c('table', {
      staticClass: "statics-table"
    }, [_c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('Start')))]), _vm._l((item.bsg4), function(i) {
      return _c('td', {
        staticClass: "td1"
      }, [_vm._v(_vm._s(i[0]))])
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(_vm.$t('basal_unit2')))]), _vm._l((item.bsg4), function(i) {
      return _c('td', {
        staticClass: "td3"
      }, [_vm._v(_vm._s(i[1]))])
    })], 2)])])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.showEasyPatch !== 'easysense') ? _c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "tit1e"
  }, [_c('span', [_vm._v("  " + _vm._s(_vm.$t('bolus')))])]), _vm._v(" "), (_vm.showEasyPatch === 'PDM') ? _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Maximum Bolus')) + ": " + _vm._s(_vm.bolus.max_bolus) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Bolus Increment')) + ": " + _vm._s(_vm.bolus.bolus_step) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Bolus Calculator')) + ": " + _vm._s(_vm.bolus.bolus_wizard))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Combo/Ext Bolus')) + ": " + _vm._s(_vm.bolus.extent_option))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('BG Reminder')) + ": " + _vm._s(_vm.bolus.bg_reminder))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Active Insulin Time')) + ": " + _vm._s(_vm.bolus.ins_active_time) + " ")])])])]) : _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Maximum Bolus')) + ": " + _vm._s(_vm.bolus.max_bolus) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Bolus Calculator')) + ": " + _vm._s(_vm.bolus.bolus_wizard))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Active Insulin Time')) + ": " + _vm._s(_vm.bolus.ins_active_time) + " ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('IC Ratios')) + "(g/" + _vm._s(_vm.$t('ins_unit2')) + ")")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Start')))]), _vm._l((_vm.IcRatio), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('carbs')))]), _vm._l((_vm.IcRatio), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[1]))])
  }), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', [_vm._v("--")])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('Insulin Sensitivity')) + " " + _vm._s(_vm.unit))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Start')))]), _vm._l((_vm.ins_sen), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('BG')))]), _vm._l((_vm.ins_sen), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[1]))])
  }), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', [_vm._v("--")])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('BG Target')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('From')))]), _vm._l((_vm.bg_target), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Range')))]), _vm._l((_vm.bg_target), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[1]))])
  }), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', [_vm._v("--")])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('Bolus Reminder')) + " " + _vm._s(_vm.maxBolOption))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('From')))]), _vm._v(" "), _vm._l((_vm.bolus_rem), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _vm._v(" "), (_vm.bolus_rem.length < 3) ? _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]) : _vm._e(), _vm._v(" "), (_vm.bolus_rem.length < 2) ? _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]) : _vm._e(), _vm._v(" "), (_vm.bolus_rem.length < 1) ? _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")]) : _vm._e()], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _vm._l((_vm.bolus_rem), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[1]))])
  }), _vm._v(" "), (_vm.bolus_rem.length < 3) ? _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]) : _vm._e(), _vm._v(" "), (_vm.bolus_rem.length < 2) ? _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]) : _vm._e(), _vm._v(" "), (_vm.bolus_rem.length < 1) ? _c('td', [_vm._v("--")]) : _vm._e()], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.showEasyPatch === 'PDM') ? _c('div', [_c('div', {
    staticClass: "part part1"
  }, [_c('div', {
    staticClass: "tit1e"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('pdm')))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Audio Options')) + ": " + _vm._s(_vm.userset.alarm_type))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Patch Expiration')) + ":" + _vm._s(_vm.userset.patch_expire_alarm))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Sensor Expiration')) + ": " + _vm._s(_vm.userset.sensor_expire_option))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Low Reservoir')) + ": " + _vm._s(_vm.userset.low_reservoir_time))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Auto Off')) + ": " + _vm._s(_vm.userset.auto_off_option))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Confidence Reminder')) + ": " + _vm._s(_vm.userset.cmd_response))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Hourly Max')) + ": " + _vm._s(_vm.userset.hour_bolus_max) + _vm._s(_vm.$t('ins_unit2')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Daily Max')) + ": " + _vm._s(_vm.userset.day_bolus_max) + _vm._s(_vm.$t('ins_unit2')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Low Suspend')) + ": " + _vm._s(_vm.userset.suspend_on_lowbg_option))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Predictive Low Suspend')) + ": " + _vm._s(_vm.userset.pre_suspend_on_lowbg_option))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1102_Out_of_Range')) + ": " + _vm._s(_vm.userset.out_of_range_option) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Auto_Mode_Feature')) + ": " + _vm._s(_vm.userset.auto_basal.autobasalflag) + " ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Time Format')) + ": " + _vm._s(_vm.userset.time_style))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('uername')) + ": " + _vm._s(_vm.userset.user_name))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Dispay Settings (Screen)')) + ": " + _vm._s(_vm.userset.screen_timeout) + _vm._s(_vm.$t('Sec')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Dispay Settings (Backlight)')) + ": " + _vm._s(_vm.userset.screen_timeout) + _vm._s(_vm.$t('Sec')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Device Options（CGM System)')) + ": " + _vm._s(_vm.userset.cgms_module_flag))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Device Options（Insulin Pump)')) + ": " + _vm._s(_vm.userset.pump_module_flag))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Glucose Unit')) + ": " + _vm._s(_vm.userset.glucose_unit))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Alarm Clock')) + " : " + _vm._s(_vm.userset.clock_option))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Telephone')) + ": " + _vm._s(_vm.userset.telephone))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('Alarm Clock')) + " (" + _vm._s(_vm.userset.clock_option) + ")")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('time')))]), _vm._v(" "), _vm._l((_vm.userset.clock), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._l((_vm.userset.clock), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[1]))])
  }), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', [_vm._v("--")])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "tit1e"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('CGM')))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "spe-text"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Glucose Alerts')) + ":  " + _vm._s(_vm.cgm.sensor_alarm_option))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Alert Silence')) + ":  " + _vm._s(_vm.cgm.alarm_silent_option))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('Glucose Limits')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('From')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Low')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[1]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('High')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[2]))])
  }), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', [_vm._v("--")])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('Predicitive Alerts')) + " (hh:mm)")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('high1')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.high[0]))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.high[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('low1')))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.low[0]))]), _c('td', [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.low[1]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('Rate Alerts')) + " (" + _vm._s(_vm.unit1) + "/min)")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Rise')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.rise[0]))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.rise[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Fall')))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.fall[0]))]), _c('td', [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.fall[1]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('Snooze')) + " (hh:mm)")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('high1')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_alarm_repeat.high[0]))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_alarm_repeat.high[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('low1')))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_alarm_repeat.low[0]))]), _c('td', [_vm._v(_vm._s(_vm.cgm.sensor_alarm_repeat.low[1]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics middle-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('calib')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Calibration Reminder')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_alarm_settings.calib_remind_option))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_alarm_settings.calib_remind_time))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Calibration Repeat')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_alarm_settings.calib_remind_interval))]), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Graph Range')))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_alarm_settings.trend_time_scope) + "H")]), _c('td')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "tit1e"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('t1222_Auto_Mode')))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "spe-text"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('t1222_Auto_Mode')) + ":  " + _vm._s(_vm.userset.auto_basal.autobasalflag))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Target_SG')) + ": " + _vm._s(_vm.userset.auto_basal.BGTarget))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Auto_Meal_Handling')) + ": " + _vm._s(_vm.userset.auto_basal.nFoodFlag))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('weight')) + ": " + _vm._s(_vm.userset.auto_basal.AutoBasalWeight === 0 ? '--' : _vm.userset.auto_basal.AutoBasalWeight + 'kg') + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Total_Daily_Dose')) + ": " + _vm._s(_vm.userset.auto_basal.AutoBasalTDD === 0 ? '--' : _vm.userset.auto_basal.AutoBasalTDD + 'U') + " ")]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }), _vm._v(" "), _c('td', {
    staticClass: "td3"
  })])])])])])]) : _vm._e(), _vm._v(" "), (_vm.showEasyPatch === 'easypatch') ? _c('div', [_c('div', {
    staticClass: "part part1"
  }, [_c('div', {
    staticClass: "tit1e"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('Pump')))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1108_Pump_Bash_SN')) + ": " + _vm._s(_vm.pumpSN))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Patch Expiration')) + ":" + _vm._s(_vm.userset.patch_expire_alarm))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Low Reservoir')) + ": " + _vm._s(_vm.userset.low_reservoir_time))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1102_Out_of_Range')) + ": " + _vm._s(_vm.userset.out_of_range_option))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1102_Command_Reminder')) + ": " + _vm._s(_vm.userset.cmd_response))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Auto Off')) + ": " + _vm._s(_vm.userset.auto_off_option))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Daily Max')) + ": " + _vm._s(_vm.userset.day_bolus_max) + _vm._s(_vm.$t('ins_unit2')))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Hourly Max')) + ": " + _vm._s(_vm.userset.hour_bolus_max) + _vm._s(_vm.$t('ins_unit2')))]), _vm._v(" "), _c('td', {})])])]), _vm._v(" "), _c('div', {
    staticClass: "small-table-wrap"
  }, [_c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alarms_Alerts_on_APP')) + " ")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Audio')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t(_vm.userset.pump_alarm_audio_option)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Vibrate')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t(_vm.userset.pump_alarm_vibrate_option)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Pump_Light')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.$t(_vm.userset.easypatch_pump_light)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alarms_on_App')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.userset.easypatch_pump_alarm_repeat))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Snooze')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.userset.easypatch_pump_alarm_snooze))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userset.easypatch_pump_alarm_tone.split('.')[0]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alerts_on_App')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.userset.easypatch_pump_alert_repeat))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Snooze')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.userset.easypatch_pump_alert_snooze))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userset.easypatch_pump_alert_tone.split('.')[0]))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "tit1e"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('CGM')))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1108_Transmitter_SN')) + ": " + _vm._s(_vm.tranSN))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Sensor Expiration')) + ":" + _vm._s(_vm.userset.sensor_expire_option))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Glucose Alerts')) + ": " + _vm._s(_vm.cgm.sensor_alarm_option))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1102_Factory_Calibration')) + ": " + _vm._s(_vm.$t(_vm.userset.factory_calibration_option)))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }), _vm._v(" "), _c('td', {
    staticClass: "td3"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('Glucose Limits')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('From')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Low')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[1]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('High')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[2]))])
  }), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', [_vm._v("--")])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "table-group-wrap1"
  }, [_c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('Predicitive Alerts')) + " (hh:mm)")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('high1')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.high[0]))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.high[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('low1')))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.low[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.low[1]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('Rate Alerts')) + " (" + _vm._s(_vm.unit1) + "/min)")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Rise')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.rise[0]))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.rise[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Fall')))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.fall[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.fall[1]))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-group-wrap1"
  }, [_c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alerts_for_Low')) + " ")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_low_repeat))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Snooze')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_low_snooze))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_low_tone))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alerts_for_High')) + " ")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_high_repeat))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Snooze')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_high_snooze))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_high_tone))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alerts_for_Others')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_other_repeat))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Snooze')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_other_snooze))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_other_tone))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1029_Alerts_for_Hypo')) + " ")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_hypo_tone))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "tit1e"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('APP')))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Name')) + ": " + _vm._s(_vm.userset.user_name))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Audio Options')) + ": " + _vm._s(_vm.userset.alarm_type))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Glucose Unit')) + ": " + _vm._s(_vm.userset.glucose_unit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Weight_Unit')) + ": " + _vm._s(_vm.userset.easypatch_weight_unit))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Height_Unit')) + ": " + _vm._s(_vm.userset.easypatch_height_unit))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "tit1e"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('EasyLoop')))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Low Suspend')) + ": " + _vm._s(_vm.userset.suspend_on_lowbg_option))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Predictive Low Suspend')) + ":  " + _vm._s(_vm.userset.pre_suspend_on_lowbg_option))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "tit1e"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('t1222_Auto_Mode')))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "spe-text"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('t1222_Auto_Mode')) + ":  " + _vm._s(_vm.userset.auto_basal.autobasalflag))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Target_SG')) + ": " + _vm._s(_vm.userset.auto_basal.BGTarget))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Auto_Meal_Handling')) + ": " + _vm._s(_vm.userset.auto_basal.nFoodFlag))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('weight')) + ": " + _vm._s(_vm.userset.auto_basal.AutoBasalWeight) + " kg ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Total_Daily_Dose')) + ": " + _vm._s(_vm.userset.auto_basal.AutoBasalTDD) + " U")]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }), _vm._v(" "), _c('td', {
    staticClass: "td3"
  })])])])])])]) : _vm._e(), _vm._v(" "), (_vm.showEasyPatch === 'easysense') ? _c('div', [_c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "tit1e"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('CGM')))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1108_Transmitter_SN')) + ": " + _vm._s(_vm.tranSN))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Sensor Expiration')) + ":" + _vm._s(_vm.userset.sensor_expire_option))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Glucose Alerts')) + ": " + _vm._s(_vm.cgm.sensor_alarm_option))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1102_Factory_Calibration')) + ": " + _vm._s(_vm.$t(_vm.userset.factory_calibration_option)))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }), _vm._v(" "), _c('td', {
    staticClass: "td3"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('Glucose Limits')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('From')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Low')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[1]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('High')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[2]))])
  }), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', [_vm._v("--")])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "table-group-wrap1"
  }, [_c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('Predicitive Alerts')) + " (hh:mm)")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('high1')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.high[0]))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.high[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('low1')))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.low[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.low[1]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('Rate Alerts')) + " (" + _vm._s(_vm.unit1) + "/min)")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Rise')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.rise[0]))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.rise[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Fall')))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.fall[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.fall[1]))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "table-group-wrap1"
  }, [_c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alerts_for_Low')) + " ")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_low_repeat))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Snooze')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_low_snooze))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_low_tone))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alerts_for_High')) + " ")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_high_repeat))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Snooze')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_high_snooze))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_high_tone))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alerts_for_Others')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_other_repeat))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Snooze')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_other_snooze))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_other_tone))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1029_Alerts_for_Hypo')) + " ")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_hypo_tone))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "tit1e"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('APP')))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Name')) + ": " + _vm._s(_vm.userset.user_name))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Audio Options')) + ": " + _vm._s(_vm.userset.alarm_type))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Glucose Unit')) + ": " + _vm._s(_vm.userset.glucose_unit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Weight_Unit')) + ": " + _vm._s(_vm.userset.easypatch_weight_unit))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Height_Unit')) + ": " + _vm._s(_vm.userset.easypatch_height_unit))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  })])])])])])]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.typeChooseVisible,
      "size": _vm.dialogSize,
      "id": "dialog-form2",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.typeChooseVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('DeviceSetting')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(21)
    },
    on: {
      "click": _vm.cancel
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('div', {
    staticClass: "time-range"
  }, [_c('p', {
    staticStyle: {
      "margin-right": "35%"
    }
  }, [_vm._v(_vm._s(_vm.$t('time')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Source')))])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  }), _vm._v(" "), _c('table', {
    staticClass: "pdm",
    attrs: {
      "id": "pdm"
    }
  }, _vm._l((_vm.PDM), function(item, index) {
    return _c('tr', [_c('td', {
      staticClass: "select"
    }, [_c('label', {
      class: {
        'no': item[0] == _vm.tempSelectId
      },
      attrs: {
        "id": item[0]
      },
      on: {
        "click": _vm.choose
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item[1]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item[2]))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "patientList-block"
  }, [_c('img', {
    class: {
      'click1': !_vm.has_prev
    },
    attrs: {
      "src": __webpack_require__(1297)
    },
    on: {
      "click": _vm.prevPage
    }
  }), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.page),
      expression: "page"
    }],
    domProps: {
      "value": (_vm.page)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && $event.keyCode !== 13) { return null; }
        _vm.go($event)
      },
      "blur": _vm.go,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.page = $event.target.value
      }
    }
  }), _vm._v(" of   " + _vm._s(_vm.pages))]), _vm._v(" "), _c('img', {
    class: {
      'click1': !_vm.has_next
    },
    attrs: {
      "src": __webpack_require__(1296)
    },
    on: {
      "click": _vm.nextPage
    }
  })]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    on: {
      "click": _vm.apply
    }
  }, [_vm._v(_vm._s(_vm.$t('Apply')))]), _vm._v(" "), _c('button', {
    staticClass: "cancelButton",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "chart-container"
  }, [_c('div', {
    staticClass: "Hcp-main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Segment Analysis')))])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('button', {
    on: {
      "click": _vm.print
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('print')))])]), _vm._v(" "), _c('button', {
    staticClass: "set",
    on: {
      "click": _vm.open
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('set')))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('period')) + ":"), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.timeRange2))])])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr spe-hr"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": "Loading"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart1_1"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "bolCount"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('# of Boluses')))]), _vm._v(" "), _c('table', {
    staticClass: "countLabel"
  }, [_c('tr', {
    attrs: {
      "id": "count"
    }
  }, _vm._l((48), function(i) {
    return _c('td')
  }))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart1_3"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart1_2"
    }
  })])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.typeChooseVisible,
      "size": _vm.dialogSize,
      "id": "dialog-form2",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.typeChooseVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('setPeriod')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(21)
    },
    on: {
      "click": _vm.cancel
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('div', {
    staticClass: "duration"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('duration')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeType),
      expression: "timeType"
    }],
    attrs: {
      "id": "duration"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.timeType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.timeChange]
    }
  }, [_c('option', [_vm._v(_vm._s(_vm.$t('7 days')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('14 days')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('30 days')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('90 days')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('Customize')))])])]), _vm._v(" "), _c('div', {
    staticClass: "time-range",
    class: {
      'zh2': !_vm.isEn
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('From')))]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.custo),
      expression: "!custo"
    }]
  }, [_vm._v(_vm._s(_vm.staTime))]), _vm._v(" "), _c('el-date-picker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.custo),
      expression: "custo"
    }],
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.staTime,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value4),
      callback: function($$v) {
        _vm.value4 = $$v
      },
      expression: "value4"
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.endTime,
      "format": "dd-MM-yyyy"
    },
    on: {
      "change": _vm.timeChange
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1)]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    on: {
      "click": _vm.dateApply
    }
  }, [_vm._v(_vm._s(_vm.$t('applyM')))]), _vm._v(" "), _c('button', {
    staticClass: "cancelButton",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "events"
  }, [_c('div', {
    staticClass: "events-container"
  }, [_c('div', {
    staticClass: "operate"
  }, [_c('button', {
    attrs: {
      "id": "danger"
    },
    on: {
      "click": _vm.delete2
    }
  }, [_vm._v(_vm._s(_vm.$t('Delete')))]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.create
    }
  }, [_vm._v(_vm._s(_vm.$t('Create')))]), _vm._v(" "), _c('button', {
    staticClass: "print",
    on: {
      "click": _vm.print
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('button', {
    staticClass: "set",
    on: {
      "click": _vm.open
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('set')))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('period')) + ":"), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.timeRange))])])]), _vm._v(" "), (true) ? _c('div', [_c('div', {
    staticClass: "patient-table"
  }, [_c('table', {
    attrs: {
      "id": "patientList"
    }
  }, [_c('tr', {
    staticClass: "header"
  }, [_c('td', {
    staticClass: "checkbox"
  }, [_c('input', {
    staticClass: "checkbox22",
    attrs: {
      "type": "checkbox",
      "id": "checkbox1"
    }
  }), _c('label', {
    attrs: {
      "for": "checkbox1"
    },
    on: {
      "click": _vm.chooseAll
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('time'))), _c('div', {
    staticClass: "order",
    class: {
      'order1': !_vm.orderFlag
    },
    on: {
      "click": _vm.orderChange
    }
  })]), _c('td', [_vm._v(_vm._s(_vm.$t('Event Type')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Details')))]), _c('td', [_vm._v(_vm._s(_vm.$t('Notes')))]), _c('td', [_vm._v(_vm._s(_vm.$t('Source')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Action')))])]), _vm._v(" "), _vm._l((_vm.events), function(item, index) {
    return _c('tr', {
      class: (index % 2 === 0) ? '' : 'even',
      attrs: {
        "id": index
      }
    }, [_c('td', {
      staticClass: "checkbox"
    }, [_c('input', {
      staticClass: "checkbox22",
      attrs: {
        "type": "checkbox"
      }
    }), _c('label', {
      attrs: {
        "id": index
      },
      on: {
        "click": _vm.select
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "event-time"
    }, [_vm._v(_vm._s(item[1]))]), _c('td', {
      staticClass: "event-type"
    }, [_vm._v(_vm._s(item[2]))]), _vm._v(" "), _c('td', {
      staticClass: "event-detail"
    }, [_vm._v(_vm._s(item[3].value ? item[3].value : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item[3].note))]), _c('td', [_vm._v(_vm._s(item[4]))]), _vm._v(" "), _c('td', {
      staticClass: "operate1"
    }, [_c('span', {
      on: {
        "click": _vm.edit
      }
    }, [_vm._v(_vm._s(_vm.$t('edit')))]), _c('br'), _c('span', {
      on: {
        "click": _vm.delete1
      }
    }, [_vm._v(_vm._s(_vm.$t('Delete')))])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "patientList-block"
  }, [_c('img', {
    class: {
      'click1': !_vm.has_prev
    },
    attrs: {
      "src": __webpack_require__(121)
    },
    on: {
      "click": _vm.prevPage
    }
  }), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.page),
      expression: "page"
    }],
    domProps: {
      "value": (_vm.page)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && $event.keyCode !== 13) { return null; }
        _vm.go($event)
      },
      "blur": _vm.go,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.page = $event.target.value
      }
    }
  }), _vm._v(" of   " + _vm._s(_vm.pages))]), _vm._v(" "), _c('img', {
    class: {
      'click1': !_vm.has_next
    },
    attrs: {
      "src": __webpack_require__(120)
    },
    on: {
      "click": _vm.nextPage
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-form2",
    attrs: {
      "visible": _vm.isA,
      "size": _vm.dialogSize,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.isA = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Create')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(21)
    },
    on: {
      "click": _vm.cancel
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('div', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "date",
    class: {
      'zh2': !_vm.isEn, 'sw2': _vm.isSw, 'cz2': _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('time')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "size": "small",
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": "Date",
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  }), _vm._v(" "), _c('el-time-picker', {
    staticStyle: {
      "width": "110px",
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "Time",
      "size": "small",
      "editable": false,
      "clearable": false,
      "format": "HH:mm"
    },
    model: {
      value: (_vm.value4),
      callback: function($$v) {
        _vm.value4 = $$v
      },
      expression: "value4"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    class: {
      'es1': _vm.isEs, 'de1': _vm.isDe, 'it1': _vm.isIt, 'po1': _vm.isPo, 'du1': _vm.isDu, 'fr1': _vm.isFr
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Event Type')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.typeShow]
    }
  }, [_c('option', [_vm._v(_vm._s(_vm.$t('carbs')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('exercise')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('HbA1c1')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('Urine Ketone')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('BG1')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('Injection')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('Other')))])])]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    class: {
      'es2': _vm.isEs, 'de2': _vm.isDe, 'it2': _vm.isIt, 'po2': _vm.isPo, 'du2': _vm.isDu, 'fr2': _vm.isFr, 'sw3': _vm.isSw, 'cz3': _vm.isCz
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.type8),
      expression: "!type8"
    }]
  }, [_vm._v(_vm._s(_vm.$t('Details')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type8),
      expression: "type8"
    }]
  }, [_vm._v(_vm._s(_vm.$t('Notes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deta1),
      expression: "deta1"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.type1),
      expression: "type1"
    }],
    class: {
      'vuerify-invalid': _vm.Tr1
    },
    attrs: {
      "type": "text",
      "placeholder": "(1-300)",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.deta1)
    },
    on: {
      "blur": function($event) {
        _vm.check(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deta1 = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type1),
      expression: "type1"
    }],
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("g")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deta2),
      expression: "deta2"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.type2),
      expression: "type2"
    }],
    staticClass: "spe-select spe-select1",
    class: {
      'es4': _vm.isEs, 'de4': _vm.isDe, 'it4': _vm.isIt, 'po4': _vm.isPo, 'du4': _vm.isDu, 'fr4': _vm.isFr, 'sw4': _vm.isSw, 'cz4': _vm.isCz
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.deta2 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Light")]), _vm._v(" "), _c('option', [_vm._v("Medium")]), _vm._v(" "), _c('option', [_vm._v("Heavy")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.EXEtime),
      expression: "EXEtime"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.type2),
      expression: "type2"
    }],
    staticClass: "exe1",
    class: {
      'vuerify-invalid': _vm.Tr2
    },
    attrs: {
      "placeholder": "(5-480)",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.EXEtime)
    },
    on: {
      "blur": function($event) {
        _vm.check(2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.EXEtime = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type2),
      expression: "type2"
    }],
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("min")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deta3),
      expression: "deta3"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.type3),
      expression: "type3"
    }],
    class: {
      'vuerify-invalid': _vm.Tr3
    },
    attrs: {
      "type": "text",
      "placeholder": "(3.3-19.9)",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.deta3)
    },
    on: {
      "blur": function($event) {
        _vm.check(3)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deta3 = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type3),
      expression: "type3"
    }],
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("%")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deta4),
      expression: "deta4"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.type4),
      expression: "type4"
    }],
    staticClass: "spe-select1",
    class: {
      'es4': _vm.isEs, 'de4': _vm.isDe, 'it4': _vm.isIt, 'po4': _vm.isPo, 'du4': _vm.isDu, 'fr4': _vm.isFr, 'sw4': _vm.isSw, 'cz4': _vm.isCz
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.deta4 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Negative")]), _vm._v(" "), _c('option', [_vm._v("Macro")]), _vm._v(" "), _c('option', [_vm._v("+")]), _vm._v(" "), _c('option', [_vm._v("++")]), _vm._v(" "), _c('option', [_vm._v("+++")]), _vm._v(" "), _c('option', [_vm._v("++++")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deta5),
      expression: "deta5"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.type5),
      expression: "type5"
    }],
    class: {
      'vuerify-invalid': _vm.Tr5
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.bgRange,
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.deta5)
    },
    on: {
      "blur": function($event) {
        _vm.check(5)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deta5 = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type5),
      expression: "type5"
    }],
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.unit))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deta6),
      expression: "deta6"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.type6),
      expression: "type6"
    }],
    class: {
      'vuerify-invalid': _vm.Tr6
    },
    attrs: {
      "type": "text",
      "placeholder": "(0.1-99.0)",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.deta6)
    },
    on: {
      "blur": function($event) {
        _vm.check(6)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deta6 = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type6),
      expression: "type6"
    }],
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("U")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deta7),
      expression: "deta7"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.type8),
      expression: "type8"
    }],
    class: {
      'vuerify-invalid': _vm.Tr7, 'es3': _vm.isEs, 'de3': _vm.isDe, 'it6': _vm.isIt, 'po6': _vm.isPo, 'du6': _vm.isDu, 'fr6': _vm.isFr, 'sw7': _vm.isSw, 'cz7': _vm.isCz
    },
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip,
      "maxlength": "40"
    },
    domProps: {
      "value": (_vm.deta7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deta7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.type8),
      expression: "!type8"
    }],
    staticClass: "cont"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Notes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note),
      expression: "note"
    }],
    staticClass: "notes",
    class: {
      'zh3': !_vm.isEn, 'es6': _vm.isEs || _vm.isDe, 'du3': _vm.isDu, 'fr6': _vm.isFr, 'sw6': _vm.isSw, 'cz6': _vm.isCz
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip,
      "maxlength": "40"
    },
    domProps: {
      "value": (_vm.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    class: {
      'sw9': _vm.isSw || _vm.isCz
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "26px"
    }
  }, [_vm._v(_vm._s(_vm.$t('Source')))]), _vm._v(" "), _c('span', {
    staticClass: "source"
  }, [_vm._v("Web")])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    on: {
      "click": _vm.newEvents
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))]), _vm._v(" "), _c('button', {
    staticClass: "cancelButton",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-form2",
    attrs: {
      "visible": _vm.isB,
      "size": _vm.dialogSize,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.isB = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('edit')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(21)
    },
    on: {
      "click": _vm.cancel2
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('div', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "date",
    class: {
      'zh2': !_vm.isEn, 'sw2': _vm.isSw, 'cz2': _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('time')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "size": "small",
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.time[0],
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value5),
      callback: function($$v) {
        _vm.value5 = $$v
      },
      expression: "value5"
    }
  }), _vm._v(" "), _c('el-time-picker', {
    staticStyle: {
      "width": "110px",
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": _vm.time[1],
      "size": "small",
      "editable": false,
      "clearable": false,
      "format": "HH:mm"
    },
    model: {
      value: (_vm.value6),
      callback: function($$v) {
        _vm.value6 = $$v
      },
      expression: "value6"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    class: {
      'es1': _vm.isEs, 'de1': _vm.isDe, 'it1': _vm.isIt, 'po1': _vm.isPo, 'du1': _vm.isDu, 'fr1': _vm.isFr
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Event Type')))]), _vm._v(" "), _c('span', {
    staticClass: "eveType",
    class: {
      'es8': _vm.isEs, 'de8': _vm.isDe, 'it8': _vm.isIt, 'po8': _vm.isPo, 'du8': _vm.isDu, 'fr8': _vm.isFr
    }
  }, [_vm._v(_vm._s(_vm.event[2]))])]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    class: {
      'es2': _vm.isEs, 'de2': _vm.isDe, 'de7': _vm.isDe || _vm.isIt || _vm.isPo || _vm.isDu || _vm.isFr || _vm.isEs, 'it2': _vm.isIt, 'po2': _vm.isPo, 'du2': _vm.isDu, 'fr2': _vm.isFr, 'sw3': _vm.isSw, 'cz3': _vm.isCz
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.edType8),
      expression: "!edType8"
    }]
  }, [_vm._v(_vm._s(_vm.$t('Details')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.edType8),
      expression: "edType8"
    }]
  }, [_vm._v(_vm._s(_vm.$t('Notes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eDetail1),
      expression: "eDetail1"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.edType1),
      expression: "edType1"
    }],
    class: {
      'vuerify-invalid': _vm.Tr1
    },
    attrs: {
      "type": "text",
      "placeholder": "(1-300)",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.eDetail1)
    },
    on: {
      "blur": function($event) {
        _vm.edCheck(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.eDetail1 = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.edType1),
      expression: "edType1"
    }],
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("g")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eDetail2),
      expression: "eDetail2"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.edType2),
      expression: "edType2"
    }],
    staticClass: "spe-select spe-select1",
    class: {
      'es4': _vm.isEs, 'de4': _vm.isDe, 'it4': _vm.isIt, 'po4': _vm.isPo, 'du4': _vm.isDu, 'fr4': _vm.isFr, 'sw4': _vm.isSw, 'cz4': _vm.isCz
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.eDetail2 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Light")]), _vm._v(" "), _c('option', [_vm._v("Medium")]), _vm._v(" "), _c('option', [_vm._v("Heavy")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edEXEtime),
      expression: "edEXEtime"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.edType2),
      expression: "edType2"
    }],
    staticClass: "exe1",
    class: {
      'vuerify-invalid': _vm.Tr2
    },
    attrs: {
      "placeholder": "(5-480)",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.edEXEtime)
    },
    on: {
      "blur": function($event) {
        _vm.edCheck(2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edEXEtime = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.edType2),
      expression: "edType2"
    }],
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("min")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eDetail3),
      expression: "eDetail3"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.edType3),
      expression: "edType3"
    }],
    class: {
      'vuerify-invalid': _vm.Tr3
    },
    attrs: {
      "type": "text",
      "placeholder": "(3.3-19.9)",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.eDetail3)
    },
    on: {
      "blur": function($event) {
        _vm.edCheck(3)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.eDetail3 = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.edType3),
      expression: "edType3"
    }],
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("%")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eDetail4),
      expression: "eDetail4"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.edType4),
      expression: "edType4"
    }],
    staticClass: "spe-select1",
    class: {
      'es4': _vm.isEs, 'de4': _vm.isDe, 'it4': _vm.isIt, 'po4': _vm.isPo, 'du4': _vm.isDu, 'fr4': _vm.isFr, 'sw4': _vm.isSw, 'cz4': _vm.isCz
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.eDetail4 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Negative")]), _vm._v(" "), _c('option', [_vm._v("Macro")]), _vm._v(" "), _c('option', [_vm._v("+")]), _vm._v(" "), _c('option', [_vm._v("++")]), _vm._v(" "), _c('option', [_vm._v("+++")]), _vm._v(" "), _c('option', [_vm._v("++++")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eDetail5),
      expression: "eDetail5"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.edType5),
      expression: "edType5"
    }],
    class: {
      'vuerify-invalid': _vm.Tr5
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.bgRange,
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.eDetail5)
    },
    on: {
      "blur": function($event) {
        _vm.edCheck(5)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.eDetail5 = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.edType5),
      expression: "edType5"
    }],
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.unit))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eDetail6),
      expression: "eDetail6"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.edType6),
      expression: "edType6"
    }],
    class: {
      'vuerify-invalid': _vm.Tr6
    },
    attrs: {
      "type": "text",
      "placeholder": "(0.1-99.0)",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.eDetail6)
    },
    on: {
      "blur": function($event) {
        _vm.edCheck(6)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.eDetail6 = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.edType6),
      expression: "edType6"
    }],
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("U")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eDetail7),
      expression: "eDetail7"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.edType8),
      expression: "edType8"
    }],
    class: {
      'vuerify-invalid': _vm.Tr7, 'es3': _vm.isEs, 'de3': _vm.isDe, 'it6': _vm.isIt, 'po6': _vm.isPo, 'du6': _vm.isDu, 'fr6': _vm.isFr, 'sw7': _vm.isSw, 'cz7': _vm.isCz
    },
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip,
      "maxlength": "40"
    },
    domProps: {
      "value": (_vm.eDetail7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.eDetail7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.edType8),
      expression: "!edType8"
    }],
    staticClass: "cont"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Notes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eNote),
      expression: "eNote"
    }],
    staticClass: "notes",
    class: {
      'zh3': !_vm.isEn, 'es6': _vm.isEs, 'de6': _vm.isDe, 'du3': _vm.isDu, 'fr6': _vm.isFr, 'sw6': _vm.isSw, 'cz6': _vm.isCz
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip,
      "maxlength": "40"
    },
    domProps: {
      "value": (_vm.eNote)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.eNote = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    class: {
      'sw9': _vm.isSw || _vm.isCz
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "26px"
    }
  }, [_vm._v(_vm._s(_vm.$t('Source')))]), _vm._v(" "), _c('span', {
    staticClass: "source"
  }, [_vm._v("Web")])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    on: {
      "click": _vm.editEvents
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))]), _vm._v(" "), _c('button', {
    staticClass: "cancelButton",
    on: {
      "click": _vm.cancel2
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.typeChooseVisible,
      "size": _vm.dialogSize,
      "id": "dialog-form2",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.typeChooseVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('setPeriod')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(21)
    },
    on: {
      "click": _vm.cancelSet
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('div', {
    staticClass: "select-interval-wrap"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.$t('duration')) + "  ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeRangeSelect),
      expression: "timeRangeSelect"
    }],
    staticClass: "select-timerange",
    attrs: {
      "id": "timeRangeSelect"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.timeRangeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.procTimeRangeSelect]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('7 days')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('14 days')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('30 days')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v(_vm._s(_vm.$t('90 days')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('Customized')))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Event Filter')) + "：")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eventTypeSelect),
      expression: "eventTypeSelect"
    }],
    staticClass: "select-interval",
    attrs: {
      "id": "timeIntervalSelect"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.eventTypeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.procEventTypeSelect]
    }
  }, [_c('option', {
    attrs: {
      "value": "ALL"
    }
  }, [_vm._v(_vm._s(_vm.$t('All')))]), _c('option', {
    attrs: {
      "value": "CARB"
    }
  }, [_vm._v(_vm._s(_vm.$t('carbs')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EXR"
    }
  }, [_vm._v(_vm._s(_vm.$t('exercise')))]), _c('option', {
    attrs: {
      "value": "HBA1C"
    }
  }, [_vm._v(_vm._s(_vm.$t('HbA1c1')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "URINEK"
    }
  }, [_vm._v(_vm._s(_vm.$t('Urine Ketone')))]), _c('option', {
    attrs: {
      "value": "BG"
    }
  }, [_vm._v(_vm._s(_vm.$t('BG1')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "INS"
    }
  }, [_vm._v(_vm._s(_vm.$t('Injection')))]), _c('option', {
    attrs: {
      "value": "OTR"
    }
  }, [_vm._v(_vm._s(_vm.$t('Other')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "time-range",
    class: {
      'zh2': !_vm.isEn
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('From')))]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "disabled": _vm.startDateDisable,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.startDate,
      "format": "dd-MM-yyyy"
    },
    on: {
      "change": _vm.startDateChange
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate,
      "format": "dd-MM-yyyy"
    },
    on: {
      "change": _vm.endDateChange
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1)]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    on: {
      "click": _vm.dateApply
    }
  }, [_vm._v(_vm._s(_vm.$t('applyM')))]), _vm._v(" "), _c('button', {
    staticClass: "cancelButton",
    on: {
      "click": _vm.cancelSet
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "chart-container"
  }, [_c('div', {
    staticClass: "Hcp-main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Alerts')))])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('button', {
    on: {
      "click": _vm.print
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('print')))])]), _vm._v(" "), _c('button', {
    staticClass: "set",
    on: {
      "click": _vm.open
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('set')))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('period')) + ":"), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.timeRangeDisplay))])])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr spe-hr"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.haveData),
      expression: "!haveData"
    }],
    staticClass: "no-data"
  }, [_vm._v(_vm._s(_vm.$t('No data')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveData),
      expression: "haveData"
    }],
    staticClass: "patient-table"
  }, [_c('table', {
    attrs: {
      "id": "patientList"
    }
  }, [_c('tr', {
    staticClass: "header"
  }, [_c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('time'))), _c('div', {
    staticClass: "order"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('type')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('alert')))])]), _vm._v(" "), _vm._l((_vm.alerts), function(item, index) {
    return _c('tr', {
      class: (index % 2 === 0) ? '' : 'even',
      attrs: {
        "id": index
      }
    }, [_c('td', {
      staticClass: "event-time"
    }, [_vm._v(_vm._s(item[0]))]), _vm._v(" "), _c('td', {
      staticClass: "event-type"
    }, [_vm._v(_vm._s(item[3]))]), _vm._v(" "), _c('td', {
      staticClass: "event-detail"
    }, [_vm._v(_vm._s(item[1]))])])
  })], 2)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.typeChooseVisible,
      "size": _vm.dialogSize,
      "id": "dialog-form2",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.typeChooseVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('setPeriod')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(21)
    },
    on: {
      "click": _vm.cancel
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('div', {
    staticClass: "duration"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('duration')) + ":")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeRangeSelect),
      expression: "timeRangeSelect"
    }],
    attrs: {
      "id": "duration"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.timeRangeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.procTimeRangeSelect]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('7 days')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('14 days')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('30 days')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v(_vm._s(_vm.$t('90 days')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('Customize')))])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t('Alert Filter')) + ":")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alertTypeSelect),
      expression: "alertTypeSelect"
    }],
    staticClass: "select-interval",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.alertTypeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.procAlertTypeSelect]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('PDM')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('Pump')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('CGM')))])])]), _vm._v(" "), _c('div', {
    staticClass: "time-range",
    class: {
      'zh2': !_vm.isEn
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('From')))]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.customDaySpan),
      expression: "!customDaySpan"
    }]
  }, [_vm._v(_vm._s(_vm.startDateText))]), _vm._v(" "), _c('el-date-picker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.customDaySpan),
      expression: "customDaySpan"
    }],
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.startDatePlaceholder,
      "format": "dd-MM-yyyy"
    },
    on: {
      "change": _vm.startDateChange
    },
    model: {
      value: (_vm.startDateValue),
      callback: function($$v) {
        _vm.startDateValue = $$v
      },
      expression: "startDateValue"
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.endDatePlaceholder,
      "format": "dd-MM-yyyy"
    },
    on: {
      "change": _vm.endDateChange
    },
    model: {
      value: (_vm.endDateValue),
      callback: function($$v) {
        _vm.endDateValue = $$v
      },
      expression: "endDateValue"
    }
  })], 1)]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    on: {
      "click": _vm.dateApply
    }
  }, [_vm._v(_vm._s(_vm.$t('applyM')))]), _vm._v(" "), _c('button', {
    staticClass: "cancelButton",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1428 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#ffffff"
    }
  }, [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.exportPDF()
      }
    }
  }, [_vm._v(" 导出")]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "graphList"
  }, [_c('div', {
    staticClass: "graph",
    attrs: {
      "id": "AGPgraph"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "graph",
    attrs: {
      "id": "AGP19graph"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "graph",
    attrs: {
      "id": "TIRComparison"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "graph",
    attrs: {
      "id": "TBRComparison"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "graph",
    attrs: {
      "id": "TIRDistribution"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "graph",
    attrs: {
      "id": "A1CDistribution"
    }
  })])
}]}

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "chart-container",
    class: {
      'chart-container-spe1': _vm.isA
    }
  }, [_c('div', {
    staticClass: "Hcp-main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('dayByday')))])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('button', {
    on: {
      "click": _vm.print
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('print')))])]), _vm._v(" "), _c('button', {
    staticClass: "set",
    on: {
      "click": _vm.open
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('set')))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('period')) + ":"), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.timeRange2))])])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr spe-hr"
  }), _vm._v(" "), _c('div', _vm._l((_vm.date), function(day, index) {
    return _c('div', {
      key: day,
      staticClass: "chart-item2",
      class: {
        'spe-item2': (index % 3 !== 0)
      }
    }, [_c('div', {
      staticClass: "date date-spe3"
    }, [_c('span', [_vm._v(_vm._s(day))])]), _vm._v(" "), _c('div', {
      staticClass: "eat-label eat-spe3",
      class: [_vm.isPo || _vm.isFr ? 'eat-spe3-po' : 'eat-spe3']
    }, [_c('p', {
      class: [_vm.isPo ? 'eat-label-spe1-po' : _vm.isFr ? 'eat-label-spe1-fo' : 'eat-label-spe1']
    }, [_vm._v(_vm._s(_vm.titleText))]), _vm._v(" "), _c('p', {
      class: [_vm.isPo || _vm.isFr ? 'eat-label-spe2-po' : 'eat-label-spe2']
    }, [_vm._v(_vm._s(_vm.$t('Breakfast')))]), _vm._v(" "), _c('p', {
      class: [_vm.isPo ? 'eat-label-spe3-po' : _vm.isFr ? 'eat-label-spe3-fo' : _vm.isEn ? 'eat-label-spe3-en' : 'eat-label-spe3']
    }, [_vm._v(_vm._s(_vm.$t('Lunch')))]), _vm._v(" "), _c('p', {
      class: [_vm.isPo || _vm.isFr ? 'eat-label-spe4-po' : _vm.isEn ? 'eat-label-spe4-en' : 'eat-label-spe4']
    }, [_vm._v(_vm._s(_vm.$t('Dinner')))])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (index === 1 ? _vm.loading : false),
        expression: "index===1?loading:false"
      }],
      staticClass: "graph",
      staticStyle: {
        "margin-top": "35px"
      },
      attrs: {
        "id": 'sgChart' + index,
        "element-loading-text": _vm.loadingText
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "carb carb-spe2"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('carbs')) + " (g)")]), _vm._v(" "), _c('div', {
      attrs: {
        "id": 'carb' + index
      }
    }, [_vm._l((_vm.carb[index]), function(i) {
      return _c('label', {
        key: i
      }, [_vm._v(_vm._s(i[1]))])
    }), _vm._v(" "), _vm._l((_vm.autoBreakfast[index]), function(b) {
      return _c('img', {
        key: b,
        staticClass: "breakfast",
        attrs: {
          "src": "/static/legend/automode/早餐.png"
        }
      })
    }), _vm._v(" "), _vm._l((_vm.autoLunch[index]), function(b) {
      return _c('img', {
        key: b,
        staticClass: "lunch",
        attrs: {
          "src": "/static/legend/automode/中餐.png"
        }
      })
    }), _vm._v(" "), _vm._l((_vm.autoDinner[index]), function(b) {
      return _c('img', {
        key: b,
        staticClass: "dinner",
        attrs: {
          "src": "/static/legend/automode/晚餐.png"
        }
      })
    }), _vm._v(" "), _vm._l((_vm.autoSnack[index]), function(b) {
      return _c('img', {
        key: b,
        staticClass: "snack",
        attrs: {
          "src": "/static/legend/automode/零食.png"
        }
      })
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "graph",
      attrs: {
        "id": 'baChart' + index,
        "element-loading-background": "rgba(0, 0, 0, 0.8)"
      }
    })])
  }))]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "legend-group",
    class: {
      'zh5': !_vm.isEn, 'it5': _vm.isIt, 'po5': _vm.isPo, 'du5': _vm.isDu || _vm.isFr || _vm.isCz
    }
  }, [_c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(88)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('alert')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(116)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('target')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": __webpack_require__(112)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('hypo')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": __webpack_require__(105)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('sensorGlucose')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(110)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('calib')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend "
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(118)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('newSen')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(119)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('warm')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1",
    class: {
      'zh6': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(109)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('basal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1",
    class: {
      'zh7': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(117)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('tampBasal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe3",
    class: {
      'zh8': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(114)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('normalBolus')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe4",
    class: {
      'zh9': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(111)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('extendBolus')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe5",
    class: {
      'zh10': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(106)
    }
  }), _c('span', {
    staticClass: "span1"
  }, [_vm._v(_vm._s(_vm.$t('manualStop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1",
    class: {
      'zh11': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(104)
    }
  }), _c('span', {
    staticClass: "span1"
  }, [_vm._v(_vm._s(_vm.$t('autoStop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(115)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('stop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe6",
    class: {
      'zh12': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(113)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('newPatch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe7",
    class: {
      'zh13': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(143)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('carbs')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe2",
    class: {
      'zh14': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(144)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('exercise')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(142)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('BG Reading')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(71)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Breakfast')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(70)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Lunch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(72)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Dinner')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(73)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1222_Snack')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(108)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1222_auto_basal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(107)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1222_auto_bolus')))])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.typeChooseVisible,
      "size": _vm.dialogSize,
      "id": "dialog-form2",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.typeChooseVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('setPeriod')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(21)
    },
    on: {
      "click": _vm.cancel
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('div', {
    staticClass: "duration"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('duration')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeType),
      expression: "timeType"
    }],
    attrs: {
      "id": "duration"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.timeType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.procTimeRangeSelect]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('7 days')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('14 days')))])])]), _vm._v(" "), _c('div', {
    staticClass: "time-range",
    class: {
      'zh2': !_vm.isEn
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('From')))]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_c('span', [_vm._v(_vm._s(_vm.staTime))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.endTime,
      "format": "dd-MM-yyyy"
    },
    on: {
      "change": _vm.procTimeRangeSelect
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1)]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    on: {
      "click": _vm.dateApply
    }
  }, [_vm._v(_vm._s(_vm.$t('applyM')))]), _vm._v(" "), _c('button', {
    staticClass: "cancelButton",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newPatient-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Patient Profile')))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('uername')) + ":"), _c('span', [_vm._v(_vm._s(_vm.profile.username))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('alias')) + ": ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alias),
      expression: "alias"
    }],
    staticClass: "alias",
    attrs: {
      "maxlength": "15"
    },
    domProps: {
      "value": (_vm.alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.alias = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isA),
      expression: "isA"
    }]
  }, [_vm._v("Patient ID:"), _c('span', {
    staticStyle: {
      "margin-left": "36px"
    }
  }, [_vm._v("0000001")])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "content content1",
    class: {
      'sw1': _vm.isSw
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Portrait')) + ":")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.portrait
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('fullName')) + ": "), _c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.profile.realname))])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isM),
      expression: "isM"
    }],
    staticStyle: {
      "margin-left": "105px",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.Remark = true
      }
    }
  }, [_vm._v("Remark: "), _c('span', [_vm._v("Jack")])])]), _vm._v(" "), _c('div', {
    staticClass: "content content1"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('gender')) + ": "), _c('span', {
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_vm._v(_vm._s(_vm.profile.gender))])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('height'))), _c('span', [_vm._v(_vm._s(_vm.profile.height))])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('weight'))), _c('span', [_vm._v(_vm._s(_vm.profile.weight))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('birthday')) + ":"), _c('span', [_vm._v(_vm._s(_vm.profile.birthday))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "content content1 content2",
    class: {
      'sw2': _vm.isSw
    }
  }, [_c('p', {
    staticClass: "text2"
  }, [_vm._v(_vm._s(_vm.$t('disType')) + ":"), _c('span', {
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_vm._v(_vm._s(_vm.profile.diabetes_type))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('disDate')) + ":"), _c('span', [_vm._v(_vm._s(_vm.profile.date))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "content content3"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Address')) + ":"), _c('span', [_vm._v(_vm._s(_vm.profile.address))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Postcode')) + ": "), _c('span', [_vm._v(_vm._s(_vm.profile.zipcode))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Mobile')) + ":"), _c('span', [_vm._v(_vm._s(_vm.profile.mobile))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Telephone')) + ": "), _c('span', {
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_vm._v(_vm._s(_vm.profile.telephone))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Email')) + ":"), _c('span', [_vm._v(_vm._s(_vm.profile.email))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "item1"
  }, [_c('span', {
    class: {
      'es1': _vm.isEs || _vm.isDe || _vm.isPo || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('Inpatient')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.inHospital),
      expression: "profile.inHospital"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.profile.inHospital = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v(_vm._s(_vm.$t('Yes')))]), _c('option', [_vm._v(_vm._s(_vm.$t('No')))])])]), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_c('span', {
    class: {
      'po1': _vm.isPo || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('Pno')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.patientNo),
      expression: "profile.patientNo"
    }],
    domProps: {
      "value": (_vm.profile.patientNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.patientNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item1 spe-item1"
  }, [_c('span', {
    class: {
      'po1': _vm.isPo || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('Bno')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.bedNo),
      expression: "profile.bedNo"
    }],
    domProps: {
      "value": (_vm.profile.bedNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.bedNo = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('button', {
    staticClass: "cancel",
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "create",
    on: {
      "click": _vm.create
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.Remark,
      "size": "tiny",
      "id": "remark-form",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.Remark = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v("Set remark")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(21)
    },
    on: {
      "click": _vm.cancel
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('p', [_vm._v("Please input remark in the following box")]), _vm._v(" "), _c('input')]), _vm._v(" "), _c('div', {
    staticClass: "patientList-dialog-footer",
    slot: "footer"
  }, [_c('button', {
    staticClass: "confirmButton"
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('button', {
    staticClass: "cancelButton",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1431 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    key: _vm.key,
    attrs: {
      "name": "header"
    }
  }), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "footer"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-left"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag == 'patient'),
      expression: "flag=='patient'"
    }],
    attrs: {
      "href": "/#/login"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('title')))])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag == 'hcp'),
      expression: "flag=='hcp'"
    }],
    attrs: {
      "href": "/#/hcpLogin"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('title1')))])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag == 'accountsmanagement'),
      expression: "flag=='accountsmanagement'"
    }],
    attrs: {
      "href": "/#/accountsmanagement"
    }
  }, [_c('span', [_vm._v("EasyView Accounts Managment")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag == 'clinic'),
      expression: "flag=='clinic'"
    }],
    attrs: {
      "href": "/#/clinic"
    }
  }, [_c('span', [_vm._v("EasyView Clinic")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCountry),
      expression: "showCountry"
    }],
    staticClass: "header-right",
    on: {
      "click": function($event) {
        _vm.languageFormVisible = true
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[0]),
      expression: "this.$store.state.country[0]"
    }],
    attrs: {
      "src": __webpack_require__(468)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[1]),
      expression: "this.$store.state.country[1]"
    }],
    attrs: {
      "src": __webpack_require__(465)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[2]),
      expression: "this.$store.state.country[2]"
    }],
    attrs: {
      "src": __webpack_require__(469)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[3]),
      expression: "this.$store.state.country[3]"
    }],
    attrs: {
      "src": __webpack_require__(470)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[4]),
      expression: "this.$store.state.country[4]"
    }],
    attrs: {
      "src": __webpack_require__(491)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[5]),
      expression: "this.$store.state.country[5]"
    }],
    attrs: {
      "src": __webpack_require__(464)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[6]),
      expression: "this.$store.state.country[6]"
    }],
    attrs: {
      "src": __webpack_require__(472)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[7]),
      expression: "this.$store.state.country[7]"
    }],
    attrs: {
      "src": __webpack_require__(473)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[8]),
      expression: "this.$store.state.country[8]"
    }],
    attrs: {
      "src": __webpack_require__(476)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[9]),
      expression: "this.$store.state.country[9]"
    }],
    attrs: {
      "src": __webpack_require__(480)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[10]),
      expression: "this.$store.state.country[10]"
    }],
    attrs: {
      "src": __webpack_require__(481)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[11]),
      expression: "this.$store.state.country[11]"
    }],
    attrs: {
      "src": __webpack_require__(482)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[12]),
      expression: "this.$store.state.country[12]"
    }],
    attrs: {
      "src": __webpack_require__(489)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[13]),
      expression: "this.$store.state.country[13]"
    }],
    attrs: {
      "src": __webpack_require__(494)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[14]),
      expression: "this.$store.state.country[14]"
    }],
    attrs: {
      "src": __webpack_require__(1294)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[15]),
      expression: "this.$store.state.country[15]"
    }],
    attrs: {
      "src": __webpack_require__(486)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[16]),
      expression: "this.$store.state.country[16]"
    }],
    attrs: {
      "src": __webpack_require__(466)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[17]),
      expression: "this.$store.state.country[17]"
    }],
    attrs: {
      "src": __webpack_require__(488)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[18]),
      expression: "this.$store.state.country[18]"
    }],
    attrs: {
      "src": __webpack_require__(478)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[19]),
      expression: "this.$store.state.country[19]"
    }],
    attrs: {
      "src": __webpack_require__(483)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[20]),
      expression: "this.$store.state.country[20]"
    }],
    attrs: {
      "src": __webpack_require__(467)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[21]),
      expression: "this.$store.state.country[21]"
    }],
    attrs: {
      "src": __webpack_require__(490)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[22]),
      expression: "this.$store.state.country[22]"
    }],
    attrs: {
      "src": __webpack_require__(493)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[23]),
      expression: "this.$store.state.country[23]"
    }],
    attrs: {
      "src": __webpack_require__(475)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[24]),
      expression: "this.$store.state.country[24]"
    }],
    attrs: {
      "src": __webpack_require__(479)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[25]),
      expression: "this.$store.state.country[25]"
    }],
    attrs: {
      "src": __webpack_require__(474)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[26]),
      expression: "this.$store.state.country[26]"
    }],
    attrs: {
      "src": __webpack_require__(492)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[27]),
      expression: "this.$store.state.country[27]"
    }],
    attrs: {
      "src": __webpack_require__(487)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[28]),
      expression: "this.$store.state.country[28]"
    }],
    attrs: {
      "src": __webpack_require__(495)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[29]),
      expression: "this.$store.state.country[29]"
    }],
    attrs: {
      "src": __webpack_require__(485)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[30]),
      expression: "this.$store.state.country[30]"
    }],
    attrs: {
      "src": __webpack_require__(477)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[31]),
      expression: "this.$store.state.country[31]"
    }],
    attrs: {
      "src": __webpack_require__(502)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[32]),
      expression: "this.$store.state.country[32]"
    }],
    attrs: {
      "src": __webpack_require__(497)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[33]),
      expression: "this.$store.state.country[33]"
    }],
    attrs: {
      "src": __webpack_require__(505)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[34]),
      expression: "this.$store.state.country[34]"
    }],
    attrs: {
      "src": __webpack_require__(503)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[35]),
      expression: "this.$store.state.country[35]"
    }],
    attrs: {
      "src": __webpack_require__(504)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[36]),
      expression: "this.$store.state.country[36]"
    }],
    attrs: {
      "src": __webpack_require__(498)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[37]),
      expression: "this.$store.state.country[37]"
    }],
    attrs: {
      "src": __webpack_require__(500)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[38]),
      expression: "this.$store.state.country[38]"
    }],
    attrs: {
      "src": __webpack_require__(501)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[39]),
      expression: "this.$store.state.country[39]"
    }],
    attrs: {
      "src": __webpack_require__(499)
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[0].lang),
      expression: "this.$store.state.langs[0].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[1].lang),
      expression: "this.$store.state.langs[1].lang"
    }]
  }, [_vm._v("中文")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[2].lang),
      expression: "this.$store.state.langs[2].lang"
    }]
  }, [_vm._v("France")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[3].lang),
      expression: "this.$store.state.langs[3].lang"
    }]
  }, [_vm._v("German")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[4].lang),
      expression: "this.$store.state.langs[4].lang"
    }]
  }, [_vm._v("Sweden")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[5].lang),
      expression: "this.$store.state.langs[5].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[6].lang),
      expression: "this.$store.state.langs[6].lang"
    }]
  }, [_vm._v("繁体中文")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[7].lang),
      expression: "this.$store.state.langs[7].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[8].lang),
      expression: "this.$store.state.langs[8].lang"
    }]
  }, [_vm._v("Italian")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[9].lang),
      expression: "this.$store.state.langs[9].lang"
    }]
  }, [_vm._v("Dutch")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[10].lang),
      expression: "this.$store.state.langs[10].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[11].lang),
      expression: "this.$store.state.langs[11].lang"
    }]
  }, [_vm._v("Portuguese")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[12].lang),
      expression: "this.$store.state.langs[12].lang"
    }]
  }, [_vm._v("Spanish")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[13].lang),
      expression: "this.$store.state.langs[13].lang"
    }]
  }, [_vm._v("Türkçe")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[14].lang),
      expression: "this.$store.state.langs[14].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[15].lang),
      expression: "this.$store.state.langs[15].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[16].lang),
      expression: "this.$store.state.langs[16].lang"
    }]
  }, [_vm._v("Czech")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[17].lang),
      expression: "this.$store.state.langs[17].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[18].lang),
      expression: "this.$store.state.langs[18].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[19].lang),
      expression: "this.$store.state.langs[19].lang"
    }]
  }, [_vm._v("Polski")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[20].lang),
      expression: "this.$store.state.langs[20].lang"
    }]
  }, [_vm._v("Dansk")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[21].lang),
      expression: "this.$store.state.langs[21].lang"
    }]
  }, [_vm._v("Suomi")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[22].lang),
      expression: "this.$store.state.langs[22].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[23].lang),
      expression: "this.$store.state.langs[23].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[24].lang),
      expression: "this.$store.state.langs[24].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[25].lang),
      expression: "this.$store.state.langs[25].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[26].lang),
      expression: "this.$store.state.langs[26].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[27].lang),
      expression: "this.$store.state.langs[27].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[28].lang),
      expression: "this.$store.state.langs[28].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[29].lang),
      expression: "this.$store.state.langs[29].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[30].lang),
      expression: "this.$store.state.langs[30].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[31].lang),
      expression: "this.$store.state.langs[31].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[32].lang),
      expression: "this.$store.state.langs[32].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[33].lang),
      expression: "this.$store.state.langs[33].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[34].lang),
      expression: "this.$store.state.langs[34].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[35].lang),
      expression: "this.$store.state.langs[35].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[36].lang),
      expression: "this.$store.state.langs[36].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[37].lang),
      expression: "this.$store.state.langs[37].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[38].lang),
      expression: "this.$store.state.langs[38].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[39].lang),
      expression: "this.$store.state.langs[39].lang"
    }]
  }, [_vm._v("English")])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.languageFormVisible,
      "size": _vm.dialogSize,
      "id": "language-choose",
      "show-close": false,
      "top": "10%"
    },
    on: {
      "update:visible": function($event) {
        _vm.languageFormVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "language-choose-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('chooseLang')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(21)
    },
    on: {
      "click": _vm.cancelChoose
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "language-choose-body",
    slot: "default"
  }, [_c('div', {
    staticClass: "language-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('asia')))]), _vm._v(" "), _c('hr', {
    staticClass: "language-form-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(464)
    }
  }), _c('span', [_vm._v("Australia -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(5, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language zhType"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(465)
    }
  }), _c('span', [_vm._v("中国 -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(1, 1)
      }
    }
  }, [_vm._v("中文简体")])])]), _vm._v(" "), _c('div', {
    staticClass: "language speLang2"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(472)
    }
  }), _c('span', [_vm._v("香港 (中国) -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(6, 6)
      }
    }
  }, [_vm._v("繁体中文")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(493)
    }
  }), _c('span', [_vm._v("Thailand -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(22, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(475)
    }
  }), _c('span', [_vm._v("Indonesia -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(23, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(479)
    }
  }), _c('span', [_vm._v("Malaysia -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(24, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(474)
    }
  }), _c('span', [_vm._v("India -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(25, 0)
      }
    }
  }, [_vm._v("English")])])])]), _vm._v(" "), _c('div', {
    staticClass: "language-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('europe')))]), _vm._v(" "), _c('hr', {
    staticClass: "language-form-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(469)
    }
  }), _vm._v(" "), _c('span', [_vm._v("France -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(2, 0)
      }
    }
  }, [_vm._v("English")]), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(2, 2)
      }
    }
  }, [_vm._v("France")])])]), _vm._v(" "), _c('div', {
    staticClass: "language speLang3"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(470)
    }
  }), _vm._v(" "), _c('span', [_vm._v("Deutschland -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(3, 0)
      }
    }
  }, [_vm._v("English")]), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(3, 3)
      }
    }
  }, [_vm._v("German")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(473)
    }
  }), _c('span', [_vm._v("Magyarország -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(7, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(476)
    }
  }), _vm._v(" "), _c('span', [_vm._v("Italia -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(8, 0)
      }
    }
  }, [_vm._v("English")]), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(8, 8)
      }
    }
  }, [_vm._v("Italian")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(480)
    }
  }), _vm._v(" "), _c('span', [_vm._v("Nederland -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(9, 0)
      }
    }
  }, [_vm._v("English")]), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(9, 9)
      }
    }
  }, [_vm._v("Dutch")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(481)
    }
  }), _c('span', [_vm._v("Norge -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(10, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(482)
    }
  }), _vm._v(" "), _c('span', [_vm._v("Portugal -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(11, 0)
      }
    }
  }, [_vm._v("English")]), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(11, 11)
      }
    }
  }, [_vm._v("Portuguese")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(489)
    }
  }), _vm._v(" "), _c('span', [_vm._v("España -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(12, 0)
      }
    }
  }, [_vm._v("English")]), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(12, 12)
      }
    }
  }, [_vm._v("Spanish")])])]), _vm._v(" "), _c('div', {
    staticClass: "language "
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(491)
    }
  }), _vm._v(" "), _c('span', [_vm._v("Sverige -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(4, 0)
      }
    }
  }, [_vm._v("English")]), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(4, 4)
      }
    }
  }, [_vm._v("Sweden")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(494)
    }
  }), _c('span', [_vm._v("Turkey -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(13, 0)
      }
    }
  }, [_vm._v("English")]), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(13, 13)
      }
    }
  }, [_vm._v("Türkçe")])])]), _vm._v(" "), _c('div', {
    staticClass: "language speLang3"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(468)
    }
  }), _c('span', [_vm._v("United Kingdom -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(0, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(486)
    }
  }), _c('span', [_vm._v("Romania -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(15, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(466)
    }
  }), _vm._v(" "), _c('span', [_vm._v("Czech republika -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(16, 0)
      }
    }
  }, [_vm._v("English")]), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(16, 16)
      }
    }
  }, [_vm._v("Czech")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(488)
    }
  }), _c('span', [_vm._v("Slovenska republika -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(17, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(478)
    }
  }), _c('span', [_vm._v("Lithuania -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(18, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(483)
    }
  }), _c('span', [_vm._v("Polska -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(19, 0)
      }
    }
  }, [_vm._v("English")]), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(19, 19)
      }
    }
  }, [_vm._v("Polski")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(467)
    }
  }), _c('span', [_vm._v("Danmark -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(20, 0)
      }
    }
  }, [_vm._v("English")]), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(20, 20)
      }
    }
  }, [_vm._v("Dansk")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(490)
    }
  }), _c('span', [_vm._v("Suomi -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(21, 0)
      }
    }
  }, [_vm._v("English")]), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(21, 21)
      }
    }
  }, [_vm._v("Suomi")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(492)
    }
  }), _c('span', [_vm._v("Switzerland -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(26, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(502)
    }
  }), _c('span', [_vm._v("Republika Hrvatska -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(31, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(497)
    }
  }), _c('span', [_vm._v("Republik Österreich -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(32, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(505)
    }
  }), _c('span', [_vm._v("Republika Slovenija -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(33, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(503)
    }
  }), _c('span', [_vm._v("Eesti Vabariik -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(34, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(504)
    }
  }), _c('span', [_vm._v("Latvijas Republika -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(35, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(498)
    }
  }), _c('span', [_vm._v("Bosnia and Herzegovina -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(36, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(500)
    }
  }), _c('span', [_vm._v("Народна република България -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(37, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(499)
    }
  }), _c('span', [_vm._v("België -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(39, 0)
      }
    }
  }, [_vm._v("English")])])])]), _vm._v(" "), _c('div', {
    staticClass: "language-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('South America')))]), _vm._v(" "), _c('hr', {
    staticClass: "language-form-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(501)
    }
  }), _vm._v(" "), _c('span', [_vm._v("República de Chile -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(38, 0)
      }
    }
  }, [_vm._v("English")]), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(38, 12)
      }
    }
  }, [_vm._v("Spanish")])])])]), _vm._v(" "), _c('div', {
    staticClass: "language-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('middleEast')))]), _vm._v(" "), _c('hr', {
    staticClass: "language-form-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(487)
    }
  }), _c('span', [_vm._v("Saudi -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(27, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(495)
    }
  }), _c('span', [_vm._v("Uniited Arab -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(28, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(485)
    }
  }), _c('span', [_vm._v("Qatar -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(29, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(477)
    }
  }), _c('span', [_vm._v("Kuwait -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(30, 0)
      }
    }
  }, [_vm._v("English")])])])]), _vm._v(" "), _c('hr', {
    staticClass: "language-form-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "language-choose-footer",
    slot: "footer"
  }, [_c('button', {
    on: {
      "click": _vm.cancelChoose
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(19)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])
}]}

/***/ }),
/* 1433 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "title": "导入列表",
      "name": "uploadName",
      "width": "300px",
      "custom-class": "dialog"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('a', [_vm._v("文件*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uploadFileName),
      expression: "uploadFileName"
    }],
    staticStyle: {
      "width": "80%"
    },
    style: ({
      'border-color': _vm.isEmpty ? 'red' : '#ddd'
    }),
    attrs: {
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.uploadFileName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.uploadFileName = $event.target.value
      }
    }
  }), (_vm.uploadPercentage == 100) ? _c('a', {
    staticClass: "cancelUpload",
    on: {
      "click": _vm.cancelUpload
    }
  }, [_vm._v("X")]) : _vm._e(), _vm._v(" "), (_vm.isUploaded) ? _c('el-progress', {
    attrs: {
      "percentage": _vm.uploadPercentage
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "tip",
    staticStyle: {
      "margin-top": "14px"
    }
  }, [_vm._v("*只支持xls和xlsx文件")]), _vm._v(" "), _c('div', {
    staticClass: "dislogFooter"
  }, [_c('div', {
    staticClass: "uploadBox"
  }, [_vm._v("\n    浏览\n    "), _c('input', {
    ref: "inputer",
    staticClass: "upload",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.upload()
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "leadIn",
    on: {
      "click": _vm.uploadToServer
    }
  }, [_vm._v("导入")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "chart-container",
    attrs: {
      "id": "container"
    }
  }, [_c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('dailyReport')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.$t('date')) + ":" + _vm._s(_vm.time))])])]), _vm._v(" "), _c('table', {
    staticClass: "status-table1",
    class: {
      'zh1': !_vm.isEn, 'de1': _vm.isDe || _vm.isIt || _vm.isFr
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('uername')))]), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.username))]), _vm._v(" "), _c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('fullName')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('devices')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "id": "reportPdmTitle"
    }
  }, [_vm._v(_vm._s(_vm.$t('pdm')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('tran')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('pumpBase')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[2]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td4"
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _vm._v(" "), _c('td', {
    staticClass: "td4",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v(_vm._s(_vm.statics.medical_history))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('img', {
    staticClass: "img",
    attrs: {
      "id": "img1_1"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img",
    attrs: {
      "id": "img1_2"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img",
    attrs: {
      "id": "img1_3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "spe-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "legend-group",
    class: {
      'de2': _vm.isDe, 'it2': _vm.isIt || _vm.isFr, 'po2': _vm.isPo, 'es2': _vm.isEs, 'du2': _vm.isDu || _vm.isCz, 'sw2': _vm.isSw
    }
  }, [_c('div', {
    staticClass: "legend",
    class: {
      'it3': _vm.isIt
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(88)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('alert')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend",
    class: {
      'it4': _vm.isIt
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(116)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('target')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend",
    class: {
      'it5': _vm.isIt
    }
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": __webpack_require__(112)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('hypo')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe15"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": __webpack_require__(105)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('sensorGlucose')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe16"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(110)
    }
  }), _c('span', {
    staticClass: "span1",
    class: {
      'span1': !_vm.isEn
    }
  }, [_vm._v(_vm._s(_vm.$t('calib')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe17"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(118)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('newSen')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe5",
    class: {
      'zh3': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(109)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('basal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe6",
    class: {
      'zh4': !_vm.isEn, 'du3': _vm.isDu
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(117)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('tampBasal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe12",
    class: {
      'de5': _vm.isDe
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(114)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('normalBolus')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1",
    class: {
      'zh5': !_vm.isEn, 'de4': _vm.isDe
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(111)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('extendBolus')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe7",
    class: {
      'zh6': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(106)
    }
  }), _c('span', {
    staticClass: "span1"
  }, [_vm._v(_vm._s(_vm.$t('manualStop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(119)
    }
  }), _c('span', {
    class: {
      'span1': !_vm.isEn
    }
  }, [_vm._v(_vm._s(_vm.$t('warm')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe3",
    class: {
      'zh2': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(115)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('stop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe4",
    class: {
      'zh18': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(104)
    }
  }), _c('span', {
    staticClass: "span1"
  }, [_vm._v(_vm._s(_vm.$t('autoStop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe9",
    class: {
      'zh7': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(113)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('newPatch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe2",
    class: {
      'zh8': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(144)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('exercise')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe10",
    class: {
      'zh9': !_vm.isEn, 'es3': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(143)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('carbs')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend",
    staticStyle: {
      "margin-right": "0"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(142)
    }
  }), _c('span', {
    staticClass: "span1"
  }, [_vm._v(_vm._s(_vm.$t('BG Reading')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe11"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(71)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Breakfast')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe11"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(70)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Lunch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe11"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(72)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Dinner')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe11"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(73)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1222_Snack')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe11"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(219)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Exercise')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe11"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(108)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1222_auto_basal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe11"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(107)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1222_auto_bolus')))])])]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('statics')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table",
    class: {
      'de3': _vm.isDe
    }
  }, [_vm._m(1), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    staticStyle: {
      "padding-bottom": "5px"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('glucose')))]), _vm._v(" "), _c('td', {
    staticClass: "td1",
    attrs: {
      "rowspan": "2",
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('insulin')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "rowspan": "2",
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('events')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('BG1')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('SG1')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    staticStyle: {
      "width": "300px"
    }
  }, [_vm._v(_vm._s(_vm.$t('Avg')) + _vm._s(_vm.unit) + _vm._s(_vm.$t('±SD')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.bg_avg_dev))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.sg_avg_dev))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(" " + _vm._s(_vm.$t('totalDose')) + " " + _vm._s(_vm.$t('ins_unit')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.insulin.total))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(" " + _vm._s(_vm.$t('carbs')) + " (g)")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.events.carb_total))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('min')) + _vm._s(_vm.unit))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.bg_min))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.sg_min))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('bolus')) + " " + _vm._s(_vm.$t('ins_unit')) + "/%")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.insulin.bolus))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(" " + _vm._s(_vm.$t('ofMeal')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.events.meal_count))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('max')) + _vm._s(_vm.unit))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.bg_max))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.sg_max))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('basal')) + " " + _vm._s(_vm.$t('ins_unit')) + "/%")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.insulin.basal))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('avgSD1')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.events.meal_avg_sd))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('target')) + " (%)")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.bg_np))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.sg_np))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('foodBolus')) + " " + _vm._s(_vm.$t('ins_unit')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.insulin.carb_bolus))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('totalExerTime')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.events.exercise_time))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('low1')) + " (%)")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.bg_lp))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.sg_lp))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('calibBolus')) + " " + _vm._s(_vm.$t('ins_unit')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.insulin.corr_bolus))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('exerNum')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.events.exercise_count))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('high1')) + " (%)")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.bg_hp))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.sg_hp))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(" " + _vm._s(_vm.$t('Food+coor')) + " " + _vm._s(_vm.$t('ins_unit')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.foodCoor))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(" " + _vm._s(_vm.$t('avgInten')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.events.exercise_avg_time))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('ofRead')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.bg_rds_time))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.sg_data_num))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(" " + _vm._s(_vm.$t('normalBolus')) + " " + _vm._s(_vm.$t('ins_unit')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.insulin.normal_bolus))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }), _c('td', {
    staticClass: "td2"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('ofHypo')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.bg_hypo_rds_time))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.sg_hypo_num) + "/" + _vm._s(_vm.glucose.sg_hypo_duration))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('extendBolus')) + " " + _vm._s(_vm.$t('ins_unit')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.insulin.extent_bolus))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }), _c('td', {
    staticClass: "td2"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('ofAlert')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.bg_alarm_cnt))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.sg_alarm_cnt))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('tampBasal')) + " " + _vm._s(_vm.$t('ins_unit')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.insulin.temp_basal))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }), _c('td', {
    staticClass: "td2"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }), _c('td', {
    staticClass: "td1"
  }), _c('td', {
    staticClass: "td1"
  }), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('durationStop')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.insulin.suspend_time))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }), _c('td', {
    staticClass: "td2"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }), _c('td', {
    staticClass: "td3"
  }), _c('td', {
    staticClass: "td3"
  }), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('ofPumpAlert')))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.insulin.pump_alarm_cnt))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }), _c('td')])]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('table', {
    staticClass: "statics-table auto_mode",
    class: {
      'de3': _vm.isDe
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td2",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1222_Auto_Mode')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(" " + _vm._s(_vm.$t('t1222_Time_in_Auto_Mode')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.timeInAutoMode))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(" " + _vm._s(_vm.$t('t1222_Avg_SD')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.autoModeSGAvgSD) + " " + _vm._s(_vm.glucose_unit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1222_Target_Range')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.autoModeSGInTargetRange))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1222_Above_Range')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.autoModeSGAboveRange))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1222_Below_Range')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.autoModeSGBelowRange))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: " td3"
  }, [_vm._v(" " + _vm._s(_vm.$t('t1222_Auto_Mode_Exits')))]), _vm._v(" "), _c('td', {
    staticClass: " "
  }, [_vm._v(_vm._s(_vm.autoModeExits))])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-end"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(19)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "height": "5px",
      "font-size": "8px",
      "line-height": "8px"
    },
    attrs: {
      "height": "5px"
    }
  }, [_c('td', {
    attrs: {
      "width": "18%"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-right": "1px solid rgba(116,116,116,0.34)"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "width": "18%"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-right": "1px solid rgba(116,116,116,0.34)"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])
}]}

/***/ }),
/* 1435 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "nav-bar"
  }, [_c('p', [_c('span', {
    staticClass: "parent-link",
    on: {
      "click": function($event) {
        _vm.navToHome()
      }
    }
  }, [_vm._v("Admin")]), _vm._v(" "), _c('span', [_vm._v(" >> ")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.title) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('div', {
    staticClass: "typeSelect"
  }, [_c('span', [_vm._v("data type")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeDadaType
    },
    model: {
      value: (_vm.dataType),
      callback: function($$v) {
        _vm.dataType = $$v
      },
      expression: "dataType"
    }
  }, _vm._l((_vm.dataTypeList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showUploadDialog
    }
  }, [_vm._v("导入")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v(" 导出数据")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportGraph
    }
  }, [_vm._v(" 导出图表")])], 1)]), _vm._v(" "), _c('Upload', {
    ref: "upload",
    attrs: {
      "dataType": _vm.dataType
    },
    on: {
      "uploadToServer": _vm.uploadToServer
    }
  }), _vm._v(" "), _c('div'), _vm._v(" "), _c('keep-alive', [_c(_vm.currentComponent, {
    ref: "child",
    tag: "component"
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newPatient-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('myP')))])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right",
    class: {
      'de22': _vm.isDe || _vm.isFr, 'cz22': _vm.isCz
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(63)
    }
  }), _vm._v(" "), _c('p', {
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t('home')))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('div', {
    staticClass: "item post"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Postcode')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.zipcode),
      expression: "profile.zipcode"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.zipcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.zipcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Mobile')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.mobile),
      expression: "profile.mobile"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.mobile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Telephone')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.telephone),
      expression: "profile.telephone"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.telephone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.telephone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Email')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.email),
      expression: "profile.email"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item email"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Bio')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.motto),
      expression: "profile.motto"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.motto)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.motto = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n          " + _vm._s(_vm.$t('copyright')) + " "), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1437 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "login-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row2"
  }, [_c('img', {
    attrs: {
      "src": "/static/accountadmin/icon_user.png"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "placeholder": "E-mail"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row2 password"
  }, [_c('img', {
    attrs: {
      "src": "/static/accountadmin/icon_password.png"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "placeholder": "Password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "error-tip"
  }, [_vm._v("\n      " + _vm._s(_vm.errorTip) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.accountAdminLogin()
      }
    }
  }, [_c('p', [_vm._v("Sign in")])])]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": "/static/accountadmin/img_logo_green2.png"
    }
  }), _vm._v(" "), _c('div', [_vm._v("Medtrum")]), _vm._v(" "), _c('div', [_vm._v(" Management")])])
}]}

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "base_line"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon_line"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('Enter veri')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(221)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tips",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('t1215_Multi_factor_ON').replace('$1', _vm.routeData.user_name))
    }
  }), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "placement": "top-start",
      "disabled": !_vm.isErrorCode,
      "effect": "light"
    }
  }, [_c('div', {
    staticClass: "tooltip",
    slot: "content"
  }, [_vm._v(_vm._s(_vm.$t('errtip3')))]), _vm._v(" "), _c('el-input', {
    class: {
      'alert_border': _vm.isErrorCode
    },
    attrs: {
      "placeholder": _vm.$t('Entercode')
    },
    model: {
      value: (_vm.mfa_seccode),
      callback: function($$v) {
        _vm.mfa_seccode = $$v
      },
      expression: "mfa_seccode"
    }
  }, [_c('el-button', {
    staticClass: "login",
    on: {
      "click": function($event) {
        _vm.getCode()
      }
    },
    slot: "append"
  }, [_vm._v(_vm._s(_vm.codeText))])], 1)], 1), _vm._v(" "), _c('button', {
    staticClass: "register",
    on: {
      "click": _vm.next
    }
  }, [_vm._v(_vm._s(_vm.$t('Next')))])], 1)
},staticRenderFns: []}

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-left"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isA),
      expression: "isA"
    }],
    attrs: {
      "href": "/#/login"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('title')))])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isA),
      expression: "!isA"
    }],
    attrs: {
      "href": "/#/hcpLogin"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "-21px"
    }
  }, [_vm._v(_vm._s(_vm.$t('title1')))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(19)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])
}]}

/***/ }),
/* 1440 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newPatient-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Patient profile')))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('uername')) + ":"), _c('span', [_vm._v(_vm._s(_vm.profile.username))])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isA),
      expression: "isA"
    }]
  }, [_vm._v(_vm._s(_vm.$t('Patient ID')) + ":"), _c('span', {
    staticStyle: {
      "margin-left": "36px"
    }
  }, [_vm._v("0000001")])])]), _vm._v(" "), _c('div', {
    staticClass: "content content1"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Portrait')) + ":")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.portrait
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content content1"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('fullName')) + ": "), _c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.profile.realname))])])]), _vm._v(" "), _c('div', {
    staticClass: "content content1"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Alias')) + ": ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alias),
      expression: "alias"
    }],
    attrs: {
      "placeholder": _vm.alias
    },
    domProps: {
      "value": (_vm.alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.alias = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content content1"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Mobile')) + ":"), _c('span', [_vm._v(_vm._s(_vm.profile.mobile))])])]), _vm._v(" "), _c('div', {
    staticClass: "content content1"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Telephone')) + ": "), _c('span', {
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_vm._v(_vm._s(_vm.profile.telephone))])])]), _vm._v(" "), _c('div', {
    staticClass: "content content1"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Email')) + ":"), _c('span', [_vm._v(_vm._s(_vm.profile.email))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('button', {
    staticClass: "cancel",
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "create",
    on: {
      "click": _vm.create
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newPatient-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', {
    staticClass: "parent-link",
    on: {
      "click": function($event) {
        _vm.navToHome()
      }
    }
  }, [_vm._v("Admin")]), _vm._v(" "), _c('span', [_vm._v(" >> ")]), _vm._v(" "), _c('span', [_vm._v("EasyView Accounts Management")])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabA),
      expression: "tabA"
    }]
  }, [_c('div', {
    staticClass: "item-wrap"
  }, [_c('div', {
    staticClass: "item intro-text"
  }, [_c('p', [_vm._v("Please submit the HCP account information for creating a new HCP account.")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('country_region')) + ":")]), _vm._v(" "), (!_vm.isCN) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.country_region),
      expression: "profile.country_region"
    }],
    staticClass: "country_region",
    attrs: {
      "id": "country_region"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.profile.country_region = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "GB"
    }
  }, [_vm._v("United Kingdom (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AU"
    }
  }, [_vm._v("Australia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "HKF"
    }
  }, [_vm._v("香港(中国) (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TH"
    }
  }, [_vm._v("Thailand (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ID"
    }
  }, [_vm._v("Indonesia (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MY"
    }
  }, [_vm._v("Malaysia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "IN"
    }
  }, [_vm._v("India (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FR"
    }
  }, [_vm._v("France (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DE"
    }
  }, [_vm._v("Deutschland (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DD"
    }
  }, [_vm._v("Deutschland (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "HU"
    }
  }, [_vm._v("Magyarország (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "IT"
    }
  }, [_vm._v("Italia (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NL"
    }
  }, [_vm._v("Nederland (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Nor"
    }
  }, [_vm._v("Norge (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PT"
    }
  }, [_vm._v("Portugal (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ES"
    }
  }, [_vm._v("España (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SE"
    }
  }, [_vm._v("Sverige (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TR"
    }
  }, [_vm._v("Turkey (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Ro"
    }
  }, [_vm._v("Romania (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CZ"
    }
  }, [_vm._v("Czech republika (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SK"
    }
  }, [_vm._v("Slovenska republika (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LT"
    }
  }, [_vm._v("Lithuania (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PL"
    }
  }, [_vm._v("Polska (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DK"
    }
  }, [_vm._v("Danmark (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FI"
    }
  }, [_vm._v("Suomi (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CH"
    }
  }, [_vm._v("Switzerland (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SA"
    }
  }, [_vm._v("Saudi  (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AE"
    }
  }, [_vm._v("United Arab (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QA"
    }
  }, [_vm._v("Qatar  (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QW"
    }
  }, [_vm._v("Kuwait (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RH"
    }
  }, [_vm._v("Croatia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AT"
    }
  }, [_vm._v("Austria (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SI"
    }
  }, [_vm._v("Slovenia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EE"
    }
  }, [_vm._v("Estonia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LV"
    }
  }, [_vm._v("Latvia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BA"
    }
  }, [_vm._v("Bosnia and Herzegovina (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BG"
    }
  }, [_vm._v("Bulgaria (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CL"
    }
  }, [_vm._v("Chile (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BE"
    }
  }, [_vm._v("Belgium (mg/L)")])]) : _c('label', {
    staticClass: "ID2"
  }, [_vm._v("中国 (mmol/L)")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    class: {
      'es5': _vm.isIt || _vm.isFr || _vm.isDe || _vm.isEs || _vm.isDu || _vm.isPo || _vm.isSw
    }
  }, [_vm._v(_vm._s(_vm.$t('Name')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.realname),
      expression: "profile.realname"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.realname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.realname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Organization')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.serve_for),
      expression: "profile.serve_for"
    }],
    staticClass: "name org",
    class: {
      'zh2': !_vm.isEn, 'es2': _vm.isEs, 'it2': _vm.isIt, 'cz2': _vm.isCz
    },
    domProps: {
      "value": (_vm.profile.serve_for)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.serve_for = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Email')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.email),
      expression: "profile.email"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Mobile')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.mobile),
      expression: "profile.mobile"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.mobile = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "operate",
    class: {
      'opeP': _vm.isP
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "create",
    on: {
      "click": _vm.create2
    }
  }, [_vm._v("Create")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabB),
      expression: "tabB"
    }]
  }, [_c('p', {
    staticClass: "update-to-hcp-text"
  }, [_vm._v("\n            This email address has been used by a patient account. If you want to switch to an HCP account, choose Next. "), _c('br'), _vm._v("\n            Please note that once the account type is changed, any account data will be lost, and you can’t log in anymore to this account on EasyTouch, EasySense or EasyPatch.\n\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "operate",
    class: {
      'opeP': _vm.isP
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "create",
    on: {
      "click": _vm.nextProc
    }
  }, [_vm._v("Next")]), _vm._v(" "), _c('button', {
    staticClass: "cancel",
    on: {
      "click": _vm.backProc
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabC),
      expression: "tabC"
    }]
  }, [_c('p', {
    staticClass: "update-to-hcp-text"
  }, [_vm._v("\n            This email address has been used by a caregiver account. If you want to switch to an HCP account, choose Next. "), _c('br'), _vm._v("\n            Please note that once the account type is changed, any account data will be lost, and you can’t log in anymore to this account on EasyFollow.\n\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "operate",
    class: {
      'opeP': _vm.isP
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "create",
    on: {
      "click": _vm.nextProc
    }
  }, [_vm._v("Next")]), _vm._v(" "), _c('button', {
    staticClass: "cancel",
    on: {
      "click": _vm.backProc
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabD),
      expression: "tabD"
    }]
  }, [_c('div', {
    staticClass: "success_wrap"
  }, [_c('p', [_c('img', {
    attrs: {
      "src": __webpack_require__(1301)
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Account created.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "add_new",
    on: {
      "click": _vm.addNewProc
    }
  }, [_vm._v("+ Add new account")])]), _vm._v(" "), _c('div', {
    staticClass: "success_wrap"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n\n          " + _vm._s(_vm.$t('copyright')) + " "), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isA),
      expression: "isA"
    }],
    staticClass: "account"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Find account')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(55)
    }
  }), _vm._v(" "), _c('p', {
    class: {
      'zh': _vm.styleChange
    }
  }, [_vm._v(_vm._s(_vm.$t('Enter username')))]), _vm._v(" "), _c('div', {
    staticClass: "icon-bor",
    class: {
      'in': _vm.isE
    }
  }, [_c('div', {
    class: {
      'in1': _vm.isE
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(173)
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.user
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "focus": function($event) {
        _vm.check4()
      },
      "blur": function($event) {
        _vm.check4()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "next",
    on: {
      "click": function($event) {
        _vm.check1(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Next')))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.udHcp),
      expression: "udHcp"
    }],
    staticClass: "cancel",
    on: {
      "click": function($event) {
        _vm.goHome()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Back')))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.udHcp),
      expression: "!udHcp"
    }],
    staticClass: "cancel",
    on: {
      "click": function($event) {
        _vm.goHome()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Back')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isB),
      expression: "isB"
    }],
    staticClass: "verify"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Enter veri')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(221)
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isZh),
      expression: "!isZh"
    }]
  }, [_vm._v(_vm._s(_vm.$t('VcodeTip1'))), _c('span', {
    staticClass: "tryAgain",
    class: {
      'disAble': _vm.tryAgain
    },
    on: {
      "click": _vm.sendSeccode1
    }
  }, [_vm._v(_vm._s(_vm.$t('VcodeTip2')))]), _vm._v(_vm._s(_vm.$t('VcodeTip3')) + "\n      "), _c('span', {
    staticClass: "userName"
  }, [_vm._v(_vm._s(_vm.username))])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }]
  }, [_vm._v(_vm._s(_vm.$t('VcodeTip1'))), _c('span', {
    staticClass: "userName"
  }, [_vm._v(_vm._s(_vm.username))]), _vm._v(_vm._s(_vm.$t('VcodeTip2')) + "\n      "), _c('span', {
    staticClass: "tryAgain",
    class: {
      'disAble': _vm.tryAgain
    },
    on: {
      "click": _vm.sendSeccode1
    }
  }, [_vm._v(_vm._s(_vm.$t('VcodeTip3')))])]), _vm._v(" "), _c('div', {
    staticClass: "icon-bor icon-spe2",
    class: {
      'in': _vm.isE
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Vcode),
      expression: "Vcode"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.veri
    },
    domProps: {
      "value": (_vm.Vcode)
    },
    on: {
      "focus": function($event) {
        _vm.check4()
      },
      "blur": function($event) {
        _vm.check4()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Vcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "next",
    on: {
      "click": function($event) {
        _vm.check2(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Next')))]), _vm._v(" "), _c('button', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        _vm.check1(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Back')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isC),
      expression: "isC"
    }],
    staticClass: "create"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Create new')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(1292)
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Create new notice')))]), _vm._v(" "), _c('div', {
    staticClass: "icon-bor",
    class: {
      'in': _vm.isE
    }
  }, [_c('div', {
    class: {
      'in1': _vm.isE
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(172)
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isF),
      expression: "!isF"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": _vm.newpass,
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "focus": function($event) {
        _vm.check4()
      },
      "blur": function($event) {
        _vm.check4()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isF),
      expression: "isF"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.newpass,
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "focus": function($event) {
        _vm.check4()
      },
      "blur": function($event) {
        _vm.check4()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    class: [_vm.isF ? 'hide' : 'nohide'],
    attrs: {
      "id": "type"
    },
    on: {
      "click": _vm.choose
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "next",
    on: {
      "click": function($event) {
        _vm.check3()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Next')))]), _vm._v(" "), _c('button', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        _vm.check2(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Back')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isD),
      expression: "isD"
    }],
    staticClass: "completed"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Completed')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(1279)
    }
  }), _vm._v(" "), _c('p', {
    class: {
      'zh': _vm.styleChange
    }
  }, [_vm._v(_vm._s(_vm.$t('Created')))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.udHcp),
      expression: "udHcp"
    }],
    staticClass: "sign",
    on: {
      "click": function($event) {
        _vm.goHome()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Login Now')))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.udHcp),
      expression: "!udHcp"
    }],
    staticClass: "sign",
    on: {
      "click": function($event) {
        _vm.goHome()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Login Now')))])])])
},staticRenderFns: []}

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('img', {
    attrs: {
      "id": "user",
      "src": __webpack_require__(220)
    }
  }), _vm._v(" "), _c('p', [_vm._v("EasyView Clinic")]), _vm._v(" "), _c('div', {
    staticClass: "icon-bor",
    class: {
      'in': _vm.isB
    }
  }, [_c('div', {
    class: {
      'in1': _vm.isB
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(173)
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": _vm.user,
      "maxlength": "80"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "focus": _vm.check2,
      "blur": _vm.check2,
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.down($event)
      }, function($event) {
        if (!('button' in $event) && $event.keyCode !== 13) { return null; }
        _vm.down($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon-bor",
    class: {
      'in': _vm.isC
    }
  }, [_c('div', {
    class: {
      'in1': _vm.isC
    }
  }, [_c('img', {
    attrs: {
      "id": "img1",
      "src": __webpack_require__(172)
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "id": "psd",
      "type": "password",
      "placeholder": _vm.pas,
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.up($event)
      },
      "focus": _vm.check3,
      "blur": _vm.check3,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "operate",
    class: {
      'po1': _vm.isEs || _vm.isPo
    }
  }, [_c('div', {
    staticClass: "operate-left",
    class: [_vm.isA ? 'Select' : 'noSelect']
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": _vm.choose
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('remember')))])]), _vm._v(" "), _c('div', {
    staticClass: "operate-right"
  }, [_c('label', {
    on: {
      "click": _vm.forgot
    }
  }, [_vm._v(_vm._s(_vm.$t('forget')))])])]), _vm._v(" "), _c('button', {
    staticClass: "login",
    class: {
      'po2': _vm.isEs || _vm.isPo
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('sign in')))])])
},staticRenderFns: []}

/***/ }),
/* 1444 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "menu-wrap"
  }, [_vm._l((_vm.menuInfo2), function(item, index) {
    return _c('div', {
      staticClass: "icon-menu",
      on: {
        "click": function($event) {
          _vm.clickMenu(item.permission, item.title)
        }
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("\n          " + _vm._s(item.title) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "img-wrap",
      style: ({
        'background-color': item.bkColor
      })
    }, [_c('div', {
      staticClass: "top"
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": item.imgUrl
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both",
      "width": "49%"
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "footer-margin"
  })])])
},staticRenderFns: []}

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "findPatient-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('findP')))])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right",
    class: {
      'de22': _vm.isDe || _vm.isFr, 'cz11': _vm.isCz
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(63)
    }
  }), _vm._v(" "), _c('p', {
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t('home')))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isA),
      expression: "isA"
    }],
    staticClass: "search"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('enterU')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.search
    }
  }, [_vm._v(_vm._s(_vm.$t('search')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isB),
      expression: "isB"
    }],
    staticClass: "search-result"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('searchR')))]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isC),
      expression: "isC"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "result"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(55)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user"
  }, [_c('p', [_vm._v(_vm._s(this.user.realname))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('uername')) + ": " + _vm._s(this.user.username))])])]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('button', {
    on: {
      "click": _vm.request
    }
  }, [_vm._v(_vm._s(_vm.$t('sendR')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isD),
      expression: "isD"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "result2"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(55)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user"
  }, [_c('p', [_vm._v(_vm._s(this.user.realname))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('uername')) + ":" + _vm._s(this.user.username))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Bio')) + ": "), _c('span', [_vm._v(_vm._s(_vm.mark))])])])]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('button', {
    on: {
      "click": _vm.goCharts
    }
  }, [_vm._v(_vm._s(_vm.$t('viewG')))]), _vm._v(" "), _c('button', {
    staticClass: "remove",
    on: {
      "click": _vm.Remove
    }
  }, [_vm._v(_vm._s(_vm.$t('remove')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isE),
      expression: "isE"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "result2"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(55)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user"
  }, [_c('p', [_vm._v(_vm._s(this.user.realname))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('uername')) + ": " + _vm._s(this.user.username))])])]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('button', {
    staticClass: "remove",
    on: {
      "click": _vm.cancelRequest
    }
  }, [_vm._v(_vm._s(_vm.$t('cancelR')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n\n           " + _vm._s(_vm.$t('copyright'))), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.Remark,
      "size": "tiny",
      "id": "remark-form",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.Remark = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v("Set remark")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(21)
    },
    on: {
      "click": _vm.cancel
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('p', [_vm._v("Please input remark in the following box")]), _vm._v(" "), _c('input')]), _vm._v(" "), _c('div', {
    staticClass: "patientList-dialog-footer",
    slot: "footer"
  }, [_c('button', {
    staticClass: "confirmButton"
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('button', {
    staticClass: "cancelButton",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _vm._l((_vm.day1), function(day, index) {
    return _c('div', [_c('div', {
      staticClass: "chart-container"
    }, [(index > 0) ? _c('div', [_c('div', {
      staticClass: "page-break"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "Hcp-main-header"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "main-header-right"
    }, [_c('p', [_vm._v(_vm._s(_vm.$t('dailyReport')))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "9px"
      }
    }, [_vm._v(_vm._s(_vm.$t('date')) + ":" + _vm._s(day))])])]), _vm._v(" "), _c('table', {
      staticClass: "status-table1",
      class: {
        'zh1': !_vm.isEn, 'de1': _vm.isDe || _vm.isIt || _vm.isFr
      }
    }, [_c('tr', [_c('td', {
      staticClass: "td1 td2"
    }, [_vm._v(_vm._s(_vm.$t('uername')))]), _c('td', {
      staticClass: "td2",
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v(_vm._s(_vm.statics.username))]), _vm._v(" "), _c('td', {
      staticClass: "td1 td2"
    }, [_vm._v(_vm._s(_vm.$t('fullName')))]), _c('td', {
      staticClass: "td3",
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v(_vm._s(_vm.statics.name))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td1 td2",
      attrs: {
        "rowspan": "3"
      }
    }, [_vm._v(_vm._s(_vm.$t('devices')))]), _vm._v(" "), (_vm.devices[index][0].trim() == 'EasyPatch') ? _c('td', {
      staticClass: "td2",
      attrs: {
        "id": 'reportPdmTitle' + index
      }
    }, [_vm._v("APP")]) : _c('td', {
      staticClass: "td2",
      attrs: {
        "id": 'reportPdmTitle' + index
      }
    }, [_vm._v(_vm._s(_vm.$t('pdm')))]), _vm._v(" "), _c('td', {
      staticClass: "td3",
      attrs: {
        "colspan": "8"
      }
    }, [_vm._v(_vm._s(_vm.devices[index][0]))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.$t('tran')))]), _c('td', {
      staticClass: "td3",
      attrs: {
        "colspan": "8"
      }
    }, [_vm._v(_vm._s(_vm.devices[index][1]))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.$t('pumpBase')))]), _c('td', {
      staticClass: "td3",
      attrs: {
        "colspan": "8"
      }
    }, [_vm._v(_vm._s(_vm.devices[index][2]))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td1 td4"
    }, [_vm._v(_vm._s(_vm.$t('disType')))]), _c('td', {
      staticClass: "td4",
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v(_vm._s(_vm.statics.medical_history))]), _vm._v(" "), _c('td', {
      staticClass: "td td4"
    }, [_vm._v(_vm._s(_vm.$t('HbA1c')))]), _c('td', {
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v(_vm._s(_vm.hb1c[0]))])])]), _vm._v(" "), _c('div', {
      staticClass: "small-hr"
    }), _vm._v(" "), _c('div', {
      staticClass: "graph",
      attrs: {
        "id": 'chart1_1' + index
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "graph",
      attrs: {
        "id": 'chart1_2' + index
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "graph",
      attrs: {
        "id": 'chart1_3' + index
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "spe-hr"
    }), _vm._v(" "), _c('div', {
      staticClass: "legend-group",
      class: {
        'de2': _vm.isDe, 'it2': _vm.isIt || _vm.isFr, 'po2': _vm.isPo, 'es2': _vm.isEs, 'du2': _vm.isDu || _vm.isCz, 'sw2': _vm.isSw
      }
    }, [_c('div', {
      staticClass: "legend",
      class: {
        'it3': _vm.isIt
      }
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(88)
      }
    }), _c('span', [_vm._v(_vm._s(_vm.$t('alert')))])]), _vm._v(" "), _c('div', {
      staticClass: "legend",
      class: {
        'it4': _vm.isIt
      }
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(116)
      }
    }), _c('span', [_vm._v(_vm._s(_vm.$t('target')))])]), _vm._v(" "), _c('div', {
      staticClass: "legend",
      class: {
        'it5': _vm.isIt
      }
    }, [_c('img', {
      staticClass: "img-spe",
      attrs: {
        "src": __webpack_require__(112)
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('hypo')))])]), _vm._v(" "), _c('div', {
      staticClass: "legend legend-spe15"
    }, [_c('img', {
      staticClass: "img-spe",
      attrs: {
        "src": __webpack_require__(105)
      }
    }), _c('span', [_vm._v(_vm._s(_vm.$t('sensorGlucose')))])]), _vm._v(" "), _c('div', {
      staticClass: "legend legend-spe16"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(110)
      }
    }), _c('span', {
      staticClass: "span1",
      class: {
        'span1': !_vm.isEn
      }
    }, [_vm._v(_vm._s(_vm.$t('calib')))])]), _vm._v(" "), _c('div', {
      staticClass: "legend legend-spe17"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(118)
      }
    }), _c('span', [_vm._v(_vm._s(_vm.$t('newSen')))])]), _vm._v(" "), _c('div', {
      staticClass: "legend legend-spe5",
      class: {
        'zh3': !_vm.isEn
      }
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(109)
      }
    }), _c('span', [_vm._v(_vm._s(_vm.$t('basal')))])]), _vm._v(" "), _c('div', {
      staticClass: "legend legend-spe6",
      class: {
        'zh4': !_vm.isEn, 'du3': _vm.isDu
      }
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(117)
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('tampBasal')))])]), _vm._v(" "), _c('div', {
      staticClass: "legend legend-spe12",
      class: {
        'de5': _vm.isDe
      }
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(114)
      }
    }), _c('span', [_vm._v(_vm._s(_vm.$t('normalBolus')))])]), _vm._v(" "), _c('div', {
      staticClass: "legend legend-spe1",
      class: {
        'zh5': !_vm.isEn, 'de4': _vm.isDe
      }
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(111)
      }
    }), _c('span', [_vm._v(_vm._s(_vm.$t('extendBolus')))])]), _vm._v(" "), _c('div', {
      staticClass: "legend legend-spe7",
      class: {
        'zh6': !_vm.isEn
      }
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(106)
      }
    }), _c('span', {
      staticClass: "span1"
    }, [_vm._v(_vm._s(_vm.$t('manualStop')))])]), _vm._v(" "), _c('div', {
      staticClass: "legend",
      staticStyle: {
        "margin-right": "10px"
      }
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(119)
      }
    }), _c('span', {
      class: {
        'span1': !_vm.isEn
      }
    }, [_vm._v(_vm._s(_vm.$t('warm')))])]), _vm._v(" "), _c('div', {
      staticClass: "legend legend-spe3",
      class: {
        'zh2': !_vm.isEn
      }
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(115)
      }
    }), _c('span', [_vm._v(_vm._s(_vm.$t('stop')))])]), _vm._v(" "), _c('div', {
      staticClass: "legend legend-spe4",
      class: {
        'zh18': !_vm.isEn
      }
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(104)
      }
    }), _c('span', {
      staticClass: "span1"
    }, [_vm._v(_vm._s(_vm.$t('autoStop')))])]), _vm._v(" "), _c('div', {
      staticClass: "legend legend-spe9",
      class: {
        'zh7': !_vm.isEn
      }
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(113)
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('newPatch')))])]), _vm._v(" "), _c('div', {
      staticClass: "legend legend-spe2",
      class: {
        'zh8': !_vm.isEn
      }
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(144)
      }
    }), _c('span', [_vm._v(_vm._s(_vm.$t('exercise')))])]), _vm._v(" "), _c('div', {
      staticClass: "legend legend-spe10",
      class: {
        'zh9': !_vm.isEn, 'es3': _vm.isEs
      }
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(143)
      }
    }), _c('span', [_vm._v(_vm._s(_vm.$t('carbs')))])]), _vm._v(" "), _c('div', {
      staticClass: "legend",
      staticStyle: {
        "margin-right": "0"
      }
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(142)
      }
    }), _c('span', {
      staticClass: "span1"
    }, [_vm._v(_vm._s(_vm.$t('BG Reading')))])]), _vm._v(" "), _c('div', {
      staticClass: "legend legend-spe11"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(71)
      }
    }), _c('span', [_vm._v(_vm._s(_vm.$t('Breakfast')))])]), _vm._v(" "), _c('div', {
      staticClass: "legend legend-spe11"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(70)
      }
    }), _c('span', [_vm._v(_vm._s(_vm.$t('Lunch')))])]), _vm._v(" "), _c('div', {
      staticClass: "legend legend-spe11"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(72)
      }
    }), _c('span', [_vm._v(_vm._s(_vm.$t('Dinner')))])]), _vm._v(" "), _c('div', {
      staticClass: "legend legend-spe11"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(73)
      }
    }), _c('span', [_vm._v(_vm._s(_vm.$t('t1222_Snack')))])]), _vm._v(" "), _c('div', {
      staticClass: "legend legend-spe11"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(219)
      }
    }), _c('span', [_vm._v(_vm._s(_vm.$t('Exercise')))])]), _vm._v(" "), _c('div', {
      staticClass: "legend legend-spe11"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(108)
      }
    }), _c('span', [_vm._v(_vm._s(_vm.$t('t1222_auto_basal')))])]), _vm._v(" "), _c('div', {
      staticClass: "legend legend-spe11"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(107)
      }
    }), _c('span', [_vm._v(_vm._s(_vm.$t('t1222_auto_bolus')))])])]), _vm._v(" "), _c('div', {
      staticClass: "statics"
    }, [_c('p', [_vm._v(_vm._s(_vm.$t('statics')))]), _vm._v(" "), _c('table', {
      staticClass: "statics-table"
    }, [_c('tr', [_c('td', {
      staticClass: "td1",
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v(_vm._s(_vm.$t('glucose')))]), _vm._v(" "), _c('td', {
      staticClass: "td1",
      attrs: {
        "rowspan": "2",
        "colspan": "2"
      }
    }, [_vm._v(_vm._s(_vm.$t('insulin')))]), _vm._v(" "), _c('td', {
      staticClass: "td2",
      attrs: {
        "rowspan": "2",
        "colspan": "2"
      }
    }, [_vm._v(_vm._s(_vm.$t('events')))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td1"
    }), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('BG1')))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('SG1')))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('avgSD')))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[index].bg_avg_dev))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[index].sg_avg_dev))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('totalDose')) + _vm._s(_vm.$t('ins_unit')))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.insulin[index].total))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('carbs')) + "(g)")]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.events[index].carb_total))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('min')) + "(mmol/L)")]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[index].bg_min))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[index].sg_min))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('bolus')) + _vm._s(_vm.$t('ins_unit')) + "/%")]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.insulin[index].bolus))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('ofMeal')))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.events[index].meal_count))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('max')) + "(mmol/L)")]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[index].bg_max))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[index].sg_max))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('basal')) + _vm._s(_vm.$t('ins_unit')) + "/%")]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.insulin[index].basal))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('avgSD1')))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.events[index].meal_avg_sd))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('target')) + "(%)")]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[index].bg_np))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[index].sg_np))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('foodBolus')) + _vm._s(_vm.$t('ins_unit')))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.insulin[index].carb_bolus))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('totalExerTime')))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.events[index].exercise_time))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('low1')) + "(%)")]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[index].bg_lp))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[index].sg_lp))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('calibBolus')) + _vm._s(_vm.$t('ins_unit')))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.insulin[index].corr_bolus))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('exerNum')))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.events[index].exercise_count))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('high1')) + "(%)")]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[index].bg_hp))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[index].sg_hp))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(" " + _vm._s(_vm.$t('Food+coor')) + " " + _vm._s(_vm.$t('ins_unit')))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.foodCoor[index]))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('avgInten')))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.events[index].exercise_avg_time))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('ofRead')))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[index].bg_rds_time))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[index].sg_data_num))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('normalBolus')) + _vm._s(_vm.$t('ins_unit')))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.insulin[index].normal_bolus))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }), _c('td', {
      staticClass: "td2"
    })]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('ofHypo')))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[index].bg_hypo_rds_time))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[index].sg_hypo_num) + "/" + _vm._s(_vm.glucose[index].sg_hypo_duration))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('extendBolus')) + _vm._s(_vm.$t('ins_unit')))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.insulin[index].extent_bolus))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }), _c('td', {
      staticClass: "td2"
    })]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('ofAlert')))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[index].bg_alarm_cnt))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[index].sg_alarm_cnt))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('tampBasal')) + _vm._s(_vm.$t('ins_unit')))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.insulin[index].temp_basal))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }), _c('td', {
      staticClass: "td2"
    })]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td1"
    }), _c('td', {
      staticClass: "td1"
    }), _c('td', {
      staticClass: "td1"
    }), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('durationStop')))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.insulin[index].suspend_time))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }), _c('td', {
      staticClass: "td2"
    })]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td3"
    }), _c('td', {
      staticClass: "td3"
    }), _c('td', {
      staticClass: "td3"
    }), _vm._v(" "), _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(_vm.$t('ofPumpAlert')))]), _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(_vm.insulin[index].pump_alarm_cnt))]), _vm._v(" "), _c('td', {
      staticClass: "td3"
    }), _c('td')])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "statics"
    }, [_c('table', {
      staticClass: "statics-table auto_mode",
      class: {
        'de3': _vm.isDe
      }
    }, [_c('tr', [_c('td', {
      staticClass: "td2",
      staticStyle: {
        "height": "30px"
      },
      attrs: {
        "rowspan": "1",
        "colspan": "2"
      }
    }, [_vm._v(_vm._s(_vm.$t('t1222_Auto_Mode')))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(" " + _vm._s(_vm.$t('t1222_Time_in_Auto_Mode')))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.autoModeStat[index].timeInAutoMode))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(" " + _vm._s(_vm.$t('t1222_Avg_SD')))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.autoModeStat[index].autoModeSGAvgSD) + " " + _vm._s(_vm.glucose_unit))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('t1222_Target_Range')))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.autoModeStat[index].autoModeSGInTargetRange))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('t1222_Above_Range')))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.autoModeStat[index].autoModeSGAboveRange))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('t1222_Below_Range')))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.autoModeStat[index].autoModeSGBelowRange))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: " td3"
    }, [_vm._v(" " + _vm._s(_vm.$t('t1222_Auto_Mode_Exits')))]), _vm._v(" "), _c('td', {
      staticClass: " "
    }, [_vm._v(_vm._s(_vm.autoModeStat[index].autoModeExits))])])])]), _vm._v(" "), (index == _vm.day1.length - 1) ? _c('div', {
      staticClass: "page-end"
    }) : _vm._e()])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(19)
    }
  })])
}]}

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background",
    class: {
      'longCont1': _vm.long
    }
  }, [_c('div', {
    staticClass: "chart-container",
    class: {
      'longCont': _vm.long
    }
  }, [_c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('dayBydayRe')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "9px"
    }
  }, [_vm._v(_vm._s(_vm.$t('period')) + ": " + _vm._s(_vm.staTime) + "-" + _vm._s(_vm.endTime))])])]), _vm._v(" "), _c('table', {
    staticClass: "status-table1",
    class: {
      'zh11': !_vm.isEn, 'de1': _vm.isDe || _vm.isIt || _vm.isFr
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('uername')))]), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.username))]), _vm._v(" "), _c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('fullName')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('devices')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "id": "reportPdmTitle"
    }
  }, [_vm._v(_vm._s(_vm.$t('pdm')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('tran')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('pumpBase')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.pump_device))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td4"
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _c('td', {
    staticClass: "td4",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.medical_history))]), _vm._v(" "), _c('td', {
    staticClass: "td td4"
  }, [_vm._v(_vm._s(_vm.$t('HbA1c')))]), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.hb1c[0]))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _vm._l((_vm.pagePos), function(base, p) {
    return _c('div', [(p == 1) ? _c('div', [_c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "page-seperator"
    }), _vm._v(" "), _c('div', {
      staticClass: "page-starter"
    })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.date.slice(base, base + _vm.perPage[p])), function(day, index) {
      return _c('div', {
        staticClass: "chart-item2",
        class: {
          'spe-item2': ((base + index) % 3 !== 0), 'fr2': _vm.isFr
        }
      }, [_c('div', {
        staticClass: "date date-spe3"
      }, [_c('span', [_vm._v(_vm._s(day))])]), _vm._v(" "), _c('div', {
        staticClass: "eat-label eat-spe3",
        class: {
          'zh1': !_vm.isEn, 'de11': _vm.isDe, 'po1': _vm.isPo || _vm.isFr
        }
      }, [_c('span', {
        staticClass: "eat-label-spe1",
        class: {
          'zh2': !_vm.isEn, 'de2': _vm.isDe, 'po2': _vm.isPo || _vm.isFr
        }
      }, [_vm._v(_vm._s(_vm.$t('Breakfast')))]), _vm._v(" "), _c('span', {
        class: {
          'zh3': !_vm.isEn, 'de3': _vm.isDe, 'po3': _vm.isPo || _vm.isFr
        }
      }, [_vm._v(_vm._s(_vm.$t('Lunch')))]), _vm._v(" "), _c('span', {
        class: {
          'zh4': !_vm.isEn
        }
      }, [_vm._v(_vm._s(_vm.$t('Dinner')))])]), _vm._v(" "), _c('div', {
        directives: [{
          name: "loading",
          rawName: "v-loading",
          value: (index === 1 ? _vm.loading : false),
          expression: "index===1?loading:false"
        }],
        staticClass: "graph",
        staticStyle: {
          "margin-top": "35px"
        },
        attrs: {
          "id": 'sgChart' + (base + index),
          "element-loading-text": _vm.loadingText
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "carb carb-spe2"
      }, [_c('span', [_vm._v(_vm._s(_vm.$t('carbs')) + "(g)")]), _vm._v(" "), _c('div', {
        attrs: {
          "id": 'carb' + (base + index)
        }
      }, [_vm._l((_vm.carb[base + index]), function(i) {
        return _c('label', [_vm._v(_vm._s(i[1]))])
      }), _vm._v(" "), _vm._l((_vm.autoBreakfast[base + index]), function(b) {
        return _c('img', {
          staticClass: "breakfast",
          attrs: {
            "src": "/static/legend/automode/早餐.png"
          }
        })
      }), _vm._v(" "), _vm._l((_vm.autoLunch[base + index]), function(b) {
        return _c('img', {
          staticClass: "lunch",
          attrs: {
            "src": "/static/legend/automode/中餐.png"
          }
        })
      }), _vm._v(" "), _vm._l((_vm.autoDinner[base + index]), function(b) {
        return _c('img', {
          staticClass: "dinner",
          attrs: {
            "src": "/static/legend/automode/晚餐.png"
          }
        })
      }), _vm._v(" "), _vm._l((_vm.autoSnack[base + index]), function(b) {
        return _c('img', {
          staticClass: "snack",
          attrs: {
            "src": "/static/legend/automode/零食.png"
          }
        })
      })], 2)]), _vm._v(" "), _c('div', {
        staticClass: "graph bolus",
        attrs: {
          "id": 'baChart' + (base + index),
          "element-loading-background": "rgba(0, 0, 0, 0.8)"
        }
      })])
    })], 2)
  }), _vm._v(" "), (_vm.chartEndPage.show) ? _c('div', [_c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-seperator"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "legend-group",
    class: {
      'zh5': !_vm.isEn, 'it5': _vm.isIt, 'po5': _vm.isPo, 'du5': _vm.isDu || _vm.isFr || _vm.isCz
    }
  }, [_c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(88)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('alert')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(116)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('target')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": __webpack_require__(112)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('hypo')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": __webpack_require__(105)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('sensorGlucose')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(110)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('calib')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend "
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(118)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('newSen')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(119)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('warm')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1",
    class: {
      'zh6': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(109)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('basal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1",
    class: {
      'zh7': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(117)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('tampBasal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe3",
    class: {
      'zh8': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(114)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('normalBolus')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe4",
    class: {
      'zh9': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(111)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('extendBolus')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe5",
    class: {
      'zh10': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(106)
    }
  }), _c('span', {
    staticClass: "span1"
  }, [_vm._v(_vm._s(_vm.$t('manualStop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1",
    class: {
      'zh11': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(104)
    }
  }), _c('span', {
    staticClass: "span1"
  }, [_vm._v(_vm._s(_vm.$t('autoStop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(115)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('stop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe6",
    class: {
      'zh12': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(113)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('newPatch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe7",
    class: {
      'zh13': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(143)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('carbs')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe2",
    class: {
      'zh14': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(144)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('exercise')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(142)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('BG Reading')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(71)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Breakfast')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(70)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Lunch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(72)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Dinner')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(73)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1222_Snack')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(108)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1222_auto_basal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(107)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1222_auto_bolus')))])])]), _vm._v(" "), _c('div', {
    staticClass: "page-end"
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(19)
    }
  })])
}]}

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "chart-container"
  }, [_c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('sensorOlRe')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "9px"
    }
  }, [_vm._v(_vm._s(_vm.$t('period')) + ": " + _vm._s(_vm.timeRange3))])])]), _vm._v(" "), _c('table', {
    staticClass: "status-table1",
    class: {
      'zh1': !_vm.isEn, 'de1': _vm.isDe || _vm.isIt || _vm.isFr
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('uername')))]), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.username))]), _vm._v(" "), _c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('fullName')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('devices')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "id": "reportPdmTitle"
    }
  }, [_vm._v(_vm._s(_vm.$t('pdm')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('tran')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('pumpBase')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[2]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td4"
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _c('td', {
    staticClass: "td4",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.medical_history))]), _vm._v(" "), _c('td', {
    staticClass: "td td4"
  }, [_vm._v(_vm._s(_vm.$t('HbA1c')))]), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.hb1c[0]))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": "Loading"
    }
  }, [_c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart3_1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "spe-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "legend-group"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.A),
      expression: "show.A"
    }],
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(297)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.legendDate[0]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.B),
      expression: "show.B"
    }],
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(298)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.legendDate[1]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.C),
      expression: "show.C"
    }],
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(299)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.legendDate[2]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.D),
      expression: "show.D"
    }],
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(300)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.legendDate[3]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.E),
      expression: "show.E"
    }],
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(301)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.legendDate[4]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.F),
      expression: "show.F"
    }],
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(302)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.legendDate[5]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.G),
      expression: "show.G"
    }],
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(303)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.legendDate[6]))])]), _vm._v(" "), _c('div', {
    staticClass: "legend",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(294)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Average')))])])]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('date')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Avg')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('min')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('max')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('ofhypo')))])]), _vm._v(" "), _vm._l((_vm.date), function(item, i) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item),
        expression: "item"
      }]
    }, [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(item))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[i].avg))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[i].min))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[i].max))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[i].nh))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('overall')))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.glucose[_vm.glucoseLength].avg))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.glucose[_vm.glucoseLength].min))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.glucose[_vm.glucoseLength].max))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.glucoseLength].nh))])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "page-end"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(19)
    }
  })])
}]}

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "chart-container"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.styleText)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('TrendRe')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "9px"
    }
  }, [_vm._v(_vm._s(_vm.$t('period')) + ": " + _vm._s(_vm.timeRange))])])]), _vm._v(" "), _c('table', {
    staticClass: "status-table1",
    class: {
      'zh1': !_vm.isEn, 'de1': _vm.isDe || _vm.isIt
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('uername')))]), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.username))]), _vm._v(" "), _c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('fullName')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('devices')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "id": "reportPdmTitle"
    }
  }, [_vm._v(_vm._s(_vm.$t('pdm')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('tran')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('pumpBase')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[2]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td4"
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _c('td', {
    staticClass: "td4",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.medical_history))]), _vm._v(" "), _c('td', {
    staticClass: "td td4"
  }, [_vm._v(_vm._s(_vm.$t('HbA1c')))]), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.hb1c[0]))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart4_1"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table",
    class: {
      'de2': _vm.isDe || _vm.isIt
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "rowspan": "2",
      "width": "9%"
    }
  }, [_vm._v(_vm._s(_vm.$t('static')))]), _vm._v(" "), _c('td', {
    staticClass: "td1",
    attrs: {
      "colspan": "10",
      "width": "29%"
    }
  }, [_vm._v(_vm._s(_vm.$t('Basics')))]), _vm._v(" "), _c('td', {
    staticClass: "td1",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('distri')) + "%")]), _vm._v(" "), _c('td', {
    staticClass: "td1",
    attrs: {
      "colspan": "4",
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('stab')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v(_vm._s(_vm.$t('BG1')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Avg')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('max')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('min')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Med')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Q1')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Q3')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('IQR')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('SD')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('CV')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('SE1')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('high')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('low')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('target')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('aucAbove')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('aucBelow')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('#high')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('#low')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('high')) + "%")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('low')) + "%")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('target')) + "%")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Avg')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('SD')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('#hypo')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('bgRead')))])]), _vm._v(" "), _vm._l((_vm.xDate2), function(day, j) {
    return _c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(day))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_avg))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_max))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_min))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_median))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_q1))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_q3))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_iqr))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_sd))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_cv))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_se))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_up))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_lp))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_tp))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_aucu))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_aucl))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_nu))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_nl))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].bg_up))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].bg_lp))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[j].bg_tp))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].bg_avg))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].bg_sd))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].bg_hypo_num))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].bg_num))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Avg/Total')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_avg))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_max))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_min))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_median))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_q1))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_q3))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_iqr))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_sd))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_cv))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_se))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_up))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_lp))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_tp))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_aucu))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_aucl))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_nu))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_nl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].bg_up))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].bg_lp))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].bg_tp))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].bg_avg))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].bg_sd))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].bg_hypo_num))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].bg_num))])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "page-seperator"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart4_2"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "statics spe-statics"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table",
    class: {
      'de2': _vm.isDe
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "rowspan": "2",
      "width": "11%"
    }
  }, [_vm._v(_vm._s(_vm.$t('static')))]), _vm._v(" "), _c('td', {
    staticClass: "td1",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.$t('insulin')))]), _vm._v(" "), _c('td', {
    staticClass: "td1",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('carbs')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('exercise')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('total')) + " " + _vm._s(_vm.$t('ins_unit')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('avg_daily_basal')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('avg_daily_bolus')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('ofBolus')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('avgBolus')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('carbs')) + " (g)")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('ofMeal')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Dura1')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('ofExer')))])]), _vm._v(" "), _vm._l((_vm.xDate2), function(day, i) {
    return _c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(day))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.event[i].ins_total))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_c('span', {
      staticClass: "value_percent_cell left_value"
    }, [_vm._v(_vm._s(_vm.event[i].ins_basal))]), _vm._v(" "), _c('span', {
      staticClass: "value_percent_cell right_percent"
    }, [_vm._v(_vm._s(_vm.event[i].ins_basal_p))])]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_c('span', {
      staticClass: "value_percent_cell left_value"
    }, [_vm._v(_vm._s(_vm.event[i].ins_bolus))]), _vm._v(" "), _c('span', {
      staticClass: "value_percent_cell right_percent"
    }, [_vm._v(_vm._s(_vm.event[i].ins_bolus_p))])]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.event[i].ins_bolus_n))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.event[i].ins_bolus_avg))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.event[i].carb_gram))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.event[i].carb_num))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.event[i].exer_time))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.event[i].exer_num))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Avg/Total')))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].ins_total))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_c('span', {
    staticClass: "value_percent_cell left_value"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].ins_basal))]), _vm._v(" "), _c('span', {
    staticClass: "value_percent_cell right_percent"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].ins_basal_p))])]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_c('span', {
    staticClass: "value_percent_cell left_value"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].ins_bolus))]), _vm._v(" "), _c('span', {
    staticClass: "value_percent_cell right_percent"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].ins_bolus_p))])]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].ins_bolus_n))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].ins_bolus_avg))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].carb_gram))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].carb_num))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].exer_time))]), _c('td', [_vm._v(_vm._s(_vm.event[_vm.dayNum].exer_num))])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "page-end"
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(19)
    }
  })])
}]}

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background",
    class: {
      'long': _vm.long
    }
  }, [_c('div', {
    staticClass: "chart-container",
    class: {
      'long1': _vm.long
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.styleText)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('logRe')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.$t('period')) + ": " + _vm._s(_vm.timeRange))])])]), _vm._v(" "), _c('table', {
    staticClass: "status-table1",
    class: {
      'zh1': !_vm.isEn
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('uername')))]), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.username))]), _vm._v(" "), _c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('fullName')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('devices')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "id": "reportPdmTitle"
    }
  }, [_vm._v(_vm._s(_vm.$t('pdm')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('tran')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('pumpBase')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.pump_device))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td4"
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _c('td', {
    staticClass: "td4",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.medical_history))]), _vm._v(" "), _c('td', {
    staticClass: "td td4"
  }, [_vm._v(_vm._s(_vm.$t('HbA1c')))]), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.hb1c[0]))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "tip",
    class: {
      'po6': _vm.isPo, 'fr6': _vm.isFr
    }
  }, [_c('span', {
    attrs: {
      "id": "m0"
    }
  }, [_vm._v(_vm._s(_vm.$t('Breakfast')))]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "m1"
    }
  }, [_vm._v(_vm._s(_vm.$t('Lunch')))]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "m2"
    }
  }, [_vm._v(_vm._s(_vm.$t('Dinner')))])]), _vm._v(" "), _vm._l((_vm.pagePos), function(base, p) {
    return _c('div', [(p == 1) ? _c('div', [_c('div', {
      staticClass: "page-seperator"
    }), _vm._v(" "), _c('div', {
      staticClass: "page-starter"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "main-wrapper table-wrapper",
      attrs: {
        "id": "table-wrapper"
      }
    }, [_c('table', {
      staticClass: "table content"
    }, [_c('tr', [_c('td', {
      staticClass: "title",
      staticStyle: {
        "width": "60px"
      }
    }, [_vm._v(_vm._s(_vm.$t('date')))]), _c('td', {
      staticStyle: {
        "width": "127px",
        "border-right": "none"
      }
    }, [_vm._v(_vm._s(_vm.$t('dailyTotal')))]), _vm._v(" "), _vm._l((_vm.hours), function(i) {
      return _c('td', {
        staticClass: "spe7"
      }, [_vm._v(_vm._s(i))])
    }), _c('td', {
      staticClass: "spe10"
    }, [_vm._v("23:00")])], 2)]), _vm._v(" "), _vm._l((_vm.whichDate.slice(base, base + _vm.perPage[p])), function(item, index) {
      return _c('table', {
        staticClass: "table content",
        class: {
          'po4': _vm.isPo || _vm.isDu || _vm.isDe || _vm.isIt || _vm.isFr || _vm.isSw
        },
        attrs: {
          "id": base + index
        }
      }, [_c('tr', [_c('td', {
        staticClass: "spe5",
        staticStyle: {
          "width": "60px"
        },
        attrs: {
          "rowspan": "4"
        }
      }, [_vm._v(_vm._s(item))]), _vm._v(" "), _c('td', {
        staticClass: "spe1 spe5",
        staticStyle: {
          "width": "45px"
        }
      }, [_vm._v(_vm._s(_vm.$t('BG1')))]), _vm._v(" "), _c('td', {
        staticClass: "spe1 spe5",
        staticStyle: {
          "width": "85px"
        }
      }, [_vm._v(_vm._s(_vm.bgAvg[base + index].avg))]), _vm._v(" "), _vm._l((23), function(n) {
        return _c('td', {
          staticClass: "spe1 spe5"
        })
      }), _vm._v(" "), _c('td', {
        staticClass: "spe4 spe1"
      })], 2), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "spe"
      }, [_vm._v(_vm._s(_vm.$t('carbs')))]), _vm._v(" "), _c('td', {
        staticClass: "spe"
      }, [_vm._v(_vm._s(_vm.carb[base + index].total))]), _vm._v(" "), _vm._l((23), function(n) {
        return _c('td', {
          staticClass: "spe"
        })
      }), _vm._v(" "), _c('td', {
        staticClass: "spe4 spe1"
      })], 2), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "spe"
      }, [_vm._v(_vm._s(_vm.$t('insulin')))]), _vm._v(" "), _c('td', {
        staticClass: "spe"
      }, [_vm._v(_vm._s(_vm.ins[base + index].total) + " " + _vm._s(_vm.$t('bolus')) + ":" + _vm._s(_vm.ins[base + index].percent) + " %")]), _vm._v(" "), _vm._l((23), function(n) {
        return _c('td', {
          staticClass: "spe"
        })
      }), _vm._v(" "), _c('td', {
        staticClass: "spe4 spe1"
      })], 2), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "spe6"
      }, [_vm._v(_vm._s(_vm.$t('events')))]), _c('td', {
        staticClass: "spe6"
      }), _vm._v(" "), _vm._l((23), function(n) {
        return _c('td', {
          staticClass: "spe6"
        })
      }), _vm._v(" "), _c('td', {
        staticClass: "spe4"
      })], 2)])
    })], 2)])
  }), _vm._v(" "), (_vm.chartEndPage.show) ? _c('div', [_c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-seperator"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "legend-group",
    class: {
      'zh8': !_vm.isEn, 'de8': _vm.isDe, 'it8': _vm.isIt, 'po8': _vm.isPo, 'du8': _vm.isDu, 'fr8': _vm.isFr || _vm.isCz, 'sw8': _vm.isSw
    }
  }, [_c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe2",
    attrs: {
      "src": __webpack_require__(307)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('High Glucose')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe2",
    attrs: {
      "src": __webpack_require__(315)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Low Glucose')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": __webpack_require__(316)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1112_Normal_Glucose')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe2",
    attrs: {
      "src": __webpack_require__(312)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('No Active Patch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": __webpack_require__(308)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('manualStop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": __webpack_require__(304)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('autoStop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1",
    class: {
      'zh9': !_vm.isEn
    }
  }, [_c('img', {
    staticClass: "img-spe1",
    attrs: {
      "src": __webpack_require__(309)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Missed Meal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe2",
    class: {
      'zh10': !_vm.isEn, 'it10': _vm.isIt, 'po10': _vm.isPo, 'du10': _vm.isDu, 'cz10': _vm.isCz
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(314)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Stop Patch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe3",
    class: {
      'it11': _vm.isIt, 'po11': _vm.isPo, 'du11': _vm.isDu, 'cz11': _vm.isCz
    }
  }, [_c('img', {
    staticClass: "img-spe2",
    attrs: {
      "src": __webpack_require__(305)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('t1112_Manual_Bolus_or_Modified_Bolus')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe5",
    class: {
      'zh12': !_vm.isEn, 'it11': _vm.isIt, 'po12': _vm.isPo, 'du12': _vm.isDu, 'cz12': _vm.isCz
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(311)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('newPatch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe6",
    class: {
      'zh13': !_vm.isEn, 'it12': _vm.isIt, 'po13': _vm.isPo, 'du13': _vm.isDu, 'cz13': _vm.isCz
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(313)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Others')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe4",
    class: {
      'zh11': !_vm.isEn, 'it13': _vm.isIt, 'po14': _vm.isPo, 'du14': _vm.isDu
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(306)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('exercise')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1",
    class: {
      'zh9': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(310)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Multiple BG Readings')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe7",
    class: {
      'zh13': !_vm.isEn, 'es16': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(71)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Breakfast')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe7",
    class: {
      'zh13': !_vm.isEn, 'es16': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(70)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Lunch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe7",
    class: {
      'zh13': !_vm.isEn, 'es16': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(72)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Dinner')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe7",
    class: {
      'zh13': !_vm.isEn, 'es16': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(73)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Snack')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe7",
    class: {
      'zh13': !_vm.isEn, 'es16': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(295)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Auto Mode On')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe7",
    class: {
      'zh13': !_vm.isEn, 'es16': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(296)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Auto Mode Off')))])])]), _vm._v(" "), _c('div', {
    staticClass: "page-end"
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(19)
    }
  })])
}]}

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background",
    class: {
      'long': _vm.long
    },
    attrs: {
      "id": "background"
    }
  }, [_c('div', {
    staticClass: "chart-container",
    class: {
      'longCont': _vm.long
    },
    attrs: {
      "id": "chart-container"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.styleText)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('EventReport')) + " (" + _vm._s(_vm.$t('By Date')) + ")")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('period')) + ":" + _vm._s(_vm.days))])])]), _vm._v(" "), _c('table', {
    staticClass: "status-table1"
  }, [_c('tr', [_c('td', {
    staticClass: "td4"
  }, [_vm._v(_vm._s(_vm.$t('uername')) + ": " + _vm._s(_vm.statics.username))]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v(_vm._s(_vm.$t('fullName')) + ": " + _vm._s(_vm.statics.name))]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v(_vm._s(_vm.$t('disType')) + ": " + _vm._s(_vm.statics.medical_history))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('HbA1c')) + ": " + _vm._s(_vm.hb1c))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "29px",
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t('Event Summary')))]), _vm._v(" "), _vm._l((_vm.pagePos), function(base, p) {
    return _c('div', [(p >= 1) ? _c('div', [_c('div', {
      staticClass: "page-seperator"
    }), _vm._v(" "), _c('div', {
      staticClass: "page-starter"
    })]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "events-table",
      staticStyle: {
        "margin-top": "5px"
      }
    }, [_c('tr', [_c('td', {
      staticClass: "td5",
      attrs: {
        "width": "52px"
      }
    }, [_vm._v(_vm._s(_vm.$t('date')))]), _vm._v(" "), _c('td', {
      staticClass: " spe1 td5"
    }), _vm._v(" "), _vm._l((_vm.hours), function(i) {
      return _c('td', {
        staticClass: "td2"
      }, [_vm._v(_vm._s(i))])
    }), _c('td', {
      staticClass: "spe2 td5"
    }, [_vm._v("Avg/#")])], 2)]), _vm._v(" "), _vm._l((_vm.whichDate.slice(base, base + _vm.perPage[p])), function(day, index) {
      return _c('table', {
        staticClass: "events-table",
        attrs: {
          "id": base + index
        }
      }, [_c('tr', [_c('td', {
        staticClass: "td1 td4",
        attrs: {
          "rowspan": "4",
          "width": "52px"
        }
      }, [_vm._v(_vm._s(day))]), _vm._v(" "), _c('td', {
        staticClass: "td1 spe1"
      }, [_vm._v(_vm._s(_vm.$t('BG1')))]), _vm._v(" "), _vm._l((24), function(i) {
        return _c('td')
      }), _c('td', {
        staticClass: "td1 spe2"
      })], 2), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "td3"
      }, [_vm._v(_vm._s(_vm.$t('carbs')))]), _vm._v(" "), _vm._l((24), function(i) {
        return _c('td')
      }), _vm._v(" "), _c('td', {
        staticClass: "td1 spe2"
      })], 2), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "td3"
      }, [_vm._v(_vm._s(_vm.$t('Injection')))]), _vm._v(" "), _vm._l((24), function(i) {
        return _c('td')
      }), _vm._v(" "), _c('td', {
        staticClass: "td1 spe2"
      })], 2), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "td3 td4"
      }, [_vm._v(_vm._s(_vm.$t('exercise')))]), _vm._v(" "), _vm._l((24), function(i) {
        return _c('td', {
          staticClass: "td4"
        })
      }), _vm._v(" "), _c('td', {
        staticClass: "td1 td4 spe2"
      })], 2)])
    })], 2)
  }), _vm._v(" "), (_vm.chartEndPage.show) ? _c('div', [_c('div', {
    staticClass: "page-seperator"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('static')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('type')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Avg')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('SD')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('max')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('min')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('#')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('BG1')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bgstat.day.avg))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bgstat.day.sd))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bgstat.day.max))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bgstat.day.min))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.bgstat.day.num))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('carbs')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.carbstat.day.avg))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.carbstat.day.sd))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.carbstat.day.max))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.carbstat.day.min))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.carbstat.day.num))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Injection')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bolstat.day.avg))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bolstat.day.sd))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bolstat.day.max))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bolstat.day.min))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.bolstat.day.num))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('exercise')))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.exerstat.day.avg))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.exerstat.day.sd))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.exerstat.day.max))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.exerstat.day.min))]), _c('td', [_vm._v(_vm._s(_vm.exerstat.day.num))])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-end"
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(19)
    }
  })])
}]}

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background",
    class: {
      'long': _vm.long
    }
  }, [_c('div', {
    staticClass: "chart-container",
    class: {
      'longCont': _vm.long
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.styleText)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('EventReport')) + " (" + _vm._s(_vm.$t('By Category')) + ")")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('period')) + ": " + _vm._s(_vm.timeRange))])])]), _vm._v(" "), _c('table', {
    staticClass: "status-table1"
  }, [_c('tr', [_c('td', {
    staticClass: "td4"
  }, [_vm._v(_vm._s(_vm.$t('uername')) + ": " + _vm._s(_vm.statics.username))]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v(_vm._s(_vm.$t('fullName')) + ": " + _vm._s(_vm.statics.name))]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v(_vm._s(_vm.$t('disType')) + ": " + _vm._s(_vm.statics.medical_history))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('HbA1c')) + ": " + _vm._s(_vm.hb1c))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "29px",
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t('BG Summary')))]), _vm._v(" "), _vm._l((_vm.pagePosBG), function(base, p) {
    return _c('div', [(p >= 1) ? _c('div', [_c('div', {
      staticClass: "page-break"
    }), _vm._v(" "), _c('div', {
      staticClass: "page-starter"
    })]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "events-table",
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "id": "bg" + base
      }
    }, [_c('tr', [_c('td', {
      staticClass: "td5",
      attrs: {
        "width": "95px"
      }
    }, [_vm._v(_vm._s(_vm.$t('date')))]), _vm._v(" "), _vm._l((_vm.hours), function(i) {
      return _c('td', {
        staticClass: "td2"
      }, [_vm._v(_vm._s(i))])
    }), _c('td', {
      staticClass: "td5"
    }, [_vm._v("Avg/#")])], 2), _vm._v(" "), _vm._l((_vm.whichDate.slice(base, base + base + _vm.perPageBG[p])), function(day) {
      return _c('tr', [_c('td', {
        staticClass: "td1 td4"
      }, [_vm._v(_vm._s(day))]), _vm._v(" "), _vm._l((24), function(i) {
        return _c('td', {
          staticClass: "td4"
        })
      }), _c('td', {
        staticClass: "td1 td2"
      })], 2)
    })], 2)])
  }), _vm._v(" "), (_vm.endPageBG.show) ? _c('div', [_c('div', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "29px",
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t('Carbs Summary')))]), _vm._v(" "), _vm._l((_vm.pagePosCarb), function(base, p) {
    return _c('div', [(p >= 1) ? _c('div', [_c('div', {
      staticClass: "page-break"
    }), _vm._v(" "), _c('div', {
      staticClass: "page-starter"
    })]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "events-table",
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "id": "carb" + base
      }
    }, [_c('tr', [_c('td', {
      staticClass: "td5",
      attrs: {
        "width": "95px"
      }
    }, [_vm._v(_vm._s(_vm.$t('date')))]), _vm._v(" "), _vm._l((_vm.hours), function(i) {
      return _c('td', {
        staticClass: "td2"
      }, [_vm._v(_vm._s(i))])
    }), _c('td', {
      staticClass: "td5"
    }, [_vm._v("Avg/#")])], 2), _vm._v(" "), _vm._l((_vm.whichDate.slice(base, base + _vm.perPageCarb[p])), function(day) {
      return _c('tr', [_c('td', {
        staticClass: "td1 td4"
      }, [_vm._v(_vm._s(day))]), _vm._v(" "), _vm._l((24), function(i) {
        return _c('td', {
          staticClass: "td4"
        })
      }), _c('td', {
        staticClass: "td1 td2"
      })], 2)
    })], 2)])
  }), _vm._v(" "), (_vm.endPageCarb.show) ? _c('div', [_c('div', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "29px",
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t('Injection Summary')))]), _vm._v(" "), _vm._l((_vm.pagePosInj), function(base, p) {
    return _c('div', [(p >= 1) ? _c('div', [_c('div', {
      staticClass: "page-break"
    }), _vm._v(" "), _c('div', {
      staticClass: "page-starter"
    })]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "events-table",
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "id": "bol" + base
      }
    }, [_c('tr', [_c('td', {
      staticClass: "td5",
      attrs: {
        "width": "95px"
      }
    }, [_vm._v(_vm._s(_vm.$t('date')))]), _vm._v(" "), _vm._l((_vm.hours), function(i) {
      return _c('td', {
        staticClass: "td2"
      }, [_vm._v(_vm._s(i))])
    }), _c('td', {
      staticClass: "td5"
    }, [_vm._v("Avg/#")])], 2), _vm._v(" "), _vm._l((_vm.whichDate.slice(base, base + _vm.perPageInj[p])), function(day) {
      return _c('tr', [_c('td', {
        staticClass: "td1 td4"
      }, [_vm._v(_vm._s(day))]), _vm._v(" "), _vm._l((24), function(i) {
        return _c('td', {
          staticClass: "td4"
        })
      }), _c('td', {
        staticClass: "td1 td2"
      })], 2)
    })], 2)])
  }), _vm._v(" "), (_vm.endPageInj.show) ? _c('div', [_c('div', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "29px",
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t('Exercise Summary')))]), _vm._v(" "), _vm._l((_vm.pagePosExer), function(base, p) {
    return _c('div', [(p >= 1) ? _c('div', [_c('div', {
      staticClass: "page-break"
    }), _vm._v(" "), _c('div', {
      staticClass: "page-starter"
    })]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "events-table",
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "id": "exer" + base
      }
    }, [_c('tr', [_c('td', {
      staticClass: "td5",
      attrs: {
        "width": "95px"
      }
    }, [_vm._v(_vm._s(_vm.$t('date')))]), _vm._v(" "), _vm._l((_vm.hours), function(i) {
      return _c('td', {
        staticClass: "td2"
      }, [_vm._v(_vm._s(i))])
    }), _c('td', {
      staticClass: "td5"
    }, [_vm._v("Avg/#")])], 2), _vm._v(" "), _vm._l((_vm.whichDate.slice(base, base + _vm.perPageExer[p])), function(day) {
      return _c('tr', [_c('td', {
        staticClass: "td1 td4"
      }, [_vm._v(_vm._s(day))]), _vm._v(" "), _vm._l((24), function(i) {
        return _c('td', {
          staticClass: "td4"
        })
      }), _c('td', {
        staticClass: "td1 td2"
      })], 2)
    })], 2)])
  }), _vm._v(" "), (_vm.endPageExer.show) ? _c('div', [_c('div', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('static')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('type')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Avg')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('SD')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('max')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('min')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('#')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('BG1')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bgstat[0]))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bgstat[1]))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bgstat[2]))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bgstat[3]))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.bgstat[4]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('carbs')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.carbstat[0]))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.carbstat[1]))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.carbstat[2]))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.carbstat[3]))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.carbstat[4]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Injection')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bolstat[0]))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bolstat[1]))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bolstat[2]))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bolstat[3]))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.bolstat[4]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('exercise')))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.exerstat[0]))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.exerstat[1]))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.exerstat[2]))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.exerstat[3]))]), _c('td', [_vm._v(_vm._s(_vm.exerstat[4]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-end"
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(19)
    }
  })])
}]}

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background",
    attrs: {
      "id": "background"
    }
  }, [_c('div', {
    staticClass: "chart-container",
    attrs: {
      "id": "chart-container"
    }
  }, [_c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Device Settings Report')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "9px"
    }
  }, [_vm._v(_vm._s(_vm.$t('Device Settings at')) + " " + _vm._s(_vm.time))])])]), _vm._v(" "), _c('table', {
    staticClass: "status-table1",
    class: {
      'zh1': !_vm.isEn, 'de1': _vm.isDe || _vm.isFr
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('uername')))]), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.username))]), _vm._v(" "), _c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('fullName')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('devices')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.pdmTitle))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.pdmSN))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('tran')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.tranSN))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('pumpBase')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.pumpSN))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td4"
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _c('td', {
    staticClass: "td4",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.medical_history))]), _vm._v(" "), _c('td', {
    staticClass: "td td4"
  }, [_vm._v(_vm._s(_vm.$t('HbA1c')))]), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.hb1c[0]))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('basal')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('MaxBasalRate')) + ": " + _vm._s(_vm.basal.max_rate) + " " + _vm._s(_vm.$t('basal_unit2')))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Selected Basal Pattern')) + ": " + _vm._s(_vm.basal.basal_select))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('BasalPatterns')) + ": " + _vm._s(_vm.basal.basal_onoff))])])])]), _vm._v(" "), _c('div', {
    staticClass: "context"
  }, [_c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart6_1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart6_2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart6_3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart6_4"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart6_5"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.moreBasal),
      expression: "moreBasal"
    }]
  }, [_c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart6_6"
    }
  }), _vm._v(" "), (_vm.moreBasal) ? _c('div', [_c('div', {
    staticClass: "page-seperator2"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart6_7"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "graph",
    attrs: {
      "id": "chart6_8"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.moreBasal),
      expression: "!moreBasal"
    }]
  }, [_c('div', {
    staticClass: "page-seperator5"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]), _vm._v(" "), _vm._l((this.basalInfo), function(item, index) {
    return _c('div', [(index == _vm.basalPagePos + 1) ? _c('div', [_c('div', [_c('div', {
      staticClass: "page-seperator45",
      attrs: {
        "id": 'basalPage' + index
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "page-starter"
    })])]) : _vm._e(), _vm._v(" "), (index == _vm.basalPagePos2 + 1) ? _c('div', [_c('div', [_c('div', {
      staticClass: "page-seperator3",
      attrs: {
        "id": 'basalPage2' + index
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "page-starter"
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "statics"
    }, [_c('p', {
      staticClass: "custom"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "margin-right": "30px"
      }
    }, [_vm._v(_vm._s(_vm.$t('24h Total')) + ": " + _vm._s(item.total) + _vm._s(_vm.$t('ins_unit2')))]), _vm._v(" "), _c('table', {
      staticClass: "statics-table"
    }, [_c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('Start')))]), _vm._l((item.bsg1), function(i) {
      return _c('td', {
        staticClass: "td1"
      }, [_vm._v(_vm._s(i[0]))])
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(_vm.$t('basal_unit2')))]), _vm._l((item.bsg1), function(i) {
      return _c('td', {
        staticClass: "td3"
      }, [_vm._v(_vm._s(i[1]))])
    })], 2)])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((item.bsg2show)),
        expression: "(item.bsg2show)"
      }],
      staticClass: "statics"
    }, [_c('table', {
      staticClass: "statics-table"
    }, [_c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('Start')))]), _vm._l((item.bsg2), function(i) {
      return _c('td', {
        staticClass: "td1"
      }, [_vm._v(_vm._s(i[0]))])
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(_vm.$t('basal_unit2')))]), _vm._l((item.bsg2), function(i) {
      return _c('td', {
        staticClass: "td3"
      }, [_vm._v(_vm._s(i[1]))])
    })], 2)])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((item.bsg3show)),
        expression: "(item.bsg3show)"
      }],
      staticClass: "statics"
    }, [_c('table', {
      staticClass: "statics-table"
    }, [_c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('Start')))]), _vm._l((item.bsg3), function(i) {
      return _c('td', {
        staticClass: "td1"
      }, [_vm._v(_vm._s(i[0]))])
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(_vm.$t('basal_unit2')))]), _vm._l((item.bsg3), function(i) {
      return _c('td', {
        staticClass: "td3"
      }, [_vm._v(_vm._s(i[1]))])
    })], 2)])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((item.bsg4show)),
        expression: "(item.bsg4show)"
      }],
      staticClass: "statics"
    }, [_c('table', {
      staticClass: "statics-table"
    }, [_c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('Start')))]), _vm._l((item.bsg4), function(i) {
      return _c('td', {
        staticClass: "td1"
      }, [_vm._v(_vm._s(i[0]))])
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(_vm.$t('basal_unit2')))]), _vm._l((item.bsg4), function(i) {
      return _c('td', {
        staticClass: "td3"
      }, [_vm._v(_vm._s(i[1]))])
    })], 2)])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bolusStartPage.show),
      expression: "bolusStartPage.show"
    }]
  }, [_c('div', {
    staticClass: "page-seperator4",
    attrs: {
      "id": "bolusStartPage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('bolus')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Maximum Bolus')) + ": " + _vm._s(_vm.bolus.max_bolus) + " " + _vm._s(_vm.$t('ins_unit2')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Bolus Increment')) + ": " + _vm._s(_vm.bolus.bolus_step) + " " + _vm._s(_vm.$t('ins_unit2')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Bolus Calculator')) + ": " + _vm._s(_vm.bolus.bolus_wizard))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Combo/Ext Bolus')) + ": " + _vm._s(_vm.bolus.extent_option))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('BG Reminder')) + ": " + _vm._s(_vm.bolus.bg_reminder))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Active Insulin Time')) + ": " + _vm._s(_vm.bolus.ins_active_time) + " H")])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('IC Ratios')) + "(g/" + _vm._s(_vm.$t('ins_unit2')) + ")")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Start')))]), _vm._l((_vm.IcRatio), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('carbs')))]), _vm._l((_vm.IcRatio), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[1]))])
  }), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', [_vm._v("--")])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('Insulin Sensitivity')) + "(mmol/L/" + _vm._s(_vm.$t('ins_unit2')) + ")")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Start')))]), _vm._l((_vm.ins_sen), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('BG')))]), _vm._l((_vm.ins_sen), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[1]))])
  }), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', [_vm._v("--")])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('BG Target')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('From')))]), _vm._l((_vm.bg_target), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Range')))]), _vm._l((_vm.bg_target), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[1]))])
  }), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', [_vm._v("--")])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('Bolus Reminder')) + _vm._s(_vm.maxBolOption))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('From')))]), _vm._l((_vm.bolus_rem), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._l((_vm.bolus_rem), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[1]))])
  }), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', [_vm._v("--")])], 2)])]), _vm._v(" "), (!_vm.showEasyPatch) ? _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pdmStartPage.show),
      expression: "pdmStartPage.show"
    }]
  }, [_c('div', {
    staticClass: "page-seperator4",
    attrs: {
      "id": "pdmStartPage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('pdm')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Audio Options')) + ": " + _vm._s(_vm.userset.alarm_type))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Patch Expiration')) + ":" + _vm._s(_vm.userset.patch_expire_alarm))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Sensor Expiration')) + ": " + _vm._s(_vm.userset.sensor_expire_option))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Low Reservoir')) + ": " + _vm._s(_vm.userset.low_reservoir_time))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Auto Off')) + ": " + _vm._s(_vm.userset.auto_off_option))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Confidence Reminder')) + ":" + _vm._s(_vm.userset.cmd_response))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Hourly Max')) + ": " + _vm._s(_vm.userset.hour_bolus_max) + _vm._s(_vm.$t('ins_unit2')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Daily Max')) + ": " + _vm._s(_vm.userset.day_bolus_max) + _vm._s(_vm.$t('ins_unit2')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Low Suspend')) + ": " + _vm._s(_vm.userset.suspend_on_lowbg_option))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Predictive Low Suspend')) + ": " + _vm._s(_vm.userset.pre_suspend_on_lowbg_option))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Time Format')) + ":" + _vm._s(_vm.userset.time_style))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('uername')) + ":" + _vm._s(_vm.userset.user_name))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Dispay Settings (Screen)')) + ":" + _vm._s(_vm.userset.screen_timeout) + _vm._s(_vm.$t('Sec')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Dispay Settings (Backlight)')) + ":" + _vm._s(_vm.userset.screen_timeout) + _vm._s(_vm.$t('Sec')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Device Options（CGM System)')) + ":" + _vm._s(_vm.userset.cgms_module_flag))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Device Options（Insulin Pump)')) + ":" + _vm._s(_vm.userset.pump_module_flag))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Glucose Unit')) + ":" + _vm._s(_vm.userset.glucose_unit))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Alarm Clock')) + " :" + _vm._s(_vm.userset.clock_option))]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('Alarm Clock')) + " (" + _vm._s(_vm.userset.clock_option) + ")")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('time')))]), _vm._l((_vm.userset.clock), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._l((_vm.userset.clock), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[1]))])
  }), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', [_vm._v("--")])], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cgmStartPage.show),
      expression: "cgmStartPage.show"
    }]
  }, [_c('div', {
    staticClass: "page-seperator3",
    attrs: {
      "id": "cgmStartPage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('CGM')))]), _vm._v(" "), _c('div', {
    staticClass: "spe-text"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Glucose Alerts')) + ":  " + _vm._s(_vm.cgm.sensor_alarm_option))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Alert Silence')) + ":  " + _vm._s(_vm.cgm.alarm_silent_option))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('Glucose Limits')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('From')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Low')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[1]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('High')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[2]))])
  }), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', [_vm._v("--")])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('Predicitive Alerts')) + " (hh:mm)")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('high1')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.high[0]))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.high[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('low1')))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.low[0]))]), _c('td', [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.low[1]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('Rate Alerts')) + " (" + _vm._s(_vm.unit1) + "/min)")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Rise')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.rise[0]))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.rise[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Fall')))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.fall[0]))]), _c('td', [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.fall[1]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('Snooze')) + " (hh:mm)")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('high1')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_alarm_repeat.high[0]))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_alarm_repeat.high[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('low1')))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_alarm_repeat.low[0]))]), _c('td', [_vm._v(_vm._s(_vm.cgm.sensor_alarm_repeat.low[1]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics middle-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('calib')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Calibration Reminder')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_alarm_settings.calib_remind_option))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_alarm_settings.calib_remind_time))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Calibration Repeat')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_alarm_settings.calib_remind_interval))]), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Graph Range')))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_alarm_settings.trend_time_scope) + "H")]), _c('td')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "part statics"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.$t('t1222_Auto_Mode')))]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "spe-text"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('t1222_Auto_Mode')) + ":  " + _vm._s(_vm.userset.auto_basal.autobasalflag))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Target_SG')) + ": " + _vm._s(_vm.userset.auto_basal.BGTarget))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Auto_Meal_Handling')) + ": " + _vm._s(_vm.userset.auto_basal.nFoodFlag))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('weight')) + ": " + _vm._s(_vm.userset.auto_basal.AutoBasalWeight) + " kg ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Total_Daily_Dose')) + ": " + _vm._s(_vm.userset.auto_basal.AutoBasalTDD) + " U")]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }), _vm._v(" "), _c('td', {
    staticClass: "td3"
  })])])])])])]) : _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pumpStartPage.show),
      expression: "pumpStartPage.show"
    }]
  }, [_c('div', {
    staticClass: "page-seperator3",
    attrs: {
      "id": "pumpStartPage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]), _vm._v(" "), _c('div', {
    staticClass: "part part1"
  }, [_c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Pump')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1108_Pump_Bash_SN')) + ": " + _vm._s(_vm.pumpSN))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Patch Expiration')) + ":" + _vm._s(_vm.userset.patch_expire_alarm))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Low Reservoir')) + ": " + _vm._s(_vm.userset.low_reservoir_time))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1102_Out_of_Range')) + ": " + _vm._s(_vm.userset.out_of_range_option))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1102_Command_Reminder')) + ": " + _vm._s(_vm.userset.cmd_response))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Auto Off')) + ": " + _vm._s(_vm.userset.auto_off_option))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Daily Max')) + ": " + _vm._s(_vm.userset.day_bolus_max) + _vm._s(_vm.$t('ins_unit2')))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Hourly Max')) + ": " + _vm._s(_vm.userset.hour_bolus_max) + _vm._s(_vm.$t('ins_unit2')))]), _vm._v(" "), _c('td', {})])])]), _vm._v(" "), _c('div', {
    staticClass: "small-table-wrap"
  }, [_c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alarms_Alerts_on_APP')) + " ")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Audio')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.userset.pump_alarm_audio_option))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Vibrate')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.userset.pump_alarm_vibrate_option))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Pump_Light')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.userset.easypatch_pump_light))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alarms_on_App')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.userset.easypatch_pump_alarm_repeat))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Snooze')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.userset.easypatch_pump_alarm_snooze))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userset.easypatch_pump_alarm_tone))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alerts_on_App')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.userset.easypatch_pump_alert_repeat))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Snooze')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.userset.easypatch_pump_alert_snooze))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userset.easypatch_pump_alert_tone))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('CGM')))]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1108_Transmitter_SN')) + ": " + _vm._s(_vm.tranSN))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Sensor Expiration')) + ":" + _vm._s(_vm.userset.sensor_expire_option))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Glucose Alerts')) + ": " + _vm._s(_vm.cgm.sensor_alarm_option))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1102_Factory_Calibration')) + ": " + _vm._s(_vm.userset.factory_calibration_option))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }), _vm._v(" "), _c('td', {
    staticClass: "td3"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('Glucose Limits')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('From')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Low')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[1]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('High')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[2]))])
  }), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', [_vm._v("--")])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "table-group-wrap1"
  }, [_c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('Predicitive Alerts')) + " (hh:mm)")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('high1')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.high[0]))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.high[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('low1')))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.low[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.low[1]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('Rate Alerts')) + " (" + _vm._s(_vm.unit1) + "/min)")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Rise')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.rise[0]))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.rise[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Fall')))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.fall[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.fall[1]))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-group-wrap1"
  }, [_c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alerts_for_Low')) + " ")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_low_repeat))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Snooze')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_low_snooze))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_low_tone))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alerts_for_High')) + " ")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_high_repeat))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Snooze')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_high_snooze))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_high_tone))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alerts_for_Others')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_other_repeat))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Snooze')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_other_snooze))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_other_tone))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1029_Alerts_for_Hypo')) + " ")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_hypo_tone))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.appStartPage.show),
      expression: "appStartPage.show"
    }]
  }, [_c('div', {
    staticClass: "page-seperator3",
    attrs: {
      "id": "appStartPage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('APP')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Name')) + ": " + _vm._s(_vm.userset.user_name))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Audio Options')) + ": " + _vm._s(_vm.userset.alarm_type))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Glucose Unit')) + ": " + _vm._s(_vm.userset.glucose_unit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Weight_Unit')) + ": " + _vm._s(_vm.userset.easypatch_weight_unit))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Height_Unit')) + ": " + _vm._s(_vm.userset.easypatch_height_unit))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('EasyLoop')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Low Suspend')) + ": " + _vm._s(_vm.userset.suspend_on_lowbg_option))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Predictive Low Suspend')) + ":  " + _vm._s(_vm.userset.pre_suspend_on_lowbg_option))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('t1222_Auto_Mode')))]), _vm._v(" "), _c('div', {
    staticClass: "spe-text"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('t1222_Auto_Mode')) + ":  " + _vm._s(_vm.userset.auto_basal.autobasalflag))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Target_SG')) + ": " + _vm._s(_vm.userset.auto_basal.BGTarget))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Auto_Meal_Handling')) + ": " + _vm._s(_vm.userset.auto_basal.nFoodFlag))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('weight')) + ": " + _vm._s(_vm.userset.auto_basal.AutoBasalWeight) + " kg ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Total_Daily_Dose')) + ": " + _vm._s(_vm.userset.auto_basal.AutoBasalTDD) + " U")]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }), _vm._v(" "), _c('td', {
    staticClass: "td3"
  })])])])])])])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(19)
    }
  })])
}]}

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "chart-container",
    attrs: {
      "id": "container"
    }
  }, [_c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('dboard_report')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.$t('date')) + ":" + _vm._s(_vm.time))])])]), _vm._v(" "), _c('table', {
    staticClass: "status-table1",
    class: {
      'zh1': !_vm.isEn, 'de1': _vm.isDe || _vm.isIt
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('uername')))]), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.username))]), _vm._v(" "), _c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('fullName')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('devices')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "id": "reportPdmTitle"
    }
  }, [_vm._v(_vm._s(_vm.$t('pdm')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('tran')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('pumpBase')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[2]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td4"
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _c('td', {
    staticClass: "td4",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v(_vm._s(_vm.statics.medical_history))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "width": "94%",
      "margin": "10px auto"
    }
  }, [_vm._v(_vm._s(_vm.$t("dboard_glucose_statistics")))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "rb bb",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_glucose')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_cgm')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_insulin')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_carbs')))]), _vm._v(" "), _c('td', {
    staticClass: "bb",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_exercise')))])]), _vm._v(" "), _c('tr', {
    staticClass: "trh1"
  }, [_c('td', {
    staticClass: "rb ",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_glucose_avg')))]), _vm._v(" "), _c('td', {
    staticClass: "rb ",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_cgm_avg')))]), _vm._v(" "), _c('td', {
    staticClass: "rb ",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_insulin_avg')))]), _vm._v(" "), _c('td', {
    staticClass: "rb ",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_carbs_avg')))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_exercise_avg')))])]), _vm._v(" "), _c('tr', {
    staticClass: "trh1"
  }, [_c('td', {
    staticClass: "rb bb sp",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "bbv"
  }, [_vm._v(_vm._s(_vm.bgAvg))]), _vm._v(" " + _vm._s(_vm.glucoseUnit))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "bbv"
  }, [_vm._v(_vm._s(_vm.sgAvg))]), _vm._v(" " + _vm._s(_vm.glucoseUnit))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "bbv"
  }, [_vm._v(_vm._s(_vm.insAvg))]), _vm._v(" " + _vm._s(_vm.$t('ins_unit2')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "bbv"
  }, [_vm._v(_vm._s(_vm.carbAvg))]), _vm._v(" g")]), _vm._v(" "), (_vm.exerAvgHour == 0) ? _c('td', {
    staticClass: "bb",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "bbv"
  }, [_vm._v(_vm._s(_vm.exerAvg))]), _vm._v(_vm._s(_vm.$t('t1112_min')))]) : _c('td', {
    staticClass: "bb",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "bbv"
  }, [_vm._v(_vm._s(_vm.exerAvgHour))]), _vm._v(_vm._s(_vm.$t('Hours')) + "   "), _c('span', {
    staticClass: "bbv"
  }, [_vm._v(_vm._s(_vm.exerAvg))]), _vm._v(" " + _vm._s(_vm.$t('t1112_min')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_sd')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_num')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_sd')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_num')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_sd')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('t1112_days')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_sd')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_num')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_sd')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_num')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.bgSD))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.bgNum))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.sgSD))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.sgNum))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.insSD))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.insNum))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.carbSD))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.carbNum))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.exerSD))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.exerNum))])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "est-a1c"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "est-title"
  }, [_vm._v(_vm._s(_vm.$t("est_a1c_t1")))]), _vm._v(" "), (_vm.a1c_available) ? _c('span', [_c('span', [_vm._v(" " + _vm._s(_vm.est_a1c) + "  ")]), _c('span', [_vm._v(_vm._s(_vm.$t("est_a1c_t2")))])]) : _c('span', [_c('span', [_vm._v(_vm._s(_vm.$t('t1112_Not_available')))])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "x_est-ita"
  }, [_vm._v(_vm._s(_vm.$t("est_a1c_t3")))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "graph2",
    attrs: {
      "id": "chart1_4"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "row1"
  }, [_c('div', {
    staticClass: "left-table"
  }, [_c('p', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_statistics')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_BG')))]), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_BG_calibration')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.bgPerDay) + " / " + _vm._s(_vm.calibPerDay))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_SG')))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_AUC_high')) + " " + _vm._s(_vm.highLevelText))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.aucu))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_AUC_low')) + " " + _vm._s(_vm.lowLevelText))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.aucl))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_highest_value')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.sgHighest))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_lowest_value')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.sgLowest))])])]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "rb",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_pump')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_daily_basal')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.basalPercent))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_daily_bolus')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.bolusPercent))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_avg_bolus_num')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgBolusNum))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_avg_suspend_time')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgSuspendTime))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_avg_reservoir_usage')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.patchAvgLife) + " " + _vm._s(_vm.$t('t1113_days')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "right-chart"
  }, [_c('div', {
    class: {
      'hide': _vm.chart5NoData
    },
    attrs: {
      "id": "chart1_5"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "chart_title",
    class: {
      'hide': _vm.chart5NoData
    }
  }, [_vm._v(" Overall: Time In Range ")]), _vm._v(" "), _c('p', {
    class: {
      'hide': !_vm.chart5NoData
    },
    attrs: {
      "id": "chart1_5_no_data"
    }
  }, [_vm._v("No data")])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "row2 left-table"
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "rb bb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_manual_bolus')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgManualBolus))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb bb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_normal')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgManualNormalBolus))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb bb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_extend')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgManualExtendBolus))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_combo')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.avgManualComboBolus))])])]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "rb bb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_bolus_calculator')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgWizzardBolus))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb bb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_food_bolus')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgFoodWizzardBolus))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_corr_bolus')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.avgCorrWizzardBolus))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb bb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_override_add')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgWizzardOverrideAdd))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_override_sub')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.avgWizzardOverrideSub))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row2 right-chart",
    attrs: {
      "id": "xx_chart1_6"
    }
  }, [_c('div', {
    class: {
      'hide': _vm.chart6NoData
    },
    attrs: {
      "id": "chart1_6"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "chart_title",
    class: {
      'hide': _vm.chart6NoData
    }
  }, [_vm._v("Basal & Bolus")]), _vm._v(" "), _c('p', {
    class: {
      'hide': !_vm.chart6NoData
    },
    attrs: {
      "id": "chart1_6_no_data"
    }
  }, [_vm._v("No data")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "row1"
  }, [_c('div', {
    staticClass: "left-table"
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: " rb",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Auto_Mode')))]), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Time_in_Auto_Mode')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.timeInAutoMode))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: " rb",
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Average_SG_SD')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.autoModeSGAvgSD) + " " + _vm._s(_vm.glucoseUnit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: " rb",
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Time_in_Target_Range')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.autoModeSGInTargetRange))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: " rb",
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Time_above_Range')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.autoModeSGAboveRange))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: " rb",
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Time_below_Range')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.autoModeSGBelowRange))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: " rb",
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Auto_Basal_per_day')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.autoModeBasalPerDay))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Auto_Bolus_per_day')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.autoModeBolusPerDay))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('t1221_Auto_Mode_Exits')))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('t1221_No_Sensor_readings')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.autoModeExitCauseNoSensorReadings))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('t1221_Max_Delivery')) + " ")]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.autoModeExitCauseMaxDelivery))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('t1221_Min_Delivery')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.autoModeExitCauseMinDelivery))])])])]), _vm._v(" "), _c('div', {
    staticClass: "right-chart"
  }, [_c('div', {
    class: {
      'hide': _vm.chart7NoData
    },
    attrs: {
      "id": "chart1_7"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "chart_title",
    class: {
      'hide': _vm.chart7NoData
    }
  }, [_vm._v(" Auto Mode: Time In Range")]), _vm._v(" "), _c('p', {
    class: {
      'hide': !_vm.chart7NoData
    },
    attrs: {
      "id": "chart1_7_no_data"
    }
  }, [_vm._v("No data")])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-end"
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(19)
    }
  })])
}]}

/***/ }),
/* 1455 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.dialogVisible,
      "width": "30%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_vm._t("default"), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.confirmText))])], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "print-container"
  }, [_c('el-card', {
    staticClass: "print-card1"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Data Export')))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "content1"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Data Export Settings')) + ":")]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content2",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Select duration')) + ": ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeInterval),
      expression: "timeInterval"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.timeInterval = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.timeIntervalChange]
    }
  }, [_c('option', [_vm._v(_vm._s(_vm.$t('One Week')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('One Month')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('One Quarter')))])])]), _vm._v(" "), _c('div', {
    staticClass: "content2"
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "25px"
    }
  }, [_vm._v(_vm._s(_vm.$t('End date')) + ":")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endDate),
      expression: "endDate"
    }],
    staticClass: "cust",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.endDate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.timeChange]
    }
  }, [_c('option', [_vm._v(_vm._s(_vm.$t('Yesterday')))]), _vm._v(" "), _c('option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.time1),
      expression: "time1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('Last Saturday')))]), _vm._v(" "), _c('option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.time1),
      expression: "time1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('Last Sunday')))]), _vm._v(" "), _c('option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.time2),
      expression: "time2"
    }]
  }, [_vm._v(_vm._s(_vm.$t('Last Day of Last Month')))]), _vm._v(" "), _c('option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.time3),
      expression: "time3"
    }]
  }, [_vm._v(_vm._s(_vm.$t('Last Day of Last Quarter')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('Customize')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cust),
      expression: "cust"
    }],
    staticClass: "block cust"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.custDate,
      "format": "dd-MM-yyyy"
    },
    on: {
      "change": _vm.customizeDate
    },
    model: {
      value: (_vm.custTime),
      callback: function($$v) {
        _vm.custTime = $$v
      },
      expression: "custTime"
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('period')) + ":  "), _c('span', [_vm._v(_vm._s(_vm.timeRange))])])]), _vm._v(" "), _c('div', {
    staticClass: "content1 custn"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Week Filter')) + ":")]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "weeks",
    attrs: {
      "id": "weeks"
    }
  }, [_c('span', {
    staticClass: "tittle"
  }, [_c('label', {
    on: {
      "click": _vm.chooseAll
    }
  }, [_vm._v(_vm._s(_vm.$t('Weekdays')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Mon')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Tue')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Wed')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Thur')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Fri')))])])]), _vm._v(" "), _c('div', {
    staticClass: "weeks weken",
    attrs: {
      "id": "weken"
    }
  }, [_c('span', {
    staticClass: "tittle",
    class: {
      'de1': _vm.isDe, 'it1': _vm.isIt, 'po1': _vm.isPo, 'du1': _vm.isDu, 'fr1': _vm.isFr, 'sw1': _vm.isSw, 'cz5': _vm.isCz
    }
  }, [_c('label', {
    on: {
      "click": _vm.chooseAll
    }
  }, [_vm._v(_vm._s(_vm.$t('Weekends')))])]), _vm._v(" "), _c('span', {
    class: {
      'zh3': !_vm.isEn
    }
  }, [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Sat')))])]), _vm._v(" "), _c('span', {
    staticClass: "spe-span",
    class: {
      'zh4': !_vm.isEn, 'it2': _vm.isIt, 'po2': _vm.isPo, 'du2': _vm.isDu, 'fr2': _vm.isFr, 'sw2': _vm.isSw, 'cz2': _vm.isCz
    }
  }, [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Sun')))])])]), _vm._v(" "), _c('div', {
    staticClass: "content1"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Select data to export')) + ":")]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "report"
  }, [_c('div', {
    staticClass: "content3"
  }, [_c('label', {
    on: {
      "click": _vm.chooseAll
    }
  }), _c('p', [_vm._v(_vm._s(_vm.$t('All')))]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content3"
  }, [_c('label', {
    attrs: {
      "id": "dash"
    },
    on: {
      "click": _vm.choose1
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Bolus')))]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'zh1': !_vm.isEn
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate2,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.bolusEndDate),
      callback: function($$v) {
        _vm.bolusEndDate = $$v
      },
      expression: "bolusEndDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "to"
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate1,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.bolusStartDate),
      callback: function($$v) {
        _vm.bolusStartDate = $$v
      },
      expression: "bolusStartDate"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('From')))])]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content3"
  }, [_c('label', {
    attrs: {
      "id": "ds"
    },
    on: {
      "click": _vm.choose1
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Basal')))]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'zh1': !_vm.isEn
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate2,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value12),
      callback: function($$v) {
        _vm.value12 = $$v
      },
      expression: "value12"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "to"
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate1,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value11),
      callback: function($$v) {
        _vm.value11 = $$v
      },
      expression: "value11"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('From')))])]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content3"
  }, [_c('label', {
    attrs: {
      "id": "dd"
    },
    on: {
      "click": _vm.choose1
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('BG Export')))]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'zh1': !_vm.isEn
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate2,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value22),
      callback: function($$v) {
        _vm.value22 = $$v
      },
      expression: "value22"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "to"
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate1,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value21),
      callback: function($$v) {
        _vm.value21 = $$v
      },
      expression: "value21"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('From')))])]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content3"
  }, [_c('label', {
    attrs: {
      "id": "ol"
    },
    on: {
      "click": _vm.choose1
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('SG')))]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'zh1': !_vm.isEn
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate2,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value32),
      callback: function($$v) {
        _vm.value32 = $$v
      },
      expression: "value32"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "to"
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate1,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value31),
      callback: function($$v) {
        _vm.value31 = $$v
      },
      expression: "value31"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('From')))])]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content3"
  }, [_c('label', {
    attrs: {
      "id": "ta"
    },
    on: {
      "click": _vm.choose1
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Events')))]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'zh1': !_vm.isEn
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate2,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value42),
      callback: function($$v) {
        _vm.value42 = $$v
      },
      expression: "value42"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "to"
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate1,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value41),
      callback: function($$v) {
        _vm.value41 = $$v
      },
      expression: "value41"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('From')))])]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isM),
      expression: "!isM"
    }],
    staticClass: "content3"
  }, [_c('label', {
    attrs: {
      "id": "lg"
    },
    on: {
      "click": _vm.choose1
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Device Settings')))]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'zh1': !_vm.isEn
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate2,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value52),
      callback: function($$v) {
        _vm.value52 = $$v
      },
      expression: "value52"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "to"
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate1,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value51),
      callback: function($$v) {
        _vm.value51 = $$v
      },
      expression: "value51"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('From')))])]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })])]), _vm._v(" "), _c('button', {
    class: {
      'zh2': !_vm.isEn
    },
    on: {
      "click": _vm.print
    }
  }, [_vm._v(_vm._s(_vm.$t('Export')))]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "download_link",
    attrs: {
      "href": _vm.download_url
    }
  }, [_vm._v("123")])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.typeChooseVisible,
      "size": _vm.dialogSize,
      "id": "dialog-form2",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.typeChooseVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('setPeriod')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(21)
    },
    on: {
      "click": _vm.cancel
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('div', {
    staticClass: "duration"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('duration')))]), _vm._v(" "), _c('select', {
    attrs: {
      "id": "duration"
    }
  }, [_c('option', [_vm._v(_vm._s(_vm.$t('7 days')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('14 days')))])])])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('applyM')))]), _vm._v(" "), _c('button', {
    staticClass: "cancelButton",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1457 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "nav-bar"
  }, [_c('p', [_c('span', {
    staticClass: "parent-link",
    on: {
      "click": function($event) {
        _vm.navToHome()
      }
    }
  }, [_vm._v("Admin")]), _vm._v(" "), _c('span', [_vm._v(" >> ")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.title) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "nav-select",
    staticStyle: {
      "width": "100%",
      "margin-top": "15px"
    }
  }, [_c('div', [_c('span', [_vm._v("用户名")]), _vm._v(" "), _c('el-input', {
    staticClass: "input-with-select",
    attrs: {
      "placeholder": "请在此输入正确的账号"
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_c('span', [_vm._v("平台")]), _vm._v(" "), _c('el-select', {
    staticClass: "input-with-select",
    attrs: {
      "clearable": "",
      "placeholder": "请输入平台"
    },
    model: {
      value: (_vm.platform),
      callback: function($$v) {
        _vm.platform = $$v
      },
      expression: "platform"
    }
  }, _vm._l((_vm.setHospital), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_c('span', [_vm._v("数据类型")]), _vm._v(" "), _c('el-input', {
    staticClass: "input-with-select",
    attrs: {
      "placeholder": "请在此输入数据类型"
    },
    model: {
      value: (_vm.flag),
      callback: function($$v) {
        _vm.flag = $$v
      },
      expression: "flag"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.select
    }
  }, [_vm._v("搜索")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tables"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData.slice((_vm.currentPage - 1) * _vm.pagesize, _vm.currentPage * _vm.pagesize),
      "stripe": ""
    },
    on: {
      "cell-click": _vm.ceclick
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "uid",
      "label": "UID",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "width": "120px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "用户名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "uploadTime",
      "label": "上传日期"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "flag",
      "label": "flag"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "platform",
      "label": "平台"
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticClass: "fy",
    attrs: {
      "layout": "prev, pager, next, jumper",
      "total": _vm.total,
      "background": "",
      "current-page": _vm.filterPage
    },
    on: {
      "current-change": _vm.current_change,
      "update:currentPage": function($event) {
        _vm.filterPage = $event
      }
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Hcp"
    }
  }, [_c('div', {
    staticClass: "Hcp-header",
    class: {
      'de1': _vm.isDe, 'es1': _vm.isEs, 'po2': _vm.isPo || _vm.isDu || _vm.isFr
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHcp),
      expression: "isHcp"
    }],
    staticClass: "menu-left",
    class: {
      'isM': !_vm.notM
    }
  }, [_c('div', {
    staticClass: "menu-item1",
    on: {
      "click": _vm.back
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(471)
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notM),
      expression: "notM"
    }]
  }, [_vm._v(_vm._s(_vm.$t('pList')))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.notM),
      expression: "!notM"
    }]
  }, [_vm._v(_vm._s(_vm.$t('connections')))])])]), _vm._v(" "), _c('div', {
    staticClass: "menu-right",
    class: {
      'personal': !_vm.isHcp, 'es2': _vm.isEs
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHcp),
      expression: "isHcp"
    }],
    staticClass: "menu-item3 menu-spe3",
    class: {
      'item-choose': _vm.isG
    },
    on: {
      "click": _vm.changeMenu7
    }
  }, [_c('img', {
    staticClass: "portrait",
    attrs: {
      "src": _vm.portrait
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.patientName))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item3 per-item3",
    class: {
      'item-choose': _vm.isA, 'isM1': !_vm.notM
    },
    on: {
      "click": _vm.changeMenu1
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isA),
      expression: "!isA"
    }],
    attrs: {
      "src": __webpack_require__(1285)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isA),
      expression: "isA"
    }],
    attrs: {
      "src": __webpack_require__(1281)
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('settings')))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item3 menu-spe2",
    class: {
      'item-choose': _vm.isB, 'isM1': !_vm.notM
    },
    on: {
      "click": _vm.changeMenu2
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isB),
      expression: "isB"
    }],
    attrs: {
      "src": __webpack_require__(1282)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isB),
      expression: "!isB"
    }],
    attrs: {
      "src": __webpack_require__(1287)
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('monitor')))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item3",
    class: {
      'item-choose': _vm.isC, 'isM2': !_vm.notM
    },
    on: {
      "click": _vm.changeMenu3
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isC),
      expression: "isC"
    }],
    attrs: {
      "src": __webpack_require__(1280)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isC),
      expression: "!isC"
    }],
    attrs: {
      "src": __webpack_require__(1286)
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('graphs')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notM),
      expression: "notM"
    }],
    staticClass: "menu-item3",
    class: {
      'item-choose': _vm.isE
    },
    on: {
      "click": _vm.changeMenu5
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isE),
      expression: "isE"
    }],
    attrs: {
      "src": __webpack_require__(1284)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isE),
      expression: "!isE"
    }],
    attrs: {
      "src": __webpack_require__(1289)
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('records')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.no),
      expression: "no"
    }],
    staticClass: "menu-item3",
    class: {
      'item-choose': _vm.isF
    },
    on: {
      "click": _vm.changeMenu6
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isF),
      expression: "isF"
    }],
    attrs: {
      "src": __webpack_require__(1283)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isF),
      expression: "!isF"
    }],
    attrs: {
      "src": __webpack_require__(1288)
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('qPrint')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-container"
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n\n        " + _vm._s(_vm.$t('copyright'))), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])])])
},staticRenderFns: []}

/***/ }),
/* 1459 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    staticStyle: {
      "margin-top": "20px"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, _vm._l((_vm.tabLabel), function(item) {
    return _c('el-tab-pane', {
      key: item.tabType,
      attrs: {
        "label": item.label,
        "name": item.name
      }
    }, [_c('HCLTable', {
      staticStyle: {
        "margin-top": "13px"
      },
      attrs: {
        "tableData": item.tableData,
        "tabType": item.tabType,
        "pagesize": _vm.pagesize,
        "loading": _vm.Loading
      }
    })], 1)
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background",
    class: {
      'long': _vm.long
    }
  }, [_c('div', {
    staticClass: "chart-container",
    class: {
      'long1': _vm.long
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.styleText)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('logRe')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.$t('period')) + ": " + _vm._s(_vm.timeRange))])])]), _vm._v(" "), _c('table', {
    staticClass: "status-table1",
    class: {
      'zh1': !_vm.isEn
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('uername')))]), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.username))]), _vm._v(" "), _c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('fullName')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('devices')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "id": "reportPdmTitle"
    }
  }, [_vm._v(_vm._s(_vm.$t('pdm')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('tran')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('pumpBase')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.pump_device))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td4"
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _c('td', {
    staticClass: "td4",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v(_vm._s(_vm.statics.medical_history))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "tip",
    class: {
      'po6': _vm.isPo, 'fr6': _vm.isFr
    }
  }, [_c('span', {
    attrs: {
      "id": "m0"
    }
  }, [_vm._v(_vm._s(_vm.$t('Breakfast')))]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "m1"
    }
  }, [_vm._v(_vm._s(_vm.$t('Lunch')))]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "m2"
    }
  }, [_vm._v(_vm._s(_vm.$t('Dinner')))])]), _vm._v(" "), _vm._l((_vm.pagePos), function(base, p) {
    return _c('div', [(p >= 1) ? _c('div', [_c('div', {
      staticClass: "page-seperator"
    }), _vm._v(" "), _c('div', {
      staticClass: "page-starter"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "main-wrapper table-wrapper"
    }, [_c('table', {
      staticClass: "table content"
    }, [_c('tr', [_c('td', {
      staticClass: "title",
      staticStyle: {
        "width": "60px"
      }
    }, [_vm._v(_vm._s(_vm.$t('date')))]), _c('td', {
      staticStyle: {
        "width": "127px",
        "border-right": "none"
      }
    }, [_vm._v(_vm._s(_vm.$t('dailyTotal')))]), _vm._v(" "), _vm._l((_vm.hours), function(i) {
      return _c('td', {
        staticClass: "spe7"
      }, [_vm._v(_vm._s(i))])
    }), _vm._v(" "), _c('td', {
      staticClass: "spe10"
    }, [_vm._v("23:00")])], 2)]), _vm._v(" "), _vm._l((_vm.whichDate.slice(base, base + _vm.perPage[p])), function(item, index) {
      return _c('table', {
        staticClass: "table content",
        class: {
          'po4': _vm.isPo || _vm.isDu || _vm.isDe || _vm.isIt || _vm.isFr || _vm.isSw
        },
        attrs: {
          "id": base + index
        }
      }, [_c('tr', [_c('td', {
        staticClass: "spe5",
        staticStyle: {
          "width": "60px"
        },
        attrs: {
          "rowspan": "4"
        }
      }, [_vm._v(_vm._s(item))]), _vm._v(" "), _c('td', {
        staticClass: "spe1 spe5",
        staticStyle: {
          "width": "45px"
        }
      }, [_vm._v(_vm._s(_vm.$t('BG1')))]), _vm._v(" "), _c('td', {
        staticClass: "spe1 spe5",
        staticStyle: {
          "width": "85px"
        }
      }, [_vm._v(_vm._s(_vm.bgAvg[base + index].avg))]), _vm._v(" "), _vm._l((23), function(n) {
        return _c('td', {
          staticClass: "spe1 spe5"
        })
      }), _vm._v(" "), _c('td', {
        staticClass: "spe4 spe1"
      })], 2), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "spe"
      }, [_vm._v(_vm._s(_vm.$t('carbs')))]), _vm._v(" "), _c('td', {
        staticClass: "spe"
      }, [_vm._v(_vm._s(_vm.carb[base + index].total))]), _vm._v(" "), _vm._l((23), function(n) {
        return _c('td', {
          staticClass: "spe"
        })
      }), _vm._v(" "), _c('td', {
        staticClass: "spe4 spe1"
      })], 2), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "spe"
      }, [_vm._v(_vm._s(_vm.$t('insulin')))]), _vm._v(" "), _c('td', {
        staticClass: "spe"
      }, [_vm._v(_vm._s(_vm.ins[base + index].total) + " " + _vm._s(_vm.$t('bolus')) + ":" + _vm._s(_vm.ins[base + index].percent) + " %")]), _vm._v(" "), _vm._l((23), function(n) {
        return _c('td', {
          staticClass: "spe"
        })
      }), _vm._v(" "), _c('td', {
        staticClass: "spe4 spe1"
      })], 2), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "spe6"
      }, [_vm._v(_vm._s(_vm.$t('events')))]), _c('td', {
        staticClass: "spe6"
      }), _vm._v(" "), _vm._l((23), function(n) {
        return _c('td', {
          staticClass: "spe6"
        })
      }), _vm._v(" "), _c('td', {
        staticClass: "spe4"
      })], 2)])
    })], 2)])
  }), _vm._v(" "), (_vm.chartEndPage.show) ? _c('div', [_c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-seperator"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "legend-group",
    class: {
      'zh8': !_vm.isEn, 'de8': _vm.isDe, 'it8': _vm.isIt, 'po8': _vm.isPo, 'du8': _vm.isDu, 'fr8': _vm.isFr || _vm.isCz, 'sw8': _vm.isSw
    }
  }, [_c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe2",
    attrs: {
      "src": __webpack_require__(307)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('High Glucose')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe2",
    attrs: {
      "src": __webpack_require__(315)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Low Glucose')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": __webpack_require__(316)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1112_Normal_Glucose')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe2",
    attrs: {
      "src": __webpack_require__(312)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('No Active Patch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": __webpack_require__(308)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('manualStop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": __webpack_require__(304)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('autoStop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1",
    class: {
      'zh9': !_vm.isEn
    }
  }, [_c('img', {
    staticClass: "img-spe1",
    attrs: {
      "src": __webpack_require__(309)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Missed Meal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe2",
    class: {
      'zh10': !_vm.isEn, 'it10': _vm.isIt, 'po10': _vm.isPo, 'du10': _vm.isDu, 'cz10': _vm.isCz
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(314)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Stop Patch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe3",
    class: {
      'it11': _vm.isIt, 'po11': _vm.isPo, 'du11': _vm.isDu, 'cz11': _vm.isCz
    }
  }, [_c('img', {
    staticClass: "img-spe2",
    attrs: {
      "src": __webpack_require__(305)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('t1112_Manual_Bolus_or_Modified_Bolus')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe5",
    class: {
      'zh12': !_vm.isEn, 'it11': _vm.isIt, 'po12': _vm.isPo, 'du12': _vm.isDu, 'cz12': _vm.isCz
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(311)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('newPatch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe6",
    class: {
      'zh13': !_vm.isEn, 'it12': _vm.isIt, 'po13': _vm.isPo, 'du13': _vm.isDu, 'cz13': _vm.isCz
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(313)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Others')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe4",
    class: {
      'zh11': !_vm.isEn, 'it13': _vm.isIt, 'po14': _vm.isPo, 'du14': _vm.isDu
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(306)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('exercise')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1",
    class: {
      'zh9': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(310)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Multiple BG Readings')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe7",
    class: {
      'zh13': !_vm.isEn, 'es16': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(71)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Breakfast')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe7",
    class: {
      'zh13': !_vm.isEn, 'es16': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(70)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Lunch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe7",
    class: {
      'zh13': !_vm.isEn, 'es16': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(72)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Dinner')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe7",
    class: {
      'zh13': !_vm.isEn, 'es16': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(73)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Snack')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe7",
    class: {
      'zh13': !_vm.isEn, 'es16': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(295)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Auto Mode On')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe7",
    class: {
      'zh13': !_vm.isEn, 'es16': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(296)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Auto Mode Off')))])])]), _vm._v(" "), _c('div', {
    staticClass: "page-end"
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(19)
    }
  })])
}]}

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "PainterList"
    }
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('el-card', {
    attrs: {
      "id": "list"
    }
  }, [_c('div', {
    staticClass: "patientList-operate"
  }, [_c('button', {
    attrs: {
      "id": "danger"
    },
    on: {
      "click": _vm.deleteP
    }
  }, [_vm._v(_vm._s(_vm.$t('Delete')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.findPatient
    }
  }, [_vm._v(_vm._s(_vm.$t('findP')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.NewPatient
    }
  }, [_vm._v(_vm._s(_vm.$t('newP')))]), _vm._v(" "), _c('el-popover', {
    ref: "popover1",
    attrs: {
      "placement": "bottom-start",
      "width": "300",
      "trigger": "hover",
      "disabled": _vm.tooltipVisible
    }
  }, [_c('div', {
    staticClass: "patientList-label-tooltip"
  }, [_c('div', {
    staticClass: "patientList-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Filter')))])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small2-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "label-group"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab2),
      expression: "lab2"
    }],
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab2, 'de6': _vm.isDe || _vm.isIt, 'po4': _vm.isPo, 'fr2': _vm.isFr
    }
  }, [_c('span', {
    class: {
      'ZH3': _vm.styleChange
    }
  }, [_vm._v(_vm._s(_vm.$t('Female')))]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab3),
      expression: "lab3"
    }],
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab3, 'es3': _vm.isEs, 'de6': _vm.isDe || _vm.isIt, 'po4': _vm.isPo
    }
  }, [_c('span', {
    class: {
      'ZH3': _vm.styleChange
    }
  }, [_vm._v(_vm._s(_vm.$t('Male')))]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab17),
      expression: "lab17"
    }],
    staticClass: "filter-label",
    class: {
      'choose4': _vm.lab17, 'de17': _vm.isDe, 'po17': _vm.isPo || _vm.isDu
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('genUn')))]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab18),
      expression: "lab18"
    }],
    staticClass: "filter-label",
    class: {
      'choose4': _vm.lab18, 'po19': _vm.isPo || _vm.isDu
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('ageUn')))]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab6),
      expression: "lab6"
    }],
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab6
    }
  }, [_c('span', [_vm._v("< 18")]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab7),
      expression: "lab7"
    }],
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab7
    }
  }, [_c('span', [_vm._v("18-40")]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab8),
      expression: "lab8"
    }],
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab8
    }
  }, [_c('span', [_vm._v("40-60")]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab9),
      expression: "lab9"
    }],
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab9
    }
  }, [_c('span', [_vm._v("> 60")]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab19),
      expression: "lab19"
    }],
    staticClass: "filter-label",
    class: {
      'choose4': _vm.lab19, 'de18': _vm.isDe || _vm.isFr, 'it18': _vm.isIt, 'es18': _vm.isEs, 'po18': _vm.isPo || _vm.isDu, 'sw2': _vm.isSw
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('disUn')))]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab16),
      expression: "lab16"
    }],
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab16
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Other')))]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab11),
      expression: "lab11"
    }],
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab11, 'cz2': _vm.isCz
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Type 1')))]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab12),
      expression: "lab12"
    }],
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab12, 'cz2': _vm.isCz
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Type 2')))]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab13),
      expression: "lab13"
    }],
    staticClass: "filter-label",
    class: {
      'choose2': _vm.lab13, 'de2': _vm.isDe, 'it6': _vm.isIt, 'du4': _vm.isDu, 'fr1': _vm.isFr, 'cz3': _vm.isCz
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Gestational')))]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab14),
      expression: "lab14"
    }],
    staticClass: "filter-label",
    class: {
      'choose2': _vm.lab14, 'po5': _vm.isPo
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Prediabetes')))]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab15),
      expression: "lab15"
    }],
    staticClass: "filter-label",
    class: {
      'choose3': _vm.lab15, 'ZH2': _vm.styleChange
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('LADA')))]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })])])])]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover1",
      arg: "popover1"
    }],
    attrs: {
      "id": "filter",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Filter')))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hcpGroupMenu),
      expression: "hcpGroupMenu"
    }],
    staticClass: "back-btn",
    on: {
      "click": function($event) {
        _vm.backToMenu()
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v(_vm._s(_vm.$t('t0805_Back')))])]), _vm._v(" "), _c('div', {
    staticClass: "patientList-search",
    class: {
      'patientList-in': _vm.searchPatient
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keywords),
      expression: "keywords"
    }],
    domProps: {
      "value": (_vm.keywords)
    },
    on: {
      "focus": function($event) {
        _vm.check(0)
      },
      "blur": function($event) {
        _vm.check(1)
      },
      "keyup": function($event) {
        if (!('button' in $event) && $event.keyCode !== 13) { return null; }
        _vm.check(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keywords = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    class: {
      'patientList-in1': _vm.searchPatient
    },
    attrs: {
      "src": __webpack_require__(506)
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "patient-table"
  }, [_c('table', {
    attrs: {
      "id": "patientList"
    }
  }, [_c('tr', {
    staticClass: "header"
  }, [_c('td', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked),
      expression: "checked"
    }],
    staticClass: "checkbox22",
    attrs: {
      "type": "checkbox",
      "id": "checkbox1"
    },
    domProps: {
      "checked": Array.isArray(_vm.checked) ? _vm._i(_vm.checked, null) > -1 : (_vm.checked)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.checked = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Name')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Gender')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Age')))]), _c('td', [_vm._v(_vm._s(_vm.$t('Type')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Duration')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Connections')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('UploadTime')))])]), _vm._v(" "), _vm._l((_vm.currentPageData), function(item, index) {
    return (!_vm.displayTab) ? _c('tr', {
      key: index,
      class: (index % 2 === 0) ? '' : 'even',
      attrs: {
        "data": _vm.users
      }
    }, [_c('td', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkList),
        expression: "checkList"
      }],
      staticClass: "checkbox22",
      attrs: {
        "type": "checkbox",
        "autocomplate": "off"
      },
      domProps: {
        "value": item.uid,
        "checked": Array.isArray(_vm.checkList) ? _vm._i(_vm.checkList, item.uid) > -1 : (_vm.checkList)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.checkList,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.uid,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.checkList = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.checkList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkList = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "name",
      attrs: {
        "id": index
      },
      on: {
        "click": _vm.goDetail
      }
    }, [_c('img', {
      ref: "imgs",
      refInFor: true,
      staticClass: "portrait",
      attrs: {
        "src": _vm.imgSrc,
        "onload": _vm.imgload(item.uid)
      }
    }), _vm._v(" "), _c('p', {
      class: {
        'filterResult': _vm.filFlag2
      }
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('td', {
      staticClass: "gender"
    }, [_vm._v(_vm._s(item.gender))]), _vm._v(" "), _c('td', {
      staticClass: "small"
    }, [_vm._v(_vm._s(item.age))]), _vm._v(" "), _c('td', {
      staticClass: "small"
    }, [_vm._v(_vm._s(item.diabetes_type))]), _vm._v(" "), _c('td', {
      staticClass: "diabetes-date"
    }, [_vm._v(_vm._s(item.diabetes_diagnosis_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.created_by))]), _c('td', [_vm._v(_vm._s(item.upload_time))])]) : _vm._e()
  })], 2)]), _vm._v(" "), (_vm.displayTab) ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "empty-text": "--",
      "element-loading-text": _vm.$t('Loading'),
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(0, 0, 0, 0.8)"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "patientList-block"
  }, [_c('img', {
    class: {
      'click1': _vm.currentPage == 1
    },
    attrs: {
      "src": __webpack_require__(121)
    },
    on: {
      "click": _vm.prevPage
    }
  }), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPage),
      expression: "currentPage"
    }],
    domProps: {
      "value": (_vm.currentPage)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && $event.keyCode !== 13) { return null; }
        _vm.go($event)
      },
      "blur": _vm.go,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentPage = $event.target.value
      }
    }
  }), _vm._v(" of   " + _vm._s(_vm.totalPage))]), _vm._v(" "), _c('img', {
    class: {
      'click1': _vm.currentPage == _vm.totalPage
    },
    attrs: {
      "src": __webpack_require__(120)
    },
    on: {
      "click": _vm.nextPage
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n\n          " + _vm._s(_vm.$t('copyright')) + " "), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogFormVisible,
      "size": _vm.dialogSize,
      "id": "dialog-form",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Filter')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(21)
    },
    on: {
      "click": _vm.cancelFilter
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('hr', {
    staticClass: "patientList-small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "lab-group1"
  }, [_c('label', {
    class: {
      'de3': _vm.isDe || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('Gender')))]), _vm._v(" "), _c('div', {
    staticClass: "patientList-line",
    class: {
      'de4': _vm.isDe
    }
  }, [_c('div', {
    staticClass: "label1",
    class: {
      'choose': _vm.lab1, 'ZH1': _vm.styleChange, 'es2': _vm.isEs || _vm.isIt || _vm.isFr, 'de5': _vm.isDe, 'po2': _vm.isPo, 'du2': _vm.isDu, 'pl2': _vm.isPl
    },
    on: {
      "click": _vm.choose1
    }
  }, [_c('span', {
    class: {
      'ZH': _vm.styleChange || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('All')))]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab1),
      expression: "lab1"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "filter-label long-lab",
    class: {
      'choose2': _vm.lab17, 'es1': _vm.isEs, 'de1': _vm.isDe, 'po3': _vm.isPo, 'du3': _vm.isDu, 'fr1': _vm.isFr, 'sw1': _vm.isSw, 'pl3': _vm.isPl
    },
    on: {
      "click": function($event) {
        _vm.choose17()
      }
    }
  }, [_c('span', {
    class: {
      'ZH3': _vm.styleChange
    }
  }, [_vm._v(_vm._s(_vm.$t('DBTNF')))]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab17),
      expression: "lab17"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab2, 'de6': _vm.isDe || _vm.isIt, 'po4': _vm.isPo, 'fr2': _vm.isFr
    },
    on: {
      "click": _vm.choose2
    }
  }, [_c('span', {
    class: {
      'ZH3': _vm.styleChange
    }
  }, [_vm._v(_vm._s(_vm.$t('Female')))]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab2),
      expression: "lab2"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab3, 'es3': _vm.isEs, 'de6': _vm.isDe || _vm.isIt, 'po4': _vm.isPo, 'pl4': _vm.isPl
    },
    on: {
      "click": _vm.choose3
    }
  }, [_c('span', {
    class: {
      'ZH3': _vm.styleChange
    }
  }, [_vm._v(_vm._s(_vm.$t('Male')))]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab3),
      expression: "lab3"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "lab-group2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Age')))]), _vm._v(" "), _c('div', {
    staticClass: "patientList-line"
  }, [_c('div', {
    staticClass: "label1",
    class: {
      'choose': _vm.lab5, 'ZH1': _vm.styleChange, 'es2': _vm.isEs || _vm.isIt || _vm.isFr, 'de5': _vm.isDe, 'po2': _vm.isPo, 'du2': _vm.isDu, 'pl2': _vm.isPl
    },
    on: {
      "click": _vm.choose5
    }
  }, [_c('span', {
    class: {
      'ZH': _vm.styleChange || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('All')))]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab5),
      expression: "lab5"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "filter-label long-lab",
    class: {
      'choose2': _vm.lab18, 'es1': _vm.isEs, 'de1': _vm.isDe, 'po3': _vm.isPo, 'du3': _vm.isDu, 'fr1': _vm.isFr, 'sw1': _vm.isSw, 'pl3': _vm.isPl
    },
    on: {
      "click": function($event) {
        _vm.choose18()
      }
    }
  }, [_c('span', {
    class: {
      'ZH3': _vm.styleChange
    }
  }, [_vm._v(_vm._s(_vm.$t('DBTNF')))]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab18),
      expression: "lab18"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab6
    },
    on: {
      "click": _vm.choose6
    }
  }, [_c('span', [_vm._v(" < 18")]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab6),
      expression: "lab6"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab7
    },
    on: {
      "click": _vm.choose7
    }
  }, [_c('span', [_vm._v("18-40")]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab7),
      expression: "lab7"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab8, 'ZH8': _vm.styleChange
    },
    on: {
      "click": _vm.choose8
    }
  }, [_c('span', [_vm._v("41-60")]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab8),
      expression: "lab8"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label small_lab",
    class: {
      'choose1': _vm.lab9, 'ZH9': _vm.styleChange
    },
    on: {
      "click": _vm.choose9
    }
  }, [_c('span', [_vm._v("> 60")]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab9),
      expression: "lab9"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "lab-group3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Type')))]), _vm._v(" "), _c('div', {
    staticClass: "patientList-line"
  }, [_c('div', {
    staticClass: "label1",
    class: {
      'choose': _vm.lab10, 'ZH1': _vm.styleChange, 'es2': _vm.isEs || _vm.isIt || _vm.isFr, 'de5': _vm.isDe, 'po2': _vm.isPo, 'du2': _vm.isDu, 'pl2': _vm.isPl
    },
    on: {
      "click": _vm.choose10
    }
  }, [_c('span', {
    class: {
      'ZH': _vm.styleChange || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('All')))]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab10),
      expression: "lab10"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "patientList-type"
  }, [_c('div', {
    staticClass: "filter-label long-lab",
    class: {
      'choose3': _vm.lab19, 'ZH5': _vm.styleChange, 'es1': _vm.isEs, 'de1': _vm.isDe, 'po3': _vm.isPo, 'du3': _vm.isDu, 'fr1': _vm.isFr, 'sw1': _vm.isSw, 'cz1': _vm.isCz, 'pl3': _vm.isPl
    },
    on: {
      "click": _vm.choose19
    }
  }, [_c('span', {
    class: {
      'ZH3': _vm.styleChange
    }
  }, [_vm._v(_vm._s(_vm.$t('DBTNF')))]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab19),
      expression: "lab19"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab11, 'cz2': _vm.isCz
    },
    on: {
      "click": _vm.choose11
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Type 1')))]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab11),
      expression: "lab11"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab12, 'cz2': _vm.isCz
    },
    on: {
      "click": _vm.choose12
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Type 2')))]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab12),
      expression: "lab12"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label long-lab1",
    class: {
      'choose3': _vm.lab15, 'ZH2': _vm.styleChange
    },
    on: {
      "click": _vm.choose15
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('LADA')))]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab15),
      expression: "lab15"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label long-lab",
    class: {
      'choose2': _vm.lab13, 'de2': _vm.isDe, 'it6': _vm.isIt, 'du4': _vm.isDu, 'fr1': _vm.isFr, 'ZH10': _vm.styleChange, 'cz3': _vm.isCz
    },
    on: {
      "click": _vm.choose13
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Gestational')))]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab13),
      expression: "lab13"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label long-lab",
    class: {
      'choose2': _vm.lab14, 'po5': _vm.isPo, 'pl1': _vm.isPl
    },
    on: {
      "click": _vm.choose14
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Prediabetes')))]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab14),
      expression: "lab14"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label small_lab",
    class: {
      'choose1': _vm.lab16
    },
    on: {
      "click": _vm.choose16
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('OTR1')))]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab16),
      expression: "lab16"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })])])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr patientList-spe1-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "patientList-dialog-footer",
    slot: "footer"
  }, [_c('button', {
    on: {
      "click": _vm.checkFilter
    }
  }, [_vm._v(_vm._s(_vm.$t('Apply')))])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.showConfirmDialog,
      "size": _vm.dialogSize2,
      "id": "dialog-form3",
      "show-close": false,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showConfirmDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('privacy_policy_and_terms_of_use')))])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-content"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('privacy_confirm_text'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [_c('button', {
    staticClass: "deny",
    on: {
      "click": _vm.denyPrivacyConfirm
    }
  }, [_vm._v(_vm._s(_vm.$t('privacy_confirm_disagree')))]), _vm._v(" "), _c('button', {
    staticClass: "agree",
    on: {
      "click": _vm.agreePrivacyConfirm
    }
  }, [_vm._v(_vm._s(_vm.$t('privacy_confirm_accept')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "findPatient-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Add Connection')))])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right",
    class: {
      'zh1': !_vm.isEn, 'de1': _vm.isDe || _vm.isIt, 'cz1': _vm.isCz
    },
    on: {
      "click": _vm.back
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(63)
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('connections')))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isA),
      expression: "isA"
    }],
    staticClass: "search",
    class: {
      'zh2': !_vm.isEn
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Enter username (email)')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.search
    }
  }, [_vm._v(_vm._s(_vm.$t('search')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isB),
      expression: "isB"
    }],
    staticClass: "search-result"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Search results')))]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isC),
      expression: "isC"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "result"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(55)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user"
  }, [_c('p', [_vm._v(_vm._s(this.user.realname))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('uername')) + ": " + _vm._s(this.user.username))])])]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('button', {
    on: {
      "click": _vm.request
    }
  }, [_vm._v(_vm._s(_vm.$t('Send request')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isD),
      expression: "isD"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "result2"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(55)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user"
  }, [_c('p', [_vm._v(_vm._s(this.user.realname))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('uername')) + ": " + _vm._s(this.user.username))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Bio')) + ": "), _c('span', {
    on: {
      "click": function($event) {
        _vm.Remark = true
      }
    }
  }, [_vm._v(_vm._s(_vm.mark))])])])]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('button', {
    on: {
      "click": _vm.goCharts
    }
  }, [_vm._v(_vm._s(_vm.$t('View graphs')))]), _vm._v(" "), _c('button', {
    staticClass: "remove",
    on: {
      "click": _vm.Remove
    }
  }, [_vm._v(_vm._s(_vm.$t('Remove')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isE),
      expression: "isE"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "result2"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(55)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user"
  }, [_c('p', [_vm._v(_vm._s(this.user.realname))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('uername')) + ": " + _vm._s(this.user.username))])])]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('button', {
    staticClass: "remove",
    on: {
      "click": _vm.cancelRequest
    }
  }, [_vm._v(_vm._s(_vm.$t('cancelR')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n\n          " + _vm._s(_vm.$t('copyright')) + " "), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.Remark,
      "size": "tiny",
      "id": "remark-form",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.Remark = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v("Set remark")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(21)
    },
    on: {
      "click": _vm.cancel
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('p', [_vm._v("Please input remark in the following box")]), _vm._v(" "), _c('input')]), _vm._v(" "), _c('div', {
    staticClass: "patientList-dialog-footer",
    slot: "footer"
  }, [_c('button', {
    staticClass: "confirmButton"
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('button', {
    staticClass: "cancelButton",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabA),
      expression: "tabA"
    }]
  }, [_c('div', {
    staticClass: "cont-head",
    class: {
      'newStyle': !_vm.newStyle, 'DE1': _vm.isDe || _vm.isPo || _vm.isIt || _vm.isSw || _vm.isCz
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('applyHcp')))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "icon-bor"
  }, [_c('select', {
    attrs: {
      "id": "chooseCountry"
    },
    on: {
      "change": _vm.select
    }
  }, [_c('option', {
    attrs: {
      "value": "GB"
    }
  }, [_vm._v("United Kingdom (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AU"
    }
  }, [_vm._v("Australia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CN"
    }
  }, [_vm._v("中国 (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "HKF"
    }
  }, [_vm._v("香港(中国) (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TH"
    }
  }, [_vm._v("Thailand (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ID"
    }
  }, [_vm._v("Indonesia (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MY"
    }
  }, [_vm._v("Malaysia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "IN"
    }
  }, [_vm._v("India (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FR"
    }
  }, [_vm._v("France (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DE"
    }
  }, [_vm._v("Deutschland (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DD"
    }
  }, [_vm._v("Deutschland (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "HU"
    }
  }, [_vm._v("Magyarország (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "IT"
    }
  }, [_vm._v("Italia (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NL"
    }
  }, [_vm._v("Nederland (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Nor"
    }
  }, [_vm._v("Norge (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PT"
    }
  }, [_vm._v("Portugal (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ES"
    }
  }, [_vm._v("España (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SE"
    }
  }, [_vm._v("Sverige (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TR"
    }
  }, [_vm._v("Turkey (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Ro"
    }
  }, [_vm._v("Romania (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CZ"
    }
  }, [_vm._v("Czech republika (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SK"
    }
  }, [_vm._v("Slovenska republika (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LT"
    }
  }, [_vm._v("Lithuania (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PL"
    }
  }, [_vm._v("Polska (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DK"
    }
  }, [_vm._v("Danmark (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FI"
    }
  }, [_vm._v("Suomi (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CH"
    }
  }, [_vm._v("Switzerland (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SA"
    }
  }, [_vm._v("Saudi  (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AE"
    }
  }, [_vm._v("United Arab (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QA"
    }
  }, [_vm._v("Qatar  (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QW"
    }
  }, [_vm._v("Kuwait (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RH"
    }
  }, [_vm._v("Croatia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AT"
    }
  }, [_vm._v("Austria (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SI"
    }
  }, [_vm._v("Slovenia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EE"
    }
  }, [_vm._v("Estonia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LV"
    }
  }, [_vm._v("Latvia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BA"
    }
  }, [_vm._v("Bosnia and Herzegovina (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BG"
    }
  }, [_vm._v("Bulgaria (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CL"
    }
  }, [_vm._v("Chile (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BE"
    }
  }, [_vm._v("Belgium (mg/L)")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-bor",
    class: {
      'in': _vm.isI, 'vuerify-invalid': _vm.isR
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": _vm.disE,
      "placement": "top",
      "effect": "light"
    }
  }, [_c('div', {
    staticClass: "tooltip",
    slot: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('errtip5')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.nam
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "focus": function($event) {
        _vm.check57(0)
      },
      "blur": function($event) {
        _vm.check57(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "icon-bor",
    class: {
      'in': _vm.isJ, 'vuerify-invalid': _vm.isS
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": _vm.disF,
      "placement": "top",
      "effect": "light"
    }
  }, [_c('div', {
    staticClass: "tooltip",
    slot: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('errtip7')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization),
      expression: "organization"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.org
    },
    domProps: {
      "value": (_vm.organization)
    },
    on: {
      "focus": function($event) {
        _vm.check58(0)
      },
      "blur": function($event) {
        _vm.check58(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.organization = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isD),
      expression: "isD"
    }],
    staticClass: "icon-bor",
    class: {
      'in': _vm.isF, 'vuerify-invalid': _vm.isO, 'It2': _vm.isIt
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": _vm.disA,
      "placement": "top",
      "effect": "light",
      "offset": "-30"
    }
  }, [_c('div', {
    staticClass: "tooltip",
    slot: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('errtip1-1')))]), _c('br'), _c('span', [_vm._v(_vm._s(_vm.$t('errtip1-2')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    class: {
      'DE2': _vm.isDe
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.ema
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "focus": function($event) {
        _vm.check54(0)
      },
      "blur": function($event) {
        _vm.check54(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "icon-bor",
    class: {
      'in': _vm.isK, 'vuerify-invalid': _vm.isT
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": _vm.disB,
      "placement": "top",
      "effect": "light"
    }
  }, [_c('div', {
    staticClass: "tooltip",
    slot: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('errtip2')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    class: {
      'DE2': _vm.isDe
    },
    attrs: {
      "placeholder": _vm.phone
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "focus": function($event) {
        _vm.check59(0)
      },
      "blur": function($event) {
        _vm.check59(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "operate",
    class: [_vm.isA ? 'xSelect' : 'xnoSelect']
  }), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.register
    }
  }, [_c('button', {
    staticClass: "register",
    class: {
      'click': true, 'DE2': _vm.isDe
    },
    attrs: {
      "disabled": !_vm.isNext
    }
  }, [_vm._v(_vm._s(_vm.$t('Next')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabB),
      expression: "tabB"
    }]
  }, [_c('div', {
    staticClass: "policy-wrap"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEU),
      expression: "isEU"
    }]
  }, [_c('p', [_vm._v("We will only process your Healthcare data through Medtrum App/website with your consent.")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "check",
    class: [_vm.isA ? 'Select' : 'noSelect']
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": function($event) {
        _vm.check1()
      }
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "check",
    class: [_vm.isA2 ? 'Select' : 'noSelect']
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": function($event) {
        _vm.check1_2()
      }
    }
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEU),
      expression: "!isEU"
    }]
  }, [_c('p', [_vm._v("We will only process your Healthcare data through Medtrum App/website with your consent.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "check",
    class: [_vm.isA ? 'Select' : 'noSelect']
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": function($event) {
        _vm.check1()
      }
    }
  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "check",
    class: [_vm.isA2 ? 'Select' : 'noSelect']
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": function($event) {
        _vm.check1_2()
      }
    }
  }), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "send-apply",
    class: {
      'click': _vm.isAgree, 'newStyle1': !_vm.newStyle
    },
    attrs: {
      "disabled": !_vm.isAgree
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v(_vm._s(_vm.$t('send')))]), _vm._v(" "), _c('span', {
    staticClass: "back-link"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.registerBack()
      }
    }
  }, [_vm._v("Back")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabA1),
      expression: "tabA1"
    }],
    staticClass: "tabA1"
  }, [_c('div', {
    staticClass: "policy-wrap"
  }, [_c('div', [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('hcp_apply_user_exist'))
    }
  }, [_vm._v("This email address has been used by a patient/caregiver account. If you want to switch to an HCP account, choose Next.\n          ")]), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "next_step",
    on: {
      "click": _vm.nextStepA1
    }
  }, [_vm._v(_vm._s(_vm.$t('Next')))])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "back"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.prevStepA1
    }
  }, [_vm._v(_vm._s(_vm.$t('Back')))])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabA2),
      expression: "tabA2"
    }],
    staticClass: "tabA2"
  }, [_c('div', {
    staticClass: "policy-wrap"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Enter veri')))])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    attrs: {
      "id": "check_email_for_code"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('check_email_for_code'))
    }
  }), _c('br'), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "try_again",
    class: {
      'try_enable': _vm.try_enable
    },
    on: {
      "click": _vm.tryAgainProc
    }
  }, [_vm._v(_vm._s(_vm.$t('try_again')) + " " + _vm._s(this.try_timer_text))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "veri_code icon-spe2",
    class: {
      'veri_focus': _vm.veri_focus
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.veri_code),
      expression: "veri_code"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.veri_placeholder
    },
    domProps: {
      "value": (_vm.veri_code)
    },
    on: {
      "focus": function($event) {
        _vm.checkVeriCode()
      },
      "blur": function($event) {
        _vm.checkVeriCode()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.veri_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "next_step",
    on: {
      "click": _vm.nextStepA2
    }
  }, [_vm._v(_vm._s(_vm.$t('Next')))]), _vm._v(" "), _c('button', {
    staticClass: "cancel",
    on: {
      "click": _vm.prevStepA2
    }
  }, [_vm._v(_vm._s(_vm.$t('Back')))])]), _vm._v(" "), (false) ? _c('div', [_c('p', {
    staticClass: "back"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.prevStepA2
    }
  }, [_vm._v(_vm._s(_vm.$t('Back')))])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabA3),
      expression: "tabA3"
    }],
    staticClass: "tabA3"
  }, [_c('div', {
    staticClass: "policy-wrap"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Completed')))])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('application_has_been_submitted')))]), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "bottom_btn"
  }, [_c('button', {
    staticClass: "next_step",
    on: {
      "click": _vm.signInNow
    }
  }, [_vm._v(_vm._s(_vm.$t('OK')))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1299)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("I Agree to "), _c('a', {
    attrs: {
      "href": "http://www.medtrum.co.uk/terms_of_use.html",
      "target": "_blank"
    }
  }, [_vm._v("the Terms of Use of Medtrum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("I Agree to "), _c('a', {
    attrs: {
      "href": "http://www.medtrum.co.uk/privacy_policy.html",
      "target": "_blank"
    }
  }, [_vm._v("the Privacy Policy of Medtrum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("I Agree to "), _c('a', {
    attrs: {
      "href": "http://www.medtrum.co.uk/terms_of_use.html",
      "target": "_blank"
    }
  }, [_vm._v("the Terms of Use of Medtrum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("I Agree to "), _c('a', {
    attrs: {
      "href": "http://www.medtrum.com/privacy_policy.html",
      "target": "_blank"
    }
  }, [_vm._v("the Privacy Policy of Medtrum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(221)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(221)
    }
  })])
}]}

/***/ }),
/* 1464 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  })
},staticRenderFns: []}

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background",
    class: {
      'page4': _vm.page4
    },
    attrs: {
      "id": "background"
    }
  }, [_c('div', {
    staticClass: "chart-container",
    class: {
      'page4': _vm.page4
    },
    attrs: {
      "id": "chart-container"
    }
  }, [_c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Device Settings Report')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.$t('Device Settings at')) + " " + _vm._s(_vm.time))])])]), _vm._v(" "), _c('table', {
    staticClass: "status-table1",
    class: {
      'zh1': !_vm.isEn, 'de1': _vm.isDe || _vm.isFr
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('uername')))]), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.username))]), _vm._v(" "), _c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('fullName')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('devices')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.pdmTitle))]), _vm._v(" "), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.pdmSN))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('tran')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.tranSN))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('pumpBase')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.pumpSN))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td4"
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _c('td', {
    staticClass: "td4",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v(_vm._s(_vm.statics.medical_history))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('basal')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('MaxBasalRate')) + ": " + _vm._s(_vm.basal.max_rate) + " " + _vm._s(_vm.$t('basal_unit2')))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Selected Basal Pattern')) + ": " + _vm._s(_vm.basal.basal_select))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('BasalPatterns')) + ": " + _vm._s(_vm.basal.basal_onoff))])])])]), _vm._v(" "), _c('div', {
    staticClass: "context"
  }, [_c('img', {
    staticClass: "graph",
    attrs: {
      "id": "img6_1"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "graph",
    attrs: {
      "id": "img6_2"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "graph",
    attrs: {
      "id": "img6_3"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "graph",
    attrs: {
      "id": "img6_4"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "graph",
    attrs: {
      "id": "img6_5"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.moreBasal),
      expression: "moreBasal"
    }]
  }, [_c('img', {
    staticClass: "graph",
    attrs: {
      "id": "img6_6"
    }
  }), _vm._v(" "), (_vm.moreBasal) ? _c('div', [_c('div', {
    staticClass: "page-seperator2"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "graph",
    attrs: {
      "id": "img6_7"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "graph",
    attrs: {
      "id": "img6_8"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.moreBasal),
      expression: "!moreBasal"
    }]
  }, [_c('div', {
    staticClass: "page-seperator5"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })])]), _vm._v(" "), _vm._l((this.basalInfo), function(item, index) {
    return _c('div', [(index == _vm.basalPagePos + 1) ? _c('div', [_c('div', [_c('div', {
      staticClass: "page-seperator45",
      class: {
        'sep6': _vm.basalPageSep6
      },
      attrs: {
        "id": 'basalPage' + index
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "page-starter"
    })])]) : _vm._e(), _vm._v(" "), (index == _vm.basalPagePos2 + 1) ? _c('div', [_c('div', [_c('div', {
      staticClass: "page-seperator3",
      attrs: {
        "id": 'basalPage2' + index
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "page-starter"
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "statics"
    }, [_c('p', {
      staticClass: "custom"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "margin-right": "30px"
      }
    }, [_vm._v(_vm._s(_vm.$t('24h Total')) + ": " + _vm._s(item.total) + _vm._s(_vm.$t('ins_unit2')))]), _vm._v(" "), _c('table', {
      staticClass: "statics-table"
    }, [_c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('Start')))]), _vm._l((item.bsg1), function(i) {
      return _c('td', {
        staticClass: "td1"
      }, [_vm._v(_vm._s(i[0]))])
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(_vm.$t('basal_unit2')))]), _vm._l((item.bsg1), function(i) {
      return _c('td', {
        staticClass: "td3"
      }, [_vm._v(_vm._s(i[1]))])
    })], 2)])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((item.bsg2show)),
        expression: "(item.bsg2show)"
      }],
      staticClass: "statics"
    }, [_c('table', {
      staticClass: "statics-table"
    }, [_c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('Start')))]), _vm._l((item.bsg2), function(i) {
      return _c('td', {
        staticClass: "td1"
      }, [_vm._v(_vm._s(i[0]))])
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(_vm.$t('basal_unit2')))]), _vm._l((item.bsg2), function(i) {
      return _c('td', {
        staticClass: "td3"
      }, [_vm._v(_vm._s(i[1]))])
    })], 2)])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((item.bsg3show)),
        expression: "(item.bsg3show)"
      }],
      staticClass: "statics"
    }, [_c('table', {
      staticClass: "statics-table"
    }, [_c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('Start')))]), _vm._l((item.bsg3), function(i) {
      return _c('td', {
        staticClass: "td1"
      }, [_vm._v(_vm._s(i[0]))])
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(_vm.$t('basal_unit2')))]), _vm._l((item.bsg3), function(i) {
      return _c('td', {
        staticClass: "td3"
      }, [_vm._v(_vm._s(i[1]))])
    })], 2)])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((item.bsg4show)),
        expression: "(item.bsg4show)"
      }],
      staticClass: "statics"
    }, [_c('table', {
      staticClass: "statics-table"
    }, [_c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.$t('Start')))]), _vm._l((item.bsg4), function(i) {
      return _c('td', {
        staticClass: "td1"
      }, [_vm._v(_vm._s(i[0]))])
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(_vm.$t('basal_unit2')))]), _vm._l((item.bsg4), function(i) {
      return _c('td', {
        staticClass: "td3"
      }, [_vm._v(_vm._s(i[1]))])
    })], 2)])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bolusStartPage.show),
      expression: "bolusStartPage.show"
    }]
  }, [_c('div', {
    staticClass: "page-seperator4",
    attrs: {
      "id": "bolusStartPage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('bolus')))]), _vm._v(" "), (!_vm.showEasyPatch) ? _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Maximum Bolus')) + ": " + _vm._s(_vm.bolus.max_bolus) + " " + _vm._s(_vm.$t('ins_unit2')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Bolus Increment')) + ": " + _vm._s(_vm.bolus.bolus_step) + " " + _vm._s(_vm.$t('ins_unit2')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Bolus Calculator')) + ": " + _vm._s(_vm.bolus.bolus_wizard))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Combo/Ext Bolus')) + ": " + _vm._s(_vm.bolus.extent_option))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('BG Reminder')) + ": " + _vm._s(_vm.bolus.bg_reminder))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Active Insulin Time')) + ": " + _vm._s(_vm.bolus.ins_active_time) + " H")])])]) : _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Maximum Bolus')) + ": " + _vm._s(_vm.bolus.max_bolus) + " " + _vm._s(_vm.$t('ins_unit2')))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Bolus Calculator')) + ": " + _vm._s(_vm.bolus.bolus_wizard))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Active Insulin Time')) + ": " + _vm._s(_vm.bolus.ins_active_time) + " ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('IC Ratios')) + "(g/" + _vm._s(_vm.$t('ins_unit2')) + ")")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Start')))]), _vm._l((_vm.IcRatio), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('carbs')))]), _vm._l((_vm.IcRatio), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[1]))])
  }), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', [_vm._v("--")])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('Insulin Sensitivity')) + " " + _vm._s(_vm.unit))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Start')))]), _vm._l((_vm.ins_sen), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('BG')))]), _vm._l((_vm.ins_sen), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[1]))])
  }), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', [_vm._v("--")])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('BG Target')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('From')))]), _vm._l((_vm.bg_target), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Range')))]), _vm._l((_vm.bg_target), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[1]))])
  }), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', [_vm._v("--")])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('Bolus Reminder')) + " " + _vm._s(_vm.maxBolOption))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('From')))]), _vm._l((_vm.bolus_rem), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._l((_vm.bolus_rem), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[1]))])
  }), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', [_vm._v("--")])], 2)])]), _vm._v(" "), (!_vm.showEasyPatch) ? _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pdmStartPage.show),
      expression: "pdmStartPage.show"
    }]
  }, [_c('div', {
    staticClass: "page-seperator4",
    attrs: {
      "id": "pdmStartPage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('pdm')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Audio Options')) + ": " + _vm._s(_vm.userset.alarm_type))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Patch Expiration')) + ":" + _vm._s(_vm.userset.patch_expire_alarm))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Sensor Expiration')) + ": " + _vm._s(_vm.userset.sensor_expire_option))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Low Reservoir')) + ": " + _vm._s(_vm.userset.low_reservoir_time))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Auto Off')) + ": " + _vm._s(_vm.userset.auto_off_option))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Confidence Reminder')) + ": " + _vm._s(_vm.userset.cmd_response))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Hourly Max')) + ": " + _vm._s(_vm.userset.hour_bolus_max) + _vm._s(_vm.$t('ins_unit2')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Daily Max')) + ": " + _vm._s(_vm.userset.day_bolus_max) + _vm._s(_vm.$t('ins_unit2')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Low Suspend')) + ": " + _vm._s(_vm.userset.suspend_on_lowbg_option))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Predictive Low Suspend')) + ": " + _vm._s(_vm.userset.pre_suspend_on_lowbg_option))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Time Format')) + ": " + _vm._s(_vm.userset.time_style))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('uername')) + ": " + _vm._s(_vm.userset.user_name))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Dispay Settings (Screen)')) + ": " + _vm._s(_vm.userset.screen_timeout) + _vm._s(_vm.$t('Sec')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Dispay Settings (Backlight)')) + ": " + _vm._s(_vm.userset.screen_timeout) + _vm._s(_vm.$t('Sec')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Device Options（CGM System)')) + ": " + _vm._s(_vm.userset.cgms_module_flag))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Device Options（Insulin Pump)')) + ": " + _vm._s(_vm.userset.pump_module_flag))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Glucose Unit')) + ": " + _vm._s(_vm.userset.glucose_unit))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Alarm Clock')) + " : " + _vm._s(_vm.userset.clock_option))]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('Alarm Clock')) + " (" + _vm._s(_vm.userset.clock_option) + ")")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('time')))]), _vm._l((_vm.userset.clock), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._l((_vm.userset.clock), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[1]))])
  }), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', [_vm._v("--")])], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cgmStartPage.show),
      expression: "cgmStartPage.show"
    }]
  }, [_c('div', {
    staticClass: "page-seperator3",
    class: {
      'sep5': _vm.cgmSep5
    },
    attrs: {
      "id": "cgmStartPage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('CGM')))]), _vm._v(" "), _c('div', {
    staticClass: "spe-text"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Glucose Alerts')) + ":  " + _vm._s(_vm.cgm.sensor_alarm_option))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Alert Silence')) + ":  " + _vm._s(_vm.cgm.alarm_silent_option))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('Glucose Limits')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('From')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Low')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[1]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('High')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[2]))])
  }), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', [_vm._v("--")])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('Predicitive Alerts')) + " (hh:mm)")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('high1')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.high[0]))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.high[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('low1')))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.low[0]))]), _c('td', [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.low[1]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('Rate Alerts')) + " (" + _vm._s(_vm.unit1) + "/min)")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Rise')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.rise[0]))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.rise[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Fall')))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.fall[0]))]), _c('td', [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.fall[1]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('Snooze')) + " (hh:mm)")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('high1')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_alarm_repeat.high[0]))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_alarm_repeat.high[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('low1')))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_alarm_repeat.low[0]))]), _c('td', [_vm._v(_vm._s(_vm.cgm.sensor_alarm_repeat.low[1]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics middle-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('calib')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Calibration Reminder')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_alarm_settings.calib_remind_option))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_alarm_settings.calib_remind_time))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Calibration Repeat')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_alarm_settings.calib_remind_interval))]), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Graph Range')))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_alarm_settings.trend_time_scope) + "H")]), _c('td')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "part statics"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.$t('t1222_Auto_Mode')))]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "spe-text"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('t1222_Auto_Mode')) + ":  " + _vm._s(_vm.userset.auto_basal.autobasalflag))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Target_SG')) + ": " + _vm._s(_vm.userset.auto_basal.BGTarget))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Auto_Meal_Handling')) + ": " + _vm._s(_vm.userset.auto_basal.nFoodFlag))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('weight')) + ": " + _vm._s(_vm.userset.auto_basal.AutoBasalWeight) + " kg ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Total_Daily_Dose')) + ": " + _vm._s(_vm.userset.auto_basal.AutoBasalTDD) + " U")]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }), _vm._v(" "), _c('td', {
    staticClass: "td3"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-end"
  })]) : _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pumpStartPage.show),
      expression: "pumpStartPage.show"
    }]
  }, [_c('div', {
    staticClass: "page-seperator3",
    attrs: {
      "id": "pumpStartPage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]), _vm._v(" "), _c('div', {
    staticClass: "part part1"
  }, [_c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Pump')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1108_Pump_Bash_SN')) + ": " + _vm._s(_vm.pumpSN))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Patch Expiration')) + ":" + _vm._s(_vm.userset.patch_expire_alarm))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Low Reservoir')) + ": " + _vm._s(_vm.userset.low_reservoir_time))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1102_Out_of_Range')) + ": " + _vm._s(_vm.userset.out_of_range_option))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1102_Command_Reminder')) + ": " + _vm._s(_vm.userset.cmd_response))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Auto Off')) + ": " + _vm._s(_vm.userset.auto_off_option))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Daily Max')) + ": " + _vm._s(_vm.userset.day_bolus_max) + _vm._s(_vm.$t('ins_unit2')))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Hourly Max')) + ": " + _vm._s(_vm.userset.hour_bolus_max) + _vm._s(_vm.$t('ins_unit2')))]), _vm._v(" "), _c('td', {})])])]), _vm._v(" "), _c('div', {
    staticClass: "small-table-wrap"
  }, [_c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alarms_Alerts_on_APP')) + " ")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Audio')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.userset.pump_alarm_audio_option))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Vibrate')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.userset.pump_alarm_vibrate_option))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Pump_Light')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.userset.easypatch_pump_light))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alarms_on_App')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.userset.easypatch_pump_alarm_repeat))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Snooze')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.userset.easypatch_pump_alarm_snooze))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userset.easypatch_pump_alarm_tone.split('.')[0]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alerts_on_App')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.userset.easypatch_pump_alert_repeat))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Snooze')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.userset.easypatch_pump_alert_snooze))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userset.easypatch_pump_alert_tone.split('.')[0]))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('CGM')))]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1108_Transmitter_SN')) + ": " + _vm._s(_vm.tranSN))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Sensor Expiration')) + ":" + _vm._s(_vm.userset.sensor_expire_option))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Glucose Alerts')) + ": " + _vm._s(_vm.cgm.sensor_alarm_option))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1102_Factory_Calibration')) + ": " + _vm._s(_vm.userset.factory_calibration_option))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }), _vm._v(" "), _c('td', {
    staticClass: "td3"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('Glucose Limits')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('From')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[0]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Low')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(i[1]))])
  }), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td2"
  }, [_vm._v("--")])], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('High')))]), _vm._l((_vm.cgmLimit), function(i) {
    return _c('td', {
      staticClass: "td3"
    }, [_vm._v(_vm._s(i[2]))])
  }), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', {
    staticClass: "td3"
  }, [_vm._v("--")]), _c('td', [_vm._v("--")])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "table-group-wrap1"
  }, [_c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('Predicitive Alerts')) + " (hh:mm)")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('high1')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.high[0]))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.high[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('low1')))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.low[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.sensor_forecast_alarm.low[1]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('Rate Alerts')) + " (" + _vm._s(_vm.unit1) + "/min)")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Rise')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.rise[0]))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.rise[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Fall')))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.fall[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.sensor_rate_alarm.fall[1]))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-group-wrap1"
  }, [_c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alerts_for_Low')) + " ")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_low_repeat))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Snooze')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_low_snooze))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_low_tone))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alerts_for_High')) + " ")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_high_repeat))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Snooze')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_high_snooze))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_high_tone))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1102_Alerts_for_Others')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Repeat')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_other_repeat))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Snooze')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_other_snooze))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_other_tone))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics small-table"
  }, [_c('p', {
    staticClass: "custom",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1029_Alerts_for_Hypo')) + " ")]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Tone')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cgm.easypatch_cgm_alerts_hypo_tone))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.appStartPage.show),
      expression: "appStartPage.show"
    }]
  }, [_c('div', {
    staticClass: "page-seperator3",
    attrs: {
      "id": "appStartPage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('APP')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Name')) + ": " + _vm._s(_vm.userset.user_name))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Audio Options')) + ": " + _vm._s(_vm.userset.alarm_type))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Glucose Unit')) + ": " + _vm._s(_vm.userset.glucose_unit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Weight_Unit')) + ": " + _vm._s(_vm.userset.easypatch_weight_unit))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1112_Height_Unit')) + ": " + _vm._s(_vm.userset.easypatch_height_unit))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('EasyLoop')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Low Suspend')) + ": " + _vm._s(_vm.userset.suspend_on_lowbg_option))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Predictive Low Suspend')) + ":  " + _vm._s(_vm.userset.pre_suspend_on_lowbg_option))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "statics",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('t1222_Auto_Mode')))]), _vm._v(" "), _c('div', {
    staticClass: "spe-text"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('t1222_Auto_Mode')) + ":  " + _vm._s(_vm.userset.auto_basal.autobasalflag))])]), _vm._v(" "), _c('div', {
    staticClass: "statics",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Target_SG')) + ": " + _vm._s(_vm.userset.auto_basal.BGTarget))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Auto_Meal_Handling')) + ": " + _vm._s(_vm.userset.auto_basal.nFoodFlag))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('weight')) + ": " + _vm._s(_vm.userset.auto_basal.AutoBasalWeight) + " kg ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('t1029_Total_Daily_Dose')) + ": " + _vm._s(_vm.userset.auto_basal.AutoBasalTDD) + " U")]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }), _vm._v(" "), _c('td', {
    staticClass: "td3"
  })])])])])])])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(19)
    }
  })])
}]}

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "header-content"
  }, [_c('img', {
    staticClass: "patientList-logo",
    attrs: {
      "src": __webpack_require__(19)
    },
    on: {
      "click": _vm.home
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "patientList-user"
  }, [_c('div', {
    staticClass: "recent-updates"
  }, [(_vm.isHcpDoctor) ? _c('p', [_c('a', {
    attrs: {
      "href": "/static/Recent_update_hcp.pdf",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1105_Recent_Updates')))])]) : _c('p', [_c('a', {
    attrs: {
      "href": "/static/Recent_update.pdf",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1105_Recent_Updates')))])])]), _vm._v(" "), _c('img', {
    staticClass: "portrait",
    attrs: {
      "src": _vm.portrait
    }
  }), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "id": "dropdown"
    },
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('label', [_vm._v(_vm._s(_vm.username)), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.messageTip),
      expression: "messageTip"
    }],
    staticClass: "messageTip"
  })]), _vm._v(" "), _c('img', {
    staticClass: "patientList-drown",
    attrs: {
      "src": __webpack_require__(496)
    }
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "id": "dropdown-menu"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHcp),
      expression: "isHcp"
    }],
    attrs: {
      "command": "messages"
    }
  }, [_vm._v(_vm._s(_vm.$t('messages'))), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.messageTip),
      expression: "messageTip"
    }],
    staticClass: "messageTip"
  })]), _vm._v(" "), _c('el-dropdown-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHcp),
      expression: "!isHcp"
    }],
    attrs: {
      "command": "connect"
    }
  }, [_vm._v(_vm._s(_vm.$t('connection'))), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.messageTip),
      expression: "messageTip"
    }],
    staticClass: "messageTip"
  })]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "profile"
    }
  }, [_vm._v(_vm._s(_vm.$t('profile')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "changePassword"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1215_Security')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": "",
      "command": "loginOut"
    }
  }, [_vm._v(_vm._s(_vm.$t('sign out')))])], 1)], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1467 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setting-container"
  }, [_c('div', {
    staticClass: "setting-operate"
  }, [_c('button', {
    staticClass: "operate-spe3",
    class: {
      'operate-spe1': _vm.isA, 'es1': _vm.isEs, 'po1': _vm.isPo
    },
    on: {
      "click": _vm.changeStype1
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('staticSettings')))])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isM),
      expression: "isM"
    }],
    staticClass: "operate-spe3",
    class: {
      'operate-spe1': _vm.isB, 'po1': _vm.isFr
    },
    on: {
      "click": _vm.changeStype2
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('dataSource')))])])]), _vm._v(" "), _c('el-card', {
    staticClass: "setting-main"
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1468 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  })
},staticRenderFns: []}

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "chart-container",
    attrs: {
      "id": "container"
    }
  }, [_c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('dboard_report')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.$t('date')) + ":" + _vm._s(_vm.time))])])]), _vm._v(" "), _c('table', {
    staticClass: "status-table1",
    class: {
      'zh1': !_vm.isEn, 'de1': _vm.isDe || _vm.isIt
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('uername')))]), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.username))]), _vm._v(" "), _c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('fullName')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('devices')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "id": "reportPdmTitle"
    }
  }, [_vm._v(_vm._s(_vm.$t('pdm')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('tran')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('pumpBase')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[2]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td4"
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _c('td', {
    staticClass: "td4",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v(_vm._s(_vm.statics.medical_history))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "width": "94%",
      "margin": "10px auto"
    }
  }, [_vm._v(_vm._s(_vm.$t("dboard_glucose_statistics")))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "rb bb",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_glucose')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_cgm')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_insulin')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_carbs')))]), _vm._v(" "), _c('td', {
    staticClass: "bb",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_exercise')))])]), _vm._v(" "), _c('tr', {
    staticClass: "trh1"
  }, [_c('td', {
    staticClass: "rb ",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_glucose_avg')))]), _vm._v(" "), _c('td', {
    staticClass: "rb ",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_cgm_avg')))]), _vm._v(" "), _c('td', {
    staticClass: "rb ",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_insulin_avg')))]), _vm._v(" "), _c('td', {
    staticClass: "rb ",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_carbs_avg')))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_exercise_avg')))])]), _vm._v(" "), _c('tr', {
    staticClass: "trh1"
  }, [_c('td', {
    staticClass: "rb bb sp",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "bbv"
  }, [_vm._v(_vm._s(_vm.bgAvg))]), _vm._v(" " + _vm._s(_vm.glucoseUnit))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "bbv"
  }, [_vm._v(_vm._s(_vm.sgAvg))]), _vm._v(" " + _vm._s(_vm.glucoseUnit))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "bbv"
  }, [_vm._v(_vm._s(_vm.insAvg))]), _vm._v(" " + _vm._s(_vm.$t('ins_unit2')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "bbv"
  }, [_vm._v(_vm._s(_vm.carbAvg))]), _vm._v(" g")]), _vm._v(" "), (_vm.exerAvgHour == 0) ? _c('td', {
    staticClass: "bb",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "bbv"
  }, [_vm._v(_vm._s(_vm.exerAvg))]), _vm._v(_vm._s(_vm.$t('t1112_min')))]) : _c('td', {
    staticClass: "bb",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "bbv"
  }, [_vm._v(_vm._s(_vm.exerAvgHour))]), _vm._v(_vm._s(_vm.$t('Hours')) + "   "), _c('span', {
    staticClass: "bbv"
  }, [_vm._v(_vm._s(_vm.exerAvg))]), _vm._v(" " + _vm._s(_vm.$t('t1112_min')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_sd')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_num')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_sd')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_num')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_sd')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('t1112_days')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_sd')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_num')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_sd')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_num')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.bgSD))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.bgNum))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.sgSD))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.sgNum))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.insSD))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.insNum))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.carbSD))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.carbNum))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.exerSD))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.exerNum))])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "est-a1c"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "est-title"
  }, [_vm._v(_vm._s(_vm.$t("est_a1c_t1")))]), _vm._v(" "), (_vm.a1c_available) ? _c('span', [_c('span', [_vm._v(_vm._s(_vm.est_a1c) + "  ")]), _c('span', [_vm._v(_vm._s(_vm.$t("est_a1c_t2")))])]) : _c('span', [_c('span', [_vm._v(_vm._s(_vm.$t('t1112_Not_available')))])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "x_est-ita"
  }, [_vm._v(_vm._s(_vm.$t("est_a1c_t3")))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "graph2",
    attrs: {
      "id": "chart1_4"
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "id": "img1_1"
    }
  })])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "row1"
  }, [_c('div', {
    staticClass: "left-table"
  }, [_c('p', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_statistics')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_BG')))]), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_BG_calibration')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.bgPerDay) + " / " + _vm._s(_vm.calibPerDay))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_SG')))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_AUC_high')) + " " + _vm._s(_vm.highLevelText))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.aucu))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_AUC_low')) + " " + _vm._s(_vm.lowLevelText))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.aucl))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_highest_value')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.sgHighest))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_lowest_value')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.sgLowest))])])]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "rb",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_pump')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_daily_basal')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.basalPercent))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_daily_bolus')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.bolusPercent))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_avg_bolus_num')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgBolusNum))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_avg_suspend_time')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgSuspendTime))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_avg_reservoir_usage')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.patchAvgLife) + " " + _vm._s(_vm.$t('t1113_days')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "right-chart"
  }, [_c('div', {
    attrs: {
      "id": "chart1_5"
    }
  }, [_c('img', {
    staticClass: "img",
    class: {
      'hide': _vm.chart5NoData
    },
    attrs: {
      "id": "img1_2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "chart_title",
    class: {
      'hide': _vm.chart5NoData
    }
  }, [_vm._v("Overall: Time In Range")]), _vm._v(" "), _c('p', {
    class: {
      'hide': !_vm.chart5NoData
    },
    attrs: {
      "id": "chart1_5_no_data"
    }
  }, [_vm._v("No data")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "row2 left-table"
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "rb bb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_manual_bolus')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgManualBolus))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb bb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_normal')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgManualNormalBolus))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb bb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_extend')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgManualExtendBolus))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_combo')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.avgManualComboBolus))])])]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "rb bb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_bolus_calculator')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgWizzardBolus))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb bb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_food_bolus')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgFoodWizzardBolus))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_corr_bolus')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.avgCorrWizzardBolus))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb bb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_override_add')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgWizzardOverrideAdd))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_override_sub')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.avgWizzardOverrideSub))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row2 right-chart",
    attrs: {
      "id": "chart1_6"
    }
  }, [_c('img', {
    staticClass: "img",
    class: {
      'hide': _vm.chart6NoData
    },
    attrs: {
      "id": "img1_3"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "chart_title",
    class: {
      'hide': _vm.chart6NoData
    }
  }, [_vm._v(" Basal & Bolus")]), _vm._v(" "), _c('p', {
    class: {
      'hide': !_vm.chart6NoData
    },
    attrs: {
      "id": "chart1_6_no_data"
    }
  }, [_vm._v("No data")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "row1"
  }, [_c('div', {
    staticClass: "left-table"
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: " rb",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Auto_Mode')))]), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Time_in_Auto_Mode')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.timeInAutoMode))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: " rb",
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Average_SG_SD')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.autoModeSGAvgSD) + " " + _vm._s(_vm.glucoseUnit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: " rb",
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Time_in_Target_Range')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.autoModeSGInTargetRange))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: " rb",
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Time_above_Range')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.autoModeSGAboveRange))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: " rb",
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Time_below_Range')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.autoModeSGBelowRange))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: " rb",
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Auto_Basal_per_day')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.autoModeBasalPerDay))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Auto_Bolus_per_day')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.autoModeBolusPerDay))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('t1221_Auto_Mode_Exits')))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('t1221_No_Sensor_readings')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.autoModeExitCauseNoSensorReadings))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('t1221_Max_Delivery')) + " ")]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.autoModeExitCauseMaxDelivery))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('t1221_Min_Delivery')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.autoModeExitCauseMinDelivery))])])])]), _vm._v(" "), _c('div', {
    staticClass: "right-chart"
  }, [_c('img', {
    staticClass: "img",
    class: {
      'hide': _vm.chart7NoData
    },
    attrs: {
      "id": "img1_4"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "chart_title",
    class: {
      'hide': _vm.chart7NoData
    }
  }, [_vm._v(" Auto Mode: Time In Range")]), _vm._v(" "), _c('p', {
    class: {
      'hide': !_vm.chart7NoData
    },
    attrs: {
      "id": "chart1_7_no_data"
    }
  }, [_vm._v("No data")])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-end"
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(19)
    }
  })])
}]}

/***/ }),
/* 1470 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData.slice((_vm.currentPage - 1) * _vm.pagesize, _vm.currentPage * _vm.pagesize),
      "tooltip-effect": "dark",
      "border": "",
      "element-loading-text": "拼命加载中"
    }
  }, [_c('template', {
    slot: "empty"
  }, [_c('p', [_vm._v(_vm._s(_vm.dataText))])]), _vm._v(" "), _vm._l((_vm.tabType), function(item) {
    return _c('el-table-column', {
      key: item.index,
      attrs: {
        "label": item.label,
        "prop": item.prop,
        "width": item.width
      }
    }, _vm._l((item.child), function(inner) {
      return _c('el-table-column', {
        key: inner.index,
        attrs: {
          "label": inner.label,
          "prop": inner.prop,
          "width": inner.width
        }
      })
    }))
  })], 2), _vm._v(" "), (this.total !== 0) ? _c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pagesize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.current_change
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newPatient-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v("HCP User Info")])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right",
    class: {
      'de22': _vm.isDe || _vm.isFr, 'cz22': _vm.isCz
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(63)
    }
  }), _vm._v(" "), _c('p', {
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t('Users')))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('span', {
    class: {
      'es5': _vm.isIt || _vm.isFr
    }
  }, [_vm._v(_vm._s(_vm.$t('uername')) + ":  ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.profile.username))])]), _vm._v(" "), _c('div', {
    staticClass: "item portrait"
  }, [_c('span', {
    staticClass: "porSpan"
  }, [_vm._v(_vm._s(_vm.$t('Portrait')) + ":")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.portrait
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    class: {
      'es5': _vm.isIt || _vm.isFr || _vm.isDe || _vm.isEs || _vm.isDu || _vm.isPo || _vm.isSw
    }
  }, [_vm._v(_vm._s(_vm.$t('fullName')) + " ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.profile.realname))])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('gender')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.profile.gender))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isP),
      expression: "isP"
    }],
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('height')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.height),
      expression: "profile.height"
    }],
    staticClass: "height",
    attrs: {
      "placeholder": _vm.profile.height
    },
    domProps: {
      "value": (_vm.profile.height)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.height = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.$t('cm')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isP),
      expression: "isP"
    }],
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('weight')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.weight),
      expression: "profile.weight"
    }],
    staticClass: "height",
    attrs: {
      "placeholder": _vm.profile.weight
    },
    domProps: {
      "value": (_vm.profile.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.weight = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.$t('kg')))])]), _vm._v(" "), _c('div', {
    staticClass: "item spe-item"
  }, [_c('span', {
    class: {
      'es5': _vm.isEs || _vm.isIt || _vm.isPo || _vm.isFr || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('birthday')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.profile.birthday))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isP),
      expression: "isP"
    }],
    staticClass: "item"
  }, [_c('label', {
    staticClass: "spe-span",
    class: {
      'zh3': !_vm.isEn
    }
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _vm._v(" "), _c('select', {
    staticClass: "weight",
    attrs: {
      "id": "dis_type"
    },
    domProps: {
      "value": _vm.profile.diabetes_type
    }
  }, [_c('option', {
    attrs: {
      "value": "DBTNF"
    }
  }, [_vm._v(_vm._s(_vm.$t('DBTNF')))]), _vm._v(" "), _c('option', {
    attrs: {
      "selected": "",
      "value": "DBT1"
    }
  }, [_vm._v(_vm._s(_vm.$t('DBT1')))]), _c('option', {
    attrs: {
      "value": "DBT2"
    }
  }, [_vm._v(_vm._s(_vm.$t('DBT2')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DBTLADA"
    }
  }, [_vm._v(_vm._s(_vm.$t('LADA')))]), _c('option', {
    attrs: {
      "value": "DBTGEST"
    }
  }, [_vm._v(_vm._s(_vm.$t('Gestational')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DBTPRE"
    }
  }, [_vm._v(_vm._s(_vm.$t('Prediabetes')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "OTR"
    }
  }, [_vm._v(_vm._s(_vm.$t('Other')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isP),
      expression: "isP"
    }],
    staticClass: "item"
  }, [_c('label', {
    staticClass: "spe-span"
  }, [_vm._v(_vm._s(_vm.$t('disDate')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": _vm.disDateShow,
      "clearable": false,
      "picker-options": _vm.pickerOptions,
      "format": "dd/MM  yyyy"
    },
    model: {
      value: (_vm.profile.diabetes_diagonosis_date),
      callback: function($$v) {
        _vm.profile.diabetes_diagonosis_date = $$v
      },
      expression: "profile.diabetes_diagonosis_date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isD),
      expression: "isD"
    }],
    staticClass: "item"
  }, [_c('span', {
    staticClass: "xx_spe-span"
  }, [_vm._v(_vm._s(_vm.$t('Profession')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t(_vm.profile.major)))])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "addSpan"
  }, [_vm._v(_vm._s(_vm.$t('Address')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.profile.address))])]), _vm._v(" "), _c('div', {
    staticClass: "item post"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Postcode')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.profile.zipcode))])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Mobile')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.profile.mobile))])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v("Email")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.profile.email))])]), _vm._v(" "), _c('div', {
    staticClass: "item email"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Bio')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.profile.motto))])])])]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n          " + _vm._s(_vm.$t('copyright')) + " "), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1472 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('div', [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.data_source),
      callback: function($$v) {
        _vm.data_source = $$v
      },
      expression: "data_source"
    }
  }, _vm._l((_vm.options1), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })), _vm._v(" "), _c('el-input', {
    staticClass: "input-with-select",
    attrs: {
      "placeholder": "请在此输入正确的账号"
    },
    model: {
      value: (_vm.id),
      callback: function($$v) {
        _vm.id = $$v
      },
      expression: "id"
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "input-with-select",
    attrs: {
      "placeholder": "请在此输入正确的账号"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.select
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData.slice((_vm.currentPage - 1) * _vm.pagesize, _vm.currentPage * _vm.pagesize),
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "0",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "1",
      "label": "时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "2",
      "label": "类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "3",
      "label": "持续时间/s"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "4",
      "label": "速率"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "5",
      "label": "输注量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "6",
      "label": "参数1"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "7",
      "label": "参数2"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "8",
      "label": "删除标志"
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticClass: "fy",
    attrs: {
      "layout": "prev, pager, next, jumper",
      "total": _vm.total,
      "background": "",
      "current-page": _vm.filterPage
    },
    on: {
      "current-change": _vm.current_change,
      "update:currentPage": function($event) {
        _vm.filterPage = $event
      }
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "header-content"
  }, [_c('img', {
    staticClass: "patientList-logo",
    attrs: {
      "src": __webpack_require__(19)
    },
    on: {
      "click": _vm.home
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "patientList-user"
  }, [_c('img', {
    staticClass: "portrait",
    attrs: {
      "src": _vm.portrait
    }
  }), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "id": "dropdown"
    },
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('label', [_vm._v(_vm._s(_vm.username))]), _vm._v(" "), _c('img', {
    staticClass: "patientList-drown",
    attrs: {
      "src": __webpack_require__(496)
    }
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "id": "dropdown-menu"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "loginOut"
    }
  }, [_vm._v(_vm._s(_vm.$t('sign out')))])], 1)], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "events"
  }, [_c('el-card', {
    staticClass: "events-container"
  }, [_c('div', {
    staticClass: "operate"
  }, [_c('button', {
    attrs: {
      "id": "danger"
    },
    on: {
      "click": _vm.delete2
    }
  }, [_vm._v(_vm._s(_vm.$t('Delete')))]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.create
    }
  }, [_vm._v(_vm._s(_vm.$t('Create')))]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'zh1': !_vm.isEn
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('From')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate2,
      "format": "dd-MM-yyyy"
    },
    on: {
      "change": _vm.filter2
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "to"
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate1,
      "format": "dd-MM-yyyy"
    },
    on: {
      "change": _vm.filter2
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "events-filter",
    class: {
      'zh1': !_vm.isEn
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Event Filter')) + ":")]), _vm._v(" "), _c('select', {
    on: {
      "change": _vm.filter
    }
  }, [_c('option', {
    attrs: {
      "value": "ALL"
    }
  }, [_vm._v(_vm._s(_vm.$t('All')))]), _c('option', {
    attrs: {
      "value": "CARB"
    }
  }, [_vm._v(_vm._s(_vm.$t('carbs')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EXR"
    }
  }, [_vm._v(_vm._s(_vm.$t('exercise')))]), _c('option', {
    attrs: {
      "value": "HBA1C"
    }
  }, [_vm._v(_vm._s(_vm.$t('HbA1c1')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "URINEK"
    }
  }, [_vm._v(_vm._s(_vm.$t('Urine Ketone')))]), _c('option', {
    attrs: {
      "value": "BG"
    }
  }, [_vm._v(_vm._s(_vm.$t('BG1')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "INS"
    }
  }, [_vm._v(_vm._s(_vm.$t('Injection')))]), _c('option', {
    attrs: {
      "value": "OTR"
    }
  }, [_vm._v(_vm._s(_vm.$t('Other')))])])]), _vm._v(" "), _c('button', {
    staticClass: "print",
    on: {
      "click": _vm.print
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))])]), _vm._v(" "), _c('div', {
    staticClass: "patient-table"
  }, [_c('table', {
    attrs: {
      "id": "patientList"
    }
  }, [_c('tr', {
    staticClass: "header"
  }, [_c('td', {
    staticClass: "checkbox"
  }, [_c('input', {
    staticClass: "checkbox22",
    attrs: {
      "type": "checkbox",
      "id": "checkbox1"
    }
  }), _c('label', {
    attrs: {
      "for": "checkbox1"
    },
    on: {
      "click": _vm.chooseAll
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('time'))), _c('div', {
    staticClass: "order",
    class: {
      'order1': !_vm.orderFlag
    },
    on: {
      "click": _vm.orderChange
    }
  })]), _c('td', [_vm._v(_vm._s(_vm.$t('Event Type')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Details')))]), _c('td', [_vm._v(_vm._s(_vm.$t('Notes')))]), _c('td', [_vm._v(_vm._s(_vm.$t('Source')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Action')))])]), _vm._v(" "), _vm._l((_vm.events), function(item, index) {
    return _c('tr', {
      class: (index % 2 === 0) ? '' : 'even',
      attrs: {
        "id": index
      }
    }, [_c('td', {
      staticClass: "checkbox"
    }, [_c('input', {
      staticClass: "checkbox22",
      attrs: {
        "type": "checkbox"
      }
    }), _c('label', {
      attrs: {
        "id": index
      },
      on: {
        "click": _vm.select
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "event-time"
    }, [_vm._v(_vm._s(item[1]))]), _c('td', {
      staticClass: "event-type"
    }, [_vm._v(_vm._s(item[2]))]), _vm._v(" "), _c('td', {
      staticClass: "event-detail"
    }, [_vm._v(_vm._s(item[3].value))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item[3].note))]), _c('td', [_vm._v(_vm._s(item[4]))]), _vm._v(" "), _c('td', {
      staticClass: "operate1"
    }, [_c('span', {
      on: {
        "click": _vm.edit
      }
    }, [_vm._v(_vm._s(_vm.$t('edit')))]), _c('br'), _c('span', {
      on: {
        "click": _vm.delete1
      }
    }, [_vm._v(_vm._s(_vm.$t('Delete')))])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "patientList-block"
  }, [_c('img', {
    class: {
      'click1': !_vm.has_prev
    },
    attrs: {
      "src": __webpack_require__(121)
    },
    on: {
      "click": _vm.prevPage
    }
  }), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.page),
      expression: "page"
    }],
    domProps: {
      "value": (_vm.page)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && $event.keyCode !== 13) { return null; }
        _vm.go($event)
      },
      "blur": _vm.go,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.page = $event.target.value
      }
    }
  }), _vm._v(" of   " + _vm._s(_vm.pages))]), _vm._v(" "), _c('img', {
    class: {
      'click1': !_vm.has_next
    },
    attrs: {
      "src": __webpack_require__(120)
    },
    on: {
      "click": _vm.nextPage
    }
  })])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-form2",
    attrs: {
      "visible": _vm.isA,
      "size": _vm.dialogSize,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.isA = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Create')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(21)
    },
    on: {
      "click": _vm.cancel
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('div', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "date",
    class: {
      'zh2': !_vm.isEn, 'sw2': _vm.isSw, 'cz2': _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('time')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "size": "small",
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": "Date",
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  }), _vm._v(" "), _c('el-time-picker', {
    staticStyle: {
      "width": "110px",
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "Time",
      "size": "small",
      "editable": false,
      "clearable": false,
      "format": "HH:mm"
    },
    model: {
      value: (_vm.value4),
      callback: function($$v) {
        _vm.value4 = $$v
      },
      expression: "value4"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    class: {
      'es1': _vm.isEs, 'de1': _vm.isDe, 'it1': _vm.isIt, 'po1': _vm.isPo, 'du1': _vm.isDu, 'fr1': _vm.isFr
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Event Type')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.typeShow]
    }
  }, [_c('option', [_vm._v(_vm._s(_vm.$t('carbs')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('exercise')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('HbA1c1')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('Urine Ketone')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('BG1')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('Injection')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('Other')))])])]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    class: {
      'es2': _vm.isEs, 'de2': _vm.isDe, 'it2': _vm.isIt, 'po2': _vm.isPo, 'du2': _vm.isDu, 'fr2': _vm.isFr, 'sw3': _vm.isSw, 'cz3': _vm.isCz
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.type8),
      expression: "!type8"
    }]
  }, [_vm._v(_vm._s(_vm.$t('Details')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type8),
      expression: "type8"
    }]
  }, [_vm._v(_vm._s(_vm.$t('Notes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deta1),
      expression: "deta1"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.type1),
      expression: "type1"
    }],
    class: {
      'vuerify-invalid': _vm.Tr1
    },
    attrs: {
      "type": "text",
      "placeholder": "(1-300)",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.deta1)
    },
    on: {
      "blur": function($event) {
        _vm.check(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deta1 = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type1),
      expression: "type1"
    }],
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("g")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deta2),
      expression: "deta2"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.type2),
      expression: "type2"
    }],
    staticClass: "spe-select spe-select1",
    class: {
      'es4': _vm.isEs, 'de4': _vm.isDe, 'it4': _vm.isIt, 'po4': _vm.isPo, 'du4': _vm.isDu, 'fr4': _vm.isFr, 'sw4': _vm.isSw, 'cz4': _vm.isCz
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.deta2 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Light")]), _vm._v(" "), _c('option', [_vm._v("Medium")]), _vm._v(" "), _c('option', [_vm._v("Heavy")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.EXEtime),
      expression: "EXEtime"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.type2),
      expression: "type2"
    }],
    staticClass: "exe1",
    class: {
      'vuerify-invalid': _vm.Tr2
    },
    attrs: {
      "placeholder": "(5-480)",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.EXEtime)
    },
    on: {
      "blur": function($event) {
        _vm.check(2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.EXEtime = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type2),
      expression: "type2"
    }],
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("min")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deta3),
      expression: "deta3"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.type3),
      expression: "type3"
    }],
    class: {
      'vuerify-invalid': _vm.Tr3
    },
    attrs: {
      "type": "text",
      "placeholder": "(3.3-19.9)",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.deta3)
    },
    on: {
      "blur": function($event) {
        _vm.check(3)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deta3 = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type3),
      expression: "type3"
    }],
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("%")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deta4),
      expression: "deta4"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.type4),
      expression: "type4"
    }],
    staticClass: "spe-select1",
    class: {
      'es4': _vm.isEs, 'de4': _vm.isDe, 'it4': _vm.isIt, 'po4': _vm.isPo, 'du4': _vm.isDu, 'fr4': _vm.isFr, 'sw4': _vm.isSw, 'cz4': _vm.isCz
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.deta4 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Negative")]), _vm._v(" "), _c('option', [_vm._v("Macro")]), _vm._v(" "), _c('option', [_vm._v("+")]), _vm._v(" "), _c('option', [_vm._v("++")]), _vm._v(" "), _c('option', [_vm._v("+++")]), _vm._v(" "), _c('option', [_vm._v("++++")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deta5),
      expression: "deta5"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.type5),
      expression: "type5"
    }],
    class: {
      'vuerify-invalid': _vm.Tr5
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.bgRange,
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.deta5)
    },
    on: {
      "blur": function($event) {
        _vm.check(5)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deta5 = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type5),
      expression: "type5"
    }],
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.unit))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deta6),
      expression: "deta6"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.type6),
      expression: "type6"
    }],
    class: {
      'vuerify-invalid': _vm.Tr6
    },
    attrs: {
      "type": "text",
      "placeholder": "(0.1-99.0)",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.deta6)
    },
    on: {
      "blur": function($event) {
        _vm.check(6)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deta6 = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type6),
      expression: "type6"
    }],
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("U")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deta7),
      expression: "deta7"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.type8),
      expression: "type8"
    }],
    class: {
      'vuerify-invalid': _vm.Tr7, 'es3': _vm.isEs, 'de3': _vm.isDe, 'it6': _vm.isIt, 'po6': _vm.isPo, 'du6': _vm.isDu, 'fr6': _vm.isFr, 'sw7': _vm.isSw, 'cz7': _vm.isCz
    },
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip,
      "maxlength": "40"
    },
    domProps: {
      "value": (_vm.deta7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deta7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.type8),
      expression: "!type8"
    }],
    staticClass: "cont"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Notes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note),
      expression: "note"
    }],
    staticClass: "notes",
    class: {
      'zh3': !_vm.isEn, 'es6': _vm.isEs || _vm.isDe, 'du3': _vm.isDu, 'fr6': _vm.isFr, 'sw6': _vm.isSw, 'cz6': _vm.isCz
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip,
      "maxlength": "40"
    },
    domProps: {
      "value": (_vm.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    class: {
      'sw9': _vm.isSw || _vm.isCz
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "26px"
    }
  }, [_vm._v(_vm._s(_vm.$t('Source')))]), _vm._v(" "), _c('span', {
    staticClass: "source"
  }, [_vm._v("Web")])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    on: {
      "click": _vm.newEvents
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))]), _vm._v(" "), _c('button', {
    staticClass: "cancelButton",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-form2",
    attrs: {
      "visible": _vm.isB,
      "size": _vm.dialogSize,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.isB = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('edit')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(21)
    },
    on: {
      "click": _vm.cancel2
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('div', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "date",
    class: {
      'zh2': !_vm.isEn, 'sw2': _vm.isSw, 'cz2': _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('time')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "size": "small",
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.time[0],
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value5),
      callback: function($$v) {
        _vm.value5 = $$v
      },
      expression: "value5"
    }
  }), _vm._v(" "), _c('el-time-picker', {
    staticStyle: {
      "width": "110px",
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": _vm.time[1],
      "size": "small",
      "editable": false,
      "clearable": false,
      "format": "HH:mm"
    },
    model: {
      value: (_vm.value6),
      callback: function($$v) {
        _vm.value6 = $$v
      },
      expression: "value6"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    class: {
      'es1': _vm.isEs, 'de1': _vm.isDe, 'it1': _vm.isIt, 'po1': _vm.isPo, 'du1': _vm.isDu, 'fr1': _vm.isFr
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Event Type')))]), _vm._v(" "), _c('span', {
    staticClass: "eveType",
    class: {
      'es8': _vm.isEs, 'de8': _vm.isDe, 'it8': _vm.isIt, 'po8': _vm.isPo, 'du8': _vm.isDu, 'fr8': _vm.isFr
    }
  }, [_vm._v(_vm._s(_vm.event[2]))])]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    class: {
      'es2': _vm.isEs, 'de2': _vm.isDe, 'de7': _vm.isDe || _vm.isIt || _vm.isPo || _vm.isDu || _vm.isFr || _vm.isEs, 'it2': _vm.isIt, 'po2': _vm.isPo, 'du2': _vm.isDu, 'fr2': _vm.isFr, 'sw3': _vm.isSw, 'cz3': _vm.isCz
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.edType8),
      expression: "!edType8"
    }]
  }, [_vm._v(_vm._s(_vm.$t('Details')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.edType8),
      expression: "edType8"
    }]
  }, [_vm._v(_vm._s(_vm.$t('Notes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eDetail1),
      expression: "eDetail1"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.edType1),
      expression: "edType1"
    }],
    class: {
      'vuerify-invalid': _vm.Tr1
    },
    attrs: {
      "type": "text",
      "placeholder": "(1-300)",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.eDetail1)
    },
    on: {
      "blur": function($event) {
        _vm.edCheck(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.eDetail1 = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.edType1),
      expression: "edType1"
    }],
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("g")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eDetail2),
      expression: "eDetail2"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.edType2),
      expression: "edType2"
    }],
    staticClass: "spe-select spe-select1",
    class: {
      'es4': _vm.isEs, 'de4': _vm.isDe, 'it4': _vm.isIt, 'po4': _vm.isPo, 'du4': _vm.isDu, 'fr4': _vm.isFr, 'sw4': _vm.isSw, 'cz4': _vm.isCz
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.eDetail2 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Light")]), _vm._v(" "), _c('option', [_vm._v("Medium")]), _vm._v(" "), _c('option', [_vm._v("Heavy")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edEXEtime),
      expression: "edEXEtime"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.edType2),
      expression: "edType2"
    }],
    staticClass: "exe1",
    class: {
      'vuerify-invalid': _vm.Tr2
    },
    attrs: {
      "placeholder": "(5-480)",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.edEXEtime)
    },
    on: {
      "blur": function($event) {
        _vm.edCheck(2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edEXEtime = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.edType2),
      expression: "edType2"
    }],
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("min")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eDetail3),
      expression: "eDetail3"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.edType3),
      expression: "edType3"
    }],
    class: {
      'vuerify-invalid': _vm.Tr3
    },
    attrs: {
      "type": "text",
      "placeholder": "(3.3-19.9)",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.eDetail3)
    },
    on: {
      "blur": function($event) {
        _vm.edCheck(3)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.eDetail3 = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.edType3),
      expression: "edType3"
    }],
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("%")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eDetail4),
      expression: "eDetail4"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.edType4),
      expression: "edType4"
    }],
    staticClass: "spe-select1",
    class: {
      'es4': _vm.isEs, 'de4': _vm.isDe, 'it4': _vm.isIt, 'po4': _vm.isPo, 'du4': _vm.isDu, 'fr4': _vm.isFr, 'sw4': _vm.isSw, 'cz4': _vm.isCz
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.eDetail4 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Negative")]), _vm._v(" "), _c('option', [_vm._v("Macro")]), _vm._v(" "), _c('option', [_vm._v("+")]), _vm._v(" "), _c('option', [_vm._v("++")]), _vm._v(" "), _c('option', [_vm._v("+++")]), _vm._v(" "), _c('option', [_vm._v("++++")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eDetail5),
      expression: "eDetail5"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.edType5),
      expression: "edType5"
    }],
    class: {
      'vuerify-invalid': _vm.Tr5
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.bgRange,
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.eDetail5)
    },
    on: {
      "blur": function($event) {
        _vm.edCheck(5)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.eDetail5 = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.edType5),
      expression: "edType5"
    }],
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.unit))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eDetail6),
      expression: "eDetail6"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.edType6),
      expression: "edType6"
    }],
    class: {
      'vuerify-invalid': _vm.Tr6
    },
    attrs: {
      "type": "text",
      "placeholder": "(0.1-99.0)",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.eDetail6)
    },
    on: {
      "blur": function($event) {
        _vm.edCheck(6)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.eDetail6 = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.edType6),
      expression: "edType6"
    }],
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("U")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eDetail7),
      expression: "eDetail7"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.edType8),
      expression: "edType8"
    }],
    class: {
      'vuerify-invalid': _vm.Tr7, 'es3': _vm.isEs, 'de3': _vm.isDe, 'it6': _vm.isIt, 'po6': _vm.isPo, 'du6': _vm.isDu, 'fr6': _vm.isFr, 'sw7': _vm.isSw, 'cz7': _vm.isCz
    },
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip,
      "maxlength": "40"
    },
    domProps: {
      "value": (_vm.eDetail7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.eDetail7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.edType8),
      expression: "!edType8"
    }],
    staticClass: "cont"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Notes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eNote),
      expression: "eNote"
    }],
    staticClass: "notes",
    class: {
      'zh3': !_vm.isEn, 'es6': _vm.isEs, 'de6': _vm.isDe, 'du3': _vm.isDu, 'fr6': _vm.isFr, 'sw6': _vm.isSw, 'cz6': _vm.isCz
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip,
      "maxlength": "40"
    },
    domProps: {
      "value": (_vm.eNote)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.eNote = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    class: {
      'sw9': _vm.isSw || _vm.isCz
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "26px"
    }
  }, [_vm._v(_vm._s(_vm.$t('Source')))]), _vm._v(" "), _c('span', {
    staticClass: "source"
  }, [_vm._v("Web")])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    on: {
      "click": _vm.editEvents
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))]), _vm._v(" "), _c('button', {
    staticClass: "cancelButton",
    on: {
      "click": _vm.cancel2
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "chart-container",
    attrs: {
      "id": "container"
    }
  }, [_c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Segment Analysis Report')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.$t('date')) + ":" + _vm._s(_vm.time))])])]), _vm._v(" "), _c('table', {
    staticClass: "status-table1",
    class: {
      'zh1': !_vm.isEn, 'de1': _vm.isDe || _vm.isIt
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('uername')))]), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.username))]), _vm._v(" "), _c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('fullName')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('devices')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "id": "reportPdmTitle"
    }
  }, [_vm._v(_vm._s(_vm.$t('pdm')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('tran')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('pumpBase')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[2]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td4"
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _c('td', {
    staticClass: "td4",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v(_vm._s(_vm.statics.medical_history))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "est-a1c"
    }
  }, [_c('div', [_c('span', {
    staticClass: "est-title"
  }, [_vm._v(_vm._s(_vm.$t("est_a1c_t1")) + " " + _vm._s(_vm.est_a1c) + "  ")]), _c('span', [_vm._v(_vm._s(_vm.$t("est_a1c_t2")))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "x_est-ita"
  }, [_vm._v(_vm._s(_vm.$t("est_a1c_t3")))])])]), _vm._v(" "), _c('img', {
    staticClass: "img",
    attrs: {
      "id": "img1_1"
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "sgTable"
  }, [_c('tr', [_c('td', {
    staticClass: "td2 td5"
  }, [_vm._v(_vm._s(_vm.$t('Avg Glucose'))), _c('br'), _vm._v(_vm._s(_vm.unit))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Below ')) + _vm._s(_vm.hypo) + _vm._s(_vm.unit))]), _c('td', {
    staticClass: "td2 td6"
  }, [_vm._v(_vm._s(_vm.$t('low')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('In Target Range'))), _c('br'), _vm._v(_vm._s(_vm.target))]), _vm._v(" "), _c('td', {
    staticClass: "td2 td6"
  }, [_vm._v(_vm._s(_vm.$t('high')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Coefficient of variation')) + " ")]), _c('td', {
    staticClass: "td2 td6"
  }, [_vm._v(_vm._s(_vm.$t('SD'))), _c('br'), _vm._v(" " + _vm._s(_vm.unit))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('% Time CGM Active')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td4"
  }, [_vm._v(_vm._s(_vm.avg))]), _vm._l((_vm.seg), function(item) {
    return _c('td', {
      staticClass: "td4"
    }, [_vm._v(_vm._s(item))])
  }), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v(_vm._s(_vm.cv))]), _c('td', {
    staticClass: "td4"
  }, [_vm._v(_vm._s(_vm.sd))]), _c('td', [_vm._v(_vm._s(_vm.active))])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "bolCount"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('# of Boluses')))]), _vm._v(" "), _c('table', {
    staticClass: "countLabel"
  }, [_c('tr', {
    attrs: {
      "id": "count"
    }
  }, _vm._l((48), function(i) {
    return _c('td')
  }))])]), _vm._v(" "), _c('img', {
    staticClass: "img",
    attrs: {
      "id": "img1_3"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img",
    attrs: {
      "id": "img1_2"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(19)
    }
  })])
}]}

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "connect-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('connections1')))])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right",
    class: {
      'zh1': !_vm.isEn, 'fr1': _vm.isFr, 'cz1': _vm.isCz
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(63)
    }
  }), _vm._v(" "), _c('p', {
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t('home')))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _vm._l((_vm.hcpApply), function(item) {
    return _c('div', {
      staticClass: "context apply",
      attrs: {
        "id": item.uid
      }
    }, [_c('img', {
      staticClass: "hcptype",
      attrs: {
        "src": __webpack_require__(484)
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "applyImg",
      attrs: {
        "src": __webpack_require__(55)
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.username))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('fullName')) + ": " + _vm._s(item.realname))]), _vm._v(" "), _c('span', {
      staticClass: "applyTip"
    }, [_vm._v(_vm._s(_vm.$t('t1105_request_to_view_your_data').replace('$1', item.username)))]), _vm._v(" "), _c('div', {
      staticClass: "applyButton"
    }, [_c('button', {
      on: {
        "click": function($event) {
          _vm.open(0, $event)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('Deny')))]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.open(1, $event)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('Agree')))])]), _vm._v(" "), _c('img', {
      staticClass: "cancel",
      attrs: {
        "src": __webpack_require__(15)
      },
      on: {
        "click": _vm.openDelete
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.carerApply), function(item) {
    return _c('div', {
      staticClass: "context apply",
      attrs: {
        "id": item.uid
      }
    }, [_c('img', {
      staticClass: "applyImg",
      attrs: {
        "src": __webpack_require__(55)
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.username))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('fullName')) + ": " + _vm._s(item.realname))]), _vm._v(" "), _c('span', {
      staticClass: "applyTip"
    }, [_vm._v(_vm._s(_vm.$t('t1105_request_to_view_your_data').replace('$1', item.username)))]), _vm._v(" "), _c('div', {
      staticClass: "applyButton"
    }, [_c('button', {
      on: {
        "click": function($event) {
          _vm.open(0, $event)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('Deny')))]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.open(1, $event)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('Agree')))])]), _vm._v(" "), _c('img', {
      staticClass: "cancel",
      attrs: {
        "src": __webpack_require__(15)
      },
      on: {
        "click": _vm.openDelete
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.hcp), function(item) {
    return _c('div', {
      staticClass: "context",
      attrs: {
        "id": item.uid
      }
    }, [_c('img', {
      staticClass: "hcptype",
      attrs: {
        "src": __webpack_require__(484)
      }
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": __webpack_require__(55)
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.username))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('fullName')) + ": " + _vm._s(item.realname))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Bio')) + ": "), _c('span', [_vm._v(_vm._s(item.motto))])]), _vm._v(" "), _c('img', {
      staticClass: "cancel",
      attrs: {
        "src": __webpack_require__(15)
      },
      on: {
        "click": _vm.openDelete
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.carer), function(item) {
    return _c('div', {
      staticClass: "context",
      attrs: {
        "id": item.uid
      }
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(55)
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.username))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('fullName')) + ": " + _vm._s(item.realname))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Bio')) + ": "), _c('span', [_vm._v(_vm._s(item.motto))])]), _vm._v(" "), _c('img', {
      staticClass: "cancel",
      attrs: {
        "src": __webpack_require__(15)
      },
      on: {
        "click": _vm.openDelete
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.oauth2), function(item) {
    return _c('div', {
      staticClass: "context",
      attrs: {
        "id": item.name
      }
    }, [(item.name == 'diasend') ? _c('img', {
      attrs: {
        "src": __webpack_require__(1298)
      }
    }) : _c('img', {
      attrs: {
        "src": __webpack_require__(55)
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p'), _vm._v(" "), _c('img', {
      staticClass: "cancel",
      attrs: {
        "src": __webpack_require__(15)
      },
      on: {
        "click": _vm.deleteAuth
      }
    })])
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noMes),
      expression: "noMes"
    }],
    staticClass: "noMes"
  }, [_vm._v(_vm._s(_vm.$t('noConnect')))])], 2), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n\n         " + _vm._s(_vm.$t('copyright')) + " "), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.ChooseVisible,
      "size": "tiny",
      "id": "dialog-form2",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.ChooseVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Warning')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(21)
    },
    on: {
      "click": _vm.cancel
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isA),
      expression: "isA"
    }]
  }, [_vm._v(_vm._s(_vm.$t('agreeConnect')))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isA),
      expression: "!isA"
    }]
  }, [_vm._v(_vm._s(_vm.$t('denyConnect')))])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isA),
      expression: "isA"
    }],
    on: {
      "click": _vm.agree
    }
  }, [_vm._v(_vm._s(_vm.$t('Agree')))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isA),
      expression: "!isA"
    }],
    on: {
      "click": _vm.reject
    }
  }, [_vm._v(_vm._s(_vm.$t('Yes')))]), _vm._v(" "), _c('button', {
    staticClass: "cancel1",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.ChooseVisible2,
      "size": "tiny",
      "id": "dialog-form3",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.ChooseVisible2 = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Warning')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(21)
    },
    on: {
      "click": _vm.cancel
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('deleteConnect')))])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    on: {
      "click": _vm.delete1
    }
  }, [_vm._v(_vm._s(_vm.$t('Delete')))]), _vm._v(" "), _c('button', {
    staticClass: "cancel1",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1477 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1478 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": _vm.activeIndex2,
      "mode": "horizontal",
      "background-color": "#545c64",
      "text-color": "#fff",
      "active-text-color": "#ffd04b"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("泵状态数据")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2"
    }
  }, [_vm._v("传感器状态数据")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3"
    }
  }, [_vm._v("基础量数据")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "4"
    }
  }, [_vm._v("血糖数据")])], 1), _vm._v(" "), _c('div', {
    staticClass: "modeln"
  }, [_c('BasicQuantity', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.aType == '3'),
      expression: "aType =='3'"
    }]
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1479 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/accountadmin/img_logo_white.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("Accounts Management")]), _vm._v(" "), _c('img', {
    staticClass: "logout",
    attrs: {
      "src": "/static/accountadmin/icon_out.png"
    },
    on: {
      "click": _vm.logout
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "username"
  }, [_vm._v("Hello  " + _vm._s(_vm.username))])])])
},staticRenderFns: []}

/***/ }),
/* 1480 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "nav-bar"
  }, [_c('p', [_c('span', {
    staticClass: "parent-link",
    on: {
      "click": function($event) {
        _vm.navToHome()
      }
    }
  }, [_vm._v("Admin")]), _vm._v(" "), _c('span', [_vm._v(" >> ")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.title) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "nav-select",
    staticStyle: {
      "width": "100%",
      "margin-top": "15px"
    }
  }, [_c('el-input', {
    staticClass: "input-with-select",
    attrs: {
      "placeholder": "请在此输入正确的账号"
    },
    model: {
      value: (_vm.input3),
      callback: function($$v) {
        _vm.input3 = $$v
      },
      expression: "input3"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.search
    },
    slot: "append"
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), (_vm.hasAccount) ? _c('div', [_c('p', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_vm._v(_vm._s(_vm.formLabelAlign.accounts))]), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "label-position": _vm.labelPosition,
      "label-width": "120px",
      "model": _vm.formLabelAlign
    }
  }, [_c('p', {
    staticClass: "span1"
  }, [_vm._v("Type")]), _vm._v(" "), _c('p', {
    staticClass: "span2"
  }, [_vm._v(_vm._s(_vm.alignType))]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "label": "Country/region"
    }
  }, [_c('el-select', {
    staticClass: "from-item",
    attrs: {
      "placeholder": "请选择国家地区"
    },
    model: {
      value: (_vm.formLabelAlign.region),
      callback: function($$v) {
        _vm.formLabelAlign.region = $$v
      },
      expression: "formLabelAlign.region"
    }
  }, _vm._l((_vm.countries), function(item) {
    return _c('el-option', {
      key: item.index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name"
    }
  }, [_c('el-input', {
    staticClass: "from-item",
    model: {
      value: (_vm.formLabelAlign.name),
      callback: function($$v) {
        _vm.formLabelAlign.name = $$v
      },
      expression: "formLabelAlign.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Organization"
    }
  }, [_c('el-input', {
    staticClass: "from-item",
    model: {
      value: (_vm.formLabelAlign.orz),
      callback: function($$v) {
        _vm.formLabelAlign.orz = $$v
      },
      expression: "formLabelAlign.orz"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email"
    }
  }, [_c('el-input', {
    staticClass: "from-item",
    model: {
      value: (_vm.formLabelAlign.email),
      callback: function($$v) {
        _vm.formLabelAlign.email = $$v
      },
      expression: "formLabelAlign.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mobile"
    }
  }, [_c('el-input', {
    staticClass: "from-item",
    model: {
      value: (_vm.formLabelAlign.mobile),
      callback: function($$v) {
        _vm.formLabelAlign.mobile = $$v
      },
      expression: "formLabelAlign.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Password"
    }
  }, [_c('el-input', {
    staticClass: "from-item",
    model: {
      value: (_vm.formLabelAlign.password),
      callback: function($$v) {
        _vm.formLabelAlign.password = $$v
      },
      expression: "formLabelAlign.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger",
      "round": "true"
    },
    on: {
      "click": _vm.del
    }
  }, [_vm._v("删除账号")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "round": "true"
    },
    on: {
      "click": _vm.refresh
    }
  }, [_vm._v("更新账号")])], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "width": "30%",
      "center": "true"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v("搜索失败，无此账号信息，请检查确认！")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "是否删除账号？",
      "visible": _vm.centerDialogVisible,
      "before-close": _vm.handleDialogClose,
      "width": "10%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      }
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "验证码"
    },
    model: {
      value: (_vm.input4),
      callback: function($$v) {
        _vm.input4 = $$v
      },
      expression: "input4"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.delTest
    },
    slot: "append"
  }, [_vm._v(_vm._s(_vm.btnText))])], 1), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shoWFalse),
      expression: "shoWFalse"
    }],
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("验证码对比失败，请重试")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelDel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.determineDel
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "是否更新账号信息？",
      "visible": _vm.RefreshDialogVisible,
      "width": "10%",
      "before-close": _vm.handleDialogClose,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.RefreshDialogVisible = $event
      }
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "验证码"
    },
    model: {
      value: (_vm.input5),
      callback: function($$v) {
        _vm.input5 = $$v
      },
      expression: "input5"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.refreshTest
    },
    slot: "append"
  }, [_vm._v(_vm._s(_vm.btnText))])], 1), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shoWFalse),
      expression: "shoWFalse"
    }],
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("验证码对比失败，请重试")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelRefresh
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.determineRefresh
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newPatient-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('messages')))])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right",
    class: {
      'de22': _vm.isDe || _vm.isFr, 'cz22': _vm.isCz
    }
  }, [_c('p', {
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t('home')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(63)
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _vm._l((_vm.messages), function(item, index) {
    return _c('div', [_c('div', {
      staticClass: "note1",
      class: {
        'notRead': (item[3] === 'N')
      },
      attrs: {
        "id": index
      }
    }, [_c('img', {
      staticClass: "portrait",
      attrs: {
        "src": item[4]
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('p', [_vm._v(_vm._s(item[1]))]), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item[2]))])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((item[3] === 'N')),
        expression: "(item[3]==='N')"
      }],
      staticClass: "operate",
      on: {
        "click": function($event) {
          _vm.read(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('Read')))])])]), _vm._v(" "), _c('hr', {
      staticClass: "small-hr"
    })])
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noMes),
      expression: "noMes"
    }],
    staticClass: "noMes"
  }, [_vm._v(_vm._s(_vm.$t('noMes')))])], 2), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n\n          " + _vm._s(_vm.$t('copyright')) + " "), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "print-container"
  }, [_c('el-card', {
    staticClass: "print-card1"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Quick Print')))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "content1"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Quick Print Settings')) + ":")]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content2",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Select duration')) + ": ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeInterval),
      expression: "timeInterval"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.timeInterval = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.timeIntervalChange]
    }
  }, [_c('option', [_vm._v(_vm._s(_vm.$t('One Week')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('One Month')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('One Quarter')))])])]), _vm._v(" "), _c('div', {
    staticClass: "content2"
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "25px"
    }
  }, [_vm._v(_vm._s(_vm.$t('End date')) + ":")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endDate),
      expression: "endDate"
    }],
    staticClass: "cust",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.endDate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.timeChange]
    }
  }, [_c('option', [_vm._v(_vm._s(_vm.$t('Yesterday')))]), _vm._v(" "), _c('option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.time1),
      expression: "time1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('Last Saturday')))]), _vm._v(" "), _c('option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.time1),
      expression: "time1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('Last Sunday')))]), _vm._v(" "), _c('option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.time2),
      expression: "time2"
    }]
  }, [_vm._v(_vm._s(_vm.$t('Last Day of Last Month')))]), _vm._v(" "), _c('option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.time3),
      expression: "time3"
    }]
  }, [_vm._v(_vm._s(_vm.$t('Last Day of Last Quarter')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('Customize')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cust),
      expression: "cust"
    }],
    staticClass: "block cust"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.custDate,
      "format": "dd-MM-yyyy"
    },
    on: {
      "change": _vm.customizeDate
    },
    model: {
      value: (_vm.custTime),
      callback: function($$v) {
        _vm.custTime = $$v
      },
      expression: "custTime"
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('period')) + ":  "), _c('span', [_vm._v(_vm._s(_vm.timeRange))])])]), _vm._v(" "), _c('div', {
    staticClass: "content1 custn"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Week Filter')) + ":")]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "weeks",
    attrs: {
      "id": "weeks"
    }
  }, [_c('span', {
    staticClass: "tittle"
  }, [_c('label', {
    on: {
      "click": _vm.chooseAll
    }
  }, [_vm._v(_vm._s(_vm.$t('Weekdays')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Mon')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Tue')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Wed')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Thur')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Fri')))])])]), _vm._v(" "), _c('div', {
    staticClass: "weeks weken",
    attrs: {
      "id": "weken"
    }
  }, [_c('span', {
    staticClass: "tittle",
    class: {
      'de1': _vm.isDe, 'it1': _vm.isIt, 'po1': _vm.isPo, 'du1': _vm.isDu, 'fr1': _vm.isFr, 'sw1': _vm.isSw, 'cz5': _vm.isCz
    }
  }, [_c('label', {
    on: {
      "click": _vm.chooseAll
    }
  }, [_vm._v(_vm._s(_vm.$t('Weekends')))])]), _vm._v(" "), _c('span', {
    class: {
      'zh3': !_vm.isEn
    }
  }, [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Sat')))])]), _vm._v(" "), _c('span', {
    staticClass: "spe-span",
    class: {
      'zh4': !_vm.isEn, 'it2': _vm.isIt, 'po2': _vm.isPo, 'du2': _vm.isDu, 'fr2': _vm.isFr, 'sw2': _vm.isSw, 'cz2': _vm.isCz
    }
  }, [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Sun')))])])]), _vm._v(" "), _c('div', {
    staticClass: "content1"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Select reports to print')) + ":")]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "report"
  }, [_c('div', {
    staticClass: "content3"
  }, [_c('label', {
    on: {
      "click": _vm.chooseAll
    }
  }), _c('p', [_vm._v(_vm._s(_vm.$t('All')))]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content3"
  }, [_c('label', {
    attrs: {
      "id": "dash"
    },
    on: {
      "click": _vm.choose1
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('dashboard')))]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'zh1': !_vm.isEn
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate2,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value12),
      callback: function($$v) {
        _vm.value12 = $$v
      },
      expression: "value12"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "to"
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate1,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value11),
      callback: function($$v) {
        _vm.value11 = $$v
      },
      expression: "value11"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('From')))])]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content3"
  }, [_c('label', {
    attrs: {
      "id": "ds"
    },
    on: {
      "click": _vm.choose1
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Daily Summary')))]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'zh1': !_vm.isEn
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate2,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value12),
      callback: function($$v) {
        _vm.value12 = $$v
      },
      expression: "value12"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "to"
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate1,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value11),
      callback: function($$v) {
        _vm.value11 = $$v
      },
      expression: "value11"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('From')))])]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content3"
  }, [_c('label', {
    attrs: {
      "id": "dd"
    },
    on: {
      "click": _vm.choose1
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Day By Day Overview')))]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'zh1': !_vm.isEn
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate2,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value22),
      callback: function($$v) {
        _vm.value22 = $$v
      },
      expression: "value22"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "to"
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate1,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value21),
      callback: function($$v) {
        _vm.value21 = $$v
      },
      expression: "value21"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('From')))])]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content3"
  }, [_c('label', {
    attrs: {
      "id": "ol"
    },
    on: {
      "click": _vm.choose1
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Sensor Overlay')))]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'zh1': !_vm.isEn
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate2,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value32),
      callback: function($$v) {
        _vm.value32 = $$v
      },
      expression: "value32"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "to"
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate1,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value31),
      callback: function($$v) {
        _vm.value31 = $$v
      },
      expression: "value31"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('From')))])]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content3"
  }, [_c('label', {
    attrs: {
      "id": "ta"
    },
    on: {
      "click": _vm.choose1
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Trend Analysis')))]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'zh1': !_vm.isEn
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate2,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value42),
      callback: function($$v) {
        _vm.value42 = $$v
      },
      expression: "value42"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "to"
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate1,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value41),
      callback: function($$v) {
        _vm.value41 = $$v
      },
      expression: "value41"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('From')))])]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isM),
      expression: "!isM"
    }],
    staticClass: "content3"
  }, [_c('label', {
    attrs: {
      "id": "lg"
    },
    on: {
      "click": _vm.choose1
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Logbook')))]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'zh1': !_vm.isEn
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate2,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value52),
      callback: function($$v) {
        _vm.value52 = $$v
      },
      expression: "value52"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "to"
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate1,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value51),
      callback: function($$v) {
        _vm.value51 = $$v
      },
      expression: "value51"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('From')))])]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isM),
      expression: "!isM"
    }],
    staticClass: "content3"
  }, [_c('label', {
    attrs: {
      "id": "ev"
    },
    on: {
      "click": _vm.choose1
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Event Summary')))]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'zh1': !_vm.isEn
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate2,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value62),
      callback: function($$v) {
        _vm.value62 = $$v
      },
      expression: "value62"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "to"
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate1,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value61),
      callback: function($$v) {
        _vm.value61 = $$v
      },
      expression: "value61"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('From')))])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.evType),
      expression: "evType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.evType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('date')))]), _c('option', [_vm._v(_vm._s(_vm.$t('item')))])]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content3"
  }, [_c('label', {
    attrs: {
      "id": "alert"
    },
    on: {
      "click": _vm.choose1
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Alert')))]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'zh1': !_vm.isEn
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate2,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value12),
      callback: function($$v) {
        _vm.value12 = $$v
      },
      expression: "value12"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "to"
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate1,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value11),
      callback: function($$v) {
        _vm.value11 = $$v
      },
      expression: "value11"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('From')))])]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isM),
      expression: "!isM"
    }],
    staticClass: "content3"
  }, [_c('label', {
    attrs: {
      "id": "dSet"
    },
    on: {
      "click": _vm.choose1
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Device Settings Review')))]), _vm._v(" "), _c('hr', {
    staticClass: "spe-hr"
  })])]), _vm._v(" "), _c('button', {
    class: {
      'zh2': !_vm.isEn
    },
    on: {
      "click": _vm.print
    }
  }, [_vm._v(_vm._s(_vm.$t('createReport')))])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.typeChooseVisible,
      "size": _vm.dialogSize,
      "id": "dialog-form2",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.typeChooseVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('setPeriod')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(21)
    },
    on: {
      "click": _vm.cancel
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('div', {
    staticClass: "duration"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('duration')))]), _vm._v(" "), _c('select', {
    attrs: {
      "id": "duration"
    }
  }, [_c('option', [_vm._v(_vm._s(_vm.$t('7 days')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('14 days')))])])])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('applyM')))]), _vm._v(" "), _c('button', {
    staticClass: "cancelButton",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1483 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "PainterList"
    }
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('el-card', {
    attrs: {
      "id": "list"
    }
  }, [_c('div', {
    staticClass: "menu-wrap"
  }, [_vm._l((_vm.menuInfo2), function(item, index) {
    return _c('div', {
      staticClass: "icon-menu",
      on: {
        "click": function($event) {
          _vm.clickMenu(index)
        }
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("\n              " + _vm._s(_vm.$t(item.title)) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "img-wrap",
      style: ({
        'background-color': item.bkColor
      })
    }, [_c('div', {
      staticClass: "top"
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": item.imgUrl
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n\n          " + _vm._s(_vm.$t('copyright')) + " "), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1484 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  })
},staticRenderFns: []}

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newPatient-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v("New User")])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right",
    class: {
      'de22': _vm.isDe || _vm.isFr, 'cz22': _vm.isCz
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(63)
    }
  }), _vm._v(" "), _c('p', {
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t('home')))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "long-span",
    class: {
      'es5': _vm.isIt || _vm.isFr
    }
  }, [_vm._v(_vm._s(_vm.$t('uername')) + "(email): "), _c('img', {
    staticClass: "star",
    attrs: {
      "src": __webpack_require__(317)
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.username),
      expression: "profile.username"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item portrait"
  }, [_c('span', {
    staticClass: "porSpan"
  }, [_vm._v(_vm._s(_vm.$t('Portrait')) + ":")]), _vm._v(" "), _c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": '/api/v2.0/person/' + _vm.uid + '/portrait',
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.portrait
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    class: {
      'es5': _vm.isIt || _vm.isFr || _vm.isDe || _vm.isEs || _vm.isDu || _vm.isPo || _vm.isSw
    }
  }, [_vm._v(_vm._s(_vm.$t('fullName')) + " "), _c('img', {
    staticClass: "star",
    attrs: {
      "src": __webpack_require__(317)
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.realname),
      expression: "profile.realname"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.realname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.realname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('gender')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.gender),
      expression: "profile.gender"
    }],
    staticClass: "gender",
    attrs: {
      "id": "gender"
    },
    domProps: {
      "value": _vm.profile.gender
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.profile.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "GDRNF"
    }
  }, [_vm._v(_vm._s(_vm.$t('GDRNF')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GDRM"
    }
  }, [_vm._v(_vm._s(_vm.$t('GDRM')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GDRF"
    }
  }, [_vm._v(_vm._s(_vm.$t('GDRF')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isP),
      expression: "isP"
    }],
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('height')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.height),
      expression: "profile.height"
    }],
    staticClass: "height",
    attrs: {
      "placeholder": _vm.profile.height
    },
    domProps: {
      "value": (_vm.profile.height)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.height = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.$t('cm')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isP),
      expression: "isP"
    }],
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('weight')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.weight),
      expression: "profile.weight"
    }],
    staticClass: "height",
    attrs: {
      "placeholder": _vm.profile.weight
    },
    domProps: {
      "value": (_vm.profile.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.weight = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.$t('kg')))])]), _vm._v(" "), _c('div', {
    staticClass: "item spe-item"
  }, [_c('span', {
    class: {
      'es5': _vm.isEs || _vm.isIt || _vm.isPo || _vm.isFr || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('birthday')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": _vm.birthdayShow,
      "clearable": false,
      "picker-options": _vm.pickerOptions,
      "format": "dd/MM  yyyy"
    },
    model: {
      value: (_vm.birthday),
      callback: function($$v) {
        _vm.birthday = $$v
      },
      expression: "birthday"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isP),
      expression: "isP"
    }],
    staticClass: "item"
  }, [_c('label', {
    staticClass: "spe-span",
    class: {
      'zh3': !_vm.isEn
    }
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _vm._v(" "), _c('select', {
    staticClass: "weight",
    attrs: {
      "id": "dis_type"
    },
    domProps: {
      "value": _vm.profile.diabetes_type
    }
  }, [_c('option', {
    attrs: {
      "value": "DBTNF"
    }
  }, [_vm._v(_vm._s(_vm.$t('DBTNF')))]), _vm._v(" "), _c('option', {
    attrs: {
      "selected": "",
      "value": "DBT1"
    }
  }, [_vm._v(_vm._s(_vm.$t('DBT1')))]), _c('option', {
    attrs: {
      "value": "DBT2"
    }
  }, [_vm._v(_vm._s(_vm.$t('DBT2')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DBTLADA"
    }
  }, [_vm._v(_vm._s(_vm.$t('LADA')))]), _c('option', {
    attrs: {
      "value": "DBTGEST"
    }
  }, [_vm._v(_vm._s(_vm.$t('Gestational')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DBTPRE"
    }
  }, [_vm._v(_vm._s(_vm.$t('Prediabetes')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "OTR"
    }
  }, [_vm._v(_vm._s(_vm.$t('Other')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isP),
      expression: "isP"
    }],
    staticClass: "item"
  }, [_c('label', {
    staticClass: "spe-span"
  }, [_vm._v(_vm._s(_vm.$t('disDate')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": _vm.disDateShow,
      "clearable": false,
      "picker-options": _vm.pickerOptions,
      "format": "dd/MM  yyyy"
    },
    model: {
      value: (_vm.profile.diabetes_diagonosis_date),
      callback: function($$v) {
        _vm.profile.diabetes_diagonosis_date = $$v
      },
      expression: "profile.diabetes_diagonosis_date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isD),
      expression: "isD"
    }],
    staticClass: "item"
  }, [_c('label', {
    staticClass: "spe-span"
  }, [_vm._v(_vm._s(_vm.$t('Profession')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.major),
      expression: "profile.major"
    }],
    staticClass: "profession",
    class: {
      'zh1': !_vm.isEn, 'es1': _vm.isEs, 'de1': _vm.isDe, 'it1': _vm.isIt, 'po1': _vm.isPo, fr1: _vm.isFr, 'sw1': _vm.isSw, 'cz1': _vm.isCz
    },
    attrs: {
      "id": "major"
    },
    domProps: {
      "value": _vm.profile.major
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.profile.major = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "DPRONF"
    }
  }, [_vm._v(_vm._s(_vm.$t('DPRONF')))]), _vm._v(" "), _c('option', {
    attrs: {
      "selected": "",
      "value": "DPROENDOCRIN"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('DPROENDOCRIN')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DPRODIABTRA"
    }
  }, [_vm._v(_vm._s(_vm.$t('DPRODIABTRA')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DPRONURSE"
    }
  }, [_vm._v(_vm._s(_vm.$t('DPRONURSE')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DPRODIATIT"
    }
  }, [_vm._v(_vm._s(_vm.$t('DPRODIATIT')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DPROOTR"
    }
  }, [_vm._v("\t" + _vm._s(_vm.$t('DPROOTR')))])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "addSpan"
  }, [_vm._v(_vm._s(_vm.$t('Address')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.address),
      expression: "profile.address"
    }],
    staticClass: "address",
    domProps: {
      "value": (_vm.profile.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.address = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address2),
      expression: "address2"
    }],
    staticClass: "address",
    domProps: {
      "value": (_vm.address2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item post"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Postcode')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.zipcode),
      expression: "profile.zipcode"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.zipcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.zipcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Mobile')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.mobile),
      expression: "profile.mobile"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.mobile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v("Email")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.email),
      expression: "profile.email"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item email"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Bio')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.motto),
      expression: "profile.motto"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.motto)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.motto = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('img', {
    staticClass: "star",
    attrs: {
      "src": __webpack_require__(317)
    }
  }), _vm._v("    indicates a required field")])]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('button', {
    staticClass: "cancel",
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "create",
    on: {
      "click": _vm.create
    }
  }, [_vm._v(_vm._s(_vm.$t('create')))])])]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n          " + _vm._s(_vm.$t('copyright')) + " "), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background",
    attrs: {
      "id": "background"
    }
  }, [_c('div', {
    staticClass: "chart-container",
    attrs: {
      "id": "chart-container"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.styleText)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Alerts Report')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('period')) + ":   " + _vm._s(_vm.days))])])]), _vm._v(" "), _c('table', {
    staticClass: "status-table1"
  }, [_c('tr', [_c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('uername')))]), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.username))]), _vm._v(" "), _c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('fullName')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('devices')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "id": "reportPdmTitle"
    }
  }, [_vm._v(_vm._s(_vm.$t('pdm')))]), _vm._v(" "), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('tran')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('pumpBase')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[2]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td4"
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _vm._v(" "), _c('td', {
    staticClass: "x_td4",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v(_vm._s(_vm.statics.medical_history))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.haveData),
      expression: "!haveData"
    }],
    staticClass: "no-data"
  }, [_vm._v("\n    No Data\n  ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveData),
      expression: "haveData"
    }]
  }, _vm._l((_vm.pagePos), function(base, p) {
    return _c('div', [(p >= 1) ? _c('div', [_c('div', {
      staticClass: "page-seperator"
    }), _vm._v(" "), _c('div', {
      staticClass: "page-starter"
    })]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "alert-table-header"
    }, [_c('tr', [_c('td', {
      attrs: {
        "width": "30%"
      }
    }, [_vm._v(_vm._s(_vm.$t('time')))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(_vm.$t('type')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Alert')))])])]), _vm._v(" "), _vm._l((_vm.alerts.slice(base, base + _vm.perPage[p])), function(item, index) {
      return _c('table', {
        staticClass: "alert-table",
        attrs: {
          "id": 'tbl' + base + index
        }
      }, [_c('tr', {
        class: (index % 2 === 0) ? '' : 'x_even'
      }, [_c('td', {
        attrs: {
          "width": "30%"
        }
      }, [_vm._v(_vm._s(item[0]))]), _vm._v(" "), _c('td', {
        attrs: {
          "width": "20%"
        }
      }, [_vm._v(_vm._s(item[3]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item[1]))])])])
    })], 2)
  })), _vm._v(" "), (_vm.chartEndPage.show) ? _c('div', [_c('div', {
    staticClass: "page-seperator"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-end"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(19)
    }
  })])
}]}

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "monitor-container"
  }, [_c('el-card', {
    staticClass: "monitor-card1"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('CGM')))])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('timeOfLaRead')) + " :"), _c('span', [_vm._v(" " + _vm._s(_vm.sensorTime))])])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('table', {
    staticClass: "status-table1"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('tranSn')) + ":  "), _c('label', [_vm._v(_vm._s(_vm.sensor.serial))])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('status')) + ":"), _c('label', [_vm._v(_vm._s(_vm.sensor.status))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('sensorLife')) + ":"), _c('label', [_vm._v(_vm._s(_vm.sensor.sensorLifetimeTotalCount))])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('lastSenorRead')) + ": "), _c('label', [_vm._v(_vm._s(_vm.getGlucose))]), _vm._v(" "), _c('img', {
    staticClass: "sgIcon",
    attrs: {
      "src": _vm.sgIcon,
      "id": "sgIcon"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_vm._v(_vm._s(_vm.updateTime1))])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('TranBattery')) + ":\n            "), (_vm.showCGMStatus) ? _c('img', {
    attrs: {
      "src": _vm.batteryIcon
    }
  }) : _c('label', [_vm._v("--")])])])]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "graph",
    attrs: {
      "id": "chart1",
      "element-loading-text": _vm.loadingText
    }
  })])], 1), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "legend-group",
    class: {
      'zh1': !_vm.isEn, 'es1': _vm.isEs, 'de1': _vm.isDe, 'it1': _vm.isIt, 'po1': _vm.isPo, 'du1': _vm.isDu || _vm.isFr || _vm.isCz
    }
  }, [_c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(88)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('alert')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(116)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('target')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": __webpack_require__(112)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('hypo')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": __webpack_require__(105)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('sensorGlucose')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(110)
    }
  }), _c('span', {
    class: {
      'zh4': !_vm.isEn
    }
  }, [_vm._v(_vm._s(_vm.$t('calib')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(118)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('newSen')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1",
    class: {
      'zh2': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(119)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('warm')))])])])], 1), _vm._v(" "), _c('el-card', {
    staticClass: "monitor-card2"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('InsulinPump')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('timeOfLaPump')) + " : "), _c('span', [_vm._v(" " + _vm._s(_vm.pumpTime))])])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('table', {
    staticClass: "status-table1 status-table2"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('pumpSN')) + ": "), _c('label', [_vm._v(_vm._s(_vm.pump.serial))])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('status')) + ":"), _c('label', [_vm._v(_vm._s(_vm.pump.state))])]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('ReserviorLife')) + ": "), _c('label', [_vm._v(_vm._s(_vm.pump.remainingTime))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('InsulinLeft')) + ": "), _c('label', [_vm._v(_vm._s(_vm.pump.remainingDose))])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('basal')) + ":"), _c('label', [_vm._v(_vm._s(_vm.pump.basalRate) + " ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('totalBasal')) + ":"), _c('label', [_vm._v(_vm._s(_vm.pump.basalSum))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('lastBolus')) + ":"), _c('label', [_vm._v(_vm._s(_vm.lastBolus))])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v(_vm._s(_vm.$t('activeInsulin')) + ":"), _c('label', [_vm._v(_vm._s(_vm.pump.iob))])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('totalBolus')) + ":"), _c('label', [_vm._v(_vm._s(_vm.pump.bolusSum) + " ")])])])]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "chart2"
    }
  })])], 1), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "legend-group card2-legend",
    class: {
      'zh3': !_vm.isEn, 'es3': _vm.isEs, 'de3': _vm.isDe, 'it2': _vm.isIt, 'po2': _vm.isPo, 'du2': _vm.isDu || _vm.isFr || _vm.isCz, 'sw2': _vm.isSw
    }
  }, [_c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(88)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('alert')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(109)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('basal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(117)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('tampBasal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend "
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(114)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('normalBolus')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend "
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(111)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('extendBolus')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend "
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(106)
    }
  }), _c('span', {
    staticClass: "span1"
  }, [_vm._v(_vm._s(_vm.$t('manualStop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend sep-1"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(115)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('stop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend sep-2"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(113)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('newPatch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend spe"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(104)
    }
  }), _c('span', {
    staticClass: "span1"
  }, [_vm._v(_vm._s(_vm.$t('autoStop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(108)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1222_auto_basal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(107)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1222_auto_bolus')))])])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.showConfirmDialog,
      "size": _vm.dialogSize,
      "id": "dialog-form2",
      "show-close": false,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showConfirmDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('privacy_policy_and_terms_of_use')))])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-content"
  }, [_c('p', {
    attrs: {
      "id": "privacy_confirm_text"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('privacy_confirm_text'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [_c('button', {
    staticClass: "deny",
    on: {
      "click": _vm.denyPrivacyConfirm
    }
  }, [_vm._v(_vm._s(_vm.$t('privacy_confirm_disagree')))]), _vm._v(" "), _c('button', {
    staticClass: "agree",
    on: {
      "click": _vm.agreePrivacyConfirm
    }
  }, [_vm._v(_vm._s(_vm.$t('privacy_confirm_accept')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1488 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setting-context"
  }, [_c('div', {
    staticClass: "setting-main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('staticSettings')) + " (" + _vm._s(_vm.settingsData.glucose_unit) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('button', {
    staticClass: "cancel",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.apply
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "setting-main-context"
  }, [_c('div', {
    staticClass: "item1 overflow",
    class: {
      'it2': _vm.isIt, 'po2': _vm.isPo, 'es12': _vm.isEs || _vm.isFr
    }
  }, [_c('span', {
    staticClass: "alert-option",
    class: {
      'it3': _vm.isIt, 'po3': _vm.isPo, 'du2': _vm.isDu, 'de12': _vm.isDe, 'es13': _vm.isEs || _vm.isSw, 'fr13': _vm.isFr || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('showAlert')))]), _vm._v(" "), _c('div', {
    staticClass: "alert-left",
    class: {
      'alert-choose': _vm.alertOption
    },
    on: {
      "click": function($event) {
        _vm.changeAlarm(0)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('On')))])]), _vm._v(" "), _c('div', {
    staticClass: "alert-right",
    class: {
      'alert-choose': !_vm.alertOption
    },
    on: {
      "click": function($event) {
        _vm.changeAlarm(1)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Off')))])])]), _vm._v(" "), (true) ? _c('div', {
    staticClass: "item1 overflow",
    class: {
      'it2': _vm.isIt, 'po2': _vm.isPo, 'es12': _vm.isEs || _vm.isFr
    }
  }, [_c('span', {
    staticClass: "alert-option",
    class: {
      'it3': _vm.isIt, 'po3': _vm.isPo, 'du2': _vm.isDu, 'de12': _vm.isDe, 'es13': _vm.isEs || _vm.isSw, 'fr13': _vm.isFr || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('t1215_Show_Glucose_Value')))]), _vm._v(" "), _c('div', {
    staticClass: "alert-left",
    class: {
      'alert-choose': _vm.glucoseOption
    },
    on: {
      "click": function($event) {
        _vm.changeGlucose(0)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('On')))])]), _vm._v(" "), _c('div', {
    staticClass: "alert-right",
    class: {
      'alert-choose': !_vm.glucoseOption
    },
    on: {
      "click": function($event) {
        _vm.changeGlucose(1)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Off')))])])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "small-hr spe-hr"
  }), _vm._v(" "), _c('p', {
    class: {
      'zh9': !_vm.isEn, 'de9': _vm.isDe
    }
  }, [_vm._v(_vm._s(_vm.$t('glucoseTarget')))]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr spe-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_c('div', {
    staticClass: "item-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('overall')))]), _c('span', [_vm._v(_vm._s(_vm.$t('Hypoglycemia')))])]), _vm._v(" "), _c('div', {
    staticClass: "item-right",
    class: {
      'zh10': !_vm.isEn, 'it9': _vm.isIt, 'po9': _vm.isPo
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_low),
      expression: "settingsData.blos_low"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_low = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgLow), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  })), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_high),
      expression: "settingsData.blos_high"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_high = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgHigh), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  })), _vm._v(" "), (_vm.settingsData != null) ? _c('span', {
    staticClass: "hyp"
  }, [_vm._v(_vm._s(_vm.settingsData.hypo))]) : _vm._e()])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr spe-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "titleLabl"
  }, [_c('p', {
    staticClass: "spe-label",
    class: {
      'zh6': !_vm.isEn, 'de6': _vm.isDe
    }
  }, [_vm._v(_vm._s(_vm.$t('glucoseTarget')))]), _vm._v(" "), _c('p', {
    class: {
      'zh7': !_vm.isEn, 'es7': _vm.isEs, 'de7': _vm.isDe, 'it7': _vm.isIt, 'po7': _vm.isPo || _vm.isFr, 'sw7': _vm.isSw
    }
  }, [_vm._v(_vm._s(_vm.$t('timePeriod')))]), _vm._v(" "), _c('p', {
    staticClass: "spe1-label1",
    class: {
      'zh8': !_vm.isEn, 'es8': _vm.isEs, 'de8': _vm.isDe, 'po8': _vm.isPo || _vm.isFr, 'sw8': _vm.isSw || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('postMeal')))])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr spe-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "titleLab2"
  }, [_c('span', {
    staticClass: "spe-labe2",
    class: {
      'zh4': !_vm.isEn, 'es4': _vm.isEs, 'de4': _vm.isDe, 'it4': _vm.isIt, 'du4': _vm.isDu
    }
  }, [_vm._v(_vm._s(_vm.$t('Low')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('High')))]), _vm._v(" "), _c('span', {
    staticClass: "largeSpace",
    class: {
      'it6': _vm.isIt, 'po6': _vm.isPo
    }
  }, [_vm._v(_vm._s(_vm.$t('From')))]), _c('span', {
    class: {
      'fr6': _vm.isFr
    }
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('span', {
    staticClass: "largeSpace1",
    class: {
      'zh5': !_vm.isEn, 'es5': _vm.isEs, 'it6': _vm.isIt, 'po5': _vm.isPo, 'fr7': _vm.isFr
    }
  }, [_vm._v(_vm._s(_vm.$t('From')))]), _c('span', [_vm._v(_vm._s(_vm.$t('To')))])]), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_c('div', {
    staticClass: "item1-1"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Breakfast')))])]), _vm._v(" "), _c('div', {
    staticClass: "item1-2",
    class: {
      'zh1': !_vm.isEn, 'de2': _vm.isDe, 'du3': _vm.isDu, 'fr3': _vm.isFr, 'sw3': _vm.isSw
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Before')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('After')))])]), _vm._v(" "), _c('div', {
    staticClass: "item1-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_low_before_b),
      expression: "settingsData.blos_low_before_b"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_low_before_b = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgLow), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  })), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_high_before_b),
      expression: "settingsData.blos_high_before_b"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_high_before_b = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgHigh), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  })), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_low_after_b),
      expression: "settingsData.blos_low_after_b"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_low_after_b = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgLowAfter), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  })), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_high_after_b),
      expression: "settingsData.blos_high_after_b"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_high_after_b = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgHighAfter), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "item1-4 Setting-time"
  }, [_c('el-time-select', {
    attrs: {
      "size": "mini",
      "clearable": false,
      "editable": false,
      "picker-options": {
        start: '06:00',
        step: '00:15',
        end: '10:00'
      },
      "placeholder": "Time"
    },
    model: {
      value: (_vm.settingsData.btime1_s),
      callback: function($$v) {
        _vm.settingsData.btime1_s = $$v
      },
      expression: "settingsData.btime1_s "
    }
  }), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('el-time-select', {
    attrs: {
      "size": "mini",
      "placeholder": "Time",
      "clearable": false,
      "editable": false,
      "picker-options": {
        start: '06:00',
        step: '00:15',
        end: '10:00',
        minTime: _vm.settingsData.btime1_s
      }
    },
    model: {
      value: (_vm.settingsData.btime1_e),
      callback: function($$v) {
        _vm.settingsData.btime1_e = $$v
      },
      expression: "settingsData.btime1_e "
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item1-5 Setting-time"
  }, [_c('el-time-select', {
    attrs: {
      "size": "mini",
      "placeholder": "Time",
      "clearable": false,
      "editable": false,
      "picker-options": {
        start: '00:30',
        step: '00:15',
        end: '2:00'
      }
    },
    model: {
      value: (_vm.settingsData.afterb_s),
      callback: function($$v) {
        _vm.settingsData.afterb_s = $$v
      },
      expression: "settingsData.afterb_s "
    }
  }), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('el-time-select', {
    attrs: {
      "size": "mini",
      "placeholder": "Time",
      "clearable": false,
      "editable": false,
      "picker-options": {
        start: '01:00',
        step: '00:15',
        end: '4:00',
        minTime: _vm.settingsData.afterb_s
      }
    },
    model: {
      value: (_vm.settingsData.afterb_e),
      callback: function($$v) {
        _vm.settingsData.afterb_e = $$v
      },
      expression: "settingsData.afterb_e "
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.$t('Hours')))])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr spe-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_c('div', {
    staticClass: "item1-1"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Lunch')))])]), _vm._v(" "), _c('div', {
    staticClass: "item1-2",
    class: {
      'zh1': !_vm.isEn, 'de2': _vm.isDe, 'du3': _vm.isDu, 'fr3': _vm.isFr, 'sw3': _vm.isSw
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Before')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('After')))])]), _vm._v(" "), _c('div', {
    staticClass: "item1-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_low_before_l),
      expression: "settingsData.blos_low_before_l"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_low_before_l = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgLow), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  })), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_high_before_l),
      expression: "settingsData.blos_high_before_l"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_high_before_l = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgHigh), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  })), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_low_after_l),
      expression: "settingsData.blos_low_after_l"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_low_after_l = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgLowAfter), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  })), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_high_after_l),
      expression: "settingsData.blos_high_after_l"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_high_after_l = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgHighAfter), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "item1-4 Setting-time"
  }, [_c('el-time-select', {
    attrs: {
      "size": "mini",
      "clearable": false,
      "editable": false,
      "picker-options": {
        start: '11:00',
        step: '00:15',
        end: '15:00'
      },
      "placeholder": "Time"
    },
    model: {
      value: (_vm.settingsData.ltime1_s),
      callback: function($$v) {
        _vm.settingsData.ltime1_s = $$v
      },
      expression: "settingsData.ltime1_s "
    }
  }), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('el-time-select', {
    attrs: {
      "size": "mini",
      "placeholder": "Time",
      "clearable": false,
      "editable": false,
      "picker-options": {
        start: '11:00',
        step: '00:15',
        end: '15:00',
        minTime: _vm.settingsData.ltime1_s
      }
    },
    model: {
      value: (_vm.settingsData.ltime1_e),
      callback: function($$v) {
        _vm.settingsData.ltime1_e = $$v
      },
      expression: "settingsData.ltime1_e "
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item1-5 Setting-time"
  }, [_c('el-time-select', {
    attrs: {
      "size": "mini",
      "clearable": false,
      "editable": false,
      "picker-options": {
        start: '00:30',
        step: '00:15',
        end: '2:00'
      },
      "placeholder": "Time"
    },
    model: {
      value: (_vm.settingsData.afterl_s),
      callback: function($$v) {
        _vm.settingsData.afterl_s = $$v
      },
      expression: "settingsData.afterl_s "
    }
  }), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('el-time-select', {
    attrs: {
      "size": "mini",
      "placeholder": "Time",
      "clearable": false,
      "editable": false,
      "picker-options": {
        start: '1:00',
        step: '00:15',
        end: '4:00',
        minTime: _vm.settingsData.afterl_s
      }
    },
    model: {
      value: (_vm.settingsData.afterl_e),
      callback: function($$v) {
        _vm.settingsData.afterl_e = $$v
      },
      expression: "settingsData.afterl_e "
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.$t('Hours')))])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr spe-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_c('div', {
    staticClass: "item1-1"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Dinner')))])]), _vm._v(" "), _c('div', {
    staticClass: "item1-2",
    class: {
      'zh1': !_vm.isEn, 'de2': _vm.isDe, 'du3': _vm.isDu, 'fr3': _vm.isFr, 'sw3': _vm.isSw
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Before')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('After')))])]), _vm._v(" "), _c('div', {
    staticClass: "item1-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_low_before_s),
      expression: "settingsData.blos_low_before_s"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_low_before_s = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgLow), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  })), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_high_before_s),
      expression: "settingsData.blos_high_before_s"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_high_before_s = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgHigh), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  })), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_low_after_s),
      expression: "settingsData.blos_low_after_s"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_low_after_s = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgLowAfter), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  })), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_high_after_s),
      expression: "settingsData.blos_high_after_s"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_high_after_s = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgHighAfter), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "item1-4 Setting-time"
  }, [_c('el-time-select', {
    attrs: {
      "size": "mini",
      "clearable": false,
      "editable": false,
      "picker-options": {
        start: '17:00',
        step: '00:15',
        end: '21:00'
      },
      "placeholder": "Time"
    },
    model: {
      value: (_vm.settingsData.stime1_s),
      callback: function($$v) {
        _vm.settingsData.stime1_s = $$v
      },
      expression: "settingsData.stime1_s "
    }
  }), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('el-time-select', {
    attrs: {
      "size": "mini",
      "placeholder": "Time",
      "clearable": false,
      "editable": false,
      "picker-options": {
        start: '17:00',
        step: '00:15',
        end: '21:00',
        minTime: _vm.settingsData.stime1_s
      }
    },
    model: {
      value: (_vm.settingsData.stime1_e),
      callback: function($$v) {
        _vm.settingsData.stime1_e = $$v
      },
      expression: "settingsData.stime1_e "
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item1-5 Setting-time"
  }, [_c('el-time-select', {
    attrs: {
      "size": "mini",
      "clearable": false,
      "editable": false,
      "picker-options": {
        start: '00:30',
        step: '00:15',
        end: '2:00'
      },
      "placeholder": "Time"
    },
    model: {
      value: (_vm.settingsData.afters_s),
      callback: function($$v) {
        _vm.settingsData.afters_s = $$v
      },
      expression: "settingsData.afters_s "
    }
  }), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('el-time-select', {
    attrs: {
      "size": "mini",
      "placeholder": "Time",
      "clearable": false,
      "editable": false,
      "picker-options": {
        start: '1:00',
        step: '00:15',
        end: '4:00',
        minTime: _vm.settingsData.afters_s
      }
    },
    model: {
      value: (_vm.settingsData.afters_e),
      callback: function($$v) {
        _vm.settingsData.afters_e = $$v
      },
      expression: "settingsData.afters_e "
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.$t('Hours')))])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr spe-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_c('div', {
    staticClass: "item1-1"
  }, [_c('span', {
    staticClass: "night",
    class: {
      'es3': _vm.isEs
    }
  }, [_vm._v(_vm._s(_vm.$t('night')))])]), _vm._v(" "), _c('div', {
    staticClass: "item1-3 spe-ietm",
    class: {
      'zh2': !_vm.isEn, 'es2': _vm.isEs
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_low_night),
      expression: "settingsData.blos_low_night"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_low_night = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgLow), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  })), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_high_night),
      expression: "settingsData.blos_high_night"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_high_night = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgHigh), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "item1-4 Setting-time"
  }, [_c('el-time-select', {
    attrs: {
      "size": "mini",
      "clearable": false,
      "editable": false,
      "picker-options": {
        start: '22:00',
        step: '00:15',
        end: '24:00'
      },
      "placeholder": "Time"
    },
    model: {
      value: (_vm.settingsData.etime1_s),
      callback: function($$v) {
        _vm.settingsData.etime1_s = $$v
      },
      expression: "settingsData.etime1_s  "
    }
  }), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('el-time-select', {
    attrs: {
      "size": "mini",
      "clearable": false,
      "editable": false,
      "picker-options": {
        start: '05:00',
        step: '00:15',
        end: '07:00'
      },
      "placeholder": "Time"
    },
    model: {
      value: (_vm.settingsData.etime1_e),
      callback: function($$v) {
        _vm.settingsData.etime1_e = $$v
      },
      expression: "settingsData.etime1_e  "
    }
  })], 1)])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr spe-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "setting-operate2"
  }, [_c('button', {
    staticClass: "reset",
    class: {
      'es1': _vm.isEs, 'de1': _vm.isDe, 'it1': _vm.isIt || _vm.isCz, 'po1': _vm.isPo, 'du1': _vm.isDu
    },
    on: {
      "click": _vm.restore
    }
  }, [_vm._v(_vm._s(_vm.$t('Reset')))])])])
},staticRenderFns: []}

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "connect-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('connections')))]), _vm._v(" "), _c('button', {
    class: {
      'de1': _vm.isDe
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v(_vm._s(_vm.$t('Add Connection')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": _vm.loadingText
    }
  }, [_c('div', {
    staticClass: "patient-table"
  }, [_c('table', {
    attrs: {
      "id": "patientList"
    }
  }, [_c('tr', {
    staticClass: "header"
  }, [_c('td', [_vm._v(_vm._s(_vm.$t('Name')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('SG'))), _c('br'), _vm._v("(" + _vm._s(_vm.unit) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('basal'))), _c('br'), _vm._v(_vm._s(_vm.$t('basal_unit')))]), _c('td', [_vm._v(_vm._s(_vm.$t('Active Insulin'))), _c('br'), _vm._v(_vm._s(_vm.$t('ins_unit')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Action')))])]), _vm._v(" "), _vm._l((_vm.connections), function(item, index) {
    return _c('tr', {
      class: (index % 2 === 0) ? '' : 'even',
      attrs: {
        "id": index
      }
    }, [_c('td', {
      staticClass: "name",
      attrs: {
        "id": index
      },
      on: {
        "click": _vm.go
      }
    }, [_c('img', {
      staticClass: "portrait",
      attrs: {
        "src": '/api/v2.0/person/' + item.uid + '/portrait'
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "name1"
    }, [_vm._v(_vm._s(item.alias))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.sensor_status.glucose))]), _c('td', [_vm._v(_vm._s(item.pump_status.basalRate))]), _c('td', [_vm._v(_vm._s(item.pump_status.iob))]), _vm._v(" "), _c('td', {
      staticClass: "name",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": _vm.StopFollow
      }
    }, [_vm._v(_vm._s(_vm.$t('Stop following')))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "patientList-block"
  }, [_c('img', {
    class: {
      'click1': !_vm.has_prev
    },
    attrs: {
      "src": __webpack_require__(121)
    },
    on: {
      "click": _vm.prevPage
    }
  }), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.page),
      expression: "page"
    }],
    domProps: {
      "value": (_vm.page)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && $event.keyCode !== 13) { return null; }
        _vm.goPage($event)
      },
      "blur": _vm.goPage,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.page = $event.target.value
      }
    }
  }), _vm._v(" of   " + _vm._s(_vm.pages))]), _vm._v(" "), _c('img', {
    class: {
      'click1': !_vm.has_next
    },
    attrs: {
      "src": __webpack_require__(120)
    },
    on: {
      "click": _vm.nextPage
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n\n           " + _vm._s(_vm.$t('copyright'))), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.showConfirmDialog,
      "size": _vm.dialogSize,
      "id": "dialog-form2",
      "show-close": false,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showConfirmDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('privacy_policy_and_terms_of_use')))])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-content"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('privacy_confirm_text'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [_c('button', {
    staticClass: "deny",
    on: {
      "click": _vm.denyPrivacyConfirm
    }
  }, [_vm._v(_vm._s(_vm.$t('privacy_confirm_disagree')))]), _vm._v(" "), _c('button', {
    staticClass: "agree",
    on: {
      "click": _vm.agreePrivacyConfirm
    }
  }, [_vm._v(_vm._s(_vm.$t('privacy_confirm_accept')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "records-container"
  }, [_c('el-card', {
    staticClass: "records-card1"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('records')))])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('button', {
    staticClass: "print",
    on: {
      "click": _vm.print
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Profile')) + ":")]), _vm._v(" "), _c('table', [_c('tr', {
    staticClass: "header"
  }, [_c('td', [_vm._v(_vm._s(_vm.$t('uername')))]), _c('td', [_vm._v(_vm._s(_vm.$t('Name')))]), _c('td', [_vm._v(_vm._s(_vm.$t('Age')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('height')))]), _c('td', [_vm._v(_vm._s(_vm.$t('weight')))]), _c('td', [_vm._v(_vm._s(_vm.$t('disType')))]), _c('td', [_vm._v(_vm._s(_vm.$t('Duration')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.profile.username))]), _c('td', [_vm._v(_vm._s(_vm.profile.name))]), _c('td', [_vm._v(_vm._s(_vm.profile.birthday))]), _c('td', [_vm._v(_vm._s(_vm.profile.height))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.profile.weight))]), _c('td', [_vm._v(_vm._s(_vm.profile.diabetes_type))]), _c('td', [_vm._v(_vm._s(_vm.profile.diabetes_diagnosis_date))])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Complications')) + ":")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.userType !== 'P')),
      expression: "(userType!=='P')"
    }],
    staticClass: "print print1",
    on: {
      "click": _vm.create1
    }
  }, [_vm._v(_vm._s(_vm.$t('Create')))]), _vm._v(" "), _c('table', [_c('tr', {
    staticClass: "header"
  }, [_c('td', [_vm._v(_vm._s(_vm.$t('Concomitant diseases')))]), _c('td', [_vm._v(_vm._s(_vm.$t('disDate')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Suggestion')))]), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.userType !== 'P')),
      expression: "(userType!=='P')"
    }]
  }, [_vm._v(_vm._s(_vm.$t('Action')))])]), _vm._v(" "), _vm._l((_vm.complications), function(item, index) {
    return _c('tr', {
      class: (index % 2 === 0) ? '' : 'even',
      attrs: {
        "id": index
      }
    }, [_c('td', [_vm._v(_vm._s(item[1]))]), _c('td', [_vm._v(_vm._s(item[2]))]), _vm._v(" "), _c('td', {
      staticClass: "cntW"
    }, [_vm._v(_vm._s(item[3]))]), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((_vm.userType !== 'P')),
        expression: "(userType!=='P')"
      }]
    }, [_c('span', {
      staticClass: "action",
      on: {
        "click": _vm.edit1
      }
    }, [_vm._v(_vm._s(_vm.$t('edit')))]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "action",
      on: {
        "click": _vm.delete1
      }
    }, [_vm._v(_vm._s(_vm.$t('Delete')))])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Prescription')) + ":")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.userType !== 'P')),
      expression: "(userType!=='P')"
    }],
    staticClass: "print print1",
    on: {
      "click": _vm.create2
    }
  }, [_vm._v(_vm._s(_vm.$t('Create')))]), _vm._v(" "), _c('table', [_c('tr', {
    staticClass: "header"
  }, [_c('td', [_vm._v(_vm._s(_vm.$t('Medicine')))]), _c('td', [_vm._v(_vm._s(_vm.$t('Dose')))]), _c('td', [_vm._v(_vm._s(_vm.$t('Notes')))]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.userType !== 'P')),
      expression: "(userType!=='P')"
    }]
  }, [_vm._v(_vm._s(_vm.$t('Action')))])]), _vm._v(" "), _vm._l((_vm.prescription), function(item, index) {
    return _c('tr', {
      class: (index % 2 === 0) ? '' : 'even',
      attrs: {
        "id": index
      }
    }, [_c('td', [_vm._v(_vm._s(item[1]))]), _c('td', [_vm._v(_vm._s(item[2]))]), _vm._v(" "), _c('td', {
      staticClass: "cntW"
    }, [_vm._v(_vm._s(item[3]))]), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((_vm.userType !== 'P')),
        expression: "(userType!=='P')"
      }]
    }, [_c('span', {
      staticClass: "action",
      on: {
        "click": _vm.edit2
      }
    }, [_vm._v(_vm._s(_vm.$t('edit')))]), _c('br'), _c('span', {
      staticClass: "action",
      on: {
        "click": _vm.delete2
      }
    }, [_vm._v(_vm._s(_vm.$t('Delete')))])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Other suggestions')) + ":")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.userType !== 'P')),
      expression: "(userType!=='P')"
    }],
    staticClass: "print print1",
    on: {
      "click": _vm.create3
    }
  }, [_vm._v(_vm._s(_vm.$t('Create')))]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'zh1': !_vm.isEn
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('From')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "to"
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1)]), _vm._v(" "), _c('table', [_c('tr', {
    staticClass: "header"
  }, [_c('td', [_vm._v(_vm._s(_vm.$t('HCP')))]), _c('td', [_vm._v(_vm._s(_vm.$t('date')))]), _c('td', [_vm._v(_vm._s(_vm.$t('Suggestion')))]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.userType !== 'P')),
      expression: "(userType!=='P')"
    }]
  }, [_vm._v(_vm._s(_vm.$t('Action')))])]), _vm._v(" "), _vm._l((_vm.suggestions), function(item, index) {
    return _c('tr', {
      class: (index % 2 === 0) ? '' : 'even',
      attrs: {
        "id": index
      }
    }, [_c('td', [_vm._v(_vm._s(item[3]))]), _c('td', [_vm._v(_vm._s(item[1]))]), _vm._v(" "), _c('td', {
      staticClass: "cntW"
    }, [_vm._v(_vm._s(item[2]))]), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((_vm.userType !== 'P')),
        expression: "(userType!=='P')"
      }]
    }, [_c('span', {
      staticClass: "action",
      on: {
        "click": _vm.edit3
      }
    }, [_vm._v(_vm._s(_vm.$t('edit')))]), _c('br'), _c('span', {
      staticClass: "action",
      on: {
        "click": _vm.delete3
      }
    }, [_vm._v(_vm._s(_vm.$t('Delete')))])])])
  })], 2)])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-form2",
    attrs: {
      "visible": _vm.CreateVisible,
      "size": _vm.dialogSize,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.CreateVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Create')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(21)
    },
    on: {
      "click": _vm.cancel
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeA),
      expression: "typeA"
    }]
  }, [_c('div', {
    staticClass: "cont",
    class: {
      'es1': _vm.isEs
    }
  }, [_c('span', {
    class: {
      'de1': _vm.isDe, 'it1': _vm.isIt, 'cz1': _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('Concomitant diseases')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.t1),
      expression: "t1"
    }],
    staticClass: "dis",
    class: {
      'zh2': !_vm.isEn
    },
    attrs: {
      "maxlength": "20",
      "placeholder": _vm.tip0
    },
    domProps: {
      "value": (_vm.t1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.t1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    class: {
      'es1': _vm.isEs
    }
  }, [_c('span', {
    staticClass: "date",
    class: {
      'es2': _vm.isEs, 'de2': _vm.isDe, 'du2': _vm.isDu, 'fr2': _vm.isFr, 'sw2': _vm.isSw
    }
  }, [_vm._v(_vm._s(_vm.$t('disDate')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.Time,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Suggestion')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.t2),
      expression: "t2"
    }],
    staticClass: "sugg",
    class: {
      'zh3': !_vm.isEn, 'de3': _vm.isDe, 'it3': _vm.isIt, 'po3': _vm.isPo, 'du3': _vm.isDu, 'fr3': _vm.isFr, 'sw3': _vm.isSw, 'cz3': _vm.isCz
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip1,
      "maxlength": 40
    },
    domProps: {
      "value": (_vm.t2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.t2 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeB),
      expression: "typeB"
    }]
  }, [_c('div', {
    staticClass: "cont"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Medicine')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.t3),
      expression: "t3"
    }],
    staticClass: "medic",
    class: {
      'zh4': !_vm.isEn, 'it4': _vm.isIt, 'du4': _vm.isDu, 'cz4': _vm.isCz
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip3,
      "maxlength": 20
    },
    domProps: {
      "value": (_vm.t3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.t3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Dose')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.t4),
      expression: "t4"
    }],
    staticClass: "dose1",
    class: {
      'es5': _vm.isEs, 'de4': _vm.isDe, 'it5': _vm.isIt, 'fr4': _vm.isFr, 'sw4': _vm.isSw
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip2,
      "maxlength": 20
    },
    domProps: {
      "value": (_vm.t4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.t4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Notes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.t5),
      expression: "t5"
    }],
    staticClass: "sug1",
    class: {
      'zh5': !_vm.isEn, 'de5': _vm.isDe, 'du5': _vm.isDu, 'fr5': _vm.isFr, 'sw5': _vm.isSw, 'cz5': _vm.isCz
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip4,
      "maxlength": 40
    },
    domProps: {
      "value": (_vm.t5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.t5 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeC),
      expression: "typeC"
    }]
  }, [_c('div', {
    staticClass: "cont"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('HCP')))]), _vm._v(" "), _c('span', {
    staticClass: "hcp",
    class: {
      'zh7': !_vm.isEn, 'es7': _vm.isEs, 'du7': _vm.isDu, 'cz7': _vm.isCz
    },
    model: {
      value: (_vm.t6),
      callback: function($$v) {
        _vm.t6 = $$v
      },
      expression: "t6"
    }
  }, [_vm._v(_vm._s(_vm.username))])]), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "date",
    class: {
      'zh8': !_vm.isEn, 'po8': _vm.isPo || _vm.isDu || _vm.isFr
    },
    staticStyle: {
      "margin-right": "73px"
    }
  }, [_vm._v(_vm._s(_vm.$t('date')))]), _vm._v(" "), _c('span', {
    staticClass: "now",
    class: {
      'de8': _vm.isDe, 'po9': _vm.isPo
    },
    model: {
      value: (_vm.value4),
      callback: function($$v) {
        _vm.value4 = $$v
      },
      expression: "value4"
    }
  }, [_vm._v(_vm._s(_vm.now))])]), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "long-span"
  }, [_vm._v(_vm._s(_vm.$t('Content')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.t7),
      expression: "t7"
    }],
    staticClass: "textArea",
    class: {
      'zh6': !_vm.isEn, 'it7': _vm.isIt, 'cz8': _vm.isCz
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip5,
      "maxlength": "1000"
    },
    domProps: {
      "value": (_vm.t7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.t7 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeA),
      expression: "typeA"
    }],
    on: {
      "click": _vm.createRecord1
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeB),
      expression: "typeB"
    }],
    on: {
      "click": _vm.createRecord2
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeC),
      expression: "typeC"
    }],
    on: {
      "click": _vm.createRecord3
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))]), _vm._v(" "), _c('button', {
    staticClass: "cancelButton",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-form2",
    attrs: {
      "visible": _vm.EditVisible,
      "size": _vm.dialogSize,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.EditVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('edit')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(21)
    },
    on: {
      "click": _vm.cancel1
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeA1),
      expression: "typeA1"
    }]
  }, [_c('div', {
    staticClass: "cont",
    class: {
      'es1': _vm.isEs
    }
  }, [_c('span', {
    class: {
      'de1': _vm.isDe, 'it1': _vm.isIt, 'cz1': _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('Concomitant diseases')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edNote0),
      expression: "edNote0"
    }],
    staticClass: "dis",
    class: {
      'zh2': !_vm.isEn
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip0,
      "maxlength": "40"
    },
    domProps: {
      "value": (_vm.edNote0)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edNote0 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    class: {
      'es1': _vm.isEs
    }
  }, [_c('span', {
    staticClass: "date",
    class: {
      'es2': _vm.isEs, 'de2': _vm.isDe, 'du2': _vm.isDu, 'fr2': _vm.isFr, 'sw2': _vm.isSw
    }
  }, [_vm._v(_vm._s(_vm.$t('disDate')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.comp[2],
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value5),
      callback: function($$v) {
        _vm.value5 = $$v
      },
      expression: "value5"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Suggestion')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edNote1),
      expression: "edNote1"
    }],
    staticClass: "sugg",
    class: {
      'zh3': !_vm.isEn, 'de3': _vm.isDe, 'it3': _vm.isIt, 'po3': _vm.isPo, 'du3': _vm.isDu, 'fr3': _vm.isFr, 'sw3': _vm.isSw, 'cz3': _vm.isCz
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip1,
      "maxlength": "40"
    },
    domProps: {
      "value": (_vm.edNote1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edNote1 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeB1),
      expression: "typeB1"
    }]
  }, [_c('div', {
    staticClass: "cont"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Medicine')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edNote2),
      expression: "edNote2"
    }],
    staticClass: "medic",
    class: {
      'zh4': !_vm.isEn, 'it4': _vm.isIt, 'du4': _vm.isDu, 'cz4': _vm.isCz
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip3,
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.edNote2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edNote2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Dose')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edNote3),
      expression: "edNote3"
    }],
    staticClass: "dose1",
    class: {
      'es5': _vm.isEs, 'de4': _vm.isDe, 'it5': _vm.isIt, 'fr4': _vm.isFr, 'sw4': _vm.isSw
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip2,
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.edNote3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edNote3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Notes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edNote4),
      expression: "edNote4"
    }],
    staticClass: "sug1",
    class: {
      'zh5': !_vm.isEn, 'de5': _vm.isDe, 'du5': _vm.isDu, 'fr5': _vm.isFr, 'sw5': _vm.isSw, 'cz5': _vm.isCz
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip4,
      "maxlength": "40"
    },
    domProps: {
      "value": (_vm.edNote4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edNote4 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeC1),
      expression: "typeC1"
    }]
  }, [_c('div', {
    staticClass: "cont"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('HCP')))]), _vm._v(" "), _c('span', {
    staticClass: "hcp",
    class: {
      'zh7': !_vm.isEn, 'es7': _vm.isEs, 'du7': _vm.isDu, 'cz7': _vm.isCz
    },
    model: {
      value: (_vm.sug[3]),
      callback: function($$v) {
        var $$exp = _vm.sug,
          $$idx = 3;
        if (!Array.isArray($$exp)) {
          _vm.sug[3] = $$v
        } else {
          $$exp.splice($$idx, 1, $$v)
        }
      },
      expression: "sug[3]"
    }
  }, [_vm._v(_vm._s(_vm.sug[3]))])]), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "date",
    class: {
      'zh8': !_vm.isEn, 'po8': _vm.isPo || _vm.isDu || _vm.isFr
    },
    staticStyle: {
      "margin-right": "73px"
    }
  }, [_vm._v(_vm._s(_vm.$t('date')))]), _vm._v(" "), _c('span', {
    staticClass: "now",
    class: {
      'de8': _vm.isDe, 'po9': _vm.isPo
    },
    model: {
      value: (_vm.value6),
      callback: function($$v) {
        _vm.value6 = $$v
      },
      expression: "value6"
    }
  }, [_vm._v(_vm._s(_vm.now))])]), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "long-span"
  }, [_vm._v(_vm._s(_vm.$t('Content')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edNote5),
      expression: "edNote5"
    }],
    staticClass: "textArea",
    class: {
      'zh6': !_vm.isEn, 'it7': _vm.isIt, 'cz8': _vm.isCz
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip5,
      "maxlength": "1000"
    },
    domProps: {
      "value": (_vm.edNote5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edNote5 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeA1),
      expression: "typeA1"
    }],
    on: {
      "click": _vm.editRecords1
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeB1),
      expression: "typeB1"
    }],
    on: {
      "click": _vm.editRecords2
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeC1),
      expression: "typeC1"
    }],
    on: {
      "click": _vm.editRecords3
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))]), _vm._v(" "), _c('button', {
    staticClass: "cancelButton",
    on: {
      "click": _vm.cancel1
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background",
    class: {
      'long': _vm.long
    },
    attrs: {
      "id": "background"
    }
  }, [_c('div', {
    staticClass: "chart-container",
    class: {
      'longCont': _vm.long
    },
    attrs: {
      "id": "chart-container"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.styleText)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('EventReport')) + " (" + _vm._s(_vm.$t('By Date')) + ")")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('period')) + ":" + _vm._s(_vm.days))])])]), _vm._v(" "), _c('table', {
    staticClass: "status-table1"
  }, [_c('tr', [_c('td', {
    staticClass: "td4"
  }, [_vm._v(_vm._s(_vm.$t('uername')) + ": " + _vm._s(_vm.statics.username))]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v(_vm._s(_vm.$t('fullName')) + ": " + _vm._s(_vm.statics.name))]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v(_vm._s(_vm.$t('disType')) + ": " + _vm._s(_vm.statics.medical_history))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('HbA1c')) + ": " + _vm._s(_vm.hb1c))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _vm._l((_vm.pagePos), function(base, p) {
    return _c('div', [(p >= 1) ? _c('div', [_c('div', {
      staticClass: "page-seperator"
    }), _vm._v(" "), _c('div', {
      staticClass: "page-starter"
    })]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "events-table",
      staticStyle: {
        "margin-top": "5px"
      }
    }, [_c('tr', [_c('td', {
      staticClass: "td5",
      attrs: {
        "width": "52px"
      }
    }, [_vm._v(_vm._s(_vm.$t('date')))]), _vm._v(" "), _c('td', {
      staticClass: " spe1 td5"
    }), _vm._v(" "), _vm._l((_vm.hours), function(i) {
      return _c('td', {
        staticClass: "td2"
      }, [_vm._v(_vm._s(i))])
    }), _c('td', {
      staticClass: "spe2 td5"
    }, [_vm._v("Avg/#")])], 2)]), _vm._v(" "), _vm._l((_vm.whichDate.slice(base, base + _vm.perPage[p])), function(day, index) {
      return _c('table', {
        staticClass: "events-table",
        attrs: {
          "id": base + index
        }
      }, [_c('tr', [_c('td', {
        staticClass: "td1 td4",
        attrs: {
          "rowspan": "4",
          "width": "52px"
        }
      }, [_vm._v(_vm._s(day))]), _vm._v(" "), _c('td', {
        staticClass: "td1 spe1"
      }, [_vm._v(_vm._s(_vm.$t('BG1')))]), _vm._v(" "), _vm._l((24), function(i) {
        return _c('td')
      }), _c('td', {
        staticClass: "td1 spe2"
      })], 2), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "td3"
      }, [_vm._v(_vm._s(_vm.$t('carbs')))]), _vm._v(" "), _vm._l((24), function(i) {
        return _c('td')
      }), _vm._v(" "), _c('td', {
        staticClass: "td1 spe2"
      })], 2), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "td3"
      }, [_vm._v(_vm._s(_vm.$t('Injection')))]), _vm._v(" "), _vm._l((24), function(i) {
        return _c('td')
      }), _vm._v(" "), _c('td', {
        staticClass: "td1 spe2"
      })], 2), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "td3 td4"
      }, [_vm._v(_vm._s(_vm.$t('exercise')))]), _vm._v(" "), _vm._l((24), function(i) {
        return _c('td', {
          staticClass: "td4"
        })
      }), _vm._v(" "), _c('td', {
        staticClass: "td1 td4 spe2"
      })], 2)])
    })], 2)
  }), _vm._v(" "), (_vm.chartEndPage.show) ? _c('div', [_c('div', {
    staticClass: "page-seperator"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('static')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('type')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Avg')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('SD')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('max')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('min')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('#')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('BG1')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bgstat.day.avg))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bgstat.day.sd))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bgstat.day.max))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bgstat.day.min))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.bgstat.day.num))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('carbs')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.carbstat.day.avg))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.carbstat.day.sd))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.carbstat.day.max))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.carbstat.day.min))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.carbstat.day.num))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Injection')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bolstat.day.avg))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bolstat.day.sd))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bolstat.day.max))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bolstat.day.min))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.bolstat.day.num))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('exercise')))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.exerstat.day.avg))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.exerstat.day.sd))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.exerstat.day.max))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.exerstat.day.min))]), _c('td', [_vm._v(_vm._s(_vm.exerstat.day.num))])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-end"
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(19)
    }
  })])
}]}

/***/ }),
/* 1492 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "PainterList"
    }
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('el-card', {
    attrs: {
      "id": "list"
    }
  }, [_c('div', {
    staticClass: "menu-wrap"
  }, [_c('div', {
    staticClass: "title-bar"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('t0805_Operation_History')))]), _vm._v(" "), _c('p', {
    staticClass: "back-btn",
    on: {
      "click": _vm.backToMenu
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v(_vm._s(_vm.$t('t0805_Back')))])])]), _vm._v(" "), _c('div', {
    staticClass: "patient-table"
  }, [_c('table', {
    attrs: {
      "id": "patientList"
    }
  }, [_c('tr', {
    staticClass: "header"
  }, [_c('td', [_vm._v(_vm._s(_vm.$t('t0805_User')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('t0805_Time')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('t0805_Operation_Type')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Patient')))])]), _vm._v(" "), _vm._l((_vm.users), function(item, index) {
    return _c('tr', {
      class: (index % 2 === 0) ? '' : 'even'
    }, [_c('td', {
      staticClass: "name",
      attrs: {
        "id": index
      }
    }, [_c('p', {
      class: {
        'filterResult': false
      }
    }, [_vm._v(_vm._s(item.username))])]), _vm._v(" "), _c('td', {
      staticClass: "gender"
    }, [_vm._v(_vm._s(item.update_time))]), _vm._v(" "), _c('td', {
      staticClass: "small"
    }, [_vm._v(_vm._s(item.action))]), _vm._v(" "), _c('td', {
      staticClass: "small"
    }, [_vm._v(_vm._s(item.patient))])])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n\n          " + _vm._s(_vm.$t('copyright')) + " "), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "chart-container"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.styleText)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('TrendRe')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.$t('period')) + ": " + _vm._s(_vm.timeRange))])])]), _vm._v(" "), _c('table', {
    staticClass: "status-table1",
    class: {
      'zh1': !_vm.isEn, 'de1': _vm.isDe || _vm.isIt
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('uername')))]), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.username))]), _vm._v(" "), _c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('fullName')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('devices')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "id": "reportPdmTitle"
    }
  }, [_vm._v(_vm._s(_vm.$t('pdm')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('tran')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('pumpBase')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[2]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td4"
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _c('td', {
    staticClass: "td4",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v(_vm._s(_vm.statics.medical_history))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('img', {
    staticClass: "graph",
    attrs: {
      "id": "img4_1"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "rowspan": "2",
      "width": "9%"
    }
  }, [_vm._v(_vm._s(_vm.$t('static')))]), _vm._v(" "), _c('td', {
    staticClass: "td1",
    attrs: {
      "colspan": "10",
      "width": "29%"
    }
  }, [_vm._v(_vm._s(_vm.$t('Basics')))]), _vm._v(" "), _c('td', {
    staticClass: "td1",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('distri')) + "%")]), _vm._v(" "), _c('td', {
    staticClass: "td1",
    attrs: {
      "colspan": "4",
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('stab')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v(_vm._s(_vm.$t('BG1')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Avg')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('max')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('min')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Med')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Q1')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Q3')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('IQR')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('SD')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('CV')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('SE1')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('high')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('low')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('target')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('aucAbove')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('aucBelow')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('#high')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('#low')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('high')) + "%")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('low')) + "%")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('target')) + "%")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Avg')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('SD')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('#hypo')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('bgRead')))])]), _vm._v(" "), _vm._l((_vm.xDate2), function(day, j) {
    return _c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(day))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_avg))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_max))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_min))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_median))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_q1))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_q3))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_iqr))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_sd))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_cv))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_se))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_up))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_lp))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_tp))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_aucu))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_aucl))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_nu))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[j].sg_nl))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].bg_up))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].bg_lp))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[j].bg_tp))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].bg_avg))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].bg_sd))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].bg_hypo_num))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[j].bg_num))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Avg/Total')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_avg))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_max))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_min))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_median))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_q1))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_q3))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_iqr))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_sd))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_cv))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_se))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_up))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_lp))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_tp))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_aucu))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_aucl))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_nu))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].sg_nl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].bg_up))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].bg_lp))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].bg_tp))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].bg_avg))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].bg_sd))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].bg_hypo_num))]), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.dayNum].bg_num))])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "page-seperator"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('img', {
    staticClass: "graph",
    attrs: {
      "id": "img4_2"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "statics spe-statics"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table",
    class: {
      'de2': _vm.isDe
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "rowspan": "2",
      "width": "11%"
    }
  }, [_vm._v(_vm._s(_vm.$t('static')))]), _vm._v(" "), _c('td', {
    staticClass: "td1",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.$t('insulin2')))]), _vm._v(" "), _c('td', {
    staticClass: "td1",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('carbs')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('exercise')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('total')) + " " + _vm._s(_vm.$t('ins_unit')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('avg_daily_basal')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('avg_daily_bolus')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('ofBolus')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('avgBolus')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('carbs')) + " (g)")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('ofMeal')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Dura1')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('ofExer')))])]), _vm._v(" "), _vm._l((_vm.xDate2), function(day, i) {
    return _c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(day))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.event[i].ins_total))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_c('span', {
      staticClass: "value_percent_cell left_value"
    }, [_vm._v(_vm._s(_vm.event[i].ins_basal))]), _vm._v(" "), _c('span', {
      staticClass: "value_percent_cell right_percent"
    }, [_vm._v(_vm._s(_vm.event[i].ins_basal_p))])]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_c('span', {
      staticClass: "value_percent_cell left_value"
    }, [_vm._v(_vm._s(_vm.event[i].ins_bolus))]), _vm._v(" "), _c('span', {
      staticClass: "value_percent_cell right_percent"
    }, [_vm._v(_vm._s(_vm.event[i].ins_bolus_p))])]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.event[i].ins_bolus_n))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.event[i].ins_bolus_avg))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.event[i].carb_gram))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.event[i].carb_num))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.event[i].exer_time))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.event[i].exer_num))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('Avg/Total')))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].ins_total))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_c('span', {
    staticClass: "value_percent_cell left_value"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].ins_basal))]), _vm._v(" "), _c('span', {
    staticClass: "value_percent_cell right_percent"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].ins_basal_p))])]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_c('span', {
    staticClass: "value_percent_cell left_value"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].ins_bolus))]), _vm._v(" "), _c('span', {
    staticClass: "value_percent_cell right_percent"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].ins_bolus_p))])]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].ins_bolus_n))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].ins_bolus_avg))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].carb_gram))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].carb_num))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.event[_vm.dayNum].exer_time))]), _c('td', [_vm._v(_vm._s(_vm.event[_vm.dayNum].exer_num))])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "page-end"
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(19)
    }
  })])
}]}

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "chart-container"
  }, [_c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Records Report')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "9px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Profile')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('uername')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Name')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Age')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('height')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('weight')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Duration')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.profile.username))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.profile.name))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.profile.birthday))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.profile.height))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.profile.weight))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.profile.diabetes_type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.profile.diabetes_diagnosis_date))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Complications')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Concomitant diseases')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('disDate')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Suggestion')))])]), _vm._v(" "), _vm._l((_vm.complications), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(item[1]))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(item[2]))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(item[3]))])])
  }), _vm._v(" "), _vm._m(1)], 2)]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Prescription')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Medicine')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Dose')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Notes')))])]), _vm._v(" "), _vm._l((_vm.prescription), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(item[1]))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(item[2]))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(item[3]))])])
  }), _vm._v(" "), _vm._m(2)], 2)]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Other suggestions')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1",
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v(_vm._s(_vm.$t('HCP')))]), _c('td', {
    staticClass: "td1",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('date')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Content')))])]), _vm._v(" "), _vm._l((_vm.suggestions), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(item[3]))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(item[1]))]), _c('td', {
      staticClass: "td2",
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(item[2]))])])
  }), _vm._v(" "), _vm._m(3)], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(19)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "td3"
  }), _c('td', {
    staticClass: "td3"
  }), _c('td')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "td3"
  }), _c('td', {
    staticClass: "td3"
  }), _c('td')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "td3"
  }), _c('td', {
    staticClass: "td3"
  }), _c('td')])
}]}

/***/ }),
/* 1495 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    class: {
      'broad': _vm.tabB
    }
  }, [_c('div', {
    staticClass: "container",
    class: {
      'newStyle2': _vm.newStyle
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabA),
      expression: "tabA"
    }]
  }, [_c('div', {
    staticClass: "cont-head",
    class: {
      'newStyle': !_vm.newStyle
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('sign up')))])]), _vm._v(" "), _c('div', {
    staticClass: "user-type"
  }, [_c('div', {
    staticClass: "user-left",
    class: {
      'Select2': _vm.isB, 'choose-left': _vm.isB
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.check2()
      }
    }
  }, [_c('input', {
    class: [_vm.isB ? 'hide1' : ''],
    attrs: {
      "type": "radio"
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('Patient')))])]), _vm._v(" "), _c('div', {
    staticClass: "user-right",
    class: {
      'Select2': _vm.isC, 'choose-right': _vm.isC
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.check2()
      }
    }
  }, [_c('input', {
    class: [_vm.isC ? 'hide1' : ''],
    attrs: {
      "type": "radio"
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('Caregiver')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newStyle),
      expression: "newStyle"
    }],
    staticClass: "user-type"
  }, [_c('div', {
    staticClass: "user-left",
    class: {
      'Select2': _vm.isD, 'choose-left': _vm.isD
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.check3($event)
      }
    }
  }, [_c('input', {
    class: [_vm.isD ? 'hide1' : ''],
    attrs: {
      "type": "radio"
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('Email')))])]), _vm._v(" "), _c('div', {
    staticClass: "user-right",
    class: {
      'Select2': _vm.isE, 'choose-right': _vm.isE
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.check3($event)
      }
    }
  }, [_c('input', {
    class: [_vm.isE ? 'hide1' : ''],
    attrs: {
      "type": "radio"
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('Mobile')))])])]), _vm._v(" "), _c('hr', {
    class: {
      'broad': _vm.tabB
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "inputGroup"
    }
  }, [_c('div', {
    staticClass: "icon-bor"
  }, [_c('select', {
    attrs: {
      "id": "chooseCountry"
    },
    on: {
      "change": _vm.select
    }
  }, [_c('option', {
    attrs: {
      "value": "GB"
    }
  }, [_vm._v("United Kingdom (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AU"
    }
  }, [_vm._v("Australia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CN"
    }
  }, [_vm._v("中国 (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "HKF"
    }
  }, [_vm._v("香港(中国) (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TH"
    }
  }, [_vm._v("Thailand (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ID"
    }
  }, [_vm._v("Indonesia (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MY"
    }
  }, [_vm._v("Malaysia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "IN"
    }
  }, [_vm._v("India (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FR"
    }
  }, [_vm._v("France (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DE"
    }
  }, [_vm._v("Deutschland (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DD"
    }
  }, [_vm._v("Deutschland (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "HU"
    }
  }, [_vm._v("Magyarország (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "IT"
    }
  }, [_vm._v("Italia (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NL"
    }
  }, [_vm._v("Nederland (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Nor"
    }
  }, [_vm._v("Norge (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PT"
    }
  }, [_vm._v("Portugal (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ES"
    }
  }, [_vm._v("España (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SE"
    }
  }, [_vm._v("Sverige (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TR"
    }
  }, [_vm._v("Turkey (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Ro"
    }
  }, [_vm._v("Romania (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CZ"
    }
  }, [_vm._v("Czech republika (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SK"
    }
  }, [_vm._v("Slovenska republika (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LT"
    }
  }, [_vm._v("Lithuania (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PL"
    }
  }, [_vm._v("Polska (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DK"
    }
  }, [_vm._v("Danmark (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FI"
    }
  }, [_vm._v("Suomi (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CH"
    }
  }, [_vm._v("Switzerland (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SA"
    }
  }, [_vm._v("Saudi  (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AE"
    }
  }, [_vm._v("United Arab (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QA"
    }
  }, [_vm._v("Qatar  (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QW"
    }
  }, [_vm._v("Kuwait (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RH"
    }
  }, [_vm._v("Croatia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AT"
    }
  }, [_vm._v("Austria (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SI"
    }
  }, [_vm._v("Slovenia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EE"
    }
  }, [_vm._v("Estonia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LV"
    }
  }, [_vm._v("Latvia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BA"
    }
  }, [_vm._v("Bosnia and Herzegovina (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BG"
    }
  }, [_vm._v("Bulgaria (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CL"
    }
  }, [_vm._v("Chile (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BE"
    }
  }, [_vm._v("Belgium (mg/L)")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isD),
      expression: "isD"
    }],
    staticClass: "icon-bor icon-spe4",
    class: {
      'in': _vm.isF, 'vuerify-invalid': _vm.isO
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": _vm.disA,
      "placement": "top",
      "effect": "light",
      "offset": "-30"
    }
  }, [_c('div', {
    staticClass: "tooltip",
    slot: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('errtip1-1')))]), _c('br'), _c('span', [_vm._v(_vm._s(_vm.$t('errtip1-2')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.Ema
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.down(1)
      },
      "focus": function($event) {
        _vm.check54(0)
      },
      "blur": function($event) {
        _vm.check54(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'in2': (_vm.isF || _vm.isO), 'zh1': _vm.newStyle
    }
  }, [_c('button', {
    attrs: {
      "disabled": _vm.canClick
    },
    on: {
      "click": _vm.sendSeccode
    }
  }, [_c('label', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTime),
      expression: "showTime"
    }],
    staticClass: "showTime"
  }, [_vm._v(_vm._s(_vm.time))]), _vm._v(_vm._s(_vm.send))])])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isE),
      expression: "isE"
    }],
    staticClass: "icon-spe1",
    class: {
      'in': _vm.isG, 'vuerify-invalid': _vm.isP
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": _vm.disB,
      "placement": "top",
      "effect": "light"
    }
  }, [_c('div', {
    staticClass: "tooltip",
    slot: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('errtip2')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.Mob
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.down(1)
      },
      "focus": function($event) {
        _vm.check55(0)
      },
      "blur": function($event) {
        _vm.check55(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'in2': (_vm.isG || _vm.isP), 'zh1': _vm.newStyle
    }
  }, [_c('button', {
    attrs: {
      "disabled": _vm.canClick
    },
    on: {
      "click": _vm.sendSeccode
    }
  }, [_c('label', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTime),
      expression: "showTime"
    }],
    staticClass: "showTime"
  }, [_vm._v(_vm._s(_vm.time))]), _vm._v(_vm._s(_vm.send))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "icon-spe2",
    class: {
      'in': _vm.isH, 'vuerify-invalid': _vm.isQ
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": _vm.disC,
      "placement": "top",
      "effect": "light"
    }
  }, [_c('div', {
    staticClass: "tooltip",
    slot: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('errtip3')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vcode),
      expression: "vcode"
    }],
    attrs: {
      "type": "text",
      "autocomplete": "new-password",
      "placeholder": _vm.Veri
    },
    domProps: {
      "value": (_vm.vcode)
    },
    on: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.down(2)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.up(2)
      }],
      "focus": function($event) {
        _vm.check56(0)
      },
      "blur": function($event) {
        _vm.check56(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vcode = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "icon-bor",
    class: {
      'in': _vm.isJ, 'vuerify-invalid': _vm.isS
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": _vm.disE,
      "placement": "top",
      "effect": "light"
    }
  }, [_c('div', {
    staticClass: "tooltip",
    slot: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('errtip5')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.realname),
      expression: "realname"
    }],
    attrs: {
      "type": "text",
      "autocomplete": "new-password",
      "placeholder": _vm.fullname
    },
    domProps: {
      "value": (_vm.realname)
    },
    on: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.down(4)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.up(4)
      }],
      "focus": function($event) {
        _vm.check58(0)
      },
      "blur": function($event) {
        _vm.check58(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.realname = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "icon-bor",
    class: {
      'in': _vm.isK, 'vuerify-invalid': _vm.isT
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": _vm.disF,
      "placement": "bottom",
      "effect": "light"
    }
  }, [_c('div', {
    staticClass: "tooltip",
    slot: "content"
  }, [_c('p', {
    staticClass: "longP",
    class: {
      'correct1': _vm.ps1
    }
  }, [_vm._v(_vm._s(_vm.$t('errp1'))), _c('br'), _vm._v(_vm._s(_vm.$t('errp2')))]), _vm._v(" "), _c('p', {
    class: {
      'correct': _vm.ps2
    }
  }, [_vm._v(_vm._s(_vm.$t('errp3')))]), _vm._v(" "), _c('p', {
    class: {
      'correct': _vm.ps3
    }
  }, [_vm._v(_vm._s(_vm.$t('errp4')))]), _vm._v(" "), _c('p', {
    class: {
      'correct': _vm.ps4
    }
  }, [_vm._v(_vm._s(_vm.$t('errp5')))]), _vm._v(" "), _c('p', {
    class: {
      'correct': _vm.ps5
    }
  }, [_vm._v(_vm._s(_vm.$t('errp6')))]), _vm._v(" "), _c('p', {
    class: {
      'correct': _vm.ps6
    }
  }, [_vm._v(_vm._s(_vm.$t('errp7')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "longps",
    attrs: {
      "type": "password",
      "autocomplete": "new-password",
      "placeholder": _vm.Enterpas
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.up(5)
      },
      "focus": function($event) {
        _vm.check59(0)
      },
      "blur": function($event) {
        _vm.check59(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "operate",
    class: [_vm.isA ? 'xSelect' : 'xnoSelect']
  }), _vm._v(" "), _c('div', {
    staticClass: "next_btn",
    on: {
      "click": _vm.register
    }
  }, [_c('button', {
    staticClass: "register",
    class: {
      'click': true, 'newStyle1': !_vm.newStyle
    },
    attrs: {
      "disabled": _vm.isNext
    }
  }, [_vm._v(_vm._s(_vm.$t('Next')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabB),
      expression: "tabB"
    }]
  }, [_c('div', {
    staticClass: "policy-wrap"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "text_wrap"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('t1222_We_will_only_process'))
    }
  }), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isB),
      expression: "isB"
    }]
  }, [(_vm.isEU) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('t1221_register_eu'))
    }
  }) : _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('t1221_register_cn'))
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('t1222_If_you_are_under_years'))
    }
  }), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "check",
    class: [_vm.isA ? 'Select' : 'noSelect']
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": function($event) {
        _vm.check1()
      }
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('t1222_I_Agree_to').replace('$1', '<a href="' + _vm.termsOfUseURL + '" target="_blank">' + _vm.$t('t1222_Terms_of_Use') + '</a>'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "check",
    class: [_vm.isA2 ? 'Select' : 'noSelect']
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": function($event) {
        _vm.check1_2()
      }
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('t1222_I_Agree_to').replace('$1', '<a href="' + _vm.privacyURL + '" target="_blank">' + _vm.$t('t1222_Privacy_Policy') + '</a>'))
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "create-account",
    class: {
      'click': _vm.isAgree, 'newStyle1': !_vm.newStyle
    },
    attrs: {
      "disabled": !_vm.isAgree
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v(_vm._s(_vm.$t('t1222_Create_Account')))]), _vm._v(" "), _c('span', {
    staticClass: "back-link"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.registerBack()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Back')))])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newPatient-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('myP')))])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right",
    class: {
      'de22': _vm.isDe || _vm.isFr, 'cz22': _vm.isCz
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(63)
    }
  }), _vm._v(" "), _c('p', {
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t('home')))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('span', {
    class: {
      'es5': _vm.isIt || _vm.isFr
    }
  }, [_vm._v(_vm._s(_vm.$t('uername')) + ":")]), _vm._v(" "), _c('label', {
    staticClass: "ID"
  }, [_vm._v(_vm._s(_vm.profile.username))])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('country_region')) + ":")]), _vm._v(" "), (!_vm.isCN) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.country_region),
      expression: "profile.country_region"
    }],
    staticClass: "country_region",
    attrs: {
      "id": "country_region"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.profile.country_region = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "GB"
    }
  }, [_vm._v("United Kingdom (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AU"
    }
  }, [_vm._v("Australia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "HKF"
    }
  }, [_vm._v("香港(中国) (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TH"
    }
  }, [_vm._v("Thailand (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ID"
    }
  }, [_vm._v("Indonesia (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MY"
    }
  }, [_vm._v("Malaysia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "IN"
    }
  }, [_vm._v("India (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FR"
    }
  }, [_vm._v("France (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DE"
    }
  }, [_vm._v("Deutschland (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DD"
    }
  }, [_vm._v("Deutschland (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "HU"
    }
  }, [_vm._v("Magyarország (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "IT"
    }
  }, [_vm._v("Italia (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NL"
    }
  }, [_vm._v("Nederland (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Nor"
    }
  }, [_vm._v("Norge (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PT"
    }
  }, [_vm._v("Portugal (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ES"
    }
  }, [_vm._v("España (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SE"
    }
  }, [_vm._v("Sverige (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TR"
    }
  }, [_vm._v("Turkey (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Ro"
    }
  }, [_vm._v("Romania (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CZ"
    }
  }, [_vm._v("Czech republika (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SK"
    }
  }, [_vm._v("Slovenska republika (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LT"
    }
  }, [_vm._v("Lithuania (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PL"
    }
  }, [_vm._v("Polska (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DK"
    }
  }, [_vm._v("Danmark (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FI"
    }
  }, [_vm._v("Suomi (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CH"
    }
  }, [_vm._v("Switzerland (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SA"
    }
  }, [_vm._v("Saudi  (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AE"
    }
  }, [_vm._v("United Arab (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QA"
    }
  }, [_vm._v("Qatar  (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QW"
    }
  }, [_vm._v("Kuwait (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RH"
    }
  }, [_vm._v("Croatia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AT"
    }
  }, [_vm._v("Austria (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SI"
    }
  }, [_vm._v("Slovenia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EE"
    }
  }, [_vm._v("Estonia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LV"
    }
  }, [_vm._v("Latvia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BA"
    }
  }, [_vm._v("Bosnia and Herzegovina (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BG"
    }
  }, [_vm._v("Bulgaria (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CL"
    }
  }, [_vm._v("Chile (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BE"
    }
  }, [_vm._v("Belgium (mg/L)")])]) : _c('label', {
    staticClass: "ID2"
  }, [_vm._v("中国 (mmol/L)")])]), _vm._v(" "), _c('div', {
    staticClass: "item portrait"
  }, [_c('span', {
    staticClass: "porSpan"
  }, [_vm._v(_vm._s(_vm.$t('Portrait')) + ":")]), _vm._v(" "), _c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": '/api/v2.0/person/' + _vm.uid + '/portrait',
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.portrait
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    class: {
      'es5': _vm.isIt || _vm.isFr || _vm.isDe || _vm.isEs || _vm.isDu || _vm.isPo || _vm.isSw
    }
  }, [_vm._v(_vm._s(_vm.$t('fullName')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.realname),
      expression: "profile.realname"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.realname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.realname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('gender')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.gender),
      expression: "profile.gender"
    }],
    staticClass: "gender",
    attrs: {
      "id": "gender"
    },
    domProps: {
      "value": _vm.profile.gender
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.profile.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "GDRNF"
    }
  }, [_vm._v(_vm._s(_vm.$t('GDRNF')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GDRM"
    }
  }, [_vm._v(_vm._s(_vm.$t('GDRM')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GDRF"
    }
  }, [_vm._v(_vm._s(_vm.$t('GDRF')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isP),
      expression: "isP"
    }],
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('height')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.height),
      expression: "profile.height"
    }],
    staticClass: "height",
    attrs: {
      "placeholder": _vm.profile.height
    },
    domProps: {
      "value": (_vm.profile.height)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.height = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.$t('cm')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isP),
      expression: "isP"
    }],
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('weight')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.weight),
      expression: "profile.weight"
    }],
    staticClass: "height",
    attrs: {
      "placeholder": _vm.profile.weight
    },
    domProps: {
      "value": (_vm.profile.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.weight = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.$t('kg')))])]), _vm._v(" "), _c('div', {
    staticClass: "item spe-item"
  }, [_c('span', {
    class: {
      'es5': _vm.isEs || _vm.isIt || _vm.isPo || _vm.isFr || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('birthday')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": _vm.birthdayShow,
      "clearable": false,
      "picker-options": _vm.pickerOptions,
      "format": "dd/MM  yyyy"
    },
    model: {
      value: (_vm.profile.birthday),
      callback: function($$v) {
        _vm.profile.birthday = $$v
      },
      expression: "profile.birthday"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isP),
      expression: "isP"
    }],
    staticClass: "item"
  }, [_c('label', {
    staticClass: "spe-span",
    class: {
      'zh3': !_vm.isEn
    }
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _vm._v(" "), _c('select', {
    staticClass: "weight",
    attrs: {
      "id": "dis_type"
    },
    domProps: {
      "value": _vm.profile.diabetes_type
    }
  }, [_c('option', {
    attrs: {
      "value": "DBTNF"
    }
  }, [_vm._v(_vm._s(_vm.$t('DBTNF')))]), _vm._v(" "), _c('option', {
    attrs: {
      "selected": "",
      "value": "DBT1"
    }
  }, [_vm._v(_vm._s(_vm.$t('DBT1')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DBT2"
    }
  }, [_vm._v(_vm._s(_vm.$t('DBT2')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DBTLADA"
    }
  }, [_vm._v(_vm._s(_vm.$t('LADA')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DBTGEST"
    }
  }, [_vm._v(_vm._s(_vm.$t('Gestational')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DBTPRE"
    }
  }, [_vm._v(_vm._s(_vm.$t('Prediabetes')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "OTR"
    }
  }, [_vm._v(_vm._s(_vm.$t('Other')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isP),
      expression: "isP"
    }],
    staticClass: "item"
  }, [_c('label', {
    staticClass: "spe-span"
  }, [_vm._v(_vm._s(_vm.$t('disDate')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": _vm.disDateShow,
      "clearable": false,
      "picker-options": _vm.pickerOptions,
      "format": "dd/MM  yyyy"
    },
    model: {
      value: (_vm.profile.diabetes_diagonosis_date),
      callback: function($$v) {
        _vm.profile.diabetes_diagonosis_date = $$v
      },
      expression: "profile.diabetes_diagonosis_date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isD),
      expression: "isD"
    }],
    staticClass: "item"
  }, [_c('label', {
    staticClass: "spe-span"
  }, [_vm._v(_vm._s(_vm.$t('Profession')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.major),
      expression: "profile.major"
    }],
    staticClass: "profession",
    class: {
      'zh1': !_vm.isEn, 'es1': _vm.isEs, 'de1': _vm.isDe, 'it1': _vm.isIt, 'po1': _vm.isPo, fr1: _vm.isFr, 'sw1': _vm.isSw, 'cz1': _vm.isCz
    },
    attrs: {
      "id": "major"
    },
    domProps: {
      "value": _vm.profile.major
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.profile.major = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "DPRONF"
    }
  }, [_vm._v(_vm._s(_vm.$t('DPRONF')))]), _vm._v(" "), _c('option', {
    attrs: {
      "selected": "",
      "value": "DPROENDOCRIN"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('DPROENDOCRIN')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DPRODIABTRA"
    }
  }, [_vm._v(_vm._s(_vm.$t('DPRODIABTRA')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DPRONURSE"
    }
  }, [_vm._v(_vm._s(_vm.$t('DPRONURSE')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DPRODIATIT"
    }
  }, [_vm._v(_vm._s(_vm.$t('DPRODIATIT')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DPROOTR"
    }
  }, [_vm._v("\t" + _vm._s(_vm.$t('DPROOTR')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isD),
      expression: "isD"
    }],
    staticClass: "item"
  }, [_c('label', {
    staticClass: "spe-span"
  }, [_vm._v(_vm._s(_vm.$t('Organization')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.serve_for),
      expression: "profile.serve_for"
    }],
    staticClass: "name org",
    class: {
      'zh2': !_vm.isEn, 'es2': _vm.isEs, 'it2': _vm.isIt, 'cz2': _vm.isCz
    },
    domProps: {
      "value": (_vm.profile.serve_for)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.serve_for = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "addSpan"
  }, [_vm._v(_vm._s(_vm.$t('Address')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.address),
      expression: "profile.address"
    }],
    staticClass: "address",
    domProps: {
      "value": (_vm.profile.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.address = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address2),
      expression: "address2"
    }],
    staticClass: "address",
    domProps: {
      "value": (_vm.address2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item post"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Postcode')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.zipcode),
      expression: "profile.zipcode"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.zipcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.zipcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Mobile')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.mobile),
      expression: "profile.mobile"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.mobile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Telephone')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.telephone),
      expression: "profile.telephone"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.telephone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.telephone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Email')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.email),
      expression: "profile.email"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item email"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Bio')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.motto),
      expression: "profile.motto"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.motto)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.motto = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "operate",
    class: {
      'opeP': _vm.isP
    }
  }, [_c('button', {
    staticClass: "cancel",
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isP),
      expression: "isP"
    }],
    staticClass: "create",
    on: {
      "click": _vm.create1
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isD),
      expression: "isD"
    }],
    staticClass: "create",
    on: {
      "click": _vm.create2
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isM),
      expression: "isM"
    }],
    staticClass: "create",
    on: {
      "click": _vm.create3
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])])]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n\n          " + _vm._s(_vm.$t('copyright')) + " "), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "nav-bar"
  }, [_c('p', [_c('span', {
    staticClass: "parent-link",
    on: {
      "click": function($event) {
        _vm.navToHome()
      }
    }
  }, [_vm._v("Admin")]), _vm._v(" "), _c('span', [_vm._v(" >> ")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.title) + " ")])])]), _vm._v(" "), ('DataExport' == _vm.permission) ? _c('div', {
    staticClass: "textarea"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 10,
      "placeholder": "请输入账号",
      "max": "10"
    },
    model: {
      value: (_vm.textarea),
      callback: function($$v) {
        _vm.textarea = $$v
      },
      expression: "textarea"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [_c('el-button', {
    staticClass: "btn",
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v(" 导出数据")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.download2
    }
  }, [_vm._v("升级记录下载")])], 1)], 1) : ('FileUpload' == _vm.permission) ? _c('div', {
    staticClass: "textarea"
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "上传文件"
    }
  }, [_c('el-upload', {
    ref: "uploadButton",
    attrs: {
      "action": "/api/v2.1/admin/utils/file_upload",
      "http-request": _vm.uploadFile,
      "auto-upload": false,
      "limit": 20,
      "file-list": _vm.fileList,
      "on-remove": _vm.handleRemove,
      "on-exceed": _vm.handleExceed,
      "on-change": _vm.handleChange,
      "on-progress": _vm.progressA
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("选择文件")])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "success"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v("立即上传")])], 1)], 1)], 1) : _c('div', [(_vm.noData) ? _c('div', {
    staticClass: "no-data"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("No Data")]), _vm._v(" "), _c('div', {
    staticClass: "add-btn",
    on: {
      "click": _vm.addAccount
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.addBtnTitle))])])]) : _c('div', {
    staticClass: "account-list"
  }, [_c('div', {
    staticClass: "tool-bar"
  }, [_c('div', {
    staticClass: "add-btn",
    on: {
      "click": _vm.addAccount
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.addBtnTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "del-btn",
    on: {
      "click": _vm.deleteAccount
    }
  }, [_c('p', [_vm._v("Delete")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [(('EasyPatchLogin' == _vm.permission) || ('EasyUpdateLogin' == _vm.permission)) ? _c('table', [_c('tr', {
    staticClass: "table-head"
  }, [_c('td', {
    staticClass: "col1",
    attrs: {
      "width": "35%"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Account")])]), _vm._v(" "), _c('td', [_vm._v("\n             Remark\n           ")])]), _vm._v(" "), _vm._l((_vm.currentPageData), function(item, index) {
    return _c('tr', {
      staticClass: "data-row",
      class: {
        'even': (index) % 2
      }
    }, [_c('td', {
      staticClass: "col1"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.check),
        expression: "item.check"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.check) ? _vm._i(item.check, null) > -1 : (item.check)
      },
      on: {
        "__c": function($event) {
          var $$a = item.check,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (item.check = $$a.concat($$v))
            } else {
              $$i > -1 && (item.check = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            item.check = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.account))])]), _vm._v(" "), _c('td', {
      staticClass: "col2",
      staticStyle: {
        "padding-left": "0px"
      }
    }, [_c('span', [_vm._v(_vm._s(item.param.remark))])])])
  })], 2) : _vm._e(), _vm._v(" "), (('FirmwareUpdateConfig' == _vm.permission)) ? _c('table', [_c('tr', {
    staticClass: "table-head"
  }, [_c('td', {
    staticClass: "col1",
    attrs: {
      "width": "35%"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('span', [_vm._v("SN")])]), _vm._v(" "), _c('td', [_vm._v("\n              Model\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              Version\n            ")])]), _vm._v(" "), _vm._l((_vm.currentPageData), function(item, index) {
    return _c('tr', {
      staticClass: "data-row",
      class: {
        'even': (index) % 2
      }
    }, [_c('td', {
      staticClass: "col1"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.check),
        expression: "item.check"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.check) ? _vm._i(item.check, null) > -1 : (item.check)
      },
      on: {
        "__c": function($event) {
          var $$a = item.check,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (item.check = $$a.concat($$v))
            } else {
              $$i > -1 && (item.check = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            item.check = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.account))])]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(item.device_id) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(item.version) + "\n            ")])])
  })], 2) : _vm._e(), _vm._v(" "), (('HCLConfig' == _vm.permission)) ? _c('table', [_c('tr', {
    staticClass: "table-head"
  }, [_c('td', {
    staticClass: "col1",
    attrs: {
      "width": "35%"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('span', [_vm._v("SN")])]), _vm._v(" "), _c('td', [_vm._v("\n              Remark\n            ")])]), _vm._v(" "), _vm._l((_vm.currentPageData), function(item, index) {
    return _c('tr', {
      staticClass: "data-row",
      class: {
        'even': (index) % 2
      }
    }, [_c('td', {
      staticClass: "col1"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.check),
        expression: "item.check"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.check) ? _vm._i(item.check, null) > -1 : (item.check)
      },
      on: {
        "__c": function($event) {
          var $$a = item.check,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (item.check = $$a.concat($$v))
            } else {
              $$i > -1 && (item.check = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            item.check = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.account))])]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(item.device_id) + "\n            ")])])
  })], 2) : _vm._e(), _vm._v(" "), (('HCLConfigForEasyPatch' == _vm.permission)) ? _c('table', [_c('tr', {
    staticClass: "table-head"
  }, [_c('td', {
    staticClass: "col1",
    attrs: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked),
      expression: "checked"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checked) ? _vm._i(_vm.checked, null) > -1 : (_vm.checked)
    },
    on: {
      "click": _vm.chooseAll,
      "__c": function($event) {
        var $$a = _vm.checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.checked = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Account")])])]), _vm._v(" "), _vm._l((_vm.currentPageData), function(item, index) {
    return _c('tr', {
      staticClass: "data-row",
      class: {
        'even': (index) % 2
      }
    }, [_c('td', {
      staticClass: "col1"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.check),
        expression: "item.check"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.check) ? _vm._i(item.check, null) > -1 : (item.check)
      },
      on: {
        "__c": function($event) {
          var $$a = item.check,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (item.check = $$a.concat($$v))
            } else {
              $$i > -1 && (item.check = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            item.check = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.account))])]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(item.device_id) + "\n            ")])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "patientList-block"
  }, [_c('img', {
    class: {
      'click1': _vm.currentPage == 1
    },
    attrs: {
      "src": __webpack_require__(121)
    },
    on: {
      "click": _vm.prevPage
    }
  }), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPage),
      expression: "currentPage"
    }],
    domProps: {
      "value": (_vm.currentPage)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && $event.keyCode !== 13) { return null; }
        _vm.go($event)
      },
      "blur": _vm.go,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentPage = $event.target.value
      }
    }
  }), _vm._v(" of   " + _vm._s(_vm.totalPage))]), _vm._v(" "), _c('img', {
    class: {
      'click1': _vm.currentPage == _vm.totalPage
    },
    attrs: {
      "src": __webpack_require__(120)
    },
    on: {
      "click": _vm.nextPage
    }
  })])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Hcp"
    }
  }, [_c('div', {
    staticClass: "Hcp-header",
    class: {
      'de1': _vm.isDe, 'es1': _vm.isEs, 'po2': _vm.isPo || _vm.isDu || _vm.isFr
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHcp),
      expression: "isHcp"
    }],
    staticClass: "menu-left",
    class: {
      'isM': !_vm.notM
    }
  }, [_c('div', {
    staticClass: "menu-item1",
    on: {
      "click": _vm.back
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(471)
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notM),
      expression: "notM"
    }]
  }, [_vm._v(_vm._s(_vm.$t('pList')))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.notM),
      expression: "!notM"
    }]
  }, [_vm._v(_vm._s(_vm.$t('connections')))])])]), _vm._v(" "), _c('div', {
    staticClass: "menu-right",
    class: {
      'personal': !_vm.isHcp, 'es2': _vm.isEs
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHcp),
      expression: "isHcp"
    }],
    staticClass: "menu-item3 menu-spe3",
    class: {
      'item-choose': _vm.isG
    },
    on: {
      "click": _vm.changeMenu7
    }
  }, [_c('img', {
    staticClass: "portrait",
    attrs: {
      "src": _vm.portrait
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.patientName))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.no),
      expression: "no"
    }],
    staticClass: "menu-item3",
    class: {
      'item-choose': _vm.isF
    },
    on: {
      "click": _vm.changeMenu6
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isF),
      expression: "isF"
    }],
    attrs: {
      "src": __webpack_require__(1291)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isF),
      expression: "!isF"
    }],
    attrs: {
      "src": __webpack_require__(1290)
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Raw data')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-container"
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n        " + _vm._s(_vm.$t('copyright'))), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])])])
},staticRenderFns: []}

/***/ }),
/* 1499 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "nav-bar"
  }, [_c('p', [_c('span', {
    staticClass: "parent-link",
    on: {
      "click": function($event) {
        _vm.navToHome()
      }
    }
  }, [_vm._v("Admin")]), _vm._v(" "), _c('span', [_vm._v(" >>> ")]), _vm._v(" "), _c('span', [_vm._v("Add Account")])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("Enter username(email)")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account),
      expression: "account"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.account = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._l((_vm.checkInfo), function(item, index) {
    return _c('div', {
      staticClass: "check"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.check),
        expression: "item.check"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.check) ? _vm._i(item.check, null) > -1 : (item.check)
      },
      on: {
        "__c": function($event) {
          var $$a = item.check,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (item.check = $$a.concat($$v))
            } else {
              $$i > -1 && (item.check = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            item.check = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.text))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "add-btn",
    on: {
      "click": _vm.addAccount
    }
  }, [_c('p', [_vm._v("Add Account")])])], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newPatient-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('newP')))])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right",
    class: {
      'de22': _vm.isDe || _vm.isFr, 'cz22': _vm.isCz
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(63)
    }
  }), _vm._v(" "), _c('p', {
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t('home')))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('span', {
    class: {
      'es2': _vm.isIt || _vm.isDe || _vm.isEs || _vm.isPo || _vm.isDu || _vm.isSw
    }
  }, [_vm._v(_vm._s(_vm.$t('fullName')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.realname),
      expression: "realname"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.realname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.realname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('gender')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    staticClass: "gender",
    attrs: {
      "id": "gender"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "GDRNF"
    }
  }, [_vm._v(_vm._s(_vm.$t('GDRNF')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GDRM"
    }
  }, [_vm._v(_vm._s(_vm.$t('GDRM')))]), _c('option', {
    attrs: {
      "value": "GDRF"
    }
  }, [_vm._v(_vm._s(_vm.$t('GDRF')))])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('height')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.height),
      expression: "height"
    }],
    staticClass: "height",
    domProps: {
      "value": (_vm.height)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.height = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.$t('cm')))])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('weight')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.weight),
      expression: "weight"
    }],
    staticClass: "height",
    domProps: {
      "value": (_vm.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.weight = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.$t('kg')))])]), _vm._v(" "), _c('div', {
    staticClass: "item spe-item"
  }, [_c('span', {
    class: {
      'es2': _vm.isEs || _vm.isIt || _vm.isPo || _vm.isFr || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('birthday')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": _vm.Time,
      "clearable": false,
      "picker-options": _vm.pickerOptions,
      "format": "dd/MM  yyyy"
    },
    model: {
      value: (_vm.birthday),
      callback: function($$v) {
        _vm.birthday = $$v
      },
      expression: "birthday"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('label', {
    staticClass: "spe-span"
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.diabetes_type),
      expression: "diabetes_type"
    }],
    staticClass: "weight",
    attrs: {
      "id": "dis_type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.diabetes_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "DBTNF"
    }
  }, [_vm._v(_vm._s(_vm.$t('DBTNF')))]), _vm._v(" "), _c('option', {
    attrs: {
      "selected": "",
      "value": "DBT1"
    }
  }, [_vm._v(_vm._s(_vm.$t('Type 1')))]), _c('option', {
    attrs: {
      "value": "DBT2"
    }
  }, [_vm._v(_vm._s(_vm.$t('Type 2')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DBTLADA"
    }
  }, [_vm._v(_vm._s(_vm.$t('LADA')))]), _c('option', {
    attrs: {
      "value": "DBTGEST"
    }
  }, [_vm._v(_vm._s(_vm.$t('Gestational')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DBTPRE"
    }
  }, [_vm._v(_vm._s(_vm.$t('DBTPRE')))]), _c('option', {
    attrs: {
      "value": "MODY"
    }
  }, [_vm._v(_vm._s(_vm.$t('MODY')))])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('label', {
    staticClass: "spe-span"
  }, [_vm._v(_vm._s(_vm.$t('disDate')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": _vm.Time,
      "clearable": false,
      "picker-options": _vm.pickerOptions,
      "format": "dd/MM  yyyy"
    },
    model: {
      value: (_vm.diabetes_diagnosis_date),
      callback: function($$v) {
        _vm.diabetes_diagnosis_date = $$v
      },
      expression: "diabetes_diagnosis_date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "addSpan"
  }, [_vm._v(_vm._s(_vm.$t('Address')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address1),
      expression: "address1"
    }],
    staticClass: "address",
    domProps: {
      "value": (_vm.address1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address1 = $event.target.value
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address2),
      expression: "address2"
    }],
    staticClass: "address",
    domProps: {
      "value": (_vm.address2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item post"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Postcode')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postcode),
      expression: "postcode"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Mobile')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Telephone')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telephone),
      expression: "telephone"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.telephone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telephone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item email"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Email')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "item1"
  }, [_c('span', {
    class: {
      'es1': _vm.isEs || _vm.isDe || _vm.isPo || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('Inpatient')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inpatient),
      expression: "inpatient"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.inpatient = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v(_vm._s(_vm.$t('Yes')))]), _c('option', [_vm._v(_vm._s(_vm.$t('No')))])])]), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_c('span', {
    class: {
      'po1': _vm.isPo || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('Pno')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.patient_no),
      expression: "patient_no"
    }],
    domProps: {
      "value": (_vm.patient_no)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.patient_no = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item1 spe-item1"
  }, [_c('span', {
    class: {
      'po1': _vm.isPo || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('Bno')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bed_no),
      expression: "bed_no"
    }],
    domProps: {
      "value": (_vm.bed_no)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bed_no = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('button', {
    staticClass: "cancel",
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "create",
    on: {
      "click": _vm.create
    }
  }, [_vm._v(_vm._s(_vm.$t('create')))])])]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n\n        " + _vm._s(_vm.$t('copyright'))), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-container"
  }, [_c('div', {
    staticClass: "Hcp-main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('logbook')))])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('button', {
    on: {
      "click": _vm.print
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('print')))])]), _vm._v(" "), _c('button', {
    staticClass: "set",
    on: {
      "click": _vm.open
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('set')))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('period')) + ":"), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.timeRange))])])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr spe-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "main-wrapper",
    attrs: {
      "id": "table-wrapper"
    }
  }, [_c('div', {
    staticClass: "table-left",
    class: {
      'zh66': !_vm.isEn
    },
    attrs: {
      "id": "table-left"
    }
  }, [_c('div', {
    staticClass: "searchBar",
    attrs: {
      "id": "title-table2"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', {
    staticStyle: {
      "height": "25px"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('date')))]), _vm._v(" "), _c('td', {
    staticClass: "spe-td2",
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dailyTotal')) + "\n             ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "searchBarTd",
    attrs: {
      "id": "wrap1"
    }
  }, [_c('div', {
    attrs: {
      "id": "context-table1"
    }
  }, _vm._l((_vm.whichDate), function(item, index) {
    return _c('table', {
      attrs: {
        "id": 'date' + index
      }
    }, [_c('tr', [_c('td', {
      staticClass: "spe-td",
      staticStyle: {
        "width": "30%"
      },
      attrs: {
        "rowspan": "4"
      }
    }, [_vm._v(_vm._s(item))]), _vm._v(" "), _c('td', {
      staticClass: "spe-td",
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(_vm.$t('BG')))]), _vm._v(" "), _c('td', {
      staticClass: "spe-td",
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v(_vm._s(_vm.bgAvg[index].avg))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('carbs')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.carb[index].total))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('insulin')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.ins[index].total) + ":" + _vm._s(_vm.$t('bolus')) + ": " + _vm._s(_vm.ins[index].percent) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('events')))]), _vm._v(" "), _c('td')])])
  }))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sliderWrap"
    }
  }, [_c('div', {
    attrs: {
      "id": "slider"
    },
    on: {
      "mousedown": function($event) {
        _vm.drag($event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "table-right",
    attrs: {
      "id": "table-right"
    }
  }, [_c('div', {
    staticClass: "tip",
    class: {
      'po6': _vm.isPo, 'fr6': _vm.isFr
    }
  }, [_c('span', {
    attrs: {
      "id": "m0"
    }
  }, [_vm._v(_vm._s(_vm.$t('Breakfast')))]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "m1"
    }
  }, [_vm._v(_vm._s(_vm.$t('Lunch')))]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "m2"
    }
  }, [_vm._v(_vm._s(_vm.$t('Dinner')))])]), _vm._v(" "), _c('div', {
    staticClass: "searchBar",
    attrs: {
      "id": "title-table"
    }
  }, [_c('table', {
    staticClass: "table2 table4 searchBarRight"
  }, [_c('tr', {
    staticStyle: {
      "height": "25px"
    }
  }, _vm._l((_vm.hours), function(i) {
    return _c('td', {
      staticClass: "spe-td3",
      class: {
        'spe-td4': (i === '23:00'), 'spe-td5': (i === '00:00')
      }
    }, [_c('span', [_vm._v(_vm._s(i))])])
  }))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('table', {
    staticClass: "table2",
    attrs: {
      "id": "context-table"
    }
  }, _vm._l(((_vm.whichDate.length * 4)), function(i) {
    return _c('tr', {
      attrs: {
        "id": i
      }
    }, _vm._l((24), function(i) {
      return _c('td', {
        staticClass: "spe-td"
      })
    }))
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "legend-group",
    class: {
      'zh8': !_vm.isEn, 'es8': _vm.isEs, 'de8': _vm.isDe, 'it8': _vm.isIt, 'po8': _vm.isPo, 'du8': _vm.isDu || _vm.isCz, 'fr8': _vm.isFr, 'sw8': _vm.isSw
    }
  }, [_c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": __webpack_require__(307)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('High Glucose')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": __webpack_require__(315)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Low Glucose')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": __webpack_require__(316)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1112_Normal_Glucose')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": __webpack_require__(312)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('No Active Patch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": __webpack_require__(1295)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('tempBasal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": __webpack_require__(308)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('manualStop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend",
    class: {
      'de12': _vm.isDe
    }
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": __webpack_require__(304)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('autoStop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend",
    class: {
      'zh9': !_vm.isEn, 'es9': _vm.isEs, 'de9': _vm.isDe, 'sw9': _vm.isSw
    }
  }, [_c('img', {
    staticClass: "img-spe1",
    attrs: {
      "src": __webpack_require__(309)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Missed Meal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend spe2",
    class: {
      'zh10': !_vm.isEn, 'es10': _vm.isEs, 'de10': _vm.isDe, 'cz10': _vm.isCz
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(314)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Stop Patch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend spe3",
    class: {
      'zh14': !_vm.isEn, 'es11': _vm.isEs, 'cz11': _vm.isCz
    }
  }, [_c('img', {
    staticClass: "img-spe2",
    attrs: {
      "src": __webpack_require__(305)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('t1112_Manual_Bolus_or_Modified_Bolus')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend spe4",
    class: {
      'zh11': !_vm.isEn, 'es12': _vm.isEs, 'cz12': _vm.isCz
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(311)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('newPatch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend spe5",
    class: {
      'zh12': !_vm.isEn, 'es13': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(313)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Other Events')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend spe6",
    class: {
      'es15': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(306)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('exercise')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend spe1",
    class: {
      'zh13': !_vm.isEn, 'es16': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(310)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Multiple BG Readings')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend spe7",
    class: {
      'zh13': !_vm.isEn, 'es16': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(71)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Breakfast')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend spe7",
    class: {
      'zh13': !_vm.isEn, 'es16': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(70)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Lunch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend spe7",
    class: {
      'zh13': !_vm.isEn, 'es16': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(72)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Dinner')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend spe7",
    class: {
      'zh13': !_vm.isEn, 'es16': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(73)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1222_Snack')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend spe7",
    class: {
      'zh13': !_vm.isEn, 'es16': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(219)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Exercise')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend spe7",
    class: {
      'zh13': !_vm.isEn, 'es16': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(295)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1112_Auto_Mode_Started')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend spe7",
    class: {
      'zh13': !_vm.isEn, 'es16': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(296)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1112_Auto_Mode_Exit')))])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.typeChooseVisible,
      "size": _vm.dialogSize,
      "id": "dialog-form2",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.typeChooseVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('setPeriod')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(21)
    },
    on: {
      "click": _vm.cancel
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('div', {
    staticClass: "duration"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('duration')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeRangeSelect),
      expression: "timeRangeSelect"
    }],
    attrs: {
      "id": "duration"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.timeRangeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.procTimeRangeSelect]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('7 days')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('14 days')))])])]), _vm._v(" "), _c('div', {
    staticClass: "time-range",
    class: {
      'zh2': !_vm.isEn
    }
  }, [_c('div', {
    staticClass: "start"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('From')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', [_vm._v(_vm._s(_vm.defaultDate1))])])]), _vm._v(" "), _c('div', {
    staticClass: "end"
  }, [_c('p', {
    staticClass: "to",
    class: {
      'zh6': !_vm.isEn
    }
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block date1"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "placeholder": _vm.defaultDate2,
      "clearable": false,
      "picker-options": _vm.pickerOptions,
      "format": "dd-MM-yyyy"
    },
    on: {
      "change": _vm.endDateChange
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1)])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "weeks",
    class: {
      'zh3': !_vm.isEn
    },
    attrs: {
      "id": "weeks"
    }
  }, [_c('span', {
    staticClass: "tittle",
    class: {
      'zh4': !_vm.isEn
    }
  }, [_c('label', {
    on: {
      "click": _vm.chooseAll
    }
  }, [_vm._v(_vm._s(_vm.$t('Weekdays')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Mon')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Tue')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Wed')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Thur')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Fri')))])])]), _vm._v(" "), _c('div', {
    staticClass: "weeks weken",
    class: {
      'zh3': !_vm.isEn
    },
    attrs: {
      "id": "weken"
    }
  }, [_c('span', {
    staticClass: "tittle",
    class: {
      'zh5': !_vm.isEn, 'de5': _vm.isDe, 'it5': _vm.isIt, 'po5': _vm.isPo, 'du5': _vm.isDu, 'sw5': _vm.isSw, 'cz5': _vm.isCz
    }
  }, [_c('label', {
    on: {
      "click": _vm.chooseAll
    }
  }, [_vm._v(_vm._s(_vm.$t('Weekends')))])]), _vm._v(" "), _c('span', [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Sat')))])]), _vm._v(" "), _c('span', {
    class: {
      'it2': _vm.isIt, 'po2': _vm.isPo, 'du2': _vm.isDu, 'fr3': _vm.isFr, 'sw2': _vm.isSw, 'cz2': _vm.isCz
    }
  }, [_c('label', {
    on: {
      "click": _vm.choose
    }
  }, [_vm._v(_vm._s(_vm.$t('Sun')))])])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    on: {
      "click": _vm.dateApply
    }
  }, [_vm._v(_vm._s(_vm.$t('applyM')))]), _vm._v(" "), _c('button', {
    staticClass: "cancelButton",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1502 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "PainterList"
    }
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('el-card', {
    attrs: {
      "id": "list"
    }
  }, [_c('div', {
    staticClass: "content-wrap "
  }, [_c('div', {
    staticClass: "top-bar patientList-operate"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('t0805_User_List')))]), _vm._v(" "), _c('button', {
    attrs: {
      "id": "danger"
    },
    on: {
      "click": function($event) {
        _vm.deleteUser()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Delete')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "id": "add",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.addUser()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('t0809_Add_User')))]), _vm._v(" "), _c('p', {
    staticClass: "back-btn",
    on: {
      "click": _vm.backToMenu
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v(_vm._s(_vm.$t('t0805_Back')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "patient-table"
  }, [_c('table', {
    attrs: {
      "id": "patientList"
    }
  }, [_c('tr', {
    staticClass: "header"
  }, [_c('td', {
    staticClass: "checkbox",
    attrs: {
      "width": "5%"
    }
  }, [_c('input', {
    staticClass: "checkbox22",
    attrs: {
      "type": "checkbox",
      "id": "checkbox1"
    }
  }), _vm._v(" "), _c('label', {
    class: {
      'checked': _vm.selectAll
    },
    attrs: {
      "for": "checkbox1"
    },
    on: {
      "click": _vm.chooseAll
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Name')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Email')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Profession')))])]), _vm._v(" "), _vm._l((_vm.users), function(item, index) {
    return _c('tr', {
      class: (index % 2 === 0) ? '' : 'even'
    }, [_c('td', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.check),
        expression: "item.check"
      }],
      staticClass: "checkbox22",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.check) ? _vm._i(item.check, null) > -1 : (item.check)
      },
      on: {
        "__c": function($event) {
          var $$a = item.check,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (item.check = $$a.concat($$v))
            } else {
              $$i > -1 && (item.check = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            item.check = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      class: {
        'checked': item.check
      },
      on: {
        "click": function($event) {
          _vm.select(index)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "name",
      attrs: {
        "id": index
      }
    }, [_c('p', {
      class: {
        'filterResult': false
      },
      on: {
        "click": function($event) {
          _vm.hcpGroupUser(item.uid)
        }
      }
    }, [_vm._v(_vm._s(item.realname))])]), _vm._v(" "), _c('td', {
      staticClass: "gender"
    }, [_vm._v(_vm._s(item.username))]), _vm._v(" "), _c('td', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t(item.profession)))])])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n\n          " + _vm._s(_vm.$t('copyright')) + " "), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1503 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "nav-bar"
  }, [_c('p', [_c('span', {
    staticClass: "parent-link",
    on: {
      "click": function($event) {
        _vm.navToHome()
      }
    }
  }, [_vm._v("Admin")]), _vm._v(" "), _c('span', [_vm._v(" >>> ")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.navToList()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _vm._v(" "), _c('span', [_vm._v(" >>> ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.addBtnTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(('EasyPatchLogin' == _vm.permission) || ('EasyUpdateLogin' == _vm.permission)) ? _c('div', [_c('p', {
    staticClass: "text"
  }, [_vm._v("Enter username(email)")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account),
      expression: "account"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.account = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Enter remark")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remake),
      expression: "remake"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.remake)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.remake = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._l((_vm.checkInfo2), function(item, index) {
    return _c('div', {
      staticClass: "check"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.check),
        expression: "item.check"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.check) ? _vm._i(item.check, null) > -1 : (item.check)
      },
      on: {
        "__c": function($event) {
          var $$a = item.check,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (item.check = $$a.concat($$v))
            } else {
              $$i > -1 && (item.check = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            item.check = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.text))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })], 2) : (('FirmwareUpdateConfig' == _vm.permission)) ? _c('div', [_c('p', {
    staticClass: "text"
  }, [_vm._v("SN ")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceSN),
      expression: "deviceSN"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.deviceSN)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deviceSN = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("version (eg. 1.36.140)")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.version),
      expression: "version"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.version)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.version = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("model (eg. 0x7e)")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceId),
      expression: "deviceId"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.deviceId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deviceId = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._l((_vm.checkInfo2), function(item, index) {
    return _c('div', {
      staticClass: "check"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.check),
        expression: "item.check"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.check) ? _vm._i(item.check, null) > -1 : (item.check)
      },
      on: {
        "__c": function($event) {
          var $$a = item.check,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (item.check = $$a.concat($$v))
            } else {
              $$i > -1 && (item.check = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            item.check = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.text))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })], 2) : (('HCLConfig' == _vm.permission)) ? _c('div', [_c('p', {
    staticClass: "text"
  }, [_vm._v("SN ")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account),
      expression: "account"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.account = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Remark")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remark),
      expression: "remark"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.remark = $event.target.value
      }
    }
  })])]) : (('HCLConfigForEasyPatch' == _vm.permission)) ? _c('div', [_c('p', {
    staticClass: "text"
  }, [_vm._v("Enter username(email)")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account),
      expression: "account"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.account = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "add-btn",
    on: {
      "click": _vm.addAccount
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.addBtnTitle))])])])])])
},staticRenderFns: []}

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newPatient-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('t1215_Security')))])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right",
    class: {
      'de22': _vm.isDe || _vm.isFr, 'cz22': _vm.isCz
    },
    on: {
      "click": _vm.back
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(63)
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('home')))])])]), _vm._v(" "), _c('div', {
    staticClass: "content  content1",
    class: {
      'es1': _vm.isEs, 'de1': _vm.isDe, 'du1': _vm.isDu, 'fr1': _vm.isFr, 'cz1': _vm.isCz
    },
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('span', {
    staticClass: "MFA-option",
    class: {
      'it3': _vm.isIt, 'po3': _vm.isPo, 'du2': _vm.isDu, 'de12': _vm.isDe, 'es13': _vm.isEs || _vm.isSw, 'fr13': _vm.isFr || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('t1215_MFA')))]), _vm._v(" "), _c('div', {
    staticClass: "MFA-left",
    class: {
      'MFA-choose': _vm.MFA
    },
    on: {
      "click": function($event) {
        _vm.changeMFA(true)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('On')))])]), _vm._v(" "), _c('div', {
    staticClass: "MFA-right",
    class: {
      'MFA-choose': !_vm.MFA
    },
    on: {
      "click": function($event) {
        _vm.changeMFA(false)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Off')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "content  content1",
    class: {
      'es1': _vm.isEs, 'de1': _vm.isDe, 'du1': _vm.isDu, 'fr1': _vm.isFr, 'cz1': _vm.isCz
    },
    staticStyle: {
      "margin-top": "50px",
      "padding-bottom": "30px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('oldPa')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content content2",
    class: {
      'zh1': !_vm.isEn, 'es2': _vm.isEs, 'de1': _vm.isDe, 'it1': _vm.isIt, 'po1': _vm.isPo, 'du2': _vm.isDu, 'sw2': _vm.isSw, 'cz2': _vm.isCz
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('newPa')))]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "disabled": _vm.disF,
      "placement": "bottom",
      "effect": "light"
    }
  }, [_c('div', {
    staticClass: "tooltip",
    slot: "content"
  }, [_c('p', {
    staticClass: "longP",
    class: {
      'correct1': _vm.ps1
    }
  }, [_vm._v(_vm._s(_vm.$t('errp1'))), _c('br'), _vm._v(_vm._s(_vm.$t('errp2')))]), _vm._v(" "), _c('p', {
    class: {
      'correct': _vm.ps2
    }
  }, [_vm._v(_vm._s(_vm.$t('errp3')))]), _vm._v(" "), _c('p', {
    class: {
      'correct': _vm.ps3
    }
  }, [_vm._v(_vm._s(_vm.$t('errp4')))]), _vm._v(" "), _c('p', {
    class: {
      'correct': _vm.ps4
    }
  }, [_vm._v(_vm._s(_vm.$t('errp5')))]), _vm._v(" "), _c('p', {
    class: {
      'correct': _vm.ps5
    }
  }, [_vm._v(_vm._s(_vm.$t('errp6')))]), _vm._v(" "), _c('p', {
    class: {
      'correct': _vm.ps6
    }
  }, [_vm._v(_vm._s(_vm.$t('errp7')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_password),
      expression: "new_password"
    }],
    class: {
      'vuerify-invalid': _vm.isT
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.new_password)
    },
    on: {
      "blur": _vm.checkPassword,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_password = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "content",
    class: {
      'zh2': !_vm.isEn, 'it2': _vm.isIt, 'po2': _vm.isPo, 'fr2': _vm.isFr, 'sw3': _vm.isSw
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('RePa')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_password2),
      expression: "new_password2"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.new_password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_password2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "forgot"
  }, [_c('p', {
    on: {
      "click": _vm.forgot
    }
  }, [_vm._v(_vm._s(_vm.$t('forgetY')))])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('button', {
    staticClass: "cancel",
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "create",
    on: {
      "click": _vm.apply
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])])]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n\n          " + _vm._s(_vm.$t('copyright')) + " "), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])])], 1), _vm._v(" "), _c('vertifyDialog', {
    ref: "verifyEmail",
    attrs: {
      "confirmText": _vm.confirmText,
      "title": _vm.title
    },
    on: {
      "confirm": _vm.confirm,
      "handleClose": _vm.handleClose
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVertify),
      expression: "isVertify"
    }],
    domProps: {
      "innerHTML": _vm._s(_vm.$t('t1222_please_check_your_account').replace('$1', '<span style="color: #043a97ff">' + _vm.userName + '</span>'))
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isVertify),
      expression: "!isVertify"
    }]
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('t1221_enter_verification_code').replace('$1', '<span style="color: #043a97ff">' + _vm.userName + '</span>'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inputs"
  }, _vm._l((_vm.verifyInputs), function(item, index) {
    return _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.verifyInputs[index]),
        expression: "verifyInputs[index]"
      }],
      key: index,
      class: {
        'input-code-error': _vm.errVeritifyCode, 'input-code': true
      },
      attrs: {
        "type": "text",
        "pattern": "[0-9]*"
      },
      domProps: {
        "value": (_vm.verifyInputs[index])
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          var $$exp = _vm.verifyInputs,
            $$idx = index;
          if (!Array.isArray($$exp)) {
            _vm.verifyInputs[index] = $event.target.value
          } else {
            $$exp.splice($$idx, 1, $event.target.value)
          }
        }, function($event) {
          _vm.vertifyInput(index)
        }]
      }
    })
  })), _vm._v(" "), (_vm.errVeritifyCode) ? _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1223_Invalid_Verification_Code')))]) : _vm._e()])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "PainterList"
    }
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('el-card', {
    attrs: {
      "id": "list"
    }
  }, [_c('div', {
    staticClass: "patientList-operate"
  }, [_c('el-popover', {
    ref: "popover1",
    attrs: {
      "placement": "bottom-start",
      "width": "300",
      "trigger": "hover",
      "disabled": _vm.tooltipVisible
    }
  }, [_c('div', {
    staticClass: "patientList-label-tooltip"
  }, [_c('div', {
    staticClass: "patientList-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Filter')))])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small2-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "label-group"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab2),
      expression: "lab2"
    }],
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab2, 'de6': _vm.isDe || _vm.isIt, 'po4': _vm.isPo, 'fr2': _vm.isFr
    }
  }, [_c('span', {
    class: {
      'ZH3': _vm.styleChange
    }
  }, [_vm._v(_vm._s(_vm.$t('Female')))]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab3),
      expression: "lab3"
    }],
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab3, 'es3': _vm.isEs, 'de6': _vm.isDe || _vm.isIt, 'po4': _vm.isPo
    }
  }, [_c('span', {
    class: {
      'ZH3': _vm.styleChange
    }
  }, [_vm._v(_vm._s(_vm.$t('Male')))]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab17),
      expression: "lab17"
    }],
    staticClass: "filter-label",
    class: {
      'choose4': _vm.lab17, 'de17': _vm.isDe, 'po17': _vm.isPo || _vm.isDu
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('genUn')))]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab18),
      expression: "lab18"
    }],
    staticClass: "filter-label",
    class: {
      'choose4': _vm.lab18, 'po19': _vm.isPo || _vm.isDu
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('ageUn')))]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab6),
      expression: "lab6"
    }],
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab6
    }
  }, [_c('span', [_vm._v("< 18")]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab7),
      expression: "lab7"
    }],
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab7
    }
  }, [_c('span', [_vm._v("18-40")]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab8),
      expression: "lab8"
    }],
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab8
    }
  }, [_c('span', [_vm._v("40-60")]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab9),
      expression: "lab9"
    }],
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab9
    }
  }, [_c('span', [_vm._v("> 60")]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab19),
      expression: "lab19"
    }],
    staticClass: "filter-label",
    class: {
      'choose4': _vm.lab19, 'de18': _vm.isDe || _vm.isFr, 'it18': _vm.isIt, 'es18': _vm.isEs, 'po18': _vm.isPo || _vm.isDu, 'sw2': _vm.isSw
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('disUn')))]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab16),
      expression: "lab16"
    }],
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab16
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Other')))]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab11),
      expression: "lab11"
    }],
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab11, 'cz2': _vm.isCz
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Type 1')))]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab12),
      expression: "lab12"
    }],
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab12, 'cz2': _vm.isCz
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Type 2')))]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab13),
      expression: "lab13"
    }],
    staticClass: "filter-label",
    class: {
      'choose2': _vm.lab13, 'de2': _vm.isDe, 'it6': _vm.isIt, 'du4': _vm.isDu, 'fr1': _vm.isFr, 'cz3': _vm.isCz
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Gestational')))]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab14),
      expression: "lab14"
    }],
    staticClass: "filter-label",
    class: {
      'choose2': _vm.lab14, 'po5': _vm.isPo
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Prediabetes')))]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab15),
      expression: "lab15"
    }],
    staticClass: "filter-label",
    class: {
      'choose3': _vm.lab15, 'ZH2': _vm.styleChange
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('LADA')))]), _c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })])])])]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover1",
      arg: "popover1"
    }],
    attrs: {
      "id": "filter",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Filter')))]), _vm._v(" "), _c('div', {
    staticClass: "patientList-search",
    class: {
      'patientList-in': _vm.searchPatient
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keywords),
      expression: "keywords"
    }],
    domProps: {
      "value": (_vm.keywords)
    },
    on: {
      "focus": function($event) {
        _vm.check(0)
      },
      "blur": function($event) {
        _vm.check(1)
      },
      "keyup": function($event) {
        if (!('button' in $event) && $event.keyCode !== 13) { return null; }
        _vm.check(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keywords = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    class: {
      'patientList-in1': _vm.searchPatient
    },
    attrs: {
      "src": __webpack_require__(506)
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "patient-table"
  }, [_c('table', {
    attrs: {
      "id": "patientList"
    }
  }, [_c('tr', {
    staticClass: "header"
  }, [_c('td', [_vm._v(_vm._s(_vm.$t('Name')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Gender')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Age')))]), _c('td', [_vm._v(_vm._s(_vm.$t('Type')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Duration')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Connections')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('UploadTime')))])]), _vm._v(" "), _vm._l((_vm.users), function(item, index) {
    return _c('tr', {
      class: (index % 2 === 0) ? '' : 'even'
    }, [_c('td', {
      staticClass: "name",
      attrs: {
        "id": index
      },
      on: {
        "click": _vm.goDetail
      }
    }, [_c('img', {
      staticClass: "portrait",
      attrs: {
        "src": '/api/v2.0/person/' + item.uid + '/portrait'
      }
    }), _vm._v(" "), _c('p', {
      class: {
        'filterResult': _vm.filFlag2
      }
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('td', {
      staticClass: "gender"
    }, [_vm._v(_vm._s(item.gender))]), _vm._v(" "), _c('td', {
      staticClass: "small"
    }, [_vm._v(_vm._s(item.age))]), _vm._v(" "), _c('td', {
      staticClass: "small"
    }, [_vm._v(_vm._s(item.diabetes_type))]), _vm._v(" "), _c('td', {
      staticClass: "diabetes-date"
    }, [_vm._v(_vm._s(item.diabetes_diagnosis_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.created_by))]), _c('td', [_vm._v(_vm._s(item.upload_time))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "patientList-block"
  }, [_c('img', {
    class: {
      'click1': !_vm.has_prev
    },
    attrs: {
      "src": __webpack_require__(121)
    },
    on: {
      "click": _vm.prevPage
    }
  }), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.page),
      expression: "page"
    }],
    domProps: {
      "value": (_vm.page)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && $event.keyCode !== 13) { return null; }
        _vm.go($event)
      },
      "blur": _vm.go,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.page = $event.target.value
      }
    }
  }), _vm._v(" of   " + _vm._s(_vm.pages))]), _vm._v(" "), _c('img', {
    class: {
      'click1': !_vm.has_next
    },
    attrs: {
      "src": __webpack_require__(120)
    },
    on: {
      "click": _vm.nextPage
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n          " + _vm._s(_vm.$t('copyright')) + " "), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogFormVisible,
      "size": _vm.dialogSize,
      "id": "dialog-form",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Filter')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(21)
    },
    on: {
      "click": _vm.cancelFilter
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('hr', {
    staticClass: "patientList-small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "lab-group1"
  }, [_c('label', {
    class: {
      'de3': _vm.isDe || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('Gender')))]), _vm._v(" "), _c('div', {
    staticClass: "patientList-line",
    class: {
      'de4': _vm.isDe
    }
  }, [_c('div', {
    staticClass: "label1",
    class: {
      'choose': _vm.lab1, 'ZH1': _vm.styleChange, 'es2': _vm.isEs || _vm.isIt || _vm.isFr, 'de5': _vm.isDe, 'po2': _vm.isPo, 'du2': _vm.isDu, 'pl2': _vm.isPl
    },
    on: {
      "click": _vm.choose1
    }
  }, [_c('span', {
    class: {
      'ZH': _vm.styleChange || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('All')))]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab1),
      expression: "lab1"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "filter-label long-lab",
    class: {
      'choose2': _vm.lab17, 'es1': _vm.isEs, 'de1': _vm.isDe, 'po3': _vm.isPo, 'du3': _vm.isDu, 'fr1': _vm.isFr, 'sw1': _vm.isSw, 'pl3': _vm.isPl
    },
    on: {
      "click": function($event) {
        _vm.choose17()
      }
    }
  }, [_c('span', {
    class: {
      'ZH3': _vm.styleChange
    }
  }, [_vm._v(_vm._s(_vm.$t('DBTNF')))]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab17),
      expression: "lab17"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab2, 'de6': _vm.isDe || _vm.isIt, 'po4': _vm.isPo, 'fr2': _vm.isFr
    },
    on: {
      "click": _vm.choose2
    }
  }, [_c('span', {
    class: {
      'ZH3': _vm.styleChange
    }
  }, [_vm._v(_vm._s(_vm.$t('Female')))]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab2),
      expression: "lab2"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab3, 'es3': _vm.isEs, 'de6': _vm.isDe || _vm.isIt, 'po4': _vm.isPo, 'pl4': _vm.isPl
    },
    on: {
      "click": _vm.choose3
    }
  }, [_c('span', {
    class: {
      'ZH3': _vm.styleChange
    }
  }, [_vm._v(_vm._s(_vm.$t('Male')))]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab3),
      expression: "lab3"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "lab-group2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Age')))]), _vm._v(" "), _c('div', {
    staticClass: "patientList-line"
  }, [_c('div', {
    staticClass: "label1",
    class: {
      'choose': _vm.lab5, 'ZH1': _vm.styleChange, 'es2': _vm.isEs || _vm.isIt || _vm.isFr, 'de5': _vm.isDe, 'po2': _vm.isPo, 'du2': _vm.isDu, 'pl2': _vm.isPl
    },
    on: {
      "click": _vm.choose5
    }
  }, [_c('span', {
    class: {
      'ZH': _vm.styleChange || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('All')))]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab5),
      expression: "lab5"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "filter-label long-lab",
    class: {
      'choose2': _vm.lab18, 'es1': _vm.isEs, 'de1': _vm.isDe, 'po3': _vm.isPo, 'du3': _vm.isDu, 'fr1': _vm.isFr, 'sw1': _vm.isSw, 'pl3': _vm.isPl
    },
    on: {
      "click": function($event) {
        _vm.choose18()
      }
    }
  }, [_c('span', {
    class: {
      'ZH3': _vm.styleChange
    }
  }, [_vm._v(_vm._s(_vm.$t('DBTNF')))]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab18),
      expression: "lab18"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab6
    },
    on: {
      "click": _vm.choose6
    }
  }, [_c('span', [_vm._v(" < 18")]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab6),
      expression: "lab6"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab7
    },
    on: {
      "click": _vm.choose7
    }
  }, [_c('span', [_vm._v("18-40")]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab7),
      expression: "lab7"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab8, 'ZH8': _vm.styleChange
    },
    on: {
      "click": _vm.choose8
    }
  }, [_c('span', [_vm._v("41-60")]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab8),
      expression: "lab8"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label small_lab",
    class: {
      'choose1': _vm.lab9, 'ZH9': _vm.styleChange
    },
    on: {
      "click": _vm.choose9
    }
  }, [_c('span', [_vm._v("> 60")]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab9),
      expression: "lab9"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "lab-group3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Type')))]), _vm._v(" "), _c('div', {
    staticClass: "patientList-line"
  }, [_c('div', {
    staticClass: "label1",
    class: {
      'choose': _vm.lab10, 'ZH1': _vm.styleChange, 'es2': _vm.isEs || _vm.isIt || _vm.isFr, 'de5': _vm.isDe, 'po2': _vm.isPo, 'du2': _vm.isDu, 'pl2': _vm.isPl
    },
    on: {
      "click": _vm.choose10
    }
  }, [_c('span', {
    class: {
      'ZH': _vm.styleChange || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('All')))]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab10),
      expression: "lab10"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "patientList-type"
  }, [_c('div', {
    staticClass: "filter-label long-lab",
    class: {
      'choose3': _vm.lab19, 'ZH5': _vm.styleChange, 'es1': _vm.isEs, 'de1': _vm.isDe, 'po3': _vm.isPo, 'du3': _vm.isDu, 'fr1': _vm.isFr, 'sw1': _vm.isSw, 'cz1': _vm.isCz, 'pl3': _vm.isPl
    },
    on: {
      "click": _vm.choose19
    }
  }, [_c('span', {
    class: {
      'ZH3': _vm.styleChange
    }
  }, [_vm._v(_vm._s(_vm.$t('DBTNF')))]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab19),
      expression: "lab19"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab11, 'cz2': _vm.isCz
    },
    on: {
      "click": _vm.choose11
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Type 1')))]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab11),
      expression: "lab11"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label",
    class: {
      'choose1': _vm.lab12, 'cz2': _vm.isCz
    },
    on: {
      "click": _vm.choose12
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Type 2')))]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab12),
      expression: "lab12"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label long-lab1",
    class: {
      'choose3': _vm.lab15, 'ZH2': _vm.styleChange
    },
    on: {
      "click": _vm.choose15
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('LADA')))]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab15),
      expression: "lab15"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label long-lab",
    class: {
      'choose2': _vm.lab13, 'de2': _vm.isDe, 'it6': _vm.isIt, 'du4': _vm.isDu, 'fr1': _vm.isFr, 'ZH10': _vm.styleChange, 'cz3': _vm.isCz
    },
    on: {
      "click": _vm.choose13
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Gestational')))]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab13),
      expression: "lab13"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label long-lab",
    class: {
      'choose2': _vm.lab14, 'po5': _vm.isPo, 'pl1': _vm.isPl
    },
    on: {
      "click": _vm.choose14
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Prediabetes')))]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab14),
      expression: "lab14"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-label small_lab",
    class: {
      'choose1': _vm.lab16
    },
    on: {
      "click": _vm.choose16
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('OTR1')))]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab16),
      expression: "lab16"
    }],
    attrs: {
      "src": __webpack_require__(14)
    }
  })])])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr patientList-spe1-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "patientList-dialog-footer",
    slot: "footer"
  }, [_c('button', {
    on: {
      "click": _vm.checkFilter
    }
  }, [_vm._v(_vm._s(_vm.$t('Apply')))])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.typeChooseVisible,
      "size": _vm.dialogSize,
      "id": "dialog-form2",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.typeChooseVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('addP')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(21)
    },
    on: {
      "click": _vm.cancelAdd
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('div', {
    staticClass: "new"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1302)
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.NewPatient
    }
  }, [_vm._v(_vm._s(_vm.$t('newP')))])]), _vm._v(" "), _c('div', {
    staticClass: "find"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1300)
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.findPatient
    }
  }, [_vm._v(_vm._s(_vm.$t('findP')))])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr patientList-spe1-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "patientList-dialog-footer",
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancelButton",
    on: {
      "click": _vm.cancelAdd
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.showConfirmDialog,
      "size": _vm.dialogSize2,
      "id": "dialog-form3",
      "show-close": false,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showConfirmDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('t1104_Privacy_Policy')))])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-content"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('t1104_updated_privacy_policy'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [_c('button', {
    staticClass: "deny",
    on: {
      "click": _vm.denyPrivacyConfirm
    }
  }, [_vm._v(_vm._s(_vm.$t('t1104_Disagree')))]), _vm._v(" "), _c('button', {
    staticClass: "agree",
    on: {
      "click": _vm.agreePrivacyConfirm
    }
  }, [_vm._v(_vm._s(_vm.$t('t1104_Agree')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('img', {
    attrs: {
      "id": "user",
      "src": __webpack_require__(220)
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('title1')))]), _vm._v(" "), _c('div', {
    staticClass: "icon-bor",
    class: {
      'in': _vm.isB
    }
  }, [_c('div', {
    class: {
      'in1': _vm.isB
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(173)
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": _vm.user,
      "maxlength": "80"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "focus": _vm.check2,
      "blur": _vm.check2,
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.down($event)
      }, function($event) {
        if (!('button' in $event) && $event.keyCode !== 13) { return null; }
        _vm.down($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon-bor",
    class: {
      'in': _vm.isC
    }
  }, [_c('div', {
    class: {
      'in1': _vm.isC
    }
  }, [_c('img', {
    attrs: {
      "id": "img1",
      "src": __webpack_require__(172)
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "id": "psd",
      "type": "password",
      "placeholder": _vm.pas,
      "maxlength": "40"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.up($event)
      },
      "focus": _vm.check3,
      "blur": _vm.check3,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "operate",
    class: {
      'po1': _vm.isEs || _vm.isPo
    }
  }, [_c('div', {
    staticClass: "operate-left",
    class: [_vm.isA ? 'Select' : 'noSelect']
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": _vm.choose
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('remember')))])]), _vm._v(" "), _c('div', {
    staticClass: "operate-right"
  }, [_c('label', {
    on: {
      "click": _vm.forgot
    }
  }, [_vm._v(_vm._s(_vm.$t('forget')))])])]), _vm._v(" "), _c('button', {
    staticClass: "login",
    class: {
      'po2': _vm.isEs || _vm.isPo
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('sign in')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/hcpSign"
    }
  }, [_c('button', {
    staticClass: "sign"
  }, [_vm._v(_vm._s(_vm.$t('apply')))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1507 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dateView-Container"
  }, [_c('div', {
    attrs: {
      "id": "sel_card_wrap"
    }
  }, [_c('el-card', {
    class: {
      'card-sel': _vm.isPDM
    },
    attrs: {
      "id": "pdm-card",
      "body-style": {
        padding: '5px'
      }
    }
  }, [_c('div', {
    staticClass: "daop_row",
    on: {
      "click": _vm.selectPDM
    }
  }, [_c('div', {
    staticClass: "sel-icon",
    class: {
      'sel': _vm.isPDM
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "daop_name"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('daop_uploaded_data')))])]), _vm._v(" "), _c('div', {
    staticClass: "daop_sep"
  }), _vm._v(" "), _c('div', {
    staticClass: "daop_text"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('daop_uploaded_data_text')))])]), _vm._v(" "), _c('div', {
    staticClass: "daop_app_icon easytouch"
  }), _vm._v(" "), _c('div', {
    staticClass: "daop_app_icon easyview_ipad"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('el-card', {
    class: {
      'card-sel': _vm.isRealtime
    },
    attrs: {
      "id": "realtime-card",
      "body-style": {
        padding: '5px'
      }
    }
  }, [_c('div', {
    staticClass: "daop_row",
    on: {
      "click": _vm.selectRealtime
    }
  }, [_c('div', {
    staticClass: "sel-icon",
    class: {
      'sel': _vm.isRealtime
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "daop_name"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('daop_realtime_data')))])]), _vm._v(" "), _c('div', {
    staticClass: "daop_sep"
  }), _vm._v(" "), _c('div', {
    staticClass: "daop_text"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('t1104_The_data_is_from')))])]), _vm._v(" "), _c('div', {
    staticClass: "daop_app_icon easysense"
  }), _vm._v(" "), _c('div', {
    staticClass: "daop_app_icon easypatch"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "upload_history"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToUploadHistory()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('t1105_Upload_History')))])])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isP),
      expression: "isP"
    }],
    staticClass: "central-btn-container"
  }, [_c('button', {
    staticClass: "data-delete",
    class: {},
    on: {
      "click": _vm.deleteData
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('t1105_Delete_Data')))])])])])
},staticRenderFns: []}

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background",
    class: {
      'longCont1': _vm.long
    }
  }, [_c('div', {
    staticClass: "chart-container",
    class: {
      'longCont': _vm.long
    }
  }, [_c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('dayBydayRe')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.$t('period')) + ": " + _vm._s(_vm.staTime) + "-" + _vm._s(_vm.endTime))])])]), _vm._v(" "), _c('table', {
    staticClass: "status-table1",
    class: {
      'zh11': !_vm.isEn, 'de1': _vm.isDe || _vm.isIt || _vm.isFr
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('uername')))]), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.username))]), _vm._v(" "), _c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('fullName')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('devices')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "id": "reportPdmTitle"
    }
  }, [_vm._v(_vm._s(_vm.$t('pdm')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('tran')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('pumpBase')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[2]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td4"
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _c('td', {
    staticClass: "td4",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v(_vm._s(_vm.statics.medical_history))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _vm._l((_vm.pagePos), function(base, p) {
    return _c('div', [(p == 1) ? _c('div', [_c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "page-seperator"
    }), _vm._v(" "), _c('div', {
      staticClass: "page-starter"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "page-charts"
    }, _vm._l((_vm.src2_1.slice(base, base + _vm.perPage[p])), function(url, index) {
      return _c('div', {
        staticClass: "imgCotain"
      }, [_c('div', {
        staticClass: "date date-spe3"
      }, [_c('span', [_vm._v(_vm._s(_vm.date[base + index]))])]), _vm._v(" "), _c('div', {
        staticClass: "eat-label eat-spe3",
        class: {
          'zh1': !_vm.isEn, 'de11': _vm.isDe, 'po1': _vm.isPo || _vm.isFr
        }
      }, [_c('span', {
        staticClass: "eat-label-spe1",
        class: {
          'zh2': !_vm.isEn, 'de2': _vm.isDe, 'po2': _vm.isPo || _vm.isFr
        }
      }, [_vm._v(_vm._s(_vm.$t('Breakfast')))]), _vm._v(" "), _c('span', {
        class: {
          'zh3': !_vm.isEn, 'de3': _vm.isDe, 'po3': _vm.isPo || _vm.isFr
        }
      }, [_vm._v(_vm._s(_vm.$t('Lunch')))]), _vm._v(" "), _c('span', {
        class: {
          'zh4': !_vm.isEn
        }
      }, [_vm._v(_vm._s(_vm.$t('Dinner')))])]), _vm._v(" "), _c('img', {
        staticClass: "img",
        attrs: {
          "src": url
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "carb"
      }, [_c('span', [_vm._v(_vm._s(_vm.$t('carbs')) + "(g)")]), _vm._v(" "), _c('div', {
        attrs: {
          "id": 'carb' + (base + index)
        }
      }, [_vm._l((_vm.carb[base + index]), function(i) {
        return _c('label', [_vm._v(_vm._s(i[1]))])
      }), _vm._v(" "), _vm._l((_vm.autoBreakfast[base + index]), function(b) {
        return _c('img', {
          staticClass: "breakfast",
          attrs: {
            "src": "/static/legend/automode/早餐.png"
          }
        })
      }), _vm._v(" "), _vm._l((_vm.autoLunch[base + index]), function(b) {
        return _c('img', {
          staticClass: "lunch",
          attrs: {
            "src": "/static/legend/automode/中餐.png"
          }
        })
      }), _vm._v(" "), _vm._l((_vm.autoDinner[base + index]), function(b) {
        return _c('img', {
          staticClass: "dinner",
          attrs: {
            "src": "/static/legend/automode/晚餐.png"
          }
        })
      }), _vm._v(" "), _vm._l((_vm.autoSnack[base + index]), function(b) {
        return _c('img', {
          staticClass: "snack",
          attrs: {
            "src": "/static/legend/automode/零食.png"
          }
        })
      })], 2)]), _vm._v(" "), _c('img', {
        staticClass: "img",
        attrs: {
          "src": _vm.src2_2[base + index]
        }
      })])
    }))])
  }), _vm._v(" "), (_vm.chartEndPage.show) ? _c('div', [_c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-seperator"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "legend-group",
    class: {
      'zh5': !_vm.isEn, 'it5': _vm.isIt, 'po5': _vm.isPo, 'du5': _vm.isDu || _vm.isFr || _vm.isCz
    }
  }, [_c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(88)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('alert')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(116)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('target')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": __webpack_require__(112)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('hypo')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": __webpack_require__(105)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('sensorGlucose')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(110)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('calib')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend "
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(118)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('newSen')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(119)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('warm')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1",
    class: {
      'zh6': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(109)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('basal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1",
    class: {
      'zh7': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(117)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('tampBasal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe3",
    class: {
      'zh8': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(114)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('normalBolus')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe4",
    class: {
      'zh9': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(111)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('extendBolus')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe5",
    class: {
      'zh10': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(106)
    }
  }), _c('span', {
    staticClass: "span1"
  }, [_vm._v(_vm._s(_vm.$t('manualStop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1",
    class: {
      'zh11': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(104)
    }
  }), _c('span', {
    staticClass: "span1"
  }, [_vm._v(_vm._s(_vm.$t('autoStop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(115)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('stop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe6",
    class: {
      'zh12': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(113)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('newPatch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe7",
    class: {
      'zh13': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(143)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('carbs')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe2",
    class: {
      'zh14': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(144)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('exercise')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(142)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('BG Reading')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(71)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Breakfast')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(70)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Lunch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(72)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Dinner')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(73)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1222_Snack')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(108)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1222_auto_basal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(107)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1222_auto_bolus')))])])]), _vm._v(" "), _c('div', {
    staticClass: "page-end"
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(19)
    }
  })])
}]}

/***/ }),
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1562 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1563 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1564 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1565 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1566 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[738]);


// WEBPACK FOOTER //
// static/js/app.e4f346bdede106b8ff18.js